const signs = [
  [-2208864271,-2208688813,'Capricorn'],
  [-2208688813,-2208511380,'Aquarius'],
  [-2208511380,-2208327230,'Pisces'],
  [-2208327230,-2208134184,'Aries'],
  [-2208134184,-2207932545,'Taurus'],
  [-2207932545,-2207723677,'Gemini'],
  [-2207723677,-2207508965,'Cancer'],
  [-2207508965,-2207290754,'Leo'],
  [-2207290754,-2207074171,'Virgo'],
  [-2207074171,-2206866427,'Libra'],
  [-2206866427,-2206672567,'Scorpio'],
  [-2206672567,-2206492217,'Sagittarius'],
  [-2206492217,-2206320120,'Capricorn'],
  [-2206320120,-2206148760,'Aquarius'],
  [-2206148760,-2205970797,'Pisces'],
  [-2205970797,-2205781273,'Aries'],
  [-2205781273,-2205579496,'Taurus'],
  [-2205579496,-2205368596,'Gemini'],
  [-2205368596,-2205152627,'Cancer'],
  [-2205152627,-2204934551,'Leo'],
  [-2204934551,-2204717309,'Virgo'],
  [-2204717309,-2204505846,'Libra'],
  [-2204505846,-2204305962,'Scorpio'],
  [-2204305962,-2204120403,'Sagittarius'],
  [-2204120403,-2203946510,'Capricorn'],
  [-2203946510,-2203777495,'Aquarius'],
  [-2203777495,-2203605142,'Pisces'],
  [-2203605142,-2203422161,'Aries'],
  [-2203422161,-2203224837,'Taurus'],
  [-2203224837,-2203014939,'Gemini'],
  [-2203014939,-2202798126,'Cancer'],
  [-2202798126,-2202579856,'Leo'],
  [-2202579856,-2202363375,'Virgo'],
  [-2202363375,-2202151397,'Libra'],
  [-2202151397,-2201947764,'Scorpio'],
  [-2201947764,-2201756028,'Sagittarius'],
  [-2201756028,-2201576393,'Capricorn'],
  [-2201576393,-2201404566,'Aquarius'],
  [-2201404566,-2201233379,'Pisces'],
  [-2201233379,-2201055089,'Aries'],
  [-2201055089,-2200863780,'Taurus'],
  [-2200863780,-2200658130,'Gemini'],
  [-2200658130,-2200442496,'Cancer'],
  [-2200442496,-2200224082,'Leo'],
  [-2200224082,-2200008420,'Virgo'],
  [-2200008420,-2199798170,'Libra'],
  [-2199798170,-2199594902,'Scorpio'],
  [-2199594902,-2199400290,'Sagittarius'],
  [-2199400290,-2199215111,'Capricorn'],
  [-2199215111,-2199037544,'Aquarius'],
  [-2199037544,-2198862890,'Pisces'],
  [-2198862890,-2198684789,'Aries'],
  [-2198684789,-2198497081,'Taurus'],
  [-2198497081,-2198296202,'Gemini'],
  [-2198296202,-2198083558,'Cancer'],
  [-2198083558,-2197865605,'Leo'],
  [-2197865605,-2197650008,'Virgo'],
  [-2197650008,-2197441422,'Libra'],
  [-2197441422,-2197240981,'Scorpio'],
  [-2197240981,-2197048007,'Sagittarius'],
  [-2197048007,-2196861357,'Capricorn'],
  [-2196861357,-2196679409,'Aquarius'],
  [-2196679409,-2196499509,'Pisces'],
  [-2196499509,-2196317782,'Aries'],
  [-2196317782,-2196129652,'Taurus'],
  [-2196129652,-2195931250,'Gemini'],
  [-2195931250,-2195721618,'Cancer'],
  [-2195721618,-2195504682,'Leo'],
  [-2195504682,-2195288311,'Virgo'],
  [-2195288311,-2195079661,'Libra'],
  [-2195079661,-2194881490,'Scorpio'],
  [-2194881490,-2194692335,'Sagittarius'],
  [-2194692335,-2194508682,'Capricorn'],
  [-2194508682,-2194326889,'Aquarius'],
  [-2194326889,-2194144050,'Pisces'],
  [-2194144050,-2193957950,'Aries'],
  [-2193957950,-2193766492,'Taurus'],
  [-2193766492,-2193567397,'Gemini'],
  [-2193567397,-2193359141,'Cancer'],
  [-2193359141,-2193143188,'Leo'],
  [-2193143188,-2192925606,'Virgo'],
  [-2192925606,-2192714809,'Libra'],
  [-2192714809,-2192516232,'Scorpio'],
  [-2192516232,-2192329632,'Sagittarius'],
  [-2192329632,-2192150518,'Capricorn'],
  [-2192150518,-2191972975,'Aquarius'],
  [-2191972975,-2191791916,'Pisces'],
  [-2191791916,-2191604398,'Aries'],
  [-2191604398,-2191409674,'Taurus'],
  [-2191409674,-2191207890,'Gemini'],
  [-2191207890,-2190998943,'Cancer'],
  [-2190998943,-2190783360,'Leo'],
  [-2190783360,-2190564766,'Virgo'],
  [-2190564766,-2190350695,'Libra'],
  [-2190350695,-2190148684,'Scorpio'],
  [-2190148684,-2189961135,'Sagittarius'],
  [-2189961135,-2189784479,'Capricorn'],
  [-2189784479,-2189611865,'Aquarius'],
  [-2189611865,-2189436083,'Pisces'],
  [-2189436083,-2189251780,'Aries'],
  [-2189251780,-2189057054,'Taurus'],
  [-2189057054,-2188853177,'Gemini'],
  [-2188853177,-2188642395,'Cancer'],
  [-2188642395,-2188426384,'Leo'],
  [-2188426384,-2188207418,'Virgo'],
  [-2188207418,-2187990742,'Libra'],
  [-2187990742,-2187783847,'Scorpio'],
  [-2187783847,-2187591727,'Sagittarius'],
  [-2187591727,-2187413351,'Capricorn'],
  [-2187413351,-2187242720,'Aquarius'],
  [-2187242720,-2187071921,'Pisces'],
  [-2187071921,-2186893587,'Aries'],
  [-2186893587,-2186703130,'Taurus'],
  [-2186703130,-2186500340,'Gemini'],
  [-2186500340,-2186288499,'Cancer'],
  [-2186288499,-2186071628,'Leo'],
  [-2186071628,-2185852816,'Virgo'],
  [-2185852816,-2185635559,'Libra'],
  [-2185635559,-2185425223,'Scorpio'],
  [-2185425223,-2185227246,'Sagittarius'],
  [-2185227246,-2185043341,'Capricorn'],
  [-2185043341,-2184870021,'Aquarius'],
  [-2184870021,-2184700430,'Pisces'],
  [-2184700430,-2184526800,'Aries'],
  [-2184526800,-2184342530,'Taurus'],
  [-2184342530,-2184144445,'Gemini'],
  [-2184144445,-2183934174,'Cancer'],
  [-2183934174,-2183716950,'Leo'],
  [-2183716950,-2183498302,'Virgo'],
  [-2183498302,-2183282168,'Libra'],
  [-2183282168,-2183071802,'Scorpio'],
  [-2183071802,-2182870529,'Sagittarius'],
  [-2182870529,-2182680563,'Capricorn'],
  [-2182680563,-2182501061,'Aquarius'],
  [-2182501061,-2182327800,'Pisces'],
  [-2182327800,-2182154454,'Aries'],
  [-2182154454,-2181974264,'Taurus'],
  [-2181974264,-2181781930,'Gemini'],
  [-2181781930,-2181575913,'Cancer'],
  [-2181575913,-2181359913,'Leo'],
  [-2181359913,-2181141177,'Virgo'],
  [-2181141177,-2180926161,'Libra'],
  [-2180926161,-2180718190,'Scorpio'],
  [-2180718190,-2180518178,'Sagittarius'],
  [-2180518178,-2180326076,'Capricorn'],
  [-2180326076,-2180141198,'Aquarius'],
  [-2180141198,-2179961658,'Pisces'],
  [-2179961658,-2179783951,'Aries'],
  [-2179783951,-2179603161,'Taurus'],
  [-2179603161,-2179413945,'Gemini'],
  [-2179413945,-2179212491,'Cancer'],
  [-2179212491,-2178999290,'Leo'],
  [-2178999290,-2178780607,'Virgo'],
  [-2178780607,-2178565272,'Libra'],
  [-2178565272,-2178359086,'Scorpio'],
  [-2178359086,-2178162720,'Sagittarius'],
  [-2178162720,-2177973597,'Capricorn'],
  [-2177973597,-2177788550,'Aquarius'],
  [-2177788550,-2177605208,'Pisces'],
  [-2177605208,-2177421903,'Aries'],
  [-2177421903,-2177236616,'Taurus'],
  [-2177236616,-2177046124,'Gemini'],
  [-2177046124,-2176846621,'Cancer'],
  [-2176846621,-2176636191,'Leo'],
  [-2176636191,-2176418112,'Virgo'],
  [-2176418112,-2176201114,'Libra'],
  [-2176201114,-2175993913,'Scorpio'],
  [-2175993913,-2175799469,'Sagittarius'],
  [-2175799469,-2175614817,'Capricorn'],
  [-2175614817,-2175434409,'Aquarius'],
  [-2175434409,-2175253195,'Pisces'],
  [-2175253195,-2175068267,'Aries'],
  [-2175068267,-2174878788,'Taurus'],
  [-2174878788,-2174684292,'Gemini'],
  [-2174684292,-2174483223,'Cancer'],
  [-2174483223,-2174273667,'Leo'],
  [-2174273667,-2174056394,'Virgo'],
  [-2174056394,-2173837652,'Libra'],
  [-2173837652,-2173626984,'Scorpio'],
  [-2173626984,-2173430517,'Sagittarius'],
  [-2173430517,-2173247328,'Capricorn'],
  [-2173247328,-2173071565,'Aquarius'],
  [-2173071565,-2172896140,'Pisces'],
  [-2172896140,-2172715360,'Aries'],
  [-2172715360,-2172526479,'Taurus'],
  [-2172526479,-2172329533,'Gemini'],
  [-2172329533,-2172125441,'Cancer'],
  [-2172125441,-2171914543,'Leo'],
  [-2171914543,-2171697470,'Virgo'],
  [-2171697470,-2171477938,'Libra'],
  [-2171477938,-2171263657,'Scorpio'],
  [-2171263657,-2171062265,'Sagittarius'],
  [-2171062265,-2170875969,'Capricorn'],
  [-2170875969,-2170700794,'Aquarius'],
  [-2170700794,-2170529606,'Pisces'],
  [-2170529606,-2170355059,'Aries'],
  [-2170355059,-2170171606,'Taurus'],
  [-2170171606,-2169976924,'Gemini'],
  [-2169976924,-2169771920,'Cancer'],
  [-2169771920,-2169559190,'Leo'],
  [-2169559190,-2169341473,'Virgo'],
  [-2169341473,-2169122043,'Libra'],
  [-2169122043,-2168906126,'Scorpio'],
  [-2168906126,-2168700111,'Sagittarius'],
  [-2168700111,-2168508021,'Capricorn'],
  [-2168508021,-2168328824,'Aquarius'],
  [-2168328824,-2168157251,'Pisces'],
  [-2168157251,-2167986212,'Aries'],
  [-2167986212,-2167808785,'Taurus'],
  [-2167808785,-2167619885,'Gemini'],
  [-2167619885,-2167417872,'Cancer'],
  [-2167417872,-2167205167,'Leo'],
  [-2167205167,-2166986742,'Virgo'],
  [-2166986742,-2166767658,'Libra'],
  [-2166767658,-2166552305,'Scorpio'],
  [-2166552305,-2166344640,'Sagittarius'],
  [-2166344640,-2166147813,'Capricorn'],
  [-2166147813,-2165962579,'Aquarius'],
  [-2165962579,-2165786417,'Pisces'],
  [-2165786417,-2165614190,'Aries'],
  [-2165614190,-2165439448,'Taurus'],
  [-2165439448,-2165255867,'Gemini'],
  [-2165255867,-2165059098,'Cancer'],
  [-2165059098,-2164849084,'Leo'],
  [-2164849084,-2164630930,'Virgo'],
  [-2164630930,-2164412029,'Libra'],
  [-2164412029,-2164198111,'Scorpio'],
  [-2164198111,-2163991869,'Sagittarius'],
  [-2163991869,-2163794078,'Capricorn'],
  [-2163794078,-2163604724,'Aquarius'],
  [-2163604724,-2163422834,'Pisces'],
  [-2163422834,-2163245859,'Aries'],
  [-2163245859,-2163069389,'Taurus'],
  [-2163069389,-2162887678,'Gemini'],
  [-2162887678,-2162695160,'Cancer'],
  [-2162695160,-2162489094,'Leo'],
  [-2162489094,-2162272483,'Virgo'],
  [-2162272483,-2162053546,'Libra'],
  [-2162053546,-2161840412,'Scorpio'],
  [-2161840412,-2161636611,'Sagittarius'],
  [-2161636611,-2161441319,'Capricorn'],
  [-2161441319,-2161252195,'Aquarius'],
  [-2161252195,-2161067338,'Pisces'],
  [-2161067338,-2160885389,'Aries'],
  [-2160885389,-2160704370,'Taurus'],
  [-2160704370,-2160520632,'Gemini'],
  [-2160520632,-2160329230,'Cancer'],
  [-2160329230,-2160126096,'Leo'],
  [-2160126096,-2159911564,'Virgo'],
  [-2159911564,-2159692486,'Libra'],
  [-2159692486,-2159478641,'Scorpio'],
  [-2159478641,-2159275909,'Sagittarius'],
  [-2159275909,-2159083842,'Capricorn'],
  [-2159083842,-2158898374,'Aquarius'],
  [-2158898374,-2158715249,'Pisces'],
  [-2158715249,-2158531835,'Aries'],
  [-2158531835,-2158346928,'Taurus'],
  [-2158346928,-2158159129,'Gemini'],
  [-2158159129,-2157965642,'Cancer'],
  [-2157965642,-2157762995,'Leo'],
  [-2157762995,-2157549921,'Virgo'],
  [-2157549921,-2157330742,'Libra'],
  [-2157330742,-2157114849,'Scorpio'],
  [-2157114849,-2156910488,'Sagittarius'],
  [-2156910488,-2156719405,'Capricorn'],
  [-2156719405,-2156537658,'Aquarius'],
  [-2156537658,-2156359297,'Pisces'],
  [-2156359297,-2156179223,'Aries'],
  [-2156179223,-2155994522,'Taurus'],
  [-2155994522,-2155804121,'Gemini'],
  [-2155804121,-2155607303,'Cancer'],
  [-2155607303,-2155402813,'Leo'],
  [-2155402813,-2155189806,'Virgo'],
  [-2155189806,-2154970630,'Libra'],
  [-2154970630,-2154752472,'Scorpio'],
  [-2154752472,-2154544196,'Sagittarius'],
  [-2154544196,-2154350385,'Capricorn'],
  [-2154350385,-2154169156,'Aquarius'],
  [-2154169156,-2153994678,'Pisces'],
  [-2153994678,-2153820267,'Aries'],
  [-2153820267,-2153640393,'Taurus'],
  [-2153640393,-2153451821,'Gemini'],
  [-2153451821,-2153253714,'Cancer'],
  [-2153253714,-2153046821,'Leo'],
  [-2153046821,-2152832570,'Virgo'],
  [-2152832570,-2152613368,'Libra'],
  [-2152613368,-2152394085,'Scorpio'],
  [-2152394085,-2152181804,'Sagittarius'],
  [-2152181804,-2151982497,'Capricorn'],
  [-2151982497,-2151797342,'Aquarius'],
  [-2151797342,-2151622585,'Pisces'],
  [-2151622585,-2151451822,'Aries'],
  [-2151451822,-2151278089,'Taurus'],
  [-2151278089,-2151095426,'Gemini'],
  [-2151095426,-2150900419,'Cancer'],
  [-2150900419,-2150693345,'Leo'],
  [-2150693345,-2150477725,'Virgo'],
  [-2150477725,-2150258214,'Libra'],
  [-2150258214,-2150039287,'Scorpio'],
  [-2150039287,-2149825449,'Sagittarius'],
  [-2149825449,-2149621240,'Capricorn'],
  [-2149621240,-2149429551,'Aquarius'],
  [-2149429551,-2149249763,'Pisces'],
  [-2149249763,-2149077712,'Aries'],
  [-2149077712,-2148906947,'Taurus'],
  [-2148906947,-2148730277,'Gemini'],
  [-2148730277,-2148541535,'Cancer'],
  [-2148541535,-2148338104,'Leo'],
  [-2148338104,-2148122929,'Virgo'],
  [-2148122929,-2147902997,'Libra'],
  [-2147902997,-2147684889,'Scorpio'],
  [-2147684889,-2147472306,'Sagittarius'],
  [-2147472306,-2147267065,'Capricorn'],
  [-2147267065,-2147070704,'Aquarius'],
  [-2147070704,-2146884156,'Pisces'],
  [-2146884156,-2146706335,'Aries'],
  [-2146706335,-2146533236,'Taurus'],
  [-2146533236,-2146358476,'Gemini'],
  [-2146358476,-2146174907,'Cancer'],
  [-2146174907,-2145977156,'Leo'],
  [-2145977156,-2145765144,'Virgo'],
  [-2145765144,-2145545566,'Libra'],
  [-2145545566,-2145327629,'Scorpio'],
  [-2145327629,-2145116926,'Sagittarius'],
  [-2145116926,-2144914192,'Capricorn'],
  [-2144914192,-2144718224,'Aquarius'],
  [-2144718224,-2144528353,'Pisces'],
  [-2144528353,-2144344508,'Aries'],
  [-2144344508,-2144165507,'Taurus'],
  [-2144165507,-2143987574,'Gemini'],
  [-2143987574,-2143804736,'Cancer'],
  [-2143804736,-2143610850,'Leo'],
  [-2143610850,-2143403022,'Virgo'],
  [-2143403022,-2143185108,'Libra'],
  [-2143185108,-2142966683,'Scorpio'],
  [-2142966683,-2142756213,'Sagittarius'],
  [-2142756213,-2142556066,'Capricorn'],
  [-2142556066,-2142363881,'Aquarius'],
  [-2142363881,-2142176299,'Pisces'],
  [-2142176299,-2141991233,'Aries'],
  [-2141991233,-2141807781,'Taurus'],
  [-2141807781,-2141624515,'Gemini'],
  [-2141624515,-2141438156,'Cancer'],
  [-2141438156,-2141244062,'Leo'],
  [-2141244062,-2141038616,'Virgo'],
  [-2141038616,-2140822792,'Libra'],
  [-2140822792,-2140603901,'Scorpio'],
  [-2140603901,-2140391614,'Sagittarius'],
  [-2140391614,-2140191267,'Capricorn'],
  [-2140191267,-2140001890,'Aquarius'],
  [-2140001890,-2139819051,'Pisces'],
  [-2139819051,-2139638067,'Aries'],
  [-2139638067,-2139455652,'Taurus'],
  [-2139455652,-2139269927,'Gemini'],
  [-2139269927,-2139079380,'Cancer'],
  [-2139079380,-2138882048,'Leo'],
  [-2138882048,-2138675952,'Virgo'],
  [-2138675952,-2138461168,'Libra'],
  [-2138461168,-2138242185,'Scorpio'],
  [-2138242185,-2138027267,'Sagittarius'],
  [-2138027267,-2137823703,'Capricorn'],
  [-2137823703,-2137633408,'Aquarius'],
  [-2137633408,-2137453174,'Pisces'],
  [-2137453174,-2137277388,'Aries'],
  [-2137277388,-2137100326,'Taurus'],
  [-2137100326,-2136917514,'Gemini'],
  [-2136917514,-2136726384,'Cancer'],
  [-2136726384,-2136526258,'Leo'],
  [-2136526258,-2136317752,'Virgo'],
  [-2136317752,-2136102411,'Libra'],
  [-2136102411,-2135883501,'Scorpio'],
  [-2135883501,-2135666705,'Sagittarius'],
  [-2135666705,-2135458822,'Capricorn'],
  [-2135458822,-2135264168,'Aquarius'],
  [-2135264168,-2135082257,'Pisces'],
  [-2135082257,-2134908593,'Aries'],
  [-2134908593,-2134736671,'Taurus'],
  [-2134736671,-2134559812,'Gemini'],
  [-2134559812,-2134372775,'Cancer'],
  [-2134372775,-2134173426,'Leo'],
  [-2134173426,-2133963430,'Virgo'],
  [-2133963430,-2133746793,'Libra'],
  [-2133746793,-2133527821,'Scorpio'],
  [-2133527821,-2133310634,'Sagittarius'],
  [-2133310634,-2133099811,'Capricorn'],
  [-2133099811,-2132899870,'Aquarius'],
  [-2132899870,-2132712862,'Pisces'],
  [-2132712862,-2132536854,'Aries'],
  [-2132536854,-2132366396,'Taurus'],
  [-2132366396,-2132194219,'Gemini'],
  [-2132194219,-2132013115,'Cancer'],
  [-2132013115,-2131818241,'Leo'],
  [-2131818241,-2131609672,'Virgo'],
  [-2131609672,-2131392523,'Libra'],
  [-2131392523,-2131173376,'Scorpio'],
  [-2131173376,-2130956885,'Sagittarius'],
  [-2130956885,-2130745783,'Capricorn'],
  [-2130745783,-2130542692,'Aquarius'],
  [-2130542692,-2130350152,'Pisces'],
  [-2130350152,-2130168703,'Aries'],
  [-2130168703,-2129995334,'Taurus'],
  [-2129995334,-2129823875,'Gemini'],
  [-2129823875,-2129646753,'Cancer'],
  [-2129646753,-2129457273,'Leo'],
  [-2129457273,-2129252755,'Virgo'],
  [-2129252755,-2129036925,'Libra'],
  [-2129036925,-2128817795,'Scorpio'],
  [-2128817795,-2128602117,'Sagittarius'],
  [-2128602117,-2128392666,'Capricorn'],
  [-2128392666,-2128190012,'Aquarius'],
  [-2128190012,-2127994903,'Pisces'],
  [-2127994903,-2127808297,'Aries'],
  [-2127808297,-2127629475,'Taurus'],
  [-2127629475,-2127454647,'Gemini'],
  [-2127454647,-2127277523,'Cancer'],
  [-2127277523,-2127091209,'Leo'],
  [-2127091209,-2126891071,'Virgo'],
  [-2126891071,-2126678096,'Libra'],
  [-2126678096,-2126459473,'Scorpio'],
  [-2126459473,-2126243901,'Sagittarius'],
  [-2126243901,-2126036073,'Capricorn'],
  [-2126036073,-2125836172,'Aquarius'],
  [-2125836172,-2125642723,'Pisces'],
  [-2125642723,-2125454762,'Aries'],
  [-2125454762,-2125271684,'Taurus'],
  [-2125271684,-2125091706,'Gemini'],
  [-2125091706,-2124910951,'Cancer'],
  [-2124910951,-2124724066,'Leo'],
  [-2124724066,-2124526214,'Virgo'],
  [-2124526214,-2124316140,'Libra'],
  [-2124316140,-2124098502,'Scorpio'],
  [-2124098502,-2123882087,'Sagittarius'],
  [-2123882087,-2123674082,'Capricorn'],
  [-2123674082,-2123476375,'Aquarius'],
  [-2123476375,-2123286807,'Pisces'],
  [-2123286807,-2123102042,'Aries'],
  [-2123102042,-2122919281,'Taurus'],
  [-2122919281,-2122736388,'Gemini'],
  [-2122736388,-2122551140,'Cancer'],
  [-2122551140,-2122360693,'Leo'],
  [-2122360693,-2122161961,'Virgo'],
  [-2122161961,-2121953251,'Libra'],
  [-2121953251,-2121736665,'Scorpio'],
  [-2121736665,-2121518949,'Sagittarius'],
  [-2121518949,-2121308445,'Capricorn'],
  [-2121308445,-2121109938,'Aquarius'],
  [-2121109938,-2120922789,'Pisces'],
  [-2120922789,-2120742842,'Aries'],
  [-2120742842,-2120564860,'Taurus'],
  [-2120564860,-2120384204,'Gemini'],
  [-2120384204,-2120197704,'Cancer'],
  [-2120197704,-2120003791,'Leo'],
  [-2120003791,-2119801999,'Virgo'],
  [-2119801999,-2119592429,'Libra'],
  [-2119592429,-2119376349,'Scorpio'],
  [-2119376349,-2119157762,'Sagittarius'],
  [-2119157762,-2118943689,'Capricorn'],
  [-2118943689,-2118740988,'Aquarius'],
  [-2118740988,-2118552125,'Pisces'],
  [-2118552125,-2118374351,'Aries'],
  [-2118374351,-2118201645,'Taurus'],
  [-2118201645,-2118027052,'Gemini'],
  [-2118027052,-2117844630,'Cancer'],
  [-2117844630,-2117651213,'Leo'],
  [-2117651213,-2117447253,'Virgo'],
  [-2117447253,-2117235522,'Libra'],
  [-2117235522,-2117018960,'Scorpio'],
  [-2117018960,-2116800340,'Sagittarius'],
  [-2116800340,-2116583925,'Capricorn'],
  [-2116583925,-2116375940,'Aquarius'],
  [-2116375940,-2116181448,'Pisces'],
  [-2116181448,-2116000854,'Aries'],
  [-2116000854,-2115829527,'Taurus'],
  [-2115829527,-2115659978,'Gemini'],
  [-2115659978,-2115484260,'Cancer'],
  [-2115484260,-2115296240,'Leo'],
  [-2115296240,-2115094203,'Virgo'],
  [-2115094203,-2114881565,'Libra'],
  [-2114881565,-2114663937,'Scorpio'],
  [-2114663937,-2114445571,'Sagittarius'],
  [-2114445571,-2114229197,'Capricorn'],
  [-2114229197,-2114018381,'Aquarius'],
  [-2114018381,-2113817886,'Pisces'],
  [-2113817886,-2113630769,'Aries'],
  [-2113630769,-2113455490,'Taurus'],
  [-2113455490,-2113286103,'Gemini'],
  [-2113286103,-2113114567,'Cancer'],
  [-2113114567,-2112933083,'Leo'],
  [-2112933083,-2112736825,'Virgo'],
  [-2112736825,-2112526721,'Libra'],
  [-2112526721,-2112308978,'Scorpio'],
  [-2112308978,-2112090560,'Sagittarius'],
  [-2112090560,-2111875448,'Capricorn'],
  [-2111875448,-2111665482,'Aquarius'],
  [-2111665482,-2111462833,'Pisces'],
  [-2111462833,-2111270139,'Aries'],
  [-2111270139,-2111088177,'Taurus'],
  [-2111088177,-2110913963,'Gemini'],
  [-2110913963,-2110741320,'Cancer'],
  [-2110741320,-2110562837,'Leo'],
  [-2110562837,-2110372198,'Virgo'],
  [-2110372198,-2110167124,'Libra'],
  [-2110167124,-2109951404,'Scorpio'],
  [-2109951404,-2109732946,'Sagittarius'],
  [-2109732946,-2109518496,'Capricorn'],
  [-2109518496,-2109310865,'Aquarius'],
  [-2109310865,-2109110391,'Pisces'],
  [-2109110391,-2108917082,'Aries'],
  [-2108917082,-2108730922,'Taurus'],
  [-2108730922,-2108550657,'Gemini'],
  [-2108550657,-2108372883,'Cancer'],
  [-2108372883,-2108192400,'Leo'],
  [-2108192400,-2108003600,'Virgo'],
  [-2108003600,-2107802676,'Libra'],
  [-2107802676,-2107590235,'Scorpio'],
  [-2107590235,-2107372327,'Sagittarius'],
  [-2107372327,-2107157293,'Capricorn'],
  [-2107157293,-2106950661,'Aquarius'],
  [-2106950661,-2106753417,'Pisces'],
  [-2106753417,-2106563672,'Aries'],
  [-2106563672,-2106378759,'Taurus'],
  [-2106378759,-2106196201,'Gemini'],
  [-2106196201,-2106013647,'Cancer'],
  [-2106013647,-2105828417,'Leo'],
  [-2105828417,-2105637314,'Virgo'],
  [-2105637314,-2105437289,'Libra'],
  [-2105437289,-2105227253,'Scorpio'],
  [-2105227253,-2105010316,'Sagittarius'],
  [-2105010316,-2104793925,'Capricorn'],
  [-2104793925,-2104585852,'Aquarius'],
  [-2104585852,-2104389600,'Pisces'],
  [-2104389600,-2104203608,'Aries'],
  [-2104203608,-2104023348,'Taurus'],
  [-2104023348,-2103843762,'Gemini'],
  [-2103843762,-2103660879,'Cancer'],
  [-2103660879,-2103472447,'Leo'],
  [-2103472447,-2103277515,'Virgo'],
  [-2103277515,-2103075427,'Libra'],
  [-2103075427,-2102865653,'Scorpio'],
  [-2102865653,-2102649408,'Sagittarius'],
  [-2102649408,-2102431688,'Capricorn'],
  [-2102431688,-2102220452,'Aquarius'],
  [-2102220452,-2102021866,'Pisces'],
  [-2102021866,-2101836571,'Aries'],
  [-2101836571,-2101660144,'Taurus'],
  [-2101660144,-2101485863,'Gemini'],
  [-2101485863,-2101307291,'Cancer'],
  [-2101307291,-2101120200,'Leo'],
  [-2101120200,-2100923598,'Virgo'],
  [-2100923598,-2100718845,'Libra'],
  [-2100718845,-2100507616,'Scorpio'],
  [-2100507616,-2100291324,'Sagittarius'],
  [-2100291324,-2100072905,'Capricorn'],
  [-2100072905,-2099858512,'Aquarius'],
  [-2099858512,-2099655374,'Pisces'],
  [-2099655374,-2099466932,'Aries'],
  [-2099466932,-2099290661,'Taurus'],
  [-2099290661,-2099119917,'Gemini'],
  [-2099119917,-2098946887,'Cancer'],
  [-2098946887,-2098764954,'Leo'],
  [-2098764954,-2098570863,'Virgo'],
  [-2098570863,-2098365659,'Libra'],
  [-2098365659,-2098152911,'Scorpio'],
  [-2098152911,-2097935985,'Sagittarius'],
  [-2097935985,-2097717575,'Capricorn'],
  [-2097717575,-2097501676,'Aquarius'],
  [-2097501676,-2097294279,'Pisces'],
  [-2097294279,-2097100384,'Aries'],
  [-2097100384,-2096920228,'Taurus'],
  [-2096920228,-2096748922,'Gemini'],
  [-2096748922,-2096578900,'Cancer'],
  [-2096578900,-2096402412,'Leo'],
  [-2096402412,-2096213774,'Virgo'],
  [-2096213774,-2096011594,'Libra'],
  [-2096011594,-2095799099,'Scorpio'],
  [-2095799099,-2095581618,'Sagittarius'],
  [-2095581618,-2095363540,'Capricorn'],
  [-2095363540,-2095148152,'Aquarius'],
  [-2095148152,-2094939196,'Pisces'],
  [-2094939196,-2094740732,'Aries'],
  [-2094740732,-2094554687,'Taurus'],
  [-2094554687,-2094378847,'Gemini'],
  [-2094378847,-2094207490,'Cancer'],
  [-2094207490,-2094033381,'Leo'],
  [-2094033381,-2093849782,'Virgo'],
  [-2093849782,-2093652720,'Libra'],
  [-2093652720,-2093442960,'Scorpio'],
  [-2093442960,-2093225816,'Sagittarius'],
  [-2093225816,-2093007921,'Capricorn'],
  [-2093007921,-2092793955,'Aquarius'],
  [-2092793955,-2092586495,'Pisces'],
  [-2092586495,-2092387188,'Aries'],
  [-2092387188,-2092197032,'Taurus'],
  [-2092197032,-2092015341,'Gemini'],
  [-2092015341,-2091839000,'Cancer'],
  [-2091839000,-2091662878,'Leo'],
  [-2091662878,-2091480992,'Virgo'],
  [-2091480992,-2091288205,'Libra'],
  [-2091288205,-2091082504,'Scorpio'],
  [-2091082504,-2090866954,'Sagittarius'],
  [-2090866954,-2090648904,'Capricorn'],
  [-2090648904,-2090435605,'Aquarius'],
  [-2090435605,-2090230684,'Pisces'],
  [-2090230684,-2090034212,'Aries'],
  [-2090034212,-2089844604,'Taurus'],
  [-2089844604,-2089659993,'Gemini'],
  [-2089659993,-2089478392,'Cancer'],
  [-2089478392,-2089297213,'Leo'],
  [-2089297213,-2089112867,'Virgo'],
  [-2089112867,-2088921096,'Libra'],
  [-2088921096,-2088718508,'Scorpio'],
  [-2088718508,-2088505237,'Sagittarius'],
  [-2088505237,-2088286940,'Capricorn'],
  [-2088286940,-2088072532,'Aquarius'],
  [-2088072532,-2087868411,'Pisces'],
  [-2087868411,-2087675363,'Aries'],
  [-2087675363,-2087490020,'Taurus'],
  [-2087490020,-2087307825,'Gemini'],
  [-2087307825,-2087125134,'Cancer'],
  [-2087125134,-2086939901,'Leo'],
  [-2086939901,-2086750942,'Virgo'],
  [-2086750942,-2086556587,'Libra'],
  [-2086556587,-2086354353,'Scorpio'],
  [-2086354353,-2086142750,'Sagittarius'],
  [-2086142750,-2085924497,'Capricorn'],
  [-2085924497,-2085707660,'Aquarius'],
  [-2085707660,-2085501149,'Pisces'],
  [-2085501149,-2085308541,'Aries'],
  [-2085308541,-2085126974,'Taurus'],
  [-2085126974,-2084950214,'Gemini'],
  [-2084950214,-2084771913,'Cancer'],
  [-2084771913,-2084587786,'Leo'],
  [-2084587786,-2084396488,'Virgo'],
  [-2084396488,-2084198474,'Libra'],
  [-2084198474,-2083993925,'Scorpio'],
  [-2083993925,-2083782246,'Sagittarius'],
  [-2083782246,-2083564276,'Capricorn'],
  [-2083564276,-2083345329,'Aquarius'],
  [-2083345329,-2083134351,'Pisces'],
  [-2083134351,-2082937946,'Aries'],
  [-2082937946,-2082755940,'Taurus'],
  [-2082755940,-2082582627,'Gemini'],
  [-2082582627,-2082410340,'Cancer'],
  [-2082410340,-2082232184,'Leo'],
  [-2082232184,-2082044053,'Virgo'],
  [-2082044053,-2081845535,'Libra'],
  [-2081845535,-2081638582,'Scorpio'],
  [-2081638582,-2081425280,'Sagittarius'],
  [-2081425280,-2081207256,'Capricorn'],
  [-2081207256,-2080987726,'Aquarius'],
  [-2080987726,-2080773189,'Pisces'],
  [-2080773189,-2080570893,'Aries'],
  [-2080570893,-2080383820,'Taurus'],
  [-2080383820,-2080208861,'Gemini'],
  [-2080208861,-2080039129,'Cancer'],
  [-2080039129,-2079866855,'Leo'],
  [-2079866855,-2079685467,'Virgo'],
  [-2079685467,-2079491455,'Libra'],
  [-2079491455,-2079285382,'Scorpio'],
  [-2079285382,-2079070880,'Sagittarius'],
  [-2079070880,-2078852242,'Capricorn'],
  [-2078852242,-2078633222,'Aquarius'],
  [-2078633222,-2078418064,'Pisces'],
  [-2078418064,-2078211839,'Aries'],
  [-2078211839,-2078018353,'Taurus'],
  [-2078018353,-2077837476,'Gemini'],
  [-2077837476,-2077664935,'Cancer'],
  [-2077664935,-2077494098,'Leo'],
  [-2077494098,-2077317871,'Virgo'],
  [-2077317871,-2077130398,'Libra'],
  [-2077130398,-2076929037,'Scorpio'],
  [-2076929037,-2076715892,'Sagittarius'],
  [-2076715892,-2076496901,'Capricorn'],
  [-2076496901,-2076278362,'Aquarius'],
  [-2076278362,-2076064691,'Pisces'],
  [-2076064691,-2075858589,'Aries'],
  [-2075858589,-2075661839,'Taurus'],
  [-2075661839,-2075474952,'Gemini'],
  [-2075474952,-2075296283,'Cancer'],
  [-2075296283,-2075121871,'Leo'],
  [-2075121871,-2074946054,'Virgo'],
  [-2074946054,-2074762651,'Libra'],
  [-2074762651,-2074566752,'Scorpio'],
  [-2074566752,-2074357351,'Sagittarius'],
  [-2074357351,-2074139236,'Capricorn'],
  [-2074139236,-2073920709,'Aquarius'],
  [-2073920709,-2073708463,'Pisces'],
  [-2073708463,-2073504942,'Aries'],
  [-2073504942,-2073309524,'Taurus'],
  [-2073309524,-2073120746,'Gemini'],
  [-2073120746,-2072937195,'Cancer'],
  [-2072937195,-2072757111,'Leo'],
  [-2072757111,-2072577481,'Virgo'],
  [-2072577481,-2072393718,'Libra'],
  [-2072393718,-2072200655,'Scorpio'],
  [-2072200655,-2071995032,'Sagittarius'],
  [-2071995032,-2071778835,'Capricorn'],
  [-2071778835,-2071560051,'Aquarius'],
  [-2071560051,-2071347757,'Pisces'],
  [-2071347757,-2071146284,'Aries'],
  [-2071146284,-2070954394,'Taurus'],
  [-2070954394,-2070768302,'Gemini'],
  [-2070768302,-2070584549,'Cancer'],
  [-2070584549,-2070401118,'Leo'],
  [-2070401118,-2070216753,'Virgo'],
  [-2070216753,-2070029394,'Libra'],
  [-2070029394,-2069835518,'Scorpio'],
  [-2069835518,-2069631550,'Sagittarius'],
  [-2069631550,-2069417152,'Capricorn'],
  [-2069417152,-2069198093,'Aquarius'],
  [-2069198093,-2068984145,'Pisces'],
  [-2068984145,-2068782254,'Aries'],
  [-2068782254,-2068592644,'Taurus'],
  [-2068592644,-2068410767,'Gemini'],
  [-2068410767,-2068230975,'Cancer'],
  [-2068230975,-2068049037,'Leo'],
  [-2068049037,-2067862964,'Virgo'],
  [-2067862964,-2067672035,'Libra'],
  [-2067672035,-2067475111,'Scorpio'],
  [-2067475111,-2067270226,'Sagittarius'],
  [-2067270226,-2067056480,'Capricorn'],
  [-2067056480,-2066837252,'Aquarius'],
  [-2066837252,-2066620904,'Pisces'],
  [-2066620904,-2066415985,'Aries'],
  [-2066415985,-2066225362,'Taurus'],
  [-2066225362,-2066045651,'Gemini'],
  [-2066045651,-2065870484,'Cancer'],
  [-2065870484,-2065693556,'Leo'],
  [-2065693556,-2065510461,'Virgo'],
  [-2065510461,-2065319323,'Libra'],
  [-2065319323,-2065120014,'Scorpio'],
  [-2065120014,-2064912876,'Sagittarius'],
  [-2064912876,-2064698456,'Capricorn'],
  [-2064698456,-2064479155,'Aquarius'],
  [-2064479155,-2064260985,'Pisces'],
  [-2064260985,-2064051913,'Aries'],
  [-2064051913,-2063857043,'Taurus'],
  [-2063857043,-2063675565,'Gemini'],
  [-2063675565,-2063502193,'Cancer'],
  [-2063502193,-2063330033,'Leo'],
  [-2063330033,-2063152661,'Virgo'],
  [-2063152661,-2062965595,'Libra'],
  [-2062965595,-2062767224,'Scorpio'],
  [-2062767224,-2062558751,'Sagittarius'],
  [-2062558751,-2062343057,'Capricorn'],
  [-2062343057,-2062123658,'Aquarius'],
  [-2062123658,-2061905117,'Pisces'],
  [-2061905117,-2061693161,'Aries'],
  [-2061693161,-2061492960,'Taurus'],
  [-2061492960,-2061306230,'Gemini'],
  [-2061306230,-2061130262,'Cancer'],
  [-2061130262,-2060959337,'Leo'],
  [-2060959337,-2060786581,'Virgo'],
  [-2060786581,-2060605506,'Libra'],
  [-2060605506,-2060411727,'Scorpio'],
  [-2060411727,-2060204779,'Sagittarius'],
  [-2060204779,-2059988544,'Capricorn'],
  [-2059988544,-2059768945,'Aquarius'],
  [-2059768945,-2059551210,'Pisces'],
  [-2059551210,-2059339176,'Aries'],
  [-2059339176,-2059135863,'Taurus'],
  [-2059135863,-2058943332,'Gemini'],
  [-2058943332,-2058761428,'Cancer'],
  [-2058761428,-2058587104,'Leo'],
  [-2058587104,-2058414854,'Virgo'],
  [-2058414854,-2058237883,'Libra'],
  [-2058237883,-2058049800,'Scorpio'],
  [-2058049800,-2057847199,'Sagittarius'],
  [-2057847199,-2057632355,'Capricorn'],
  [-2057632355,-2057412646,'Aquarius'],
  [-2057412646,-2057195734,'Pisces'],
  [-2057195734,-2056985669,'Aries'],
  [-2056985669,-2056783241,'Taurus'],
  [-2056783241,-2056588345,'Gemini'],
  [-2056588345,-2056400999,'Cancer'],
  [-2056400999,-2056220537,'Leo'],
  [-2056220537,-2056044232,'Virgo'],
  [-2056044232,-2055866910,'Libra'],
  [-2055866910,-2055682056,'Scorpio'],
  [-2055682056,-2055484209,'Sagittarius'],
  [-2055484209,-2055272578,'Capricorn'],
  [-2055272578,-2055053351,'Aquarius'],
  [-2055053351,-2054836267,'Pisces'],
  [-2054836267,-2054627780,'Aries'],
  [-2054627780,-2054428541,'Taurus'],
  [-2054428541,-2054236068,'Gemini'],
  [-2054236068,-2054048012,'Cancer'],
  [-2054048012,-2053863355,'Leo'],
  [-2053863355,-2053681351,'Virgo'],
  [-2053681351,-2053499634,'Libra'],
  [-2053499634,-2053313614,'Scorpio'],
  [-2053313614,-2053117899,'Sagittarius'],
  [-2053117899,-2052909487,'Capricorn'],
  [-2052909487,-2052691534,'Aquarius'],
  [-2052691534,-2052473358,'Pisces'],
  [-2052473358,-2052264092,'Aries'],
  [-2052264092,-2052066688,'Taurus'],
  [-2052066688,-2051878388,'Gemini'],
  [-2051878388,-2051694511,'Cancer'],
  [-2051694511,-2051511370,'Leo'],
  [-2051511370,-2051327153,'Virgo'],
  [-2051327153,-2051140857,'Libra'],
  [-2051140857,-2050950610,'Scorpio'],
  [-2050950610,-2050753245,'Sagittarius'],
  [-2050753245,-2050545907,'Capricorn'],
  [-2050545907,-2050329315,'Aquarius'],
  [-2050329315,-2050110074,'Pisces'],
  [-2050110074,-2049897819,'Aries'],
  [-2049897819,-2049698593,'Taurus'],
  [-2049698593,-2049511810,'Gemini'],
  [-2049511810,-2049332588,'Cancer'],
  [-2049332588,-2049155087,'Leo'],
  [-2049155087,-2048974606,'Virgo'],
  [-2048974606,-2048788372,'Libra'],
  [-2048788372,-2048595151,'Scorpio'],
  [-2048595151,-2048394312,'Sagittarius'],
  [-2048394312,-2048185396,'Capricorn'],
  [-2048185396,-2047969142,'Aquarius'],
  [-2047969142,-2047749550,'Pisces'],
  [-2047749550,-2047534100,'Aries'],
  [-2047534100,-2047330151,'Taurus'],
  [-2047330151,-2047140347,'Gemini'],
  [-2047140347,-2046961895,'Cancer'],
  [-2046961895,-2046788921,'Leo'],
  [-2046788921,-2046614840,'Virgo'],
  [-2046614840,-2046433966,'Libra'],
  [-2046433966,-2046242761,'Scorpio'],
  [-2046242761,-2046040600,'Sagittarius'],
  [-2046040600,-2045829382,'Capricorn'],
  [-2045829382,-2045612181,'Aquarius'],
  [-2045612181,-2045392702,'Pisces'],
  [-2045392702,-2045175789,'Aries'],
  [-2045175789,-2044967281,'Taurus'],
  [-2044967281,-2044771592,'Gemini'],
  [-2044771592,-2044589093,'Cancer'],
  [-2044589093,-2044415961,'Leo'],
  [-2044415961,-2044245754,'Virgo'],
  [-2044245754,-2044071229,'Libra'],
  [-2044071229,-2043886074,'Scorpio'],
  [-2043886074,-2043687051,'Sagittarius'],
  [-2043687051,-2043475741,'Capricorn'],
  [-2043475741,-2043257487,'Aquarius'],
  [-2043257487,-2043038029,'Pisces'],
  [-2043038029,-2042821532,'Aries'],
  [-2042821532,-2042611296,'Taurus'],
  [-2042611296,-2042410689,'Gemini'],
  [-2042410689,-2042221893,'Cancer'],
  [-2042221893,-2042044071,'Leo'],
  [-2042044071,-2041872798,'Virgo'],
  [-2041872798,-2041701183,'Libra'],
  [-2041701183,-2041521691,'Scorpio'],
  [-2041521691,-2041328449,'Sagittarius'],
  [-2041328449,-2041120354,'Capricorn'],
  [-2041120354,-2040902539,'Aquarius'],
  [-2040902539,-2040683021,'Pisces'],
  [-2040683021,-2040467592,'Aries'],
  [-2040467592,-2040258503,'Taurus'],
  [-2040258503,-2040056728,'Gemini'],
  [-2040056728,-2039863547,'Cancer'],
  [-2039863547,-2039679702,'Leo'],
  [-2039679702,-2039503501,'Virgo'],
  [-2039503501,-2039330073,'Libra'],
  [-2039330073,-2039152483,'Scorpio'],
  [-2039152483,-2038963850,'Sagittarius'],
  [-2038963850,-2038760455,'Capricorn'],
  [-2038760455,-2038544959,'Aquarius'],
  [-2038544959,-2038325696,'Pisces'],
  [-2038325696,-2038110818,'Aries'],
  [-2038110818,-2037903758,'Taurus'],
  [-2037903758,-2037704155,'Gemini'],
  [-2037704155,-2037510958,'Cancer'],
  [-2037510958,-2037323872,'Leo'],
  [-2037323872,-2037142418,'Virgo'],
  [-2037142418,-2036964177,'Libra'],
  [-2036964177,-2036784301,'Scorpio'],
  [-2036784301,-2036596722,'Sagittarius'],
  [-2036596722,-2036396690,'Capricorn'],
  [-2036396690,-2036184189,'Aquarius'],
  [-2036184189,-2035965642,'Pisces'],
  [-2035965642,-2035750321,'Aries'],
  [-2035750321,-2035544075,'Taurus'],
  [-2035544075,-2035347298,'Gemini'],
  [-2035347298,-2035157427,'Cancer'],
  [-2035157427,-2034971785,'Leo'],
  [-2034971785,-2034788583,'Virgo'],
  [-2034788583,-2034606173,'Libra'],
  [-2034606173,-2034421907,'Scorpio'],
  [-2034421907,-2034231920,'Sagittarius'],
  [-2034231920,-2034032336,'Capricorn'],
  [-2034032336,-2033821832,'Aquarius'],
  [-2033821832,-2033604175,'Pisces'],
  [-2033604175,-2033387618,'Aries'],
  [-2033387618,-2033179967,'Taurus'],
  [-2033179967,-2032983974,'Gemini'],
  [-2032983974,-2032797511,'Cancer'],
  [-2032797511,-2032616294,'Leo'],
  [-2032616294,-2032436066,'Virgo'],
  [-2032436066,-2032253539,'Libra'],
  [-2032253539,-2032066366,'Scorpio'],
  [-2032066366,-2031872701,'Sagittarius'],
  [-2031872701,-2031670975,'Capricorn'],
  [-2031670975,-2031460557,'Aquarius'],
  [-2031460557,-2031243491,'Pisces'],
  [-2031243491,-2031025614,'Aries'],
  [-2031025614,-2030814770,'Taurus'],
  [-2030814770,-2030616307,'Gemini'],
  [-2030616307,-2030430337,'Cancer'],
  [-2030430337,-2030252823,'Leo'],
  [-2030252823,-2030077896,'Virgo'],
  [-2030077896,-2029899749,'Libra'],
  [-2029899749,-2029714031,'Scorpio'],
  [-2029714031,-2029518764,'Sagittarius'],
  [-2029518764,-2029314324,'Capricorn'],
  [-2029314324,-2029102389,'Aquarius'],
  [-2029102389,-2028885292,'Pisces'],
  [-2028885292,-2028666768,'Aries'],
  [-2028666768,-2028452676,'Taurus'],
  [-2028452676,-2028249338,'Gemini'],
  [-2028249338,-2028059820,'Cancer'],
  [-2028059820,-2027882234,'Leo'],
  [-2027882234,-2027710907,'Virgo'],
  [-2027710907,-2027538559,'Libra'],
  [-2027538559,-2027358311,'Scorpio'],
  [-2027358311,-2027165796,'Sagittarius'],
  [-2027165796,-2026960933,'Capricorn'],
  [-2026960933,-2026747374,'Aquarius'],
  [-2026747374,-2026529648,'Pisces'],
  [-2026529648,-2026311314,'Aries'],
  [-2026311314,-2026095860,'Taurus'],
  [-2026095860,-2025888062,'Gemini'],
  [-2025888062,-2025692484,'Cancer'],
  [-2025692484,-2025510328,'Leo'],
  [-2025510328,-2025338055,'Virgo'],
  [-2025338055,-2025168724,'Libra'],
  [-2025168724,-2024994268,'Scorpio'],
  [-2024994268,-2024807774,'Sagittarius'],
  [-2024807774,-2024606406,'Capricorn'],
  [-2024606406,-2024393223,'Aquarius'],
  [-2024393223,-2024174859,'Pisces'],
  [-2024174859,-2023956939,'Aries'],
  [-2023956939,-2023742370,'Taurus'],
  [-2023742370,-2023533386,'Gemini'],
  [-2023533386,-2023333174,'Cancer'],
  [-2023333174,-2023144470,'Leo'],
  [-2023144470,-2022966776,'Virgo'],
  [-2022966776,-2022795398,'Libra'],
  [-2022795398,-2022622975,'Scorpio'],
  [-2022622975,-2022441716,'Sagittarius'],
  [-2022441716,-2022246148,'Capricorn'],
  [-2022246148,-2022036332,'Aquarius'],
  [-2022036332,-2021818454,'Pisces'],
  [-2021818454,-2021600542,'Aries'],
  [-2021600542,-2021387453,'Taurus'],
  [-2021387453,-2021180534,'Gemini'],
  [-2021180534,-2020980303,'Cancer'],
  [-2020980303,-2020787919,'Leo'],
  [-2020787919,-2020604036,'Virgo'],
  [-2020604036,-2020426784,'Libra'],
  [-2020426784,-2020251287,'Scorpio'],
  [-2020251287,-2020070939,'Sagittarius'],
  [-2020070939,-2019879571,'Capricorn'],
  [-2019879571,-2019674427,'Aquarius'],
  [-2019674427,-2019458732,'Pisces'],
  [-2019458732,-2019240604,'Aries'],
  [-2019240604,-2019027685,'Taurus'],
  [-2019027685,-2018823122,'Gemini'],
  [-2018823122,-2018626369,'Cancer'],
  [-2018626369,-2018435806,'Leo'],
  [-2018435806,-2018250117,'Virgo'],
  [-2018250117,-2018067918,'Libra'],
  [-2018067918,-2017886766,'Scorpio'],
  [-2017886766,-2017702783,'Sagittarius'],
  [-2017702783,-2017511379,'Capricorn'],
  [-2017511379,-2017309084,'Aquarius'],
  [-2017309084,-2017096155,'Pisces'],
  [-2017096155,-2016878176,'Aries'],
  [-2016878176,-2016663733,'Taurus'],
  [-2016663733,-2016459025,'Gemini'],
  [-2016459025,-2016265103,'Cancer'],
  [-2016265103,-2016079214,'Leo'],
  [-2016079214,-2015897278,'Virgo'],
  [-2015897278,-2015715579,'Libra'],
  [-2015715579,-2015531375,'Scorpio'],
  [-2015531375,-2015342702,'Sagittarius'],
  [-2015342702,-2015147795,'Capricorn'],
  [-2015147795,-2014944911,'Aquarius'],
  [-2014944911,-2014733427,'Pisces'],
  [-2014733427,-2014515973,'Aries'],
  [-2014515973,-2014299385,'Taurus'],
  [-2014299385,-2014091660,'Gemini'],
  [-2014091660,-2013896949,'Cancer'],
  [-2013896949,-2013713852,'Leo'],
  [-2013713852,-2013537208,'Virgo'],
  [-2013537208,-2013360757,'Libra'],
  [-2013360757,-2013179192,'Scorpio'],
  [-2013179192,-2012989528,'Sagittarius'],
  [-2012989528,-2012791383,'Capricorn'],
  [-2012791383,-2012585739,'Aquarius'],
  [-2012585739,-2012373584,'Pisces'],
  [-2012373584,-2012156432,'Aries'],
  [-2012156432,-2011938382,'Taurus'],
  [-2011938382,-2011726600,'Gemini'],
  [-2011726600,-2011527602,'Cancer'],
  [-2011527602,-2011342930,'Leo'],
  [-2011342930,-2011168554,'Virgo'],
  [-2011168554,-2010997357,'Libra'],
  [-2010997357,-2010821843,'Scorpio'],
  [-2010821843,-2010636336,'Sagittarius'],
  [-2010636336,-2010438899,'Capricorn'],
  [-2010438899,-2010231504,'Aquarius'],
  [-2010231504,-2010017657,'Pisces'],
  [-2010017657,-2009800181,'Aries'],
  [-2009800181,-2009581800,'Taurus'],
  [-2009581800,-2009367292,'Gemini'],
  [-2009367292,-2009163083,'Cancer'],
  [-2009163083,-2008973273,'Leo'],
  [-2008973273,-2008796519,'Virgo'],
  [-2008796519,-2008626761,'Libra'],
  [-2008626761,-2008455996,'Scorpio'],
  [-2008455996,-2008276675,'Sagittarius'],
  [-2008276675,-2008084081,'Capricorn'],
  [-2008084081,-2007878369,'Aquarius'],
  [-2007878369,-2007663894,'Pisces'],
  [-2007663894,-2007445831,'Aries'],
  [-2007445831,-2007227809,'Taurus'],
  [-2007227809,-2007012975,'Gemini'],
  [-2007012975,-2006805682,'Cancer'],
  [-2006805682,-2006610299,'Leo'],
  [-2006610299,-2006427971,'Virgo'],
  [-2006427971,-2006255114,'Libra'],
  [-2006255114,-2006084909,'Scorpio'],
  [-2006084909,-2005909625,'Sagittarius'],
  [-2005909625,-2005722801,'Capricorn'],
  [-2005722801,-2005521746,'Aquarius'],
  [-2005521746,-2005309048,'Pisces'],
  [-2005309048,-2005090949,'Aries'],
  [-2005090949,-2004873336,'Taurus'],
  [-2004873336,-2004659802,'Gemini'],
  [-2004659802,-2004452815,'Cancer'],
  [-2004452815,-2004254794,'Leo'],
  [-2004254794,-2004067189,'Virgo'],
  [-2004067189,-2003888682,'Libra'],
  [-2003888682,-2003714857,'Scorpio'],
  [-2003714857,-2003539403,'Sagittarius'],
  [-2003539403,-2003355847,'Capricorn'],
  [-2003355847,-2003159661,'Aquarius'],
  [-2003159661,-2002950585,'Pisces'],
  [-2002950585,-2002733534,'Aries'],
  [-2002733534,-2002516011,'Taurus'],
  [-2002516011,-2002303742,'Gemini'],
  [-2002303742,-2002099159,'Cancer'],
  [-2002099159,-2001902542,'Leo'],
  [-2001902542,-2001713359,'Virgo'],
  [-2001713359,-2001530391,'Libra'],
  [-2001530391,-2001351193,'Scorpio'],
  [-2001351193,-2001171900,'Sagittarius'],
  [-2001171900,-2000987681,'Capricorn'],
  [-2000987681,-2000793947,'Aquarius'],
  [-2000793947,-2000588372,'Pisces'],
  [-2000588372,-2000373179,'Aries'],
  [-2000373179,-2000155401,'Taurus'],
  [-2000155401,-1999943015,'Gemini'],
  [-1999943015,-1999740366,'Cancer'],
  [-1999740366,-1999547248,'Leo'],
  [-1999547248,-1999360825,'Virgo'],
  [-1999360825,-1999177779,'Libra'],
  [-1999177779,-1998995358,'Scorpio'],
  [-1998995358,-1998811347,'Sagittarius'],
  [-1998811347,-1998623428,'Capricorn'],
  [-1998623428,-1998428766,'Aquarius'],
  [-1998428766,-1998224760,'Pisces'],
  [-1998224760,-1998011308,'Aries'],
  [-1998011308,-1997793164,'Taurus'],
  [-1997793164,-1997578933,'Gemini'],
  [-1997578933,-1997375690,'Cancer'],
  [-1997375690,-1997184850,'Leo'],
  [-1997184850,-1997002818,'Virgo'],
  [-1997002818,-1996823969,'Libra'],
  [-1996823969,-1996643229,'Scorpio'],
  [-1996643229,-1996457547,'Sagittarius'],
  [-1996457547,-1996265923,'Capricorn'],
  [-1996265923,-1996068053,'Aquarius'],
  [-1996068053,-1995863082,'Pisces'],
  [-1995863082,-1995650327,'Aries'],
  [-1995650327,-1995432014,'Taurus'],
  [-1995432014,-1995215129,'Gemini'],
  [-1995215129,-1995008390,'Cancer'],
  [-1995008390,-1994816180,'Leo'],
  [-1994816180,-1994636290,'Virgo'],
  [-1994636290,-1994462344,'Libra'],
  [-1994462344,-1994287097,'Scorpio'],
  [-1994287097,-1994104883,'Sagittarius'],
  [-1994104883,-1993913279,'Capricorn'],
  [-1993913279,-1993712954,'Aquarius'],
  [-1993712954,-1993505558,'Pisces'],
  [-1993505558,-1993292091,'Aries'],
  [-1993292091,-1993073843,'Taurus'],
  [-1993073843,-1992855172,'Gemini'],
  [-1992855172,-1992643878,'Cancer'],
  [-1992643878,-1992446657,'Leo'],
  [-1992446657,-1992264319,'Virgo'],
  [-1992264319,-1992091832,'Libra'],
  [-1992091832,-1991921480,'Scorpio'],
  [-1991921480,-1991745637,'Sagittarius'],
  [-1991745637,-1991558972,'Capricorn'],
  [-1991558972,-1991360174,'Aquarius'],
  [-1991360174,-1991151551,'Pisces'],
  [-1991151551,-1990936637,'Aries'],
  [-1990936637,-1990718306,'Taurus'],
  [-1990718306,-1990499619,'Gemini'],
  [-1990499619,-1990285729,'Cancer'],
  [-1990285729,-1990082855,'Leo'],
  [-1990082855,-1989894348,'Virgo'],
  [-1989894348,-1989718178,'Libra'],
  [-1989718178,-1989548186,'Scorpio'],
  [-1989548186,-1989376690,'Sagittarius'],
  [-1989376690,-1989196596,'Capricorn'],
  [-1989196596,-1989003463,'Aquarius'],
  [-1989003463,-1988797222,'Pisces'],
  [-1988797222,-1988581947,'Aries'],
  [-1988581947,-1988363192,'Taurus'],
  [-1988363192,-1988145423,'Gemini'],
  [-1988145423,-1987932179,'Cancer'],
  [-1987932179,-1987727002,'Leo'],
  [-1987727002,-1987532809,'Virgo'],
  [-1987532809,-1987349929,'Libra'],
  [-1987349929,-1987175198,'Scorpio'],
  [-1987175198,-1987002866,'Sagittarius'],
  [-1987002866,-1986826166,'Capricorn'],
  [-1986826166,-1986639000,'Aquarius'],
  [-1986639000,-1986438068,'Pisces'],
  [-1986438068,-1986224990,'Aries'],
  [-1986224990,-1986006132,'Taurus'],
  [-1986006132,-1985788798,'Gemini'],
  [-1985788798,-1985577650,'Cancer'],
  [-1985577650,-1985374369,'Leo'],
  [-1985374369,-1985179162,'Virgo'],
  [-1985179162,-1984991643,'Libra'],
  [-1984991643,-1984810506,'Scorpio'],
  [-1984810506,-1984632939,'Sagittarius'],
  [-1984632939,-1984454448,'Capricorn'],
  [-1984454448,-1984269518,'Aquarius'],
  [-1984269518,-1984073234,'Pisces'],
  [-1984073234,-1983864009,'Aries'],
  [-1983864009,-1983646129,'Taurus'],
  [-1983646129,-1983428323,'Gemini'],
  [-1983428323,-1983218107,'Cancer'],
  [-1983218107,-1983017928,'Leo'],
  [-1983017928,-1982826034,'Virgo'],
  [-1982826034,-1982639359,'Libra'],
  [-1982639359,-1982455420,'Scorpio'],
  [-1982455420,-1982272590,'Sagittarius'],
  [-1982272590,-1982089096,'Capricorn'],
  [-1982089096,-1981901863,'Aquarius'],
  [-1981901863,-1981706696,'Pisces'],
  [-1981706696,-1981500385,'Aries'],
  [-1981500385,-1981284175,'Taurus'],
  [-1981284175,-1981065515,'Gemini'],
  [-1981065515,-1980854019,'Cancer'],
  [-1980854019,-1980654813,'Leo'],
  [-1980654813,-1980466577,'Virgo'],
  [-1980466577,-1980284405,'Libra'],
  [-1980284405,-1980103209,'Scorpio'],
  [-1980103209,-1979919701,'Sagittarius'],
  [-1979919701,-1979732603,'Capricorn'],
  [-1979732603,-1979541193,'Aquarius'],
  [-1979541193,-1979343715,'Pisces'],
  [-1979343715,-1979137691,'Aries'],
  [-1979137691,-1978922632,'Taurus'],
  [-1978922632,-1978703309,'Gemini'],
  [-1978703309,-1978489063,'Cancer'],
  [-1978489063,-1978287600,'Leo'],
  [-1978287600,-1978099967,'Virgo'],
  [-1978099967,-1977921518,'Libra'],
  [-1977921518,-1977745592,'Scorpio'],
  [-1977745592,-1977566375,'Sagittarius'],
  [-1977566375,-1977380519,'Capricorn'],
  [-1977380519,-1977187214,'Aquarius'],
  [-1977187214,-1976986688,'Pisces'],
  [-1976986688,-1976778810,'Aries'],
  [-1976778810,-1976563632,'Taurus'],
  [-1976563632,-1976344009,'Gemini'],
  [-1976344009,-1976127132,'Cancer'],
  [-1976127132,-1975921364,'Leo'],
  [-1975921364,-1975730526,'Virgo'],
  [-1975730526,-1975552051,'Libra'],
  [-1975552051,-1975379562,'Scorpio'],
  [-1975379562,-1975205944,'Sagittarius'],
  [-1975205944,-1975025387,'Capricorn'],
  [-1975025387,-1974834718,'Aquarius'],
  [-1974834718,-1974633676,'Pisces'],
  [-1974633676,-1974423912,'Aries'],
  [-1974423912,-1974207680,'Taurus'],
  [-1974207680,-1973987973,'Gemini'],
  [-1973987973,-1973769888,'Cancer'],
  [-1973769888,-1973560192,'Leo'],
  [-1973560192,-1973363998,'Virgo'],
  [-1973363998,-1973181504,'Libra'],
  [-1973181504,-1973008281,'Scorpio'],
  [-1973008281,-1972837629,'Sagittarius'],
  [-1972837629,-1972662621,'Capricorn'],
  [-1972662621,-1972477649,'Aquarius'],
  [-1972477649,-1972279930,'Pisces'],
  [-1972279930,-1972070483,'Aries'],
  [-1972070483,-1971853402,'Taurus'],
  [-1971853402,-1971633643,'Gemini'],
  [-1971633643,-1971415929,'Cancer'],
  [-1971415929,-1971204778,'Leo'],
  [-1971204778,-1971004137,'Virgo'],
  [-1971004137,-1970815756,'Libra'],
  [-1970815756,-1970637901,'Scorpio'],
  [-1970637901,-1970465857,'Sagittarius'],
  [-1970465857,-1970293247,'Capricorn'],
  [-1970293247,-1970113426,'Aquarius'],
  [-1970113426,-1969921163,'Pisces'],
  [-1969921163,-1969714916,'Aries'],
  [-1969714916,-1969498378,'Taurus'],
  [-1969498378,-1969278599,'Gemini'],
  [-1969278599,-1969061929,'Cancer'],
  [-1969061929,-1968851983,'Leo'],
  [-1968851983,-1968650342,'Virgo'],
  [-1968650342,-1968457770,'Libra'],
  [-1968457770,-1968274009,'Scorpio'],
  [-1968274009,-1968096982,'Sagittarius'],
  [-1968096982,-1967922414,'Capricorn'],
  [-1967922414,-1967744335,'Aquarius'],
  [-1967744335,-1967556488,'Pisces'],
  [-1967556488,-1967354793,'Aries'],
  [-1967354793,-1967140515,'Taurus'],
  [-1967140515,-1966920945,'Gemini'],
  [-1966920945,-1966704820,'Cancer'],
  [-1966704820,-1966496989,'Leo'],
  [-1966496989,-1966297686,'Virgo'],
  [-1966297686,-1966105234,'Libra'],
  [-1966105234,-1965918255,'Scorpio'],
  [-1965918255,-1965735836,'Sagittarius'],
  [-1965735836,-1965556245,'Capricorn'],
  [-1965556245,-1965375757,'Aquarius'],
  [-1965375757,-1965188934,'Pisces'],
  [-1965188934,-1964990602,'Aries'],
  [-1964990602,-1964779321,'Taurus'],
  [-1964779321,-1964560377,'Gemini'],
  [-1964560377,-1964343637,'Cancer'],
  [-1964343637,-1964136558,'Leo'],
  [-1964136558,-1963940241,'Virgo'],
  [-1963940241,-1963751438,'Libra'],
  [-1963751438,-1963566234,'Scorpio'],
  [-1963566234,-1963382189,'Sagittarius'],
  [-1963382189,-1963198255,'Capricorn'],
  [-1963198255,-1963013067,'Aquarius'],
  [-1963013067,-1962823584,'Pisces'],
  [-1962823584,-1962625607,'Aries'],
  [-1962625607,-1962416397,'Taurus'],
  [-1962416397,-1962198394,'Gemini'],
  [-1962198394,-1961980189,'Cancer'],
  [-1961980189,-1961771272,'Leo'],
  [-1961771272,-1961575442,'Virgo'],
  [-1961575442,-1961390113,'Libra'],
  [-1961390113,-1961209821,'Scorpio'],
  [-1961209821,-1961029465,'Sagittarius'],
  [-1961029465,-1960845929,'Capricorn'],
  [-1960845929,-1960657906,'Aquarius'],
  [-1960657906,-1960464448,'Pisces'],
  [-1960464448,-1960263920,'Aries'],
  [-1960263920,-1960054628,'Taurus'],
  [-1960054628,-1959837373,'Gemini'],
  [-1959837373,-1959617928,'Cancer'],
  [-1959617928,-1959405378,'Leo'],
  [-1959405378,-1959206244,'Virgo'],
  [-1959206244,-1959020646,'Libra'],
  [-1959020646,-1958843797,'Scorpio'],
  [-1958843797,-1958669239,'Sagittarius'],
  [-1958669239,-1958491136,'Capricorn'],
  [-1958491136,-1958305592,'Aquarius'],
  [-1958305592,-1958111028,'Pisces'],
  [-1958111028,-1957907610,'Aries'],
  [-1957907610,-1957696354,'Taurus'],
  [-1957696354,-1957478993,'Gemini'],
  [-1957478993,-1957259304,'Cancer'],
  [-1957259304,-1957043756,'Leo'],
  [-1957043756,-1956839222,'Virgo'],
  [-1956839222,-1956648884,'Libra'],
  [-1956648884,-1956470684,'Scorpio'],
  [-1956470684,-1956298999,'Sagittarius'],
  [-1956298999,-1956126905,'Capricorn'],
  [-1956126905,-1955947884,'Aquarius'],
  [-1955947884,-1955757402,'Pisces'],
  [-1955757402,-1955554393,'Aries'],
  [-1955554393,-1955341482,'Taurus'],
  [-1955341482,-1955123152,'Gemini'],
  [-1955123152,-1954903832,'Cancer'],
  [-1954903832,-1954687728,'Leo'],
  [-1954687728,-1954479386,'Virgo'],
  [-1954479386,-1954282708,'Libra'],
  [-1954282708,-1954098706,'Scorpio'],
  [-1954098706,-1953924538,'Sagittarius'],
  [-1953924538,-1953754321,'Capricorn'],
  [-1953754321,-1953580767,'Aquarius'],
  [-1953580767,-1953396944,'Pisces'],
  [-1953396944,-1953198652,'Aries'],
  [-1953198652,-1952986976,'Taurus'],
  [-1952986976,-1952768027,'Gemini'],
  [-1952768027,-1952548875,'Cancer'],
  [-1952548875,-1952334018,'Leo'],
  [-1952334018,-1952125622,'Virgo'],
  [-1952125622,-1951925483,'Libra'],
  [-1951925483,-1951735231,'Scorpio'],
  [-1951735231,-1951554844,'Sagittarius'],
  [-1951554844,-1951381225,'Capricorn'],
  [-1951381225,-1951208367,'Aquarius'],
  [-1951208367,-1951028917,'Pisces'],
  [-1951028917,-1950836484,'Aries'],
  [-1950836484,-1950628987,'Taurus'],
  [-1950628987,-1950411151,'Gemini'],
  [-1950411151,-1950191912,'Cancer'],
  [-1950191912,-1949978193,'Leo'],
  [-1949978193,-1949772095,'Virgo'],
  [-1949772095,-1949573054,'Libra'],
  [-1949573054,-1949380625,'Scorpio'],
  [-1949380625,-1949194998,'Sagittarius'],
  [-1949194998,-1949015450,'Capricorn'],
  [-1949015450,-1948838675,'Aquarius'],
  [-1948838675,-1948658872,'Pisces'],
  [-1948658872,-1948469514,'Aries'],
  [-1948469514,-1948266376,'Taurus'],
  [-1948266376,-1948051169,'Gemini'],
  [-1948051169,-1947832068,'Cancer'],
  [-1947832068,-1947618239,'Leo'],
  [-1947618239,-1947413907,'Virgo'],
  [-1947413907,-1947218157,'Libra'],
  [-1947218157,-1947028260,'Scorpio'],
  [-1947028260,-1946842214,'Sagittarius'],
  [-1946842214,-1946659001,'Capricorn'],
  [-1946659001,-1946477148,'Aquarius'],
  [-1946477148,-1946293418,'Pisces'],
  [-1946293418,-1946103056,'Aries'],
  [-1946103056,-1945901775,'Taurus'],
  [-1945901775,-1945689031,'Gemini'],
  [-1945689031,-1945470412,'Cancer'],
  [-1945470412,-1945255277,'Leo'],
  [-1945255277,-1945050419,'Virgo'],
  [-1945050419,-1944856701,'Libra'],
  [-1944856701,-1944670880,'Scorpio'],
  [-1944670880,-1944488732,'Sagittarius'],
  [-1944488732,-1944306901,'Capricorn'],
  [-1944306901,-1944123130,'Aquarius'],
  [-1944123130,-1943935490,'Pisces'],
  [-1943935490,-1943741661,'Aries'],
  [-1943741661,-1943539211,'Taurus'],
  [-1943539211,-1943327319,'Gemini'],
  [-1943327319,-1943109182,'Cancer'],
  [-1943109182,-1942892284,'Leo'],
  [-1942892284,-1942684617,'Virgo'],
  [-1942684617,-1942489762,'Libra'],
  [-1942489762,-1942305950,'Scorpio'],
  [-1942305950,-1942128366,'Sagittarius'],
  [-1942128366,-1941951514,'Capricorn'],
  [-1941951514,-1941770690,'Aquarius'],
  [-1941770690,-1941582746,'Pisces'],
  [-1941582746,-1941386262,'Aries'],
  [-1941386262,-1941181172,'Taurus'],
  [-1941181172,-1940968368,'Gemini'],
  [-1940968368,-1940750336,'Cancer'],
  [-1940750336,-1940532144,'Leo'],
  [-1940532144,-1940320786,'Virgo'],
  [-1940320786,-1940121826,'Libra'],
  [-1940121826,-1939936203,'Scorpio'],
  [-1939936203,-1939760369,'Sagittarius'],
  [-1939760369,-1939588228,'Capricorn'],
  [-1939588228,-1939413073,'Aquarius'],
  [-1939413073,-1939229237,'Pisces'],
  [-1939229237,-1939033721,'Aries'],
  [-1939033721,-1938827148,'Taurus'],
  [-1938827148,-1938612748,'Gemini'],
  [-1938612748,-1938394359,'Cancer'],
  [-1938394359,-1938175855,'Leo'],
  [-1938175855,-1937961933,'Virgo'],
  [-1937961933,-1937757942,'Libra'],
  [-1937757942,-1937567227,'Scorpio'],
  [-1937567227,-1937388893,'Sagittarius'],
  [-1937388893,-1937218003,'Capricorn'],
  [-1937218003,-1937047357,'Aquarius'],
  [-1937047357,-1936869454,'Pisces'],
  [-1936869454,-1936678672,'Aries'],
  [-1936678672,-1936473827,'Taurus'],
  [-1936473827,-1936258880,'Gemini'],
  [-1936258880,-1936039978,'Cancer'],
  [-1936039978,-1935821905,'Leo'],
  [-1935821905,-1935607741,'Virgo'],
  [-1935607741,-1935400702,'Libra'],
  [-1935400702,-1935204335,'Scorpio'],
  [-1935204335,-1935020258,'Sagittarius'],
  [-1935020258,-1934846146,'Capricorn'],
  [-1934846146,-1934676017,'Aquarius'],
  [-1934676017,-1934502109,'Pisces'],
  [-1934502109,-1934317073,'Aries'],
  [-1934317073,-1934116920,'Taurus'],
  [-1934116920,-1933903791,'Gemini'],
  [-1933903791,-1933684869,'Cancer'],
  [-1933684869,-1933467268,'Leo'],
  [-1933467268,-1933254556,'Virgo'],
  [-1933254556,-1933047995,'Libra'],
  [-1933047995,-1932849027,'Scorpio'],
  [-1932849027,-1932659446,'Sagittarius'],
  [-1932659446,-1932479307,'Capricorn'],
  [-1932479307,-1932305245,'Aquarius'],
  [-1932305245,-1932130984,'Pisces'],
  [-1932130984,-1931949192,'Aries'],
  [-1931949192,-1931754086,'Taurus'],
  [-1931754086,-1931544801,'Gemini'],
  [-1931544801,-1931326985,'Cancer'],
  [-1931326985,-1931109373,'Leo'],
  [-1931109373,-1930897916,'Virgo'],
  [-1930897916,-1930694003,'Libra'],
  [-1930694003,-1930496875,'Scorpio'],
  [-1930496875,-1930306028,'Sagittarius'],
  [-1930306028,-1930121322,'Capricorn'],
  [-1930121322,-1929941426,'Aquarius'],
  [-1929941426,-1929762730,'Pisces'],
  [-1929762730,-1929579785,'Aries'],
  [-1929579785,-1929387023,'Taurus'],
  [-1929387023,-1929181525,'Gemini'],
  [-1929181525,-1928965857,'Cancer'],
  [-1928965857,-1928747883,'Leo'],
  [-1928747883,-1928535897,'Virgo'],
  [-1928535897,-1928333677,'Libra'],
  [-1928333677,-1928140352,'Scorpio'],
  [-1928140352,-1927953075,'Sagittarius'],
  [-1927953075,-1927769107,'Capricorn'],
  [-1927769107,-1927586316,'Aquarius'],
  [-1927586316,-1927402593,'Pisces'],
  [-1927402593,-1927215192,'Aries'],
  [-1927215192,-1927020795,'Taurus'],
  [-1927020795,-1926816700,'Gemini'],
  [-1926816700,-1926603101,'Cancer'],
  [-1926603101,-1926384976,'Leo'],
  [-1926384976,-1926170700,'Virgo'],
  [-1926170700,-1925966999,'Libra'],
  [-1925966999,-1925775329,'Scorpio'],
  [-1925775329,-1925592630,'Sagittarius'],
  [-1925592630,-1925413848,'Capricorn'],
  [-1925413848,-1925234033,'Aquarius'],
  [-1925234033,-1925049568,'Pisces'],
  [-1925049568,-1924858550,'Aries'],
  [-1924858550,-1924660310,'Taurus'],
  [-1924660310,-1924454573,'Gemini'],
  [-1924454573,-1924241581,'Cancer'],
  [-1924241581,-1924023720,'Leo'],
  [-1924023720,-1923806964,'Virgo'],
  [-1923806964,-1923599059,'Libra'],
  [-1923599059,-1923404741,'Scorpio'],
  [-1923404741,-1923223152,'Sagittarius'],
  [-1923223152,-1923049048,'Capricorn'],
  [-1923049048,-1922875435,'Aquarius'],
  [-1922875435,-1922695844,'Pisces'],
  [-1922695844,-1922506218,'Aries'],
  [-1922506218,-1922306075,'Taurus'],
  [-1922306075,-1922097618,'Gemini'],
  [-1922097618,-1921883463,'Cancer'],
  [-1921883463,-1921665794,'Leo'],
  [-1921665794,-1921447941,'Virgo'],
  [-1921447941,-1921235865,'Libra'],
  [-1921235865,-1921035922,'Scorpio'],
  [-1921035922,-1920850564,'Sagittarius'],
  [-1920850564,-1920676611,'Capricorn'],
  [-1920676611,-1920507066,'Aquarius'],
  [-1920507066,-1920333870,'Pisces'],
  [-1920333870,-1920150210,'Aries'],
  [-1920150210,-1919952987,'Taurus'],
  [-1919952987,-1919744122,'Gemini'],
  [-1919744122,-1919528511,'Cancer'],
  [-1919528511,-1919310517,'Leo'],
  [-1919310517,-1919092989,'Virgo'],
  [-1919092989,-1918879324,'Libra'],
  [-1918879324,-1918674563,'Scorpio'],
  [-1918674563,-1918482918,'Sagittarius'],
  [-1918482918,-1918304324,'Capricorn'],
  [-1918304324,-1918133795,'Aquarius'],
  [-1918133795,-1917963625,'Pisces'],
  [-1917963625,-1917785849,'Aries'],
  [-1917785849,-1917594692,'Taurus'],
  [-1917594692,-1917389254,'Gemini'],
  [-1917389254,-1917174033,'Cancer'],
  [-1917174033,-1916955626,'Leo'],
  [-1916955626,-1916738781,'Virgo'],
  [-1916738781,-1916526117,'Libra'],
  [-1916526117,-1916320212,'Scorpio'],
  [-1916320212,-1916124118,'Sagittarius'],
  [-1916124118,-1915939332,'Capricorn'],
  [-1915939332,-1915763682,'Aquarius'],
  [-1915763682,-1915591553,'Pisces'],
  [-1915591553,-1915415718,'Aries'],
  [-1915415718,-1915229488,'Taurus'],
  [-1915229488,-1915029281,'Gemini'],
  [-1915029281,-1914816870,'Cancer'],
  [-1914816870,-1914598812,'Leo'],
  [-1914598812,-1914382224,'Virgo'],
  [-1914382224,-1914171258,'Libra'],
  [-1914171258,-1913967405,'Scorpio'],
  [-1913967405,-1913771264,'Sagittarius'],
  [-1913771264,-1913583116,'Capricorn'],
  [-1913583116,-1913401971,'Aquarius'],
  [-1913401971,-1913224712,'Pisces'],
  [-1913224712,-1913046349,'Aries'],
  [-1913046349,-1912861182,'Taurus'],
  [-1912861182,-1912664690,'Gemini'],
  [-1912664690,-1912455920,'Cancer'],
  [-1912455920,-1912239158,'Leo'],
  [-1912239158,-1912022259,'Virgo'],
  [-1912022259,-1911811881,'Libra'],
  [-1911811881,-1911610617,'Scorpio'],
  [-1911610617,-1911417686,'Sagittarius'],
  [-1911417686,-1911230896,'Capricorn'],
  [-1911230896,-1911047874,'Aquarius'],
  [-1911047874,-1910866220,'Pisces'],
  [-1910866220,-1910683170,'Aries'],
  [-1910683170,-1910495368,'Taurus'],
  [-1910495368,-1910299314,'Gemini'],
  [-1910299314,-1910092892,'Cancer'],
  [-1910092892,-1909877690,'Leo'],
  [-1909877690,-1909660118,'Virgo'],
  [-1909660118,-1909448479,'Libra'],
  [-1909448479,-1909247867,'Scorpio'],
  [-1909247867,-1909058158,'Sagittarius'],
  [-1909058158,-1908875611,'Capricorn'],
  [-1908875611,-1908695416,'Aquarius'],
  [-1908695416,-1908513524,'Pisces'],
  [-1908513524,-1908327404,'Aries'],
  [-1908327404,-1908135711,'Taurus'],
  [-1908135711,-1907937301,'Gemini'],
  [-1907937301,-1907730908,'Cancer'],
  [-1907730908,-1907516634,'Leo'],
  [-1907516634,-1907298390,'Virgo'],
  [-1907298390,-1907084084,'Libra'],
  [-1907084084,-1906881194,'Scorpio'],
  [-1906881194,-1906691931,'Sagittarius'],
  [-1906691931,-1906512879,'Capricorn'],
  [-1906512879,-1906337713,'Aquarius'],
  [-1906337713,-1906160006,'Pisces'],
  [-1906160006,-1905975243,'Aries'],
  [-1905975243,-1905781872,'Taurus'],
  [-1905781872,-1905580587,'Gemini'],
  [-1905580587,-1905372404,'Cancer'],
  [-1905372404,-1905157968,'Leo'],
  [-1905157968,-1904939363,'Virgo'],
  [-1904939363,-1904722385,'Libra'],
  [-1904722385,-1904515108,'Scorpio'],
  [-1904515108,-1904322550,'Sagittarius'],
  [-1904322550,-1904143423,'Capricorn'],
  [-1904143423,-1903971630,'Aquarius'],
  [-1903971630,-1903799435,'Pisces'],
  [-1903799435,-1903619960,'Aries'],
  [-1903619960,-1903429300,'Taurus'],
  [-1903429300,-1903227598,'Gemini'],
  [-1903227598,-1903017610,'Cancer'],
  [-1903017610,-1902802171,'Leo'],
  [-1902802171,-1902583520,'Virgo'],
  [-1902583520,-1902365330,'Libra'],
  [-1902365330,-1902153986,'Scorpio'],
  [-1902153986,-1901955762,'Sagittarius'],
  [-1901955762,-1901772323,'Capricorn'],
  [-1901772323,-1901599616,'Aquarius'],
  [-1901599616,-1901430309,'Pisces'],
  [-1901430309,-1901256477,'Aries'],
  [-1901256477,-1901071780,'Taurus'],
  [-1901071780,-1900873666,'Gemini'],
  [-1900873666,-1900664135,'Cancer'],
  [-1900664135,-1900447843,'Leo'],
  [-1900447843,-1900229167,'Virgo'],
  [-1900229167,-1900011504,'Libra'],
  [-1900011504,-1899798865,'Scorpio'],
  [-1899798865,-1899596066,'Sagittarius'],
  [-1899596066,-1899406245,'Capricorn'],
  [-1899406245,-1899228284,'Aquarius'],
  [-1899228284,-1899057031,'Pisces'],
  [-1899057031,-1898885323,'Aries'],
  [-1898885323,-1898705979,'Taurus'],
  [-1898705979,-1898513855,'Gemini'],
  [-1898513855,-1898308011,'Cancer'],
  [-1898308011,-1898092403,'Leo'],
  [-1898092403,-1897873579,'Virgo'],
  [-1897873579,-1897656995,'Libra'],
  [-1897656995,-1897445974,'Scorpio'],
  [-1897445974,-1897242713,'Sagittarius'],
  [-1897242713,-1897048841,'Capricorn'],
  [-1897048841,-1896864502,'Aquarius'],
  [-1896864502,-1896687364,'Pisces'],
  [-1896687364,-1896512743,'Aries'],
  [-1896512743,-1896334613,'Taurus'],
  [-1896334613,-1896147061,'Gemini'],
  [-1896147061,-1895946385,'Cancer'],
  [-1895946385,-1895733553,'Leo'],
  [-1895733553,-1895514887,'Virgo'],
  [-1895514887,-1895298490,'Libra'],
  [-1895298490,-1895089588,'Scorpio'],
  [-1895089588,-1894889347,'Sagittarius'],
  [-1894889347,-1894696611,'Capricorn'],
  [-1894696611,-1894509739,'Aquarius'],
  [-1894509739,-1894327098,'Pisces'],
  [-1894327098,-1894146582,'Aries'],
  [-1894146582,-1893964930,'Taurus'],
  [-1893964930,-1893777677,'Gemini'],
  [-1893777677,-1893580345,'Cancer'],
  [-1893580345,-1893371017,'Leo'],
  [-1893371017,-1893153299,'Virgo'],
  [-1893153299,-1892935895,'Libra'],
  [-1892935895,-1892727048,'Scorpio'],
  [-1892727048,-1892529586,'Sagittarius'],
  [-1892529586,-1892341159,'Capricorn'],
  [-1892341159,-1892157370,'Aquarius'],
  [-1892157370,-1891974400,'Pisces'],
  [-1891974400,-1891790078,'Aries'],
  [-1891790078,-1891603294,'Taurus'],
  [-1891603294,-1891412447,'Gemini'],
  [-1891412447,-1891214685,'Cancer'],
  [-1891214685,-1891007277,'Leo'],
  [-1891007277,-1890790902,'Virgo'],
  [-1890790902,-1890572172,'Libra'],
  [-1890572172,-1890360819,'Scorpio'],
  [-1890360819,-1890162817,'Sagittarius'],
  [-1890162817,-1889977214,'Capricorn'],
  [-1889977214,-1889798524,'Aquarius'],
  [-1889798524,-1889620382,'Pisces'],
  [-1889620382,-1889438063,'Aries'],
  [-1889438063,-1889249602,'Taurus'],
  [-1889249602,-1889054984,'Gemini'],
  [-1889054984,-1888854118,'Cancer'],
  [-1888854118,-1888645963,'Leo'],
  [-1888645963,-1888430266,'Virgo'],
  [-1888430266,-1888210808,'Libra'],
  [-1888210808,-1887996037,'Scorpio'],
  [-1887996037,-1887794079,'Sagittarius'],
  [-1887794079,-1887607019,'Capricorn'],
  [-1887607019,-1887430616,'Aquarius'],
  [-1887430616,-1887257721,'Pisces'],
  [-1887257721,-1887081358,'Aries'],
  [-1887081358,-1886896765,'Taurus'],
  [-1886896765,-1886702436,'Gemini'],
  [-1886702436,-1886499326,'Cancer'],
  [-1886499326,-1886288990,'Leo'],
  [-1886288990,-1886072754,'Virgo'],
  [-1886072754,-1885853239,'Libra'],
  [-1885853239,-1885636290,'Scorpio'],
  [-1885636290,-1885429489,'Sagittarius'],
  [-1885429489,-1885237372,'Capricorn'],
  [-1885237372,-1885058521,'Aquarius'],
  [-1885058521,-1884887054,'Pisces'],
  [-1884887054,-1884715565,'Aries'],
  [-1884715565,-1884537303,'Taurus'],
  [-1884537303,-1884347856,'Gemini'],
  [-1884347856,-1884146314,'Cancer'],
  [-1884146314,-1883934991,'Leo'],
  [-1883934991,-1883717695,'Virgo'],
  [-1883717695,-1883498306,'Libra'],
  [-1883498306,-1883281216,'Scorpio'],
  [-1883281216,-1883071658,'Sagittarius'],
  [-1883071658,-1882874107,'Capricorn'],
  [-1882874107,-1882689579,'Aquarius'],
  [-1882689579,-1882514848,'Pisces'],
  [-1882514848,-1882343913,'Aries'],
  [-1882343913,-1882169853,'Taurus'],
  [-1882169853,-1881986423,'Gemini'],
  [-1881986423,-1881789808,'Cancer'],
  [-1881789808,-1881580395,'Leo'],
  [-1881580395,-1881362871,'Virgo'],
  [-1881362871,-1881143517,'Libra'],
  [-1881143517,-1880927509,'Scorpio'],
  [-1880927509,-1880718314,'Sagittarius'],
  [-1880718314,-1880518260,'Capricorn'],
  [-1880518260,-1880328464,'Aquarius'],
  [-1880328464,-1880147934,'Pisces'],
  [-1880147934,-1879973243,'Aries'],
  [-1879973243,-1879799014,'Taurus'],
  [-1879799014,-1879618964,'Gemini'],
  [-1879618964,-1879427493,'Cancer'],
  [-1879427493,-1879222143,'Leo'],
  [-1879222143,-1879005987,'Virgo'],
  [-1879005987,-1878786667,'Libra'],
  [-1878786667,-1878571624,'Scorpio'],
  [-1878571624,-1878364574,'Sagittarius'],
  [-1878364574,-1878165818,'Capricorn'],
  [-1878165818,-1877974435,'Aquarius'],
  [-1877974435,-1877789400,'Pisces'],
  [-1877789400,-1877609239,'Aries'],
  [-1877609239,-1877431098,'Taurus'],
  [-1877431098,-1877250332,'Gemini'],
  [-1877250332,-1877061343,'Cancer'],
  [-1877061343,-1876859827,'Leo'],
  [-1876859827,-1876646128,'Virgo'],
  [-1876646128,-1876427002,'Libra'],
  [-1876427002,-1876211861,'Scorpio'],
  [-1876211861,-1876006454,'Sagittarius'],
  [-1876006454,-1875810843,'Capricorn'],
  [-1875810843,-1875621972,'Aquarius'],
  [-1875621972,-1875436735,'Pisces'],
  [-1875436735,-1875253277,'Aries'],
  [-1875253277,-1875070368,'Taurus'],
  [-1875070368,-1874885818,'Gemini'],
  [-1874885818,-1874695749,'Cancer'],
  [-1874695749,-1874495810,'Leo'],
  [-1874495810,-1874284302,'Virgo'],
  [-1874284302,-1874065547,'Libra'],
  [-1874065547,-1873849075,'Scorpio'],
  [-1873849075,-1873643122,'Sagittarius'],
  [-1873643122,-1873449490,'Capricorn'],
  [-1873449490,-1873264600,'Aquarius'],
  [-1873264600,-1873083216,'Pisces'],
  [-1873083216,-1872901207,'Aries'],
  [-1872901207,-1872716506,'Taurus'],
  [-1872716506,-1872528173,'Gemini'],
  [-1872528173,-1872334713,'Cancer'],
  [-1872334713,-1872133573,'Leo'],
  [-1872133573,-1871922812,'Virgo'],
  [-1871922812,-1871704438,'Libra'],
  [-1871704438,-1871486086,'Scorpio'],
  [-1871486086,-1871277149,'Sagittarius'],
  [-1871277149,-1871082231,'Capricorn'],
  [-1871082231,-1870899261,'Aquarius'],
  [-1870899261,-1870722447,'Pisces'],
  [-1870722447,-1870545577,'Aries'],
  [-1870545577,-1870364033,'Taurus'],
  [-1870364033,-1870175531,'Gemini'],
  [-1870175531,-1869979443,'Cancer'],
  [-1869979443,-1869775583,'Leo'],
  [-1869775583,-1869563834,'Virgo'],
  [-1869563834,-1869345582,'Libra'],
  [-1869345582,-1869125939,'Scorpio'],
  [-1869125939,-1868913075,'Sagittarius'],
  [-1868913075,-1868713578,'Capricorn'],
  [-1868713578,-1868528317,'Aquarius'],
  [-1868528317,-1868352966,'Pisces'],
  [-1868352966,-1868180900,'Aries'],
  [-1868180900,-1868005489,'Taurus'],
  [-1868005489,-1867821640,'Gemini'],
  [-1867821640,-1867626874,'Cancer'],
  [-1867626874,-1867421553,'Leo'],
  [-1867421553,-1867208017,'Virgo'],
  [-1867208017,-1866989377,'Libra'],
  [-1866989377,-1866769652,'Scorpio'],
  [-1866769652,-1866554382,'Sagittarius'],
  [-1866554382,-1866349518,'Capricorn'],
  [-1866349518,-1866158350,'Aquarius'],
  [-1866158350,-1865979571,'Pisces'],
  [-1865979571,-1865808162,'Aries'],
  [-1865808162,-1865637299,'Taurus'],
  [-1865637299,-1865460008,'Gemini'],
  [-1865460008,-1865270825,'Cancer'],
  [-1865270825,-1865067831,'Leo'],
  [-1865067831,-1864853792,'Virgo'],
  [-1864853792,-1864634442,'Libra'],
  [-1864634442,-1864415289,'Scorpio'],
  [-1864415289,-1864200351,'Sagittarius'],
  [-1864200351,-1863992922,'Capricorn'],
  [-1863992922,-1863795904,'Aquarius'],
  [-1863795904,-1863610426,'Pisces'],
  [-1863610426,-1863434556,'Aries'],
  [-1863434556,-1863263304,'Taurus'],
  [-1863263304,-1863089770,'Gemini'],
  [-1863089770,-1862906806,'Cancer'],
  [-1862906806,-1862709415,'Leo'],
  [-1862709415,-1862497859,'Virgo'],
  [-1862497859,-1862278490,'Libra'],
  [-1862278490,-1862059590,'Scorpio'],
  [-1862059590,-1861846371,'Sagittarius'],
  [-1861846371,-1861640316,'Capricorn'],
  [-1861640316,-1861441679,'Aquarius'],
  [-1861441679,-1861251003,'Pisces'],
  [-1861251003,-1861068442,'Aries'],
  [-1861068442,-1860892059,'Taurus'],
  [-1860892059,-1860717044,'Gemini'],
  [-1860717044,-1860536666,'Cancer'],
  [-1860536666,-1860344425,'Leo'],
  [-1860344425,-1860137432,'Virgo'],
  [-1860137432,-1859919684,'Libra'],
  [-1859919684,-1859700584,'Scorpio'],
  [-1859700584,-1859488196,'Sagittarius'],
  [-1859488196,-1859284902,'Capricorn'],
  [-1859284902,-1859089065,'Aquarius'],
  [-1859089065,-1858898555,'Pisces'],
  [-1858898555,-1858712443,'Aries'],
  [-1858712443,-1858530255,'Taurus'],
  [-1858530255,-1858350017,'Gemini'],
  [-1858350017,-1858167333,'Cancer'],
  [-1858167333,-1857976460,'Leo'],
  [-1857976460,-1857773052,'Virgo'],
  [-1857773052,-1857557948,'Libra'],
  [-1857557948,-1857338782,'Scorpio'],
  [-1857338782,-1857125409,'Sagittarius'],
  [-1857125409,-1856923009,'Capricorn'],
  [-1856923009,-1856730611,'Aquarius'],
  [-1856730611,-1856544295,'Pisces'],
  [-1856544295,-1856360412,'Aries'],
  [-1856360412,-1856176857,'Taurus'],
  [-1856176857,-1855992370,'Gemini'],
  [-1855992370,-1855805017,'Cancer'],
  [-1855805017,-1855611558,'Leo'],
  [-1855611558,-1855408587,'Virgo'],
  [-1855408587,-1855195348,'Libra'],
  [-1855195348,-1854976506,'Scorpio'],
  [-1854976506,-1854761058,'Sagittarius'],
  [-1854761058,-1854556573,'Capricorn'],
  [-1854556573,-1854364698,'Aquarius'],
  [-1854364698,-1854182048,'Pisces'],
  [-1854182048,-1854003358,'Aries'],
  [-1854003358,-1853823819,'Taurus'],
  [-1853823819,-1853640104,'Gemini'],
  [-1853640104,-1853450293,'Cancer'],
  [-1853450293,-1853253216,'Leo'],
  [-1853253216,-1853048004,'Virgo'],
  [-1853048004,-1852834729,'Libra'],
  [-1852834729,-1852616226,'Scorpio'],
  [-1852616226,-1852398947,'Sagittarius'],
  [-1852398947,-1852190597,'Capricorn'],
  [-1852190597,-1851995552,'Aquarius'],
  [-1851995552,-1851812828,'Pisces'],
  [-1851812828,-1851637635,'Aries'],
  [-1851637635,-1851463736,'Taurus'],
  [-1851463736,-1851285223,'Gemini'],
  [-1851285223,-1851097827,'Cancer'],
  [-1851097827,-1850899871,'Leo'],
  [-1850899871,-1850692302,'Virgo'],
  [-1850692302,-1850477603,'Libra'],
  [-1850477603,-1850259041,'Scorpio'],
  [-1850259041,-1850041027,'Sagittarius'],
  [-1850041027,-1849829299,'Capricorn'],
  [-1849829299,-1849629146,'Aquarius'],
  [-1849629146,-1849442397,'Pisces'],
  [-1849442397,-1849266478,'Aries'],
  [-1849266478,-1849095605,'Taurus'],
  [-1849095605,-1848922661,'Gemini'],
  [-1848922661,-1848740973,'Cancer'],
  [-1848740973,-1848546345,'Leo'],
  [-1848546345,-1848338975,'Virgo'],
  [-1848338975,-1848123113,'Libra'],
  [-1848123113,-1847904154,'Scorpio'],
  [-1847904154,-1847686434,'Sagittarius'],
  [-1847686434,-1847473517,'Capricorn'],
  [-1847473517,-1847269264,'Aquarius'],
  [-1847269264,-1847076791,'Pisces'],
  [-1847076791,-1846896282,'Aries'],
  [-1846896282,-1846724034,'Taurus'],
  [-1846724034,-1846553438,'Gemini'],
  [-1846553438,-1846376856,'Cancer'],
  [-1846376856,-1846187801,'Leo'],
  [-1846187801,-1845983867,'Virgo'],
  [-1845983867,-1845768655,'Libra'],
  [-1845768655,-1845549452,'Scorpio'],
  [-1845549452,-1845332386,'Sagittarius'],
  [-1845332386,-1845120457,'Capricorn'],
  [-1845120457,-1844915281,'Aquarius'],
  [-1844915281,-1844718810,'Pisces'],
  [-1844718810,-1844532533,'Aries'],
  [-1844532533,-1844355375,'Taurus'],
  [-1844355375,-1844182776,'Gemini'],
  [-1844182776,-1844007783,'Cancer'],
  [-1844007783,-1843823109,'Leo'],
  [-1843823109,-1843624004,'Virgo'],
  [-1843624004,-1843411521,'Libra'],
  [-1843411521,-1843192765,'Scorpio'],
  [-1843192765,-1842976023,'Sagittarius'],
  [-1842976023,-1842765752,'Capricorn'],
  [-1842765752,-1842562580,'Aquarius'],
  [-1842562580,-1842366134,'Pisces'],
  [-1842366134,-1842176672,'Aries'],
  [-1842176672,-1841994198,'Taurus'],
  [-1841994198,-1841816602,'Gemini'],
  [-1841816602,-1841639078,'Cancer'],
  [-1841639078,-1841455273,'Leo'],
  [-1841455273,-1841259617,'Virgo'],
  [-1841259617,-1841050615,'Libra'],
  [-1841050615,-1840833128,'Scorpio'],
  [-1840833128,-1840616061,'Sagittarius'],
  [-1840616061,-1840406340,'Capricorn'],
  [-1840406340,-1840205721,'Aquarius'],
  [-1840205721,-1840012532,'Pisces'],
  [-1840012532,-1839824555,'Aries'],
  [-1839824555,-1839640284,'Taurus'],
  [-1839640284,-1839458276,'Gemini'],
  [-1839458276,-1839275967,'Cancer'],
  [-1839275967,-1839089349,'Leo'],
  [-1839089349,-1838893978,'Virgo'],
  [-1838893978,-1838687293,'Libra'],
  [-1838687293,-1838471394,'Scorpio'],
  [-1838471394,-1838253571,'Sagittarius'],
  [-1838253571,-1838042344,'Capricorn'],
  [-1838042344,-1837842149,'Aquarius'],
  [-1837842149,-1837652178,'Pisces'],
  [-1837652178,-1837468743,'Aries'],
  [-1837468743,-1837287708,'Taurus'],
  [-1837287708,-1837105711,'Gemini'],
  [-1837105711,-1836920304,'Cancer'],
  [-1836920304,-1836729504,'Leo'],
  [-1836729504,-1836531426,'Virgo'],
  [-1836531426,-1836324652,'Libra'],
  [-1836324652,-1836109810,'Scorpio'],
  [-1836109810,-1835891385,'Sagittarius'],
  [-1835891385,-1835677164,'Capricorn'],
  [-1835677164,-1835474049,'Aquarius'],
  [-1835474049,-1835283997,'Pisces'],
  [-1835283997,-1835104034,'Aries'],
  [-1835104034,-1834928551,'Taurus'],
  [-1834928551,-1834751515,'Gemini'],
  [-1834751515,-1834568104,'Cancer'],
  [-1834568104,-1834375810,'Leo'],
  [-1834375810,-1834174563,'Virgo'],
  [-1834174563,-1833965630,'Libra'],
  [-1833965630,-1833750611,'Scorpio'],
  [-1833750611,-1833532117,'Sagittarius'],
  [-1833532117,-1833315296,'Capricorn'],
  [-1833315296,-1833107201,'Aquarius'],
  [-1833107201,-1832912802,'Pisces'],
  [-1832912802,-1832731895,'Aries'],
  [-1832731895,-1832559546,'Taurus'],
  [-1832559546,-1832388473,'Gemini'],
  [-1832388473,-1832211318,'Cancer'],
  [-1832211318,-1832022780,'Leo'],
  [-1832022780,-1831821641,'Virgo'],
  [-1831821641,-1831610789,'Libra'],
  [-1831610789,-1831394516,'Scorpio'],
  [-1831394516,-1831176145,'Sagittarius'],
  [-1831176145,-1830958664,'Capricorn'],
  [-1830958664,-1830746768,'Aquarius'],
  [-1830746768,-1830546118,'Pisces'],
  [-1830546118,-1830359681,'Aries'],
  [-1830359681,-1830185252,'Taurus'],
  [-1830185252,-1830016368,'Gemini'],
  [-1830016368,-1829844847,'Cancer'],
  [-1829844847,-1829663083,'Leo'],
  [-1829663083,-1829466742,'Virgo'],
  [-1829466742,-1829257126,'Libra'],
  [-1829257126,-1829040048,'Scorpio'],
  [-1829040048,-1828821481,'Sagittarius'],
  [-1828821481,-1828604861,'Capricorn'],
  [-1828604861,-1828392574,'Aquarius'],
  [-1828392574,-1828188112,'Pisces'],
  [-1828188112,-1827995151,'Aries'],
  [-1827995151,-1827814484,'Taurus'],
  [-1827814484,-1827642350,'Gemini'],
  [-1827642350,-1827471738,'Cancer'],
  [-1827471738,-1827294691,'Leo'],
  [-1827294691,-1827104725,'Virgo'],
  [-1827104725,-1826899848,'Libra'],
  [-1826899848,-1826684212,'Scorpio'],
  [-1826684212,-1826465469,'Sagittarius'],
  [-1826465469,-1826249637,'Capricorn'],
  [-1826249637,-1826039275,'Aquarius'],
  [-1826039275,-1825835515,'Pisces'],
  [-1825835515,-1825639841,'Aries'],
  [-1825639841,-1825453389,'Taurus'],
  [-1825453389,-1825274962,'Gemini'],
  [-1825274962,-1825100264,'Cancer'],
  [-1825100264,-1824922946,'Leo'],
  [-1824922946,-1824736500,'Virgo'],
  [-1824736500,-1824536768,'Libra'],
  [-1824536768,-1824324637,'Scorpio'],
  [-1824324637,-1824106537,'Sagittarius'],
  [-1824106537,-1823890579,'Capricorn'],
  [-1823890579,-1823681735,'Aquarius'],
  [-1823681735,-1823481032,'Pisces'],
  [-1823481032,-1823287566,'Aries'],
  [-1823287566,-1823100163,'Taurus'],
  [-1823100163,-1822917449,'Gemini'],
  [-1822917449,-1822737111,'Cancer'],
  [-1822737111,-1822555495,'Leo'],
  [-1822555495,-1822368023,'Virgo'],
  [-1822368023,-1822170584,'Libra'],
  [-1822170584,-1821961786,'Scorpio'],
  [-1821961786,-1821745115,'Sagittarius'],
  [-1821745115,-1821528355,'Capricorn'],
  [-1821528355,-1821319005,'Aquarius'],
  [-1821319005,-1821120215,'Pisces'],
  [-1821120215,-1820930711,'Aries'],
  [-1820930711,-1820746967,'Taurus'],
  [-1820746967,-1820565218,'Gemini'],
  [-1820565218,-1820382433,'Cancer'],
  [-1820382433,-1820196363,'Leo'],
  [-1820196363,-1820005021,'Virgo'],
  [-1820005021,-1819806308,'Libra'],
  [-1819806308,-1819598710,'Scorpio'],
  [-1819598710,-1819383334,'Sagittarius'],
  [-1819383334,-1819165665,'Capricorn'],
  [-1819165665,-1818953926,'Aquarius'],
  [-1818953926,-1818754044,'Pisces'],
  [-1818754044,-1818566495,'Aries'],
  [-1818566495,-1818387205,'Taurus'],
  [-1818387205,-1818210230,'Gemini'],
  [-1818210230,-1818030113,'Cancer'],
  [-1818030113,-1817843388,'Leo'],
  [-1817843388,-1817648999,'Virgo'],
  [-1817648999,-1817447282,'Libra'],
  [-1817447282,-1817238579,'Scorpio'],
  [-1817238579,-1817023555,'Sagittarius'],
  [-1817023555,-1816805299,'Capricorn'],
  [-1816805299,-1816590585,'Aquarius'],
  [-1816590585,-1816386944,'Pisces'],
  [-1816386944,-1816197641,'Aries'],
  [-1816197641,-1816020008,'Taurus'],
  [-1816020008,-1815847555,'Gemini'],
  [-1815847555,-1815672914,'Cancer'],
  [-1815672914,-1815490139,'Leo'],
  [-1815490139,-1815296560,'Virgo'],
  [-1815296560,-1815093132,'Libra'],
  [-1815093132,-1814882476,'Scorpio'],
  [-1814882476,-1814666821,'Sagittarius'],
  [-1814666821,-1814448411,'Capricorn'],
  [-1814448411,-1814231724,'Aquarius'],
  [-1814231724,-1814023639,'Pisces'],
  [-1814023639,-1813829546,'Aries'],
  [-1813829546,-1813649444,'Taurus'],
  [-1813649444,-1813478073,'Gemini'],
  [-1813478073,-1813307700,'Cancer'],
  [-1813307700,-1813130699,'Leo'],
  [-1813130699,-1812941818,'Virgo'],
  [-1812941818,-1812740143,'Libra'],
  [-1812740143,-1812528808,'Scorpio'],
  [-1812528808,-1812312250,'Sagittarius'],
  [-1812312250,-1812093929,'Capricorn'],
  [-1812093929,-1811877065,'Aquarius'],
  [-1811877065,-1811666363,'Pisces'],
  [-1811666363,-1811467062,'Aries'],
  [-1811467062,-1811281466,'Taurus'],
  [-1811281466,-1811106875,'Gemini'],
  [-1811106875,-1810936849,'Cancer'],
  [-1810936849,-1810763661,'Leo'],
  [-1810763661,-1810580455,'Virgo'],
  [-1810580455,-1810383580,'Libra'],
  [-1810383580,-1810174242,'Scorpio'],
  [-1810174242,-1809957578,'Sagittarius'],
  [-1809957578,-1809739325,'Capricorn'],
  [-1809739325,-1809523522,'Aquarius'],
  [-1809523522,-1809313220,'Pisces'],
  [-1809313220,-1809111493,'Aries'],
  [-1809111493,-1808920632,'Taurus'],
  [-1808920632,-1808740173,'Gemini'],
  [-1808740173,-1808566232,'Cancer'],
  [-1808566232,-1808392640,'Leo'],
  [-1808392640,-1808212651,'Virgo'],
  [-1808212651,-1808020901,'Libra'],
  [-1808020901,-1807815699,'Scorpio'],
  [-1807815699,-1807600460,'Sagittarius'],
  [-1807600460,-1807382188,'Capricorn'],
  [-1807382188,-1807167306,'Aquarius'],
  [-1807167306,-1806959257,'Pisces'],
  [-1806959257,-1806759079,'Aries'],
  [-1806759079,-1806566786,'Taurus'],
  [-1806566786,-1806381715,'Gemini'],
  [-1806381715,-1806201958,'Cancer'],
  [-1806201958,-1806023989,'Leo'],
  [-1806023989,-1805842953,'Virgo'],
  [-1805842953,-1805653669,'Libra'],
  [-1805653669,-1805452506,'Scorpio'],
  [-1805452506,-1805239909,'Sagittarius'],
  [-1805239909,-1805021744,'Capricorn'],
  [-1805021744,-1804806483,'Aquarius'],
  [-1804806483,-1804599978,'Pisces'],
  [-1804599978,-1804403256,'Aries'],
  [-1804403256,-1804214046,'Taurus'],
  [-1804214046,-1804029229,'Gemini'],
  [-1804029229,-1803846223,'Cancer'],
  [-1803846223,-1803663062,'Leo'],
  [-1803663062,-1803477606,'Virgo'],
  [-1803477606,-1803286822,'Libra'],
  [-1803286822,-1803087237,'Scorpio'],
  [-1803087237,-1802877097,'Sagittarius'],
  [-1802877097,-1802659411,'Capricorn'],
  [-1802659411,-1802442437,'Aquarius'],
  [-1802442437,-1802234784,'Pisces'],
  [-1802234784,-1802039787,'Aries'],
  [-1802039787,-1801854917,'Taurus'],
  [-1801854917,-1801674783,'Gemini'],
  [-1801674783,-1801494142,'Cancer'],
  [-1801494142,-1801309686,'Leo'],
  [-1801309686,-1801120277,'Virgo'],
  [-1801120277,-1800925540,'Libra'],
  [-1800925540,-1800724293,'Scorpio'],
  [-1800724293,-1800514867,'Sagittarius'],
  [-1800514867,-1800297846,'Capricorn'],
  [-1800297846,-1800078985,'Aquarius'],
  [-1800078985,-1799867663,'Pisces'],
  [-1799867663,-1799670415,'Aries'],
  [-1799670415,-1799486848,'Taurus'],
  [-1799486848,-1799311331,'Gemini'],
  [-1799311331,-1799136621,'Cancer'],
  [-1799136621,-1798956599,'Leo'],
  [-1798956599,-1798768079,'Virgo'],
  [-1798768079,-1798571038,'Libra'],
  [-1798571038,-1798366754,'Scorpio'],
  [-1798366754,-1798155920,'Sagittarius'],
  [-1798155920,-1797939068,'Capricorn'],
  [-1797939068,-1797719369,'Aquarius'],
  [-1797719369,-1797504216,'Pisces'],
  [-1797504216,-1797301640,'Aries'],
  [-1797301640,-1797114560,'Taurus'],
  [-1797114560,-1796939378,'Gemini'],
  [-1796939378,-1796768880,'Cancer'],
  [-1796768880,-1796595350,'Leo'],
  [-1796595350,-1796412744,'Virgo'],
  [-1796412744,-1796218427,'Libra'],
  [-1796218427,-1796013431,'Scorpio'],
  [-1796013431,-1795800717,'Sagittarius'],
  [-1795800717,-1795583162,'Capricorn'],
  [-1795583162,-1795363651,'Aquarius'],
  [-1795363651,-1795146940,'Pisces'],
  [-1795146940,-1794939520,'Aries'],
  [-1794939520,-1794746096,'Taurus'],
  [-1794746096,-1794566259,'Gemini'],
  [-1794566259,-1794394887,'Cancer'],
  [-1794394887,-1794224685,'Leo'],
  [-1794224685,-1794048369,'Virgo'],
  [-1794048369,-1793860474,'Libra'],
  [-1793860474,-1793659118,'Scorpio'],
  [-1793659118,-1793446711,'Sagittarius'],
  [-1793446711,-1793228378,'Capricorn'],
  [-1793228378,-1793009187,'Aquarius'],
  [-1793009187,-1792793287,'Pisces'],
  [-1792793287,-1792584540,'Aries'],
  [-1792584540,-1792386349,'Taurus'],
  [-1792386349,-1792199961,'Gemini'],
  [-1792199961,-1792023220,'Cancer'],
  [-1792023220,-1791851088,'Leo'],
  [-1791851088,-1791677049,'Virgo'],
  [-1791677049,-1791494611,'Libra'],
  [-1791494611,-1791299127,'Scorpio'],
  [-1791299127,-1791090089,'Sagittarius'],
  [-1791090089,-1790872262,'Capricorn'],
  [-1790872262,-1790653108,'Aquarius'],
  [-1790653108,-1790438622,'Pisces'],
  [-1790438622,-1790231702,'Aries'],
  [-1790231702,-1790033161,'Taurus'],
  [-1790033161,-1789842979,'Gemini'],
  [-1789842979,-1789660259,'Cancer'],
  [-1789660259,-1789482654,'Leo'],
  [-1789482654,-1789306034,'Virgo'],
  [-1789306034,-1789124881,'Libra'],
  [-1789124881,-1788933613,'Scorpio'],
  [-1788933613,-1788729018,'Sagittarius'],
  [-1788729018,-1788513258,'Capricorn'],
  [-1788513258,-1788294101,'Aquarius'],
  [-1788294101,-1788080088,'Pisces'],
  [-1788080088,-1787875504,'Aries'],
  [-1787875504,-1787679893,'Taurus'],
  [-1787679893,-1787490744,'Gemini'],
  [-1787490744,-1787305745,'Cancer'],
  [-1787305745,-1787123303,'Leo'],
  [-1787123303,-1786941665,'Virgo'],
  [-1786941665,-1786757715,'Libra'],
  [-1786757715,-1786566930,'Scorpio'],
  [-1786566930,-1786365136,'Sagittarius'],
  [-1786365136,-1786151827,'Capricorn'],
  [-1786151827,-1785932844,'Aquarius'],
  [-1785932844,-1785717909,'Pisces'],
  [-1785717909,-1785513869,'Aries'],
  [-1785513869,-1785321184,'Taurus'],
  [-1785321184,-1785135955,'Gemini'],
  [-1785135955,-1784953476,'Cancer'],
  [-1784953476,-1784770470,'Leo'],
  [-1784770470,-1784585432,'Virgo'],
  [-1784585432,-1784397284,'Libra'],
  [-1784397284,-1784203854,'Scorpio'],
  [-1784203854,-1784002014,'Sagittarius'],
  [-1784002014,-1783790099,'Capricorn'],
  [-1783790099,-1783571382,'Aquarius'],
  [-1783571382,-1783354594,'Pisces'],
  [-1783354594,-1783148562,'Aries'],
  [-1783148562,-1782956168,'Taurus'],
  [-1782956168,-1782774099,'Gemini'],
  [-1782774099,-1782596323,'Cancer'],
  [-1782596323,-1782417216,'Leo'],
  [-1782417216,-1782233272,'Virgo'],
  [-1782233272,-1782043200,'Libra'],
  [-1782043200,-1781846572,'Scorpio'],
  [-1781846572,-1781642560,'Sagittarius'],
  [-1781642560,-1781430383,'Capricorn'],
  [-1781430383,-1781211810,'Aquarius'],
  [-1781211810,-1780993259,'Pisces'],
  [-1780993259,-1780783549,'Aries'],
  [-1780783549,-1780588080,'Taurus'],
  [-1780588080,-1780405781,'Gemini'],
  [-1780405781,-1780231099,'Cancer'],
  [-1780231099,-1780057223,'Leo'],
  [-1780057223,-1779878288,'Virgo'],
  [-1779878288,-1779690709,'Libra'],
  [-1779690709,-1779493460,'Scorpio'],
  [-1779493460,-1779287295,'Sagittarius'],
  [-1779287295,-1779073709,'Capricorn'],
  [-1779073709,-1778854991,'Aquarius'],
  [-1778854991,-1778635685,'Pisces'],
  [-1778635685,-1778422648,'Aries'],
  [-1778422648,-1778222074,'Taurus'],
  [-1778222074,-1778035667,'Gemini'],
  [-1778035667,-1777860047,'Cancer'],
  [-1777860047,-1777688956,'Leo'],
  [-1777688956,-1777515468,'Virgo'],
  [-1777515468,-1777333599,'Libra'],
  [-1777333599,-1777139775,'Scorpio'],
  [-1777139775,-1776933917,'Sagittarius'],
  [-1776933917,-1776719167,'Capricorn'],
  [-1776719167,-1776500034,'Aquarius'],
  [-1776500034,-1776281087,'Pisces'],
  [-1776281087,-1776066975,'Aries'],
  [-1776066975,-1775862251,'Taurus'],
  [-1775862251,-1775669838,'Gemini'],
  [-1775669838,-1775489209,'Cancer'],
  [-1775489209,-1775316371,'Leo'],
  [-1775316371,-1775145120,'Virgo'],
  [-1775145120,-1774968517,'Libra'],
  [-1774968517,-1774780541,'Scorpio'],
  [-1774780541,-1774578355,'Sagittarius'],
  [-1774578355,-1774364287,'Capricorn'],
  [-1774364287,-1774144810,'Aquarius'],
  [-1774144810,-1773926574,'Pisces'],
  [-1773926574,-1773713745,'Aries'],
  [-1773713745,-1773508401,'Taurus'],
  [-1773508401,-1773311955,'Gemini'],
  [-1773311955,-1773125082,'Cancer'],
  [-1773125082,-1772946617,'Leo'],
  [-1772946617,-1772772797,'Virgo'],
  [-1772772797,-1772597630,'Libra'],
  [-1772597630,-1772414270,'Scorpio'],
  [-1772414270,-1772217354,'Sagittarius'],
  [-1772217354,-1772006335,'Capricorn'],
  [-1772006335,-1771787253,'Aquarius'],
  [-1771787253,-1771569161,'Pisces'],
  [-1771569161,-1771358116,'Aries'],
  [-1771358116,-1771155306,'Taurus'],
  [-1771155306,-1770959514,'Gemini'],
  [-1770959514,-1770769731,'Cancer'],
  [-1770769731,-1770585594,'Leo'],
  [-1770585594,-1770405996,'Virgo'],
  [-1770405996,-1770227558,'Libra'],
  [-1770227558,-1770044679,'Scorpio'],
  [-1770044679,-1769851304,'Sagittarius'],
  [-1769851304,-1769644205,'Capricorn'],
  [-1769644205,-1769426650,'Aquarius'],
  [-1769426650,-1769207980,'Pisces'],
  [-1769207980,-1768997074,'Aries'],
  [-1768997074,-1768796801,'Taurus'],
  [-1768796801,-1768604869,'Gemini'],
  [-1768604869,-1768417599,'Cancer'],
  [-1768417599,-1768232521,'Leo'],
  [-1768232521,-1768048661,'Virgo'],
  [-1768048661,-1767864911,'Libra'],
  [-1767864911,-1767678403,'Scorpio'],
  [-1767678403,-1767484658,'Sagittarius'],
  [-1767484658,-1767279791,'Capricorn'],
  [-1767279791,-1767064205,'Aquarius'],
  [-1767064205,-1766844902,'Pisces'],
  [-1766844902,-1766631932,'Aries'],
  [-1766631932,-1766431249,'Taurus'],
  [-1766431249,-1766242072,'Gemini'],
  [-1766242072,-1766059715,'Cancer'],
  [-1766059715,-1765879084,'Leo'],
  [-1765879084,-1765696649,'Virgo'],
  [-1765696649,-1765510647,'Libra'],
  [-1765510647,-1765319916,'Scorpio'],
  [-1765319916,-1765122746,'Sagittarius'],
  [-1765122746,-1764917061,'Capricorn'],
  [-1764917061,-1764702469,'Aquarius'],
  [-1764702469,-1764483031,'Pisces'],
  [-1764483031,-1764267165,'Aries'],
  [-1764267165,-1764062789,'Taurus'],
  [-1764062789,-1763872259,'Gemini'],
  [-1763872259,-1763692322,'Cancer'],
  [-1763692322,-1763517084,'Leo'],
  [-1763517084,-1763340552,'Virgo'],
  [-1763340552,-1763158116,'Libra'],
  [-1763158116,-1762967232,'Scorpio'],
  [-1762967232,-1762767307,'Sagittarius'],
  [-1762767307,-1762558989,'Capricorn'],
  [-1762558989,-1762343689,'Aquarius'],
  [-1762343689,-1762124394,'Pisces'],
  [-1762124394,-1761906694,'Aries'],
  [-1761906694,-1761697659,'Taurus'],
  [-1761697659,-1761502078,'Gemini'],
  [-1761502078,-1761319748,'Cancer'],
  [-1761319748,-1761146207,'Leo'],
  [-1761146207,-1760974890,'Virgo'],
  [-1760974890,-1760798996,'Libra'],
  [-1760798996,-1760613060,'Scorpio'],
  [-1760613060,-1760414585,'Sagittarius'],
  [-1760414585,-1760204943,'Capricorn'],
  [-1760204943,-1759988167,'Aquarius'],
  [-1759988167,-1759768760,'Pisces'],
  [-1759768760,-1759550930,'Aries'],
  [-1759550930,-1759339183,'Taurus'],
  [-1759339183,-1759138061,'Gemini'],
  [-1759138061,-1758949876,'Cancer'],
  [-1758949876,-1758773079,'Leo'],
  [-1758773079,-1758602550,'Virgo'],
  [-1758602550,-1758431164,'Libra'],
  [-1758431164,-1758251594,'Scorpio'],
  [-1758251594,-1758058452,'Sagittarius'],
  [-1758058452,-1757850983,'Capricorn'],
  [-1757850983,-1757633897,'Aquarius'],
  [-1757633897,-1757414188,'Pisces'],
  [-1757414188,-1757197130,'Aries'],
  [-1757197130,-1756985577,'Taurus'],
  [-1756985577,-1756781808,'Gemini'],
  [-1756781808,-1756588111,'Cancer'],
  [-1756588111,-1756405275,'Leo'],
  [-1756405275,-1756230915,'Virgo'],
  [-1756230915,-1756059404,'Libra'],
  [-1756059404,-1755883369,'Scorpio'],
  [-1755883369,-1755695803,'Sagittarius'],
  [-1755695803,-1755493083,'Capricorn'],
  [-1755493083,-1755277931,'Aquarius'],
  [-1755277931,-1755058329,'Pisces'],
  [-1755058329,-1754841913,'Aries'],
  [-1754841913,-1754632120,'Taurus'],
  [-1754632120,-1754429381,'Gemini'],
  [-1754429381,-1754233882,'Cancer'],
  [-1754233882,-1754046277,'Leo'],
  [-1754046277,-1753866200,'Virgo'],
  [-1753866200,-1753690582,'Libra'],
  [-1753690582,-1753513671,'Scorpio'],
  [-1753513671,-1753328649,'Sagittarius'],
  [-1753328649,-1753130297,'Capricorn'],
  [-1753130297,-1752918498,'Aquarius'],
  [-1752918498,-1752699785,'Pisces'],
  [-1752699785,-1752483356,'Aries'],
  [-1752483356,-1752274855,'Taurus'],
  [-1752274855,-1752074852,'Gemini'],
  [-1752074852,-1751881562,'Cancer'],
  [-1751881562,-1751693495,'Leo'],
  [-1751693495,-1751509860,'Virgo'],
  [-1751509860,-1751329215,'Libra'],
  [-1751329215,-1751148220,'Scorpio'],
  [-1751148220,-1750961860,'Sagittarius'],
  [-1750961860,-1750765171,'Capricorn'],
  [-1750765171,-1750556226,'Aquarius'],
  [-1750556226,-1750338887,'Pisces'],
  [-1750338887,-1750121802,'Aries'],
  [-1750121802,-1749912808,'Taurus'],
  [-1749912808,-1749714462,'Gemini'],
  [-1749714462,-1749524783,'Cancer'],
  [-1749524783,-1749340226,'Leo'],
  [-1749340226,-1749157712,'Virgo'],
  [-1749157712,-1748974985,'Libra'],
  [-1748974985,-1748789914,'Scorpio'],
  [-1748789914,-1748599820,'Sagittarius'],
  [-1748599820,-1748401685,'Capricorn'],
  [-1748401685,-1748193652,'Aquarius'],
  [-1748193652,-1747977450,'Pisces'],
  [-1747977450,-1747759477,'Aries'],
  [-1747759477,-1747548110,'Taurus'],
  [-1747548110,-1747348568,'Gemini'],
  [-1747348568,-1747160627,'Cancer'],
  [-1747160627,-1746980351,'Leo'],
  [-1746980351,-1746802570,'Virgo'],
  [-1746802570,-1746622577,'Libra'],
  [-1746622577,-1746436992,'Scorpio'],
  [-1746436992,-1746243950,'Sagittarius'],
  [-1746243950,-1746042770,'Capricorn'],
  [-1746042770,-1745833543,'Aquarius'],
  [-1745833543,-1745617652,'Pisces'],
  [-1745617652,-1745399099,'Aries'],
  [-1745399099,-1745184669,'Taurus'],
  [-1745184669,-1744981117,'Gemini'],
  [-1744981117,-1744791127,'Cancer'],
  [-1744791127,-1744612357,'Leo'],
  [-1744612357,-1744439184,'Virgo'],
  [-1744439184,-1744264885,'Libra'],
  [-1744264885,-1744083479,'Scorpio'],
  [-1744083479,-1743891387,'Sagittarius'],
  [-1743891387,-1743688454,'Capricorn'],
  [-1743688454,-1743477154,'Aquarius'],
  [-1743477154,-1743260634,'Pisces'],
  [-1743260634,-1743042060,'Aries'],
  [-1743042060,-1742825703,'Taurus'],
  [-1742825703,-1742617409,'Gemini'],
  [-1742617409,-1742422037,'Cancer'],
  [-1742422037,-1742240257,'Leo'],
  [-1742240257,-1742067976,'Virgo'],
  [-1742067976,-1741898133,'Libra'],
  [-1741898133,-1741722938,'Scorpio'],
  [-1741722938,-1741536057,'Sagittarius'],
  [-1741536057,-1741335190,'Capricorn'],
  [-1741335190,-1741123201,'Aquarius'],
  [-1741123201,-1740905687,'Pisces'],
  [-1740905687,-1740687325,'Aries'],
  [-1740687325,-1740471113,'Taurus'],
  [-1740471113,-1740260363,'Gemini'],
  [-1740260363,-1740059427,'Cancer'],
  [-1740059427,-1739871341,'Leo'],
  [-1739871341,-1739695036,'Virgo'],
  [-1739695036,-1739525082,'Libra'],
  [-1739525082,-1739353677,'Scorpio'],
  [-1739353677,-1739172931,'Sagittarius'],
  [-1739172931,-1738977603,'Capricorn'],
  [-1738977603,-1738768121,'Aquarius'],
  [-1738768121,-1738550549,'Pisces'],
  [-1738550549,-1738332154,'Aries'],
  [-1738332154,-1738117219,'Taurus'],
  [-1738117219,-1737907456,'Gemini'],
  [-1737907456,-1737704638,'Cancer'],
  [-1737704638,-1737511230,'Leo'],
  [-1737511230,-1737328326,'Virgo'],
  [-1737328326,-1737153462,'Libra'],
  [-1737153462,-1736980764,'Scorpio'],
  [-1736980764,-1736802778,'Sagittarius'],
  [-1736802778,-1736612855,'Capricorn'],
  [-1736612855,-1736408283,'Aquarius'],
  [-1736408283,-1736192678,'Pisces'],
  [-1736192678,-1735974180,'Aries'],
  [-1735974180,-1735759862,'Taurus'],
  [-1735759862,-1735552500,'Gemini'],
  [-1735552500,-1735352084,'Cancer'],
  [-1735352084,-1735158357,'Leo'],
  [-1735158357,-1734971429,'Virgo'],
  [-1734971429,-1734790467,'Libra'],
  [-1734790467,-1734612426,'Scorpio'],
  [-1734612426,-1734432175,'Sagittarius'],
  [-1734432175,-1734243890,'Capricorn'],
  [-1734243890,-1734043408,'Aquarius'],
  [-1734043408,-1733831091,'Pisces'],
  [-1733831091,-1733613047,'Aries'],
  [-1733613047,-1733397916,'Taurus'],
  [-1733397916,-1733191383,'Gemini'],
  [-1733191383,-1732994286,'Cancer'],
  [-1732994286,-1732804517,'Leo'],
  [-1732804517,-1732619344,'Virgo'],
  [-1732619344,-1732436416,'Libra'],
  [-1732436416,-1732253579,'Scorpio'],
  [-1732253579,-1732068274,'Sagittarius'],
  [-1732068274,-1731877299,'Capricorn'],
  [-1731877299,-1731677492,'Aquarius'],
  [-1731677492,-1731467596,'Pisces'],
  [-1731467596,-1731250564,'Aries'],
  [-1731250564,-1731033835,'Taurus'],
  [-1731033835,-1730825380,'Gemini'],
  [-1730825380,-1730628891,'Cancer'],
  [-1730628891,-1730442897,'Leo'],
  [-1730442897,-1730262878,'Virgo'],
  [-1730262878,-1730083686,'Libra'],
  [-1730083686,-1729901167,'Scorpio'],
  [-1729901167,-1729712878,'Sagittarius'],
  [-1729712878,-1729517830,'Capricorn'],
  [-1729517830,-1729315548,'Aquarius'],
  [-1729315548,-1729105700,'Pisces'],
  [-1729105700,-1728889435,'Aries'],
  [-1728889435,-1728671404,'Taurus'],
  [-1728671404,-1728459379,'Gemini'],
  [-1728459379,-1728259819,'Cancer'],
  [-1728259819,-1728073889,'Leo'],
  [-1728073889,-1727897529,'Virgo'],
  [-1727897529,-1727724049,'Libra'],
  [-1727724049,-1727546705,'Scorpio'],
  [-1727546705,-1727360688,'Sagittarius'],
  [-1727360688,-1727164481,'Capricorn'],
  [-1727164481,-1726959470,'Aquarius'],
  [-1726959470,-1726747855,'Pisces'],
  [-1726747855,-1726531441,'Aries'],
  [-1726531441,-1726312917,'Taurus'],
  [-1726312917,-1726097826,'Gemini'],
  [-1726097826,-1725893270,'Cancer'],
  [-1725893270,-1725703327,'Leo'],
  [-1725703327,-1725526284,'Virgo'],
  [-1725526284,-1725355878,'Libra'],
  [-1725355878,-1725184199,'Scorpio'],
  [-1725184199,-1725004085,'Sagittarius'],
  [-1725004085,-1724811404,'Capricorn'],
  [-1724811404,-1724606618,'Aquarius'],
  [-1724606618,-1724393568,'Pisces'],
  [-1724393568,-1724176345,'Aries'],
  [-1724176345,-1723957906,'Taurus'],
  [-1723957906,-1723741723,'Gemini'],
  [-1723741723,-1723533205,'Cancer'],
  [-1723533205,-1723337530,'Leo'],
  [-1723337530,-1723155807,'Virgo'],
  [-1723155807,-1722983899,'Libra'],
  [-1722983899,-1722814483,'Scorpio'],
  [-1722814483,-1722639588,'Sagittarius'],
  [-1722639588,-1722452851,'Capricorn'],
  [-1722452851,-1722251982,'Aquarius'],
  [-1722251982,-1722039825,'Pisces'],
  [-1722039825,-1721822135,'Aries'],
  [-1721822135,-1721603916,'Taurus'],
  [-1721603916,-1721388456,'Gemini'],
  [-1721388456,-1721179000,'Cancer'],
  [-1721179000,-1720979332,'Leo'],
  [-1720979332,-1720791755,'Virgo'],
  [-1720791755,-1720614761,'Libra'],
  [-1720614761,-1720443111,'Scorpio'],
  [-1720443111,-1720269682,'Sagittarius'],
  [-1720269682,-1720087492,'Capricorn'],
  [-1720087492,-1719891972,'Aquarius'],
  [-1719891972,-1719683219,'Pisces'],
  [-1719683219,-1719466314,'Aries'],
  [-1719466314,-1719248223,'Taurus'],
  [-1719248223,-1719034005,'Gemini'],
  [-1719034005,-1718826259,'Cancer'],
  [-1718826259,-1718626460,'Leo'],
  [-1718626460,-1718435568,'Virgo'],
  [-1718435568,-1718253104,'Libra'],
  [-1718253104,-1718076246,'Scorpio'],
  [-1718076246,-1717900077,'Sagittarius'],
  [-1717900077,-1717718694,'Capricorn'],
  [-1717718694,-1717526867,'Aquarius'],
  [-1717526867,-1717322251,'Pisces'],
  [-1717322251,-1717107404,'Aries'],
  [-1717107404,-1716889373,'Taurus'],
  [-1716889373,-1716675572,'Gemini'],
  [-1716675572,-1716470022,'Cancer'],
  [-1716470022,-1716273115,'Leo'],
  [-1716273115,-1716083363,'Virgo'],
  [-1716083363,-1715898813,'Libra'],
  [-1715898813,-1715717309,'Scorpio'],
  [-1715717309,-1715536159,'Sagittarius'],
  [-1715536159,-1715351841,'Capricorn'],
  [-1715351841,-1715160307,'Aquarius'],
  [-1715160307,-1714958326,'Pisces'],
  [-1714958326,-1714745843,'Aries'],
  [-1714745843,-1714527923,'Taurus'],
  [-1714527923,-1714313076,'Gemini'],
  [-1714313076,-1714107954,'Cancer'],
  [-1714107954,-1713913986,'Leo'],
  [-1713913986,-1713728303,'Virgo'],
  [-1713728303,-1713546445,'Libra'],
  [-1713546445,-1713364487,'Scorpio'],
  [-1713364487,-1713179911,'Sagittarius'],
  [-1713179911,-1712991231,'Capricorn'],
  [-1712991231,-1712796898,'Aquarius'],
  [-1712796898,-1712594829,'Pisces'],
  [-1712594829,-1712383764,'Aries'],
  [-1712383764,-1712166080,'Taurus'],
  [-1712166080,-1711949143,'Gemini'],
  [-1711949143,-1711741665,'Cancer'],
  [-1711741665,-1711547790,'Leo'],
  [-1711547790,-1711365381,'Virgo'],
  [-1711365381,-1711188570,'Libra'],
  [-1711188570,-1711010931,'Scorpio'],
  [-1711010931,-1710827753,'Sagittarius'],
  [-1710827753,-1710637165,'Capricorn'],
  [-1710637165,-1710439439,'Aquarius'],
  [-1710439439,-1710235025,'Pisces'],
  [-1710235025,-1710023697,'Aries'],
  [-1710023697,-1709806265,'Taurus'],
  [-1709806265,-1709587492,'Gemini'],
  [-1709587492,-1709375856,'Cancer'],
  [-1709375856,-1709178233,'Leo'],
  [-1709178233,-1708995156,'Virgo'],
  [-1708995156,-1708821405,'Libra'],
  [-1708821405,-1708649380,'Scorpio'],
  [-1708649380,-1708471932,'Sagittarius'],
  [-1708471932,-1708284527,'Capricorn'],
  [-1708284527,-1708086482,'Aquarius'],
  [-1708086482,-1707879833,'Pisces'],
  [-1707879833,-1707666912,'Aries'],
  [-1707666912,-1707449395,'Taurus'],
  [-1707449395,-1707230132,'Gemini'],
  [-1707230132,-1707015187,'Cancer'],
  [-1707015187,-1706811866,'Leo'],
  [-1706811866,-1706623720,'Virgo'],
  [-1706623720,-1706448161,'Libra'],
  [-1706448161,-1706278431,'Scorpio'],
  [-1706278431,-1706106591,'Sagittarius'],
  [-1706106591,-1705925755,'Capricorn'],
  [-1705925755,-1705732182,'Aquarius'],
  [-1705732182,-1705526469,'Pisces'],
  [-1705526469,-1705312395,'Aries'],
  [-1705312395,-1705094275,'Taurus'],
  [-1705094275,-1704875586,'Gemini'],
  [-1704875586,-1704660199,'Cancer'],
  [-1704660199,-1704453138,'Leo'],
  [-1704453138,-1704258600,'Virgo'],
  [-1704258600,-1704076963,'Libra'],
  [-1704076963,-1703904173,'Scorpio'],
  [-1703904173,-1703733519,'Sagittarius'],
  [-1703733519,-1703557700,'Capricorn'],
  [-1703557700,-1703370678,'Aquarius'],
  [-1703370678,-1703169764,'Pisces'],
  [-1703169764,-1702957086,'Aries'],
  [-1702957086,-1702738552,'Taurus'],
  [-1702738552,-1702520322,'Gemini'],
  [-1702520322,-1702306593,'Cancer'],
  [-1702306593,-1702099992,'Leo'],
  [-1702099992,-1701902441,'Virgo'],
  [-1701902441,-1701714738,'Libra'],
  [-1701714738,-1701535486,'Scorpio'],
  [-1701535486,-1701360809,'Sagittarius'],
  [-1701360809,-1701185046,'Capricorn'],
  [-1701185046,-1701001986,'Aquarius'],
  [-1701001986,-1700806671,'Pisces'],
  [-1700806671,-1700597927,'Aries'],
  [-1700597927,-1700380261,'Taurus'],
  [-1700380261,-1700161848,'Gemini'],
  [-1700161848,-1699949470,'Cancer'],
  [-1699949470,-1699745736,'Leo'],
  [-1699745736,-1699550086,'Virgo'],
  [-1699550086,-1699360989,'Libra'],
  [-1699360989,-1699176952,'Scorpio'],
  [-1699176952,-1698996252,'Sagittarius'],
  [-1698996252,-1698816100,'Capricorn'],
  [-1698816100,-1698632199,'Aquarius'],
  [-1698632199,-1698439549,'Pisces'],
  [-1698439549,-1698234719,'Aries'],
  [-1698234719,-1698019129,'Taurus'],
  [-1698019129,-1697800292,'Gemini'],
  [-1697800292,-1697587467,'Cancer'],
  [-1697587467,-1697385580,'Leo'],
  [-1697385580,-1697193755,'Virgo'],
  [-1697193755,-1697008084,'Libra'],
  [-1697008084,-1696824664,'Scorpio'],
  [-1696824664,-1696641065,'Sagittarius'],
  [-1696641065,-1696456043,'Capricorn'],
  [-1696456043,-1696268022,'Aquarius'],
  [-1696268022,-1696074027,'Pisces'],
  [-1696074027,-1695870617,'Aries'],
  [-1695870617,-1695656917,'Taurus'],
  [-1695656917,-1695437849,'Gemini'],
  [-1695437849,-1695222995,'Cancer'],
  [-1695222995,-1695020059,'Leo'],
  [-1695020059,-1694830097,'Virgo'],
  [-1694830097,-1694648764,'Libra'],
  [-1694648764,-1694470022,'Scorpio'],
  [-1694470022,-1694288947,'Sagittarius'],
  [-1694288947,-1694103024,'Capricorn'],
  [-1694103024,-1693911633,'Aquarius'],
  [-1693911633,-1693714260,'Pisces'],
  [-1693714260,-1693509469,'Aries'],
  [-1693509469,-1693296234,'Taurus'],
  [-1693296234,-1693077127,'Gemini'],
  [-1693077127,-1692859869,'Cancer'],
  [-1692859869,-1692653402,'Leo'],
  [-1692653402,-1692461620,'Virgo'],
  [-1692461620,-1692281776,'Libra'],
  [-1692281776,-1692107466,'Scorpio'],
  [-1692107466,-1691931896,'Sagittarius'],
  [-1691931896,-1691749976,'Capricorn'],
  [-1691749976,-1691559377,'Aquarius'],
  [-1691559377,-1691360081,'Pisces'],
  [-1691360081,-1691152910,'Aries'],
  [-1691152910,-1690938695,'Taurus'],
  [-1690938695,-1690719511,'Gemini'],
  [-1690719511,-1690500731,'Cancer'],
  [-1690500731,-1690290212,'Leo'],
  [-1690290212,-1690093725,'Virgo'],
  [-1690093725,-1689911257,'Libra'],
  [-1689911257,-1689737849,'Scorpio'],
  [-1689737849,-1689566509,'Sagittarius'],
  [-1689566509,-1689390468,'Capricorn'],
  [-1689390468,-1689204766,'Aquarius'],
  [-1689204766,-1689007387,'Pisces'],
  [-1689007387,-1688799418,'Aries'],
  [-1688799418,-1688583901,'Taurus'],
  [-1688583901,-1688364469,'Gemini'],
  [-1688364469,-1688145538,'Cancer'],
  [-1688145538,-1687932673,'Leo'],
  [-1687932673,-1687731181,'Virgo'],
  [-1687731181,-1687543217,'Libra'],
  [-1687543217,-1687366454,'Scorpio'],
  [-1687366454,-1687195373,'Sagittarius'],
  [-1687195373,-1687023162,'Capricorn'],
  [-1687023162,-1686843271,'Aquarius'],
  [-1686843271,-1686651010,'Pisces'],
  [-1686651010,-1686445355,'Aries'],
  [-1686445355,-1686229723,'Taurus'],
  [-1686229723,-1686010029,'Gemini'],
  [-1686010029,-1685791817,'Cancer'],
  [-1685791817,-1685579224,'Leo'],
  [-1685579224,-1685375325,'Virgo'],
  [-1685375325,-1685182126,'Libra'],
  [-1685182126,-1684999471,'Scorpio'],
  [-1684999471,-1684824461,'Sagittarius'],
  [-1684824461,-1684651880,'Capricorn'],
  [-1684651880,-1684475243,'Aquarius'],
  [-1684475243,-1684288282,'Pisces'],
  [-1684288282,-1684087229,'Aries'],
  [-1684087229,-1683873521,'Taurus'],
  [-1683873521,-1683653937,'Gemini'],
  [-1683653937,-1683436375,'Cancer'],
  [-1683436375,-1683225613,'Leo'],
  [-1683225613,-1683022889,'Virgo'],
  [-1683022889,-1682827997,'Libra'],
  [-1682827997,-1682640581,'Scorpio'],
  [-1682640581,-1682459722,'Sagittarius'],
  [-1682459722,-1682282850,'Capricorn'],
  [-1682282850,-1682105239,'Aquarius'],
  [-1682105239,-1681920785,'Pisces'],
  [-1681920785,-1681724068,'Aries'],
  [-1681724068,-1681513691,'Taurus'],
  [-1681513691,-1681294917,'Gemini'],
  [-1681294917,-1681077240,'Cancer'],
  [-1681077240,-1680867799,'Leo'],
  [-1680867799,-1680668017,'Virgo'],
  [-1680668017,-1680475614,'Libra'],
  [-1680475614,-1680287921,'Scorpio'],
  [-1680287921,-1680103446,'Sagittarius'],
  [-1680103446,-1679921260,'Capricorn'],
  [-1679921260,-1679739262,'Aquarius'],
  [-1679739262,-1679553309,'Pisces'],
  [-1679553309,-1679358248,'Aries'],
  [-1679358248,-1679150819,'Taurus'],
  [-1679150819,-1678933439,'Gemini'],
  [-1678933439,-1678714897,'Cancer'],
  [-1678714897,-1678504670,'Leo'],
  [-1678504670,-1678306469,'Virgo'],
  [-1678306469,-1678117932,'Libra'],
  [-1678117932,-1677934272,'Scorpio'],
  [-1677934272,-1677751444,'Sagittarius'],
  [-1677751444,-1677567368,'Capricorn'],
  [-1677567368,-1677381092,'Aquarius'],
  [-1677381092,-1677191013,'Pisces'],
  [-1677191013,-1676994170,'Aries'],
  [-1676994170,-1676787588,'Taurus'],
  [-1676787588,-1676571502,'Gemini'],
  [-1676571502,-1676352052,'Cancer'],
  [-1676352052,-1676138983,'Leo'],
  [-1676138983,-1675938921,'Virgo'],
  [-1675938921,-1675751696,'Libra'],
  [-1675751696,-1675572427,'Scorpio'],
  [-1675572427,-1675395060,'Sagittarius'],
  [-1675395060,-1675214706,'Capricorn'],
  [-1675214706,-1675028605,'Aquarius'],
  [-1675028605,-1674835691,'Pisces'],
  [-1674835691,-1674635417,'Aries'],
  [-1674635417,-1674427200,'Taurus'],
  [-1674427200,-1674211409,'Gemini'],
  [-1674211409,-1673991694,'Cancer'],
  [-1673991694,-1673775557,'Leo'],
  [-1673775557,-1673570766,'Virgo'],
  [-1673570766,-1673380363,'Libra'],
  [-1673380363,-1673201642,'Scorpio'],
  [-1673201642,-1673028626,'Sagittarius'],
  [-1673028626,-1672854631,'Capricorn'],
  [-1672854631,-1672673969,'Aquarius'],
  [-1672673969,-1672483177,'Pisces'],
  [-1672483177,-1672281626,'Aries'],
  [-1672281626,-1672071051,'Taurus'],
  [-1672071051,-1671854273,'Gemini'],
  [-1671854273,-1671634772,'Cancer'],
  [-1671634772,-1671417373,'Leo'],
  [-1671417373,-1671208078,'Virgo'],
  [-1671208078,-1671011569,'Libra'],
  [-1671011569,-1670828418,'Scorpio'],
  [-1670828418,-1670654893,'Sagittarius'],
  [-1670654893,-1670484617,'Capricorn'],
  [-1670484617,-1670310404,'Aquarius'],
  [-1670310404,-1670125926,'Pisces'],
  [-1670125926,-1669927761,'Aries'],
  [-1669927761,-1669717147,'Taurus'],
  [-1669717147,-1669499207,'Gemini'],
  [-1669499207,-1669279727,'Cancer'],
  [-1669279727,-1669063012,'Leo'],
  [-1669063012,-1668852356,'Virgo'],
  [-1668852356,-1668651016,'Libra'],
  [-1668651016,-1668461219,'Scorpio'],
  [-1668461219,-1668282401,'Sagittarius'],
  [-1668282401,-1668110518,'Capricorn'],
  [-1668110518,-1667938951,'Aquarius'],
  [-1667938951,-1667760224,'Pisces'],
  [-1667760224,-1667568196,'Aries'],
  [-1667568196,-1667361148,'Taurus'],
  [-1667361148,-1667143703,'Gemini'],
  [-1667143703,-1666924019,'Cancer'],
  [-1666924019,-1666708415,'Leo'],
  [-1666708415,-1666499345,'Virgo'],
  [-1666499345,-1666297453,'Libra'],
  [-1666297453,-1666103594,'Scorpio'],
  [-1666103594,-1665918507,'Sagittarius'],
  [-1665918507,-1665741041,'Capricorn'],
  [-1665741041,-1665566968,'Aquarius'],
  [-1665566968,-1665389687,'Pisces'],
  [-1665389687,-1665202203,'Aries'],
  [-1665202203,-1665000152,'Taurus'],
  [-1665000152,-1664785329,'Gemini'],
  [-1664785329,-1664565851,'Cancer'],
  [-1664565851,-1664350545,'Leo'],
  [-1664350545,-1664143502,'Virgo'],
  [-1664143502,-1663944300,'Libra'],
  [-1663944300,-1663751287,'Scorpio'],
  [-1663751287,-1663563649,'Sagittarius'],
  [-1663563649,-1663381016,'Capricorn'],
  [-1663381016,-1663201648,'Aquarius'],
  [-1663201648,-1663021361,'Pisces'],
  [-1663021361,-1662834321,'Aries'],
  [-1662834321,-1662635413,'Taurus'],
  [-1662635413,-1662423761,'Gemini'],
  [-1662423761,-1662205142,'Cancer'],
  [-1662205142,-1661989137,'Leo'],
  [-1661989137,-1661782448,'Virgo'],
  [-1661782448,-1661585894,'Libra'],
  [-1661585894,-1661396643,'Scorpio'],
  [-1661396643,-1661211420,'Sagittarius'],
  [-1661211420,-1661028041,'Capricorn'],
  [-1661028041,-1660844997,'Aquarius'],
  [-1660844997,-1660660152,'Pisces'],
  [-1660660152,-1660470099,'Aries'],
  [-1660470099,-1660271019,'Taurus'],
  [-1660271019,-1660061121,'Gemini'],
  [-1660061121,-1659843517,'Cancer'],
  [-1659843517,-1659626274,'Leo'],
  [-1659626274,-1659417723,'Virgo'],
  [-1659417723,-1659221264,'Libra'],
  [-1659221264,-1659034978,'Scorpio'],
  [-1659034978,-1658854378,'Sagittarius'],
  [-1658854378,-1658674846,'Capricorn'],
  [-1658674846,-1658492809,'Aquarius'],
  [-1658492809,-1658305850,'Pisces'],
  [-1658305850,-1658112247,'Aries'],
  [-1658112247,-1657910608,'Taurus'],
  [-1657910608,-1657700324,'Gemini'],
  [-1657700324,-1657483223,'Cancer'],
  [-1657483223,-1657264870,'Leo'],
  [-1657264870,-1657053101,'Virgo'],
  [-1657053101,-1656853633,'Libra'],
  [-1656853633,-1656666998,'Scorpio'],
  [-1656666998,-1656489401,'Sagittarius'],
  [-1656489401,-1656315033,'Capricorn'],
  [-1656315033,-1656137957,'Aquarius'],
  [-1656137957,-1655953482,'Pisces'],
  [-1655953482,-1655759168,'Aries'],
  [-1655759168,-1655555104,'Taurus'],
  [-1655555104,-1655343067,'Gemini'],
  [-1655343067,-1655125689,'Cancer'],
  [-1655125689,-1654906848,'Leo'],
  [-1654906848,-1654692224,'Virgo'],
  [-1654692224,-1654487976,'Libra'],
  [-1654487976,-1654297335,'Scorpio'],
  [-1654297335,-1654118826,'Sagittarius'],
  [-1654118826,-1653947212,'Capricorn'],
  [-1653947212,-1653775470,'Aquarius'],
  [-1653775470,-1653596657,'Pisces'],
  [-1653596657,-1653405855,'Aries'],
  [-1653405855,-1653202148,'Taurus'],
  [-1653202148,-1652988786,'Gemini'],
  [-1652988786,-1652770654,'Cancer'],
  [-1652770654,-1652551935,'Leo'],
  [-1652551935,-1652336294,'Virgo'],
  [-1652336294,-1652128139,'Libra'],
  [-1652128139,-1651931724,'Scorpio'],
  [-1651931724,-1651748403,'Sagittarius'],
  [-1651748403,-1651575182,'Capricorn'],
  [-1651575182,-1651405645,'Aquarius'],
  [-1651405645,-1651231968,'Pisces'],
  [-1651231968,-1651047045,'Aries'],
  [-1651047045,-1650847269,'Taurus'],
  [-1650847269,-1650634832,'Gemini'],
  [-1650634832,-1650416268,'Cancer'],
  [-1650416268,-1650197855,'Leo'],
  [-1650197855,-1649983074,'Virgo'],
  [-1649983074,-1649774082,'Libra'],
  [-1649774082,-1649573605,'Scorpio'],
  [-1649573605,-1649384147,'Sagittarius'],
  [-1649384147,-1649205511,'Capricorn'],
  [-1649205511,-1649033548,'Aquarius'],
  [-1649033548,-1648861278,'Pisces'],
  [-1648861278,-1648680953,'Aries'],
  [-1648680953,-1648486697,'Taurus'],
  [-1648486697,-1648277831,'Gemini'],
  [-1648277831,-1648060085,'Cancer'],
  [-1648060085,-1647841768,'Leo'],
  [-1647841768,-1647628323,'Virgo'],
  [-1647628323,-1647421307,'Libra'],
  [-1647421307,-1647220997,'Scorpio'],
  [-1647220997,-1647028269,'Sagittarius'],
  [-1647028269,-1646843826,'Capricorn'],
  [-1646843826,-1646666135,'Aquarius'],
  [-1646666135,-1646490643,'Pisces'],
  [-1646490643,-1646310832,'Aries'],
  [-1646310832,-1646120327,'Taurus'],
  [-1646120327,-1645915935,'Gemini'],
  [-1645915935,-1645700504,'Cancer'],
  [-1645700504,-1645482157,'Leo'],
  [-1645482157,-1645268884,'Virgo'],
  [-1645268884,-1645064064,'Libra'],
  [-1645064064,-1644867092,'Scorpio'],
  [-1644867092,-1644676213,'Sagittarius'],
  [-1644676213,-1644490147,'Capricorn'],
  [-1644490147,-1644307721,'Aquarius'],
  [-1644307721,-1644126676,'Pisces'],
  [-1644126676,-1643943150,'Aries'],
  [-1643943150,-1643752385,'Taurus'],
  [-1643752385,-1643550642,'Gemini'],
  [-1643550642,-1643337965,'Cancer'],
  [-1643337965,-1643119890,'Leo'],
  [-1643119890,-1642905142,'Virgo'],
  [-1642905142,-1642700088,'Libra'],
  [-1642700088,-1642505801,'Scorpio'],
  [-1642505801,-1642319524,'Sagittarius'],
  [-1642319524,-1642137255,'Capricorn'],
  [-1642137255,-1641955425,'Aquarius'],
  [-1641955425,-1641771392,'Pisces'],
  [-1641771392,-1641583136,'Aries'],
  [-1641583136,-1641388725,'Taurus'],
  [-1641388725,-1641186264,'Gemini'],
  [-1641186264,-1640975037,'Cancer'],
  [-1640975037,-1640757614,'Leo'],
  [-1640757614,-1640540769,'Virgo'],
  [-1640540769,-1640332538,'Libra'],
  [-1640332538,-1640137211,'Scorpio'],
  [-1640137211,-1639953570,'Sagittarius'],
  [-1639953570,-1639776647,'Capricorn'],
  [-1639776647,-1639600280,'Aquarius'],
  [-1639600280,-1639419114,'Pisces'],
  [-1639419114,-1639229964,'Aries'],
  [-1639229964,-1639032212,'Taurus'],
  [-1639032212,-1638826792,'Gemini'],
  [-1638826792,-1638614818,'Cancer'],
  [-1638614818,-1638397848,'Leo'],
  [-1638397848,-1638179740,'Virgo'],
  [-1638179740,-1637967365,'Libra'],
  [-1637967365,-1637767331,'Scorpio'],
  [-1637767331,-1637581635,'Sagittarius'],
  [-1637581635,-1637406722,'Capricorn'],
  [-1637406722,-1637235680,'Aquarius'],
  [-1637235680,-1637060919,'Pisces'],
  [-1637060919,-1636876380,'Aries'],
  [-1636876380,-1636679623,'Taurus'],
  [-1636679623,-1636472422,'Gemini'],
  [-1636472422,-1636258577,'Cancer'],
  [-1636258577,-1636041282,'Leo'],
  [-1636041282,-1635823145,'Virgo'],
  [-1635823145,-1635608354,'Libra'],
  [-1635608354,-1635402984,'Scorpio'],
  [-1635402984,-1635211556,'Sagittarius'],
  [-1635211556,-1635033567,'Capricorn'],
  [-1635033567,-1634863491,'Aquarius'],
  [-1634863491,-1634693377,'Pisces'],
  [-1634693377,-1634515339,'Aries'],
  [-1634515339,-1634324002,'Taurus'],
  [-1634324002,-1634118937,'Gemini'],
  [-1634118937,-1633904535,'Cancer'],
  [-1633904535,-1633686521,'Leo'],
  [-1633686521,-1633468840,'Virgo'],
  [-1633468840,-1633254217,'Libra'],
  [-1633254217,-1633046304,'Scorpio'],
  [-1633046304,-1632849352,'Sagittarius'],
  [-1632849352,-1632665235,'Capricorn'],
  [-1632665235,-1632491250,'Aquarius'],
  [-1632491250,-1632320975,'Pisces'],
  [-1632320975,-1632146589,'Aries'],
  [-1632146589,-1631961151,'Taurus'],
  [-1631961151,-1631761261,'Gemini'],
  [-1631761261,-1631549085,'Cancer'],
  [-1631549085,-1631331080,'Leo'],
  [-1631331080,-1631113654,'Virgo'],
  [-1631113654,-1630900480,'Libra'],
  [-1630900480,-1630693544,'Scorpio'],
  [-1630693544,-1630494796,'Sagittarius'],
  [-1630494796,-1630305794,'Capricorn'],
  [-1630305794,-1630125868,'Aquarius'],
  [-1630125868,-1629951218,'Pisces'],
  [-1629951218,-1629775794,'Aries'],
  [-1629775794,-1629593005,'Taurus'],
  [-1629593005,-1629397904,'Gemini'],
  [-1629397904,-1629189700,'Cancer'],
  [-1629189700,-1628973022,'Leo'],
  [-1628973022,-1628755548,'Virgo'],
  [-1628755548,-1628543347,'Libra'],
  [-1628543347,-1628338906,'Scorpio'],
  [-1628338906,-1628142296,'Sagittarius'],
  [-1628142296,-1627952776,'Capricorn'],
  [-1627952776,-1627769150,'Aquarius'],
  [-1627769150,-1627589215,'Pisces'],
  [-1627589215,-1627409404,'Aries'],
  [-1627409404,-1627225101,'Taurus'],
  [-1627225101,-1627031761,'Gemini'],
  [-1627031761,-1626826873,'Cancer'],
  [-1626826873,-1626612251,'Leo'],
  [-1626612251,-1626394575,'Virgo'],
  [-1626394575,-1626181879,'Libra'],
  [-1626181879,-1625978873,'Scorpio'],
  [-1625978873,-1625785679,'Sagittarius'],
  [-1625785679,-1625599530,'Capricorn'],
  [-1625599530,-1625416910,'Aquarius'],
  [-1625416910,-1625234759,'Pisces'],
  [-1625234759,-1625050659,'Aries'],
  [-1625050659,-1624862381,'Taurus'],
  [-1624862381,-1624667430,'Gemini'],
  [-1624667430,-1624463527,'Cancer'],
  [-1624463527,-1624250517,'Leo'],
  [-1624250517,-1624032632,'Virgo'],
  [-1624032632,-1623817999,'Libra'],
  [-1623817999,-1623613861,'Scorpio'],
  [-1623613861,-1623422273,'Sagittarius'],
  [-1623422273,-1623240177,'Capricorn'],
  [-1623240177,-1623062051,'Aquarius'],
  [-1623062051,-1622882470,'Pisces'],
  [-1622882470,-1622697742,'Aries'],
  [-1622697742,-1622506384,'Taurus'],
  [-1622506384,-1622308197,'Gemini'],
  [-1622308197,-1622102888,'Cancer'],
  [-1622102888,-1621890215,'Leo'],
  [-1621890215,-1621672207,'Virgo'],
  [-1621672207,-1621455151,'Libra'],
  [-1621455151,-1621247440,'Scorpio'],
  [-1621247440,-1621053956,'Sagittarius'],
  [-1621053956,-1620873276,'Capricorn'],
  [-1620873276,-1620699479,'Aquarius'],
  [-1620699479,-1620525294,'Pisces'],
  [-1620525294,-1620344562,'Aries'],
  [-1620344562,-1620154083,'Taurus'],
  [-1620154083,-1619954081,'Gemini'],
  [-1619954081,-1619746475,'Cancer'],
  [-1619746475,-1619532863,'Leo'],
  [-1619532863,-1619314779,'Virgo'],
  [-1619314779,-1619096155,'Libra'],
  [-1619096155,-1618884229,'Scorpio'],
  [-1618884229,-1618685786,'Sagittarius'],
  [-1618685786,-1618502302,'Capricorn'],
  [-1618502302,-1618329341,'Aquarius'],
  [-1618329341,-1618159383,'Pisces'],
  [-1618159383,-1617984632,'Aries'],
  [-1617984632,-1617799246,'Taurus'],
  [-1617799246,-1617601328,'Gemini'],
  [-1617601328,-1617393005,'Cancer'],
  [-1617393005,-1617178101,'Leo'],
  [-1617178101,-1616959818,'Virgo'],
  [-1616959818,-1616741146,'Libra'],
  [-1616741146,-1616526890,'Scorpio'],
  [-1616526890,-1616323162,'Sagittarius'],
  [-1616323162,-1616133675,'Capricorn'],
  [-1616133675,-1615956880,'Aquarius'],
  [-1615956880,-1615786850,'Pisces'],
  [-1615786850,-1615615866,'Aries'],
  [-1615615866,-1615436605,'Taurus'],
  [-1615436605,-1615244304,'Gemini'],
  [-1615244304,-1615038670,'Cancer'],
  [-1615038670,-1614823728,'Leo'],
  [-1614823728,-1614605107,'Virgo'],
  [-1614605107,-1614387262,'Libra'],
  [-1614387262,-1614173629,'Scorpio'],
  [-1614173629,-1613967776,'Sagittarius'],
  [-1613967776,-1613772857,'Capricorn'],
  [-1613772857,-1613589499,'Aquarius'],
  [-1613589499,-1613414667,'Pisces'],
  [-1613414667,-1613242567,'Aries'],
  [-1613242567,-1613066315,'Taurus'],
  [-1613066315,-1612879702,'Gemini'],
  [-1612879702,-1612679361,'Cancer'],
  [-1612679361,-1612466804,'Leo'],
  [-1612466804,-1612248230,'Virgo'],
  [-1612248230,-1612030820,'Libra'],
  [-1612030820,-1611819216,'Scorpio'],
  [-1611819216,-1611615264,'Sagittarius'],
  [-1611615264,-1611419419,'Capricorn'],
  [-1611419419,-1611231502,'Aquarius'],
  [-1611231502,-1611050255,'Pisces'],
  [-1611050255,-1610872775,'Aries'],
  [-1610872775,-1610694499,'Taurus'],
  [-1610694499,-1610509924,'Gemini'],
  [-1610509924,-1610314187,'Cancer'],
  [-1610314187,-1610105607,'Leo'],
  [-1610105607,-1609888139,'Virgo'],
  [-1609888139,-1609670242,'Libra'],
  [-1609670242,-1609459490,'Scorpio'],
  [-1609459490,-1609258642,'Sagittarius'],
  [-1609258642,-1609066241,'Capricorn'],
  [-1609066241,-1608879317,'Aquarius'],
  [-1608879317,-1608695302,'Pisces'],
  [-1608695302,-1608512419,'Aries'],
  [-1608512419,-1608328858,'Taurus'],
  [-1608328858,-1608141710,'Gemini'],
  [-1608141710,-1607946986,'Cancer'],
  [-1607946986,-1607741436,'Leo'],
  [-1607741436,-1607525845,'Virgo'],
  [-1607525845,-1607307106,'Libra'],
  [-1607307106,-1607094848,'Scorpio'],
  [-1607094848,-1606894766,'Sagittarius'],
  [-1606894766,-1606706056,'Capricorn'],
  [-1606706056,-1606523916,'Aquarius'],
  [-1606523916,-1606343012,'Pisces'],
  [-1606343012,-1606159671,'Aries'],
  [-1606159671,-1605972432,'Taurus'],
  [-1605972432,-1605780799,'Gemini'],
  [-1605780799,-1605583450,'Cancer'],
  [-1605583450,-1605378098,'Leo'],
  [-1605378098,-1605163853,'Virgo'],
  [-1605163853,-1604944656,'Libra'],
  [-1604944656,-1604729487,'Scorpio'],
  [-1604729487,-1604526669,'Sagittarius'],
  [-1604526669,-1604338143,'Capricorn'],
  [-1604338143,-1604159641,'Aquarius'],
  [-1604159641,-1603984308,'Pisces'],
  [-1603984308,-1603805829,'Aries'],
  [-1603805829,-1603620357,'Taurus'],
  [-1603620357,-1603427010,'Gemini'],
  [-1603427010,-1603226426,'Cancer'],
  [-1603226426,-1603018926,'Leo'],
  [-1603018926,-1602804515,'Virgo'],
  [-1602804515,-1602585309,'Libra'],
  [-1602585309,-1602367746,'Scorpio'],
  [-1602367746,-1602160349,'Sagittarius'],
  [-1602160349,-1601967933,'Capricorn'],
  [-1601967933,-1601788724,'Aquarius'],
  [-1601788724,-1601616468,'Pisces'],
  [-1601616468,-1601443718,'Aries'],
  [-1601443718,-1601264143,'Taurus'],
  [-1601264143,-1601074162,'Gemini'],
  [-1601074162,-1600873494,'Cancer'],
  [-1600873494,-1600664081,'Leo'],
  [-1600664081,-1600448407,'Virgo'],
  [-1600448407,-1600229201,'Libra'],
  [-1600229201,-1600010914,'Scorpio'],
  [-1600010914,-1599799991,'Sagittarius'],
  [-1599799991,-1599602014,'Capricorn'],
  [-1599602014,-1599418041,'Aquarius'],
  [-1599418041,-1599244158,'Pisces'],
  [-1599244158,-1599073699,'Aries'],
  [-1599073699,-1598899513,'Taurus'],
  [-1598899513,-1598715661,'Gemini'],
  [-1598715661,-1598519038,'Cancer'],
  [-1598519038,-1598310444,'Leo'],
  [-1598310444,-1598093945,'Virgo'],
  [-1598093945,-1597874559,'Libra'],
  [-1597874559,-1597656895,'Scorpio'],
  [-1597656895,-1597445250,'Sagittarius'],
  [-1597445250,-1597243501,'Capricorn'],
  [-1597243501,-1597053690,'Aquarius'],
  [-1597053690,-1596874557,'Pisces'],
  [-1596874557,-1596701746,'Aries'],
  [-1596701746,-1596529069,'Taurus'],
  [-1596529069,-1596349928,'Gemini'],
  [-1596349928,-1596158933,'Cancer'],
  [-1596158933,-1595954080,'Leo'],
  [-1595954080,-1595738487,'Virgo'],
  [-1595738487,-1595519007,'Libra'],
  [-1595519007,-1595302251,'Scorpio'],
  [-1595302251,-1595092158,'Sagittarius'],
  [-1595092158,-1594890311,'Capricorn'],
  [-1594890311,-1594697252,'Aquarius'],
  [-1594697252,-1594512606,'Pisces'],
  [-1594512606,-1594334471,'Aries'],
  [-1594334471,-1594158993,'Taurus'],
  [-1594158993,-1593980660,'Gemini'],
  [-1593980660,-1593793466,'Cancer'],
  [-1593793466,-1593593116,'Leo'],
  [-1593593116,-1593380092,'Virgo'],
  [-1593380092,-1593160939,'Libra'],
  [-1593160939,-1592944467,'Scorpio'],
  [-1592944467,-1592736243,'Sagittarius'],
  [-1592736243,-1592537009,'Capricorn'],
  [-1592537009,-1592344952,'Aquarius'],
  [-1592344952,-1592158172,'Pisces'],
  [-1592158172,-1591975342,'Aries'],
  [-1591975342,-1591794839,'Taurus'],
  [-1591794839,-1591613511,'Gemini'],
  [-1591613511,-1591426520,'Cancer'],
  [-1591426520,-1591228906,'Leo'],
  [-1591228906,-1591018747,'Virgo'],
  [-1591018747,-1590800368,'Libra'],
  [-1590800368,-1590583203,'Scorpio'],
  [-1590583203,-1590375312,'Sagittarius'],
  [-1590375312,-1590178652,'Capricorn'],
  [-1590178652,-1589990274,'Aquarius'],
  [-1589990274,-1589805913,'Pisces'],
  [-1589805913,-1589622470,'Aries'],
  [-1589622470,-1589438472,'Taurus'],
  [-1589438472,-1589252733,'Gemini'],
  [-1589252733,-1589062795,'Cancer'],
  [-1589062795,-1588864934,'Leo'],
  [-1588864934,-1588656363,'Virgo'],
  [-1588656363,-1588438861,'Libra'],
  [-1588438861,-1588220353,'Scorpio'],
  [-1588220353,-1588010492,'Sagittarius'],
  [-1588010492,-1587813865,'Capricorn'],
  [-1587813865,-1587628421,'Aquarius'],
  [-1587628421,-1587448702,'Pisces'],
  [-1587448702,-1587269216,'Aries'],
  [-1587269216,-1587086350,'Taurus'],
  [-1587086350,-1586898566,'Gemini'],
  [-1586898566,-1586705087,'Cancer'],
  [-1586705087,-1586504616,'Leo'],
  [-1586504616,-1586295598,'Virgo'],
  [-1586295598,-1586078576,'Libra'],
  [-1586078576,-1585858894,'Scorpio'],
  [-1585858894,-1585645567,'Sagittarius'],
  [-1585645567,-1585445569,'Capricorn'],
  [-1585445569,-1585259486,'Aquarius'],
  [-1585259486,-1585082667,'Pisces'],
  [-1585082667,-1584908537,'Aries'],
  [-1584908537,-1584731053,'Taurus'],
  [-1584731053,-1584546134,'Gemini'],
  [-1584546134,-1584352121,'Cancer'],
  [-1584352121,-1584149152,'Leo'],
  [-1584149152,-1583938203,'Virgo'],
  [-1583938203,-1583720889,'Libra'],
  [-1583720889,-1583500865,'Scorpio'],
  [-1583500865,-1583284670,'Sagittarius'],
  [-1583284670,-1583079432,'Capricorn'],
  [-1583079432,-1582888591,'Aquarius'],
  [-1582888591,-1582710156,'Pisces'],
  [-1582710156,-1582538474,'Aries'],
  [-1582538474,-1582366612,'Taurus'],
  [-1582366612,-1582188076,'Gemini'],
  [-1582188076,-1581998318,'Cancer'],
  [-1581998318,-1581796099,'Leo'],
  [-1581796099,-1581583732,'Virgo'],
  [-1581583732,-1581365475,'Libra'],
  [-1581365475,-1581145744,'Scorpio'],
  [-1581145744,-1580928987,'Sagittarius'],
  [-1580928987,-1580720011,'Capricorn'],
  [-1580720011,-1580522860,'Aquarius'],
  [-1580522860,-1580338525,'Pisces'],
  [-1580338525,-1580164123,'Aries'],
  [-1580164123,-1579993860,'Taurus'],
  [-1579993860,-1579820599,'Gemini'],
  [-1579820599,-1579637489,'Cancer'],
  [-1579637489,-1579440162,'Leo'],
  [-1579440162,-1579229240,'Virgo'],
  [-1579229240,-1579010449,'Libra'],
  [-1579010449,-1578790890,'Scorpio'],
  [-1578790890,-1578575410,'Sagittarius'],
  [-1578575410,-1578366454,'Capricorn'],
  [-1578366454,-1578165843,'Aquarius'],
  [-1578165843,-1577975113,'Pisces'],
  [-1577975113,-1577794213,'Aries'],
  [-1577794213,-1577620232,'Taurus'],
  [-1577620232,-1577447447,'Gemini'],
  [-1577447447,-1577268671,'Cancer'],
  [-1577268671,-1577077372,'Leo'],
  [-1577077372,-1576870912,'Virgo'],
  [-1576870912,-1576653386,'Libra'],
  [-1576653386,-1576433711,'Scorpio'],
  [-1576433711,-1576219357,'Sagittarius'],
  [-1576219357,-1576012846,'Capricorn'],
  [-1576012846,-1575813560,'Aquarius'],
  [-1575813560,-1575620748,'Pisces'],
  [-1575620748,-1575434430,'Aries'],
  [-1575434430,-1575254116,'Taurus'],
  [-1575254116,-1575076972,'Gemini'],
  [-1575076972,-1574897549,'Cancer'],
  [-1574897549,-1574709301,'Leo'],
  [-1574709301,-1574507468,'Virgo'],
  [-1574507468,-1574292906,'Libra'],
  [-1574292906,-1574073423,'Scorpio'],
  [-1574073423,-1573858771,'Sagittarius'],
  [-1573858771,-1573653930,'Capricorn'],
  [-1573653930,-1573458137,'Aquarius'],
  [-1573458137,-1573268288,'Pisces'],
  [-1573268288,-1573081932,'Aries'],
  [-1573081932,-1572897999,'Taurus'],
  [-1572897999,-1572715449,'Gemini'],
  [-1572715449,-1572531594,'Cancer'],
  [-1572531594,-1572341927,'Leo'],
  [-1572341927,-1572141865,'Virgo'],
  [-1572141865,-1571930048,'Libra'],
  [-1571930048,-1571711333,'Scorpio'],
  [-1571711333,-1571495244,'Sagittarius'],
  [-1571495244,-1571289446,'Capricorn'],
  [-1571289446,-1571095381,'Aquarius'],
  [-1571095381,-1570909719,'Pisces'],
  [-1570909719,-1570727810,'Aries'],
  [-1570727810,-1570545947,'Taurus'],
  [-1570545947,-1570361896,'Gemini'],
  [-1570361896,-1570174073,'Cancer'],
  [-1570174073,-1569980516,'Leo'],
  [-1569980516,-1569778838,'Virgo'],
  [-1569778838,-1569567785,'Libra'],
  [-1569567785,-1569349863,'Scorpio'],
  [-1569349863,-1569132233,'Sagittarius'],
  [-1569132233,-1568923309,'Capricorn'],
  [-1568923309,-1568727416,'Aquarius'],
  [-1568727416,-1568543169,'Pisces'],
  [-1568543169,-1568365704,'Aries'],
  [-1568365704,-1568189290,'Taurus'],
  [-1568189290,-1568009008,'Gemini'],
  [-1568009008,-1567821599,'Cancer'],
  [-1567821599,-1567625625,'Leo'],
  [-1567625625,-1567421051,'Virgo'],
  [-1567421051,-1567208746,'Libra'],
  [-1567208746,-1566990984,'Scorpio'],
  [-1566990984,-1566772509,'Sagittarius'],
  [-1566772509,-1566560152,'Capricorn'],
  [-1566560152,-1566359771,'Aquarius'],
  [-1566359771,-1566172859,'Pisces'],
  [-1566172859,-1565996296,'Aries'],
  [-1565996296,-1565824171,'Taurus'],
  [-1565824171,-1565649764,'Gemini'],
  [-1565649764,-1565467182,'Cancer'],
  [-1565467182,-1565272978,'Leo'],
  [-1565272978,-1565067310,'Virgo'],
  [-1565067310,-1564853297,'Libra'],
  [-1564853297,-1564635018,'Scorpio'],
  [-1564635018,-1564416522,'Sagittarius'],
  [-1564416522,-1564202279,'Capricorn'],
  [-1564202279,-1563997299,'Aquarius'],
  [-1563997299,-1563805024,'Pisces'],
  [-1563805024,-1563625118,'Aries'],
  [-1563625118,-1563453275,'Taurus'],
  [-1563453275,-1563282678,'Gemini'],
  [-1563282678,-1563105881,'Cancer'],
  [-1563105881,-1562916863,'Leo'],
  [-1562916863,-1562713596,'Virgo'],
  [-1562713596,-1562499385,'Libra'],
  [-1562499385,-1562280522,'Scorpio'],
  [-1562280522,-1562062426,'Sagittarius'],
  [-1562062426,-1561848424,'Capricorn'],
  [-1561848424,-1561641286,'Aquarius'],
  [-1561641286,-1561444040,'Pisces'],
  [-1561444040,-1561258379,'Aries'],
  [-1561258379,-1561082671,'Taurus'],
  [-1561082671,-1560911664,'Gemini'],
  [-1560911664,-1560737994,'Cancer'],
  [-1560737994,-1560554266,'Leo'],
  [-1560554266,-1560355842,'Virgo'],
  [-1560355842,-1560143879,'Libra'],
  [-1560143879,-1559925180,'Scorpio'],
  [-1559925180,-1559707409,'Sagittarius'],
  [-1559707409,-1559494820,'Capricorn'],
  [-1559494820,-1559288666,'Aquarius'],
  [-1559288666,-1559089788,'Pisces'],
  [-1559089788,-1558899506,'Aries'],
  [-1558899506,-1558718077,'Taurus'],
  [-1558718077,-1558542819,'Gemini'],
  [-1558542819,-1558368053,'Cancer'],
  [-1558368053,-1558186690,'Leo'],
  [-1558186690,-1557992710,'Virgo'],
  [-1557992710,-1557784536,'Libra'],
  [-1557784536,-1557567158,'Scorpio'],
  [-1557567158,-1557349376,'Sagittarius'],
  [-1557349376,-1557137766,'Capricorn'],
  [-1557137766,-1556934087,'Aquarius'],
  [-1556934087,-1556737377,'Pisces'],
  [-1556737377,-1556546666,'Aries'],
  [-1556546666,-1556361590,'Taurus'],
  [-1556361590,-1556181047,'Gemini'],
  [-1556181047,-1556001849,'Cancer'],
  [-1556001849,-1555818843,'Leo'],
  [-1555818843,-1555626473,'Virgo'],
  [-1555626473,-1555421542,'Libra'],
  [-1555421542,-1555206217,'Scorpio'],
  [-1555206217,-1554988174,'Sagittarius'],
  [-1554988174,-1554775929,'Capricorn'],
  [-1554775929,-1554573585,'Aquarius'],
  [-1554573585,-1554380353,'Pisces'],
  [-1554380353,-1554193267,'Aries'],
  [-1554193267,-1554009457,'Taurus'],
  [-1554009457,-1553826769,'Gemini'],
  [-1553826769,-1553643141,'Cancer'],
  [-1553643141,-1553455863,'Leo'],
  [-1553455863,-1553261596,'Virgo'],
  [-1553261596,-1553057580,'Libra'],
  [-1553057580,-1552843978,'Scorpio'],
  [-1552843978,-1552625754,'Sagittarius'],
  [-1552625754,-1552411274,'Capricorn'],
  [-1552411274,-1552207319,'Aquarius'],
  [-1552207319,-1552015399,'Pisces'],
  [-1552015399,-1551832532,'Aries'],
  [-1551832532,-1551653790,'Taurus'],
  [-1551653790,-1551474304,'Gemini'],
  [-1551474304,-1551290405,'Cancer'],
  [-1551290405,-1551099961,'Leo'],
  [-1551099961,-1550902034,'Virgo'],
  [-1550902034,-1550696264,'Libra'],
  [-1550696264,-1550483027,'Scorpio'],
  [-1550483027,-1550264917,'Sagittarius'],
  [-1550264917,-1550047948,'Capricorn'],
  [-1550047948,-1549839761,'Aquarius'],
  [-1549839761,-1549645030,'Pisces'],
  [-1549645030,-1549463004,'Aries'],
  [-1549463004,-1549288697,'Taurus'],
  [-1549288697,-1549115329,'Gemini'],
  [-1549115329,-1548936430,'Cancer'],
  [-1548936430,-1548747662,'Leo'],
  [-1548747662,-1548548090,'Virgo'],
  [-1548548090,-1548339692,'Libra'],
  [-1548339692,-1548125255,'Scorpio'],
  [-1548125255,-1547907273,'Sagittarius'],
  [-1547907273,-1547689163,'Capricorn'],
  [-1547689163,-1547476706,'Aquarius'],
  [-1547476706,-1547276143,'Pisces'],
  [-1547276143,-1547090073,'Aries'],
  [-1547090073,-1546915683,'Taurus'],
  [-1546915683,-1546746275,'Gemini'],
  [-1546746275,-1546573836,'Cancer'],
  [-1546573836,-1546391275,'Leo'],
  [-1546391275,-1546194926,'Virgo'],
  [-1546194926,-1545986293,'Libra'],
  [-1545986293,-1545770417,'Scorpio'],
  [-1545770417,-1545552112,'Sagittarius'],
  [-1545552112,-1545334397,'Capricorn'],
  [-1545334397,-1545120384,'Aquarius'],
  [-1545120384,-1544914822,'Pisces'],
  [-1544914822,-1544722065,'Aries'],
  [-1544722065,-1544542584,'Taurus'],
  [-1544542584,-1544371863,'Gemini'],
  [-1544371863,-1544202333,'Cancer'],
  [-1544202333,-1544025810,'Leo'],
  [-1544025810,-1543835942,'Virgo'],
  [-1543835942,-1543631173,'Libra'],
  [-1543631173,-1543415868,'Scorpio'],
  [-1543415868,-1543197116,'Sagittarius'],
  [-1543197116,-1542980113,'Capricorn'],
  [-1542980113,-1542767311,'Aquarius'],
  [-1542767311,-1542560813,'Pisces'],
  [-1542560813,-1542363530,'Aries'],
  [-1542363530,-1542177415,'Taurus'],
  [-1542177415,-1542000973,'Gemini'],
  [-1542000973,-1541828954,'Cancer'],
  [-1541828954,-1541654086,'Leo'],
  [-1541654086,-1541469261,'Virgo'],
  [-1541469261,-1541270219,'Libra'],
  [-1541270219,-1541058228,'Scorpio'],
  [-1541058228,-1540839955,'Sagittarius'],
  [-1540839955,-1540623072,'Capricorn'],
  [-1540623072,-1540411966,'Aquarius'],
  [-1540411966,-1540207858,'Pisces'],
  [-1540207858,-1540011021,'Aries'],
  [-1540011021,-1539821785,'Taurus'],
  [-1539821785,-1539639608,'Gemini'],
  [-1539639608,-1539461861,'Cancer'],
  [-1539461861,-1539283772,'Leo'],
  [-1539283772,-1539099535,'Virgo'],
  [-1539099535,-1538904218,'Libra'],
  [-1538904218,-1538696324,'Scorpio'],
  [-1538696324,-1538479765,'Sagittarius'],
  [-1538479765,-1538262516,'Capricorn'],
  [-1538262516,-1538051655,'Aquarius'],
  [-1538051655,-1537850002,'Pisces'],
  [-1537850002,-1537656746,'Aries'],
  [-1537656746,-1537469595,'Taurus'],
  [-1537469595,-1537286165,'Gemini'],
  [-1537286165,-1537104161,'Cancer'],
  [-1537104161,-1536920985,'Leo'],
  [-1536920985,-1536733423,'Virgo'],
  [-1536733423,-1536538001,'Libra'],
  [-1536538001,-1536332412,'Scorpio'],
  [-1536332412,-1536117802,'Sagittarius'],
  [-1536117802,-1535900128,'Capricorn'],
  [-1535900128,-1535687702,'Aquarius'],
  [-1535687702,-1535486100,'Pisces'],
  [-1535486100,-1535295716,'Aries'],
  [-1535295716,-1535113048,'Taurus'],
  [-1535113048,-1534933201,'Gemini'],
  [-1534933201,-1534751832,'Cancer'],
  [-1534751832,-1534566090,'Leo'],
  [-1534566090,-1534374530,'Virgo'],
  [-1534374530,-1534176229,'Libra'],
  [-1534176229,-1533970225,'Scorpio'],
  [-1533970225,-1533756582,'Sagittarius'],
  [-1533756582,-1533538642,'Capricorn'],
  [-1533538642,-1533323691,'Aquarius'],
  [-1533323691,-1533119334,'Pisces'],
  [-1533119334,-1532928598,'Aries'],
  [-1532928598,-1532748827,'Taurus'],
  [-1532748827,-1532573955,'Gemini'],
  [-1532573955,-1532397327,'Cancer'],
  [-1532397327,-1532213836,'Leo'],
  [-1532213836,-1532021297,'Virgo'],
  [-1532021297,-1531820254,'Libra'],
  [-1531820254,-1531612158,'Scorpio'],
  [-1531612158,-1531398119,'Sagittarius'],
  [-1531398119,-1531180069,'Capricorn'],
  [-1531180069,-1530962991,'Aquarius'],
  [-1530962991,-1530754433,'Pisces'],
  [-1530754433,-1530559928,'Aries'],
  [-1530559928,-1530379228,'Taurus'],
  [-1530379228,-1530206922,'Gemini'],
  [-1530206922,-1530035385,'Cancer'],
  [-1530035385,-1529857379,'Leo'],
  [-1529857379,-1529668252,'Virgo'],
  [-1529668252,-1529467479,'Libra'],
  [-1529467479,-1529257819,'Scorpio'],
  [-1529257819,-1529042634,'Sagittarius'],
  [-1529042634,-1528824507,'Capricorn'],
  [-1528824507,-1528606698,'Aquarius'],
  [-1528606698,-1528394819,'Pisces'],
  [-1528394819,-1528195017,'Aries'],
  [-1528195017,-1528009718,'Taurus'],
  [-1528009718,-1527835753,'Gemini'],
  [-1527835753,-1527666199,'Cancer'],
  [-1527666199,-1527493111,'Leo'],
  [-1527493111,-1527309762,'Virgo'],
  [-1527309762,-1527112966,'Libra'],
  [-1527112966,-1526904285,'Scorpio'],
  [-1526904285,-1526688446,'Sagittarius'],
  [-1526688446,-1526470185,'Capricorn'],
  [-1526470185,-1526252962,'Aquarius'],
  [-1526252962,-1526040383,'Pisces'],
  [-1526040383,-1525836887,'Aries'],
  [-1525836887,-1525645790,'Taurus'],
  [-1525645790,-1525466574,'Gemini'],
  [-1525466574,-1525294561,'Cancer'],
  [-1525294561,-1525122755,'Leo'],
  [-1525122755,-1524943912,'Virgo'],
  [-1524943912,-1524752668,'Libra'],
  [-1524752668,-1524547776,'Scorpio'],
  [-1524547776,-1524332921,'Sagittarius'],
  [-1524332921,-1524114570,'Capricorn'],
  [-1524114570,-1523898253,'Aquarius'],
  [-1523898253,-1523687306,'Pisces'],
  [-1523687306,-1523483866,'Aries'],
  [-1523483866,-1523289549,'Taurus'],
  [-1523289549,-1523104647,'Gemini'],
  [-1523104647,-1522926995,'Cancer'],
  [-1522926995,-1522752018,'Leo'],
  [-1522752018,-1522573746,'Virgo'],
  [-1522573746,-1522386333,'Libra'],
  [-1522386333,-1522186136,'Scorpio'],
  [-1522186136,-1521974011,'Sagittarius'],
  [-1521974011,-1521755928,'Capricorn'],
  [-1521755928,-1521539724,'Aquarius'],
  [-1521539724,-1521330662,'Pisces'],
  [-1521330662,-1521130165,'Aries'],
  [-1521130165,-1520937294,'Taurus'],
  [-1520937294,-1520750456,'Gemini'],
  [-1520750456,-1520567901,'Cancer'],
  [-1520567901,-1520387345,'Leo'],
  [-1520387345,-1520205470,'Virgo'],
  [-1520205470,-1520017968,'Libra'],
  [-1520017968,-1519820627,'Scorpio'],
  [-1519820627,-1519611671,'Sagittarius'],
  [-1519611671,-1519394453,'Capricorn'],
  [-1519394453,-1519177221,'Aquarius'],
  [-1519177221,-1518968076,'Pisces'],
  [-1518968076,-1518770152,'Aries'],
  [-1518770152,-1518581502,'Taurus'],
  [-1518581502,-1518397891,'Gemini'],
  [-1518397891,-1518215353,'Cancer'],
  [-1518215353,-1518031372,'Leo'],
  [-1518031372,-1517844582,'Virgo'],
  [-1517844582,-1517653468,'Libra'],
  [-1517653468,-1517455513,'Scorpio'],
  [-1517455513,-1517248240,'Sagittarius'],
  [-1517248240,-1517032187,'Capricorn'],
  [-1517032187,-1516813502,'Aquarius'],
  [-1516813502,-1516601694,'Pisces'],
  [-1516601694,-1516403045,'Aries'],
  [-1516403045,-1516217092,'Taurus'],
  [-1516217092,-1516038587,'Gemini'],
  [-1516038587,-1515861044,'Cancer'],
  [-1515861044,-1515679344,'Leo'],
  [-1515679344,-1515491123,'Virgo'],
  [-1515491123,-1515296331,'Libra'],
  [-1515296331,-1515095227,'Scorpio'],
  [-1515095227,-1514887119,'Sagittarius'],
  [-1514887119,-1514671673,'Capricorn'],
  [-1514671673,-1514452157,'Aquarius'],
  [-1514452157,-1514236689,'Pisces'],
  [-1514236689,-1514033733,'Aries'],
  [-1514033733,-1513846022,'Taurus'],
  [-1513846022,-1513669673,'Gemini'],
  [-1513669673,-1513497464,'Cancer'],
  [-1513497464,-1513322038,'Leo'],
  [-1513322038,-1513138123,'Virgo'],
  [-1513138123,-1512943942,'Libra'],
  [-1512943942,-1512740673,'Scorpio'],
  [-1512740673,-1512530297,'Sagittarius'],
  [-1512530297,-1512314261,'Capricorn'],
  [-1512314261,-1512094738,'Aquarius'],
  [-1512094738,-1511877049,'Pisces'],
  [-1511877049,-1511668904,'Aries'],
  [-1511668904,-1511475575,'Taurus'],
  [-1511475575,-1511296260,'Gemini'],
  [-1511296260,-1511125177,'Cancer'],
  [-1511125177,-1510954655,'Leo'],
  [-1510954655,-1510777496,'Virgo'],
  [-1510777496,-1510588856,'Libra'],
  [-1510588856,-1510387674,'Scorpio'],
  [-1510387674,-1510176452,'Sagittarius'],
  [-1510176452,-1509959253,'Capricorn'],
  [-1509959253,-1509739865,'Aquarius'],
  [-1509739865,-1509522251,'Pisces'],
  [-1509522251,-1509311481,'Aries'],
  [-1509311481,-1509112429,'Taurus'],
  [-1509112429,-1508926773,'Gemini'],
  [-1508926773,-1508751675,'Cancer'],
  [-1508751675,-1508581133,'Leo'],
  [-1508581133,-1508408017,'Virgo'],
  [-1508408017,-1508225780,'Libra'],
  [-1508225780,-1508030273,'Scorpio'],
  [-1508030273,-1507821585,'Sagittarius'],
  [-1507821585,-1507604302,'Capricorn'],
  [-1507604302,-1507384821,'Aquarius'],
  [-1507384821,-1507168371,'Pisces'],
  [-1507168371,-1506958398,'Aries'],
  [-1506958398,-1506757277,'Taurus'],
  [-1506757277,-1506566336,'Gemini'],
  [-1506566336,-1506384881,'Cancer'],
  [-1506384881,-1506209733,'Leo'],
  [-1506209733,-1506035662,'Virgo'],
  [-1506035662,-1505856430,'Libra'],
  [-1505856430,-1505666297,'Scorpio'],
  [-1505666297,-1505462333,'Sagittarius'],
  [-1505462333,-1505246945,'Capricorn'],
  [-1505246945,-1505027502,'Aquarius'],
  [-1505027502,-1504811795,'Pisces'],
  [-1504811795,-1504604058,'Aries'],
  [-1504604058,-1504404816,'Taurus'],
  [-1504404816,-1504213022,'Gemini'],
  [-1504213022,-1504027437,'Cancer'],
  [-1504027437,-1503846567,'Leo'],
  [-1503846567,-1503667849,'Virgo'],
  [-1503667849,-1503487071,'Libra'],
  [-1503487071,-1503298909,'Scorpio'],
  [-1503298909,-1503098854,'Sagittarius'],
  [-1503098854,-1502886420,'Capricorn'],
  [-1502886420,-1502667470,'Aquarius'],
  [-1502667470,-1502451434,'Pisces'],
  [-1502451434,-1502244942,'Aries'],
  [-1502244942,-1502048816,'Taurus'],
  [-1502048816,-1501860080,'Gemini'],
  [-1501860080,-1501675179,'Cancer'],
  [-1501675179,-1501491728,'Leo'],
  [-1501491728,-1501308368,'Virgo'],
  [-1501308368,-1501123344,'Libra'],
  [-1501123344,-1500933389,'Scorpio'],
  [-1500933389,-1500734410,'Sagittarius'],
  [-1500734410,-1500524213,'Capricorn'],
  [-1500524213,-1500306024,'Aquarius'],
  [-1500306024,-1500088753,'Pisces'],
  [-1500088753,-1499881278,'Aries'],
  [-1499881278,-1499686530,'Taurus'],
  [-1499686530,-1499501493,'Gemini'],
  [-1499501493,-1499320755,'Cancer'],
  [-1499320755,-1499139574,'Leo'],
  [-1499139574,-1498955298,'Virgo'],
  [-1498955298,-1498766920,'Libra'],
  [-1498766920,-1498573411,'Scorpio'],
  [-1498573411,-1498372728,'Sagittarius'],
  [-1498372728,-1498162935,'Capricorn'],
  [-1498162935,-1497945305,'Aquarius'],
  [-1497945305,-1497726576,'Pisces'],
  [-1497726576,-1497516156,'Aries'],
  [-1497516156,-1497319611,'Taurus'],
  [-1497319611,-1497135742,'Gemini'],
  [-1497135742,-1496958992,'Cancer'],
  [-1496958992,-1496782885,'Leo'],
  [-1496782885,-1496602312,'Virgo'],
  [-1496602312,-1496414579,'Libra'],
  [-1496414579,-1496219009,'Scorpio'],
  [-1496219009,-1496015650,'Sagittarius'],
  [-1496015650,-1495804575,'Capricorn'],
  [-1495804575,-1495586954,'Aquarius'],
  [-1495586954,-1495367334,'Pisces'],
  [-1495367334,-1495153548,'Aries'],
  [-1495153548,-1494952568,'Taurus'],
  [-1494952568,-1494765989,'Gemini'],
  [-1494765989,-1494589923,'Cancer'],
  [-1494589923,-1494417823,'Leo'],
  [-1494417823,-1494242950,'Virgo'],
  [-1494242950,-1494060023,'Libra'],
  [-1494060023,-1493866340,'Scorpio'],
  [-1493866340,-1493662031,'Sagittarius'],
  [-1493662031,-1493449276,'Capricorn'],
  [-1493449276,-1493231110,'Aquarius'],
  [-1493231110,-1493011479,'Pisces'],
  [-1493011479,-1492795854,'Aries'],
  [-1492795854,-1492590194,'Taurus'],
  [-1492590194,-1492398020,'Gemini'],
  [-1492398020,-1492218298,'Cancer'],
  [-1492218298,-1492046204,'Leo'],
  [-1492046204,-1491875072,'Virgo'],
  [-1491875072,-1491698072,'Libra'],
  [-1491698072,-1491509789,'Scorpio'],
  [-1491509789,-1491308059,'Sagittarius'],
  [-1491308059,-1491095116,'Capricorn'],
  [-1491095116,-1490876291,'Aquarius'],
  [-1490876291,-1490657124,'Pisces'],
  [-1490657124,-1490441968,'Aries'],
  [-1490441968,-1490234300,'Taurus'],
  [-1490234300,-1490036949,'Gemini'],
  [-1490036949,-1489850929,'Cancer'],
  [-1489850929,-1489674324,'Leo'],
  [-1489674324,-1489502378,'Virgo'],
  [-1489502378,-1489328520,'Libra'],
  [-1489328520,-1489145867,'Scorpio'],
  [-1489145867,-1488949420,'Sagittarius'],
  [-1488949420,-1488738979,'Capricorn'],
  [-1488738979,-1488520240,'Aquarius'],
  [-1488520240,-1488301299,'Pisces'],
  [-1488301299,-1488087779,'Aries'],
  [-1488087779,-1487881602,'Taurus'],
  [-1487881602,-1487683025,'Gemini'],
  [-1487683025,-1487492298,'Cancer'],
  [-1487492298,-1487309329,'Leo'],
  [-1487309329,-1487132282,'Virgo'],
  [-1487132282,-1486956728,'Libra'],
  [-1486956728,-1486776299,'Scorpio'],
  [-1486776299,-1486584608,'Sagittarius'],
  [-1486584608,-1486378466,'Capricorn'],
  [-1486378466,-1486161262,'Aquarius'],
  [-1486161262,-1485942081,'Pisces'],
  [-1485942081,-1485729325,'Aries'],
  [-1485729325,-1485525880,'Taurus'],
  [-1485525880,-1485330222,'Gemini'],
  [-1485330222,-1485139926,'Cancer'],
  [-1485139926,-1484953698,'Leo'],
  [-1484953698,-1484771008,'Virgo'],
  [-1484771008,-1484590214,'Libra'],
  [-1484590214,-1484407342,'Scorpio'],
  [-1484407342,-1484216823,'Sagittarius'],
  [-1484216823,-1484014075,'Capricorn'],
  [-1484014075,-1483799367,'Aquarius'],
  [-1483799367,-1483579971,'Pisces'],
  [-1483579971,-1483366052,'Aries'],
  [-1483366052,-1483163383,'Taurus'],
  [-1483163383,-1482971192,'Gemini'],
  [-1482971192,-1482785303,'Cancer'],
  [-1482785303,-1482601637,'Leo'],
  [-1482601637,-1482417858,'Virgo'],
  [-1482417858,-1482232901,'Libra'],
  [-1482232901,-1482045253,'Scorpio'],
  [-1482045253,-1481851960,'Sagittarius'],
  [-1481851960,-1481649501,'Capricorn'],
  [-1481649501,-1481436599,'Aquarius'],
  [-1481436599,-1481217438,'Pisces'],
  [-1481217438,-1481001172,'Aries'],
  [-1481001172,-1480796031,'Taurus'],
  [-1480796031,-1480604088,'Gemini'],
  [-1480604088,-1480421858,'Cancer'],
  [-1480421858,-1480243710,'Leo'],
  [-1480243710,-1480064502,'Virgo'],
  [-1480064502,-1479880816,'Libra'],
  [-1479880816,-1479690919,'Scorpio'],
  [-1479690919,-1479493892,'Sagittarius'],
  [-1479493892,-1479288938,'Capricorn'],
  [-1479288938,-1479075872,'Aquarius'],
  [-1479075872,-1478857092,'Pisces'],
  [-1478857092,-1478638929,'Aries'],
  [-1478638929,-1478429495,'Taurus'],
  [-1478429495,-1478233737,'Gemini'],
  [-1478233737,-1478050893,'Cancer'],
  [-1478050893,-1477876064,'Leo'],
  [-1477876064,-1477702815,'Virgo'],
  [-1477702815,-1477525054,'Libra'],
  [-1477525054,-1477338357,'Scorpio'],
  [-1477338357,-1477140902,'Sagittarius'],
  [-1477140902,-1476933561,'Capricorn'],
  [-1476933561,-1476718835,'Aquarius'],
  [-1476718835,-1476499962,'Pisces'],
  [-1476499962,-1476281265,'Aries'],
  [-1476281265,-1476068483,'Taurus'],
  [-1476068483,-1475867142,'Gemini'],
  [-1475867142,-1475679441,'Cancer'],
  [-1475679441,-1475503082,'Leo'],
  [-1475503082,-1475332426,'Virgo'],
  [-1475332426,-1475160373,'Libra'],
  [-1475160373,-1474980077,'Scorpio'],
  [-1474980077,-1474786873,'Sagittarius'],
  [-1474786873,-1474580341,'Capricorn'],
  [-1474580341,-1474364503,'Aquarius'],
  [-1474364503,-1474145080,'Pisces'],
  [-1474145080,-1473926807,'Aries'],
  [-1473926807,-1473713268,'Taurus'],
  [-1473713268,-1473508087,'Gemini'],
  [-1473508087,-1473314343,'Cancer'],
  [-1473314343,-1473132565,'Leo'],
  [-1473132565,-1472959592,'Virgo'],
  [-1472959592,-1472789211,'Libra'],
  [-1472789211,-1472613876,'Scorpio'],
  [-1472613876,-1472426739,'Sagittarius'],
  [-1472426739,-1472224490,'Capricorn'],
  [-1472224490,-1472009869,'Aquarius'],
  [-1472009869,-1471790229,'Pisces'],
  [-1471790229,-1471572499,'Aries'],
  [-1471572499,-1471360199,'Taurus'],
  [-1471360199,-1471154736,'Gemini'],
  [-1471154736,-1470957562,'Cancer'],
  [-1470957562,-1470770026,'Leo'],
  [-1470770026,-1470591536,'Virgo'],
  [-1470591536,-1470418250,'Libra'],
  [-1470418250,-1470243675,'Scorpio'],
  [-1470243675,-1470060520,'Sagittarius'],
  [-1470060520,-1469863364,'Capricorn'],
  [-1469863364,-1469652115,'Aquarius'],
  [-1469652115,-1469433288,'Pisces'],
  [-1469433288,-1469215757,'Aries'],
  [-1469215757,-1469004923,'Taurus'],
  [-1469004923,-1468801694,'Gemini'],
  [-1468801694,-1468605271,'Cancer'],
  [-1468605271,-1468415371,'Leo'],
  [-1468415371,-1468231947,'Virgo'],
  [-1468231947,-1468053412,'Libra'],
  [-1468053412,-1467875594,'Scorpio'],
  [-1467875594,-1467692472,'Sagittarius'],
  [-1467692472,-1467498259,'Capricorn'],
  [-1467498259,-1467290622,'Aquarius'],
  [-1467290622,-1467073513,'Pisces'],
  [-1467073513,-1466855790,'Aries'],
  [-1466855790,-1466645177,'Taurus'],
  [-1466645177,-1466444118,'Gemini'],
  [-1466444118,-1466250989,'Cancer'],
  [-1466250989,-1466063196,'Leo'],
  [-1466063196,-1465878877,'Virgo'],
  [-1465878877,-1465696591,'Libra'],
  [-1465696591,-1465514089,'Scorpio'],
  [-1465514089,-1465327699,'Sagittarius'],
  [-1465327699,-1465133068,'Capricorn'],
  [-1465133068,-1464927325,'Aquarius'],
  [-1464927325,-1464711966,'Pisces'],
  [-1464711966,-1464493860,'Aries'],
  [-1464493860,-1464281734,'Taurus'],
  [-1464281734,-1464080623,'Gemini'],
  [-1464080623,-1463890118,'Cancer'],
  [-1463890118,-1463706606,'Leo'],
  [-1463706606,-1463525842,'Virgo'],
  [-1463525842,-1463344317,'Libra'],
  [-1463344317,-1463159462,'Scorpio'],
  [-1463159462,-1462969216,'Sagittarius'],
  [-1462969216,-1462771660,'Capricorn'],
  [-1462771660,-1462565355,'Aquarius'],
  [-1462565355,-1462350854,'Pisces'],
  [-1462350854,-1462132459,'Aries'],
  [-1462132459,-1461917750,'Taurus'],
  [-1461917750,-1461713714,'Gemini'],
  [-1461713714,-1461522640,'Cancer'],
  [-1461522640,-1461341905,'Leo'],
  [-1461341905,-1461166174,'Virgo'],
  [-1461166174,-1460989543,'Libra'],
  [-1460989543,-1460807094,'Scorpio'],
  [-1460807094,-1460615951,'Sagittarius'],
  [-1460615951,-1460415584,'Capricorn'],
  [-1460415584,-1460207064,'Aquarius'],
  [-1460207064,-1459992153,'Pisces'],
  [-1459992153,-1459773726,'Aries'],
  [-1459773726,-1459556867,'Taurus'],
  [-1459556867,-1459348317,'Gemini'],
  [-1459348317,-1459152970,'Cancer'],
  [-1459152970,-1458970918,'Leo'],
  [-1458970918,-1458797716,'Virgo'],
  [-1458797716,-1458626457,'Libra'],
  [-1458626457,-1458449923,'Scorpio'],
  [-1458449923,-1458262587,'Sagittarius'],
  [-1458262587,-1458062641,'Capricorn'],
  [-1458062641,-1457852447,'Aquarius'],
  [-1457852447,-1457636296,'Pisces'],
  [-1457636296,-1457417922,'Aries'],
  [-1457417922,-1457200569,'Taurus'],
  [-1457200569,-1456988665,'Gemini'],
  [-1456988665,-1456787487,'Cancer'],
  [-1456787487,-1456600018,'Leo'],
  [-1456600018,-1456424530,'Virgo'],
  [-1456424530,-1456255069,'Libra'],
  [-1456255069,-1456083702,'Scorpio'],
  [-1456083702,-1455902756,'Sagittarius'],
  [-1455902756,-1455707468,'Capricorn'],
  [-1455707468,-1455498586,'Aquarius'],
  [-1455498586,-1455281732,'Pisces'],
  [-1455281732,-1455063181,'Aries'],
  [-1455063181,-1454846708,'Taurus'],
  [-1454846708,-1454634598,'Gemini'],
  [-1454634598,-1454429929,'Cancer'],
  [-1454429929,-1454236194,'Leo'],
  [-1454236194,-1454054515,'Virgo'],
  [-1454054515,-1453881677,'Libra'],
  [-1453881677,-1453710990,'Scorpio'],
  [-1453710990,-1453534478,'Sagittarius'],
  [-1453534478,-1453345326,'Capricorn'],
  [-1453345326,-1453141064,'Aquarius'],
  [-1453141064,-1452925627,'Pisces'],
  [-1452925627,-1452706885,'Aries'],
  [-1452706885,-1452491202,'Taurus'],
  [-1452491202,-1452281111,'Gemini'],
  [-1452281111,-1452077370,'Cancer'],
  [-1452077370,-1451881169,'Leo'],
  [-1451881169,-1451693807,'Virgo'],
  [-1451693807,-1451514585,'Libra'],
  [-1451514585,-1451339609,'Scorpio'],
  [-1451339609,-1451162596,'Sagittarius'],
  [-1451162596,-1450976791,'Capricorn'],
  [-1450976791,-1450777615,'Aquarius'],
  [-1450777615,-1450565673,'Pisces'],
  [-1450565673,-1450347490,'Aries'],
  [-1450347490,-1450131531,'Taurus'],
  [-1450131531,-1449922905,'Gemini'],
  [-1449922905,-1449722398,'Cancer'],
  [-1449722398,-1449528794,'Leo'],
  [-1449528794,-1449340859,'Virgo'],
  [-1449340859,-1449157476,'Libra'],
  [-1449157476,-1448976690,'Scorpio'],
  [-1448976690,-1448795030,'Sagittarius'],
  [-1448795030,-1448607861,'Capricorn'],
  [-1448607861,-1448410828,'Aquarius'],
  [-1448410828,-1448202266,'Pisces'],
  [-1448202266,-1447985536,'Aries'],
  [-1447985536,-1447768544,'Taurus'],
  [-1447768544,-1447559043,'Gemini'],
  [-1447559043,-1447360258,'Cancer'],
  [-1447360258,-1447170828,'Leo'],
  [-1447170828,-1446987138,'Virgo'],
  [-1446987138,-1446805386,'Libra'],
  [-1446805386,-1446622539,'Scorpio'],
  [-1446622539,-1446436366,'Sagittarius'],
  [-1446436366,-1446244932,'Capricorn'],
  [-1446244932,-1446046211,'Aquarius'],
  [-1446046211,-1445838698,'Pisces'],
  [-1445838698,-1445623352,'Aries'],
  [-1445623352,-1445405414,'Taurus'],
  [-1445405414,-1445193079,'Gemini'],
  [-1445193079,-1444992557,'Cancer'],
  [-1444992557,-1444804672,'Leo'],
  [-1444804672,-1444625548,'Virgo'],
  [-1444625548,-1444449214,'Libra'],
  [-1444449214,-1444269943,'Scorpio'],
  [-1444269943,-1444083845,'Sagittarius'],
  [-1444083845,-1443889566,'Capricorn'],
  [-1443889566,-1443687555,'Aquarius'],
  [-1443687555,-1443478571,'Pisces'],
  [-1443478571,-1443263497,'Aries'],
  [-1443263497,-1443045134,'Taurus'],
  [-1443045134,-1442829755,'Gemini'],
  [-1442829755,-1442624880,'Cancer'],
  [-1442624880,-1442434383,'Leo'],
  [-1442434383,-1442256262,'Virgo'],
  [-1442256262,-1442084304,'Libra'],
  [-1442084304,-1441910982,'Scorpio'],
  [-1441910982,-1441729790,'Sagittarius'],
  [-1441729790,-1441537274,'Capricorn'],
  [-1441537274,-1441333989,'Aquarius'],
  [-1441333989,-1441122936,'Pisces'],
  [-1441122936,-1440907005,'Aries'],
  [-1440907005,-1440688581,'Taurus'],
  [-1440688581,-1440471559,'Gemini'],
  [-1440471559,-1440262284,'Cancer'],
  [-1440262284,-1440066443,'Leo'],
  [-1440066443,-1439884939,'Virgo'],
  [-1439884939,-1439713207,'Libra'],
  [-1439713207,-1439543676,'Scorpio'],
  [-1439543676,-1439368412,'Sagittarius'],
  [-1439368412,-1439181393,'Capricorn'],
  [-1439181393,-1438980815,'Aquarius'],
  [-1438980815,-1438769591,'Pisces'],
  [-1438769591,-1438552736,'Aries'],
  [-1438552736,-1438334310,'Taurus'],
  [-1438334310,-1438117396,'Gemini'],
  [-1438117396,-1437906068,'Cancer'],
  [-1437906068,-1437705317,'Leo'],
  [-1437705317,-1437518000,'Virgo'],
  [-1437518000,-1437342253,'Libra'],
  [-1437342253,-1437172120,'Scorpio'],
  [-1437172120,-1436999913,'Sagittarius'],
  [-1436999913,-1436818400,'Capricorn'],
  [-1436818400,-1436623167,'Aquarius'],
  [-1436623167,-1436414723,'Pisces'],
  [-1436414723,-1436198157,'Aries'],
  [-1436198157,-1435979727,'Taurus'],
  [-1435979727,-1435763811,'Gemini'],
  [-1435763811,-1435553271,'Cancer'],
  [-1435553271,-1435350847,'Leo'],
  [-1435350847,-1435158854,'Virgo'],
  [-1435158854,-1434977265,'Libra'],
  [-1434977265,-1434802675,'Scorpio'],
  [-1434802675,-1434629167,'Sagittarius'],
  [-1434629167,-1434449993,'Capricorn'],
  [-1434449993,-1434259513,'Aquarius'],
  [-1434259513,-1434055521,'Pisces'],
  [-1434055521,-1433840933,'Aries'],
  [-1433840933,-1433622661,'Taurus'],
  [-1433622661,-1433407433,'Gemini'],
  [-1433407433,-1433198974,'Cancer'],
  [-1433198974,-1432998423,'Leo'],
  [-1432998423,-1432805771,'Virgo'],
  [-1432805771,-1432620348,'Libra'],
  [-1432620348,-1432440293,'Scorpio'],
  [-1432440293,-1432262168,'Sagittarius'],
  [-1432262168,-1432081232,'Capricorn'],
  [-1432081232,-1431892418,'Aquarius'],
  [-1431892418,-1431692080,'Pisces'],
  [-1431692080,-1431480346,'Aries'],
  [-1431480346,-1431262550,'Taurus'],
  [-1431262550,-1431046929,'Gemini'],
  [-1431046929,-1430839623,'Cancer'],
  [-1430839623,-1430642183,'Leo'],
  [-1430642183,-1430452703,'Virgo'],
  [-1430452703,-1430268097,'Libra'],
  [-1430268097,-1430085544,'Scorpio'],
  [-1430085544,-1429902745,'Sagittarius'],
  [-1429902745,-1429717402,'Capricorn'],
  [-1429717402,-1429526641,'Aquarius'],
  [-1429526641,-1429327317,'Pisces'],
  [-1429327317,-1429117808,'Aries'],
  [-1429117808,-1428900730,'Taurus'],
  [-1428900730,-1428683681,'Gemini'],
  [-1428683681,-1428475138,'Cancer'],
  [-1428475138,-1428278992,'Leo'],
  [-1428278992,-1428093392,'Virgo'],
  [-1428093392,-1427913277,'Libra'],
  [-1427913277,-1427733299,'Scorpio'],
  [-1427733299,-1427549708,'Sagittarius'],
  [-1427549708,-1427360878,'Capricorn'],
  [-1427360878,-1427166309,'Aquarius'],
  [-1427166309,-1426965132,'Pisces'],
  [-1426965132,-1426756055,'Aries'],
  [-1426756055,-1426539617,'Taurus'],
  [-1426539617,-1426320975,'Gemini'],
  [-1426320975,-1426109018,'Cancer'],
  [-1426109018,-1425910556,'Leo'],
  [-1425910556,-1425725922,'Virgo'],
  [-1425725922,-1425549993,'Libra'],
  [-1425549993,-1425375606,'Scorpio'],
  [-1425375606,-1425196367,'Sagittarius'],
  [-1425196367,-1425008615,'Capricorn'],
  [-1425008615,-1424812016,'Aquarius'],
  [-1424812016,-1424607948,'Pisces'],
  [-1424607948,-1424397426,'Aries'],
  [-1424397426,-1424181085,'Taurus'],
  [-1424181085,-1423961718,'Gemini'],
  [-1423961718,-1423746200,'Cancer'],
  [-1423746200,-1423542580,'Leo'],
  [-1423542580,-1423354381,'Virgo'],
  [-1423354381,-1423178569,'Libra'],
  [-1423178569,-1423008092,'Scorpio'],
  [-1423008092,-1422835063,'Sagittarius'],
  [-1422835063,-1422653081,'Capricorn'],
  [-1422653081,-1422459226,'Aquarius'],
  [-1422459226,-1422254549,'Pisces'],
  [-1422254549,-1422042212,'Aries'],
  [-1422042212,-1421825178,'Taurus'],
  [-1421825178,-1421606053,'Gemini'],
  [-1421606053,-1421389147,'Cancer'],
  [-1421389147,-1421180852,'Leo'],
  [-1421180852,-1420986311,'Virgo'],
  [-1420986311,-1420805696,'Libra'],
  [-1420805696,-1420634124,'Scorpio'],
  [-1420634124,-1420464203,'Sagittarius'],
  [-1420464203,-1420288385,'Capricorn'],
  [-1420288385,-1420100951,'Aquarius'],
  [-1420100951,-1419899977,'Pisces'],
  [-1419899977,-1419687978,'Aries'],
  [-1419687978,-1419470135,'Taurus'],
  [-1419470135,-1419251352,'Gemini'],
  [-1419251352,-1419035434,'Cancer'],
  [-1419035434,-1418826080,'Leo'],
  [-1418826080,-1418626894,'Virgo'],
  [-1418626894,-1418439570,'Libra'],
  [-1418439570,-1418262287,'Scorpio'],
  [-1418262287,-1418090060,'Sagittarius'],
  [-1418090060,-1417916264,'Capricorn'],
  [-1417916264,-1417734269,'Aquarius'],
  [-1417734269,-1417539335,'Pisces'],
  [-1417539335,-1417330873,'Aries'],
  [-1417330873,-1417113516,'Taurus'],
  [-1417113516,-1416894636,'Gemini'],
  [-1416894636,-1416680164,'Cancer'],
  [-1416680164,-1416472979,'Leo'],
  [-1416472979,-1416273932,'Virgo'],
  [-1416273932,-1416083084,'Libra'],
  [-1416083084,-1415899669,'Scorpio'],
  [-1415899669,-1415721485,'Sagittarius'],
  [-1415721485,-1415544548,'Capricorn'],
  [-1415544548,-1415363471,'Aquarius'],
  [-1415363471,-1415172723,'Pisces'],
  [-1415172723,-1414968921,'Aries'],
  [-1414968921,-1414753792,'Taurus'],
  [-1414753792,-1414534754,'Gemini'],
  [-1414534754,-1414320468,'Cancer'],
  [-1414320468,-1414115611,'Leo'],
  [-1414115611,-1413919958,'Virgo'],
  [-1413919958,-1413730888,'Libra'],
  [-1413730888,-1413545790,'Scorpio'],
  [-1413545790,-1413362864,'Sagittarius'],
  [-1413362864,-1413180493,'Capricorn'],
  [-1413180493,-1412995997,'Aquarius'],
  [-1412995997,-1412805261,'Pisces'],
  [-1412805261,-1412604150,'Aries'],
  [-1412604150,-1412391637,'Taurus'],
  [-1412391637,-1412172800,'Gemini'],
  [-1412172800,-1411957215,'Cancer'],
  [-1411957215,-1411752401,'Leo'],
  [-1411752401,-1411559515,'Virgo'],
  [-1411559515,-1411374783,'Libra'],
  [-1411374783,-1411193090,'Scorpio'],
  [-1411193090,-1411010529,'Sagittarius'],
  [-1411010529,-1410825231,'Capricorn'],
  [-1410825231,-1410636386,'Aquarius'],
  [-1410636386,-1410442482,'Pisces'],
  [-1410442482,-1410240848,'Aries'],
  [-1410240848,-1410029603,'Taurus'],
  [-1410029603,-1409811159,'Gemini'],
  [-1409811159,-1409593616,'Cancer'],
  [-1409593616,-1409386234,'Leo'],
  [-1409386234,-1409192918,'Virgo'],
  [-1409192918,-1409010928,'Libra'],
  [-1409010928,-1408834114,'Scorpio'],
  [-1408834114,-1408656266,'Sagittarius'],
  [-1408656266,-1408473158,'Capricorn'],
  [-1408473158,-1408283175,'Aquarius'],
  [-1408283175,-1408086222,'Pisces'],
  [-1408086222,-1407882080,'Aries'],
  [-1407882080,-1407670217,'Taurus'],
  [-1407670217,-1407451918,'Gemini'],
  [-1407451918,-1407232822,'Cancer'],
  [-1407232822,-1407021653,'Leo'],
  [-1407021653,-1406824627,'Virgo'],
  [-1406824627,-1406641536,'Libra'],
  [-1406641536,-1406467112,'Scorpio'],
  [-1406467112,-1406294318,'Sagittarius'],
  [-1406294318,-1406116776,'Capricorn'],
  [-1406116776,-1405930324,'Aquarius'],
  [-1405930324,-1405733658,'Pisces'],
  [-1405733658,-1405527688,'Aries'],
  [-1405527688,-1405314239,'Taurus'],
  [-1405314239,-1405095630,'Gemini'],
  [-1405095630,-1404876009,'Cancer'],
  [-1404876009,-1404661929,'Leo'],
  [-1404661929,-1404459849,'Virgo'],
  [-1404459849,-1404272129,'Libra'],
  [-1404272129,-1404095872,'Scorpio'],
  [-1404095872,-1403924949,'Sagittarius'],
  [-1403924949,-1403752341,'Capricorn'],
  [-1403752341,-1403571809,'Aquarius'],
  [-1403571809,-1403379379,'Pisces'],
  [-1403379379,-1403174542,'Aries'],
  [-1403174542,-1402960246,'Taurus'],
  [-1402960246,-1402741105,'Gemini'],
  [-1402741105,-1402521824,'Cancer'],
  [-1402521824,-1402307106,'Leo'],
  [-1402307106,-1402101510,'Virgo'],
  [-1402101510,-1401908091,'Libra'],
  [-1401908091,-1401726548,'Scorpio'],
  [-1401726548,-1401553110,'Sagittarius'],
  [-1401553110,-1401381784,'Capricorn'],
  [-1401381784,-1401205801,'Aquarius'],
  [-1401205801,-1401019118,'Pisces'],
  [-1401019118,-1400818475,'Aries'],
  [-1400818475,-1400605467,'Taurus'],
  [-1400605467,-1400386154,'Gemini'],
  [-1400386154,-1400167419,'Cancer'],
  [-1400167419,-1399953987,'Leo'],
  [-1399953987,-1399748249,'Virgo'],
  [-1399748249,-1399551526,'Libra'],
  [-1399551526,-1399364263,'Scorpio'],
  [-1399364263,-1399185202,'Sagittarius'],
  [-1399185202,-1399010794,'Capricorn'],
  [-1399010794,-1398835448,'Aquarius'],
  [-1398835448,-1398652656,'Pisces'],
  [-1398652656,-1398457026,'Aries'],
  [-1398457026,-1398247360,'Taurus'],
  [-1398247360,-1398028807,'Gemini'],
  [-1398028807,-1397810224,'Cancer'],
  [-1397810224,-1397598327,'Leo'],
  [-1397598327,-1397395025,'Virgo'],
  [-1397395025,-1397199263,'Libra'],
  [-1397199263,-1397009701,'Scorpio'],
  [-1397009701,-1396825540,'Sagittarius'],
  [-1396825540,-1396645565,'Capricorn'],
  [-1396645565,-1396466725,'Aquarius'],
  [-1396466725,-1396283889,'Pisces'],
  [-1396283889,-1396091245,'Aries'],
  [-1396091245,-1395885280,'Taurus'],
  [-1395885280,-1395668448,'Gemini'],
  [-1395668448,-1395449501,'Cancer'],
  [-1395449501,-1395237667,'Leo'],
  [-1395237667,-1395036621,'Virgo'],
  [-1395036621,-1394844498,'Libra'],
  [-1394844498,-1394657490,'Scorpio'],
  [-1394657490,-1394472716,'Sagittarius'],
  [-1394472716,-1394288898,'Capricorn'],
  [-1394288898,-1394105005,'Aquarius'],
  [-1394105005,-1393918517,'Pisces'],
  [-1393918517,-1393725237,'Aries'],
  [-1393725237,-1393521200,'Taurus'],
  [-1393521200,-1393306272,'Gemini'],
  [-1393306272,-1393086869,'Cancer'],
  [-1393086869,-1392873100,'Leo'],
  [-1392873100,-1392671557,'Virgo'],
  [-1392671557,-1392481947,'Libra'],
  [-1392481947,-1392299602,'Scorpio'],
  [-1392299602,-1392119170,'Sagittarius'],
  [-1392119170,-1391936864,'Capricorn'],
  [-1391936864,-1391750912,'Aquarius'],
  [-1391750912,-1391560358,'Pisces'],
  [-1391560358,-1391363667,'Aries'],
  [-1391363667,-1391158701,'Taurus'],
  [-1391158701,-1390944684,'Gemini'],
  [-1390944684,-1390725220,'Cancer'],
  [-1390725220,-1390508683,'Leo'],
  [-1390508683,-1390303450,'Virgo'],
  [-1390303450,-1390112349,'Libra'],
  [-1390112349,-1389932222,'Scorpio'],
  [-1389932222,-1389757023,'Sagittarius'],
  [-1389757023,-1389580583,'Capricorn'],
  [-1389580583,-1389398260,'Aquarius'],
  [-1389398260,-1389207641,'Pisces'],
  [-1389207641,-1389008227,'Aries'],
  [-1389008227,-1388800576,'Taurus'],
  [-1388800576,-1388585811,'Gemini'],
  [-1388585811,-1388366571,'Cancer'],
  [-1388366571,-1388148352,'Leo'],
  [-1388148352,-1387938467,'Virgo'],
  [-1387938467,-1387742102,'Libra'],
  [-1387742102,-1387559273,'Scorpio'],
  [-1387559273,-1387385516,'Sagittarius'],
  [-1387385516,-1387214222,'Capricorn'],
  [-1387214222,-1387038582,'Aquarius'],
  [-1387038582,-1386853142,'Pisces'],
  [-1386853142,-1386655342,'Aries'],
  [-1386655342,-1386446352,'Taurus'],
  [-1386446352,-1386230003,'Gemini'],
  [-1386230003,-1386010682,'Cancer'],
  [-1386010682,-1385792581,'Leo'],
  [-1385792581,-1385580232,'Virgo'],
  [-1385580232,-1385378249,'Libra'],
  [-1385378249,-1385189133,'Scorpio'],
  [-1385189133,-1385011569,'Sagittarius'],
  [-1385011569,-1384840657,'Capricorn'],
  [-1384840657,-1384669430,'Aquarius'],
  [-1384669430,-1384490581,'Pisces'],
  [-1384490581,-1384298510,'Aries'],
  [-1384298510,-1384091982,'Taurus'],
  [-1384091982,-1383875312,'Gemini'],
  [-1383875312,-1383655567,'Cancer'],
  [-1383655567,-1383438364,'Leo'],
  [-1383438364,-1383226664,'Virgo'],
  [-1383226664,-1383022490,'Libra'],
  [-1383022490,-1382827892,'Scorpio'],
  [-1382827892,-1382643800,'Sagittarius'],
  [-1382643800,-1382468342,'Capricorn'],
  [-1382468342,-1382296396,'Aquarius'],
  [-1382296396,-1382120820,'Pisces'],
  [-1382120820,-1381934465,'Aries'],
  [-1381934465,-1381733098,'Taurus'],
  [-1381733098,-1381518656,'Gemini'],
  [-1381518656,-1381298952,'Cancer'],
  [-1381298952,-1381082226,'Leo'],
  [-1381082226,-1380872459,'Virgo'],
  [-1380872459,-1380669948,'Libra'],
  [-1380669948,-1380474301,'Scorpio'],
  [-1380474301,-1380285787,'Sagittarius'],
  [-1380285787,-1380104324,'Capricorn'],
  [-1380104324,-1379927577,'Aquarius'],
  [-1379927577,-1379750400,'Pisces'],
  [-1379750400,-1379566124,'Aries'],
  [-1379566124,-1379369101,'Taurus'],
  [-1379369101,-1379158309,'Gemini'],
  [-1379158309,-1378939646,'Cancer'],
  [-1378939646,-1378722669,'Leo'],
  [-1378722669,-1378513883,'Virgo'],
  [-1378513883,-1378314196,'Libra'],
  [-1378314196,-1378121441,'Scorpio'],
  [-1378121441,-1377933465,'Sagittarius'],
  [-1377933465,-1377749178,'Capricorn'],
  [-1377749178,-1377567491,'Aquarius'],
  [-1377567491,-1377385745,'Pisces'],
  [-1377385745,-1377199405,'Aries'],
  [-1377199405,-1377003477,'Taurus'],
  [-1377003477,-1376795418,'Gemini'],
  [-1376795418,-1376578302,'Cancer'],
  [-1376578302,-1376360627,'Leo'],
  [-1376360627,-1376150883,'Virgo'],
  [-1376150883,-1375952314,'Libra'],
  [-1375952314,-1375763038,'Scorpio'],
  [-1375763038,-1375579129,'Sagittarius'],
  [-1375579129,-1375397028,'Capricorn'],
  [-1375397028,-1375214274,'Aquarius'],
  [-1375214274,-1375028914,'Pisces'],
  [-1375028914,-1374838635,'Aries'],
  [-1374838635,-1374640663,'Taurus'],
  [-1374640663,-1374433022,'Gemini'],
  [-1374433022,-1374216986,'Cancer'],
  [-1374216986,-1373998578,'Leo'],
  [-1373998578,-1373786300,'Virgo'],
  [-1373786300,-1373585908,'Libra'],
  [-1373585908,-1373397609,'Scorpio'],
  [-1373397609,-1373217560,'Sagittarius'],
  [-1373217560,-1373040461,'Capricorn'],
  [-1373040461,-1372861353,'Aquarius'],
  [-1372861353,-1372676569,'Pisces'],
  [-1372676569,-1372484033,'Aries'],
  [-1372484033,-1372283035,'Taurus'],
  [-1372283035,-1372073794,'Gemini'],
  [-1372073794,-1371857788,'Cancer'],
  [-1371857788,-1371638948,'Leo'],
  [-1371638948,-1371423875,'Virgo'],
  [-1371423875,-1371219345,'Libra'],
  [-1371219345,-1371028354,'Scorpio'],
  [-1371028354,-1370848937,'Sagittarius'],
  [-1370848937,-1370675770,'Capricorn'],
  [-1370675770,-1370502250,'Aquarius'],
  [-1370502250,-1370322227,'Pisces'],
  [-1370322227,-1370131595,'Aries'],
  [-1370131595,-1369929556,'Taurus'],
  [-1369929556,-1369718366,'Gemini'],
  [-1369718366,-1369501506,'Cancer'],
  [-1369501506,-1369282596,'Leo'],
  [-1369282596,-1369065963,'Virgo'],
  [-1369065963,-1368857128,'Libra'],
  [-1368857128,-1368660791,'Scorpio'],
  [-1368660791,-1368477866,'Sagittarius'],
  [-1368477866,-1368304780,'Capricorn'],
  [-1368304780,-1368134923,'Aquarius'],
  [-1368134923,-1367960685,'Pisces'],
  [-1367960685,-1367775467,'Aries'],
  [-1367775467,-1367576164,'Taurus'],
  [-1367576164,-1367364851,'Gemini'],
  [-1367364851,-1367147114,'Cancer'],
  [-1367147114,-1366928281,'Leo'],
  [-1366928281,-1366711863,'Virgo'],
  [-1366711863,-1366501027,'Libra'],
  [-1366501027,-1366299666,'Scorpio'],
  [-1366299666,-1366110656,'Sagittarius'],
  [-1366110656,-1365933302,'Capricorn'],
  [-1365933302,-1365762749,'Aquarius'],
  [-1365762749,-1365591577,'Pisces'],
  [-1365591577,-1365411933,'Aries'],
  [-1365411933,-1365218105,'Taurus'],
  [-1365218105,-1365009679,'Gemini'],
  [-1365009679,-1364792247,'Cancer'],
  [-1364792247,-1364573427,'Leo'],
  [-1364573427,-1364358151,'Virgo'],
  [-1364358151,-1364148335,'Libra'],
  [-1364148335,-1363945439,'Scorpio'],
  [-1363945439,-1363751586,'Sagittarius'],
  [-1363751586,-1363567939,'Capricorn'],
  [-1363567939,-1363392460,'Aquarius'],
  [-1363392460,-1363219675,'Pisces'],
  [-1363219675,-1363042266,'Aries'],
  [-1363042266,-1362853370,'Taurus'],
  [-1362853370,-1362649736,'Gemini'],
  [-1362649736,-1362434484,'Cancer'],
  [-1362434484,-1362215759,'Leo'],
  [-1362215759,-1362001076,'Virgo'],
  [-1362001076,-1361793505,'Libra'],
  [-1361793505,-1361592949,'Scorpio'],
  [-1361592949,-1361398927,'Sagittarius'],
  [-1361398927,-1361211533,'Capricorn'],
  [-1361211533,-1361030186,'Aquarius'],
  [-1361030186,-1360852110,'Pisces'],
  [-1360852110,-1360672271,'Aries'],
  [-1360672271,-1360484703,'Taurus'],
  [-1360484703,-1360284913,'Gemini'],
  [-1360284913,-1360072943,'Cancer'],
  [-1360072943,-1359854818,'Leo'],
  [-1359854818,-1359639387,'Virgo'],
  [-1359639387,-1359432566,'Libra'],
  [-1359432566,-1359235194,'Scorpio'],
  [-1359235194,-1359045073,'Sagittarius'],
  [-1359045073,-1358859495,'Capricorn'],
  [-1358859495,-1358676289,'Aquarius'],
  [-1358676289,-1358493483,'Pisces'],
  [-1358493483,-1358308545,'Aries'],
  [-1358308545,-1358118133,'Taurus'],
  [-1358118133,-1357918869,'Gemini'],
  [-1357918869,-1357709303,'Cancer'],
  [-1357709303,-1357492302,'Leo'],
  [-1357492302,-1357275324,'Virgo'],
  [-1357275324,-1357066467,'Libra'],
  [-1357066467,-1356869526,'Scorpio'],
  [-1356869526,-1356683091,'Sagittarius'],
  [-1356683091,-1356502745,'Capricorn'],
  [-1356502745,-1356323451,'Aquarius'],
  [-1356323451,-1356141101,'Pisces'],
  [-1356141101,-1355953177,'Aries'],
  [-1355953177,-1355758533,'Taurus'],
  [-1355758533,-1355556595,'Gemini'],
  [-1355556595,-1355347026,'Cancer'],
  [-1355347026,-1355130937,'Leo'],
  [-1355130937,-1354912804,'Virgo'],
  [-1354912804,-1354700250,'Libra'],
  [-1354700250,-1354499864,'Scorpio'],
  [-1354499864,-1354313140,'Sagittarius'],
  [-1354313140,-1354136349,'Capricorn'],
  [-1354136349,-1353962959,'Aquarius'],
  [-1353962959,-1353786162,'Pisces'],
  [-1353786162,-1353600862,'Aries'],
  [-1353600862,-1353405174,'Taurus'],
  [-1353405174,-1353200353,'Gemini'],
  [-1353200353,-1352988819,'Cancer'],
  [-1352988819,-1352772615,'Leo'],
  [-1352772615,-1352554269,'Virgo'],
  [-1352554269,-1352338823,'Libra'],
  [-1352338823,-1352133161,'Scorpio'],
  [-1352133161,-1351941804,'Sagittarius'],
  [-1351941804,-1351763754,'Capricorn'],
  [-1351763754,-1351593175,'Aquarius'],
  [-1351593175,-1351422172,'Pisces'],
  [-1351422172,-1351243245,'Aries'],
  [-1351243245,-1351051647,'Taurus'],
  [-1351051647,-1350847357,'Gemini'],
  [-1350847357,-1350634328,'Cancer'],
  [-1350634328,-1350417175,'Leo'],
  [-1350417175,-1350199071,'Virgo'],
  [-1350199071,-1349982999,'Libra'],
  [-1349982999,-1349773699,'Scorpio'],
  [-1349773699,-1349576358,'Sagittarius'],
  [-1349576358,-1349392908,'Capricorn'],
  [-1349392908,-1349220054,'Aquarius'],
  [-1349220054,-1349050783,'Pisces'],
  [-1349050783,-1348876966,'Aries'],
  [-1348876966,-1348691690,'Taurus'],
  [-1348691690,-1348491930,'Gemini'],
  [-1348491930,-1348280181,'Cancer'],
  [-1348280181,-1348062541,'Leo'],
  [-1348062541,-1347844560,'Virgo'],
  [-1347844560,-1347629491,'Libra'],
  [-1347629491,-1347419948,'Scorpio'],
  [-1347419948,-1347219229,'Sagittarius'],
  [-1347219229,-1347029928,'Capricorn'],
  [-1347029928,-1346851385,'Aquarius'],
  [-1346851385,-1346679023,'Pisces'],
  [-1346679023,-1346505895,'Aries'],
  [-1346505895,-1346324781,'Taurus'],
  [-1346324781,-1346130547,'Gemini'],
  [-1346130547,-1345922693,'Cancer'],
  [-1345922693,-1345706120,'Leo'],
  [-1345706120,-1345488141,'Virgo'],
  [-1345488141,-1345274161,'Libra'],
  [-1345274161,-1345066647,'Scorpio'],
  [-1345066647,-1344866668,'Sagittarius'],
  [-1344866668,-1344674975,'Capricorn'],
  [-1344674975,-1344491348,'Aquarius'],
  [-1344491348,-1344313471,'Pisces'],
  [-1344313471,-1344136822,'Aries'],
  [-1344136822,-1343955633,'Taurus'],
  [-1343955633,-1343764538,'Gemini'],
  [-1343764538,-1343560824,'Cancer'],
  [-1343560824,-1343346609,'Leo'],
  [-1343346609,-1343128742,'Virgo'],
  [-1343128742,-1342914837,'Libra'],
  [-1342914837,-1342709204,'Scorpio'],
  [-1342709204,-1342512345,'Sagittarius'],
  [-1342512345,-1342322673,'Capricorn'],
  [-1342322673,-1342138065,'Aquarius'],
  [-1342138065,-1341956283,'Pisces'],
  [-1341956283,-1341774698,'Aries'],
  [-1341774698,-1341589997,'Taurus'],
  [-1341589997,-1341398386,'Gemini'],
  [-1341398386,-1341196759,'Cancer'],
  [-1341196759,-1340984867,'Leo'],
  [-1340984867,-1340767273,'Virgo'],
  [-1340767273,-1340552161,'Libra'],
  [-1340552161,-1340346407,'Scorpio'],
  [-1340346407,-1340151970,'Sagittarius'],
  [-1340151970,-1339966362,'Capricorn'],
  [-1339966362,-1339785120,'Aquarius'],
  [-1339785120,-1339603965,'Pisces'],
  [-1339603965,-1339419892,'Aries'],
  [-1339419892,-1339231157,'Taurus'],
  [-1339231157,-1339036425,'Gemini'],
  [-1339036425,-1338834110,'Cancer'],
  [-1338834110,-1338623256,'Leo'],
  [-1338623256,-1338405956,'Virgo'],
  [-1338405956,-1338188899,'Libra'],
  [-1338188899,-1337980554,'Scorpio'],
  [-1337980554,-1337785583,'Sagittarius'],
  [-1337785583,-1337602583,'Capricorn'],
  [-1337602583,-1337426077,'Aquarius'],
  [-1337426077,-1337249539,'Pisces'],
  [-1337249539,-1337067705,'Aries'],
  [-1337067705,-1336877976,'Taurus'],
  [-1336877976,-1336680320,'Gemini'],
  [-1336680320,-1336475565,'Cancer'],
  [-1336475565,-1336264093,'Leo'],
  [-1336264093,-1336046895,'Virgo'],
  [-1336046895,-1335828219,'Libra'],
  [-1335828219,-1335615945,'Scorpio'],
  [-1335615945,-1335417079,'Sagittarius'],
  [-1335417079,-1335232880,'Capricorn'],
  [-1335232880,-1335058750,'Aquarius'],
  [-1335058750,-1334887279,'Pisces'],
  [-1334887279,-1334711083,'Aries'],
  [-1334711083,-1334525011,'Taurus'],
  [-1334525011,-1334327740,'Gemini'],
  [-1334327740,-1334121207,'Cancer'],
  [-1334121207,-1333908172,'Leo'],
  [-1333908172,-1333690713,'Virgo'],
  [-1333690713,-1333471557,'Libra'],
  [-1333471557,-1333256281,'Scorpio'],
  [-1333256281,-1333052018,'Sagittarius'],
  [-1333052018,-1332862755,'Capricorn'],
  [-1332862755,-1332686489,'Aquarius'],
  [-1332686489,-1332516757,'Pisces'],
  [-1332516757,-1332345581,'Aries'],
  [-1332345581,-1332165773,'Taurus'],
  [-1332165773,-1331973138,'Gemini'],
  [-1331973138,-1331767981,'Cancer'],
  [-1331767981,-1331554125,'Leo'],
  [-1331554125,-1331336101,'Virgo'],
  [-1331336101,-1331117415,'Libra'],
  [-1331117415,-1330901737,'Scorpio'],
  [-1330901737,-1330693988,'Sagittarius'],
  [-1330693988,-1330498594,'Capricorn'],
  [-1330498594,-1330316330,'Aquarius'],
  [-1330316330,-1330143370,'Pisces'],
  [-1330143370,-1329972998,'Aries'],
  [-1329972998,-1329797763,'Taurus'],
  [-1329797763,-1329611418,'Gemini'],
  [-1329611418,-1329411122,'Cancer'],
  [-1329411122,-1329198917,'Leo'],
  [-1329198917,-1328980649,'Virgo'],
  [-1328980649,-1328762416,'Libra'],
  [-1328762416,-1328548326,'Scorpio'],
  [-1328548326,-1328341064,'Sagittarius'],
  [-1328341064,-1328142778,'Capricorn'],
  [-1328142778,-1327954552,'Aquarius'],
  [-1327954552,-1327775120,'Pisces'],
  [-1327775120,-1327600563,'Aries'],
  [-1327600563,-1327425118,'Taurus'],
  [-1327425118,-1327242509,'Gemini'],
  [-1327242509,-1327047757,'Cancer'],
  [-1327047757,-1326839615,'Leo'],
  [-1326839615,-1326622360,'Virgo'],
  [-1326622360,-1326403962,'Libra'],
  [-1326403962,-1326191176,'Scorpio'],
  [-1326191176,-1325986795,'Sagittarius'],
  [-1325986795,-1325790513,'Capricorn'],
  [-1325790513,-1325600975,'Aquarius'],
  [-1325600975,-1325416727,'Pisces'],
  [-1325416727,-1325235969,'Aries'],
  [-1325235969,-1325055858,'Taurus'],
  [-1325055858,-1324872168,'Gemini'],
  [-1324872168,-1324680015,'Cancer'],
  [-1324680015,-1324475922,'Leo'],
  [-1324475922,-1324260940,'Virgo'],
  [-1324260940,-1324042131,'Libra'],
  [-1324042131,-1323828742,'Scorpio'],
  [-1323828742,-1323626107,'Sagittarius'],
  [-1323626107,-1323433766,'Capricorn'],
  [-1323433766,-1323247933,'Aquarius'],
  [-1323247933,-1323064548,'Pisces'],
  [-1323064548,-1322880925,'Aries'],
  [-1322880925,-1322695714,'Taurus'],
  [-1322695714,-1322507538,'Gemini'],
  [-1322507538,-1322313764,'Cancer'],
  [-1322313764,-1322111078,'Leo'],
  [-1322111078,-1321898215,'Virgo'],
  [-1321898215,-1321679344,'Libra'],
  [-1321679344,-1321463738,'Scorpio'],
  [-1321463738,-1321259660,'Sagittarius'],
  [-1321259660,-1321068944,'Capricorn'],
  [-1321068944,-1320887558,'Aquarius'],
  [-1320887558,-1320709274,'Pisces'],
  [-1320709274,-1320528693,'Aries'],
  [-1320528693,-1320342889,'Taurus'],
  [-1320342889,-1320151274,'Gemini'],
  [-1320151274,-1319953793,'Cancer'],
  [-1319953793,-1319749434,'Leo'],
  [-1319749434,-1319537053,'Virgo'],
  [-1319537053,-1319318433,'Libra'],
  [-1319318433,-1319100538,'Scorpio'],
  [-1319100538,-1318892547,'Sagittarius'],
  [-1318892547,-1318699366,'Capricorn'],
  [-1318699366,-1318518985,'Aquarius'],
  [-1318518985,-1318345049,'Pisces'],
  [-1318345049,-1318170361,'Aries'],
  [-1318170361,-1317989257,'Taurus'],
  [-1317989257,-1317799041,'Gemini'],
  [-1317799041,-1317599833,'Cancer'],
  [-1317599833,-1317392896,'Leo'],
  [-1317392896,-1317179306,'Virgo'],
  [-1317179306,-1316960735,'Libra'],
  [-1316960735,-1316741747,'Scorpio'],
  [-1316741747,-1316529875,'Sagittarius'],
  [-1316529875,-1316331547,'Capricorn'],
  [-1316331547,-1316147729,'Aquarius'],
  [-1316147729,-1315973933,'Pisces'],
  [-1315973933,-1315803076,'Aries'],
  [-1315803076,-1315628022,'Taurus'],
  [-1315628022,-1315443366,'Gemini'],
  [-1315443366,-1315246813,'Cancer'],
  [-1315246813,-1315039439,'Leo'],
  [-1315039439,-1314824457,'Virgo'],
  [-1314824457,-1314605526,'Libra'],
  [-1314605526,-1314386709,'Scorpio'],
  [-1314386709,-1314173161,'Sagittarius'],
  [-1314173161,-1313970213,'Capricorn'],
  [-1313970213,-1313780596,'Aquarius'],
  [-1313780596,-1313602619,'Pisces'],
  [-1313602619,-1313431066,'Aries'],
  [-1313431066,-1313259147,'Taurus'],
  [-1313259147,-1313080177,'Gemini'],
  [-1313080177,-1312889199,'Cancer'],
  [-1312889199,-1312684792,'Leo'],
  [-1312684792,-1312470016,'Virgo'],
  [-1312470016,-1312250727,'Libra'],
  [-1312250727,-1312032596,'Scorpio'],
  [-1312032596,-1311819821,'Sagittarius'],
  [-1311819821,-1311615376,'Capricorn'],
  [-1311615376,-1311421207,'Aquarius'],
  [-1311421207,-1311237332,'Pisces'],
  [-1311237332,-1311061185,'Aries'],
  [-1311061185,-1310887919,'Taurus'],
  [-1310887919,-1310711340,'Gemini'],
  [-1310711340,-1310525277,'Cancer'],
  [-1310525277,-1310325678,'Leo'],
  [-1310325678,-1310113255,'Virgo'],
  [-1310113255,-1309894196,'Libra'],
  [-1309894196,-1309676493,'Scorpio'],
  [-1309676493,-1309465487,'Sagittarius'],
  [-1309465487,-1309262755,'Capricorn'],
  [-1309262755,-1309067915,'Aquarius'],
  [-1309067915,-1308880219,'Pisces'],
  [-1308880219,-1308698561,'Aries'],
  [-1308698561,-1308520630,'Taurus'],
  [-1308520630,-1308342254,'Gemini'],
  [-1308342254,-1308157831,'Cancer'],
  [-1308157831,-1307962059,'Leo'],
  [-1307962059,-1307752996,'Virgo'],
  [-1307752996,-1307534951,'Libra'],
  [-1307534951,-1307317028,'Scorpio'],
  [-1307317028,-1307106956,'Sagittarius'],
  [-1307106956,-1306906959,'Capricorn'],
  [-1306906959,-1306714975,'Aquarius'],
  [-1306714975,-1306527923,'Pisces'],
  [-1306527923,-1306343687,'Aries'],
  [-1306343687,-1306161051,'Taurus'],
  [-1306161051,-1305978244,'Gemini'],
  [-1305978244,-1305791766,'Cancer'],
  [-1305791766,-1305596925,'Leo'],
  [-1305596925,-1305390352,'Virgo'],
  [-1305390352,-1305173696,'Libra'],
  [-1305173696,-1304954996,'Scorpio'],
  [-1304954996,-1304743916,'Sagittarius'],
  [-1304743916,-1304545015,'Capricorn'],
  [-1304545015,-1304356497,'Aquarius'],
  [-1304356497,-1304173525,'Pisces'],
  [-1304173525,-1303991552,'Aries'],
  [-1303991552,-1303807936,'Taurus'],
  [-1303807936,-1303621565,'Gemini'],
  [-1303621565,-1303431169,'Cancer'],
  [-1303431169,-1303234259,'Leo'],
  [-1303234259,-1303028038,'Virgo'],
  [-1303028038,-1302812395,'Libra'],
  [-1302812395,-1302592860,'Scorpio'],
  [-1302592860,-1302379031,'Sagittarius'],
  [-1302379031,-1302178073,'Capricorn'],
  [-1302178073,-1301990402,'Aquarius'],
  [-1301990402,-1301811307,'Pisces'],
  [-1301811307,-1301634551,'Aries'],
  [-1301634551,-1301454898,'Taurus'],
  [-1301454898,-1301269315,'Gemini'],
  [-1301269315,-1301076704,'Cancer'],
  [-1301076704,-1300876658,'Leo'],
  [-1300876658,-1300668696,'Virgo'],
  [-1300668696,-1300453073,'Libra'],
  [-1300453073,-1300233172,'Scorpio'],
  [-1300233172,-1300016416,'Sagittarius'],
  [-1300016416,-1299810842,'Capricorn'],
  [-1299810842,-1299619878,'Aquarius'],
  [-1299619878,-1299440969,'Pisces'],
  [-1299440969,-1299268092,'Aries'],
  [-1299268092,-1299094467,'Taurus'],
  [-1299094467,-1298914329,'Gemini'],
  [-1298914329,-1298724169,'Cancer'],
  [-1298724169,-1298523260,'Leo'],
  [-1298523260,-1298313161,'Virgo'],
  [-1298313161,-1298096517,'Libra'],
  [-1298096517,-1297876709,'Scorpio'],
  [-1297876709,-1297658687,'Sagittarius'],
  [-1297658687,-1297448703,'Capricorn'],
  [-1297448703,-1297251669,'Aquarius'],
  [-1297251669,-1297068209,'Pisces'],
  [-1297068209,-1296894546,'Aries'],
  [-1296894546,-1296724323,'Taurus'],
  [-1296724323,-1296550435,'Gemini'],
  [-1296550435,-1296366610,'Cancer'],
  [-1296366610,-1296169304,'Leo'],
  [-1296169304,-1295959399,'Virgo'],
  [-1295959399,-1295741684,'Libra'],
  [-1295741684,-1295521888,'Scorpio'],
  [-1295521888,-1295304548,'Sagittarius'],
  [-1295304548,-1295093239,'Capricorn'],
  [-1295093239,-1294891347,'Aquarius'],
  [-1294891347,-1294701093,'Pisces'],
  [-1294701093,-1294521879,'Aries'],
  [-1294521879,-1294349767,'Taurus'],
  [-1294349767,-1294178341,'Gemini'],
  [-1294178341,-1294000260,'Cancer'],
  [-1294000260,-1293809276,'Leo'],
  [-1293809276,-1293603200,'Virgo'],
  [-1293603200,-1293386110,'Libra'],
  [-1293386110,-1293166102,'Scorpio'],
  [-1293166102,-1292949897,'Sagittarius'],
  [-1292949897,-1292740313,'Capricorn'],
  [-1292740313,-1292538005,'Aquarius'],
  [-1292538005,-1292343639,'Pisces'],
  [-1292343639,-1292157866,'Aries'],
  [-1292157866,-1291979743,'Taurus'],
  [-1291979743,-1291805429,'Gemini'],
  [-1291805429,-1291628605,'Cancer'],
  [-1291628605,-1291442248,'Leo'],
  [-1291442248,-1291241495,'Virgo'],
  [-1291241495,-1291027341,'Libra'],
  [-1291027341,-1290807573,'Scorpio'],
  [-1290807573,-1290591545,'Sagittarius'],
  [-1290591545,-1290384014,'Capricorn'],
  [-1290384014,-1290184670,'Aquarius'],
  [-1290184670,-1289991506,'Pisces'],
  [-1289991506,-1289803337,'Aries'],
  [-1289803337,-1289619835,'Taurus'],
  [-1289619835,-1289439747,'Gemini'],
  [-1289439747,-1289259414,'Cancer'],
  [-1289259414,-1289073197,'Leo'],
  [-1289073197,-1288875642,'Virgo'],
  [-1288875642,-1288665020,'Libra'],
  [-1288665020,-1288446372,'Scorpio'],
  [-1288446372,-1288229505,'Sagittarius'],
  [-1288229505,-1288022011,'Capricorn'],
  [-1288022011,-1287825221,'Aquarius'],
  [-1287825221,-1287636130,'Pisces'],
  [-1287636130,-1287450968,'Aries'],
  [-1287450968,-1287267229,'Taurus'],
  [-1287267229,-1287083563,'Gemini'],
  [-1287083563,-1286898342,'Cancer'],
  [-1286898342,-1286708581,'Leo'],
  [-1286708581,-1286510460,'Virgo'],
  [-1286510460,-1286301616,'Libra'],
  [-1286301616,-1286084330,'Scorpio'],
  [-1286084330,-1285866364,'Sagittarius'],
  [-1285866364,-1285656637,'Capricorn'],
  [-1285656637,-1285459357,'Aquarius'],
  [-1285459357,-1285272890,'Pisces'],
  [-1285272890,-1285092536,'Aries'],
  [-1285092536,-1284913317,'Taurus'],
  [-1284913317,-1284731453,'Gemini'],
  [-1284731453,-1284544588,'Cancer'],
  [-1284544588,-1284351218,'Leo'],
  [-1284351218,-1284150109,'Virgo'],
  [-1284150109,-1283940529,'Libra'],
  [-1283940529,-1283723852,'Scorpio'],
  [-1283723852,-1283505177,'Sagittarius'],
  [-1283505177,-1283292305,'Capricorn'],
  [-1283292305,-1283091481,'Aquarius'],
  [-1283091481,-1282903837,'Pisces'],
  [-1282903837,-1282725853,'Aries'],
  [-1282725853,-1282551715,'Taurus'],
  [-1282551715,-1282375345,'Gemini'],
  [-1282375345,-1282191825,'Cancer'],
  [-1282191825,-1281998439,'Leo'],
  [-1281998439,-1281795069,'Virgo'],
  [-1281795069,-1281583471,'Libra'],
  [-1281583471,-1281366345,'Scorpio'],
  [-1281366345,-1281147503,'Sagittarius'],
  [-1281147503,-1280932343,'Capricorn'],
  [-1280932343,-1280726892,'Aquarius'],
  [-1280726892,-1280534702,'Pisces'],
  [-1280534702,-1280354866,'Aries'],
  [-1280354866,-1280182623,'Taurus'],
  [-1280182623,-1280011179,'Gemini'],
  [-1280011179,-1279833542,'Cancer'],
  [-1279833542,-1279644377,'Leo'],
  [-1279644377,-1279442059,'Virgo'],
  [-1279442059,-1279229364,'Libra'],
  [-1279229364,-1279011342,'Scorpio'],
  [-1279011342,-1278792647,'Sagittarius'],
  [-1278792647,-1278577036,'Capricorn'],
  [-1278577036,-1278368471,'Aquarius'],
  [-1278368471,-1278170873,'Pisces'],
  [-1278170873,-1277985859,'Aries'],
  [-1277985859,-1277811145,'Taurus'],
  [-1277811145,-1277640952,'Gemini'],
  [-1277640952,-1277467762,'Cancer'],
  [-1277467762,-1277284344,'Leo'],
  [-1277284344,-1277086386,'Virgo'],
  [-1277086386,-1276875133,'Libra'],
  [-1276875133,-1276656823,'Scorpio'],
  [-1276656823,-1276438302,'Sagittarius'],
  [-1276438302,-1276223667,'Capricorn'],
  [-1276223667,-1276014956,'Aquarius'],
  [-1276014956,-1275814264,'Pisces'],
  [-1275814264,-1275623736,'Aries'],
  [-1275623736,-1275443545,'Taurus'],
  [-1275443545,-1275270307,'Gemini'],
  [-1275270307,-1275097632,'Cancer'],
  [-1275097632,-1274917977,'Leo'],
  [-1274917977,-1274725147,'Virgo'],
  [-1274725147,-1274517624,'Libra'],
  [-1274517624,-1274300420,'Scorpio'],
  [-1274300420,-1274081980,'Sagittarius'],
  [-1274081980,-1273868457,'Capricorn'],
  [-1273868457,-1273661762,'Aquarius'],
  [-1273661762,-1273461847,'Pisces'],
  [-1273461847,-1273269023,'Aries'],
  [-1273269023,-1273083823,'Taurus'],
  [-1273083823,-1272905116,'Gemini'],
  [-1272905116,-1272728919,'Cancer'],
  [-1272728919,-1272549073,'Leo'],
  [-1272549073,-1272359196,'Virgo'],
  [-1272359196,-1272155688,'Libra'],
  [-1272155688,-1271940813,'Scorpio'],
  [-1271940813,-1271722460,'Sagittarius'],
  [-1271722460,-1271508962,'Capricorn'],
  [-1271508962,-1271304131,'Aquarius'],
  [-1271304131,-1271107413,'Pisces'],
  [-1271107413,-1270916789,'Aries'],
  [-1270916789,-1270730730,'Taurus'],
  [-1270730730,-1270548075,'Gemini'],
  [-1270548075,-1270366776,'Cancer'],
  [-1270366776,-1270183175,'Leo'],
  [-1270183175,-1269992572,'Virgo'],
  [-1269992572,-1269791112,'Libra'],
  [-1269791112,-1269578646,'Scorpio'],
  [-1269578646,-1269360571,'Sagittarius'],
  [-1269360571,-1269145634,'Capricorn'],
  [-1269145634,-1268940376,'Aquarius'],
  [-1268940376,-1268745976,'Pisces'],
  [-1268745976,-1268559682,'Aries'],
  [-1268559682,-1268377500,'Taurus'],
  [-1268377500,-1268195884,'Gemini'],
  [-1268195884,-1268012185,'Cancer'],
  [-1268012185,-1267824284,'Leo'],
  [-1267824284,-1267630105,'Virgo'],
  [-1267630105,-1267427675,'Libra'],
  [-1267427675,-1267216319,'Scorpio'],
  [-1267216319,-1266998726,'Sagittarius'],
  [-1266998726,-1266781700,'Capricorn'],
  [-1266781700,-1266573235,'Aquarius'],
  [-1266573235,-1266377599,'Pisces'],
  [-1266377599,-1266193638,'Aries'],
  [-1266193638,-1266016568,'Taurus'],
  [-1266016568,-1265840400,'Gemini'],
  [-1265840400,-1265659796,'Cancer'],
  [-1265659796,-1265471355,'Leo'],
  [-1265471355,-1265274102,'Virgo'],
  [-1265274102,-1265068763,'Libra'],
  [-1265068763,-1264856557,'Scorpio'],
  [-1264856557,-1264639289,'Sagittarius'],
  [-1264639289,-1264420929,'Capricorn'],
  [-1264420929,-1264208234,'Aquarius'],
  [-1264208234,-1264007717,'Pisces'],
  [-1264007717,-1263821457,'Aries'],
  [-1263821457,-1263646185,'Taurus'],
  [-1263646185,-1263475257,'Gemini'],
  [-1263475257,-1263301147,'Cancer'],
  [-1263301147,-1263117561,'Leo'],
  [-1263117561,-1262921572,'Virgo'],
  [-1262921572,-1262714586,'Libra'],
  [-1262714586,-1262500508,'Scorpio'],
  [-1262500508,-1262282902,'Sagittarius'],
  [-1262282902,-1262064532,'Capricorn'],
  [-1262064532,-1261849375,'Aquarius'],
  [-1261849375,-1261643284,'Pisces'],
  [-1261643284,-1261450908,'Aries'],
  [-1261450908,-1261272185,'Taurus'],
  [-1261272185,-1261102001,'Gemini'],
  [-1261102001,-1260932530,'Cancer'],
  [-1260932530,-1260755684,'Leo'],
  [-1260755684,-1260565530,'Virgo'],
  [-1260565530,-1260361031,'Libra'],
  [-1260361031,-1260146497,'Scorpio'],
  [-1260146497,-1259928137,'Sagittarius'],
  [-1259928137,-1259710283,'Capricorn'],
  [-1259710283,-1259495464,'Aquarius'],
  [-1259495464,-1259286883,'Pisces'],
  [-1259286883,-1259088710,'Aries'],
  [-1259088710,-1258903323,'Taurus'],
  [-1258903323,-1258728672,'Gemini'],
  [-1258728672,-1258558653,'Cancer'],
  [-1258558653,-1258385359,'Leo'],
  [-1258385359,-1258201389,'Virgo'],
  [-1258201389,-1258002624,'Libra'],
  [-1258002624,-1257790760,'Scorpio'],
  [-1257790760,-1257572482,'Sagittarius'],
  [-1257572482,-1257354798,'Capricorn'],
  [-1257354798,-1257141533,'Aquarius'],
  [-1257141533,-1256934282,'Pisces'],
  [-1256934282,-1256734631,'Aries'],
  [-1256734631,-1256544292,'Taurus'],
  [-1256544292,-1256363207,'Gemini'],
  [-1256363207,-1256188133,'Cancer'],
  [-1256188133,-1256013192,'Leo'],
  [-1256013192,-1255831584,'Virgo'],
  [-1255831584,-1255637827,'Libra'],
  [-1255637827,-1255430499,'Scorpio'],
  [-1255430499,-1255213944,'Sagittarius'],
  [-1255213944,-1254996145,'Capricorn'],
  [-1254996145,-1254783629,'Aquarius'],
  [-1254783629,-1254578942,'Pisces'],
  [-1254578942,-1254381933,'Aries'],
  [-1254381933,-1254191720,'Taurus'],
  [-1254191720,-1254007252,'Gemini'],
  [-1254007252,-1253826672,'Cancer'],
  [-1253826672,-1253646714,'Leo'],
  [-1253646714,-1253462867,'Virgo'],
  [-1253462867,-1253270448,'Libra'],
  [-1253270448,-1253066566,'Scorpio'],
  [-1253066566,-1252852538,'Sagittarius'],
  [-1252852538,-1252634748,'Capricorn'],
  [-1252634748,-1252421426,'Aquarius'],
  [-1252421426,-1252217719,'Pisces'],
  [-1252217719,-1252024050,'Aries'],
  [-1252024050,-1251837713,'Taurus'],
  [-1251837713,-1251655095,'Gemini'],
  [-1251655095,-1251472988,'Cancer'],
  [-1251472988,-1251288897,'Leo'],
  [-1251288897,-1251100660,'Virgo'],
  [-1251100660,-1250905972,'Libra'],
  [-1250905972,-1250702668,'Scorpio'],
  [-1250702668,-1250490384,'Sagittarius'],
  [-1250490384,-1250272783,'Capricorn'],
  [-1250272783,-1250057546,'Aquarius'],
  [-1250057546,-1249852162,'Pisces'],
  [-1249852162,-1249659406,'Aries'],
  [-1249659406,-1249476808,'Taurus'],
  [-1249476808,-1249298988,'Gemini'],
  [-1249298988,-1249120260,'Cancer'],
  [-1249120260,-1248936425,'Leo'],
  [-1248936425,-1248745565,'Virgo'],
  [-1248745565,-1248547489,'Libra'],
  [-1248547489,-1248342318,'Scorpio'],
  [-1248342318,-1248130133,'Sagittarius'],
  [-1248130133,-1247912685,'Capricorn'],
  [-1247912685,-1247695463,'Aquarius'],
  [-1247695463,-1247486466,'Pisces'],
  [-1247486466,-1247291170,'Aries'],
  [-1247291170,-1247109144,'Taurus'],
  [-1247109144,-1246935059,'Gemini'],
  [-1246935059,-1246761676,'Cancer'],
  [-1246761676,-1246582397,'Leo'],
  [-1246582397,-1246393264,'Virgo'],
  [-1246393264,-1246193952,'Libra'],
  [-1246193952,-1245986525,'Scorpio'],
  [-1245986525,-1245773151,'Sagittarius'],
  [-1245773151,-1245555622,'Capricorn'],
  [-1245555622,-1245337338,'Aquarius'],
  [-1245337338,-1245124721,'Pisces'],
  [-1245124721,-1244924536,'Aries'],
  [-1244924536,-1244739154,'Taurus'],
  [-1244739154,-1244565046,'Gemini'],
  [-1244565046,-1244395071,'Cancer'],
  [-1244395071,-1244221334,'Leo'],
  [-1244221334,-1244037483,'Virgo'],
  [-1244037483,-1243840879,'Libra'],
  [-1243840879,-1243633262,'Scorpio'],
  [-1243633262,-1243418696,'Sagittarius'],
  [-1243418696,-1243200840,'Capricorn'],
  [-1243200840,-1242982675,'Aquarius'],
  [-1242982675,-1242768415,'Pisces'],
  [-1242768415,-1242563719,'Aries'],
  [-1242563719,-1242372628,'Taurus'],
  [-1242372628,-1242194382,'Gemini'],
  [-1242194382,-1242023608,'Cancer'],
  [-1242023608,-1241852742,'Leo'],
  [-1241852742,-1241674313,'Virgo'],
  [-1241674313,-1241483168,'Libra'],
  [-1241483168,-1241278570,'Scorpio'],
  [-1241278570,-1241064322,'Sagittarius'],
  [-1241064322,-1240846158,'Capricorn'],
  [-1240846158,-1240628689,'Aquarius'],
  [-1240628689,-1240415242,'Pisces'],
  [-1240415242,-1240209122,'Aries'],
  [-1240209122,-1240013440,'Taurus'],
  [-1240013440,-1239829132,'Gemini'],
  [-1239829132,-1239653536,'Cancer'],
  [-1239653536,-1239481056,'Leo'],
  [-1239481056,-1239304844,'Virgo'],
  [-1239304844,-1239118644,'Libra'],
  [-1239118644,-1238919004,'Scorpio'],
  [-1238919004,-1238707245,'Sagittarius'],
  [-1238707245,-1238489285,'Capricorn'],
  [-1238489285,-1238272165,'Aquarius'],
  [-1238272165,-1238060557,'Pisces'],
  [-1238060557,-1237856431,'Aries'],
  [-1237856431,-1237660347,'Taurus'],
  [-1237660347,-1237472195,'Gemini'],
  [-1237472195,-1237290735,'Cancer'],
  [-1237290735,-1237113028,'Leo'],
  [-1237113028,-1236934517,'Virgo'],
  [-1236934517,-1236749802,'Libra'],
  [-1236749802,-1236554197,'Scorpio'],
  [-1236554197,-1236346108,'Sagittarius'],
  [-1236346108,-1236129242,'Capricorn'],
  [-1236129242,-1235911639,'Aquarius'],
  [-1235911639,-1235700729,'Pisces'],
  [-1235700729,-1235499513,'Aries'],
  [-1235499513,-1235306879,'Taurus'],
  [-1235306879,-1235120012,'Gemini'],
  [-1235120012,-1234936249,'Cancer'],
  [-1234936249,-1234753547,'Leo'],
  [-1234753547,-1234569906,'Virgo'],
  [-1234569906,-1234382491,'Libra'],
  [-1234382491,-1234187602,'Scorpio'],
  [-1234187602,-1233982226,'Sagittarius'],
  [-1233982226,-1233767044,'Capricorn'],
  [-1233767044,-1233548508,'Aquarius'],
  [-1233548508,-1233335975,'Pisces'],
  [-1233335975,-1233135361,'Aries'],
  [-1233135361,-1232946305,'Taurus'],
  [-1232946305,-1232764262,'Gemini'],
  [-1232764262,-1232583815,'Cancer'],
  [-1232583815,-1232400949,'Leo'],
  [-1232400949,-1232213857,'Virgo'],
  [-1232213857,-1232022013,'Libra'],
  [-1232022013,-1231824417,'Scorpio'],
  [-1231824417,-1231619108,'Sagittarius'],
  [-1231619108,-1231405149,'Capricorn'],
  [-1231405149,-1231186021,'Aquarius'],
  [-1231186021,-1230970351,'Pisces'],
  [-1230970351,-1230766720,'Aries'],
  [-1230766720,-1230577640,'Taurus'],
  [-1230577640,-1230399191,'Gemini'],
  [-1230399191,-1230224470,'Cancer'],
  [-1230224470,-1230046792,'Leo'],
  [-1230046792,-1229861822,'Virgo'],
  [-1229861822,-1229668464,'Libra'],
  [-1229668464,-1229467625,'Scorpio'],
  [-1229467625,-1229260064,'Sagittarius'],
  [-1229260064,-1229045887,'Capricorn'],
  [-1229045887,-1228826748,'Aquarius'],
  [-1228826748,-1228608549,'Pisces'],
  [-1228608549,-1228399944,'Aries'],
  [-1228399944,-1228206474,'Taurus'],
  [-1228206474,-1228026948,'Gemini'],
  [-1228026948,-1227855183,'Cancer'],
  [-1227855183,-1227683432,'Leo'],
  [-1227683432,-1227504868,'Virgo'],
  [-1227504868,-1227315461,'Libra'],
  [-1227315461,-1227114887,'Scorpio'],
  [-1227114887,-1226905424,'Sagittarius'],
  [-1226905424,-1226689867,'Capricorn'],
  [-1226689867,-1226470753,'Aquarius'],
  [-1226470753,-1226251972,'Pisces'],
  [-1226251972,-1226039781,'Aries'],
  [-1226039781,-1225840279,'Taurus'],
  [-1225840279,-1225655293,'Gemini'],
  [-1225655293,-1225481273,'Cancer'],
  [-1225481273,-1225311460,'Leo'],
  [-1225311460,-1225138379,'Virgo'],
  [-1225138379,-1224955680,'Libra'],
  [-1224955680,-1224759920,'Scorpio'],
  [-1224759920,-1224551776,'Sagittarius'],
  [-1224551776,-1224335432,'Capricorn'],
  [-1224335432,-1224116029,'Aquarius'],
  [-1224116029,-1223898014,'Pisces'],
  [-1223898014,-1223685476,'Aries'],
  [-1223685476,-1223482384,'Taurus'],
  [-1223482384,-1223291225,'Gemini'],
  [-1223291225,-1223111209,'Cancer'],
  [-1223111209,-1222938199,'Leo'],
  [-1222938199,-1222766009,'Virgo'],
  [-1222766009,-1222587913,'Libra'],
  [-1222587913,-1222398266,'Scorpio'],
  [-1222398266,-1222194633,'Sagittarius'],
  [-1222194633,-1221979672,'Capricorn'],
  [-1221979672,-1221760143,'Aquarius'],
  [-1221760143,-1221542906,'Pisces'],
  [-1221542906,-1221332161,'Aries'],
  [-1221332161,-1221129587,'Taurus'],
  [-1221129587,-1220935704,'Gemini'],
  [-1220935704,-1220750174,'Cancer'],
  [-1220750174,-1220571258,'Leo'],
  [-1220571258,-1220395385,'Virgo'],
  [-1220395385,-1220217322,'Libra'],
  [-1220217322,-1220031174,'Scorpio'],
  [-1220031174,-1219832357,'Sagittarius'],
  [-1219832357,-1219620578,'Capricorn'],
  [-1219620578,-1219401653,'Aquarius'],
  [-1219401653,-1219184482,'Pisces'],
  [-1219184482,-1218975365,'Aries'],
  [-1218975365,-1218775627,'Taurus'],
  [-1218775627,-1218583470,'Gemini'],
  [-1218583470,-1218396620,'Cancer'],
  [-1218396620,-1218213403,'Leo'],
  [-1218213403,-1218032249,'Virgo'],
  [-1218032249,-1217850471,'Libra'],
  [-1217850471,-1217663757,'Scorpio'],
  [-1217663757,-1217467290,'Sagittarius'],
  [-1217467290,-1217258575,'Capricorn'],
  [-1217258575,-1217040853,'Aquarius'],
  [-1217040853,-1216823018,'Pisces'],
  [-1216823018,-1216613794,'Aries'],
  [-1216613794,-1216416200,'Taurus'],
  [-1216416200,-1216227757,'Gemini'],
  [-1216227757,-1216043947,'Cancer'],
  [-1216043947,-1215861045,'Leo'],
  [-1215861045,-1215677089,'Virgo'],
  [-1215677089,-1215490997,'Libra'],
  [-1215490997,-1215300885,'Scorpio'],
  [-1215300885,-1215103545,'Sagittarius'],
  [-1215103545,-1214896112,'Capricorn'],
  [-1214896112,-1214679501,'Aquarius'],
  [-1214679501,-1214460670,'Pisces'],
  [-1214460670,-1214249359,'Aries'],
  [-1214249359,-1214051209,'Taurus'],
  [-1214051209,-1213865057,'Gemini'],
  [-1213865057,-1213685609,'Cancer'],
  [-1213685609,-1213506988,'Leo'],
  [-1213506988,-1213324973,'Virgo'],
  [-1213324973,-1213137637,'Libra'],
  [-1213137637,-1212944333,'Scorpio'],
  [-1212944333,-1212744188,'Sagittarius'],
  [-1212744188,-1212535897,'Capricorn'],
  [-1212535897,-1212319669,'Aquarius'],
  [-1212319669,-1212100066,'Pisces'],
  [-1212100066,-1211885701,'Aries'],
  [-1211885701,-1211684088,'Taurus'],
  [-1211684088,-1211496706,'Gemini'],
  [-1211496706,-1211319372,'Cancer'],
  [-1211319372,-1211145505,'Leo'],
  [-1211145505,-1210968795,'Virgo'],
  [-1210968795,-1210784819,'Libra'],
  [-1210784819,-1210591679,'Scorpio'],
  [-1210591679,-1210389464,'Sagittarius'],
  [-1210389464,-1210179203,'Capricorn'],
  [-1210179203,-1209962468,'Aquarius'],
  [-1209962468,-1209742652,'Pisces'],
  [-1209742652,-1209526005,'Aries'],
  [-1209526005,-1209319698,'Taurus'],
  [-1209319698,-1209127621,'Gemini'],
  [-1209127621,-1208948215,'Cancer'],
  [-1208948215,-1208776022,'Leo'],
  [-1208776022,-1208604165,'Virgo'],
  [-1208604165,-1208426158,'Libra'],
  [-1208426158,-1208237389,'Scorpio'],
  [-1208237389,-1208036369,'Sagittarius'],
  [-1208036369,-1207825020,'Capricorn'],
  [-1207825020,-1207607334,'Aquarius'],
  [-1207607334,-1207387710,'Pisces'],
  [-1207387710,-1207170752,'Aries'],
  [-1207170752,-1206961352,'Taurus'],
  [-1206961352,-1206763579,'Gemini'],
  [-1206763579,-1206578489,'Cancer'],
  [-1206578489,-1206403313,'Leo'],
  [-1206403313,-1206232456,'Virgo'],
  [-1206232456,-1206059025,'Libra'],
  [-1206059025,-1205876370,'Scorpio'],
  [-1205876370,-1205680093,'Sagittarius'],
  [-1205680093,-1205470360,'Capricorn'],
  [-1205470360,-1205252293,'Aquarius'],
  [-1205252293,-1205032799,'Pisces'],
  [-1205032799,-1204817064,'Aries'],
  [-1204817064,-1204607921,'Taurus'],
  [-1204607921,-1204407206,'Gemini'],
  [-1204407206,-1204216240,'Cancer'],
  [-1204216240,-1204034808,'Leo'],
  [-1204034808,-1203860125,'Virgo'],
  [-1203860125,-1203686814,'Libra'],
  [-1203686814,-1203508020,'Scorpio'],
  [-1203508020,-1203317339,'Sagittarius'],
  [-1203317339,-1203111856,'Capricorn'],
  [-1203111856,-1202895044,'Aquarius'],
  [-1202895044,-1202675437,'Pisces'],
  [-1202675437,-1202460770,'Aries'],
  [-1202460770,-1202254069,'Taurus'],
  [-1202254069,-1202054862,'Gemini'],
  [-1202054862,-1201862145,'Cancer'],
  [-1201862145,-1201675612,'Leo'],
  [-1201675612,-1201494727,'Virgo'],
  [-1201494727,-1201316988,'Libra'],
  [-1201316988,-1201137355,'Scorpio'],
  [-1201137355,-1200949470,'Sagittarius'],
  [-1200949470,-1200748378,'Capricorn'],
  [-1200748378,-1200534375,'Aquarius'],
  [-1200534375,-1200314848,'Pisces'],
  [-1200314848,-1200099772,'Aries'],
  [-1200099772,-1199894682,'Taurus'],
  [-1199894682,-1199699046,'Gemini'],
  [-1199699046,-1199509522,'Cancer'],
  [-1199509522,-1199323243,'Leo'],
  [-1199323243,-1199138936,'Virgo'],
  [-1199138936,-1198955798,'Libra'],
  [-1198955798,-1198771596,'Scorpio'],
  [-1198771596,-1198582114,'Sagittarius'],
  [-1198582114,-1198382650,'Capricorn'],
  [-1198382650,-1198171312,'Aquarius'],
  [-1198171312,-1197952438,'Pisces'],
  [-1197952438,-1197735679,'Aries'],
  [-1197735679,-1197529355,'Taurus'],
  [-1197529355,-1197335315,'Gemini'],
  [-1197335315,-1197150104,'Cancer'],
  [-1197150104,-1196968654,'Leo'],
  [-1196968654,-1196786894,'Virgo'],
  [-1196786894,-1196602570,'Libra'],
  [-1196602570,-1196414421,'Scorpio'],
  [-1196414421,-1196220841,'Sagittarius'],
  [-1196220841,-1196019518,'Capricorn'],
  [-1196019518,-1195808845,'Aquarius'],
  [-1195808845,-1195590777,'Pisces'],
  [-1195590777,-1195372335,'Aries'],
  [-1195372335,-1195162441,'Taurus'],
  [-1195162441,-1194966042,'Gemini'],
  [-1194966042,-1194781913,'Cancer'],
  [-1194781913,-1194604960,'Leo'],
  [-1194604960,-1194429143,'Virgo'],
  [-1194429143,-1194249322,'Libra'],
  [-1194249322,-1194062192,'Scorpio'],
  [-1194062192,-1193866397,'Sagittarius'],
  [-1193866397,-1193661992,'Capricorn'],
  [-1193661992,-1193449810,'Aquarius'],
  [-1193449810,-1193231880,'Pisces'],
  [-1193231880,-1193012719,'Aries'],
  [-1193012719,-1192799247,'Taurus'],
  [-1192799247,-1192597760,'Gemini'],
  [-1192597760,-1192410173,'Cancer'],
  [-1192410173,-1192233511,'Leo'],
  [-1192233511,-1192061833,'Virgo'],
  [-1192061833,-1191888316,'Libra'],
  [-1191888316,-1191706866,'Scorpio'],
  [-1191706866,-1191513694,'Sagittarius'],
  [-1191513694,-1191308594,'Capricorn'],
  [-1191308594,-1191094602,'Aquarius'],
  [-1191094602,-1190875984,'Pisces'],
  [-1190875984,-1190656948,'Aries'],
  [-1190656948,-1190441917,'Taurus'],
  [-1190441917,-1190235822,'Gemini'],
  [-1190235822,-1190042286,'Cancer'],
  [-1190042286,-1189861355,'Leo'],
  [-1189861355,-1189689116,'Virgo'],
  [-1189689116,-1189518986,'Libra'],
  [-1189518986,-1189343513,'Scorpio'],
  [-1189343513,-1189156289,'Sagittarius'],
  [-1189156289,-1188954487,'Capricorn'],
  [-1188954487,-1188740745,'Aquarius'],
  [-1188740745,-1188521488,'Pisces'],
  [-1188521488,-1188302789,'Aries'],
  [-1188302789,-1188088335,'Taurus'],
  [-1188088335,-1187880658,'Gemini'],
  [-1187880658,-1187682425,'Cancer'],
  [-1187682425,-1187495376,'Leo'],
  [-1187495376,-1187318423,'Virgo'],
  [-1187318423,-1187146947,'Libra'],
  [-1187146947,-1186973934,'Scorpio'],
  [-1186973934,-1186791901,'Sagittarius'],
  [-1186791901,-1186595489,'Capricorn'],
  [-1186595489,-1186384738,'Aquarius'],
  [-1186384738,-1186165964,'Pisces'],
  [-1186165964,-1185947468,'Aries'],
  [-1185947468,-1185734376,'Taurus'],
  [-1185734376,-1185528105,'Gemini'],
  [-1185528105,-1185329011,'Cancer'],
  [-1185329011,-1185137941,'Leo'],
  [-1185137941,-1184955264,'Virgo'],
  [-1184955264,-1184778949,'Libra'],
  [-1184778949,-1184603967,'Scorpio'],
  [-1184603967,-1184423505,'Sagittarius'],
  [-1184423505,-1184231238,'Capricorn'],
  [-1184231238,-1184024621,'Aquarius'],
  [-1184024621,-1183807680,'Pisces'],
  [-1183807680,-1183589267,'Aries'],
  [-1183589267,-1183376862,'Taurus'],
  [-1183376862,-1183172885,'Gemini'],
  [-1183172885,-1182976293,'Cancer'],
  [-1182976293,-1182785604,'Leo'],
  [-1182785604,-1182600108,'Virgo'],
  [-1182600108,-1182418870,'Libra'],
  [-1182418870,-1182239211,'Scorpio'],
  [-1182239211,-1182056416,'Sagittarius'],
  [-1182056416,-1181865000,'Capricorn'],
  [-1181865000,-1181661305,'Aquarius'],
  [-1181661305,-1181446683,'Pisces'],
  [-1181446683,-1181228353,'Aries'],
  [-1181228353,-1181015212,'Taurus'],
  [-1181015212,-1180812093,'Gemini'],
  [-1180812093,-1180618570,'Cancer'],
  [-1180618570,-1180431581,'Leo'],
  [-1180431581,-1180247986,'Virgo'],
  [-1180247986,-1180065457,'Libra'],
  [-1180065457,-1179881966,'Scorpio'],
  [-1179881966,-1179694952,'Sagittarius'],
  [-1179694952,-1179501182,'Capricorn'],
  [-1179501182,-1179297829,'Aquarius'],
  [-1179297829,-1179084765,'Pisces'],
  [-1179084765,-1178866585,'Aries'],
  [-1178866585,-1178651512,'Taurus'],
  [-1178651512,-1178446616,'Gemini'],
  [-1178446616,-1178253831,'Cancer'],
  [-1178253831,-1178070451,'Leo'],
  [-1178070451,-1177891668,'Virgo'],
  [-1177891668,-1177712620,'Libra'],
  [-1177712620,-1177529508,'Scorpio'],
  [-1177529508,-1177339944,'Sagittarius'],
  [-1177339944,-1177142721,'Capricorn'],
  [-1177142721,-1176937378,'Aquarius'],
  [-1176937378,-1176724365,'Pisces'],
  [-1176724365,-1176506363,'Aries'],
  [-1176506363,-1176289250,'Taurus'],
  [-1176289250,-1176080466,'Gemini'],
  [-1176080466,-1175884758,'Cancer'],
  [-1175884758,-1175701697,'Leo'],
  [-1175701697,-1175526701,'Virgo'],
  [-1175526701,-1175353291,'Libra'],
  [-1175353291,-1175175087,'Scorpio'],
  [-1175175087,-1174987505,'Sagittarius'],
  [-1174987505,-1174789067,'Capricorn'],
  [-1174789067,-1174581299,'Aquarius'],
  [-1174581299,-1174367004,'Pisces'],
  [-1174367004,-1174149034,'Aries'],
  [-1174149034,-1173931003,'Taurus'],
  [-1173931003,-1173718430,'Gemini'],
  [-1173718430,-1173517239,'Cancer'],
  [-1173517239,-1173330104,'Leo'],
  [-1173330104,-1173154672,'Virgo'],
  [-1173154672,-1172984723,'Libra'],
  [-1172984723,-1172812495,'Scorpio'],
  [-1172812495,-1172630835,'Sagittarius'],
  [-1172630835,-1172435636,'Capricorn'],
  [-1172435636,-1172227816,'Aquarius'],
  [-1172227816,-1172012201,'Pisces'],
  [-1172012201,-1171793899,'Aries'],
  [-1171793899,-1171576291,'Taurus'],
  [-1171576291,-1171362407,'Gemini'],
  [-1171362407,-1171156586,'Cancer'],
  [-1171156586,-1170963004,'Leo'],
  [-1170963004,-1170782465,'Virgo'],
  [-1170782465,-1170611006,'Libra'],
  [-1170611006,-1170441387,'Scorpio'],
  [-1170441387,-1170265435,'Sagittarius'],
  [-1170265435,-1170076475,'Capricorn'],
  [-1170076475,-1169872441,'Aquarius'],
  [-1169872441,-1169657421,'Pisces'],
  [-1169657421,-1169438697,'Aries'],
  [-1169438697,-1169221822,'Taurus'],
  [-1169221822,-1169009258,'Gemini'],
  [-1169009258,-1168802732,'Cancer'],
  [-1168802732,-1168604848,'Leo'],
  [-1168604848,-1168417738,'Virgo'],
  [-1168417738,-1168240448,'Libra'],
  [-1168240448,-1168068149,'Scorpio'],
  [-1168068149,-1167893639,'Sagittarius'],
  [-1167893639,-1167709554,'Capricorn'],
  [-1167709554,-1167511172,'Aquarius'],
  [-1167511172,-1167299443,'Pisces'],
  [-1167299443,-1167081138,'Aries'],
  [-1167081138,-1166864306,'Taurus'],
  [-1166864306,-1166653468,'Gemini'],
  [-1166653468,-1166449548,'Cancer'],
  [-1166449548,-1166252447,'Leo'],
  [-1166252447,-1166062454,'Virgo'],
  [-1166062454,-1165879406,'Libra'],
  [-1165879406,-1165701135,'Scorpio'],
  [-1165701135,-1165523077,'Sagittarius'],
  [-1165523077,-1165339313,'Capricorn'],
  [-1165339313,-1165144571,'Aquarius'],
  [-1165144571,-1164937001,'Pisces'],
  [-1164937001,-1164720416,'Aries'],
  [-1164720416,-1164503023,'Taurus'],
  [-1164503023,-1164292186,'Gemini'],
  [-1164292186,-1164090698,'Cancer'],
  [-1164090698,-1163897513,'Leo'],
  [-1163897513,-1163710178,'Virgo'],
  [-1163710178,-1163526352,'Libra'],
  [-1163526352,-1163343938,'Scorpio'],
  [-1163343938,-1163160529,'Sagittarius'],
  [-1163160529,-1162972987,'Capricorn'],
  [-1162972987,-1162777782,'Aquarius'],
  [-1162777782,-1162572444,'Pisces'],
  [-1162572444,-1162357914,'Aries'],
  [-1162357914,-1162140020,'Taurus'],
  [-1162140020,-1161927195,'Gemini'],
  [-1161927195,-1161725263,'Cancer'],
  [-1161725263,-1161534779,'Leo'],
  [-1161534779,-1161352280,'Virgo'],
  [-1161352280,-1161172801,'Libra'],
  [-1161172801,-1160991825,'Scorpio'],
  [-1160991825,-1160806287,'Sagittarius'],
  [-1160806287,-1160614648,'Capricorn'],
  [-1160614648,-1160416125,'Aquarius'],
  [-1160416125,-1160210006,'Pisces'],
  [-1160210006,-1159996406,'Aries'],
  [-1159996406,-1159778368,'Taurus'],
  [-1159778368,-1159562827,'Gemini'],
  [-1159562827,-1159357490,'Cancer'],
  [-1159357490,-1159165902,'Leo'],
  [-1159165902,-1158985900,'Virgo'],
  [-1158985900,-1158811582,'Libra'],
  [-1158811582,-1158636097,'Scorpio'],
  [-1158636097,-1158453821,'Sagittarius'],
  [-1158453821,-1158261953,'Capricorn'],
  [-1158261953,-1158060835,'Aquarius'],
  [-1158060835,-1157852328,'Pisces'],
  [-1157852328,-1157638077,'Aries'],
  [-1157638077,-1157420027,'Taurus'],
  [-1157420027,-1157202576,'Gemini'],
  [-1157202576,-1156992849,'Cancer'],
  [-1156992849,-1156796757,'Leo'],
  [-1156796757,-1156614914,'Virgo'],
  [-1156614914,-1156442501,'Libra'],
  [-1156442501,-1156271972,'Scorpio'],
  [-1156271972,-1156095708,'Sagittarius'],
  [-1156095708,-1155908253,'Capricorn'],
  [-1155908253,-1155708290,'Aquarius'],
  [-1155708290,-1155498525,'Pisces'],
  [-1155498525,-1155282983,'Aries'],
  [-1155282983,-1155064775,'Taurus'],
  [-1155064775,-1154846899,'Gemini'],
  [-1154846899,-1154634272,'Cancer'],
  [-1154634272,-1154432873,'Leo'],
  [-1154432873,-1154245817,'Virgo'],
  [-1154245817,-1154070822,'Libra'],
  [-1154070822,-1153901406,'Scorpio'],
  [-1153901406,-1153729576,'Sagittarius'],
  [-1153729576,-1153548108,'Capricorn'],
  [-1153548108,-1153352933,'Aquarius'],
  [-1153352933,-1153144957,'Pisces'],
  [-1153144957,-1152929058,'Aries'],
  [-1152929058,-1152710615,'Taurus'],
  [-1152710615,-1152493362,'Gemini'],
  [-1152493362,-1152280523,'Cancer'],
  [-1152280523,-1152076094,'Leo'],
  [-1152076094,-1151883526,'Virgo'],
  [-1151883526,-1151702952,'Libra'],
  [-1151702952,-1151530291,'Scorpio'],
  [-1151530291,-1151358790,'Sagittarius'],
  [-1151358790,-1151181104,'Capricorn'],
  [-1151181104,-1150991408,'Aquarius'],
  [-1150991408,-1150787783,'Pisces'],
  [-1150787783,-1150573471,'Aries'],
  [-1150573471,-1150355075,'Taurus'],
  [-1150355075,-1150138539,'Gemini'],
  [-1150138539,-1149927347,'Cancer'],
  [-1149927347,-1149723509,'Leo'],
  [-1149723509,-1149528533,'Virgo'],
  [-1149528533,-1149342847,'Libra'],
  [-1149342847,-1149164568,'Scorpio'],
  [-1149164568,-1148989356,'Sagittarius'],
  [-1148989356,-1148811362,'Capricorn'],
  [-1148811362,-1148624723,'Aquarius'],
  [-1148624723,-1148425586,'Pisces'],
  [-1148425586,-1148214374,'Aries'],
  [-1148214374,-1147996624,'Taurus'],
  [-1147996624,-1147780137,'Gemini'],
  [-1147780137,-1147570483,'Cancer'],
  [-1147570483,-1147369451,'Leo'],
  [-1147369451,-1147176300,'Virgo'],
  [-1147176300,-1146989432,'Libra'],
  [-1146989432,-1146806964,'Scorpio'],
  [-1146806964,-1146626467,'Sagittarius'],
  [-1146626467,-1146444604,'Capricorn'],
  [-1146444604,-1146257219,'Aquarius'],
  [-1146257219,-1146060313,'Pisces'],
  [-1146060313,-1145852110,'Aries'],
  [-1145852110,-1145635524,'Taurus'],
  [-1145635524,-1145418238,'Gemini'],
  [-1145418238,-1145208316,'Cancer'],
  [-1145208316,-1145009407,'Leo'],
  [-1145009407,-1144820155,'Virgo'],
  [-1144820155,-1144636591,'Libra'],
  [-1144636591,-1144454619,'Scorpio'],
  [-1144454619,-1144271316,'Sagittarius'],
  [-1144271316,-1144084926,'Capricorn'],
  [-1144084926,-1143893884,'Aquarius'],
  [-1143893884,-1143695993,'Pisces'],
  [-1143695993,-1143489112,'Aries'],
  [-1143489112,-1143273691,'Taurus'],
  [-1143273691,-1143055257,'Gemini'],
  [-1143055257,-1142842846,'Cancer'],
  [-1142842846,-1142643031,'Leo'],
  [-1142643031,-1142456060,'Virgo'],
  [-1142456060,-1142277197,'Libra'],
  [-1142277197,-1142100031,'Scorpio'],
  [-1142100031,-1141919145,'Sagittarius'],
  [-1141919145,-1141731674,'Capricorn'],
  [-1141731674,-1141537257,'Aquarius'],
  [-1141537257,-1141336283,'Pisces'],
  [-1141336283,-1141128428,'Aries'],
  [-1141128428,-1140913497,'Taurus'],
  [-1140913497,-1140694367,'Gemini'],
  [-1140694367,-1140478576,'Cancer'],
  [-1140478576,-1140274577,'Leo'],
  [-1140274577,-1140085724,'Virgo'],
  [-1140085724,-1139908727,'Libra'],
  [-1139908727,-1139736559,'Scorpio'],
  [-1139736559,-1139561695,'Sagittarius'],
  [-1139561695,-1139378472,'Capricorn'],
  [-1139378472,-1139184776,'Aquarius'],
  [-1139184776,-1138981782,'Pisces'],
  [-1138981782,-1138771718,'Aries'],
  [-1138771718,-1138556182,'Taurus'],
  [-1138556182,-1138337085,'Gemini'],
  [-1138337085,-1138119247,'Cancer'],
  [-1138119247,-1137910222,'Leo'],
  [-1137910222,-1137715745,'Virgo'],
  [-1137715745,-1137535639,'Libra'],
  [-1137535639,-1137364384,'Scorpio'],
  [-1137364384,-1137194210,'Sagittarius'],
  [-1137194210,-1137017615,'Capricorn'],
  [-1137017615,-1136829449,'Aquarius'],
  [-1136829449,-1136628596,'Pisces'],
  [-1136628596,-1136417723,'Aries'],
  [-1136417723,-1136201018,'Taurus'],
  [-1136201018,-1135982098,'Gemini'],
  [-1135982098,-1135764497,'Cancer'],
  [-1135764497,-1135553050,'Leo'],
  [-1135553050,-1135352884,'Virgo'],
  [-1135352884,-1135166242,'Libra'],
  [-1135166242,-1134990671,'Scorpio'],
  [-1134990671,-1134820185,'Sagittarius'],
  [-1134820185,-1134647465,'Capricorn'],
  [-1134647465,-1134465735,'Aquarius'],
  [-1134465735,-1134270720,'Pisces'],
  [-1134270720,-1134062507,'Aries'],
  [-1134062507,-1133845687,'Taurus'],
  [-1133845687,-1133626600,'Gemini'],
  [-1133626600,-1133410263,'Cancer'],
  [-1133410263,-1133199952,'Leo'],
  [-1133199952,-1132998070,'Virgo'],
  [-1132998070,-1132806196,'Libra'],
  [-1132806196,-1132623955,'Scorpio'],
  [-1132623955,-1132448353,'Sagittarius'],
  [-1132448353,-1132274206,'Capricorn'],
  [-1132274206,-1132095252,'Aquarius'],
  [-1132095252,-1131905702,'Pisces'],
  [-1131905702,-1131702481,'Aries'],
  [-1131702481,-1131487701,'Taurus'],
  [-1131487701,-1131268511,'Gemini'],
  [-1131268511,-1131052745,'Cancer'],
  [-1131052745,-1130844816,'Leo'],
  [-1130844816,-1130645355,'Virgo'],
  [-1130645355,-1130453259,'Libra'],
  [-1130453259,-1130267188,'Scorpio'],
  [-1130267188,-1130085645,'Sagittarius'],
  [-1130085645,-1129906264,'Capricorn'],
  [-1129906264,-1129725150,'Aquarius'],
  [-1129725150,-1129537226,'Pisces'],
  [-1129537226,-1129337947,'Aries'],
  [-1129337947,-1129126355,'Taurus'],
  [-1129126355,-1128907677,'Gemini'],
  [-1128907677,-1128691243,'Cancer'],
  [-1128691243,-1128484220,'Leo'],
  [-1128484220,-1128287967,'Virgo'],
  [-1128287967,-1128099562,'Libra'],
  [-1128099562,-1127915073,'Scorpio'],
  [-1127915073,-1127731625,'Sagittarius'],
  [-1127731625,-1127547695,'Capricorn'],
  [-1127547695,-1127361890,'Aquarius'],
  [-1127361890,-1127171552,'Pisces'],
  [-1127171552,-1126972931,'Aries'],
  [-1126972931,-1126763546,'Taurus'],
  [-1126763546,-1126545770,'Gemini'],
  [-1126545770,-1126327933,'Cancer'],
  [-1126327933,-1126119358,'Leo'],
  [-1126119358,-1125923925,'Virgo'],
  [-1125923925,-1125739106,'Libra'],
  [-1125739106,-1125559296,'Scorpio'],
  [-1125559296,-1125379119,'Sagittarius'],
  [-1125379119,-1125195258,'Capricorn'],
  [-1125195258,-1125006559,'Aquarius'],
  [-1125006559,-1124812494,'Pisces'],
  [-1124812494,-1124611671,'Aries'],
  [-1124611671,-1124402327,'Taurus'],
  [-1124402327,-1124185132,'Gemini'],
  [-1124185132,-1123965963,'Cancer'],
  [-1123965963,-1123754169,'Leo'],
  [-1123754169,-1123556222,'Virgo'],
  [-1123556222,-1123371798,'Libra'],
  [-1123371798,-1123195555,'Scorpio'],
  [-1123195555,-1123020677,'Sagittarius'],
  [-1123020677,-1122841402,'Capricorn'],
  [-1122841402,-1122654441,'Aquarius'],
  [-1122654441,-1122459018,'Pisces'],
  [-1122459018,-1122255585,'Aries'],
  [-1122255585,-1122044639,'Taurus'],
  [-1122044639,-1121827272,'Gemini'],
  [-1121827272,-1121607421,'Cancer'],
  [-1121607421,-1121392515,'Leo'],
  [-1121392515,-1121189923,'Virgo'],
  [-1121189923,-1121002075,'Libra'],
  [-1121002075,-1120825606,'Scorpio'],
  [-1120825606,-1120654011,'Sagittarius'],
  [-1120654011,-1120480294,'Capricorn'],
  [-1120480294,-1120298739,'Aquarius'],
  [-1120298739,-1120106193,'Pisces'],
  [-1120106193,-1119902559,'Aries'],
  [-1119902559,-1119690093,'Taurus'],
  [-1119690093,-1119471997,'Gemini'],
  [-1119471997,-1119252160,'Cancer'],
  [-1119252160,-1119035862,'Leo'],
  [-1119035862,-1118829061,'Virgo'],
  [-1118829061,-1118635626,'Libra'],
  [-1118635626,-1118454946,'Scorpio'],
  [-1118454946,-1118282446,'Sagittarius'],
  [-1118282446,-1118111568,'Capricorn'],
  [-1118111568,-1117935481,'Aquarius'],
  [-1117935481,-1117748593,'Pisces'],
  [-1117748593,-1117548286,'Aries'],
  [-1117548286,-1117336242,'Taurus'],
  [-1117336242,-1117117588,'Gemini'],
  [-1117117588,-1116898066,'Cancer'],
  [-1116898066,-1116682373,'Leo'],
  [-1116682373,-1116474148,'Virgo'],
  [-1116474148,-1116276192,'Libra'],
  [-1116276192,-1116089485,'Scorpio'],
  [-1116089485,-1115912177,'Sagittarius'],
  [-1115912177,-1115739739,'Capricorn'],
  [-1115739739,-1115565912,'Aquarius'],
  [-1115565912,-1115384042,'Pisces'],
  [-1115384042,-1115189009,'Aries'],
  [-1115189009,-1114979944,'Taurus'],
  [-1114979944,-1114761758,'Gemini'],
  [-1114761758,-1114542429,'Cancer'],
  [-1114542429,-1114328171,'Leo'],
  [-1114328171,-1114121524,'Virgo'],
  [-1114121524,-1113922854,'Libra'],
  [-1113922854,-1113732117,'Scorpio'],
  [-1113732117,-1113548887,'Sagittarius'],
  [-1113548887,-1113371315,'Capricorn'],
  [-1113371315,-1113195328,'Aquarius'],
  [-1113195328,-1113015001,'Pisces'],
  [-1113015001,-1112824163,'Aries'],
  [-1112824163,-1112619298,'Taurus'],
  [-1112619298,-1112402933,'Gemini'],
  [-1112402933,-1112183560,'Cancer'],
  [-1112183560,-1111969937,'Leo'],
  [-1111969937,-1111765763,'Virgo'],
  [-1111765763,-1111569940,'Libra'],
  [-1111569940,-1111379894,'Scorpio'],
  [-1111379894,-1111193894,'Sagittarius'],
  [-1111193894,-1111011106,'Capricorn'],
  [-1111011106,-1110830012,'Aquarius'],
  [-1110830012,-1110647046,'Pisces'],
  [-1110647046,-1110456972,'Aries'],
  [-1110456972,-1110255143,'Taurus'],
  [-1110255143,-1110041244,'Gemini'],
  [-1110041244,-1109821859,'Cancer'],
  [-1109821859,-1109607169,'Leo'],
  [-1109607169,-1109403630,'Virgo'],
  [-1109403630,-1109211018,'Libra'],
  [-1109211018,-1109025193,'Scorpio'],
  [-1109025193,-1108841775,'Sagittarius'],
  [-1108841775,-1108658115,'Capricorn'],
  [-1108658115,-1108473115,'Aquarius'],
  [-1108473115,-1108285510,'Pisces'],
  [-1108285510,-1108092604,'Aries'],
  [-1108092604,-1107890878,'Taurus'],
  [-1107890878,-1107678661,'Gemini'],
  [-1107678661,-1107459586,'Cancer'],
  [-1107459586,-1107242683,'Leo'],
  [-1107242683,-1107036675,'Virgo'],
  [-1107036675,-1106844172,'Libra'],
  [-1106844172,-1106661807,'Scorpio'],
  [-1106661807,-1106483758,'Sagittarius'],
  [-1106483758,-1106304647,'Capricorn'],
  [-1106304647,-1106120996,'Aquarius'],
  [-1106120996,-1105931239,'Pisces'],
  [-1105931239,-1105734630,'Aries'],
  [-1105734630,-1105530351,'Taurus'],
  [-1105530351,-1105317916,'Gemini'],
  [-1105317916,-1105099277,'Cancer'],
  [-1105099277,-1104880598,'Leo'],
  [-1104880598,-1104670289,'Virgo'],
  [-1104670289,-1104473795,'Libra'],
  [-1104473795,-1104290579,'Scorpio'],
  [-1104290579,-1104115672,'Sagittarius'],
  [-1104115672,-1103942502,'Capricorn'],
  [-1103942502,-1103764911,'Aquarius'],
  [-1103764911,-1103578522,'Pisces'],
  [-1103578522,-1103381570,'Aries'],
  [-1103381570,-1103174848,'Taurus'],
  [-1103174848,-1102960655,'Gemini'],
  [-1102960655,-1102741967,'Cancer'],
  [-1102741967,-1102522964,'Leo'],
  [-1102522964,-1102309446,'Virgo'],
  [-1102309446,-1102107194,'Libra'],
  [-1102107194,-1101918695,'Scorpio'],
  [-1101918695,-1101741810,'Sagittarius'],
  [-1101741810,-1101570976,'Capricorn'],
  [-1101570976,-1101399138,'Aquarius'],
  [-1101399138,-1101219452,'Pisces'],
  [-1101219452,-1101027114,'Aries'],
  [-1101027114,-1100821387,'Taurus'],
  [-1100821387,-1100606005,'Gemini'],
  [-1100606005,-1100386673,'Cancer'],
  [-1100386673,-1100168265,'Leo'],
  [-1100168265,-1099954400,'Virgo'],
  [-1099954400,-1099748565,'Libra'],
  [-1099748565,-1099553810,'Scorpio'],
  [-1099553810,-1099370899,'Sagittarius'],
  [-1099370899,-1099197079,'Capricorn'],
  [-1099197079,-1099026482,'Aquarius'],
  [-1099026482,-1098851704,'Pisces'],
  [-1098851704,-1098665748,'Aries'],
  [-1098665748,-1098464767,'Taurus'],
  [-1098464767,-1098250841,'Gemini'],
  [-1098250841,-1098031196,'Cancer'],
  [-1098031196,-1097813249,'Leo'],
  [-1097813249,-1097600921,'Virgo'],
  [-1097600921,-1097395446,'Libra'],
  [-1097395446,-1097197794,'Scorpio'],
  [-1097197794,-1097009108,'Sagittarius'],
  [-1097009108,-1096829199,'Capricorn'],
  [-1096829199,-1096654925,'Aquarius'],
  [-1096654925,-1096480282,'Pisces'],
  [-1096480282,-1096298047,'Aries'],
  [-1096298047,-1096102343,'Taurus'],
  [-1096102343,-1095892184,'Gemini'],
  [-1095892184,-1095673495,'Cancer'],
  [-1095673495,-1095455540,'Leo'],
  [-1095455540,-1095244528,'Virgo'],
  [-1095244528,-1095041608,'Libra'],
  [-1095041608,-1094845519,'Scorpio'],
  [-1094845519,-1094655334,'Sagittarius'],
  [-1094655334,-1094470850,'Capricorn'],
  [-1094470850,-1094291024,'Aquarius'],
  [-1094291024,-1094112437,'Pisces'],
  [-1094112437,-1093929499,'Aries'],
  [-1093929499,-1093736303,'Taurus'],
  [-1093736303,-1093529795,'Gemini'],
  [-1093529795,-1093313062,'Cancer'],
  [-1093313062,-1093094855,'Leo'],
  [-1093094855,-1092883648,'Virgo'],
  [-1092883648,-1092682563,'Libra'],
  [-1092682563,-1092489959,'Scorpio'],
  [-1092489959,-1092302707,'Sagittarius'],
  [-1092302707,-1092118414,'Capricorn'],
  [-1092118414,-1091935579,'Aquarius'],
  [-1091935579,-1091752380,'Pisces'],
  [-1091752380,-1091565678,'Aries'],
  [-1091565678,-1091371363,'Taurus'],
  [-1091371363,-1091166295,'Gemini'],
  [-1091166295,-1090951319,'Cancer'],
  [-1090951319,-1090732852,'Leo'],
  [-1090732852,-1090519882,'Virgo'],
  [-1090519882,-1090318120,'Libra'],
  [-1090318120,-1090127558,'Scorpio'],
  [-1090127558,-1089944516,'Sagittarius'],
  [-1089944516,-1089764427,'Capricorn'],
  [-1089764427,-1089583453,'Aquarius'],
  [-1089583453,-1089398877,'Pisces'],
  [-1089398877,-1089208706,'Aries'],
  [-1089208706,-1089011203,'Taurus'],
  [-1089011203,-1088805033,'Gemini'],
  [-1088805033,-1088590623,'Cancer'],
  [-1088590623,-1088371998,'Leo'],
  [-1088371998,-1088156582,'Virgo'],
  [-1088156582,-1087951584,'Libra'],
  [-1087951584,-1087759715,'Scorpio'],
  [-1087759715,-1087578660,'Sagittarius'],
  [-1087578660,-1087403219,'Capricorn'],
  [-1087403219,-1087227446,'Aquarius'],
  [-1087227446,-1087046177,'Pisces'],
  [-1087046177,-1086856108,'Aries'],
  [-1086856108,-1086656326,'Taurus'],
  [-1086656326,-1086447854,'Gemini'],
  [-1086447854,-1086232706,'Cancer'],
  [-1086232706,-1086014005,'Leo'],
  [-1086014005,-1085796778,'Virgo'],
  [-1085796778,-1085587532,'Libra'],
  [-1085587532,-1085391177,'Scorpio'],
  [-1085391177,-1085208117,'Sagittarius'],
  [-1085208117,-1085034347,'Capricorn'],
  [-1085034347,-1084863310,'Aquarius'],
  [-1084863310,-1084687870,'Pisces'],
  [-1084687870,-1084502165,'Aries'],
  [-1084502165,-1084303624,'Taurus'],
  [-1084303624,-1084093973,'Gemini'],
  [-1084093973,-1083877581,'Cancer'],
  [-1083877581,-1083658771,'Leo'],
  [-1083658771,-1083441192,'Virgo'],
  [-1083441192,-1083229078,'Libra'],
  [-1083229078,-1083027308,'Scorpio'],
  [-1083027308,-1082838810,'Sagittarius'],
  [-1082838810,-1082662271,'Capricorn'],
  [-1082662271,-1082492295,'Aquarius'],
  [-1082492295,-1082321305,'Pisces'],
  [-1082321305,-1082141626,'Aries'],
  [-1082141626,-1081947957,'Taurus'],
  [-1081947957,-1081740157,'Gemini'],
  [-1081740157,-1081523414,'Cancer'],
  [-1081523414,-1081304417,'Leo'],
  [-1081304417,-1081087611,'Virgo'],
  [-1081087611,-1080875452,'Libra'],
  [-1080875452,-1080670652,'Scorpio'],
  [-1080670652,-1080476346,'Sagittarius'],
  [-1080476346,-1080293767,'Capricorn'],
  [-1080293767,-1080120197,'Aquarius'],
  [-1080120197,-1079949392,'Pisces'],
  [-1079949392,-1079773538,'Aries'],
  [-1079773538,-1079585586,'Taurus'],
  [-1079585586,-1079382433,'Gemini'],
  [-1079382433,-1079167414,'Cancer'],
  [-1079167414,-1078948424,'Leo'],
  [-1078948424,-1078732354,'Virgo'],
  [-1078732354,-1078522091,'Libra'],
  [-1078522091,-1078318269,'Scorpio'],
  [-1078318269,-1078121777,'Sagittarius'],
  [-1078121777,-1077933852,'Capricorn'],
  [-1077933852,-1077754086,'Aquarius'],
  [-1077754086,-1077578944,'Pisces'],
  [-1077578944,-1077402310,'Aries'],
  [-1077402310,-1077217309,'Taurus'],
  [-1077217309,-1077018976,'Gemini'],
  [-1077018976,-1076807484,'Cancer'],
  [-1076807484,-1076589231,'Leo'],
  [-1076589231,-1076372958,'Virgo'],
  [-1076372958,-1076164077,'Libra'],
  [-1076164077,-1075963368,'Scorpio'],
  [-1075963368,-1075769454,'Sagittarius'],
  [-1075769454,-1075581063,'Capricorn'],
  [-1075581063,-1075397280,'Aquarius'],
  [-1075397280,-1075216402,'Pisces'],
  [-1075216402,-1075035060,'Aries'],
  [-1075035060,-1074848511,'Taurus'],
  [-1074848511,-1074652134,'Gemini'],
  [-1074652134,-1074443983,'Cancer'],
  [-1074443983,-1074227289,'Leo'],
  [-1074227289,-1074010049,'Virgo'],
  [-1074010049,-1073800225,'Libra'],
  [-1073800225,-1073601116,'Scorpio'],
  [-1073601116,-1073411322,'Sagittarius'],
  [-1073411322,-1073227250,'Capricorn'],
  [-1073227250,-1073045220,'Aquarius'],
  [-1073045220,-1072862346,'Pisces'],
  [-1072862346,-1072676433,'Aries'],
  [-1072676433,-1072485443,'Taurus'],
  [-1072485443,-1072287195,'Gemini'],
  [-1072287195,-1072080056,'Cancer'],
  [-1072080056,-1071864880,'Leo'],
  [-1071864880,-1071646806,'Virgo'],
  [-1071646806,-1071434021,'Libra'],
  [-1071434021,-1071232884,'Scorpio'],
  [-1071232884,-1071044410,'Sagittarius'],
  [-1071044410,-1070864915,'Capricorn'],
  [-1070864915,-1070688549,'Aquarius'],
  [-1070688549,-1070509574,'Pisces'],
  [-1070509574,-1070323940,'Aries'],
  [-1070323940,-1070130063,'Taurus'],
  [-1070130063,-1069928291,'Gemini'],
  [-1069928291,-1069719496,'Cancer'],
  [-1069719496,-1069504659,'Leo'],
  [-1069504659,-1069286407,'Virgo'],
  [-1069286407,-1069070640,'Libra'],
  [-1069070640,-1068864796,'Scorpio'],
  [-1068864796,-1068673150,'Sagittarius'],
  [-1068673150,-1068494249,'Capricorn'],
  [-1068494249,-1068322206,'Aquarius'],
  [-1068322206,-1068149487,'Pisces'],
  [-1068149487,-1067969282,'Aries'],
  [-1067969282,-1067777618,'Taurus'],
  [-1067777618,-1067574690,'Gemini'],
  [-1067574690,-1067363649,'Cancer'],
  [-1067363649,-1067147824,'Leo'],
  [-1067147824,-1066929706,'Virgo'],
  [-1066929706,-1066712689,'Libra'],
  [-1066712689,-1066502544,'Scorpio'],
  [-1066502544,-1066305089,'Sagittarius'],
  [-1066305089,-1066122048,'Capricorn'],
  [-1066122048,-1065949592,'Aquarius'],
  [-1065949592,-1065780378,'Pisces'],
  [-1065780378,-1065606266,'Aries'],
  [-1065606266,-1065420658,'Taurus'],
  [-1065420658,-1065221044,'Gemini'],
  [-1065221044,-1065010092,'Cancer'],
  [-1065010092,-1064793243,'Leo'],
  [-1064793243,-1064575074,'Virgo'],
  [-1064575074,-1064358525,'Libra'],
  [-1064358525,-1064146950,'Scorpio'],
  [-1064146950,-1063944901,'Sagittarius'],
  [-1063944901,-1063755700,'Capricorn'],
  [-1063755700,-1063578442,'Aquarius'],
  [-1063578442,-1063407797,'Pisces'],
  [-1063407797,-1063236159,'Aries'],
  [-1063236159,-1063055959,'Taurus'],
  [-1063055959,-1062862111,'Gemini'],
  [-1062862111,-1062654507,'Cancer'],
  [-1062654507,-1062438188,'Leo'],
  [-1062438188,-1062219893,'Virgo'],
  [-1062219893,-1062004322,'Libra'],
  [-1062004322,-1061794025,'Scorpio'],
  [-1061794025,-1061591177,'Sagittarius'],
  [-1061591177,-1061397949,'Capricorn'],
  [-1061397949,-1061214822,'Aquarius'],
  [-1061214822,-1061039096,'Pisces'],
  [-1061039096,-1060865264,'Aries'],
  [-1060865264,-1060686607,'Taurus'],
  [-1060686607,-1060497177,'Gemini'],
  [-1060497177,-1060294247,'Cancer'],
  [-1060294247,-1060080295,'Leo'],
  [-1060080295,-1059862211,'Virgo'],
  [-1059862211,-1059647052,'Libra'],
  [-1059647052,-1059438731,'Scorpio'],
  [-1059438731,-1059238260,'Sagittarius'],
  [-1059238260,-1059045389,'Capricorn'],
  [-1059045389,-1058859378,'Aquarius'],
  [-1058859378,-1058678552,'Pisces'],
  [-1058678552,-1058499772,'Aries'],
  [-1058499772,-1058318555,'Taurus'],
  [-1058318555,-1058129955,'Gemini'],
  [-1058129955,-1057930248,'Cancer'],
  [-1057930248,-1057719236,'Leo'],
  [-1057719236,-1057501814,'Virgo'],
  [-1057501814,-1057286071,'Libra'],
  [-1057286071,-1057078413,'Scorpio'],
  [-1057078413,-1056880768,'Sagittarius'],
  [-1056880768,-1056691419,'Capricorn'],
  [-1056691419,-1056507180,'Aquarius'],
  [-1056507180,-1056324954,'Pisces'],
  [-1056324954,-1056142181,'Aries'],
  [-1056142181,-1055956533,'Taurus'],
  [-1055956533,-1055765398,'Gemini'],
  [-1055765398,-1055566002,'Cancer'],
  [-1055566002,-1055356866,'Leo'],
  [-1055356866,-1055140249,'Virgo'],
  [-1055140249,-1054923150,'Libra'],
  [-1054923150,-1054713912,'Scorpio'],
  [-1054713912,-1054516921,'Sagittarius'],
  [-1054516921,-1054330956,'Capricorn'],
  [-1054330956,-1054151248,'Aquarius'],
  [-1054151248,-1053972273,'Pisces'],
  [-1053972273,-1053789733,'Aries'],
  [-1053789733,-1053601412,'Taurus'],
  [-1053601412,-1053406679,'Gemini'],
  [-1053406679,-1053205097,'Cancer'],
  [-1053205097,-1052995928,'Leo'],
  [-1052995928,-1052779799,'Virgo'],
  [-1052779799,-1052561303,'Libra'],
  [-1052561303,-1052348743,'Scorpio'],
  [-1052348743,-1052149109,'Sagittarius'],
  [-1052149109,-1051963471,'Capricorn'],
  [-1051963471,-1051787315,'Aquarius'],
  [-1051787315,-1051613633,'Pisces'],
  [-1051613633,-1051435719,'Aries'],
  [-1051435719,-1051249224,'Taurus'],
  [-1051249224,-1051053200,'Gemini'],
  [-1051053200,-1050849045,'Cancer'],
  [-1050849045,-1050638302,'Leo'],
  [-1050638302,-1050422031,'Virgo'],
  [-1050422031,-1050202846,'Libra'],
  [-1050202846,-1049987025,'Scorpio'],
  [-1049987025,-1049782415,'Sagittarius'],
  [-1049782415,-1049593034,'Capricorn'],
  [-1049593034,-1049416507,'Aquarius'],
  [-1049416507,-1049246115,'Pisces'],
  [-1049246115,-1049073918,'Aries'],
  [-1049073918,-1048893131,'Taurus'],
  [-1048893131,-1048700257,'Gemini'],
  [-1048700257,-1048496026,'Cancer'],
  [-1048496026,-1048283754,'Leo'],
  [-1048283754,-1048066756,'Virgo'],
  [-1048066756,-1047847701,'Libra'],
  [-1047847701,-1047630595,'Scorpio'],
  [-1047630595,-1047421603,'Sagittarius'],
  [-1047421603,-1047226094,'Capricorn'],
  [-1047226094,-1047044729,'Aquarius'],
  [-1047044729,-1046872947,'Pisces'],
  [-1046872947,-1046703381,'Aries'],
  [-1046703381,-1046528299,'Taurus'],
  [-1046528299,-1046341676,'Gemini'],
  [-1046341676,-1046141334,'Cancer'],
  [-1046141334,-1045929724,'Leo'],
  [-1045929724,-1045712088,'Virgo'],
  [-1045712088,-1045493345,'Libra'],
  [-1045493345,-1045277162,'Scorpio'],
  [-1045277162,-1045067182,'Sagittarius'],
  [-1045067182,-1044867192,'Capricorn'],
  [-1044867192,-1044679234,'Aquarius'],
  [-1044679234,-1044501708,'Pisces'],
  [-1044501708,-1044329631,'Aries'],
  [-1044329631,-1044156257,'Taurus'],
  [-1044156257,-1043974813,'Gemini'],
  [-1043974813,-1043780461,'Cancer'],
  [-1043780461,-1043572543,'Leo'],
  [-1043572543,-1043355563,'Virgo'],
  [-1043355563,-1043136766,'Libra'],
  [-1043136766,-1042921996,'Scorpio'],
  [-1042921996,-1042714191,'Sagittarius'],
  [-1042714191,-1042514413,'Capricorn'],
  [-1042514413,-1042322976,'Aquarius'],
  [-1042322976,-1042139263,'Pisces'],
  [-1042139263,-1041961051,'Aries'],
  [-1041961051,-1041784278,'Taurus'],
  [-1041784278,-1041603536,'Gemini'],
  [-1041603536,-1041413320,'Cancer'],
  [-1041413320,-1041210203,'Leo'],
  [-1041210203,-1040995638,'Virgo'],
  [-1040995638,-1040776710,'Libra'],
  [-1040776710,-1040562033,'Scorpio'],
  [-1040562033,-1040356530,'Sagittarius'],
  [-1040356530,-1040160292,'Capricorn'],
  [-1040160292,-1039970850,'Aquarius'],
  [-1039970850,-1039785558,'Pisces'],
  [-1039785558,-1039602490,'Aries'],
  [-1039602490,-1039419968,'Taurus'],
  [-1039419968,-1039235444,'Gemini'],
  [-1039235444,-1039045034,'Cancer'],
  [-1039045034,-1038844666,'Leo'],
  [-1038844666,-1038632970,'Virgo'],
  [-1038632970,-1038414384,'Libra'],
  [-1038414384,-1038198233,'Scorpio'],
  [-1038198233,-1037992492,'Sagittarius'],
  [-1037992492,-1037798946,'Capricorn'],
  [-1037798946,-1037614085,'Aquarius'],
  [-1037614085,-1037432632,'Pisces'],
  [-1037432632,-1037250292,'Aries'],
  [-1037250292,-1037064904,'Taurus'],
  [-1037064904,-1036875758,'Gemini'],
  [-1036875758,-1036681781,'Cancer'],
  [-1036681781,-1036480651,'Leo'],
  [-1036480651,-1036270317,'Virgo'],
  [-1036270317,-1036052409,'Libra'],
  [-1036052409,-1035834326,'Scorpio'],
  [-1035834326,-1035625603,'Sagittarius'],
  [-1035625603,-1035431101,'Capricorn'],
  [-1035431101,-1035248726,'Aquarius'],
  [-1035248726,-1035072325,'Pisces'],
  [-1035072325,-1034895247,'Aries'],
  [-1034895247,-1034712701,'Taurus'],
  [-1034712701,-1034522795,'Gemini'],
  [-1034522795,-1034325708,'Cancer'],
  [-1034325708,-1034121744,'Leo'],
  [-1034121744,-1033910579,'Virgo'],
  [-1033910579,-1033692988,'Libra'],
  [-1033692988,-1033473703,'Scorpio'],
  [-1033473703,-1033261164,'Sagittarius'],
  [-1033261164,-1033062372,'Capricorn'],
  [-1033062372,-1032878134,'Aquarius'],
  [-1032878134,-1032703577,'Pisces'],
  [-1032703577,-1032531471,'Aries'],
  [-1032531471,-1032354954,'Taurus'],
  [-1032354954,-1032169355,'Gemini'],
  [-1032169355,-1031973180,'Cancer'],
  [-1031973180,-1031767545,'Leo'],
  [-1031767545,-1031554588,'Virgo'],
  [-1031554588,-1031336594,'Libra'],
  [-1031336594,-1031117138,'Scorpio'],
  [-1031117138,-1030902224,'Sagittarius'],
  [-1030902224,-1030698458,'Capricorn'],
  [-1030698458,-1030509021,'Aquarius'],
  [-1030509021,-1030331731,'Pisces'],
  [-1030331731,-1030160670,'Aries'],
  [-1030160670,-1029988677,'Taurus'],
  [-1029988677,-1029809214,'Gemini'],
  [-1029809214,-1029617956,'Cancer'],
  [-1029617956,-1029414117,'Leo'],
  [-1029414117,-1029200532,'Virgo'],
  [-1029200532,-1028981872,'Libra'],
  [-1028981872,-1028762808,'Scorpio'],
  [-1028762808,-1028547839,'Sagittarius'],
  [-1028547839,-1028341353,'Capricorn'],
  [-1028341353,-1028146560,'Aquarius'],
  [-1028146560,-1027963610,'Pisces'],
  [-1027963610,-1027789157,'Aries'],
  [-1027789157,-1027617465,'Taurus'],
  [-1027617465,-1027441874,'Gemini'],
  [-1027441874,-1027256283,'Cancer'],
  [-1027256283,-1027057091,'Leo'],
  [-1027057091,-1026845298,'Virgo'],
  [-1026845298,-1026626563,'Libra'],
  [-1026626563,-1026407873,'Scorpio'],
  [-1026407873,-1026194307,'Sagittarius'],
  [-1026194307,-1025988406,'Capricorn'],
  [-1025988406,-1025791316,'Aquarius'],
  [-1025791316,-1025603304,'Pisces'],
  [-1025603304,-1025423168,'Aries'],
  [-1025423168,-1025247708,'Taurus'],
  [-1025247708,-1025071798,'Gemini'],
  [-1025071798,-1024889295,'Cancer'],
  [-1024889295,-1024694815,'Leo'],
  [-1024694815,-1024486581,'Virgo'],
  [-1024486581,-1024268865,'Libra'],
  [-1024268865,-1024050213,'Scorpio'],
  [-1024050213,-1023837881,'Sagittarius'],
  [-1023837881,-1023634456,'Capricorn'],
  [-1023634456,-1023438996,'Aquarius'],
  [-1023438996,-1023249743,'Pisces'],
  [-1023249743,-1023065398,'Aries'],
  [-1023065398,-1022884640,'Taurus'],
  [-1022884640,-1022704854,'Gemini'],
  [-1022704854,-1022521535,'Cancer'],
  [-1022521535,-1022329275,'Leo'],
  [-1022329275,-1022124382,'Virgo'],
  [-1022124382,-1021908468,'Libra'],
  [-1021908468,-1021689522,'Scorpio'],
  [-1021689522,-1021476978,'Sagittarius'],
  [-1021476978,-1021275370,'Capricorn'],
  [-1021275370,-1021083382,'Aquarius'],
  [-1021083382,-1020897083,'Pisces'],
  [-1020897083,-1020713014,'Aries'],
  [-1020713014,-1020529347,'Taurus'],
  [-1020529347,-1020345013,'Gemini'],
  [-1020345013,-1020157967,'Cancer'],
  [-1020157967,-1019964562,'Leo'],
  [-1019964562,-1019761008,'Virgo'],
  [-1019761008,-1019546738,'Libra'],
  [-1019546738,-1019327416,'Scorpio'],
  [-1019327416,-1019112949,'Sagittarius'],
  [-1019112949,-1018910542,'Capricorn'],
  [-1018910542,-1018720573,'Aquarius'],
  [-1018720573,-1018538558,'Pisces'],
  [-1018538558,-1018358876,'Aries'],
  [-1018358876,-1018177268,'Taurus'],
  [-1018177268,-1017991637,'Gemini'],
  [-1017991637,-1017801088,'Cancer'],
  [-1017801088,-1017604393,'Leo'],
  [-1017604393,-1017399640,'Virgo'],
  [-1017399640,-1017185925,'Libra'],
  [-1017185925,-1016966444,'Scorpio'],
  [-1016966444,-1016749340,'Sagittarius'],
  [-1016749340,-1016543280,'Capricorn'],
  [-1016543280,-1016351594,'Aquarius'],
  [-1016351594,-1016171357,'Pisces'],
  [-1016171357,-1015996456,'Aries'],
  [-1015996456,-1015820529,'Taurus'],
  [-1015820529,-1015638746,'Gemini'],
  [-1015638746,-1015448618,'Cancer'],
  [-1015448618,-1015249644,'Leo'],
  [-1015249644,-1015042359,'Virgo'],
  [-1015042359,-1014827774,'Libra'],
  [-1014827774,-1014608350,'Scorpio'],
  [-1014608350,-1014389569,'Sagittarius'],
  [-1014389569,-1014178963,'Capricorn'],
  [-1014178963,-1013982030,'Aquarius'],
  [-1013982030,-1013798920,'Pisces'],
  [-1013798920,-1013625129,'Aries'],
  [-1013625129,-1013454002,'Taurus'],
  [-1013454002,-1013278732,'Gemini'],
  [-1013278732,-1013093878,'Cancer'],
  [-1013093878,-1012896806,'Leo'],
  [-1012896806,-1012688441,'Virgo'],
  [-1012688441,-1012472352,'Libra'],
  [-1012472352,-1012252802,'Scorpio'],
  [-1012252802,-1012034101,'Sagittarius'],
  [-1012034101,-1011821047,'Capricorn'],
  [-1011821047,-1011618469,'Aquarius'],
  [-1011618469,-1011428942,'Pisces'],
  [-1011428942,-1011251108,'Aries'],
  [-1011251108,-1011080098,'Taurus'],
  [-1011080098,-1010909069,'Gemini'],
  [-1010909069,-1010730814,'Cancer'],
  [-1010730814,-1010539661,'Leo'],
  [-1010539661,-1010334005,'Virgo'],
  [-1010334005,-1010117713,'Libra'],
  [-1010117713,-1009897744,'Scorpio'],
  [-1009897744,-1009679969,'Sagittarius'],
  [-1009679969,-1009467661,'Capricorn'],
  [-1009467661,-1009262932,'Aquarius'],
  [-1009262932,-1009067777,'Pisces'],
  [-1009067777,-1008883087,'Aries'],
  [-1008883087,-1008707136,'Taurus'],
  [-1008707136,-1008535086,'Gemini'],
  [-1008535086,-1008360011,'Cancer'],
  [-1008360011,-1008174736,'Leo'],
  [-1008174736,-1007974586,'Virgo'],
  [-1007974586,-1007760797,'Libra'],
  [-1007760797,-1007540888,'Scorpio'],
  [-1007540888,-1007323530,'Sagittarius'],
  [-1007323530,-1007113255,'Capricorn'],
  [-1007113255,-1006910459,'Aquarius'],
  [-1006910459,-1006714465,'Pisces'],
  [-1006714465,-1006525281,'Aries'],
  [-1006525281,-1006342932,'Taurus'],
  [-1006342932,-1006165554,'Gemini'],
  [-1006165554,-1005988451,'Cancer'],
  [-1005988451,-1005805093,'Leo'],
  [-1005805093,-1005609481,'Virgo'],
  [-1005609481,-1005399754,'Libra'],
  [-1005399754,-1005181116,'Scorpio'],
  [-1005181116,-1004963377,'Sagittarius'],
  [-1004963377,-1004753895,'Capricorn'],
  [-1004753895,-1004554010,'Aquarius'],
  [-1004554010,-1004361322,'Pisces'],
  [-1004361322,-1004173179,'Aries'],
  [-1004173179,-1003988241,'Taurus'],
  [-1003988241,-1003805711,'Gemini'],
  [-1003805711,-1003623527,'Cancer'],
  [-1003623527,-1003437568,'Leo'],
  [-1003437568,-1003242773,'Virgo'],
  [-1003242773,-1003035938,'Libra'],
  [-1003035938,-1002819226,'Scorpio'],
  [-1002819226,-1002600872,'Sagittarius'],
  [-1002600872,-1002390071,'Capricorn'],
  [-1002390071,-1002190882,'Aquarius'],
  [-1002190882,-1002001599,'Pisces'],
  [-1002001599,-1001817949,'Aries'],
  [-1001817949,-1001635935,'Taurus'],
  [-1001635935,-1001452948,'Gemini'],
  [-1001452948,-1001267292,'Cancer'],
  [-1001267292,-1001077063,'Leo'],
  [-1001077063,-1000879698,'Virgo'],
  [-1000879698,-1000672981,'Libra'],
  [-1000672981,-1000457527,'Scorpio'],
  [-1000457527,-1000238792,'Sagittarius'],
  [-1000238792,-1000025389,'Capricorn'],
  [-1000025389,-999823787,'Aquarius'],
  [-999823787,-999634782,'Pisces'],
  [-999634782,-999454645,'Aries'],
  [-999454645,-999277889,'Taurus'],
  [-999277889,-999099309,'Gemini'],
  [-999099309,-998915073,'Cancer'],
  [-998915073,-998723051,'Leo'],
  [-998723051,-998522562,'Virgo'],
  [-998522562,-998313852,'Libra'],
  [-998313852,-998098267,'Scorpio'],
  [-998098267,-997879433,'Sagittarius'],
  [-997879433,-997663663,'Capricorn'],
  [-997663663,-997457824,'Aquarius'],
  [-997457824,-997265420,'Pisces'],
  [-997265420,-997085005,'Aries'],
  [-997085005,-996911544,'Taurus'],
  [-996911544,-996738502,'Gemini'],
  [-996738502,-996559588,'Cancer'],
  [-996559588,-996370315,'Leo'],
  [-996370315,-996169382,'Virgo'],
  [-996169382,-995958773,'Libra'],
  [-995958773,-995742112,'Scorpio'],
  [-995742112,-995523275,'Sagittarius'],
  [-995523275,-995306523,'Capricorn'],
  [-995306523,-995096994,'Aquarius'],
  [-995096994,-994899281,'Pisces'],
  [-994899281,-994714711,'Aries'],
  [-994714711,-994540367,'Taurus'],
  [-994540367,-994370138,'Gemini'],
  [-994370138,-994196608,'Cancer'],
  [-994196608,-994012977,'Leo'],
  [-994012977,-993815431,'Virgo'],
  [-993815431,-993605221,'Libra'],
  [-993605221,-993387747,'Scorpio'],
  [-993387747,-993168867,'Sagittarius'],
  [-993168867,-992952577,'Capricorn'],
  [-992952577,-992741826,'Aquarius'],
  [-992741826,-992539923,'Pisces'],
  [-992539923,-992349555,'Aries'],
  [-992349555,-992170530,'Taurus'],
  [-992170530,-991998767,'Gemini'],
  [-991998767,-991827378,'Cancer'],
  [-991827378,-991648651,'Leo'],
  [-991648651,-991456480,'Virgo'],
  [-991456480,-991249531,'Libra'],
  [-991249531,-991032688,'Scorpio'],
  [-991032688,-990813786,'Sagittarius'],
  [-990813786,-990598496,'Capricorn'],
  [-990598496,-990389027,'Aquarius'],
  [-990389027,-990186404,'Pisces'],
  [-990186404,-989992155,'Aries'],
  [-989992155,-989807383,'Taurus'],
  [-989807383,-989630615,'Gemini'],
  [-989630615,-989457035,'Cancer'],
  [-989457035,-989279697,'Leo'],
  [-989279697,-989091693,'Virgo'],
  [-989091693,-988889244,'Libra'],
  [-988889244,-988674733,'Scorpio'],
  [-988674733,-988456057,'Sagittarius'],
  [-988456057,-988241193,'Capricorn'],
  [-988241193,-988033723,'Aquarius'],
  [-988033723,-987833542,'Pisces'],
  [-987833542,-987639758,'Aries'],
  [-987639758,-987452135,'Taurus'],
  [-987452135,-987270185,'Gemini'],
  [-987270185,-987091526,'Cancer'],
  [-987091526,-986911466,'Leo'],
  [-986911466,-986724143,'Virgo'],
  [-986724143,-986524878,'Libra'],
  [-986524878,-986313359,'Scorpio'],
  [-986313359,-986095339,'Sagittarius'],
  [-986095339,-985879740,'Capricorn'],
  [-985879740,-985672781,'Aquarius'],
  [-985672781,-985475449,'Pisces'],
  [-985475449,-985285466,'Aries'],
  [-985285466,-985099990,'Taurus'],
  [-985099990,-984916822,'Gemini'],
  [-984916822,-984734059,'Cancer'],
  [-984734059,-984549225,'Leo'],
  [-984549225,-984358962,'Virgo'],
  [-984358962,-984159816,'Libra'],
  [-984159816,-983950278,'Scorpio'],
  [-983950278,-983733214,'Sagittarius'],
  [-983733214,-983516093,'Capricorn'],
  [-983516093,-983307049,'Aquarius'],
  [-983307049,-983109912,'Pisces'],
  [-983109912,-982923296,'Aries'],
  [-982923296,-982742880,'Taurus'],
  [-982742880,-982563737,'Gemini'],
  [-982563737,-982381792,'Cancer'],
  [-982381792,-982194394,'Leo'],
  [-982194394,-982000144,'Virgo'],
  [-982000144,-981798300,'Libra'],
  [-981798300,-981588563,'Scorpio'],
  [-981588563,-981372218,'Sagittarius'],
  [-981372218,-981153860,'Capricorn'],
  [-981153860,-980941056,'Aquarius'],
  [-980941056,-980740325,'Pisces'],
  [-980740325,-980553189,'Aries'],
  [-980553189,-980376118,'Taurus'],
  [-980376118,-980202811,'Gemini'],
  [-980202811,-980026537,'Cancer'],
  [-980026537,-979842024,'Leo'],
  [-979842024,-979646988,'Virgo'],
  [-979646988,-979442369,'Libra'],
  [-979442369,-979230641,'Scorpio'],
  [-979230641,-979014128,'Sagittarius'],
  [-979014128,-978795522,'Capricorn'],
  [-978795522,-978579730,'Aquarius'],
  [-978579730,-978373480,'Pisces'],
  [-978373480,-978181376,'Aries'],
  [-978181376,-978002752,'Taurus'],
  [-978002752,-977832118,'Gemini'],
  [-977832118,-977661706,'Cancer'],
  [-977661706,-977483841,'Leo'],
  [-977483841,-977293271,'Virgo'],
  [-977293271,-977089440,'Libra'],
  [-977089440,-976876254,'Scorpio'],
  [-976876254,-976658759,'Sagittarius'],
  [-976658759,-976440449,'Capricorn'],
  [-976440449,-976224128,'Aquarius'],
  [-976224128,-976014148,'Pisces'],
  [-976014148,-975815672,'Aries'],
  [-975815672,-975631110,'Taurus'],
  [-975631110,-975457749,'Gemini'],
  [-975457749,-975288842,'Cancer'],
  [-975288842,-975116158,'Leo'],
  [-975116158,-974932315,'Virgo'],
  [-974932315,-974733566,'Libra'],
  [-974733566,-974522003,'Scorpio'],
  [-974522003,-974304037,'Sagittarius'],
  [-974304037,-974085808,'Capricorn'],
  [-974085808,-973870649,'Aquarius'],
  [-973870649,-973660714,'Pisces'],
  [-973660714,-973458947,'Aries'],
  [-973458947,-973268201,'Taurus'],
  [-973268201,-973088522,'Gemini'],
  [-973088522,-972915877,'Cancer'],
  [-972915877,-972743433,'Leo'],
  [-972743433,-972563685,'Virgo'],
  [-972563685,-972370871,'Libra'],
  [-972370871,-972163823,'Scorpio'],
  [-972163823,-971947262,'Sagittarius'],
  [-971947262,-971728965,'Capricorn'],
  [-971728965,-971514789,'Aquarius'],
  [-971514789,-971307102,'Pisces'],
  [-971307102,-971106597,'Aries'],
  [-971106597,-970913888,'Taurus'],
  [-970913888,-970729088,'Gemini'],
  [-970729088,-970550418,'Cancer'],
  [-970550418,-970373714,'Leo'],
  [-970373714,-970193240,'Virgo'],
  [-970193240,-970003334,'Libra'],
  [-970003334,-969800747,'Scorpio'],
  [-969800747,-969587083,'Sagittarius'],
  [-969587083,-969369073,'Capricorn'],
  [-969369073,-969154697,'Aquarius'],
  [-969154697,-968948618,'Pisces'],
  [-968948618,-968751408,'Aries'],
  [-968751408,-968561385,'Taurus'],
  [-968561385,-968376363,'Gemini'],
  [-968376363,-968194162,'Cancer'],
  [-968194162,-968012314,'Leo'],
  [-968012314,-967827679,'Virgo'],
  [-967827679,-967636562,'Libra'],
  [-967636562,-967435768,'Scorpio'],
  [-967435768,-967224683,'Sagittarius'],
  [-967224683,-967007346,'Capricorn'],
  [-967007346,-966791705,'Aquarius'],
  [-966791705,-966584973,'Pisces'],
  [-966584973,-966389680,'Aries'],
  [-966389680,-966203722,'Taurus'],
  [-966203722,-966022670,'Gemini'],
  [-966022670,-965842004,'Cancer'],
  [-965842004,-965658375,'Leo'],
  [-965658375,-965469836,'Virgo'],
  [-965469836,-965275171,'Libra'],
  [-965275171,-965073123,'Scorpio'],
  [-965073123,-964862877,'Sagittarius'],
  [-964862877,-964646145,'Capricorn'],
  [-964646145,-964428891,'Aquarius'],
  [-964428891,-964219354,'Pisces'],
  [-964219354,-964022814,'Aries'],
  [-964022814,-963838743,'Taurus'],
  [-963838743,-963662138,'Gemini'],
  [-963662138,-963486422,'Cancer'],
  [-963486422,-963305852,'Leo'],
  [-963305852,-963117155,'Virgo'],
  [-963117155,-962919926,'Libra'],
  [-962919926,-962715248,'Scorpio'],
  [-962715248,-962504038,'Sagittarius'],
  [-962504038,-962287429,'Capricorn'],
  [-962287429,-962069045,'Aquarius'],
  [-962069045,-961855982,'Pisces'],
  [-961855982,-961655347,'Aries'],
  [-961655347,-961469349,'Taurus'],
  [-961469349,-961294268,'Gemini'],
  [-961294268,-961123014,'Cancer'],
  [-961123014,-960948019,'Leo'],
  [-960948019,-960763516,'Virgo'],
  [-960763516,-960567418,'Libra'],
  [-960567418,-960361390,'Scorpio'],
  [-960361390,-960148579,'Sagittarius'],
  [-960148579,-959931553,'Capricorn'],
  [-959931553,-959712937,'Aquarius'],
  [-959712937,-959497566,'Pisces'],
  [-959497566,-959292111,'Aries'],
  [-959292111,-959101032,'Taurus'],
  [-959101032,-958923249,'Gemini'],
  [-958923249,-958752886,'Cancer'],
  [-958752886,-958582084,'Leo'],
  [-958582084,-958403411,'Virgo'],
  [-958403411,-958212122,'Libra'],
  [-958212122,-958007981,'Scorpio'],
  [-958007981,-957794698,'Sagittarius'],
  [-957794698,-957577087,'Capricorn'],
  [-957577087,-957358864,'Aquarius'],
  [-957358864,-957143443,'Pisces'],
  [-957143443,-956935296,'Aries'],
  [-956935296,-956738813,'Taurus'],
  [-956738813,-956555267,'Gemini'],
  [-956555267,-956381377,'Cancer'],
  [-956381377,-956210682,'Leo'],
  [-956210682,-956035725,'Virgo'],
  [-956035725,-955850095,'Libra'],
  [-955850095,-955650701,'Scorpio'],
  [-955650701,-955439325,'Sagittarius'],
  [-955439325,-955221653,'Capricorn'],
  [-955221653,-955003786,'Aquarius'],
  [-955003786,-954789847,'Pisces'],
  [-954789847,-954582477,'Aries'],
  [-954582477,-954383801,'Taurus'],
  [-954383801,-954195022,'Gemini'],
  [-954195022,-954015064,'Cancer'],
  [-954015064,-953840124,'Leo'],
  [-953840124,-953664482,'Virgo'],
  [-953664482,-953481898,'Libra'],
  [-953481898,-953287463,'Scorpio'],
  [-953287463,-953079936,'Sagittarius'],
  [-953079936,-952863351,'Capricorn'],
  [-952863351,-952645342,'Aquarius'],
  [-952645342,-952432545,'Pisces'],
  [-952432545,-952227913,'Aries'],
  [-952227913,-952031392,'Taurus'],
  [-952031392,-951841763,'Gemini'],
  [-951841763,-951657542,'Cancer'],
  [-951657542,-951476778,'Leo'],
  [-951476778,-951296512,'Virgo'],
  [-951296512,-951112582,'Libra'],
  [-951112582,-950920323,'Scorpio'],
  [-950920323,-950716465,'Sagittarius'],
  [-950716465,-950501979,'Capricorn'],
  [-950501979,-950283513,'Aquarius'],
  [-950283513,-950070021,'Pisces'],
  [-950070021,-949866976,'Aries'],
  [-949866976,-949674304,'Taurus'],
  [-949674304,-949488476,'Gemini'],
  [-949488476,-949305393,'Cancer'],
  [-949305393,-949122096,'Leo'],
  [-949122096,-948936947,'Virgo'],
  [-948936947,-948748541,'Libra'],
  [-948748541,-948554523,'Scorpio'],
  [-948554523,-948351876,'Sagittarius'],
  [-948351876,-948139333,'Capricorn'],
  [-948139333,-947920661,'Aquarius'],
  [-947920661,-947704767,'Pisces'],
  [-947704767,-947500067,'Aries'],
  [-947500067,-947308877,'Taurus'],
  [-947308877,-947127508,'Gemini'],
  [-947127508,-946949713,'Cancer'],
  [-946949713,-946769765,'Leo'],
  [-946769765,-946584299,'Virgo'],
  [-946584299,-946392564,'Libra'],
  [-946392564,-946194777,'Scorpio'],
  [-946194777,-945990345,'Sagittarius'],
  [-945990345,-945778215,'Capricorn'],
  [-945778215,-945559742,'Aquarius'],
  [-945559742,-945341368,'Pisces'],
  [-945341368,-945132372,'Aries'],
  [-945132372,-944938320,'Taurus'],
  [-944938320,-944757732,'Gemini'],
  [-944757732,-944584318,'Cancer'],
  [-944584318,-944410572,'Leo'],
  [-944410572,-944230312,'Virgo'],
  [-944230312,-944040425,'Libra'],
  [-944040425,-943841086,'Scorpio'],
  [-943841086,-943633992,'Sagittarius'],
  [-943633992,-943420536,'Capricorn'],
  [-943420536,-943202134,'Aquarius'],
  [-943202134,-942982717,'Pisces'],
  [-942982717,-942769624,'Aries'],
  [-942769624,-942569871,'Taurus'],
  [-942569871,-942385217,'Gemini'],
  [-942385217,-942211493,'Cancer'],
  [-942211493,-942041458,'Leo'],
  [-942041458,-941867567,'Virgo'],
  [-941867567,-941683923,'Libra'],
  [-941683923,-941487925,'Scorpio'],
  [-941487925,-941280721,'Sagittarius'],
  [-941280721,-941065811,'Capricorn'],
  [-941065811,-940846960,'Aquarius'],
  [-940846960,-940627872,'Pisces'],
  [-940627872,-940413350,'Aries'],
  [-940413350,-940208892,'Taurus'],
  [-940208892,-940017871,'Gemini'],
  [-940017871,-939839165,'Cancer'],
  [-939839165,-939667709,'Leo'],
  [-939667709,-939496572,'Virgo'],
  [-939496572,-939318791,'Libra'],
  [-939318791,-939129062,'Scorpio'],
  [-939129062,-938925612,'Sagittarius'],
  [-938925612,-938711282,'Capricorn'],
  [-938711282,-938491996,'Aquarius'],
  [-938491996,-938273544,'Pisces'],
  [-938273544,-938060121,'Aries'],
  [-938060121,-937854694,'Taurus'],
  [-937854694,-937659345,'Gemini'],
  [-937659345,-937474381,'Cancer'],
  [-937474381,-937297531,'Leo'],
  [-937297531,-937124152,'Virgo'],
  [-937124152,-936948150,'Libra'],
  [-936948150,-936763305,'Scorpio'],
  [-936763305,-936565214,'Sagittarius'],
  [-936565214,-936353922,'Capricorn'],
  [-936353922,-936135102,'Aquarius'],
  [-936135102,-935916889,'Pisces'],
  [-935916889,-935705157,'Aries'],
  [-935705157,-935501861,'Taurus'],
  [-935501861,-935306599,'Gemini'],
  [-935306599,-935118403,'Cancer'],
  [-935118403,-934936048,'Leo'],
  [-934936048,-934757410,'Virgo'],
  [-934757410,-934578743,'Libra'],
  [-934578743,-934394822,'Scorpio'],
  [-934394822,-934200366,'Sagittarius'],
  [-934200366,-933992816,'Capricorn'],
  [-933992816,-933775477,'Aquarius'],
  [-933775477,-933557034,'Pisces'],
  [-933557034,-933345851,'Aries'],
  [-933345851,-933145079,'Taurus'],
  [-933145079,-932953010,'Gemini'],
  [-932953010,-932766275,'Cancer'],
  [-932766275,-932582193,'Leo'],
  [-932582193,-932399231,'Virgo'],
  [-932399231,-932215867,'Libra'],
  [-932215867,-932029209,'Scorpio'],
  [-932029209,-931835018,'Sagittarius'],
  [-931835018,-931629753,'Capricorn'],
  [-931629753,-931414117,'Aquarius'],
  [-931414117,-931195185,'Pisces'],
  [-931195185,-930982773,'Aries'],
  [-930982773,-930782522,'Taurus'],
  [-930782522,-930593480,'Gemini'],
  [-930593480,-930410897,'Cancer'],
  [-930410897,-930229736,'Leo'],
  [-930229736,-930046706,'Virgo'],
  [-930046706,-929860410,'Libra'],
  [-929860410,-929669885,'Scorpio'],
  [-929669885,-929473194,'Sagittarius'],
  [-929473194,-929267791,'Capricorn'],
  [-929267791,-929053110,'Aquarius'],
  [-929053110,-928833733,'Pisces'],
  [-928833733,-928618828,'Aries'],
  [-928618828,-928416237,'Taurus'],
  [-928416237,-928227372,'Gemini'],
  [-928227372,-928047991,'Cancer'],
  [-928047991,-927871753,'Leo'],
  [-927871753,-927692999,'Virgo'],
  [-927692999,-927508235,'Libra'],
  [-927508235,-927316185,'Scorpio'],
  [-927316185,-927116603,'Sagittarius'],
  [-927116603,-926909244,'Capricorn'],
  [-926909244,-926694319,'Aquarius'],
  [-926694319,-926474747,'Pisces'],
  [-926474747,-926257466,'Aries'],
  [-926257466,-926050613,'Taurus'],
  [-926050613,-925858275,'Gemini'],
  [-925858275,-925678454,'Cancer'],
  [-925678454,-925505300,'Leo'],
  [-925505300,-925331975,'Virgo'],
  [-925331975,-925152565,'Libra'],
  [-925152565,-924963379,'Scorpio'],
  [-924963379,-924763489,'Sagittarius'],
  [-924763489,-924554260,'Capricorn'],
  [-924554260,-924338217,'Aquarius'],
  [-924338217,-924118648,'Pisces'],
  [-924118648,-923900443,'Aries'],
  [-923900443,-923689839,'Taurus'],
  [-923689839,-923491904,'Gemini'],
  [-923491904,-923307526,'Cancer'],
  [-923307526,-923133118,'Leo'],
  [-923133118,-922962471,'Virgo'],
  [-922962471,-922788620,'Libra'],
  [-922788620,-922605404,'Scorpio'],
  [-922605404,-922409198,'Sagittarius'],
  [-922409198,-922200471,'Capricorn'],
  [-922200471,-921983515,'Aquarius'],
  [-921983515,-921763889,'Pisces'],
  [-921763889,-921546362,'Aries'],
  [-921546362,-921334796,'Taurus'],
  [-921334796,-921132603,'Gemini'],
  [-921132603,-920941905,'Cancer'],
  [-920941905,-920762049,'Leo'],
  [-920762049,-920589239,'Virgo'],
  [-920589239,-920417349,'Libra'],
  [-920417349,-920239322,'Scorpio'],
  [-920239322,-920049035,'Sagittarius'],
  [-920049035,-919844034,'Capricorn'],
  [-919844034,-919627784,'Aquarius'],
  [-919627784,-919407976,'Pisces'],
  [-919407976,-919191524,'Aries'],
  [-919191524,-918981721,'Taurus'],
  [-918981721,-918779386,'Gemini'],
  [-918779386,-918584986,'Cancer'],
  [-918584986,-918398895,'Leo'],
  [-918398895,-918220150,'Virgo'],
  [-918220150,-918045224,'Libra'],
  [-918045224,-917868179,'Scorpio'],
  [-917868179,-917682192,'Sagittarius'],
  [-917682192,-917482245,'Capricorn'],
  [-917482245,-917268802,'Aquarius'],
  [-917268802,-917049171,'Pisces'],
  [-917049171,-916832835,'Aries'],
  [-916832835,-916625061,'Taurus'],
  [-916625061,-916425798,'Gemini'],
  [-916425798,-916232844,'Cancer'],
  [-916232844,-916044628,'Leo'],
  [-916044628,-915860653,'Virgo'],
  [-915860653,-915679915,'Libra'],
  [-915679915,-915499209,'Scorpio'],
  [-915499209,-915313181,'Sagittarius'],
  [-915313181,-915116278,'Capricorn'],
  [-915116278,-914906259,'Aquarius'],
  [-914906259,-914687626,'Pisces'],
  [-914687626,-914470254,'Aries'],
  [-914470254,-914262343,'Taurus'],
  [-914262343,-914065617,'Gemini'],
  [-914065617,-913876940,'Cancer'],
  [-913876940,-913692106,'Leo'],
  [-913692106,-913508251,'Virgo'],
  [-913508251,-913324079,'Libra'],
  [-913324079,-913138379,'Scorpio'],
  [-913138379,-912948571,'Sagittarius'],
  [-912948571,-912750893,'Capricorn'],
  [-912750893,-912542577,'Aquarius'],
  [-912542577,-912325290,'Pisces'],
  [-912325290,-912106637,'Aries'],
  [-912106637,-911896093,'Taurus'],
  [-911896093,-911698494,'Gemini'],
  [-911698494,-911512310,'Cancer'],
  [-911512310,-911332524,'Leo'],
  [-911332524,-911153761,'Virgo'],
  [-911153761,-910972022,'Libra'],
  [-910972022,-910785044,'Scorpio'],
  [-910785044,-910591602,'Sagittarius'],
  [-910591602,-910390655,'Capricorn'],
  [-910390655,-910181363,'Aquarius'],
  [-910181363,-909964676,'Pisces'],
  [-909964676,-909745361,'Aries'],
  [-909745361,-909531403,'Taurus'],
  [-909531403,-909329634,'Gemini'],
  [-909329634,-909141609,'Cancer'],
  [-909141609,-908963823,'Leo'],
  [-908963823,-908790274,'Virgo'],
  [-908790274,-908614674,'Libra'],
  [-908614674,-908431919,'Scorpio'],
  [-908431919,-908239128,'Sagittarius'],
  [-908239128,-908036074,'Capricorn'],
  [-908036074,-907824530,'Aquarius'],
  [-907824530,-907607221,'Pisces'],
  [-907607221,-907387877,'Aries'],
  [-907387877,-907171814,'Taurus'],
  [-907171814,-906965168,'Gemini'],
  [-906965168,-906771852,'Cancer'],
  [-906771852,-906591317,'Leo'],
  [-906591317,-906419017,'Virgo'],
  [-906419017,-906248234,'Libra'],
  [-906248234,-906071876,'Scorpio'],
  [-906071876,-905884235,'Sagittarius'],
  [-905884235,-905683060,'Capricorn'],
  [-905683060,-905470692,'Aquarius'],
  [-905470692,-905252340,'Pisces'],
  [-905252340,-905033114,'Aries'],
  [-905033114,-904816953,'Taurus'],
  [-904816953,-904607610,'Gemini'],
  [-904607610,-904408836,'Cancer'],
  [-904408836,-904222460,'Leo'],
  [-904222460,-904046726,'Virgo'],
  [-904046726,-903876348,'Libra'],
  [-903876348,-903704031,'Scorpio'],
  [-903704031,-903522381,'Sagittarius'],
  [-903522381,-903326356,'Capricorn'],
  [-903326356,-903116193,'Aquarius'],
  [-903116193,-902897788,'Pisces'],
  [-902897788,-902678612,'Aries'],
  [-902678612,-902463500,'Taurus'],
  [-902463500,-902254541,'Gemini'],
  [-902254541,-902053350,'Cancer'],
  [-902053350,-901861736,'Leo'],
  [-901861736,-901680140,'Virgo'],
  [-901680140,-901505884,'Libra'],
  [-901505884,-901333167,'Scorpio'],
  [-901333167,-901154645,'Sagittarius'],
  [-901154645,-900963732,'Capricorn'],
  [-900963732,-900757866,'Aquarius'],
  [-900757866,-900541115,'Pisces'],
  [-900541115,-900322079,'Aries'],
  [-900322079,-900107857,'Taurus'],
  [-900107857,-899900948,'Gemini'],
  [-899900948,-899701097,'Cancer'],
  [-899701097,-899508038,'Leo'],
  [-899508038,-899322031,'Virgo'],
  [-899322031,-899142296,'Libra'],
  [-899142296,-898965497,'Scorpio'],
  [-898965497,-898785942,'Sagittarius'],
  [-898785942,-898597268,'Capricorn'],
  [-898597268,-898395274,'Aquarius'],
  [-898395274,-898181248,'Pisces'],
  [-898181248,-897962624,'Aries'],
  [-897962624,-897748274,'Taurus'],
  [-897748274,-897542824,'Gemini'],
  [-897542824,-897346012,'Cancer'],
  [-897346012,-897155554,'Leo'],
  [-897155554,-896969524,'Virgo'],
  [-896969524,-896786630,'Libra'],
  [-896786630,-896605056,'Scorpio'],
  [-896605056,-896421492,'Sagittarius'],
  [-896421492,-896231433,'Capricorn'],
  [-896231433,-896030878,'Aquarius'],
  [-896030878,-895819174,'Pisces'],
  [-895819174,-895601183,'Aries'],
  [-895601183,-895385595,'Taurus'],
  [-895385595,-895179437,'Gemini'],
  [-895179437,-894984375,'Cancer'],
  [-894984375,-894797830,'Leo'],
  [-894797830,-894615757,'Virgo'],
  [-894615757,-894434493,'Libra'],
  [-894434493,-894251281,'Scorpio'],
  [-894251281,-894063916,'Sagittarius'],
  [-894063916,-893870264,'Capricorn'],
  [-893870264,-893668315,'Aquarius'],
  [-893668315,-893457348,'Pisces'],
  [-893457348,-893239937,'Aries'],
  [-893239937,-893022681,'Taurus'],
  [-893022681,-892813515,'Gemini'],
  [-892813515,-892616939,'Cancer'],
  [-892616939,-892432119,'Leo'],
  [-892432119,-892254571,'Virgo'],
  [-892254571,-892078502,'Libra'],
  [-892078502,-891898596,'Scorpio'],
  [-891898596,-891711212,'Sagittarius'],
  [-891711212,-891514936,'Capricorn'],
  [-891514936,-891310168,'Aquarius'],
  [-891310168,-891098149,'Pisces'],
  [-891098149,-890880941,'Aries'],
  [-890880941,-890662619,'Taurus'],
  [-890662619,-890449692,'Gemini'],
  [-890449692,-890248465,'Cancer'],
  [-890248465,-890061158,'Leo'],
  [-890061158,-889884922,'Virgo'],
  [-889884922,-889713538,'Libra'],
  [-889713538,-889539711,'Scorpio'],
  [-889539711,-889357080,'Sagittarius'],
  [-889357080,-889162272,'Capricorn'],
  [-889162272,-888956118,'Aquarius'],
  [-888956118,-888742316,'Pisces'],
  [-888742316,-888524712,'Aries'],
  [-888524712,-888306422,'Taurus'],
  [-888306422,-888091342,'Gemini'],
  [-888091342,-887884933,'Cancer'],
  [-887884933,-887691694,'Leo'],
  [-887691694,-887511898,'Virgo'],
  [-887511898,-887340964,'Libra'],
  [-887340964,-887171401,'Scorpio'],
  [-887171401,-886995155,'Sagittarius'],
  [-886995155,-886805988,'Capricorn'],
  [-886805988,-886602325,'Aquarius'],
  [-886602325,-886388148,'Pisces'],
  [-886388148,-886169832,'Aries'],
  [-886169832,-885952078,'Taurus'],
  [-885952078,-885737460,'Gemini'],
  [-885737460,-885528813,'Cancer'],
  [-885528813,-885330000,'Leo'],
  [-885330000,-885143578,'Virgo'],
  [-885143578,-884968051,'Libra'],
  [-884968051,-884797742,'Scorpio'],
  [-884797742,-884624827,'Sagittarius'],
  [-884624827,-884441660,'Capricorn'],
  [-884441660,-884243641,'Aquarius'],
  [-884243641,-884032113,'Pisces'],
  [-884032113,-883813850,'Aries'],
  [-883813850,-883596245,'Taurus'],
  [-883596245,-883383258,'Gemini'],
  [-883383258,-883176164,'Cancer'],
  [-883176164,-882976144,'Leo'],
  [-882976144,-882784896,'Virgo'],
  [-882784896,-882602825,'Libra'],
  [-882602825,-882427205,'Scorpio'],
  [-882427205,-882252367,'Sagittarius'],
  [-882252367,-882071363,'Capricorn'],
  [-882071363,-881878308,'Aquarius'],
  [-881878308,-881671375,'Pisces'],
  [-881671375,-881454828,'Aries'],
  [-881454828,-881236960,'Taurus'],
  [-881236960,-881024596,'Gemini'],
  [-881024596,-880820169,'Cancer'],
  [-880820169,-880623175,'Leo'],
  [-880623175,-880432527,'Virgo'],
  [-880432527,-880247325,'Libra'],
  [-880247325,-880066092,'Scorpio'],
  [-880066092,-879885864,'Sagittarius'],
  [-879885864,-879702190,'Capricorn'],
  [-879702190,-879510206,'Aquarius'],
  [-879510206,-879306724,'Pisces'],
  [-879306724,-879092822,'Aries'],
  [-879092822,-878874870,'Taurus'],
  [-878874870,-878661340,'Gemini'],
  [-878661340,-878457573,'Cancer'],
  [-878457573,-878263967,'Leo'],
  [-878263967,-878077713,'Virgo'],
  [-878077713,-877895112,'Libra'],
  [-877895112,-877712927,'Scorpio'],
  [-877712927,-877528683,'Sagittarius'],
  [-877528683,-877340284,'Capricorn'],
  [-877340284,-877145528,'Aquarius'],
  [-877145528,-876942311,'Pisces'],
  [-876942311,-876730173,'Aries'],
  [-876730173,-876512503,'Taurus'],
  [-876512503,-876296798,'Gemini'],
  [-876296798,-876090731,'Cancer'],
  [-876090731,-875897465,'Leo'],
  [-875897465,-875714831,'Virgo'],
  [-875714831,-875537507,'Libra'],
  [-875537507,-875359605,'Scorpio'],
  [-875359605,-875176521,'Sagittarius'],
  [-875176521,-874985947,'Capricorn'],
  [-874985947,-874787658,'Aquarius'],
  [-874787658,-874582149,'Pisces'],
  [-874582149,-874369860,'Aries'],
  [-874369860,-874152444,'Taurus'],
  [-874152444,-873934856,'Gemini'],
  [-873934856,-873724809,'Cancer'],
  [-873724809,-873528196,'Leo'],
  [-873528196,-873345335,'Virgo'],
  [-873345335,-873171362,'Libra'],
  [-873171362,-872999038,'Scorpio'],
  [-872999038,-872821340,'Sagittarius'],
  [-872821340,-872633547,'Capricorn'],
  [-872633547,-872434711,'Aquarius'],
  [-872434711,-872227008,'Pisces'],
  [-872227008,-872013266,'Aries'],
  [-872013266,-871795691,'Taurus'],
  [-871795691,-871577323,'Gemini'],
  [-871577323,-871363890,'Cancer'],
  [-871363890,-871162090,'Leo'],
  [-871162090,-870975062,'Virgo'],
  [-870975062,-870800140,'Libra'],
  [-870800140,-870630550,'Scorpio'],
  [-870630550,-870458269,'Sagittarius'],
  [-870458269,-870276340,'Capricorn'],
  [-870276340,-870081195,'Aquarius'],
  [-870081195,-869874033,'Pisces'],
  [-869874033,-869659250,'Aries'],
  [-869659250,-869441209,'Taurus'],
  [-869441209,-869223065,'Gemini'],
  [-869223065,-869008491,'Cancer'],
  [-869008491,-868802655,'Leo'],
  [-868802655,-868609863,'Virgo'],
  [-868609863,-868430175,'Libra'],
  [-868430175,-868258868,'Scorpio'],
  [-868258868,-868088574,'Sagittarius'],
  [-868088574,-867911613,'Capricorn'],
  [-867911613,-867722206,'Aquarius'],
  [-867722206,-867518830,'Pisces'],
  [-867518830,-867304964,'Aries'],
  [-867304964,-867086695,'Taurus'],
  [-867086695,-866869113,'Gemini'],
  [-866869113,-866655534,'Cancer'],
  [-866655534,-866448923,'Leo'],
  [-866448923,-866252249,'Virgo'],
  [-866252249,-866066768,'Libra'],
  [-866066768,-865890318,'Scorpio'],
  [-865890318,-865717634,'Sagittarius'],
  [-865717634,-865541952,'Capricorn'],
  [-865541952,-865356859,'Aquarius'],
  [-865356859,-865158489,'Pisces'],
  [-865158489,-864947640,'Aries'],
  [-864947640,-864729952,'Taurus'],
  [-864729952,-864512626,'Gemini'],
  [-864512626,-864300636,'Cancer'],
  [-864300636,-864096119,'Leo'],
  [-864096119,-863899655,'Virgo'],
  [-863899655,-863711133,'Libra'],
  [-863711133,-863529353,'Scorpio'],
  [-863529353,-863351439,'Sagittarius'],
  [-863351439,-863172919,'Capricorn'],
  [-863172919,-862988503,'Aquarius'],
  [-862988503,-862793566,'Pisces'],
  [-862793566,-862586364,'Aries'],
  [-862586364,-862370139,'Taurus'],
  [-862370139,-862152511,'Gemini'],
  [-862152511,-861940973,'Cancer'],
  [-861940973,-861738975,'Leo'],
  [-861738975,-861545858,'Virgo'],
  [-861545858,-861358988,'Libra'],
  [-861358988,-861175576,'Scorpio'],
  [-861175576,-860993274,'Sagittarius'],
  [-860993274,-860809829,'Capricorn'],
  [-860809829,-860622435,'Aquarius'],
  [-860622435,-860427672,'Pisces'],
  [-860427672,-860222783,'Aries'],
  [-860222783,-860008293,'Taurus'],
  [-860008293,-859790040,'Gemini'],
  [-859790040,-859576967,'Cancer'],
  [-859576967,-859375288,'Leo'],
  [-859375288,-859185314,'Virgo'],
  [-859185314,-859002976,'Libra'],
  [-859002976,-858822919,'Scorpio'],
  [-858822919,-858640817,'Sagittarius'],
  [-858640817,-858454376,'Capricorn'],
  [-858454376,-858262800,'Aquarius'],
  [-858262800,-858065257,'Pisces'],
  [-858065257,-857860174,'Aries'],
  [-857860174,-857646756,'Taurus'],
  [-857646756,-857428072,'Gemini'],
  [-857428072,-857212131,'Cancer'],
  [-857212131,-857007489,'Leo'],
  [-857007489,-856817274,'Virgo'],
  [-856817274,-856638181,'Libra'],
  [-856638181,-856463523,'Scorpio'],
  [-856463523,-856286451,'Sagittarius'],
  [-856286451,-856102211,'Capricorn'],
  [-856102211,-855909332,'Aquarius'],
  [-855909332,-855708709,'Pisces'],
  [-855708709,-855501388,'Aries'],
  [-855501388,-855287684,'Taurus'],
  [-855287684,-855069019,'Gemini'],
  [-855069019,-854850738,'Cancer'],
  [-854850738,-854641282,'Leo'],
  [-854641282,-854446657,'Virgo'],
  [-854446657,-854266321,'Libra'],
  [-854266321,-854094388,'Scorpio'],
  [-854094388,-853923022,'Sagittarius'],
  [-853923022,-853745066,'Capricorn'],
  [-853745066,-853556142,'Aquarius'],
  [-853556142,-853355853,'Pisces'],
  [-853355853,-853146682,'Aries'],
  [-853146682,-852931602,'Taurus'],
  [-852931602,-852713001,'Gemini'],
  [-852713001,-852494281,'Cancer'],
  [-852494281,-852281396,'Leo'],
  [-852281396,-852080730,'Virgo'],
  [-852080730,-851894749,'Libra'],
  [-851894749,-851720312,'Scorpio'],
  [-851720312,-851550661,'Sagittarius'],
  [-851550661,-851378078,'Capricorn'],
  [-851378078,-851195912,'Aquarius'],
  [-851195912,-851000566,'Pisces'],
  [-851000566,-850792796,'Aries'],
  [-850792796,-850576898,'Taurus'],
  [-850576898,-850357978,'Gemini'],
  [-850357978,-850140158,'Cancer'],
  [-850140158,-849927220,'Leo'],
  [-849927220,-849723172,'Virgo'],
  [-849723172,-849530910,'Libra'],
  [-849530910,-849350100,'Scorpio'],
  [-849350100,-849176795,'Sagittarius'],
  [-849176795,-849004749,'Capricorn'],
  [-849004749,-848827089,'Aquarius'],
  [-848827089,-848638036,'Pisces'],
  [-848638036,-848435049,'Aries'],
  [-848435049,-848220642,'Taurus'],
  [-848220642,-848001476,'Gemini'],
  [-848001476,-847784362,'Cancer'],
  [-847784362,-847573463,'Leo'],
  [-847573463,-847370460,'Virgo'],
  [-847370460,-847175908,'Libra'],
  [-847175908,-846989589,'Scorpio'],
  [-846989589,-846809941,'Sagittarius'],
  [-846809941,-846633576,'Capricorn'],
  [-846633576,-846455426,'Aquarius'],
  [-846455426,-846269686,'Pisces'],
  [-846269686,-846071686,'Aries'],
  [-846071686,-845860743,'Taurus'],
  [-845860743,-845642190,'Gemini'],
  [-845642190,-845424862,'Cancer'],
  [-845424862,-845215427,'Leo'],
  [-845215427,-845015559,'Virgo'],
  [-845015559,-844823464,'Libra'],
  [-844823464,-844636588,'Scorpio'],
  [-844636588,-844452973,'Sagittarius'],
  [-844452973,-844271065,'Capricorn'],
  [-844271065,-844088566,'Aquarius'],
  [-844088566,-843901642,'Pisces'],
  [-843901642,-843705693,'Aries'],
  [-843705693,-843497904,'Taurus'],
  [-843497904,-843280721,'Gemini'],
  [-843280721,-843062536,'Cancer'],
  [-843062536,-842852490,'Leo'],
  [-842852490,-842654420,'Virgo'],
  [-842654420,-842466233,'Libra'],
  [-842466233,-842283168,'Scorpio'],
  [-842283168,-842100885,'Sagittarius'],
  [-842100885,-841916897,'Capricorn'],
  [-841916897,-841730160,'Aquarius'],
  [-841730160,-841539388,'Pisces'],
  [-841539388,-841341985,'Aries'],
  [-841341985,-841135161,'Taurus'],
  [-841135161,-840919153,'Gemini'],
  [-840919153,-840700035,'Cancer'],
  [-840700035,-840487526,'Leo'],
  [-840487526,-840288193,'Virgo'],
  [-840288193,-840101714,'Libra'],
  [-840101714,-839922934,'Scorpio'],
  [-839922934,-839745532,'Sagittarius'],
  [-839745532,-839564557,'Capricorn'],
  [-839564557,-839377556,'Aquarius'],
  [-839377556,-839183990,'Pisces'],
  [-839183990,-838983575,'Aries'],
  [-838983575,-838775460,'Taurus'],
  [-838775460,-838559654,'Gemini'],
  [-838559654,-838339939,'Cancer'],
  [-838339939,-838124462,'Leo'],
  [-838124462,-837921249,'Virgo'],
  [-837921249,-837732735,'Libra'],
  [-837732735,-837555260,'Scorpio'],
  [-837555260,-837382191,'Sagittarius'],
  [-837382191,-837206796,'Capricorn'],
  [-837206796,-837024069,'Aquarius'],
  [-837024069,-836831694,'Pisces'],
  [-836831694,-836629774,'Aries'],
  [-836629774,-836419652,'Taurus'],
  [-836419652,-836203085,'Gemini'],
  [-836203085,-835983201,'Cancer'],
  [-835983201,-835765838,'Leo'],
  [-835765838,-835558185,'Virgo'],
  [-835558185,-835364697,'Libra'],
  [-835364697,-835184394,'Scorpio'],
  [-835184394,-835012062,'Sagittarius'],
  [-835012062,-834840803,'Capricorn'],
  [-834840803,-834663952,'Aquarius'],
  [-834663952,-834476562,'Pisces'],
  [-834476562,-834276721,'Aries'],
  [-834276721,-834066047,'Taurus'],
  [-834066047,-833848530,'Gemini'],
  [-833848530,-833628703,'Cancer'],
  [-833628703,-833411261,'Leo'],
  [-833411261,-833201112,'Virgo'],
  [-833201112,-833002405,'Libra'],
  [-833002405,-832816390,'Scorpio'],
  [-832816390,-832640503,'Sagittarius'],
  [-832640503,-832469350,'Capricorn'],
  [-832469350,-832296228,'Aquarius'],
  [-832296228,-832114576,'Pisces'],
  [-832114576,-831919772,'Aries'],
  [-831919772,-831711347,'Taurus'],
  [-831711347,-831493812,'Gemini'],
  [-831493812,-831274043,'Cancer'],
  [-831274043,-831057699,'Leo'],
  [-831057699,-830848072,'Virgo'],
  [-830848072,-830647060,'Libra'],
  [-830647060,-830455787,'Scorpio'],
  [-830455787,-830273860,'Sagittarius'],
  [-830273860,-830098573,'Capricorn'],
  [-830098573,-829924890,'Aquarius'],
  [-829924890,-829746335,'Pisces'],
  [-829746335,-829556659,'Aries'],
  [-829556659,-829352570,'Taurus'],
  [-829352570,-829136675,'Gemini'],
  [-829136675,-828916965,'Cancer'],
  [-828916965,-828701526,'Leo'],
  [-828701526,-828494156,'Virgo'],
  [-828494156,-828294775,'Libra'],
  [-828294775,-828102215,'Scorpio'],
  [-828102215,-827915749,'Sagittarius'],
  [-827915749,-827734591,'Capricorn'],
  [-827734591,-827556420,'Aquarius'],
  [-827556420,-827376635,'Pisces'],
  [-827376635,-827189221,'Aries'],
  [-827189221,-826989161,'Taurus'],
  [-826989161,-826776120,'Gemini'],
  [-826776120,-826556724,'Cancer'],
  [-826556724,-826340931,'Leo'],
  [-826340931,-826134985,'Virgo'],
  [-826134985,-825938944,'Libra'],
  [-825938944,-825749513,'Scorpio'],
  [-825749513,-825563491,'Sagittarius'],
  [-825563491,-825379250,'Capricorn'],
  [-825379250,-825195950,'Aquarius'],
  [-825195950,-825011654,'Pisces'],
  [-825011654,-824822473,'Aries'],
  [-824822473,-824623764,'Taurus'],
  [-824623764,-824413235,'Gemini'],
  [-824413235,-824194583,'Cancer'],
  [-824194583,-823977249,'Leo'],
  [-823977249,-823770056,'Virgo'],
  [-823770056,-823575452,'Libra'],
  [-823575452,-823390136,'Scorpio'],
  [-823390136,-823208827,'Sagittarius'],
  [-823208827,-823027165,'Capricorn'],
  [-823027165,-822842806,'Aquarius'],
  [-822842806,-822654680,'Pisces'],
  [-822654680,-822461423,'Aries'],
  [-822461423,-822260769,'Taurus'],
  [-822260769,-822050818,'Gemini'],
  [-822050818,-821833004,'Cancer'],
  [-821833004,-821614093,'Leo'],
  [-821614093,-821403332,'Virgo'],
  [-821403332,-821206233,'Libra'],
  [-821206233,-821021815,'Scorpio'],
  [-821021815,-820844873,'Sagittarius'],
  [-820844873,-820669152,'Capricorn'],
  [-820669152,-820489404,'Aquarius'],
  [-820489404,-820302407,'Pisces'],
  [-820302407,-820106968,'Aries'],
  [-820106968,-819903157,'Taurus'],
  [-819903157,-819691611,'Gemini'],
  [-819691611,-819473979,'Cancer'],
  [-819473979,-819254516,'Leo'],
  [-819254516,-819040239,'Virgo'],
  [-819040239,-818837845,'Libra'],
  [-818837845,-818649605,'Scorpio'],
  [-818649605,-818472625,'Sagittarius'],
  [-818472625,-818300916,'Capricorn'],
  [-818300916,-818127610,'Aquarius'],
  [-818127610,-817946602,'Pisces'],
  [-817946602,-817754061,'Aries'],
  [-817754061,-817549631,'Taurus'],
  [-817549631,-817336151,'Gemini'],
  [-817336151,-817117763,'Cancer'],
  [-817117763,-816898613,'Leo'],
  [-816898613,-816683101,'Virgo'],
  [-816683101,-816476170,'Libra'],
  [-816476170,-816281614,'Scorpio'],
  [-816281614,-816099749,'Sagittarius'],
  [-816099749,-815926932,'Capricorn'],
  [-815926932,-815756770,'Aquarius'],
  [-815756770,-815581876,'Pisces'],
  [-815581876,-815395709,'Aries'],
  [-815395709,-815195015,'Taurus'],
  [-815195015,-814981930,'Gemini'],
  [-814981930,-814762777,'Cancer'],
  [-814762777,-814543951,'Leo'],
  [-814543951,-814329380,'Virgo'],
  [-814329380,-814121425,'Libra'],
  [-814121425,-813922428,'Scorpio'],
  [-813922428,-813734119,'Sagittarius'],
  [-813734119,-813555861,'Capricorn'],
  [-813555861,-813383619,'Aquarius'],
  [-813383619,-813210735,'Pisces'],
  [-813210735,-813029733,'Aries'],
  [-813029733,-812834799,'Taurus'],
  [-812834799,-812625146,'Gemini'],
  [-812625146,-812406584,'Cancer'],
  [-812406584,-812187786,'Leo'],
  [-812187786,-811974578,'Virgo'],
  [-811974578,-811768519,'Libra'],
  [-811768519,-811569472,'Scorpio'],
  [-811569472,-811377736,'Sagittarius'],
  [-811377736,-811193708,'Capricorn'],
  [-811193708,-811016021,'Aquarius'],
  [-811016021,-810840374,'Pisces'],
  [-810840374,-810660299,'Aries'],
  [-810660299,-810469275,'Taurus'],
  [-810469275,-810263973,'Gemini'],
  [-810263973,-810047539,'Cancer'],
  [-810047539,-809828758,'Leo'],
  [-809828758,-809615907,'Virgo'],
  [-809615907,-809412035,'Libra'],
  [-809412035,-809215963,'Scorpio'],
  [-809215963,-809025576,'Sagittarius'],
  [-809025576,-808839660,'Capricorn'],
  [-808839660,-808657407,'Aquarius'],
  [-808657407,-808476776,'Pisces'],
  [-808476776,-808293665,'Aries'],
  [-808293665,-808102778,'Taurus'],
  [-808102778,-807900058,'Gemini'],
  [-807900058,-807686046,'Cancer'],
  [-807686046,-807467465,'Leo'],
  [-807467465,-807253591,'Virgo'],
  [-807253591,-807050026,'Libra'],
  [-807050026,-806856692,'Scorpio'],
  [-806856692,-806670299,'Sagittarius'],
  [-806670299,-806487218,'Capricorn'],
  [-806487218,-806304788,'Aquarius'],
  [-806304788,-806121035,'Pisces'],
  [-806121035,-805933735,'Aries'],
  [-805933735,-805739980,'Taurus'],
  [-805739980,-805536979,'Gemini'],
  [-805536979,-805324261,'Cancer'],
  [-805324261,-805105957,'Leo'],
  [-805105957,-804890178,'Virgo'],
  [-804890178,-804684403,'Libra'],
  [-804684403,-804491072,'Scorpio'],
  [-804491072,-804307695,'Sagittarius'],
  [-804307695,-804129414,'Capricorn'],
  [-804129414,-803951162,'Aquarius'],
  [-803951162,-803768869,'Pisces'],
  [-803768869,-803579906,'Aries'],
  [-803579906,-803382965,'Taurus'],
  [-803382965,-803177663,'Gemini'],
  [-803177663,-802964581,'Cancer'],
  [-802964581,-802746411,'Leo'],
  [-802746411,-802528868,'Virgo'],
  [-802528868,-802319287,'Libra'],
  [-802319287,-802122611,'Scorpio'],
  [-802122611,-801938758,'Sagittarius'],
  [-801938758,-801763484,'Capricorn'],
  [-801763484,-801590518,'Aquarius'],
  [-801590518,-801413449,'Pisces'],
  [-801413449,-801227315,'Aries'],
  [-801227315,-801030005,'Taurus'],
  [-801030005,-800822622,'Gemini'],
  [-800822622,-800608107,'Cancer'],
  [-800608107,-800389773,'Leo'],
  [-800389773,-800171496,'Virgo'],
  [-800171496,-799958571,'Libra'],
  [-799958571,-799756640,'Scorpio'],
  [-799756640,-799568444,'Sagittarius'],
  [-799568444,-799392055,'Capricorn'],
  [-799392055,-799221754,'Aquarius'],
  [-799221754,-799050075,'Pisces'],
  [-799050075,-798869802,'Aries'],
  [-798869802,-798676240,'Taurus'],
  [-798676240,-798469442,'Gemini'],
  [-798469442,-798253894,'Cancer'],
  [-798253894,-798035150,'Leo'],
  [-798035150,-797817223,'Virgo'],
  [-797817223,-797603259,'Libra'],
  [-797603259,-797397200,'Scorpio'],
  [-797397200,-797202904,'Sagittarius'],
  [-797202904,-797021348,'Capricorn'],
  [-797021348,-796849107,'Aquarius'],
  [-796849107,-796679401,'Pisces'],
  [-796679401,-796504222,'Aries'],
  [-796504222,-796316633,'Taurus'],
  [-796316633,-796113844,'Gemini'],
  [-796113844,-795899284,'Cancer'],
  [-795899284,-795680291,'Leo'],
  [-795680291,-795463016,'Virgo'],
  [-795463016,-795250308,'Libra'],
  [-795250308,-795043728,'Scorpio'],
  [-795043728,-794845514,'Sagittarius'],
  [-794845514,-794657717,'Capricorn'],
  [-794657717,-794479726,'Aquarius'],
  [-794479726,-794307148,'Pisces'],
  [-794307148,-794133004,'Aries'],
  [-794133004,-793949828,'Taurus'],
  [-793949828,-793752457,'Gemini'],
  [-793752457,-793541297,'Cancer'],
  [-793541297,-793322941,'Leo'],
  [-793322941,-793105777,'Virgo'],
  [-793105777,-792894701,'Libra'],
  [-792894701,-792690638,'Scorpio'],
  [-792690638,-792493262,'Sagittarius'],
  [-792493262,-792302764,'Capricorn'],
  [-792302764,-792119194,'Aquarius'],
  [-792119194,-791940703,'Pisces'],
  [-791940703,-791762904,'Aries'],
  [-791762904,-791579807,'Taurus'],
  [-791579807,-791385843,'Gemini'],
  [-791385843,-791178788,'Cancer'],
  [-791178788,-790962271,'Leo'],
  [-790962271,-790744633,'Virgo'],
  [-790744633,-790533522,'Libra'],
  [-790533522,-790331798,'Scorpio'],
  [-790331798,-790138299,'Sagittarius'],
  [-790138299,-789950522,'Capricorn'],
  [-789950522,-789766263,'Aquarius'],
  [-789766263,-789583661,'Pisces'],
  [-789583661,-789400435,'Aries'],
  [-789400435,-789213386,'Taurus'],
  [-789213386,-789018784,'Gemini'],
  [-789018784,-788813925,'Cancer'],
  [-788813925,-788599582,'Leo'],
  [-788599582,-788381540,'Virgo'],
  [-788381540,-788168343,'Libra'],
  [-788168343,-787965971,'Scorpio'],
  [-787965971,-787775051,'Sagittarius'],
  [-787775051,-787592188,'Capricorn'],
  [-787592188,-787412511,'Aquarius'],
  [-787412511,-787231566,'Pisces'],
  [-787231566,-787046269,'Aries'],
  [-787046269,-786854971,'Taurus'],
  [-786854971,-786656789,'Gemini'],
  [-786656789,-786450995,'Cancer'],
  [-786450995,-786237676,'Leo'],
  [-786237676,-786019704,'Virgo'],
  [-786019704,-785803783,'Libra'],
  [-785803783,-785597652,'Scorpio'],
  [-785597652,-785405178,'Sagittarius'],
  [-785405178,-785224579,'Capricorn'],
  [-785224579,-785050181,'Aquarius'],
  [-785050181,-784875130,'Pisces'],
  [-784875130,-784693564,'Aries'],
  [-784693564,-784502308,'Taurus'],
  [-784502308,-784301463,'Gemini'],
  [-784301463,-784093026,'Cancer'],
  [-784093026,-783878950,'Leo'],
  [-783878950,-783661182,'Virgo'],
  [-783661182,-783443650,'Libra'],
  [-783443650,-783233045,'Scorpio'],
  [-783233045,-783035498,'Sagittarius'],
  [-783035498,-782852365,'Capricorn'],
  [-782852365,-782679429,'Aquarius'],
  [-782679429,-782509304,'Pisces'],
  [-782509304,-782334145,'Aries'],
  [-782334145,-782147936,'Taurus'],
  [-782147936,-781948741,'Gemini'],
  [-781948741,-781739135,'Cancer'],
  [-781739135,-781523595,'Leo'],
  [-781523595,-781305664,'Virgo'],
  [-781305664,-781088098,'Libra'],
  [-781088098,-780875073,'Scorpio'],
  [-780875073,-780672230,'Sagittarius'],
  [-780672230,-780483284,'Capricorn'],
  [-780483284,-780306927,'Aquarius'],
  [-780306927,-780137220,'Pisces'],
  [-780137220,-779966174,'Aries'],
  [-779966174,-779786152,'Taurus'],
  [-779786152,-779592352,'Gemini'],
  [-779592352,-779385099,'Cancer'],
  [-779385099,-779169351,'Leo'],
  [-779169351,-778951059,'Virgo'],
  [-778951059,-778734209,'Libra'],
  [-778734209,-778521555,'Scorpio'],
  [-778521555,-778316435,'Sagittarius'],
  [-778316435,-778122270,'Capricorn'],
  [-778122270,-777939934,'Aquarius'],
  [-777939934,-777766162,'Pisces'],
  [-777766162,-777594566,'Aries'],
  [-777594566,-777417716,'Taurus'],
  [-777417716,-777229340,'Gemini'],
  [-777229340,-777026869,'Cancer'],
  [-777026869,-776813151,'Leo'],
  [-776813151,-776594944,'Virgo'],
  [-776594944,-776378613,'Libra'],
  [-776378613,-776167708,'Scorpio'],
  [-776167708,-775963882,'Sagittarius'],
  [-775963882,-775768310,'Capricorn'],
  [-775768310,-775581511,'Aquarius'],
  [-775581511,-775402073,'Pisces'],
  [-775402073,-775226124,'Aries'],
  [-775226124,-775048054,'Taurus'],
  [-775048054,-774861973,'Gemini'],
  [-774861973,-774663753,'Cancer'],
  [-774663753,-774453377,'Leo'],
  [-774453377,-774236033,'Virgo'],
  [-774236033,-774019561,'Libra'],
  [-774019561,-773809818,'Scorpio'],
  [-773809818,-773608785,'Sagittarius'],
  [-773608785,-773415700,'Capricorn'],
  [-773415700,-773228811,'Aquarius'],
  [-773228811,-773046120,'Pisces'],
  [-773046120,-772865208,'Aries'],
  [-772865208,-772682897,'Taurus'],
  [-772682897,-772495280,'Gemini'],
  [-772495280,-772298564,'Cancer'],
  [-772298564,-772090935,'Leo'],
  [-772090935,-771874898,'Virgo'],
  [-771874898,-771657654,'Libra'],
  [-771657654,-771447245,'Scorpio'],
  [-771447245,-771247770,'Sagittarius'],
  [-771247770,-771058353,'Capricorn'],
  [-771058353,-770875189,'Aquarius'],
  [-770875189,-770693958,'Pisces'],
  [-770693958,-770511279,'Aries'],
  [-770511279,-770325019,'Taurus'],
  [-770325019,-770133645,'Gemini'],
  [-770133645,-769935387,'Cancer'],
  [-769935387,-769728541,'Leo'],
  [-769728541,-769513539,'Virgo'],
  [-769513539,-769295313,'Libra'],
  [-769295313,-769082380,'Scorpio'],
  [-769082380,-768881537,'Sagittarius'],
  [-768881537,-768693742,'Capricorn'],
  [-768693742,-768514813,'Aquarius'],
  [-768514813,-768338436,'Pisces'],
  [-768338436,-768158812,'Aries'],
  [-768158812,-767972384,'Taurus'],
  [-767972384,-767778285,'Gemini'],
  [-767778285,-767577047,'Cancer'],
  [-767577047,-767368923,'Leo'],
  [-767368923,-767154114,'Virgo'],
  [-767154114,-766935245,'Libra'],
  [-766935245,-766719184,'Scorpio'],
  [-766719184,-766514187,'Sagittarius'],
  [-766514187,-766324150,'Capricorn'],
  [-766324150,-766146491,'Aquarius'],
  [-766146491,-765974523,'Pisces'],
  [-765974523,-765800642,'Aries'],
  [-765800642,-765618710,'Taurus'],
  [-765618710,-765425954,'Gemini'],
  [-765425954,-765223249,'Cancer'],
  [-765223249,-765013098,'Leo'],
  [-765013098,-764797551,'Virgo'],
  [-764797551,-764578597,'Libra'],
  [-764578597,-764360644,'Scorpio'],
  [-764360644,-764150908,'Sagittarius'],
  [-764150908,-763955361,'Capricorn'],
  [-763955361,-763774407,'Aquarius'],
  [-763774407,-763602926,'Pisces'],
  [-763602926,-763433200,'Aries'],
  [-763433200,-763257505,'Taurus'],
  [-763257505,-763070276,'Gemini'],
  [-763070276,-762870052,'Cancer'],
  [-762870052,-762659464,'Leo'],
  [-762659464,-762442891,'Virgo'],
  [-762442891,-762224046,'Libra'],
  [-762224046,-762006281,'Scorpio'],
  [-762006281,-761794250,'Sagittarius'],
  [-761794250,-761593213,'Capricorn'],
  [-761593213,-761405819,'Aquarius'],
  [-761405819,-761229929,'Pisces'],
  [-761229929,-761059612,'Aries'],
  [-761059612,-760887420,'Taurus'],
  [-760887420,-760706356,'Gemini'],
  [-760706356,-760511960,'Cancer'],
  [-760511960,-760304241,'Leo'],
  [-760304241,-760087752,'Virgo'],
  [-760087752,-759868791,'Libra'],
  [-759868791,-759652252,'Scorpio'],
  [-759652252,-759441356,'Sagittarius'],
  [-759441356,-759238670,'Capricorn'],
  [-759238670,-759046085,'Aquarius'],
  [-759046085,-758863474,'Pisces'],
  [-758863474,-758687873,'Aries'],
  [-758687873,-758514001,'Taurus'],
  [-758514001,-758335499,'Gemini'],
  [-758335499,-758146520,'Cancer'],
  [-758146520,-757943932,'Leo'],
  [-757943932,-757729667,'Virgo'],
  [-757729667,-757510652,'Libra'],
  [-757510652,-757294640,'Scorpio'],
  [-757294640,-757086138,'Sagittarius'],
  [-757086138,-756886002,'Capricorn'],
  [-756886002,-756693326,'Aquarius'],
  [-756693326,-756506871,'Pisces'],
  [-756506871,-756325130,'Aries'],
  [-756325130,-756145692,'Taurus'],
  [-756145692,-755964709,'Gemini'],
  [-755964709,-755777215,'Cancer'],
  [-755777215,-755578682,'Leo'],
  [-755578682,-755367868,'Virgo'],
  [-755367868,-755149489,'Libra'],
  [-755149489,-754932672,'Scorpio'],
  [-754932672,-754724907,'Sagittarius'],
  [-754724907,-754528027,'Capricorn'],
  [-754528027,-754339339,'Aquarius'],
  [-754339339,-754154818,'Pisces'],
  [-754154818,-753971331,'Aries'],
  [-753971331,-753787184,'Taurus'],
  [-753787184,-753601110,'Gemini'],
  [-753601110,-753410808,'Cancer'],
  [-753410808,-753212780,'Leo'],
  [-753212780,-753004345,'Virgo'],
  [-753004345,-752787149,'Libra'],
  [-752787149,-752568903,'Scorpio'],
  [-752568903,-752359203,'Sagittarius'],
  [-752359203,-752162774,'Capricorn'],
  [-752162774,-751977638,'Aquarius'],
  [-751977638,-751798156,'Pisces'],
  [-751798156,-751618525,'Aries'],
  [-751618525,-751434931,'Taurus'],
  [-751434931,-751246060,'Gemini'],
  [-751246060,-751051746,'Cancer'],
  [-751051746,-750851126,'Leo'],
  [-750851126,-750642576,'Virgo'],
  [-750642576,-750426181,'Libra'],
  [-750426181,-750206876,'Scorpio'],
  [-750206876,-749993785,'Sagittarius'],
  [-749993785,-749794226,'Capricorn'],
  [-749794226,-749608862,'Aquarius'],
  [-749608862,-749432669,'Pisces'],
  [-749432669,-749258559,'Aries'],
  [-749258559,-749080210,'Taurus'],
  [-749080210,-748893821,'Gemini'],
  [-748893821,-748698555,'Cancer'],
  [-748698555,-748495252,'Leo'],
  [-748495252,-748284803,'Virgo'],
  [-748284803,-748068174,'Libra'],
  [-748068174,-747848549,'Scorpio'],
  [-747848549,-747632714,'Sagittarius'],
  [-747632714,-747428325,'Capricorn'],
  [-747428325,-747238811,'Aquarius'],
  [-747238811,-747061541,'Pisces'],
  [-747061541,-746890115,'Aries'],
  [-746890115,-746717252,'Taurus'],
  [-746717252,-746536791,'Gemini'],
  [-746536791,-746345199,'Cancer'],
  [-746345199,-746142261,'Leo'],
  [-746142261,-745930357,'Virgo'],
  [-745930357,-745712821,'Libra'],
  [-745712821,-745493325,'Scorpio'],
  [-745493325,-745276694,'Sagittarius'],
  [-745276694,-745068688,'Capricorn'],
  [-745068688,-744873576,'Aquarius'],
  [-744873576,-744691437,'Pisces'],
  [-744691437,-744518144,'Aries'],
  [-744518144,-744347258,'Taurus'],
  [-744347258,-744171874,'Gemini'],
  [-744171874,-743986190,'Cancer'],
  [-743986190,-743787229,'Leo'],
  [-743787229,-743576256,'Virgo'],
  [-743576256,-743358203,'Libra'],
  [-743358203,-743138894,'Scorpio'],
  [-743138894,-742923137,'Sagittarius'],
  [-742923137,-742714523,'Capricorn'],
  [-742714523,-742515745,'Aquarius'],
  [-742515745,-742327871,'Pisces'],
  [-742327871,-742149341,'Aries'],
  [-742149341,-741975993,'Taurus'],
  [-741975993,-741801899,'Gemini'],
  [-741801899,-741620605,'Cancer'],
  [-741620605,-741426890,'Leo'],
  [-741426890,-741219304,'Virgo'],
  [-741219304,-741002013,'Libra'],
  [-741002013,-740782786,'Scorpio'],
  [-740782786,-740568277,'Sagittarius'],
  [-740568277,-740361529,'Capricorn'],
  [-740361529,-740162917,'Aquarius'],
  [-740162917,-739972049,'Pisces'],
  [-739972049,-739788200,'Aries'],
  [-739788200,-739609609,'Taurus'],
  [-739609609,-739432674,'Gemini'],
  [-739432674,-739252023,'Cancer'],
  [-739252023,-739061792,'Leo'],
  [-739061792,-738858212,'Virgo'],
  [-738858212,-738642939,'Libra'],
  [-738642939,-738423731,'Scorpio'],
  [-738423731,-738209569,'Sagittarius'],
  [-738209569,-738004975,'Capricorn'],
  [-738004975,-737809335,'Aquarius'],
  [-737809335,-737619879,'Pisces'],
  [-737619879,-737434288,'Aries'],
  [-737434288,-737251277,'Taurus'],
  [-737251277,-737069438,'Gemini'],
  [-737069438,-736885774,'Cancer'],
  [-736885774,-736695610,'Leo'],
  [-736695610,-736494444,'Virgo'],
  [-736494444,-736281440,'Libra'],
  [-736281440,-736062322,'Scorpio'],
  [-736062322,-735847035,'Sagittarius'],
  [-735847035,-735642705,'Capricorn'],
  [-735642705,-735449836,'Aquarius'],
  [-735449836,-735264458,'Pisces'],
  [-735264458,-735081834,'Aries'],
  [-735081834,-734898750,'Taurus'],
  [-734898750,-734713792,'Gemini'],
  [-734713792,-734525884,'Cancer'],
  [-734525884,-734332784,'Leo'],
  [-734332784,-734131276,'Virgo'],
  [-734131276,-733919538,'Libra'],
  [-733919538,-733700647,'Scorpio'],
  [-733700647,-733483256,'Sagittarius'],
  [-733483256,-733276401,'Capricorn'],
  [-733276401,-733083311,'Aquarius'],
  [-733083311,-732900924,'Pisces'],
  [-732900924,-732723331,'Aries'],
  [-732723331,-732544846,'Taurus'],
  [-732544846,-732361697,'Gemini'],
  [-732361697,-732172235,'Cancer'],
  [-732172235,-731975834,'Leo'],
  [-731975834,-731771808,'Virgo'],
  [-731771808,-731559618,'Libra'],
  [-731559618,-731340953,'Scorpio'],
  [-731340953,-731121803,'Sagittarius'],
  [-731121803,-730910749,'Capricorn'],
  [-730910749,-730713634,'Aquarius'],
  [-730713634,-730530152,'Pisces'],
  [-730530152,-730355313,'Aries'],
  [-730355313,-730182434,'Taurus'],
  [-730182434,-730005264,'Gemini'],
  [-730005264,-729819389,'Cancer'],
  [-729819389,-729623017,'Leo'],
  [-729623017,-729416816,'Virgo'],
  [-729416816,-729202908,'Libra'],
  [-729202908,-728984096,'Scorpio'],
  [-728984096,-728764553,'Sagittarius'],
  [-728764553,-728550306,'Capricorn'],
  [-728550306,-728347421,'Aquarius'],
  [-728347421,-728158539,'Pisces'],
  [-728158539,-727981487,'Aries'],
  [-727981487,-727810670,'Taurus'],
  [-727810670,-727639080,'Gemini'],
  [-727639080,-727459931,'Cancer'],
  [-727459931,-727268378,'Leo'],
  [-727268378,-727063421,'Virgo'],
  [-727063421,-726848441,'Libra'],
  [-726848441,-726628988,'Scorpio'],
  [-726628988,-726410046,'Sagittarius'],
  [-726410046,-726195495,'Capricorn'],
  [-726195495,-725988999,'Aquarius'],
  [-725988999,-725793675,'Pisces'],
  [-725793675,-725610285,'Aries'],
  [-725610285,-725436142,'Taurus'],
  [-725436142,-725265561,'Gemini'],
  [-725265561,-725091297,'Cancer'],
  [-725091297,-724906331,'Leo'],
  [-724906331,-724706455,'Virgo'],
  [-724706455,-724493157,'Libra'],
  [-724493157,-724273402,'Scorpio'],
  [-724273402,-724054905,'Sagittarius'],
  [-724054905,-723842016,'Capricorn'],
  [-723842016,-723636084,'Aquarius'],
  [-723636084,-723437910,'Pisces'],
  [-723437910,-723248495,'Aries'],
  [-723248495,-723067788,'Taurus'],
  [-723067788,-722893036,'Gemini'],
  [-722893036,-722718592,'Cancer'],
  [-722718592,-722537330,'Leo'],
  [-722537330,-722343035,'Virgo'],
  [-722343035,-722133935,'Libra'],
  [-722133935,-721915323,'Scorpio'],
  [-721915323,-721696712,'Sagittarius'],
  [-721696712,-721485069,'Capricorn'],
  [-721485069,-721281901,'Aquarius'],
  [-721281901,-721085703,'Pisces'],
  [-721085703,-720895103,'Aries'],
  [-720895103,-720709758,'Taurus'],
  [-720709758,-720529009,'Gemini'],
  [-720529009,-720350036,'Cancer'],
  [-720350036,-720167611,'Leo'],
  [-720167611,-719975704,'Virgo'],
  [-719975704,-719770548,'Libra'],
  [-719770548,-719554295,'Scorpio'],
  [-719554295,-719335476,'Sagittarius'],
  [-719335476,-719123333,'Capricorn'],
  [-719123333,-718921766,'Aquarius'],
  [-718921766,-718729215,'Pisces'],
  [-718729215,-718542111,'Aries'],
  [-718542111,-718357604,'Taurus'],
  [-718357604,-718174158,'Gemini'],
  [-718174158,-717990385,'Cancer'],
  [-717990385,-717803670,'Leo'],
  [-717803670,-717610106,'Virgo'],
  [-717610106,-717406200,'Libra'],
  [-717406200,-717191973,'Scorpio'],
  [-717191973,-716973209,'Sagittarius'],
  [-716973209,-716759146,'Capricorn'],
  [-716759146,-716556340,'Aquarius'],
  [-716556340,-716365334,'Pisces'],
  [-716365334,-716182403,'Aries'],
  [-716182403,-716002636,'Taurus'],
  [-716002636,-715821895,'Gemini'],
  [-715821895,-715637413,'Cancer'],
  [-715637413,-715447383,'Leo'],
  [-715447383,-715250288,'Virgo'],
  [-715250288,-715044807,'Libra'],
  [-715044807,-714831030,'Scorpio'],
  [-714831030,-714612452,'Sagittarius'],
  [-714612452,-714396232,'Capricorn'],
  [-714396232,-714189904,'Aquarius'],
  [-714189904,-713996825,'Pisces'],
  [-713996825,-713815113,'Aries'],
  [-713815113,-713639663,'Taurus'],
  [-713639663,-713464436,'Gemini'],
  [-713464436,-713284063,'Cancer'],
  [-713284063,-713094968,'Leo'],
  [-713094968,-712895986,'Virgo'],
  [-712895986,-712688048,'Libra'],
  [-712688048,-712473238,'Scorpio'],
  [-712473238,-712254685,'Sagittarius'],
  [-712254685,-712037196,'Capricorn'],
  [-712037196,-711827015,'Aquarius'],
  [-711827015,-711629193,'Pisces'],
  [-711629193,-711444651,'Aries'],
  [-711444651,-711269932,'Taurus'],
  [-711269932,-711098815,'Gemini'],
  [-711098815,-710924235,'Cancer'],
  [-710924235,-710740063,'Leo'],
  [-710740063,-710543091,'Virgo'],
  [-710543091,-710334409,'Libra'],
  [-710334409,-710118302,'Scorpio'],
  [-710118302,-709899522,'Sagittarius'],
  [-709899522,-709682021,'Capricorn'],
  [-709682021,-709469746,'Aquarius'],
  [-709469746,-709267112,'Pisces'],
  [-709267112,-709077064,'Aries'],
  [-709077064,-708898880,'Taurus'],
  [-708898880,-708727875,'Gemini'],
  [-708727875,-708556909,'Cancer'],
  [-708556909,-708378374,'Leo'],
  [-708378374,-708186501,'Virgo'],
  [-708186501,-707980215,'Libra'],
  [-707980215,-707764073,'Scorpio'],
  [-707764073,-707545039,'Sagittarius'],
  [-707545039,-707328263,'Capricorn'],
  [-707328263,-707116397,'Aquarius'],
  [-707116397,-706911641,'Pisces'],
  [-706911641,-706716595,'Aries'],
  [-706716595,-706532583,'Taurus'],
  [-706532583,-706357573,'Gemini'],
  [-706357573,-706186000,'Cancer'],
  [-706186000,-706010398,'Leo'],
  [-706010398,-705823625,'Virgo'],
  [-705823625,-705621931,'Libra'],
  [-705621931,-705407804,'Scorpio'],
  [-705407804,-705188912,'Sagittarius'],
  [-705188912,-704972706,'Capricorn'],
  [-704972706,-704762624,'Aquarius'],
  [-704762624,-704559213,'Pisces'],
  [-704559213,-704362826,'Aries'],
  [-704362826,-704174354,'Taurus'],
  [-704174354,-703993613,'Gemini'],
  [-703993613,-703817622,'Cancer'],
  [-703817622,-703640703,'Leo'],
  [-703640703,-703456099,'Virgo'],
  [-703456099,-703258587,'Libra'],
  [-703258587,-703047813,'Scorpio'],
  [-703047813,-702829781,'Sagittarius'],
  [-702829781,-702613362,'Capricorn'],
  [-702613362,-702404406,'Aquarius'],
  [-702404406,-702203875,'Pisces'],
  [-702203875,-702010206,'Aries'],
  [-702010206,-701821857,'Taurus'],
  [-701821857,-701637856,'Gemini'],
  [-701637856,-701456687,'Cancer'],
  [-701456687,-701275203,'Leo'],
  [-701275203,-701088756,'Virgo'],
  [-701088756,-700892644,'Libra'],
  [-700892644,-700684739,'Scorpio'],
  [-700684739,-700468130,'Sagittarius'],
  [-700468130,-700250789,'Capricorn'],
  [-700250789,-700040810,'Aquarius'],
  [-700040810,-699841603,'Pisces'],
  [-699841603,-699651767,'Aries'],
  [-699651767,-699467696,'Taurus'],
  [-699467696,-699285747,'Gemini'],
  [-699285747,-699103081,'Cancer'],
  [-699103081,-698917476,'Leo'],
  [-698917476,-698726764,'Virgo'],
  [-698726764,-698528639,'Libra'],
  [-698528639,-698321439,'Scorpio'],
  [-698321439,-698106101,'Sagittarius'],
  [-698106101,-697887851,'Capricorn'],
  [-697887851,-697674871,'Aquarius'],
  [-697674871,-697473495,'Pisces'],
  [-697473495,-697284736,'Aries'],
  [-697284736,-697105034,'Taurus'],
  [-697105034,-696928715,'Gemini'],
  [-696928715,-696750125,'Cancer'],
  [-696750125,-696565105,'Leo'],
  [-696565105,-696371770,'Virgo'],
  [-696371770,-696170205,'Libra'],
  [-696170205,-695961276,'Scorpio'],
  [-695961276,-695746165,'Sagittarius'],
  [-695746165,-695527650,'Capricorn'],
  [-695527650,-695311576,'Aquarius'],
  [-695311576,-695105282,'Pisces'],
  [-695105282,-694913074,'Aries'],
  [-694913074,-694733732,'Taurus'],
  [-694733732,-694561650,'Gemini'],
  [-694561650,-694389427,'Cancer'],
  [-694389427,-694210113,'Leo'],
  [-694210113,-694019311,'Virgo'],
  [-694019311,-693816770,'Libra'],
  [-693816770,-693605593,'Scorpio'],
  [-693605593,-693389451,'Sagittarius'],
  [-693389451,-693171097,'Capricorn'],
  [-693171097,-692953788,'Aquarius'],
  [-692953788,-692743001,'Pisces'],
  [-692743001,-692544563,'Aries'],
  [-692544563,-692360604,'Taurus'],
  [-692360604,-692187781,'Gemini'],
  [-692187781,-692018980,'Cancer'],
  [-692018980,-691845965,'Leo'],
  [-691845965,-691661679,'Virgo'],
  [-691661679,-691462934,'Libra'],
  [-691462934,-691252069,'Scorpio'],
  [-691252069,-691034873,'Sagittarius'],
  [-691034873,-690816457,'Capricorn'],
  [-690816457,-690599780,'Aquarius'],
  [-690599780,-690387729,'Pisces'],
  [-690387729,-690184563,'Aries'],
  [-690184563,-689993934,'Taurus'],
  [-689993934,-689815658,'Gemini'],
  [-689815658,-689644896,'Cancer'],
  [-689644896,-689474101,'Leo'],
  [-689474101,-689295372,'Virgo'],
  [-689295372,-689102944,'Libra'],
  [-689102944,-688896035,'Scorpio'],
  [-688896035,-688679621,'Sagittarius'],
  [-688679621,-688461004,'Capricorn'],
  [-688461004,-688245300,'Aquarius'],
  [-688245300,-688034825,'Pisces'],
  [-688034825,-687831285,'Aries'],
  [-687831285,-687636770,'Taurus'],
  [-687636770,-687452268,'Gemini'],
  [-687452268,-687275739,'Cancer'],
  [-687275739,-687102027,'Leo'],
  [-687102027,-686924351,'Virgo'],
  [-686924351,-686736341,'Libra'],
  [-686736341,-686534610,'Scorpio'],
  [-686534610,-686321132,'Sagittarius'],
  [-686321132,-686102863,'Capricorn'],
  [-686102863,-685887352,'Aquarius'],
  [-685887352,-685678765,'Pisces'],
  [-685678765,-685477969,'Aries'],
  [-685477969,-685284498,'Taurus'],
  [-685284498,-685097638,'Gemini'],
  [-685097638,-684916011,'Cancer'],
  [-684916011,-684736832,'Leo'],
  [-684736832,-684555824,'Virgo'],
  [-684555824,-684368012,'Libra'],
  [-684368012,-684169384,'Scorpio'],
  [-684169384,-683959248,'Sagittarius'],
  [-683959248,-683742047,'Capricorn'],
  [-683742047,-683525854,'Aquarius'],
  [-683525854,-683317474,'Pisces'],
  [-683317474,-683119233,'Aries'],
  [-683119233,-682929580,'Taurus'],
  [-682929580,-682745280,'Gemini'],
  [-682745280,-682563084,'Cancer'],
  [-682563084,-682380312,'Leo'],
  [-682380312,-682194651,'Virgo'],
  [-682194651,-682003661,'Libra'],
  [-682003661,-681804751,'Scorpio'],
  [-681804751,-681596383,'Sagittarius'],
  [-681596383,-681380349,'Capricorn'],
  [-681380349,-681163048,'Aquarius'],
  [-681163048,-680952764,'Pisces'],
  [-680952764,-680754491,'Aries'],
  [-680754491,-680567719,'Taurus'],
  [-680567719,-680388011,'Gemini'],
  [-680388011,-680209723,'Cancer'],
  [-680209723,-680028109,'Leo'],
  [-680028109,-679840445,'Virgo'],
  [-679840445,-679645922,'Libra'],
  [-679645922,-679444409,'Scorpio'],
  [-679444409,-679235599,'Sagittarius'],
  [-679235599,-679020112,'Capricorn'],
  [-679020112,-678801863,'Aquarius'],
  [-678801863,-678588473,'Pisces'],
  [-678588473,-678387148,'Aries'],
  [-678387148,-678199902,'Taurus'],
  [-678199902,-678023021,'Gemini'],
  [-678023021,-677849739,'Cancer'],
  [-677849739,-677673084,'Leo'],
  [-677673084,-677488036,'Virgo'],
  [-677488036,-677292952,'Libra'],
  [-677292952,-677089105,'Scorpio'],
  [-677089105,-676878518,'Sagittarius'],
  [-676878518,-676662709,'Capricorn'],
  [-676662709,-676444070,'Aquarius'],
  [-676444070,-676228049,'Pisces'],
  [-676228049,-676022078,'Aries'],
  [-676022078,-675830783,'Taurus'],
  [-675830783,-675652784,'Gemini'],
  [-675652784,-675481939,'Cancer'],
  [-675481939,-675310377,'Leo'],
  [-675310377,-675130962,'Virgo'],
  [-675130962,-674939512,'Libra'],
  [-674939512,-674736195,'Scorpio'],
  [-674736195,-674524349,'Sagittarius'],
  [-674524349,-674307719,'Capricorn'],
  [-674307719,-674089188,'Aquarius'],
  [-674089188,-673872355,'Pisces'],
  [-673872355,-673662788,'Aries'],
  [-673662788,-673465880,'Taurus'],
  [-673465880,-673282979,'Gemini'],
  [-673282979,-673110196,'Cancer'],
  [-673110196,-672940439,'Leo'],
  [-672940439,-672765923,'Virgo'],
  [-672765923,-672580323,'Libra'],
  [-672580323,-672381045,'Scorpio'],
  [-672381045,-672170244,'Sagittarius'],
  [-672170244,-671953148,'Capricorn'],
  [-671953148,-671734826,'Aquarius'],
  [-671734826,-671518921,'Pisces'],
  [-671518921,-671308844,'Aries'],
  [-671308844,-671108246,'Taurus'],
  [-671108246,-670919382,'Gemini'],
  [-670919382,-670741035,'Cancer'],
  [-670741035,-670568471,'Leo'],
  [-670568471,-670395005,'Virgo'],
  [-670395005,-670213822,'Libra'],
  [-670213822,-670020025,'Scorpio'],
  [-670020025,-669812854,'Sagittarius'],
  [-669812854,-669596581,'Capricorn'],
  [-669596581,-669378234,'Aquarius'],
  [-669378234,-669163583,'Pisces'],
  [-669163583,-668955639,'Aries'],
  [-668955639,-668755589,'Taurus'],
  [-668755589,-668563855,'Gemini'],
  [-668563855,-668379895,'Cancer'],
  [-668379895,-668201470,'Leo'],
  [-668201470,-668024488,'Virgo'],
  [-668024488,-667843583,'Libra'],
  [-667843583,-667653384,'Scorpio'],
  [-667653384,-667450613,'Sagittarius'],
  [-667450613,-667236638,'Capricorn'],
  [-667236638,-667018168,'Aquarius'],
  [-667018168,-666803531,'Pisces'],
  [-666803531,-666597730,'Aries'],
  [-666597730,-666401172,'Taurus'],
  [-666401172,-666211628,'Gemini'],
  [-666211628,-666026462,'Cancer'],
  [-666026462,-665843556,'Leo'],
  [-665843556,-665661013,'Virgo'],
  [-665661013,-665476266,'Libra'],
  [-665476266,-665285645,'Scorpio'],
  [-665285645,-665085346,'Sagittarius'],
  [-665085346,-664874023,'Capricorn'],
  [-664874023,-664655765,'Aquarius'],
  [-664655765,-664439522,'Pisces'],
  [-664439522,-664233321,'Aries'],
  [-664233321,-664039351,'Taurus'],
  [-664039351,-663854434,'Gemini'],
  [-663854434,-663673314,'Cancer'],
  [-663673314,-663491426,'Leo'],
  [-663491426,-663306244,'Virgo'],
  [-663306244,-663116927,'Libra'],
  [-663116927,-662922646,'Scorpio'],
  [-662922646,-662721453,'Sagittarius'],
  [-662721453,-662511390,'Capricorn'],
  [-662511390,-662293715,'Aquarius'],
  [-662293715,-662075333,'Pisces'],
  [-662075333,-661865824,'Aries'],
  [-661865824,-661670608,'Taurus'],
  [-661670608,-661488075,'Gemini'],
  [-661488075,-661312145,'Cancer'],
  [-661312145,-661135876,'Leo'],
  [-661135876,-660953974,'Virgo'],
  [-660953974,-660764191,'Libra'],
  [-660764191,-660566832,'Scorpio'],
  [-660566832,-660362668,'Sagittarius'],
  [-660362668,-660151665,'Capricorn'],
  [-660151665,-659934312,'Aquarius'],
  [-659934312,-659714692,'Pisces'],
  [-659714692,-659501053,'Aries'],
  [-659501053,-659300999,'Taurus'],
  [-659300999,-659116102,'Gemini'],
  [-659116102,-658941763,'Cancer'],
  [-658941763,-658770560,'Leo'],
  [-658770560,-658595161,'Virgo'],
  [-658595161,-658410364,'Libra'],
  [-658410364,-658214442,'Scorpio'],
  [-658214442,-658008745,'Sagittarius'],
  [-658008745,-657795815,'Capricorn'],
  [-657795815,-657577987,'Aquarius'],
  [-657577987,-657358334,'Pisces'],
  [-657358334,-657142409,'Aries'],
  [-657142409,-656937071,'Taurus'],
  [-656937071,-656746289,'Gemini'],
  [-656746289,-656568476,'Cancer'],
  [-656568476,-656397787,'Leo'],
  [-656397787,-656226803,'Virgo'],
  [-656226803,-656048581,'Libra'],
  [-656048581,-655858385,'Scorpio'],
  [-655858385,-655655192,'Sagittarius'],
  [-655655192,-655441862,'Capricorn'],
  [-655441862,-655223249,'Aquarius'],
  [-655223249,-655003996,'Pisces'],
  [-655003996,-654788354,'Aries'],
  [-654788354,-654580645,'Taurus'],
  [-654580645,-654384403,'Gemini'],
  [-654384403,-654200299,'Cancer'],
  [-654200299,-654025334,'Leo'],
  [-654025334,-653853862,'Virgo'],
  [-653853862,-653679145,'Libra'],
  [-653679145,-653494881,'Scorpio'],
  [-653494881,-653297083,'Sagittarius'],
  [-653297083,-653086235,'Capricorn'],
  [-653086235,-652867717,'Aquarius'],
  [-652867717,-652648680,'Pisces'],
  [-652648680,-652434506,'Aries'],
  [-652434506,-652227905,'Taurus'],
  [-652227905,-652030020,'Gemini'],
  [-652030020,-651841108,'Cancer'],
  [-651841108,-651660089,'Leo'],
  [-651660089,-651484019,'Virgo'],
  [-651484019,-651308087,'Libra'],
  [-651308087,-651126352,'Scorpio'],
  [-651126352,-650933328,'Sagittarius'],
  [-650933328,-650726612,'Capricorn'],
  [-650726612,-650509603,'Aquarius'],
  [-650509603,-650290571,'Pisces'],
  [-650290571,-650077339,'Aries'],
  [-650077339,-649873231,'Taurus'],
  [-649873231,-649677545,'Gemini'],
  [-649677545,-649488249,'Cancer'],
  [-649488249,-649303637,'Leo'],
  [-649303637,-649122267,'Virgo'],
  [-649122267,-648941868,'Libra'],
  [-648941868,-648758495,'Scorpio'],
  [-648758495,-648567078,'Sagittarius'],
  [-648567078,-648363658,'Capricorn'],
  [-648363658,-648148869,'Aquarius'],
  [-648148869,-647929793,'Pisces'],
  [-647929793,-647716079,'Aries'],
  [-647716079,-647513307,'Taurus'],
  [-647513307,-647320921,'Gemini'],
  [-647320921,-647134991,'Cancer'],
  [-647134991,-646951521,'Leo'],
  [-646951521,-646768082,'Virgo'],
  [-646768082,-646583472,'Libra'],
  [-646583472,-646396097,'Scorpio'],
  [-646396097,-646202909,'Sagittarius'],
  [-646202909,-646000319,'Capricorn'],
  [-646000319,-645787188,'Aquarius'],
  [-645787188,-645568118,'Pisces'],
  [-645568118,-645352600,'Aries'],
  [-645352600,-645148619,'Taurus'],
  [-645148619,-644957604,'Gemini'],
  [-644957604,-644775509,'Cancer'],
  [-644775509,-644596504,'Leo'],
  [-644596504,-644415773,'Virgo'],
  [-644415773,-644230713,'Libra'],
  [-644230713,-644040376,'Scorpio'],
  [-644040376,-643843893,'Sagittarius'],
  [-643843893,-643639711,'Capricorn'],
  [-643639711,-643426840,'Aquarius'],
  [-643426840,-643207816,'Pisces'],
  [-643207816,-642990137,'Aries'],
  [-642990137,-642782652,'Taurus'],
  [-642782652,-642589537,'Gemini'],
  [-642589537,-642408508,'Cancer'],
  [-642408508,-642233590,'Leo'],
  [-642233590,-642058233,'Virgo'],
  [-642058233,-641877293,'Libra'],
  [-641877293,-641688015,'Scorpio'],
  [-641688015,-641489805,'Sagittarius'],
  [-641489805,-641283221,'Capricorn'],
  [-641283221,-641069275,'Aquarius'],
  [-641069275,-640850232,'Pisces'],
  [-640850232,-640631277,'Aries'],
  [-640631277,-640419845,'Taurus'],
  [-640419845,-640221758,'Gemini'],
  [-640221758,-640037621,'Cancer'],
  [-640037621,-639863183,'Leo'],
  [-639863183,-639691863,'Virgo'],
  [-639691863,-639516875,'Libra'],
  [-639516875,-639332771,'Scorpio'],
  [-639332771,-639136783,'Sagittarius'],
  [-639136783,-638929509,'Capricorn'],
  [-638929509,-638714175,'Aquarius'],
  [-638714175,-638494899,'Pisces'],
  [-638494899,-638276082,'Aries'],
  [-638276082,-638062672,'Taurus'],
  [-638062672,-637859553,'Gemini'],
  [-637859553,-637669358,'Cancer'],
  [-637669358,-637490798,'Leo'],
  [-637490798,-637319149,'Virgo'],
  [-637319149,-637147780,'Libra'],
  [-637147780,-636969707,'Scorpio'],
  [-636969707,-636779347,'Sagittarius'],
  [-636779347,-636574836,'Capricorn'],
  [-636574836,-636359466,'Aquarius'],
  [-636359466,-636139804,'Pisces'],
  [-636139804,-635921850,'Aries'],
  [-635921850,-635709290,'Taurus'],
  [-635709290,-635504402,'Gemini'],
  [-635504402,-635309046,'Cancer'],
  [-635309046,-635123922,'Leo'],
  [-635123922,-634947315,'Virgo'],
  [-634947315,-634774669,'Libra'],
  [-634774669,-634599397,'Scorpio'],
  [-634599397,-634414522,'Sagittarius'],
  [-634414522,-634215258,'Capricorn'],
  [-634215258,-634002320,'Aquarius'],
  [-634002320,-633782714,'Pisces'],
  [-633782714,-633565145,'Aries'],
  [-633565145,-633354611,'Taurus'],
  [-633354611,-633151796,'Gemini'],
  [-633151796,-632955878,'Cancer'],
  [-632955878,-632766535,'Leo'],
  [-632766535,-632583650,'Virgo'],
  [-632583650,-632405604,'Libra'],
  [-632405604,-632228127,'Scorpio'],
  [-632228127,-632044964,'Sagittarius'],
  [-632044964,-631850048,'Capricorn'],
  [-631850048,-631641044,'Aquarius'],
  [-631641044,-631422597,'Pisces'],
  [-631422597,-631204511,'Aries'],
  [-631204511,-630994678,'Taurus'],
  [-630994678,-630794831,'Gemini'],
  [-630794831,-630602458,'Cancer'],
  [-630602458,-630414487,'Leo'],
  [-630414487,-630229254,'Virgo'],
  [-630229254,-630046075,'Libra'],
  [-630046075,-629863345,'Scorpio'],
  [-629863345,-629677353,'Sagittarius'],
  [-629677353,-629483083,'Capricorn'],
  [-629483083,-629276906,'Aquarius'],
  [-629276906,-629060347,'Pisces'],
  [-629060347,-628841455,'Aries'],
  [-628841455,-628629984,'Taurus'],
  [-628629984,-628430602,'Gemini'],
  [-628430602,-628241673,'Cancer'],
  [-628241673,-628058553,'Leo'],
  [-628058553,-627876793,'Virgo'],
  [-627876793,-627693607,'Libra'],
  [-627693607,-627507534,'Scorpio'],
  [-627507534,-627317085,'Sagittarius'],
  [-627317085,-627119931,'Capricorn'],
  [-627119931,-626913676,'Aquarius'],
  [-626913676,-626698379,'Pisces'],
  [-626698379,-626479091,'Aries'],
  [-626479091,-626264686,'Taurus'],
  [-626264686,-626062320,'Gemini'],
  [-626062320,-625873188,'Cancer'],
  [-625873188,-625693460,'Leo'],
  [-625693460,-625517330,'Virgo'],
  [-625517330,-625339304,'Libra'],
  [-625339304,-625155414,'Scorpio'],
  [-625155414,-624963576,'Sagittarius'],
  [-624963576,-624763223,'Capricorn'],
  [-624763223,-624554658,'Aquarius'],
  [-624554658,-624339072,'Pisces'],
  [-624339072,-624119799,'Aries'],
  [-624119799,-623903063,'Taurus'],
  [-623903063,-623696036,'Gemini'],
  [-623696036,-623502718,'Cancer'],
  [-623502718,-623321949,'Leo'],
  [-623321949,-623148734,'Virgo'],
  [-623148734,-622976457,'Libra'],
  [-622976457,-622798654,'Scorpio'],
  [-622798654,-622610527,'Sagittarius'],
  [-622610527,-622410377,'Capricorn'],
  [-622410377,-622199978,'Aquarius'],
  [-622199978,-621983088,'Pisces'],
  [-621983088,-621763802,'Aries'],
  [-621763802,-621546400,'Taurus'],
  [-621546400,-621335888,'Gemini'],
  [-621335888,-621136912,'Cancer'],
  [-621136912,-620951141,'Leo'],
  [-620951141,-620776094,'Virgo'],
  [-620776094,-620605983,'Libra'],
  [-620605983,-620433489,'Scorpio'],
  [-620433489,-620251582,'Sagittarius'],
  [-620251582,-620055761,'Capricorn'],
  [-620055761,-619846452,'Aquarius'],
  [-619846452,-619628860,'Pisces'],
  [-619628860,-619409398,'Aries'],
  [-619409398,-619192618,'Taurus'],
  [-619192618,-618981428,'Gemini'],
  [-618981428,-618778735,'Cancer'],
  [-618778735,-618587076,'Leo'],
  [-618587076,-618406652,'Virgo'],
  [-618406652,-618234048,'Libra'],
  [-618234048,-618062862,'Scorpio'],
  [-618062862,-617885484,'Sagittarius'],
  [-617885484,-617695346,'Capricorn'],
  [-617695346,-617490053,'Aquarius'],
  [-617490053,-617273635,'Pisces'],
  [-617273635,-617054169,'Aries'],
  [-617054169,-616838248,'Taurus'],
  [-616838248,-616628563,'Gemini'],
  [-616628563,-616425837,'Cancer'],
  [-616425837,-616231036,'Leo'],
  [-616231036,-616045125,'Virgo'],
  [-616045125,-615867135,'Libra'],
  [-615867135,-615692957,'Scorpio'],
  [-615692957,-615516082,'Sagittarius'],
  [-615516082,-615329551,'Capricorn'],
  [-615329551,-615128857,'Aquarius'],
  [-615128857,-614915300,'Pisces'],
  [-614915300,-614696367,'Aries'],
  [-614696367,-614480703,'Taurus'],
  [-614480703,-614272743,'Gemini'],
  [-614272743,-614072573,'Cancer'],
  [-614072573,-613878894,'Leo'],
  [-613878894,-613691007,'Virgo'],
  [-613691007,-613508406,'Libra'],
  [-613508406,-613329135,'Scorpio'],
  [-613329135,-613148996,'Sagittarius'],
  [-613148996,-612962350,'Capricorn'],
  [-612962350,-612764278,'Aquarius'],
  [-612764278,-612553757,'Pisces'],
  [-612553757,-612335871,'Aries'],
  [-612335871,-612119592,'Taurus'],
  [-612119592,-611911803,'Gemini'],
  [-611911803,-611714014,'Cancer'],
  [-611714014,-611523994,'Leo'],
  [-611523994,-611338674,'Virgo'],
  [-611338674,-611155647,'Libra'],
  [-611155647,-610972990,'Scorpio'],
  [-610972990,-610788347,'Sagittarius'],
  [-610788347,-610598483,'Capricorn'],
  [-610598483,-610399943,'Aquarius'],
  [-610399943,-610191015,'Pisces'],
  [-610191015,-609974231,'Aries'],
  [-609974231,-609756806,'Taurus'],
  [-609756806,-609546990,'Gemini'],
  [-609546990,-609348992,'Cancer'],
  [-609348992,-609161737,'Leo'],
  [-609161737,-608981067,'Virgo'],
  [-608981067,-608802123,'Libra'],
  [-608802123,-608620782,'Scorpio'],
  [-608620782,-608434206,'Sagittarius'],
  [-608434206,-608240723,'Capricorn'],
  [-608240723,-608039400,'Aquarius'],
  [-608039400,-607829940,'Pisces'],
  [-607829940,-607613740,'Aries'],
  [-607613740,-607395377,'Taurus'],
  [-607395377,-607182213,'Gemini'],
  [-607182213,-606980707,'Cancer'],
  [-606980707,-606792588,'Leo'],
  [-606792588,-606614689,'Virgo'],
  [-606614689,-606441058,'Libra'],
  [-606441058,-606265148,'Scorpio'],
  [-606265148,-606081595,'Sagittarius'],
  [-606081595,-605887697,'Capricorn'],
  [-605887697,-605683878,'Aquarius'],
  [-605683878,-605472437,'Pisces'],
  [-605472437,-605255947,'Aries'],
  [-605255947,-605037397,'Taurus'],
  [-605037397,-604821604,'Gemini'],
  [-604821604,-604614956,'Cancer'],
  [-604614956,-604421961,'Leo'],
  [-604421961,-604242283,'Virgo'],
  [-604242283,-604070926,'Libra'],
  [-604070926,-603900448,'Scorpio'],
  [-603900448,-603723224,'Sagittarius'],
  [-603723224,-603533707,'Capricorn'],
  [-603533707,-603330790,'Aquarius'],
  [-603330790,-603118018,'Pisces'],
  [-603118018,-602900574,'Aries'],
  [-602900574,-602682327,'Taurus'],
  [-602682327,-602466154,'Gemini'],
  [-602466154,-602256063,'Cancer'],
  [-602256063,-602056919,'Leo'],
  [-602056919,-601871310,'Virgo'],
  [-601871310,-601697064,'Libra'],
  [-601697064,-601527856,'Scorpio'],
  [-601527856,-601355560,'Sagittarius'],
  [-601355560,-601172570,'Capricorn'],
  [-601172570,-600974652,'Aquarius'],
  [-600974652,-600763505,'Pisces'],
  [-600763505,-600545598,'Aries'],
  [-600545598,-600327445,'Taurus'],
  [-600327445,-600112530,'Gemini'],
  [-600112530,-599902698,'Cancer'],
  [-599902698,-599700484,'Leo'],
  [-599700484,-599508747,'Virgo'],
  [-599508747,-599328036,'Libra'],
  [-599328036,-599154856,'Scorpio'],
  [-599154856,-598982573,'Sagittarius'],
  [-598982573,-598803524,'Capricorn'],
  [-598803524,-598611512,'Aquarius'],
  [-598611512,-598404921,'Pisces'],
  [-598404921,-598188404,'Aries'],
  [-598188404,-597970085,'Taurus'],
  [-597970085,-597756124,'Gemini'],
  [-597756124,-597548719,'Cancer'],
  [-597548719,-597348135,'Leo'],
  [-597348135,-597154766,'Virgo'],
  [-597154766,-596968985,'Libra'],
  [-596968985,-596789532,'Scorpio'],
  [-596789532,-596612599,'Sagittarius'],
  [-596612599,-596432466,'Capricorn'],
  [-596432466,-596243195,'Aquarius'],
  [-596243195,-596041135,'Pisces'],
  [-596041135,-595827631,'Aries'],
  [-595827631,-595609505,'Taurus'],
  [-595609505,-595395070,'Gemini'],
  [-595395070,-595189126,'Cancer'],
  [-595189126,-594992059,'Leo'],
  [-594992059,-594801956,'Virgo'],
  [-594801956,-594616570,'Libra'],
  [-594616570,-594433877,'Scorpio'],
  [-594433877,-594251637,'Sagittarius'],
  [-594251637,-594066872,'Capricorn'],
  [-594066872,-593875904,'Aquarius'],
  [-593875904,-593675417,'Pisces'],
  [-593675417,-593464578,'Aries'],
  [-593464578,-593247201,'Taurus'],
  [-593247201,-593031220,'Gemini'],
  [-593031220,-592824091,'Cancer'],
  [-592824091,-592628585,'Leo'],
  [-592628585,-592442701,'Virgo'],
  [-592442701,-592261971,'Libra'],
  [-592261971,-592081712,'Scorpio'],
  [-592081712,-591898350,'Sagittarius'],
  [-591898350,-591709787,'Capricorn'],
  [-591709787,-591514889,'Aquarius'],
  [-591514889,-591312662,'Pisces'],
  [-591312662,-591102457,'Aries'],
  [-591102457,-590885796,'Taurus'],
  [-590885796,-590668209,'Gemini'],
  [-590668209,-590457803,'Cancer'],
  [-590457803,-590260273,'Leo'],
  [-590260273,-590075676,'Virgo'],
  [-590075676,-589899332,'Libra'],
  [-589899332,-589724593,'Scorpio'],
  [-589724593,-589545292,'Sagittarius'],
  [-589545292,-589357516,'Capricorn'],
  [-589357516,-589160453,'Aquarius'],
  [-589160453,-588955408,'Pisces'],
  [-588955408,-588743884,'Aries'],
  [-588743884,-588527277,'Taurus'],
  [-588527277,-588308791,'Gemini'],
  [-588308791,-588094900,'Cancer'],
  [-588094900,-587892753,'Leo'],
  [-587892753,-587705335,'Virgo'],
  [-587705335,-587529704,'Libra'],
  [-587529704,-587359048,'Scorpio'],
  [-587359048,-587185591,'Sagittarius'],
  [-587185591,-587002894,'Capricorn'],
  [-587002894,-586807980,'Aquarius'],
  [-586807980,-586602138,'Pisces'],
  [-586602138,-586388986,'Aries'],
  [-586388986,-586171780,'Taurus'],
  [-586171780,-585953202,'Gemini'],
  [-585953202,-585737443,'Cancer'],
  [-585737443,-585530699,'Leo'],
  [-585530699,-585337827,'Virgo'],
  [-585337827,-585158662,'Libra'],
  [-585158662,-584987967,'Scorpio'],
  [-584987967,-584818015,'Sagittarius'],
  [-584818015,-584641054,'Capricorn'],
  [-584641054,-584451573,'Aquarius'],
  [-584451573,-584248510,'Pisces'],
  [-584248510,-584035408,'Aries'],
  [-584035408,-583817618,'Taurus'],
  [-583817618,-583599348,'Gemini'],
  [-583599348,-583383841,'Cancer'],
  [-583383841,-583175058,'Leo'],
  [-583175058,-582977269,'Virgo'],
  [-582977269,-582792264,'Libra'],
  [-582792264,-582617427,'Scorpio'],
  [-582617427,-582446666,'Sagittarius'],
  [-582446666,-582272547,'Capricorn'],
  [-582272547,-582088351,'Aquarius'],
  [-582088351,-581890379,'Pisces'],
  [-581890379,-581679846,'Aries'],
  [-581679846,-581462343,'Taurus'],
  [-581462343,-581244325,'Gemini'],
  [-581244325,-581030176,'Cancer'],
  [-581030176,-580822487,'Leo'],
  [-580822487,-580623244,'Virgo'],
  [-580623244,-580433706,'Libra'],
  [-580433706,-580253051,'Scorpio'],
  [-580253051,-580077727,'Sagittarius'],
  [-580077727,-579902161,'Capricorn'],
  [-579902161,-579720143,'Aquarius'],
  [-579720143,-579526653,'Pisces'],
  [-579526653,-579320134,'Aries'],
  [-579320134,-579104162,'Taurus'],
  [-579104162,-578886140,'Gemini'],
  [-578886140,-578672872,'Cancer'],
  [-578672872,-578467660,'Leo'],
  [-578467660,-578270730,'Virgo'],
  [-578270730,-578080950,'Libra'],
  [-578080950,-577896766,'Scorpio'],
  [-577896766,-577716081,'Sagittarius'],
  [-577716081,-577535843,'Capricorn'],
  [-577535843,-577351964,'Aquarius'],
  [-577351964,-577159979,'Pisces'],
  [-577159979,-576956751,'Aries'],
  [-576956751,-576743014,'Taurus'],
  [-576743014,-576524844,'Gemini'],
  [-576524844,-576310886,'Cancer'],
  [-576310886,-576106917,'Leo'],
  [-576106917,-575913458,'Virgo'],
  [-575913458,-575727389,'Libra'],
  [-575727389,-575544644,'Scorpio'],
  [-575544644,-575361967,'Sagittarius'],
  [-575361967,-575177305,'Capricorn'],
  [-575177305,-574989058,'Aquarius'],
  [-574989058,-574795062,'Pisces'],
  [-574795062,-574592661,'Aries'],
  [-574592661,-574380703,'Taurus'],
  [-574380703,-574162520,'Gemini'],
  [-574162520,-573946401,'Cancer'],
  [-573946401,-573740745,'Leo'],
  [-573740745,-573548466,'Virgo'],
  [-573548466,-573366483,'Libra'],
  [-573366483,-573188779,'Scorpio'],
  [-573188779,-573009456,'Sagittarius'],
  [-573009456,-572824719,'Capricorn'],
  [-572824719,-572633427,'Aquarius'],
  [-572633427,-572435789,'Pisces'],
  [-572435789,-572231532,'Aries'],
  [-572231532,-572019852,'Taurus'],
  [-572019852,-571801890,'Gemini'],
  [-571801890,-571583499,'Cancer'],
  [-571583499,-571373696,'Leo'],
  [-571373696,-571178498,'Virgo'],
  [-571178498,-570997087,'Libra'],
  [-570997087,-570823502,'Scorpio'],
  [-570823502,-570650163,'Sagittarius'],
  [-570650163,-570470548,'Capricorn'],
  [-570470548,-570281160,'Aquarius'],
  [-570281160,-570082076,'Pisces'],
  [-570082076,-569875214,'Aries'],
  [-569875214,-569662201,'Taurus'],
  [-569662201,-569444332,'Gemini'],
  [-569444332,-569225025,'Cancer'],
  [-569225025,-569011261,'Leo'],
  [-569011261,-568810341,'Virgo'],
  [-568810341,-568624701,'Libra'],
  [-568624701,-568450598,'Scorpio'],
  [-568450598,-568280790,'Sagittarius'],
  [-568280790,-568107459,'Capricorn'],
  [-568107459,-567924356,'Aquarius'],
  [-567924356,-567728705,'Pisces'],
  [-567728705,-567521783,'Aries'],
  [-567521783,-567307292,'Taurus'],
  [-567307292,-567088973,'Gemini'],
  [-567088973,-566870134,'Cancer'],
  [-566870134,-566655172,'Leo'],
  [-566655172,-566449634,'Virgo'],
  [-566449634,-566257432,'Libra'],
  [-566257432,-566077983,'Scorpio'],
  [-566077983,-565906390,'Sagittarius'],
  [-565906390,-565735581,'Capricorn'],
  [-565735581,-565558349,'Aquarius'],
  [-565558349,-565369184,'Pisces'],
  [-565369184,-565166252,'Aries'],
  [-565166252,-564952400,'Taurus'],
  [-564952400,-564733549,'Gemini'],
  [-564733549,-564515353,'Cancer'],
  [-564515353,-564301779,'Leo'],
  [-564301779,-564095711,'Virgo'],
  [-564095711,-563899385,'Libra'],
  [-563899385,-563713451,'Scorpio'],
  [-563713451,-563535927,'Sagittarius'],
  [-563535927,-563362291,'Capricorn'],
  [-563362291,-563186456,'Aquarius'],
  [-563186456,-563002155,'Pisces'],
  [-563002155,-562804863,'Aries'],
  [-562804863,-562594342,'Taurus'],
  [-562594342,-562375950,'Gemini'],
  [-562375950,-562157783,'Cancer'],
  [-562157783,-561945891,'Leo'],
  [-561945891,-561742390,'Virgo'],
  [-561742390,-561546858,'Libra'],
  [-561546858,-561358203,'Scorpio'],
  [-561358203,-561175152,'Sagittarius'],
  [-561175152,-560995735,'Capricorn'],
  [-560995735,-560816530,'Aquarius'],
  [-560816530,-560632626,'Pisces'],
  [-560632626,-560438834,'Aries'],
  [-560438834,-560232271,'Taurus'],
  [-560232271,-560015551,'Gemini'],
  [-560015551,-559796960,'Cancer'],
  [-559796960,-559585221,'Leo'],
  [-559585221,-559384129,'Virgo'],
  [-559384129,-559192246,'Libra'],
  [-559192246,-559005943,'Scorpio'],
  [-559005943,-558822030,'Sagittarius'],
  [-558822030,-558638642,'Capricorn'],
  [-558638642,-558454455,'Aquarius'],
  [-558454455,-558267175,'Pisces'],
  [-558267175,-558073069,'Aries'],
  [-558073069,-557868574,'Taurus'],
  [-557868574,-557653687,'Gemini'],
  [-557653687,-557434634,'Cancer'],
  [-557434634,-557221249,'Leo'],
  [-557221249,-557020062,'Virgo'],
  [-557020062,-556830880,'Libra'],
  [-556830880,-556649007,'Scorpio'],
  [-556649007,-556468894,'Sagittarius'],
  [-556468894,-556286527,'Capricorn'],
  [-556286527,-556100120,'Aquarius'],
  [-556100120,-555909016,'Pisces'],
  [-555909016,-555711965,'Aries'],
  [-555711965,-555506835,'Taurus'],
  [-555506835,-555292749,'Gemini'],
  [-555292749,-555073397,'Cancer'],
  [-555073397,-554857463,'Leo'],
  [-554857463,-554653388,'Virgo'],
  [-554653388,-554463591,'Libra'],
  [-554463591,-554284324,'Scorpio'],
  [-554284324,-554109088,'Sagittarius'],
  [-554109088,-553931661,'Capricorn'],
  [-553931661,-553747878,'Aquarius'],
  [-553747878,-553556157,'Pisces'],
  [-553556157,-553356513,'Aries'],
  [-553356513,-553149186,'Taurus'],
  [-553149186,-552934541,'Gemini'],
  [-552934541,-552715040,'Cancer'],
  [-552715040,-552497031,'Leo'],
  [-552497031,-552288717,'Virgo'],
  [-552288717,-552094937,'Libra'],
  [-552094937,-551914375,'Scorpio'],
  [-551914375,-551741389,'Sagittarius'],
  [-551741389,-551568983,'Capricorn'],
  [-551568983,-551390873,'Aquarius'],
  [-551390873,-551202914,'Pisces'],
  [-551202914,-551003860,'Aries'],
  [-551003860,-550795046,'Taurus'],
  [-550795046,-550579163,'Gemini'],
  [-550579163,-550359534,'Cancer'],
  [-550359534,-550140880,'Leo'],
  [-550140880,-549929333,'Virgo'],
  [-549929333,-549730186,'Libra'],
  [-549730186,-549544747,'Scorpio'],
  [-549544747,-549369732,'Sagittarius'],
  [-549369732,-549199071,'Capricorn'],
  [-549199071,-549025846,'Aquarius'],
  [-549025846,-548843818,'Pisces'],
  [-548843818,-548649044,'Aries'],
  [-548649044,-548441451,'Taurus'],
  [-548441451,-548224955,'Gemini'],
  [-548224955,-548005157,'Cancer'],
  [-548005157,-547787139,'Leo'],
  [-547787139,-547575030,'Virgo'],
  [-547575030,-547372278,'Libra'],
  [-547372278,-547180965,'Scorpio'],
  [-547180965,-547000440,'Sagittarius'],
  [-547000440,-546827052,'Capricorn'],
  [-546827052,-546654956,'Aquarius'],
  [-546654956,-546477376,'Pisces'],
  [-546477376,-546288249,'Aries'],
  [-546288249,-546084697,'Taurus'],
  [-546084697,-545869374,'Gemini'],
  [-545869374,-545649531,'Cancer'],
  [-545649531,-545432417,'Leo'],
  [-545432417,-545222001,'Virgo'],
  [-545222001,-545019429,'Libra'],
  [-545019429,-544825009,'Scorpio'],
  [-544825009,-544638772,'Sagittarius'],
  [-544638772,-544459594,'Capricorn'],
  [-544459594,-544284172,'Aquarius'],
  [-544284172,-544106996,'Pisces'],
  [-544106996,-543921562,'Aries'],
  [-543921562,-543722772,'Taurus'],
  [-543722772,-543510414,'Gemini'],
  [-543510414,-543291013,'Cancer'],
  [-543291013,-543074027,'Leo'],
  [-543074027,-542865431,'Virgo'],
  [-542865431,-542665779,'Libra'],
  [-542665779,-542472914,'Scorpio'],
  [-542472914,-542284913,'Sagittarius'],
  [-542284913,-542100911,'Capricorn'],
  [-542100911,-541919885,'Aquarius'],
  [-541919885,-541738970,'Pisces'],
  [-541738970,-541553189,'Aries'],
  [-541553189,-541357078,'Taurus'],
  [-541357078,-541147991,'Gemini'],
  [-541147991,-540929715,'Cancer'],
  [-540929715,-540711836,'Leo'],
  [-540711836,-540503061,'Virgo'],
  [-540503061,-540305763,'Libra'],
  [-540305763,-540116999,'Scorpio'],
  [-540116999,-539932338,'Sagittarius'],
  [-539932338,-539748579,'Capricorn'],
  [-539748579,-539564311,'Aquarius'],
  [-539564311,-539378526,'Pisces'],
  [-539378526,-539188946,'Aries'],
  [-539188946,-538991920,'Taurus'],
  [-538991920,-538784405,'Gemini'],
  [-538784405,-538567490,'Cancer'],
  [-538567490,-538348439,'Leo'],
  [-538348439,-538137046,'Virgo'],
  [-538137046,-537938767,'Libra'],
  [-537938767,-537752342,'Scorpio'],
  [-537752342,-537572621,'Sagittarius'],
  [-537572621,-537393958,'Capricorn'],
  [-537393958,-537212206,'Aquarius'],
  [-537212206,-537025222,'Pisces'],
  [-537025222,-536832017,'Aries'],
  [-536832017,-536631642,'Taurus'],
  [-536631642,-536423069,'Gemini'],
  [-536423069,-536206788,'Cancer'],
  [-536206788,-535987203,'Leo'],
  [-535987203,-535772418,'Virgo'],
  [-535772418,-535569778,'Libra'],
  [-535569778,-535381231,'Scorpio'],
  [-535381231,-535203294,'Sagittarius'],
  [-535203294,-535029812,'Capricorn'],
  [-535029812,-534854376,'Aquarius'],
  [-534854376,-534671869,'Pisces'],
  [-534671869,-534479481,'Aries'],
  [-534479481,-534276980,'Taurus'],
  [-534276980,-534066011,'Gemini'],
  [-534066011,-533849064,'Cancer'],
  [-533849064,-533629631,'Leo'],
  [-533629631,-533412969,'Virgo'],
  [-533412969,-533205382,'Libra'],
  [-533205382,-533011122,'Scorpio'],
  [-533011122,-532829894,'Sagittarius'],
  [-532829894,-532657274,'Capricorn'],
  [-532657274,-532486592,'Aquarius'],
  [-532486592,-532310761,'Pisces'],
  [-532310761,-532123974,'Aries'],
  [-532123974,-531923698,'Taurus'],
  [-531923698,-531711935,'Gemini'],
  [-531711935,-531493798,'Cancer'],
  [-531493798,-531274522,'Leo'],
  [-531274522,-531058135,'Virgo'],
  [-531058135,-530848260,'Libra'],
  [-530848260,-530648526,'Scorpio'],
  [-530648526,-530460926,'Sagittarius'],
  [-530460926,-530284120,'Capricorn'],
  [-530284120,-530113239,'Aquarius'],
  [-530113239,-529941218,'Pisces'],
  [-529941218,-529760624,'Aries'],
  [-529760624,-529565996,'Taurus'],
  [-529565996,-529356861,'Gemini'],
  [-529356861,-529138712,'Cancer'],
  [-529138712,-528919342,'Leo'],
  [-528919342,-528704130,'Virgo'],
  [-528704130,-528495211,'Libra'],
  [-528495211,-528293745,'Scorpio'],
  [-528293745,-528101157,'Sagittarius'],
  [-528101157,-527918086,'Capricorn'],
  [-527918086,-527742546,'Aquarius'],
  [-527742546,-527569360,'Pisces'],
  [-527569360,-527391427,'Aries'],
  [-527391427,-527201914,'Taurus'],
  [-527201914,-526997462,'Gemini'],
  [-526997462,-526781291,'Cancer'],
  [-526781291,-526561990,'Leo'],
  [-526561990,-526347440,'Virgo'],
  [-526347440,-526140685,'Libra'],
  [-526140685,-525941233,'Scorpio'],
  [-525941233,-525748150,'Sagittarius'],
  [-525748150,-525561295,'Capricorn'],
  [-525561295,-525380214,'Aquarius'],
  [-525380214,-525202338,'Pisces'],
  [-525202338,-525022573,'Aries'],
  [-525022573,-524834670,'Taurus'],
  [-524834670,-524633922,'Gemini'],
  [-524633922,-524420699,'Cancer'],
  [-524420699,-524201933,'Leo'],
  [-524201933,-523986971,'Virgo'],
  [-523986971,-523781261,'Libra'],
  [-523781261,-523584806,'Scorpio'],
  [-523584806,-523394939,'Sagittarius'],
  [-523394939,-523209135,'Capricorn'],
  [-523209135,-523025840,'Aquarius'],
  [-523025840,-522843525,'Pisces'],
  [-522843525,-522659433,'Aries'],
  [-522659433,-522469446,'Taurus'],
  [-522469446,-522269506,'Gemini'],
  [-522269506,-522058418,'Cancer'],
  [-522058418,-521840429,'Leo'],
  [-521840429,-521624181,'Virgo'],
  [-521624181,-521417277,'Libra'],
  [-521417277,-521221936,'Scorpio'],
  [-521221936,-521035678,'Sagittarius'],
  [-521035678,-520854214,'Capricorn'],
  [-520854214,-520673535,'Aquarius'],
  [-520673535,-520490668,'Pisces'],
  [-520490668,-520303411,'Aries'],
  [-520303411,-520109786,'Taurus'],
  [-520109786,-519907939,'Gemini'],
  [-519907939,-519697121,'Cancer'],
  [-519697121,-519479675,'Leo'],
  [-519479675,-519261961,'Virgo'],
  [-519261961,-519051962,'Libra'],
  [-519051962,-518854540,'Scorpio'],
  [-518854540,-518669215,'Sagittarius'],
  [-518669215,-518491700,'Capricorn'],
  [-518491700,-518316243,'Aquarius'],
  [-518316243,-518137379,'Pisces'],
  [-518137379,-517951112,'Aries'],
  [-517951112,-517755605,'Taurus'],
  [-517755605,-517551064,'Gemini'],
  [-517551064,-517338883,'Cancer'],
  [-517338883,-517121414,'Leo'],
  [-517121414,-516902825,'Virgo'],
  [-516902825,-516689411,'Libra'],
  [-516689411,-516487353,'Scorpio'],
  [-516487353,-516299051,'Sagittarius'],
  [-516299051,-516122056,'Capricorn'],
  [-516122056,-515950549,'Aquarius'],
  [-515950549,-515777442,'Pisces'],
  [-515777442,-515596232,'Aries'],
  [-515596232,-515402943,'Taurus'],
  [-515402943,-515197661,'Gemini'],
  [-515197661,-514983865,'Cancer'],
  [-514983865,-514765838,'Leo'],
  [-514765838,-514547242,'Virgo'],
  [-514547242,-514332013,'Libra'],
  [-514332013,-514125232,'Scorpio'],
  [-514125232,-513931165,'Sagittarius'],
  [-513931165,-513750320,'Capricorn'],
  [-513750320,-513578650,'Aquarius'],
  [-513578650,-513409103,'Pisces'],
  [-513409103,-513233769,'Aries'],
  [-513233769,-513046103,'Taurus'],
  [-513046103,-512843744,'Gemini'],
  [-512843744,-512630015,'Cancer'],
  [-512630015,-512411398,'Leo'],
  [-512411398,-512193232,'Virgo'],
  [-512193232,-511978477,'Libra'],
  [-511978477,-511769764,'Scorpio'],
  [-511769764,-511570551,'Sagittarius'],
  [-511570551,-511383325,'Capricorn'],
  [-511383325,-511206982,'Aquarius'],
  [-511206982,-511036332,'Pisces'],
  [-511036332,-510863806,'Aries'],
  [-510863806,-510681669,'Taurus'],
  [-510681669,-510484823,'Gemini'],
  [-510484823,-510273961,'Cancer'],
  [-510273961,-510055651,'Leo'],
  [-510055651,-509837681,'Virgo'],
  [-509837681,-509624458,'Libra'],
  [-509624458,-509417268,'Scorpio'],
  [-509417268,-509217002,'Sagittarius'],
  [-509217002,-509025206,'Capricorn'],
  [-509025206,-508842499,'Aquarius'],
  [-508842499,-508666542,'Pisces'],
  [-508666542,-508491908,'Aries'],
  [-508491908,-508311616,'Taurus'],
  [-508311616,-508119460,'Gemini'],
  [-508119460,-507913151,'Cancer'],
  [-507913151,-507696704,'Leo'],
  [-507696704,-507478581,'Virgo'],
  [-507478581,-507265959,'Libra'],
  [-507265959,-507061355,'Scorpio'],
  [-507061355,-506864091,'Sagittarius'],
  [-506864091,-506672962,'Capricorn'],
  [-506672962,-506487214,'Aquarius'],
  [-506487214,-506305670,'Pisces'],
  [-506305670,-506125567,'Aries'],
  [-506125567,-505942429,'Taurus'],
  [-505942429,-505751163,'Gemini'],
  [-505751163,-505548258,'Cancer'],
  [-505548258,-505334562,'Leo'],
  [-505334562,-505116449,'Virgo'],
  [-505116449,-504902607,'Libra'],
  [-504902607,-504698537,'Scorpio'],
  [-504698537,-504504608,'Sagittarius'],
  [-504504608,-504317971,'Capricorn'],
  [-504317971,-504135001,'Aquarius'],
  [-504135001,-503952614,'Pisces'],
  [-503952614,-503768446,'Aries'],
  [-503768446,-503580377,'Taurus'],
  [-503580377,-503386086,'Gemini'],
  [-503386086,-503183332,'Cancer'],
  [-503183332,-502971513,'Leo'],
  [-502971513,-502753867,'Virgo'],
  [-502753867,-502537807,'Libra'],
  [-502537807,-502331134,'Scorpio'],
  [-502331134,-502137231,'Sagittarius'],
  [-502137231,-501954137,'Capricorn'],
  [-501954137,-501776674,'Aquarius'],
  [-501776674,-501598970,'Pisces'],
  [-501598970,-501416294,'Aries'],
  [-501416294,-501226122,'Taurus'],
  [-501226122,-501028084,'Gemini'],
  [-501028084,-500822753,'Cancer'],
  [-500822753,-500610720,'Leo'],
  [-500610720,-500393555,'Virgo'],
  [-500393555,-500175821,'Libra'],
  [-500175821,-499964960,'Scorpio'],
  [-499964960,-499767136,'Sagittarius'],
  [-499767136,-499583261,'Capricorn'],
  [-499583261,-499408928,'Aquarius'],
  [-499408928,-499237003,'Pisces'],
  [-499237003,-499060244,'Aries'],
  [-499060244,-498873441,'Taurus'],
  [-498873441,-498675163,'Gemini'],
  [-498675163,-498467545,'Cancer'],
  [-498467545,-498253835,'Leo'],
  [-498253835,-498036549,'Virgo'],
  [-498036549,-497818414,'Libra'],
  [-497818414,-497604471,'Scorpio'],
  [-497604471,-497401213,'Sagittarius'],
  [-497401213,-497212440,'Capricorn'],
  [-497212440,-497036388,'Aquarius'],
  [-497036388,-496866718,'Pisces'],
  [-496866718,-496695350,'Aries'],
  [-496695350,-496514870,'Taurus'],
  [-496514870,-496320973,'Gemini'],
  [-496320973,-496114362,'Cancer'],
  [-496114362,-495899634,'Leo'],
  [-495899634,-495681745,'Virgo'],
  [-495681745,-495464015,'Libra'],
  [-495464015,-495249524,'Scorpio'],
  [-495249524,-495042765,'Sagittarius'],
  [-495042765,-494848156,'Capricorn'],
  [-494848156,-494666661,'Aquarius'],
  [-494666661,-494494392,'Pisces'],
  [-494494392,-494324262,'Aries'],
  [-494324262,-494148412,'Taurus'],
  [-494148412,-493960493,'Gemini'],
  [-493960493,-493758264,'Cancer'],
  [-493758264,-493544886,'Leo'],
  [-493544886,-493326770,'Virgo'],
  [-493326770,-493109481,'Libra'],
  [-493109481,-492896261,'Scorpio'],
  [-492896261,-492689525,'Sagittarius'],
  [-492689525,-492491868,'Capricorn'],
  [-492491868,-492304844,'Aquarius'],
  [-492304844,-492127007,'Pisces'],
  [-492127007,-491953645,'Aries'],
  [-491953645,-491778165,'Taurus'],
  [-491778165,-491593980,'Gemini'],
  [-491593980,-491396765,'Cancer'],
  [-491396765,-491186802,'Leo'],
  [-491186802,-490969506,'Virgo'],
  [-490969506,-490752302,'Libra'],
  [-490752302,-490540446,'Scorpio'],
  [-490540446,-490336057,'Sagittarius'],
  [-490336057,-490139490,'Capricorn'],
  [-490139490,-489950482,'Aquarius'],
  [-489950482,-489767943,'Pisces'],
  [-489767943,-489589278,'Aries'],
  [-489589278,-489410296,'Taurus'],
  [-489410296,-489225888,'Gemini'],
  [-489225888,-489031449,'Cancer'],
  [-489031449,-488825018,'Leo'],
  [-488825018,-488609404,'Virgo'],
  [-488609404,-488391903,'Libra'],
  [-488391903,-488180106,'Scorpio'],
  [-488180106,-487977826,'Sagittarius'],
  [-487977826,-487784693,'Capricorn'],
  [-487784693,-487598092,'Aquarius'],
  [-487598092,-487415020,'Pisces'],
  [-487415020,-487232847,'Aries'],
  [-487232847,-487049190,'Taurus'],
  [-487049190,-486861394,'Gemini'],
  [-486861394,-486666397,'Cancer'],
  [-486666397,-486461726,'Leo'],
  [-486461726,-486247770,'Virgo'],
  [-486247770,-486029788,'Libra'],
  [-486029788,-485816317,'Scorpio'],
  [-485816317,-485613827,'Sagittarius'],
  [-485613827,-485423261,'Capricorn'],
  [-485423261,-485241007,'Aquarius'],
  [-485241007,-485061721,'Pisces'],
  [-485061721,-484880663,'Aries'],
  [-484880663,-484694934,'Taurus'],
  [-484694934,-484503400,'Gemini'],
  [-484503400,-484305468,'Cancer'],
  [-484305468,-484100128,'Leo'],
  [-484100128,-483886909,'Virgo'],
  [-483886909,-483668558,'Libra'],
  [-483668558,-483452398,'Scorpio'],
  [-483452398,-483246816,'Sagittarius'],
  [-483246816,-483055510,'Capricorn'],
  [-483055510,-482875875,'Aquarius'],
  [-482875875,-482701553,'Pisces'],
  [-482701553,-482525563,'Aries'],
  [-482525563,-482342601,'Taurus'],
  [-482342601,-482150516,'Gemini'],
  [-482150516,-481949980,'Cancer'],
  [-481949980,-481742424,'Leo'],
  [-481742424,-481528675,'Virgo'],
  [-481528675,-481310216,'Libra'],
  [-481310216,-481091896,'Scorpio'],
  [-481091896,-480881735,'Sagittarius'],
  [-480881735,-480685990,'Capricorn'],
  [-480685990,-480504772,'Aquarius'],
  [-480504772,-480332648,'Pisces'],
  [-480332648,-480161848,'Aries'],
  [-480161848,-479984946,'Taurus'],
  [-479984946,-479797043,'Gemini'],
  [-479797043,-479597324,'Cancer'],
  [-479597324,-479388293,'Leo'],
  [-479388293,-479173243,'Virgo'],
  [-479173243,-478954735,'Libra'],
  [-478954735,-478735950,'Scorpio'],
  [-478735950,-478522536,'Sagittarius'],
  [-478522536,-478320951,'Capricorn'],
  [-478320951,-478134120,'Aquarius'],
  [-478134120,-477959305,'Pisces'],
  [-477959305,-477789855,'Aries'],
  [-477789855,-477617912,'Taurus'],
  [-477617912,-477436535,'Gemini'],
  [-477436535,-477241842,'Cancer'],
  [-477241842,-477034493,'Leo'],
  [-477034493,-476818845,'Virgo'],
  [-476818845,-476600058,'Libra'],
  [-476600058,-476382118,'Scorpio'],
  [-476382118,-476168653,'Sagittarius'],
  [-476168653,-475963770,'Capricorn'],
  [-475963770,-475770713,'Aquarius'],
  [-475770713,-475589479,'Pisces'],
  [-475589479,-475416200,'Aries'],
  [-475416200,-475244529,'Taurus'],
  [-475244529,-475067429,'Gemini'],
  [-475067429,-474878979,'Cancer'],
  [-474878979,-474676558,'Leo'],
  [-474676558,-474462592,'Virgo'],
  [-474462592,-474243630,'Libra'],
  [-474243630,-474026383,'Scorpio'],
  [-474026383,-473814976,'Sagittarius'],
  [-473814976,-473611224,'Capricorn'],
  [-473611224,-473415930,'Aquarius'],
  [-473415930,-473229105,'Pisces'],
  [-473229105,-473049261,'Aries'],
  [-473049261,-472872964,'Taurus'],
  [-472872964,-472695102,'Gemini'],
  [-472695102,-472509878,'Cancer'],
  [-472509878,-472312592,'Leo'],
  [-472312592,-472102347,'Virgo'],
  [-472102347,-471884109,'Libra'],
  [-471884109,-471666559,'Scorpio'],
  [-471666559,-471456540,'Sagittarius'],
  [-471456540,-471256043,'Capricorn'],
  [-471256043,-471063480,'Aquarius'],
  [-471063480,-470876303,'Pisces'],
  [-470876303,-470692454,'Aries'],
  [-470692454,-470510305,'Taurus'],
  [-470510305,-470327655,'Gemini'],
  [-470327655,-470140910,'Cancer'],
  [-470140910,-469945623,'Leo'],
  [-469945623,-469738774,'Virgo'],
  [-469738774,-469522178,'Libra'],
  [-469522178,-469303722,'Scorpio'],
  [-469303722,-469092782,'Sagittarius'],
  [-469092782,-468893883,'Capricorn'],
  [-468893883,-468705374,'Aquarius'],
  [-468705374,-468522457,'Pisces'],
  [-468522457,-468340433,'Aries'],
  [-468340433,-468156435,'Taurus'],
  [-468156435,-467969375,'Gemini'],
  [-467969375,-467778351,'Cancer'],
  [-467778351,-467581228,'Leo'],
  [-467581228,-467375278,'Virgo'],
  [-467375278,-467160128,'Libra'],
  [-467160128,-466940948,'Scorpio'],
  [-466940948,-466727290,'Sagittarius'],
  [-466727290,-466526564,'Capricorn'],
  [-466526564,-466339338,'Aquarius'],
  [-466339338,-466160705,'Pisces'],
  [-466160705,-465984022,'Aries'],
  [-465984022,-465803755,'Taurus'],
  [-465803755,-465617002,'Gemini'],
  [-465617002,-465423306,'Cancer'],
  [-465423306,-465222889,'Leo'],
  [-465222889,-465015308,'Virgo'],
  [-465015308,-464800350,'Libra'],
  [-464800350,-464580923,'Scorpio'],
  [-464580923,-464364500,'Sagittarius'],
  [-464364500,-464159516,'Capricorn'],
  [-464159516,-463969494,'Aquarius'],
  [-463969494,-463791469,'Pisces'],
  [-463791469,-463618816,'Aries'],
  [-463618816,-463444396,'Taurus'],
  [-463444396,-463262653,'Gemini'],
  [-463262653,-463070919,'Cancer'],
  [-463070919,-462869368,'Leo'],
  [-462869368,-462659668,'Virgo'],
  [-462659668,-462443735,'Libra'],
  [-462443735,-462224300,'Scorpio'],
  [-462224300,-462006537,'Sagittarius'],
  [-462006537,-461797453,'Capricorn'],
  [-461797453,-461602136,'Aquarius'],
  [-461602136,-461420462,'Pisces'],
  [-461420462,-461247629,'Aries'],
  [-461247629,-461076715,'Taurus'],
  [-461076715,-460900804,'Gemini'],
  [-460900804,-460714606,'Cancer'],
  [-460714606,-460515884,'Leo'],
  [-460515884,-460306061,'Virgo'],
  [-460306061,-460089133,'Libra'],
  [-460089133,-459869664,'Scorpio'],
  [-459869664,-459652194,'Sagittarius'],
  [-459652194,-459441411,'Capricorn'],
  [-459441411,-459241468,'Aquarius'],
  [-459241468,-459053996,'Pisces'],
  [-459053996,-458876894,'Aries'],
  [-458876894,-458705090,'Taurus'],
  [-458705090,-458532050,'Gemini'],
  [-458532050,-458351240,'Cancer'],
  [-458351240,-458157827,'Leo'],
  [-458157827,-457950811,'Virgo'],
  [-457950811,-457734154,'Libra'],
  [-457734154,-457514630,'Scorpio'],
  [-457514630,-457298200,'Sagittarius'],
  [-457298200,-457088432,'Capricorn'],
  [-457088432,-456887153,'Aquarius'],
  [-456887153,-456695277,'Pisces'],
  [-456695277,-456512370,'Aries'],
  [-456512370,-456335967,'Taurus'],
  [-456335967,-456161475,'Gemini'],
  [-456161475,-455982840,'Cancer'],
  [-455982840,-455794006,'Leo'],
  [-455794006,-455591356,'Virgo'],
  [-455591356,-455376651,'Libra'],
  [-455376651,-455157247,'Scorpio'],
  [-455157247,-454941459,'Sagittarius'],
  [-454941459,-454733806,'Capricorn'],
  [-454733806,-454534578,'Aquarius'],
  [-454534578,-454342361,'Pisces'],
  [-454342361,-454155915,'Aries'],
  [-454155915,-453974166,'Taurus'],
  [-453974166,-453795042,'Gemini'],
  [-453795042,-453614533,'Cancer'],
  [-453614533,-453427146,'Leo'],
  [-453427146,-453227949,'Virgo'],
  [-453227949,-453016017,'Libra'],
  [-453016017,-452797062,'Scorpio'],
  [-452797062,-452580811,'Sagittarius'],
  [-452580811,-452374198,'Capricorn'],
  [-452374198,-452178013,'Aquarius'],
  [-452178013,-451989089,'Pisces'],
  [-451989089,-451803788,'Aries'],
  [-451803788,-451619885,'Taurus'],
  [-451619885,-451436304,'Gemini'],
  [-451436304,-451251426,'Cancer'],
  [-451251426,-451061921,'Leo'],
  [-451061921,-450863479,'Virgo'],
  [-450863479,-450653621,'Libra'],
  [-450653621,-450435361,'Scorpio'],
  [-450435361,-450217647,'Sagittarius'],
  [-450217647,-450009639,'Capricorn'],
  [-450009639,-449814494,'Aquarius'],
  [-449814494,-449629269,'Pisces'],
  [-449629269,-449448555,'Aries'],
  [-449448555,-449267573,'Taurus'],
  [-449267573,-449083598,'Gemini'],
  [-449083598,-448895512,'Cancer'],
  [-448895512,-448702209,'Leo'],
  [-448702209,-448501693,'Virgo'],
  [-448501693,-448292059,'Libra'],
  [-448292059,-448074396,'Scorpio'],
  [-448074396,-447855134,'Sagittarius'],
  [-447855134,-447643630,'Capricorn'],
  [-447643630,-447445881,'Aquarius'],
  [-447445881,-447261233,'Pisces'],
  [-447261233,-447084478,'Aries'],
  [-447084478,-446909182,'Taurus'],
  [-446909182,-446729897,'Gemini'],
  [-446729897,-446543314,'Cancer'],
  [-446543314,-446348264,'Leo'],
  [-446348264,-446144831,'Virgo'],
  [-446144831,-445933569,'Libra'],
  [-445933569,-445715920,'Scorpio'],
  [-445715920,-445496013,'Sagittarius'],
  [-445496013,-445281021,'Capricorn'],
  [-445281021,-445077975,'Aquarius'],
  [-445077975,-444889379,'Pisces'],
  [-444889379,-444712329,'Aries'],
  [-444712329,-444540753,'Taurus'],
  [-444540753,-444367747,'Gemini'],
  [-444367747,-444187213,'Cancer'],
  [-444187213,-443995308,'Leo'],
  [-443995308,-443791519,'Virgo'],
  [-443791519,-443578435,'Libra'],
  [-443578435,-443360015,'Scorpio'],
  [-443360015,-443140386,'Sagittarius'],
  [-443140386,-442924152,'Capricorn'],
  [-442924152,-442716507,'Aquarius'],
  [-442716507,-442521416,'Pisces'],
  [-442521416,-442339210,'Aries'],
  [-442339210,-442166238,'Taurus'],
  [-442166238,-441996192,'Gemini'],
  [-441996192,-441821792,'Cancer'],
  [-441821792,-441636481,'Leo'],
  [-441636481,-441436735,'Virgo'],
  [-441436735,-441224229,'Libra'],
  [-441224229,-441005050,'Scorpio'],
  [-441005050,-440785749,'Sagittarius'],
  [-440785749,-440570564,'Capricorn'],
  [-440570564,-440362001,'Aquarius'],
  [-440362001,-440162374,'Pisces'],
  [-440162374,-439973379,'Aries'],
  [-439973379,-439794491,'Taurus'],
  [-439794491,-439621955,'Gemini'],
  [-439621955,-439449374,'Cancer'],
  [-439449374,-439269334,'Leo'],
  [-439269334,-439075722,'Virgo'],
  [-439075722,-438867056,'Libra'],
  [-438867056,-438648604,'Scorpio'],
  [-438648604,-438429253,'Sagittarius'],
  [-438429253,-438215452,'Capricorn'],
  [-438215452,-438009043,'Aquarius'],
  [-438009043,-437809683,'Pisces'],
  [-437809683,-437617337,'Aries'],
  [-437617337,-437432367,'Taurus'],
  [-437432367,-437253815,'Gemini'],
  [-437253815,-437077913,'Cancer'],
  [-437077913,-436898479,'Leo'],
  [-436898479,-436708831,'Virgo'],
  [-436708831,-436504927,'Libra'],
  [-436504927,-436289005,'Scorpio'],
  [-436289005,-436069687,'Sagittarius'],
  [-436069687,-435856016,'Capricorn'],
  [-435856016,-435651743,'Aquarius'],
  [-435651743,-435455689,'Pisces'],
  [-435455689,-435265259,'Aries'],
  [-435265259,-435078824,'Taurus'],
  [-435078824,-434895677,'Gemini'],
  [-434895677,-434714337,'Cancer'],
  [-434714337,-434531252,'Leo'],
  [-434531252,-434341281,'Virgo'],
  [-434341281,-434139921,'Libra'],
  [-434139921,-433926788,'Scorpio'],
  [-433926788,-433707956,'Sagittarius'],
  [-433707956,-433493064,'Capricorn'],
  [-433493064,-433288636,'Aquarius'],
  [-433288636,-433095065,'Pisces'],
  [-433095065,-432908877,'Aries'],
  [-432908877,-432725979,'Taurus'],
  [-432725979,-432543411,'Gemini'],
  [-432543411,-432359316,'Cancer'],
  [-432359316,-432171870,'Leo'],
  [-432171870,-431978502,'Virgo'],
  [-431978502,-431776385,'Libra'],
  [-431776385,-431564515,'Scorpio'],
  [-431564515,-431346320,'Sagittarius'],
  [-431346320,-431129696,'Capricorn'],
  [-431129696,-430922657,'Aquarius'],
  [-430922657,-430728372,'Pisces'],
  [-430728372,-430544662,'Aries'],
  [-430544662,-430366577,'Taurus'],
  [-430366577,-430188807,'Gemini'],
  [-430188807,-430007067,'Cancer'],
  [-430007067,-429818626,'Leo'],
  [-429818626,-429622186,'Virgo'],
  [-429622186,-429417415,'Libra'],
  [-429417415,-429204845,'Scorpio'],
  [-429204845,-428986918,'Sagittarius'],
  [-428986918,-428769006,'Capricorn'],
  [-428769006,-428558334,'Aquarius'],
  [-428558334,-428360225,'Pisces'],
  [-428360225,-428175159,'Aries'],
  [-428175159,-427999287,'Taurus'],
  [-427999287,-427826496,'Gemini'],
  [-427826496,-427650321,'Cancer'],
  [-427650321,-427465508,'Leo'],
  [-427465508,-427269454,'Virgo'],
  [-427269454,-427062861,'Libra'],
  [-427062861,-426848669,'Scorpio'],
  [-426848669,-426630458,'Sagittarius'],
  [-426630458,-426412199,'Capricorn'],
  [-426412199,-426198867,'Aquarius'],
  [-426198867,-425995824,'Pisces'],
  [-425995824,-425806031,'Aries'],
  [-425806031,-425628169,'Taurus'],
  [-425628169,-425457109,'Gemini'],
  [-425457109,-425285707,'Cancer'],
  [-425285707,-425106724,'Leo'],
  [-425106724,-424914948,'Virgo'],
  [-424914948,-424709572,'Libra'],
  [-424709572,-424494590,'Scorpio'],
  [-424494590,-424275855,'Sagittarius'],
  [-424275855,-424057985,'Capricorn'],
  [-424057985,-423844200,'Aquarius'],
  [-423844200,-423637909,'Pisces'],
  [-423637909,-423442561,'Aries'],
  [-423442561,-423259390,'Taurus'],
  [-423259390,-423085705,'Gemini'],
  [-423085705,-422915367,'Cancer'],
  [-422915367,-422740663,'Leo'],
  [-422740663,-422554500,'Virgo'],
  [-422554500,-422353349,'Libra'],
  [-422353349,-422139753,'Scorpio'],
  [-422139753,-421920886,'Sagittarius'],
  [-421920886,-421703521,'Capricorn'],
  [-421703521,-421491042,'Aquarius'],
  [-421491042,-421284826,'Pisces'],
  [-421284826,-421086500,'Aries'],
  [-421086500,-420897820,'Taurus'],
  [-420897820,-420718546,'Gemini'],
  [-420718546,-420544957,'Cancer'],
  [-420544957,-420370550,'Leo'],
  [-420370550,-420187970,'Virgo'],
  [-420187970,-419991719,'Libra'],
  [-419991719,-419781515,'Scorpio'],
  [-419781515,-419563474,'Sagittarius'],
  [-419563474,-419346191,'Capricorn'],
  [-419346191,-419135109,'Aquarius'],
  [-419135109,-418931344,'Pisces'],
  [-418931344,-418734263,'Aries'],
  [-418734263,-418543671,'Taurus'],
  [-418543671,-418359573,'Gemini'],
  [-418359573,-418180454,'Cancer'],
  [-418180454,-418002302,'Leo'],
  [-418002302,-417819301,'Virgo'],
  [-417819301,-417625784,'Libra'],
  [-417625784,-417419224,'Scorpio'],
  [-417419224,-417202952,'Sagittarius'],
  [-417202952,-416985259,'Capricorn'],
  [-416985259,-416774029,'Aquarius'],
  [-416774029,-416572317,'Pisces'],
  [-416572317,-416378925,'Aries'],
  [-416378925,-416191211,'Taurus'],
  [-416191211,-416006924,'Gemini'],
  [-416006924,-415824285,'Cancer'],
  [-415824285,-415641111,'Leo'],
  [-415641111,-415454210,'Virgo'],
  [-415454210,-415259769,'Libra'],
  [-415259769,-415054985,'Scorpio'],
  [-415054985,-414840607,'Sagittarius'],
  [-414840607,-414622454,'Capricorn'],
  [-414622454,-414409115,'Aquarius'],
  [-414409115,-414206604,'Pisces'],
  [-414206604,-414015534,'Aries'],
  [-414015534,-413832551,'Taurus'],
  [-413832551,-413652891,'Gemini'],
  [-413652891,-413472182,'Cancer'],
  [-413472182,-413287306,'Leo'],
  [-413287306,-413096420,'Virgo'],
  [-413096420,-412898436,'Libra'],
  [-412898436,-412692574,'Scorpio'],
  [-412692574,-412479035,'Sagittarius'],
  [-412479035,-412260826,'Capricorn'],
  [-412260826,-412044658,'Aquarius'],
  [-412044658,-411838218,'Pisces'],
  [-411838218,-411645366,'Aries'],
  [-411645366,-411464449,'Taurus'],
  [-411464449,-411290013,'Gemini'],
  [-411290013,-411115332,'Cancer'],
  [-411115332,-410934459,'Leo'],
  [-410934459,-410743891,'Virgo'],
  [-410743891,-410543372,'Libra'],
  [-410543372,-410334836,'Scorpio'],
  [-410334836,-410120478,'Sagittarius'],
  [-410120478,-409902452,'Capricorn'],
  [-409902452,-409684618,'Aquarius'],
  [-409684618,-409473466,'Pisces'],
  [-409473466,-409275149,'Aries'],
  [-409275149,-409091313,'Taurus'],
  [-409091313,-408918128,'Gemini'],
  [-408918128,-408748407,'Cancer'],
  [-408748407,-408574227,'Leo'],
  [-408574227,-408389155,'Virgo'],
  [-408389155,-408190661,'Libra'],
  [-408190661,-407981066,'Scorpio'],
  [-407981066,-407765180,'Sagittarius'],
  [-407765180,-407546994,'Capricorn'],
  [-407546994,-407329251,'Aquarius'],
  [-407329251,-407115707,'Pisces'],
  [-407115707,-406911786,'Aries'],
  [-406911786,-406721559,'Taurus'],
  [-406721559,-406544371,'Gemini'],
  [-406544371,-406374701,'Cancer'],
  [-406374701,-406204583,'Leo'],
  [-406204583,-406026031,'Virgo'],
  [-406026031,-405833548,'Libra'],
  [-405833548,-405626830,'Scorpio'],
  [-405626830,-405410882,'Sagittarius'],
  [-405410882,-405192258,'Capricorn'],
  [-405192258,-404975297,'Aquarius'],
  [-404975297,-404762423,'Pisces'],
  [-404762423,-404556473,'Aries'],
  [-404556473,-404360869,'Taurus'],
  [-404360869,-404177116,'Gemini'],
  [-404177116,-404002652,'Cancer'],
  [-404002652,-403831378,'Leo'],
  [-403831378,-403655728,'Virgo'],
  [-403655728,-403468910,'Libra'],
  [-403468910,-403267618,'Scorpio'],
  [-403267618,-403054247,'Sagittarius'],
  [-403054247,-402835794,'Capricorn'],
  [-402835794,-402619199,'Aquarius'],
  [-402619199,-402408146,'Pisces'],
  [-402408146,-402203954,'Aries'],
  [-402203954,-402007510,'Taurus'],
  [-402007510,-401819491,'Gemini'],
  [-401819491,-401639007,'Cancer'],
  [-401639007,-401462662,'Leo'],
  [-401462662,-401285018,'Virgo'],
  [-401285018,-401100023,'Libra'],
  [-401100023,-400903083,'Scorpio'],
  [-400903083,-400693595,'Sagittarius'],
  [-400693595,-400476408,'Capricorn'],
  [-400476408,-400259559,'Aquarius'],
  [-400259559,-400049333,'Pisces'],
  [-400049333,-399847905,'Aries'],
  [-399847905,-399654470,'Taurus'],
  [-399654470,-399467178,'Gemini'],
  [-399467178,-399284033,'Cancer'],
  [-399284033,-399102748,'Leo'],
  [-399102748,-398920335,'Virgo'],
  [-398920335,-398733039,'Libra'],
  [-398733039,-398537071,'Scorpio'],
  [-398537071,-398330367,'Sagittarius'],
  [-398330367,-398114913,'Capricorn'],
  [-398114913,-397897480,'Aquarius'],
  [-397897480,-397686221,'Pisces'],
  [-397686221,-397485778,'Aries'],
  [-397485778,-397295785,'Taurus'],
  [-397295785,-397112612,'Gemini'],
  [-397112612,-396931785,'Cancer'],
  [-396931785,-396749588,'Leo'],
  [-396749588,-396563603,'Virgo'],
  [-396563603,-396372295,'Libra'],
  [-396372295,-396174188,'Scorpio'],
  [-396174188,-395967849,'Sagittarius'],
  [-395967849,-395753549,'Capricorn'],
  [-395753549,-395535543,'Aquarius'],
  [-395535543,-395321813,'Pisces'],
  [-395321813,-395119466,'Aries'],
  [-395119466,-394930334,'Taurus'],
  [-394930334,-394750908,'Gemini'],
  [-394750908,-394575023,'Cancer'],
  [-394575023,-394396550,'Leo'],
  [-394396550,-394211289,'Virgo'],
  [-394211289,-394017829,'Libra'],
  [-394017829,-393816730,'Scorpio'],
  [-393816730,-393608747,'Sagittarius'],
  [-393608747,-393394448,'Capricorn'],
  [-393394448,-393176123,'Aquarius'],
  [-393176123,-392959782,'Pisces'],
  [-392959782,-392753362,'Aries'],
  [-392753362,-392561457,'Taurus'],
  [-392561457,-392382477,'Gemini'],
  [-392382477,-392210273,'Cancer'],
  [-392210273,-392037240,'Leo'],
  [-392037240,-391856785,'Virgo'],
  [-391856785,-391665380,'Libra'],
  [-391665380,-391463396,'Scorpio'],
  [-391463396,-391253508,'Sagittarius'],
  [-391253508,-391038290,'Capricorn'],
  [-391038290,-390819903,'Aquarius'],
  [-390819903,-390602207,'Pisces'],
  [-390602207,-390391731,'Aries'],
  [-390391731,-390194560,'Taurus'],
  [-390194560,-390011940,'Gemini'],
  [-390011940,-389839493,'Cancer'],
  [-389839493,-389669768,'Leo'],
  [-389669768,-389494927,'Virgo'],
  [-389494927,-389308969,'Libra'],
  [-389308969,-389109871,'Scorpio'],
  [-389109871,-388899991,'Sagittarius'],
  [-388899991,-388683863,'Capricorn'],
  [-388683863,-388465475,'Aquarius'],
  [-388465475,-388248091,'Pisces'],
  [-388248091,-388035939,'Aries'],
  [-388035939,-387834052,'Taurus'],
  [-387834052,-387645424,'Gemini'],
  [-387645424,-387468486,'Cancer'],
  [-387468486,-387297652,'Leo'],
  [-387297652,-387125530,'Virgo'],
  [-387125530,-386945003,'Libra'],
  [-386945003,-386751400,'Scorpio'],
  [-386751400,-386544515,'Sagittarius'],
  [-386544515,-386328715,'Capricorn'],
  [-386328715,-386110230,'Aquarius'],
  [-386110230,-385893939,'Pisces'],
  [-385893939,-385683016,'Aries'],
  [-385683016,-385479999,'Taurus'],
  [-385479999,-385286873,'Gemini'],
  [-385286873,-385103714,'Cancer'],
  [-385103714,-384927702,'Leo'],
  [-384927702,-384753600,'Virgo'],
  [-384753600,-384575055,'Libra'],
  [-384575055,-384386260,'Scorpio'],
  [-384386260,-384184148,'Sagittarius'],
  [-384184148,-383970549,'Capricorn'],
  [-383970549,-383752071,'Aquarius'],
  [-383752071,-383536231,'Pisces'],
  [-383536231,-383327557,'Aries'],
  [-383327557,-383127130,'Taurus'],
  [-383127130,-382934240,'Gemini'],
  [-382934240,-382747711,'Cancer'],
  [-382747711,-382565946,'Leo'],
  [-382565946,-382386399,'Virgo'],
  [-382386399,-382205209,'Libra'],
  [-382205209,-382017562,'Scorpio'],
  [-382017562,-381819145,'Sagittarius'],
  [-381819145,-381608761,'Capricorn'],
  [-381608761,-381390828,'Aquarius'],
  [-381390828,-381174098,'Pisces'],
  [-381174098,-380966033,'Aries'],
  [-380966033,-380768779,'Taurus'],
  [-380768779,-380579956,'Gemini'],
  [-380579956,-380395600,'Cancer'],
  [-380395600,-380212387,'Leo'],
  [-380212387,-380028334,'Virgo'],
  [-380028334,-379842068,'Libra'],
  [-379842068,-379651484,'Scorpio'],
  [-379651484,-379453403,'Sagittarius'],
  [-379453403,-379245251,'Capricorn'],
  [-379245251,-379028372,'Aquarius'],
  [-379028372,-378810023,'Pisces'],
  [-378810023,-378599769,'Aries'],
  [-378599769,-378402773,'Taurus'],
  [-378402773,-378217489,'Gemini'],
  [-378217489,-378038371,'Cancer'],
  [-378038371,-377859361,'Leo'],
  [-377859361,-377676202,'Virgo'],
  [-377676202,-377487297,'Libra'],
  [-377487297,-377292638,'Scorpio'],
  [-377292638,-377091806,'Sagittarius'],
  [-377091806,-376883438,'Capricorn'],
  [-376883438,-376667339,'Aquarius'],
  [-376667339,-376447828,'Pisces'],
  [-376447828,-376233834,'Aries'],
  [-376233834,-376033231,'Taurus'],
  [-376033231,-375847370,'Gemini'],
  [-375847370,-375671473,'Cancer'],
  [-375671473,-375498244,'Leo'],
  [-375498244,-375320870,'Virgo'],
  [-375320870,-375135026,'Libra'],
  [-375135026,-374939735,'Scorpio'],
  [-374939735,-374736195,'Sagittarius'],
  [-374736195,-374525751,'Capricorn'],
  [-374525751,-374309364,'Aquarius'],
  [-374309364,-374089623,'Pisces'],
  [-374089623,-373872823,'Aries'],
  [-373872823,-373666931,'Taurus'],
  [-373666931,-373476229,'Gemini'],
  [-373476229,-373298659,'Cancer'],
  [-373298659,-373127822,'Leo'],
  [-373127822,-372956092,'Virgo'],
  [-372956092,-372776806,'Libra'],
  [-372776806,-372585997,'Scorpio'],
  [-372585997,-372383362,'Sagittarius'],
  [-372383362,-372171529,'Capricorn'],
  [-372171529,-371954084,'Aquarius'],
  [-371954084,-371734517,'Pisces'],
  [-371734517,-371517203,'Aries'],
  [-371517203,-371307813,'Taurus'],
  [-371307813,-371111124,'Gemini'],
  [-371111124,-370927903,'Cancer'],
  [-370927903,-370754363,'Leo'],
  [-370754363,-370584022,'Virgo'],
  [-370584022,-370409743,'Libra'],
  [-370409743,-370225385,'Scorpio'],
  [-370225385,-370027588,'Sagittarius'],
  [-370027588,-369817302,'Capricorn'],
  [-369817302,-369599415,'Aquarius'],
  [-369599415,-369379907,'Pisces'],
  [-369379907,-369163633,'Aries'],
  [-369163633,-368954161,'Taurus'],
  [-368954161,-368754235,'Gemini'],
  [-368754235,-368565167,'Cancer'],
  [-368565167,-368385718,'Leo'],
  [-368385718,-368211984,'Virgo'],
  [-368211984,-368038191,'Libra'],
  [-368038191,-367857914,'Scorpio'],
  [-367857914,-367665710,'Sagittarius'],
  [-367665710,-367459538,'Capricorn'],
  [-367459538,-367242891,'Aquarius'],
  [-367242891,-367023409,'Pisces'],
  [-367023409,-366808203,'Aries'],
  [-366808203,-366600813,'Taurus'],
  [-366600813,-366401745,'Gemini'],
  [-366401745,-366210420,'Cancer'],
  [-366210420,-366025922,'Leo'],
  [-366025922,-365846559,'Virgo'],
  [-365846559,-365669102,'Libra'],
  [-365669102,-365488614,'Scorpio'],
  [-365488614,-365299434,'Sagittarius'],
  [-365299434,-365097441,'Capricorn'],
  [-365097441,-364883335,'Aquarius'],
  [-364883335,-364664098,'Pisces'],
  [-364664098,-364448965,'Aries'],
  [-364448965,-364243400,'Taurus'],
  [-364243400,-364047419,'Gemini'],
  [-364047419,-363858179,'Cancer'],
  [-363858179,-363672846,'Leo'],
  [-363672846,-363489671,'Virgo'],
  [-363489671,-363307282,'Libra'],
  [-363307282,-363123210,'Scorpio'],
  [-363123210,-362933349,'Sagittarius'],
  [-362933349,-362733317,'Capricorn'],
  [-362733317,-362521610,'Aquarius'],
  [-362521610,-362302846,'Pisces'],
  [-362302846,-362086606,'Aries'],
  [-362086606,-361880844,'Taurus'],
  [-361880844,-361687106,'Gemini'],
  [-361687106,-361501797,'Cancer'],
  [-361501797,-361319874,'Leo'],
  [-361319874,-361137487,'Virgo'],
  [-361137487,-360952760,'Libra'],
  [-360952760,-360764719,'Scorpio'],
  [-360764719,-360571642,'Sagittarius'],
  [-360571642,-360370727,'Capricorn'],
  [-360370727,-360159995,'Aquarius'],
  [-360159995,-359941697,'Pisces'],
  [-359941697,-359723737,'Aries'],
  [-359723737,-359515413,'Taurus'],
  [-359515413,-359320933,'Gemini'],
  [-359320933,-359137928,'Cancer'],
  [-359137928,-358960567,'Leo'],
  [-358960567,-358782843,'Virgo'],
  [-358782843,-358600518,'Libra'],
  [-358600518,-358411660,'Scorpio'],
  [-358411660,-358215709,'Sagittarius'],
  [-358215709,-358012211,'Capricorn'],
  [-358012211,-357800711,'Aquarius'],
  [-357800711,-357582582,'Pisces'],
  [-357582582,-357363283,'Aries'],
  [-357363283,-357151242,'Taurus'],
  [-357151242,-356952793,'Gemini'],
  [-356952793,-356768260,'Cancer'],
  [-356768260,-356592934,'Leo'],
  [-356592934,-356420130,'Virgo'],
  [-356420130,-356243477,'Libra'],
  [-356243477,-356058419,'Scorpio'],
  [-356058419,-355863005,'Sagittarius'],
  [-355863005,-355657723,'Capricorn'],
  [-355657723,-355444529,'Aquarius'],
  [-355444529,-355226100,'Pisces'],
  [-355226100,-355006529,'Aries'],
  [-355006529,-354791828,'Taurus'],
  [-354791828,-354588160,'Gemini'],
  [-354588160,-354398410,'Cancer'],
  [-354398410,-354220599,'Leo'],
  [-354220599,-354049261,'Virgo'],
  [-354049261,-353877513,'Libra'],
  [-353877513,-353698698,'Scorpio'],
  [-353698698,-353508009,'Sagittarius'],
  [-353508009,-353304194,'Capricorn'],
  [-353304194,-353090149,'Aquarius'],
  [-353090149,-352871089,'Pisces'],
  [-352871089,-352652056,'Aries'],
  [-352652056,-352437236,'Taurus'],
  [-352437236,-352230436,'Gemini'],
  [-352230436,-352034725,'Cancer'],
  [-352034725,-351850783,'Leo'],
  [-351850783,-351675976,'Virgo'],
  [-351675976,-351504851,'Libra'],
  [-351504851,-351330444,'Scorpio'],
  [-351330444,-351145926,'Sagittarius'],
  [-351145926,-350946995,'Capricorn'],
  [-350946995,-350734653,'Aquarius'],
  [-350734653,-350515338,'Pisces'],
  [-350515338,-350296729,'Aries'],
  [-350296729,-350083578,'Taurus'],
  [-350083578,-349877530,'Gemini'],
  [-349877530,-349679297,'Cancer'],
  [-349679297,-349489622,'Leo'],
  [-349489622,-349308340,'Virgo'],
  [-349308340,-349132925,'Libra'],
  [-349132925,-348958114,'Scorpio'],
  [-348958114,-348777044,'Sagittarius'],
  [-348777044,-348583467,'Capricorn'],
  [-348583467,-348375187,'Aquarius'],
  [-348375187,-348156937,'Pisces'],
  [-348156937,-347938134,'Aries'],
  [-347938134,-347726193,'Taurus'],
  [-347726193,-347523007,'Gemini'],
  [-347523007,-347326997,'Cancer'],
  [-347326997,-347136418,'Leo'],
  [-347136418,-346950655,'Virgo'],
  [-346950655,-346769188,'Libra'],
  [-346769188,-346589655,'Scorpio'],
  [-346589655,-346407213,'Sagittarius'],
  [-346407213,-346215877,'Capricorn'],
  [-346215877,-346011474,'Aquarius'],
  [-346011474,-345795524,'Pisces'],
  [-345795524,-345576340,'Aries'],
  [-345576340,-345363671,'Taurus'],
  [-345363671,-345161990,'Gemini'],
  [-345161990,-344969789,'Cancer'],
  [-344969789,-344783104,'Leo'],
  [-344783104,-344598630,'Virgo'],
  [-344598630,-344414714,'Libra'],
  [-344414714,-344230316,'Scorpio'],
  [-344230316,-344043312,'Sagittarius'],
  [-344043312,-343850028,'Capricorn'],
  [-343850028,-343646734,'Aquarius'],
  [-343646734,-343432824,'Pisces'],
  [-343432824,-343213635,'Aries'],
  [-343213635,-342998707,'Taurus'],
  [-342998707,-342795327,'Gemini'],
  [-342795327,-342604394,'Cancer'],
  [-342604394,-342421991,'Leo'],
  [-342421991,-342242784,'Virgo'],
  [-342242784,-342062300,'Libra'],
  [-342062300,-341877740,'Scorpio'],
  [-341877740,-341687546,'Sagittarius'],
  [-341687546,-341490478,'Capricorn'],
  [-341490478,-341285269,'Aquarius'],
  [-341285269,-341071685,'Pisces'],
  [-341071685,-340852768,'Aries'],
  [-340852768,-340635598,'Taurus'],
  [-340635598,-340428180,'Gemini'],
  [-340428180,-340234447,'Cancer'],
  [-340234447,-340052707,'Leo'],
  [-340052707,-339877731,'Virgo'],
  [-339877731,-339703259,'Libra'],
  [-339703259,-339523702,'Scorpio'],
  [-339523702,-339335292,'Sagittarius'],
  [-339335292,-339136725,'Capricorn'],
  [-339136725,-338928919,'Aquarius'],
  [-338928919,-338714023,'Pisces'],
  [-338714023,-338495131,'Aries'],
  [-338495131,-338276930,'Taurus'],
  [-338276930,-338065645,'Gemini'],
  [-338065645,-337866600,'Cancer'],
  [-337866600,-337681125,'Leo'],
  [-337681125,-337506063,'Virgo'],
  [-337506063,-337335335,'Libra'],
  [-337335335,-337161849,'Scorpio'],
  [-337161849,-336979205,'Sagittarius'],
  [-336979205,-336783618,'Capricorn'],
  [-336783618,-336575596,'Aquarius'],
  [-336575596,-336359366,'Pisces'],
  [-336359366,-336140099,'Aries'],
  [-336140099,-335922089,'Taurus'],
  [-335922089,-335709179,'Gemini'],
  [-335709179,-335505522,'Cancer'],
  [-335505522,-335314117,'Leo'],
  [-335314117,-335134692,'Virgo'],
  [-335134692,-334963122,'Libra'],
  [-334963122,-334792616,'Scorpio'],
  [-334792616,-334615571,'Sagittarius'],
  [-334615571,-334425708,'Capricorn'],
  [-334425708,-334220951,'Aquarius'],
  [-334220951,-334005158,'Pisces'],
  [-334005158,-333785600,'Aries'],
  [-333785600,-333568250,'Taurus'],
  [-333568250,-333356108,'Gemini'],
  [-333356108,-333151020,'Cancer'],
  [-333151020,-332955113,'Leo'],
  [-332955113,-332769740,'Virgo'],
  [-332769740,-332593473,'Libra'],
  [-332593473,-332421430,'Scorpio'],
  [-332421430,-332246509,'Sagittarius'],
  [-332246509,-332061439,'Capricorn'],
  [-332061439,-331861650,'Aquarius'],
  [-331861650,-331648514,'Pisces'],
  [-331648514,-331429374,'Aries'],
  [-331429374,-331212436,'Taurus'],
  [-331212436,-331001962,'Gemini'],
  [-331001962,-330798576,'Cancer'],
  [-330798576,-330602120,'Leo'],
  [-330602120,-330413039,'Virgo'],
  [-330413039,-330231280,'Libra'],
  [-330231280,-330054456,'Scorpio'],
  [-330054456,-329877452,'Sagittarius'],
  [-329877452,-329693718,'Capricorn'],
  [-329693718,-329497689,'Aquarius'],
  [-329497689,-329288125,'Pisces'],
  [-329288125,-329070276,'Aries'],
  [-329070276,-328853185,'Taurus'],
  [-328853185,-328643501,'Gemini'],
  [-328643501,-328442701,'Cancer'],
  [-328442701,-328249132,'Leo'],
  [-328249132,-328060864,'Virgo'],
  [-328060864,-327876687,'Libra'],
  [-327876687,-327695206,'Scorpio'],
  [-327695206,-327513608,'Sagittarius'],
  [-327513608,-327327501,'Capricorn'],
  [-327327501,-327132176,'Aquarius'],
  [-327132176,-326925138,'Pisces'],
  [-326925138,-326708929,'Aries'],
  [-326708929,-326491246,'Taurus'],
  [-326491246,-326280475,'Gemini'],
  [-326280475,-326080539,'Cancer'],
  [-326080539,-325890305,'Leo'],
  [-325890305,-325706181,'Virgo'],
  [-325706181,-325524441,'Libra'],
  [-325524441,-325342163,'Scorpio'],
  [-325342163,-325157050,'Sagittarius'],
  [-325157050,-324966861,'Capricorn'],
  [-324966861,-324769232,'Aquarius'],
  [-324769232,-324562450,'Pisces'],
  [-324562450,-324347384,'Aries'],
  [-324347384,-324129108,'Taurus'],
  [-324129108,-323915664,'Gemini'],
  [-323915664,-323713493,'Cancer'],
  [-323713493,-323523874,'Leo'],
  [-323523874,-323343534,'Virgo'],
  [-323343534,-323167044,'Libra'],
  [-323167044,-322988861,'Scorpio'],
  [-322988861,-322804716,'Sagittarius'],
  [-322804716,-322612374,'Capricorn'],
  [-322612374,-322411521,'Aquarius'],
  [-322411521,-322202899,'Pisces'],
  [-322202899,-321987865,'Aries'],
  [-321987865,-321769407,'Taurus'],
  [-321769407,-321553254,'Gemini'],
  [-321553254,-321346482,'Cancer'],
  [-321346482,-321153387,'Leo'],
  [-321153387,-320973056,'Virgo'],
  [-320973056,-320800321,'Libra'],
  [-320800321,-320628080,'Scorpio'],
  [-320628080,-320449437,'Sagittarius'],
  [-320449437,-320259709,'Capricorn'],
  [-320259709,-320058103,'Aquarius'],
  [-320058103,-319847367,'Pisces'],
  [-319847367,-319631289,'Aries'],
  [-319631289,-319412975,'Taurus'],
  [-319412975,-319195770,'Gemini'],
  [-319195770,-318984827,'Cancer'],
  [-318984827,-318785708,'Leo'],
  [-318785708,-318600716,'Virgo'],
  [-318600716,-318427015,'Libra'],
  [-318427015,-318257904,'Scorpio'],
  [-318257904,-318085271,'Sagittarius'],
  [-318085271,-317901866,'Capricorn'],
  [-317901866,-317704017,'Aquarius'],
  [-317704017,-317493641,'Pisces'],
  [-317493641,-317276543,'Aries'],
  [-317276543,-317058191,'Taurus'],
  [-317058191,-316841715,'Gemini'],
  [-316841715,-316629720,'Cancer'],
  [-316629720,-316426068,'Leo'],
  [-316426068,-316234427,'Virgo'],
  [-316234427,-316055118,'Libra'],
  [-316055118,-315883833,'Scorpio'],
  [-315883833,-315713223,'Sagittarius'],
  [-315713223,-315535240,'Capricorn'],
  [-315535240,-315343672,'Aquarius'],
  [-315343672,-315137273,'Pisces'],
  [-315137273,-314920942,'Aries'],
  [-314920942,-314702338,'Taurus'],
  [-314702338,-314486872,'Gemini'],
  [-314486872,-314276662,'Cancer'],
  [-314276662,-314072948,'Leo'],
  [-314072948,-313877610,'Virgo'],
  [-313877610,-313691983,'Libra'],
  [-313691983,-313514628,'Scorpio'],
  [-313514628,-313340753,'Sagittarius'],
  [-313340753,-313163557,'Capricorn'],
  [-313163557,-312976331,'Aquarius'],
  [-312976331,-312775213,'Pisces'],
  [-312775213,-312561920,'Aries'],
  [-312561920,-312343578,'Taurus'],
  [-312343578,-312128125,'Gemini'],
  [-312128125,-311919803,'Cancer'],
  [-311919803,-311719161,'Leo'],
  [-311719161,-311525409,'Virgo'],
  [-311525409,-311337830,'Libra'],
  [-311337830,-311155389,'Scorpio'],
  [-311155389,-310975697,'Sagittarius'],
  [-310975697,-310794662,'Capricorn'],
  [-310794662,-310607231,'Aquarius'],
  [-310607231,-310409114,'Pisces'],
  [-310409114,-310199308,'Aries'],
  [-310199308,-309982097,'Taurus'],
  [-309982097,-309765696,'Gemini'],
  [-309765696,-309557182,'Cancer'],
  [-309557182,-309358964,'Leo'],
  [-309358964,-309169405,'Virgo'],
  [-309169405,-308985155,'Libra'],
  [-308985155,-308802893,'Scorpio'],
  [-308802893,-308619939,'Sagittarius'],
  [-308619939,-308434050,'Capricorn'],
  [-308434050,-308242908,'Aquarius'],
  [-308242908,-308044037,'Pisces'],
  [-308044037,-307835873,'Aries'],
  [-307835873,-307619962,'Taurus'],
  [-307619962,-307402396,'Gemini'],
  [-307402396,-307191475,'Cancer'],
  [-307191475,-306992561,'Leo'],
  [-306992561,-306805539,'Virgo'],
  [-306805539,-306626140,'Libra'],
  [-306626140,-306448602,'Scorpio'],
  [-306448602,-306267815,'Sagittarius'],
  [-306267815,-306080614,'Capricorn'],
  [-306080614,-305886007,'Aquarius'],
  [-305886007,-305684134,'Pisces'],
  [-305684134,-305475130,'Aries'],
  [-305475130,-305259719,'Taurus'],
  [-305259719,-305041380,'Gemini'],
  [-305041380,-304827226,'Cancer'],
  [-304827226,-304624603,'Leo'],
  [-304624603,-304436244,'Virgo'],
  [-304436244,-304259078,'Libra'],
  [-304259078,-304086522,'Scorpio'],
  [-304086522,-303911328,'Sagittarius'],
  [-303911328,-303727800,'Capricorn'],
  [-303727800,-303533535,'Aquarius'],
  [-303533535,-303329625,'Pisces'],
  [-303329625,-303118632,'Aries'],
  [-303118632,-302902678,'Taurus'],
  [-302902678,-302684095,'Gemini'],
  [-302684095,-302467637,'Cancer'],
  [-302467637,-302260330,'Leo'],
  [-302260330,-302067297,'Virgo'],
  [-302067297,-301888091,'Libra'],
  [-301888091,-301717156,'Scorpio'],
  [-301717156,-301546674,'Sagittarius'],
  [-301546674,-301369088,'Capricorn'],
  [-301369088,-301179359,'Aquarius'],
  [-301179359,-300976877,'Pisces'],
  [-300976877,-300764997,'Aries'],
  [-300764997,-300548127,'Taurus'],
  [-300548127,-300329600,'Gemini'],
  [-300329600,-300112691,'Cancer'],
  [-300112691,-299902342,'Leo'],
  [-299902342,-299703891,'Virgo'],
  [-299703891,-299519377,'Libra'],
  [-299519377,-299345680,'Scorpio'],
  [-299345680,-299176068,'Sagittarius'],
  [-299176068,-299002700,'Capricorn'],
  [-299002700,-298818794,'Aquarius'],
  [-298818794,-298620985,'Pisces'],
  [-298620985,-298410882,'Aries'],
  [-298410882,-298193829,'Taurus'],
  [-298193829,-297975398,'Gemini'],
  [-297975398,-297759421,'Cancer'],
  [-297759421,-297549037,'Leo'],
  [-297549037,-297347633,'Virgo'],
  [-297347633,-297157629,'Libra'],
  [-297157629,-296978286,'Scorpio'],
  [-296978286,-296805266,'Sagittarius'],
  [-296805266,-296632046,'Capricorn'],
  [-296632046,-296451746,'Aquarius'],
  [-296451746,-296259169,'Pisces'],
  [-296259169,-296053081,'Aries'],
  [-296053081,-295837353,'Taurus'],
  [-295837353,-295618995,'Gemini'],
  [-295618995,-295404038,'Cancer'],
  [-295404038,-295195702,'Leo'],
  [-295195702,-294995251,'Virgo'],
  [-294995251,-294803122,'Libra'],
  [-294803122,-294618818,'Scorpio'],
  [-294618818,-294440153,'Sagittarius'],
  [-294440153,-294263090,'Capricorn'],
  [-294263090,-294082347,'Aquarius'],
  [-294082347,-293892643,'Pisces'],
  [-293892643,-293690678,'Aries'],
  [-293690678,-293477499,'Taurus'],
  [-293477499,-293259329,'Gemini'],
  [-293259329,-293044324,'Cancer'],
  [-293044324,-292837780,'Leo'],
  [-292837780,-292640582,'Virgo'],
  [-292640582,-292450809,'Libra'],
  [-292450809,-292265831,'Scorpio'],
  [-292265831,-292083302,'Sagittarius'],
  [-292083302,-291901030,'Capricorn'],
  [-291901030,-291716349,'Aquarius'],
  [-291716349,-291525777,'Pisces'],
  [-291525777,-291325804,'Aries'],
  [-291325804,-291115135,'Taurus'],
  [-291115135,-290897409,'Gemini'],
  [-290897409,-290680999,'Cancer'],
  [-290680999,-290473935,'Leo'],
  [-290473935,-290278966,'Virgo'],
  [-290278966,-290093491,'Libra'],
  [-290093491,-289912472,'Scorpio'],
  [-289912472,-289731174,'Sagittarius'],
  [-289731174,-289546647,'Capricorn'],
  [-289546647,-289357689,'Aquarius'],
  [-289357689,-289163487,'Pisces'],
  [-289163487,-288962427,'Aries'],
  [-288962427,-288752814,'Taurus'],
  [-288752814,-288535698,'Gemini'],
  [-288535698,-288317371,'Cancer'],
  [-288317371,-288107120,'Leo'],
  [-288107120,-287910791,'Virgo'],
  [-287910791,-287727436,'Libra'],
  [-287727436,-287551328,'Scorpio'],
  [-287551328,-287375471,'Sagittarius'],
  [-287375471,-287194229,'Capricorn'],
  [-287194229,-287004945,'Aquarius'],
  [-287004945,-286807804,'Pisces'],
  [-286807804,-286603811,'Aries'],
  [-286603811,-286393211,'Taurus'],
  [-286393211,-286176410,'Gemini'],
  [-286176410,-285956969,'Cancer'],
  [-285956969,-285742721,'Leo'],
  [-285742721,-285541534,'Virgo'],
  [-285541534,-285355662,'Libra'],
  [-285355662,-285180954,'Scorpio'],
  [-285180954,-285009997,'Sagittarius'],
  [-285009997,-284835181,'Capricorn'],
  [-284835181,-284650914,'Aquarius'],
  [-284650914,-284455280,'Pisces'],
  [-284455280,-284249791,'Aries'],
  [-284249791,-284037247,'Taurus'],
  [-284037247,-283819984,'Gemini'],
  [-283819984,-283600635,'Cancer'],
  [-283600635,-283384274,'Leo'],
  [-283384274,-283177813,'Virgo'],
  [-283177813,-282985838,'Libra'],
  [-282985838,-282807347,'Scorpio'],
  [-282807347,-282636639,'Sagittarius'],
  [-282636639,-282466107,'Capricorn'],
  [-282466107,-282288486,'Aquarius'],
  [-282288486,-282098786,'Pisces'],
  [-282098786,-281895972,'Aries'],
  [-281895972,-281683041,'Taurus'],
  [-281683041,-281464919,'Gemini'],
  [-281464919,-281246030,'Cancer'],
  [-281246030,-281030236,'Leo'],
  [-281030236,-280821713,'Virgo'],
  [-280821713,-280624278,'Libra'],
  [-280624278,-280439131,'Scorpio'],
  [-280439131,-280263618,'Sagittarius'],
  [-280263618,-280092125,'Capricorn'],
  [-280092125,-279917789,'Aquarius'],
  [-279917789,-279734146,'Pisces'],
  [-279734146,-279537068,'Aries'],
  [-279537068,-279326881,'Taurus'],
  [-279326881,-279108821,'Gemini'],
  [-279108821,-278890007,'Cancer'],
  [-278890007,-278675793,'Leo'],
  [-278675793,-278468869,'Virgo'],
  [-278468869,-278270365,'Libra'],
  [-278270365,-278080620,'Scorpio'],
  [-278080620,-277898734,'Sagittarius'],
  [-277898734,-277721987,'Capricorn'],
  [-277721987,-277545771,'Aquarius'],
  [-277545771,-277364284,'Pisces'],
  [-277364284,-277172026,'Aries'],
  [-277172026,-276966294,'Taurus'],
  [-276966294,-276749941,'Gemini'],
  [-276749941,-276530952,'Cancer'],
  [-276530952,-276317412,'Leo'],
  [-276317412,-276113081,'Virgo'],
  [-276113081,-275917407,'Libra'],
  [-275917407,-275728140,'Scorpio'],
  [-275728140,-275543238,'Sagittarius'],
  [-275543238,-275361151,'Capricorn'],
  [-275361151,-275179902,'Aquarius'],
  [-275179902,-274996059,'Pisces'],
  [-274996059,-274804916,'Aries'],
  [-274804916,-274602410,'Taurus'],
  [-274602410,-274388486,'Gemini'],
  [-274388486,-274169465,'Cancer'],
  [-274169465,-273955037,'Leo'],
  [-273955037,-273751578,'Virgo'],
  [-273751578,-273559164,'Libra'],
  [-273559164,-273373848,'Scorpio'],
  [-273373848,-273191104,'Sagittarius'],
  [-273191104,-273007872,'Capricorn'],
  [-273007872,-272822755,'Aquarius'],
  [-272822755,-272634610,'Pisces'],
  [-272634610,-272441080,'Aries'],
  [-272441080,-272238911,'Taurus'],
  [-272238911,-272026557,'Gemini'],
  [-272026557,-271807676,'Cancer'],
  [-271807676,-271591289,'Leo'],
  [-271591289,-271386020,'Virgo'],
  [-271386020,-271194300,'Libra'],
  [-271194300,-271012514,'Scorpio'],
  [-271012514,-270834580,'Sagittarius'],
  [-270834580,-270655015,'Capricorn'],
  [-270655015,-270470545,'Aquarius'],
  [-270470545,-270280088,'Pisces'],
  [-270280088,-270083252,'Aries'],
  [-270083252,-269879063,'Taurus'],
  [-269879063,-269666619,'Gemini'],
  [-269666619,-269447830,'Cancer'],
  [-269447830,-269229475,'Leo'],
  [-269229475,-269020522,'Virgo'],
  [-269020522,-268826038,'Libra'],
  [-268826038,-268644481,'Scorpio'],
  [-268644481,-268470023,'Sagittarius'],
  [-268470023,-268295817,'Capricorn'],
  [-268295817,-268116173,'Aquarius'],
  [-268116173,-267927828,'Pisces'],
  [-267927828,-267730044,'Aries'],
  [-267730044,-267523620,'Taurus'],
  [-267523620,-267309851,'Gemini'],
  [-267309851,-267090906,'Cancer'],
  [-267090906,-266871552,'Leo'],
  [-266871552,-266659027,'Virgo'],
  [-266659027,-266459535,'Libra'],
  [-266459535,-266274306,'Scorpio'],
  [-266274306,-266099448,'Sagittarius'],
  [-266099448,-265928438,'Capricorn'],
  [-265928438,-265754374,'Aquarius'],
  [-265754374,-265571550,'Pisces'],
  [-265571550,-265376822,'Aries'],
  [-265376822,-265170422,'Taurus'],
  [-265170422,-264955449,'Gemini'],
  [-264955449,-264736115,'Cancer'],
  [-264736115,-264516929,'Leo'],
  [-264516929,-264302892,'Virgo'],
  [-264302892,-264098932,'Libra'],
  [-264098932,-263907841,'Scorpio'],
  [-263907841,-263728517,'Sagittarius'],
  [-263728517,-263556411,'Capricorn'],
  [-263556411,-263385084,'Aquarius'],
  [-263385084,-263207698,'Pisces'],
  [-263207698,-263018620,'Aries'],
  [-263018620,-262815524,'Taurus'],
  [-262815524,-262601024,'Gemini'],
  [-262601024,-262381388,'Cancer'],
  [-262381388,-262162904,'Leo'],
  [-262162904,-261949781,'Virgo'],
  [-261949781,-261744534,'Libra'],
  [-261744534,-261548908,'Scorpio'],
  [-261548908,-261363394,'Sagittarius'],
  [-261363394,-261186232,'Capricorn'],
  [-261186232,-261013105,'Aquarius'],
  [-261013105,-260837801,'Pisces'],
  [-260837801,-260653612,'Aries'],
  [-260653612,-260455623,'Taurus'],
  [-260455623,-260243857,'Gemini'],
  [-260243857,-260024563,'Cancer'],
  [-260024563,-259806435,'Leo'],
  [-259806435,-259595141,'Virgo'],
  [-259595141,-259391943,'Libra'],
  [-259391943,-259196054,'Scorpio'],
  [-259196054,-259006810,'Sagittarius'],
  [-259006810,-258823757,'Capricorn'],
  [-258823757,-258645299,'Aquarius'],
  [-258645299,-258467537,'Pisces'],
  [-258467537,-258284607,'Aries'],
  [-258284607,-258090547,'Taurus'],
  [-258090547,-257882607,'Gemini'],
  [-257882607,-257664655,'Cancer'],
  [-257664655,-257446148,'Leo'],
  [-257446148,-257235475,'Virgo'],
  [-257235475,-257035052,'Libra'],
  [-257035052,-256842595,'Scorpio'],
  [-256842595,-256654800,'Sagittarius'],
  [-256654800,-256469638,'Capricorn'],
  [-256469638,-256286285,'Aquarius'],
  [-256286285,-256103360,'Pisces'],
  [-256103360,-255917505,'Aries'],
  [-255917505,-255723871,'Taurus'],
  [-255723871,-255518577,'Gemini'],
  [-255518577,-255302527,'Cancer'],
  [-255302527,-255083336,'Leo'],
  [-255083336,-254871050,'Virgo'],
  [-254871050,-254670991,'Libra'],
  [-254670991,-254481834,'Scorpio'],
  [-254481834,-254298799,'Sagittarius'],
  [-254298799,-254117128,'Capricorn'],
  [-254117128,-253933859,'Aquarius'],
  [-253933859,-253747666,'Pisces'],
  [-253747666,-253557352,'Aries'],
  [-253557352,-253360747,'Taurus'],
  [-253360747,-253155283,'Gemini'],
  [-253155283,-252940508,'Cancer'],
  [-252940508,-252721024,'Leo'],
  [-252721024,-252505815,'Virgo'],
  [-252505815,-252302622,'Libra'],
  [-252302622,-252113062,'Scorpio'],
  [-252113062,-251933288,'Sagittarius'],
  [-251933288,-251757268,'Capricorn'],
  [-251757268,-251579321,'Aquarius'],
  [-251579321,-251395486,'Pisces'],
  [-251395486,-251203850,'Aries'],
  [-251203850,-251003965,'Taurus'],
  [-251003965,-250796048,'Gemini'],
  [-250796048,-250580962,'Cancer'],
  [-250580962,-250361654,'Leo'],
  [-250361654,-250144258,'Virgo'],
  [-250144258,-249936255,'Libra'],
  [-249936255,-249742106,'Scorpio'],
  [-249742106,-249560871,'Sagittarius'],
  [-249560871,-249387539,'Capricorn'],
  [-249387539,-249215427,'Aquarius'],
  [-249215427,-249038026,'Pisces'],
  [-249038026,-248850496,'Aries'],
  [-248850496,-248651022,'Taurus'],
  [-248651022,-248441196,'Gemini'],
  [-248441196,-248224652,'Cancer'],
  [-248224652,-248005407,'Leo'],
  [-248005407,-247787684,'Virgo'],
  [-247787684,-247576434,'Libra'],
  [-247576434,-247376402,'Scorpio'],
  [-247376402,-247189546,'Sagittarius'],
  [-247189546,-247013707,'Capricorn'],
  [-247013707,-246843343,'Aquarius'],
  [-246843343,-246671245,'Pisces'],
  [-246671245,-246490318,'Aries'],
  [-246490318,-246295716,'Taurus'],
  [-246295716,-246087316,'Gemini'],
  [-246087316,-245870028,'Cancer'],
  [-245870028,-245650490,'Leo'],
  [-245650490,-245433603,'Virgo'],
  [-245433603,-245222243,'Libra'],
  [-245222243,-245018961,'Scorpio'],
  [-245018961,-244826123,'Sagittarius'],
  [-244826123,-244644258,'Capricorn'],
  [-244644258,-244470575,'Aquarius'],
  [-244470575,-244299151,'Pisces'],
  [-244299151,-244122524,'Aries'],
  [-244122524,-243933850,'Taurus'],
  [-243933850,-243729974,'Gemini'],
  [-243729974,-243514167,'Cancer'],
  [-243514167,-243294538,'Leo'],
  [-243294538,-243078386,'Virgo'],
  [-243078386,-242868829,'Libra'],
  [-242868829,-242666282,'Scorpio'],
  [-242666282,-242471086,'Sagittarius'],
  [-242471086,-242283972,'Capricorn'],
  [-242283972,-242104465,'Aquarius'],
  [-242104465,-241929253,'Pisces'],
  [-241929253,-241752350,'Aries'],
  [-241752350,-241566825,'Taurus'],
  [-241566825,-241367596,'Gemini'],
  [-241367596,-241154996,'Cancer'],
  [-241154996,-240936028,'Leo'],
  [-240936028,-240719880,'Virgo'],
  [-240719880,-240511804,'Libra'],
  [-240511804,-240312054,'Scorpio'],
  [-240312054,-240118820,'Sagittarius'],
  [-240118820,-239930772,'Capricorn'],
  [-239930772,-239747280,'Aquarius'],
  [-239747280,-239566904,'Pisces'],
  [-239566904,-239386130,'Aries'],
  [-239386130,-239199701,'Taurus'],
  [-239199701,-239002538,'Gemini'],
  [-239002538,-238792911,'Cancer'],
  [-238792911,-238575177,'Leo'],
  [-238575177,-238358326,'Virgo'],
  [-238358326,-238149949,'Libra'],
  [-238149949,-237952120,'Scorpio'],
  [-237952120,-237762580,'Sagittarius'],
  [-237762580,-237577829,'Capricorn'],
  [-237577829,-237395033,'Aquarius'],
  [-237395033,-237212184,'Pisces'],
  [-237212184,-237027197,'Aries'],
  [-237027197,-236837198,'Taurus'],
  [-236837198,-236638901,'Gemini'],
  [-236638901,-236430396,'Cancer'],
  [-236430396,-236213757,'Leo'],
  [-236213757,-235995899,'Virgo'],
  [-235995899,-235785278,'Libra'],
  [-235785278,-235586612,'Scorpio'],
  [-235586612,-235399154,'Sagittarius'],
  [-235399154,-235218789,'Capricorn'],
  [-235218789,-235040511,'Aquarius'],
  [-235040511,-234859960,'Pisces'],
  [-234859960,-234674048,'Aries'],
  [-234674048,-234480946,'Taurus'],
  [-234480946,-234279733,'Gemini'],
  [-234279733,-234070238,'Cancer'],
  [-234070238,-233853935,'Leo'],
  [-233853935,-233635315,'Virgo'],
  [-233635315,-233421565,'Libra'],
  [-233421565,-233219201,'Scorpio'],
  [-233219201,-233030234,'Sagittarius'],
  [-233030234,-232851839,'Capricorn'],
  [-232851839,-232678333,'Aquarius'],
  [-232678333,-232503255,'Pisces'],
  [-232503255,-232321026,'Aries'],
  [-232321026,-232128394,'Taurus'],
  [-232128394,-231925234,'Gemini'],
  [-231925234,-231713759,'Cancer'],
  [-231713759,-231496914,'Leo'],
  [-231496914,-231278088,'Virgo'],
  [-231278088,-231062064,'Libra'],
  [-231062064,-230854902,'Scorpio'],
  [-230854902,-230661010,'Sagittarius'],
  [-230661010,-230480332,'Capricorn'],
  [-230480332,-230308366,'Aquarius'],
  [-230308366,-230138055,'Pisces'],
  [-230138055,-229961873,'Aries'],
  [-229961873,-229773910,'Taurus'],
  [-229773910,-229572264,'Gemini'],
  [-229572264,-229359888,'Cancer'],
  [-229359888,-229142128,'Leo'],
  [-229142128,-228923477,'Virgo'],
  [-228923477,-228707162,'Libra'],
  [-228707162,-228496946,'Scorpio'],
  [-228496946,-228297301,'Sagittarius'],
  [-228297301,-228110783,'Capricorn'],
  [-228110783,-227935654,'Aquarius'],
  [-227935654,-227766097,'Pisces'],
  [-227766097,-227594253,'Aries'],
  [-227594253,-227412424,'Taurus'],
  [-227412424,-227215820,'Gemini'],
  [-227215820,-227005413,'Cancer'],
  [-227005413,-226787456,'Leo'],
  [-226787456,-226568912,'Virgo'],
  [-226568912,-226353762,'Libra'],
  [-226353762,-226143861,'Scorpio'],
  [-226143861,-225941404,'Sagittarius'],
  [-225941404,-225749054,'Capricorn'],
  [-225749054,-225567589,'Aquarius'],
  [-225567589,-225393962,'Pisces'],
  [-225393962,-225221837,'Aries'],
  [-225221837,-225043553,'Taurus'],
  [-225043553,-224852572,'Gemini'],
  [-224852572,-224646730,'Cancer'],
  [-224646730,-224430358,'Leo'],
  [-224430358,-224211772,'Virgo'],
  [-224211772,-223997553,'Libra'],
  [-223997553,-223790006,'Scorpio'],
  [-223790006,-223589184,'Sagittarius'],
  [-223589184,-223395308,'Capricorn'],
  [-223395308,-223208887,'Aquarius'],
  [-223208887,-223029014,'Pisces'],
  [-223029014,-222852146,'Aries'],
  [-222852146,-222672579,'Taurus'],
  [-222672579,-222484132,'Gemini'],
  [-222484132,-222282756,'Cancer'],
  [-222282756,-222069501,'Leo'],
  [-222069501,-221851215,'Virgo'],
  [-221851215,-221636506,'Libra'],
  [-221636506,-221430347,'Scorpio'],
  [-221430347,-221233025,'Sagittarius'],
  [-221233025,-221042501,'Capricorn'],
  [-221042501,-220856588,'Aquarius'],
  [-220856588,-220673501,'Pisces'],
  [-220673501,-220491222,'Aries'],
  [-220491222,-220306808,'Taurus'],
  [-220306808,-220116438,'Gemini'],
  [-220116438,-219916553,'Cancer'],
  [-219916553,-219706083,'Leo'],
  [-219706083,-219488708,'Virgo'],
  [-219488708,-219272411,'Libra'],
  [-219272411,-219064841,'Scorpio'],
  [-219064841,-218868894,'Sagittarius'],
  [-218868894,-218682626,'Capricorn'],
  [-218682626,-218501636,'Aquarius'],
  [-218501636,-218321301,'Pisces'],
  [-218321301,-218138059,'Aries'],
  [-218138059,-217949748,'Taurus'],
  [-217949748,-217755150,'Gemini'],
  [-217755150,-217553256,'Cancer'],
  [-217553256,-217343409,'Leo'],
  [-217343409,-217126981,'Virgo'],
  [-217126981,-216909215,'Libra'],
  [-216909215,-216698108,'Scorpio'],
  [-216698108,-216499631,'Sagittarius'],
  [-216499631,-216314270,'Capricorn'],
  [-216314270,-216137654,'Aquarius'],
  [-216137654,-215963206,'Pisces'],
  [-215963206,-215784577,'Aries'],
  [-215784577,-215597490,'Taurus'],
  [-215597490,-215400807,'Gemini'],
  [-215400807,-215195852,'Cancer'],
  [-215195852,-214984447,'Leo'],
  [-214984447,-214768155,'Virgo'],
  [-214768155,-214549834,'Libra'],
  [-214549834,-214335374,'Scorpio'],
  [-214335374,-214131862,'Sagittarius'],
  [-214131862,-213942936,'Capricorn'],
  [-213942936,-213766418,'Aquarius'],
  [-213766418,-213595831,'Pisces'],
  [-213595831,-213423300,'Aries'],
  [-213423300,-213241920,'Taurus'],
  [-213241920,-213048041,'Gemini'],
  [-213048041,-212842576,'Cancer'],
  [-212842576,-212629426,'Leo'],
  [-212629426,-212412396,'Virgo'],
  [-212412396,-212194219,'Libra'],
  [-212194219,-211978427,'Scorpio'],
  [-211978427,-211770591,'Sagittarius'],
  [-211770591,-211575826,'Capricorn'],
  [-211575826,-211394950,'Aquarius'],
  [-211394950,-211223502,'Pisces'],
  [-211223502,-211053952,'Aries'],
  [-211053952,-210878287,'Taurus'],
  [-210878287,-210690345,'Gemini'],
  [-210690345,-210488333,'Cancer'],
  [-210488333,-210275586,'Leo'],
  [-210275586,-210057913,'Virgo'],
  [-210057913,-209839991,'Libra'],
  [-209839991,-209624852,'Scorpio'],
  [-209624852,-209415756,'Sagittarius'],
  [-209415756,-209216630,'Capricorn'],
  [-209216630,-209029779,'Aquarius'],
  [-209029779,-208853481,'Pisces'],
  [-208853481,-208682204,'Aries'],
  [-208682204,-208508595,'Taurus'],
  [-208508595,-208325622,'Gemini'],
  [-208325622,-208128978,'Cancer'],
  [-208128978,-207919321,'Leo'],
  [-207919321,-207702165,'Virgo'],
  [-207702165,-207484349,'Libra'],
  [-207484349,-207270499,'Scorpio'],
  [-207270499,-207062977,'Sagittarius'],
  [-207062977,-206863367,'Capricorn'],
  [-206863367,-206672844,'Aquarius'],
  [-206672844,-206490964,'Pisces'],
  [-206490964,-206314684,'Aries'],
  [-206314684,-206138763,'Taurus'],
  [-206138763,-205957070,'Gemini'],
  [-205957070,-205764412,'Cancer'],
  [-205764412,-205558851,'Leo'],
  [-205558851,-205343531,'Virgo'],
  [-205343531,-205125708,'Libra'],
  [-205125708,-204912399,'Scorpio'],
  [-204912399,-204707152,'Sagittarius'],
  [-204707152,-204510260,'Capricorn'],
  [-204510260,-204320480,'Aquarius'],
  [-204320480,-204136128,'Pisces'],
  [-204136128,-203955070,'Aries'],
  [-203955070,-203774359,'Taurus'],
  [-203774359,-203590125,'Gemini'],
  [-203590125,-203398144,'Cancer'],
  [-203398144,-203195376,'Leo'],
  [-203195376,-202982305,'Virgo'],
  [-202982305,-202764478,'Libra'],
  [-202764478,-202550274,'Scorpio'],
  [-202550274,-202345746,'Sagittarius'],
  [-202345746,-202151930,'Capricorn'],
  [-202151930,-201966021,'Aquarius'],
  [-201966021,-201783884,'Pisces'],
  [-201783884,-201601884,'Aries'],
  [-201601884,-201417529,'Taurus'],
  [-201417529,-201229079,'Gemini'],
  [-201229079,-201034663,'Cancer'],
  [-201034663,-200832110,'Leo'],
  [-200832110,-200620478,'Virgo'],
  [-200620478,-200402714,'Libra'],
  [-200402714,-200186449,'Scorpio'],
  [-200186449,-199979968,'Sagittarius'],
  [-199979968,-199786754,'Capricorn'],
  [-199786754,-199604384,'Aquarius'],
  [-199604384,-199427122,'Pisces'],
  [-199427122,-199248877,'Aries'],
  [-199248877,-199065266,'Taurus'],
  [-199065266,-198874533,'Gemini'],
  [-198874533,-198676780,'Cancer'],
  [-198676780,-198472191,'Leo'],
  [-198472191,-198260482,'Virgo'],
  [-198260482,-198042809,'Libra'],
  [-198042809,-197824452,'Scorpio'],
  [-197824452,-197613966,'Sagittarius'],
  [-197613966,-197417648,'Capricorn'],
  [-197417648,-197235374,'Aquarius'],
  [-197235374,-197061667,'Pisces'],
  [-197061667,-196889015,'Aries'],
  [-196889015,-196710564,'Taurus'],
  [-196710564,-196522210,'Gemini'],
  [-196522210,-196323585,'Cancer'],
  [-196323585,-196116706,'Leo'],
  [-196116706,-195903631,'Virgo'],
  [-195903631,-195685883,'Libra'],
  [-195685883,-195466613,'Scorpio'],
  [-195466613,-195252371,'Sagittarius'],
  [-195252371,-195050488,'Capricorn'],
  [-195050488,-194863912,'Aquarius'],
  [-194863912,-194689386,'Pisces'],
  [-194689386,-194519820,'Aries'],
  [-194519820,-194347250,'Taurus'],
  [-194347250,-194165058,'Gemini'],
  [-194165058,-193970087,'Cancer'],
  [-193970087,-193763504,'Leo'],
  [-193763504,-193549168,'Virgo'],
  [-193549168,-193330974,'Libra'],
  [-193330974,-193112098,'Scorpio'],
  [-193112098,-192896683,'Sagittarius'],
  [-192896683,-192690296,'Capricorn'],
  [-192690296,-192497221,'Aquarius'],
  [-192497221,-192317283,'Pisces'],
  [-192317283,-192145723,'Aries'],
  [-192145723,-191975374,'Taurus'],
  [-191975374,-191798808,'Gemini'],
  [-191798808,-191610288,'Cancer'],
  [-191610288,-191407868,'Leo'],
  [-191407868,-191194382,'Virgo'],
  [-191194382,-190975744,'Libra'],
  [-190975744,-190757505,'Scorpio'],
  [-190757505,-190543483,'Sagittarius'],
  [-190543483,-190336615,'Capricorn'],
  [-190336615,-190139423,'Aquarius'],
  [-190139423,-189952897,'Pisces'],
  [-189952897,-189775198,'Aries'],
  [-189775198,-189601748,'Taurus'],
  [-189601748,-189426348,'Gemini'],
  [-189426348,-189242636,'Cancer'],
  [-189242636,-189046017,'Leo'],
  [-189046017,-188836105,'Virgo'],
  [-188836105,-188618033,'Libra'],
  [-188618033,-188399780,'Scorpio'],
  [-188399780,-188187426,'Sagittarius'],
  [-188187426,-187983262,'Capricorn'],
  [-187983262,-187787061,'Aquarius'],
  [-187787061,-187597867,'Pisces'],
  [-187597867,-187414458,'Aries'],
  [-187414458,-187234853,'Taurus'],
  [-187234853,-187055668,'Gemini'],
  [-187055668,-186872101,'Cancer'],
  [-186872101,-186679024,'Leo'],
  [-186679024,-186473362,'Virgo'],
  [-186473362,-186257219,'Libra'],
  [-186257219,-186038491,'Scorpio'],
  [-186038491,-185826074,'Sagittarius'],
  [-185826074,-185624264,'Capricorn'],
  [-185624264,-185431970,'Aquarius'],
  [-185431970,-185245557,'Pisces'],
  [-185245557,-185061595,'Aries'],
  [-185061595,-184877986,'Taurus'],
  [-184877986,-184693443,'Gemini'],
  [-184693443,-184506010,'Cancer'],
  [-184506010,-184312305,'Leo'],
  [-184312305,-184108757,'Virgo'],
  [-184108757,-183894766,'Libra'],
  [-183894766,-183675739,'Scorpio'],
  [-183675739,-183461397,'Sagittarius'],
  [-183461397,-183259039,'Capricorn'],
  [-183259039,-183069242,'Aquarius'],
  [-183069242,-182887496,'Pisces'],
  [-182887496,-182707921,'Aries'],
  [-182707921,-182525961,'Taurus'],
  [-182525961,-182339498,'Gemini'],
  [-182339498,-182148076,'Cancer'],
  [-182148076,-181950997,'Leo'],
  [-181950997,-181746490,'Virgo'],
  [-181746490,-181533366,'Libra'],
  [-181533366,-181314376,'Scorpio'],
  [-181314376,-181097549,'Sagittarius'],
  [-181097549,-180891820,'Capricorn'],
  [-180891820,-180700713,'Aquarius'],
  [-180700713,-180521105,'Pisces'],
  [-180521105,-180346424,'Aries'],
  [-180346424,-180169948,'Taurus'],
  [-180169948,-179986921,'Gemini'],
  [-179986921,-179795490,'Cancer'],
  [-179795490,-179595929,'Leo'],
  [-179595929,-179388946,'Virgo'],
  [-179388946,-179175036,'Libra'],
  [-179175036,-178956097,'Scorpio'],
  [-178956097,-178737653,'Sagittarius'],
  [-178737653,-178527777,'Capricorn'],
  [-178527777,-178332141,'Aquarius'],
  [-178332141,-178150376,'Pisces'],
  [-178150376,-177977187,'Aries'],
  [-177977187,-177805415,'Taurus'],
  [-177805415,-177628372,'Gemini'],
  [-177628372,-177441469,'Cancer'],
  [-177441469,-177243227,'Leo'],
  [-177243227,-177035026,'Virgo'],
  [-177035026,-176819728,'Libra'],
  [-176819728,-176600597,'Scorpio'],
  [-176600597,-176381936,'Sagittarius'],
  [-176381936,-176169515,'Capricorn'],
  [-176169515,-175968792,'Aquarius'],
  [-175968792,-175781730,'Pisces'],
  [-175781730,-175605625,'Aries'],
  [-175605625,-175434639,'Taurus'],
  [-175434639,-175261850,'Gemini'],
  [-175261850,-175080870,'Cancer'],
  [-175080870,-174887456,'Leo'],
  [-174887456,-174681111,'Virgo'],
  [-174681111,-174465431,'Libra'],
  [-174465431,-174246006,'Scorpio'],
  [-174246006,-174028039,'Sagittarius'],
  [-174028039,-173815687,'Capricorn'],
  [-173815687,-173612282,'Aquarius'],
  [-173612282,-173419908,'Pisces'],
  [-173419908,-173238142,'Aries'],
  [-173238142,-173063680,'Taurus'],
  [-173063680,-172891027,'Gemini'],
  [-172891027,-172713673,'Cancer'],
  [-172713673,-172525614,'Leo'],
  [-172525614,-172323588,'Virgo'],
  [-172323588,-172109488,'Libra'],
  [-172109488,-171890070,'Scorpio'],
  [-171890070,-171672795,'Sagittarius'],
  [-171672795,-171462194,'Capricorn'],
  [-171462194,-171259639,'Aquarius'],
  [-171259639,-171065191,'Pisces'],
  [-171065191,-170878528,'Aries'],
  [-170878528,-170698446,'Taurus'],
  [-170698446,-170521987,'Gemini'],
  [-170521987,-170344190,'Cancer'],
  [-170344190,-170158984,'Leo'],
  [-170158984,-169961281,'Virgo'],
  [-169961281,-169750223,'Libra'],
  [-169750223,-169531423,'Scorpio'],
  [-169531423,-169314139,'Sagittarius'],
  [-169314139,-169105019,'Capricorn'],
  [-169105019,-168905305,'Aquarius'],
  [-168905305,-168712897,'Pisces'],
  [-168712897,-168525399,'Aries'],
  [-168525399,-168341400,'Taurus'],
  [-168341400,-168159769,'Gemini'],
  [-168159769,-167978074,'Cancer'],
  [-167978074,-167791933,'Leo'],
  [-167791933,-167596211,'Virgo'],
  [-167596211,-167388022,'Libra'],
  [-167388022,-167170357,'Scorpio'],
  [-167170357,-166952233,'Sagittarius'],
  [-166952233,-166742709,'Capricorn'],
  [-166742709,-166544939,'Aquarius'],
  [-166544939,-166356365,'Pisces'],
  [-166356365,-166172371,'Aries'],
  [-166172371,-165989244,'Taurus'],
  [-165989244,-165805154,'Gemini'],
  [-165805154,-165619121,'Cancer'],
  [-165619121,-165429263,'Leo'],
  [-165429263,-165232304,'Virgo'],
  [-165232304,-165025222,'Libra'],
  [-165025222,-164808670,'Scorpio'],
  [-164808670,-164589412,'Sagittarius'],
  [-164589412,-164377299,'Capricorn'],
  [-164377299,-164178351,'Aquarius'],
  [-164178351,-163991735,'Pisces'],
  [-163991735,-163812318,'Aries'],
  [-163812318,-163634198,'Taurus'],
  [-163634198,-163452919,'Gemini'],
  [-163452919,-163266208,'Cancer'],
  [-163266208,-163073174,'Leo'],
  [-163073174,-162873025,'Virgo'],
  [-162873025,-162664741,'Libra'],
  [-162664741,-162448578,'Scorpio'],
  [-162448578,-162228684,'Sagittarius'],
  [-162228684,-162013217,'Capricorn'],
  [-162013217,-161809898,'Aquarius'],
  [-161809898,-161621000,'Pisces'],
  [-161621000,-161443068,'Aries'],
  [-161443068,-161269829,'Taurus'],
  [-161269829,-161094749,'Gemini'],
  [-161094749,-160912657,'Cancer'],
  [-160912657,-160720753,'Leo'],
  [-160720753,-160518759,'Virgo'],
  [-160518759,-160308173,'Libra'],
  [-160308173,-160091286,'Scorpio'],
  [-160091286,-159871459,'Sagittarius'],
  [-159871459,-159654078,'Capricorn'],
  [-159654078,-159445749,'Aquarius'],
  [-159445749,-159250984,'Pisces'],
  [-159250984,-159069527,'Aries'],
  [-159069527,-158896891,'Taurus'],
  [-158896891,-158726406,'Gemini'],
  [-158726406,-158551031,'Cancer'],
  [-158551031,-158364953,'Leo'],
  [-158364953,-158165464,'Virgo'],
  [-158165464,-157954237,'Libra'],
  [-157954237,-157736166,'Scorpio'],
  [-157736166,-157516496,'Sagittarius'],
  [-157516496,-157299450,'Capricorn'],
  [-157299450,-157088845,'Aquarius'],
  [-157088845,-156888423,'Pisces'],
  [-156888423,-156700230,'Aries'],
  [-156700230,-156522988,'Taurus'],
  [-156522988,-156351990,'Gemini'],
  [-156351990,-156180340,'Cancer'],
  [-156180340,-156000649,'Leo'],
  [-156000649,-155807206,'Virgo'],
  [-155807206,-155598961,'Libra'],
  [-155598961,-155380963,'Scorpio'],
  [-155380963,-155161146,'Sagittarius'],
  [-155161146,-154945349,'Capricorn'],
  [-154945349,-154735938,'Aquarius'],
  [-154735938,-154533951,'Pisces'],
  [-154533951,-154340623,'Aries'],
  [-154340623,-154156645,'Taurus'],
  [-154156645,-153980395,'Gemini'],
  [-153980395,-153807122,'Cancer'],
  [-153807122,-153629933,'Leo'],
  [-153629933,-153441821,'Virgo'],
  [-153441821,-153238749,'Libra'],
  [-153238749,-153023100,'Scorpio'],
  [-153023100,-152803344,'Sagittarius'],
  [-152803344,-152588068,'Capricorn'],
  [-152588068,-152380918,'Aquarius'],
  [-152380918,-152181350,'Pisces'],
  [-152181350,-151987976,'Aries'],
  [-151987976,-151800343,'Taurus'],
  [-151800343,-151618217,'Gemini'],
  [-151618217,-151439636,'Cancer'],
  [-151439636,-151260019,'Leo'],
  [-151260019,-151073203,'Virgo'],
  [-151073203,-150873974,'Libra'],
  [-150873974,-150661730,'Scorpio'],
  [-150661730,-150442767,'Sagittarius'],
  [-150442767,-150226880,'Capricorn'],
  [-150226880,-150020449,'Aquarius'],
  [-150020449,-149823865,'Pisces'],
  [-149823865,-149634166,'Aries'],
  [-149634166,-149448300,'Taurus'],
  [-149448300,-149264482,'Gemini'],
  [-149264482,-149081474,'Cancer'],
  [-149081474,-148897080,'Leo'],
  [-148897080,-148707558,'Virgo'],
  [-148707558,-148508734,'Libra'],
  [-148508734,-148298715,'Scorpio'],
  [-148298715,-148080918,'Sagittarius'],
  [-148080918,-147863831,'Capricorn'],
  [-147863831,-147655769,'Aquarius'],
  [-147655769,-147459713,'Pisces'],
  [-147459713,-147273370,'Aries'],
  [-147273370,-147092182,'Taurus'],
  [-147092182,-146911785,'Gemini'],
  [-146911785,-146729043,'Cancer'],
  [-146729043,-146541868,'Leo'],
  [-146541868,-146348524,'Virgo'],
  [-146348524,-146147284,'Libra'],
  [-146147284,-145937206,'Scorpio'],
  [-145937206,-145720131,'Sagittarius'],
  [-145720131,-145501981,'Capricorn'],
  [-145501981,-145290809,'Aquarius'],
  [-145290809,-145092066,'Pisces'],
  [-145092066,-144905832,'Aries'],
  [-144905832,-144728047,'Taurus'],
  [-144728047,-144552933,'Gemini'],
  [-144552933,-144374857,'Cancer'],
  [-144374857,-144189567,'Leo'],
  [-144189567,-143994945,'Virgo'],
  [-143994945,-143791038,'Libra'],
  [-143791038,-143579272,'Scorpio'],
  [-143579272,-143362056,'Sagittarius'],
  [-143362056,-143143433,'Capricorn'],
  [-143143433,-142929388,'Aquarius'],
  [-142929388,-142726047,'Pisces'],
  [-142726047,-142536215,'Aries'],
  [-142536215,-142358011,'Taurus'],
  [-142358011,-142186055,'Gemini'],
  [-142186055,-142013444,'Cancer'],
  [-142013444,-141833554,'Leo'],
  [-141833554,-141641901,'Virgo'],
  [-141641901,-141437863,'Libra'],
  [-141437863,-141224591,'Scorpio'],
  [-141224591,-141006647,'Sagittarius'],
  [-141006647,-140788125,'Capricorn'],
  [-140788125,-140572909,'Aquarius'],
  [-140572909,-140365589,'Pisces'],
  [-140365589,-140170220,'Aries'],
  [-140170220,-139987705,'Taurus'],
  [-139987705,-139814714,'Gemini'],
  [-139814714,-139644752,'Cancer'],
  [-139644752,-139470131,'Leo'],
  [-139470131,-139284074,'Virgo'],
  [-139284074,-139083428,'Libra'],
  [-139083428,-138870673,'Scorpio'],
  [-138870673,-138652206,'Sagittarius'],
  [-138652206,-138433992,'Capricorn'],
  [-138433992,-138219461,'Aquarius'],
  [-138219461,-138010965,'Pisces'],
  [-138010965,-137811347,'Aries'],
  [-137811347,-137622917,'Taurus'],
  [-137622917,-137445081,'Gemini'],
  [-137445081,-137273375,'Cancer'],
  [-137273375,-137100700,'Leo'],
  [-137100700,-136919403,'Virgo'],
  [-136919403,-136723969,'Libra'],
  [-136723969,-136514270,'Scorpio'],
  [-136514270,-136296350,'Sagittarius'],
  [-136296350,-136078285,'Capricorn'],
  [-136078285,-135865112,'Aquarius'],
  [-135865112,-135658279,'Pisces'],
  [-135658279,-135458261,'Aries'],
  [-135458261,-135266140,'Taurus'],
  [-135266140,-135082564,'Gemini'],
  [-135082564,-134905678,'Cancer'],
  [-134905678,-134730549,'Leo'],
  [-134730549,-134550418,'Virgo'],
  [-134550418,-134358951,'Libra'],
  [-134358951,-134153426,'Scorpio'],
  [-134153426,-133937399,'Sagittarius'],
  [-133937399,-133719262,'Capricorn'],
  [-133719262,-133506549,'Aquarius'],
  [-133506549,-133302054,'Pisces'],
  [-133302054,-133105015,'Aries'],
  [-133105015,-132913959,'Taurus'],
  [-132913959,-132728009,'Gemini'],
  [-132728009,-132546136,'Cancer'],
  [-132546136,-132365819,'Leo'],
  [-132365819,-132182718,'Virgo'],
  [-132182718,-131991694,'Libra'],
  [-131991694,-131789059,'Scorpio'],
  [-131789059,-131575506,'Sagittarius'],
  [-131575506,-131357362,'Capricorn'],
  [-131357362,-131143411,'Aquarius'],
  [-131143411,-130939274,'Pisces'],
  [-130939274,-130745316,'Aries'],
  [-130745316,-130558643,'Taurus'],
  [-130558643,-130375649,'Gemini'],
  [-130375649,-130193332,'Cancer'],
  [-130193332,-130009371,'Leo'],
  [-130009371,-129821575,'Virgo'],
  [-129821575,-129627481,'Libra'],
  [-129627481,-129424755,'Scorpio'],
  [-129424755,-129212814,'Sagittarius'],
  [-129212814,-128994991,'Capricorn'],
  [-128994991,-128778744,'Aquarius'],
  [-128778744,-128571872,'Pisces'],
  [-128571872,-128377735,'Aries'],
  [-128377735,-128194423,'Taurus'],
  [-128194423,-128016907,'Gemini'],
  [-128016907,-127839435,'Cancer'],
  [-127839435,-127657249,'Leo'],
  [-127657249,-127467607,'Virgo'],
  [-127467607,-127269863,'Libra'],
  [-127269863,-127064500,'Scorpio'],
  [-127064500,-126852244,'Sagittarius'],
  [-126852244,-126634826,'Capricorn'],
  [-126634826,-126416802,'Aquarius'],
  [-126416802,-126205508,'Pisces'],
  [-126205508,-126007121,'Aries'],
  [-126007121,-125822734,'Taurus'],
  [-125822734,-125648226,'Gemini'],
  [-125648226,-125476643,'Cancer'],
  [-125476643,-125300689,'Leo'],
  [-125300689,-125114809,'Virgo'],
  [-125114809,-124917086,'Libra'],
  [-124917086,-124709460,'Scorpio'],
  [-124709460,-124495445,'Sagittarius'],
  [-124495445,-124277903,'Capricorn'],
  [-124277903,-124059543,'Aquarius'],
  [-124059543,-123845072,'Pisces'],
  [-123845072,-123640852,'Aries'],
  [-123640852,-123451008,'Taurus'],
  [-123451008,-123274318,'Gemini'],
  [-123274318,-123104793,'Cancer'],
  [-123104793,-122934357,'Leo'],
  [-122934357,-122755254,'Virgo'],
  [-122755254,-122562510,'Libra'],
  [-122562510,-122356282,'Scorpio'],
  [-122356282,-122141288,'Sagittarius'],
  [-122141288,-121923068,'Capricorn'],
  [-121923068,-121705213,'Aquarius'],
  [-121705213,-121490430,'Pisces'],
  [-121490430,-121282745,'Aries'],
  [-121282745,-121086664,'Taurus'],
  [-121086664,-120903841,'Gemini'],
  [-120903841,-120731050,'Cancer'],
  [-120731050,-120561431,'Leo'],
  [-120561431,-120386930,'Virgo'],
  [-120386930,-120200621,'Libra'],
  [-120200621,-119999482,'Scorpio'],
  [-119999482,-119786307,'Sagittarius'],
  [-119786307,-119567885,'Capricorn'],
  [-119567885,-119350381,'Aquarius'],
  [-119350381,-119137055,'Pisces'],
  [-119137055,-118929849,'Aries'],
  [-118929849,-118731059,'Taurus'],
  [-118731059,-118542550,'Gemini'],
  [-118542550,-118363574,'Cancer'],
  [-118363574,-118189933,'Leo'],
  [-118189933,-118015137,'Virgo'],
  [-118015137,-117832314,'Libra'],
  [-117832314,-117636530,'Scorpio'],
  [-117636530,-117427421,'Sagittarius'],
  [-117427421,-117210192,'Capricorn'],
  [-117210192,-116992660,'Aquarius'],
  [-116992660,-116780500,'Pisces'],
  [-116780500,-116575827,'Aries'],
  [-116575827,-116378765,'Taurus'],
  [-116378765,-116188956,'Gemini'],
  [-116188956,-116005522,'Cancer'],
  [-116005522,-115826236,'Leo'],
  [-115826236,-115647197,'Virgo'],
  [-115647197,-115463374,'Libra'],
  [-115463374,-115269981,'Scorpio'],
  [-115269981,-115064625,'Sagittarius'],
  [-115064625,-114849578,'Capricorn'],
  [-114849578,-114631895,'Aquarius'],
  [-114631895,-114419441,'Pisces'],
  [-114419441,-114216477,'Aries'],
  [-114216477,-114022914,'Taurus'],
  [-114022914,-113836164,'Gemini'],
  [-113836164,-113653092,'Cancer'],
  [-113653092,-113470920,'Leo'],
  [-113470920,-113287221,'Virgo'],
  [-113287221,-113099469,'Libra'],
  [-113099469,-112904815,'Scorpio'],
  [-112904815,-112700858,'Sagittarius'],
  [-112700858,-112487678,'Capricorn'],
  [-112487678,-112269897,'Aquarius'],
  [-112269897,-112055704,'Pisces'],
  [-112055704,-111851951,'Aries'],
  [-111851951,-111660332,'Taurus'],
  [-111660332,-111477753,'Gemini'],
  [-111477753,-111298918,'Cancer'],
  [-111298918,-111118742,'Leo'],
  [-111118742,-110933798,'Virgo'],
  [-110933798,-110742612,'Libra'],
  [-110742612,-110544737,'Scorpio'],
  [-110544737,-110339612,'Sagittarius'],
  [-110339612,-110126990,'Capricorn'],
  [-110126990,-109909180,'Aquarius'],
  [-109909180,-109692688,'Pisces'],
  [-109692688,-109485705,'Aries'],
  [-109485705,-109292676,'Taurus'],
  [-109292676,-109111931,'Gemini'],
  [-109111931,-108937576,'Cancer'],
  [-108937576,-108762550,'Leo'],
  [-108762550,-108581019,'Virgo'],
  [-108581019,-108390087,'Libra'],
  [-108390087,-108190048,'Scorpio'],
  [-108190048,-107982632,'Sagittarius'],
  [-107982632,-107769211,'Capricorn'],
  [-107769211,-107551356,'Aquarius'],
  [-107551356,-107333246,'Pisces'],
  [-107333246,-107122198,'Aries'],
  [-107122198,-106924696,'Taurus'],
  [-106924696,-106741792,'Gemini'],
  [-106741792,-106568818,'Cancer'],
  [-106568818,-106398245,'Leo'],
  [-106398245,-106222453,'Virgo'],
  [-106222453,-106035976,'Libra'],
  [-106035976,-105837349,'Scorpio'],
  [-105837349,-105628878,'Sagittarius'],
  [-105628878,-105414173,'Capricorn'],
  [-105414173,-105196148,'Aquarius'],
  [-105196148,-104977805,'Pisces'],
  [-104977805,-104764191,'Aries'],
  [-104764191,-104561502,'Taurus'],
  [-104561502,-104373158,'Gemini'],
  [-104373158,-104197150,'Cancer'],
  [-104197150,-104027229,'Leo'],
  [-104027229,-103855578,'Virgo'],
  [-103855578,-103675041,'Libra'],
  [-103675041,-103481366,'Scorpio'],
  [-103481366,-103274892,'Sagittarius'],
  [-103274892,-103059869,'Capricorn'],
  [-103059869,-102841555,'Aquarius'],
  [-102841555,-102623968,'Pisces'],
  [-102623968,-102410555,'Aries'],
  [-102410555,-102205228,'Taurus'],
  [-102205228,-102011337,'Gemini'],
  [-102011337,-101829249,'Cancer'],
  [-101829249,-101655396,'Leo'],
  [-101655396,-101483526,'Virgo'],
  [-101483526,-101306566,'Libra'],
  [-101306566,-101118529,'Scorpio'],
  [-101118529,-100916745,'Sagittarius'],
  [-100916745,-100703502,'Capricorn'],
  [-100703502,-100485116,'Aquarius'],
  [-100485116,-100268144,'Pisces'],
  [-100268144,-100056683,'Aries'],
  [-100056683,-99852658,'Taurus'],
  [-99852658,-99657006,'Gemini'],
  [-99657006,-99469865,'Cancer'],
  [-99469865,-99289787,'Leo'],
  [-99289787,-99113298,'Virgo'],
  [-99113298,-98935280,'Libra'],
  [-98935280,-98750010,'Scorpio'],
  [-98750010,-98552938,'Sagittarius'],
  [-98552938,-98343204,'Capricorn'],
  [-98343204,-98125512,'Aquarius'],
  [-98125512,-97908193,'Pisces'],
  [-97908193,-97698006,'Aries'],
  [-97698006,-97497174,'Taurus'],
  [-97497174,-97304387,'Gemini'],
  [-97304387,-97117196,'Cancer'],
  [-97117196,-96933441,'Leo'],
  [-96933441,-96751289,'Virgo'],
  [-96751289,-96568451,'Libra'],
  [-96568451,-96381478,'Scorpio'],
  [-96381478,-96186174,'Sagittarius'],
  [-96186174,-95979636,'Capricorn'],
  [-95979636,-95763446,'Aquarius'],
  [-95763446,-95545070,'Pisces'],
  [-95545070,-95333780,'Aries'],
  [-95333780,-95134422,'Taurus'],
  [-95134422,-94945728,'Gemini'],
  [-94945728,-94763021,'Cancer'],
  [-94763021,-94581407,'Leo'],
  [-94581407,-94397661,'Virgo'],
  [-94397661,-94210479,'Libra'],
  [-94210479,-94019108,'Scorpio'],
  [-94019108,-93821802,'Sagittarius'],
  [-93821802,-93616059,'Capricorn'],
  [-93616059,-93401261,'Aquarius'],
  [-93401261,-93182019,'Pisces'],
  [-93182019,-92967681,'Aries'],
  [-92967681,-92766120,'Taurus'],
  [-92766120,-92578510,'Gemini'],
  [-92578510,-92400166,'Cancer'],
  [-92400166,-92224250,'Leo'],
  [-92224250,-92044751,'Virgo'],
  [-92044751,-91858294,'Libra'],
  [-91858294,-91664375,'Scorpio'],
  [-91664375,-91463636,'Sagittarius'],
  [-91463636,-91256076,'Capricorn'],
  [-91256076,-91041430,'Aquarius'],
  [-91041430,-90821976,'Pisces'],
  [-90821976,-90604694,'Aries'],
  [-90604694,-90398357,'Taurus'],
  [-90398357,-90207338,'Gemini'],
  [-90207338,-90029197,'Cancer'],
  [-90029197,-89857260,'Leo'],
  [-89857260,-89683987,'Virgo'],
  [-89683987,-89503257,'Libra'],
  [-89503257,-89311992,'Scorpio'],
  [-89311992,-89110441,'Sagittarius'],
  [-89110441,-88900681,'Capricorn'],
  [-88900681,-88684894,'Aquarius'],
  [-88684894,-88465492,'Pisces'],
  [-88465492,-88247054,'Aries'],
  [-88247054,-88036508,'Taurus'],
  [-88036508,-87839610,'Gemini'],
  [-87839610,-87657014,'Cancer'],
  [-87657014,-87484209,'Leo'],
  [-87484209,-87314117,'Virgo'],
  [-87314117,-87139453,'Libra'],
  [-87139453,-86954481,'Scorpio'],
  [-86954481,-86756620,'Sagittarius'],
  [-86756620,-86547203,'Capricorn'],
  [-86547203,-86330389,'Aquarius'],
  [-86330389,-86110848,'Pisces'],
  [-86110848,-85892923,'Aries'],
  [-85892923,-85681112,'Taurus'],
  [-85681112,-85479726,'Gemini'],
  [-85479726,-85290891,'Cancer'],
  [-85290891,-85112969,'Leo'],
  [-85112969,-84941083,'Virgo'],
  [-84941083,-84768685,'Libra'],
  [-84768685,-84589096,'Scorpio'],
  [-84589096,-84397163,'Sagittarius'],
  [-84397163,-84191370,'Capricorn'],
  [-84191370,-83975242,'Aquarius'],
  [-83975242,-83755566,'Pisces'],
  [-83755566,-83538602,'Aries'],
  [-83538602,-83328168,'Taurus'],
  [-83328168,-83126132,'Gemini'],
  [-83126132,-82933377,'Cancer'],
  [-82933377,-82749531,'Leo'],
  [-82749531,-82572351,'Virgo'],
  [-82572351,-82397559,'Libra'],
  [-82397559,-82219378,'Scorpio'],
  [-82219378,-82031802,'Sagittarius'],
  [-82031802,-81830790,'Capricorn'],
  [-81830790,-81617233,'Aquarius'],
  [-81617233,-81397874,'Pisces'],
  [-81397874,-81181311,'Aries'],
  [-81181311,-80972840,'Taurus'],
  [-80972840,-80773224,'Gemini'],
  [-80773224,-80580938,'Cancer'],
  [-80580938,-80394332,'Leo'],
  [-80394332,-80212066,'Virgo'],
  [-80212066,-80032249,'Libra'],
  [-80032249,-79851400,'Scorpio'],
  [-79851400,-79664498,'Sagittarius'],
  [-79664498,-79466626,'Capricorn'],
  [-79466626,-79256121,'Aquarius'],
  [-79256121,-79037612,'Pisces'],
  [-79037612,-78820538,'Aries'],
  [-78820538,-78612667,'Taurus'],
  [-78612667,-78415765,'Gemini'],
  [-78415765,-78226954,'Cancer'],
  [-78226954,-78042221,'Leo'],
  [-78042221,-77858709,'Virgo'],
  [-77858709,-77674993,'Libra'],
  [-77674993,-77489719,'Scorpio'],
  [-77489719,-77300158,'Sagittarius'],
  [-77300158,-77102408,'Capricorn'],
  [-77102408,-76893741,'Aquarius'],
  [-76893741,-76676215,'Pisces'],
  [-76676215,-76457975,'Aries'],
  [-76457975,-76248524,'Taurus'],
  [-76248524,-76052089,'Gemini'],
  [-76052089,-75866425,'Cancer'],
  [-75866425,-75686131,'Leo'],
  [-75686131,-75505973,'Virgo'],
  [-75505973,-75322668,'Libra'],
  [-75322668,-75134868,'Scorpio'],
  [-75134868,-74941712,'Sagittarius'],
  [-74941712,-74741603,'Capricorn'],
  [-74741603,-74532750,'Aquarius'],
  [-74532750,-74315789,'Pisces'],
  [-74315789,-74096414,'Aries'],
  [-74096414,-73883802,'Taurus'],
  [-73883802,-73684610,'Gemini'],
  [-73684610,-73498949,'Cancer'],
  [-73498949,-73321908,'Leo'],
  [-73321908,-73146957,'Virgo'],
  [-73146957,-72968375,'Libra'],
  [-72968375,-72782581,'Scorpio'],
  [-72782581,-72588277,'Sagittarius'],
  [-72588277,-72385547,'Capricorn'],
  [-72385547,-72174955,'Aquarius'],
  [-72174955,-71957813,'Pisces'],
  [-71957813,-71737968,'Aries'],
  [-71737968,-71522409,'Taurus'],
  [-71522409,-71318343,'Gemini'],
  [-71318343,-71128715,'Cancer'],
  [-71128715,-70950926,'Leo'],
  [-70950926,-70779005,'Virgo'],
  [-70779005,-70606070,'Libra'],
  [-70606070,-70426040,'Scorpio'],
  [-70426040,-70235031,'Sagittarius'],
  [-70235031,-70032314,'Capricorn'],
  [-70032314,-69820124,'Aquarius'],
  [-69820124,-69602167,'Pisces'],
  [-69602167,-69382544,'Aries'],
  [-69382544,-69166017,'Taurus'],
  [-69166017,-68957890,'Gemini'],
  [-68957890,-68762196,'Cancer'],
  [-68762196,-68579325,'Leo'],
  [-68579325,-68405714,'Virgo'],
  [-68405714,-68235228,'Libra'],
  [-68235228,-68060791,'Scorpio'],
  [-68060791,-67876006,'Sagittarius'],
  [-67876006,-67677262,'Capricorn'],
  [-67677262,-67465777,'Aquarius'],
  [-67465777,-67247143,'Pisces'],
  [-67247143,-67027818,'Aries'],
  [-67027818,-66812366,'Taurus'],
  [-66812366,-66603580,'Gemini'],
  [-66603580,-66403740,'Cancer'],
  [-66403740,-66214373,'Leo'],
  [-66214373,-66034883,'Virgo'],
  [-66034883,-65861716,'Libra'],
  [-65861716,-65688799,'Scorpio'],
  [-65688799,-65508964,'Sagittarius'],
  [-65508964,-65316102,'Capricorn'],
  [-65316102,-65108350,'Aquarius'],
  [-65108350,-64890414,'Pisces'],
  [-64890414,-64671007,'Aries'],
  [-64671007,-64456934,'Taurus'],
  [-64456934,-64250419,'Gemini'],
  [-64250419,-64051100,'Cancer'],
  [-64051100,-63858637,'Leo'],
  [-63858637,-63673172,'Virgo'],
  [-63673172,-63493894,'Libra'],
  [-63493894,-63317457,'Scorpio'],
  [-63317457,-63138029,'Sagittarius'],
  [-63138029,-62948981,'Capricorn'],
  [-62948981,-62745909,'Aquarius'],
  [-62745909,-62530434,'Pisces'],
  [-62530434,-62310922,'Aries'],
  [-62310922,-62096838,'Taurus'],
  [-62096838,-61892466,'Gemini'],
  [-61892466,-61696680,'Cancer'],
  [-61696680,-61506509,'Leo'],
  [-61506509,-61319901,'Virgo'],
  [-61319901,-61136101,'Libra'],
  [-61136101,-60954039,'Scorpio'],
  [-60954039,-60770668,'Sagittarius'],
  [-60770668,-60581057,'Capricorn'],
  [-60581057,-60380439,'Aquarius'],
  [-60380439,-60167773,'Pisces'],
  [-60167773,-59948661,'Aries'],
  [-59948661,-59733053,'Taurus'],
  [-59733053,-59528200,'Gemini'],
  [-59528200,-59334814,'Cancer'],
  [-59334814,-59149165,'Leo'],
  [-59149165,-58966674,'Virgo'],
  [-58966674,-58784044,'Libra'],
  [-58784044,-58599511,'Scorpio'],
  [-58599511,-58411666,'Sagittarius'],
  [-58411666,-58218308,'Capricorn'],
  [-58218308,-58016618,'Aquarius'],
  [-58016618,-57805141,'Pisces'],
  [-57805141,-57586728,'Aries'],
  [-57586728,-57369220,'Taurus'],
  [-57369220,-57161232,'Gemini'],
  [-57161232,-56966539,'Cancer'],
  [-56966539,-56783060,'Leo'],
  [-56783060,-56605575,'Virgo'],
  [-56605575,-56428435,'Libra'],
  [-56428435,-56247133,'Scorpio'],
  [-56247133,-56058912,'Sagittarius'],
  [-56058912,-55862585,'Capricorn'],
  [-55862585,-55657939,'Aquarius'],
  [-55657939,-55445466,'Pisces'],
  [-55445466,-55227333,'Aries'],
  [-55227333,-55008684,'Taurus'],
  [-55008684,-54796861,'Gemini'],
  [-54796861,-54597657,'Cancer'],
  [-54597657,-54411973,'Leo'],
  [-54411973,-54236107,'Virgo'],
  [-54236107,-54063908,'Libra'],
  [-54063908,-53888768,'Scorpio'],
  [-53888768,-53705160,'Sagittarius'],
  [-53705160,-53510078,'Capricorn'],
  [-53510078,-53303909,'Aquarius'],
  [-53303909,-53089627,'Pisces'],
  [-53089627,-52871049,'Aries'],
  [-52871049,-52652262,'Taurus'],
  [-52652262,-52438112,'Gemini'],
  [-52438112,-52233889,'Cancer'],
  [-52233889,-52042800,'Leo'],
  [-52042800,-51863971,'Virgo'],
  [-51863971,-51692675,'Libra'],
  [-51692675,-51521968,'Scorpio'],
  [-51521968,-51344518,'Sagittarius'],
  [-51344518,-51154592,'Capricorn'],
  [-51154592,-50950519,'Aquarius'],
  [-50950519,-50735786,'Pisces'],
  [-50735786,-50516578,'Aries'],
  [-50516578,-50298172,'Taurus'],
  [-50298172,-50083993,'Gemini'],
  [-50083993,-49877102,'Cancer'],
  [-49877102,-49680639,'Leo'],
  [-49680639,-49496028,'Virgo'],
  [-49496028,-49321205,'Libra'],
  [-49321205,-49150625,'Scorpio'],
  [-49150625,-48976842,'Sagittarius'],
  [-48976842,-48792550,'Capricorn'],
  [-48792550,-48593347,'Aquarius'],
  [-48593347,-48380705,'Pisces'],
  [-48380705,-48161585,'Aries'],
  [-48161585,-47943544,'Taurus'],
  [-47943544,-47730711,'Gemini'],
  [-47730711,-47524427,'Cancer'],
  [-47524427,-47325770,'Leo'],
  [-47325770,-47136143,'Virgo'],
  [-47136143,-46955595,'Libra'],
  [-46955595,-46781101,'Scorpio'],
  [-46781101,-46606718,'Sagittarius'],
  [-46606718,-46425252,'Capricorn'],
  [-46425252,-46230757,'Aquarius'],
  [-46230757,-46021928,'Pisces'],
  [-46021928,-45804101,'Aries'],
  [-45804101,-45586159,'Taurus'],
  [-45586159,-45374443,'Gemini'],
  [-45374443,-45170535,'Cancer'],
  [-45170535,-44973576,'Leo'],
  [-44973576,-44782869,'Virgo'],
  [-44782869,-44598222,'Libra'],
  [-44598222,-44418415,'Scorpio'],
  [-44418415,-44239942,'Sagittarius'],
  [-44239942,-44057321,'Capricorn'],
  [-44057321,-43864835,'Aquarius'],
  [-43864835,-43659424,'Pisces'],
  [-43659424,-43443676,'Aries'],
  [-43443676,-43225615,'Taurus'],
  [-43225615,-43013602,'Gemini'],
  [-43013602,-42811306,'Cancer'],
  [-42811306,-42617735,'Leo'],
  [-42617735,-42430095,'Virgo'],
  [-42430095,-42245916,'Libra'],
  [-42245916,-42063349,'Scorpio'],
  [-42063349,-41880304,'Sagittarius'],
  [-41880304,-41693714,'Capricorn'],
  [-41693714,-41499804,'Aquarius'],
  [-41499804,-41295641,'Pisces'],
  [-41295641,-41081699,'Aries'],
  [-41081699,-40863509,'Taurus'],
  [-40863509,-40649617,'Gemini'],
  [-40649617,-40446321,'Cancer'],
  [-40446321,-40254552,'Leo'],
  [-40254552,-40071151,'Virgo'],
  [-40071151,-39891462,'Libra'],
  [-39891462,-39711138,'Scorpio'],
  [-39711138,-39526959,'Sagittarius'],
  [-39526959,-39336848,'Capricorn'],
  [-39336848,-39139474,'Aquarius'],
  [-39139474,-38933968,'Pisces'],
  [-38933968,-38720605,'Aries'],
  [-38720605,-38502466,'Taurus'],
  [-38502466,-38286128,'Gemini'],
  [-38286128,-38079129,'Cancer'],
  [-38079129,-37885417,'Leo'],
  [-37885417,-37703622,'Virgo'],
  [-37703622,-37528649,'Libra'],
  [-37528649,-37354024,'Scorpio'],
  [-37354024,-37173836,'Sagittarius'],
  [-37173836,-36984308,'Capricorn'],
  [-36984308,-36784694,'Aquarius'],
  [-36784694,-36576608,'Pisces'],
  [-36576608,-36362336,'Aries'],
  [-36362336,-36144341,'Taurus'],
  [-36144341,-35926556,'Gemini'],
  [-35926556,-35715186,'Cancer'],
  [-35715186,-35516171,'Leo'],
  [-35516171,-35331335,'Virgo'],
  [-35331335,-35157305,'Libra'],
  [-35157305,-34987285,'Scorpio'],
  [-34987285,-34813491,'Sagittarius'],
  [-34813491,-34629324,'Capricorn'],
  [-34629324,-34431781,'Aquarius'],
  [-34431781,-34222738,'Pisces'],
  [-34222738,-34006983,'Aries'],
  [-34006983,-33788838,'Taurus'],
  [-33788838,-33571239,'Gemini'],
  [-33571239,-33357697,'Cancer'],
  [-33357697,-33153270,'Leo'],
  [-33153270,-32962045,'Virgo'],
  [-32962045,-32783850,'Libra'],
  [-32783850,-32613669,'Scorpio'],
  [-32613669,-32443739,'Sagittarius'],
  [-32443739,-32265950,'Capricorn'],
  [-32265950,-32074373,'Aquarius'],
  [-32074373,-31868221,'Pisces'],
  [-31868221,-31652401,'Aries'],
  [-31652401,-31433805,'Taurus'],
  [-31433805,-31217059,'Gemini'],
  [-31217059,-31004395,'Cancer'],
  [-31004395,-30798185,'Leo'],
  [-30798185,-30601665,'Virgo'],
  [-30601665,-30416736,'Libra'],
  [-30416736,-30241463,'Scorpio'],
  [-30241463,-30070097,'Sagittarius'],
  [-30070097,-29895030,'Capricorn'],
  [-29895030,-29709101,'Aquarius'],
  [-29709101,-29508486,'Pisces'],
  [-29508486,-29295317,'Aries'],
  [-29295317,-29076818,'Taurus'],
  [-29076818,-28860346,'Gemini'],
  [-28860346,-28649609,'Cancer'],
  [-28649609,-28445520,'Leo'],
  [-28445520,-28248590,'Virgo'],
  [-28248590,-28059571,'Libra'],
  [-28059571,-27878078,'Scorpio'],
  [-27878078,-27701207,'Sagittarius'],
  [-27701207,-27523688,'Capricorn'],
  [-27523688,-27339297,'Aquarius'],
  [-27339297,-27143042,'Pisces'],
  [-27143042,-26933945,'Aries'],
  [-26933945,-26716763,'Taurus'],
  [-26716763,-26499809,'Gemini'],
  [-26499809,-26289648,'Cancer'],
  [-26289648,-26088394,'Leo'],
  [-26088394,-25894986,'Virgo'],
  [-25894986,-25707412,'Libra'],
  [-25707412,-25523747,'Scorpio'],
  [-25523747,-25341937,'Sagittarius'],
  [-25341937,-25159221,'Capricorn'],
  [-25159221,-24971948,'Aquarius'],
  [-24971948,-24776275,'Pisces'],
  [-24776275,-24569940,'Aries'],
  [-24569940,-24354653,'Taurus'],
  [-24354653,-24137023,'Gemini'],
  [-24137023,-23925357,'Cancer'],
  [-23925357,-23724596,'Leo'],
  [-23724596,-23534559,'Virgo'],
  [-23534559,-23351633,'Libra'],
  [-23351633,-23171207,'Scorpio'],
  [-23171207,-22989334,'Sagittarius'],
  [-22989334,-22803397,'Capricorn'],
  [-22803397,-22611869,'Aquarius'],
  [-22611869,-22413517,'Pisces'],
  [-22413517,-22207162,'Aries'],
  [-22207162,-21993027,'Taurus'],
  [-21993027,-21774953,'Gemini'],
  [-21774953,-21560571,'Cancer'],
  [-21560571,-21357206,'Leo'],
  [-21357206,-21167296,'Virgo'],
  [-21167296,-20987810,'Libra'],
  [-20987810,-20812666,'Scorpio'],
  [-20812666,-20635422,'Sagittarius'],
  [-20635422,-20451272,'Capricorn'],
  [-20451272,-20258250,'Aquarius'],
  [-20258250,-20056907,'Pisces'],
  [-20056907,-19848532,'Aries'],
  [-19848532,-19634158,'Taurus'],
  [-19634158,-19415902,'Gemini'],
  [-19415902,-19199104,'Cancer'],
  [-19199104,-18991397,'Leo'],
  [-18991397,-18797934,'Virgo'],
  [-18797934,-18618003,'Libra'],
  [-18618003,-18445950,'Scorpio'],
  [-18445950,-18274142,'Sagittarius'],
  [-18274142,-18095484,'Capricorn'],
  [-18095484,-17905569,'Aquarius'],
  [-17905569,-17704123,'Pisces'],
  [-17704123,-17494009,'Aries'],
  [-17494009,-17278513,'Taurus'],
  [-17278513,-17060162,'Gemini'],
  [-17060162,-16842365,'Cancer'],
  [-16842365,-16630984,'Leo'],
  [-16630984,-16432144,'Virgo'],
  [-16432144,-16247902,'Libra'],
  [-16247902,-16074687,'Scorpio'],
  [-16074687,-15905362,'Sagittarius'],
  [-15905362,-15731945,'Capricorn'],
  [-15731945,-15547837,'Aquarius'],
  [-15547837,-15350138,'Pisces'],
  [-15350138,-15140746,'Aries'],
  [-15140746,-14924519,'Taurus'],
  [-14924519,-14706041,'Gemini'],
  [-14706041,-14488666,'Cancer'],
  [-14488666,-14276155,'Leo'],
  [-14276155,-14073211,'Virgo'],
  [-14073211,-13883129,'Libra'],
  [-13883129,-13705017,'Scorpio'],
  [-13705017,-13533775,'Sagittarius'],
  [-13533775,-13362147,'Capricorn'],
  [-13362147,-13182842,'Aquarius'],
  [-13182842,-12990698,'Pisces'],
  [-12990698,-12784901,'Aries'],
  [-12784901,-12569524,'Taurus'],
  [-12569524,-12351003,'Gemini'],
  [-12351003,-12134543,'Cancer'],
  [-12134543,-11923365,'Leo'],
  [-11923365,-11719877,'Virgo'],
  [-11719877,-11526045,'Libra'],
  [-11526045,-11342154,'Scorpio'],
  [-11342154,-11165646,'Sagittarius'],
  [-11165646,-10991450,'Capricorn'],
  [-10991450,-10813272,'Aquarius'],
  [-10813272,-10625256,'Pisces'],
  [-10625256,-10424136,'Aries'],
  [-10424136,-10211348,'Taurus'],
  [-10211348,-9993141,'Gemini'],
  [-9993141,-9777025,'Cancer'],
  [-9777025,-9567798,'Leo'],
  [-9567798,-9366861,'Virgo'],
  [-9366861,-9173685,'Libra'],
  [-9173685,-8987102,'Scorpio'],
  [-8987102,-8805405,'Sagittarius'],
  [-8805405,-8625914,'Capricorn'],
  [-8625914,-8444756,'Aquarius'],
  [-8444756,-8257267,'Pisces'],
  [-8257267,-8059319,'Aries'],
  [-8059319,-7849675,'Taurus'],
  [-7849675,-7632295,'Gemini'],
  [-7632295,-7415447,'Cancer'],
  [-7415447,-7206634,'Leo'],
  [-7206634,-7008508,'Virgo'],
  [-7008508,-6819193,'Libra'],
  [-6819193,-6634914,'Scorpio'],
  [-6634914,-6452185,'Sagittarius'],
  [-6452185,-6268648,'Capricorn'],
  [-6268648,-6082633,'Aquarius'],
  [-6082633,-5892083,'Pisces'],
  [-5892083,-5694138,'Aries'],
  [-5694138,-5486462,'Taurus'],
  [-5486462,-5270186,'Gemini'],
  [-5270186,-5051950,'Cancer'],
  [-5051950,-4841025,'Leo'],
  [-4841025,-4642972,'Virgo'],
  [-4642972,-4456889,'Libra'],
  [-4456889,-4277593,'Scorpio'],
  [-4277593,-4098993,'Sagittarius'],
  [-4098993,-3916485,'Capricorn'],
  [-3916485,-3728059,'Aquarius'],
  [-3728059,-3533578,'Pisces'],
  [-3533578,-3332864,'Aries'],
  [-3332864,-3124860,'Taurus'],
  [-3124860,-2909324,'Gemini'],
  [-2909324,-2690056,'Cancer'],
  [-2690056,-2475527,'Leo'],
  [-2475527,-2273842,'Virgo'],
  [-2273842,-2087020,'Libra'],
  [-2087020,-1910746,'Scorpio'],
  [-1910746,-1737761,'Sagittarius'],
  [-1737761,-1560972,'Capricorn'],
  [-1560972,-1375649,'Aquarius'],
  [-1375649,-1180611,'Pisces'],
  [-1180611,-977225,'Aries'],
  [-977225,-767127,'Taurus'],
  [-767127,-551309,'Gemini'],
  [-551309,-331916,'Cancer'],
  [-331916,-114715,'Leo'],
  [-114715,92284,'Virgo'],
  [92284,284147,'Libra'],
  [284147,462338,'Scorpio'],
  [462338,633118,'Sagittarius'],
  [633118,804327,'Capricorn'],
  [804327,982999,'Aquarius'],
  [982999,1173390,'Pisces'],
  [1173390,1375770,'Aries'],
  [1375770,1587277,'Taurus'],
  [1587277,1804204,'Gemini'],
  [1804204,2023336,'Cancer'],
  [2023336,2240805,'Leo'],
  [2240805,2451125,'Virgo'],
  [2451125,2649119,'Libra'],
  [2649119,2833366,'Scorpio'],
  [2833366,3007302,'Sagittarius'],
  [3007302,3177452,'Capricorn'],
  [3177452,3351186,'Aquarius'],
  [3351186,3534902,'Pisces'],
  [3534902,3732104,'Aries'],
  [3732104,3941870,'Taurus'],
  [3941870,4159298,'Gemini'],
  [4159298,4378450,'Cancer'],
  [4378450,4594688,'Leo'],
  [4594688,4804625,'Virgo'],
  [4804625,5005484,'Libra'],
  [5005484,5195653,'Scorpio'],
  [5195653,5376001,'Sagittarius'],
  [5376001,5550214,'Capricorn'],
  [5550214,5724004,'Aquarius'],
  [5724004,5903825,'Pisces'],
  [5903825,6095219,'Aries'],
  [6095219,6300480,'Taurus'],
  [6300480,6516490,'Gemini'],
  [6516490,6735777,'Cancer'],
  [6735777,6951089,'Leo'],
  [6951089,7158671,'Virgo'],
  [7158671,7357975,'Libra'],
  [7357975,7549710,'Scorpio'],
  [7549710,7734888,'Sagittarius'],
  [7734888,7915107,'Capricorn'],
  [7915107,8093290,'Aquarius'],
  [8093290,8274008,'Pisces'],
  [8274008,8462715,'Aries'],
  [8462715,8663697,'Taurus'],
  [8663697,8876879,'Gemini'],
  [8876879,9095916,'Cancer'],
  [9095916,9311508,'Leo'],
  [9311508,9517544,'Virgo'],
  [9517544,9713528,'Libra'],
  [9713528,9902381,'Scorpio'],
  [9902381,10087414,'Sagittarius'],
  [10087414,10270831,'Capricorn'],
  [10270831,10454004,'Aquarius'],
  [10454004,10638883,'Pisces'],
  [10638883,10828961,'Aries'],
  [10828961,11028399,'Taurus'],
  [11028399,11239168,'Gemini'],
  [11239168,11457586,'Cancer'],
  [11457586,11674498,'Leo'],
  [11674498,11881307,'Virgo'],
  [11881307,12075535,'Libra'],
  [12075535,12260426,'Scorpio'],
  [12260426,12441360,'Sagittarius'],
  [12441360,12622893,'Capricorn'],
  [12622893,12807478,'Aquarius'],
  [12807478,12996025,'Pisces'],
  [12996025,13189637,'Aries'],
  [13189637,13390520,'Taurus'],
  [13390520,13600659,'Gemini'],
  [13600659,13818553,'Cancer'],
  [13818553,14037088,'Leo'],
  [14037088,14246791,'Virgo'],
  [14246791,14442481,'Libra'],
  [14442481,14625779,'Scorpio'],
  [14625779,14802441,'Sagittarius'],
  [14802441,14978912,'Capricorn'],
  [14978912,15160100,'Aquarius'],
  [15160100,15348421,'Pisces'],
  [15348421,15544363,'Aries'],
  [15544363,15747912,'Taurus'],
  [15747912,15959191,'Gemini'],
  [15959191,16177060,'Cancer'],
  [16177060,16396692,'Leo'],
  [16396692,16609915,'Virgo'],
  [16609915,16809852,'Libra'],
  [16809852,16995404,'Scorpio'],
  [16995404,17170899,'Sagittarius'],
  [17170899,17343064,'Capricorn'],
  [17343064,17518560,'Aquarius'],
  [17518560,17702371,'Pisces'],
  [17702371,17896818,'Aries'],
  [17896818,18101549,'Taurus'],
  [18101549,18314492,'Gemini'],
  [18314492,18532869,'Cancer'],
  [18532869,18752698,'Leo'],
  [18752698,18968122,'Virgo'],
  [18968122,19172889,'Libra'],
  [19172889,19363737,'Scorpio'],
  [19363737,19542304,'Sagittarius'],
  [19542304,19713882,'Capricorn'],
  [19713882,19885280,'Aquarius'],
  [19885280,20063163,'Pisces'],
  [20063163,20252527,'Aries'],
  [20252527,20455069,'Taurus'],
  [20455069,20668376,'Gemini'],
  [20668376,20887372,'Cancer'],
  [20887372,21106802,'Leo'],
  [21106802,21322157,'Virgo'],
  [21322157,21529494,'Libra'],
  [21529494,21725761,'Scorpio'],
  [21725761,21910310,'Sagittarius'],
  [21910310,22085714,'Capricorn'],
  [22085714,22257204,'Aquarius'],
  [22257204,22431460,'Pisces'],
  [22431460,22615127,'Aries'],
  [22615127,22812697,'Taurus'],
  [22812697,23023854,'Gemini'],
  [23023854,23242817,'Cancer'],
  [23242817,23461892,'Leo'],
  [23461892,23675729,'Virgo'],
  [23675729,23882178,'Libra'],
  [23882178,24080505,'Scorpio'],
  [24080505,24270259,'Sagittarius'],
  [24270259,24451864,'Capricorn'],
  [24451864,24627770,'Aquarius'],
  [24627770,24802874,'Pisces'],
  [24802874,24983666,'Aries'],
  [24983666,25176296,'Taurus'],
  [25176296,25383398,'Gemini'],
  [25383398,25601045,'Cancer'],
  [25601045,25820187,'Leo'],
  [25820187,26032930,'Virgo'],
  [26032930,26236688,'Libra'],
  [26236688,26432793,'Scorpio'],
  [26432793,26623224,'Sagittarius'],
  [26623224,26808973,'Capricorn'],
  [26808973,26990701,'Aquarius'],
  [26990701,27170525,'Pisces'],
  [27170525,27352898,'Aries'],
  [27352898,27543603,'Taurus'],
  [27543603,27747042,'Gemini'],
  [27747042,27962351,'Cancer'],
  [27962351,28181732,'Leo'],
  [28181732,28395180,'Virgo'],
  [28395180,28597544,'Libra'],
  [28597544,28789980,'Scorpio'],
  [28789980,28976573,'Sagittarius'],
  [28976573,29160969,'Capricorn'],
  [29160969,29345018,'Aquarius'],
  [29345018,29529620,'Pisces'],
  [29529620,29716573,'Aries'],
  [29716573,29909341,'Taurus'],
  [29909341,30111793,'Gemini'],
  [30111793,30325073,'Cancer'],
  [30325073,30544367,'Leo'],
  [30544367,30760052,'Virgo'],
  [30760052,30964222,'Libra'],
  [30964222,31155531,'Scorpio'],
  [31155531,31337922,'Sagittarius'],
  [31337922,31517011,'Capricorn'],
  [31517011,31697503,'Aquarius'],
  [31697503,31882169,'Pisces'],
  [31882169,32072313,'Aries'],
  [32072313,32268971,'Taurus'],
  [32268971,32473470,'Gemini'],
  [32473470,32686432,'Cancer'],
  [32686432,32905317,'Leo'],
  [32905317,33123162,'Virgo'],
  [33123162,33331540,'Libra'],
  [33331540,33525979,'Scorpio'],
  [33525979,33707995,'Sagittarius'],
  [33707995,33882939,'Capricorn'],
  [33882939,34057243,'Aquarius'],
  [34057243,34236570,'Pisces'],
  [34236570,34424651,'Aries'],
  [34424651,34622744,'Taurus'],
  [34622744,34829989,'Gemini'],
  [34829989,35044406,'Cancer'],
  [35044406,35263167,'Leo'],
  [35263167,35481762,'Virgo'],
  [35481762,35693927,'Libra'],
  [35693927,35894027,'Scorpio'],
  [35894027,36080379,'Sagittarius'],
  [36080379,36255939,'Capricorn'],
  [36255939,36426710,'Aquarius'],
  [36426710,36599774,'Pisces'],
  [36599774,36781604,'Aries'],
  [36781604,36976223,'Taurus'],
  [36976223,37183486,'Gemini'],
  [37183486,37399362,'Cancer'],
  [37399362,37618588,'Leo'],
  [37618588,37836731,'Virgo'],
  [37836731,38050029,'Libra'],
  [38050029,38254529,'Scorpio'],
  [38254529,38447180,'Sagittarius'],
  [38447180,38627869,'Capricorn'],
  [38627869,38800235,'Aquarius'],
  [38800235,38970750,'Pisces'],
  [38970750,39146951,'Aries'],
  [39146951,39335397,'Taurus'],
  [39335397,39538838,'Gemini'],
  [39538838,39754039,'Cancer'],
  [39754039,39973671,'Leo'],
  [39973671,40191185,'Virgo'],
  [40191185,40403292,'Libra'],
  [40403292,40608482,'Scorpio'],
  [40608482,40805129,'Sagittarius'],
  [40805129,40991921,'Capricorn'],
  [40991921,41169693,'Aquarius'],
  [41169693,41342598,'Pisces'],
  [41342598,41517327,'Aries'],
  [41517327,41701199,'Taurus'],
  [41701199,41899396,'Gemini'],
  [41899396,42111502,'Cancer'],
  [42111502,42330598,'Leo'],
  [42330598,42547910,'Virgo'],
  [42547910,42758414,'Libra'],
  [42758414,42961424,'Scorpio'],
  [42961424,43157687,'Sagittarius'],
  [43157687,43347344,'Capricorn'],
  [43347344,43530388,'Aquarius'],
  [43530388,43708517,'Pisces'],
  [43708517,43886123,'Aries'],
  [43886123,44069433,'Taurus'],
  [44069433,44264269,'Gemini'],
  [44264269,44472701,'Cancer'],
  [44472701,44690264,'Leo'],
  [44690264,44907831,'Virgo'],
  [44907831,45117948,'Libra'],
  [45117948,45318600,'Scorpio'],
  [45318600,45511609,'Sagittarius'],
  [45511609,45699486,'Capricorn'],
  [45699486,45883873,'Aquarius'],
  [45883873,46066060,'Pisces'],
  [46066060,46248351,'Aries'],
  [46248351,46434644,'Taurus'],
  [46434644,46629520,'Gemini'],
  [46629520,46835837,'Cancer'],
  [46835837,47051707,'Leo'],
  [47051707,47269766,'Virgo'],
  [47269766,47481264,'Libra'],
  [47481264,47681658,'Scorpio'],
  [47681658,47871803,'Sagittarius'],
  [47871803,48055429,'Capricorn'],
  [48055429,48236585,'Aquarius'],
  [48236585,48418461,'Pisces'],
  [48418461,48603421,'Aries'],
  [48603421,48793589,'Taurus'],
  [48793589,48991160,'Gemini'],
  [48991160,49197792,'Cancer'],
  [49197792,49412767,'Leo'],
  [49412767,49631264,'Virgo'],
  [49631264,49845347,'Libra'],
  [49845347,50048330,'Scorpio'],
  [50048330,50238575,'Sagittarius'],
  [50238575,50419104,'Capricorn'],
  [50419104,50595238,'Aquarius'],
  [50595238,50772575,'Pisces'],
  [50772575,50955643,'Aries'],
  [50955643,51147084,'Taurus'],
  [51147084,51347520,'Gemini'],
  [51347520,51556191,'Cancer'],
  [51556191,51771471,'Leo'],
  [51771471,51990160,'Virgo'],
  [51990160,52206633,'Libra'],
  [52206633,52414029,'Scorpio'],
  [52414029,52608016,'Sagittarius'],
  [52608016,52789200,'Capricorn'],
  [52789200,52962336,'Aquarius'],
  [52962336,53134225,'Pisces'],
  [53134225,53311744,'Aries'],
  [53311744,53499981,'Taurus'],
  [53499981,53700459,'Gemini'],
  [53700459,53910895,'Cancer'],
  [53910895,54127295,'Leo'],
  [54127295,54345993,'Virgo'],
  [54345993,54563365,'Libra'],
  [54563365,54774523,'Scorpio'],
  [54774523,54974244,'Sagittarius'],
  [54974244,55160193,'Capricorn'],
  [55160193,55334759,'Aquarius'],
  [55334759,55504153,'Pisces'],
  [55504153,55676231,'Aries'],
  [55676231,55858358,'Taurus'],
  [55858358,56054812,'Gemini'],
  [56054812,56264436,'Cancer'],
  [56264436,56481610,'Leo'],
  [56481610,56700382,'Virgo'],
  [56700382,56917099,'Libra'],
  [56917099,57129160,'Scorpio'],
  [57129160,57333077,'Sagittarius'],
  [57333077,57525398,'Capricorn'],
  [57525398,57705552,'Aquarius'],
  [57705552,57877355,'Pisces'],
  [57877355,58047822,'Aries'],
  [58047822,58224976,'Taurus'],
  [58224976,58415383,'Gemini'],
  [58415383,58620923,'Cancer'],
  [58620923,58837080,'Leo'],
  [58837080,59055977,'Virgo'],
  [59055977,59271723,'Libra'],
  [59271723,59482053,'Scorpio'],
  [59482053,59685970,'Sagittarius'],
  [59685970,59881825,'Capricorn'],
  [59881825,60068162,'Aquarius'],
  [60068162,60246028,'Pisces'],
  [60246028,60419893,'Aries'],
  [60419893,60596505,'Taurus'],
  [60596505,60782815,'Gemini'],
  [60782815,60983144,'Cancer'],
  [60983144,61196147,'Leo'],
  [61196147,61414657,'Virgo'],
  [61414657,61630374,'Libra'],
  [61630374,61838860,'Scorpio'],
  [61838860,62039712,'Sagittarius'],
  [62039712,62233914,'Capricorn'],
  [62233914,62422133,'Aquarius'],
  [62422133,62605099,'Pisces'],
  [62605099,62784903,'Aries'],
  [62784903,62965555,'Taurus'],
  [62965555,63152271,'Gemini'],
  [63152271,63349666,'Cancer'],
  [63349666,63559063,'Leo'],
  [63559063,63776294,'Virgo'],
  [63776294,63992982,'Libra'],
  [63992982,64201804,'Scorpio'],
  [64201804,64400315,'Sagittarius'],
  [64400315,64590224,'Capricorn'],
  [64590224,64774879,'Aquarius'],
  [64774879,64957475,'Pisces'],
  [64957475,65140540,'Aries'],
  [65140540,65326257,'Taurus'],
  [65326257,65517003,'Gemini'],
  [65517003,65715374,'Cancer'],
  [65715374,65923086,'Leo'],
  [65923086,66138787,'Virgo'],
  [66138787,66356553,'Libra'],
  [66356553,66568039,'Scorpio'],
  [66568039,66767635,'Sagittarius'],
  [66767635,66955210,'Capricorn'],
  [66955210,67134858,'Aquarius'],
  [67134858,67312296,'Pisces'],
  [67312296,67492732,'Aries'],
  [67492732,67679537,'Taurus'],
  [67679537,67873880,'Gemini'],
  [67873880,68075591,'Cancer'],
  [68075591,68284358,'Leo'],
  [68284358,68499430,'Virgo'],
  [68499430,68717671,'Libra'],
  [68717671,68932396,'Scorpio'],
  [68932396,69136197,'Sagittarius'],
  [69136197,69325768,'Capricorn'],
  [69325768,69503590,'Aquarius'],
  [69503590,69676004,'Pisces'],
  [69676004,69850379,'Aries'],
  [69850379,70032838,'Taurus'],
  [70032838,70226336,'Gemini'],
  [70226336,70430019,'Cancer'],
  [70430019,70641016,'Leo'],
  [70641016,70856757,'Virgo'],
  [70856757,71074972,'Libra'],
  [71074972,71291571,'Scorpio'],
  [71291571,71500041,'Sagittarius'],
  [71500041,71694883,'Capricorn'],
  [71694883,71875586,'Aquarius'],
  [71875586,72047037,'Pisces'],
  [72047037,72216939,'Aries'],
  [72216939,72393166,'Taurus'],
  [72393166,72581441,'Gemini'],
  [72581441,72783055,'Cancer'],
  [72783055,72994729,'Leo'],
  [72994729,73211522,'Virgo'],
  [73211522,73429676,'Libra'],
  [73429676,73646261,'Scorpio'],
  [73646261,73857112,'Sagittarius'],
  [73857112,74057150,'Capricorn'],
  [74057150,74243637,'Aquarius'],
  [74243637,74418715,'Pisces'],
  [74418715,74588611,'Aries'],
  [74588611,74761180,'Taurus'],
  [74761180,74943631,'Gemini'],
  [74943631,75140051,'Cancer'],
  [75140051,75349373,'Leo'],
  [75349373,75566166,'Virgo'],
  [75566166,75784354,'Libra'],
  [75784354,75999929,'Scorpio'],
  [75999929,76210184,'Sagittarius'],
  [76210184,76412258,'Capricorn'],
  [76412258,76603693,'Aquarius'],
  [76603693,76784588,'Pisces'],
  [76784588,76958613,'Aries'],
  [76958613,77131978,'Taurus'],
  [77131978,77311607,'Gemini'],
  [77311607,77503044,'Cancer'],
  [77503044,77708054,'Leo'],
  [77708054,77923148,'Virgo'],
  [77923148,78141267,'Libra'],
  [78141267,78356078,'Scorpio'],
  [78356078,78564257,'Sagittarius'],
  [78564257,78764710,'Capricorn'],
  [78764710,78957203,'Aquarius'],
  [78957203,79142212,'Pisces'],
  [79142212,79321681,'Aries'],
  [79321681,79499352,'Taurus'],
  [79499352,79680292,'Gemini'],
  [79680292,79869686,'Cancer'],
  [79869686,80070933,'Leo'],
  [80070933,80283339,'Virgo'],
  [80283339,80501115,'Libra'],
  [80501115,80716204,'Scorpio'],
  [80716204,80923035,'Sagittarius'],
  [80923035,81120374,'Capricorn'],
  [81120374,81310003,'Aquarius'],
  [81310003,81494675,'Pisces'],
  [81494675,81677000,'Aries'],
  [81677000,81859374,'Taurus'],
  [81859374,82044428,'Gemini'],
  [82044428,82235351,'Cancer'],
  [82235351,82435299,'Leo'],
  [82435299,82645491,'Virgo'],
  [82645491,82862718,'Libra'],
  [82862718,83079182,'Scorpio'],
  [83079182,83286894,'Sagittarius'],
  [83286894,83482577,'Capricorn'],
  [83482577,83668265,'Aquarius'],
  [83668265,83848796,'Pisces'],
  [83848796,84029153,'Aries'],
  [84029153,84212839,'Taurus'],
  [84212839,84401532,'Gemini'],
  [84401532,84596026,'Cancer'],
  [84596026,84797454,'Leo'],
  [84797454,85007041,'Virgo'],
  [85007041,85223782,'Libra'],
  [85223782,85442001,'Scorpio'],
  [85442001,85652870,'Sagittarius'],
  [85652870,85850244,'Capricorn'],
  [85850244,86034369,'Aquarius'],
  [86034369,86210488,'Pisces'],
  [86210488,86385557,'Aries'],
  [86385557,86565606,'Taurus'],
  [86565606,86753946,'Gemini'],
  [86753946,86950802,'Cancer'],
  [86950802,87154979,'Leo'],
  [87154979,87365725,'Virgo'],
  [87365725,87582373,'Libra'],
  [87582373,87801683,'Scorpio'],
  [87801683,88016348,'Sagittarius'],
  [88016348,88218507,'Capricorn'],
  [88218507,88405350,'Aquarius'],
  [88405350,88580482,'Pisces'],
  [88580482,88751130,'Aries'],
  [88751130,88925065,'Taurus'],
  [88925065,89108324,'Gemini'],
  [89108324,89303291,'Cancer'],
  [89303291,89508561,'Leo'],
  [89508561,89721074,'Virgo'],
  [89721074,89938242,'Libra'],
  [89938242,90157552,'Scorpio'],
  [90157552,90374274,'Sagittarius'],
  [90374274,90581570,'Capricorn'],
  [90581570,90774471,'Aquarius'],
  [90774471,90953504,'Pisces'],
  [90953504,91124171,'Aries'],
  [91124171,91294165,'Taurus'],
  [91294165,91471017,'Gemini'],
  [91471017,91660032,'Cancer'],
  [91660032,91862398,'Leo'],
  [91862398,92075062,'Virgo'],
  [92075062,92292999,'Libra'],
  [92292999,92511867,'Scorpio'],
  [92511867,92728039,'Sagittarius'],
  [92728039,92937367,'Capricorn'],
  [92937367,93135731,'Aquarius'],
  [93135731,93321516,'Pisces'],
  [93321516,93497176,'Aries'],
  [93497176,93668379,'Taurus'],
  [93668379,93842158,'Gemini'],
  [93842158,94025158,'Cancer'],
  [94025158,94221626,'Leo'],
  [94221626,94431316,'Virgo'],
  [94431316,94649082,'Libra'],
  [94649082,94867883,'Scorpio'],
  [94867883,95082457,'Sagittarius'],
  [95082457,95290077,'Capricorn'],
  [95290077,95489413,'Aquarius'],
  [95489413,95679864,'Pisces'],
  [95679864,95862151,'Aries'],
  [95862151,96038978,'Taurus'],
  [96038978,96214988,'Gemini'],
  [96214988,96395997,'Cancer'],
  [96395997,96587528,'Leo'],
  [96587528,96792448,'Virgo'],
  [96792448,97008274,'Libra'],
  [97008274,97227288,'Scorpio'],
  [97227288,97441316,'Sagittarius'],
  [97441316,97646289,'Capricorn'],
  [97646289,97842504,'Aquarius'],
  [97842504,98032159,'Pisces'],
  [98032159,98217378,'Aries'],
  [98217378,98399795,'Taurus'],
  [98399795,98581321,'Gemini'],
  [98581321,98765152,'Cancer'],
  [98765152,98955772,'Leo'],
  [98955772,99157307,'Virgo'],
  [99157307,99370348,'Libra'],
  [99370348,99589267,'Scorpio'],
  [99589267,99804438,'Sagittarius'],
  [99804438,100008850,'Capricorn'],
  [100008850,100201802,'Aquarius'],
  [100201802,100387109,'Pisces'],
  [100387109,100569590,'Aries'],
  [100569590,100752736,'Taurus'],
  [100752736,100938140,'Gemini'],
  [100938140,101126670,'Cancer'],
  [101126670,101320167,'Leo'],
  [101320167,101521615,'Virgo'],
  [101521615,101732927,'Libra'],
  [101732927,101951380,'Scorpio'],
  [101951380,102168545,'Sagittarius'],
  [102168545,102375269,'Capricorn'],
  [102375269,102568080,'Aquarius'],
  [102568080,102750056,'Pisces'],
  [102750056,102927419,'Aries'],
  [102927419,103106194,'Taurus'],
  [103106194,103290221,'Gemini'],
  [103290221,103480727,'Cancer'],
  [103480727,103677692,'Leo'],
  [103677692,103881558,'Virgo'],
  [103881558,104093163,'Libra'],
  [104093163,104311287,'Scorpio'],
  [104311287,104530064,'Sagittarius'],
  [104530064,104740589,'Capricorn'],
  [104740589,104936828,'Aquarius'],
  [104936828,105119362,'Pisces'],
  [105119362,105293755,'Aries'],
  [105293755,105467136,'Taurus'],
  [105467136,105645728,'Gemini'],
  [105645728,105833275,'Cancer'],
  [105833275,106030608,'Leo'],
  [106030608,106236654,'Virgo'],
  [106236654,106449837,'Libra'],
  [106449837,106668156,'Scorpio'],
  [106668156,106887494,'Sagittarius'],
  [106887494,107101075,'Capricorn'],
  [107101075,107302353,'Aquarius'],
  [107302353,107489218,'Pisces'],
  [107489218,107664943,'Aries'],
  [107664943,107835927,'Taurus'],
  [107835927,108009249,'Gemini'],
  [108009249,108190929,'Cancer'],
  [108190929,108384462,'Leo'],
  [108384462,108589874,'Virgo'],
  [108589874,108804140,'Libra'],
  [108804140,109022997,'Scorpio'],
  [109022997,109242018,'Sagittarius'],
  [109242018,109456425,'Capricorn'],
  [109456425,109661411,'Aquarius'],
  [109661411,109853928,'Pisces'],
  [109853928,110034606,'Aries'],
  [110034606,110207612,'Taurus'],
  [110207612,110379165,'Gemini'],
  [110379165,110556007,'Cancer'],
  [110556007,110743863,'Leo'],
  [110743863,110945463,'Virgo'],
  [110945463,111158806,'Libra'],
  [111158806,111377939,'Scorpio'],
  [111377939,111596406,'Sagittarius'],
  [111596406,111809655,'Capricorn'],
  [111809655,112015099,'Aquarius'],
  [112015099,112211184,'Pisces'],
  [112211184,112397543,'Aries'],
  [112397543,112575806,'Taurus'],
  [112575806,112749912,'Gemini'],
  [112749912,112925626,'Cancer'],
  [112925626,113109343,'Leo'],
  [113109343,113306053,'Virgo'],
  [113306053,113516407,'Libra'],
  [113516407,113734987,'Scorpio'],
  [113734987,113953245,'Sagittarius'],
  [113953245,114164905,'Capricorn'],
  [114164905,114368126,'Aquarius'],
  [114368126,114563715,'Pisces'],
  [114563715,114752788,'Aries'],
  [114752788,114936211,'Taurus'],
  [114936211,115115538,'Gemini'],
  [115115538,115294171,'Cancer'],
  [115294171,115477403,'Leo'],
  [115477403,115670905,'Virgo'],
  [115670905,115877732,'Libra'],
  [115877732,116094876,'Scorpio'],
  [116094876,116313480,'Sagittarius'],
  [116313480,116524788,'Capricorn'],
  [116524788,116725581,'Aquarius'],
  [116725581,116917773,'Pisces'],
  [116917773,117104916,'Aries'],
  [117104916,117289607,'Taurus'],
  [117289607,117473060,'Gemini'],
  [117473060,117656520,'Cancer'],
  [117656520,117842839,'Leo'],
  [117842839,118036431,'Virgo'],
  [118036431,118241154,'Libra'],
  [118241154,118456620,'Scorpio'],
  [118456620,118675854,'Sagittarius'],
  [118675854,118888803,'Capricorn'],
  [118888803,119089507,'Aquarius'],
  [119089507,119278786,'Pisces'],
  [119278786,119461401,'Aries'],
  [119461401,119642447,'Taurus'],
  [119642447,119825294,'Gemini'],
  [119825294,120011411,'Cancer'],
  [120011411,120201802,'Leo'],
  [120201802,120398346,'Virgo'],
  [120398346,120603519,'Libra'],
  [120603519,120818024,'Scorpio'],
  [120818024,121037655,'Sagittarius'],
  [121037655,121253483,'Capricorn'],
  [121253483,121457363,'Aquarius'],
  [121457363,121647261,'Pisces'],
  [121647261,121826947,'Aries'],
  [121826947,122002610,'Taurus'],
  [122002610,122180148,'Gemini'],
  [122180148,122363640,'Cancer'],
  [122363640,122554966,'Leo'],
  [122554966,122754508,'Virgo'],
  [122754508,122962087,'Libra'],
  [122962087,123177032,'Scorpio'],
  [123177032,123396622,'Sagittarius'],
  [123396622,123614687,'Capricorn'],
  [123614687,123823424,'Aquarius'],
  [123823424,124018040,'Pisces'],
  [124018040,124199406,'Aries'],
  [124199406,124372629,'Taurus'],
  [124372629,124544475,'Gemini'],
  [124544475,124721472,'Cancer'],
  [124721472,124908457,'Leo'],
  [124908457,125107321,'Virgo'],
  [125107321,125316671,'Libra'],
  [125316671,125533075,'Scorpio'],
  [125533075,125752629,'Sagittarius'],
  [125752629,125971019,'Capricorn'],
  [125971019,126183063,'Aquarius'],
  [126183063,126383776,'Pisces'],
  [126383776,126571092,'Aries'],
  [126571092,126747167,'Taurus'],
  [126747167,126917495,'Gemini'],
  [126917495,127089192,'Cancer'],
  [127089192,127269331,'Leo'],
  [127269331,127462943,'Virgo'],
  [127462943,127670584,'Libra'],
  [127670584,127887689,'Scorpio'],
  [127887689,128107569,'Sagittarius'],
  [128107569,128325040,'Capricorn'],
  [128325040,128537027,'Aquarius'],
  [128537027,128740986,'Pisces'],
  [128740986,128934590,'Aries'],
  [128934590,129117219,'Taurus'],
  [129117219,129291395,'Gemini'],
  [129291395,129462743,'Cancer'],
  [129462743,129638579,'Leo'],
  [129638579,129825917,'Virgo'],
  [129825917,130028520,'Libra'],
  [130028520,130243836,'Scorpio'],
  [130243836,130463839,'Sagittarius'],
  [130463839,130680637,'Capricorn'],
  [130680637,130890632,'Aquarius'],
  [130890632,131093478,'Pisces'],
  [131093478,131289197,'Aries'],
  [131289197,131477243,'Taurus'],
  [131477243,131657793,'Gemini'],
  [131657793,131833586,'Cancer'],
  [131833586,132010188,'Leo'],
  [132010188,132194504,'Virgo'],
  [132194504,132392143,'Libra'],
  [132392143,132603736,'Scorpio'],
  [132603736,132822857,'Sagittarius'],
  [132822857,133039828,'Capricorn'],
  [133039828,133248514,'Aquarius'],
  [133248514,133448371,'Pisces'],
  [133448371,133641573,'Aries'],
  [133641573,133829970,'Taurus'],
  [133829970,134014316,'Gemini'],
  [134014316,134195600,'Cancer'],
  [134195600,134376702,'Leo'],
  [134376702,134562530,'Virgo'],
  [134562530,134758365,'Libra'],
  [134758365,134966745,'Scorpio'],
  [134966745,135184214,'Sagittarius'],
  [135184214,135401860,'Capricorn'],
  [135401860,135611256,'Aquarius'],
  [135611256,135809587,'Pisces'],
  [135809587,135999054,'Aries'],
  [135999054,136183572,'Taurus'],
  [136183572,136366388,'Gemini'],
  [136366388,136549561,'Cancer'],
  [136549561,136734842,'Leo'],
  [136734842,136924689,'Virgo'],
  [136924689,137122246,'Libra'],
  [137122246,137329769,'Scorpio'],
  [137329769,137545897,'Sagittarius'],
  [137545897,137764211,'Capricorn'],
  [137764211,137976002,'Aquarius'],
  [137976002,138175807,'Pisces'],
  [138175807,138363857,'Aries'],
  [138363857,138544218,'Taurus'],
  [138544218,138722103,'Gemini'],
  [138722103,138902116,'Cancer'],
  [138902116,139087496,'Leo'],
  [139087496,139280101,'Virgo'],
  [139280101,139480800,'Libra'],
  [139480800,139689746,'Scorpio'],
  [139689746,139905636,'Sagittarius'],
  [139905636,140124316,'Capricorn'],
  [140124316,140338859,'Aquarius'],
  [140338859,140542563,'Pisces'],
  [140542563,140732879,'Aries'],
  [140732879,140912147,'Taurus'],
  [140912147,141085794,'Gemini'],
  [141085794,141260245,'Cancer'],
  [141260245,141441277,'Leo'],
  [141441277,141632575,'Virgo'],
  [141632575,141834745,'Libra'],
  [141834745,142045737,'Scorpio'],
  [142045737,142262402,'Sagittarius'],
  [142262402,142481132,'Capricorn'],
  [142481132,142697320,'Aquarius'],
  [142697320,142905285,'Pisces'],
  [142905285,143100613,'Aries'],
  [143100613,143282870,'Taurus'],
  [143282870,143455920,'Gemini'],
  [143455920,143626382,'Cancer'],
  [143626382,143801656,'Leo'],
  [143801656,143987956,'Virgo'],
  [143987956,144187961,'Libra'],
  [144187961,144399435,'Scorpio'],
  [144399435,144617031,'Sagittarius'],
  [144617031,144835684,'Capricorn'],
  [144835684,145051818,'Aquarius'],
  [145051818,145262025,'Pisces'],
  [145262025,145462375,'Aries'],
  [145462375,145650328,'Taurus'],
  [145650328,145827021,'Gemini'],
  [145827021,145997557,'Cancer'],
  [145997557,146169369,'Leo'],
  [146169369,146350119,'Virgo'],
  [146350119,146545095,'Libra'],
  [146545095,146754227,'Scorpio'],
  [146754227,146971762,'Sagittarius'],
  [146971762,147190376,'Capricorn'],
  [147190376,147405431,'Aquarius'],
  [147405431,147614970,'Pisces'],
  [147614970,147817310,'Aries'],
  [147817310,148010262,'Taurus'],
  [148010262,148192909,'Gemini'],
  [148192909,148367680,'Cancer'],
  [148367680,148540355,'Leo'],
  [148540355,148718359,'Virgo'],
  [148718359,148908390,'Libra'],
  [148908390,149113175,'Scorpio'],
  [149113175,149328977,'Sagittarius'],
  [149328977,149547542,'Capricorn'],
  [149547542,149761821,'Aquarius'],
  [149761821,149969165,'Pisces'],
  [149969165,150169675,'Aries'],
  [150169675,150363528,'Taurus'],
  [150363528,150550382,'Gemini'],
  [150550382,150730899,'Cancer'],
  [150730899,150908230,'Leo'],
  [150908230,151087841,'Virgo'],
  [151087841,151275936,'Libra'],
  [151275936,151476815,'Scorpio'],
  [151476815,151689729,'Sagittarius'],
  [151689729,151907961,'Capricorn'],
  [151907961,152122749,'Aquarius'],
  [152122749,152328901,'Pisces'],
  [152328901,152526124,'Aries'],
  [152526124,152716600,'Taurus'],
  [152716600,152902591,'Gemini'],
  [152902591,153085805,'Cancer'],
  [153085805,153268119,'Leo'],
  [153268119,153452423,'Virgo'],
  [153452423,153642602,'Libra'],
  [153642602,153842348,'Scorpio'],
  [153842348,154052810,'Sagittarius'],
  [154052810,154270276,'Capricorn'],
  [154270276,154486699,'Aquarius'],
  [154486699,154694370,'Pisces'],
  [154694370,154890415,'Aries'],
  [154890415,155076800,'Taurus'],
  [155076800,155257856,'Gemini'],
  [155257856,155438099,'Cancer'],
  [155438099,155621058,'Leo'],
  [155621058,155809001,'Virgo'],
  [155809001,156003342,'Libra'],
  [156003342,156205203,'Scorpio'],
  [156205203,156415202,'Sagittarius'],
  [156415202,156631854,'Capricorn'],
  [156631854,156849868,'Aquarius'],
  [156849868,157061277,'Pisces'],
  [157061277,157260111,'Aries'],
  [157260111,157445808,'Taurus'],
  [157445808,157622550,'Gemini'],
  [157622550,157796758,'Cancer'],
  [157796758,157974797,'Leo'],
  [157974797,158161192,'Virgo'],
  [158161192,158357448,'Libra'],
  [158357448,158562402,'Scorpio'],
  [158562402,158774054,'Sagittarius'],
  [158774054,158990596,'Capricorn'],
  [158990596,159209170,'Aquarius'],
  [159209170,159424108,'Pisces'],
  [159424108,159628393,'Aries'],
  [159628393,159818136,'Taurus'],
  [159818136,159995105,'Gemini'],
  [159995105,160165495,'Cancer'],
  [160165495,160337177,'Leo'],
  [160337177,160517368,'Virgo'],
  [160517368,160710313,'Libra'],
  [160710313,160915539,'Scorpio'],
  [160915539,161128986,'Sagittarius'],
  [161128986,161346337,'Capricorn'],
  [161346337,161564667,'Aquarius'],
  [161564667,161780807,'Pisces'],
  [161780807,161989577,'Aries'],
  [161989577,162185705,'Taurus'],
  [162185705,162367716,'Gemini'],
  [162367716,162539492,'Cancer'],
  [162539492,162708398,'Leo'],
  [162708398,162882669,'Virgo'],
  [162882669,163069073,'Libra'],
  [163069073,163270163,'Scorpio'],
  [163270163,163482868,'Sagittarius'],
  [163482868,163700901,'Capricorn'],
  [163700901,163919012,'Aquarius'],
  [163919012,164134261,'Pisces'],
  [164134261,164343936,'Aries'],
  [164343936,164544371,'Taurus'],
  [164544371,164732814,'Gemini'],
  [164732814,164910195,'Cancer'],
  [164910195,165081564,'Leo'],
  [165081564,165254250,'Virgo'],
  [165254250,165435665,'Libra'],
  [165435665,165630830,'Scorpio'],
  [165630830,165839745,'Sagittarius'],
  [165839745,166056951,'Capricorn'],
  [166056951,166275068,'Aquarius'],
  [166275068,166489090,'Pisces'],
  [166489090,166696855,'Aries'],
  [166696855,166897154,'Taurus'],
  [166897154,167088848,'Gemini'],
  [167088848,167271950,'Cancer'],
  [167271950,167448950,'Leo'],
  [167448950,167624778,'Virgo'],
  [167624778,167805591,'Libra'],
  [167805591,167996933,'Scorpio'],
  [167996933,168201330,'Sagittarius'],
  [168201330,168416144,'Capricorn'],
  [168416144,168634153,'Aquarius'],
  [168634153,168847934,'Pisces'],
  [168847934,169053619,'Aries'],
  [169053619,169250875,'Taurus'],
  [169250875,169441046,'Gemini'],
  [169441046,169625862,'Cancer'],
  [169625862,169807366,'Leo'],
  [169807366,169988327,'Virgo'],
  [169988327,170172429,'Libra'],
  [170172429,170363809,'Scorpio'],
  [170363809,170565639,'Sagittarius'],
  [170565639,170777877,'Capricorn'],
  [170777877,170995520,'Aquarius'],
  [170995520,171210332,'Pisces'],
  [171210332,171415838,'Aries'],
  [171415838,171610424,'Taurus'],
  [171610424,171796567,'Gemini'],
  [171796567,171978436,'Cancer'],
  [171978436,172159959,'Leo'],
  [172159959,172343961,'Virgo'],
  [172343961,172532306,'Libra'],
  [172532306,172726657,'Scorpio'],
  [172726657,172928848,'Sagittarius'],
  [172928848,173139772,'Capricorn'],
  [173139772,173356994,'Aquarius'],
  [173356994,173573597,'Pisces'],
  [173573597,173781353,'Aries'],
  [173781353,173976048,'Taurus'],
  [173976048,174159280,'Gemini'],
  [174159280,174336426,'Cancer'],
  [174336426,174513731,'Leo'],
  [174513731,174696131,'Virgo'],
  [174696131,174886019,'Libra'],
  [174886019,175083503,'Scorpio'],
  [175083503,175288022,'Sagittarius'],
  [175288022,175499366,'Capricorn'],
  [175499366,175716401,'Aquarius'],
  [175716401,175934590,'Pisces'],
  [175934590,176146036,'Aries'],
  [176146036,176344115,'Taurus'],
  [176344115,176527973,'Gemini'],
  [176527973,176702346,'Cancer'],
  [176702346,176874557,'Leo'],
  [176874557,177051738,'Virgo'],
  [177051738,177238663,'Libra'],
  [177238663,177436351,'Scorpio'],
  [177436351,177642859,'Sagittarius'],
  [177642859,177855683,'Capricorn'],
  [177855683,178072925,'Aquarius'],
  [178072925,178291717,'Pisces'],
  [178291717,178506248,'Aries'],
  [178506248,178709435,'Taurus'],
  [178709435,178897699,'Gemini'],
  [178897699,179073457,'Cancer'],
  [179073457,179243373,'Leo'],
  [179243373,179415406,'Virgo'],
  [179415406,179596488,'Libra'],
  [179596488,179790299,'Scorpio'],
  [179790299,179996056,'Sagittarius'],
  [179996056,180209884,'Capricorn'],
  [180209884,180427628,'Aquarius'],
  [180427628,180646059,'Pisces'],
  [180646059,180861369,'Aries'],
  [180861369,181068339,'Taurus'],
  [181068339,181262535,'Gemini'],
  [181262535,181443587,'Cancer'],
  [181443587,181615825,'Leo'],
  [181615825,181786289,'Virgo'],
  [181786289,181962491,'Libra'],
  [181962491,182150351,'Scorpio'],
  [182150351,182351997,'Sagittarius'],
  [182351997,182564754,'Capricorn'],
  [182564754,182782820,'Aquarius'],
  [182782820,183000699,'Pisces'],
  [183000699,183214647,'Aries'],
  [183214647,183421773,'Taurus'],
  [183421773,183619490,'Gemini'],
  [183619490,183806598,'Cancer'],
  [183806598,183984747,'Leo'],
  [183984747,184158455,'Virgo'],
  [184158455,184333936,'Libra'],
  [184333936,184517549,'Scorpio'],
  [184517549,184713830,'Sagittarius'],
  [184713830,184923154,'Capricorn'],
  [184923154,185140613,'Aquarius'],
  [185140613,185358519,'Pisces'],
  [185358519,185570906,'Aries'],
  [185570906,185775348,'Taurus'],
  [185775348,185971853,'Gemini'],
  [185971853,186161244,'Cancer'],
  [186161244,186344747,'Leo'],
  [186344747,186524454,'Virgo'],
  [186524454,186703815,'Libra'],
  [186703815,186887546,'Scorpio'],
  [186887546,187080594,'Sagittarius'],
  [187080594,187285912,'Capricorn'],
  [187285912,187501569,'Aquarius'],
  [187501569,187720049,'Pisces'],
  [187720049,187932624,'Aries'],
  [187932624,188134793,'Taurus'],
  [188134793,188327318,'Gemini'],
  [188327318,188513692,'Cancer'],
  [188513692,188697458,'Leo'],
  [188697458,188880969,'Virgo'],
  [188880969,189065678,'Libra'],
  [189065678,189253423,'Scorpio'],
  [189253423,189447273,'Sagittarius'],
  [189447273,189650604,'Capricorn'],
  [189650604,189864197,'Aquarius'],
  [189864197,190083132,'Pisces'],
  [190083132,190297909,'Aries'],
  [190297909,190500891,'Taurus'],
  [190500891,190690998,'Gemini'],
  [190690998,190872526,'Cancer'],
  [190872526,191051518,'Leo'],
  [191051518,191232955,'Virgo'],
  [191232955,191419337,'Libra'],
  [191419337,191611102,'Scorpio'],
  [191611102,191808526,'Sagittarius'],
  [191808526,192012986,'Capricorn'],
  [192012986,192225747,'Aquarius'],
  [192225747,192444660,'Pisces'],
  [192444660,192662172,'Aries'],
  [192662172,192869027,'Taurus'],
  [192869027,193060921,'Gemini'],
  [193060921,193240516,'Cancer'],
  [193240516,193414453,'Leo'],
  [193414453,193589885,'Virgo'],
  [193589885,193772147,'Libra'],
  [193772147,193963426,'Scorpio'],
  [193963426,194163236,'Sagittarius'],
  [194163236,194370361,'Capricorn'],
  [194370361,194584067,'Aquarius'],
  [194584067,194802873,'Pisces'],
  [194802873,195021932,'Aries'],
  [195021932,195233225,'Taurus'],
  [195233225,195430321,'Gemini'],
  [195430321,195612792,'Cancer'],
  [195612792,195785708,'Leo'],
  [195785708,195956472,'Virgo'],
  [195956472,196132250,'Libra'],
  [196132250,196318146,'Scorpio'],
  [196318146,196515894,'Sagittarius'],
  [196515894,196723972,'Capricorn'],
  [196723972,196939198,'Aquarius'],
  [196939198,197158281,'Pisces'],
  [197158281,197377334,'Aries'],
  [197377334,197590901,'Taurus'],
  [197590901,197793241,'Gemini'],
  [197793241,197981683,'Cancer'],
  [197981683,198158405,'Leo'],
  [198158405,198329144,'Virgo'],
  [198329144,198500993,'Libra'],
  [198500993,198680646,'Scorpio'],
  [198680646,198872739,'Sagittarius'],
  [198872739,199078150,'Capricorn'],
  [199078150,199293459,'Aquarius'],
  [199293459,199512949,'Pisces'],
  [199512949,199731302,'Aries'],
  [199731302,199944372,'Taurus'],
  [199944372,200148836,'Gemini'],
  [200148836,200342442,'Cancer'],
  [200342442,200525296,'Leo'],
  [200525296,200700401,'Virgo'],
  [200700401,200873044,'Libra'],
  [200873044,201049641,'Scorpio'],
  [201049641,201236299,'Sagittarius'],
  [201236299,201436742,'Capricorn'],
  [201436742,201649805,'Aquarius'],
  [201649805,201869133,'Pisces'],
  [201869133,202086988,'Aries'],
  [202086988,202298283,'Taurus'],
  [202298283,202501350,'Gemini'],
  [202501350,202696232,'Cancer'],
  [202696232,202883476,'Leo'],
  [202883476,203064331,'Virgo'],
  [203064331,203241479,'Libra'],
  [203241479,203419433,'Scorpio'],
  [203419433,203603925,'Sagittarius'],
  [203603925,203800143,'Capricorn'],
  [203800143,204009710,'Aquarius'],
  [204009710,204228001,'Pisces'],
  [204228001,204445948,'Aries'],
  [204445948,204656122,'Taurus'],
  [204656122,204856437,'Gemini'],
  [204856437,205048801,'Cancer'],
  [205048801,205236005,'Leo'],
  [205236005,205419999,'Virgo'],
  [205419999,205602093,'Libra'],
  [205602093,205784338,'Scorpio'],
  [205784338,205970506,'Sagittarius'],
  [205970506,206165387,'Capricorn'],
  [206165387,206372207,'Aquarius'],
  [206372207,206589009,'Pisces'],
  [206589009,206807571,'Aries'],
  [206807571,207018424,'Taurus'],
  [207018424,207217328,'Gemini'],
  [207217328,207406181,'Cancer'],
  [207406181,207589672,'Leo'],
  [207589672,207772065,'Virgo'],
  [207772065,207955766,'Libra'],
  [207955766,208141864,'Scorpio'],
  [208141864,208331833,'Sagittarius'],
  [208331833,208528446,'Capricorn'],
  [208528446,208734625,'Aquarius'],
  [208734625,208950300,'Pisces'],
  [208950300,209169604,'Aries'],
  [209169604,209382866,'Taurus'],
  [209382866,209583267,'Gemini'],
  [209583267,209770788,'Cancer'],
  [209770788,209950274,'Leo'],
  [209950274,210127827,'Virgo'],
  [210127827,210308329,'Libra'],
  [210308329,210494408,'Scorpio'],
  [210494408,210686993,'Sagittarius'],
  [210686993,210886679,'Capricorn'],
  [210886679,211094325,'Aquarius'],
  [211094325,211309841,'Pisces'],
  [211309841,211529567,'Aries'],
  [211529567,211745684,'Taurus'],
  [211745684,211950203,'Gemini'],
  [211950203,212140227,'Cancer'],
  [212140227,212318814,'Leo'],
  [212318814,212492178,'Virgo'],
  [212492178,212666945,'Libra'],
  [212666945,212848406,'Scorpio'],
  [212848406,213039471,'Sagittarius'],
  [213039471,213240558,'Capricorn'],
  [213240558,213450348,'Aquarius'],
  [213450348,213666709,'Pisces'],
  [213666709,213886412,'Aries'],
  [213886412,214104096,'Taurus'],
  [214104096,214313087,'Gemini'],
  [214313087,214508658,'Cancer'],
  [214508658,214690861,'Leo'],
  [214690861,214864065,'Virgo'],
  [214864065,215034842,'Libra'],
  [215034842,215210111,'Scorpio'],
  [215210111,215395588,'Sagittarius'],
  [215395588,215594070,'Capricorn'],
  [215594070,215804276,'Aquarius'],
  [215804276,216021739,'Pisces'],
  [216021739,216241336,'Aries'],
  [216241336,216458624,'Taurus'],
  [216458624,216669552,'Gemini'],
  [216669552,216870350,'Cancer'],
  [216870350,217059031,'Leo'],
  [217059031,217236888,'Virgo'],
  [217236888,217408465,'Libra'],
  [217408465,217580398,'Scorpio'],
  [217580398,217759860,'Sagittarius'],
  [217759860,217952534,'Capricorn'],
  [217952534,218159800,'Aquarius'],
  [218159800,218377156,'Pisces'],
  [218377156,218596901,'Aries'],
  [218596901,218812938,'Taurus'],
  [218812938,219022535,'Gemini'],
  [219022535,219224625,'Cancer'],
  [219224625,219418188,'Leo'],
  [219418188,219602700,'Virgo'],
  [219602700,219779649,'Libra'],
  [219779649,219953420,'Scorpio'],
  [219953420,220130594,'Sagittarius'],
  [220130594,220318108,'Capricorn'],
  [220318108,220520303,'Aquarius'],
  [220520303,220735374,'Pisces'],
  [220735374,220955154,'Aries'],
  [220955154,221170738,'Taurus'],
  [221170738,221378005,'Gemini'],
  [221378005,221577425,'Cancer'],
  [221577425,221770712,'Leo'],
  [221770712,221958680,'Virgo'],
  [221958680,222141555,'Libra'],
  [222141555,222320873,'Scorpio'],
  [222320873,222500744,'Sagittarius'],
  [222500744,222687146,'Capricorn'],
  [222687146,222885552,'Aquarius'],
  [222885552,223097205,'Pisces'],
  [223097205,223316288,'Aries'],
  [223316288,223532727,'Taurus'],
  [223532727,223739463,'Gemini'],
  [223739463,223935824,'Cancer'],
  [223935824,224125058,'Leo'],
  [224125058,224310725,'Virgo'],
  [224310725,224494904,'Libra'],
  [224494904,224678617,'Scorpio'],
  [224678617,224863538,'Sagittarius'],
  [224863538,225053015,'Capricorn'],
  [225053015,225251265,'Aquarius'],
  [225251265,225460713,'Pisces'],
  [225460713,225678587,'Aries'],
  [225678587,225896434,'Taurus'],
  [225896434,226105272,'Gemini'],
  [226105272,226301518,'Cancer'],
  [226301518,226487456,'Leo'],
  [226487456,226668028,'Virgo'],
  [226668028,226848022,'Libra'],
  [226848022,227030749,'Scorpio'],
  [227030749,227218132,'Sagittarius'],
  [227218132,227411585,'Capricorn'],
  [227411585,227612646,'Aquarius'],
  [227612646,227822423,'Pisces'],
  [227822423,228039544,'Aries'],
  [228039544,228258395,'Taurus'],
  [228258395,228470672,'Gemini'],
  [228470672,228670309,'Cancer'],
  [228670309,228856835,'Leo'],
  [228856835,229034320,'Virgo'],
  [229034320,229208743,'Libra'],
  [229208743,229385979,'Scorpio'],
  [229385979,229570503,'Sagittarius'],
  [229570503,229764604,'Capricorn'],
  [229764604,229968294,'Aquarius'],
  [229968294,230180070,'Pisces'],
  [230180070,230397494,'Aries'],
  [230397494,230616633,'Taurus'],
  [230616633,230831616,'Gemini'],
  [230831616,231036181,'Cancer'],
  [231036181,231227125,'Leo'],
  [231227125,231405950,'Virgo'],
  [231405950,231577813,'Libra'],
  [231577813,231749574,'Scorpio'],
  [231749574,231928028,'Sagittarius'],
  [231928028,232118146,'Capricorn'],
  [232118146,232321198,'Aquarius'],
  [232321198,232534323,'Pisces'],
  [232534323,232752660,'Aries'],
  [232752660,232971670,'Taurus'],
  [232971670,233187408,'Gemini'],
  [233187408,233395566,'Cancer'],
  [233395566,233592198,'Leo'],
  [233592198,233776080,'Virgo'],
  [233776080,233949965,'Libra'],
  [233949965,234119892,'Scorpio'],
  [234119892,234293392,'Sagittarius'],
  [234293392,234477532,'Capricorn'],
  [234477532,234676332,'Aquarius'],
  [234676332,234888252,'Pisces'],
  [234888252,235106979,'Aries'],
  [235106979,235325806,'Taurus'],
  [235325806,235540691,'Gemini'],
  [235540691,235749417,'Cancer'],
  [235749417,235949654,'Leo'],
  [235949654,236139300,'Virgo'],
  [236139300,236318519,'Libra'],
  [236318519,236491062,'Scorpio'],
  [236491062,236663524,'Sagittarius'],
  [236663524,236843469,'Capricorn'],
  [236843469,237036952,'Aquarius'],
  [237036952,237245199,'Pisces'],
  [237245199,237462905,'Aries'],
  [237462905,237681596,'Taurus'],
  [237681596,237895316,'Gemini'],
  [237895316,238102229,'Cancer'],
  [238102229,238302214,'Leo'],
  [238302214,238494728,'Virgo'],
  [238494728,238679222,'Libra'],
  [238679222,238857079,'Scorpio'],
  [238857079,239032622,'Sagittarius'],
  [239032622,239212256,'Capricorn'],
  [239212256,239402423,'Aquarius'],
  [239402423,239606535,'Pisces'],
  [239606535,239821928,'Aries'],
  [239821928,240040434,'Taurus'],
  [240040434,240253886,'Gemini'],
  [240253886,240458812,'Cancer'],
  [240458812,240655858,'Leo'],
  [240655858,240846816,'Virgo'],
  [240846816,241032877,'Libra'],
  [241032877,241215061,'Scorpio'],
  [241215061,241395603,'Sagittarius'],
  [241395603,241578549,'Capricorn'],
  [241578549,241768947,'Aquarius'],
  [241768947,241970712,'Pisces'],
  [241970712,242183639,'Aries'],
  [242183639,242401805,'Taurus'],
  [242401805,242616359,'Gemini'],
  [242616359,242821222,'Cancer'],
  [242821222,243015683,'Leo'],
  [243015683,243202555,'Virgo'],
  [243202555,243385491,'Libra'],
  [243385491,243567549,'Scorpio'],
  [243567549,243751097,'Sagittarius'],
  [243751097,243938392,'Capricorn'],
  [243938392,244131978,'Aquarius'],
  [244131978,244334259,'Pisces'],
  [244334259,244545874,'Aries'],
  [244545874,244763583,'Taurus'],
  [244763583,244980076,'Gemini'],
  [244980076,245187561,'Cancer'],
  [245187561,245382487,'Leo'],
  [245382487,245566515,'Virgo'],
  [245566515,245744418,'Libra'],
  [245744418,245921769,'Scorpio'],
  [245921769,246103318,'Sagittarius'],
  [246103318,246292044,'Capricorn'],
  [246292044,246488982,'Aquarius'],
  [246488982,246693903,'Pisces'],
  [246693903,246906021,'Aries'],
  [246906021,247123383,'Taurus'],
  [247123383,247341401,'Gemini'],
  [247341401,247552978,'Cancer'],
  [247552978,247752065,'Leo'],
  [247752065,247937389,'Virgo'],
  [247937389,248112675,'Libra'],
  [248112675,248284524,'Scorpio'],
  [248284524,248460089,'Sagittarius'],
  [248460089,248645071,'Capricorn'],
  [248645071,248841833,'Aquarius'],
  [248841833,249048875,'Pisces'],
  [249048875,249262729,'Aries'],
  [249262729,249480240,'Taurus'],
  [249480240,249698500,'Gemini'],
  [249698500,249913010,'Cancer'],
  [249913010,250117738,'Leo'],
  [250117738,250308537,'Virgo'],
  [250308537,250486193,'Libra'],
  [250486193,250656224,'Scorpio'],
  [250656224,250826490,'Sagittarius'],
  [250826490,251004845,'Capricorn'],
  [251004845,251196666,'Aquarius'],
  [251196666,251402279,'Pisces'],
  [251402279,251617095,'Aries'],
  [251617095,251835275,'Taurus'],
  [251835275,252052952,'Gemini'],
  [252052952,252267580,'Cancer'],
  [252267580,252475578,'Leo'],
  [252475578,252672597,'Virgo'],
  [252672597,252856579,'Libra'],
  [252856579,253030137,'Scorpio'],
  [253030137,253199805,'Sagittarius'],
  [253199805,253373678,'Capricorn'],
  [253373678,253559054,'Aquarius'],
  [253559054,253759485,'Pisces'],
  [253759485,253972440,'Aries'],
  [253972440,254190881,'Taurus'],
  [254190881,254408228,'Gemini'],
  [254408228,254621232,'Cancer'],
  [254621232,254828410,'Leo'],
  [254828410,255027853,'Virgo'],
  [255027853,255217541,'Libra'],
  [255217541,255397608,'Scorpio'],
  [255397608,255571724,'Sagittarius'],
  [255571724,255746252,'Capricorn'],
  [255746252,255928300,'Aquarius'],
  [255928300,256123278,'Pisces'],
  [256123278,256331966,'Aries'],
  [256331966,256549180,'Taurus'],
  [256549180,256766733,'Gemini'],
  [256766733,256978680,'Cancer'],
  [256978680,257183103,'Leo'],
  [257183103,257380267,'Virgo'],
  [257380267,257570696,'Libra'],
  [257570696,257755034,'Scorpio'],
  [257755034,257935065,'Sagittarius'],
  [257935065,258114376,'Capricorn'],
  [258114376,258297959,'Aquarius'],
  [258297959,258490808,'Pisces'],
  [258490808,258695653,'Aries'],
  [258695653,258910499,'Taurus'],
  [258910499,259128307,'Gemini'],
  [259128307,259340944,'Cancer'],
  [259340944,259543950,'Leo'],
  [259543950,259737432,'Virgo'],
  [259737432,259924102,'Libra'],
  [259924102,260107208,'Scorpio'],
  [260107208,260289564,'Sagittarius'],
  [260289564,260473544,'Capricorn'],
  [260473544,260661538,'Aquarius'],
  [260661538,260856240,'Pisces'],
  [260856240,261059998,'Aries'],
  [261059998,261272912,'Taurus'],
  [261272912,261490717,'Gemini'],
  [261490717,261705404,'Cancer'],
  [261705404,261909855,'Leo'],
  [261909855,262101923,'Virgo'],
  [262101923,262284411,'Libra'],
  [262284411,262462629,'Scorpio'],
  [262462629,262641959,'Sagittarius'],
  [262641959,262826284,'Capricorn'],
  [262826284,263017389,'Aquarius'],
  [263017389,263215595,'Pisces'],
  [263215595,263421011,'Aries'],
  [263421011,263633596,'Taurus'],
  [263633596,263851299,'Gemini'],
  [263851299,264068216,'Cancer'],
  [264068216,264276333,'Leo'],
  [264276333,264470641,'Virgo'],
  [264470641,264652046,'Libra'],
  [264652046,264826059,'Scorpio'],
  [264826059,264999848,'Sagittarius'],
  [264999848,265179797,'Capricorn'],
  [265179797,265369600,'Aquarius'],
  [265369600,265569418,'Pisces'],
  [265569418,265777197,'Aries'],
  [265777197,265990883,'Taurus'],
  [265990883,266208661,'Gemini'],
  [266208661,266426887,'Cancer'],
  [266426887,266638894,'Leo'],
  [266638894,266838059,'Virgo'],
  [266838059,267022458,'Libra'],
  [267022458,267195984,'Scorpio'],
  [267195984,267365914,'Sagittarius'],
  [267365914,267540105,'Capricorn'],
  [267540105,267724734,'Aquarius'],
  [267724734,267922162,'Pisces'],
  [267922162,268130397,'Aries'],
  [268130397,268345330,'Taurus'],
  [268345330,268563425,'Gemini'],
  [268563425,268781707,'Cancer'],
  [268781707,268995751,'Leo'],
  [268995751,269199708,'Virgo'],
  [269199708,269389706,'Libra'],
  [269389706,269566934,'Scorpio'],
  [269566934,269737123,'Sagittarius'],
  [269737123,269908002,'Capricorn'],
  [269908002,270087018,'Aquarius'],
  [270087018,270279092,'Pisces'],
  [270279092,270484566,'Aries'],
  [270484566,270699331,'Taurus'],
  [270699331,270917714,'Gemini'],
  [270917714,271135350,'Cancer'],
  [271135350,271348929,'Leo'],
  [271348929,271554856,'Virgo'],
  [271554856,271749785,'Libra'],
  [271749785,271932945,'Scorpio'],
  [271932945,272107457,'Sagittarius'],
  [272107457,272279345,'Capricorn'],
  [272279345,272455671,'Aquarius'],
  [272455671,272642623,'Pisces'],
  [272642623,272843258,'Aries'],
  [272843258,273055724,'Taurus'],
  [273055724,273273891,'Gemini'],
  [273273891,273491043,'Cancer'],
  [273491043,273702863,'Leo'],
  [273702863,273907303,'Virgo'],
  [273907303,274103381,'Libra'],
  [274103381,274290900,'Scorpio'],
  [274290900,274471249,'Sagittarius'],
  [274471249,274647863,'Capricorn'],
  [274647863,274825814,'Aquarius'],
  [274825814,275010743,'Pisces'],
  [275010743,275207152,'Aries'],
  [275207152,275416056,'Taurus'],
  [275416056,275633190,'Gemini'],
  [275633190,275850574,'Cancer'],
  [275850574,276061361,'Leo'],
  [276061361,276262909,'Virgo'],
  [276262909,276456133,'Libra'],
  [276456133,276643336,'Scorpio'],
  [276643336,276826805,'Sagittarius'],
  [276826805,277008650,'Capricorn'],
  [277008650,277191355,'Aquarius'],
  [277191355,277378299,'Pisces'],
  [277378299,277573409,'Aries'],
  [277573409,277779405,'Taurus'],
  [277779405,277994943,'Gemini'],
  [277994943,278213147,'Cancer'],
  [278213147,278425017,'Leo'],
  [278425017,278625341,'Virgo'],
  [278625341,278814783,'Libra'],
  [278814783,278997667,'Scorpio'],
  [278997667,279178911,'Sagittarius'],
  [279178911,279362067,'Capricorn'],
  [279362067,279548832,'Aquarius'],
  [279548832,279740079,'Pisces'],
  [279740079,279937308,'Aries'],
  [279937308,280142707,'Taurus'],
  [280142707,280356917,'Gemini'],
  [280356917,280575845,'Cancer'],
  [280575845,280790624,'Leo'],
  [280790624,280993196,'Virgo'],
  [280993196,281181748,'Libra'],
  [281181748,281360487,'Scorpio'],
  [281360487,281536186,'Sagittarius'],
  [281536186,281715121,'Capricorn'],
  [281715121,281901074,'Aquarius'],
  [281901074,282094768,'Pisces'],
  [282094768,282295399,'Aries'],
  [282295399,282502653,'Taurus'],
  [282502653,282716731,'Gemini'],
  [282716731,282935784,'Cancer'],
  [282935784,283153393,'Leo'],
  [283153393,283360770,'Virgo'],
  [283360770,283552900,'Libra'],
  [283552900,283731631,'Scorpio'],
  [283731631,283903487,'Sagittarius'],
  [283903487,284076228,'Capricorn'],
  [284076228,284256372,'Aquarius'],
  [284256372,284447298,'Pisces'],
  [284447298,284648694,'Aries'],
  [284648694,284858186,'Taurus'],
  [284858186,285073439,'Gemini'],
  [285073439,285292345,'Cancer'],
  [285292345,285510914,'Leo'],
  [285510914,285722428,'Virgo'],
  [285722428,285920654,'Libra'],
  [285920654,286104214,'Scorpio'],
  [286104214,286277282,'Sagittarius'],
  [286277282,286447034,'Capricorn'],
  [286447034,286621062,'Aquarius'],
  [286621062,286805432,'Pisces'],
  [286805432,287002854,'Aries'],
  [287002854,287211894,'Taurus'],
  [287211894,287428254,'Gemini'],
  [287428254,287647328,'Cancer'],
  [287647328,287865158,'Leo'],
  [287865158,288077557,'Virgo'],
  [288077557,288280114,'Libra'],
  [288280114,288470199,'Scorpio'],
  [288470199,288648955,'Sagittarius'],
  [288648955,288821088,'Capricorn'],
  [288821088,288993223,'Aquarius'],
  [288993223,289172204,'Pisces'],
  [289172204,289363357,'Aries'],
  [289363357,289568373,'Taurus'],
  [289568373,289783920,'Gemini'],
  [289783920,290003273,'Cancer'],
  [290003273,290220168,'Leo'],
  [290220168,290430810,'Virgo'],
  [290430810,290633369,'Libra'],
  [290633369,290826946,'Scorpio'],
  [290826946,291011753,'Sagittarius'],
  [291011753,291189788,'Capricorn'],
  [291189788,291365078,'Aquarius'],
  [291365078,291543215,'Pisces'],
  [291543215,291730149,'Aries'],
  [291730149,291930115,'Taurus'],
  [291930115,292142749,'Gemini'],
  [292142749,292361787,'Cancer'],
  [292361787,292578565,'Leo'],
  [292578565,292787330,'Virgo'],
  [292787330,292987013,'Libra'],
  [292987013,293179249,'Scorpio'],
  [293179249,293366032,'Sagittarius'],
  [293366032,293548928,'Capricorn'],
  [293548928,293729659,'Aquarius'],
  [293729659,293911212,'Pisces'],
  [293911212,294098135,'Aries'],
  [294098135,294295236,'Taurus'],
  [294295236,294504674,'Gemini'],
  [294504674,294722692,'Cancer'],
  [294722692,294940211,'Leo'],
  [294940211,295148867,'Virgo'],
  [295148867,295346083,'Libra'],
  [295346083,295534487,'Scorpio'],
  [295534487,295718473,'Sagittarius'],
  [295718473,295901561,'Capricorn'],
  [295901561,296085580,'Aquarius'],
  [296085580,296271642,'Pisces'],
  [296271642,296461792,'Aries'],
  [296461792,296659395,'Taurus'],
  [296659395,296867282,'Gemini'],
  [296867282,297084222,'Cancer'],
  [297084222,297302879,'Leo'],
  [297302879,297513536,'Virgo'],
  [297513536,297710970,'Libra'],
  [297710970,297896715,'Scorpio'],
  [297896715,298076180,'Sagittarius'],
  [298076180,298255148,'Capricorn'],
  [298255148,298437633,'Aquarius'],
  [298437633,298625349,'Pisces'],
  [298625349,298818866,'Aries'],
  [298818866,299019162,'Taurus'],
  [299019162,299227699,'Gemini'],
  [299227699,299444213,'Cancer'],
  [299444213,299663814,'Leo'],
  [299663814,299877604,'Virgo'],
  [299877604,300078261,'Libra'],
  [300078261,300264791,'Scorpio'],
  [300264791,300441735,'Sagittarius'],
  [300441735,300615774,'Capricorn'],
  [300615774,300793095,'Aquarius'],
  [300793095,300977829,'Pisces'],
  [300977829,301171560,'Aries'],
  [301171560,301374077,'Taurus'],
  [301374077,301584505,'Gemini'],
  [301584505,301801462,'Cancer'],
  [301801462,302021440,'Leo'],
  [302021440,302237789,'Virgo'],
  [302237789,302443147,'Libra'],
  [302443147,302633983,'Scorpio'],
  [302633983,302812430,'Sagittarius'],
  [302812430,302984317,'Capricorn'],
  [302984317,303156583,'Aquarius'],
  [303156583,303335497,'Pisces'],
  [303335497,303525254,'Aries'],
  [303525254,303726951,'Taurus'],
  [303726951,303938584,'Gemini'],
  [303938584,304156437,'Cancer'],
  [304156437,304376310,'Leo'],
  [304376310,304593354,'Virgo'],
  [304593354,304802219,'Libra'],
  [304802219,304998753,'Scorpio'],
  [304998753,305182397,'Sagittarius'],
  [305182397,305356562,'Capricorn'],
  [305356562,305527217,'Aquarius'],
  [305527217,305701262,'Pisces'],
  [305701262,305885033,'Aries'],
  [305885033,306082401,'Taurus'],
  [306082401,306292765,'Gemini'],
  [306292765,306511039,'Cancer'],
  [306511039,306730717,'Leo'],
  [306730717,306946766,'Virgo'],
  [306946766,307156002,'Libra'],
  [307156002,307356128,'Scorpio'],
  [307356128,307545802,'Sagittarius'],
  [307545802,307725762,'Capricorn'],
  [307725762,307899444,'Aquarius'],
  [307899444,308072589,'Pisces'],
  [308072589,308252042,'Aries'],
  [308252042,308443851,'Taurus'],
  [308443851,308650336,'Gemini'],
  [308650336,308867589,'Cancer'],
  [308867589,309087244,'Leo'],
  [309087244,309302055,'Virgo'],
  [309302055,309509129,'Libra'],
  [309509129,309708588,'Scorpio'],
  [309708588,309900988,'Sagittarius'],
  [309900988,310086543,'Capricorn'],
  [310086543,310266182,'Aquarius'],
  [310266182,310442983,'Pisces'],
  [310442983,310622378,'Aries'],
  [310622378,310810775,'Taurus'],
  [310810775,311012793,'Gemini'],
  [311012793,311227494,'Cancer'],
  [311227494,311447089,'Leo'],
  [311447089,311661900,'Virgo'],
  [311661900,311866960,'Libra'],
  [311866960,312063001,'Scorpio'],
  [312063001,312253098,'Sagittarius'],
  [312253098,312439651,'Capricorn'],
  [312439651,312623634,'Aquarius'],
  [312623634,312805979,'Pisces'],
  [312805979,312989377,'Aries'],
  [312989377,313178505,'Taurus'],
  [313178505,313378239,'Gemini'],
  [313378239,313590159,'Cancer'],
  [313590159,313809258,'Leo'],
  [313809258,314025554,'Virgo'],
  [314025554,314231170,'Libra'],
  [314231170,314424918,'Scorpio'],
  [314424918,314610546,'Sagittarius'],
  [314610546,314792942,'Capricorn'],
  [314792942,314975662,'Aquarius'],
  [314975662,315160425,'Pisces'],
  [315160425,315348331,'Aries'],
  [315348331,315541322,'Taurus'],
  [315541322,315742245,'Gemini'],
  [315742245,315952985,'Cancer'],
  [315952985,316171271,'Leo'],
  [316171271,316389416,'Virgo'],
  [316389416,316598319,'Libra'],
  [316598319,316793617,'Scorpio'],
  [316793617,316977245,'Sagittarius'],
  [316977245,317154621,'Capricorn'],
  [317154621,317331645,'Aquarius'],
  [317331645,317512914,'Pisces'],
  [317512914,317701054,'Aries'],
  [317701054,317897067,'Taurus'],
  [317897067,318101133,'Gemini'],
  [318101133,318312984,'Cancer'],
  [318312984,318530878,'Leo'],
  [318530878,318749949,'Virgo'],
  [318749949,318962718,'Libra'],
  [318962718,319162914,'Scorpio'],
  [319162914,319349255,'Sagittarius'],
  [319349255,319525368,'Capricorn'],
  [319525368,319697472,'Aquarius'],
  [319697472,319872248,'Pisces'],
  [319872248,320055286,'Aries'],
  [320055286,320249688,'Taurus'],
  [320249688,320455235,'Gemini'],
  [320455235,320669085,'Cancer'],
  [320669085,320887483,'Leo'],
  [320887483,321106418,'Virgo'],
  [321106418,321321146,'Libra'],
  [321321146,321526383,'Scorpio'],
  [321526383,321718669,'Sagittarius'],
  [321718669,321898503,'Capricorn'],
  [321898503,322070299,'Aquarius'],
  [322070299,322240835,'Pisces'],
  [322240835,322417443,'Aries'],
  [322417443,322606112,'Taurus'],
  [322606112,322809047,'Gemini'],
  [322809047,323023224,'Cancer'],
  [323023224,323242401,'Leo'],
  [323242401,323460909,'Virgo'],
  [323460909,323675186,'Libra'],
  [323675186,323882478,'Scorpio'],
  [323882478,324079961,'Sagittarius'],
  [324079961,324266057,'Capricorn'],
  [324266057,324442228,'Aquarius'],
  [324442228,324613425,'Pisces'],
  [324613425,324786808,'Aries'],
  [324786808,324969789,'Taurus'],
  [324969789,325167378,'Gemini'],
  [325167378,325378987,'Cancer'],
  [325378987,325597997,'Leo'],
  [325597997,325816307,'Virgo'],
  [325816307,326029137,'Libra'],
  [326029137,326235188,'Scorpio'],
  [326235188,326433983,'Sagittarius'],
  [326433983,326624576,'Capricorn'],
  [326624576,326806667,'Aquarius'],
  [326806667,326982500,'Pisces'],
  [326982500,327157342,'Aries'],
  [327157342,327338152,'Taurus'],
  [327338152,327531210,'Gemini'],
  [327531210,327738721,'Cancer'],
  [327738721,327956149,'Leo'],
  [327956149,328174460,'Virgo'],
  [328174460,328386471,'Libra'],
  [328386471,328590124,'Scorpio'],
  [328590124,328786577,'Sagittarius'],
  [328786577,328977195,'Capricorn'],
  [328977195,329162530,'Aquarius'],
  [329162530,329343478,'Pisces'],
  [329343478,329522854,'Aries'],
  [329522854,329705604,'Taurus'],
  [329705604,329897382,'Gemini'],
  [329897382,330101759,'Cancer'],
  [330101759,330316961,'Leo'],
  [330316961,330535307,'Virgo'],
  [330535307,330747937,'Libra'],
  [330747937,330950482,'Scorpio'],
  [330950482,331143736,'Sagittarius'],
  [331143736,331330811,'Capricorn'],
  [331330811,331514642,'Aquarius'],
  [331514642,331697296,'Pisces'],
  [331697296,331880697,'Aries'],
  [331880697,332067549,'Taurus'],
  [332067549,332261364,'Gemini'],
  [332261364,332465123,'Cancer'],
  [332465123,332678730,'Leo'],
  [332678730,332897061,'Virgo'],
  [332897061,333111590,'Libra'],
  [333111590,333315594,'Scorpio'],
  [333315594,333507733,'Sagittarius'],
  [333507733,333691027,'Capricorn'],
  [333691027,333870210,'Aquarius'],
  [333870210,334049820,'Pisces'],
  [334049820,334233312,'Aries'],
  [334233312,334422954,'Taurus'],
  [334422954,334620136,'Gemini'],
  [334620136,334825639,'Cancer'],
  [334825639,335039075,'Leo'],
  [335039075,335257360,'Virgo'],
  [335257360,335474080,'Libra'],
  [335474080,335681772,'Scorpio'],
  [335681772,335876301,'Sagittarius'],
  [335876301,336058731,'Capricorn'],
  [336058731,336233854,'Aquarius'],
  [336233854,336407966,'Pisces'],
  [336407966,336587048,'Aries'],
  [336587048,336775284,'Taurus'],
  [336775284,336974006,'Gemini'],
  [336974006,337181895,'Cancer'],
  [337181895,337396450,'Leo'],
  [337396450,337614769,'Virgo'],
  [337614769,337832748,'Libra'],
  [337832748,338044443,'Scorpio'],
  [338044443,338244147,'Sagittarius'],
  [338244147,338429927,'Capricorn'],
  [338429927,338604729,'Aquarius'],
  [338604729,338774907,'Pisces'],
  [338774907,338948026,'Aries'],
  [338948026,339130843,'Taurus'],
  [339130843,339326996,'Gemini'],
  [339326996,339535331,'Cancer'],
  [339535331,339751191,'Leo'],
  [339751191,339969760,'Virgo'],
  [339969760,340187600,'Libra'],
  [340187600,340401231,'Scorpio'],
  [340401231,340605982,'Sagittarius'],
  [340605982,340797961,'Capricorn'],
  [340797961,340977062,'Aquarius'],
  [340977062,341147791,'Pisces'],
  [341147791,341317558,'Aries'],
  [341317558,341494436,'Taurus'],
  [341494436,341684733,'Gemini'],
  [341684733,341889935,'Cancer'],
  [341889935,342105558,'Leo'],
  [342105558,342324471,'Virgo'],
  [342324471,342541518,'Libra'],
  [342541518,342754292,'Scorpio'],
  [342754292,342960687,'Sagittarius'],
  [342960687,343157741,'Capricorn'],
  [343157741,343343449,'Aquarius'],
  [343343449,343519318,'Pisces'],
  [343519318,343690731,'Aries'],
  [343690731,343865199,'Taurus'],
  [343865199,344050122,'Gemini'],
  [344050122,344249838,'Cancer'],
  [344249838,344462657,'Leo'],
  [344462657,344681323,'Virgo'],
  [344681323,344898067,'Libra'],
  [344898067,345108950,'Scorpio'],
  [345108950,345313223,'Sagittarius'],
  [345313223,345510623,'Capricorn'],
  [345510623,345700362,'Aquarius'],
  [345700362,345882475,'Pisces'],
  [345882475,346059512,'Aries'],
  [346059512,346236625,'Taurus'],
  [346236625,346420204,'Gemini'],
  [346420204,346615624,'Cancer'],
  [346615624,346824260,'Leo'],
  [346824260,347041467,'Virgo'],
  [347041467,347258687,'Libra'],
  [347258687,347469068,'Scorpio'],
  [347469068,347670524,'Sagittarius'],
  [347670524,347864290,'Capricorn'],
  [347864290,348052418,'Aquarius'],
  [348052418,348236638,'Pisces'],
  [348236638,348418723,'Aries'],
  [348418723,348601290,'Taurus'],
  [348601290,348788045,'Gemini'],
  [348788045,348983048,'Cancer'],
  [348983048,349188836,'Leo'],
  [349188836,349403923,'Virgo'],
  [349403923,349621758,'Libra'],
  [349621758,349833856,'Scorpio'],
  [349833856,350035079,'Sagittarius'],
  [350035079,350225522,'Capricorn'],
  [350225522,350408749,'Aquarius'],
  [350408749,350589327,'Pisces'],
  [350589327,350771184,'Aries'],
  [350771184,350956968,'Taurus'],
  [350956968,351148264,'Gemini'],
  [351148264,351346314,'Cancer'],
  [351346314,351552279,'Leo'],
  [351552279,351766039,'Virgo'],
  [351766039,351984061,'Libra'],
  [351984061,352198971,'Scorpio'],
  [352198971,352403285,'Sagittarius'],
  [352403285,352594115,'Capricorn'],
  [352594115,352774083,'Aquarius'],
  [352774083,352949116,'Pisces'],
  [352949116,353125766,'Aries'],
  [353125766,353309175,'Taurus'],
  [353309175,353501696,'Gemini'],
  [353501696,353702891,'Cancer'],
  [353702891,353911197,'Leo'],
  [353911197,354125289,'Virgo'],
  [354125289,354343205,'Libra'],
  [354343205,354560223,'Scorpio'],
  [354560223,354769071,'Sagittarius'],
  [354769071,354964149,'Capricorn'],
  [354964149,355145314,'Aquarius'],
  [355145314,355317678,'Pisces'],
  [355317678,355488826,'Aries'],
  [355488826,355666202,'Taurus'],
  [355666202,355854868,'Gemini'],
  [355854868,356055667,'Cancer'],
  [356055667,356265691,'Leo'],
  [356265691,356481107,'Virgo'],
  [356481107,356699068,'Libra'],
  [356699068,356916609,'Scorpio'],
  [356916609,357128655,'Sagittarius'],
  [357128655,357329215,'Capricorn'],
  [357329215,357515403,'Aquarius'],
  [357515403,357689822,'Pisces'],
  [357689822,357859188,'Aries'],
  [357859188,358031581,'Taurus'],
  [358031581,358214117,'Gemini'],
  [358214117,358410476,'Cancer'],
  [358410476,358619232,'Leo'],
  [358619232,358835292,'Virgo'],
  [358835292,359053502,'Libra'],
  [359053502,359270426,'Scorpio'],
  [359270426,359482908,'Sagittarius'],
  [359482908,359686830,'Capricorn'],
  [359686830,359878695,'Aquarius'],
  [359878695,360058531,'Pisces'],
  [360058531,360230700,'Aries'],
  [360230700,360402206,'Taurus'],
  [360402206,360580501,'Gemini'],
  [360580501,360771258,'Cancer'],
  [360771258,360975924,'Leo'],
  [360975924,361190728,'Virgo'],
  [361190728,361408997,'Libra'],
  [361408997,361625165,'Scorpio'],
  [361625165,361836070,'Sagittarius'],
  [361836070,362039699,'Capricorn'],
  [362039699,362234327,'Aquarius'],
  [362234327,362419430,'Pisces'],
  [362419430,362597057,'Aries'],
  [362597057,362771869,'Taurus'],
  [362771869,362949989,'Gemini'],
  [362949989,363137340,'Cancer'],
  [363137340,363337482,'Leo'],
  [363337482,363549415,'Virgo'],
  [363549415,363767196,'Libra'],
  [363767196,363983243,'Scorpio'],
  [363983243,364192505,'Sagittarius'],
  [364192505,364393435,'Capricorn'],
  [364393435,364586608,'Aquarius'],
  [364586608,364773315,'Pisces'],
  [364773315,364955331,'Aries'],
  [364955331,365135284,'Taurus'],
  [365135284,365316876,'Gemini'],
  [365316876,365504535,'Cancer'],
  [365504535,365702200,'Leo'],
  [365702200,365911185,'Virgo'],
  [365911185,366127984,'Libra'],
  [366127984,366344780,'Scorpio'],
  [366344780,366554031,'Sagittarius'],
  [366554031,366752628,'Capricorn'],
  [366752628,366942015,'Aquarius'],
  [366942015,367125875,'Pisces'],
  [367125875,367307953,'Aries'],
  [367307953,367491042,'Taurus'],
  [367491042,367677095,'Gemini'],
  [367677095,367868040,'Cancer'],
  [367868040,368066292,'Leo'],
  [368066292,368273816,'Virgo'],
  [368273816,368489607,'Libra'],
  [368489607,368707654,'Scorpio'],
  [368707654,368919099,'Sagittarius'],
  [368919099,369118063,'Capricorn'],
  [369118063,369304776,'Aquarius'],
  [369304776,369483972,'Pisces'],
  [369483972,369661752,'Aries'],
  [369661752,369843158,'Taurus'],
  [369843158,370030834,'Gemini'],
  [370030834,370225236,'Cancer'],
  [370225236,370426268,'Leo'],
  [370426268,370634446,'Virgo'],
  [370634446,370849767,'Libra'],
  [370849767,371068807,'Scorpio'],
  [371068807,371283687,'Sagittarius'],
  [371283687,371486324,'Capricorn'],
  [371486324,371674111,'Aquarius'],
  [371674111,371850777,'Pisces'],
  [371850777,372023374,'Aries'],
  [372023374,372199184,'Taurus'],
  [372199184,372383454,'Gemini'],
  [372383454,372577888,'Cancer'],
  [372577888,372781194,'Leo'],
  [372781194,372991380,'Virgo'],
  [372991380,373207124,'Libra'],
  [373207124,373426394,'Scorpio'],
  [373426394,373643860,'Sagittarius'],
  [373643860,373851673,'Capricorn'],
  [373851673,374044511,'Aquarius'],
  [374044511,374223295,'Pisces'],
  [374223295,374394029,'Aries'],
  [374394029,374564623,'Taurus'],
  [374564623,374742425,'Gemini'],
  [374742425,374932092,'Cancer'],
  [374932092,375134085,'Leo'],
  [375134085,375345427,'Virgo'],
  [375345427,375562210,'Libra'],
  [375562210,375781269,'Scorpio'],
  [375781269,375999033,'Sagittarius'],
  [375999033,376210132,'Capricorn'],
  [376210132,376409095,'Aquarius'],
  [376409095,376594023,'Pisces'],
  [376594023,376768097,'Aries'],
  [376768097,376937882,'Taurus'],
  [376937882,377110957,'Gemini'],
  [377110957,377293979,'Cancer'],
  [377293979,377490626,'Leo'],
  [377490626,377699999,'Virgo'],
  [377699999,377917168,'Libra'],
  [377917168,378136234,'Scorpio'],
  [378136234,378352750,'Sagittarius'],
  [378352750,378563404,'Capricorn'],
  [378563404,378765218,'Aquarius'],
  [378765218,378956202,'Pisces'],
  [378956202,379136952,'Aries'],
  [379136952,379311125,'Taurus'],
  [379311125,379484537,'Gemini'],
  [379484537,379663760,'Cancer'],
  [379663760,379854435,'Leo'],
  [379854435,380058990,'Virgo'],
  [380058990,380274537,'Libra'],
  [380274537,380493759,'Scorpio'],
  [380493759,380709401,'Sagittarius'],
  [380709401,380917591,'Capricorn'],
  [380917591,381117600,'Aquarius'],
  [381117600,381309991,'Pisces'],
  [381309991,381495686,'Aries'],
  [381495686,381676248,'Taurus'],
  [381676248,381854552,'Gemini'],
  [381854552,382035058,'Cancer'],
  [382035058,382223128,'Leo'],
  [382223128,382423145,'Virgo'],
  [382423145,382635489,'Libra'],
  [382635489,382854358,'Scorpio'],
  [382854358,383070488,'Sagittarius'],
  [383070488,383277298,'Capricorn'],
  [383277298,383473825,'Aquarius'],
  [383473825,383662882,'Pisces'],
  [383662882,383847981,'Aries'],
  [383847981,384031602,'Taurus'],
  [384031602,384215178,'Gemini'],
  [384215178,384400382,'Cancer'],
  [384400382,384590289,'Leo'],
  [384590289,384788895,'Virgo'],
  [384788895,384998567,'Libra'],
  [384998567,385216498,'Scorpio'],
  [385216498,385434038,'Sagittarius'],
  [385434038,385642075,'Capricorn'],
  [385642075,385837208,'Aquarius'],
  [385837208,386022240,'Pisces'],
  [386022240,386202725,'Aries'],
  [386202725,386383744,'Taurus'],
  [386383744,386568227,'Gemini'],
  [386568227,386757083,'Cancer'],
  [386757083,386950916,'Leo'],
  [386950916,387151418,'Virgo'],
  [387151418,387360593,'Libra'],
  [387360593,387577718,'Scorpio'],
  [387577718,387796620,'Sagittarius'],
  [387796620,388007815,'Capricorn'],
  [388007815,388205089,'Aquarius'],
  [388205089,388389147,'Pisces'],
  [388389147,388565560,'Aries'],
  [388565560,388741152,'Taurus'],
  [388741152,388921446,'Gemini'],
  [388921446,389109303,'Cancer'],
  [389109303,389305138,'Leo'],
  [389305138,389508481,'Virgo'],
  [389508481,389719127,'Libra'],
  [389719127,389936232,'Scorpio'],
  [389936232,390155812,'Sagittarius'],
  [390155812,390370202,'Capricorn'],
  [390370202,390572015,'Aquarius'],
  [390572015,390759114,'Pisces'],
  [390759114,390935215,'Aries'],
  [390935215,391107039,'Taurus'],
  [391107039,391281580,'Gemini'],
  [391281580,391464280,'Cancer'],
  [391464280,391657802,'Leo'],
  [391657802,391861845,'Virgo'],
  [391861845,392074186,'Libra'],
  [392074186,392291976,'Scorpio'],
  [392291976,392511540,'Sagittarius'],
  [392511540,392727471,'Capricorn'],
  [392727471,392933595,'Aquarius'],
  [392933595,393126125,'Pisces'],
  [393126125,393306033,'Aries'],
  [393306033,393478249,'Taurus'],
  [393478249,393649508,'Gemini'],
  [393649508,393826563,'Cancer'],
  [393826563,394014640,'Leo'],
  [394014640,394215824,'Virgo'],
  [394215824,394428104,'Libra'],
  [394428104,394646542,'Scorpio'],
  [394646542,394865793,'Sagittarius'],
  [394865793,395081261,'Capricorn'],
  [395081261,395289077,'Aquarius'],
  [395289077,395486258,'Pisces'],
  [395486258,395672003,'Aries'],
  [395672003,395848578,'Taurus'],
  [395848578,396020864,'Gemini'],
  [396020864,396195233,'Cancer'],
  [396195233,396378159,'Leo'],
  [396378159,396574307,'Virgo'],
  [396574307,396784015,'Libra'],
  [396784015,397002195,'Scorpio'],
  [397002195,397221235,'Sagittarius'],
  [397221235,397435294,'Capricorn'],
  [397435294,397641802,'Aquarius'],
  [397641802,397840110,'Pisces'],
  [397840110,398030115,'Aries'],
  [398030115,398212455,'Taurus'],
  [398212455,398389393,'Gemini'],
  [398389393,398565331,'Cancer'],
  [398565331,398746263,'Leo'],
  [398746263,398938120,'Virgo'],
  [398938120,399143898,'Libra'],
  [399143898,399360568,'Scorpio'],
  [399360568,399579654,'Sagittarius'],
  [399579654,399792894,'Capricorn'],
  [399792894,399996927,'Aquarius'],
  [399996927,400192767,'Pisces'],
  [400192767,400382689,'Aries'],
  [400382689,400568243,'Taurus'],
  [400568243,400750387,'Gemini'],
  [400750387,400930984,'Cancer'],
  [400930984,401113919,'Leo'],
  [401113919,401304527,'Virgo'],
  [401304527,401507206,'Libra'],
  [401507206,401721694,'Scorpio'],
  [401721694,401940943,'Sagittarius'],
  [401940943,402154970,'Capricorn'],
  [402154970,402357932,'Aquarius'],
  [402357932,402550423,'Pisces'],
  [402550423,402736521,'Aries'],
  [402736521,402920289,'Taurus'],
  [402920289,403104048,'Gemini'],
  [403104048,403288819,'Cancer'],
  [403288819,403476094,'Leo'],
  [403476094,403668932,'Virgo'],
  [403668932,403871049,'Libra'],
  [403871049,404083874,'Scorpio'],
  [404083874,404303122,'Sagittarius'],
  [404303122,404519347,'Capricorn'],
  [404519347,404724208,'Aquarius'],
  [404724208,404915847,'Pisces'],
  [404915847,405098076,'Aries'],
  [405098076,405276706,'Taurus'],
  [405276706,405456753,'Gemini'],
  [405456753,405641172,'Cancer'],
  [405641172,405831197,'Leo'],
  [405831197,406027686,'Virgo'],
  [406027686,406231891,'Libra'],
  [406231891,406444614,'Scorpio'],
  [406444614,406663633,'Sagittarius'],
  [406663633,406882063,'Capricorn'],
  [406882063,407091165,'Aquarius'],
  [407091165,407286060,'Pisces'],
  [407286060,407468142,'Aries'],
  [407468142,407642878,'Taurus'],
  [407642878,407816855,'Gemini'],
  [407816855,407995829,'Cancer'],
  [407995829,408183522,'Leo'],
  [408183522,408381169,'Virgo'],
  [408381169,408587996,'Libra'],
  [408587996,408802201,'Scorpio'],
  [408802201,409021168,'Sagittarius'],
  [409021168,409240401,'Capricorn'],
  [409240401,409453382,'Aquarius'],
  [409453382,409654140,'Pisces'],
  [409654140,409840833,'Aries'],
  [409840833,410016462,'Taurus'],
  [410016462,410187076,'Gemini'],
  [410187076,410359740,'Cancer'],
  [410359740,410540924,'Leo'],
  [410540924,410734761,'Virgo'],
  [410734761,410941387,'Libra'],
  [410941387,411157035,'Scorpio'],
  [411157035,411376493,'Sagittarius'],
  [411376493,411595212,'Capricorn'],
  [411595212,411809254,'Aquarius'],
  [411809254,412014539,'Pisces'],
  [412014539,412207913,'Aries'],
  [412207913,412389172,'Taurus'],
  [412389172,412561808,'Gemini'],
  [412561808,412732110,'Cancer'],
  [412732110,412907527,'Leo'],
  [412907527,413094767,'Virgo'],
  [413094767,413297088,'Libra'],
  [413297088,413511836,'Scorpio'],
  [413511836,413731748,'Sagittarius'],
  [413731748,413949844,'Capricorn'],
  [413949844,414162477,'Aquarius'],
  [414162477,414368177,'Pisces'],
  [414368177,414565541,'Aries'],
  [414565541,414753303,'Taurus'],
  [414753303,414931991,'Gemini'],
  [414931991,415105284,'Cancer'],
  [415105284,415279558,'Leo'],
  [415279558,415462152,'Virgo'],
  [415462152,415658764,'Libra'],
  [415658764,415869884,'Scorpio'],
  [415869884,416089093,'Sagittarius'],
  [416089093,416307131,'Capricorn'],
  [416307131,416518192,'Aquarius'],
  [416518192,416721386,'Pisces'],
  [416721386,416917839,'Aries'],
  [416917839,417108134,'Taurus'],
  [417108134,417292253,'Gemini'],
  [417292253,417471348,'Cancer'],
  [417471348,417649190,'Leo'],
  [417649190,417831725,'Virgo'],
  [417831725,418025048,'Libra'],
  [418025048,418232097,'Scorpio'],
  [418232097,418449336,'Sagittarius'],
  [418449336,418667635,'Capricorn'],
  [418667635,418878644,'Aquarius'],
  [418878644,419079660,'Pisces'],
  [419079660,419272563,'Aries'],
  [419272563,419460376,'Taurus'],
  [419460376,419645145,'Gemini'],
  [419645145,419828057,'Cancer'],
  [419828057,420010889,'Leo'],
  [420010889,420197039,'Virgo'],
  [420197039,420390979,'Libra'],
  [420390979,420596055,'Scorpio'],
  [420596055,420811266,'Sagittarius'],
  [420811266,421029766,'Capricorn'],
  [421029766,421242387,'Aquarius'],
  [421242387,421443726,'Pisces'],
  [421443726,421634198,'Aries'],
  [421634198,421817654,'Taurus'],
  [421817654,421998508,'Gemini'],
  [421998508,422180210,'Cancer'],
  [422180210,422365110,'Leo'],
  [422365110,422555110,'Virgo'],
  [422555110,422752198,'Libra'],
  [422752198,422958080,'Scorpio'],
  [422958080,423172443,'Sagittarius'],
  [423172443,423390994,'Capricorn'],
  [423390994,423605974,'Aquarius'],
  [423605974,423810278,'Pisces'],
  [423810278,424001633,'Aries'],
  [424001633,424182696,'Taurus'],
  [424182696,424358722,'Gemini'],
  [424358722,424535427,'Cancer'],
  [424535427,424717566,'Leo'],
  [424717566,424908066,'Virgo'],
  [424908066,425107770,'Libra'],
  [425107770,425315950,'Scorpio'],
  [425315950,425530902,'Sagittarius'],
  [425530902,425749456,'Capricorn'],
  [425749456,425966262,'Aquarius'],
  [425966262,426174678,'Pisces'],
  [426174678,426370134,'Aries'],
  [426370134,426552699,'Taurus'],
  [426552699,426726616,'Gemini'],
  [426726616,426898394,'Cancer'],
  [426898394,427074892,'Leo'],
  [427074892,427261553,'Virgo'],
  [427261553,427460579,'Libra'],
  [427460579,427670217,'Scorpio'],
  [427670217,427886415,'Sagittarius'],
  [427886415,428105056,'Capricorn'],
  [428105056,428322331,'Aquarius'],
  [428322331,428533735,'Pisces'],
  [428533735,428734443,'Aries'],
  [428734443,428921958,'Taurus'],
  [428921958,429098030,'Gemini'],
  [429098030,429268226,'Cancer'],
  [429268226,429440045,'Leo'],
  [429440045,429620881,'Virgo'],
  [429620881,429815584,'Libra'],
  [429815584,430023905,'Scorpio'],
  [430023905,430240651,'Sagittarius'],
  [430240651,430459464,'Capricorn'],
  [430459464,430676066,'Aquarius'],
  [430676066,430887841,'Pisces'],
  [430887841,431091866,'Aries'],
  [431091866,431285091,'Taurus'],
  [431285091,431466674,'Gemini'],
  [431466674,431639730,'Cancer'],
  [431639730,431810705,'Leo'],
  [431810705,431987394,'Virgo'],
  [431987394,432176573,'Libra'],
  [432176573,432380805,'Scorpio'],
  [432380805,432596272,'Sagittarius'],
  [432596272,432815124,'Capricorn'],
  [432815124,433030904,'Aquarius'],
  [433030904,433240974,'Pisces'],
  [433240974,433444570,'Aries'],
  [433444570,433640542,'Taurus'],
  [433640542,433827595,'Gemini'],
  [433827595,434006409,'Cancer'],
  [434006409,434180934,'Leo'],
  [434180934,434357609,'Virgo'],
  [434357609,434543398,'Libra'],
  [434543398,434742956,'Scorpio'],
  [434742956,434955394,'Sagittarius'],
  [434955394,435173765,'Capricorn'],
  [435173765,435389546,'Aquarius'],
  [435389546,435597971,'Pisces'],
  [435597971,435798620,'Aries'],
  [435798620,435992721,'Taurus'],
  [435992721,436181119,'Gemini'],
  [436181119,436364451,'Cancer'],
  [436364451,436544551,'Leo'],
  [436544551,436725244,'Virgo'],
  [436725244,436911750,'Libra'],
  [436911750,437108850,'Scorpio'],
  [437108850,437318054,'Sagittarius'],
  [437318054,437535262,'Capricorn'],
  [437535262,437752027,'Aquarius'],
  [437752027,437960890,'Pisces'],
  [437960890,438159396,'Aries'],
  [438159396,438349333,'Taurus'],
  [438349333,438534069,'Gemini'],
  [438534069,438716721,'Cancer'],
  [438716721,438899711,'Leo'],
  [438899711,439085221,'Virgo'],
  [439085221,439275738,'Libra'],
  [439275738,439473991,'Scorpio'],
  [439473991,439681750,'Sagittarius'],
  [439681750,439897606,'Capricorn'],
  [439897606,440115566,'Aquarius'],
  [440115566,440327245,'Pisces'],
  [440327245,440527037,'Aries'],
  [440527037,440714812,'Taurus'],
  [440714812,440894566,'Gemini'],
  [440894566,441071888,'Cancer'],
  [441071888,441251959,'Leo'],
  [441251959,441438286,'Virgo'],
  [441438286,441632288,'Libra'],
  [441632288,441833947,'Scorpio'],
  [441833947,442042875,'Sagittarius'],
  [442042875,442258169,'Capricorn'],
  [442258169,442476666,'Aquarius'],
  [442476666,442691796,'Pisces'],
  [442691796,442896169,'Aries'],
  [442896169,443086317,'Taurus'],
  [443086317,443264445,'Gemini'],
  [443264445,443436672,'Cancer'],
  [443436672,443610350,'Leo'],
  [443610350,443791861,'Virgo'],
  [443791861,443984642,'Libra'],
  [443984642,444188174,'Scorpio'],
  [444188174,444399440,'Sagittarius'],
  [444399440,444615470,'Capricorn'],
  [444615470,444833871,'Aquarius'],
  [444833871,445050856,'Pisces'],
  [445050856,445260199,'Aries'],
  [445260199,445456210,'Taurus'],
  [445456210,445637816,'Gemini'],
  [445637816,445809428,'Cancer'],
  [445809428,445978626,'Leo'],
  [445978626,446153515,'Virgo'],
  [446153515,446340411,'Libra'],
  [446340411,446541299,'Scorpio'],
  [446541299,446753057,'Sagittarius'],
  [446753057,446970232,'Capricorn'],
  [446970232,447188572,'Aquarius'],
  [447188572,447405311,'Pisces'],
  [447405311,447616843,'Aries'],
  [447616843,447818269,'Taurus'],
  [447818269,448006311,'Gemini'],
  [448006311,448182317,'Cancer'],
  [448182317,448352099,'Leo'],
  [448352099,448523556,'Virgo'],
  [448523556,448704342,'Libra'],
  [448704342,448899322,'Scorpio'],
  [448899322,449108057,'Sagittarius'],
  [449108057,449325021,'Capricorn'],
  [449325021,449543501,'Aquarius'],
  [449543501,449759183,'Pisces'],
  [449759183,449969716,'Aries'],
  [449969716,450172696,'Taurus'],
  [450172696,450365602,'Gemini'],
  [450365602,450547899,'Cancer'],
  [450547899,450722603,'Leo'],
  [450722603,450895651,'Virgo'],
  [450895651,451074100,'Libra'],
  [451074100,451263996,'Scorpio'],
  [451263996,451467807,'Sagittarius'],
  [451467807,451682495,'Capricorn'],
  [451682495,451900827,'Aquarius'],
  [451900827,452115968,'Pisces'],
  [452115968,452324421,'Aries'],
  [452324421,452525274,'Taurus'],
  [452525274,452718478,'Gemini'],
  [452718478,452904412,'Cancer'],
  [452904412,453084675,'Leo'],
  [453084675,453262665,'Virgo'],
  [453262665,453443271,'Libra'],
  [453443271,453631746,'Scorpio'],
  [453631746,453831827,'Sagittarius'],
  [453831827,454043360,'Capricorn'],
  [454043360,454260984,'Aquarius'],
  [454260984,454476570,'Pisces'],
  [454476570,454684112,'Aries'],
  [454684112,454882000,'Taurus'],
  [454882000,455071886,'Gemini'],
  [455071886,455256608,'Cancer'],
  [455256608,455438936,'Leo'],
  [455438936,455621359,'Virgo'],
  [455621359,455806444,'Libra'],
  [455806444,455997171,'Scorpio'],
  [455997171,456196529,'Sagittarius'],
  [456196529,456405873,'Capricorn'],
  [456405873,456622554,'Aquarius'],
  [456622554,456839339,'Pisces'],
  [456839339,457048151,'Aries'],
  [457048151,457245035,'Taurus'],
  [457245035,457431361,'Gemini'],
  [457431361,457611729,'Cancer'],
  [457611729,457791330,'Leo'],
  [457791330,457974159,'Virgo'],
  [457974159,458162349,'Libra'],
  [458162349,458356738,'Scorpio'],
  [458356738,458558069,'Sagittarius'],
  [458558069,458767189,'Capricorn'],
  [458767189,458983248,'Aquarius'],
  [458983248,459201339,'Pisces'],
  [459201339,459413185,'Aries'],
  [459413185,459612227,'Taurus'],
  [459612227,459797753,'Gemini'],
  [459797753,459974335,'Cancer'],
  [459974335,460148806,'Leo'],
  [460148806,460327560,'Virgo'],
  [460327560,460514610,'Libra'],
  [460514610,460710751,'Scorpio'],
  [460710751,460914729,'Sagittarius'],
  [460914729,461125269,'Capricorn'],
  [461125269,461341376,'Aquarius'],
  [461341376,461560202,'Pisces'],
  [461560202,461775254,'Aries'],
  [461775254,461978860,'Taurus'],
  [461978860,462167463,'Gemini'],
  [462167463,462343775,'Cancer'],
  [462343775,462514601,'Leo'],
  [462514601,462687754,'Virgo'],
  [462687754,462869695,'Libra'],
  [462869695,463063457,'Scorpio'],
  [463063457,463268015,'Sagittarius'],
  [463268015,463480155,'Capricorn'],
  [463480155,463696903,'Aquarius'],
  [463696903,463915701,'Pisces'],
  [463915701,464132313,'Aries'],
  [464132313,464340362,'Taurus'],
  [464340362,464534651,'Gemini'],
  [464534651,464714996,'Cancer'],
  [464714996,464886374,'Leo'],
  [464886374,465056339,'Virgo'],
  [465056339,465232559,'Libra'],
  [465232559,465420658,'Scorpio'],
  [465420658,465622141,'Sagittarius'],
  [465622141,465834116,'Capricorn'],
  [465834116,466051526,'Aquarius'],
  [466051526,466269972,'Pisces'],
  [466269972,466485966,'Aries'],
  [466485966,466695573,'Taurus'],
  [466695573,466894673,'Gemini'],
  [466894673,467081326,'Cancer'],
  [467081326,467257638,'Leo'],
  [467257638,467429131,'Virgo'],
  [467429131,467602864,'Libra'],
  [467602864,467785564,'Scorpio'],
  [467785564,467981523,'Sagittarius'],
  [467981523,468190546,'Capricorn'],
  [468190546,468407667,'Aquarius'],
  [468407667,468626046,'Pisces'],
  [468626046,468840538,'Aries'],
  [468840538,469048384,'Taurus'],
  [469048384,469248117,'Gemini'],
  [469248117,469438970,'Cancer'],
  [469438970,469621556,'Leo'],
  [469621556,469798586,'Virgo'],
  [469798586,469974741,'Libra'],
  [469974741,470155816,'Scorpio'],
  [470155816,470347226,'Sagittarius'],
  [470347226,470551740,'Capricorn'],
  [470551740,470767006,'Aquarius'],
  [470767006,470985640,'Pisces'],
  [470985640,471199671,'Aries'],
  [471199671,471404927,'Taurus'],
  [471404927,471601437,'Gemini'],
  [471601437,471791233,'Cancer'],
  [471791233,471976458,'Leo'],
  [471976458,472158905,'Virgo'],
  [472158905,472340603,'Libra'],
  [472340603,472524676,'Scorpio'],
  [472524676,472715381,'Sagittarius'],
  [472715381,472916674,'Capricorn'],
  [472916674,473129270,'Aquarius'],
  [473129270,473347951,'Pisces'],
  [473347951,473563336,'Aries'],
  [473563336,473768202,'Taurus'],
  [473768202,473961443,'Gemini'],
  [473961443,474146661,'Cancer'],
  [474146661,474328787,'Leo'],
  [474328787,474511645,'Virgo'],
  [474511645,474697114,'Libra'],
  [474697114,474886013,'Scorpio'],
  [474886013,475079815,'Sagittarius'],
  [475079815,475281173,'Capricorn'],
  [475281173,475492077,'Aquarius'],
  [475492077,475710347,'Pisces'],
  [475710347,475927997,'Aries'],
  [475927997,476135606,'Taurus'],
  [476135606,476329030,'Gemini'],
  [476329030,476510942,'Cancer'],
  [476510942,476687635,'Leo'],
  [476687635,476865560,'Virgo'],
  [476865560,477049097,'Libra'],
  [477049097,477239709,'Scorpio'],
  [477239709,477437068,'Sagittarius'],
  [477437068,477641089,'Capricorn'],
  [477641089,477852423,'Aquarius'],
  [477852423,478070319,'Pisces'],
  [478070319,478289615,'Aries'],
  [478289615,478501429,'Taurus'],
  [478501429,478698940,'Gemini'],
  [478698940,478881972,'Cancer'],
  [478881972,479055920,'Leo'],
  [479055920,479228218,'Virgo'],
  [479228218,479405641,'Libra'],
  [479405641,479592471,'Scorpio'],
  [479592471,479789666,'Sagittarius'],
  [479789666,479995814,'Capricorn'],
  [479995814,480208936,'Aquarius'],
  [480208936,480427092,'Pisces'],
  [480427092,480646762,'Aries'],
  [480646762,480861549,'Taurus'],
  [480861549,481064501,'Gemini'],
  [481064501,481252651,'Cancer'],
  [481252651,481428742,'Leo'],
  [481428742,481599175,'Virgo'],
  [481599175,481771335,'Libra'],
  [481771335,481951687,'Scorpio'],
  [481951687,482144151,'Sagittarius'],
  [482144151,482348966,'Capricorn'],
  [482348966,482563022,'Aquarius'],
  [482563022,482781866,'Pisces'],
  [482781866,483001154,'Aries'],
  [483001154,483216355,'Taurus'],
  [483216355,483422676,'Gemini'],
  [483422676,483616673,'Cancer'],
  [483616673,483798449,'Leo'],
  [483798449,483971854,'Virgo'],
  [483971854,484143042,'Libra'],
  [484143042,484318844,'Scorpio'],
  [484318844,484505231,'Sagittarius'],
  [484505231,484705401,'Capricorn'],
  [484705401,484917887,'Aquarius'],
  [484917887,485136918,'Pisces'],
  [485136918,485355798,'Aries'],
  [485355798,485569670,'Taurus'],
  [485569670,485775827,'Gemini'],
  [485775827,485972749,'Cancer'],
  [485972749,486160054,'Leo'],
  [486160054,486339210,'Virgo'],
  [486339210,486513856,'Libra'],
  [486513856,486689439,'Scorpio'],
  [486689439,486872183,'Sagittarius'],
  [486872183,487067290,'Capricorn'],
  [487067290,487276164,'Aquarius'],
  [487276164,487494218,'Pisces'],
  [487494218,487712987,'Aries'],
  [487712987,487925515,'Taurus'],
  [487925515,488129296,'Gemini'],
  [488129296,488325037,'Cancer'],
  [488325037,488514198,'Leo'],
  [488514198,488698011,'Virgo'],
  [488698011,488878028,'Libra'],
  [488878028,489057216,'Scorpio'],
  [489057216,489240325,'Sagittarius'],
  [489240325,489432786,'Capricorn'],
  [489432786,489638080,'Aquarius'],
  [489638080,489854263,'Pisces'],
  [489854263,490073200,'Aries'],
  [490073200,490285686,'Taurus'],
  [490285686,490487456,'Gemini'],
  [490487456,490679835,'Cancer'],
  [490679835,490866531,'Leo'],
  [490866531,491050726,'Virgo'],
  [491050726,491234138,'Libra'],
  [491234138,491417972,'Scorpio'],
  [491417972,491604554,'Sagittarius'],
  [491604554,491797765,'Capricorn'],
  [491797765,492001417,'Aquarius'],
  [492001417,492215830,'Pisces'],
  [492215830,492435029,'Aries'],
  [492435029,492649109,'Taurus'],
  [492649109,492851214,'Gemini'],
  [492851214,493041261,'Cancer'],
  [493041261,493223757,'Leo'],
  [493223757,493404111,'Virgo'],
  [493404111,493586238,'Libra'],
  [493586238,493771977,'Scorpio'],
  [493771977,493962236,'Sagittarius'],
  [493962236,494158517,'Capricorn'],
  [494158517,494363038,'Aquarius'],
  [494363038,494576736,'Pisces'],
  [494576736,494796086,'Aries'],
  [494796086,495012624,'Taurus'],
  [495012624,495217833,'Gemini'],
  [495217833,495408890,'Cancer'],
  [495408890,495589103,'Leo'],
  [495589103,495764650,'Virgo'],
  [495764650,495941653,'Libra'],
  [495941653,496124455,'Scorpio'],
  [496124455,496315085,'Sagittarius'],
  [496315085,496513945,'Capricorn'],
  [496513945,496720843,'Aquarius'],
  [496720843,496935192,'Pisces'],
  [496935192,497154527,'Aries'],
  [497154527,497372910,'Taurus'],
  [497372910,497582495,'Gemini'],
  [497582495,497778108,'Cancer'],
  [497778108,497960265,'Leo'],
  [497960265,498133941,'Virgo'],
  [498133941,498305879,'Libra'],
  [498305879,498482595,'Scorpio'],
  [498482595,498668909,'Sagittarius'],
  [498668909,498866809,'Capricorn'],
  [498866809,499075200,'Aquarius'],
  [499075200,499290963,'Pisces'],
  [499290963,499510345,'Aries'],
  [499510345,499728949,'Taurus'],
  [499728949,499941430,'Gemini'],
  [499941430,500142707,'Cancer'],
  [500142707,500330637,'Leo'],
  [500330637,500507324,'Virgo'],
  [500507324,500678144,'Libra'],
  [500678144,500850030,'Scorpio'],
  [500850030,501029880,'Sagittarius'],
  [501029880,501222691,'Capricorn'],
  [501222691,501429313,'Aquarius'],
  [501429313,501645685,'Pisces'],
  [501645685,501865388,'Aries'],
  [501865388,502083069,'Taurus'],
  [502083069,502295327,'Gemini'],
  [502295327,502499537,'Cancer'],
  [502499537,502693492,'Leo'],
  [502693492,502876680,'Virgo'],
  [502876680,503051506,'Libra'],
  [503051506,503223297,'Scorpio'],
  [503223297,503399100,'Sagittarius'],
  [503399100,503585840,'Capricorn'],
  [503585840,503787527,'Aquarius'],
  [503787527,504002148,'Pisces'],
  [504002148,504222021,'Aries'],
  [504222021,504439051,'Taurus'],
  [504439051,504649217,'Gemini'],
  [504649217,504852065,'Cancer'],
  [504852065,505047868,'Leo'],
  [505047868,505236358,'Virgo'],
  [505236358,505417672,'Libra'],
  [505417672,505594158,'Scorpio'],
  [505594158,505770963,'Sagittarius'],
  [505770963,505954827,'Capricorn'],
  [505954827,506151592,'Aquarius'],
  [506151592,506362488,'Pisces'],
  [506362488,506581571,'Aries'],
  [506581571,506798949,'Taurus'],
  [506798949,507007878,'Gemini'],
  [507007878,507207557,'Cancer'],
  [507207557,507400441,'Leo'],
  [507400441,507588863,'Virgo'],
  [507588863,507773797,'Libra'],
  [507773797,507955930,'Scorpio'],
  [507955930,508137581,'Sagittarius'],
  [508137581,508323289,'Capricorn'],
  [508323289,508518417,'Aquarius'],
  [508518417,508726072,'Pisces'],
  [508726072,508943474,'Aries'],
  [508943474,509161741,'Taurus'],
  [509161741,509371755,'Gemini'],
  [509371755,509570130,'Cancer'],
  [509570130,509759123,'Leo'],
  [509759123,509943117,'Virgo'],
  [509943117,510125819,'Libra'],
  [510125819,510309372,'Scorpio'],
  [510309372,510495180,'Sagittarius'],
  [510495180,510685242,'Capricorn'],
  [510685242,510882508,'Aquarius'],
  [510882508,511089514,'Pisces'],
  [511089514,511305520,'Aries'],
  [511305520,511524459,'Taurus'],
  [511524459,511737260,'Gemini'],
  [511737260,511937744,'Cancer'],
  [511937744,512125804,'Leo'],
  [512125804,512305661,'Virgo'],
  [512305661,512482874,'Libra'],
  [512482874,512662351,'Scorpio'],
  [512662351,512847446,'Sagittarius'],
  [512847446,513039940,'Capricorn'],
  [513039940,513240548,'Aquarius'],
  [513240548,513449366,'Pisces'],
  [513449366,513665278,'Aries'],
  [513665278,513884433,'Taurus'],
  [513884433,514099977,'Gemini'],
  [514099977,514304862,'Cancer'],
  [514304862,514496035,'Leo'],
  [514496035,514675562,'Virgo'],
  [514675562,514848833,'Libra'],
  [514848833,515022379,'Scorpio'],
  [515022379,515202211,'Sagittarius'],
  [515202211,515392392,'Capricorn'],
  [515392392,515593915,'Aquarius'],
  [515593915,515804830,'Pisces'],
  [515804830,516021770,'Aries'],
  [516021770,516240933,'Taurus'],
  [516240933,516457770,'Gemini'],
  [516457770,516666765,'Cancer'],
  [516666765,516863392,'Leo'],
  [516863392,517046812,'Virgo'],
  [517046812,517220431,'Libra'],
  [517220431,517390570,'Scorpio'],
  [517390570,517564592,'Sagittarius'],
  [517564592,517749061,'Capricorn'],
  [517749061,517947450,'Aquarius'],
  [517947450,518158259,'Pisces'],
  [518158259,518376116,'Aries'],
  [518376116,518595320,'Taurus'],
  [518595320,518811856,'Gemini'],
  [518811856,519022507,'Cancer'],
  [519022507,519223752,'Leo'],
  [519223752,519413077,'Virgo'],
  [519413077,519591106,'Libra'],
  [519591106,519762287,'Scorpio'],
  [519762287,519933641,'Sagittarius'],
  [519933641,520112829,'Capricorn'],
  [520112829,520305756,'Aquarius'],
  [520305756,520513455,'Pisces'],
  [520513455,520730811,'Aries'],
  [520730811,520950024,'Taurus'],
  [520950024,521165571,'Gemini'],
  [521165571,521375220,'Cancer'],
  [521375220,521577719,'Leo'],
  [521577719,521771378,'Virgo'],
  [521771378,521955239,'Libra'],
  [521955239,522131128,'Scorpio'],
  [522131128,522304178,'Sagittarius'],
  [522304178,522481489,'Capricorn'],
  [522481489,522669942,'Aquarius'],
  [522669942,522873090,'Pisces'],
  [522873090,523088187,'Aries'],
  [523088187,523307126,'Taurus'],
  [523307126,523522095,'Gemini'],
  [523522095,523729752,'Cancer'],
  [523729752,523930189,'Leo'],
  [523930189,524124040,'Virgo'],
  [524124040,524311307,'Libra'],
  [524311307,524492515,'Scorpio'],
  [524492515,524670348,'Sagittarius'],
  [524670348,524849863,'Capricorn'],
  [524849863,525037161,'Aquarius'],
  [525037161,525236881,'Pisces'],
  [525236881,525448969,'Aries'],
  [525448969,525667207,'Taurus'],
  [525667207,525882629,'Gemini'],
  [525882629,526089430,'Cancer'],
  [526089430,526286965,'Leo'],
  [526286965,526477464,'Virgo'],
  [526477464,526663400,'Libra'],
  [526663400,526846583,'Scorpio'],
  [526846583,527028828,'Sagittarius'],
  [527028828,527212900,'Capricorn'],
  [527212900,527402627,'Aquarius'],
  [527402627,527601776,'Pisces'],
  [527601776,527811716,'Aries'],
  [527811716,528029006,'Taurus'],
  [528029006,528245746,'Gemini'],
  [528245746,528454069,'Cancer'],
  [528454069,528650806,'Leo'],
  [528650806,528837713,'Virgo'],
  [528837713,529018992,'Libra'],
  [529018992,529199081,'Scorpio'],
  [529199081,529381524,'Sagittarius'],
  [529381524,529568748,'Capricorn'],
  [529568748,529762420,'Aquarius'],
  [529762420,529963833,'Pisces'],
  [529963833,530173604,'Aries'],
  [530173604,530390146,'Taurus'],
  [530390146,530608203,'Gemini'],
  [530608203,530819972,'Cancer'],
  [530819972,531019504,'Leo'],
  [531019504,531206048,'Virgo'],
  [531206048,531383462,'Libra'],
  [531383462,531557873,'Scorpio'],
  [531557873,531735516,'Sagittarius'],
  [531735516,531921049,'Capricorn'],
  [531921049,532116376,'Aquarius'],
  [532116376,532320739,'Pisces'],
  [532320739,532532199,'Aries'],
  [532532199,532748706,'Taurus'],
  [532748706,532967221,'Gemini'],
  [532967221,533182254,'Cancer'],
  [533182254,533387053,'Leo'],
  [533387053,533577698,'Virgo'],
  [533577698,533755578,'Libra'],
  [533755578,533926456,'Scorpio'],
  [533926456,534097986,'Sagittarius'],
  [534097986,534277448,'Capricorn'],
  [534277448,534469460,'Aquarius'],
  [534469460,534674024,'Pisces'],
  [534674024,534887242,'Aries'],
  [534887242,535104550,'Taurus'],
  [535104550,535322753,'Gemini'],
  [535322753,535538804,'Cancer'],
  [535538804,535747920,'Leo'],
  [535747920,535944960,'Virgo'],
  [535944960,536128072,'Libra'],
  [536128072,536300568,'Scorpio'],
  [536300568,536469504,'Sagittarius'],
  [536469504,536643141,'Capricorn'],
  [536643141,536828598,'Aquarius'],
  [536828598,537028960,'Pisces'],
  [537028960,537241417,'Aries'],
  [537241417,537459446,'Taurus'],
  [537459446,537677406,'Gemini'],
  [537677406,537892378,'Cancer'],
  [537892378,538102113,'Leo'],
  [538102113,538303312,'Virgo'],
  [538303312,538493007,'Libra'],
  [538493007,538671467,'Scorpio'],
  [538671467,538843229,'Sagittarius'],
  [538843229,539015530,'Capricorn'],
  [539015530,539196049,'Aquarius'],
  [539196049,539390332,'Pisces'],
  [539390332,539598817,'Aries'],
  [539598817,539816010,'Taurus'],
  [539816010,540034099,'Gemini'],
  [540034099,540247836,'Cancer'],
  [540247836,540455352,'Leo'],
  [540455352,540655916,'Virgo'],
  [540655916,540848526,'Libra'],
  [540848526,541032795,'Scorpio'],
  [541032795,541210623,'Sagittarius'],
  [541210623,541386610,'Capricorn'],
  [541386610,541566951,'Aquarius'],
  [541566951,541757527,'Pisces'],
  [541757527,541961304,'Aries'],
  [541961304,542175908,'Taurus'],
  [542175908,542393993,'Gemini'],
  [542393993,542607784,'Cancer'],
  [542607784,542813313,'Leo'],
  [542813313,543010457,'Virgo'],
  [543010457,543200796,'Libra'],
  [543200796,543386100,'Scorpio'],
  [543386100,543568221,'Sagittarius'],
  [543568221,543749655,'Capricorn'],
  [543749655,543933901,'Aquarius'],
  [543933901,544125067,'Pisces'],
  [544125067,544326473,'Aries'],
  [544326473,544538353,'Taurus'],
  [544538353,544755984,'Gemini'],
  [544755984,544971130,'Cancer'],
  [544971130,545177026,'Leo'],
  [545177026,545371784,'Virgo'],
  [545371784,545557782,'Libra'],
  [545557782,545739284,'Scorpio'],
  [545739284,545920443,'Sagittarius'],
  [545920443,546104317,'Capricorn'],
  [546104317,546292841,'Aquarius'],
  [546292841,546487489,'Pisces'],
  [546487489,546689788,'Aries'],
  [546689788,546900533,'Taurus'],
  [546900533,547117606,'Gemini'],
  [547117606,547334572,'Cancer'],
  [547334572,547543247,'Leo'],
  [547543247,547738892,'Virgo'],
  [547738892,547922501,'Libra'],
  [547922501,548099198,'Scorpio'],
  [548099198,548275405,'Sagittarius'],
  [548275405,548456584,'Capricorn'],
  [548456584,548645769,'Aquarius'],
  [548645769,548843305,'Pisces'],
  [548843305,549048237,'Aries'],
  [549048237,549259777,'Taurus'],
  [549259777,549476687,'Gemini'],
  [549476687,549695001,'Cancer'],
  [549695001,549907392,'Leo'],
  [549907392,550107008,'Virgo'],
  [550107008,550292132,'Libra'],
  [550292132,550466805,'Scorpio'],
  [550466805,550638179,'Sagittarius'],
  [550638179,550813711,'Capricorn'],
  [550813711,550998949,'Aquarius'],
  [550998949,551195734,'Pisces'],
  [551195734,551402257,'Aries'],
  [551402257,551615405,'Taurus'],
  [551615405,551832696,'Gemini'],
  [551832696,552051411,'Cancer'],
  [552051411,552266450,'Leo'],
  [552266450,552471041,'Virgo'],
  [552471041,552661022,'Libra'],
  [552661022,552837920,'Scorpio'],
  [552837920,553007893,'Sagittarius'],
  [553007893,553178875,'Capricorn'],
  [553178875,553358212,'Aquarius'],
  [553358212,553550399,'Pisces'],
  [553550399,553755335,'Aries'],
  [553755335,553969100,'Taurus'],
  [553969100,554186962,'Gemini'],
  [554186962,554405364,'Cancer'],
  [554405364,554620810,'Leo'],
  [554620810,554828546,'Virgo'],
  [554828546,555024080,'Libra'],
  [555024080,555206445,'Scorpio'],
  [555206445,555379388,'Sagittarius'],
  [555379388,555549700,'Capricorn'],
  [555549700,555724955,'Aquarius'],
  [555724955,555911433,'Pisces'],
  [555911433,556111832,'Aries'],
  [556111832,556323912,'Taurus'],
  [556323912,556541849,'Gemini'],
  [556541849,556759834,'Cancer'],
  [556759834,556973982,'Leo'],
  [556973982,557181491,'Virgo'],
  [557181491,557379843,'Libra'],
  [557379843,557567687,'Scorpio'],
  [557567687,557746413,'Sagittarius'],
  [557746413,557920351,'Capricorn'],
  [557920351,558095640,'Aquarius'],
  [558095640,558278654,'Pisces'],
  [558278654,558474042,'Aries'],
  [558474042,558682463,'Taurus'],
  [558682463,558899400,'Gemini'],
  [558899400,559117340,'Cancer'],
  [559117340,559330173,'Leo'],
  [559330173,559535173,'Virgo'],
  [559535173,559732096,'Libra'],
  [559732096,559921666,'Scorpio'],
  [559921666,560105154,'Sagittarius'],
  [560105154,560284789,'Capricorn'],
  [560284789,560464103,'Aquarius'],
  [560464103,560647742,'Pisces'],
  [560647742,560840468,'Aries'],
  [560840468,561045145,'Taurus'],
  [561045145,561260113,'Gemini'],
  [561260113,561478387,'Cancer'],
  [561478387,561691448,'Leo'],
  [561691448,561894464,'Virgo'],
  [561894464,562087666,'Libra'],
  [562087666,562274224,'Scorpio'],
  [562274224,562457701,'Sagittarius'],
  [562457701,562640739,'Capricorn'],
  [562640739,562825128,'Aquarius'],
  [562825128,563012793,'Pisces'],
  [563012793,563206573,'Aries'],
  [563206573,563409548,'Taurus'],
  [563409548,563622526,'Gemini'],
  [563622526,563841088,'Cancer'],
  [563841088,564056220,'Leo'],
  [564056220,564260134,'Virgo'],
  [564260134,564451150,'Libra'],
  [564451150,564633085,'Scorpio'],
  [564633085,564811894,'Sagittarius'],
  [564811894,564992799,'Capricorn'],
  [564992799,565178700,'Aquarius'],
  [565178700,565370260,'Pisces'],
  [565370260,565567611,'Aries'],
  [565567611,565771803,'Taurus'],
  [565771803,565984007,'Gemini'],
  [565984007,566202475,'Cancer'],
  [566202475,566420227,'Leo'],
  [566420227,566628033,'Virgo'],
  [566628033,566820984,'Libra'],
  [566820984,567001158,'Scorpio'],
  [567001158,567175028,'Sagittarius'],
  [567175028,567349950,'Capricorn'],
  [567349950,567531664,'Aquarius'],
  [567531664,567722662,'Pisces'],
  [567722662,567922380,'Aries'],
  [567922380,568129281,'Taurus'],
  [568129281,568342456,'Gemini'],
  [568342456,568560730,'Cancer'],
  [568560730,568779880,'Leo'],
  [568779880,568992118,'Virgo'],
  [568992118,569190498,'Libra'],
  [569190498,569373855,'Scorpio'],
  [569373855,569546939,'Sagittarius'],
  [569546939,569717275,'Capricorn'],
  [569717275,569892387,'Aquarius'],
  [569892387,570077754,'Pisces'],
  [570077754,570275216,'Aries'],
  [570275216,570483044,'Taurus'],
  [570483044,570697830,'Gemini'],
  [570697830,570916371,'Cancer'],
  [570916371,571135290,'Leo'],
  [571135290,571349533,'Virgo'],
  [571349533,571553188,'Libra'],
  [571553188,571742913,'Scorpio'],
  [571742913,571920339,'Sagittarius'],
  [571920339,572091099,'Capricorn'],
  [572091099,572262472,'Aquarius'],
  [572262472,572441431,'Pisces'],
  [572441431,572632833,'Aries'],
  [572632833,572837647,'Taurus'],
  [572837647,573052459,'Gemini'],
  [573052459,573271534,'Cancer'],
  [573271534,573489690,'Leo'],
  [573489690,573703019,'Virgo'],
  [573703019,573908286,'Libra'],
  [573908286,574103045,'Scorpio'],
  [574103045,574287000,'Sagittarius'],
  [574287000,574462830,'Capricorn'],
  [574462830,574635683,'Aquarius'],
  [574635683,574811964,'Pisces'],
  [574811964,574997858,'Aries'],
  [574997858,575197298,'Taurus'],
  [575197298,575409508,'Gemini'],
  [575409508,575628443,'Cancer'],
  [575628443,575846307,'Leo'],
  [575846307,576057775,'Virgo'],
  [576057775,576261052,'Libra'],
  [576261052,576456281,'Scorpio'],
  [576456281,576644154,'Sagittarius'],
  [576644154,576825897,'Capricorn'],
  [576825897,577003927,'Aquarius'],
  [577003927,577182361,'Pisces'],
  [577182361,577366633,'Aries'],
  [577366633,577561932,'Taurus'],
  [577561932,577770366,'Gemini'],
  [577770366,577988068,'Cancer'],
  [577988068,578206245,'Leo'],
  [578206245,578416958,'Virgo'],
  [578416958,578617475,'Libra'],
  [578617475,578809563,'Scorpio'],
  [578809563,578996389,'Sagittarius'],
  [578996389,579180432,'Capricorn'],
  [579180432,579363195,'Aquarius'],
  [579363195,579546355,'Pisces'],
  [579546355,579733033,'Aries'],
  [579733033,579927594,'Taurus'],
  [579927594,580133455,'Gemini'],
  [580133455,580349511,'Cancer'],
  [580349511,580568313,'Leo'],
  [580568313,580780151,'Virgo'],
  [580780151,580979827,'Libra'],
  [580979827,581168603,'Scorpio'],
  [581168603,581351264,'Sagittarius'],
  [581351264,581532695,'Capricorn'],
  [581532695,581715992,'Aquarius'],
  [581715992,581902442,'Pisces'],
  [581902442,582093040,'Aries'],
  [582093040,582289877,'Taurus'],
  [582289877,582495604,'Gemini'],
  [582495604,582710642,'Cancer'],
  [582710642,582930037,'Leo'],
  [582930037,583144397,'Virgo'],
  [583144397,583346146,'Libra'],
  [583346146,583534335,'Scorpio'],
  [583534335,583713479,'Sagittarius'],
  [583713479,583889947,'Capricorn'],
  [583889947,584069236,'Aquarius'],
  [584069236,584254574,'Pisces'],
  [584254574,584447022,'Aries'],
  [584447022,584646802,'Taurus'],
  [584646802,584854332,'Gemini'],
  [584854332,585069518,'Cancer'],
  [585069518,585289243,'Leo'],
  [585289243,585506179,'Virgo'],
  [585506179,585712095,'Libra'],
  [585712095,585903330,'Scorpio'],
  [585903330,586082399,'Sagittarius'],
  [586082399,586255423,'Capricorn'],
  [586255423,586429233,'Aquarius'],
  [586429233,586609496,'Pisces'],
  [586609496,586799514,'Aries'],
  [586799514,586999919,'Taurus'],
  [586999919,587209360,'Gemini'],
  [587209360,587425579,'Cancer'],
  [587425579,587645388,'Leo'],
  [587645388,587863581,'Virgo'],
  [587863581,588073507,'Libra'],
  [588073507,588270154,'Scorpio'],
  [588270154,588453207,'Sagittarius'],
  [588453207,588626831,'Capricorn'],
  [588626831,588797501,'Aquarius'],
  [588797501,588972107,'Pisces'],
  [588972107,589156448,'Aries'],
  [589156448,589353636,'Taurus'],
  [589353636,589562880,'Gemini'],
  [589562880,589780016,'Cancer'],
  [589780016,589999856,'Leo'],
  [589999856,590217655,'Virgo'],
  [590217655,590429119,'Libra'],
  [590429119,590630437,'Scorpio'],
  [590630437,590819658,'Sagittarius'],
  [590819658,590998081,'Capricorn'],
  [590998081,591170111,'Aquarius'],
  [591170111,591342121,'Pisces'],
  [591342121,591521044,'Aries'],
  [591521044,591712562,'Taurus'],
  [591712562,591918534,'Gemini'],
  [591918534,592135186,'Cancer'],
  [592135186,592355105,'Leo'],
  [592355105,592571801,'Virgo'],
  [592571801,592781944,'Libra'],
  [592781944,592984254,'Scorpio'],
  [592984254,593177893,'Sagittarius'],
  [593177893,593362631,'Capricorn'],
  [593362631,593540022,'Aquarius'],
  [593540022,593714179,'Pisces'],
  [593714179,593891300,'Aries'],
  [593891300,594078111,'Taurus'],
  [594078111,594279164,'Gemini'],
  [594279164,594493356,'Cancer'],
  [594493356,594713121,'Leo'],
  [594713121,594929378,'Virgo'],
  [594929378,595137332,'Libra'],
  [595137332,595337032,'Scorpio'],
  [595337032,595530280,'Sagittarius'],
  [595530280,595718231,'Capricorn'],
  [595718231,595901340,'Aquarius'],
  [595901340,596081006,'Pisces'],
  [596081006,596260965,'Aries'],
  [596260965,596446913,'Taurus'],
  [596446913,596644396,'Gemini'],
  [596644396,596855198,'Cancer'],
  [596855198,597074149,'Leo'],
  [597074149,597291206,'Virgo'],
  [597291206,597498689,'Libra'],
  [597498689,597695426,'Scorpio'],
  [597695426,597884657,'Sagittarius'],
  [597884657,598070258,'Capricorn'],
  [598070258,598254582,'Aquarius'],
  [598254582,598438602,'Pisces'],
  [598438602,598623659,'Aries'],
  [598623659,598812803,'Taurus'],
  [598812803,599010254,'Gemini'],
  [599010254,599218870,'Cancer'],
  [599218870,599436517,'Leo'],
  [599436517,599654939,'Virgo'],
  [599654939,599864636,'Libra'],
  [599864636,600061419,'Scorpio'],
  [600061419,600247435,'Sagittarius'],
  [600247435,600427877,'Capricorn'],
  [600427877,600607834,'Aquarius'],
  [600607834,600790706,'Pisces'],
  [600790706,600978200,'Aries'],
  [600978200,601171445,'Taurus'],
  [601171445,601371895,'Gemini'],
  [601371895,601580923,'Cancer'],
  [601580923,601797700,'Leo'],
  [601797700,602016967,'Virgo'],
  [602016967,602230198,'Libra'],
  [602230198,602430727,'Scorpio'],
  [602430727,602617709,'Sagittarius'],
  [602617709,602795245,'Capricorn'],
  [602795245,602969503,'Aquarius'],
  [602969503,603146501,'Pisces'],
  [603146501,603330734,'Aries'],
  [603330734,603524434,'Taurus'],
  [603524434,603727611,'Gemini'],
  [603727611,603938857,'Cancer'],
  [603938857,604155963,'Leo'],
  [604155963,604375254,'Virgo'],
  [604375254,604590958,'Libra'],
  [604590958,604796614,'Scorpio'],
  [604796614,604988610,'Sagittarius'],
  [604988610,605168140,'Capricorn'],
  [605168140,605340228,'Aquarius'],
  [605340228,605511703,'Pisces'],
  [605511703,605689416,'Aries'],
  [605689416,605878533,'Taurus'],
  [605878533,606080680,'Gemini'],
  [606080680,606293289,'Cancer'],
  [606293289,606511480,'Leo'],
  [606511480,606730542,'Virgo'],
  [606730542,606946528,'Libra'],
  [606946528,607155361,'Scorpio'],
  [607155361,607353179,'Sagittarius'],
  [607353179,607538454,'Capricorn'],
  [607538454,607713417,'Aquarius'],
  [607713417,607883684,'Pisces'],
  [607883684,608056622,'Aries'],
  [608056622,608239441,'Taurus'],
  [608239441,608436727,'Gemini'],
  [608436727,608647690,'Cancer'],
  [608647690,608866264,'Leo'],
  [608866264,609085269,'Virgo'],
  [609085269,609300170,'Libra'],
  [609300170,609508877,'Scorpio'],
  [609508877,609709599,'Sagittarius'],
  [609709599,609900502,'Capricorn'],
  [609900502,610081345,'Aquarius'],
  [610081345,610255102,'Pisces'],
  [610255102,610427805,'Aries'],
  [610427805,610606874,'Taurus'],
  [610606874,610798755,'Gemini'],
  [610798755,611005594,'Cancer'],
  [611005594,611222838,'Leo'],
  [611222838,611441808,'Virgo'],
  [611441808,611655720,'Libra'],
  [611655720,611862360,'Scorpio'],
  [611862360,612062009,'Sagittarius'],
  [612062009,612254804,'Capricorn'],
  [612254804,612440415,'Aquarius'],
  [612440415,612619702,'Pisces'],
  [612619702,612796199,'Aries'],
  [612796199,612975810,'Taurus'],
  [612975810,613164994,'Gemini'],
  [613164994,613367794,'Cancer'],
  [613367794,613582467,'Leo'],
  [613582467,613801167,'Virgo'],
  [613801167,614015116,'Libra'],
  [614015116,614220110,'Scorpio'],
  [614220110,614416701,'Sagittarius'],
  [614416701,614607161,'Capricorn'],
  [614607161,614793225,'Aquarius'],
  [614793225,614976009,'Pisces'],
  [614976009,615157337,'Aries'],
  [615157337,615340713,'Taurus'],
  [615340713,615530894,'Gemini'],
  [615530894,615731963,'Cancer'],
  [615731963,615944297,'Leo'],
  [615944297,616162504,'Virgo'],
  [616162504,616377651,'Libra'],
  [616377651,616583077,'Scorpio'],
  [616583077,616777642,'Sagittarius'],
  [616777642,616964157,'Capricorn'],
  [616964157,617146549,'Aquarius'],
  [617146549,617328169,'Pisces'],
  [617328169,617511514,'Aries'],
  [617511514,617698777,'Taurus'],
  [617698777,617892342,'Gemini'],
  [617892342,618094504,'Cancer'],
  [618094504,618305972,'Leo'],
  [618305972,618523716,'Virgo'],
  [618523716,618740622,'Libra'],
  [618740622,618948810,'Scorpio'],
  [618948810,619144407,'Sagittarius'],
  [619144407,619328794,'Capricorn'],
  [619328794,619506582,'Aquarius'],
  [619506582,619683318,'Pisces'],
  [619683318,619863908,'Aries'],
  [619863908,620051674,'Taurus'],
  [620051674,620248019,'Gemini'],
  [620248019,620452838,'Cancer'],
  [620452838,620665160,'Leo'],
  [620665160,620882758,'Virgo'],
  [620882758,621100996,'Libra'],
  [621100996,621312998,'Scorpio'],
  [621312998,621512812,'Sagittarius'],
  [621512812,621698985,'Capricorn'],
  [621698985,621874865,'Aquarius'],
  [621874865,622046694,'Pisces'],
  [622046694,622221474,'Aries'],
  [622221474,622405119,'Taurus'],
  [622405119,622600608,'Gemini'],
  [622600608,622807056,'Cancer'],
  [622807056,623021050,'Leo'],
  [623021050,623238971,'Virgo'],
  [623238971,623457471,'Libra'],
  [623457471,623672120,'Scorpio'],
  [623672120,623877245,'Sagittarius'],
  [623877245,624068843,'Capricorn'],
  [624068843,624247402,'Aquarius'],
  [624247402,624417942,'Pisces'],
  [624417942,624587980,'Aries'],
  [624587980,624765335,'Taurus'],
  [624765335,624955795,'Gemini'],
  [624955795,625160424,'Cancer'],
  [625160424,625375057,'Leo'],
  [625375057,625593584,'Virgo'],
  [625593584,625811586,'Libra'],
  [625811586,626026324,'Scorpio'],
  [626026324,626234503,'Sagittarius'],
  [626234503,626432074,'Capricorn'],
  [626432074,626616885,'Aquarius'],
  [626616885,626791100,'Pisces'],
  [626791100,626960848,'Aries'],
  [626960848,627134102,'Taurus'],
  [627134102,627318386,'Gemini'],
  [627318386,627517819,'Cancer'],
  [627517819,627730377,'Leo'],
  [627730377,627948996,'Virgo'],
  [627948996,628166644,'Libra'],
  [628166644,628379797,'Scorpio'],
  [628379797,628587139,'Sagittarius'],
  [628587139,628787047,'Capricorn'],
  [628787047,628977491,'Aquarius'],
  [628977491,629158238,'Pisces'],
  [629158238,629332564,'Aries'],
  [629332564,629506676,'Taurus'],
  [629506676,629687839,'Gemini'],
  [629687839,629881889,'Cancer'],
  [629881889,630090070,'Leo'],
  [630090070,630307318,'Virgo'],
  [630307318,630525135,'Libra'],
  [630525135,630737258,'Scorpio'],
  [630737258,630941832,'Sagittarius'],
  [630941832,631139369,'Capricorn'],
  [631139369,631330466,'Aquarius'],
  [631330466,631515508,'Pisces'],
  [631515508,631695910,'Aries'],
  [631695910,631875057,'Taurus'],
  [631875057,632058006,'Gemini'],
  [632058006,632250040,'Cancer'],
  [632250040,632454265,'Leo'],
  [632454265,632668931,'Virgo'],
  [632668931,632886950,'Libra'],
  [632886950,633099913,'Scorpio'],
  [633099913,633303207,'Sagittarius'],
  [633303207,633497002,'Capricorn'],
  [633497002,633684067,'Aquarius'],
  [633684067,633867585,'Pisces'],
  [633867585,634050215,'Aries'],
  [634050215,634234204,'Taurus'],
  [634234204,634421927,'Gemini'],
  [634421927,634616153,'Cancer'],
  [634616153,634819370,'Leo'],
  [634819370,635031886,'Virgo'],
  [635031886,635249684,'Libra'],
  [635249684,635464830,'Scorpio'],
  [635464830,635669986,'Sagittarius'],
  [635669986,635862704,'Capricorn'],
  [635862704,636045562,'Aquarius'],
  [636045562,636223785,'Pisces'],
  [636223785,636402829,'Aries'],
  [636402829,636586768,'Taurus'],
  [636586768,636777590,'Gemini'],
  [636777590,636975646,'Cancer'],
  [636975646,637180868,'Leo'],
  [637180868,637393088,'Virgo'],
  [637393088,637610487,'Libra'],
  [637610487,637827671,'Scorpio'],
  [637827671,638036816,'Sagittarius'],
  [638036816,638232460,'Capricorn'],
  [638232460,638414816,'Aquarius'],
  [638414816,638588990,'Pisces'],
  [638588990,638762153,'Aries'],
  [638762153,638941029,'Taurus'],
  [638941029,639129881,'Gemini'],
  [639129881,639329277,'Cancer'],
  [639329277,639537032,'Leo'],
  [639537032,639750603,'Virgo'],
  [639750603,639967983,'Libra'],
  [639967983,640186031,'Scorpio'],
  [640186031,640398805,'Sagittarius'],
  [640398805,640599675,'Capricorn'],
  [640599675,640785848,'Aquarius'],
  [640785848,640960334,'Pisces'],
  [640960334,641130088,'Aries'],
  [641130088,641303131,'Taurus'],
  [641303131,641486215,'Gemini'],
  [641486215,641682470,'Cancer'],
  [641682470,641890260,'Leo'],
  [641890260,642105117,'Virgo'],
  [642105117,642322934,'Libra'],
  [642322934,642540762,'Scorpio'],
  [642540762,642754905,'Sagittarius'],
  [642754905,642960087,'Capricorn'],
  [642960087,643152064,'Aquarius'],
  [643152064,643331019,'Pisces'],
  [643331019,643501953,'Aries'],
  [643501953,643672426,'Taurus'],
  [643672426,643850153,'Gemini'],
  [643850153,644040700,'Cancer'],
  [644040700,644245095,'Leo'],
  [644245095,644459407,'Virgo'],
  [644459407,644677558,'Libra'],
  [644677558,644894806,'Scorpio'],
  [644894806,645108069,'Sagittarius'],
  [645108069,645314334,'Capricorn'],
  [645314334,645510475,'Aquarius'],
  [645510475,645695246,'Pisces'],
  [645695246,645871040,'Aries'],
  [645871040,646043425,'Taurus'],
  [646043425,646219380,'Gemini'],
  [646219380,646405318,'Cancer'],
  [646405318,646604771,'Leo'],
  [646604771,646816365,'Virgo'],
  [646816365,647034119,'Libra'],
  [647034119,647251076,'Scorpio'],
  [647251076,647462718,'Sagittarius'],
  [647462718,647667079,'Capricorn'],
  [647667079,647863393,'Aquarius'],
  [647863393,648051530,'Pisces'],
  [648051530,648232688,'Aries'],
  [648232688,648410018,'Taurus'],
  [648410018,648588348,'Gemini'],
  [648588348,648773178,'Cancer'],
  [648773178,648969007,'Leo'],
  [648969007,649177082,'Virgo'],
  [649177082,649393583,'Libra'],
  [649393583,649610816,'Scorpio'],
  [649610816,649821811,'Sagittarius'],
  [649821811,650023580,'Capricorn'],
  [650023580,650216793,'Aquarius'],
  [650216793,650403767,'Pisces'],
  [650403767,650587000,'Aries'],
  [650587000,650768839,'Taurus'],
  [650768839,650951841,'Gemini'],
  [650951841,651139191,'Cancer'],
  [651139191,651334462,'Leo'],
  [651334462,651540136,'Virgo'],
  [651540136,651755079,'Libra'],
  [651755079,651973014,'Scorpio'],
  [651973014,652185264,'Sagittarius'],
  [652185264,652386301,'Capricorn'],
  [652386301,652576189,'Aquarius'],
  [652576189,652758884,'Pisces'],
  [652758884,652939374,'Aries'],
  [652939374,653121652,'Taurus'],
  [653121652,653307952,'Gemini'],
  [653307952,653499331,'Cancer'],
  [653499331,653696962,'Leo'],
  [653696962,653902514,'Virgo'],
  [653902514,654116429,'Libra'],
  [654116429,654335034,'Scorpio'],
  [654335034,654550082,'Sagittarius'],
  [654550082,654753531,'Capricorn'],
  [654753531,654942972,'Aquarius'],
  [654942972,655122021,'Pisces'],
  [655122021,655297246,'Aries'],
  [655297246,655475156,'Taurus'],
  [655475156,655660099,'Gemini'],
  [655660099,655853322,'Cancer'],
  [655853322,656054037,'Leo'],
  [656054037,656261494,'Virgo'],
  [656261494,656475515,'Libra'],
  [656475515,656694361,'Scorpio'],
  [656694361,656912132,'Sagittarius'],
  [656912132,657120278,'Capricorn'],
  [657120278,657313393,'Aquarius'],
  [657313393,657492734,'Pisces'],
  [657492734,657664519,'Aries'],
  [657664519,657836568,'Taurus'],
  [657836568,658015755,'Gemini'],
  [658015755,658205945,'Cancer'],
  [658205945,658407044,'Leo'],
  [658407044,658616497,'Virgo'],
  [658616497,658831673,'Libra'],
  [658831673,659050467,'Scorpio'],
  [659050467,659269232,'Sagittarius'],
  [659269232,659481462,'Capricorn'],
  [659481462,659680660,'Aquarius'],
  [659680660,659864927,'Pisces'],
  [659864927,660038131,'Aries'],
  [660038131,660207462,'Taurus'],
  [660207462,660380745,'Gemini'],
  [660380745,660564383,'Cancer'],
  [660564383,660761312,'Leo'],
  [660761312,660970075,'Virgo'],
  [660970075,661186237,'Libra'],
  [661186237,661405186,'Scorpio'],
  [661405186,661623217,'Sagittarius'],
  [661623217,661836316,'Capricorn'],
  [661836316,662039882,'Aquarius'],
  [662039882,662230826,'Pisces'],
  [662230826,662409953,'Aries'],
  [662409953,662581937,'Taurus'],
  [662581937,662753551,'Gemini'],
  [662753551,662931848,'Cancer'],
  [662931848,663122323,'Leo'],
  [663122323,663326770,'Virgo'],
  [663326770,663541944,'Libra'],
  [663541944,663761172,'Scorpio'],
  [663761172,663978271,'Sagittarius'],
  [663978271,664189499,'Capricorn'],
  [664189499,664392904,'Aquarius'],
  [664392904,664587343,'Pisces'],
  [664587343,664772773,'Aries'],
  [664772773,664951080,'Taurus'],
  [664951080,665126296,'Gemini'],
  [665126296,665304029,'Cancer'],
  [665304029,665490248,'Leo'],
  [665490248,665689315,'Virgo'],
  [665689315,665901211,'Libra'],
  [665901211,666120045,'Scorpio'],
  [666120045,666337174,'Sagittarius'],
  [666337174,666546566,'Capricorn'],
  [666546566,666746845,'Aquarius'],
  [666746845,666939539,'Pisces'],
  [666939539,667126705,'Aries'],
  [667126705,667310007,'Taurus'],
  [667310007,667491135,'Gemini'],
  [667491135,667672855,'Cancer'],
  [667672855,667859439,'Leo'],
  [667859439,668055630,'Virgo'],
  [668055630,668263974,'Libra'],
  [668263974,668481480,'Scorpio'],
  [668481480,668699464,'Sagittarius'],
  [668699464,668909107,'Capricorn'],
  [668909107,669107078,'Aquarius'],
  [669107078,669295662,'Pisces'],
  [669295662,669479431,'Aries'],
  [669479431,669662345,'Taurus'],
  [669662345,669846564,'Gemini'],
  [669846564,670033080,'Cancer'],
  [670033080,670223430,'Leo'],
  [670223430,670420549,'Virgo'],
  [670420549,670627367,'Libra'],
  [670627367,670843462,'Scorpio'],
  [670843462,671062398,'Sagittarius'],
  [671062398,671274379,'Capricorn'],
  [671274379,671473176,'Aquarius'],
  [671473176,671659488,'Pisces'],
  [671659488,671838624,'Aries'],
  [671838624,672016804,'Taurus'],
  [672016804,672198670,'Gemini'],
  [672198670,672386287,'Cancer'],
  [672386287,672579984,'Leo'],
  [672579984,672780171,'Virgo'],
  [672780171,672988000,'Libra'],
  [672988000,673203621,'Scorpio'],
  [673203621,673423112,'Sagittarius'],
  [673423112,673638088,'Capricorn'],
  [673638088,673840575,'Aquarius'],
  [673840575,674028472,'Pisces'],
  [674028472,674205756,'Aries'],
  [674205756,674379212,'Taurus'],
  [674379212,674555499,'Gemini'],
  [674555499,674739298,'Cancer'],
  [674739298,674932459,'Leo'],
  [674932459,675134604,'Virgo'],
  [675134604,675344521,'Libra'],
  [675344521,675560785,'Scorpio'],
  [675560785,675780401,'Sagittarius'],
  [675780401,675997363,'Capricorn'],
  [675997363,676204305,'Aquarius'],
  [676204305,676396931,'Pisces'],
  [676396931,676576585,'Aries'],
  [676576585,676748792,'Taurus'],
  [676748792,676920573,'Gemini'],
  [676920573,677098463,'Cancer'],
  [677098463,677287004,'Leo'],
  [677287004,677487599,'Virgo'],
  [677487599,677698399,'Libra'],
  [677698399,677915666,'Scorpio'],
  [677915666,678135215,'Sagittarius'],
  [678135215,678352383,'Capricorn'],
  [678352383,678562019,'Aquarius'],
  [678562019,678759863,'Pisces'],
  [678759863,678944926,'Aries'],
  [678944926,679120193,'Taurus'],
  [679120193,679291359,'Gemini'],
  [679291359,679465178,'Cancer'],
  [679465178,679647977,'Leo'],
  [679647977,679843888,'Virgo'],
  [679843888,680052881,'Libra'],
  [680052881,680270365,'Scorpio'],
  [680270365,680489857,'Sagittarius'],
  [680489857,680705999,'Capricorn'],
  [680705999,680915392,'Aquarius'],
  [680915392,681115854,'Pisces'],
  [681115854,681306216,'Aries'],
  [681306216,681487195,'Taurus'],
  [681487195,681661941,'Gemini'],
  [681661941,681835764,'Cancer'],
  [681835764,682015122,'Leo'],
  [682015122,682205942,'Virgo'],
  [682205942,682410963,'Libra'],
  [682410963,682627137,'Scorpio'],
  [682627137,682846596,'Sagittarius'],
  [682846596,683061743,'Capricorn'],
  [683061743,683269004,'Aquarius'],
  [683269004,683468272,'Pisces'],
  [683468272,683660422,'Aries'],
  [683660422,683846134,'Taurus'],
  [683846134,684026485,'Gemini'],
  [684026485,684204208,'Cancer'],
  [684204208,684384166,'Leo'],
  [684384166,684572349,'Virgo'],
  [684572349,684773408,'Libra'],
  [684773408,684987075,'Scorpio'],
  [684987075,685206368,'Sagittarius'],
  [685206368,685421642,'Capricorn'],
  [685421642,685627212,'Aquarius'],
  [685627212,685823236,'Pisces'],
  [685823236,686012819,'Aries'],
  [686012819,686198837,'Taurus'],
  [686198837,686382748,'Gemini'],
  [686382748,686565530,'Cancer'],
  [686565530,686749467,'Leo'],
  [686749467,686938755,'Virgo'],
  [686938755,687138083,'Libra'],
  [687138083,687349350,'Scorpio'],
  [687349350,687568198,'Sagittarius'],
  [687568198,687784928,'Capricorn'],
  [687784928,687991207,'Aquarius'],
  [687991207,688185253,'Pisces'],
  [688185253,688370638,'Aries'],
  [688370638,688552492,'Taurus'],
  [688552492,688734772,'Gemini'],
  [688734772,688919426,'Cancer'],
  [688919426,689107436,'Leo'],
  [689107436,689300446,'Virgo'],
  [689300446,689501132,'Libra'],
  [689501132,689711532,'Scorpio'],
  [689711532,689929777,'Sagittarius'],
  [689929777,690148389,'Capricorn'],
  [690148389,690357983,'Aquarius'],
  [690357983,690553723,'Pisces'],
  [690553723,690737360,'Aries'],
  [690737360,690914435,'Taurus'],
  [690914435,691091077,'Gemini'],
  [691091077,691272048,'Cancer'],
  [691272048,691459963,'Leo'],
  [691459963,691655709,'Virgo'],
  [691655709,691859439,'Libra'],
  [691859439,692071027,'Scorpio'],
  [692071027,692289012,'Sagittarius'],
  [692289012,692508645,'Capricorn'],
  [692508645,692722202,'Aquarius'],
  [692722202,692923007,'Pisces'],
  [692923007,693109581,'Aries'],
  [693109581,693285624,'Taurus'],
  [693285624,693457474,'Gemini'],
  [693457474,693631879,'Cancer'],
  [693631879,693814436,'Leo'],
  [693814436,694008276,'Virgo'],
  [694008276,694213317,'Libra'],
  [694213317,694426902,'Scorpio'],
  [694426902,694645426,'Sagittarius'],
  [694645426,694864908,'Capricorn'],
  [694864908,695080441,'Aquarius'],
  [695080441,695286494,'Pisces'],
  [695286494,695479395,'Aries'],
  [695479395,695659583,'Taurus'],
  [695659583,695831439,'Gemini'],
  [695831439,696001669,'Cancer'],
  [696001669,696177564,'Leo'],
  [696177564,696365230,'Virgo'],
  [696365230,696567250,'Libra'],
  [696567250,696781025,'Scorpio'],
  [696781025,697000385,'Sagittarius'],
  [697000385,697219415,'Capricorn'],
  [697219415,697434309,'Aquarius'],
  [697434309,697642292,'Pisces'],
  [697642292,697840592,'Aries'],
  [697840592,698027572,'Taurus'],
  [698027572,698204438,'Gemini'],
  [698204438,698375806,'Cancer'],
  [698375806,698548622,'Leo'],
  [698548622,698730344,'Virgo'],
  [698730344,698926459,'Libra'],
  [698926459,699137173,'Scorpio'],
  [699137173,699356265,'Sagittarius'],
  [699356265,699575204,'Capricorn'],
  [699575204,699788574,'Aquarius'],
  [699788574,699994944,'Pisces'],
  [699994944,700194170,'Aries'],
  [700194170,700385618,'Taurus'],
  [700385618,700568856,'Gemini'],
  [700568856,700745567,'Cancer'],
  [700745567,700920481,'Leo'],
  [700920481,701100362,'Virgo'],
  [701100362,701291800,'Libra'],
  [701291800,701497884,'Scorpio'],
  [701497884,701714964,'Sagittarius'],
  [701714964,701933936,'Capricorn'],
  [701933936,702146723,'Aquarius'],
  [702146723,702350668,'Pisces'],
  [702350668,702547085,'Aries'],
  [702547085,702737886,'Taurus'],
  [702737886,702923952,'Gemini'],
  [702923952,703105912,'Cancer'],
  [703105912,703285934,'Leo'],
  [703285934,703468455,'Virgo'],
  [703468455,703659090,'Libra'],
  [703659090,703862009,'Scorpio'],
  [703862009,704076432,'Sagittarius'],
  [704076432,704295183,'Capricorn'],
  [704295183,704508845,'Aquarius'],
  [704508845,704712141,'Pisces'],
  [704712141,704905523,'Aries'],
  [704905523,705092380,'Taurus'],
  [705092380,705276120,'Gemini'],
  [705276120,705459026,'Cancer'],
  [705459026,705642805,'Leo'],
  [705642805,705829727,'Virgo'],
  [705829727,706023015,'Libra'],
  [706023015,706225791,'Scorpio'],
  [706225791,706438578,'Sagittarius'],
  [706438578,706656926,'Capricorn'],
  [706656926,706872386,'Aquarius'],
  [706872386,707077608,'Pisces'],
  [707077608,707270579,'Aries'],
  [707270579,707454095,'Taurus'],
  [707454095,707633018,'Gemini'],
  [707633018,707812133,'Cancer'],
  [707812133,707995093,'Leo'],
  [707995093,708184239,'Virgo'],
  [708184239,708380925,'Libra'],
  [708380925,708585881,'Scorpio'],
  [708585881,708798803,'Sagittarius'],
  [708798803,709016890,'Capricorn'],
  [709016890,709234070,'Aquarius'],
  [709234070,709442903,'Pisces'],
  [709442903,709638817,'Aries'],
  [709638817,709822341,'Taurus'],
  [709822341,709997913,'Gemini'],
  [709997913,710171701,'Cancer'],
  [710171701,710349784,'Leo'],
  [710349784,710536695,'Virgo'],
  [710536695,710734263,'Libra'],
  [710734263,710941485,'Scorpio'],
  [710941485,711155773,'Sagittarius'],
  [711155773,711373958,'Capricorn'],
  [711373958,711591930,'Aquarius'],
  [711591930,711804115,'Pisces'],
  [711804115,712005004,'Aries'],
  [712005004,712192345,'Taurus'],
  [712192345,712368468,'Gemini'],
  [712368468,712539194,'Cancer'],
  [712539194,712711829,'Leo'],
  [712711829,712893241,'Virgo'],
  [712893241,713087672,'Libra'],
  [713087672,713294789,'Scorpio'],
  [713294789,713510244,'Sagittarius'],
  [713510244,713728814,'Capricorn'],
  [713728814,713946534,'Aquarius'],
  [713946534,714160010,'Pisces'],
  [714160010,714365129,'Aries'],
  [714365129,714558268,'Taurus'],
  [714558268,714738928,'Gemini'],
  [714738928,714910894,'Cancer'],
  [714910894,715081039,'Leo'],
  [715081039,715257243,'Virgo'],
  [715257243,715446080,'Libra'],
  [715446080,715649816,'Scorpio'],
  [715649816,715864694,'Sagittarius'],
  [715864694,716083548,'Capricorn'],
  [716083548,716300602,'Aquarius'],
  [716300602,716513087,'Pisces'],
  [716513087,716719221,'Aries'],
  [716719221,716916594,'Taurus'],
  [716916594,717103303,'Gemini'],
  [717103303,717280367,'Cancer'],
  [717280367,717452557,'Leo'],
  [717452557,717627047,'Virgo'],
  [717627047,717811252,'Libra'],
  [717811252,718009922,'Scorpio'],
  [718009922,718221975,'Sagittarius'],
  [718221975,718440435,'Capricorn'],
  [718440435,718657228,'Aquarius'],
  [718657228,718867994,'Pisces'],
  [718867994,719071975,'Aries'],
  [719071975,719269260,'Taurus'],
  [719269260,719459325,'Gemini'],
  [719459325,719642072,'Cancer'],
  [719642072,719819665,'Leo'],
  [719819665,719996955,'Virgo'],
  [719996955,720180286,'Libra'],
  [720180286,720375229,'Scorpio'],
  [720375229,720583462,'Sagittarius'],
  [720583462,720800521,'Capricorn'],
  [720800521,721017772,'Aquarius'],
  [721017772,721228143,'Pisces'],
  [721228143,721429493,'Aries'],
  [721429493,721623194,'Taurus'],
  [721623194,721811421,'Gemini'],
  [721811421,721995852,'Cancer'],
  [721995852,722178087,'Leo'],
  [722178087,722360621,'Virgo'],
  [722360621,722547191,'Libra'],
  [722547191,722741992,'Scorpio'],
  [722741992,722947700,'Sagittarius'],
  [722947700,723162847,'Capricorn'],
  [723162847,723380806,'Aquarius'],
  [723380806,723593001,'Pisces'],
  [723593001,723794279,'Aries'],
  [723794279,723984799,'Taurus'],
  [723984799,724168117,'Gemini'],
  [724168117,724348709,'Cancer'],
  [724348709,724530424,'Leo'],
  [724530424,724715931,'Virgo'],
  [724715931,724906965,'Libra'],
  [724906965,725104907,'Scorpio'],
  [725104907,725310940,'Sagittarius'],
  [725310940,725524877,'Capricorn'],
  [725524877,725743132,'Aquarius'],
  [725743132,725958344,'Pisces'],
  [725958344,726163018,'Aries'],
  [726163018,726354200,'Taurus'],
  [726354200,726534361,'Gemini'],
  [726534361,726709262,'Cancer'],
  [726709262,726885422,'Leo'],
  [726885422,727068161,'Virgo'],
  [727068161,727260174,'Libra'],
  [727260174,727461266,'Scorpio'],
  [727461266,727669778,'Sagittarius'],
  [727669778,727884116,'Capricorn'],
  [727884116,728102237,'Aquarius'],
  [728102237,728319637,'Pisces'],
  [728319637,728529217,'Aries'],
  [728529217,728725199,'Taurus'],
  [728725199,728907019,'Gemini'],
  [728907019,729079420,'Cancer'],
  [729079420,729249892,'Leo'],
  [729249892,729426094,'Virgo'],
  [729426094,729613629,'Libra'],
  [729613629,729813917,'Scorpio'],
  [729813917,730024114,'Sagittarius'],
  [730024114,730239905,'Capricorn'],
  [730239905,730458053,'Aquarius'],
  [730458053,730675796,'Pisces'],
  [730675796,730888566,'Aries'],
  [730888566,731090459,'Taurus'],
  [731090459,731278027,'Gemini'],
  [731278027,731453157,'Cancer'],
  [731453157,731622229,'Leo'],
  [731622229,731793413,'Virgo'],
  [731793413,731974306,'Libra'],
  [731974306,732169378,'Scorpio'],
  [732169378,732377749,'Sagittarius'],
  [732377749,732594094,'Capricorn'],
  [732594094,732812593,'Aquarius'],
  [732812593,733029597,'Pisces'],
  [733029597,733242421,'Aries'],
  [733242421,733447421,'Taurus'],
  [733447421,733640919,'Gemini'],
  [733640919,733822171,'Cancer'],
  [733822171,733994870,'Leo'],
  [733994870,734165817,'Virgo'],
  [734165817,734342693,'Libra'],
  [734342693,734531785,'Scorpio'],
  [734531785,734735315,'Sagittarius'],
  [734735315,734949863,'Capricorn'],
  [734949863,735168389,'Aquarius'],
  [735168389,735384779,'Pisces'],
  [735384779,735595856,'Aries'],
  [735595856,735799984,'Taurus'],
  [735799984,735995653,'Gemini'],
  [735995653,736182061,'Cancer'],
  [736182061,736360686,'Leo'],
  [736360686,736535754,'Virgo'],
  [736535754,736713278,'Libra'],
  [736713278,736899399,'Scorpio'],
  [736899399,737098198,'Sagittarius'],
  [737098198,737309277,'Capricorn'],
  [737309277,737526963,'Aquarius'],
  [737526963,737743398,'Pisces'],
  [737743398,737953126,'Aries'],
  [737953126,738154447,'Taurus'],
  [738154447,738348000,'Gemini'],
  [738348000,738535162,'Cancer'],
  [738535162,738717667,'Leo'],
  [738717667,738897988,'Virgo'],
  [738897988,739079629,'Libra'],
  [739079629,739266873,'Scorpio'],
  [739266873,739463682,'Sagittarius'],
  [739463682,739671688,'Capricorn'],
  [739671688,739887950,'Aquarius'],
  [739887950,740105025,'Pisces'],
  [740105025,740315152,'Aries'],
  [740315152,740514649,'Taurus'],
  [740514649,740704496,'Gemini'],
  [740704496,740888269,'Cancer'],
  [740888269,741069925,'Leo'],
  [741069925,741252602,'Virgo'],
  [741252602,741438483,'Libra'],
  [741438483,741629403,'Scorpio'],
  [741629403,741827445,'Sagittarius'],
  [741827445,742034357,'Capricorn'],
  [742034357,742249417,'Aquarius'],
  [742249417,742467352,'Pisces'],
  [742467352,742679709,'Aries'],
  [742679709,742880143,'Taurus'],
  [742880143,743068011,'Gemini'],
  [743068011,743247480,'Cancer'],
  [743247480,743424613,'Leo'],
  [743424613,743604867,'Virgo'],
  [743604867,743791536,'Libra'],
  [743791536,743985492,'Scorpio'],
  [743985492,744186456,'Sagittarius'],
  [744186456,744394423,'Capricorn'],
  [744394423,744609150,'Aquarius'],
  [744609150,744827704,'Pisces'],
  [744827704,745043033,'Aries'],
  [745043033,745247155,'Taurus'],
  [745247155,745436648,'Gemini'],
  [745436648,745614354,'Cancer'],
  [745614354,745786933,'Leo'],
  [745786933,745961775,'Virgo'],
  [745961775,746144652,'Libra'],
  [746144652,746337972,'Scorpio'],
  [746337972,746540753,'Sagittarius'],
  [746540753,746750707,'Capricorn'],
  [746750707,746966050,'Aquarius'],
  [746966050,747184755,'Pisces'],
  [747184755,747402125,'Aries'],
  [747402125,747610839,'Taurus'],
  [747610839,747805251,'Gemini'],
  [747805251,747985445,'Cancer'],
  [747985445,748156845,'Leo'],
  [748156845,748327225,'Virgo'],
  [748327225,748504136,'Libra'],
  [748504136,748692687,'Scorpio'],
  [748692687,748893776,'Sagittarius'],
  [748893776,749104536,'Capricorn'],
  [749104536,749320866,'Aquarius'],
  [749320866,749539452,'Pisces'],
  [749539452,749756944,'Aries'],
  [749756944,749968364,'Taurus'],
  [749968364,750168279,'Gemini'],
  [750168279,750354336,'Cancer'],
  [750354336,750529219,'Leo'],
  [750529219,750699283,'Virgo'],
  [750699283,750872148,'Libra'],
  [750872148,751054641,'Scorpio'],
  [751054641,751250612,'Sagittarius'],
  [751250612,751459277,'Capricorn'],
  [751459277,751675817,'Aquarius'],
  [751675817,751894414,'Pisces'],
  [751894414,752110733,'Aries'],
  [752110733,752321549,'Taurus'],
  [752321549,752523853,'Gemini'],
  [752523853,752715460,'Cancer'],
  [752715460,752896723,'Leo'],
  [752896723,753071197,'Virgo'],
  [753071197,753244712,'Libra'],
  [753244712,753423880,'Scorpio'],
  [753423880,753614320,'Sagittarius'],
  [753614320,753818399,'Capricorn'],
  [753818399,754033332,'Aquarius'],
  [754033332,754252074,'Pisces'],
  [754252074,754467581,'Aries'],
  [754467581,754675970,'Taurus'],
  [754675970,754876322,'Gemini'],
  [754876322,755069023,'Cancer'],
  [755069023,755254919,'Leo'],
  [755254919,755435627,'Virgo'],
  [755435627,755614098,'Libra'],
  [755614098,755794768,'Scorpio'],
  [755794768,755982860,'Sagittarius'],
  [755982860,756182615,'Capricorn'],
  [756182615,756394475,'Aquarius'],
  [756394475,756612974,'Pisces'],
  [756612974,756829110,'Aries'],
  [756829110,757036218,'Taurus'],
  [757036218,757233031,'Gemini'],
  [757233031,757422153,'Cancer'],
  [757422153,757607137,'Leo'],
  [757607137,757790678,'Virgo'],
  [757790678,757974409,'Libra'],
  [757974409,758159952,'Scorpio'],
  [758159952,758350099,'Sagittarius'],
  [758350099,758548581,'Capricorn'],
  [758548581,758757821,'Aquarius'],
  [758757821,758975465,'Pisces'],
  [758975465,759193265,'Aries'],
  [759193265,759401932,'Taurus'],
  [759401932,759597530,'Gemini'],
  [759597530,759782512,'Cancer'],
  [759782512,759962486,'Leo'],
  [759962486,760142915,'Virgo'],
  [760142915,760327178,'Libra'],
  [760327178,760516323,'Scorpio'],
  [760516323,760710610,'Sagittarius'],
  [760710610,760911241,'Capricorn'],
  [760911241,761120086,'Aquarius'],
  [761120086,761336895,'Pisces'],
  [761336895,761556170,'Aries'],
  [761556170,761768438,'Taurus'],
  [761768438,761966749,'Gemini'],
  [761966749,762151122,'Cancer'],
  [762151122,762327008,'Leo'],
  [762327008,762501566,'Virgo'],
  [762501566,762680904,'Libra'],
  [762680904,762868379,'Scorpio'],
  [762868379,763064393,'Sagittarius'],
  [763064393,763268000,'Capricorn'],
  [763268000,763478564,'Aquarius'],
  [763478564,763695398,'Pisces'],
  [763695398,763915221,'Aries'],
  [763915221,764130781,'Taurus'],
  [764130781,764334188,'Gemini'],
  [764334188,764522384,'Cancer'],
  [764522384,764698596,'Leo'],
  [764698596,764869634,'Virgo'],
  [764869634,765042911,'Libra'],
  [765042911,765224417,'Scorpio'],
  [765224417,765417219,'Sagittarius'],
  [765417219,765621025,'Capricorn'],
  [765621025,765833307,'Aquarius'],
  [765833307,766051003,'Pisces'],
  [766051003,766270717,'Aries'],
  [766270717,766487488,'Taurus'],
  [766487488,766695127,'Gemini'],
  [766695127,766889240,'Cancer'],
  [766889240,767070124,'Leo'],
  [767070124,767242437,'Virgo'],
  [767242437,767412995,'Libra'],
  [767412995,767588805,'Scorpio'],
  [767588805,767775471,'Sagittarius'],
  [767775471,767975498,'Capricorn'],
  [767975498,768187168,'Aquarius'],
  [768187168,768405511,'Pisces'],
  [768405511,768625018,'Aries'],
  [768625018,768841061,'Taurus'],
  [768841061,769049805,'Gemini'],
  [769049805,769248189,'Cancer'],
  [769248189,769435132,'Leo'],
  [769435132,769612572,'Virgo'],
  [769612572,769785136,'Libra'],
  [769785136,769959044,'Scorpio'],
  [769959044,770140774,'Sagittarius'],
  [770140774,770335300,'Capricorn'],
  [770335300,770543643,'Aquarius'],
  [770543643,770761334,'Pisces'],
  [770761334,770980736,'Aries'],
  [770980736,771195487,'Taurus'],
  [771195487,771402573,'Gemini'],
  [771402573,771601318,'Cancer'],
  [771601318,771791834,'Leo'],
  [771791834,771974900,'Virgo'],
  [771974900,772152622,'Libra'],
  [772152622,772328986,'Scorpio'],
  [772328986,772509569,'Sagittarius'],
  [772509569,772700183,'Capricorn'],
  [772700183,772904328,'Aquarius'],
  [772904328,773119989,'Pisces'],
  [773119989,773339295,'Aries'],
  [773339295,773553522,'Taurus'],
  [773553522,773758374,'Gemini'],
  [773758374,773954392,'Cancer'],
  [773954392,774144062,'Leo'],
  [774144062,774329472,'Virgo'],
  [774329472,774511934,'Libra'],
  [774511934,774693128,'Scorpio'],
  [774693128,774876363,'Sagittarius'],
  [774876363,775066481,'Capricorn'],
  [775066481,775267908,'Aquarius'],
  [775267908,775481185,'Pisces'],
  [775481185,775700299,'Aries'],
  [775700299,775915366,'Taurus'],
  [775915366,776119602,'Gemini'],
  [776119602,776312707,'Cancer'],
  [776312707,776498568,'Leo'],
  [776498568,776681654,'Virgo'],
  [776681654,776864895,'Libra'],
  [776864895,777049615,'Scorpio'],
  [777049615,777237060,'Sagittarius'],
  [777237060,777429774,'Capricorn'],
  [777429774,777631183,'Aquarius'],
  [777631183,777843022,'Pisces'],
  [777843022,778061859,'Aries'],
  [778061859,778278797,'Taurus'],
  [778278797,778485029,'Gemini'],
  [778485029,778677782,'Cancer'],
  [778677782,778860375,'Leo'],
  [778860375,779038667,'Virgo'],
  [779038667,779218037,'Libra'],
  [779218037,779401824,'Scorpio'],
  [779401824,779591400,'Sagittarius'],
  [779591400,779787476,'Capricorn'],
  [779787476,779991116,'Aquarius'],
  [779991116,780203157,'Pisces'],
  [780203157,780421772,'Aries'],
  [780421772,780640510,'Taurus'],
  [780640510,780850604,'Gemini'],
  [780850604,781046629,'Cancer'],
  [781046629,781229493,'Leo'],
  [781229493,781404522,'Virgo'],
  [781404522,781578367,'Libra'],
  [781578367,781756897,'Scorpio'],
  [781756897,781943912,'Sagittarius'],
  [781943912,782140730,'Capricorn'],
  [782140730,782346727,'Aquarius'],
  [782346727,782560283,'Pisces'],
  [782560283,782778965,'Aries'],
  [782778965,782998353,'Taurus'],
  [782998353,783211877,'Gemini'],
  [783211877,783413381,'Cancer'],
  [783413381,783600797,'Leo'],
  [783600797,783777010,'Virgo'],
  [783777010,783947995,'Libra'],
  [783947995,784120722,'Scorpio'],
  [784120722,784301546,'Sagittarius'],
  [784301546,784494577,'Capricorn'],
  [784494577,784700199,'Aquarius'],
  [784700199,784915071,'Pisces'],
  [784915071,785134255,'Aries'],
  [785134255,785353130,'Taurus'],
  [785353130,785567502,'Gemini'],
  [785567502,785773179,'Cancer'],
  [785773179,785967017,'Leo'],
  [785967017,786148850,'Virgo'],
  [786148850,786322072,'Libra'],
  [786322072,786492754,'Scorpio'],
  [786492754,786668118,'Sagittarius'],
  [786668118,786854773,'Capricorn'],
  [786854773,787056165,'Aquarius'],
  [787056165,787270128,'Pisces'],
  [787270128,787489770,'Aries'],
  [787489770,787708020,'Taurus'],
  [787708020,787920875,'Gemini'],
  [787920875,788126722,'Cancer'],
  [788126722,788324315,'Leo'],
  [788324315,788512582,'Virgo'],
  [788512582,788692000,'Libra'],
  [788692000,788865914,'Scorpio'],
  [788865914,789040351,'Sagittarius'],
  [789040351,789222494,'Capricorn'],
  [789222494,789418225,'Aquarius'],
  [789418225,789628571,'Pisces'],
  [789628571,789847588,'Aries'],
  [789847588,790065888,'Taurus'],
  [790065888,790277156,'Gemini'],
  [790277156,790480265,'Cancer'],
  [790480265,790676580,'Leo'],
  [790676580,790867100,'Virgo'],
  [790867100,791051947,'Libra'],
  [791051947,791231930,'Scorpio'],
  [791231930,791410281,'Sagittarius'],
  [791410281,791592626,'Capricorn'],
  [791592626,791785157,'Aquarius'],
  [791785157,791991373,'Pisces'],
  [791991373,792208404,'Aries'],
  [792208404,792427163,'Taurus'],
  [792427163,792638641,'Gemini'],
  [792638641,792839617,'Cancer'],
  [792839617,793032073,'Leo'],
  [793032073,793219536,'Virgo'],
  [793219536,793404496,'Libra'],
  [793404496,793588111,'Scorpio'],
  [793588111,793771670,'Sagittarius'],
  [793771670,793958053,'Capricorn'],
  [793958053,794151571,'Aquarius'],
  [794151571,794355936,'Pisces'],
  [794355936,794570856,'Aries'],
  [794570856,794789863,'Taurus'],
  [794789863,795003346,'Gemini'],
  [795003346,795205150,'Cancer'],
  [795205150,795395417,'Leo'],
  [795395417,795578273,'Virgo'],
  [795578273,795758594,'Libra'],
  [795758594,795940146,'Scorpio'],
  [795940146,796125238,'Sagittarius'],
  [796125238,796315460,'Capricorn'],
  [796315460,796512508,'Aquarius'],
  [796512508,796718082,'Pisces'],
  [796718082,796932257,'Aries'],
  [796932257,797151197,'Taurus'],
  [797151197,797367159,'Gemini'],
  [797367159,797572511,'Cancer'],
  [797572511,797764431,'Leo'],
  [797764431,797945417,'Virgo'],
  [797945417,798120872,'Libra'],
  [798120872,798296752,'Scorpio'],
  [798296752,798478063,'Sagittarius'],
  [798478063,798667941,'Capricorn'],
  [798667941,798867330,'Aquarius'],
  [798867330,799075451,'Pisces'],
  [799075451,799290515,'Aries'],
  [799290515,799509412,'Taurus'],
  [799509412,799726947,'Gemini'],
  [799726947,799936491,'Cancer'],
  [799936491,800133158,'Leo'],
  [800133158,800316587,'Virgo'],
  [800316587,800490716,'Libra'],
  [800490716,800661931,'Scorpio'],
  [800661931,800837170,'Sagittarius'],
  [800837170,801022249,'Capricorn'],
  [801022249,801220012,'Aquarius'],
  [801220012,801429190,'Pisces'],
  [801429190,801645622,'Aries'],
  [801645622,801864727,'Taurus'],
  [801864727,802082453,'Gemini'],
  [802082453,802294512,'Cancer'],
  [802294512,802496317,'Leo'],
  [802496317,802685219,'Virgo'],
  [802685219,802862440,'Libra'],
  [802862440,803033005,'Scorpio'],
  [803033005,803204123,'Sagittarius'],
  [803204123,803383283,'Capricorn'],
  [803383283,803575988,'Aquarius'],
  [803575988,803783013,'Pisces'],
  [803783013,803999641,'Aries'],
  [803999641,804219008,'Taurus'],
  [804219008,804436064,'Gemini'],
  [804436064,804648039,'Cancer'],
  [804648039,804852467,'Leo'],
  [804852467,805046685,'Virgo'],
  [805046685,805229658,'Libra'],
  [805229658,805403832,'Scorpio'],
  [805403832,805575037,'Sagittarius'],
  [805575037,805750808,'Capricorn'],
  [805750808,805938181,'Aquarius'],
  [805938181,806140649,'Pisces'],
  [806140649,806355394,'Aries'],
  [806355394,806574618,'Taurus'],
  [806574618,806791028,'Gemini'],
  [806791028,807001328,'Cancer'],
  [807001328,807204866,'Leo'],
  [807204866,807401032,'Virgo'],
  [807401032,807588835,'Libra'],
  [807588835,807768662,'Scorpio'],
  [807768662,807943860,'Sagittarius'],
  [807943860,808120406,'Capricorn'],
  [808120406,808305181,'Aquarius'],
  [808305181,808503294,'Pisces'],
  [808503294,808714726,'Aries'],
  [808714726,808933082,'Taurus'],
  [808933082,809149495,'Gemini'],
  [809149495,809358469,'Cancer'],
  [809358469,809559257,'Leo'],
  [809559257,809753283,'Virgo'],
  [809753283,809941738,'Libra'],
  [809941738,810125354,'Scorpio'],
  [810125354,810305751,'Sagittarius'],
  [810305751,810486448,'Capricorn'],
  [810486448,810672502,'Aquarius'],
  [810672502,810868804,'Pisces'],
  [810868804,811077253,'Aries'],
  [811077253,811294200,'Taurus'],
  [811294200,811511326,'Gemini'],
  [811511326,811720841,'Cancer'],
  [811720841,811919902,'Leo'],
  [811919902,812110153,'Virgo'],
  [812110153,812294975,'Libra'],
  [812294975,812477516,'Scorpio'],
  [812477516,812660208,'Sagittarius'],
  [812660208,812845272,'Capricorn'],
  [812845272,813035281,'Aquarius'],
  [813035281,813233058,'Pisces'],
  [813233058,813440449,'Aries'],
  [813440449,813656102,'Taurus'],
  [813656102,813874134,'Gemini'],
  [813874134,814086236,'Cancer'],
  [814086236,814286697,'Leo'],
  [814286697,814475190,'Virgo'],
  [814475190,814655474,'Libra'],
  [814655474,814832926,'Scorpio'],
  [814832926,815012626,'Sagittarius'],
  [815012626,815198192,'Capricorn'],
  [815198192,815391370,'Aquarius'],
  [815391370,815592463,'Pisces'],
  [815592463,815801154,'Aries'],
  [815801154,816016375,'Taurus'],
  [816016375,816234831,'Gemini'],
  [816234831,816450103,'Cancer'],
  [816450103,816654990,'Leo'],
  [816654990,816845972,'Virgo'],
  [816845972,817024934,'Libra'],
  [817024934,817197619,'Scorpio'],
  [817197619,817371163,'Sagittarius'],
  [817371163,817551986,'Capricorn'],
  [817551986,817743855,'Aquarius'],
  [817743855,817946702,'Pisces'],
  [817946702,818157694,'Aries'],
  [818157694,818373670,'Taurus'],
  [818373670,818591980,'Gemini'],
  [818591980,818808926,'Cancer'],
  [818808926,819018621,'Leo'],
  [819018621,819215483,'Virgo'],
  [819215483,819398108,'Libra'],
  [819398108,819570400,'Scorpio'],
  [819570400,819739639,'Sagittarius'],
  [819739639,819913932,'Capricorn'],
  [819913932,820099911,'Aquarius'],
  [820099911,820300066,'Pisces'],
  [820300066,820511539,'Aries'],
  [820511539,820728680,'Taurus'],
  [820728680,820946883,'Gemini'],
  [820946883,821163401,'Cancer'],
  [821163401,821375062,'Leo'],
  [821375062,821577292,'Virgo'],
  [821577292,821766568,'Libra'],
  [821766568,821943588,'Scorpio'],
  [821943588,822113692,'Sagittarius'],
  [822113692,822284702,'Capricorn'],
  [822284702,822464546,'Aquarius'],
  [822464546,822658626,'Pisces'],
  [822658626,822866938,'Aries'],
  [822866938,823083885,'Taurus'],
  [823083885,823302303,'Gemini'],
  [823302303,823517672,'Cancer'],
  [823517672,823728001,'Leo'],
  [823728001,823931401,'Virgo'],
  [823931401,824125434,'Libra'],
  [824125434,824309030,'Scorpio'],
  [824309030,824484546,'Sagittarius'],
  [824484546,824657615,'Capricorn'],
  [824657615,824835400,'Aquarius'],
  [824835400,825024370,'Pisces'],
  [825024370,825227501,'Aries'],
  [825227501,825441989,'Taurus'],
  [825441989,825660358,'Gemini'],
  [825660358,825875374,'Cancer'],
  [825875374,826083543,'Leo'],
  [826083543,826284326,'Virgo'],
  [826284326,826477988,'Libra'],
  [826477988,826664828,'Scorpio'],
  [826664828,826846024,'Sagittarius'],
  [826846024,827024551,'Capricorn'],
  [827024551,827205128,'Aquarius'],
  [827205128,827393116,'Pisces'],
  [827393116,827592564,'Aries'],
  [827592564,827803670,'Taurus'],
  [827803670,828021251,'Gemini'],
  [828021251,828237010,'Cancer'],
  [828237010,828444663,'Leo'],
  [828444663,828642512,'Virgo'],
  [828642512,828832303,'Libra'],
  [828832303,829017017,'Scorpio'],
  [829017017,829199507,'Sagittarius'],
  [829199507,829382238,'Capricorn'],
  [829382238,829567648,'Aquarius'],
  [829567648,829758532,'Pisces'],
  [829758532,829957757,'Aries'],
  [829957757,830166762,'Taurus'],
  [830166762,830383238,'Gemini'],
  [830383238,830600290,'Cancer'],
  [830600290,830809757,'Leo'],
  [830809757,831007244,'Virgo'],
  [831007244,831193711,'Libra'],
  [831193711,831373643,'Scorpio'],
  [831373643,831552442,'Sagittarius'],
  [831552442,831734537,'Capricorn'],
  [831734537,831922465,'Aquarius'],
  [831922465,832117099,'Pisces'],
  [832117099,832318795,'Aries'],
  [832318795,832527980,'Taurus'],
  [832527980,832743839,'Gemini'],
  [832743839,832962028,'Cancer'],
  [832962028,833174723,'Leo'],
  [833174723,833375066,'Virgo'],
  [833375066,833561565,'Libra'],
  [833561565,833738209,'Scorpio'],
  [833738209,833911753,'Sagittarius'],
  [833911753,834088984,'Capricorn'],
  [834088984,834274673,'Aquarius'],
  [834274673,834470270,'Pisces'],
  [834470270,834674476,'Aries'],
  [834674476,834885374,'Taurus'],
  [834885374,835101482,'Gemini'],
  [835101482,835320210,'Cancer'],
  [835320210,835535811,'Leo'],
  [835535811,835740846,'Virgo'],
  [835740846,835931093,'Libra'],
  [835931093,836108367,'Scorpio'],
  [836108367,836279013,'Sagittarius'],
  [836279013,836450899,'Capricorn'],
  [836450899,836631014,'Aquarius'],
  [836631014,836823284,'Pisces'],
  [836823284,837027278,'Aries'],
  [837027278,837239547,'Taurus'],
  [837239547,837456446,'Gemini'],
  [837456446,837675152,'Cancer'],
  [837675152,837891901,'Leo'],
  [837891901,838100871,'Virgo'],
  [838100871,838296715,'Libra'],
  [838296715,838478488,'Scorpio'],
  [838478488,838650510,'Sagittarius'],
  [838650510,838820098,'Capricorn'],
  [838820098,838995067,'Aquarius'],
  [838995067,839181560,'Pisces'],
  [839181560,839381802,'Aries'],
  [839381802,839593263,'Taurus'],
  [839593263,839810648,'Gemini'],
  [839810648,840029135,'Cancer'],
  [840029135,840245200,'Leo'],
  [840245200,840455211,'Virgo'],
  [840455211,840655196,'Libra'],
  [840655196,840842930,'Scorpio'],
  [840842930,841020054,'Sagittarius'],
  [841020054,841191794,'Capricorn'],
  [841191794,841365141,'Aquarius'],
  [841365141,841546941,'Pisces'],
  [841546941,841741785,'Aries'],
  [841741785,841949876,'Taurus'],
  [841949876,842166547,'Gemini'],
  [842166547,842384934,'Cancer'],
  [842384934,842599711,'Leo'],
  [842599711,842807967,'Virgo'],
  [842807967,843008155,'Libra'],
  [843008155,843199433,'Scorpio'],
  [843199433,843382329,'Sagittarius'],
  [843382329,843559518,'Capricorn'],
  [843559518,843735665,'Aquarius'],
  [843735665,843916516,'Pisces'],
  [843916516,844107417,'Aries'],
  [844107417,844311165,'Taurus'],
  [844311165,844525717,'Gemini'],
  [844525717,844744123,'Cancer'],
  [844744123,844958528,'Leo'],
  [844958528,845164480,'Virgo'],
  [845164480,845361584,'Libra'],
  [845361584,845551608,'Scorpio'],
  [845551608,845736697,'Sagittarius'],
  [845736697,845918857,'Capricorn'],
  [845918857,846100365,'Aquarius'],
  [846100365,846284384,'Pisces'],
  [846284384,846474979,'Aries'],
  [846474979,846675864,'Taurus'],
  [846675864,846887799,'Gemini'],
  [846887799,847106052,'Cancer'],
  [847106052,847321699,'Leo'],
  [847321699,847527395,'Virgo'],
  [847527395,847721488,'Libra'],
  [847721488,847907122,'Scorpio'],
  [847907122,848089116,'Sagittarius'],
  [848089116,848271509,'Capricorn'],
  [848271509,848456552,'Aquarius'],
  [848456552,848645282,'Pisces'],
  [848645282,848839036,'Aries'],
  [848839036,849040147,'Taurus'],
  [849040147,849250496,'Gemini'],
  [849250496,849468268,'Cancer'],
  [849468268,849686056,'Leo'],
  [849686056,849894506,'Virgo'],
  [849894506,850088930,'Libra'],
  [850088930,850271427,'Scorpio'],
  [850271427,850448097,'Sagittarius'],
  [850448097,850625569,'Capricorn'],
  [850625569,850808611,'Aquarius'],
  [850808611,850998981,'Pisces'],
  [850998981,851196286,'Aries'],
  [851196286,851400116,'Taurus'],
  [851400116,851610928,'Gemini'],
  [851610928,851828258,'Cancer'],
  [851828258,852047574,'Leo'],
  [852047574,852260250,'Virgo'],
  [852260250,852458962,'Libra'],
  [852458962,852642813,'Scorpio'],
  [852642813,852816886,'Sagittarius'],
  [852816886,852988742,'Capricorn'],
  [852988742,853165531,'Aquarius'],
  [853165531,853351931,'Pisces'],
  [853351931,853548972,'Aries'],
  [853548972,853754966,'Taurus'],
  [853754966,853967653,'Gemini'],
  [853967653,854185209,'Cancer'],
  [854185209,854404697,'Leo'],
  [854404697,854620188,'Virgo'],
  [854620188,854824494,'Libra'],
  [854824494,855013882,'Scorpio'],
  [855013882,855190539,'Sagittarius'],
  [855190539,855360818,'Capricorn'],
  [855360818,855532367,'Aquarius'],
  [855532367,855712017,'Pisces'],
  [855712017,855903937,'Aries'],
  [855903937,856108350,'Taurus'],
  [856108350,856321994,'Gemini'],
  [856321994,856540342,'Cancer'],
  [856540342,856759327,'Leo'],
  [856759327,856974838,'Virgo'],
  [856974838,857182192,'Libra'],
  [857182192,857377560,'Scorpio'],
  [857377560,857560453,'Sagittarius'],
  [857560453,857734384,'Capricorn'],
  [857734384,857905494,'Aquarius'],
  [857905494,858080758,'Pisces'],
  [858080758,858266335,'Aries'],
  [858266335,858465622,'Taurus'],
  [858465622,858677380,'Gemini'],
  [858677380,858895970,'Cancer'],
  [858895970,859114677,'Leo'],
  [859114677,859328641,'Virgo'],
  [859328641,859535199,'Libra'],
  [859535199,859732875,'Scorpio'],
  [859732875,859921182,'Sagittarius'],
  [859921182,860101342,'Capricorn'],
  [860101342,860276704,'Aquarius'],
  [860276704,860452480,'Pisces'],
  [860452480,860634769,'Aries'],
  [860634769,860828864,'Taurus'],
  [860828864,861036608,'Gemini'],
  [861036608,861254020,'Cancer'],
  [861254020,861472815,'Leo'],
  [861472815,861685656,'Virgo'],
  [861685656,861889598,'Libra'],
  [861889598,862085306,'Scorpio'],
  [862085306,862274545,'Sagittarius'],
  [862274545,862458864,'Capricorn'],
  [862458864,862639791,'Aquarius'],
  [862639791,862819868,'Pisces'],
  [862819868,863003304,'Aries'],
  [863003304,863195242,'Taurus'],
  [863195242,863399423,'Gemini'],
  [863399423,863614726,'Cancer'],
  [863614726,863833713,'Leo'],
  [863833713,864046931,'Virgo'],
  [864046931,864249254,'Libra'],
  [864249254,864441488,'Scorpio'],
  [864441488,864627508,'Sagittarius'],
  [864627508,864811115,'Capricorn'],
  [864811115,864994590,'Aquarius'],
  [864994590,865179136,'Pisces'],
  [865179136,865366486,'Aries'],
  [865366486,865559859,'Taurus'],
  [865559859,865762881,'Gemini'],
  [865762881,865976457,'Cancer'],
  [865976457,866195579,'Leo'],
  [866195579,866410599,'Virgo'],
  [866410599,866613863,'Libra'],
  [866613863,866804367,'Scorpio'],
  [866804367,866986350,'Sagittarius'],
  [866986350,867165594,'Capricorn'],
  [867165594,867346729,'Aquarius'],
  [867346729,867532150,'Pisces'],
  [867532150,867722697,'Aries'],
  [867722697,867919304,'Taurus'],
  [867919304,868123691,'Gemini'],
  [868123691,868336880,'Cancer'],
  [868336880,868556067,'Leo'],
  [868556067,868773385,'Virgo'],
  [868773385,868979995,'Libra'],
  [868979995,869172176,'Scorpio'],
  [869172176,869352653,'Sagittarius'],
  [869352653,869527580,'Capricorn'],
  [869527580,869703438,'Aquarius'],
  [869703438,869885111,'Pisces'],
  [869885111,870075025,'Aries'],
  [870075025,870273589,'Taurus'],
  [870273589,870480330,'Gemini'],
  [870480330,870694471,'Cancer'],
  [870694471,870913747,'Leo'],
  [870913747,871132613,'Virgo'],
  [871132613,871343287,'Libra'],
  [871343287,871540133,'Scorpio'],
  [871540133,871723132,'Sagittarius'],
  [871723132,871897022,'Capricorn'],
  [871897022,872068548,'Aquarius'],
  [872068548,872244355,'Pisces'],
  [872244355,872429505,'Aries'],
  [872429505,872626312,'Taurus'],
  [872626312,872833970,'Gemini'],
  [872833970,873049454,'Cancer'],
  [873049454,873268952,'Leo'],
  [873268952,873487971,'Virgo'],
  [873487971,873701093,'Libra'],
  [873701093,873903142,'Scorpio'],
  [873903142,874091821,'Sagittarius'],
  [874091821,874269107,'Capricorn'],
  [874269107,874440239,'Aquarius'],
  [874440239,874611985,'Pisces'],
  [874611985,874791113,'Aries'],
  [874791113,874982706,'Taurus'],
  [874982706,875188083,'Gemini'],
  [875188083,875403781,'Cancer'],
  [875403781,875623581,'Leo'],
  [875623581,875841817,'Virgo'],
  [875841817,876054612,'Libra'],
  [876054612,876259172,'Scorpio'],
  [876259172,876453399,'Sagittarius'],
  [876453399,876636966,'Capricorn'],
  [876636966,876812282,'Aquarius'],
  [876812282,876984421,'Pisces'],
  [876984421,877160097,'Aries'],
  [877160097,877346050,'Taurus'],
  [877346050,877546518,'Gemini'],
  [877546518,877760187,'Cancer'],
  [877760187,877979954,'Leo'],
  [877979954,878197583,'Virgo'],
  [878197583,878408417,'Libra'],
  [878408417,878611583,'Scorpio'],
  [878611583,878807417,'Sagittarius'],
  [878807417,878995966,'Capricorn'],
  [878995966,879177585,'Aquarius'],
  [879177585,879354473,'Pisces'],
  [879354473,879531403,'Aries'],
  [879531403,879714823,'Taurus'],
  [879714823,879910620,'Gemini'],
  [879910620,880120560,'Cancer'],
  [880120560,880339387,'Leo'],
  [880339387,880557298,'Virgo'],
  [880557298,880766960,'Libra'],
  [880766960,880967046,'Scorpio'],
  [880967046,881159969,'Sagittarius'],
  [881159969,881348365,'Capricorn'],
  [881348365,881533487,'Aquarius'],
  [881533487,881715979,'Pisces'],
  [881715979,881897823,'Aries'],
  [881897823,882083231,'Taurus'],
  [882083231,882277540,'Gemini'],
  [882277540,882484278,'Cancer'],
  [882484278,882701337,'Leo'],
  [882701337,882920085,'Virgo'],
  [882920085,883130902,'Libra'],
  [883130902,883329783,'Scorpio'],
  [883329783,883518846,'Sagittarius'],
  [883518846,883702737,'Capricorn'],
  [883702737,883885495,'Aquarius'],
  [883885495,884069335,'Pisces'],
  [884069335,884255388,'Aries'],
  [884255388,884445306,'Taurus'],
  [884445306,884641922,'Gemini'],
  [884641922,884848065,'Cancer'],
  [884848065,885063612,'Leo'],
  [885063612,885282916,'Virgo'],
  [885282916,885496630,'Libra'],
  [885496630,885697905,'Scorpio'],
  [885697905,885886273,'Sagittarius'],
  [885886273,886066065,'Capricorn'],
  [886066065,886243121,'Aquarius'],
  [886243121,886422537,'Pisces'],
  [886422537,886607620,'Aries'],
  [886607620,886799947,'Taurus'],
  [886799947,887000101,'Gemini'],
  [887000101,887208269,'Cancer'],
  [887208269,887423710,'Leo'],
  [887423710,887642990,'Virgo'],
  [887642990,887859332,'Libra'],
  [887859332,888065305,'Scorpio'],
  [888065305,888257346,'Sagittarius'],
  [888257346,888437299,'Capricorn'],
  [888437299,888610582,'Aquarius'],
  [888610582,888783819,'Pisces'],
  [888783819,888963105,'Aries'],
  [888963105,889152603,'Taurus'],
  [889152603,889353462,'Gemini'],
  [889353462,889563871,'Cancer'],
  [889563871,889780521,'Leo'],
  [889780521,889999669,'Virgo'],
  [889999669,890216888,'Libra'],
  [890216888,890426772,'Scorpio'],
  [890426772,890624636,'Sagittarius'],
  [890624636,890809250,'Capricorn'],
  [890809250,890983631,'Aquarius'],
  [890983631,891153859,'Pisces'],
  [891153859,891327238,'Aries'],
  [891327238,891510495,'Taurus'],
  [891510495,891707574,'Gemini'],
  [891707574,891917546,'Cancer'],
  [891917546,892135195,'Leo'],
  [892135195,892354476,'Virgo'],
  [892354476,892571075,'Libra'],
  [892571075,892781959,'Scorpio'],
  [892781959,892984009,'Sagittarius'],
  [892984009,893174757,'Capricorn'],
  [893174757,893354328,'Aquarius'],
  [893354328,893526490,'Pisces'],
  [893526490,893697843,'Aries'],
  [893697843,893875991,'Taurus'],
  [893875991,894067258,'Gemini'],
  [894067258,894273552,'Cancer'],
  [894273552,894490420,'Leo'],
  [894490420,894709820,'Virgo'],
  [894709820,894925488,'Libra'],
  [894925488,895134930,'Scorpio'],
  [895134930,895337360,'Sagittarius'],
  [895337360,895531693,'Capricorn'],
  [895531693,895717001,'Aquarius'],
  [895717001,895894440,'Pisces'],
  [895894440,896068358,'Aries'],
  [896068358,896245435,'Taurus'],
  [896245435,896432645,'Gemini'],
  [896432645,896634260,'Cancer'],
  [896634260,896848501,'Leo'],
  [896848501,897067541,'Virgo'],
  [897067541,897282889,'Libra'],
  [897282889,897490488,'Scorpio'],
  [897490488,897690446,'Sagittarius'],
  [897690446,897884004,'Capricorn'],
  [897884004,898071704,'Aquarius'],
  [898071704,898253988,'Pisces'],
  [898253988,898432913,'Aries'],
  [898432913,898612899,'Taurus'],
  [898612899,898799782,'Gemini'],
  [898799782,898998488,'Cancer'],
  [898998488,899209718,'Leo'],
  [899209718,899427873,'Virgo'],
  [899427873,899643809,'Libra'],
  [899643809,899851012,'Scorpio'],
  [899851012,900048420,'Sagittarius'],
  [900048420,900238414,'Capricorn'],
  [900238414,900423917,'Aquarius'],
  [900423917,900607067,'Pisces'],
  [900607067,900789632,'Aries'],
  [900789632,900974055,'Taurus'],
  [900974055,901163842,'Gemini'],
  [901163842,901362681,'Cancer'],
  [901362681,901572194,'Leo'],
  [901572194,901789366,'Virgo'],
  [901789366,902006508,'Libra'],
  [902006508,902215491,'Scorpio'],
  [902215491,902412708,'Sagittarius'],
  [902412708,902599687,'Capricorn'],
  [902599687,902780633,'Aquarius'],
  [902780633,902960124,'Pisces'],
  [902960124,903141903,'Aries'],
  [903141903,903328599,'Taurus'],
  [903328599,903521991,'Gemini'],
  [903521991,903723346,'Cancer'],
  [903723346,903933171,'Leo'],
  [903933171,904149808,'Virgo'],
  [904149808,904368087,'Libra'],
  [904368087,904580357,'Scorpio'],
  [904580357,904780603,'Sagittarius'],
  [904780603,904967834,'Capricorn'],
  [904967834,905145610,'Aquarius'],
  [905145610,905319812,'Pisces'],
  [905319812,905496622,'Aries'],
  [905496622,905680951,'Taurus'],
  [905680951,905875234,'Gemini'],
  [905875234,906079153,'Cancer'],
  [906079153,906290759,'Leo'],
  [906290759,906507614,'Virgo'],
  [906507614,906726351,'Libra'],
  [906726351,906941587,'Scorpio'],
  [906941587,907146865,'Sagittarius'],
  [907146865,907338319,'Capricorn'],
  [907338319,907517036,'Aquarius'],
  [907517036,907688326,'Pisces'],
  [907688326,907859529,'Aries'],
  [907859529,908037920,'Taurus'],
  [908037920,908228556,'Gemini'],
  [908228556,908432166,'Cancer'],
  [908432166,908645231,'Leo'],
  [908645231,908862900,'Virgo'],
  [908862900,909081434,'Libra'],
  [909081434,909297605,'Scorpio'],
  [909297605,909506925,'Sagittarius'],
  [909506925,909704552,'Capricorn'],
  [909704552,909888530,'Aquarius'],
  [909888530,910061712,'Pisces'],
  [910061712,910230736,'Aries'],
  [910230736,910403719,'Taurus'],
  [910403719,910588004,'Gemini'],
  [910588004,910787281,'Cancer'],
  [910787281,910999301,'Leo'],
  [910999301,911217517,'Virgo'],
  [911217517,911435807,'Libra'],
  [911435807,911650941,'Scorpio'],
  [911650941,911860828,'Sagittarius'],
  [911860828,912062483,'Capricorn'],
  [912062483,912252957,'Aquarius'],
  [912252957,912432147,'Pisces'],
  [912432147,912604162,'Aries'],
  [912604162,912776051,'Taurus'],
  [912776051,912955630,'Gemini'],
  [912955630,913148898,'Cancer'],
  [913148898,913356818,'Leo'],
  [913356818,913574038,'Virgo'],
  [913574038,913792398,'Libra'],
  [913792398,914006302,'Scorpio'],
  [914006302,914213951,'Sagittarius'],
  [914213951,914414907,'Capricorn'],
  [914414907,914608260,'Aquarius'],
  [914608260,914793327,'Pisces'],
  [914793327,914971578,'Aries'],
  [914971578,915147379,'Taurus'],
  [915147379,915326991,'Gemini'],
  [915326991,915516629,'Cancer'],
  [915516629,915719717,'Leo'],
  [915719717,915934149,'Virgo'],
  [915934149,916152449,'Libra'],
  [916152449,916366490,'Scorpio'],
  [916366490,916572196,'Sagittarius'],
  [916572196,916769618,'Capricorn'],
  [916769618,916960474,'Aquarius'],
  [916960474,917146430,'Pisces'],
  [917146430,917329045,'Aries'],
  [917329045,917510570,'Taurus'],
  [917510570,917694454,'Gemini'],
  [917694454,917884956,'Cancer'],
  [917884956,918085672,'Leo'],
  [918085672,918297130,'Virgo'],
  [918297130,918514786,'Libra'],
  [918514786,918730315,'Scorpio'],
  [918730315,918936700,'Sagittarius'],
  [918936700,919131898,'Capricorn'],
  [919131898,919318233,'Aquarius'],
  [919318233,919499941,'Pisces'],
  [919499941,919681163,'Aries'],
  [919681163,919864977,'Taurus'],
  [919864977,920053353,'Gemini'],
  [920053353,920247760,'Cancer'],
  [920247760,920449683,'Leo'],
  [920449683,920659963,'Virgo'],
  [920659963,920876756,'Libra'],
  [920876756,921094002,'Scorpio'],
  [921094002,921303544,'Sagittarius'],
  [921303544,921500223,'Capricorn'],
  [921500223,921684535,'Aquarius'],
  [921684535,921861334,'Pisces'],
  [921861334,922037073,'Aries'],
  [922037073,922217502,'Taurus'],
  [922217502,922406067,'Gemini'],
  [922406067,922603355,'Cancer'],
  [922603355,922808242,'Leo'],
  [922808242,923019573,'Virgo'],
  [923019573,923236063,'Libra'],
  [923236063,923454269,'Scorpio'],
  [923454269,923667462,'Sagittarius'],
  [923667462,923868652,'Capricorn'],
  [923868652,924055294,'Aquarius'],
  [924055294,924230682,'Pisces'],
  [924230682,924401736,'Aries'],
  [924401736,924576130,'Taurus'],
  [924576130,924759992,'Gemini'],
  [924759992,924955849,'Cancer'],
  [924955849,925162105,'Leo'],
  [925162105,925375222,'Virgo'],
  [925375222,925592207,'Libra'],
  [925592207,925810490,'Scorpio'],
  [925810490,926025759,'Sagittarius'],
  [926025759,926231739,'Capricorn'],
  [926231739,926423744,'Aquarius'],
  [926423744,926602244,'Pisces'],
  [926602244,926772731,'Aries'],
  [926772731,926943055,'Taurus'],
  [926943055,927120927,'Gemini'],
  [927120927,927311571,'Cancer'],
  [927311571,927515561,'Leo'],
  [927515561,927729011,'Virgo'],
  [927729011,927946665,'Libra'],
  [927946665,928164620,'Scorpio'],
  [928164620,928379773,'Sagittarius'],
  [928379773,928588080,'Capricorn'],
  [928588080,928785189,'Aquarius'],
  [928785189,928969424,'Pisces'],
  [928969424,929143666,'Aries'],
  [929143666,929314271,'Taurus'],
  [929314271,929488821,'Gemini'],
  [929488821,929673976,'Cancer'],
  [929673976,929873061,'Leo'],
  [929873061,930084312,'Virgo'],
  [930084312,930301878,'Libra'],
  [930301878,930519573,'Scorpio'],
  [930519573,930733391,'Sagittarius'],
  [930733391,930940841,'Capricorn'],
  [930940841,931139756,'Aquarius'],
  [931139756,931328723,'Pisces'],
  [931328723,931508665,'Aries'],
  [931508665,931683444,'Taurus'],
  [931683444,931858946,'Gemini'],
  [931858946,932041521,'Cancer'],
  [932041521,932236012,'Leo'],
  [932236012,932443454,'Virgo'],
  [932443454,932659732,'Libra'],
  [932659732,932877436,'Scorpio'],
  [932877436,933090256,'Sagittarius'],
  [933090256,933295271,'Capricorn'],
  [933295271,933492200,'Aquarius'],
  [933492200,933681865,'Pisces'],
  [933681865,933865617,'Aries'],
  [933865617,934045678,'Taurus'],
  [934045678,934225461,'Gemini'],
  [934225461,934409405,'Cancer'],
  [934409405,934602048,'Leo'],
  [934602048,934806179,'Virgo'],
  [934806179,935020436,'Libra'],
  [935020436,935238361,'Scorpio'],
  [935238361,935451642,'Sagittarius'],
  [935451642,935655141,'Capricorn'],
  [935655141,935848609,'Aquarius'],
  [935848609,936034966,'Pisces'],
  [936034966,936217891,'Aries'],
  [936217891,936400404,'Taurus'],
  [936400404,936584660,'Gemini'],
  [936584660,936772627,'Cancer'],
  [936772627,936966802,'Leo'],
  [936966802,937169826,'Virgo'],
  [937169826,937382386,'Libra'],
  [937382386,937600527,'Scorpio'],
  [937600527,937815832,'Sagittarius'],
  [937815832,938020505,'Capricorn'],
  [938020505,938212286,'Aquarius'],
  [938212286,938394428,'Pisces'],
  [938394428,938572713,'Aries'],
  [938572713,938752637,'Taurus'],
  [938752637,938937676,'Gemini'],
  [938937676,939128954,'Cancer'],
  [939128954,939326540,'Leo'],
  [939326540,939531004,'Virgo'],
  [939531004,939743125,'Libra'],
  [939743125,939961289,'Scorpio'],
  [939961289,940179101,'Sagittarius'],
  [940179101,940387619,'Capricorn'],
  [940387619,940581539,'Aquarius'],
  [940581539,940762312,'Pisces'],
  [940762312,940936071,'Aries'],
  [940936071,941110233,'Taurus'],
  [941110233,941290940,'Gemini'],
  [941290940,941481227,'Cancer'],
  [941481227,941680756,'Leo'],
  [941680756,941887744,'Virgo'],
  [941887744,942100904,'Libra'],
  [942100904,942319020,'Scorpio'],
  [942319020,942538256,'Sagittarius'],
  [942538256,942751133,'Capricorn'],
  [942751133,942950480,'Aquarius'],
  [942950480,943134576,'Pisces'],
  [943134576,943307806,'Aries'],
  [943307806,943477680,'Taurus'],
  [943477680,943651975,'Gemini'],
  [943651975,943836573,'Cancer'],
  [943836573,944033593,'Leo'],
  [944033593,944241249,'Virgo'],
  [944241249,944455905,'Libra'],
  [944455905,944674300,'Scorpio'],
  [944674300,944893342,'Sagittarius'],
  [944893342,945108237,'Capricorn'],
  [945108237,945312908,'Aquarius'],
  [945312908,945503512,'Pisces'],
  [945503512,945681289,'Aries'],
  [945681289,945851821,'Taurus'],
  [945851821,946022568,'Gemini'],
  [946022568,946200777,'Cancer'],
  [946200777,946391549,'Leo'],
  [946391549,946595924,'Virgo'],
  [946595924,946810450,'Libra'],
  [946810450,947029360,'Scorpio'],
  [947029360,947247623,'Sagittarius'],
  [947247623,947461521,'Capricorn'],
  [947461521,947667747,'Aquarius'],
  [947667747,947863506,'Pisces'],
  [947863506,948048119,'Aries'],
  [948048119,948224115,'Taurus'],
  [948224115,948396701,'Gemini'],
  [948396701,948572408,'Cancer'],
  [948572408,948757543,'Leo'],
  [948757543,948956181,'Virgo'],
  [948956181,949167774,'Libra'],
  [949167774,949386486,'Scorpio'],
  [949386486,949604543,'Sagittarius'],
  [949604543,949816533,'Capricorn'],
  [949816533,950020505,'Aquarius'],
  [950020505,950216461,'Pisces'],
  [950216461,950404987,'Aries'],
  [950404987,950587235,'Taurus'],
  [950587235,950765549,'Gemini'],
  [950765549,950943929,'Cancer'],
  [950943929,951127687,'Leo'],
  [951127687,951322027,'Virgo'],
  [951322027,951529416,'Libra'],
  [951529416,951746607,'Scorpio'],
  [951746607,951965090,'Sagittarius'],
  [951965090,952176571,'Capricorn'],
  [952176571,952377760,'Aquarius'],
  [952377760,952570169,'Pisces'],
  [952570169,952757094,'Aries'],
  [952757094,952941310,'Taurus'],
  [952941310,953124483,'Gemini'],
  [953124483,953308103,'Cancer'],
  [953308103,953494852,'Leo'],
  [953494852,953688784,'Virgo'],
  [953688784,953893488,'Libra'],
  [953893488,954108646,'Scorpio'],
  [954108646,954327622,'Sagittarius'],
  [954327622,954540580,'Capricorn'],
  [954540580,954741398,'Aquarius'],
  [954741398,954930626,'Pisces'],
  [954930626,955113009,'Aries'],
  [955113009,955293882,'Taurus'],
  [955293882,955476908,'Gemini'],
  [955476908,955663580,'Cancer'],
  [955663580,955854529,'Leo'],
  [955854529,956051249,'Virgo'],
  [956051249,956256149,'Libra'],
  [956256149,956470163,'Scorpio'],
  [956470163,956689372,'Sagittarius'],
  [956689372,956904858,'Capricorn'],
  [956904858,957108308,'Aquarius'],
  [957108308,957297655,'Pisces'],
  [957297655,957476927,'Aries'],
  [957476927,957652692,'Taurus'],
  [957652692,957831019,'Gemini'],
  [957831019,958015711,'Cancer'],
  [958015711,958207963,'Leo'],
  [958207963,958407630,'Virgo'],
  [958407630,958614682,'Libra'],
  [958614682,958829045,'Scorpio'],
  [958829045,959048308,'Sagittarius'],
  [959048308,959265916,'Capricorn'],
  [959265916,959473541,'Aquarius'],
  [959473541,959666557,'Pisces'],
  [959666557,959846632,'Aries'],
  [959846632,960019663,'Taurus'],
  [960019663,960192713,'Gemini'],
  [960192713,960371877,'Cancer'],
  [960371877,960560874,'Leo'],
  [960560874,960760503,'Virgo'],
  [960760503,960969313,'Libra'],
  [960969313,961184906,'Scorpio'],
  [961184906,961404251,'Sagittarius'],
  [961404251,961622595,'Capricorn'],
  [961622595,961833567,'Aquarius'],
  [961833567,962031837,'Pisces'],
  [962031837,962216410,'Aries'],
  [962216410,962390960,'Taurus'],
  [962390960,962561800,'Gemini'],
  [962561800,962735844,'Cancer'],
  [962735844,962919051,'Leo'],
  [962919051,963114855,'Virgo'],
  [963114855,963322893,'Libra'],
  [963322893,963539269,'Scorpio'],
  [963539269,963758782,'Sagittarius'],
  [963758782,963976575,'Capricorn'],
  [963976575,964188356,'Aquarius'],
  [964188356,964390416,'Pisces'],
  [964390416,964580734,'Aries'],
  [964580734,964760356,'Taurus'],
  [964760356,964933355,'Gemini'],
  [964933355,965105780,'Cancer'],
  [965105780,965284320,'Leo'],
  [965284320,965474650,'Virgo'],
  [965474650,965679089,'Libra'],
  [965679089,965894624,'Scorpio'],
  [965894624,966114224,'Sagittarius'],
  [966114224,966331096,'Capricorn'],
  [966331096,966541383,'Aquarius'],
  [966541383,966743684,'Pisces'],
  [966743684,966937440,'Aries'],
  [966937440,967122719,'Taurus'],
  [967122719,967301055,'Gemini'],
  [967301055,967476166,'Cancer'],
  [967476166,967653740,'Leo'],
  [967653740,967840144,'Virgo'],
  [967840144,968040025,'Libra'],
  [968040025,968252997,'Scorpio'],
  [968252997,968472306,'Sagittarius'],
  [968472306,968688892,'Capricorn'],
  [968688892,968897257,'Aquarius'],
  [968897257,969096908,'Pisces'],
  [969096908,969289723,'Aries'],
  [969289723,969477350,'Taurus'],
  [969477350,969660671,'Gemini'],
  [969660671,969841028,'Cancer'],
  [969841028,970021671,'Leo'],
  [970021671,970207789,'Virgo'],
  [970207789,970404737,'Libra'],
  [970404737,970614659,'Scorpio'],
  [970614659,970833147,'Sagittarius'],
  [970833147,971050518,'Capricorn'],
  [971050518,971258620,'Aquarius'],
  [971258620,971455616,'Pisces'],
  [971455616,971644547,'Aries'],
  [971644547,971829578,'Taurus'],
  [971829578,972013536,'Gemini'],
  [972013536,972197635,'Cancer'],
  [972197635,972383026,'Leo'],
  [972383026,972572356,'Virgo'],
  [972572356,972769594,'Libra'],
  [972769594,972977736,'Scorpio'],
  [972977736,973195136,'Sagittarius'],
  [973195136,973413887,'Capricorn'],
  [973413887,973624241,'Aquarius'],
  [973624241,973821466,'Pisces'],
  [973821466,974007453,'Aries'],
  [974007453,974187516,'Taurus'],
  [974187516,974367051,'Gemini'],
  [974367051,974549690,'Cancer'],
  [974549690,974737122,'Leo'],
  [974737122,974930279,'Virgo'],
  [974930279,975130477,'Libra'],
  [975130477,975339187,'Scorpio'],
  [975339187,975555913,'Sagittarius'],
  [975555913,975775624,'Capricorn'],
  [975775624,975989593,'Aquarius'],
  [975989593,976190700,'Pisces'],
  [976190700,976377849,'Aries'],
  [976377849,976555215,'Taurus'],
  [976555215,976729152,'Gemini'],
  [976729152,976905816,'Cancer'],
  [976905816,977089729,'Leo'],
  [977089729,977283067,'Virgo'],
  [977283067,977485847,'Libra'],
  [977485847,977696789,'Scorpio'],
  [977696789,977913907,'Sagittarius'],
  [977913907,978133685,'Capricorn'],
  [978133685,978350210,'Aquarius'],
  [978350210,978556673,'Pisces'],
  [978556673,978749171,'Aries'],
  [978749171,978928864,'Taurus'],
  [978928864,979100844,'Gemini'],
  [979100844,979271963,'Cancer'],
  [979271963,979449076,'Leo'],
  [979449076,979637421,'Virgo'],
  [979637421,979838856,'Libra'],
  [979838856,980051094,'Scorpio'],
  [980051094,980269359,'Sagittarius'],
  [980269359,980488880,'Capricorn'],
  [980488880,980705566,'Aquarius'],
  [980705566,980915230,'Pisces'],
  [980915230,981113891,'Aries'],
  [981113891,981299888,'Taurus'],
  [981299888,981475292,'Gemini'],
  [981475292,981645528,'Cancer'],
  [981645528,981817835,'Leo'],
  [981817835,981999489,'Virgo'],
  [981999489,982195479,'Libra'],
  [982195479,982405666,'Scorpio'],
  [982405666,982624282,'Sagittarius'],
  [982624282,982843820,'Capricorn'],
  [982843820,983059283,'Aquarius'],
  [983059283,983268490,'Pisces'],
  [983268490,983469877,'Aries'],
  [983469877,983661757,'Taurus'],
  [983661757,983843676,'Gemini'],
  [983843676,984018118,'Cancer'],
  [984018118,984190697,'Leo'],
  [984190697,984368715,'Virgo'],
  [984368715,984558948,'Libra'],
  [984558948,984764389,'Scorpio'],
  [984764389,984981289,'Sagittarius'],
  [984981289,985200846,'Capricorn'],
  [985200846,985415451,'Aquarius'],
  [985415451,985622399,'Pisces'],
  [985622399,985822185,'Aries'],
  [985822185,986015453,'Taurus'],
  [986015453,986202075,'Gemini'],
  [986202075,986382509,'Cancer'],
  [986382509,986559609,'Leo'],
  [986559609,986738830,'Virgo'],
  [986738830,986926667,'Libra'],
  [986926667,987127836,'Scorpio'],
  [987127836,987341643,'Sagittarius'],
  [987341643,987560705,'Capricorn'],
  [987560705,987775591,'Aquarius'],
  [987775591,987981192,'Pisces'],
  [987981192,988177819,'Aries'],
  [988177819,988368146,'Taurus'],
  [988368146,988554426,'Gemini'],
  [988554426,988737883,'Cancer'],
  [988737883,988919921,'Leo'],
  [988919921,989103470,'Virgo'],
  [989103470,989292990,'Libra'],
  [989292990,989492811,'Scorpio'],
  [989492811,989704110,'Sagittarius'],
  [989704110,989922278,'Capricorn'],
  [989922278,990138346,'Aquarius'],
  [990138346,990344859,'Pisces'],
  [990344859,990540005,'Aries'],
  [990540005,990726516,'Taurus'],
  [990726516,990908628,'Gemini'],
  [990908628,991090025,'Cancer'],
  [991090025,991273300,'Leo'],
  [991273300,991460480,'Virgo'],
  [991460480,991653701,'Libra'],
  [991653701,991855182,'Scorpio'],
  [991855182,992065898,'Sagittarius'],
  [992065898,992283350,'Capricorn'],
  [992283350,992500801,'Aquarius'],
  [992500801,992710183,'Pisces'],
  [992710183,992907012,'Aries'],
  [992907012,993092177,'Taurus'],
  [993092177,993270112,'Gemini'],
  [993270112,993446411,'Cancer'],
  [993446411,993626171,'Leo'],
  [993626171,993812982,'Virgo'],
  [993812982,994008510,'Libra'],
  [994008510,994212756,'Scorpio'],
  [994212756,994424690,'Sagittarius'],
  [994424690,994642045,'Capricorn'],
  [994642045,994860363,'Aquarius'],
  [994860363,995073075,'Pisces'],
  [995073075,995274193,'Aries'],
  [995274193,995461815,'Taurus'],
  [995461815,995638747,'Gemini'],
  [995638747,995810838,'Cancer'],
  [995810838,995984955,'Leo'],
  [995984955,996167201,'Virgo'],
  [996167201,996361132,'Libra'],
  [996361132,996566515,'Scorpio'],
  [996566515,996780120,'Sagittarius'],
  [996780120,996997976,'Capricorn'],
  [996997976,997216367,'Aquarius'],
  [997216367,997431044,'Pisces'],
  [997431044,997636817,'Aries'],
  [997636817,997829764,'Taurus'],
  [997829764,998009893,'Gemini'],
  [998009893,998181542,'Cancer'],
  [998181542,998351756,'Leo'],
  [998351756,998528220,'Virgo'],
  [998528220,998717057,'Libra'],
  [998717057,998920156,'Scorpio'],
  [998920156,999134038,'Sagittarius'],
  [999134038,999352496,'Capricorn'],
  [999352496,999570482,'Aquarius'],
  [999570482,999784959,'Pisces'],
  [999784959,999993027,'Aries'],
  [999993027,1000191175,'Taurus'],
  [1000191175,1000377246,'Gemini'],
  [1000377246,1000552811,'Cancer'],
  [1000552811,1000723359,'Leo'],
  [1000723359,1000896519,'Virgo'],
  [1000896519,1001079849,'Libra'],
  [1001079849,1001277968,'Scorpio'],
  [1001277968,1001489588,'Sagittarius'],
  [1001489588,1001707952,'Capricorn'],
  [1001707952,1001925645,'Aquarius'],
  [1001925645,1002138647,'Pisces'],
  [1002138647,1002345661,'Aries'],
  [1002345661,1002545516,'Taurus'],
  [1002545516,1002736495,'Gemini'],
  [1002736495,1002918156,'Cancer'],
  [1002918156,1003093262,'Leo'],
  [1003093262,1003267637,'Virgo'],
  [1003267637,1003448463,'Libra'],
  [1003448463,1003641806,'Scorpio'],
  [1003641806,1003849339,'Sagittarius'],
  [1003849339,1004066304,'Capricorn'],
  [1004066304,1004284124,'Aquarius'],
  [1004284124,1004496213,'Pisces'],
  [1004496213,1004700604,'Aries'],
  [1004700604,1004898008,'Taurus'],
  [1004898008,1005089247,'Gemini'],
  [1005089247,1005274684,'Cancer'],
  [1005274684,1005455473,'Leo'],
  [1005455473,1005634763,'Virgo'],
  [1005634763,1005817554,'Libra'],
  [1005817554,1006009272,'Scorpio'],
  [1006009272,1006213245,'Sagittarius'],
  [1006213245,1006427836,'Capricorn'],
  [1006427836,1006645910,'Aquarius'],
  [1006645910,1006858908,'Pisces'],
  [1006858908,1007062163,'Aries'],
  [1007062163,1007255942,'Taurus'],
  [1007255942,1007443094,'Gemini'],
  [1007443094,1007626757,'Cancer'],
  [1007626757,1007809453,'Leo'],
  [1007809453,1007993348,'Virgo'],
  [1007993348,1008180869,'Libra'],
  [1008180869,1008374914,'Scorpio'],
  [1008374914,1008578084,'Sagittarius'],
  [1008578084,1008790698,'Capricorn'],
  [1008790698,1009008680,'Aquarius'],
  [1009008680,1009224035,'Pisces'],
  [1009224035,1009429379,'Aries'],
  [1009429379,1009622274,'Taurus'],
  [1009622274,1009805255,'Gemini'],
  [1009805255,1009983440,'Cancer'],
  [1009983440,1010162224,'Leo'],
  [1010162224,1010345758,'Virgo'],
  [1010345758,1010536232,'Libra'],
  [1010536232,1010734175,'Scorpio'],
  [1010734175,1010939500,'Sagittarius'],
  [1010939500,1011151902,'Capricorn'],
  [1011151902,1011369508,'Aquarius'],
  [1011369508,1011587043,'Pisces'],
  [1011587043,1011796752,'Aries'],
  [1011796752,1011993035,'Taurus'],
  [1011993035,1012175830,'Gemini'],
  [1012175830,1012349979,'Cancer'],
  [1012349979,1012522572,'Leo'],
  [1012522572,1012700515,'Virgo'],
  [1012700515,1012888511,'Libra'],
  [1012888511,1013087569,'Scorpio'],
  [1013087569,1013295514,'Sagittarius'],
  [1013295514,1013509410,'Capricorn'],
  [1013509410,1013726977,'Aquarius'],
  [1013726977,1013945274,'Pisces'],
  [1013945274,1014158763,'Aries'],
  [1014158763,1014360816,'Taurus'],
  [1014360816,1014548124,'Gemini'],
  [1014548124,1014723101,'Cancer'],
  [1014723101,1014892440,'Leo'],
  [1014892440,1015064276,'Virgo'],
  [1015064276,1015245848,'Libra'],
  [1015245848,1015441033,'Scorpio'],
  [1015441033,1015648626,'Sagittarius'],
  [1015648626,1015863840,'Capricorn'],
  [1015863840,1016081939,'Aquarius'],
  [1016081939,1016299862,'Pisces'],
  [1016299862,1016514432,'Aries'],
  [1016514432,1016720801,'Taurus'],
  [1016720801,1016914433,'Gemini'],
  [1016914433,1017094687,'Cancer'],
  [1017094687,1017265943,'Leo'],
  [1017265943,1017435638,'Virgo'],
  [1017435638,1017611785,'Libra'],
  [1017611785,1017800643,'Scorpio'],
  [1017800643,1018004037,'Sagittarius'],
  [1018004037,1018218261,'Capricorn'],
  [1018218261,1018436720,'Aquarius'],
  [1018436720,1018654131,'Pisces'],
  [1018654131,1018867541,'Aries'],
  [1018867541,1019074456,'Taurus'],
  [1019074456,1019271937,'Gemini'],
  [1019271937,1019458268,'Cancer'],
  [1019458268,1019635108,'Leo'],
  [1019635108,1019807581,'Virgo'],
  [1019807581,1019982643,'Libra'],
  [1019982643,1020167066,'Scorpio'],
  [1020167066,1020365056,'Sagittarius'],
  [1020365056,1020575868,'Capricorn'],
  [1020575868,1020793614,'Aquarius'],
  [1020793614,1021010885,'Pisces'],
  [1021010885,1021222812,'Aries'],
  [1021222812,1021427501,'Taurus'],
  [1021427501,1021624415,'Gemini'],
  [1021624415,1021813444,'Cancer'],
  [1021813444,1021995514,'Leo'],
  [1021995514,1022173396,'Virgo'],
  [1022173396,1022351664,'Libra'],
  [1022351664,1022535777,'Scorpio'],
  [1022535777,1022730458,'Sagittarius'],
  [1022730458,1022937438,'Capricorn'],
  [1022937438,1023153434,'Aquarius'],
  [1023153434,1023370912,'Pisces'],
  [1023370912,1023582566,'Aries'],
  [1023582566,1023784973,'Taurus'],
  [1023784973,1023978562,'Gemini'],
  [1023978562,1024165660,'Cancer'],
  [1024165660,1024348911,'Leo'],
  [1024348911,1024530796,'Virgo'],
  [1024530796,1024713871,'Libra'],
  [1024713871,1024901154,'Scorpio'],
  [1024901154,1025095998,'Sagittarius'],
  [1025095998,1025300865,'Capricorn'],
  [1025300865,1025515025,'Aquarius'],
  [1025515025,1025732858,'Pisces'],
  [1025732858,1025945916,'Aries'],
  [1025945916,1026148175,'Taurus'],
  [1026148175,1026338965,'Gemini'],
  [1026338965,1026521811,'Cancer'],
  [1026521811,1026701746,'Leo'],
  [1026701746,1026883169,'Virgo'],
  [1026883169,1027068825,'Libra'],
  [1027068825,1027259994,'Scorpio'],
  [1027259994,1027457595,'Sagittarius'],
  [1027457595,1027662847,'Capricorn'],
  [1027662847,1027876088,'Aquarius'],
  [1027876088,1028094212,'Pisces'],
  [1028094212,1028309744,'Aries'],
  [1028309744,1028514632,'Taurus'],
  [1028514632,1028705637,'Gemini'],
  [1028705637,1028885537,'Cancer'],
  [1028885537,1029060571,'Leo'],
  [1029060571,1029237426,'Virgo'],
  [1029237426,1029421045,'Libra'],
  [1029421045,1029613348,'Scorpio'],
  [1029613348,1029813736,'Sagittarius'],
  [1029813736,1030021060,'Capricorn'],
  [1030021060,1030234669,'Aquarius'],
  [1030234669,1030452910,'Pisces'],
  [1030452910,1030670626,'Aries'],
  [1030670626,1030879797,'Taurus'],
  [1030879797,1031074591,'Gemini'],
  [1031074591,1031255349,'Cancer'],
  [1031255349,1031427687,'Leo'],
  [1031427687,1031599312,'Virgo'],
  [1031599312,1031777382,'Libra'],
  [1031777382,1031966336,'Scorpio'],
  [1031966336,1032166587,'Sagittarius'],
  [1032166587,1032375600,'Capricorn'],
  [1032375600,1032590404,'Aquarius'],
  [1032590404,1032808689,'Pisces'],
  [1032808689,1033027125,'Aries'],
  [1033027125,1033239754,'Taurus'],
  [1033239754,1033440123,'Gemini'],
  [1033440123,1033625741,'Cancer'],
  [1033625741,1033799850,'Leo'],
  [1033799850,1033969392,'Virgo'],
  [1033969392,1034142257,'Libra'],
  [1034142257,1034325111,'Scorpio'],
  [1034325111,1034521202,'Sagittarius'],
  [1034521202,1034729252,'Capricorn'],
  [1034729252,1034944844,'Aquarius'],
  [1034944844,1035163312,'Pisces'],
  [1035163312,1035381049,'Aries'],
  [1035381049,1035594267,'Taurus'],
  [1035594267,1035798449,'Gemini'],
  [1035798449,1035990258,'Cancer'],
  [1035990258,1036170112,'Leo'],
  [1036170112,1036342474,'Virgo'],
  [1036342474,1036514119,'Libra'],
  [1036514119,1036692193,'Scorpio'],
  [1036692193,1036882268,'Sagittarius'],
  [1036882268,1037086149,'Capricorn'],
  [1037086149,1037300676,'Aquarius'],
  [1037300676,1037519370,'Pisces'],
  [1037519370,1037736231,'Aries'],
  [1037736231,1037947583,'Taurus'],
  [1037947583,1038151381,'Gemini'],
  [1038151381,1038346304,'Cancer'],
  [1038346304,1038532132,'Leo'],
  [1038532132,1038710697,'Virgo'],
  [1038710697,1038886066,'Libra'],
  [1038886066,1039063864,'Scorpio'],
  [1039063864,1039250013,'Sagittarius'],
  [1039250013,1039448767,'Capricorn'],
  [1039448767,1039660136,'Aquarius'],
  [1039660136,1039878494,'Pisces'],
  [1039878494,1040095465,'Aries'],
  [1040095465,1040305037,'Taurus'],
  [1040305037,1040505625,'Gemini'],
  [1040505625,1040698553,'Cancer'],
  [1040698553,1040885834,'Leo'],
  [1040885834,1041069226,'Virgo'],
  [1041069226,1041250542,'Libra'],
  [1041250542,1041432524,'Scorpio'],
  [1041432524,1041619255,'Sagittarius'],
  [1041619255,1041815280,'Capricorn'],
  [1041815280,1042023171,'Aquarius'],
  [1042023171,1042240296,'Pisces'],
  [1042240296,1042458332,'Aries'],
  [1042458332,1042668385,'Taurus'],
  [1042668385,1042866727,'Gemini'],
  [1042866727,1043055341,'Cancer'],
  [1043055341,1043238821,'Leo'],
  [1043238821,1043421422,'Virgo'],
  [1043421422,1043605637,'Libra'],
  [1043605637,1043792520,'Scorpio'],
  [1043792520,1043983290,'Sagittarius'],
  [1043983290,1044180472,'Capricorn'],
  [1044180472,1044386908,'Aquarius'],
  [1044386908,1044602608,'Pisces'],
  [1044602608,1044821753,'Aries'],
  [1044821753,1045034567,'Taurus'],
  [1045034567,1045234173,'Gemini'],
  [1045234173,1045420684,'Cancer'],
  [1045420684,1045599312,'Leo'],
  [1045599312,1045776618,'Virgo'],
  [1045776618,1045957807,'Libra'],
  [1045957807,1046145351,'Scorpio'],
  [1046145351,1046339445,'Sagittarius'],
  [1046339445,1046539960,'Capricorn'],
  [1046539960,1046747652,'Aquarius'],
  [1046747652,1046962899,'Pisces'],
  [1046962899,1047182533,'Aries'],
  [1047182533,1047398570,'Taurus'],
  [1047398570,1047602486,'Gemini'],
  [1047602486,1047791263,'Cancer'],
  [1047791263,1047968450,'Leo'],
  [1047968450,1048140987,'Virgo'],
  [1048140987,1048316032,'Libra'],
  [1048316032,1048498872,'Scorpio'],
  [1048498872,1048691690,'Sagittarius'],
  [1048691690,1048893912,'Capricorn'],
  [1048893912,1049103868,'Aquarius'],
  [1049103868,1049319948,'Pisces'],
  [1049319948,1049539606,'Aries'],
  [1049539606,1049757423,'Taurus'],
  [1049757423,1049965965,'Gemini'],
  [1049965965,1050160150,'Cancer'],
  [1050160150,1050340578,'Leo'],
  [1050340578,1050512576,'Virgo'],
  [1050512576,1050683371,'Libra'],
  [1050683371,1050859912,'Scorpio'],
  [1050859912,1051047211,'Sagittarius'],
  [1051047211,1051246996,'Capricorn'],
  [1051246996,1051457451,'Aquarius'],
  [1051457451,1051674632,'Pisces'],
  [1051674632,1051894300,'Aries'],
  [1051894300,1052112023,'Taurus'],
  [1052112023,1052322802,'Gemini'],
  [1052322802,1052522142,'Cancer'],
  [1052522142,1052708520,'Leo'],
  [1052708520,1052884496,'Virgo'],
  [1052884496,1053055604,'Libra'],
  [1053055604,1053228624,'Scorpio'],
  [1053228624,1053410058,'Sagittarius'],
  [1053410058,1053604425,'Capricorn'],
  [1053604425,1053812261,'Aquarius'],
  [1053812261,1054029340,'Pisces'],
  [1054029340,1054249068,'Aries'],
  [1054249068,1054465766,'Taurus'],
  [1054465766,1054675826,'Gemini'],
  [1054675826,1054877069,'Cancer'],
  [1054877069,1055068350,'Leo'],
  [1055068350,1055250281,'Virgo'],
  [1055250281,1055425756,'Libra'],
  [1055425756,1055599751,'Scorpio'],
  [1055599751,1055778471,'Sagittarius'],
  [1055778471,1055967863,'Capricorn'],
  [1055967863,1056171220,'Aquarius'],
  [1056171220,1056386404,'Pisces'],
  [1056386404,1056605990,'Aries'],
  [1056605990,1056821938,'Taurus'],
  [1056821938,1057029908,'Gemini'],
  [1057029908,1057229456,'Cancer'],
  [1057229456,1057421673,'Leo'],
  [1057421673,1057607644,'Virgo'],
  [1057607644,1057788612,'Libra'],
  [1057788612,1057967017,'Scorpio'],
  [1057967017,1058147177,'Sagittarius'],
  [1058147177,1058334678,'Capricorn'],
  [1058334678,1058534296,'Aquarius'],
  [1058534296,1058746627,'Pisces'],
  [1058746627,1058965695,'Aries'],
  [1058965695,1059181886,'Taurus'],
  [1059181886,1059388580,'Gemini'],
  [1059388580,1059585099,'Cancer'],
  [1059585099,1059774436,'Leo'],
  [1059774436,1059959932,'Virgo'],
  [1059959932,1060143629,'Libra'],
  [1060143629,1060326687,'Scorpio'],
  [1060326687,1060511009,'Sagittarius'],
  [1060511009,1060700213,'Capricorn'],
  [1060700213,1060898708,'Aquarius'],
  [1060898708,1061108797,'Pisces'],
  [1061108797,1061327105,'Aries'],
  [1061327105,1061544517,'Taurus'],
  [1061544517,1061752146,'Gemini'],
  [1061752146,1061947217,'Cancer'],
  [1061947217,1062132804,'Leo'],
  [1062132804,1062314162,'Virgo'],
  [1062314162,1062495737,'Libra'],
  [1062495737,1062679930,'Scorpio'],
  [1062679930,1062867785,'Sagittarius'],
  [1062867785,1063060635,'Capricorn'],
  [1063060635,1063260827,'Aquarius'],
  [1063260827,1063470427,'Pisces'],
  [1063470427,1063688107,'Aries'],
  [1063688107,1063907009,'Taurus'],
  [1063907009,1064117707,'Gemini'],
  [1064117707,1064314660,'Cancer'],
  [1064314660,1064499024,'Leo'],
  [1064499024,1064676203,'Virgo'],
  [1064676203,1064852487,'Libra'],
  [1064852487,1065032891,'Scorpio'],
  [1065032891,1065220193,'Sagittarius'],
  [1065220193,1065415308,'Capricorn'],
  [1065415308,1065618370,'Aquarius'],
  [1065618370,1065829306,'Pisces'],
  [1065829306,1066046879,'Aries'],
  [1066046879,1066266603,'Taurus'],
  [1066266603,1066480814,'Gemini'],
  [1066480814,1066682548,'Cancer'],
  [1066682548,1066869937,'Leo'],
  [1066869937,1067046504,'Virgo'],
  [1067046504,1067218564,'Libra'],
  [1067218564,1067392865,'Scorpio'],
  [1067392865,1067574975,'Sagittarius'],
  [1067574975,1067768029,'Capricorn'],
  [1067768029,1067972130,'Aquarius'],
  [1067972130,1068184941,'Pisces'],
  [1068184941,1068403105,'Aries'],
  [1068403105,1068622678,'Taurus'],
  [1068622678,1068838600,'Gemini'],
  [1068838600,1069045198,'Cancer'],
  [1069045198,1069238689,'Leo'],
  [1069238689,1069419462,'Virgo'],
  [1069419462,1069591826,'Libra'],
  [1069591826,1069762343,'Scorpio'],
  [1069762343,1069938136,'Sagittarius'],
  [1069938136,1070125212,'Capricorn'],
  [1070125212,1070326297,'Aquarius'],
  [1070326297,1070539225,'Pisces'],
  [1070539225,1070758202,'Aries'],
  [1070758202,1070977321,'Taurus'],
  [1070977321,1071192490,'Gemini'],
  [1071192490,1071400764,'Cancer'],
  [1071400764,1071599428,'Leo'],
  [1071599428,1071786946,'Virgo'],
  [1071786946,1071964476,'Libra'],
  [1071964476,1072136379,'Scorpio'],
  [1072136379,1072309314,'Sagittarius'],
  [1072309314,1072490594,'Capricorn'],
  [1072490594,1072685835,'Aquarius'],
  [1072685835,1072895715,'Pisces'],
  [1072895715,1073114475,'Aries'],
  [1073114475,1073333556,'Taurus'],
  [1073333556,1073547137,'Gemini'],
  [1073547137,1073753554,'Cancer'],
  [1073753554,1073952837,'Leo'],
  [1073952837,1074144666,'Virgo'],
  [1074144666,1074328679,'Libra'],
  [1074328679,1074506228,'Scorpio'],
  [1074506228,1074681570,'Sagittarius'],
  [1074681570,1074861199,'Capricorn'],
  [1074861199,1075051798,'Aquarius'],
  [1075051798,1075256975,'Pisces'],
  [1075256975,1075473722,'Aries'],
  [1075473722,1075693000,'Taurus'],
  [1075693000,1075906148,'Gemini'],
  [1075906148,1076110050,'Cancer'],
  [1076110050,1076306137,'Leo'],
  [1076306137,1076496810,'Virgo'],
  [1076496810,1076683334,'Libra'],
  [1076683334,1076866199,'Scorpio'],
  [1076866199,1077047014,'Sagittarius'],
  [1077047014,1077229708,'Capricorn'],
  [1077229708,1077419785,'Aquarius'],
  [1077419785,1077621829,'Pisces'],
  [1077621829,1077835810,'Aries'],
  [1077835810,1078054936,'Taurus'],
  [1078054936,1078269311,'Gemini'],
  [1078269311,1078472906,'Cancer'],
  [1078472906,1078665964,'Leo'],
  [1078665964,1078852242,'Virgo'],
  [1078852242,1079035682,'Libra'],
  [1079035682,1079218838,'Scorpio'],
  [1079218838,1079403200,'Sagittarius'],
  [1079403200,1079590550,'Capricorn'],
  [1079590550,1079783755,'Aquarius'],
  [1079783755,1079986016,'Pisces'],
  [1079986016,1080198400,'Aries'],
  [1080198400,1080417027,'Taurus'],
  [1080417027,1080633401,'Gemini'],
  [1080633401,1080839506,'Cancer'],
  [1080839506,1081032767,'Leo'],
  [1081032767,1081215945,'Virgo'],
  [1081215945,1081394211,'Libra'],
  [1081394211,1081572705,'Scorpio'],
  [1081572705,1081755291,'Sagittarius'],
  [1081755291,1081944297,'Capricorn'],
  [1081944297,1082140927,'Aquarius'],
  [1082140927,1082345771,'Pisces'],
  [1082345771,1082558599,'Aries'],
  [1082558599,1082776913,'Taurus'],
  [1082776913,1082994861,'Gemini'],
  [1082994861,1083204844,'Cancer'],
  [1083204844,1083401797,'Leo'],
  [1083401797,1083585844,'Virgo'],
  [1083585844,1083761289,'Libra'],
  [1083761289,1083934353,'Scorpio'],
  [1083934353,1084111302,'Sagittarius'],
  [1084111302,1084297010,'Capricorn'],
  [1084297010,1084493727,'Aquarius'],
  [1084493727,1084700674,'Pisces'],
  [1084700674,1084915127,'Aries'],
  [1084915127,1085133669,'Taurus'],
  [1085133669,1085352144,'Gemini'],
  [1085352144,1085565170,'Cancer'],
  [1085565170,1085767271,'Leo'],
  [1085767271,1085955885,'Virgo'],
  [1085955885,1086132865,'Libra'],
  [1086132865,1086303642,'Scorpio'],
  [1086303642,1086475371,'Sagittarius'],
  [1086475371,1086655102,'Capricorn'],
  [1086655102,1086847729,'Aquarius'],
  [1086847729,1087053772,'Pisces'],
  [1087053772,1087269181,'Aries'],
  [1087269181,1087488250,'Taurus'],
  [1087488250,1087706412,'Gemini'],
  [1087706412,1087920235,'Cancer'],
  [1087920235,1088126022,'Leo'],
  [1088126022,1088320367,'Virgo'],
  [1088320367,1088502448,'Libra'],
  [1088502448,1088675390,'Scorpio'],
  [1088675390,1088845535,'Sagittarius'],
  [1088845535,1089020587,'Capricorn'],
  [1089020587,1089207466,'Aquarius'],
  [1089207466,1089409417,'Pisces'],
  [1089409417,1089623621,'Aries'],
  [1089623621,1089842855,'Taurus'],
  [1089842855,1090060492,'Gemini'],
  [1090060492,1090273191,'Cancer'],
  [1090273191,1090479384,'Leo'],
  [1090479384,1090677216,'Virgo'],
  [1090677216,1090864983,'Libra'],
  [1090864983,1091043269,'Scorpio'],
  [1091043269,1091216166,'Sagittarius'],
  [1091216166,1091390394,'Capricorn'],
  [1091390394,1091573329,'Aquarius'],
  [1091573329,1091770292,'Pisces'],
  [1091770292,1091981207,'Aries'],
  [1091981207,1092199648,'Taurus'],
  [1092199648,1092417068,'Gemini'],
  [1092417068,1092628297,'Cancer'],
  [1092628297,1092832309,'Leo'],
  [1092832309,1093029527,'Virgo'],
  [1093029527,1093219859,'Libra'],
  [1093219859,1093403241,'Scorpio'],
  [1093403241,1093581450,'Sagittarius'],
  [1093581450,1093758891,'Capricorn'],
  [1093758891,1093941687,'Aquarius'],
  [1093941687,1094135577,'Pisces'],
  [1094135577,1094342802,'Aries'],
  [1094342802,1094559516,'Taurus'],
  [1094559516,1094777166,'Gemini'],
  [1094777166,1094988175,'Cancer'],
  [1094988175,1095189939,'Leo'],
  [1095189939,1095383766,'Virgo'],
  [1095383766,1095572000,'Libra'],
  [1095572000,1095756452,'Scorpio'],
  [1095756452,1095938683,'Sagittarius'],
  [1095938683,1096121067,'Capricorn'],
  [1096121067,1096307261,'Aquarius'],
  [1096307261,1096501505,'Pisces'],
  [1096501505,1096706652,'Aries'],
  [1096706652,1096921473,'Taurus'],
  [1096921473,1097139530,'Gemini'],
  [1097139530,1097352209,'Cancer'],
  [1097352209,1097554114,'Leo'],
  [1097554114,1097745199,'Virgo'],
  [1097745199,1097928883,'Libra'],
  [1097928883,1098109536,'Scorpio'],
  [1098109536,1098290949,'Sagittarius'],
  [1098290949,1098475862,'Capricorn'],
  [1098475862,1098666221,'Aquarius'],
  [1098666221,1098863630,'Pisces'],
  [1098863630,1099069354,'Aries'],
  [1099069354,1099283145,'Taurus'],
  [1099283145,1099501367,'Gemini'],
  [1099501367,1099716782,'Cancer'],
  [1099716782,1099921982,'Leo'],
  [1099921982,1100113921,'Virgo'],
  [1100113921,1100294814,'Libra'],
  [1100294814,1100470115,'Scorpio'],
  [1100470115,1100646148,'Sagittarius'],
  [1100646148,1100828247,'Capricorn'],
  [1100828247,1101019393,'Aquarius'],
  [1101019393,1101219799,'Pisces'],
  [1101219799,1101427999,'Aries'],
  [1101427999,1101642260,'Taurus'],
  [1101642260,1101860321,'Gemini'],
  [1101860321,1102077734,'Cancer'],
  [1102077734,1102287672,'Leo'],
  [1102287672,1102484438,'Virgo'],
  [1102484438,1102667187,'Libra'],
  [1102667187,1102840228,'Scorpio'],
  [1102840228,1103010759,'Sagittarius'],
  [1103010759,1103186416,'Capricorn'],
  [1103186416,1103373075,'Aquarius'],
  [1103373075,1103572620,'Pisces'],
  [1103572620,1103782486,'Aries'],
  [1103782486,1103998212,'Taurus'],
  [1103998212,1104216255,'Gemini'],
  [1104216255,1104433848,'Cancer'],
  [1104433848,1104646801,'Leo'],
  [1104646801,1104849484,'Virgo'],
  [1104849484,1105038207,'Libra'],
  [1105038207,1105214264,'Scorpio'],
  [1105214264,1105383606,'Sagittarius'],
  [1105383606,1105554327,'Capricorn'],
  [1105554327,1105734283,'Aquarius'],
  [1105734283,1105928467,'Pisces'],
  [1105928467,1106136420,'Aries'],
  [1106136420,1106352735,'Taurus'],
  [1106352735,1106571163,'Gemini'],
  [1106571163,1106787880,'Cancer'],
  [1106787880,1107000579,'Leo'],
  [1107000579,1107206124,'Virgo'],
  [1107206124,1107400853,'Libra'],
  [1107400853,1107583418,'Scorpio'],
  [1107583418,1107756845,'Sagittarius'],
  [1107756845,1107927679,'Capricorn'],
  [1107927679,1108103750,'Aquarius'],
  [1108103750,1108291814,'Pisces'],
  [1108291814,1108494647,'Aries'],
  [1108494647,1108709023,'Taurus'],
  [1108709023,1108927571,'Gemini'],
  [1108927571,1109143760,'Cancer'],
  [1109143760,1109354508,'Leo'],
  [1109354508,1109558670,'Virgo'],
  [1109558670,1109755077,'Libra'],
  [1109755077,1109942710,'Scorpio'],
  [1109942710,1110122436,'Sagittarius'],
  [1110122436,1110297988,'Capricorn'],
  [1110297988,1110475265,'Aquarius'],
  [1110475265,1110660640,'Pisces'],
  [1110660640,1110858636,'Aries'],
  [1110858636,1111069254,'Taurus'],
  [1111069254,1111286890,'Gemini'],
  [1111286890,1111503378,'Cancer'],
  [1111503378,1111713001,'Leo'],
  [1111713001,1111914163,'Virgo'],
  [1111914163,1112107765,'Libra'],
  [1112107765,1112295333,'Scorpio'],
  [1112295333,1112478490,'Sagittarius'],
  [1112478490,1112659431,'Capricorn'],
  [1112659431,1112841404,'Aquarius'],
  [1112841404,1113028574,'Pisces'],
  [1113028574,1113224978,'Aries'],
  [1113224978,1113432488,'Taurus'],
  [1113432488,1113648505,'Gemini'],
  [1113648505,1113865754,'Cancer'],
  [1113865754,1114076277,'Leo'],
  [1114076277,1114276060,'Virgo'],
  [1114276060,1114465889,'Libra'],
  [1114465889,1114649362,'Scorpio'],
  [1114649362,1114830637,'Sagittarius'],
  [1114830637,1115013109,'Capricorn'],
  [1115013109,1115199103,'Aquarius'],
  [1115199103,1115390342,'Pisces'],
  [1115390342,1115588595,'Aries'],
  [1115588595,1115795389,'Taurus'],
  [1115795389,1116010165,'Gemini'],
  [1116010165,1116228159,'Cancer'],
  [1116228159,1116441217,'Leo'],
  [1116441217,1116642656,'Virgo'],
  [1116642656,1116831181,'Libra'],
  [1116831181,1117010527,'Scorpio'],
  [1117010527,1117186772,'Sagittarius'],
  [1117186772,1117365792,'Capricorn'],
  [1117365792,1117551531,'Aquarius'],
  [1117551531,1117745296,'Pisces'],
  [1117745296,1117946621,'Aries'],
  [1117946621,1118154906,'Taurus'],
  [1118154906,1118369560,'Gemini'],
  [1118369560,1118587998,'Cancer'],
  [1118587998,1118803878,'Leo'],
  [1118803878,1119009351,'Virgo'],
  [1119009351,1119200299,'Libra'],
  [1119200299,1119378723,'Scorpio'],
  [1119378723,1119550899,'Sagittarius'],
  [1119550899,1119724355,'Capricorn'],
  [1119724355,1119905484,'Aquarius'],
  [1119905484,1120097573,'Pisces'],
  [1120097573,1120300080,'Aries'],
  [1120300080,1120510326,'Taurus'],
  [1120510326,1120725834,'Gemini'],
  [1120725834,1120944408,'Cancer'],
  [1120944408,1121161941,'Leo'],
  [1121161941,1121371692,'Virgo'],
  [1121371692,1121567761,'Libra'],
  [1121567761,1121749369,'Scorpio'],
  [1121749369,1121921256,'Sagittarius'],
  [1121921256,1122091003,'Capricorn'],
  [1122091003,1122266400,'Aquarius'],
  [1122266400,1122453232,'Pisces'],
  [1122453232,1122653193,'Aries'],
  [1122653193,1122863654,'Taurus'],
  [1122863654,1123080080,'Gemini'],
  [1123080080,1123298667,'Cancer'],
  [1123298667,1123516151,'Leo'],
  [1123516151,1123728044,'Virgo'],
  [1123728044,1123929094,'Libra'],
  [1123929094,1124116505,'Scorpio'],
  [1124116505,1124292327,'Sagittarius'],
  [1124292327,1124462557,'Capricorn'],
  [1124462557,1124634777,'Aquarius'],
  [1124634777,1124816054,'Pisces'],
  [1124816054,1125010724,'Aries'],
  [1125010724,1125218497,'Taurus'],
  [1125218497,1125434709,'Gemini'],
  [1125434709,1125653319,'Cancer'],
  [1125653319,1125869781,'Leo'],
  [1125869781,1126080901,'Virgo'],
  [1126080901,1126283762,'Libra'],
  [1126283762,1126476088,'Scorpio'],
  [1126476088,1126657984,'Sagittarius'],
  [1126657984,1126832794,'Capricorn'],
  [1126832794,1127006262,'Aquarius'],
  [1127006262,1127184996,'Pisces'],
  [1127184996,1127374684,'Aries'],
  [1127374684,1127577870,'Taurus'],
  [1127577870,1127792102,'Gemini'],
  [1127792102,1128010628,'Cancer'],
  [1128010628,1128226405,'Leo'],
  [1128226405,1128435331,'Virgo'],
  [1128435331,1128636202,'Libra'],
  [1128636202,1128829225,'Scorpio'],
  [1128829225,1129015206,'Sagittarius'],
  [1129015206,1129195858,'Capricorn'],
  [1129195858,1129374261,'Aquarius'],
  [1129374261,1129554857,'Pisces'],
  [1129554857,1129742734,'Aries'],
  [1129742734,1129941981,'Taurus'],
  [1129941981,1130153133,'Gemini'],
  [1130153133,1130371176,'Cancer'],
  [1130371176,1130587496,'Leo'],
  [1130587496,1130795320,'Virgo'],
  [1130795320,1130992907,'Libra'],
  [1130992907,1131182446,'Scorpio'],
  [1131182446,1131367369,'Sagittarius'],
  [1131367369,1131550548,'Capricorn'],
  [1131550548,1131733938,'Aquarius'],
  [1131733938,1131919349,'Pisces'],
  [1131919349,1132109448,'Aries'],
  [1132109448,1132307680,'Taurus'],
  [1132307680,1132516355,'Gemini'],
  [1132516355,1132733459,'Cancer'],
  [1132733459,1132951306,'Leo'],
  [1132951306,1133160708,'Virgo'],
  [1133160708,1133357245,'Libra'],
  [1133357245,1133542821,'Scorpio'],
  [1133542821,1133722827,'Sagittarius'],
  [1133722827,1133902869,'Capricorn'],
  [1133902869,1134086684,'Aquarius'],
  [1134086684,1134275608,'Pisces'],
  [1134275608,1134469855,'Aries'],
  [1134469855,1134670318,'Taurus'],
  [1134670318,1134878660,'Gemini'],
  [1134878660,1135094883,'Cancer'],
  [1135094883,1135314102,'Leo'],
  [1135314102,1135527122,'Virgo'],
  [1135527122,1135726534,'Libra'],
  [1135726534,1135911680,'Scorpio'],
  [1135911680,1136087693,'Sagittarius'],
  [1136087693,1136261843,'Capricorn'],
  [1136261843,1136440611,'Aquarius'],
  [1136440611,1136627744,'Pisces'],
  [1136627744,1136823692,'Aries'],
  [1136823692,1137027203,'Taurus'],
  [1137027203,1137237342,'Gemini'],
  [1137237342,1137453544,'Cancer'],
  [1137453544,1137673142,'Leo'],
  [1137673142,1137889380,'Virgo'],
  [1137889380,1138094099,'Libra'],
  [1138094099,1138283443,'Scorpio'],
  [1138283443,1138460101,'Sagittarius'],
  [1138460101,1138630872,'Capricorn'],
  [1138630872,1138803478,'Aquarius'],
  [1138803478,1138984334,'Pisces'],
  [1138984334,1139176758,'Aries'],
  [1139176758,1139380344,'Taurus'],
  [1139380344,1139592285,'Gemini'],
  [1139592285,1139809430,'Cancer'],
  [1139809430,1140028765,'Leo'],
  [1140028765,1140245889,'Virgo'],
  [1140245889,1140454712,'Libra'],
  [1140454712,1140650290,'Scorpio'],
  [1140650290,1140832208,'Sagittarius'],
  [1140832208,1141004824,'Capricorn'],
  [1141004824,1141175050,'Aquarius'],
  [1141175050,1141350164,'Pisces'],
  [1141350164,1141536049,'Aries'],
  [1141536049,1141735377,'Taurus'],
  [1141735377,1141946481,'Gemini'],
  [1141946481,1142164365,'Cancer'],
  [1142164365,1142383556,'Leo'],
  [1142383556,1142599652,'Virgo'],
  [1142599652,1142809006,'Libra'],
  [1142809006,1143008500,'Scorpio'],
  [1143008500,1143196691,'Sagittarius'],
  [1143196691,1143375101,'Capricorn'],
  [1143375101,1143548123,'Aquarius'],
  [1143548123,1143721911,'Pisces'],
  [1143721911,1143902983,'Aries'],
  [1143902983,1144096478,'Taurus'],
  [1144096478,1144303780,'Gemini'],
  [1144303780,1144520837,'Cancer'],
  [1144520837,1144740098,'Leo'],
  [1144740098,1144954981,'Virgo'],
  [1144954981,1145162258,'Libra'],
  [1145162258,1145361288,'Scorpio'],
  [1145361288,1145552356,'Sagittarius'],
  [1145552356,1145736292,'Capricorn'],
  [1145736292,1145915004,'Aquarius'],
  [1145915004,1146092083,'Pisces'],
  [1146092083,1146272733,'Aries'],
  [1146272733,1146462624,'Taurus'],
  [1146462624,1146665556,'Gemini'],
  [1146665556,1146880267,'Cancer'],
  [1146880267,1147099460,'Leo'],
  [1147099460,1147314171,'Virgo'],
  [1147314171,1147519398,'Libra'],
  [1147519398,1147715303,'Scorpio'],
  [1147715303,1147904586,'Sagittarius'],
  [1147904586,1148089869,'Capricorn'],
  [1148089869,1148272828,'Aquarius'],
  [1148272828,1148454957,'Pisces'],
  [1148454957,1148638949,'Aries'],
  [1148638949,1148829075,'Taurus'],
  [1148829075,1149029680,'Gemini'],
  [1149029680,1149241946,'Cancer'],
  [1149241946,1149460816,'Leo'],
  [1149460816,1149676624,'Virgo'],
  [1149676624,1149881796,'Libra'],
  [1149881796,1150075169,'Scorpio'],
  [1150075169,1150260446,'Sagittarius'],
  [1150260446,1150442557,'Capricorn'],
  [1150442557,1150625165,'Aquarius'],
  [1150625165,1150810016,'Pisces'],
  [1150810016,1150998095,'Aries'],
  [1150998095,1151191261,'Taurus'],
  [1151191261,1151392452,'Gemini'],
  [1151392452,1151603590,'Cancer'],
  [1151603590,1151822092,'Leo'],
  [1151822092,1152039715,'Virgo'],
  [1152039715,1152247260,'Libra'],
  [1152247260,1152440982,'Scorpio'],
  [1152440982,1152623609,'Sagittarius'],
  [1152623609,1152801065,'Capricorn'],
  [1152801065,1152979237,'Aquarius'],
  [1152979237,1153162113,'Pisces'],
  [1153162113,1153351386,'Aries'],
  [1153351386,1153547544,'Taurus'],
  [1153547544,1153751178,'Gemini'],
  [1153751178,1153962920,'Cancer'],
  [1153962920,1154181302,'Leo'],
  [1154181302,1154400475,'Virgo'],
  [1154400475,1154611747,'Libra'],
  [1154611747,1154809068,'Scorpio'],
  [1154809068,1154992678,'Sagittarius'],
  [1154992678,1155167665,'Capricorn'],
  [1155167665,1155340792,'Aquarius'],
  [1155340792,1155518238,'Pisces'],
  [1155518238,1155704183,'Aries'],
  [1155704183,1155900214,'Taurus'],
  [1155900214,1156105759,'Gemini'],
  [1156105759,1156319092,'Cancer'],
  [1156319092,1156537758,'Leo'],
  [1156537758,1156757470,'Virgo'],
  [1156757470,1156971743,'Libra'],
  [1156971743,1157174246,'Scorpio'],
  [1157174246,1157362556,'Sagittarius'],
  [1157362556,1157539315,'Capricorn'],
  [1157539315,1157710393,'Aquarius'],
  [1157710393,1157882710,'Pisces'],
  [1157882710,1158062633,'Aries'],
  [1158062633,1158254458,'Taurus'],
  [1158254458,1158458983,'Gemini'],
  [1158458983,1158673275,'Cancer'],
  [1158673275,1158892492,'Leo'],
  [1158892492,1159111810,'Virgo'],
  [1159111810,1159326725,'Libra'],
  [1159326725,1159532918,'Scorpio'],
  [1159532918,1159727248,'Sagittarius'],
  [1159727248,1159909592,'Capricorn'],
  [1159909592,1160083291,'Aquarius'],
  [1160083291,1160254204,'Pisces'],
  [1160254204,1160429302,'Aries'],
  [1160429302,1160615066,'Taurus'],
  [1160615066,1160815199,'Gemini'],
  [1160815199,1161028197,'Cancer'],
  [1161028197,1161247678,'Leo'],
  [1161247678,1161466448,'Virgo'],
  [1161466448,1161679941,'Libra'],
  [1161679941,1161886156,'Scorpio'],
  [1161886156,1162083888,'Sagittarius'],
  [1162083888,1162272323,'Capricorn'],
  [1162272323,1162452114,'Aquarius'],
  [1162452114,1162626451,'Pisces'],
  [1162626451,1162801007,'Aries'],
  [1162801007,1162982682,'Taurus'],
  [1162982682,1163177395,'Gemini'],
  [1163177395,1163386702,'Cancer'],
  [1163386702,1163605361,'Leo'],
  [1163605361,1163824115,'Virgo'],
  [1163824115,1164036102,'Libra'],
  [1164036102,1164239652,'Scorpio'],
  [1164239652,1164436058,'Sagittarius'],
  [1164436058,1164626595,'Capricorn'],
  [1164626595,1164811661,'Aquarius'],
  [1164811661,1164992035,'Pisces'],
  [1164992035,1165170615,'Aries'],
  [1165170615,1165352690,'Taurus'],
  [1165352690,1165544394,'Gemini'],
  [1165544394,1165749625,'Cancer'],
  [1165749625,1165966204,'Leo'],
  [1165966204,1166185346,'Virgo'],
  [1166185346,1166397580,'Libra'],
  [1166397580,1166599063,'Scorpio'],
  [1166599063,1166791617,'Sagittarius'],
  [1166791617,1166979026,'Capricorn'],
  [1166979026,1167164117,'Aquarius'],
  [1167164117,1167348104,'Pisces'],
  [1167348104,1167531982,'Aries'],
  [1167531982,1167718254,'Taurus'],
  [1167718254,1167911096,'Gemini'],
  [1167911096,1168114515,'Cancer'],
  [1168114515,1168328875,'Leo'],
  [1168328875,1168548172,'Virgo'],
  [1168548172,1168762506,'Libra'],
  [1168762506,1168965016,'Scorpio'],
  [1168965016,1169155501,'Sagittarius'],
  [1169155501,1169338244,'Capricorn'],
  [1169338244,1169518466,'Aquarius'],
  [1169518466,1169700139,'Pisces'],
  [1169700139,1169885451,'Aries'],
  [1169885451,1170075672,'Taurus'],
  [1170075672,1170272282,'Gemini'],
  [1170272282,1170477089,'Cancer'],
  [1170477089,1170690654,'Leo'],
  [1170690654,1170909675,'Virgo'],
  [1170909675,1171126456,'Libra'],
  [1171126456,1171332836,'Scorpio'],
  [1171332836,1171525430,'Sagittarius'],
  [1171525430,1171706609,'Capricorn'],
  [1171706609,1171881937,'Aquarius'],
  [1171881937,1172057565,'Pisces'],
  [1172057565,1172238589,'Aries'],
  [1172238589,1172428116,'Taurus'],
  [1172428116,1172627052,'Gemini'],
  [1172627052,1172834647,'Cancer'],
  [1172834647,1173049264,'Leo'],
  [1173049264,1173268074,'Virgo'],
  [1173268074,1173486096,'Libra'],
  [1173486096,1173696662,'Scorpio'],
  [1173696662,1173894509,'Sagittarius'],
  [1173894509,1174078862,'Capricorn'],
  [1174078862,1174253432,'Aquarius'],
  [1174253432,1174424536,'Pisces'],
  [1174424536,1174599146,'Aries'],
  [1174599146,1174783233,'Taurus'],
  [1174783233,1174979970,'Gemini'],
  [1174979970,1175188455,'Cancer'],
  [1175188455,1175404614,'Leo'],
  [1175404614,1175623694,'Virgo'],
  [1175623694,1175841548,'Libra'],
  [1175841548,1176054087,'Scorpio'],
  [1176054087,1176256937,'Sagittarius'],
  [1176256937,1176447278,'Capricorn'],
  [1176447278,1176625818,'Aquarius'],
  [1176625818,1176797065,'Pisces'],
  [1176797065,1176967955,'Aries'],
  [1176967955,1177145995,'Taurus'],
  [1177145995,1177337109,'Gemini'],
  [1177337109,1177542839,'Cancer'],
  [1177542839,1177758995,'Leo'],
  [1177758995,1177978467,'Virgo'],
  [1177978467,1178195606,'Libra'],
  [1178195606,1178407508,'Scorpio'],
  [1178407508,1178612180,'Sagittarius'],
  [1178612180,1178807413,'Capricorn'],
  [1178807413,1178992007,'Aquarius'],
  [1178992007,1179167677,'Pisces'],
  [1179167677,1179339554,'Aries'],
  [1179339554,1179514854,'Taurus'],
  [1179514854,1179700785,'Gemini'],
  [1179700785,1179901596,'Cancer'],
  [1179901596,1180115425,'Leo'],
  [1180115425,1180334682,'Virgo'],
  [1180334682,1180551372,'Libra'],
  [1180551372,1180761552,'Scorpio'],
  [1180761552,1180964699,'Sagittarius'],
  [1180964699,1181160872,'Capricorn'],
  [1181160872,1181349538,'Aquarius'],
  [1181349538,1181530803,'Pisces'],
  [1181530803,1181707237,'Aries'],
  [1181707237,1181884171,'Taurus'],
  [1181884171,1182068289,'Gemini'],
  [1182068289,1182265086,'Cancer'],
  [1182265086,1182475435,'Leo'],
  [1182475435,1182693600,'Virgo'],
  [1182693600,1182910438,'Libra'],
  [1182910438,1183119661,'Scorpio'],
  [1183119661,1183320154,'Sagittarius'],
  [1183320154,1183513645,'Capricorn'],
  [1183513645,1183701908,'Aquarius'],
  [1183701908,1183885963,'Pisces'],
  [1183885963,1184067164,'Aries'],
  [1184067164,1184248488,'Taurus'],
  [1184248488,1184434585,'Gemini'],
  [1184434585,1184630327,'Cancer'],
  [1184630327,1184838049,'Leo'],
  [1184838049,1185054712,'Virgo'],
  [1185054712,1185272196,'Libra'],
  [1185272196,1185482287,'Scorpio'],
  [1185482287,1185681612,'Sagittarius'],
  [1185681612,1185871665,'Capricorn'],
  [1185871665,1186056018,'Aquarius'],
  [1186056018,1186238112,'Pisces'],
  [1186238112,1186420558,'Aries'],
  [1186420558,1186605566,'Taurus'],
  [1186605566,1186795573,'Gemini'],
  [1186795573,1186993277,'Cancer'],
  [1186993277,1187200514,'Leo'],
  [1187200514,1187416086,'Virgo'],
  [1187416086,1187634318,'Libra'],
  [1187634318,1187846956,'Scorpio'],
  [1187846956,1188048058,'Sagittarius'],
  [1188048058,1188237015,'Capricorn'],
  [1188237015,1188417390,'Aquarius'],
  [1188417390,1188594467,'Pisces'],
  [1188594467,1188773385,'Aries'],
  [1188773385,1188958015,'Taurus'],
  [1188958015,1189150467,'Gemini'],
  [1189150467,1189351288,'Cancer'],
  [1189351288,1189560098,'Leo'],
  [1189560098,1189775564,'Virgo'],
  [1189775564,1189994211,'Libra'],
  [1189994211,1190209752,'Scorpio'],
  [1190209752,1190415176,'Sagittarius'],
  [1190415176,1190606918,'Capricorn'],
  [1190606918,1190786573,'Aquarius'],
  [1190786573,1190959506,'Pisces'],
  [1190959506,1191132605,'Aries'],
  [1191132605,1191312335,'Taurus'],
  [1191312335,1191502912,'Gemini'],
  [1191502912,1191704919,'Cancer'],
  [1191704919,1191915816,'Leo'],
  [1191915816,1192132153,'Virgo'],
  [1192132153,1192350786,'Libra'],
  [1192350786,1192567872,'Scorpio'],
  [1192567872,1192777812,'Sagittarius'],
  [1192777812,1192975289,'Capricorn'],
  [1192975289,1193158774,'Aquarius'],
  [1193158774,1193331726,'Pisces'],
  [1193331726,1193501016,'Aries'],
  [1193501016,1193674601,'Taurus'],
  [1193674601,1193859348,'Gemini'],
  [1193859348,1194058379,'Cancer'],
  [1194058379,1194269412,'Leo'],
  [1194269412,1194486762,'Virgo'],
  [1194486762,1194705330,'Libra'],
  [1194705330,1194922026,'Scorpio'],
  [1194922026,1195133830,'Sagittarius'],
  [1195133830,1195336501,'Capricorn'],
  [1195336501,1195526559,'Aquarius'],
  [1195526559,1195704338,'Pisces'],
  [1195704338,1195874724,'Aries'],
  [1195874724,1196045328,'Taurus'],
  [1196045328,1196224189,'Gemini'],
  [1196224189,1196417183,'Cancer'],
  [1196417183,1196624883,'Leo'],
  [1196624883,1196841856,'Virgo'],
  [1196841856,1197060570,'Libra'],
  [1197060570,1197276123,'Scorpio'],
  [1197276123,1197486582,'Sagittarius'],
  [1197486582,1197690373,'Capricorn'],
  [1197690373,1197885169,'Aquarius'],
  [1197885169,1198069601,'Pisces'],
  [1198069601,1198245562,'Aries'],
  [1198245562,1198418429,'Taurus'],
  [1198418429,1198595421,'Gemini'],
  [1198595421,1198783366,'Cancer'],
  [1198783366,1198985760,'Leo'],
  [1198985760,1199200089,'Virgo'],
  [1199200089,1199418688,'Libra'],
  [1199418688,1199633916,'Scorpio'],
  [1199633916,1199842200,'Sagittarius'],
  [1199842200,1200043257,'Capricorn'],
  [1200043257,1200237541,'Aquarius'],
  [1200237541,1200425205,'Pisces'],
  [1200425205,1200607026,'Aries'],
  [1200607026,1200785658,'Taurus'],
  [1200785658,1200965765,'Gemini'],
  [1200965765,1201152923,'Cancer'],
  [1201152923,1201351565,'Leo'],
  [1201351565,1201562246,'Virgo'],
  [1201562246,1201779888,'Libra'],
  [1201779888,1201995968,'Scorpio'],
  [1201995968,1202203932,'Sagittarius'],
  [1202203932,1202402070,'Capricorn'],
  [1202402070,1202592223,'Aquarius'],
  [1202592223,1202777376,'Pisces'],
  [1202777376,1202960260,'Aries'],
  [1202960260,1203143180,'Taurus'],
  [1203143180,1203328482,'Gemini'],
  [1203328482,1203518977,'Cancer'],
  [1203518977,1203717631,'Leo'],
  [1203717631,1203926083,'Virgo'],
  [1203926083,1204142314,'Libra'],
  [1204142314,1204359641,'Scorpio'],
  [1204359641,1204569785,'Sagittarius'],
  [1204569785,1204768009,'Capricorn'],
  [1204768009,1204954979,'Aquarius'],
  [1204954979,1205135040,'Pisces'],
  [1205135040,1205313631,'Aries'],
  [1205313631,1205495357,'Taurus'],
  [1205495357,1205682979,'Gemini'],
  [1205682979,1205877461,'Cancer'],
  [1205877461,1206079013,'Leo'],
  [1206079013,1206287863,'Virgo'],
  [1206287863,1206503283,'Libra'],
  [1206503283,1206721421,'Scorpio'],
  [1206721421,1206934881,'Sagittarius'],
  [1206934881,1207136570,'Capricorn'],
  [1207136570,1207324279,'Aquarius'],
  [1207324279,1207501418,'Pisces'],
  [1207501418,1207674596,'Aries'],
  [1207674596,1207850838,'Taurus'],
  [1207850838,1208035443,'Gemini'],
  [1208035443,1208230399,'Cancer'],
  [1208230399,1208434482,'Leo'],
  [1208434482,1208645341,'Virgo'],
  [1208645341,1208861105,'Libra'],
  [1208861105,1209079439,'Scorpio'],
  [1209079439,1209295374,'Sagittarius'],
  [1209295374,1209501842,'Capricorn'],
  [1209501842,1209694000,'Aquarius'],
  [1209694000,1209872648,'Pisces'],
  [1209872648,1210043567,'Aries'],
  [1210043567,1210214619,'Taurus'],
  [1210214619,1210393229,'Gemini'],
  [1210393229,1210584081,'Cancer'],
  [1210584081,1210787337,'Leo'],
  [1210787337,1210999441,'Virgo'],
  [1210999441,1211216156,'Libra'],
  [1211216156,1211434390,'Scorpio'],
  [1211434390,1211650909,'Sagittarius'],
  [1211650909,1211860661,'Capricorn'],
  [1211860661,1212058318,'Aquarius'],
  [1212058318,1212242050,'Pisces'],
  [1212242050,1212415255,'Aries'],
  [1212415255,1212584878,'Taurus'],
  [1212584878,1212758841,'Gemini'],
  [1212758841,1212943798,'Cancer'],
  [1212943798,1213142708,'Leo'],
  [1213142708,1213353463,'Virgo'],
  [1213353463,1213570558,'Libra'],
  [1213570558,1213788696,'Scorpio'],
  [1213788696,1214004338,'Sagittarius'],
  [1214004338,1214214379,'Capricorn'],
  [1214214379,1214415276,'Aquarius'],
  [1214415276,1214604565,'Pisces'],
  [1214604565,1214783171,'Aries'],
  [1214783171,1214955740,'Taurus'],
  [1214955740,1215129049,'Gemini'],
  [1215129049,1215310051,'Cancer'],
  [1215310051,1215503715,'Leo'],
  [1215503715,1215710747,'Virgo'],
  [1215710747,1215926791,'Libra'],
  [1215926791,1216144887,'Scorpio'],
  [1216144887,1216359458,'Sagittarius'],
  [1216359458,1216567575,'Capricorn'],
  [1216567575,1216767878,'Aquarius'],
  [1216767878,1216959660,'Pisces'],
  [1216959660,1217143332,'Aries'],
  [1217143332,1217321300,'Taurus'],
  [1217321300,1217497975,'Gemini'],
  [1217497975,1217678929,'Cancer'],
  [1217678929,1217869442,'Leo'],
  [1217869442,1218072415,'Virgo'],
  [1218072415,1218286169,'Libra'],
  [1218286169,1218504167,'Scorpio'],
  [1218504167,1218718620,'Sagittarius'],
  [1218718620,1218924808,'Capricorn'],
  [1218924808,1219122019,'Aquarius'],
  [1219122019,1219311923,'Pisces'],
  [1219311923,1219496791,'Aries'],
  [1219496791,1219678861,'Taurus'],
  [1219678861,1219860563,'Gemini'],
  [1219860563,1220044981,'Cancer'],
  [1220044981,1220235876,'Leo'],
  [1220235876,1220436641,'Virgo'],
  [1220436641,1220648022,'Libra'],
  [1220648022,1220865765,'Scorpio'],
  [1220865765,1221081471,'Sagittarius'],
  [1221081471,1221287754,'Capricorn'],
  [1221287754,1221482434,'Aquarius'],
  [1221482434,1221668160,'Pisces'],
  [1221668160,1221849642,'Aries'],
  [1221849642,1222031215,'Taurus'],
  [1222031215,1222215648,'Gemini'],
  [1222215648,1222404323,'Cancer'],
  [1222404323,1222598435,'Leo'],
  [1222598435,1222799836,'Virgo'],
  [1222799836,1223010043,'Libra'],
  [1223010043,1223227412,'Scorpio'],
  [1223227412,1223445155,'Sagittarius'],
  [1223445155,1223654226,'Capricorn'],
  [1223654226,1223849546,'Aquarius'],
  [1223849546,1224032581,'Pisces'],
  [1224032581,1224209081,'Aries'],
  [1224209081,1224385749,'Taurus'],
  [1224385749,1224567799,'Gemini'],
  [1224567799,1224757551,'Cancer'],
  [1224757551,1224954811,'Leo'],
  [1224954811,1225158856,'Virgo'],
  [1225158856,1225369709,'Libra'],
  [1225369709,1225586834,'Scorpio'],
  [1225586834,1225806118,'Sagittarius'],
  [1225806118,1226019336,'Capricorn'],
  [1226019336,1226218981,'Aquarius'],
  [1226218981,1226403578,'Pisces'],
  [1226403578,1226577797,'Aries'],
  [1226577797,1226749151,'Taurus'],
  [1226749151,1226925065,'Gemini'],
  [1226925065,1227110678,'Cancer'],
  [1227110678,1227307345,'Leo'],
  [1227307345,1227513286,'Virgo'],
  [1227513286,1227725932,'Libra'],
  [1227725932,1227943341,'Scorpio'],
  [1227943341,1228162868,'Sagittarius'],
  [1228162868,1228378920,'Capricorn'],
  [1228378920,1228584200,'Aquarius'],
  [1228584200,1228774459,'Pisces'],
  [1228774459,1228951451,'Aries'],
  [1228951451,1229121452,'Taurus'],
  [1229121452,1229292300,'Gemini'],
  [1229292300,1229471163,'Cancer'],
  [1229471163,1229662513,'Leo'],
  [1229662513,1229866621,'Virgo'],
  [1229866621,1230080079,'Libra'],
  [1230080079,1230298254,'Scorpio'],
  [1230298254,1230517269,'Sagittarius'],
  [1230517269,1230733310,'Capricorn'],
  [1230733310,1230941665,'Aquarius'],
  [1230941665,1231138087,'Pisces'],
  [1231138087,1231321616,'Aries'],
  [1231321616,1231495598,'Taurus'],
  [1231495598,1231666278,'Gemini'],
  [1231666278,1231840840,'Cancer'],
  [1231840840,1232025659,'Leo'],
  [1232025659,1232224284,'Virgo'],
  [1232224284,1232435576,'Libra'],
  [1232435576,1232653949,'Scorpio'],
  [1232653949,1232872723,'Sagittarius'],
  [1232872723,1233087128,'Capricorn'],
  [1233087128,1233294477,'Aquarius'],
  [1233294477,1233493103,'Pisces'],
  [1233493103,1233682238,'Aries'],
  [1233682238,1233862895,'Taurus'],
  [1233862895,1234038362,'Gemini'],
  [1234038362,1234213851,'Cancer'],
  [1234213851,1234395478,'Leo'],
  [1234395478,1234588628,'Virgo'],
  [1234588628,1234795442,'Libra'],
  [1234795442,1235012387,'Scorpio'],
  [1235012387,1235231348,'Sagittarius'],
  [1235231348,1235444762,'Capricorn'],
  [1235444762,1235649340,'Aquarius'],
  [1235649340,1235845565,'Pisces'],
  [1235845565,1236035240,'Aries'],
  [1236035240,1236220019,'Taurus'],
  [1236220019,1236401443,'Gemini'],
  [1236401443,1236581860,'Cancer'],
  [1236581860,1236765174,'Leo'],
  [1236765174,1236956349,'Virgo'],
  [1236956349,1237159341,'Libra'],
  [1237159341,1237373747,'Scorpio'],
  [1237373747,1237592806,'Sagittarius'],
  [1237592806,1237806914,'Capricorn'],
  [1237806914,1238010173,'Aquarius'],
  [1238010173,1238202816,'Pisces'],
  [1238202816,1238388724,'Aries'],
  [1238388724,1238572100,'Taurus'],
  [1238572100,1238755658,'Gemini'],
  [1238755658,1238940654,'Cancer'],
  [1238940654,1239128397,'Leo'],
  [1239128397,1239321564,'Virgo'],
  [1239321564,1239523635,'Libra'],
  [1239523635,1239736089,'Scorpio'],
  [1239736089,1239954943,'Sagittarius'],
  [1239954943,1240170960,'Capricorn'],
  [1240170960,1240375718,'Aquarius'],
  [1240375718,1240567166,'Pisces'],
  [1240567166,1240749140,'Aries'],
  [1240749140,1240927698,'Taurus'],
  [1240927698,1241108088,'Gemini'],
  [1241108088,1241293222,'Cancer'],
  [1241293222,1241483919,'Leo'],
  [1241483919,1241680594,'Virgo'],
  [1241680594,1241884483,'Libra'],
  [1241884483,1242096716,'Scorpio'],
  [1242096716,1242315335,'Sagittarius'],
  [1242315335,1242533321,'Capricorn'],
  [1242533321,1242741637,'Aquarius'],
  [1242741637,1242935478,'Pisces'],
  [1242935478,1243116719,'Aries'],
  [1243116719,1243291385,'Taurus'],
  [1243291385,1243466320,'Gemini'],
  [1243466320,1243646971,'Cancer'],
  [1243646971,1243836178,'Leo'],
  [1243836178,1244034330,'Virgo'],
  [1244034330,1244240633,'Libra'],
  [1244240633,1244454100,'Scorpio'],
  [1244454100,1244672776,'Sagittarius'],
  [1244672776,1244891805,'Capricorn'],
  [1244891805,1245103726,'Aquarius'],
  [1245103726,1245302374,'Pisces'],
  [1245302374,1245486859,'Aries'],
  [1245486859,1245661420,'Taurus'],
  [1245661420,1245832760,'Gemini'],
  [1245832760,1246007729,'Cancer'],
  [1246007729,1246191707,'Leo'],
  [1246191707,1246387339,'Virgo'],
  [1246387339,1246594044,'Libra'],
  [1246594044,1246808832,'Scorpio'],
  [1246808832,1247027875,'Sagittarius'],
  [1247027875,1247246806,'Capricorn'],
  [1247246806,1247460426,'Aquarius'],
  [1247460426,1247663596,'Pisces'],
  [1247663596,1247853682,'Aries'],
  [1247853682,1248032210,'Taurus'],
  [1248032210,1248204100,'Gemini'],
  [1248204100,1248375931,'Cancer'],
  [1248375931,1248554390,'Leo'],
  [1248554390,1248744680,'Virgo'],
  [1248744680,1248948576,'Libra'],
  [1248948576,1249163208,'Scorpio'],
  [1249163208,1249382591,'Sagittarius'],
  [1249382591,1249600845,'Capricorn'],
  [1249600845,1249813776,'Aquarius'],
  [1249813776,1250018581,'Pisces'],
  [1250018581,1250213341,'Aries'],
  [1250213341,1250397796,'Taurus'],
  [1250397796,1250574180,'Gemini'],
  [1250574180,1250747183,'Cancer'],
  [1250747183,1250923107,'Leo'],
  [1250923107,1251108431,'Virgo'],
  [1251108431,1251307555,'Libra'],
  [1251307555,1251519894,'Scorpio'],
  [1251519894,1251739088,'Sagittarius'],
  [1251739088,1251956896,'Capricorn'],
  [1251956896,1252168029,'Aquarius'],
  [1252168029,1252371155,'Pisces'],
  [1252371155,1252566737,'Aries'],
  [1252566737,1252755267,'Taurus'],
  [1252755267,1252937402,'Gemini'],
  [1252937402,1253115174,'Cancer'],
  [1253115174,1253292844,'Leo'],
  [1253292844,1253476371,'Virgo'],
  [1253476371,1253671472,'Libra'],
  [1253671472,1253880321,'Scorpio'],
  [1253880321,1254098491,'Sagittarius'],
  [1254098491,1254316581,'Capricorn'],
  [1254316581,1254526779,'Aquarius'],
  [1254526779,1254727066,'Pisces'],
  [1254727066,1254919658,'Aries'],
  [1254919658,1255107529,'Taurus'],
  [1255107529,1255292439,'Gemini'],
  [1255292439,1255475242,'Cancer'],
  [1255475242,1255657641,'Leo'],
  [1255657641,1255843371,'Virgo'],
  [1255843371,1256037464,'Libra'],
  [1256037464,1256243579,'Scorpio'],
  [1256243579,1256460173,'Sagittarius'],
  [1256460173,1256679091,'Capricorn'],
  [1256679091,1256890507,'Aquarius'],
  [1256890507,1257089812,'Pisces'],
  [1257089812,1257278801,'Aries'],
  [1257278801,1257462249,'Taurus'],
  [1257462249,1257644568,'Gemini'],
  [1257644568,1257828268,'Cancer'],
  [1257828268,1258014445,'Leo'],
  [1258014445,1258204466,'Virgo'],
  [1258204466,1258400928,'Libra'],
  [1258400928,1258606705,'Scorpio'],
  [1258606705,1258822045,'Sagittarius'],
  [1258822045,1259041638,'Capricorn'],
  [1259041638,1259256011,'Aquarius'],
  [1259256011,1259457827,'Pisces'],
  [1259457827,1259646314,'Aries'],
  [1259646314,1259825858,'Taurus'],
  [1259825858,1260002540,'Gemini'],
  [1260002540,1260181667,'Cancer'],
  [1260181667,1260366588,'Leo'],
  [1260366588,1260558748,'Virgo'],
  [1260558748,1260758624,'Libra'],
  [1260758624,1260966469,'Scorpio'],
  [1260966469,1261181813,'Sagittarius'],
  [1261181813,1261401482,'Capricorn'],
  [1261401482,1261618601,'Aquarius'],
  [1261618601,1261825327,'Pisces'],
  [1261825327,1262017753,'Aries'],
  [1262017753,1262197710,'Taurus'],
  [1262197710,1262370756,'Gemini'],
  [1262370756,1262543627,'Cancer'],
  [1262543627,1262722462,'Leo'],
  [1262722462,1262911441,'Virgo'],
  [1262911441,1263111793,'Libra'],
  [1263111793,1263321861,'Scorpio'],
  [1263321861,1263538478,'Sagittarius'],
  [1263538478,1263758008,'Capricorn'],
  [1263758008,1263975968,'Aquarius'],
  [1263975968,1264186748,'Pisces'],
  [1264186748,1264385395,'Aries'],
  [1264385395,1264570521,'Taurus'],
  [1264570521,1264745088,'Gemini'],
  [1264745088,1264915120,'Cancer'],
  [1264915120,1265087874,'Leo'],
  [1265087874,1265270143,'Virgo'],
  [1265270143,1265466179,'Libra'],
  [1265466179,1265675523,'Scorpio'],
  [1265675523,1265893168,'Sagittarius'],
  [1265893168,1266112882,'Capricorn'],
  [1266112882,1266330070,'Aquarius'],
  [1266330070,1266541624,'Pisces'],
  [1266541624,1266744504,'Aries'],
  [1266744504,1266936223,'Taurus'],
  [1266936223,1267116678,'Gemini'],
  [1267116678,1267289273,'Cancer'],
  [1267289273,1267460323,'Leo'],
  [1267460323,1267637376,'Virgo'],
  [1267637376,1267827078,'Libra'],
  [1267827078,1268032103,'Scorpio'],
  [1268032103,1268248664,'Sagittarius'],
  [1268248664,1268468571,'Capricorn'],
  [1268468571,1268684867,'Aquarius'],
  [1268684867,1268894690,'Pisces'],
  [1268894690,1269097476,'Aries'],
  [1269097476,1269292541,'Taurus'],
  [1269292541,1269479011,'Gemini'],
  [1269479011,1269657568,'Cancer'],
  [1269657568,1269831937,'Leo'],
  [1269831937,1270008443,'Virgo'],
  [1270008443,1270194163,'Libra'],
  [1270194163,1270394071,'Scorpio'],
  [1270394071,1270607425,'Sagittarius'],
  [1270607425,1270826789,'Capricorn'],
  [1270826789,1271042973,'Aquarius'],
  [1271042973,1271251074,'Pisces'],
  [1271251074,1271451074,'Aries'],
  [1271451074,1271644686,'Taurus'],
  [1271644686,1271832940,'Gemini'],
  [1271832940,1272016239,'Cancer'],
  [1272016239,1272196062,'Leo'],
  [1272196062,1272376202,'Virgo'],
  [1272376202,1272562245,'Libra'],
  [1272562245,1272759462,'Scorpio'],
  [1272759462,1272969482,'Sagittarius'],
  [1272969482,1273187541,'Capricorn'],
  [1273187541,1273404349,'Aquarius'],
  [1273404349,1273612486,'Pisces'],
  [1273612486,1273810261,'Aries'],
  [1273810261,1274000125,'Taurus'],
  [1274000125,1274185458,'Gemini'],
  [1274185458,1274368753,'Cancer'],
  [1274368753,1274551717,'Leo'],
  [1274551717,1274736392,'Virgo'],
  [1274736392,1274925897,'Libra'],
  [1274925897,1275123868,'Scorpio'],
  [1275123868,1275332377,'Sagittarius'],
  [1275332377,1275549144,'Capricorn'],
  [1275549144,1275766860,'Aquarius'],
  [1275766860,1275977008,'Pisces'],
  [1275977008,1276175245,'Aries'],
  [1276175245,1276362686,'Taurus'],
  [1276362686,1276543544,'Gemini'],
  [1276543544,1276722619,'Cancer'],
  [1276722619,1276903882,'Leo'],
  [1276903882,1277090081,'Virgo'],
  [1277090081,1277282994,'Libra'],
  [1277282994,1277483827,'Scorpio'],
  [1277483827,1277693095,'Sagittarius'],
  [1277693095,1277909348,'Capricorn'],
  [1277909348,1278127763,'Aquarius'],
  [1278127763,1278340893,'Pisces'],
  [1278340893,1278542452,'Aries'],
  [1278542452,1278730920,'Taurus'],
  [1278730920,1278909420,'Gemini'],
  [1278909420,1279083615,'Cancer'],
  [1279083615,1279259684,'Leo'],
  [1279259684,1279442784,'Virgo'],
  [1279442784,1279635812,'Libra'],
  [1279635812,1279838877,'Scorpio'],
  [1279838877,1280050094,'Sagittarius'],
  [1280050094,1280266785,'Capricorn'],
  [1280266785,1280485421,'Aquarius'],
  [1280485421,1280700873,'Pisces'],
  [1280700873,1280907028,'Aries'],
  [1280907028,1281099909,'Taurus'],
  [1281099909,1281280077,'Gemini'],
  [1281280077,1281452250,'Cancer'],
  [1281452250,1281623396,'Leo'],
  [1281623396,1281800734,'Virgo'],
  [1281800734,1281989719,'Libra'],
  [1281989719,1282191871,'Scorpio'],
  [1282191871,1282404241,'Sagittarius'],
  [1282404241,1282621823,'Capricorn'],
  [1282621823,1282840313,'Aquarius'],
  [1282840313,1283056285,'Pisces'],
  [1283056285,1283265695,'Aries'],
  [1283265695,1283464150,'Taurus'],
  [1283464150,1283649560,'Gemini'],
  [1283649560,1283824133,'Cancer'],
  [1283824133,1283993882,'Leo'],
  [1283993882,1284166605,'Virgo'],
  [1284166605,1284349717,'Libra'],
  [1284349717,1284547487,'Scorpio'],
  [1284547487,1284758473,'Sagittarius'],
  [1284758473,1284976416,'Capricorn'],
  [1284976416,1285194743,'Aquarius'],
  [1285194743,1285409699,'Pisces'],
  [1285409699,1285619269,'Aries'],
  [1285619269,1285820996,'Taurus'],
  [1285820996,1286012240,'Gemini'],
  [1286012240,1286192592,'Cancer'],
  [1286192592,1286365548,'Leo'],
  [1286365548,1286537728,'Virgo'],
  [1286537728,1286716846,'Libra'],
  [1286716846,1286909167,'Scorpio'],
  [1286909167,1287116206,'Sagittarius'],
  [1287116206,1287333028,'Capricorn'],
  [1287333028,1287551371,'Aquarius'],
  [1287551371,1287765217,'Pisces'],
  [1287765217,1287972614,'Aries'],
  [1287972614,1288173389,'Taurus'],
  [1288173389,1288366960,'Gemini'],
  [1288366960,1288552629,'Cancer'],
  [1288552629,1288731513,'Leo'],
  [1288731513,1288907623,'Virgo'],
  [1288907623,1289087098,'Libra'],
  [1289087098,1289276295,'Scorpio'],
  [1289276295,1289478935,'Sagittarius'],
  [1289478935,1289693138,'Capricorn'],
  [1289693138,1289911422,'Aquarius'],
  [1289911422,1290125453,'Pisces'],
  [1290125453,1290331041,'Aries'],
  [1290331041,1290528357,'Taurus'],
  [1290528357,1290719293,'Gemini'],
  [1290719293,1290905517,'Cancer'],
  [1290905517,1291088406,'Leo'],
  [1291088406,1291270020,'Virgo'],
  [1291270020,1291453770,'Libra'],
  [1291453770,1291644031,'Scorpio'],
  [1291644031,1291844578,'Sagittarius'],
  [1291844578,1292056032,'Capricorn'],
  [1292056032,1292273802,'Aquarius'],
  [1292273802,1292489447,'Pisces'],
  [1292489447,1292695874,'Aries'],
  [1292695874,1292891102,'Taurus'],
  [1292891102,1293077509,'Gemini'],
  [1293077509,1293259285,'Cancer'],
  [1293259285,1293440482,'Leo'],
  [1293440482,1293624136,'Virgo'],
  [1293624136,1293812296,'Libra'],
  [1293812296,1294006561,'Scorpio'],
  [1294006561,1294208478,'Sagittarius'],
  [1294208478,1294418865,'Capricorn'],
  [1294418865,1294635843,'Aquarius'],
  [1294635843,1294853376,'Pisces'],
  [1294853376,1295063291,'Aries'],
  [1295063291,1295260348,'Taurus'],
  [1295260348,1295444915,'Gemini'],
  [1295444915,1295621680,'Cancer'],
  [1295621680,1295797024,'Leo'],
  [1295797024,1295976817,'Virgo'],
  [1295976817,1296164812,'Libra'],
  [1296164812,1296361892,'Scorpio'],
  [1296361892,1296566934,'Sagittarius'],
  [1296566934,1296778516,'Capricorn'],
  [1296778516,1296995182,'Aquarius'],
  [1296995182,1297213654,'Pisces'],
  [1297213654,1297427482,'Aries'],
  [1297427482,1297629618,'Taurus'],
  [1297629618,1297817104,'Gemini'],
  [1297817104,1297992785,'Cancer'],
  [1297992785,1298163382,'Leo'],
  [1298163382,1298336687,'Virgo'],
  [1298336687,1298519283,'Libra'],
  [1298519283,1298714341,'Scorpio'],
  [1298714341,1298920566,'Sagittarius'],
  [1298920566,1299134066,'Capricorn'],
  [1299134066,1299351315,'Aquarius'],
  [1299351315,1299569716,'Pisces'],
  [1299569716,1299785467,'Aries'],
  [1299785467,1299992632,'Taurus'],
  [1299992632,1300186163,'Gemini'],
  [1300186163,1300365742,'Cancer'],
  [1300365742,1300536335,'Leo'],
  [1300536335,1300705733,'Virgo'],
  [1300705733,1300881987,'Libra'],
  [1300881987,1301071056,'Scorpio'],
  [1301071056,1301274259,'Sagittarius'],
  [1301274259,1301487798,'Capricorn'],
  [1301487798,1301705804,'Aquarius'],
  [1301705804,1301923886,'Pisces'],
  [1301923886,1302139201,'Aries'],
  [1302139201,1302348298,'Taurus'],
  [1302348298,1302546941,'Gemini'],
  [1302546941,1302732825,'Cancer'],
  [1302732825,1302908021,'Leo'],
  [1302908021,1303078490,'Virgo'],
  [1303078490,1303251882,'Libra'],
  [1303251882,1303435329,'Scorpio'],
  [1303435329,1303632943,'Sagittarius'],
  [1303632943,1303843558,'Capricorn'],
  [1303843558,1304061228,'Aquarius'],
  [1304061228,1304279183,'Pisces'],
  [1304279183,1304493154,'Aries'],
  [1304493154,1304700937,'Taurus'],
  [1304700937,1304900708,'Gemini'],
  [1304900708,1305090965,'Cancer'],
  [1305090965,1305272114,'Leo'],
  [1305272114,1305447486,'Virgo'],
  [1305447486,1305622723,'Libra'],
  [1305622723,1305804259,'Scorpio'],
  [1305804259,1305997346,'Sagittarius'],
  [1305997346,1306203639,'Capricorn'],
  [1306203639,1306419486,'Aquarius'],
  [1306419486,1306637409,'Pisces'],
  [1306637409,1306850682,'Aries'],
  [1306850682,1307056116,'Taurus'],
  [1307056116,1307253425,'Gemini'],
  [1307253425,1307443526,'Cancer'],
  [1307443526,1307627783,'Leo'],
  [1307627783,1307808295,'Virgo'],
  [1307808295,1307988287,'Libra'],
  [1307988287,1308172016,'Scorpio'],
  [1308172016,1308363956,'Sagittarius'],
  [1308363956,1308567078,'Capricorn'],
  [1308567078,1308780516,'Aquarius'],
  [1308780516,1308998344,'Pisces'],
  [1308998344,1309212284,'Aries'],
  [1309212284,1309416722,'Taurus'],
  [1309416722,1309610851,'Gemini'],
  [1309610851,1309797332,'Cancer'],
  [1309797332,1309979943,'Leo'],
  [1309979943,1310162022,'Virgo'],
  [1310162022,1310346025,'Libra'],
  [1310346025,1310533958,'Scorpio'],
  [1310533958,1310728049,'Sagittarius'],
  [1310728049,1310930620,'Capricorn'],
  [1310930620,1311142406,'Aquarius'],
  [1311142406,1311360065,'Pisces'],
  [1311360065,1311575834,'Aries'],
  [1311575834,1311781802,'Taurus'],
  [1311781802,1311974919,'Gemini'],
  [1311974919,1312157703,'Cancer'],
  [1312157703,1312335689,'Leo'],
  [1312335689,1312514622,'Virgo'],
  [1312514622,1312698570,'Libra'],
  [1312698570,1312889208,'Scorpio'],
  [1312889208,1313086653,'Sagittarius'],
  [1313086653,1313291026,'Capricorn'],
  [1313291026,1313502688,'Aquarius'],
  [1313502688,1313720210,'Pisces'],
  [1313720210,1313937997,'Aries'],
  [1313937997,1314147588,'Taurus'],
  [1314147588,1314343175,'Gemini'],
  [1314343175,1314525271,'Cancer'],
  [1314525271,1314699423,'Leo'],
  [1314699423,1314872974,'Virgo'],
  [1314872974,1315052437,'Libra'],
  [1315052437,1315241508,'Scorpio'],
  [1315241508,1315440341,'Sagittarius'],
  [1315440341,1315647057,'Capricorn'],
  [1315647057,1315859916,'Aquarius'],
  [1315859916,1316077486,'Pisces'],
  [1316077486,1316296352,'Aries'],
  [1316296352,1316509705,'Taurus'],
  [1316509705,1316710389,'Gemini'],
  [1316710389,1316895971,'Cancer'],
  [1316895971,1317070127,'Leo'],
  [1317070127,1317240096,'Virgo'],
  [1317240096,1317413752,'Libra'],
  [1317413752,1317597343,'Scorpio'],
  [1317597343,1317793434,'Sagittarius'],
  [1317793434,1318000445,'Capricorn'],
  [1318000445,1318214632,'Aquarius'],
  [1318214632,1318432548,'Pisces'],
  [1318432548,1318651204,'Aries'],
  [1318651204,1318866181,'Taurus'],
  [1318866181,1319071599,'Gemini'],
  [1319071599,1319263300,'Cancer'],
  [1319263300,1319441987,'Leo'],
  [1319441987,1319612945,'Virgo'],
  [1319612945,1319783620,'Libra'],
  [1319783620,1319961415,'Scorpio'],
  [1319961415,1320151612,'Sagittarius'],
  [1320151612,1320355348,'Capricorn'],
  [1320355348,1320569238,'Aquarius'],
  [1320569238,1320787600,'Pisces'],
  [1320787600,1321005531,'Aries'],
  [1321005531,1321219465,'Taurus'],
  [1321219465,1321426117,'Gemini'],
  [1321426117,1321622531,'Cancer'],
  [1321622531,1321807743,'Leo'],
  [1321807743,1321984110,'Virgo'],
  [1321984110,1322156832,'Libra'],
  [1322156832,1322332501,'Scorpio'],
  [1322332501,1322517457,'Sagittarius'],
  [1322517457,1322715723,'Capricorn'],
  [1322715723,1322926756,'Aquarius'],
  [1322926756,1323144917,'Pisces'],
  [1323144917,1323362679,'Aries'],
  [1323362679,1323574737,'Taurus'],
  [1323574737,1323779029,'Gemini'],
  [1323779029,1323975373,'Cancer'],
  [1323975373,1324164221,'Leo'],
  [1324164221,1324346701,'Virgo'],
  [1324346701,1324525215,'Libra'],
  [1324525215,1324703769,'Scorpio'],
  [1324703769,1324887581,'Sagittarius'],
  [1324887581,1325081724,'Capricorn'],
  [1325081724,1325288652,'Aquarius'],
  [1325288652,1325505381,'Pisces'],
  [1325505381,1325723722,'Aries'],
  [1325723722,1325935410,'Taurus'],
  [1325935410,1326136902,'Gemini'],
  [1326136902,1326329455,'Cancer'],
  [1326329455,1326516339,'Leo'],
  [1326516339,1326700505,'Virgo'],
  [1326700505,1326883828,'Libra'],
  [1326883828,1327067816,'Scorpio'],
  [1327067816,1327254902,'Sagittarius'],
  [1327254902,1327448829,'Capricorn'],
  [1327448829,1327653121,'Aquarius'],
  [1327653121,1327867822,'Pisces'],
  [1327867822,1328086826,'Aries'],
  [1328086826,1328300349,'Taurus'],
  [1328300349,1328501762,'Gemini'],
  [1328501762,1328691128,'Cancer'],
  [1328691128,1328873115,'Leo'],
  [1328873115,1329053365,'Virgo'],
  [1329053365,1329236026,'Libra'],
  [1329236026,1329422879,'Scorpio'],
  [1329422879,1329614341,'Sagittarius'],
  [1329614341,1329811380,'Capricorn'],
  [1329811380,1330016077,'Aquarius'],
  [1330016077,1330229630,'Pisces'],
  [1330229630,1330448856,'Aries'],
  [1330448856,1330665215,'Taurus'],
  [1330665215,1330869853,'Gemini'],
  [1330869853,1331059858,'Cancer'],
  [1331059858,1331238893,'Leo'],
  [1331238893,1331413726,'Virgo'],
  [1331413726,1331590969,'Libra'],
  [1331590969,1331775027,'Scorpio'],
  [1331775027,1331967306,'Sagittarius'],
  [1331967306,1332167298,'Capricorn'],
  [1332167298,1332374432,'Aquarius'],
  [1332374432,1332588512,'Pisces'],
  [1332588512,1332807699,'Aries'],
  [1332807699,1333026109,'Taurus'],
  [1333026109,1333235287,'Gemini'],
  [1333235287,1333429719,'Cancer'],
  [1333429719,1333610325,'Leo'],
  [1333610325,1333782881,'Virgo'],
  [1333782881,1333954768,'Libra'],
  [1333954768,1334132619,'Scorpio'],
  [1334132619,1334320668,'Sagittarius'],
  [1334320668,1334519890,'Capricorn'],
  [1334519890,1334728612,'Aquarius'],
  [1334728612,1334944117,'Pisces'],
  [1334944117,1335163443,'Aries'],
  [1335163443,1335382307,'Taurus'],
  [1335382307,1335594569,'Gemini'],
  [1335594569,1335794497,'Cancer'],
  [1335794497,1335980359,'Leo'],
  [1335980359,1336155373,'Virgo'],
  [1336155373,1336325806,'Libra'],
  [1336325806,1336498768,'Scorpio'],
  [1336498768,1336680555,'Sagittarius'],
  [1336680555,1336875030,'Capricorn'],
  [1336875030,1337082209,'Aquarius'],
  [1337082209,1337298296,'Pisces'],
  [1337298296,1337517927,'Aries'],
  [1337517927,1337736153,'Taurus'],
  [1337736153,1337948712,'Gemini'],
  [1337948712,1338151888,'Cancer'],
  [1338151888,1338343449,'Leo'],
  [1338343449,1338524108,'Virgo'],
  [1338524108,1338697649,'Libra'],
  [1338697649,1338869922,'Scorpio'],
  [1338869922,1339047537,'Sagittarius'],
  [1339047537,1339236333,'Capricorn'],
  [1339236333,1339439192,'Aquarius'],
  [1339439192,1339653834,'Pisces'],
  [1339653834,1339873484,'Aries'],
  [1339873484,1340090967,'Taurus'],
  [1340090967,1340301890,'Gemini'],
  [1340301890,1340504655,'Cancer'],
  [1340504655,1340698868,'Leo'],
  [1340698868,1340884794,'Virgo'],
  [1340884794,1341063937,'Libra'],
  [1341063937,1341239676,'Scorpio'],
  [1341239676,1341417249,'Sagittarius'],
  [1341417249,1341602748,'Capricorn'],
  [1341602748,1341801040,'Aquarius'],
  [1341801040,1342012620,'Pisces'],
  [1342012620,1342231630,'Aries'],
  [1342231630,1342448972,'Taurus'],
  [1342448972,1342658286,'Gemini'],
  [1342658286,1342858361,'Cancer'],
  [1342858361,1343051043,'Leo'],
  [1343051043,1343238440,'Virgo'],
  [1343238440,1343421910,'Libra'],
  [1343421910,1343602820,'Scorpio'],
  [1343602820,1343783954,'Sagittarius'],
  [1343783954,1343969931,'Capricorn'],
  [1343969931,1344165884,'Aquarius'],
  [1344165884,1344374449,'Pisces'],
  [1344374449,1344592272,'Aries'],
  [1344592272,1344810240,'Taurus'],
  [1344810240,1345019595,'Gemini'],
  [1345019595,1345217485,'Cancer'],
  [1345217485,1345406485,'Leo'],
  [1345406485,1345590970,'Virgo'],
  [1345590970,1345774338,'Libra'],
  [1345774338,1345958250,'Scorpio'],
  [1345958250,1346143800,'Sagittarius'],
  [1346143800,1346333178,'Capricorn'],
  [1346333178,1346529940,'Aquarius'],
  [1346529940,1346737138,'Pisces'],
  [1346737138,1346953799,'Aries'],
  [1346953799,1347172784,'Taurus'],
  [1347172784,1347384281,'Gemini'],
  [1347384281,1347582726,'Cancer'],
  [1347582726,1347769339,'Leo'],
  [1347769339,1347949313,'Virgo'],
  [1347949313,1348128312,'Libra'],
  [1348128312,1348310357,'Scorpio'],
  [1348310357,1348497346,'Sagittarius'],
  [1348497346,1348690136,'Capricorn'],
  [1348690136,1348889845,'Aquarius'],
  [1348889845,1349097890,'Pisces'],
  [1349097890,1349314055,'Aries'],
  [1349314055,1349533769,'Taurus'],
  [1349533769,1349748471,'Gemini'],
  [1349748471,1349950646,'Cancer'],
  [1349950646,1350138658,'Leo'],
  [1350138658,1350316452,'Virgo'],
  [1350316452,1350490409,'Libra'],
  [1350490409,1350666798,'Scorpio'],
  [1350666798,1350850211,'Sagittarius'],
  [1350850211,1351042851,'Capricorn'],
  [1351042851,1351244829,'Aquarius'],
  [1351244829,1351455039,'Pisces'],
  [1351455039,1351671710,'Aries'],
  [1351671710,1351891483,'Taurus'],
  [1351891483,1352108430,'Gemini'],
  [1352108430,1352315581,'Cancer'],
  [1352315581,1352508787,'Leo'],
  [1352508787,1352689066,'Virgo'],
  [1352689066,1352861456,'Libra'],
  [1352861456,1353032748,'Scorpio'],
  [1353032748,1353209696,'Sagittarius'],
  [1353209696,1353397455,'Capricorn'],
  [1353397455,1353597988,'Aquarius'],
  [1353597988,1353809364,'Pisces'],
  [1353809364,1354027156,'Aries'],
  [1354027156,1354246684,'Taurus'],
  [1354246684,1354463670,'Gemini'],
  [1354463670,1354673746,'Cancer'],
  [1354673746,1354872885,'Leo'],
  [1354872885,1355059439,'Virgo'],
  [1355059439,1355235432,'Libra'],
  [1355235432,1355406114,'Scorpio'],
  [1355406114,1355578506,'Sagittarius'],
  [1355578506,1355759745,'Capricorn'],
  [1355759745,1355954898,'Aquarius'],
  [1355954898,1356164216,'Pisces'],
  [1356164216,1356382375,'Aries'],
  [1356382375,1356601938,'Taurus'],
  [1356601938,1356817615,'Gemini'],
  [1356817615,1357027001,'Cancer'],
  [1357027001,1357228619,'Leo'],
  [1357228619,1357420980,'Virgo'],
  [1357420980,1357603652,'Libra'],
  [1357603652,1357778836,'Scorpio'],
  [1357778836,1357951760,'Sagittarius'],
  [1357951760,1358129501,'Capricorn'],
  [1358129501,1358318903,'Aquarius'],
  [1358318903,1358523412,'Pisces'],
  [1358523412,1358739867,'Aries'],
  [1358739867,1358959572,'Taurus'],
  [1358959572,1359174449,'Gemini'],
  [1359174449,1359381399,'Cancer'],
  [1359381399,1359581021,'Leo'],
  [1359581021,1359774390,'Virgo'],
  [1359774390,1359961663,'Libra'],
  [1359961663,1360143083,'Scorpio'],
  [1360143083,1360320947,'Sagittarius'],
  [1360320947,1360500256,'Capricorn'],
  [1360500256,1360687436,'Aquarius'],
  [1360687436,1360887623,'Pisces'],
  [1360887623,1361100864,'Aries'],
  [1361100864,1361320154,'Taurus'],
  [1361320154,1361535594,'Gemini'],
  [1361535594,1361741369,'Cancer'],
  [1361741369,1361937646,'Leo'],
  [1361937646,1362127517,'Virgo'],
  [1362127517,1362313784,'Libra'],
  [1362313784,1362497854,'Scorpio'],
  [1362497854,1362680752,'Sagittarius'],
  [1362680752,1362864817,'Capricorn'],
  [1362864817,1363054159,'Aquarius'],
  [1363054159,1363253266,'Pisces'],
  [1363253266,1363463963,'Aries'],
  [1363463963,1363682274,'Taurus'],
  [1363682274,1363899134,'Gemini'],
  [1363899134,1364106339,'Cancer'],
  [1364106339,1364301538,'Leo'],
  [1364301538,1364487546,'Virgo'],
  [1364487546,1364669043,'Libra'],
  [1364669043,1364850136,'Scorpio'],
  [1364850136,1365033527,'Sagittarius'],
  [1365033527,1365220997,'Capricorn'],
  [1365220997,1365414329,'Aquarius'],
  [1365414329,1365615583,'Pisces'],
  [1365615583,1365825971,'Aries'],
  [1365825971,1366043498,'Taurus'],
  [1366043498,1366261688,'Gemini'],
  [1366261688,1366472152,'Cancer'],
  [1366472152,1366669784,'Leo'],
  [1366669784,1366855131,'Virgo'],
  [1366855131,1367032665,'Libra'],
  [1367032665,1367208202,'Scorpio'],
  [1367208202,1367387103,'Sagittarius'],
  [1367387103,1367573201,'Capricorn'],
  [1367573201,1367768311,'Aquarius'],
  [1367768311,1367972425,'Pisces'],
  [1367972425,1368184401,'Aries'],
  [1368184401,1368401961,'Taurus'],
  [1368401961,1368620796,'Gemini'],
  [1368620796,1368834463,'Cancer'],
  [1368834463,1369036794,'Leo'],
  [1369036794,1369225465,'Virgo'],
  [1369225465,1369402900,'Libra'],
  [1369402900,1369574739,'Scorpio'],
  [1369574739,1369747840,'Sagittarius'],
  [1369747840,1369928564,'Capricorn'],
  [1369928564,1370121036,'Aquarius'],
  [1370121036,1370325634,'Pisces'],
  [1370325634,1370539249,'Aries'],
  [1370539249,1370757514,'Taurus'],
  [1370757514,1370976327,'Gemini'],
  [1370976327,1371191504,'Cancer'],
  [1371191504,1371398167,'Leo'],
  [1371398167,1371592419,'Virgo'],
  [1371592419,1371773855,'Libra'],
  [1371773855,1371946228,'Scorpio'],
  [1371946228,1372116180,'Sagittarius'],
  [1372116180,1372291315,'Capricorn'],
  [1372291315,1372478178,'Aquarius'],
  [1372478178,1372679614,'Pisces'],
  [1372679614,1372892931,'Aries'],
  [1372892931,1373111763,'Taurus'],
  [1373111763,1373330279,'Gemini'],
  [1373330279,1373544997,'Cancer'],
  [1373544997,1373753305,'Leo'],
  [1373753305,1373952188,'Virgo'],
  [1373952188,1374139542,'Libra'],
  [1374139542,1374316398,'Scorpio'],
  [1374316398,1374487565,'Sagittarius'],
  [1374487565,1374660267,'Capricorn'],
  [1374660267,1374842091,'Aquarius'],
  [1374842091,1375038323,'Pisces'],
  [1375038323,1375248753,'Aries'],
  [1375248753,1375467110,'Taurus'],
  [1375467110,1375685404,'Gemini'],
  [1375685404,1375898792,'Cancer'],
  [1375898792,1376105797,'Leo'],
  [1376105797,1376305696,'Virgo'],
  [1376305696,1376497219,'Libra'],
  [1376497219,1376679847,'Scorpio'],
  [1376679847,1376855801,'Sagittarius'],
  [1376855801,1377030376,'Capricorn'],
  [1377030376,1377210523,'Aquarius'],
  [1377210523,1377402539,'Pisces'],
  [1377402539,1377608828,'Aries'],
  [1377608828,1377825374,'Taurus'],
  [1377825374,1378043608,'Gemini'],
  [1378043608,1378256291,'Cancer'],
  [1378256291,1378460955,'Leo'],
  [1378460955,1378658344,'Virgo'],
  [1378658344,1378849605,'Libra'],
  [1378849605,1379035290,'Scorpio'],
  [1379035290,1379216418,'Sagittarius'],
  [1379216418,1379395841,'Capricorn'],
  [1379395841,1379578346,'Aquarius'],
  [1379578346,1379769379,'Pisces'],
  [1379769379,1379972555,'Aries'],
  [1379972555,1380186669,'Taurus'],
  [1380186669,1380404847,'Gemini'],
  [1380404847,1380618363,'Cancer'],
  [1380618363,1380822173,'Leo'],
  [1380822173,1381016340,'Virgo'],
  [1381016340,1381203696,'Libra'],
  [1381203696,1381387395,'Scorpio'],
  [1381387395,1381569940,'Sagittarius'],
  [1381569940,1381753486,'Capricorn'],
  [1381753486,1381940524,'Aquarius'],
  [1381940524,1382134067,'Pisces'],
  [1382134067,1382336820,'Aries'],
  [1382336820,1382549169,'Taurus'],
  [1382549169,1382767098,'Gemini'],
  [1382767098,1382982705,'Cancer'],
  [1382982705,1383188574,'Leo'],
  [1383188574,1383382128,'Virgo'],
  [1383382128,1383565710,'Libra'],
  [1383565710,1383744218,'Scorpio'],
  [1383744218,1383922891,'Sagittarius'],
  [1383922891,1384105876,'Capricorn'],
  [1384105876,1384295587,'Aquarius'],
  [1384295587,1384492884,'Pisces'],
  [1384492884,1384697859,'Aries'],
  [1384697859,1384910134,'Taurus'],
  [1384910134,1385127679,'Gemini'],
  [1385127679,1385345263,'Cancer'],
  [1385345263,1385555331,'Leo'],
  [1385555331,1385752320,'Virgo'],
  [1385752320,1385935946,'Libra'],
  [1385935946,1386110688,'Scorpio'],
  [1386110688,1386283368,'Sagittarius'],
  [1386283368,1386460838,'Capricorn'],
  [1386460838,1386648023,'Aquarius'],
  [1386648023,1386846345,'Pisces'],
  [1386846345,1387053913,'Aries'],
  [1387053913,1387267705,'Taurus'],
  [1387267705,1387485185,'Gemini'],
  [1387485185,1387703388,'Cancer'],
  [1387703388,1387917086,'Leo'],
  [1387917086,1388119870,'Virgo'],
  [1388119870,1388308216,'Libra'],
  [1388308216,1388484033,'Scorpio'],
  [1388484033,1388653622,'Sagittarius'],
  [1388653622,1388825034,'Capricorn'],
  [1388825034,1389005731,'Aquarius'],
  [1389005731,1389200074,'Pisces'],
  [1389200074,1389407249,'Aries'],
  [1389407249,1389622403,'Taurus'],
  [1389622403,1389840421,'Gemini'],
  [1389840421,1390058099,'Cancer'],
  [1390058099,1390272620,'Leo'],
  [1390272620,1390479600,'Virgo'],
  [1390479600,1390674466,'Libra'],
  [1390674466,1390855959,'Scorpio'],
  [1390855959,1391027843,'Sagittarius'],
  [1391027843,1391197334,'Capricorn'],
  [1391197334,1391372613,'Aquarius'],
  [1391372613,1391560422,'Pisces'],
  [1391560422,1391763145,'Aries'],
  [1391763145,1391977225,'Taurus'],
  [1391977225,1392195691,'Gemini'],
  [1392195691,1392412860,'Cancer'],
  [1392412860,1392625948,'Leo'],
  [1392625948,1392833023,'Virgo'],
  [1392833023,1393031467,'Libra'],
  [1393031467,1393219214,'Scorpio'],
  [1393219214,1393397191,'Sagittarius'],
  [1393397191,1393570031,'Capricorn'],
  [1393570031,1393744643,'Aquarius'],
  [1393744643,1393928120,'Pisces'],
  [1393928120,1394125202,'Aries'],
  [1394125202,1394335558,'Taurus'],
  [1394335558,1394553261,'Gemini'],
  [1394553261,1394770486,'Cancer'],
  [1394770486,1394982154,'Leo'],
  [1394982154,1395186642,'Virgo'],
  [1395186642,1395383814,'Libra'],
  [1395383814,1395573664,'Scorpio'],
  [1395573664,1395756784,'Sagittarius'],
  [1395756784,1395935459,'Capricorn'],
  [1395935459,1396113957,'Aquarius'],
  [1396113957,1396297728,'Pisces'],
  [1396297728,1396491739,'Aries'],
  [1396491739,1396698094,'Taurus'],
  [1396698094,1396913819,'Gemini'],
  [1396913819,1397131379,'Cancer'],
  [1397131379,1397343183,'Leo'],
  [1397343183,1397545611,'Virgo'],
  [1397545611,1397739115,'Libra'],
  [1397739115,1397926167,'Scorpio'],
  [1397926167,1398109540,'Sagittarius'],
  [1398109540,1398291732,'Capricorn'],
  [1398291732,1398475195,'Aquarius'],
  [1398475195,1398662750,'Pisces'],
  [1398662750,1398857572,'Aries'],
  [1398857572,1399062104,'Taurus'],
  [1399062104,1399275884,'Gemini'],
  [1399275884,1399493714,'Cancer'],
  [1399493714,1399707281,'Leo'],
  [1399707281,1399910216,'Virgo'],
  [1399910216,1400101364,'Libra'],
  [1400101364,1400283994,'Scorpio'],
  [1400283994,1400463234,'Sagittarius'],
  [1400463234,1400643863,'Capricorn'],
  [1400643863,1400829081,'Aquarius'],
  [1400829081,1401020363,'Pisces'],
  [1401020363,1401218356,'Aries'],
  [1401218356,1401423801,'Taurus'],
  [1401423801,1401636856,'Gemini'],
  [1401636856,1401854822,'Cancer'],
  [1401854822,1402070845,'Leo'],
  [1402070845,1402276905,'Virgo'],
  [1402276905,1402469089,'Libra'],
  [1402469089,1402649441,'Scorpio'],
  [1402649441,1402823916,'Sagittarius'],
  [1402823916,1402999422,'Capricorn'],
  [1402999422,1403181553,'Aquarius'],
  [1403181553,1403372996,'Pisces'],
  [1403372996,1403573393,'Aries'],
  [1403573393,1403781106,'Taurus'],
  [1403781106,1403994847,'Gemini'],
  [1403994847,1404212910,'Cancer'],
  [1404212910,1404430800,'Leo'],
  [1404430800,1404641044,'Virgo'],
  [1404641044,1404837469,'Libra'],
  [1404837469,1405019508,'Scorpio'],
  [1405019508,1405192123,'Sagittarius'],
  [1405192123,1405362883,'Capricorn'],
  [1405362883,1405539290,'Aquarius'],
  [1405539290,1405726571,'Pisces'],
  [1405726571,1405925919,'Aries'],
  [1405925919,1406134872,'Taurus'],
  [1406134872,1406349871,'Gemini'],
  [1406349871,1406568115,'Cancer'],
  [1406568115,1406786493,'Leo'],
  [1406786493,1406999677,'Virgo'],
  [1406999677,1407201378,'Libra'],
  [1407201378,1407388516,'Scorpio'],
  [1407388516,1407563581,'Sagittarius'],
  [1407563581,1407733134,'Capricorn'],
  [1407733134,1407905075,'Aquarius'],
  [1407905075,1408086440,'Pisces'],
  [1408086440,1408281141,'Aries'],
  [1408281141,1408488421,'Taurus'],
  [1408488421,1408703840,'Gemini'],
  [1408703840,1408922327,'Cancer'],
  [1408922327,1409140083,'Leo'],
  [1409140083,1409353539,'Virgo'],
  [1409353539,1409558424,'Libra'],
  [1409558424,1409751260,'Scorpio'],
  [1409751260,1409932026,'Sagittarius'],
  [1409932026,1410104828,'Capricorn'],
  [1410104828,1410276313,'Aquarius'],
  [1410276313,1410453692,'Pisces'],
  [1410453692,1410642756,'Aries'],
  [1410642756,1410845644,'Taurus'],
  [1410845644,1411059527,'Gemini'],
  [1411059527,1411278037,'Cancer'],
  [1411278037,1411495060,'Leo'],
  [1411495060,1411706784,'Virgo'],
  [1411706784,1411911057,'Libra'],
  [1411911057,1412106458,'Scorpio'],
  [1412106458,1412292654,'Sagittarius'],
  [1412292654,1412471417,'Capricorn'],
  [1412471417,1412646815,'Aquarius'],
  [1412646815,1412824464,'Pisces'],
  [1412824464,1413010233,'Aries'],
  [1413010233,1413208341,'Taurus'],
  [1413208341,1413418951,'Gemini'],
  [1413418951,1413636844,'Cancer'],
  [1413636844,1413853922,'Leo'],
  [1413853922,1414064074,'Virgo'],
  [1414064074,1414265336,'Libra'],
  [1414265336,1414458690,'Scorpio'],
  [1414458690,1414646027,'Sagittarius'],
  [1414646027,1414829219,'Capricorn'],
  [1414829219,1415010321,'Aquarius'],
  [1415010321,1415192209,'Pisces'],
  [1415192209,1415378863,'Aries'],
  [1415378863,1415574596,'Taurus'],
  [1415574596,1415781888,'Gemini'],
  [1415781888,1415998430,'Cancer'],
  [1415998430,1416216423,'Leo'],
  [1416216423,1416427094,'Virgo'],
  [1416427094,1416626301,'Libra'],
  [1416626301,1416815514,'Scorpio'],
  [1416815514,1416999094,'Sagittarius'],
  [1416999094,1417181394,'Capricorn'],
  [1417181394,1417365225,'Aquarius'],
  [1417365225,1417551912,'Pisces'],
  [1417551912,1417742647,'Aries'],
  [1417742647,1417939670,'Taurus'],
  [1417939670,1418145615,'Gemini'],
  [1418145615,1418360706,'Cancer'],
  [1418360706,1418579704,'Leo'],
  [1418579704,1418793136,'Virgo'],
  [1418793136,1418993740,'Libra'],
  [1418993740,1419180997,'Scorpio'],
  [1419180997,1419359794,'Sagittarius'],
  [1419359794,1419536772,'Capricorn'],
  [1419536772,1419717483,'Aquarius'],
  [1419717483,1419904757,'Pisces'],
  [1419904757,1420098832,'Aries'],
  [1420098832,1420299277,'Taurus'],
  [1420299277,1420506550,'Gemini'],
  [1420506550,1420721144,'Cancer'],
  [1420721144,1420940494,'Leo'],
  [1420940494,1421157127,'Virgo'],
  [1421157127,1421362252,'Libra'],
  [1421362252,1421552074,'Scorpio'],
  [1421552074,1421729633,'Sagittarius'],
  [1421729633,1421901867,'Capricorn'],
  [1421901867,1422076265,'Aquarius'],
  [1422076265,1422258561,'Pisces'],
  [1422258561,1422451164,'Aries'],
  [1422451164,1422653308,'Taurus'],
  [1422653308,1422862969,'Gemini'],
  [1422862969,1423078447,'Cancer'],
  [1423078447,1423297658,'Leo'],
  [1423297658,1423515831,'Virgo'],
  [1423515831,1423725612,'Libra'],
  [1423725612,1423921249,'Scorpio'],
  [1423921249,1424102582,'Sagittarius'],
  [1424102582,1424274687,'Capricorn'],
  [1424274687,1424444973,'Aquarius'],
  [1424444973,1424620752,'Pisces'],
  [1424620752,1424807379,'Aries'],
  [1424807379,1425006688,'Taurus'],
  [1425006688,1425216742,'Gemini'],
  [1425216742,1425433447,'Cancer'],
  [1425433447,1425652675,'Leo'],
  [1425652675,1425870424,'Virgo'],
  [1425870424,1426081996,'Libra'],
  [1426081996,1426282710,'Scorpio'],
  [1426282710,1426470445,'Sagittarius'],
  [1426470445,1426647256,'Capricorn'],
  [1426647256,1426818533,'Aquarius'],
  [1426818533,1426991151,'Pisces'],
  [1426991151,1427171796,'Aries'],
  [1427171796,1427365203,'Taurus'],
  [1427365203,1427572158,'Gemini'],
  [1427572158,1427788646,'Cancer'],
  [1427788646,1428008088,'Leo'],
  [1428008088,1428224767,'Virgo'],
  [1428224767,1428435099,'Libra'],
  [1428435099,1428636981,'Scorpio'],
  [1428636981,1428829245,'Sagittarius'],
  [1428829245,1429012283,'Capricorn'],
  [1429012283,1429188677,'Aquarius'],
  [1429188677,1429363117,'Pisces'],
  [1429363117,1429541619,'Aries'],
  [1429541619,1429730126,'Taurus'],
  [1429730126,1429932245,'Gemini'],
  [1429932245,1430146471,'Cancer'],
  [1430146471,1430365803,'Leo'],
  [1430365803,1430581999,'Virgo'],
  [1430581999,1430790215,'Libra'],
  [1430790215,1430989783,'Scorpio'],
  [1430989783,1431182011,'Sagittarius'],
  [1431182011,1431368347,'Capricorn'],
  [1431368347,1431550156,'Aquarius'],
  [1431550156,1431729567,'Pisces'],
  [1431729567,1431910340,'Aries'],
  [1431910340,1432097634,'Taurus'],
  [1432097634,1432296245,'Gemini'],
  [1432296245,1432507425,'Cancer'],
  [1432507425,1432726089,'Leo'],
  [1432726089,1432942792,'Virgo'],
  [1432942792,1433150184,'Libra'],
  [1433150184,1433346837,'Scorpio'],
  [1433346837,1433535654,'Sagittarius'],
  [1433535654,1433720476,'Capricorn'],
  [1433720476,1433903993,'Aquarius'],
  [1433903993,1434087604,'Pisces'],
  [1434087604,1434272785,'Aries'],
  [1434272785,1434462444,'Taurus'],
  [1434462444,1434660573,'Gemini'],
  [1434660573,1434869753,'Cancer'],
  [1434869753,1435087537,'Leo'],
  [1435087537,1435305478,'Virgo'],
  [1435305478,1435514257,'Libra'],
  [1435514257,1435710100,'Scorpio'],
  [1435710100,1435895529,'Sagittarius'],
  [1435895529,1436075957,'Capricorn'],
  [1436075957,1436256454,'Aquarius'],
  [1436256454,1436440093,'Pisces'],
  [1436440093,1436628090,'Aries'],
  [1436628090,1436821339,'Taurus'],
  [1436821339,1437021600,'Gemini'],
  [1437021600,1437230765,'Cancer'],
  [1437230765,1437448014,'Leo'],
  [1437448014,1437667255,'Virgo'],
  [1437667255,1437879134,'Libra'],
  [1437879134,1438077350,'Scorpio'],
  [1438077350,1438262304,'Sagittarius'],
  [1438262304,1438439181,'Capricorn'],
  [1438439181,1438614508,'Aquarius'],
  [1438614508,1438793783,'Pisces'],
  [1438793783,1438980252,'Aries'],
  [1438980252,1439174968,'Taurus'],
  [1439174968,1439377860,'Gemini'],
  [1439377860,1439588601,'Cancer'],
  [1439588601,1439806000,'Leo'],
  [1439806000,1440025937,'Virgo'],
  [1440025937,1440240978,'Libra'],
  [1440240978,1440443881,'Scorpio'],
  [1440443881,1440632232,'Sagittarius'],
  [1440632232,1440809222,'Capricorn'],
  [1440809222,1440981109,'Aquarius'],
  [1440981109,1441154725,'Pisces'],
  [1441154725,1441335819,'Aries'],
  [1441335819,1441527787,'Taurus'],
  [1441527787,1441731030,'Gemini'],
  [1441731030,1441943387,'Cancer'],
  [1441943387,1442161512,'Leo'],
  [1442161512,1442381395,'Virgo'],
  [1442381395,1442597870,'Libra'],
  [1442597870,1442805172,'Scorpio'],
  [1442805172,1442999376,'Sagittarius'],
  [1442999376,1443180751,'Capricorn'],
  [1443180751,1443353512,'Aquarius'],
  [1443353512,1443524079,'Pisces'],
  [1443524079,1443699423,'Aries'],
  [1443699423,1443885514,'Taurus'],
  [1443885514,1444085363,'Gemini'],
  [1444085363,1444297376,'Cancer'],
  [1444297376,1444516154,'Leo'],
  [1444516154,1444735691,'Virgo'],
  [1444735691,1444951452,'Libra'],
  [1444951452,1445160168,'Scorpio'],
  [1445160168,1445359124,'Sagittarius'],
  [1445359124,1445546954,'Capricorn'],
  [1445546954,1445724918,'Aquarius'],
  [1445724918,1445897222,'Pisces'],
  [1445897222,1446070220,'Aries'],
  [1446070220,1446250975,'Taurus'],
  [1446250975,1446445144,'Gemini'],
  [1446445144,1446653926,'Cancer'],
  [1446653926,1446872244,'Leo'],
  [1446872244,1447091692,'Virgo'],
  [1447091692,1447305961,'Libra'],
  [1447305961,1447512854,'Scorpio'],
  [1447512854,1447712297,'Sagittarius'],
  [1447712297,1447904208,'Capricorn'],
  [1447904208,1448088484,'Aquarius'],
  [1448088484,1448266451,'Pisces'],
  [1448266451,1448442042,'Aries'],
  [1448442042,1448621418,'Taurus'],
  [1448621418,1448811182,'Gemini'],
  [1448811182,1449015311,'Cancer'],
  [1449015311,1449231495,'Leo'],
  [1449231495,1449451047,'Virgo'],
  [1449451047,1449664904,'Libra'],
  [1449664904,1449869336,'Scorpio'],
  [1449869336,1450065580,'Sagittarius'],
  [1450065580,1450256266,'Capricorn'],
  [1450256266,1450442977,'Aquarius'],
  [1450442977,1450626260,'Pisces'],
  [1450626260,1450807429,'Aries'],
  [1450807429,1450990031,'Taurus'],
  [1450990031,1451179419,'Gemini'],
  [1451179419,1451380454,'Cancer'],
  [1451380454,1451593773,'Leo'],
  [1451593773,1451813089,'Virgo'],
  [1451813089,1452028235,'Libra'],
  [1452028235,1452232480,'Scorpio'],
  [1452232480,1452425731,'Sagittarius'],
  [1452425731,1452611917,'Capricorn'],
  [1452611917,1452795354,'Aquarius'],
  [1452795354,1452978794,'Pisces'],
  [1452978794,1453163544,'Aries'],
  [1453163544,1453350988,'Taurus'],
  [1453350988,1453543740,'Gemini'],
  [1453543740,1453745124,'Cancer'],
  [1453745124,1453956765,'Leo'],
  [1453956765,1454175398,'Virgo'],
  [1454175398,1454392559,'Libra'],
  [1454392559,1454599604,'Scorpio'],
  [1454599604,1454793380,'Sagittarius'],
  [1454793380,1454976595,'Capricorn'],
  [1454976595,1455154686,'Aquarius'],
  [1455154686,1455333061,'Pisces'],
  [1455333061,1455515646,'Aries'],
  [1455515646,1455704604,'Taurus'],
  [1455704604,1455900930,'Gemini'],
  [1455900930,1456105183,'Cancer'],
  [1456105183,1456317390,'Leo'],
  [1456317390,1456535523,'Virgo'],
  [1456535523,1456754013,'Libra'],
  [1456754013,1456965069,'Scorpio'],
  [1456965069,1457163078,'Sagittarius'],
  [1457163078,1457347770,'Capricorn'],
  [1457347770,1457523384,'Aquarius'],
  [1457523384,1457696223,'Pisces'],
  [1457696223,1457872663,'Aries'],
  [1457872663,1458057690,'Taurus'],
  [1458057690,1458253702,'Gemini'],
  [1458253702,1458460077,'Cancer'],
  [1458460077,1458674152,'Leo'],
  [1458674152,1458892540,'Virgo'],
  [1458892540,1459111197,'Libra'],
  [1459111197,1459324915,'Scorpio'],
  [1459324915,1459528202,'Sagittarius'],
  [1459528202,1459718146,'Capricorn'],
  [1459718146,1459896144,'Aquarius'],
  [1459896144,1460067298,'Pisces'],
  [1460067298,1460238634,'Aries'],
  [1460238634,1460417280,'Taurus'],
  [1460417280,1460608508,'Gemini'],
  [1460608508,1460813443,'Cancer'],
  [1460813443,1461028402,'Leo'],
  [1461028402,1461247475,'Virgo'],
  [1461247475,1461465693,'Libra'],
  [1461465693,1461679619,'Scorpio'],
  [1461679619,1461885970,'Sagittarius'],
  [1461885970,1462081580,'Capricorn'],
  [1462081580,1462265296,'Aquarius'],
  [1462265296,1462439540,'Pisces'],
  [1462439540,1462610100,'Aries'],
  [1462610100,1462784470,'Taurus'],
  [1462784470,1462969799,'Gemini'],
  [1462969799,1463170083,'Cancer'],
  [1463170083,1463383373,'Leo'],
  [1463383373,1463602579,'Virgo'],
  [1463602579,1463820410,'Libra'],
  [1463820410,1464032990,'Scorpio'],
  [1464032990,1464238981,'Sagittarius'],
  [1464238981,1464437182,'Capricorn'],
  [1464437182,1464626190,'Aquarius'],
  [1464626190,1464806122,'Pisces'],
  [1464806122,1464980243,'Aries'],
  [1464980243,1465154684,'Taurus'],
  [1465154684,1465336704,'Gemini'],
  [1465336704,1465532097,'Cancer'],
  [1465532097,1465741758,'Leo'],
  [1465741758,1465959914,'Virgo'],
  [1465959914,1466177665,'Libra'],
  [1466177665,1466389018,'Scorpio'],
  [1466389018,1466592657,'Sagittarius'],
  [1466592657,1466789447,'Capricorn'],
  [1466789447,1466979940,'Aquarius'],
  [1466979940,1467164242,'Pisces'],
  [1467164242,1467343639,'Aries'],
  [1467343639,1467521850,'Taurus'],
  [1467521850,1467704575,'Gemini'],
  [1467704575,1467897610,'Cancer'],
  [1467897610,1468103797,'Leo'],
  [1468103797,1468320049,'Virgo'],
  [1468320049,1468537986,'Libra'],
  [1468537986,1468749460,'Scorpio'],
  [1468749460,1468951284,'Sagittarius'],
  [1468951284,1469144716,'Capricorn'],
  [1469144716,1469332476,'Aquarius'],
  [1469332476,1469516776,'Pisces'],
  [1469516776,1469699256,'Aries'],
  [1469699256,1469882035,'Taurus'],
  [1469882035,1470068428,'Gemini'],
  [1470068428,1470262498,'Cancer'],
  [1470262498,1470467219,'Leo'],
  [1470467219,1470681734,'Virgo'],
  [1470681734,1470899935,'Libra'],
  [1470899935,1471113143,'Scorpio'],
  [1471113143,1471315570,'Sagittarius'],
  [1471315570,1471506869,'Capricorn'],
  [1471506869,1471690389,'Aquarius'],
  [1471690389,1471870584,'Pisces'],
  [1471870584,1472051404,'Aries'],
  [1472051404,1472235769,'Taurus'],
  [1472235769,1472425769,'Gemini'],
  [1472425769,1472623049,'Cancer'],
  [1472623049,1472828800,'Leo'],
  [1472828800,1473042669,'Virgo'],
  [1473042669,1473261017,'Libra'],
  [1473261017,1473476752,'Scorpio'],
  [1473476752,1473682516,'Sagittarius'],
  [1473682516,1473875113,'Capricorn'],
  [1473875113,1474056498,'Aquarius'],
  [1474056498,1474231852,'Pisces'],
  [1474231852,1474407347,'Aries'],
  [1474407347,1474588423,'Taurus'],
  [1474588423,1474778473,'Gemini'],
  [1474778473,1474978218,'Cancer'],
  [1474978218,1475186374,'Leo'],
  [1475186374,1475400950,'Virgo'],
  [1475400950,1475619292,'Libra'],
  [1475619292,1475836865,'Scorpio'],
  [1475836865,1476047109,'Sagittarius'],
  [1476047109,1476244506,'Capricorn'],
  [1476244506,1476428067,'Aquarius'],
  [1476428067,1476601688,'Pisces'],
  [1476601688,1476772193,'Aries'],
  [1476772193,1476947088,'Taurus'],
  [1476947088,1477132496,'Gemini'],
  [1477132496,1477330938,'Cancer'],
  [1477330938,1477540389,'Leo'],
  [1477540389,1477756339,'Virgo'],
  [1477756339,1477974760,'Libra'],
  [1477974760,1478192542,'Scorpio'],
  [1478192542,1478405645,'Sagittarius'],
  [1478405645,1478608767,'Capricorn'],
  [1478608767,1478798273,'Aquarius'],
  [1478798273,1478975098,'Pisces'],
  [1478975098,1479144736,'Aries'],
  [1479144736,1479315049,'Taurus'],
  [1479315049,1479493986,'Gemini'],
  [1479493986,1479687024,'Cancer'],
  [1479687024,1479894323,'Leo'],
  [1479894323,1480110659,'Virgo'],
  [1480110659,1480329406,'Libra'],
  [1480329406,1480546335,'Scorpio'],
  [1480546335,1480759171,'Sagittarius'],
  [1480759171,1480965095,'Capricorn'],
  [1480965095,1481160581,'Aquarius'],
  [1481160581,1481343991,'Pisces'],
  [1481343991,1481517879,'Aries'],
  [1481517879,1481688512,'Taurus'],
  [1481688512,1481863754,'Gemini'],
  [1481863754,1482050730,'Cancer'],
  [1482050730,1482252780,'Leo'],
  [1482252780,1482466994,'Virgo'],
  [1482466994,1482685781,'Libra'],
  [1482685781,1482902176,'Scorpio'],
  [1482902176,1483113024,'Sagittarius'],
  [1483113024,1483317475,'Capricorn'],
  [1483317475,1483514582,'Aquarius'],
  [1483514582,1483703143,'Pisces'],
  [1483703143,1483883555,'Aries'],
  [1483883555,1484059192,'Taurus'],
  [1484059192,1484235901,'Gemini'],
  [1484235901,1484420309,'Cancer'],
  [1484420309,1484617405,'Leo'],
  [1484617405,1484827597,'Virgo'],
  [1484827597,1485045327,'Libra'],
  [1485045327,1485262089,'Scorpio'],
  [1485262089,1485471903,'Sagittarius'],
  [1485471903,1485673273,'Capricorn'],
  [1485673273,1485867312,'Aquarius'],
  [1485867312,1486055556,'Pisces'],
  [1486055556,1486239379,'Aries'],
  [1486239379,1486420661,'Taurus'],
  [1486420661,1486602489,'Gemini'],
  [1486602489,1486789085,'Cancer'],
  [1486789085,1486984720,'Leo'],
  [1486984720,1487191597,'Virgo'],
  [1487191597,1487407400,'Libra'],
  [1487407400,1487624910,'Scorpio'],
  [1487624910,1487835930,'Sagittarius'],
  [1487835930,1488036202,'Capricorn'],
  [1488036202,1488226413,'Aquarius'],
  [1488226413,1488410135,'Pisces'],
  [1488410135,1488591532,'Aries'],
  [1488591532,1488774020,'Taurus'],
  [1488774020,1488959949,'Gemini'],
  [1488959949,1489151029,'Cancer'],
  [1489151029,1489348963,'Leo'],
  [1489348963,1489555261,'Virgo'],
  [1489555261,1489769571,'Libra'],
  [1489769571,1489987554,'Scorpio'],
  [1489987554,1490201293,'Sagittarius'],
  [1490201293,1490403807,'Capricorn'],
  [1490403807,1490593243,'Aquarius'],
  [1490593243,1490772935,'Pisces'],
  [1490772935,1490948888,'Aries'],
  [1490948888,1491127199,'Taurus'],
  [1491127199,1491312223,'Gemini'],
  [1491312223,1491505613,'Cancer'],
  [1491505613,1491706871,'Leo'],
  [1491706871,1491915031,'Virgo'],
  [1491915031,1492129274,'Libra'],
  [1492129274,1492347351,'Scorpio'],
  [1492347351,1492563629,'Sagittarius'],
  [1492563629,1492770476,'Capricorn'],
  [1492770476,1492963115,'Aquarius'],
  [1492963115,1493142647,'Pisces'],
  [1493142647,1493314898,'Aries'],
  [1493314898,1493487461,'Taurus'],
  [1493487461,1493667196,'Gemini'],
  [1493667196,1493858107,'Cancer'],
  [1493858107,1494060108,'Leo'],
  [1494060108,1494270292,'Virgo'],
  [1494270292,1494485605,'Libra'],
  [1494485605,1494703693,'Scorpio'],
  [1494703693,1494921080,'Sagittarius'],
  [1494921080,1495131779,'Capricorn'],
  [1495131779,1495329767,'Aquarius'],
  [1495329767,1495513274,'Pisces'],
  [1495513274,1495686146,'Aries'],
  [1495686146,1495855670,'Taurus'],
  [1495855670,1496029836,'Gemini'],
  [1496029836,1496215043,'Cancer'],
  [1496215043,1496413762,'Leo'],
  [1496413762,1496623683,'Virgo'],
  [1496623683,1496839900,'Libra'],
  [1496839900,1497058100,'Scorpio'],
  [1497058100,1497275129,'Sagittarius'],
  [1497275129,1497487195,'Capricorn'],
  [1497487195,1497689488,'Aquarius'],
  [1497689488,1497878776,'Pisces'],
  [1497878776,1498056197,'Aries'],
  [1498056197,1498227130,'Taurus'],
  [1498227130,1498399014,'Gemini'],
  [1498399014,1498579148,'Cancer'],
  [1498579148,1498772422,'Leo'],
  [1498772422,1498979127,'Virgo'],
  [1498979127,1499194788,'Libra'],
  [1499194788,1499413076,'Scorpio'],
  [1499413076,1499629184,'Sagittarius'],
  [1499629184,1499840091,'Capricorn'],
  [1499840091,1500043271,'Aquarius'],
  [1500043271,1500236557,'Pisces'],
  [1500236557,1500419693,'Aries'],
  [1500419693,1500595520,'Taurus'],
  [1500595520,1500769455,'Gemini'],
  [1500769455,1500948005,'Cancer'],
  [1500948005,1501136956,'Leo'],
  [1501136956,1501339142,'Virgo'],
  [1501339142,1501552523,'Libra'],
  [1501552523,1501770605,'Scorpio'],
  [1501770605,1501986268,'Sagittarius'],
  [1501986268,1502195201,'Capricorn'],
  [1502195201,1502396094,'Aquarius'],
  [1502396094,1502589199,'Pisces'],
  [1502589199,1502775400,'Aries'],
  [1502775400,1502956428,'Taurus'],
  [1502956428,1503135294,'Gemini'],
  [1503135294,1503316282,'Cancer'],
  [1503316282,1503504259,'Leo'],
  [1503504259,1503703145,'Virgo'],
  [1503703145,1503913582,'Libra'],
  [1503913582,1504131034,'Scorpio'],
  [1504131034,1504347296,'Sagittarius'],
  [1504347296,1504555509,'Capricorn'],
  [1504555509,1504753486,'Aquarius'],
  [1504753486,1504943042,'Pisces'],
  [1504943042,1505127572,'Aries'],
  [1505127572,1505310223,'Taurus'],
  [1505310223,1505493335,'Gemini'],
  [1505493335,1505678909,'Cancer'],
  [1505678909,1505869417,'Leo'],
  [1505869417,1506067870,'Virgo'],
  [1506067870,1506276288,'Libra'],
  [1506276288,1506492875,'Scorpio'],
  [1506492875,1506710573,'Sagittarius'],
  [1506710573,1506920482,'Capricorn'],
  [1506920482,1507117800,'Aquarius'],
  [1507117800,1507303822,'Pisces'],
  [1507303822,1507483607,'Aries'],
  [1507483607,1507662862,'Taurus'],
  [1507662862,1507845792,'Gemini'],
  [1507845792,1508034258,'Cancer'],
  [1508034258,1508228609,'Leo'],
  [1508228609,1508429382,'Virgo'],
  [1508429382,1508637781,'Libra'],
  [1508637781,1508853727,'Scorpio'],
  [1508853727,1509072793,'Sagittarius'],
  [1509072793,1509286255,'Capricorn'],
  [1509286255,1509486551,'Aquarius'],
  [1509486551,1509672433,'Pisces'],
  [1509672433,1509848581,'Aries'],
  [1509848581,1510022196,'Taurus'],
  [1510022196,1510200055,'Gemini'],
  [1510200055,1510386412,'Cancer'],
  [1510386412,1510582064,'Leo'],
  [1510582064,1510785638,'Virgo'],
  [1510785638,1510995820,'Libra'],
  [1510995820,1511211872,'Scorpio'],
  [1511211872,1511431415,'Sagittarius'],
  [1511431415,1511648103,'Capricorn'],
  [1511648103,1511853736,'Aquarius'],
  [1511853736,1512043942,'Pisces'],
  [1512043942,1512220939,'Aries'],
  [1512220939,1512391410,'Taurus'],
  [1512391410,1512563268,'Gemini'],
  [1512563268,1512743312,'Cancer'],
  [1512743312,1512935217,'Leo'],
  [1512935217,1513138612,'Virgo'],
  [1513138612,1513350458,'Libra'],
  [1513350458,1513567437,'Scorpio'],
  [1513567437,1513786737,'Sagittarius'],
  [1513786737,1514004329,'Capricorn'],
  [1514004329,1514214144,'Aquarius'],
  [1514214144,1514410778,'Pisces'],
  [1514410778,1514593297,'Aries'],
  [1514593297,1514765875,'Taurus'],
  [1514765875,1514935551,'Gemini'],
  [1514935551,1515109877,'Cancer'],
  [1515109877,1515295030,'Leo'],
  [1515295030,1515493838,'Virgo'],
  [1515493838,1515704620,'Libra'],
  [1515704620,1515922302,'Scorpio'],
  [1515922302,1516141464,'Sagittarius'],
  [1516141464,1516357942,'Capricorn'],
  [1516357942,1516568169,'Aquarius'],
  [1516568169,1516768774,'Pisces'],
  [1516768774,1516957878,'Aries'],
  [1516957878,1517136711,'Taurus'],
  [1517136711,1517309639,'Gemini'],
  [1517309639,1517482924,'Cancer'],
  [1517482924,1517663223,'Leo'],
  [1517663223,1517855830,'Virgo'],
  [1517855830,1518062355,'Libra'],
  [1518062355,1518279009,'Scorpio'],
  [1518279009,1518498319,'Sagittarius'],
  [1518498319,1518713620,'Capricorn'],
  [1518713620,1518921548,'Aquarius'],
  [1518921548,1519121329,'Pisces'],
  [1519121329,1519313147,'Aries'],
  [1519313147,1519497737,'Taurus'],
  [1519497737,1519676908,'Gemini'],
  [1519676908,1519854118,'Cancer'],
  [1519854118,1520034418,'Leo'],
  [1520034418,1520223429,'Virgo'],
  [1520223429,1520425190,'Libra'],
  [1520425190,1520639048,'Scorpio'],
  [1520639048,1520858225,'Sagittarius'],
  [1520858225,1521073609,'Capricorn'],
  [1521073609,1521279612,'Aquarius'],
  [1521279612,1521475977,'Pisces'],
  [1521475977,1521665418,'Aries'],
  [1521665418,1521850844,'Taurus'],
  [1521850844,1522034183,'Gemini'],
  [1522034183,1522216855,'Cancer'],
  [1522216855,1522401147,'Leo'],
  [1522401147,1522590906,'Virgo'],
  [1522590906,1522790433,'Libra'],
  [1522790433,1523001508,'Scorpio'],
  [1523001508,1523220035,'Sagittarius'],
  [1523220035,1523436675,'Capricorn'],
  [1523436675,1523643114,'Aquarius'],
  [1523643114,1523837260,'Pisces'],
  [1523837260,1524022507,'Aries'],
  [1524022507,1524204099,'Taurus'],
  [1524204099,1524386286,'Gemini'],
  [1524386286,1524571215,'Cancer'],
  [1524571215,1524759691,'Leo'],
  [1524759691,1524952984,'Virgo'],
  [1524952984,1525153584,'Libra'],
  [1525153584,1525363618,'Scorpio'],
  [1525363618,1525581445,'Sagittarius'],
  [1525581445,1525799680,'Capricorn'],
  [1525799680,1526008839,'Aquarius'],
  [1526008839,1526204040,'Pisces'],
  [1526204040,1526387210,'Aries'],
  [1526387210,1526564233,'Taurus'],
  [1526564233,1526741470,'Gemini'],
  [1526741470,1526923540,'Cancer'],
  [1526923540,1527112476,'Leo'],
  [1527112476,1527308553,'Virgo'],
  [1527308553,1527511874,'Libra'],
  [1527511874,1527722855,'Scorpio'],
  [1527722855,1527940494,'Sagittarius'],
  [1527940494,1528159820,'Capricorn'],
  [1528159820,1528372460,'Aquarius'],
  [1528372460,1528571645,'Pisces'],
  [1528571645,1528756615,'Aries'],
  [1528756615,1528931992,'Taurus'],
  [1528931992,1529104622,'Gemini'],
  [1529104622,1529281057,'Cancer'],
  [1529281057,1529465925,'Leo'],
  [1529465925,1529661088,'Virgo'],
  [1529661088,1529865958,'Libra'],
  [1529865958,1530078652,'Scorpio'],
  [1530078652,1530296731,'Sagittarius'],
  [1530296731,1530516286,'Capricorn'],
  [1530516286,1530731240,'Aquarius'],
  [1530731240,1530935191,'Pisces'],
  [1530935191,1531125106,'Aries'],
  [1531125106,1531303037,'Taurus'],
  [1531303037,1531474584,'Gemini'],
  [1531474584,1531646629,'Cancer'],
  [1531646629,1531825637,'Leo'],
  [1531825637,1532016143,'Virgo'],
  [1532016143,1532219344,'Libra'],
  [1532219344,1532432675,'Scorpio'],
  [1532432675,1532651393,'Sagittarius'],
  [1532651393,1532870585,'Capricorn'],
  [1532870585,1533085679,'Aquarius'],
  [1533085679,1533292434,'Pisces'],
  [1533292434,1533487722,'Aries'],
  [1533487722,1533671226,'Taurus'],
  [1533671226,1533845995,'Gemini'],
  [1533845995,1534017568,'Cancer'],
  [1534017568,1534192631,'Leo'],
  [1534192631,1534377528,'Virgo'],
  [1534377528,1534576201,'Libra'],
  [1534576201,1534787836,'Scorpio'],
  [1534787836,1535006664,'Sagittarius'],
  [1535006664,1535225463,'Capricorn'],
  [1535225463,1535439158,'Aquarius'],
  [1535439158,1535645419,'Pisces'],
  [1535645419,1535843191,'Aries'],
  [1535843191,1536031981,'Taurus'],
  [1536031981,1536212569,'Gemini'],
  [1536212569,1536387888,'Cancer'],
  [1536387888,1536563127,'Leo'],
  [1536563127,1536744758,'Virgo'],
  [1536744758,1536938574,'Libra'],
  [1536938574,1537146592,'Scorpio'],
  [1537146592,1537364428,'Sagittarius'],
  [1537364428,1537583226,'Capricorn'],
  [1537583226,1537795651,'Aquarius'],
  [1537795651,1537999356,'Pisces'],
  [1537999356,1538195469,'Aries'],
  [1538195469,1538385630,'Taurus'],
  [1538385630,1538570721,'Gemini'],
  [1538570721,1538751650,'Cancer'],
  [1538751650,1538930960,'Leo'],
  [1538930960,1539113419,'Virgo'],
  [1539113419,1539304843,'Libra'],
  [1539304843,1539509266,'Scorpio'],
  [1539509266,1539725150,'Sagittarius'],
  [1539725150,1539944298,'Capricorn'],
  [1539944298,1540157065,'Aquarius'],
  [1540157065,1540358952,'Pisces'],
  [1540358952,1540551401,'Aries'],
  [1540551401,1540738339,'Taurus'],
  [1540738339,1540923025,'Gemini'],
  [1540923025,1541107007,'Cancer'],
  [1541107007,1541291208,'Leo'],
  [1541291208,1541477760,'Virgo'],
  [1541477760,1541670521,'Libra'],
  [1541670521,1541873502,'Scorpio'],
  [1541873502,1542087469,'Sagittarius'],
  [1542087469,1542306875,'Capricorn'],
  [1542306875,1542521782,'Aquarius'],
  [1542521782,1542724816,'Pisces'],
  [1542724816,1542915401,'Aries'],
  [1542915401,1543097846,'Taurus'],
  [1543097846,1543277658,'Gemini'],
  [1543277658,1543459093,'Cancer'],
  [1543459093,1543644388,'Leo'],
  [1543644388,1543834618,'Virgo'],
  [1543834618,1544031061,'Libra'],
  [1544031061,1544235527,'Scorpio'],
  [1544235527,1544448874,'Sagittarius'],
  [1544448874,1544668149,'Capricorn'],
  [1544668149,1544885627,'Aquarius'],
  [1544885627,1545092705,'Pisces'],
  [1545092705,1545285606,'Aries'],
  [1545285606,1545466682,'Taurus'],
  [1545466682,1545641687,'Gemini'],
  [1545641687,1545816965,'Cancer'],
  [1545816965,1545997694,'Leo'],
  [1545997694,1546186935,'Virgo'],
  [1546186935,1546385535,'Libra'],
  [1546385535,1546592798,'Scorpio'],
  [1546592798,1546807271,'Sagittarius'],
  [1546807271,1547026369,'Capricorn'],
  [1547026369,1547245131,'Aquarius'],
  [1547245131,1547456604,'Pisces'],
  [1547456604,1547655143,'Aries'],
  [1547655143,1547839805,'Taurus'],
  [1547839805,1548014347,'Gemini'],
  [1548014347,1548185142,'Cancer'],
  [1548185142,1548359187,'Leo'],
  [1548359187,1548542512,'Virgo'],
  [1548542512,1548738476,'Libra'],
  [1548738476,1548946461,'Scorpio'],
  [1548946461,1549162547,'Sagittarius'],
  [1549162547,1549381952,'Capricorn'],
  [1549381952,1549600422,'Aquarius'],
  [1549600422,1549813778,'Pisces'],
  [1549813778,1550017552,'Aries'],
  [1550017552,1550208764,'Taurus'],
  [1550208764,1550387932,'Gemini'],
  [1550387932,1550559352,'Cancer'],
  [1550559352,1550729800,'Leo'],
  [1550729800,1550906776,'Virgo'],
  [1550906776,1551096496,'Libra'],
  [1551096496,1551301139,'Scorpio'],
  [1551301139,1551517029,'Sagittarius'],
  [1551517029,1551736918,'Capricorn'],
  [1551736918,1551954645,'Aquarius'],
  [1551954645,1552167051,'Pisces'],
  [1552167051,1552372322,'Aries'],
  [1552372322,1552568482,'Taurus'],
  [1552568482,1552754248,'Gemini'],
  [1552754248,1552930871,'Cancer'],
  [1552930871,1553102977,'Leo'],
  [1553102977,1553277535,'Virgo'],
  [1553277535,1553461898,'Libra'],
  [1553461898,1553661016,'Scorpio'],
  [1553661016,1553873992,'Sagittarius'],
  [1553873992,1554093539,'Capricorn'],
  [1554093539,1554310979,'Aquarius'],
  [1554310979,1554521626,'Pisces'],
  [1554521626,1554724925,'Aries'],
  [1554724925,1554921414,'Taurus'],
  [1554921414,1555110949,'Gemini'],
  [1555110949,1555293441,'Cancer'],
  [1555293441,1555470796,'Leo'],
  [1555470796,1555647755,'Virgo'],
  [1555647755,1555830825,'Libra'],
  [1555830825,1556025926,'Scorpio'],
  [1556025926,1556234938,'Sagittarius'],
  [1556234938,1556452962,'Capricorn'],
  [1556452962,1556670613,'Aquarius'],
  [1556670613,1556880639,'Pisces'],
  [1556880639,1557081370,'Aries'],
  [1557081370,1557274737,'Taurus'],
  [1557274737,1557463060,'Gemini'],
  [1557463060,1557647667,'Cancer'],
  [1557647667,1557829659,'Leo'],
  [1557829659,1558011436,'Virgo'],
  [1558011436,1558197200,'Libra'],
  [1558197200,1558391834,'Scorpio'],
  [1558391834,1558598288,'Sagittarius'],
  [1558598288,1558814425,'Capricorn'],
  [1558814425,1559032481,'Aquarius'],
  [1559032481,1559243669,'Pisces'],
  [1559243669,1559443803,'Aries'],
  [1559443803,1559634061,'Taurus'],
  [1559634061,1559818209,'Gemini'],
  [1559818209,1560000048,'Cancer'],
  [1560000048,1560182393,'Leo'],
  [1560182393,1560367366,'Virgo'],
  [1560367366,1560557162,'Libra'],
  [1560557162,1560754306,'Scorpio'],
  [1560754306,1560960756,'Sagittarius'],
  [1560960756,1561175767,'Capricorn'],
  [1561175767,1561394161,'Aquarius'],
  [1561394161,1561607753,'Pisces'],
  [1561607753,1561810107,'Aries'],
  [1561810107,1562000038,'Taurus'],
  [1562000038,1562180813,'Gemini'],
  [1562180813,1562357681,'Cancer'],
  [1562357681,1562535916,'Leo'],
  [1562535916,1562719625,'Virgo'],
  [1562719625,1562911200,'Libra'],
  [1562911200,1563111365,'Scorpio'],
  [1563111365,1563319730,'Sagittarius'],
  [1563319730,1563534887,'Capricorn'],
  [1563534887,1563753429,'Aquarius'],
  [1563753429,1563969368,'Pisces'],
  [1563969368,1564175846,'Aries'],
  [1564175846,1564368996,'Taurus'],
  [1564368996,1564549888,'Gemini'],
  [1564549888,1564723421,'Cancer'],
  [1564723421,1564896238,'Leo'],
  [1564896238,1565074843,'Virgo'],
  [1565074843,1565263878,'Libra'],
  [1565263878,1565464600,'Scorpio'],
  [1565464600,1565674875,'Sagittarius'],
  [1565674875,1565891079,'Capricorn'],
  [1565891079,1566109634,'Aquarius'],
  [1566109634,1566326625,'Pisces'],
  [1566326625,1566536897,'Aries'],
  [1566536897,1566735427,'Taurus'],
  [1566735427,1566920420,'Gemini'],
  [1566920420,1567094689,'Cancer'],
  [1567094689,1567264540,'Leo'],
  [1567264540,1567437664,'Virgo'],
  [1567437664,1567621051,'Libra'],
  [1567621051,1567818469,'Scorpio'],
  [1567818469,1568028445,'Sagittarius'],
  [1568028445,1568245522,'Capricorn'],
  [1568245522,1568464115,'Aquarius'],
  [1568464115,1568680636,'Pisces'],
  [1568680636,1568892208,'Aries'],
  [1568892208,1569095149,'Taurus'],
  [1569095149,1569286219,'Gemini'],
  [1569286219,1569465344,'Cancer'],
  [1569465344,1569636746,'Leo'],
  [1569636746,1569807592,'Virgo'],
  [1569807592,1569985818,'Libra'],
  [1569985818,1570177611,'Scorpio'],
  [1570177611,1570384216,'Sagittarius'],
  [1570384216,1570600702,'Capricorn'],
  [1570600702,1570819394,'Aquarius'],
  [1570819394,1571034883,'Pisces'],
  [1571034883,1571245056,'Aries'],
  [1571245056,1571448675,'Taurus'],
  [1571448675,1571643821,'Gemini'],
  [1571643821,1571829087,'Cancer'],
  [1571829087,1572005909,'Leo'],
  [1572005909,1572179215,'Virgo'],
  [1572179215,1572356051,'Libra'],
  [1572356051,1572543387,'Scorpio'],
  [1572543387,1572745097,'Sagittarius'],
  [1572745097,1572959024,'Capricorn'],
  [1572959024,1573177548,'Aquarius'],
  [1573177548,1573392750,'Pisces'],
  [1573392750,1573600870,'Aries'],
  [1573600870,1573801757,'Taurus'],
  [1573801757,1573996128,'Gemini'],
  [1573996128,1574184193,'Cancer'],
  [1574184193,1574366497,'Leo'],
  [1574366497,1574545397,'Virgo'],
  [1574545397,1574725432,'Libra'],
  [1574725432,1574912274,'Scorpio'],
  [1574912274,1575110594,'Sagittarius'],
  [1575110594,1575321130,'Capricorn'],
  [1575321130,1575538802,'Aquarius'],
  [1575538802,1575754931,'Pisces'],
  [1575754931,1575962844,'Aries'],
  [1575962844,1576160911,'Taurus'],
  [1576160911,1576351109,'Gemini'],
  [1576351109,1576536441,'Cancer'],
  [1576536441,1576719514,'Leo'],
  [1576719514,1576902484,'Virgo'],
  [1576902484,1577087668,'Libra'],
  [1577087668,1577277969,'Scorpio'],
  [1577277969,1577476490,'Sagittarius'],
  [1577476490,1577684950,'Capricorn'],
  [1577684950,1577901321,'Aquarius'],
  [1577901321,1578118863,'Pisces'],
  [1578118863,1578329217,'Aries'],
  [1578329217,1578527612,'Taurus'],
  [1578527612,1578714706,'Gemini'],
  [1578714706,1578894773,'Cancer'],
  [1578894773,1579073184,'Leo'],
  [1579073184,1579254577,'Virgo'],
  [1579254577,1579441869,'Libra'],
  [1579441869,1579636204,'Scorpio'],
  [1579636204,1579837818,'Sagittarius'],
  [1579837818,1580046814,'Capricorn'],
  [1580046814,1580262386,'Aquarius'],
  [1580262386,1580480789,'Pisces'],
  [1580480789,1580694770,'Aries'],
  [1580694770,1580897145,'Taurus'],
  [1580897145,1581085423,'Gemini'],
  [1581085423,1581262712,'Cancer'],
  [1581262712,1581435472,'Leo'],
  [1581435472,1581610836,'Virgo'],
  [1581610836,1581794482,'Libra'],
  [1581794482,1581988897,'Scorpio'],
  [1581988897,1582193039,'Sagittarius'],
  [1582193039,1582404243,'Capricorn'],
  [1582404243,1582620235,'Aquarius'],
  [1582620235,1582838717,'Pisces'],
  [1582838717,1583055162,'Aries'],
  [1583055162,1583262726,'Taurus'],
  [1583262726,1583456182,'Gemini'],
  [1583456182,1583635653,'Cancer'],
  [1583635653,1583806496,'Leo'],
  [1583806496,1583976561,'Virgo'],
  [1583976561,1584153635,'Libra'],
  [1584153635,1584343121,'Scorpio'],
  [1584343121,1584545830,'Sagittarius'],
  [1584545830,1584758159,'Capricorn'],
  [1584758159,1584975244,'Aquarius'],
  [1584975244,1585193597,'Pisces'],
  [1585193597,1585410330,'Aries'],
  [1585410330,1585620987,'Taurus'],
  [1585620987,1585820253,'Gemini'],
  [1585820253,1586005572,'Cancer'],
  [1586005572,1586179544,'Leo'],
  [1586179544,1586348796,'Virgo'],
  [1586348796,1586521394,'Libra'],
  [1586521394,1586704551,'Scorpio'],
  [1586704551,1586902074,'Sagittarius'],
  [1586902074,1587112383,'Capricorn'],
  [1587112383,1587329701,'Aquarius'],
  [1587329701,1587548075,'Pisces'],
  [1587548075,1587763810,'Aries'],
  [1587763810,1587974256,'Taurus'],
  [1587974256,1588176269,'Gemini'],
  [1588176269,1588367152,'Cancer'],
  [1588367152,1588547106,'Leo'],
  [1588547106,1588720175,'Virgo'],
  [1588720175,1588892952,'Libra'],
  [1588892952,1589072596,'Scorpio'],
  [1589072596,1589264653,'Sagittarius'],
  [1589264653,1589470546,'Capricorn'],
  [1589470546,1589686274,'Aquarius'],
  [1589686274,1589904593,'Pisces'],
  [1589904593,1590119459,'Aries'],
  [1590119459,1590327859,'Taurus'],
  [1590327859,1590528646,'Gemini'],
  [1590528646,1590721242,'Cancer'],
  [1590721242,1590905879,'Leo'],
  [1590905879,1591084589,'Virgo'],
  [1591084589,1591261469,'Libra'],
  [1591261469,1591441957,'Scorpio'],
  [1591441957,1591631442,'Sagittarius'],
  [1591631442,1591833206,'Capricorn'],
  [1591833206,1592046134,'Aquarius'],
  [1592046134,1592264056,'Pisces'],
  [1592264056,1592479027,'Aries'],
  [1592479027,1592685888,'Taurus'],
  [1592685888,1592883588,'Gemini'],
  [1592883588,1593073710,'Cancer'],
  [1593073710,1593258633,'Leo'],
  [1593258633,1593440744,'Virgo'],
  [1593440744,1593622533,'Libra'],
  [1593622533,1593806979,'Scorpio'],
  [1593806979,1593997619,'Sagittarius'],
  [1593997619,1594197705,'Capricorn'],
  [1594197705,1594408196,'Aquarius'],
  [1594408196,1594625460,'Pisces'],
  [1594625460,1594841588,'Aries'],
  [1594841588,1595048975,'Taurus'],
  [1595048975,1595244732,'Gemini'],
  [1595244732,1595430922,'Cancer'],
  [1595430922,1595612109,'Leo'],
  [1595612109,1595792910,'Virgo'],
  [1595792910,1595976599,'Libra'],
  [1595976599,1596164926,'Scorpio'],
  [1596164926,1596359007,'Sagittarius'],
  [1596359007,1596560267,'Capricorn'],
  [1596560267,1596769918,'Aquarius'],
  [1596769918,1596986608,'Pisces'],
  [1596986608,1597204351,'Aries'],
  [1597204351,1597414488,'Taurus'],
  [1597414488,1597611375,'Gemini'],
  [1597611375,1597795573,'Cancer'],
  [1597795573,1597972292,'Leo'],
  [1597972292,1598148225,'Virgo'],
  [1598148225,1598329030,'Libra'],
  [1598329030,1598517709,'Scorpio'],
  [1598517709,1598714471,'Sagittarius'],
  [1598714471,1598918386,'Capricorn'],
  [1598918386,1599128970,'Aquarius'],
  [1599128970,1599345506,'Pisces'],
  [1599345506,1599564408,'Aries'],
  [1599564408,1599778182,'Taurus'],
  [1599778182,1599979276,'Gemini'],
  [1599979276,1600165410,'Cancer'],
  [1600165410,1600340503,'Leo'],
  [1600340503,1600511795,'Virgo'],
  [1600511795,1600686854,'Libra'],
  [1600686854,1600871293,'Scorpio'],
  [1600871293,1601067014,'Sagittarius'],
  [1601067014,1601272427,'Capricorn'],
  [1601272427,1601484721,'Aquarius'],
  [1601484721,1601701663,'Pisces'],
  [1601701663,1601920735,'Aries'],
  [1601920735,1602136868,'Taurus'],
  [1602136868,1602343043,'Gemini'],
  [1602343043,1602534607,'Cancer'],
  [1602534607,1602712649,'Leo'],
  [1602712649,1602883076,'Virgo'],
  [1602883076,1603053711,'Libra'],
  [1603053711,1603231933,'Scorpio'],
  [1603231933,1603422520,'Sagittarius'],
  [1603422520,1603625936,'Capricorn'],
  [1603625936,1603838808,'Aquarius'],
  [1603838808,1604056459,'Pisces'],
  [1604056459,1604275076,'Aries'],
  [1604275076,1604491076,'Taurus'],
  [1604491076,1604699908,'Gemini'],
  [1604699908,1604897169,'Cancer'],
  [1604897169,1605081501,'Leo'],
  [1605081501,1605255960,'Virgo'],
  [1605255960,1605426744,'Libra'],
  [1605426744,1605601136,'Scorpio'],
  [1605601136,1605785626,'Sagittarius'],
  [1605785626,1605983786,'Capricorn'],
  [1605983786,1606194487,'Aquarius'],
  [1606194487,1606412274,'Pisces'],
  [1606412274,1606630662,'Aries'],
  [1606630662,1606845045,'Taurus'],
  [1606845045,1607052727,'Gemini'],
  [1607052727,1607251886,'Cancer'],
  [1607251886,1607441537,'Leo'],
  [1607441537,1607622552,'Virgo'],
  [1607622552,1607798215,'Libra'],
  [1607798215,1607973777,'Scorpio'],
  [1607973777,1608155351,'Sagittarius'],
  [1608155351,1608348252,'Capricorn'],
  [1608348252,1608554590,'Aquarius'],
  [1608554590,1608771010,'Pisces'],
  [1608771010,1608989676,'Aries'],
  [1608989676,1609203140,'Taurus'],
  [1609203140,1609407988,'Gemini'],
  [1609407988,1609604497,'Cancer'],
  [1609604497,1609794379,'Leo'],
  [1609794379,1609979329,'Virgo'],
  [1609979329,1610160987,'Libra'],
  [1610160987,1610341706,'Scorpio'],
  [1610341706,1610525234,'Sagittarius'],
  [1610525234,1610716326,'Capricorn'],
  [1610716326,1610918885,'Aquarius'],
  [1610918885,1611132787,'Pisces'],
  [1611132787,1611351711,'Aries'],
  [1611351711,1611566142,'Taurus'],
  [1611566142,1611769827,'Gemini'],
  [1611769827,1611962620,'Cancer'],
  [1611962620,1612148320,'Leo'],
  [1612148320,1612331370,'Virgo'],
  [1612331370,1612514845,'Libra'],
  [1612514845,1612700174,'Scorpio'],
  [1612700174,1612888428,'Sagittarius'],
  [1612888428,1613081837,'Capricorn'],
  [1613081837,1613283630,'Aquarius'],
  [1613283630,1613495553,'Pisces'],
  [1613495553,1613714298,'Aries'],
  [1613714298,1613930969,'Taurus'],
  [1613930969,1614136661,'Gemini'],
  [1614136661,1614328586,'Cancer'],
  [1614328586,1614510279,'Leo'],
  [1614510279,1614688013,'Virgo'],
  [1614688013,1614867576,'Libra'],
  [1614867576,1615052418,'Scorpio'],
  [1615052418,1615243432,'Sagittarius'],
  [1615243432,1615440565,'Capricorn'],
  [1615440565,1615644512,'Aquarius'],
  [1615644512,1615856358,'Pisces'],
  [1615856358,1616074787,'Aries'],
  [1616074787,1616293473,'Taurus'],
  [1616293473,1616503206,'Gemini'],
  [1616503206,1616698258,'Cancer'],
  [1616698258,1616879800,'Leo'],
  [1616879800,1617053806,'Virgo'],
  [1617053806,1617227525,'Libra'],
  [1617227525,1617407023,'Scorpio'],
  [1617407023,1617595642,'Sagittarius'],
  [1617595642,1617793769,'Capricorn'],
  [1617793769,1618000184,'Aquarius'],
  [1618000184,1618213529,'Pisces'],
  [1618213529,1618432056,'Aries'],
  [1618432056,1618651559,'Taurus'],
  [1618651559,1618864846,'Gemini'],
  [1618864846,1619065193,'Cancer'],
  [1619065193,1619250833,'Leo'],
  [1619250833,1619425573,'Virgo'],
  [1619425573,1619596188,'Libra'],
  [1619596188,1619769877,'Scorpio'],
  [1619769877,1619952497,'Sagittarius'],
  [1619952497,1620147113,'Capricorn'],
  [1620147113,1620353297,'Aquarius'],
  [1620353297,1620567916,'Pisces'],
  [1620567916,1620786969,'Aries'],
  [1620786969,1621006237,'Taurus'],
  [1621006237,1621220759,'Gemini'],
  [1621220759,1621425336,'Cancer'],
  [1621425336,1621616873,'Leo'],
  [1621616873,1621796389,'Virgo'],
  [1621796389,1621968537,'Libra'],
  [1621968537,1622139853,'Scorpio'],
  [1622139853,1622317130,'Sagittarius'],
  [1622317130,1622505868,'Capricorn'],
  [1622505868,1622708372,'Aquarius'],
  [1622708372,1622922273,'Pisces'],
  [1622922273,1623141659,'Aries'],
  [1623141659,1623360363,'Taurus'],
  [1623360363,1623573913,'Gemini'],
  [1623573913,1623779437,'Cancer'],
  [1623779437,1623975061,'Leo'],
  [1623975061,1624160477,'Virgo'],
  [1624160477,1624337718,'Libra'],
  [1624337718,1624511157,'Scorpio'],
  [1624511157,1624686787,'Sagittarius'],
  [1624686787,1624870966,'Capricorn'],
  [1624870966,1625068410,'Aquarius'],
  [1625068410,1625279377,'Pisces'],
  [1625279377,1625498240,'Aries'],
  [1625498240,1625716647,'Taurus'],
  [1625716647,1625928576,'Gemini'],
  [1625928576,1626132137,'Cancer'],
  [1626132137,1626327824,'Leo'],
  [1626327824,1626516506,'Virgo'],
  [1626516506,1626699135,'Libra'],
  [1626699135,1626877625,'Scorpio'],
  [1626877625,1627055752,'Sagittarius'],
  [1627055752,1627238976,'Capricorn'],
  [1627238976,1627432883,'Aquarius'],
  [1627432883,1627640218,'Pisces'],
  [1627640218,1627857627,'Aries'],
  [1627857627,1628076216,'Taurus'],
  [1628076216,1628287536,'Gemini'],
  [1628287536,1628488589,'Cancer'],
  [1628488589,1628681193,'Leo'],
  [1628681193,1628868604,'Virgo'],
  [1628868604,1629053165,'Libra'],
  [1629053165,1629236097,'Scorpio'],
  [1629236097,1629418914,'Sagittarius'],
  [1629418914,1629604800,'Capricorn'],
  [1629604800,1629798356,'Aquarius'],
  [1629798356,1630003349,'Pisces'],
  [1630003349,1630219033,'Aries'],
  [1630219033,1630438116,'Taurus'],
  [1630438116,1630650666,'Gemini'],
  [1630650666,1630851149,'Cancer'],
  [1630851149,1631040643,'Leo'],
  [1631040643,1631223840,'Virgo'],
  [1631223840,1631405533,'Libra'],
  [1631405533,1631588720,'Scorpio'],
  [1631588720,1631774697,'Sagittarius'],
  [1631774697,1631964622,'Capricorn'],
  [1631964622,1632160739,'Aquarius'],
  [1632160739,1632365803,'Pisces'],
  [1632365803,1632580415,'Aries'],
  [1632580415,1632799915,'Taurus'],
  [1632799915,1633015081,'Gemini'],
  [1633015081,1633218070,'Cancer'],
  [1633218070,1633407431,'Leo'],
  [1633407431,1633587276,'Virgo'],
  [1633587276,1633763774,'Libra'],
  [1633763774,1633942468,'Scorpio'],
  [1633942468,1634126883,'Sagittarius'],
  [1634126883,1634318495,'Capricorn'],
  [1634318495,1634517747,'Aquarius'],
  [1634517747,1634724918,'Pisces'],
  [1634724918,1634939723,'Aries'],
  [1634939723,1635159278,'Taurus'],
  [1635159278,1635376849,'Gemini'],
  [1635376849,1635584410,'Cancer'],
  [1635584410,1635777659,'Leo'],
  [1635777659,1635958188,'Virgo'],
  [1635958188,1636131522,'Libra'],
  [1636131522,1636304416,'Scorpio'],
  [1636304416,1636482995,'Sagittarius'],
  [1636482995,1636671395,'Capricorn'],
  [1636671395,1636870908,'Aquarius'],
  [1636870908,1637080141,'Pisces'],
  [1637080141,1637296220,'Aries'],
  [1637296220,1637515674,'Taurus'],
  [1637515674,1637733944,'Gemini'],
  [1637733944,1637945253,'Cancer'],
  [1637945253,1638144499,'Leo'],
  [1638144499,1638330201,'Virgo'],
  [1638330201,1638505279,'Libra'],
  [1638505279,1638675657,'Scorpio'],
  [1638675657,1638848443,'Sagittarius'],
  [1638848443,1639030311,'Capricorn'],
  [1639030311,1639225544,'Aquarius'],
  [1639225544,1639434002,'Pisces'],
  [1639434002,1639651091,'Aries'],
  [1639651091,1639870730,'Taurus'],
  [1639870730,1640088145,'Gemini'],
  [1640088145,1640300009,'Cancer'],
  [1640300009,1640503275,'Leo'],
  [1640503275,1640695536,'Virgo'],
  [1640695536,1640876679,'Libra'],
  [1640876679,1641049894,'Scorpio'],
  [1641049894,1641221207,'Sagittarius'],
  [1641221207,1641397973,'Capricorn'],
  [1641397973,1641586878,'Aquarius'],
  [1641586878,1641790970,'Pisces'],
  [1641790970,1642006990,'Aries'],
  [1642006990,1642226905,'Taurus'],
  [1642226905,1642443420,'Gemini'],
  [1642443420,1642653336,'Cancer'],
  [1642653336,1642856158,'Leo'],
  [1642856158,1643051526,'Virgo'],
  [1643051526,1643238746,'Libra'],
  [1643238746,1643418261,'Scorpio'],
  [1643418261,1643593292,'Sagittarius'],
  [1643593292,1643769789,'Capricorn'],
  [1643769789,1643954788,'Aquarius'],
  [1643954788,1644153656,'Pisces'],
  [1644153656,1644366353,'Aries'],
  [1644366353,1644585808,'Taurus'],
  [1644585808,1644802412,'Gemini'],
  [1644802412,1645010632,'Cancer'],
  [1645010632,1645210350,'Leo'],
  [1645210350,1645403706,'Virgo'],
  [1645403706,1645592235,'Libra'],
  [1645592235,1645776410,'Scorpio'],
  [1645776410,1645957223,'Sagittarius'],
  [1645957223,1646137852,'Capricorn'],
  [1646137852,1646323585,'Aquarius'],
  [1646323585,1646519910,'Pisces'],
  [1646519910,1646729160,'Aries'],
  [1646729160,1646947231,'Taurus'],
  [1646947231,1647164698,'Gemini'],
  [1647164698,1647373359,'Cancer'],
  [1647373359,1647571031,'Leo'],
  [1647571031,1647760344,'Virgo'],
  [1647760344,1647945217,'Libra'],
  [1647945217,1648128579,'Scorpio'],
  [1648128579,1648312101,'Sagittarius'],
  [1648312101,1648497372,'Capricorn'],
  [1648497372,1648687039,'Aquarius'],
  [1648687039,1648884612,'Pisces'],
  [1648884612,1649092548,'Aries'],
  [1649092548,1649309227,'Taurus'],
  [1649309227,1649527615,'Gemini'],
  [1649527615,1649738732,'Cancer'],
  [1649738732,1649937529,'Leo'],
  [1649937529,1650124860,'Virgo'],
  [1650124860,1650305141,'Libra'],
  [1650305141,1650483544,'Scorpio'],
  [1650483544,1650664334,'Sagittarius'],
  [1650664334,1650850338,'Capricorn'],
  [1650850338,1651043211,'Aquarius'],
  [1651043211,1651243973,'Pisces'],
  [1651243973,1651453103,'Aries'],
  [1651453103,1651669381,'Taurus'],
  [1651669381,1651888294,'Gemini'],
  [1651888294,1652102431,'Cancer'],
  [1652102431,1652305119,'Leo'],
  [1652305119,1652494347,'Virgo'],
  [1652494347,1652672988,'Libra'],
  [1652672988,1652846681,'Scorpio'],
  [1652846681,1653021742,'Sagittarius'],
  [1653021742,1653203620,'Capricorn'],
  [1653203620,1653395629,'Aquarius'],
  [1653395629,1653598207,'Pisces'],
  [1653598207,1653809450,'Aries'],
  [1653809450,1654026426,'Taurus'],
  [1654026426,1654245457,'Gemini'],
  [1654245457,1654461554,'Cancer'],
  [1654461554,1654668762,'Leo'],
  [1654668762,1654862929,'Virgo'],
  [1654862929,1655044170,'Libra'],
  [1655044170,1655216747,'Scorpio'],
  [1655216747,1655387368,'Sagittarius'],
  [1655387368,1655563285,'Capricorn'],
  [1655563285,1655750423,'Aquarius'],
  [1655750423,1655951151,'Pisces'],
  [1655951151,1656163101,'Aries'],
  [1656163101,1656381040,'Taurus'],
  [1656381040,1656600013,'Gemini'],
  [1656600013,1656816301,'Cancer'],
  [1656816301,1657026175,'Leo'],
  [1657026175,1657225609,'Virgo'],
  [1657225609,1657412406,'Libra'],
  [1657412406,1657588191,'Scorpio'],
  [1657588191,1657758361,'Sagittarius'],
  [1657758361,1657930389,'Capricorn'],
  [1657930389,1658111798,'Aquarius'],
  [1658111798,1658307606,'Pisces'],
  [1658307606,1658517441,'Aries'],
  [1658517441,1658735414,'Taurus'],
  [1658735414,1658954320,'Gemini'],
  [1658954320,1659169624,'Cancer'],
  [1659169624,1659379236,'Leo'],
  [1659379236,1659581206,'Virgo'],
  [1659581206,1659773284,'Libra'],
  [1659773284,1659954852,'Scorpio'],
  [1659954852,1660128762,'Sagittarius'],
  [1660128762,1660301078,'Capricorn'],
  [1660301078,1660479309,'Aquarius'],
  [1660479309,1660670029,'Pisces'],
  [1660670029,1660875630,'Aries'],
  [1660875630,1661091994,'Taurus'],
  [1661091994,1661310771,'Gemini'],
  [1661310771,1661525169,'Cancer'],
  [1661525169,1661732733,'Leo'],
  [1661732733,1661933437,'Virgo'],
  [1661933437,1662127145,'Libra'],
  [1662127145,1662313351,'Scorpio'],
  [1662313351,1662492903,'Sagittarius'],
  [1662492903,1662669360,'Capricorn'],
  [1662669360,1662848560,'Aquarius'],
  [1662848560,1663036879,'Pisces'],
  [1663036879,1663238452,'Aries'],
  [1663238452,1663452024,'Taurus'],
  [1663452024,1663670421,'Gemini'],
  [1663670421,1663884997,'Cancer'],
  [1663884997,1664091059,'Leo'],
  [1664091059,1664288593,'Virgo'],
  [1664288593,1664479605,'Libra'],
  [1664479605,1664665909,'Scorpio'],
  [1664665909,1664848869,'Sagittarius'],
  [1664848869,1665030420,'Capricorn'],
  [1665030420,1665213876,'Aquarius'],
  [1665213876,1665403628,'Pisces'],
  [1665403628,1665603599,'Aries'],
  [1665603599,1665814628,'Taurus'],
  [1665814628,1666032317,'Gemini'],
  [1666032317,1666248269,'Cancer'],
  [1666248269,1666455221,'Leo'],
  [1666455221,1666650997,'Virgo'],
  [1666650997,1666837852,'Libra'],
  [1666837852,1667019864,'Scorpio'],
  [1667019864,1667200981,'Sagittarius'],
  [1667200981,1667384221,'Capricorn'],
  [1667384221,1667571765,'Aquarius'],
  [1667571765,1667765445,'Pisces'],
  [1667765445,1667966963,'Aries'],
  [1667966963,1668177142,'Taurus'],
  [1668177142,1668394038,'Gemini'],
  [1668394038,1668611661,'Cancer'],
  [1668611661,1668821949,'Leo'],
  [1668821949,1669019643,'Virgo'],
  [1669019643,1669204935,'Libra'],
  [1669204935,1669382230,'Scorpio'],
  [1669382230,1669557674,'Sagittarius'],
  [1669557674,1669737065,'Capricorn'],
  [1669737065,1669924320,'Aquarius'],
  [1669924320,1670120683,'Pisces'],
  [1670120683,1670325306,'Aries'],
  [1670325306,1670536740,'Taurus'],
  [1670536740,1670753330,'Gemini'],
  [1670753330,1670971761,'Cancer'],
  [1670971761,1671185818,'Leo'],
  [1671185818,1671388612,'Virgo'],
  [1671388612,1671577014,'Libra'],
  [1671577014,1671753452,'Scorpio'],
  [1671753452,1671924299,'Sagittarius'],
  [1671924299,1672097243,'Capricorn'],
  [1672097243,1672279049,'Aquarius'],
  [1672279049,1672473310,'Pisces'],
  [1672473310,1672679099,'Aries'],
  [1672679099,1672892494,'Taurus'],
  [1672892494,1673109663,'Gemini'],
  [1673109663,1673327880,'Cancer'],
  [1673327880,1673543658,'Leo'],
  [1673543658,1673751450,'Virgo'],
  [1673751450,1673946135,'Libra'],
  [1673946135,1674126834,'Scorpio'],
  [1674126834,1674297960,'Sagittarius'],
  [1674297960,1674467111,'Capricorn'],
  [1674467111,1674642497,'Aquarius'],
  [1674642497,1674830549,'Pisces'],
  [1674830549,1675033123,'Aries'],
  [1675033123,1675246537,'Taurus'],
  [1675246537,1675464540,'Gemini'],
  [1675464540,1675682384,'Cancer'],
  [1675682384,1675897434,'Leo'],
  [1675897434,1676106815,'Virgo'],
  [1676106815,1676306560,'Libra'],
  [1676306560,1676493915,'Scorpio'],
  [1676493915,1676670182,'Sagittarius'],
  [1676670182,1676840873,'Capricorn'],
  [1676840873,1677013648,'Aquarius'],
  [1677013648,1677196015,'Pisces'],
  [1677196015,1677392676,'Aries'],
  [1677392676,1677602874,'Taurus'],
  [1677602874,1677820529,'Gemini'],
  [1677820529,1678038383,'Cancer'],
  [1678038383,1678252019,'Leo'],
  [1678252019,1678459636,'Virgo'],
  [1678459636,1678659900,'Libra'],
  [1678659900,1678851327,'Scorpio'],
  [1678851327,1679033782,'Sagittarius'],
  [1679033782,1679209975,'Capricorn'],
  [1679209975,1679385262,'Aquarius'],
  [1679385262,1679566179,'Pisces'],
  [1679566179,1679758364,'Aries'],
  [1679758364,1679963946,'Taurus'],
  [1679963946,1680179532,'Gemini'],
  [1680179532,1680397478,'Cancer'],
  [1680397478,1680610707,'Leo'],
  [1680610707,1680815976,'Virgo'],
  [1680815976,1681013231,'Libra'],
  [1681013231,1681203622,'Scorpio'],
  [1681203622,1681388507,'Sagittarius'],
  [1681388507,1681569744,'Capricorn'],
  [1681569744,1681750252,'Aquarius'],
  [1681750252,1681934091,'Pisces'],
  [1681934091,1682125716,'Aries'],
  [1682125716,1682328281,'Taurus'],
  [1682328281,1682541260,'Gemini'],
  [1682541260,1682759036,'Cancer'],
  [1682759036,1682973294,'Leo'],
  [1682973294,1683178091,'Virgo'],
  [1683178091,1683372336,'Libra'],
  [1683372336,1683558617,'Scorpio'],
  [1683558617,1683740862,'Sagittarius'],
  [1683740862,1683922670,'Capricorn'],
  [1683922670,1684106704,'Aquarius'],
  [1684106704,1684294944,'Pisces'],
  [1684294944,1684489339,'Aries'],
  [1684489339,1684691904,'Taurus'],
  [1684691904,1684903369,'Gemini'],
  [1684903369,1685120821,'Cancer'],
  [1685120821,1685336989,'Leo'],
  [1685336989,1685543888,'Virgo'],
  [1685543888,1685737863,'Libra'],
  [1685737863,1685920853,'Scorpio'],
  [1685920853,1686098226,'Sagittarius'],
  [1686098226,1686276006,'Capricorn'],
  [1686276006,1686458866,'Aquarius'],
  [1686458866,1686649053,'Pisces'],
  [1686649053,1686846730,'Aries'],
  [1686846730,1687051504,'Taurus'],
  [1687051504,1687263218,'Gemini'],
  [1687263218,1687480511,'Cancer'],
  [1687480511,1687698467,'Leo'],
  [1687698467,1687909091,'Virgo'],
  [1687909091,1688106167,'Libra'],
  [1688106167,1688289323,'Scorpio'],
  [1688289323,1688463517,'Sagittarius'],
  [1688463517,1688636035,'Capricorn'],
  [1688636035,1688813827,'Aquarius'],
  [1688813827,1689001424,'Pisces'],
  [1689001424,1689199654,'Aries'],
  [1689199654,1689406534,'Taurus'],
  [1689406534,1689619656,'Gemini'],
  [1689619656,1689837149,'Cancer'],
  [1689837149,1690055935,'Leo'],
  [1690055935,1690269917,'Virgo'],
  [1690269917,1690472049,'Libra'],
  [1690472049,1690659191,'Scorpio'],
  [1690659191,1690834211,'Sagittarius'],
  [1690834211,1691003977,'Capricorn'],
  [1691003977,1691176439,'Aquarius'],
  [1691176439,1691358352,'Pisces'],
  [1691358352,1691553078,'Aries'],
  [1691553078,1691759518,'Taurus'],
  [1691759518,1691973709,'Gemini'],
  [1691973709,1692191667,'Cancer'],
  [1692191667,1692410254,'Leo'],
  [1692410254,1692625453,'Virgo'],
  [1692625453,1692831743,'Libra'],
  [1692831743,1693024739,'Scorpio'],
  [1693024739,1693204529,'Sagittarius'],
  [1693204529,1693375932,'Capricorn'],
  [1693375932,1693546263,'Aquarius'],
  [1693546263,1693723062,'Pisces'],
  [1693723062,1693912001,'Aries'],
  [1693912001,1694114704,'Taurus'],
  [1694114704,1694328066,'Gemini'],
  [1694328066,1694546313,'Cancer'],
  [1694546313,1694764319,'Leo'],
  [1694764319,1694978484,'Virgo'],
  [1694978484,1695185611,'Libra'],
  [1695185611,1695382712,'Scorpio'],
  [1695382712,1695568596,'Sagittarius'],
  [1695568596,1695745386,'Capricorn'],
  [1695745386,1695918175,'Aquarius'],
  [1695918175,1696093550,'Pisces'],
  [1696093550,1696277898,'Aries'],
  [1696277898,1696475352,'Taurus'],
  [1696475352,1696685600,'Gemini'],
  [1696685600,1696903327,'Cancer'],
  [1696903327,1697121142,'Leo'],
  [1697121142,1697333640,'Virgo'],
  [1697333640,1697538500,'Libra'],
  [1697538500,1697735303,'Scorpio'],
  [1697735303,1697924373,'Sagittarius'],
  [1697924373,1698106862,'Capricorn'],
  [1698106862,1698285302,'Aquarius'],
  [1698285302,1698463774,'Pisces'],
  [1698463774,1698647429,'Aries'],
  [1698647429,1698841187,'Taurus'],
  [1698841187,1699047465,'Gemini'],
  [1699047465,1699263588,'Cancer'],
  [1699263588,1699481824,'Leo'],
  [1699481824,1699694018,'Virgo'],
  [1699694018,1699896286,'Libra'],
  [1699896286,1700089431,'Scorpio'],
  [1700089431,1700276486,'Sagittarius'],
  [1700276486,1700460454,'Capricorn'],
  [1700460454,1700643474,'Aquarius'],
  [1700643474,1700827294,'Pisces'],
  [1700827294,1701014333,'Aries'],
  [1701014333,1701208089,'Taurus'],
  [1701208089,1701411894,'Gemini'],
  [1701411894,1701625968,'Cancer'],
  [1701625968,1701844748,'Leo'],
  [1701844748,1702058762,'Virgo'],
  [1702058762,1702261072,'Libra'],
  [1702261072,1702451170,'Scorpio'],
  [1702451170,1702633387,'Sagittarius'],
  [1702633387,1702813405,'Capricorn'],
  [1702813405,1702995674,'Aquarius'],
  [1702995674,1703182300,'Pisces'],
  [1703182300,1703373750,'Aries'],
  [1703373750,1703570723,'Taurus'],
  [1703570723,1703775012,'Gemini'],
  [1703775012,1703987908,'Cancer'],
  [1703987908,1704206797,'Leo'],
  [1704206797,1704423641,'Virgo'],
  [1704423641,1704629355,'Libra'],
  [1704629355,1704820312,'Scorpio'],
  [1704820312,1704999692,'Sagittarius'],
  [1704999692,1705174249,'Capricorn'],
  [1705174249,1705350922,'Aquarius'],
  [1705350922,1705534553,'Pisces'],
  [1705534553,1705726741,'Aries'],
  [1705726741,1705926742,'Taurus'],
  [1705926742,1706133605,'Gemini'],
  [1706133605,1706347053,'Cancer'],
  [1706347053,1706565744,'Leo'],
  [1706565744,1706784480,'Virgo'],
  [1706784480,1706994867,'Libra'],
  [1706994867,1707190663,'Scorpio'],
  [1707190663,1707372035,'Sagittarius'],
  [1707372035,1707544556,'Capricorn'],
  [1707544556,1707715837,'Aquarius'],
  [1707715837,1707892940,'Pisces'],
  [1707892940,1708080472,'Aries'],
  [1708080472,1708279441,'Taurus'],
  [1708279441,1708487909,'Gemini'],
  [1708487909,1708702926,'Cancer'],
  [1708702926,1708921717,'Leo'],
  [1708921717,1709140591,'Virgo'],
  [1709140591,1709353779,'Libra'],
  [1709353779,1709555228,'Scorpio'],
  [1709555228,1709742430,'Sagittarius'],
  [1709742430,1709918081,'Capricorn'],
  [1709918081,1710088406,'Aquarius'],
  [1710088406,1710260743,'Pisces'],
  [1710260743,1710441690,'Aries'],
  [1710441690,1710635355,'Taurus'],
  [1710635355,1710841867,'Gemini'],
  [1710841867,1711057439,'Cancer'],
  [1711057439,1711276672,'Leo'],
  [1711276672,1711494769,'Virgo'],
  [1711494769,1711707710,'Libra'],
  [1711707710,1711911862,'Scorpio'],
  [1711911862,1712104734,'Sagittarius'],
  [1712104734,1712286583,'Capricorn'],
  [1712286583,1712460849,'Aquarius'],
  [1712460849,1712633241,'Pisces'],
  [1712633241,1712810366,'Aries'],
  [1712810366,1712998177,'Taurus'],
  [1712998177,1713199864,'Gemini'],
  [1713199864,1713413617,'Cancer'],
  [1713413617,1713632918,'Leo'],
  [1713632918,1713850449,'Virgo'],
  [1713850449,1714061545,'Libra'],
  [1714061545,1714264546,'Scorpio'],
  [1714264546,1714459217,'Sagittarius'],
  [1714459217,1714645951,'Capricorn'],
  [1714645951,1714826135,'Aquarius'],
  [1714826135,1715002788,'Pisces'],
  [1715002788,1715180723,'Aries'],
  [1715180723,1715365770,'Taurus'],
  [1715365770,1715562909,'Gemini'],
  [1715562909,1715773267,'Cancer'],
  [1715773267,1715991759,'Leo'],
  [1715991759,1716209392,'Virgo'],
  [1716209392,1716419185,'Libra'],
  [1716419185,1716619335,'Scorpio'],
  [1716619335,1716811691,'Sagittarius'],
  [1716811691,1716998830,'Capricorn'],
  [1716998830,1717182591,'Aquarius'],
  [1717182591,1717364370,'Pisces'],
  [1717364370,1717546435,'Aries'],
  [1717546435,1717732754,'Taurus'],
  [1717732754,1717928148,'Gemini'],
  [1717928148,1718135610,'Cancer'],
  [1718135610,1718352740,'Leo'],
  [1718352740,1718571058,'Virgo'],
  [1718571058,1718781351,'Libra'],
  [1718781351,1718979811,'Scorpio'],
  [1718979811,1719168531,'Sagittarius'],
  [1719168531,1719352133,'Capricorn'],
  [1719352133,1719534701,'Aquarius'],
  [1719534701,1719718493,'Pisces'],
  [1719718493,1719904586,'Aries'],
  [1719904586,1720094577,'Taurus'],
  [1720094577,1720291398,'Gemini'],
  [1720291398,1720497989,'Cancer'],
  [1720497989,1720714018,'Leo'],
  [1720714018,1720933212,'Virgo'],
  [1720933212,1721145816,'Libra'],
  [1721145816,1721345411,'Scorpio'],
  [1721345411,1721532419,'Sagittarius'],
  [1721532419,1721711862,'Capricorn'],
  [1721711862,1721889771,'Aquarius'],
  [1721889771,1722070793,'Pisces'],
  [1722070793,1722257301,'Aries'],
  [1722257301,1722450103,'Taurus'],
  [1722450103,1722649890,'Gemini'],
  [1722649890,1722857732,'Cancer'],
  [1722857732,1723073553,'Leo'],
  [1723073553,1723293355,'Virgo'],
  [1723293355,1723508925,'Libra'],
  [1723508925,1723712359,'Scorpio'],
  [1723712359,1723901314,'Sagittarius'],
  [1723901314,1724079344,'Capricorn'],
  [1724079344,1724252838,'Aquarius'],
  [1724252838,1724428305,'Pisces'],
  [1724428305,1724610684,'Aries'],
  [1724610684,1724802477,'Taurus'],
  [1724802477,1725003906,'Gemini'],
  [1725003906,1725213812,'Cancer'],
  [1725213812,1725430368,'Leo'],
  [1725430368,1725650311,'Virgo'],
  [1725650311,1725867822,'Libra'],
  [1725867822,1726075858,'Scorpio'],
  [1726075858,1726269957,'Sagittarius'],
  [1726269957,1726450863,'Capricorn'],
  [1726450863,1726623496,'Aquarius'],
  [1726623496,1726794593,'Pisces'],
  [1726794593,1726970884,'Aries'],
  [1726970884,1727157606,'Taurus'],
  [1727157606,1727357013,'Gemini'],
  [1727357013,1727567602,'Cancer'],
  [1727567602,1727785189,'Leo'],
  [1727785189,1728005030,'Virgo'],
  [1728005030,1728222553,'Libra'],
  [1728222553,1728433165,'Scorpio'],
  [1728433165,1728632782,'Sagittarius'],
  [1728632782,1728819793,'Capricorn'],
  [1728819793,1728996242,'Aquarius'],
  [1728996242,1729167242,'Pisces'],
  [1729167242,1729339579,'Aries'],
  [1729339579,1729520199,'Taurus'],
  [1729520199,1729714239,'Gemini'],
  [1729714239,1729922452,'Cancer'],
  [1729922452,1730140131,'Leo'],
  [1730140131,1730359983,'Virgo'],
  [1730359983,1730576304,'Libra'],
  [1730576304,1730786197,'Scorpio'],
  [1730786197,1730988062,'Sagittarius'],
  [1730988062,1731180593,'Capricorn'],
  [1731180593,1731363578,'Aquarius'],
  [1731363578,1731539186,'Pisces'],
  [1731539186,1731712349,'Aries'],
  [1731712349,1731889829,'Taurus'],
  [1731889829,1732078381,'Gemini'],
  [1732078381,1732281794,'Cancer'],
  [1732281794,1732497599,'Leo'],
  [1732497599,1732717481,'Virgo'],
  [1732717481,1732933024,'Libra'],
  [1732933024,1733140535,'Scorpio'],
  [1733140535,1733340383,'Sagittarius'],
  [1733340383,1733533827,'Capricorn'],
  [1733533827,1733721319,'Aquarius'],
  [1733721319,1733903168,'Pisces'],
  [1733903168,1734081392,'Aries'],
  [1734081392,1734260619,'Taurus'],
  [1734260619,1734447113,'Gemini'],
  [1734447113,1734646256,'Cancer'],
  [1734646256,1734858752,'Leo'],
  [1734858752,1735078130,'Virgo'],
  [1735078130,1735294262,'Libra'],
  [1735294262,1735500661,'Scorpio'],
  [1735500661,1735697152,'Sagittarius'],
  [1735697152,1735886993,'Capricorn'],
  [1735886993,1736073353,'Aquarius'],
  [1736073353,1736257816,'Pisces'],
  [1736257816,1736441189,'Aries'],
  [1736441189,1736625386,'Taurus'],
  [1736625386,1736814251,'Gemini'],
  [1736814251,1737012400,'Cancer'],
  [1737012400,1737222248,'Leo'],
  [1737222248,1737440485,'Virgo'],
  [1737440485,1737658069,'Libra'],
  [1737658069,1737866122,'Scorpio'],
  [1737866122,1738061726,'Sagittarius'],
  [1738061726,1738247691,'Capricorn'],
  [1738247691,1738429034,'Aquarius'],
  [1738429034,1738610177,'Pisces'],
  [1738610177,1738793830,'Aries'],
  [1738793830,1738981479,'Taurus'],
  [1738981479,1739174590,'Gemini'],
  [1739174590,1739375165,'Cancer'],
  [1739375165,1739584770,'Leo'],
  [1739584770,1739802020,'Virgo'],
  [1739802020,1740020765,'Libra'],
  [1740020765,1740232286,'Scorpio'],
  [1740232286,1740430815,'Sagittarius'],
  [1740430815,1740616554,'Capricorn'],
  [1740616554,1740794052,'Aquarius'],
  [1740794052,1740969340,'Pisces'],
  [1740969340,1741147937,'Aries'],
  [1741147937,1741333707,'Taurus'],
  [1741333707,1741528417,'Gemini'],
  [1741528417,1741732041,'Cancer'],
  [1741732041,1741943508,'Leo'],
  [1741943508,1742160778,'Virgo'],
  [1742160778,1742379829,'Libra'],
  [1742379829,1742594341,'Scorpio'],
  [1742594341,1742797894,'Sagittarius'],
  [1742797894,1742987689,'Capricorn'],
  [1742987689,1743165806,'Aquarius'],
  [1743165806,1743337748,'Pisces'],
  [1743337748,1743510375,'Aries'],
  [1743510375,1743690165,'Taurus'],
  [1743690165,1743881536,'Gemini'],
  [1743881536,1744085263,'Cancer'],
  [1744085263,1744298447,'Leo'],
  [1744298447,1744516600,'Virgo'],
  [1744516600,1744735449,'Libra'],
  [1744735449,1744950917,'Scorpio'],
  [1744950917,1745158419,'Sagittarius'],
  [1745158419,1745354056,'Capricorn'],
  [1745354056,1745536984,'Aquarius'],
  [1745536984,1745710368,'Pisces'],
  [1745710368,1745880458,'Aries'],
  [1745880458,1746054762,'Taurus'],
  [1746054762,1746240086,'Gemini'],
  [1746240086,1746439971,'Cancer'],
  [1746439971,1746652448,'Leo'],
  [1746652448,1746871206,'Virgo'],
  [1746871206,1747089845,'Libra'],
  [1747089845,1747304500,'Scorpio'],
  [1747304500,1747512859,'Sagittarius'],
  [1747512859,1747712466,'Capricorn'],
  [1747712466,1747901317,'Aquarius'],
  [1747901317,1748079851,'Pisces'],
  [1748079851,1748252086,'Aries'],
  [1748252086,1748424769,'Taurus'],
  [1748424769,1748605448,'Gemini'],
  [1748605448,1748799947,'Cancer'],
  [1748799947,1749009045,'Leo'],
  [1749009045,1749227067,'Virgo'],
  [1749227067,1749445611,'Libra'],
  [1749445611,1749659038,'Scorpio'],
  [1749659038,1749865687,'Sagittarius'],
  [1749865687,1750065376,'Capricorn'],
  [1750065376,1750257459,'Aquarius'],
  [1750257459,1750441413,'Pisces'],
  [1750441413,1750618791,'Aries'],
  [1750618791,1750794137,'Taurus'],
  [1750794137,1750974022,'Gemini'],
  [1750974022,1751164883,'Cancer'],
  [1751164883,1751369859,'Leo'],
  [1751369859,1751585795,'Virgo'],
  [1751585795,1751804242,'Libra'],
  [1751804242,1752017275,'Scorpio'],
  [1752017275,1752221828,'Sagittarius'],
  [1752221828,1752418720,'Capricorn'],
  [1752418720,1752609635,'Aquarius'],
  [1752609635,1752795562,'Pisces'],
  [1752795562,1752977438,'Aries'],
  [1752977438,1753157622,'Taurus'],
  [1753157622,1753340423,'Gemini'],
  [1753340423,1753531107,'Cancer'],
  [1753531107,1753733548,'Leo'],
  [1753733548,1753947120,'Virgo'],
  [1753947120,1754165365,'Libra'],
  [1754165365,1754379367,'Scorpio'],
  [1754379367,1754583546,'Sagittarius'],
  [1754583546,1754777673,'Capricorn'],
  [1754777673,1754964662,'Aquarius'],
  [1754964662,1755147935,'Pisces'],
  [1755147935,1755330205,'Aries'],
  [1755330205,1755513666,'Taurus'],
  [1755513666,1755700709,'Gemini'],
  [1755700709,1755894215,'Cancer'],
  [1755894215,1756096841,'Leo'],
  [1756096841,1756309055,'Virgo'],
  [1756309055,1756527019,'Libra'],
  [1756527019,1756742971,'Scorpio'],
  [1756742971,1756949388,'Sagittarius'],
  [1756949388,1757143439,'Capricorn'],
  [1757143439,1757327263,'Aquarius'],
  [1757327263,1757505620,'Pisces'],
  [1757505620,1757683725,'Aries'],
  [1757683725,1757865873,'Taurus'],
  [1757865873,1758054792,'Gemini'],
  [1758054792,1758251655,'Cancer'],
  [1758251655,1758456623,'Leo'],
  [1758456623,1758669125,'Virgo'],
  [1758669125,1758886878,'Libra'],
  [1758886878,1759104642,'Scorpio'],
  [1759104642,1759315068,'Sagittarius'],
  [1759315068,1759512672,'Capricorn'],
  [1759512672,1759696999,'Aquarius'],
  [1759696999,1759872178,'Pisces'],
  [1759872178,1760044718,'Aries'],
  [1760044718,1760221386,'Taurus'],
  [1760221386,1760407376,'Gemini'],
  [1760407376,1760604699,'Cancer'],
  [1760604699,1760811923,'Leo'],
  [1760811923,1761025953,'Virgo'],
  [1761025953,1761243805,'Libra'],
  [1761243805,1761462202,'Scorpio'],
  [1761462202,1761676065,'Sagittarius'],
  [1761676065,1761879291,'Capricorn'],
  [1761879291,1762068398,'Aquarius'],
  [1762068398,1762244952,'Pisces'],
  [1762244952,1762414815,'Aries'],
  [1762414815,1762585798,'Taurus'],
  [1762585798,1762765450,'Gemini'],
  [1762765450,1762958620,'Cancer'],
  [1762958620,1763165132,'Leo'],
  [1763165132,1763380315,'Virgo'],
  [1763380315,1763598683,'Libra'],
  [1763598683,1763816605,'Scorpio'],
  [1763816605,1764031267,'Sagittarius'],
  [1764031267,1764238600,'Capricorn'],
  [1764238600,1764434186,'Aquarius'],
  [1764434186,1764616509,'Pisces'],
  [1764616509,1764788861,'Aries'],
  [1764788861,1764958161,'Taurus'],
  [1764958161,1765132600,'Gemini'],
  [1765132600,1765319282,'Cancer'],
  [1765319282,1765521190,'Leo'],
  [1765521190,1765735109,'Virgo'],
  [1765735109,1765953833,'Libra'],
  [1765953833,1766171227,'Scorpio'],
  [1766171227,1766384425,'Sagittarius'],
  [1766384425,1766591799,'Capricorn'],
  [1766591799,1766790965,'Aquarius'],
  [1766790965,1766979667,'Pisces'],
  [1766979667,1767158336,'Aries'],
  [1767158336,1767331230,'Taurus'],
  [1767331230,1767505206,'Gemini'],
  [1767505206,1767687627,'Cancer'],
  [1767687627,1767883753,'Leo'],
  [1767883753,1768093699,'Virgo'],
  [1768093699,1768311531,'Libra'],
  [1768311531,1768529010,'Scorpio'],
  [1768529010,1768740799,'Sagittarius'],
  [1768740799,1768945464,'Capricorn'],
  [1768945464,1769143156,'Aquarius'],
  [1769143156,1769333868,'Pisces'],
  [1769333868,1769517831,'Aries'],
  [1769517831,1769696905,'Taurus'],
  [1769696905,1769875172,'Gemini'],
  [1769875172,1770058190,'Cancer'],
  [1770058190,1770251271,'Leo'],
  [1770251271,1770456945,'Virgo'],
  [1770456945,1770672504,'Libra'],
  [1770672504,1770890318,'Scorpio'],
  [1770890318,1771102465,'Sagittarius'],
  [1771102465,1771305188,'Capricorn'],
  [1771305188,1771499018,'Aquarius'],
  [1771499018,1771686496,'Pisces'],
  [1771686496,1771870333,'Aries'],
  [1771870333,1772052868,'Taurus'],
  [1772052868,1772236405,'Gemini'],
  [1772236405,1772423709,'Cancer'],
  [1772423709,1772617998,'Leo'],
  [1772617998,1772821879,'Virgo'],
  [1772821879,1773035182,'Libra'],
  [1773035182,1773253037,'Scorpio'],
  [1773253037,1773467169,'Sagittarius'],
  [1773467169,1773670895,'Capricorn'],
  [1773670895,1773862684,'Aquarius'],
  [1773862684,1774045589,'Pisces'],
  [1774045589,1774224719,'Aries'],
  [1774224719,1774405011,'Taurus'],
  [1774405011,1774589899,'Gemini'],
  [1774589899,1774781009,'Cancer'],
  [1774781009,1774978903,'Leo'],
  [1774978903,1775184080,'Virgo'],
  [1775184080,1775396644,'Libra'],
  [1775396644,1775614283,'Scorpio'],
  [1775614283,1775830723,'Sagittarius'],
  [1775830723,1776038002,'Capricorn'],
  [1776038002,1776231577,'Aquarius'],
  [1776231577,1776412764,'Pisces'],
  [1776412764,1776587189,'Aries'],
  [1776587189,1776761873,'Taurus'],
  [1776761873,1776942866,'Gemini'],
  [1776942866,1777133455,'Cancer'],
  [1777133455,1777333566,'Leo'],
  [1777333566,1777541265,'Virgo'],
  [1777541265,1777754767,'Libra'],
  [1777754767,1777972338,'Scorpio'],
  [1777972338,1778190161,'Sagittarius'],
  [1778190161,1778401436,'Capricorn'],
  [1778401436,1778599733,'Aquarius'],
  [1778599733,1778783482,'Pisces'],
  [1778783482,1778956835,'Aries'],
  [1778956835,1779127157,'Taurus'],
  [1779127157,1779302227,'Gemini'],
  [1779302227,1779487946,'Cancer'],
  [1779487946,1779686253,'Leo'],
  [1779686253,1779894861,'Virgo'],
  [1779894861,1780109727,'Libra'],
  [1780109727,1780327563,'Scorpio'],
  [1780327563,1780545493,'Sagittarius'],
  [1780545493,1780759003,'Capricorn'],
  [1780759003,1780962196,'Aquarius'],
  [1780962196,1781151372,'Pisces'],
  [1781151372,1781328001,'Aries'],
  [1781328001,1781498047,'Taurus'],
  [1781498047,1781669352,'Gemini'],
  [1781669352,1781849304,'Cancer'],
  [1781849304,1782042507,'Leo'],
  [1782042507,1782248811,'Virgo'],
  [1782248811,1782463801,'Libra'],
  [1782463801,1782681967,'Scorpio'],
  [1782681967,1782899268,'Sagittarius'],
  [1782899268,1783112504,'Capricorn'],
  [1783112504,1783317957,'Aquarius'],
  [1783317957,1783512178,'Pisces'],
  [1783512178,1783694533,'Aries'],
  [1783694533,1783868449,'Taurus'],
  [1783868449,1784040236,'Gemini'],
  [1784040236,1784217095,'Cancer'],
  [1784217095,1784405086,'Leo'],
  [1784405086,1784606810,'Virgo'],
  [1784606810,1784819854,'Libra'],
  [1784819854,1785037926,'Scorpio'],
  [1785037926,1785254694,'Sagittarius'],
  [1785254694,1785466232,'Capricorn'],
  [1785466232,1785670514,'Aquarius'],
  [1785670514,1785866294,'Pisces'],
  [1785866294,1786053198,'Aries'],
  [1786053198,1786232761,'Taurus'],
  [1786232761,1786408794,'Gemini'],
  [1786408794,1786586725,'Cancer'],
  [1786586725,1786772314,'Leo'],
  [1786772314,1786969788,'Virgo'],
  [1786969788,1787179543,'Libra'],
  [1787179543,1787396795,'Scorpio'],
  [1787396795,1787613702,'Sagittarius'],
  [1787613702,1787824023,'Capricorn'],
  [1787824023,1788025474,'Aquarius'],
  [1788025474,1788218830,'Pisces'],
  [1788218830,1788406007,'Aries'],
  [1788406007,1788589065,'Taurus'],
  [1788589065,1788770256,'Gemini'],
  [1788770256,1788952481,'Cancer'],
  [1788952481,1789139511,'Leo'],
  [1789139511,1789335321,'Virgo'],
  [1789335321,1789542205,'Libra'],
  [1789542205,1789758121,'Scorpio'],
  [1789758121,1789975863,'Sagittarius'],
  [1789975863,1790186894,'Capricorn'],
  [1790186894,1790386714,'Aquarius'],
  [1790386714,1790576249,'Pisces'],
  [1790576249,1790759582,'Aries'],
  [1790759582,1790941202,'Taurus'],
  [1790941202,1791124358,'Gemini'],
  [1791124358,1791310809,'Cancer'],
  [1791310809,1791501795,'Leo'],
  [1791501795,1791699179,'Virgo'],
  [1791699179,1791905156,'Libra'],
  [1791905156,1792119884,'Scorpio'],
  [1792119884,1792338609,'Sagittarius'],
  [1792338609,1792552367,'Capricorn'],
  [1792552367,1792753767,'Aquarius'],
  [1792753767,1792941706,'Pisces'],
  [1792941706,1793120602,'Aries'],
  [1793120602,1793297022,'Taurus'],
  [1793297022,1793476832,'Gemini'],
  [1793476832,1793663396,'Cancer'],
  [1793663396,1793857289,'Leo'],
  [1793857289,1794057921,'Virgo'],
  [1794057921,1794265320,'Libra'],
  [1794265320,1794479758,'Scorpio'],
  [1794479758,1794698950,'Sagittarius'],
  [1794698950,1794915901,'Capricorn'],
  [1794915901,1795121852,'Aquarius'],
  [1795121852,1795312509,'Pisces'],
  [1795312509,1795490409,'Aries'],
  [1795490409,1795662333,'Taurus'],
  [1795662333,1795835956,'Gemini'],
  [1795835956,1796017435,'Cancer'],
  [1796017435,1796209579,'Leo'],
  [1796209579,1796411644,'Virgo'],
  [1796411644,1796621310,'Libra'],
  [1796621310,1796836651,'Scorpio'],
  [1796836651,1797055769,'Sagittarius'],
  [1797055769,1797274315,'Capricorn'],
  [1797274315,1797485014,'Aquarius'],
  [1797485014,1797681662,'Pisces'],
  [1797681662,1797863554,'Aries'],
  [1797863554,1798035563,'Taurus'],
  [1798035563,1798205226,'Gemini'],
  [1798205226,1798380172,'Cancer'],
  [1798380172,1798566120,'Leo'],
  [1798566120,1798765060,'Virgo'],
  [1798765060,1798974937,'Libra'],
  [1798974937,1799191474,'Scorpio'],
  [1799191474,1799410603,'Sagittarius'],
  [1799410603,1799628672,'Capricorn'],
  [1799628672,1799841143,'Aquarius'],
  [1799841143,1800043037,'Pisces'],
  [1800043037,1800231685,'Aries'],
  [1800231685,1800408808,'Taurus'],
  [1800408808,1800579809,'Gemini'],
  [1800579809,1800751755,'Cancer'],
  [1800751755,1800931573,'Leo'],
  [1800931573,1801124204,'Virgo'],
  [1801124204,1801330575,'Libra'],
  [1801330575,1801546751,'Scorpio'],
  [1801546751,1801766150,'Sagittarius'],
  [1801766150,1801983121,'Capricorn'],
  [1801983121,1802194132,'Aquarius'],
  [1802194132,1802396975,'Pisces'],
  [1802396975,1802590223,'Aries'],
  [1802590223,1802773990,'Taurus'],
  [1802773990,1802950708,'Gemini'],
  [1802950708,1803125027,'Cancer'],
  [1803125027,1803302967,'Leo'],
  [1803302967,1803490533,'Virgo'],
  [1803490533,1803691575,'Libra'],
  [1803691575,1803905053,'Scorpio'],
  [1803905053,1804124308,'Sagittarius'],
  [1804124308,1804340974,'Capricorn'],
  [1804340974,1804549845,'Aquarius'],
  [1804549845,1804749987,'Pisces'],
  [1804749987,1804942690,'Aries'],
  [1804942690,1805129519,'Taurus'],
  [1805129519,1805311898,'Gemini'],
  [1805311898,1805491805,'Cancer'],
  [1805491805,1805672686,'Leo'],
  [1805672686,1805859429,'Virgo'],
  [1805859429,1806056878,'Libra'],
  [1806056878,1806266862,'Scorpio'],
  [1806266862,1806485137,'Sagittarius'],
  [1806485137,1806702486,'Capricorn'],
  [1806702486,1806910908,'Aquarius'],
  [1806910908,1807108214,'Pisces'],
  [1807108214,1807297087,'Aries'],
  [1807297087,1807481672,'Taurus'],
  [1807481672,1807665148,'Gemini'],
  [1807665148,1807849141,'Cancer'],
  [1807849141,1808034840,'Leo'],
  [1808034840,1808224576,'Virgo'],
  [1808224576,1808421983,'Libra'],
  [1808421983,1808629934,'Scorpio'],
  [1808629934,1808846952,'Sagittarius'],
  [1808846952,1809065402,'Capricorn'],
  [1809065402,1809275619,'Aquarius'],
  [1809275619,1809472722,'Pisces'],
  [1809472722,1809658517,'Aries'],
  [1809658517,1809838459,'Taurus'],
  [1809838459,1810018162,'Gemini'],
  [1810018162,1810201322,'Cancer'],
  [1810201322,1810389364,'Leo'],
  [1810389364,1810582794,'Virgo'],
  [1810582794,1810782795,'Libra'],
  [1810782795,1810991086,'Scorpio'],
  [1810991086,1811207452,'Sagittarius'],
  [1811207452,1811426798,'Capricorn'],
  [1811426798,1811640059,'Aquarius'],
  [1811640059,1811840076,'Pisces'],
  [1811840076,1812026193,'Aries'],
  [1812026193,1812203189,'Taurus'],
  [1812203189,1812377797,'Gemini'],
  [1812377797,1812556035,'Cancer'],
  [1812556035,1812741665,'Leo'],
  [1812741665,1812935889,'Virgo'],
  [1812935889,1813138389,'Libra'],
  [1813138389,1813348528,'Scorpio'],
  [1813348528,1813565207,'Sagittarius'],
  [1813565207,1813784913,'Capricorn'],
  [1813784913,1814000771,'Aquarius'],
  [1814000771,1814205336,'Pisces'],
  [1814205336,1814395356,'Aries'],
  [1814395356,1814573345,'Taurus'],
  [1814573345,1814745370,'Gemini'],
  [1814745370,1814918388,'Cancer'],
  [1814918388,1815098421,'Leo'],
  [1815098421,1815289196,'Virgo'],
  [1815289196,1815491382,'Libra'],
  [1815491382,1815702936,'Scorpio'],
  [1815702936,1815920494,'Sagittarius'],
  [1815920494,1816140114,'Capricorn'],
  [1816140114,1816356827,'Aquarius'],
  [1816356827,1816565009,'Pisces'],
  [1816565009,1816760529,'Aries'],
  [1816760529,1816943219,'Taurus'],
  [1816943219,1817116933,'Gemini'],
  [1817116933,1817287867,'Cancer'],
  [1817287867,1817462862,'Leo'],
  [1817462862,1817647895,'Virgo'],
  [1817647895,1817846279,'Libra'],
  [1817846279,1818057004,'Scorpio'],
  [1818057004,1818275098,'Sagittarius'],
  [1818275098,1818494516,'Capricorn'],
  [1818494516,1818710392,'Aquarius'],
  [1818710392,1818919298,'Pisces'],
  [1818919298,1819118653,'Aries'],
  [1819118653,1819307214,'Taurus'],
  [1819307214,1819486178,'Gemini'],
  [1819486178,1819659448,'Cancer'],
  [1819659448,1819832971,'Leo'],
  [1819832971,1820013470,'Virgo'],
  [1820013470,1820206553,'Libra'],
  [1820206553,1820413914,'Scorpio'],
  [1820413914,1820631304,'Sagittarius'],
  [1820631304,1820850661,'Capricorn'],
  [1820850661,1821065246,'Aquarius'],
  [1821065246,1821272257,'Pisces'],
  [1821272257,1821471518,'Aries'],
  [1821471518,1821663299,'Taurus'],
  [1821663299,1821847889,'Gemini'],
  [1821847889,1822026629,'Cancer'],
  [1822026629,1822203050,'Leo'],
  [1822203050,1822382799,'Virgo'],
  [1822382799,1822572173,'Libra'],
  [1822572173,1822775305,'Scorpio'],
  [1822775305,1822990585,'Sagittarius'],
  [1822990585,1823209981,'Capricorn'],
  [1823209981,1823424278,'Aquarius'],
  [1823424278,1823629066,'Pisces'],
  [1823629066,1823825180,'Aries'],
  [1823825180,1824015414,'Taurus'],
  [1824015414,1824201822,'Gemini'],
  [1824201822,1824385282,'Cancer'],
  [1824385282,1824566980,'Leo'],
  [1824566980,1824750021,'Virgo'],
  [1824750021,1824939379,'Libra'],
  [1824939379,1825139891,'Scorpio'],
  [1825139891,1825352619,'Sagittarius'],
  [1825352619,1825571846,'Capricorn'],
  [1825571846,1825787459,'Aquarius'],
  [1825787459,1825992201,'Pisces'],
  [1825992201,1826185532,'Aries'],
  [1826185532,1826371381,'Taurus'],
  [1826371381,1826554392,'Gemini'],
  [1826554392,1826737659,'Cancer'],
  [1826737659,1826922545,'Leo'],
  [1826922545,1827110179,'Virgo'],
  [1827110179,1827302883,'Libra'],
  [1827302883,1827503924,'Scorpio'],
  [1827503924,1827715224,'Sagittarius'],
  [1827715224,1827933945,'Capricorn'],
  [1827933945,1828151682,'Aquarius'],
  [1828151682,1828359356,'Pisces'],
  [1828359356,1828553382,'Aries'],
  [1828553382,1828736421,'Taurus'],
  [1828736421,1828914134,'Gemini'],
  [1828914134,1829092196,'Cancer'],
  [1829092196,1829274643,'Leo'],
  [1829274643,1829463527,'Virgo'],
  [1829463527,1829659676,'Libra'],
  [1829659676,1829863615,'Scorpio'],
  [1829863615,1830075579,'Sagittarius'],
  [1830075579,1830293885,'Capricorn'],
  [1830293885,1830513055,'Aquarius'],
  [1830513055,1830724968,'Pisces'],
  [1830724968,1830923552,'Aries'],
  [1830923552,1831108375,'Taurus'],
  [1831108375,1831283793,'Gemini'],
  [1831283793,1831456263,'Cancer'],
  [1831456263,1831632251,'Leo'],
  [1831632251,1831816780,'Virgo'],
  [1831816780,1832012293,'Libra'],
  [1832012293,1832218285,'Scorpio'],
  [1832218285,1832432212,'Sagittarius'],
  [1832432212,1832650809,'Capricorn'],
  [1832650809,1832870078,'Aquarius'],
  [1832870078,1833084694,'Pisces'],
  [1833084694,1833288906,'Aries'],
  [1833288906,1833479545,'Taurus'],
  [1833479545,1833657891,'Gemini'],
  [1833657891,1833828986,'Cancer'],
  [1833828986,1833999805,'Leo'],
  [1833999805,1834177511,'Virgo'],
  [1834177511,1834367609,'Libra'],
  [1834367609,1834571691,'Scorpio'],
  [1834571691,1834786425,'Sagittarius'],
  [1834786425,1835005812,'Capricorn'],
  [1835005812,1835224577,'Aquarius'],
  [1835224577,1835439135,'Pisces'],
  [1835439135,1835646285,'Aries'],
  [1835646285,1835842905,'Taurus'],
  [1835842905,1836027662,'Gemini'],
  [1836027662,1836202600,'Cancer'],
  [1836202600,1836373154,'Leo'],
  [1836373154,1836546667,'Virgo'],
  [1836546667,1836730460,'Libra'],
  [1836730460,1836929182,'Scorpio'],
  [1836929182,1837141720,'Sagittarius'],
  [1837141720,1837361186,'Capricorn'],
  [1837361186,1837579678,'Aquarius'],
  [1837579678,1837792734,'Pisces'],
  [1837792734,1837999048,'Aries'],
  [1837999048,1838197837,'Taurus'],
  [1838197837,1838387935,'Gemini'],
  [1838387935,1838569142,'Cancer'],
  [1838569142,1838744067,'Leo'],
  [1838744067,1838918343,'Virgo'],
  [1838918343,1839099137,'Libra'],
  [1839099137,1839292718,'Scorpio'],
  [1839292718,1839501004,'Sagittarius'],
  [1839501004,1839719004,'Capricorn'],
  [1839719004,1839937498,'Aquarius'],
  [1839937498,1840149540,'Pisces'],
  [1840149540,1840353367,'Aries'],
  [1840353367,1840550147,'Taurus'],
  [1840550147,1840741000,'Gemini'],
  [1840741000,1840926225,'Cancer'],
  [1840926225,1841106682,'Leo'],
  [1841106682,1841285407,'Virgo'],
  [1841285407,1841467666,'Libra'],
  [1841467666,1841659351,'Scorpio'],
  [1841659351,1841864046,'Sagittarius'],
  [1841864046,1842079670,'Capricorn'],
  [1842079670,1842298149,'Aquarius'],
  [1842298149,1842510617,'Pisces'],
  [1842510617,1842713049,'Aries'],
  [1842713049,1842906507,'Taurus'],
  [1842906507,1843094072,'Gemini'],
  [1843094072,1843278400,'Cancer'],
  [1843278400,1843461238,'Leo'],
  [1843461238,1843644394,'Virgo'],
  [1843644394,1843830749,'Libra'],
  [1843830749,1844024151,'Scorpio'],
  [1844024151,1844227823,'Sagittarius'],
  [1844227823,1844441587,'Capricorn'],
  [1844441587,1844659938,'Aquarius'],
  [1844659938,1844874120,'Pisces'],
  [1844874120,1845077667,'Aries'],
  [1845077667,1845269652,'Taurus'],
  [1845269652,1845453287,'Gemini'],
  [1845453287,1845633184,'Cancer'],
  [1845633184,1845813526,'Leo'],
  [1845813526,1845997400,'Virgo'],
  [1845997400,1846186934,'Libra'],
  [1846186934,1846383722,'Scorpio'],
  [1846383722,1846588920,'Sagittarius'],
  [1846588920,1846802293,'Capricorn'],
  [1846802293,1847020504,'Aquarius'],
  [1847020504,1847236771,'Pisces'],
  [1847236771,1847443675,'Aries'],
  [1847443675,1847637556,'Taurus'],
  [1847637556,1847819885,'Gemini'],
  [1847819885,1847995539,'Cancer'],
  [1847995539,1848170591,'Leo'],
  [1848170591,1848350616,'Virgo'],
  [1848350616,1848539391,'Libra'],
  [1848539391,1848738116,'Scorpio'],
  [1848738116,1848945729,'Sagittarius'],
  [1848945729,1849160090,'Capricorn'],
  [1849160090,1849378296,'Aquarius'],
  [1849378296,1849595887,'Pisces'],
  [1849595887,1849806686,'Aries'],
  [1849806686,1850005279,'Taurus'],
  [1850005279,1850190303,'Gemini'],
  [1850190303,1850365058,'Cancer'],
  [1850365058,1850535903,'Leo'],
  [1850535903,1850710148,'Virgo'],
  [1850710148,1850894113,'Libra'],
  [1850894113,1851090977,'Scorpio'],
  [1851090977,1851299441,'Sagittarius'],
  [1851299441,1851515129,'Capricorn'],
  [1851515129,1851733547,'Aquarius'],
  [1851733547,1851951168,'Pisces'],
  [1851951168,1852164172,'Aries'],
  [1852164172,1852367785,'Taurus'],
  [1852367785,1852558496,'Gemini'],
  [1852558496,1852736752,'Cancer'],
  [1852736752,1852907384,'Leo'],
  [1852907384,1853077826,'Virgo'],
  [1853077826,1853255940,'Libra'],
  [1853255940,1853447572,'Scorpio'],
  [1853447572,1853653640,'Sagittarius'],
  [1853653640,1853869446,'Capricorn'],
  [1853869446,1854088172,'Aquarius'],
  [1854088172,1854305027,'Pisces'],
  [1854305027,1854517566,'Aries'],
  [1854517566,1854723381,'Taurus'],
  [1854723381,1854919385,'Gemini'],
  [1854919385,1855103853,'Cancer'],
  [1855103853,1855278785,'Leo'],
  [1855278785,1855449936,'Virgo'],
  [1855449936,1855624970,'Libra'],
  [1855624970,1855811153,'Scorpio'],
  [1855811153,1856012285,'Sagittarius'],
  [1856012285,1856225939,'Capricorn'],
  [1856225939,1856444604,'Aquarius'],
  [1856444604,1856660966,'Pisces'],
  [1856660966,1856871609,'Aries'],
  [1856871609,1857075837,'Taurus'],
  [1857075837,1857273054,'Gemini'],
  [1857273054,1857462164,'Cancer'],
  [1857462164,1857643272,'Leo'],
  [1857643272,1857819353,'Virgo'],
  [1857819353,1857996052,'Libra'],
  [1857996052,1858180070,'Scorpio'],
  [1858180070,1858376678,'Sagittarius'],
  [1858376678,1858586564,'Capricorn'],
  [1858586564,1858804228,'Aquarius'],
  [1858804228,1859020985,'Pisces'],
  [1859020985,1859230680,'Aries'],
  [1859230680,1859431897,'Taurus'],
  [1859431897,1859625956,'Gemini'],
  [1859625956,1859814480,'Cancer'],
  [1859814480,1859998687,'Leo'],
  [1859998687,1860180212,'Virgo'],
  [1860180212,1860362012,'Libra'],
  [1860362012,1860548373,'Scorpio'],
  [1860548373,1860743756,'Sagittarius'],
  [1860743756,1860950531,'Capricorn'],
  [1860950531,1861166405,'Aquarius'],
  [1861166405,1861384050,'Pisces'],
  [1861384050,1861595134,'Aries'],
  [1861595134,1861795406,'Taurus'],
  [1861795406,1861985644,'Gemini'],
  [1861985644,1862169440,'Cancer'],
  [1862169440,1862350888,'Leo'],
  [1862350888,1862533331,'Virgo'],
  [1862533331,1862719129,'Libra'],
  [1862719129,1862910082,'Scorpio'],
  [1862910082,1863107965,'Sagittarius'],
  [1863107965,1863314297,'Capricorn'],
  [1863314297,1863528720,'Aquarius'],
  [1863528720,1863746936,'Pisces'],
  [1863746936,1863961047,'Aries'],
  [1863961047,1864163979,'Taurus'],
  [1864163979,1864353735,'Gemini'],
  [1864353735,1864533486,'Cancer'],
  [1864533486,1864709139,'Leo'],
  [1864709139,1864886860,'Virgo'],
  [1864886860,1865071269,'Libra'],
  [1865071269,1865264344,'Scorpio'],
  [1865264344,1865465691,'Sagittarius'],
  [1865465691,1865674109,'Capricorn'],
  [1865674109,1865888527,'Aquarius'],
  [1865888527,1866106766,'Pisces'],
  [1866106766,1866323527,'Aries'],
  [1866323527,1866531287,'Taurus'],
  [1866531287,1866724923,'Gemini'],
  [1866724923,1866905014,'Cancer'],
  [1866905014,1867077071,'Leo'],
  [1867077071,1867248699,'Virgo'],
  [1867248699,1867427113,'Libra'],
  [1867427113,1867616961,'Scorpio'],
  [1867616961,1867818657,'Sagittarius'],
  [1867818657,1868029154,'Capricorn'],
  [1868029154,1868244820,'Aquarius'],
  [1868244820,1868463021,'Pisces'],
  [1868463021,1868680667,'Aries'],
  [1868680667,1868892307,'Taurus'],
  [1868892307,1869091832,'Gemini'],
  [1869091832,1869276731,'Cancer'],
  [1869276731,1869450134,'Leo'],
  [1869450134,1869619093,'Virgo'],
  [1869619093,1869791795,'Libra'],
  [1869791795,1869975255,'Scorpio'],
  [1869975255,1870172788,'Sagittarius'],
  [1870172788,1870382488,'Capricorn'],
  [1870382488,1870599035,'Aquarius'],
  [1870599035,1870817453,'Pisces'],
  [1870817453,1871034550,'Aries'],
  [1871034550,1871247111,'Taurus'],
  [1871247111,1871450717,'Gemini'],
  [1871450717,1871641752,'Cancer'],
  [1871641752,1871820503,'Leo'],
  [1871820503,1871991751,'Virgo'],
  [1871991751,1872162832,'Libra'],
  [1872162832,1872341362,'Scorpio'],
  [1872341362,1872532935,'Sagittarius'],
  [1872532935,1872738607,'Capricorn'],
  [1872738607,1872954110,'Aquarius'],
  [1872954110,1873172640,'Pisces'],
  [1873172640,1873388921,'Aries'],
  [1873388921,1873600039,'Taurus'],
  [1873600039,1873803863,'Gemini'],
  [1873803863,1873998335,'Cancer'],
  [1873998335,1874182800,'Leo'],
  [1874182800,1874359518,'Virgo'],
  [1874359518,1874533538,'Libra'],
  [1874533538,1874711321,'Scorpio'],
  [1874711321,1874898932,'Sagittarius'],
  [1874898932,1875099767,'Capricorn'],
  [1875099767,1875312370,'Aquarius'],
  [1875312370,1875530419,'Pisces'],
  [1875530419,1875746461,'Aries'],
  [1875746461,1875955827,'Taurus'],
  [1875955827,1876157108,'Gemini'],
  [1876157108,1876350631,'Cancer'],
  [1876350631,1876537332,'Leo'],
  [1876537332,1876718862,'Virgo'],
  [1876718862,1876898064,'Libra'],
  [1876898064,1877079029,'Scorpio'],
  [1877079029,1877266498,'Sagittarius'],
  [1877266498,1877464450,'Capricorn'],
  [1877464450,1877673894,'Aquarius'],
  [1877673894,1877890881,'Pisces'],
  [1877890881,1878107493,'Aries'],
  [1878107493,1878316571,'Taurus'],
  [1878316571,1878515355,'Gemini'],
  [1878515355,1878705256,'Cancer'],
  [1878705256,1878889629,'Leo'],
  [1878889629,1879071872,'Virgo'],
  [1879071872,1879254659,'Libra'],
  [1879254659,1879440149,'Scorpio'],
  [1879440149,1879630649,'Sagittarius'],
  [1879630649,1879828827,'Capricorn'],
  [1879828827,1880036551,'Aquarius'],
  [1880036551,1880252419,'Pisces'],
  [1880252419,1880470118,'Aries'],
  [1880470118,1880681004,'Taurus'],
  [1880681004,1880879698,'Gemini'],
  [1880879698,1881066669,'Cancer'],
  [1881066669,1881246527,'Leo'],
  [1881246527,1881425041,'Virgo'],
  [1881425041,1881606889,'Libra'],
  [1881606889,1881794546,'Scorpio'],
  [1881794546,1881988624,'Sagittarius'],
  [1881988624,1882189362,'Capricorn'],
  [1882189362,1882397471,'Aquarius'],
  [1882397471,1882612772,'Pisces'],
  [1882612772,1882831445,'Aries'],
  [1882831445,1883045500,'Taurus'],
  [1883045500,1883247262,'Gemini'],
  [1883247262,1883434630,'Cancer'],
  [1883434630,1883611534,'Leo'],
  [1883611534,1883784922,'Virgo'],
  [1883784922,1883961774,'Libra'],
  [1883961774,1884146910,'Scorpio'],
  [1884146910,1884341713,'Sagittarius'],
  [1884341713,1884544925,'Capricorn'],
  [1884544925,1884754871,'Aquarius'],
  [1884754871,1884970458,'Pisces'],
  [1884970458,1885189483,'Aries'],
  [1885189483,1885406257,'Taurus'],
  [1885406257,1885612903,'Gemini'],
  [1885612903,1885804559,'Cancer'],
  [1885804559,1885982676,'Leo'],
  [1885982676,1886153523,'Virgo'],
  [1886153523,1886325004,'Libra'],
  [1886325004,1886504194,'Scorpio'],
  [1886504194,1886695195,'Sagittarius'],
  [1886695195,1886897910,'Capricorn'],
  [1886897910,1887109269,'Aquarius'],
  [1887109269,1887325773,'Pisces'],
  [1887325773,1887544613,'Aries'],
  [1887544613,1887762086,'Taurus'],
  [1887762086,1887972425,'Gemini'],
  [1887972425,1888170075,'Cancer'],
  [1888170075,1888353581,'Leo'],
  [1888353581,1888526722,'Virgo'],
  [1888526722,1888696455,'Libra'],
  [1888696455,1888870464,'Scorpio'],
  [1888870464,1889055124,'Sagittarius'],
  [1889055124,1889253379,'Capricorn'],
  [1889253379,1889463568,'Aquarius'],
  [1889463568,1889680668,'Pisces'],
  [1889680668,1889899378,'Aries'],
  [1889899378,1890115738,'Taurus'],
  [1890115738,1890326287,'Gemini'],
  [1890326287,1890527551,'Cancer'],
  [1890527551,1890717351,'Leo'],
  [1890717351,1890896662,'Virgo'],
  [1890896662,1891069786,'Libra'],
  [1891069786,1891243050,'Scorpio'],
  [1891243050,1891423188,'Sagittarius'],
  [1891423188,1891615491,'Capricorn'],
  [1891615491,1891821528,'Aquarius'],
  [1891821528,1892037617,'Pisces'],
  [1892037617,1892256510,'Aries'],
  [1892256510,1892471723,'Taurus'],
  [1892471723,1892679889,'Gemini'],
  [1892679889,1892880083,'Cancer'],
  [1892880083,1893072330,'Leo'],
  [1893072330,1893257269,'Virgo'],
  [1893257269,1893436714,'Libra'],
  [1893436714,1893614136,'Scorpio'],
  [1893614136,1893794525,'Sagittarius'],
  [1893794525,1893983390,'Capricorn'],
  [1893983390,1894184719,'Aquarius'],
  [1894184719,1894398045,'Pisces'],
  [1894398045,1894616937,'Aries'],
  [1894616937,1894832416,'Taurus'],
  [1894832416,1895038707,'Gemini'],
  [1895038707,1895235273,'Cancer'],
  [1895235273,1895424738,'Leo'],
  [1895424738,1895610141,'Virgo'],
  [1895610141,1895793627,'Libra'],
  [1895793627,1895976691,'Scorpio'],
  [1895976691,1896161416,'Sagittarius'],
  [1896161416,1896351313,'Capricorn'],
  [1896351313,1896550505,'Aquarius'],
  [1896550505,1896761005,'Pisces'],
  [1896761005,1896979298,'Aries'],
  [1896979298,1897196345,'Taurus'],
  [1897196345,1897403454,'Gemini'],
  [1897403454,1897597940,'Cancer'],
  [1897597940,1897782950,'Leo'],
  [1897782950,1897963933,'Virgo'],
  [1897963933,1898145623,'Libra'],
  [1898145623,1898330579,'Scorpio'],
  [1898330579,1898519562,'Sagittarius'],
  [1898519562,1898713346,'Capricorn'],
  [1898713346,1898913940,'Aquarius'],
  [1898913940,1899123491,'Pisces'],
  [1899123491,1899341010,'Aries'],
  [1899341010,1899559784,'Taurus'],
  [1899559784,1899770135,'Gemini'],
  [1899770135,1899966302,'Cancer'],
  [1899966302,1900149584,'Leo'],
  [1900149584,1900325871,'Virgo'],
  [1900325871,1900501981,'Libra'],
  [1900501981,1900683183,'Scorpio'],
  [1900683183,1900871927,'Sagittarius'],
  [1900871927,1901068309,'Capricorn'],
  [1901068309,1901271869,'Aquarius'],
  [1901271869,1901482664,'Pisces'],
  [1901482664,1901700017,'Aries'],
  [1901700017,1901919729,'Taurus'],
  [1901919729,1902133703,'Gemini'],
  [1902133703,1902334492,'Cancer'],
  [1902334492,1902520407,'Leo'],
  [1902520407,1902695687,'Virgo'],
  [1902695687,1902867356,'Libra'],
  [1902867356,1903042448,'Scorpio'],
  [1903042448,1903226166,'Sagittarius'],
  [1903226166,1903420715,'Capricorn'],
  [1903420715,1903625415,'Aquarius'],
  [1903625415,1903838038,'Pisces'],
  [1903838038,1904056013,'Aries'],
  [1904056013,1904275801,'Taurus'],
  [1904275801,1904491738,'Gemini'],
  [1904491738,1904697282,'Cancer'],
  [1904697282,1904888715,'Leo'],
  [1904888715,1905067467,'Virgo'],
  [1905067467,1905238943,'Libra'],
  [1905238943,1905410138,'Scorpio'],
  [1905410138,1905587801,'Sagittarius'],
  [1905587801,1905776876,'Capricorn'],
  [1905776876,1905978988,'Aquarius'],
  [1905978988,1906191805,'Pisces'],
  [1906191805,1906410487,'Aries'],
  [1906410487,1906629974,'Taurus'],
  [1906629974,1906845688,'Gemini'],
  [1906845688,1907053427,'Cancer'],
  [1907053427,1907249937,'Leo'],
  [1907249937,1907434595,'Virgo'],
  [1907434595,1907610133,'Libra'],
  [1907610133,1907781851,'Scorpio'],
  [1907781851,1907956299,'Sagittarius'],
  [1907956299,1908139858,'Capricorn'],
  [1908139858,1908336869,'Aquarius'],
  [1908336869,1908547255,'Pisces'],
  [1908547255,1908765758,'Aries'],
  [1908765758,1908984994,'Taurus'],
  [1908984994,1909199344,'Gemini'],
  [1909199344,1909406119,'Cancer'],
  [1909406119,1909604318,'Leo'],
  [1909604318,1909793665,'Virgo'],
  [1909793665,1909975021,'Libra'],
  [1909975021,1910151092,'Scorpio'],
  [1910151092,1910326632,'Sagittarius'],
  [1910326632,1910507734,'Capricorn'],
  [1910507734,1910700169,'Aquarius'],
  [1910700169,1910906583,'Pisces'],
  [1910906583,1911123608,'Aries'],
  [1911123608,1911342784,'Taurus'],
  [1911342784,1911556159,'Gemini'],
  [1911556159,1911760515,'Cancer'],
  [1911760515,1911956677,'Leo'],
  [1911956677,1912146598,'Virgo'],
  [1912146598,1912331676,'Libra'],
  [1912331676,1912513044,'Scorpio'],
  [1912513044,1912692940,'Sagittarius'],
  [1912692940,1912875561,'Capricorn'],
  [1912875561,1913066325,'Aquarius'],
  [1913066325,1913269441,'Pisces'],
  [1913269441,1913484260,'Aries'],
  [1913484260,1913703479,'Taurus'],
  [1913703479,1913917302,'Gemini'],
  [1913917302,1914120264,'Cancer'],
  [1914120264,1914313094,'Leo'],
  [1914313094,1914499694,'Virgo'],
  [1914499694,1914683792,'Libra'],
  [1914683792,1914867462,'Scorpio'],
  [1914867462,1915051756,'Sagittarius'],
  [1915051756,1915238462,'Capricorn'],
  [1915238462,1915430975,'Aquarius'],
  [1915430975,1915633156,'Pisces'],
  [1915633156,1915846212,'Aries'],
  [1915846212,1916065406,'Taurus'],
  [1916065406,1916281113,'Gemini'],
  [1916281113,1916485356,'Cancer'],
  [1916485356,1916676772,'Leo'],
  [1916676772,1916859373,'Virgo'],
  [1916859373,1917038822,'Libra'],
  [1917038822,1917219733,'Scorpio'],
  [1917219733,1917404611,'Sagittarius'],
  [1917404611,1917594518,'Capricorn'],
  [1917594518,1917790550,'Aquarius'],
  [1917790550,1917994402,'Pisces'],
  [1917994402,1918207099,'Aries'],
  [1918207099,1918426123,'Taurus'],
  [1918426123,1918644053,'Gemini'],
  [1918644053,1918852079,'Cancer'],
  [1918852079,1919045886,'Leo'],
  [1919045886,1919227495,'Virgo'],
  [1919227495,1919402643,'Libra'],
  [1919402643,1919577783,'Scorpio'],
  [1919577783,1919758177,'Sagittarius'],
  [1919758177,1919946887,'Capricorn'],
  [1919946887,1920144775,'Aquarius'],
  [1920144775,1920351279,'Pisces'],
  [1920351279,1920565164,'Aries'],
  [1920565164,1920784078,'Taurus'],
  [1920784078,1921003124,'Gemini'],
  [1921003124,1921215223,'Cancer'],
  [1921215223,1921414470,'Leo'],
  [1921414470,1921599727,'Virgo'],
  [1921599727,1921774699,'Libra'],
  [1921774699,1921945729,'Scorpio'],
  [1921945729,1922119747,'Sagittarius'],
  [1922119747,1922302688,'Capricorn'],
  [1922302688,1922497907,'Aquarius'],
  [1922497907,1922705025,'Pisces'],
  [1922705025,1922920483,'Aries'],
  [1922920483,1923139711,'Taurus'],
  [1923139711,1923358393,'Gemini'],
  [1923358393,1923572158,'Cancer'],
  [1923572158,1923776442,'Leo'],
  [1923776442,1923968228,'Virgo'],
  [1923968228,1924148001,'Libra'],
  [1924148001,1924319921,'Scorpio'],
  [1924319921,1924490565,'Sagittarius'],
  [1924490565,1924667274,'Capricorn'],
  [1924667274,1924856266,'Aquarius'],
  [1924856266,1925060006,'Pisces'],
  [1925060006,1925275277,'Aries'],
  [1925275277,1925495036,'Taurus'],
  [1925495036,1925712929,'Gemini'],
  [1925712929,1925925527,'Cancer'],
  [1925925527,1926131023,'Leo'],
  [1926131023,1926327638,'Virgo'],
  [1926327638,1926514170,'Libra'],
  [1926514170,1926691647,'Scorpio'],
  [1926691647,1926864290,'Sagittarius'],
  [1926864290,1927038772,'Capricorn'],
  [1927038772,1927222410,'Aquarius'],
  [1927222410,1927420494,'Pisces'],
  [1927420494,1927632757,'Aries'],
  [1927632757,1927852257,'Taurus'],
  [1927852257,1928069986,'Gemini'],
  [1928069986,1928280739,'Cancer'],
  [1928280739,1928483886,'Leo'],
  [1928483886,1928680355,'Virgo'],
  [1928680355,1928870409,'Libra'],
  [1928870409,1929053920,'Scorpio'],
  [1929053920,1929232267,'Sagittarius'],
  [1929232267,1929409624,'Capricorn'],
  [1929409624,1929592265,'Aquarius'],
  [1929592265,1929786357,'Pisces'],
  [1929786357,1929994480,'Aries'],
  [1929994480,1930212387,'Taurus'],
  [1930212387,1930430546,'Gemini'],
  [1930430546,1930640948,'Cancer'],
  [1930640948,1930841497,'Leo'],
  [1930841497,1931034373,'Virgo'],
  [1931034373,1931222482,'Libra'],
  [1931222482,1931407532,'Scorpio'],
  [1931407532,1931590431,'Sagittarius'],
  [1931590431,1931772976,'Capricorn'],
  [1931772976,1931958861,'Aquarius'],
  [1931958861,1932152910,'Pisces'],
  [1932152910,1932358564,'Aries'],
  [1932358564,1932574445,'Taurus'],
  [1932574445,1932793061,'Gemini'],
  [1932793061,1933005062,'Cancer'],
  [1933005062,1933205525,'Leo'],
  [1933205525,1933395457,'Virgo'],
  [1933395457,1933578974,'Libra'],
  [1933578974,1933760363,'Scorpio'],
  [1933760363,1933942699,'Sagittarius'],
  [1933942699,1934127974,'Capricorn'],
  [1934127974,1934318018,'Aquarius'],
  [1934318018,1934515072,'Pisces'],
  [1934515072,1934721161,'Aries'],
  [1934721161,1934935985,'Taurus'],
  [1934935985,1935154806,'Gemini'],
  [1935154806,1935369375,'Cancer'],
  [1935369375,1935572695,'Leo'],
  [1935572695,1935763070,'Virgo'],
  [1935763070,1935943661,'Libra'],
  [1935943661,1936119880,'Scorpio'],
  [1936119880,1936297265,'Sagittarius'],
  [1936297265,1936480193,'Capricorn'],
  [1936480193,1936671246,'Aquarius'],
  [1936671246,1936871195,'Pisces'],
  [1936871195,1937079545,'Aries'],
  [1937079545,1937294811,'Taurus'],
  [1937294811,1937513683,'Gemini'],
  [1937513683,1937730358,'Cancer'],
  [1937730358,1937937957,'Leo'],
  [1937937957,1938132258,'Virgo'],
  [1938132258,1938313904,'Libra'],
  [1938313904,1938487501,'Scorpio'],
  [1938487501,1938659593,'Sagittarius'],
  [1938659593,1938836830,'Capricorn'],
  [1938836830,1939024314,'Aquarius'],
  [1939024314,1939223957,'Pisces'],
  [1939223957,1939433965,'Aries'],
  [1939433965,1939650471,'Taurus'],
  [1939650471,1939869437,'Gemini'],
  [1939869437,1940086824,'Cancer'],
  [1940086824,1940297770,'Leo'],
  [1940297770,1940497438,'Virgo'],
  [1940497438,1940683786,'Libra'],
  [1940683786,1940859062,'Scorpio'],
  [1940859062,1941029071,'Sagittarius'],
  [1941029071,1941201280,'Capricorn'],
  [1941201280,1941382878,'Aquarius'],
  [1941382878,1941578412,'Pisces'],
  [1941578412,1941787370,'Aries'],
  [1941787370,1942004523,'Taurus'],
  [1942004523,1942223652,'Gemini'],
  [1942223652,1942440502,'Cancer'],
  [1942440502,1942652229,'Leo'],
  [1942652229,1942855653,'Virgo'],
  [1942855653,1943047805,'Libra'],
  [1943047805,1943228275,'Scorpio'],
  [1943228275,1943400606,'Sagittarius'],
  [1943400606,1943571438,'Capricorn'],
  [1943571438,1943748553,'Aquarius'],
  [1943748553,1943938529,'Pisces'],
  [1943938529,1944143593,'Aries'],
  [1944143593,1944359623,'Taurus'],
  [1944359623,1944578755,'Gemini'],
  [1944578755,1944794745,'Cancer'],
  [1944794745,1945005020,'Leo'],
  [1945005020,1945208603,'Virgo'],
  [1945208603,1945404085,'Libra'],
  [1945404085,1945590193,'Scorpio'],
  [1945590193,1945767953,'Sagittarius'],
  [1945767953,1945941730,'Capricorn'],
  [1945941730,1946118228,'Aquarius'],
  [1946118228,1946304459,'Pisces'],
  [1946304459,1946504836,'Aries'],
  [1946504836,1946717992,'Taurus'],
  [1946717992,1946936629,'Gemini'],
  [1946936629,1947152379,'Cancer'],
  [1947152379,1947360880,'Leo'],
  [1947360880,1947561837,'Virgo'],
  [1947561837,1947756224,'Libra'],
  [1947756224,1947944501,'Scorpio'],
  [1947944501,1948127164,'Sagittarius'],
  [1948127164,1948306300,'Capricorn'],
  [1948306300,1948486202,'Aquarius'],
  [1948486202,1948672488,'Pisces'],
  [1948672488,1948870029,'Aries'],
  [1948870029,1949079947,'Taurus'],
  [1949079947,1949297487,'Gemini'],
  [1949297487,1949513961,'Cancer'],
  [1949513961,1949722378,'Leo'],
  [1949722378,1949920863,'Virgo'],
  [1949920863,1950111347,'Libra'],
  [1950111347,1950296846,'Scorpio'],
  [1950296846,1950479927,'Sagittarius'],
  [1950479927,1950662684,'Capricorn'],
  [1950662684,1950847453,'Aquarius'],
  [1950847453,1951037245,'Pisces'],
  [1951037245,1951235297,'Aries'],
  [1951235297,1951443427,'Taurus'],
  [1951443427,1951659657,'Gemini'],
  [1951659657,1951877315,'Cancer'],
  [1951877315,1952088052,'Leo'],
  [1952088052,1952287009,'Virgo'],
  [1952287009,1952474706,'Libra'],
  [1952474706,1952655225,'Scorpio'],
  [1952655225,1952833749,'Sagittarius'],
  [1952833749,1953014830,'Capricorn'],
  [1953014830,1953201492,'Aquarius'],
  [1953201492,1953395163,'Pisces'],
  [1953395163,1953596327,'Aries'],
  [1953596327,1953805113,'Taurus'],
  [1953805113,1954020591,'Gemini'],
  [1954020591,1954238982,'Cancer'],
  [1954238982,1954453197,'Leo'],
  [1954453197,1954656151,'Virgo'],
  [1954656151,1954845220,'Libra'],
  [1954845220,1955023188,'Scorpio'],
  [1955023188,1955196214,'Sagittarius'],
  [1955196214,1955371307,'Capricorn'],
  [1955371307,1955554273,'Aquarius'],
  [1955554273,1955747949,'Pisces'],
  [1955747949,1955951630,'Aries'],
  [1955951630,1956162672,'Taurus'],
  [1956162672,1956378571,'Gemini'],
  [1956378571,1956596918,'Cancer'],
  [1956596918,1956813439,'Leo'],
  [1956813439,1957021594,'Virgo'],
  [1957021594,1957216074,'Libra'],
  [1957216074,1957396527,'Scorpio'],
  [1957396527,1957567837,'Sagittarius'],
  [1957567837,1957737672,'Capricorn'],
  [1957737672,1957913952,'Aquarius'],
  [1957913952,1958102509,'Pisces'],
  [1958102509,1958304639,'Aries'],
  [1958304639,1958516838,'Taurus'],
  [1958516838,1958733895,'Gemini'],
  [1958733895,1958952027,'Cancer'],
  [1958952027,1959168565,'Leo'],
  [1959168565,1959379595,'Virgo'],
  [1959379595,1959580000,'Libra'],
  [1959580000,1959766731,'Scorpio'],
  [1959766731,1959941652,'Sagittarius'],
  [1959941652,1960111004,'Capricorn'],
  [1960111004,1960282893,'Aquarius'],
  [1960282893,1960464929,'Pisces'],
  [1960464929,1960661528,'Aries'],
  [1960661528,1960871480,'Taurus'],
  [1960871480,1961088801,'Gemini'],
  [1961088801,1961307038,'Cancer'],
  [1961307038,1961522411,'Leo'],
  [1961522411,1961732772,'Virgo'],
  [1961732772,1961935493,'Libra'],
  [1961935493,1962127787,'Scorpio'],
  [1962127787,1962309154,'Sagittarius'],
  [1962309154,1962482966,'Capricorn'],
  [1962482966,1962655594,'Aquarius'],
  [1962655594,1962834387,'Pisces'],
  [1962834387,1963025380,'Aries'],
  [1963025380,1963230535,'Taurus'],
  [1963230535,1963446039,'Gemini'],
  [1963446039,1963664337,'Cancer'],
  [1963664337,1963879010,'Leo'],
  [1963879010,1964087136,'Virgo'],
  [1964087136,1964287980,'Libra'],
  [1964287980,1964481236,'Scorpio'],
  [1964481236,1964666953,'Sagittarius'],
  [1964666953,1964846672,'Capricorn'],
  [1964846672,1965024064,'Aquarius'],
  [1965024064,1965204429,'Pisces'],
  [1965204429,1965393298,'Aries'],
  [1965393298,1965594304,'Taurus'],
  [1965594304,1965806719,'Gemini'],
  [1965806719,1966024548,'Cancer'],
  [1966024548,1966239651,'Leo'],
  [1966239651,1966446590,'Virgo'],
  [1966446590,1966644240,'Libra'],
  [1966644240,1966834293,'Scorpio'],
  [1966834293,1967019288,'Sagittarius'],
  [1967019288,1967201679,'Capricorn'],
  [1967201679,1967383892,'Aquarius'],
  [1967383892,1967568715,'Pisces'],
  [1967568715,1967759468,'Aries'],
  [1967759468,1967959296,'Taurus'],
  [1967959296,1968169313,'Gemini'],
  [1968169313,1968386312,'Cancer'],
  [1968386312,1968602713,'Leo'],
  [1968602713,1968810746,'Virgo'],
  [1968810746,1969007032,'Libra'],
  [1969007032,1969193241,'Scorpio'],
  [1969193241,1969373897,'Sagittarius'],
  [1969373897,1969553909,'Capricorn'],
  [1969553909,1969737015,'Aquarius'],
  [1969737015,1969925288,'Pisces'],
  [1969925288,1970119730,'Aries'],
  [1970119730,1970321305,'Taurus'],
  [1970321305,1970530869,'Gemini'],
  [1970530869,1970747254,'Cancer'],
  [1970747254,1970965124,'Leo'],
  [1970965124,1971176169,'Virgo'],
  [1971176169,1971374302,'Libra'],
  [1971374302,1971559287,'Scorpio'],
  [1971559287,1971735845,'Sagittarius'],
  [1971735845,1971910698,'Capricorn'],
  [1971910698,1972090008,'Aquarius'],
  [1972090008,1972277560,'Pisces'],
  [1972277560,1972474053,'Aries'],
  [1972474053,1972678304,'Taurus'],
  [1972678304,1972889155,'Gemini'],
  [1972889155,1973105554,'Cancer'],
  [1973105554,1973324352,'Leo'],
  [1973324352,1973538782,'Virgo'],
  [1973538782,1973741329,'Libra'],
  [1973741329,1973928941,'Scorpio'],
  [1973928941,1974104724,'Sagittarius'],
  [1974104724,1974275588,'Capricorn'],
  [1974275588,1974449261,'Aquarius'],
  [1974449261,1974631980,'Pisces'],
  [1974631980,1974826500,'Aries'],
  [1974826500,1975031596,'Taurus'],
  [1975031596,1975244059,'Gemini'],
  [1975244059,1975461050,'Cancer'],
  [1975461050,1975679981,'Leo'],
  [1975679981,1975896341,'Virgo'],
  [1975896341,1976103537,'Libra'],
  [1976103537,1976296584,'Scorpio'],
  [1976296584,1976475812,'Sagittarius'],
  [1976475812,1976646604,'Capricorn'],
  [1976646604,1976816667,'Aquarius'],
  [1976816667,1976993610,'Pisces'],
  [1976993610,1977182764,'Aries'],
  [1977182764,1977385197,'Taurus'],
  [1977385197,1977597707,'Gemini'],
  [1977597707,1977815324,'Cancer'],
  [1977815324,1978033933,'Leo'],
  [1978033933,1978250049,'Virgo'],
  [1978250049,1978459398,'Libra'],
  [1978459398,1978657584,'Scorpio'],
  [1978657584,1978842874,'Sagittarius'],
  [1978842874,1979017926,'Capricorn'],
  [1979017926,1979188750,'Aquarius'],
  [1979188750,1979362646,'Pisces'],
  [1979362646,1979546268,'Aries'],
  [1979546268,1979743457,'Taurus'],
  [1979743457,1979953387,'Gemini'],
  [1979953387,1980170803,'Cancer'],
  [1980170803,1980389198,'Leo'],
  [1980389198,1980603871,'Virgo'],
  [1980603871,1980812021,'Libra'],
  [1980812021,1981011710,'Scorpio'],
  [1981011710,1981201805,'Sagittarius'],
  [1981201805,1981383076,'Capricorn'],
  [1981383076,1981558803,'Aquarius'],
  [1981558803,1981734260,'Pisces'],
  [1981734260,1981915545,'Aries'],
  [1981915545,1982107924,'Taurus'],
  [1982107924,1982313545,'Gemini'],
  [1982313545,1982529350,'Cancer'],
  [1982529350,1982747862,'Leo'],
  [1982747862,1982961713,'Virgo'],
  [1982961713,1983167229,'Libra'],
  [1983167229,1983364316,'Scorpio'],
  [1983364316,1983554459,'Sagittarius'],
  [1983554459,1983739354,'Capricorn'],
  [1983739354,1983920827,'Aquarius'],
  [1983920827,1984101420,'Pisces'],
  [1984101420,1984284871,'Aries'],
  [1984284871,1984475751,'Taurus'],
  [1984475751,1984677801,'Gemini'],
  [1984677801,1984891053,'Cancer'],
  [1984891053,1985109680,'Leo'],
  [1985109680,1985324474,'Virgo'],
  [1985324474,1985528953,'Libra'],
  [1985528953,1985722463,'Scorpio'],
  [1985722463,1985908468,'Sagittarius'],
  [1985908468,1986091399,'Capricorn'],
  [1986091399,1986274574,'Aquarius'],
  [1986274574,1986459710,'Pisces'],
  [1986459710,1986647940,'Aries'],
  [1986647940,1986841268,'Taurus'],
  [1986841268,1987042659,'Gemini'],
  [1987042659,1987253922,'Cancer'],
  [1987253922,1987472270,'Leo'],
  [1987472270,1987689293,'Virgo'],
  [1987689293,1987895914,'Libra'],
  [1987895914,1988088715,'Scorpio'],
  [1988088715,1988270769,'Sagittarius'],
  [1988270769,1988448314,'Capricorn'],
  [1988448314,1988627430,'Aquarius'],
  [1988627430,1988811962,'Pisces'],
  [1988811962,1989002961,'Aries'],
  [1989002961,1989200138,'Taurus'],
  [1989200138,1989403814,'Gemini'],
  [1989403814,1989615006,'Cancer'],
  [1989615006,1989832891,'Leo'],
  [1989832891,1990051832,'Virgo'],
  [1990051832,1990262669,'Libra'],
  [1990262669,1990458955,'Scorpio'],
  [1990458955,1990641152,'Sagittarius'],
  [1990641152,1990815055,'Capricorn'],
  [1990815055,1990988167,'Aquarius'],
  [1990988167,1991167013,'Pisces'],
  [1991167013,1991355298,'Aries'],
  [1991355298,1991553365,'Taurus'],
  [1991553365,1991759625,'Gemini'],
  [1991759625,1991972458,'Cancer'],
  [1991972458,1992190367,'Leo'],
  [1992190367,1992409849,'Virgo'],
  [1992409849,1992624116,'Libra'],
  [1992624116,1992826009,'Scorpio'],
  [1992826009,1993012891,'Sagittarius'],
  [1993012891,1993188067,'Capricorn'],
  [1993188067,1993358359,'Aquarius'],
  [1993358359,1993531292,'Pisces'],
  [1993531292,1993713120,'Aries'],
  [1993713120,1993907143,'Taurus'],
  [1993907143,1994112894,'Gemini'],
  [1994112894,1994327068,'Cancer'],
  [1994327068,1994545620,'Leo'],
  [1994545620,1994764665,'Virgo'],
  [1994764665,1994979677,'Libra'],
  [1994979677,1995185502,'Scorpio'],
  [1995185502,1995378549,'Sagittarius'],
  [1995378549,1995559207,'Capricorn'],
  [1995559207,1995731820,'Aquarius'],
  [1995731820,1995902936,'Pisces'],
  [1995902936,1996079508,'Aries'],
  [1996079508,1996267253,'Taurus'],
  [1996267253,1996468741,'Gemini'],
  [1996468741,1996681878,'Cancer'],
  [1996681878,1996900843,'Leo'],
  [1996900843,1997119417,'Virgo'],
  [1997119417,1997333112,'Libra'],
  [1997333112,1997539136,'Scorpio'],
  [1997539136,1997735662,'Sagittarius'],
  [1997735662,1997922230,'Capricorn'],
  [1997922230,1998100559,'Aquarius'],
  [1998100559,1998274691,'Pisces'],
  [1998274691,1998450376,'Aries'],
  [1998450376,1998633873,'Taurus'],
  [1998633873,1998830085,'Gemini'],
  [1998830085,1999039837,'Cancer'],
  [1999039837,1999258108,'Leo'],
  [1999258108,1999476597,'Virgo'],
  [1999476597,1999688813,'Libra'],
  [1999688813,1999892473,'Scorpio'],
  [1999892473,2000088144,'Sagittarius'],
  [2000088144,2000277055,'Capricorn'],
  [2000277055,2000460404,'Aquarius'],
  [2000460404,2000639940,'Pisces'],
  [2000639940,2000818919,'Aries'],
  [2000818919,2001002279,'Taurus'],
  [2001002279,2001195413,'Gemini'],
  [2001195413,2001401484,'Cancer'],
  [2001401484,2001618057,'Leo'],
  [2001618057,2001836798,'Virgo'],
  [2001836798,2002048819,'Libra'],
  [2002048819,2002250261,'Scorpio'],
  [2002250261,2002442567,'Sagittarius'],
  [2002442567,2002629306,'Capricorn'],
  [2002629306,2002813478,'Aquarius'],
  [2002813478,2002996743,'Pisces'],
  [2002996743,2003180411,'Aries'],
  [2003180411,2003366994,'Taurus'],
  [2003366994,2003560506,'Gemini'],
  [2003560506,2003764690,'Cancer'],
  [2003764690,2003979531,'Leo'],
  [2003979531,2004198658,'Virgo'],
  [2004198658,2004412167,'Libra'],
  [2004412167,2004613627,'Scorpio'],
  [2004613627,2004803323,'Sagittarius'],
  [2004803323,2004985848,'Capricorn'],
  [2004985848,2005166476,'Aquarius'],
  [2005166476,2005348909,'Pisces'],
  [2005348909,2005534830,'Aries'],
  [2005534830,2005725149,'Taurus'],
  [2005725149,2005921517,'Gemini'],
  [2005921517,2006126309,'Cancer'],
  [2006126309,2006340375,'Leo'],
  [2006340375,2006559806,'Virgo'],
  [2006559806,2006775812,'Libra'],
  [2006775812,2006980063,'Scorpio'],
  [2006980063,2007170273,'Sagittarius'],
  [2007170273,2007350139,'Capricorn'],
  [2007350139,2007525917,'Aquarius'],
  [2007525917,2007703553,'Pisces'],
  [2007703553,2007887061,'Aries'],
  [2007887061,2008078168,'Taurus'],
  [2008078168,2008277213,'Gemini'],
  [2008277213,2008484209,'Cancer'],
  [2008484209,2008698793,'Leo'],
  [2008698793,2008918355,'Virgo'],
  [2008918355,2009136481,'Libra'],
  [2009136481,2009345069,'Scorpio'],
  [2009345069,2009539329,'Sagittarius'],
  [2009539329,2009720443,'Capricorn'],
  [2009720443,2009893812,'Aquarius'],
  [2009893812,2010066241,'Pisces'],
  [2010066241,2010243986,'Aries'],
  [2010243986,2010431382,'Taurus'],
  [2010431382,2010629978,'Gemini'],
  [2010629978,2010838606,'Cancer'],
  [2010838606,2011054480,'Leo'],
  [2011054480,2011274116,'Virgo'],
  [2011274116,2011492859,'Libra'],
  [2011492859,2011704811,'Scorpio'],
  [2011704811,2011904734,'Sagittarius'],
  [2011904734,2012091023,'Capricorn'],
  [2012091023,2012266532,'Aquarius'],
  [2012266532,2012437086,'Pisces'],
  [2012437086,2012609649,'Aries'],
  [2012609649,2012790789,'Taurus'],
  [2012790789,2012984906,'Gemini'],
  [2012984906,2013192314,'Cancer'],
  [2013192314,2013408920,'Leo'],
  [2013408920,2013628764,'Virgo'],
  [2013628764,2013846754,'Libra'],
  [2013846754,2014059152,'Scorpio'],
  [2014059152,2014262782,'Sagittarius'],
  [2014262782,2014455335,'Capricorn'],
  [2014455335,2014636849,'Aquarius'],
  [2014636849,2014810472,'Pisces'],
  [2014810472,2014981975,'Aries'],
  [2014981975,2015158442,'Taurus'],
  [2015158442,2015346471,'Gemini'],
  [2015346471,2015549435,'Cancer'],
  [2015549435,2015764739,'Leo'],
  [2015764739,2015984736,'Virgo'],
  [2015984736,2016201864,'Libra'],
  [2016201864,2016412367,'Scorpio'],
  [2016412367,2016615491,'Sagittarius'],
  [2016615491,2016811007,'Capricorn'],
  [2016811007,2016998478,'Aquarius'],
  [2016998478,2017178418,'Pisces'],
  [2017178418,2017353800,'Aries'],
  [2017353800,2017530221,'Taurus'],
  [2017530221,2017714543,'Gemini'],
  [2017714543,2017912346,'Cancer'],
  [2017912346,2018124222,'Leo'],
  [2018124222,2018343652,'Virgo'],
  [2018343652,2018560866,'Libra'],
  [2018560866,2018769705,'Scorpio'],
  [2018769705,2018969698,'Sagittarius'],
  [2018969698,2019163113,'Capricorn'],
  [2019163113,2019351820,'Aquarius'],
  [2019351820,2019536446,'Pisces'],
  [2019536446,2019717760,'Aries'],
  [2019717760,2019898522,'Taurus'],
  [2019898522,2020083756,'Gemini'],
  [2020083756,2020279073,'Cancer'],
  [2020279073,2020487389,'Leo'],
  [2020487389,2020705290,'Virgo'],
  [2020705290,2020923392,'Libra'],
  [2020923392,2021132821,'Scorpio'],
  [2021132821,2021330846,'Sagittarius'],
  [2021330846,2021520116,'Capricorn'],
  [2021520116,2021704922,'Aquarius'],
  [2021704922,2021888511,'Pisces'],
  [2021888511,2022072499,'Aries'],
  [2022072499,2022258090,'Taurus'],
  [2022258090,2022447555,'Gemini'],
  [2022447555,2022644351,'Cancer'],
  [2022644351,2022851354,'Leo'],
  [2022851354,2023067651,'Virgo'],
  [2023067651,2023286560,'Libra'],
  [2023286560,2023498671,'Scorpio'],
  [2023498671,2023698211,'Sagittarius'],
  [2023698211,2023885747,'Capricorn'],
  [2023885747,2024065881,'Aquarius'],
  [2024065881,2024244105,'Pisces'],
  [2024244105,2024424859,'Aries'],
  [2024424859,2024610882,'Taurus'],
  [2024610882,2024803599,'Gemini'],
  [2024803599,2025003890,'Cancer'],
  [2025003890,2025212348,'Leo'],
  [2025212348,2025428180,'Virgo'],
  [2025428180,2025647311,'Libra'],
  [2025647311,2025862375,'Scorpio'],
  [2025862375,2026066236,'Sagittarius'],
  [2026066236,2026256343,'Capricorn'],
  [2026256343,2026435355,'Aquarius'],
  [2026435355,2026608951,'Pisces'],
  [2026608951,2026783565,'Aries'],
  [2026783565,2026964774,'Taurus'],
  [2026964774,2027156045,'Gemini'],
  [2027156045,2027357985,'Cancer'],
  [2027357985,2027568775,'Leo'],
  [2027568775,2027785488,'Virgo'],
  [2027785488,2028004520,'Libra'],
  [2028004520,2028221074,'Scorpio'],
  [2028221074,2028429325,'Sagittarius'],
  [2028429325,2028624874,'Capricorn'],
  [2028624874,2028807356,'Aquarius'],
  [2028807356,2028980611,'Pisces'],
  [2028980611,2029151129,'Aries'],
  [2029151129,2029326164,'Taurus'],
  [2029326164,2029511909,'Gemini'],
  [2029511909,2029711308,'Cancer'],
  [2029711308,2029922524,'Leo'],
  [2029922524,2030140325,'Virgo'],
  [2030140325,2030359344,'Libra'],
  [2030359344,2030575660,'Scorpio'],
  [2030575660,2030785867,'Sagittarius'],
  [2030785867,2030986332,'Capricorn'],
  [2030986332,2031174740,'Aquarius'],
  [2031174740,2031352075,'Pisces'],
  [2031352075,2031523064,'Aries'],
  [2031523064,2031694827,'Taurus'],
  [2031694827,2031874931,'Gemini'],
  [2031874931,2032068960,'Cancer'],
  [2032068960,2032277477,'Leo'],
  [2032277477,2032495091,'Virgo'],
  [2032495091,2032714168,'Libra'],
  [2032714168,2032929467,'Scorpio'],
  [2032929467,2033138832,'Sagittarius'],
  [2033138832,2033340896,'Capricorn'],
  [2033340896,2033533927,'Aquarius'],
  [2033533927,2033717108,'Pisces'],
  [2033717108,2033892510,'Aries'],
  [2033892510,2034065477,'Taurus'],
  [2034065477,2034243207,'Gemini'],
  [2034243207,2034432498,'Cancer'],
  [2034432498,2034636573,'Leo'],
  [2034636573,2034852214,'Virgo'],
  [2034852214,2035071128,'Libra'],
  [2035071128,2035285770,'Scorpio'],
  [2035285770,2035493118,'Sagittarius'],
  [2035493118,2035693345,'Capricorn'],
  [2035693345,2035886964,'Aquarius'],
  [2035886964,2036073859,'Pisces'],
  [2036073859,2036254597,'Aries'],
  [2036254597,2036432055,'Taurus'],
  [2036432055,2036611532,'Gemini'],
  [2036611532,2036799262,'Cancer'],
  [2036799262,2036999769,'Leo'],
  [2036999769,2037212557,'Virgo'],
  [2037212557,2037430926,'Libra'],
  [2037430926,2037645919,'Scorpio'],
  [2037645919,2037852193,'Sagittarius'],
  [2037852193,2038049475,'Capricorn'],
  [2038049475,2038240022,'Aquarius'],
  [2038240022,2038426072,'Pisces'],
  [2038426072,2038609185,'Aries'],
  [2038609185,2038791133,'Taurus'],
  [2038791133,2038974895,'Gemini'],
  [2038974895,2039164620,'Cancer'],
  [2039164620,2039364237,'Leo'],
  [2039364237,2039574863,'Virgo'],
  [2039574863,2039792461,'Libra'],
  [2039792461,2040008752,'Scorpio'],
  [2040008752,2040216195,'Sagittarius'],
  [2040216195,2040412277,'Capricorn'],
  [2040412277,2040599117,'Aquarius'],
  [2040599117,2040780822,'Pisces'],
  [2040780822,2040961452,'Aries'],
  [2040961452,2041144169,'Taurus'],
  [2041144169,2041331303,'Gemini'],
  [2041331303,2041524775,'Cancer'],
  [2041524775,2041726271,'Leo'],
  [2041726271,2041936522,'Virgo'],
  [2041936522,2042153506,'Libra'],
  [2042153506,2042371311,'Scorpio'],
  [2042371311,2042581998,'Sagittarius'],
  [2042581998,2042780257,'Capricorn'],
  [2042780257,2042966088,'Aquarius'],
  [2042966088,2043143632,'Pisces'],
  [2043143632,2043318820,'Aries'],
  [2043318820,2043497427,'Taurus'],
  [2043497427,2043683641,'Gemini'],
  [2043683641,2043879188,'Cancer'],
  [2043879188,2044083557,'Leo'],
  [2044083557,2044295208,'Virgo'],
  [2044295208,2044512121,'Libra'],
  [2044512121,2044730737,'Scorpio'],
  [2044730737,2044944988,'Sagittarius'],
  [2044944988,2045148235,'Capricorn'],
  [2045148235,2045337353,'Aquarius'],
  [2045337353,2045514456,'Pisces'],
  [2045514456,2045685517,'Aries'],
  [2045685517,2045857998,'Taurus'],
  [2045857998,2046038752,'Gemini'],
  [2046038752,2046231863,'Cancer'],
  [2046231863,2046437011,'Leo'],
  [2046437011,2046650446,'Virgo'],
  [2046650446,2046867978,'Libra'],
  [2046867978,2047086459,'Scorpio'],
  [2047086459,2047302383,'Sagittarius'],
  [2047302383,2047510506,'Capricorn'],
  [2047510506,2047705875,'Aquarius'],
  [2047705875,2047887376,'Pisces'],
  [2047887376,2048058969,'Aries'],
  [2048058969,2048227941,'Taurus'],
  [2048227941,2048402487,'Gemini'],
  [2048402487,2048589391,'Cancer'],
  [2048589391,2048791126,'Leo'],
  [2048791126,2049004368,'Virgo'],
  [2049004368,2049222641,'Libra'],
  [2049222641,2049440741,'Scorpio'],
  [2049440741,2049655926,'Sagittarius'],
  [2049655926,2049865610,'Capricorn'],
  [2049865610,2050066060,'Aquarius'],
  [2050066060,2050254349,'Pisces'],
  [2050254349,2050431288,'Aries'],
  [2050431288,2050602014,'Taurus'],
  [2050602014,2050774122,'Gemini'],
  [2050774122,2050955383,'Cancer'],
  [2050955383,2051151054,'Leo'],
  [2051151054,2051360852,'Virgo'],
  [2051360852,2051578659,'Libra'],
  [2051578659,2051796764,'Scorpio'],
  [2051796764,2052010501,'Sagittarius'],
  [2052010501,2052218304,'Capricorn'],
  [2052218304,2052419164,'Aquarius'],
  [2052419164,2052611574,'Pisces'],
  [2052611574,2052794955,'Aries'],
  [2052794955,2052971538,'Taurus'],
  [2052971538,2053146495,'Gemini'],
  [2053146495,2053326507,'Cancer'],
  [2053326507,2053517636,'Leo'],
  [2053517636,2053722513,'Virgo'],
  [2053722513,2053937982,'Libra'],
  [2053937982,2054156178,'Scorpio'],
  [2054156178,2054369641,'Sagittarius'],
  [2054369641,2054575084,'Capricorn'],
  [2054575084,2054772679,'Aquarius'],
  [2054772679,2054963702,'Pisces'],
  [2054963702,2055149359,'Aries'],
  [2055149359,2055331170,'Taurus'],
  [2055331170,2055511786,'Gemini'],
  [2055511786,2055695217,'Cancer'],
  [2055695217,2055886081,'Leo'],
  [2055886081,2056087847,'Virgo'],
  [2056087847,2056300349,'Libra'],
  [2056300349,2056518180,'Scorpio'],
  [2056518180,2056732889,'Sagittarius'],
  [2056732889,2056938223,'Capricorn'],
  [2056938223,2057132908,'Aquarius'],
  [2057132908,2057319486,'Pisces'],
  [2057319486,2057501899,'Aries'],
  [2057501899,2057683781,'Taurus'],
  [2057683781,2057867822,'Gemini'],
  [2057867822,2058055991,'Cancer'],
  [2058055991,2058250153,'Leo'],
  [2058250153,2058452251,'Virgo'],
  [2058452251,2058663132,'Libra'],
  [2058663132,2058880286,'Scorpio'],
  [2058880286,2059096854,'Sagittarius'],
  [2059096854,2059304765,'Capricorn'],
  [2059304765,2059499814,'Aquarius'],
  [2059499814,2059683409,'Pisces'],
  [2059683409,2059860712,'Aries'],
  [2059860712,2060037884,'Taurus'],
  [2060037884,2060219973,'Gemini'],
  [2060219973,2060409648,'Cancer'],
  [2060409648,2060607189,'Leo'],
  [2060607189,2060811904,'Virgo'],
  [2060811904,2061023282,'Libra'],
  [2061023282,2061240068,'Scorpio'],
  [2061240068,2061458022,'Sagittarius'],
  [2061458022,2061669680,'Capricorn'],
  [2061669680,2061868465,'Aquarius'],
  [2061868465,2062053067,'Pisces'],
  [2062053067,2062227762,'Aries'],
  [2062227762,2062399716,'Taurus'],
  [2062399716,2062576211,'Gemini'],
  [2062576211,2062762454,'Cancer'],
  [2062762454,2062959905,'Leo'],
  [2062959905,2063166609,'Virgo'],
  [2063166609,2063379625,'Libra'],
  [2063379625,2063596681,'Scorpio'],
  [2063596681,2063815053,'Sagittarius'],
  [2063815053,2064029501,'Capricorn'],
  [2064029501,2064233271,'Aquarius'],
  [2064233271,2064422463,'Pisces'],
  [2064422463,2064598895,'Aries'],
  [2064598895,2064768910,'Taurus'],
  [2064768910,2064940481,'Gemini'],
  [2064940481,2065120823,'Cancer'],
  [2065120823,2065314077,'Leo'],
  [2065314077,2065519702,'Virgo'],
  [2065519702,2065733601,'Libra'],
  [2065733601,2065951246,'Scorpio'],
  [2065951246,2066169320,'Sagittarius'],
  [2066169320,2066384354,'Capricorn'],
  [2066384354,2066591479,'Aquarius'],
  [2066591479,2066786208,'Pisces'],
  [2066786208,2066967793,'Aries'],
  [2066967793,2067140278,'Taurus'],
  [2067140278,2067310670,'Gemini'],
  [2067310670,2067486604,'Cancer'],
  [2067486604,2067674180,'Leo'],
  [2067674180,2067875632,'Virgo'],
  [2067875632,2068088227,'Libra'],
  [2068088227,2068306071,'Scorpio'],
  [2068306071,2068523713,'Sagittarius'],
  [2068523713,2068737562,'Capricorn'],
  [2068737562,2068944777,'Aquarius'],
  [2068944777,2069142623,'Pisces'],
  [2069142623,2069329696,'Aries'],
  [2069329696,2069507620,'Taurus'],
  [2069507620,2069681096,'Gemini'],
  [2069681096,2069856542,'Cancer'],
  [2069856542,2070040368,'Leo'],
  [2070040368,2070236900,'Virgo'],
  [2070236900,2070446180,'Libra'],
  [2070446180,2070663252,'Scorpio'],
  [2070663252,2070880799,'Sagittarius'],
  [2070880799,2071093255,'Capricorn'],
  [2071093255,2071298146,'Aquarius'],
  [2071298146,2071495031,'Pisces'],
  [2071495031,2071684293,'Aries'],
  [2071684293,2071867109,'Taurus'],
  [2071867109,2072045980,'Gemini'],
  [2072045980,2072224880,'Cancer'],
  [2072224880,2072408775,'Leo'],
  [2072408775,2072602379,'Virgo'],
  [2072602379,2072808053,'Libra'],
  [2072808053,2073023448,'Scorpio'],
  [2073023448,2073241341,'Sagittarius'],
  [2073241341,2073453733,'Capricorn'],
  [2073453733,2073656422,'Aquarius'],
  [2073656422,2073849772,'Pisces'],
  [2073849772,2074036628,'Aries'],
  [2074036628,2074220137,'Taurus'],
  [2074220137,2074402789,'Gemini'],
  [2074402789,2074586620,'Cancer'],
  [2074586620,2074774009,'Leo'],
  [2074774009,2074968100,'Virgo'],
  [2074968100,2075171841,'Libra'],
  [2075171841,2075385437,'Scorpio'],
  [2075385437,2075603829,'Sagittarius'],
  [2075603829,2075818048,'Capricorn'],
  [2075818048,2076021040,'Aquarius'],
  [2076021040,2076211735,'Pisces'],
  [2076211735,2076394007,'Aries'],
  [2076394007,2076573476,'Taurus'],
  [2076573476,2076754922,'Gemini'],
  [2076754922,2076940969,'Cancer'],
  [2076940969,2077132373,'Leo'],
  [2077132373,2077329635,'Virgo'],
  [2077329635,2077534096,'Libra'],
  [2077534096,2077746803,'Scorpio'],
  [2077746803,2077965422,'Sagittarius'],
  [2077965422,2078182450,'Capricorn'],
  [2078182450,2078388896,'Aquarius'],
  [2078388896,2078580655,'Pisces'],
  [2078580655,2078760375,'Aries'],
  [2078760375,2078934620,'Taurus'],
  [2078934620,2079110511,'Gemini'],
  [2079110511,2079293342,'Cancer'],
  [2079293342,2079485134,'Leo'],
  [2079485134,2079685157,'Virgo'],
  [2079685157,2079892116,'Libra'],
  [2079892116,2080105456,'Scorpio'],
  [2080105456,2080323992,'Sagittarius'],
  [2080323992,2080542983,'Capricorn'],
  [2080542983,2080754184,'Aquarius'],
  [2080754184,2080950933,'Pisces'],
  [2080950933,2081132842,'Aries'],
  [2081132842,2081305245,'Taurus'],
  [2081305245,2081475869,'Gemini'],
  [2081475869,2081652127,'Cancer'],
  [2081652127,2081839039,'Leo'],
  [2081839039,2082037766,'Virgo'],
  [2082037766,2082246174,'Libra'],
  [2082246174,2082461058,'Scorpio'],
  [2082461058,2082679703,'Sagittarius'],
  [2082679703,2082898830,'Capricorn'],
  [2082898830,2083112894,'Aquarius'],
  [2083112894,2083315519,'Pisces'],
  [2083315519,2083503591,'Aries'],
  [2083503591,2083679451,'Taurus'],
  [2083679451,2083849362,'Gemini'],
  [2083849362,2084020910,'Cancer'],
  [2084020910,2084201020,'Leo'],
  [2084201020,2084394047,'Virgo'],
  [2084394047,2084600168,'Libra'],
  [2084600168,2084815514,'Scorpio'],
  [2084815514,2085034635,'Sagittarius'],
  [2085034635,2085252927,'Capricorn'],
  [2085252927,2085466581,'Aquarius'],
  [2085466581,2085671859,'Pisces'],
  [2085671859,2085865856,'Aries'],
  [2085865856,2086048414,'Taurus'],
  [2086048414,2086222818,'Gemini'],
  [2086222818,2086394839,'Cancer'],
  [2086394839,2086571222,'Leo'],
  [2086571222,2086758085,'Virgo'],
  [2086758085,2086958841,'Libra'],
  [2086958841,2087171986,'Scorpio'],
  [2087171986,2087391169,'Sagittarius'],
  [2087391169,2087609000,'Capricorn'],
  [2087609000,2087820681,'Aquarius'],
  [2087820681,2088024418,'Pisces'],
  [2088024418,2088219891,'Aries'],
  [2088219891,2088407399,'Taurus'],
  [2088407399,2088588211,'Gemini'],
  [2088588211,2088765192,'Cancer'],
  [2088765192,2088942979,'Leo'],
  [2088942979,2089127291,'Virgo'],
  [2089127291,2089323229,'Libra'],
  [2089323229,2089532445,'Scorpio'],
  [2089532445,2089750532,'Sagittarius'],
  [2089750532,2089968634,'Capricorn'],
  [2089968634,2090179248,'Aquarius'],
  [2090179248,2090380009,'Pisces'],
  [2090380009,2090572617,'Aries'],
  [2090572617,2090759886,'Taurus'],
  [2090759886,2090943969,'Gemini'],
  [2090943969,2091126319,'Cancer'],
  [2091126319,2091308872,'Leo'],
  [2091308872,2091495111,'Virgo'],
  [2091495111,2091689624,'Libra'],
  [2091689624,2091895757,'Scorpio'],
  [2091895757,2092112055,'Sagittarius'],
  [2092112055,2092330760,'Capricorn'],
  [2092330760,2092542281,'Aquarius'],
  [2092542281,2092741795,'Pisces'],
  [2092741795,2092930790,'Aries'],
  [2092930790,2093114000,'Taurus'],
  [2093114000,2093296052,'Gemini'],
  [2093296052,2093479743,'Cancer'],
  [2093479743,2093666197,'Leo'],
  [2093666197,2093856505,'Virgo'],
  [2093856505,2094053019,'Libra'],
  [2094053019,2094258591,'Scorpio'],
  [2094258591,2094473596,'Sagittarius'],
  [2094473596,2094692822,'Capricorn'],
  [2094692822,2094906743,'Aquarius'],
  [2094906743,2095107998,'Pisces'],
  [2095107998,2095295957,'Aries'],
  [2095295957,2095475315,'Taurus'],
  [2095475315,2095652414,'Gemini'],
  [2095652414,2095832527,'Cancer'],
  [2095832527,2096018531,'Leo'],
  [2096018531,2096211218,'Virgo'],
  [2096211218,2096410830,'Libra'],
  [2096410830,2096618054,'Scorpio'],
  [2096618054,2096833003,'Sagittarius'],
  [2096833003,2097052491,'Capricorn'],
  [2097052491,2097268960,'Aquarius'],
  [2097268960,2097474165,'Pisces'],
  [2097474165,2097664745,'Aries'],
  [2097664745,2097843547,'Taurus'],
  [2097843547,2098016863,'Gemini'],
  [2098016863,2098191482,'Cancer'],
  [2098191482,2098372785,'Leo'],
  [2098372785,2098563630,'Virgo'],
  [2098563630,2098764326,'Libra'],
  [2098764326,2098973585,'Scorpio'],
  [2098973585,2099189496,'Sagittarius'],
  [2099189496,2099409046,'Capricorn'],
  [2099409046,2099626868,'Aquarius'],
  [2099626868,2099836075,'Pisces'],
  [2099836075,2100031760,'Aries'],
  [2100031760,2100214019,'Taurus'],
  [2100214019,2100387393,'Gemini'],
  [2100387393,2100558513,'Cancer'],
  [2100558513,2100734150,'Leo'],
  [2100734150,2100919702,'Virgo'],
  [2100919702,2101117752,'Libra'],
  [2101117752,2101327206,'Scorpio'],
  [2101327206,2101544107,'Sagittarius'],
  [2101544107,2101763685,'Capricorn'],
  [2101763685,2101981267,'Aquarius'],
  [2101981267,2102192275,'Pisces'],
  [2102192275,2102392686,'Aries'],
  [2102392686,2102580766,'Taurus'],
  [2102580766,2102758317,'Gemini'],
  [2102758317,2102930151,'Cancer'],
  [2102930151,2103102759,'Leo'],
  [2103102759,2103282867,'Virgo'],
  [2103282867,2103475657,'Libra'],
  [2103475657,2103682395,'Scorpio'],
  [2103682395,2103899099,'Sagittarius'],
  [2103899099,2104118740,'Capricorn'],
  [2104118740,2104335254,'Aquarius'],
  [2104335254,2104545272,'Pisces'],
  [2104545272,2104747161,'Aries'],
  [2104747161,2104939897,'Taurus'],
  [2104939897,2105123498,'Gemini'],
  [2105123498,2105300032,'Cancer'],
  [2105300032,2105474022,'Leo'],
  [2105474022,2105651770,'Virgo'],
  [2105651770,2105839762,'Libra'],
  [2105839762,2106041982,'Scorpio'],
  [2106041982,2106256706,'Sagittarius'],
  [2106256706,2106476286,'Capricorn'],
  [2106476286,2106692167,'Aquarius'],
  [2106692167,2106899983,'Pisces'],
  [2106899983,2107099715,'Aries'],
  [2107099715,2107292810,'Taurus'],
  [2107292810,2107480184,'Gemini'],
  [2107480184,2107662427,'Cancer'],
  [2107662427,2107841359,'Leo'],
  [2107841359,2108021123,'Virgo'],
  [2108021123,2108207582,'Libra'],
  [2108207582,2108406074,'Scorpio'],
  [2108406074,2108617764,'Sagittarius'],
  [2108617764,2108836851,'Capricorn'],
  [2108836851,2109053345,'Aquarius'],
  [2109053345,2109260216,'Pisces'],
  [2109260216,2109456780,'Aries'],
  [2109456780,2109646273,'Taurus'],
  [2109646273,2109832225,'Gemini'],
  [2109832225,2110016607,'Cancer'],
  [2110016607,2110200278,'Leo'],
  [2110200278,2110384834,'Virgo'],
  [2110384834,2110573752,'Libra'],
  [2110573752,2110771541,'Scorpio'],
  [2110771541,2110980905,'Sagittarius'],
  [2110980905,2111199037,'Capricorn'],
  [2111199037,2111417062,'Aquarius'],
  [2111417062,2111625691,'Pisces'],
  [2111625691,2111821522,'Aries'],
  [2111821522,2112007278,'Taurus'],
  [2112007278,2112188220,'Gemini'],
  [2112188220,2112369094,'Cancer'],
  [2112369094,2112552746,'Leo'],
  [2112552746,2112740502,'Virgo'],
  [2112740502,2112933566,'Libra'],
  [2112933566,2113133842,'Scorpio'],
  [2113133842,2113343107,'Sagittarius'],
  [2113343107,2113560391,'Capricorn'],
  [2113560391,2113779714,'Aquarius'],
  [2113779714,2113992018,'Pisces'],
  [2113992018,2114191028,'Aries'],
  [2114191028,2114376775,'Taurus'],
  [2114376775,2114553967,'Gemini'],
  [2114553967,2114728871,'Cancer'],
  [2114728871,2114907155,'Leo'],
  [2114907155,2115092680,'Virgo'],
  [2115092680,2115287127,'Libra'],
  [2115287127,2115490447,'Scorpio'],
  [2115490447,2115701677,'Sagittarius'],
  [2115701677,2115919030,'Capricorn'],
  [2115919030,2116138660,'Aquarius'],
  [2116138660,2116354094,'Pisces'],
  [2116354094,2116558518,'Aries'],
  [2116558518,2116748816,'Taurus'],
  [2116748816,2116927029,'Gemini'],
  [2116927029,2117098732,'Cancer'],
  [2117098732,2117270832,'Leo'],
  [2117270832,2117449870,'Virgo'],
  [2117449870,2117640417,'Libra'],
  [2117640417,2117843520,'Scorpio'],
  [2117843520,2118056491,'Sagittarius'],
  [2118056491,2118274838,'Capricorn'],
  [2118274838,2118494194,'Aquarius'],
  [2118494194,2118710410,'Pisces'],
  [2118710410,2118918857,'Aries'],
  [2118918857,2119115488,'Taurus'],
  [2119115488,2119299233,'Gemini'],
  [2119299233,2119473014,'Cancer'],
  [2119473014,2119642884,'Leo'],
  [2119642884,2119816283,'Virgo'],
  [2119816283,2120000201,'Libra'],
  [2120000201,2120198739,'Scorpio'],
  [2120198739,2120410591,'Sagittarius'],
  [2120410591,2120629566,'Capricorn'],
  [2120629566,2120848787,'Aquarius'],
  [2120848787,2121063971,'Pisces'],
  [2121063971,2121272867,'Aries'],
  [2121272867,2121473307,'Taurus'],
  [2121473307,2121663347,'Gemini'],
  [2121663347,2121843048,'Cancer'],
  [2121843048,2122015865,'Leo'],
  [2122015865,2122188169,'Virgo'],
  [2122188169,2122367492,'Libra'],
  [2122367492,2122560155,'Scorpio'],
  [2122560155,2122767921,'Sagittarius'],
  [2122767921,2122985798,'Capricorn'],
  [2122985798,2123205017,'Aquarius'],
  [2123205017,2123419067,'Pisces'],
  [2123419067,2123625949,'Aries'],
  [2123625949,2123825840,'Taurus'],
  [2123825840,2124018601,'Gemini'],
  [2124018601,2124203756,'Cancer'],
  [2124203756,2124382296,'Leo'],
  [2124382296,2124558075,'Virgo'],
  [2124558075,2124737299,'Libra'],
  [2124737299,2124926581,'Scorpio'],
  [2124926581,2125129893,'Sagittarius'],
  [2125129893,2125345133,'Capricorn'],
  [2125345133,2125564088,'Aquarius'],
  [2125564088,2125778017,'Pisces'],
  [2125778017,2125983036,'Aries'],
  [2125983036,2126179891,'Taurus'],
  [2126179891,2126370752,'Gemini'],
  [2126370752,2126557067,'Cancer'],
  [2126557067,2126739729,'Leo'],
  [2126739729,2126920582,'Virgo'],
  [2126920582,2127103387,'Libra'],
  [2127103387,2127293216,'Scorpio'],
  [2127293216,2127494322,'Sagittarius'],
  [2127494322,2127706950,'Capricorn'],
  [2127706950,2127925316,'Aquarius'],
  [2127925316,2128140275,'Pisces'],
  [2128140275,2128345421,'Aries'],
  [2128345421,2128539978,'Taurus'],
  [2128539978,2128726890,'Gemini'],
  [2128726890,2128909911,'Cancer'],
  [2128909911,2129092038,'Leo'],
  [2129092038,2129275480,'Virgo'],
  [2129275480,2129462419,'Libra'],
  [2129462419,2129655511,'Scorpio'],
  [2129655511,2129857400,'Sagittarius'],
  [2129857400,2130068887,'Capricorn'],
  [2130068887,2130286658,'Aquarius'],
  [2130286658,2130503236,'Pisces'],
  [2130503236,2130710811,'Aries'],
  [2130710811,2130905961,'Taurus'],
  [2130905961,2131090416,'Gemini'],
  [2131090416,2131268809,'Cancer'],
  [2131268809,2131446418,'Leo'],
  [2131446418,2131627734,'Virgo'],
  [2131627734,2131815753,'Libra'],
  [2131815753,2132011879,'Scorpio'],
  [2132011879,2132216340,'Sagittarius'],
  [2132216340,2132428489,'Capricorn'],
  [2132428489,2132646024,'Aquarius'],
  [2132646024,2132863917,'Pisces'],
  [2132863917,2133075096,'Aries'],
  [2133075096,2133273962,'Taurus'],
  [2133273962,2133459608,'Gemini'],
  [2133459608,2133635663,'Cancer'],
  [2133635663,2133808294,'Leo'],
  [2133808294,2133984177,'Virgo'],
  [2133984177,2134168762,'Libra'],
  [2134168762,2134364667,'Scorpio'],
  [2134364667,2134571024,'Sagittarius'],
  [2134571024,2134784787,'Capricorn'],
  [2134784787,2135002583,'Aquarius'],
  [2135002583,2135220855,'Pisces'],
  [2135220855,2135434802,'Aries'],
  [2135434802,2135638748,'Taurus'],
  [2135638748,2135829186,'Gemini'],
  [2135829186,2136007152,'Cancer'],
  [2136007152,2136177890,'Leo'],
  [2136177890,2136348829,'Virgo'],
  [2136348829,2136527471,'Libra'],
  [2136527471,2136719096,'Scorpio'],
  [2136719096,2136924322,'Sagittarius'],
  [2136924322,2137138972,'Capricorn'],
  [2137138972,2137357319,'Aquarius'],
  [2137357319,2137575167,'Pisces'],
  [2137575167,2137789574,'Aries'],
  [2137789574,2137996932,'Taurus'],
  [2137996932,2138193239,'Gemini'],
  [2138193239,2138376809,'Cancer'],
  [2138376809,2138550313,'Leo'],
  [2138550313,2138720139,'Virgo'],
  [2138720139,2138894263,'Libra'],
  [2138894263,2139079942,'Scorpio'],
  [2139079942,2139280704,'Sagittarius'],
  [2139280704,2139493927,'Capricorn'],
  [2139493927,2139712502,'Aquarius'],
  [2139712502,2139929874,'Pisces'],
  [2139929874,2140142853,'Aries'],
  [2140142853,2140349990,'Taurus'],
  [2140349990,2140549334,'Gemini'],
  [2140549334,2140738756,'Cancer'],
  [2140738756,2140918329,'Leo'],
  [2140918329,2141091817,'Virgo'],
  [2141091817,2141265817,'Libra'],
  [2141265817,2141447744,'Scorpio'],
  [2141447744,2141643182,'Sagittarius'],
  [2141643182,2141852633,'Capricorn'],
  [2141852633,2142070305,'Aquarius'],
  [2142070305,2142287755,'Pisces'],
  [2142287755,2142499399,'Aries'],
  [2142499399,2142703859,'Taurus'],
  [2142703859,2142901560,'Gemini'],
  [2142901560,2143092648,'Cancer'],
  [2143092648,2143277176,'Leo'],
  [2143277176,2143456667,'Virgo'],
  [2143456667,2143634988,'Libra'],
  [2143634988,2143817726,'Scorpio'],
  [2143817726,2144010421,'Sagittarius'],
  [2144010421,2144215854,'Capricorn'],
  [2144215854,2144431392,'Aquarius'],
  [2144431392,2144649272,'Pisces'],
  [2144649272,2144861389,'Aries'],
  [2144861389,2145063999,'Taurus'],
  [2145063999,2145257802,'Gemini'],
  [2145257802,2145445438,'Cancer'],
  [2145445438,2145629542,'Leo'],
  [2145629542,2145812275,'Virgo'],
  [2145812275,2145995824,'Libra'],
  [2145995824,2146182982,'Scorpio'],
  [2146182982,2146377088,'Sagittarius'],
  [2146377088,2146580876,'Capricorn'],
  [2146580876,2146794234,'Aquarius'],
  [2146794234,2147012277,'Pisces'],
  [2147012277,2147226646,'Aries'],
  [2147226646,2147430563,'Taurus'],
  [2147430563,2147622482,'Gemini'],
  [2147622482,2147805416,'Cancer'],
  [2147805416,2147984421,'Leo'],
  [2147984421,2148164441,'Virgo'],
  [2148164441,2148349028,'Libra'],
  [2148349028,2148539976,'Scorpio'],
  [2148539976,2148737907,'Sagittarius'],
  [2148737907,2148943212,'Capricorn'],
  [2148943212,2149155883,'Aquarius'],
  [2149155883,2149373685,'Pisces'],
  [2149373685,2149590550,'Aries'],
  [2149590550,2149798522,'Taurus'],
  [2149798522,2149992787,'Gemini'],
  [2149992787,2150174310,'Cancer'],
  [2150174310,2150348498,'Leo'],
  [2150348498,2150522402,'Virgo'],
  [2150522402,2150702380,'Libra'],
  [2150702380,2150892230,'Scorpio'],
  [2150892230,2151092221,'Sagittarius'],
  [2151092221,2151300240,'Capricorn'],
  [2151300240,2151514037,'Aquarius'],
  [2151514037,2151731718,'Pisces'],
  [2151731718,2151949839,'Aries'],
  [2151949839,2152162023,'Taurus'],
  [2152162023,2152361676,'Gemini'],
  [2152361676,2152546547,'Cancer'],
  [2152546547,2152720198,'Leo'],
  [2152720198,2152889830,'Virgo'],
  [2152889830,2153063455,'Libra'],
  [2153063455,2153247603,'Scorpio'],
  [2153247603,2153444987,'Sagittarius'],
  [2153444987,2153653580,'Capricorn'],
  [2153653580,2153868843,'Aquarius'],
  [2153868843,2154086885,'Pisces'],
  [2154086885,2154304898,'Aries'],
  [2154304898,2154518999,'Taurus'],
  [2154518999,2154723614,'Gemini'],
  [2154723614,2154914540,'Cancer'],
  [2154914540,2155092352,'Leo'],
  [2155092352,2155262479,'Virgo'],
  [2155262479,2155432741,'Libra'],
  [2155432741,2155610931,'Scorpio'],
  [2155610931,2155802451,'Sagittarius'],
  [2155802451,2156007900,'Capricorn'],
  [2156007900,2156222909,'Aquarius'],
  [2156222909,2156441353,'Pisces'],
  [2156441353,2156658759,'Aries'],
  [2156658759,2156872207,'Taurus'],
  [2156872207,2157078498,'Gemini'],
  [2157078498,2157274221,'Cancer'],
  [2157274221,2157458130,'Leo'],
  [2157458130,2157632933,'Virgo'],
  [2157632933,2157804591,'Libra'],
  [2157804591,2157980360,'Scorpio'],
  [2157980360,2158166735,'Sagittarius'],
  [2158166735,2158367033,'Capricorn'],
  [2158367033,2158579404,'Aquarius'],
  [2158579404,2158797519,'Pisces'],
  [2158797519,2159014565,'Aries'],
  [2159014565,2159226365,'Taurus'],
  [2159226365,2159431028,'Gemini'],
  [2159431028,2159627509,'Cancer'],
  [2159627509,2159815370,'Leo'],
  [2159815370,2159995814,'Virgo'],
  [2159995814,2160172293,'Libra'],
  [2160172293,2160350030,'Scorpio'],
  [2160350030,2160534787,'Sagittarius'],
  [2160534787,2160731054,'Capricorn'],
  [2160731054,2160939740,'Aquarius'],
  [2160939740,2161156570,'Pisces'],
  [2161156570,2161373766,'Aries'],
  [2161373766,2161584721,'Taurus'],
  [2161584721,2161786749,'Gemini'],
  [2161786749,2161980430,'Cancer'],
  [2161980430,2162167722,'Leo'],
  [2162167722,2162350825,'Virgo'],
  [2162350825,2162532098,'Libra'],
  [2162532098,2162714408,'Scorpio'],
  [2162714408,2162901334,'Sagittarius'],
  [2162901334,2163096643,'Capricorn'],
  [2163096643,2163302659,'Aquarius'],
  [2163302659,2163517823,'Pisces'],
  [2163517823,2163735563,'Aries'],
  [2163735563,2163947442,'Taurus'],
  [2163947442,2164148400,'Gemini'],
  [2164148400,2164338671,'Cancer'],
  [2164338671,2164522007,'Leo'],
  [2164522007,2164703018,'Virgo'],
  [2164703018,2164885395,'Libra'],
  [2164885395,2165071355,'Scorpio'],
  [2165071355,2165262246,'Sagittarius'],
  [2165262246,2165459599,'Capricorn'],
  [2165459599,2165665196,'Aquarius'],
  [2165665196,2165879206,'Pisces'],
  [2165879206,2166097540,'Aries'],
  [2166097540,2166311900,'Taurus'],
  [2166311900,2166514705,'Gemini'],
  [2166514705,2166704003,'Cancer'],
  [2166704003,2166883498,'Leo'],
  [2166883498,2167059551,'Virgo'],
  [2167059551,2167238299,'Libra'],
  [2167238299,2167423721,'Scorpio'],
  [2167423721,2167616938,'Sagittarius'],
  [2167616938,2167817375,'Capricorn'],
  [2167817375,2168024615,'Aquarius'],
  [2168024615,2168238569,'Pisces'],
  [2168238569,2168457200,'Aries'],
  [2168457200,2168674261,'Taurus'],
  [2168674261,2168881316,'Gemini'],
  [2168881316,2169073499,'Cancer'],
  [2169073499,2169252520,'Leo'],
  [2169252520,2169424721,'Virgo'],
  [2169424721,2169597786,'Libra'],
  [2169597786,2169778226,'Scorpio'],
  [2169778226,2169969386,'Sagittarius'],
  [2169969386,2170170839,'Capricorn'],
  [2170170839,2170380145,'Aquarius'],
  [2170380145,2170595072,'Pisces'],
  [2170595072,2170813684,'Aries'],
  [2170813684,2171032056,'Taurus'],
  [2171032056,2171243345,'Gemini'],
  [2171243345,2171441178,'Cancer'],
  [2171441178,2171624214,'Leo'],
  [2171624214,2171796836,'Virgo'],
  [2171796836,2171966478,'Libra'],
  [2171966478,2172140928,'Scorpio'],
  [2172140928,2172326195,'Sagittarius'],
  [2172326195,2172524492,'Capricorn'],
  [2172524492,2172733801,'Aquarius'],
  [2172733801,2172949801,'Pisces'],
  [2172949801,2173168448,'Aries'],
  [2173168448,2173386319,'Taurus'],
  [2173386319,2173599105,'Gemini'],
  [2173599105,2173801781,'Cancer'],
  [2173801781,2173991304,'Leo'],
  [2173991304,2174169020,'Virgo'],
  [2174169020,2174340213,'Libra'],
  [2174340213,2174512034,'Scorpio'],
  [2174512034,2174691556,'Sagittarius'],
  [2174691556,2174883797,'Capricorn'],
  [2174883797,2175089657,'Aquarius'],
  [2175089657,2175305253,'Pisces'],
  [2175305253,2175524163,'Aries'],
  [2175524163,2175740944,'Taurus'],
  [2175740944,2175952170,'Gemini'],
  [2175952170,2176155543,'Cancer'],
  [2176155543,2176349413,'Leo'],
  [2176349413,2176533674,'Virgo'],
  [2176533674,2176710678,'Libra'],
  [2176710678,2176885106,'Scorpio'],
  [2176885106,2177063005,'Sagittarius'],
  [2177063005,2177250354,'Capricorn'],
  [2177250354,2177450962,'Aquarius'],
  [2177450962,2177663895,'Pisces'],
  [2177663895,2177882749,'Aries'],
  [2177882749,2178099330,'Taurus'],
  [2178099330,2178308394,'Gemini'],
  [2178308394,2178508825,'Cancer'],
  [2178508825,2178701798,'Leo'],
  [2178701798,2178888877,'Virgo'],
  [2178888877,2179071553,'Libra'],
  [2179071553,2179251822,'Scorpio'],
  [2179251822,2179432998,'Sagittarius'],
  [2179432998,2179619756,'Capricorn'],
  [2179619756,2179816824,'Aquarius'],
  [2179816824,2180026215,'Pisces'],
  [2180026215,2180244150,'Aries'],
  [2180244150,2180461677,'Taurus'],
  [2180461677,2180670544,'Gemini'],
  [2180670544,2180868119,'Cancer'],
  [2180868119,2181056884,'Leo'],
  [2181056884,2181241149,'Virgo'],
  [2181241149,2181424461,'Libra'],
  [2181424461,2181608716,'Scorpio'],
  [2181608716,2181794982,'Sagittarius'],
  [2181794982,2181985140,'Capricorn'],
  [2181985140,2182182442,'Aquarius'],
  [2182182442,2182389829,'Pisces'],
  [2182389829,2182606437,'Aries'],
  [2182606437,2182825244,'Taurus'],
  [2182825244,2183036399,'Gemini'],
  [2183036399,2183234238,'Cancer'],
  [2183234238,2183420031,'Leo'],
  [2183420031,2183599280,'Virgo'],
  [2183599280,2183778070,'Libra'],
  [2183778070,2183960709,'Scorpio'],
  [2183960709,2184148909,'Sagittarius'],
  [2184148909,2184342859,'Capricorn'],
  [2184342859,2184543129,'Aquarius'],
  [2184543129,2184751141,'Pisces'],
  [2184751141,2184967091,'Aries'],
  [2184967091,2185186713,'Taurus'],
  [2185186713,2185401195,'Gemini'],
  [2185401195,2185602639,'Cancer'],
  [2185602639,2185789468,'Leo'],
  [2185789468,2185966145,'Virgo'],
  [2185966145,2186139667,'Libra'],
  [2186139667,2186316636,'Scorpio'],
  [2186316636,2186501425,'Sagittarius'],
  [2186501425,2186695453,'Capricorn'],
  [2186695453,2186898082,'Aquarius'],
  [2186898082,2187108203,'Pisces'],
  [2187108203,2187324657,'Aries'],
  [2187324657,2187544493,'Taurus'],
  [2187544493,2187761369,'Gemini'],
  [2187761369,2187967605,'Cancer'],
  [2187967605,2188159085,'Leo'],
  [2188159085,2188337659,'Virgo'],
  [2188337659,2188509286,'Libra'],
  [2188509286,2188681183,'Scorpio'],
  [2188681183,2188859820,'Sagittarius'],
  [2188859820,2189049401,'Capricorn'],
  [2189049401,2189250871,'Aquarius'],
  [2189250871,2189462140,'Pisces'],
  [2189462140,2189679627,'Aries'],
  [2189679627,2189899407,'Taurus'],
  [2189899407,2190116765,'Gemini'],
  [2190116765,2190326176,'Cancer'],
  [2190326176,2190523186,'Leo'],
  [2190523186,2190707088,'Virgo'],
  [2190707088,2190881365,'Libra'],
  [2190881365,2191052091,'Scorpio'],
  [2191052091,2191226149,'Sagittarius'],
  [2191226149,2191409722,'Capricorn'],
  [2191409722,2191606573,'Aquarius'],
  [2191606573,2191816258,'Pisces'],
  [2191816258,2192034073,'Aries'],
  [2192034073,2192253787,'Taurus'],
  [2192253787,2192470219,'Gemini'],
  [2192470219,2192679785,'Cancer'],
  [2192679785,2192879934,'Leo'],
  [2192879934,2193069423,'Virgo'],
  [2193069423,2193249310,'Libra'],
  [2193249310,2193423222,'Scorpio'],
  [2193423222,2193596777,'Sagittarius'],
  [2193596777,2193776473,'Capricorn'],
  [2193776473,2193968017,'Aquarius'],
  [2193968017,2194173767,'Pisces'],
  [2194173767,2194390357,'Aries'],
  [2194390357,2194609986,'Taurus'],
  [2194609986,2194825355,'Gemini'],
  [2194825355,2195032954,'Cancer'],
  [2195032954,2195232410,'Leo'],
  [2195232410,2195424280,'Virgo'],
  [2195424280,2195609221,'Libra'],
  [2195609221,2195788635,'Scorpio'],
  [2195788635,2195965679,'Sagittarius'],
  [2195965679,2196145474,'Capricorn'],
  [2196145474,2196333998,'Aquarius'],
  [2196333998,2196535641,'Pisces'],
  [2196535641,2196749741,'Aries'],
  [2196749741,2196969120,'Taurus'],
  [2196969120,2197184365,'Gemini'],
  [2197184365,2197390107,'Cancer'],
  [2197390107,2197586517,'Leo'],
  [2197586517,2197776435,'Virgo'],
  [2197776435,2197962423,'Libra'],
  [2197962423,2198145851,'Scorpio'],
  [2198145851,2198327919,'Sagittarius'],
  [2198327919,2198511280,'Capricorn'],
  [2198511280,2198700399,'Aquarius'],
  [2198700399,2198899975,'Pisces'],
  [2198899975,2199111601,'Aries'],
  [2199111601,2199330498,'Taurus'],
  [2199330498,2199546889,'Gemini'],
  [2199546889,2199752829,'Cancer'],
  [2199752829,2199946918,'Leo'],
  [2199946918,2200132785,'Virgo'],
  [2200132785,2200315308,'Libra'],
  [2200315308,2200498053,'Scorpio'],
  [2200498053,2200682690,'Sagittarius'],
  [2200682690,2200870259,'Capricorn'],
  [2200870259,2201062748,'Aquarius'],
  [2201062748,2201263202,'Pisces'],
  [2201263202,2201473719,'Aries'],
  [2201473719,2201692041,'Taurus'],
  [2201692041,2201910221,'Gemini'],
  [2201910221,2202118934,'Cancer'],
  [2202118934,2202313920,'Leo'],
  [2202313920,2202497428,'Virgo'],
  [2202497428,2202675121,'Libra'],
  [2202675121,2202852879,'Scorpio'],
  [2202852879,2203034935,'Sagittarius'],
  [2203034935,2203223382,'Capricorn'],
  [2203223382,2203418988,'Aquarius'],
  [2203418988,2203622271,'Pisces'],
  [2203622271,2203833604,'Aries'],
  [2203833604,2204051605,'Taurus'],
  [2204051605,2204271021,'Gemini'],
  [2204271021,2204483653,'Cancer'],
  [2204483653,2204683057,'Leo'],
  [2204683057,2204868494,'Virgo'],
  [2204868494,2205044252,'Libra'],
  [2205044252,2205216827,'Scorpio'],
  [2205216827,2205392702,'Sagittarius'],
  [2205392702,2205576847,'Capricorn'],
  [2205576847,2205771683,'Aquarius'],
  [2205771683,2205976858,'Pisces'],
  [2205976858,2206190116,'Aries'],
  [2206190116,2206408444,'Taurus'],
  [2206408444,2206627897,'Gemini'],
  [2206627897,2206843005,'Cancer'],
  [2206843005,2207047841,'Leo'],
  [2207047841,2207239081,'Virgo'],
  [2207239081,2207417950,'Libra'],
  [2207417950,2207589427,'Scorpio'],
  [2207589427,2207760372,'Sagittarius'],
  [2207760372,2207937827,'Capricorn'],
  [2207937827,2208127267,'Aquarius'],
  [2208127267,2208330486,'Pisces'],
  [2208330486,2208544539,'Aries'],
  [2208544539,2208763678,'Taurus'],
  [2208763678,2208982571,'Gemini'],
  [2208982571,2209197421,'Cancer'],
  [2209197421,2209404969,'Leo'],
  [2209404969,2209602147,'Virgo'],
  [2209602147,2209787625,'Libra'],
  [2209787625,2209963274,'Scorpio'],
  [2209963274,2210134234,'Sagittarius'],
  [2210134234,2210307623,'Capricorn'],
  [2210307623,2210490724,'Aquarius'],
  [2210490724,2210688457,'Pisces'],
  [2210688457,2210900250,'Aries'],
  [2210900250,2211119542,'Taurus'],
  [2211119542,2211338222,'Gemini'],
  [2211338222,2211551417,'Cancer'],
  [2211551417,2211757757,'Leo'],
  [2211757757,2211956762,'Virgo'],
  [2211956762,2212147543,'Libra'],
  [2212147543,2212329785,'Scorpio'],
  [2212329785,2212505599,'Sagittarius'],
  [2212505599,2212680146,'Capricorn'],
  [2212680146,2212860416,'Aquarius'],
  [2212860416,2213052924,'Pisces'],
  [2213052924,2213260253,'Aries'],
  [2213260253,2213478030,'Taurus'],
  [2213478030,2213696894,'Gemini'],
  [2213696894,2213909214,'Cancer'],
  [2213909214,2214112871,'Leo'],
  [2214112871,2214309318,'Virgo'],
  [2214309318,2214500241,'Libra'],
  [2214500241,2214686224,'Scorpio'],
  [2214686224,2214867790,'Sagittarius'],
  [2214867790,2215047309,'Capricorn'],
  [2215047309,2215229577,'Aquarius'],
  [2215229577,2215420492,'Pisces'],
  [2215420492,2215624196,'Aries'],
  [2215624196,2215839417,'Taurus'],
  [2215839417,2216058337,'Gemini'],
  [2216058337,2216271466,'Cancer'],
  [2216271466,2216474051,'Leo'],
  [2216474051,2216667073,'Virgo'],
  [2216667073,2216854078,'Libra'],
  [2216854078,2217038268,'Scorpio'],
  [2217038268,2217221557,'Sagittarius'],
  [2217221557,2217405410,'Capricorn'],
  [2217405410,2217592169,'Aquarius'],
  [2217592169,2217785377,'Pisces'],
  [2217785377,2217988438,'Aries'],
  [2217988438,2218201797,'Taurus'],
  [2218201797,2218420478,'Gemini'],
  [2218420478,2218635563,'Cancer'],
  [2218635563,2218839883,'Leo'],
  [2218839883,2219032021,'Virgo'],
  [2219032021,2219215225,'Libra'],
  [2219215225,2219394448,'Scorpio'],
  [2219394448,2219574230,'Sagittarius'],
  [2219574230,2219757830,'Capricorn'],
  [2219757830,2219947312,'Aquarius'],
  [2219947312,2220144077,'Pisces'],
  [2220144077,2220349148,'Aries'],
  [2220349148,2220562414,'Taurus'],
  [2220562414,2220780862,'Gemini'],
  [2220780862,2220997909,'Cancer'],
  [2220997909,2221205922,'Leo'],
  [2221205922,2221400742,'Virgo'],
  [2221400742,2221583473,'Libra'],
  [2221583473,2221758877,'Scorpio'],
  [2221758877,2221933099,'Sagittarius'],
  [2221933099,2222111950,'Capricorn'],
  [2222111950,2222299596,'Aquarius'],
  [2222299596,2222497626,'Pisces'],
  [2222497626,2222705099,'Aries'],
  [2222705099,2222919663,'Taurus'],
  [2222919663,2223138191,'Gemini'],
  [2223138191,2223356255,'Cancer'],
  [2223356255,2223567902,'Leo'],
  [2223567902,2223767700,'Virgo'],
  [2223767700,2223953922,'Libra'],
  [2223953922,2224129386,'Scorpio'],
  [2224129386,2224300092,'Sagittarius'],
  [2224300092,2224473252,'Capricorn'],
  [2224473252,2224655471,'Aquarius'],
  [2224655471,2224850669,'Pisces'],
  [2224850669,2225058318,'Aries'],
  [2225058318,2225274126,'Taurus'],
  [2225274126,2225493026,'Gemini'],
  [2225493026,2225710989,'Cancer'],
  [2225710989,2225924310,'Leo'],
  [2225924310,2226128650,'Virgo'],
  [2226128650,2226320606,'Libra'],
  [2226320606,2226500198,'Scorpio'],
  [2226500198,2226671606,'Sagittarius'],
  [2226671606,2226841812,'Capricorn'],
  [2226841812,2227018596,'Aquarius'],
  [2227018596,2227208281,'Pisces'],
  [2227208281,2227412809,'Aries'],
  [2227412809,2227628214,'Taurus'],
  [2227628214,2227847389,'Gemini'],
  [2227847389,2228064711,'Cancer'],
  [2228064711,2228277353,'Leo'],
  [2228277353,2228483258,'Virgo'],
  [2228483258,2228679845,'Libra'],
  [2228679845,2228865419,'Scorpio'],
  [2228865419,2229041451,'Sagittarius'],
  [2229041451,2229213080,'Capricorn'],
  [2229213080,2229387631,'Aquarius'],
  [2229387631,2229572455,'Pisces'],
  [2229572455,2229772017,'Aries'],
  [2229772017,2229984803,'Taurus'],
  [2229984803,2230203599,'Gemini'],
  [2230203599,2230420511,'Cancer'],
  [2230420511,2230631458,'Leo'],
  [2230631458,2230835668,'Virgo'],
  [2230835668,2231032928,'Libra'],
  [2231032928,2231222455,'Scorpio'],
  [2231222455,2231404228,'Sagittarius'],
  [2231404228,2231580801,'Capricorn'],
  [2231580801,2231757458,'Aquarius'],
  [2231757458,2231940808,'Pisces'],
  [2231940808,2232136391,'Aries'],
  [2232136391,2232345449,'Taurus'],
  [2232345449,2232562936,'Gemini'],
  [2232562936,2232780080,'Cancer'],
  [2232780080,2232990256,'Leo'],
  [2232990256,2233191760,'Virgo'],
  [2233191760,2233385959,'Libra'],
  [2233385959,2233574621,'Scorpio'],
  [2233574621,2233758982,'Sagittarius'],
  [2233758982,2233940544,'Capricorn'],
  [2233940544,2234122143,'Aquarius'],
  [2234122143,2234308054,'Pisces'],
  [2234308054,2234502858,'Aries'],
  [2234502858,2234709139,'Taurus'],
  [2234709139,2234924793,'Gemini'],
  [2234924793,2235142582,'Cancer'],
  [2235142582,2235354072,'Leo'],
  [2235354072,2235554834,'Virgo'],
  [2235554834,2235745542,'Libra'],
  [2235745542,2235929694,'Scorpio'],
  [2235929694,2236111264,'Sagittarius'],
  [2236111264,2236293504,'Capricorn'],
  [2236293504,2236478812,'Aquarius'],
  [2236478812,2236669180,'Pisces'],
  [2236669180,2236866583,'Aries'],
  [2236866583,2237072624,'Taurus'],
  [2237072624,2237286910,'Gemini'],
  [2237286910,2237505135,'Cancer'],
  [2237505135,2237719496,'Leo'],
  [2237719496,2237922943,'Virgo'],
  [2237922943,2238113372,'Libra'],
  [2238113372,2238293723,'Scorpio'],
  [2238293723,2238469651,'Sagittarius'],
  [2238469651,2238647191,'Capricorn'],
  [2238647191,2238831027,'Aquarius'],
  [2238831027,2239023418,'Pisces'],
  [2239023418,2239224273,'Aries'],
  [2239224273,2239432464,'Taurus'],
  [2239432464,2239646771,'Gemini'],
  [2239646771,2239864923,'Cancer'],
  [2239864923,2240081798,'Leo'],
  [2240081798,2240290093,'Virgo'],
  [2240290093,2240484607,'Libra'],
  [2240484607,2240665547,'Scorpio'],
  [2240665547,2240838029,'Sagittarius'],
  [2240838029,2241009479,'Capricorn'],
  [2241009479,2241187210,'Aquarius'],
  [2241187210,2241376233,'Pisces'],
  [2241376233,2241577385,'Aries'],
  [2241577385,2241787719,'Taurus'],
  [2241787719,2242003328,'Gemini'],
  [2242003328,2242221343,'Cancer'],
  [2242221343,2242438875,'Leo'],
  [2242438875,2242650940,'Virgo'],
  [2242650940,2242851553,'Libra'],
  [2242851553,2243037727,'Scorpio'],
  [2243037727,2243211941,'Sagittarius'],
  [2243211941,2243380915,'Capricorn'],
  [2243380915,2243552888,'Aquarius'],
  [2243552888,2243735260,'Pisces'],
  [2243735260,2243931938,'Aries'],
  [2243931938,2244141340,'Taurus'],
  [2244141340,2244357903,'Gemini'],
  [2244357903,2244576175,'Cancer'],
  [2244576175,2244792938,'Leo'],
  [2244792938,2245005521,'Virgo'],
  [2245005521,2245209994,'Libra'],
  [2245209994,2245402548,'Scorpio'],
  [2245402548,2245582681,'Sagittarius'],
  [2245582681,2245754531,'Capricorn'],
  [2245754531,2245925277,'Aquarius'],
  [2245925277,2246102785,'Pisces'],
  [2246102785,2246293210,'Aries'],
  [2246293210,2246498172,'Taurus'],
  [2246498172,2246713512,'Gemini'],
  [2246713512,2246932010,'Cancer'],
  [2246932010,2247148013,'Leo'],
  [2247148013,2247358829,'Virgo'],
  [2247358829,2247562874,'Libra'],
  [2247562874,2247758351,'Scorpio'],
  [2247758351,2247944229,'Sagittarius'],
  [2247944229,2248122079,'Capricorn'],
  [2248122079,2248296492,'Aquarius'],
  [2248296492,2248473881,'Pisces'],
  [2248473881,2248660595,'Aries'],
  [2248660595,2248860519,'Taurus'],
  [2248860519,2249072600,'Gemini'],
  [2249072600,2249290551,'Cancer'],
  [2249290551,2249506582,'Leo'],
  [2249506582,2249715810,'Virgo'],
  [2249715810,2249916966,'Libra'],
  [2249916966,2250110648,'Scorpio'],
  [2250110648,2250297901,'Sagittarius'],
  [2250297901,2250480207,'Capricorn'],
  [2250480207,2250660087,'Aquarius'],
  [2250660087,2250841365,'Pisces'],
  [2250841365,2251028673,'Aries'],
  [2251028673,2251226088,'Taurus'],
  [2251226088,2251434918,'Gemini'],
  [2251434918,2251651600,'Cancer'],
  [2251651600,2251868364,'Leo'],
  [2251868364,2252077808,'Virgo'],
  [2252077808,2252276825,'Libra'],
  [2252276825,2252466649,'Scorpio'],
  [2252466649,2252650707,'Sagittarius'],
  [2252650707,2252832638,'Capricorn'],
  [2252832638,2253015367,'Aquarius'],
  [2253015367,2253201118,'Pisces'],
  [2253201118,2253391986,'Aries'],
  [2253391986,2253590296,'Taurus'],
  [2253590296,2253797753,'Gemini'],
  [2253797753,2254013236,'Cancer'],
  [2254013236,2254231001,'Leo'],
  [2254231001,2254442615,'Virgo'],
  [2254442615,2254642256,'Libra'],
  [2254642256,2254829729,'Scorpio'],
  [2254829729,2255009290,'Sagittarius'],
  [2255009290,2255186821,'Capricorn'],
  [2255186821,2255367512,'Aquarius'],
  [2255367512,2255554472,'Pisces'],
  [2255554472,2255748587,'Aries'],
  [2255748587,2255949746,'Taurus'],
  [2255949746,2256158060,'Gemini'],
  [2256158060,2256373147,'Cancer'],
  [2256373147,2256591689,'Leo'],
  [2256591689,2256806379,'Virgo'],
  [2256806379,2257009496,'Libra'],
  [2257009496,2257198154,'Scorpio'],
  [2257198154,2257375522,'Sagittarius'],
  [2257375522,2257548284,'Capricorn'],
  [2257548284,2257723667,'Aquarius'],
  [2257723667,2257907202,'Pisces'],
  [2257907202,2258101079,'Aries'],
  [2258101079,2258304243,'Taurus'],
  [2258304243,2258514490,'Gemini'],
  [2258514490,2258730118,'Cancer'],
  [2258730118,2258948952,'Leo'],
  [2258948952,2259165974,'Virgo'],
  [2259165974,2259373741,'Libra'],
  [2259373741,2259566957,'Scorpio'],
  [2259566957,2259746231,'Sagittarius'],
  [2259746231,2259917287,'Capricorn'],
  [2259917287,2260087947,'Aquarius'],
  [2260087947,2260265623,'Pisces'],
  [2260265623,2260455125,'Aries'],
  [2260455125,2260657000,'Taurus'],
  [2260657000,2260868207,'Gemini'],
  [2260868207,2261084769,'Cancer'],
  [2261084769,2261303542,'Leo'],
  [2261303542,2261521054,'Virgo'],
  [2261521054,2261731985,'Libra'],
  [2261731985,2261930786,'Scorpio'],
  [2261930786,2262115476,'Sagittarius'],
  [2262115476,2262289293,'Capricorn'],
  [2262289293,2262458962,'Aquarius'],
  [2262458962,2262632222,'Pisces'],
  [2262632222,2262815739,'Aries'],
  [2262815739,2263012902,'Taurus'],
  [2263012902,2263222395,'Gemini'],
  [2263222395,2263439234,'Cancer'],
  [2263439234,2263657931,'Leo'],
  [2263657931,2263874446,'Virgo'],
  [2263874446,2264085389,'Libra'],
  [2264085389,2264287295,'Scorpio'],
  [2264287295,2264477795,'Sagittarius'],
  [2264477795,2264657606,'Capricorn'],
  [2264657606,2264830894,'Aquarius'],
  [2264830894,2265003974,'Pisces'],
  [2265003974,2265183630,'Aries'],
  [2265183630,2265375229,'Taurus'],
  [2265375229,2265580486,'Gemini'],
  [2265580486,2265795988,'Cancer'],
  [2265795988,2266014715,'Leo'],
  [2266014715,2266230204,'Virgo'],
  [2266230204,2266438920,'Libra'],
  [2266438920,2266639677,'Scorpio'],
  [2266639677,2266832300,'Sagittarius'],
  [2266832300,2267017363,'Capricorn'],
  [2267017363,2267196767,'Aquarius'],
  [2267196767,2267374096,'Pisces'],
  [2267374096,2267554346,'Aries'],
  [2267554346,2267742915,'Taurus'],
  [2267742915,2267943687,'Gemini'],
  [2267943687,2268156349,'Cancer'],
  [2268156349,2268374899,'Leo'],
  [2268374899,2268590633,'Virgo'],
  [2268590633,2268797613,'Libra'],
  [2268797613,2268994874,'Scorpio'],
  [2268994874,2269184714,'Sagittarius'],
  [2269184714,2269370113,'Capricorn'],
  [2269370113,2269553391,'Aquarius'],
  [2269553391,2269736289,'Pisces'],
  [2269736289,2269920963,'Aries'],
  [2269920963,2270110746,'Taurus'],
  [2270110746,2270309535,'Gemini'],
  [2270309535,2270519382,'Cancer'],
  [2270519382,2270737229,'Leo'],
  [2270737229,2270954500,'Virgo'],
  [2270954500,2271162399,'Libra'],
  [2271162399,2271357703,'Scorpio'],
  [2271357703,2271543120,'Sagittarius'],
  [2271543120,2271724029,'Capricorn'],
  [2271724029,2271905400,'Aquarius'],
  [2271905400,2272090131,'Pisces'],
  [2272090131,2272279123,'Aries'],
  [2272279123,2272472940,'Taurus'],
  [2272472940,2272673253,'Gemini'],
  [2272673253,2272882148,'Cancer'],
  [2272882148,2273099092,'Leo'],
  [2273099092,2273318029,'Virgo'],
  [2273318029,2273529339,'Libra'],
  [2273529339,2273726602,'Scorpio'],
  [2273726602,2273910466,'Sagittarius'],
  [2273910466,2274086652,'Capricorn'],
  [2274086652,2274262229,'Aquarius'],
  [2274262229,2274442914,'Pisces'],
  [2274442914,2274631489,'Aries'],
  [2274631489,2274827939,'Taurus'],
  [2274827939,2275031396,'Gemini'],
  [2275031396,2275241655,'Cancer'],
  [2275241655,2275458333,'Leo'],
  [2275458333,2275677984,'Virgo'],
  [2275677984,2275892917,'Libra'],
  [2275892917,2276095183,'Scorpio'],
  [2276095183,2276282196,'Sagittarius'],
  [2276282196,2276457743,'Capricorn'],
  [2276457743,2276628951,'Aquarius'],
  [2276628951,2276803252,'Pisces'],
  [2276803252,2276986301,'Aries'],
  [2276986301,2277180500,'Taurus'],
  [2277180500,2277384985,'Gemini'],
  [2277384985,2277597221,'Cancer'],
  [2277597221,2277814609,'Leo'],
  [2277814609,2278034104,'Virgo'],
  [2278034104,2278250613,'Libra'],
  [2278250613,2278457578,'Scorpio'],
  [2278457578,2278650583,'Sagittarius'],
  [2278650583,2278830332,'Capricorn'],
  [2278830332,2279001994,'Aquarius'],
  [2279001994,2279172714,'Pisces'],
  [2279172714,2279349535,'Aries'],
  [2279349535,2279537703,'Taurus'],
  [2279537703,2279739029,'Gemini'],
  [2279739029,2279951246,'Cancer'],
  [2279951246,2280169465,'Leo'],
  [2280169465,2280388678,'Virgo'],
  [2280388678,2280604546,'Libra'],
  [2280604546,2280813055,'Scorpio'],
  [2280813055,2281010842,'Sagittarius'],
  [2281010842,2281196851,'Capricorn'],
  [2281196851,2281373378,'Aquarius'],
  [2281373378,2281545486,'Pisces'],
  [2281545486,2281719664,'Aries'],
  [2281719664,2281902358,'Taurus'],
  [2281902358,2282098147,'Gemini'],
  [2282098147,2282307414,'Cancer'],
  [2282307414,2282525313,'Leo'],
  [2282525313,2282744454,'Virgo'],
  [2282744454,2282958943,'Libra'],
  [2282958943,2283165915,'Scorpio'],
  [2283165915,2283364481,'Sagittarius'],
  [2283364481,2283554539,'Capricorn'],
  [2283554539,2283736930,'Aquarius'],
  [2283736930,2283914058,'Pisces'],
  [2283914058,2284090238,'Aries'],
  [2284090238,2284271206,'Taurus'],
  [2284271206,2284462672,'Gemini'],
  [2284462672,2284667726,'Cancer'],
  [2284667726,2284883832,'Leo'],
  [2284883832,2285102984,'Virgo'],
  [2285102984,2285316829,'Libra'],
  [2285316829,2285521440,'Scorpio'],
  [2285521440,2285717398,'Sagittarius'],
  [2285717398,2285906991,'Capricorn'],
  [2285906991,2286092155,'Aquarius'],
  [2286092155,2286274250,'Pisces'],
  [2286274250,2286455161,'Aries'],
  [2286455161,2286638424,'Taurus'],
  [2286638424,2286828967,'Gemini'],
  [2286828967,2287031066,'Cancer'],
  [2287031066,2287244859,'Leo'],
  [2287244859,2287463951,'Virgo'],
  [2287463951,2287678541,'Libra'],
  [2287678541,2287882278,'Scorpio'],
  [2287882278,2288075154,'Sagittarius'],
  [2288075154,2288261055,'Capricorn'],
  [2288261055,2288444274,'Aquarius'],
  [2288444274,2288627575,'Pisces'],
  [2288627575,2288812244,'Aries'],
  [2288812244,2288999637,'Taurus'],
  [2288999637,2289192473,'Gemini'],
  [2289192473,2289394260,'Cancer'],
  [2289394260,2289606555,'Leo'],
  [2289606555,2289825510,'Virgo'],
  [2289825510,2290041971,'Libra'],
  [2290041971,2290247395,'Scorpio'],
  [2290247395,2290439512,'Sagittarius'],
  [2290439512,2290621917,'Capricorn'],
  [2290621917,2290800462,'Aquarius'],
  [2290800462,2290980317,'Pisces'],
  [2290980317,2291164546,'Aries'],
  [2291164546,2291354353,'Taurus'],
  [2291354353,2291550502,'Gemini'],
  [2291550502,2291754270,'Cancer'],
  [2291754270,2291966617,'Leo'],
  [2291966617,2292185471,'Virgo'],
  [2292185471,2292403919,'Libra'],
  [2292403919,2292613054,'Scorpio'],
  [2292613054,2292807912,'Sagittarius'],
  [2292807912,2292989996,'Capricorn'],
  [2292989996,2293164933,'Aquarius'],
  [2293164933,2293339344,'Pisces'],
  [2293339344,2293518794,'Aries'],
  [2293518794,2293706644,'Taurus'],
  [2293706644,2293903913,'Gemini'],
  [2293903913,2294110035,'Cancer'],
  [2294110035,2294323720,'Leo'],
  [2294323720,2294542673,'Virgo'],
  [2294542673,2294762118,'Libra'],
  [2294762118,2294974965,'Scorpio'],
  [2294974965,2295175069,'Sagittarius'],
  [2295175069,2295360996,'Capricorn'],
  [2295360996,2295536314,'Aquarius'],
  [2295536314,2295707316,'Pisces'],
  [2295707316,2295880901,'Aries'],
  [2295880901,2296063014,'Taurus'],
  [2296063014,2296257179,'Gemini'],
  [2296257179,2296463382,'Cancer'],
  [2296463382,2296678405,'Leo'],
  [2296678405,2296897757,'Virgo'],
  [2296897757,2297116929,'Libra'],
  [2297116929,2297331258,'Scorpio'],
  [2297331258,2297536044,'Sagittarius'],
  [2297536044,2297728260,'Capricorn'],
  [2297728260,2297908448,'Aquarius'],
  [2297908448,2298080718,'Pisces'],
  [2298080718,2298251452,'Aries'],
  [2298251452,2298427780,'Taurus'],
  [2298427780,2298615864,'Gemini'],
  [2298615864,2298818480,'Cancer'],
  [2298818480,2299033016,'Leo'],
  [2299033016,2299252786,'Virgo'],
  [2299252786,2299471232,'Libra'],
  [2299471232,2299684430,'Scorpio'],
  [2299684430,2299890305,'Sagittarius'],
  [2299890305,2300087146,'Capricorn'],
  [2300087146,2300273963,'Aquarius'],
  [2300273963,2300451851,'Pisces'],
  [2300451851,2300624815,'Aries'],
  [2300624815,2300799209,'Taurus'],
  [2300799209,2300982178,'Gemini'],
  [2300982178,2301179189,'Cancer'],
  [2301179189,2301390578,'Leo'],
  [2301390578,2301609956,'Virgo'],
  [2301609956,2301828220,'Libra'],
  [2301828220,2302039599,'Scorpio'],
  [2302039599,2302243097,'Sagittarius'],
  [2302243097,2302439716,'Capricorn'],
  [2302439716,2302630002,'Aquarius'],
  [2302630002,2302813971,'Pisces'],
  [2302813971,2302992799,'Aries'],
  [2302992799,2303170272,'Taurus'],
  [2303170272,2303352407,'Gemini'],
  [2303352407,2303545471,'Cancer'],
  [2303545471,2303752608,'Leo'],
  [2303752608,2303970257,'Virgo'],
  [2303970257,2304188956,'Libra'],
  [2304188956,2304400066,'Scorpio'],
  [2304400066,2304600967,'Sagittarius'],
  [2304600967,2304793858,'Capricorn'],
  [2304793858,2304982010,'Aquarius'],
  [2304982010,2305167425,'Pisces'],
  [2305167425,2305350909,'Aries'],
  [2305350909,2305533828,'Taurus'],
  [2305533828,2305719492,'Gemini'],
  [2305719492,2305912682,'Cancer'],
  [2305912682,2306117292,'Leo'],
  [2306117292,2306332698,'Virgo'],
  [2306332698,2306551775,'Libra'],
  [2306551775,2306764685,'Scorpio'],
  [2306764685,2306965765,'Sagittarius'],
  [2306965765,2307155788,'Capricorn'],
  [2307155788,2307339136,'Aquarius'],
  [2307339136,2307520479,'Pisces'],
  [2307520479,2307703050,'Aries'],
  [2307703050,2307888632,'Taurus'],
  [2307888632,2308078681,'Gemini'],
  [2308078681,2308275230,'Cancer'],
  [2308275230,2308480481,'Leo'],
  [2308480481,2308694711,'Virgo'],
  [2308694711,2308913726,'Libra'],
  [2308913726,2309129239,'Scorpio'],
  [2309129239,2309333625,'Sagittarius'],
  [2309333625,2309524633,'Capricorn'],
  [2309524633,2309705339,'Aquarius'],
  [2309705339,2309881351,'Pisces'],
  [2309881351,2310058416,'Aries'],
  [2310058416,2310241011,'Taurus'],
  [2310241011,2310431700,'Gemini'],
  [2310431700,2310631207,'Cancer'],
  [2310631207,2310839042,'Leo'],
  [2310839042,2311053873,'Virgo'],
  [2311053873,2311272698,'Libra'],
  [2311272698,2311489959,'Scorpio'],
  [2311489959,2311698708,'Sagittarius'],
  [2311698708,2311894278,'Capricorn'],
  [2311894278,2312076851,'Aquarius'],
  [2312076851,2312250799,'Pisces'],
  [2312250799,2312422614,'Aries'],
  [2312422614,2312599030,'Taurus'],
  [2312599030,2312785391,'Gemini'],
  [2312785391,2312984006,'Cancer'],
  [2312984006,2313193402,'Leo'],
  [2313193402,2313409686,'Virgo'],
  [2313409686,2313628614,'Libra'],
  [2313628614,2313846132,'Scorpio'],
  [2313846132,2314057678,'Sagittarius'],
  [2314057678,2314258584,'Capricorn'],
  [2314258584,2314446500,'Aquarius'],
  [2314446500,2314623073,'Pisces'],
  [2314623073,2314793598,'Aries'],
  [2314793598,2314965327,'Taurus'],
  [2314965327,2315145563,'Gemini'],
  [2315145563,2315339408,'Cancer'],
  [2315339408,2315547163,'Leo'],
  [2315547163,2315763963,'Virgo'],
  [2315763963,2315983189,'Libra'],
  [2315983189,2316200026,'Scorpio'],
  [2316200026,2316411681,'Sagittarius'],
  [2316411681,2316615534,'Capricorn'],
  [2316615534,2316808955,'Aquarius'],
  [2316808955,2316991161,'Pisces'],
  [2316991161,2317164892,'Aries'],
  [2317164892,2317336161,'Taurus'],
  [2317336161,2317512530,'Gemini'],
  [2317512530,2317700875,'Cancer'],
  [2317700875,2317904302,'Leo'],
  [2317904302,2318119563,'Virgo'],
  [2318119563,2318338774,'Libra'],
  [2318338774,2318554922,'Scorpio'],
  [2318554922,2318764945,'Sagittarius'],
  [2318764945,2318968183,'Capricorn'],
  [2318968183,2319163912,'Aquarius'],
  [2319163912,2319351134,'Pisces'],
  [2319351134,2319530392,'Aries'],
  [2319530392,2319705262,'Taurus'],
  [2319705262,2319881914,'Gemini'],
  [2319881914,2320067282,'Cancer'],
  [2320067282,2320266285,'Leo'],
  [2320266285,2320478455,'Virgo'],
  [2320478455,2320696980,'Libra'],
  [2320696980,2320913068,'Scorpio'],
  [2320913068,2321121634,'Sagittarius'],
  [2321121634,2321322195,'Capricorn'],
  [2321322195,2321516139,'Aquarius'],
  [2321516139,2321704454,'Pisces'],
  [2321704454,2321887744,'Aries'],
  [2321887744,2322067707,'Taurus'],
  [2322067707,2322248120,'Gemini'],
  [2322248120,2322434301,'Cancer'],
  [2322434301,2322631210,'Leo'],
  [2322631210,2322840435,'Virgo'],
  [2322840435,2323057747,'Libra'],
  [2323057747,2323274527,'Scorpio'],
  [2323274527,2323483346,'Sagittarius'],
  [2323483346,2323681926,'Capricorn'],
  [2323681926,2323872160,'Aquarius'],
  [2323872160,2324057280,'Pisces'],
  [2324057280,2324240079,'Aries'],
  [2324240079,2324422730,'Taurus'],
  [2324422730,2324607497,'Gemini'],
  [2324607497,2324797276,'Cancer'],
  [2324797276,2324995235,'Leo'],
  [2324995235,2325203224,'Virgo'],
  [2325203224,2325419387,'Libra'],
  [2325419387,2325637211,'Scorpio'],
  [2325637211,2325848359,'Sagittarius'],
  [2325848359,2326047784,'Capricorn'],
  [2326047784,2326235809,'Aquarius'],
  [2326235809,2326416361,'Pisces'],
  [2326416361,2326594538,'Aries'],
  [2326594538,2326774943,'Taurus'],
  [2326774943,2326960826,'Gemini'],
  [2326960826,2327153935,'Cancer'],
  [2327153935,2327354943,'Leo'],
  [2327354943,2327563893,'Virgo'],
  [2327563893,2327779605,'Libra'],
  [2327779605,2327998154,'Scorpio'],
  [2327998154,2328212593,'Sagittarius'],
  [2328212593,2328415997,'Capricorn'],
  [2328415997,2328605698,'Aquarius'],
  [2328605698,2328784205,'Pisces'],
  [2328784205,2328957341,'Aries'],
  [2328957341,2329131929,'Taurus'],
  [2329131929,2329313883,'Gemini'],
  [2329313883,2329506502,'Cancer'],
  [2329506502,2329709619,'Leo'],
  [2329709619,2329920723,'Virgo'],
  [2329920723,2330136982,'Libra'],
  [2330136982,2330355597,'Scorpio'],
  [2330355597,2330572266,'Sagittarius'],
  [2330572266,2330780735,'Capricorn'],
  [2330780735,2330975849,'Aquarius'],
  [2330975849,2331157054,'Pisces'],
  [2331157054,2331328804,'Aries'],
  [2331328804,2331498458,'Taurus'],
  [2331498458,2331673904,'Gemini'],
  [2331673904,2331861318,'Cancer'],
  [2331861318,2332062611,'Leo'],
  [2332062611,2332274640,'Virgo'],
  [2332274640,2332491984,'Libra'],
  [2332491984,2332710408,'Scorpio'],
  [2332710408,2332927105,'Sagittarius'],
  [2332927105,2333138420,'Capricorn'],
  [2333138420,2333339476,'Aquarius'],
  [2333339476,2333527082,'Pisces'],
  [2333527082,2333702645,'Aries'],
  [2333702645,2333872026,'Taurus'],
  [2333872026,2334043245,'Gemini'],
  [2334043245,2334224165,'Cancer'],
  [2334224165,2334419767,'Leo'],
  [2334419767,2334629334,'Virgo'],
  [2334629334,2334846829,'Libra'],
  [2334846829,2335065332,'Scorpio'],
  [2335065332,2335280820,'Sagittarius'],
  [2335280820,2335491386,'Capricorn'],
  [2335491386,2335694738,'Aquarius'],
  [2335694738,2335888047,'Pisces'],
  [2335888047,2336070340,'Aries'],
  [2336070340,2336244499,'Taurus'],
  [2336244499,2336416715,'Gemini'],
  [2336416715,2336594504,'Cancer'],
  [2336594504,2336784368,'Leo'],
  [2336784368,2336988825,'Virgo'],
  [2336988825,2337204270,'Libra'],
  [2337204270,2337422829,'Scorpio'],
  [2337422829,2337637670,'Sagittarius'],
  [2337637670,2337845908,'Capricorn'],
  [2337845908,2338047138,'Aquarius'],
  [2338047138,2338241210,'Pisces'],
  [2338241210,2338427920,'Aries'],
  [2338427920,2338608329,'Taurus'],
  [2338608329,2338785784,'Gemini'],
  [2338785784,2338965565,'Cancer'],
  [2338965565,2339153469,'Leo'],
  [2339153469,2339353571,'Virgo'],
  [2339353571,2339565539,'Libra'],
  [2339565539,2339783465,'Scorpio'],
  [2339783465,2339998917,'Sagittarius'],
  [2339998917,2340206182,'Capricorn'],
  [2340206182,2340404140,'Aquarius'],
  [2340404140,2340594585,'Pisces'],
  [2340594585,2340780066,'Aries'],
  [2340780066,2340962915,'Taurus'],
  [2340962915,2341145377,'Gemini'],
  [2341145377,2341330122,'Cancer'],
  [2341330122,2341520444,'Leo'],
  [2341520444,2341719594,'Virgo'],
  [2341719594,2341928948,'Libra'],
  [2341928948,2342145686,'Scorpio'],
  [2342145686,2342362448,'Sagittarius'],
  [2342362448,2342571257,'Capricorn'],
  [2342571257,2342768310,'Aquarius'],
  [2342768310,2342954957,'Pisces'],
  [2342954957,2343135631,'Aries'],
  [2343135631,2343315360,'Taurus'],
  [2343315360,2343498119,'Gemini'],
  [2343498119,2343686186,'Cancer'],
  [2343686186,2343880552,'Leo'],
  [2343880552,2344081942,'Virgo'],
  [2344081942,2344291041,'Libra'],
  [2344291041,2344506906,'Scorpio'],
  [2344506906,2344724814,'Sagittarius'],
  [2344724814,2344936814,'Capricorn'],
  [2344936814,2345136399,'Aquarius'],
  [2345136399,2345322527,'Pisces'],
  [2345322527,2345499390,'Aries'],
  [2345499390,2345673669,'Taurus'],
  [2345673669,2345851877,'Gemini'],
  [2345851877,2346038402,'Cancer'],
  [2346038402,2346234403,'Leo'],
  [2346234403,2346438597,'Virgo'],
  [2346438597,2346649318,'Libra'],
  [2346649318,2346865241,'Scorpio'],
  [2346865241,2347083666,'Sagittarius'],
  [2347083666,2347298655,'Capricorn'],
  [2347298655,2347502854,'Aquarius'],
  [2347502854,2347692379,'Pisces'],
  [2347692379,2347869344,'Aries'],
  [2347869344,2348040220,'Taurus'],
  [2348040220,2348212837,'Gemini'],
  [2348212837,2348393977,'Cancer'],
  [2348393977,2348587189,'Leo'],
  [2348587189,2348791693,'Virgo'],
  [2348791693,2349003997,'Libra'],
  [2349003997,2349220681,'Scorpio'],
  [2349220681,2349439073,'Sagittarius'],
  [2349439073,2349655353,'Capricorn'],
  [2349655353,2349863607,'Aquarius'],
  [2349863607,2350058602,'Pisces'],
  [2350058602,2350239675,'Aries'],
  [2350239675,2350411404,'Taurus'],
  [2350411404,2350581253,'Gemini'],
  [2350581253,2350757026,'Cancer'],
  [2350757026,2350944634,'Leo'],
  [2350944634,2351145844,'Virgo'],
  [2351145844,2351357727,'Libra'],
  [2351357727,2351575006,'Scorpio'],
  [2351575006,2351793176,'Sagittarius'],
  [2351793176,2352008902,'Capricorn'],
  [2352008902,2352218475,'Aquarius'],
  [2352218475,2352417779,'Pisces'],
  [2352417779,2352604657,'Aries'],
  [2352604657,2352781045,'Taurus'],
  [2352781045,2352952491,'Gemini'],
  [2352952491,2353126178,'Cancer'],
  [2353126178,2353308920,'Leo'],
  [2353308920,2353504940,'Virgo'],
  [2353504940,2353713861,'Libra'],
  [2353713861,2353930660,'Scorpio'],
  [2353930660,2354148715,'Sagittarius'],
  [2354148715,2354363158,'Capricorn'],
  [2354363158,2354571231,'Aquarius'],
  [2354571231,2354771171,'Pisces'],
  [2354771171,2354961881,'Aries'],
  [2354961881,2355143938,'Taurus'],
  [2355143938,2355320367,'Gemini'],
  [2355320367,2355496244,'Cancer'],
  [2355496244,2355677545,'Leo'],
  [2355677545,2355869483,'Virgo'],
  [2355869483,2356074303,'Libra'],
  [2356074303,2356289309,'Scorpio'],
  [2356289309,2356507408,'Sagittarius'],
  [2356507408,2356721283,'Capricorn'],
  [2356721283,2356927008,'Aquarius'],
  [2356927008,2357124207,'Pisces'],
  [2357124207,2357314287,'Aries'],
  [2357314287,2357499054,'Taurus'],
  [2357499054,2357680530,'Gemini'],
  [2357680530,2357861370,'Cancer'],
  [2357861370,2358045206,'Leo'],
  [2358045206,2358236315,'Virgo'],
  [2358236315,2358438154,'Libra'],
  [2358438154,2358650802,'Scorpio'],
  [2358650802,2358868937,'Sagittarius'],
  [2358868937,2359083805,'Capricorn'],
  [2359083805,2359288809,'Aquarius'],
  [2359288809,2359482790,'Pisces'],
  [2359482790,2359668804,'Aries'],
  [2359668804,2359851253,'Taurus'],
  [2359851253,2360033773,'Gemini'],
  [2360033773,2360218532,'Cancer'],
  [2360218532,2360406871,'Leo'],
  [2360406871,2360600563,'Virgo'],
  [2360600563,2360802132,'Libra'],
  [2360802132,2361013149,'Scorpio'],
  [2361013149,2361231109,'Sagittarius'],
  [2361231109,2361448176,'Capricorn'],
  [2361448176,2361655414,'Aquarius'],
  [2361655414,2361848951,'Pisces'],
  [2361848951,2362031323,'Aries'],
  [2362031323,2362208555,'Taurus'],
  [2362208555,2362386909,'Gemini'],
  [2362386909,2362570697,'Cancer'],
  [2362570697,2362761392,'Leo'],
  [2362761392,2362958698,'Virgo'],
  [2362958698,2363162561,'Libra'],
  [2363162561,2363373675,'Scorpio'],
  [2363373675,2363591338,'Sagittarius'],
  [2363591338,2363810393,'Capricorn'],
  [2363810393,2364021909,'Aquarius'],
  [2364021909,2364219073,'Pisces'],
  [2364219073,2364401786,'Aries'],
  [2364401786,2364575572,'Taurus'],
  [2364575572,2364748025,'Gemini'],
  [2364748025,2364926041,'Cancer'],
  [2364926041,2365113773,'Leo'],
  [2365113773,2365311713,'Virgo'],
  [2365311713,2365518024,'Libra'],
  [2365518024,2365730773,'Scorpio'],
  [2365730773,2365948504,'Sagittarius'],
  [2365948504,2366168151,'Capricorn'],
  [2366168151,2366383207,'Aquarius'],
  [2366383207,2366586204,'Pisces'],
  [2366586204,2366773884,'Aries'],
  [2366773884,2366949192,'Taurus'],
  [2366949192,2367118983,'Gemini'],
  [2367118983,2367291071,'Cancer'],
  [2367291071,2367472099,'Leo'],
  [2367472099,2367665641,'Virgo'],
  [2367665641,2367871191,'Libra'],
  [2367871191,2368085228,'Scorpio'],
  [2368085228,2368303621,'Sagittarius'],
  [2368303621,2368522780,'Capricorn'],
  [2368522780,2368738503,'Aquarius'],
  [2368738503,2368945531,'Pisces'],
  [2368945531,2369139739,'Aries'],
  [2369139739,2369321015,'Taurus'],
  [2369321015,2369493576,'Gemini'],
  [2369493576,2369664113,'Cancer'],
  [2369664113,2369839824,'Leo'],
  [2369839824,2370026681,'Virgo'],
  [2370026681,2370227443,'Libra'],
  [2370227443,2370440143,'Scorpio'],
  [2370440143,2370658970,'Sagittarius'],
  [2370658970,2370877700,'Capricorn'],
  [2370877700,2371091933,'Aquarius'],
  [2371091933,2371298855,'Pisces'],
  [2371298855,2371496454,'Aries'],
  [2371496454,2371683959,'Taurus'],
  [2371683959,2371862854,'Gemini'],
  [2371862854,2372037076,'Cancer'],
  [2372037076,2372212348,'Leo'],
  [2372212348,2372394968,'Virgo'],
  [2372394968,2372590017,'Libra'],
  [2372590017,2372798758,'Scorpio'],
  [2372798758,2373016652,'Sagittarius'],
  [2373016652,2373235444,'Capricorn'],
  [2373235444,2373448299,'Aquarius'],
  [2373448299,2373652585,'Pisces'],
  [2373652585,2373848770,'Aries'],
  [2373848770,2374038191,'Taurus'],
  [2374038191,2374222148,'Gemini'],
  [2374222148,2374402304,'Cancer'],
  [2374402304,2374581614,'Leo'],
  [2374581614,2374764680,'Virgo'],
  [2374764680,2374956791,'Libra'],
  [2374956791,2375161496,'Scorpio'],
  [2375161496,2375377222,'Sagittarius'],
  [2375377222,2375596223,'Capricorn'],
  [2375596223,2375809239,'Aquarius'],
  [2375809239,2376011553,'Pisces'],
  [2376011553,2376204136,'Aries'],
  [2376204136,2376390699,'Taurus'],
  [2376390699,2376574726,'Gemini'],
  [2376574726,2376758255,'Cancer'],
  [2376758255,2376942488,'Leo'],
  [2376942488,2377129396,'Virgo'],
  [2377129396,2377322485,'Libra'],
  [2377322485,2377525503,'Scorpio'],
  [2377525503,2377739207,'Sagittarius'],
  [2377739207,2377958273,'Capricorn'],
  [2377958273,2378172957,'Aquarius'],
  [2378172957,2378375872,'Pisces'],
  [2378375872,2378566319,'Aries'],
  [2378566319,2378748646,'Taurus'],
  [2378748646,2378928526,'Gemini'],
  [2378928526,2379110319,'Cancer'],
  [2379110319,2379296124,'Leo'],
  [2379296124,2379486657,'Virgo'],
  [2379486657,2379682986,'Libra'],
  [2379682986,2379887096,'Scorpio'],
  [2379887096,2380100133,'Sagittarius'],
  [2380100133,2380319151,'Capricorn'],
  [2380319151,2380536060,'Aquarius'],
  [2380536060,2380742065,'Pisces'],
  [2380742065,2380933762,'Aries'],
  [2380933762,2381114152,'Taurus'],
  [2381114152,2381289493,'Gemini'],
  [2381289493,2381466163,'Cancer'],
  [2381466163,2381648732,'Leo'],
  [2381648732,2381839242,'Virgo'],
  [2381839242,2382037901,'Libra'],
  [2382037901,2382244387,'Scorpio'],
  [2382244387,2382458234,'Sagittarius'],
  [2382458234,2382677269,'Capricorn'],
  [2382677269,2382895753,'Aquarius'],
  [2382895753,2383105719,'Pisces'],
  [2383105719,2383301709,'Aries'],
  [2383301709,2383484100,'Taurus'],
  [2383484100,2383657934,'Gemini'],
  [2383657934,2383830041,'Cancer'],
  [2383830041,2384006897,'Leo'],
  [2384006897,2384193143,'Virgo'],
  [2384193143,2384390620,'Libra'],
  [2384390620,2384598340,'Scorpio'],
  [2384598340,2384813545,'Sagittarius'],
  [2384813545,2385032777,'Capricorn'],
  [2385032777,2385251533,'Aquarius'],
  [2385251533,2385464100,'Pisces'],
  [2385464100,2385665178,'Aries'],
  [2385665178,2385852782,'Taurus'],
  [2385852782,2386029379,'Gemini'],
  [2386029379,2386200537,'Cancer'],
  [2386200537,2386373059,'Leo'],
  [2386373059,2386553442,'Virgo'],
  [2386553442,2386746233,'Libra'],
  [2386746233,2386952228,'Scorpio'],
  [2386952228,2387167884,'Sagittarius'],
  [2387167884,2387387407,'Capricorn'],
  [2387387407,2387605461,'Aquarius'],
  [2387605461,2387818026,'Pisces'],
  [2387818026,2388021952,'Aries'],
  [2388021952,2388215081,'Taurus'],
  [2388215081,2388397475,'Gemini'],
  [2388397475,2388572083,'Cancer'],
  [2388572083,2388744307,'Leo'],
  [2388744307,2388920860,'Virgo'],
  [2388920860,2389108138,'Libra'],
  [2389108138,2389309759,'Scorpio'],
  [2389309759,2389523872,'Sagittarius'],
  [2389523872,2389743446,'Capricorn'],
  [2389743446,2389960790,'Aquarius'],
  [2389960790,2390171535,'Pisces'],
  [2390171535,2390374596,'Aries'],
  [2390374596,2390569947,'Taurus'],
  [2390569947,2390757555,'Gemini'],
  [2390757555,2390938114,'Cancer'],
  [2390938114,2391114332,'Leo'],
  [2391114332,2391291321,'Virgo'],
  [2391291321,2391475551,'Libra'],
  [2391475551,2391672556,'Scorpio'],
  [2391672556,2391883422,'Sagittarius'],
  [2391883422,2392102374,'Capricorn'],
  [2392102374,2392319830,'Aquarius'],
  [2392319830,2392529094,'Pisces'],
  [2392529094,2392729146,'Aries'],
  [2392729146,2392922228,'Taurus'],
  [2392922228,2393110596,'Gemini'],
  [2393110596,2393295279,'Cancer'],
  [2393295279,2393477064,'Leo'],
  [2393477064,2393658343,'Virgo'],
  [2393658343,2393843717,'Libra'],
  [2393843717,2394038646,'Scorpio'],
  [2394038646,2394246326,'Sagittarius'],
  [2394246326,2394463913,'Capricorn'],
  [2394463913,2394682302,'Aquarius'],
  [2394682302,2394892245,'Pisces'],
  [2394892245,2395090485,'Aries'],
  [2395090485,2395279532,'Taurus'],
  [2395279532,2395463932,'Gemini'],
  [2395463932,2395647307,'Cancer'],
  [2395647307,2395831425,'Leo'],
  [2395831425,2396017290,'Virgo'],
  [2396017290,2396206836,'Libra'],
  [2396206836,2396403363,'Scorpio'],
  [2396403363,2396609940,'Sagittarius'],
  [2396609940,2396826112,'Capricorn'],
  [2396826112,2397045453,'Aquarius'],
  [2397045453,2397258246,'Pisces'],
  [2397258246,2397458187,'Aries'],
  [2397458187,2397645650,'Taurus'],
  [2397645650,2397825417,'Gemini'],
  [2397825417,2398003278,'Cancer'],
  [2398003278,2398183869,'Leo'],
  [2398183869,2398369883,'Virgo'],
  [2398369883,2398562540,'Libra'],
  [2398562540,2398762592,'Scorpio'],
  [2398762592,2398970733,'Sagittarius'],
  [2398970733,2399186519,'Capricorn'],
  [2399186519,2399406147,'Aquarius'],
  [2399406147,2399622088,'Pisces'],
  [2399622088,2399826717,'Aries'],
  [2399826717,2400017139,'Taurus'],
  [2400017139,2400196043,'Gemini'],
  [2400196043,2400369280,'Cancer'],
  [2400369280,2400543425,'Leo'],
  [2400543425,2400724129,'Virgo'],
  [2400724129,2400914903,'Libra'],
  [2400914903,2401116434,'Scorpio'],
  [2401116434,2401327003,'Sagittarius'],
  [2401327003,2401543775,'Capricorn'],
  [2401543775,2401763253,'Aquarius'],
  [2401763253,2401980624,'Pisces'],
  [2401980624,2402189875,'Aries'],
  [2402189875,2402386303,'Taurus'],
  [2402386303,2402569328,'Gemini'],
  [2402569328,2402742693,'Cancer'],
  [2402742693,2402912833,'Leo'],
  [2402912833,2403087007,'Virgo'],
  [2403087007,2403271584,'Libra'],
  [2403271584,2403469930,'Scorpio'],
  [2403469930,2403680667,'Sagittarius'],
  [2403680667,2403898623,'Capricorn'],
  [2403898623,2404118134,'Aquarius'],
  [2404118134,2404335038,'Pisces'],
  [2404335038,2404545980,'Aries'],
  [2404545980,2404747437,'Taurus'],
  [2404747437,2404936990,'Gemini'],
  [2404936990,2405115261,'Cancer'],
  [2405115261,2405286558,'Leo'],
  [2405286558,2405457759,'Virgo'],
  [2405457759,2405636471,'Libra'],
  [2405636471,2405828769,'Scorpio'],
  [2405828769,2406036093,'Sagittarius'],
  [2406036093,2406253598,'Capricorn'],
  [2406253598,2406473273,'Aquarius'],
  [2406473273,2406689151,'Pisces'],
  [2406689151,2406898855,'Aries'],
  [2406898855,2407101374,'Taurus'],
  [2407101374,2407295353,'Gemini'],
  [2407295353,2407479867,'Cancer'],
  [2407479867,2407656372,'Leo'],
  [2407656372,2407829593,'Virgo'],
  [2407829593,2408006461,'Libra'],
  [2408006461,2408194015,'Scorpio'],
  [2408194015,2408396352,'Sagittarius'],
  [2408396352,2408611287,'Capricorn'],
  [2408611287,2408830674,'Aquarius'],
  [2408830674,2409046112,'Pisces'],
  [2409046112,2409253838,'Aries'],
  [2409253838,2409454070,'Taurus'],
  [2409454070,2409647871,'Gemini'],
  [2409647871,2409835527,'Cancer'],
  [2409835527,2410017383,'Leo'],
  [2410017383,2410195656,'Virgo'],
  [2410195656,2410375070,'Libra'],
  [2410375070,2410561725,'Scorpio'],
  [2410561725,2410760640,'Sagittarius'],
  [2410760640,2410972324,'Capricorn'],
  [2410972324,2411190774,'Aquarius'],
  [2411190774,2411406668,'Pisces'],
  [2411406668,2411613743,'Aries'],
  [2411613743,2411811253,'Taurus'],
  [2411811253,2412001643,'Gemini'],
  [2412001643,2412187621,'Cancer'],
  [2412187621,2412371007,'Leo'],
  [2412371007,2412553394,'Virgo'],
  [2412553394,2412737330,'Libra'],
  [2412737330,2412926632,'Scorpio'],
  [2412926632,2413125281,'Sagittarius'],
  [2413125281,2413334930,'Capricorn'],
  [2413334930,2413552253,'Aquarius'],
  [2413552253,2413769206,'Pisces'],
  [2413769206,2413977753,'Aries'],
  [2413977753,2414174702,'Taurus'],
  [2414174702,2414361870,'Gemini'],
  [2414361870,2414543428,'Cancer'],
  [2414543428,2414723653,'Leo'],
  [2414723653,2414905898,'Virgo'],
  [2414905898,2415092575,'Libra'],
  [2415092575,2415285583,'Scorpio'],
  [2415285583,2415486555,'Sagittarius'],
  [2415486555,2415696262,'Capricorn'],
  [2415696262,2415912913,'Aquarius'],
  [2415912913,2416130926,'Pisces'],
  [2416130926,2416342493,'Aries'],
  [2416342493,2416541982,'Taurus'],
  [2416541982,2416728902,'Gemini'],
  [2416728902,2416907019,'Cancer'],
  [2416907019,2417082076,'Leo'],
  [2417082076,2417259876,'Virgo'],
  [2417259876,2417444886,'Libra'],
  [2417444886,2417639297,'Scorpio'],
  [2417639297,2417842954,'Sagittarius'],
  [2417842954,2418054304,'Capricorn'],
  [2418054304,2418271071,'Aquarius'],
  [2418271071,2418489593,'Pisces'],
  [2418489593,2418704110,'Aries'],
  [2418704110,2418908259,'Taurus'],
  [2418908259,2419098734,'Gemini'],
  [2419098734,2419277122,'Cancer'],
  [2419277122,2419448859,'Leo'],
  [2419448859,2419621102,'Virgo'],
  [2419621102,2419800724,'Libra'],
  [2419800724,2419992280,'Scorpio'],
  [2419992280,2420196201,'Sagittarius'],
  [2420196201,2420409138,'Capricorn'],
  [2420409138,2420626635,'Aquarius'],
  [2420626635,2420845032,'Pisces'],
  [2420845032,2421060772,'Aries'],
  [2421060772,2421269094,'Taurus'],
  [2421269094,2421465373,'Gemini'],
  [2421465373,2421648236,'Cancer'],
  [2421648236,2421821001,'Leo'],
  [2421821001,2421990437,'Virgo'],
  [2421990437,2422164529,'Libra'],
  [2422164529,2422350240,'Scorpio'],
  [2422350240,2422550663,'Sagittarius'],
  [2422550663,2422763131,'Capricorn'],
  [2422763131,2422981247,'Aquarius'],
  [2422981247,2423199333,'Pisces'],
  [2423199333,2423414290,'Aries'],
  [2423414290,2423623759,'Taurus'],
  [2423623759,2423824492,'Gemini'],
  [2423824492,2424013680,'Cancer'],
  [2424013680,2424191702,'Leo'],
  [2424191702,2424363132,'Virgo'],
  [2424363132,2424535269,'Libra'],
  [2424535269,2424715919,'Scorpio'],
  [2424715919,2424910698,'Sagittarius'],
  [2424910698,2425119817,'Capricorn'],
  [2425119817,2425337380,'Aquarius'],
  [2425337380,2425555445,'Pisces'],
  [2425555445,2425769021,'Aries'],
  [2425769021,2425976578,'Taurus'],
  [2425976578,2426177443,'Gemini'],
  [2426177443,2426370325,'Cancer'],
  [2426370325,2426554447,'Leo'],
  [2426554447,2426731614,'Virgo'],
  [2426731614,2426906709,'Libra'],
  [2426906709,2427086408,'Scorpio'],
  [2427086408,2427277019,'Sagittarius'],
  [2427277019,2427481501,'Capricorn'],
  [2427481501,2427696840,'Aquarius'],
  [2427696840,2427915039,'Pisces'],
  [2427915039,2428128406,'Aries'],
  [2428128406,2428333656,'Taurus'],
  [2428333656,2428531185,'Gemini'],
  [2428531185,2428722444,'Cancer'],
  [2428722444,2428908558,'Leo'],
  [2428908558,2429090772,'Virgo'],
  [2429090772,2429271518,'Libra'],
  [2429271518,2429454782,'Scorpio'],
  [2429454782,2429645344,'Sagittarius'],
  [2429645344,2429846893,'Capricorn'],
  [2429846893,2430059375,'Aquarius'],
  [2430059375,2430277332,'Pisces'],
  [2430277332,2430492147,'Aries'],
  [2430492147,2430697485,'Taurus'],
  [2430697485,2430892155,'Gemini'],
  [2430892155,2431078775,'Cancer'],
  [2431078775,2431261269,'Leo'],
  [2431261269,2431443196,'Virgo'],
  [2431443196,2431627208,'Libra'],
  [2431627208,2431815305,'Scorpio'],
  [2431815305,2432009413,'Sagittarius'],
  [2432009413,2432211494,'Capricorn'],
  [2432211494,2432422405,'Aquarius'],
  [2432422405,2432639702,'Pisces'],
  [2432639702,2432856601,'Aries'],
  [2432856601,2433064960,'Taurus'],
  [2433064960,2433260403,'Gemini'],
  [2433260403,2433444159,'Cancer'],
  [2433444159,2433621264,'Leo'],
  [2433621264,2433797905,'Virgo'],
  [2433797905,2433979351,'Libra'],
  [2433979351,2434168606,'Scorpio'],
  [2434168606,2434366146,'Sagittarius'],
  [2434366146,2434571120,'Capricorn'],
  [2434571120,2434782702,'Aquarius'],
  [2434782702,2434999581,'Pisces'],
  [2434999581,2435217835,'Aries'],
  [2435217835,2435430287,'Taurus'],
  [2435430287,2435630153,'Gemini'],
  [2435630153,2435815571,'Cancer'],
  [2435815571,2435990368,'Leo'],
  [2435990368,2436161606,'Virgo'],
  [2436161606,2436336817,'Libra'],
  [2436336817,2436521789,'Scorpio'],
  [2436521789,2436718624,'Sagittarius'],
  [2436718624,2436925480,'Capricorn'],
  [2436925480,2437138907,'Aquarius'],
  [2437138907,2437356140,'Pisces'],
  [2437356140,2437574615,'Aries'],
  [2437574615,2437789705,'Taurus'],
  [2437789705,2437994881,'Gemini'],
  [2437994881,2438185673,'Cancer'],
  [2438185673,2438363054,'Leo'],
  [2438363054,2438532921,'Virgo'],
  [2438532921,2438703296,'Libra'],
  [2438703296,2438881860,'Scorpio'],
  [2438881860,2439073587,'Sagittarius'],
  [2439073587,2439278606,'Capricorn'],
  [2439278606,2439492698,'Aquarius'],
  [2439492698,2439710646,'Pisces'],
  [2439710646,2439928783,'Aries'],
  [2439928783,2440144062,'Taurus'],
  [2440144062,2440352193,'Gemini'],
  [2440352193,2440548621,'Cancer'],
  [2440548621,2440731821,'Leo'],
  [2440731821,2440905066,'Virgo'],
  [2440905066,2441075075,'Libra'],
  [2441075075,2441249638,'Scorpio'],
  [2441249638,2441435423,'Sagittarius'],
  [2441435423,2441635486,'Capricorn'],
  [2441635486,2441847579,'Aquarius'],
  [2441847579,2442065559,'Pisces'],
  [2442065559,2442283402,'Aries'],
  [2442283402,2442497393,'Taurus'],
  [2442497393,2442705047,'Gemini'],
  [2442705047,2442903904,'Cancer'],
  [2442903904,2443092332,'Leo'],
  [2443092332,2443271384,'Virgo'],
  [2443271384,2443445287,'Libra'],
  [2443445287,2443620290,'Scorpio'],
  [2443620290,2443802947,'Sagittarius'],
  [2443802947,2443998042,'Capricorn'],
  [2443998042,2444206240,'Aquarius'],
  [2444206240,2444422967,'Pisces'],
  [2444422967,2444640747,'Aries'],
  [2444640747,2444853619,'Taurus'],
  [2444853619,2445058908,'Gemini'],
  [2445058908,2445256195,'Cancer'],
  [2445256195,2445445939,'Leo'],
  [2445445939,2445629282,'Virgo'],
  [2445629282,2445808580,'Libra'],
  [2445808580,2445987624,'Scorpio'],
  [2445987624,2446171220,'Sagittarius'],
  [2446171220,2446364042,'Capricorn'],
  [2446364042,2446568674,'Aquarius'],
  [2446568674,2446783299,'Pisces'],
  [2446783299,2447001177,'Aries'],
  [2447001177,2447214248,'Taurus'],
  [2447214248,2447417804,'Gemini'],
  [2447417804,2447611703,'Cancer'],
  [2447611703,2447798597,'Leo'],
  [2447798597,2447981779,'Virgo'],
  [2447981779,2448164062,'Libra'],
  [2448164062,2448347732,'Scorpio'],
  [2448347732,2448535135,'Sagittarius'],
  [2448535135,2448729108,'Capricorn'],
  [2448729108,2448932317,'Aquarius'],
  [2448932317,2449145110,'Pisces'],
  [2449145110,2449363102,'Aries'],
  [2449363102,2449577879,'Taurus'],
  [2449577879,2449782128,'Gemini'],
  [2449782128,2449973983,'Cancer'],
  [2449973983,2450156689,'Leo'],
  [2450156689,2450335729,'Virgo'],
  [2450335729,2450516206,'Libra'],
  [2450516206,2450701333,'Scorpio'],
  [2450701333,2450892298,'Sagittarius'],
  [2450892298,2451089507,'Capricorn'],
  [2451089507,2451293829,'Aquarius'],
  [2451293829,2451506001,'Pisces'],
  [2451506001,2451724014,'Aries'],
  [2451724014,2451941162,'Taurus'],
  [2451941162,2452148734,'Gemini'],
  [2452148734,2452342001,'Cancer'],
  [2452342001,2452522767,'Leo'],
  [2452522767,2452697160,'Virgo'],
  [2452697160,2452872343,'Libra'],
  [2452872343,2453054043,'Scorpio'],
  [2453054043,2453244884,'Sagittarius'],
  [2453244884,2453444431,'Capricorn'],
  [2453444431,2453651170,'Aquarius'],
  [2453651170,2453864146,'Pisces'],
  [2453864146,2454082126,'Aries'],
  [2454082126,2454300896,'Taurus'],
  [2454300896,2454512741,'Gemini'],
  [2454512741,2454710799,'Cancer'],
  [2454710799,2454893948,'Leo'],
  [2454893948,2455066971,'Virgo'],
  [2455066971,2455237472,'Libra'],
  [2455237472,2455413054,'Scorpio'],
  [2455413054,2455599125,'Sagittarius'],
  [2455599125,2455797167,'Capricorn'],
  [2455797167,2456005083,'Aquarius'],
  [2456005083,2456219506,'Pisces'],
  [2456219506,2456437651,'Aries'],
  [2456437651,2456656492,'Taurus'],
  [2456656492,2456870852,'Gemini'],
  [2456870852,2457074370,'Cancer'],
  [2457074370,2457263480,'Leo'],
  [2457263480,2457440037,'Virgo'],
  [2457440037,2457610134,'Libra'],
  [2457610134,2457781452,'Scorpio'],
  [2457781452,2457961124,'Sagittarius'],
  [2457961124,2458153667,'Capricorn'],
  [2458153667,2458359268,'Aquarius'],
  [2458359268,2458574051,'Pisces'],
  [2458574051,2458792641,'Aries'],
  [2458792641,2459010653,'Taurus'],
  [2459010653,2459224480,'Gemini'],
  [2459224480,2459430371,'Cancer'],
  [2459430371,2459625153,'Leo'],
  [2459625153,2459808327,'Virgo'],
  [2459808327,2459983029,'Libra'],
  [2459983029,2460155069,'Scorpio'],
  [2460155069,2460331293,'Sagittarius'],
  [2460331293,2460517876,'Capricorn'],
  [2460517876,2460718204,'Aquarius'],
  [2460718204,2460930804,'Pisces'],
  [2460930804,2461149498,'Aries'],
  [2461149498,2461367092,'Taurus'],
  [2461367092,2461578884,'Gemini'],
  [2461578884,2461782999,'Cancer'],
  [2461782999,2461978967,'Leo'],
  [2461978967,2462166947,'Virgo'],
  [2462166947,2462348145,'Libra'],
  [2462348145,2462525413,'Scorpio'],
  [2462525413,2462703344,'Sagittarius'],
  [2462703344,2462887561,'Capricorn'],
  [2462887561,2463083101,'Aquarius'],
  [2463083101,2463291732,'Pisces'],
  [2463291732,2463509392,'Aries'],
  [2463509392,2463727455,'Taurus'],
  [2463727455,2463938314,'Gemini'],
  [2463938314,2464139315,'Cancer'],
  [2464139315,2464332002,'Leo'],
  [2464332002,2464519272,'Virgo'],
  [2464519272,2464703493,'Libra'],
  [2464703493,2464886246,'Scorpio'],
  [2464886246,2465069321,'Sagittarius'],
  [2465069321,2465255857,'Capricorn'],
  [2465255857,2465450168,'Aquarius'],
  [2465450168,2465655686,'Pisces'],
  [2465655686,2465871491,'Aries'],
  [2465871491,2466090351,'Taurus'],
  [2466090351,2466302532,'Gemini'],
  [2466302532,2466502574,'Cancer'],
  [2466502574,2466691534,'Leo'],
  [2466691534,2466874208,'Virgo'],
  [2466874208,2467055663,'Libra'],
  [2467055663,2467239200,'Scorpio'],
  [2467239200,2467426085,'Sagittarius'],
  [2467426085,2467617009,'Capricorn'],
  [2467617009,2467813747,'Aquarius'],
  [2467813747,2468018935,'Pisces'],
  [2468018935,2468233403,'Aries'],
  [2468233403,2468452760,'Taurus'],
  [2468452760,2468667704,'Gemini'],
  [2468667704,2468870139,'Cancer'],
  [2468870139,2469058585,'Leo'],
  [2469058585,2469237489,'Virgo'],
  [2469237489,2469413519,'Libra'],
  [2469413519,2469592584,'Scorpio'],
  [2469592584,2469778137,'Sagittarius'],
  [2469778137,2469971022,'Capricorn'],
  [2469971022,2470170985,'Aquarius'],
  [2470170985,2470378187,'Pisces'],
  [2470378187,2470592776,'Aries'],
  [2470592776,2470812267,'Taurus'],
  [2470812267,2471029708,'Gemini'],
  [2471029708,2471236531,'Cancer'],
  [2471236531,2471428409,'Leo'],
  [2471428409,2471607533,'Virgo'],
  [2471607533,2471780178,'Libra'],
  [2471780178,2471953526,'Scorpio'],
  [2471953526,2472133535,'Sagittarius'],
  [2472133535,2472323545,'Capricorn'],
  [2472323545,2472523937,'Aquarius'],
  [2472523937,2472733122,'Pisces'],
  [2472733122,2472948910,'Aries'],
  [2472948910,2473168476,'Taurus'],
  [2473168476,2473386941,'Gemini'],
  [2473386941,2473597545,'Cancer'],
  [2473597545,2473794858,'Leo'],
  [2473794858,2473978257,'Virgo'],
  [2473978257,2474151915,'Libra'],
  [2474151915,2474322472,'Scorpio'],
  [2474322472,2474496918,'Sagittarius'],
  [2474496918,2474681017,'Capricorn'],
  [2474681017,2474877796,'Aquarius'],
  [2474877796,2475086498,'Pisces'],
  [2475086498,2475303184,'Aries'],
  [2475303184,2475522917,'Taurus'],
  [2475522917,2475740969,'Gemini'],
  [2475740969,2475952802,'Cancer'],
  [2475952802,2476154355,'Leo'],
  [2476154355,2476343641,'Virgo'],
  [2476343641,2476522136,'Libra'],
  [2476522136,2476694386,'Scorpio'],
  [2476694386,2476866697,'Sagittarius'],
  [2476866697,2477045741,'Capricorn'],
  [2477045741,2477236926,'Aquarius'],
  [2477236926,2477442159,'Pisces'],
  [2477442159,2477658139,'Aries'],
  [2477658139,2477877948,'Taurus'],
  [2477877948,2478095075,'Gemini'],
  [2478095075,2478305661,'Cancer'],
  [2478305661,2478507979,'Leo'],
  [2478507979,2478701191,'Virgo'],
  [2478701191,2478885479,'Libra'],
  [2478885479,2479062809,'Scorpio'],
  [2479062809,2479237330,'Sagittarius'],
  [2479237330,2479414917,'Capricorn'],
  [2479414917,2479601848,'Aquarius'],
  [2479601848,2479802449,'Pisces'],
  [2479802449,2480015938,'Aries'],
  [2480015938,2480235420,'Taurus'],
  [2480235420,2480452099,'Gemini'],
  [2480452099,2480660731,'Cancer'],
  [2480660731,2480860733,'Leo'],
  [2480860733,2481053655,'Virgo'],
  [2481053655,2481240896,'Libra'],
  [2481240896,2481423422,'Scorpio'],
  [2481423422,2481602944,'Sagittarius'],
  [2481602944,2481783095,'Capricorn'],
  [2481783095,2481969242,'Aquarius'],
  [2481969242,2482166632,'Pisces'],
  [2482166632,2482377043,'Aries'],
  [2482377043,2482595682,'Taurus'],
  [2482595682,2482812879,'Gemini'],
  [2482812879,2483020872,'Cancer'],
  [2483020872,2483218094,'Leo'],
  [2483218094,2483407505,'Virgo'],
  [2483407505,2483592949,'Libra'],
  [2483592949,2483776933,'Scorpio'],
  [2483776933,2483960601,'Sagittarius'],
  [2483960601,2484145352,'Capricorn'],
  [2484145352,2484334213,'Aquarius'],
  [2484334213,2484531401,'Pisces'],
  [2484531401,2484739825,'Aries'],
  [2484739825,2484957392,'Taurus'],
  [2484957392,2485175813,'Gemini'],
  [2485175813,2485385517,'Cancer'],
  [2485385517,2485582313,'Leo'],
  [2485582313,2485768448,'Virgo'],
  [2485768448,2485949213,'Libra'],
  [2485949213,2486129661,'Scorpio'],
  [2486129661,2486312938,'Sagittarius'],
  [2486312938,2486500423,'Capricorn'],
  [2486500423,2486693159,'Aquarius'],
  [2486693159,2486892896,'Pisces'],
  [2486892896,2487101476,'Aries'],
  [2487101476,2487318309,'Taurus'],
  [2487318309,2487537808,'Gemini'],
  [2487537808,2487750894,'Cancer'],
  [2487750894,2487950814,'Leo'],
  [2487950814,2488137178,'Virgo'],
  [2488137178,2488314609,'Libra'],
  [2488314609,2488489478,'Scorpio'],
  [2488489478,2488667561,'Sagittarius'],
  [2488667561,2488852727,'Capricorn'],
  [2488852727,2489046605,'Aquarius'],
  [2489046605,2489249204,'Pisces'],
  [2489249204,2489459752,'Aries'],
  [2489459752,2489676735,'Taurus'],
  [2489676735,2489896482,'Gemini'],
  [2489896482,2490112458,'Cancer'],
  [2490112458,2490317598,'Leo'],
  [2490317598,2490508522,'Virgo'],
  [2490508522,2490687186,'Libra'],
  [2490687186,2490859158,'Scorpio'],
  [2490859158,2491031318,'Sagittarius'],
  [2491031318,2491210129,'Capricorn'],
  [2491210129,2491400102,'Aquarius'],
  [2491400102,2491602404,'Pisces'],
  [2491602404,2491814657,'Aries'],
  [2491814657,2492032644,'Taurus'],
  [2492032644,2492252071,'Gemini'],
  [2492252071,2492468651,'Cancer'],
  [2492468651,2492677628,'Leo'],
  [2492677628,2492874876,'Virgo'],
  [2492874876,2493059265,'Libra'],
  [2493059265,2493233607,'Scorpio'],
  [2493233607,2493403772,'Sagittarius'],
  [2493403772,2493577035,'Capricorn'],
  [2493577035,2493760339,'Aquarius'],
  [2493760339,2493957975,'Pisces'],
  [2493957975,2494169071,'Aries'],
  [2494169071,2494387750,'Taurus'],
  [2494387750,2494607055,'Gemini'],
  [2494607055,2494822422,'Cancer'],
  [2494822422,2495031526,'Leo'],
  [2495031526,2495232381,'Virgo'],
  [2495232381,2495423181,'Libra'],
  [2495423181,2495603833,'Scorpio'],
  [2495603833,2495777385,'Sagittarius'],
  [2495777385,2495949840,'Capricorn'],
  [2495949840,2496128601,'Aquarius'],
  [2496128601,2496320204,'Pisces'],
  [2496320204,2496527004,'Aries'],
  [2496527004,2496744563,'Taurus'],
  [2496744563,2496964011,'Gemini'],
  [2496964011,2497178268,'Cancer'],
  [2497178268,2497385056,'Leo'],
  [2497385056,2497584831,'Virgo'],
  [2497584831,2497777941,'Libra'],
  [2497777941,2497964066,'Scorpio'],
  [2497964066,2498143772,'Sagittarius'],
  [2498143772,2498320268,'Capricorn'],
  [2498320268,2498499367,'Aquarius'],
  [2498499367,2498687741,'Pisces'],
  [2498687741,2498889934,'Aries'],
  [2498889934,2499104651,'Taurus'],
  [2499104651,2499323916,'Gemini'],
  [2499323916,2499538352,'Cancer'],
  [2499538352,2499743405,'Leo'],
  [2499743405,2499939821,'Virgo'],
  [2499939821,2500130303,'Libra'],
  [2500130303,2500316841,'Scorpio'],
  [2500316841,2500500356,'Sagittarius'],
  [2500500356,2500682167,'Capricorn'],
  [2500682167,2500865412,'Aquarius'],
  [2500865412,2501054892,'Pisces'],
  [2501054892,2501255146,'Aries'],
  [2501255146,2501467159,'Taurus'],
  [2501467159,2501685729,'Gemini'],
  [2501685729,2501901469,'Cancer'],
  [2501901469,2502107184,'Leo'],
  [2502107184,2502301654,'Virgo'],
  [2502301654,2502487999,'Libra'],
  [2502487999,2502670459,'Scorpio'],
  [2502670459,2502852425,'Sagittarius'],
  [2502852425,2503036121,'Capricorn'],
  [2503036121,2503223407,'Aquarius'],
  [2503223407,2503416573,'Pisces'],
  [2503416573,2503618162,'Aries'],
  [2503618162,2503829290,'Taurus'],
  [2503829290,2504047162,'Gemini'],
  [2504047162,2504264495,'Cancer'],
  [2504264495,2504473085,'Leo'],
  [2504473085,2504668913,'Virgo'],
  [2504668913,2504853427,'Libra'],
  [2504853427,2505031333,'Scorpio'],
  [2505031333,2505208147,'Sagittarius'],
  [2505208147,2505388642,'Capricorn'],
  [2505388642,2505576045,'Aquarius'],
  [2505576045,2505771864,'Pisces'],
  [2505771864,2505976255,'Aries'],
  [2505976255,2506188449,'Taurus'],
  [2506188449,2506406171,'Gemini'],
  [2506406171,2506624572,'Cancer'],
  [2506624572,2506836700,'Leo'],
  [2506836700,2507036726,'Virgo'],
  [2507036726,2507223316,'Libra'],
  [2507223316,2507399733,'Scorpio'],
  [2507399733,2507571957,'Sagittarius'],
  [2507571957,2507746700,'Capricorn'],
  [2507746700,2507929752,'Aquarius'],
  [2507929752,2508124349,'Pisces'],
  [2508124349,2508330136,'Aries'],
  [2508330136,2508544032,'Taurus'],
  [2508544032,2508762219,'Gemini'],
  [2508762219,2508980839,'Cancer'],
  [2508980839,2509195268,'Leo'],
  [2509195268,2509400135,'Virgo'],
  [2509400135,2509591865,'Libra'],
  [2509591865,2509771024,'Scorpio'],
  [2509771024,2509942293,'Sagittarius'],
  [2509942293,2510112754,'Capricorn'],
  [2510112754,2510289919,'Aquarius'],
  [2510289919,2510479612,'Pisces'],
  [2510479612,2510683427,'Aries'],
  [2510683427,2510897768,'Taurus'],
  [2510897768,2511116553,'Gemini'],
  [2511116553,2511334827,'Cancer'],
  [2511334827,2511549385,'Leo'],
  [2511549385,2511757018,'Virgo'],
  [2511757018,2511954153,'Libra'],
  [2511954153,2512139005,'Scorpio'],
  [2512139005,2512313645,'Sagittarius'],
  [2512313645,2512483853,'Capricorn'],
  [2512483853,2512657301,'Aquarius'],
  [2512657301,2512841395,'Pisces'],
  [2512841395,2513040429,'Aries'],
  [2513040429,2513252755,'Taurus'],
  [2513252755,2513471484,'Gemini'],
  [2513471484,2513689390,'Cancer'],
  [2513689390,2513902610,'Leo'],
  [2513902610,2514109709,'Virgo'],
  [2514109709,2514309212,'Libra'],
  [2514309212,2514499303,'Scorpio'],
  [2514499303,2514679820,'Sagittarius'],
  [2514679820,2514853980,'Capricorn'],
  [2514853980,2515027954,'Aquarius'],
  [2515027954,2515209055,'Pisces'],
  [2515209055,2515403208,'Aries'],
  [2515403208,2515611634,'Taurus'],
  [2515611634,2515829086,'Gemini'],
  [2515829086,2516046946,'Cancer'],
  [2516046946,2516259031,'Leo'],
  [2516259031,2516463655,'Virgo'],
  [2516463655,2516661392,'Libra'],
  [2516661392,2516852662,'Scorpio'],
  [2516852662,2517037557,'Sagittarius'],
  [2517037557,2517217369,'Capricorn'],
  [2517217369,2517395696,'Aquarius'],
  [2517395696,2517578012,'Pisces'],
  [2517578012,2517769981,'Aries'],
  [2517769981,2517974716,'Taurus'],
  [2517974716,2518189929,'Gemini'],
  [2518189929,2518407968,'Cancer'],
  [2518407968,2518620503,'Leo'],
  [2518620503,2518823521,'Virgo'],
  [2518823521,2519017650,'Libra'],
  [2519017650,2519205549,'Scorpio'],
  [2519205549,2519389812,'Sagittarius'],
  [2519389812,2519572499,'Capricorn'],
  [2519572499,2519755748,'Aquarius'],
  [2519755748,2519942427,'Pisces'],
  [2519942427,2520136020,'Aries'],
  [2520136020,2520339405,'Taurus'],
  [2520339405,2520552544,'Gemini'],
  [2520552544,2520770595,'Cancer'],
  [2520770595,2520985225,'Leo'],
  [2520985225,2521189598,'Virgo'],
  [2521189598,2521382074,'Libra'],
  [2521382074,2521565521,'Scorpio'],
  [2521565521,2521744809,'Sagittarius'],
  [2521744809,2521924744,'Capricorn'],
  [2521924744,2522108886,'Aquarius'],
  [2522108886,2522299223,'Pisces'],
  [2522299223,2522496642,'Aries'],
  [2522496642,2522701646,'Taurus'],
  [2522701646,2522914165,'Gemini'],
  [2522914165,2523131901,'Cancer'],
  [2523131901,2523348898,'Leo'],
  [2523348898,2523557334,'Virgo'],
  [2523557334,2523752330,'Libra'],
  [2523752330,2523934581,'Scorpio'],
  [2523934581,2524109177,'Sagittarius'],
  [2524109177,2524282993,'Capricorn'],
  [2524282993,2524462435,'Aquarius'],
  [2524462435,2524651577,'Pisces'],
  [2524651577,2524851045,'Aries'],
  [2524851045,2525058843,'Taurus'],
  [2525058843,2525272536,'Gemini'],
  [2525272536,2525490058,'Cancer'],
  [2525490058,2525708128,'Leo'],
  [2525708128,2525920741,'Virgo'],
  [2525920741,2526121362,'Libra'],
  [2526121362,2526307333,'Scorpio'],
  [2526307333,2526481672,'Sagittarius'],
  [2526481672,2526651293,'Capricorn'],
  [2526651293,2526824248,'Aquarius'],
  [2526824248,2527007421,'Pisces'],
  [2527007421,2527204054,'Aries'],
  [2527204054,2527412391,'Taurus'],
  [2527412391,2527627651,'Gemini'],
  [2527627651,2527845537,'Cancer'],
  [2527845537,2528063266,'Leo'],
  [2528063266,2528277485,'Virgo'],
  [2528277485,2528483044,'Libra'],
  [2528483044,2528675464,'Scorpio'],
  [2528675464,2528854536,'Sagittarius'],
  [2528854536,2529025114,'Capricorn'],
  [2529025114,2529194914,'Aquarius'],
  [2529194914,2529372010,'Pisces'],
  [2529372010,2529562390,'Aries'],
  [2529562390,2529767207,'Taurus'],
  [2529767207,2529982118,'Gemini'],
  [2529982118,2530200517,'Cancer'],
  [2530200517,2530417600,'Leo'],
  [2530417600,2530630774,'Virgo'],
  [2530630774,2530837467,'Libra'],
  [2530837467,2531034464,'Scorpio'],
  [2531034464,2531219967,'Sagittarius'],
  [2531219967,2531395888,'Capricorn'],
  [2531395888,2531567762,'Aquarius'],
  [2531567762,2531742886,'Pisces'],
  [2531742886,2531928150,'Aries'],
  [2531928150,2532127455,'Taurus'],
  [2532127455,2532339341,'Gemini'],
  [2532339341,2532557370,'Cancer'],
  [2532557370,2532774293,'Leo'],
  [2532774293,2532985805,'Virgo'],
  [2532985805,2533190355,'Libra'],
  [2533190355,2533387284,'Scorpio'],
  [2533387284,2533576165,'Sagittarius'],
  [2533576165,2533757766,'Capricorn'],
  [2533757766,2533935033,'Aquarius'],
  [2533935033,2534112915,'Pisces'],
  [2534112915,2534297202,'Aries'],
  [2534297202,2534492666,'Taurus'],
  [2534492666,2534700628,'Gemini'],
  [2534700628,2534917131,'Cancer'],
  [2534917131,2535134364,'Leo'],
  [2535134364,2535345426,'Virgo'],
  [2535345426,2535547451,'Libra'],
  [2535547451,2535741062,'Scorpio'],
  [2535741062,2535928377,'Sagittarius'],
  [2535928377,2536111716,'Capricorn'],
  [2536111716,2536293417,'Aquarius'],
  [2536293417,2536476187,'Pisces'],
  [2536476187,2536663367,'Aries'],
  [2536663367,2536858547,'Taurus'],
  [2536858547,2537064087,'Gemini'],
  [2537064087,2537278778,'Cancer'],
  [2537278778,2537496503,'Leo'],
  [2537496503,2537708891,'Virgo'],
  [2537708891,2537910469,'Libra'],
  [2537910469,2538100986,'Scorpio'],
  [2538100986,2538283997,'Sagittarius'],
  [2538283997,2538464289,'Capricorn'],
  [2538464289,2538645985,'Aquarius'],
  [2538645985,2538831714,'Pisces'],
  [2538831714,2539022877,'Aries'],
  [2539022877,2539220629,'Taurus'],
  [2539220629,2539426290,'Gemini'],
  [2539426290,2539639974,'Cancer'],
  [2539639974,2539858126,'Leo'],
  [2539858126,2540073037,'Virgo'],
  [2540073037,2540277003,'Libra'],
  [2540277003,2540467328,'Scorpio'],
  [2540467328,2540647054,'Sagittarius'],
  [2540647054,2540822366,'Capricorn'],
  [2540822366,2540999731,'Aquarius'],
  [2540999731,2541183844,'Pisces'],
  [2541183844,2541376492,'Aries'],
  [2541376492,2541577122,'Taurus'],
  [2541577122,2541784724,'Gemini'],
  [2541784724,2541998669,'Cancer'],
  [2541998669,2542217053,'Leo'],
  [2542217053,2542434363,'Virgo'],
  [2542434363,2542642557,'Libra'],
  [2542642557,2542836261,'Scorpio'],
  [2542836261,2543016309,'Sagittarius'],
  [2543016309,2543188520,'Capricorn'],
  [2543188520,2543360553,'Aquarius'],
  [2543360553,2543539366,'Pisces'],
  [2543539366,2543729109,'Aries'],
  [2543729109,2543929956,'Taurus'],
  [2543929956,2544139325,'Gemini'],
  [2544139325,2544354380,'Cancer'],
  [2544354380,2544572867,'Leo'],
  [2544572867,2544791225,'Virgo'],
  [2544791225,2545003185,'Libra'],
  [2545003185,2545202342,'Scorpio'],
  [2545202342,2545386694,'Sagittarius'],
  [2545386694,2545559985,'Capricorn'],
  [2545559985,2545729402,'Aquarius'],
  [2545729402,2545902840,'Pisces'],
  [2545902840,2546086737,'Aries'],
  [2546086737,2546283904,'Taurus'],
  [2546283904,2546492658,'Gemini'],
  [2546492658,2546708531,'Cancer'],
  [2546708531,2546927149,'Leo'],
  [2546927149,2547145051,'Virgo'],
  [2547145051,2547358185,'Libra'],
  [2547358185,2547561649,'Scorpio'],
  [2547561649,2547752133,'Sagittarius'],
  [2547752133,2547930558,'Capricorn'],
  [2547930558,2548101962,'Aquarius'],
  [2548101962,2548273469,'Pisces'],
  [2548273469,2548452273,'Aries'],
  [2548452273,2548643617,'Taurus'],
  [2548643617,2548848658,'Gemini'],
  [2548848658,2549063732,'Cancer'],
  [2549063732,2549282484,'Leo'],
  [2549282484,2549499430,'Virgo'],
  [2549499430,2549711080,'Libra'],
  [2549711080,2549915015,'Scorpio'],
  [2549915015,2550109418,'Sagittarius'],
  [2550109418,2550294022,'Capricorn'],
  [2550294022,2550471141,'Aquarius'],
  [2550471141,2550645495,'Pisces'],
  [2550645495,2550823156,'Aries'],
  [2550823156,2551010082,'Taurus'],
  [2551010082,2551210059,'Gemini'],
  [2551210059,2551422316,'Cancer'],
  [2551422316,2551640803,'Leo'],
  [2551640803,2551857540,'Virgo'],
  [2551857540,2552067178,'Libra'],
  [2552067178,2552268269,'Scorpio'],
  [2552268269,2552461690,'Sagittarius'],
  [2552461690,2552648897,'Capricorn'],
  [2552648897,2552831479,'Aquarius'],
  [2552831479,2553011623,'Pisces'],
  [2553011623,2553192713,'Aries'],
  [2553192713,2553379305,'Taurus'],
  [2553379305,2553575949,'Gemini'],
  [2553575949,2553784686,'Cancer'],
  [2553784686,2554002132,'Leo'],
  [2554002132,2554219760,'Virgo'],
  [2554219760,2554429281,'Libra'],
  [2554429281,2554627623,'Scorpio'],
  [2554627623,2554816860,'Sagittarius'],
  [2554816860,2555001186,'Capricorn'],
  [2555001186,2555184311,'Aquarius'],
  [2555184311,2555368405,'Pisces'],
  [2555368405,2555554667,'Aries'],
  [2555554667,2555744817,'Taurus'],
  [2555744817,2555941822,'Gemini'],
  [2555941822,2556148556,'Cancer'],
  [2556148556,2556364562,'Leo'],
  [2556364562,2556583421,'Virgo'],
  [2556583421,2556795366,'Libra'],
  [2556795366,2556994170,'Scorpio'],
  [2556994170,2557180518,'Sagittarius'],
  [2557180518,2557359737,'Capricorn'],
  [2557359737,2557538131,'Aquarius'],
  [2557538131,2557720413,'Pisces'],
  [2557720413,2557908567,'Aries'],
  [2557908567,2558102646,'Taurus'],
  [2558102646,2558302816,'Gemini'],
  [2558302816,2558510263,'Cancer'],
  [2558510263,2558725492,'Leo'],
  [2558725492,2558944991,'Virgo'],
  [2558944991,2559160341,'Libra'],
  [2559160341,2559363124,'Scorpio'],
  [2559363124,2559550905,'Sagittarius'],
  [2559550905,2559727743,'Capricorn'],
  [2559727743,2559900767,'Aquarius'],
  [2559900767,2560077012,'Pisces'],
  [2560077012,2560261317,'Aries'],
  [2560261317,2560455229,'Taurus'],
  [2560455229,2560657808,'Gemini'],
  [2560657808,2560867564,'Cancer'],
  [2560867564,2561083348,'Leo'],
  [2561083348,2561302821,'Virgo'],
  [2561302821,2561520302,'Libra'],
  [2561520302,2561728020,'Scorpio'],
  [2561728020,2561921019,'Sagittarius'],
  [2561921019,2562100404,'Capricorn'],
  [2562100404,2562271977,'Aquarius'],
  [2562271977,2562443208,'Pisces'],
  [2562443208,2562620975,'Aries'],
  [2562620975,2562809826,'Taurus'],
  [2562809826,2563010784,'Gemini'],
  [2563010784,2563221618,'Cancer'],
  [2563221618,2563438598,'Leo'],
  [2563438598,2563657974,'Virgo'],
  [2563657974,2563875502,'Libra'],
  [2563875502,2564085919,'Scorpio'],
  [2564085919,2564284472,'Sagittarius'],
  [2564284472,2564469782,'Capricorn'],
  [2564469782,2564644848,'Aquarius'],
  [2564644848,2564815635,'Pisces'],
  [2564815635,2564989138,'Aries'],
  [2564989138,2565171746,'Taurus'],
  [2565171746,2565367487,'Gemini'],
  [2565367487,2565576227,'Cancer'],
  [2565576227,2565793459,'Leo'],
  [2565793459,2566012920,'Virgo'],
  [2566012920,2566229377,'Libra'],
  [2566229377,2566439292,'Scorpio'],
  [2566439292,2566640216,'Sagittarius'],
  [2566640216,2566830836,'Capricorn'],
  [2566830836,2567011929,'Aquarius'],
  [2567011929,2567186763,'Pisces'],
  [2567186763,2567360657,'Aries'],
  [2567360657,2567539936,'Taurus'],
  [2567539936,2567730364,'Gemini'],
  [2567730364,2567934740,'Cancer'],
  [2567934740,2568150392,'Leo'],
  [2568150392,2568369840,'Virgo'],
  [2568369840,2568585460,'Libra'],
  [2568585460,2568793242,'Scorpio'],
  [2568793242,2568992698,'Sagittarius'],
  [2568992698,2569184685,'Capricorn'],
  [2569184685,2569370191,'Aquarius'],
  [2569370191,2569550614,'Pisces'],
  [2569550614,2569728680,'Aries'],
  [2569728680,2569908942,'Taurus'],
  [2569908942,2570097018,'Gemini'],
  [2570097018,2570297455,'Cancer'],
  [2570297455,2570510383,'Leo'],
  [2570510383,2570729468,'Virgo'],
  [2570729468,2570945259,'Libra'],
  [2570945259,2571151569,'Scorpio'],
  [2571151569,2571347939,'Sagittarius'],
  [2571347939,2571537276,'Capricorn'],
  [2571537276,2571722729,'Aquarius'],
  [2571722729,2571906242,'Pisces'],
  [2571906242,2572089059,'Aries'],
  [2572089059,2572273274,'Taurus'],
  [2572273274,2572462676,'Gemini'],
  [2572462676,2572661681,'Cancer'],
  [2572661681,2572872323,'Leo'],
  [2572872323,2573090793,'Virgo'],
  [2573090793,2573307792,'Libra'],
  [2573307792,2573514764,'Scorpio'],
  [2573514764,2573709378,'Sagittarius'],
  [2573709378,2573894884,'Capricorn'],
  [2573894884,2574076451,'Aquarius'],
  [2574076451,2574258307,'Pisces'],
  [2574258307,2574442670,'Aries'],
  [2574442670,2574630550,'Taurus'],
  [2574630550,2574823416,'Gemini'],
  [2574823416,2575023806,'Cancer'],
  [2575023806,2575233801,'Leo'],
  [2575233801,2575451751,'Virgo'],
  [2575451751,2575670366,'Libra'],
  [2575670366,2575880196,'Scorpio'],
  [2575880196,2576076196,'Sagittarius'],
  [2576076196,2576260022,'Capricorn'],
  [2576260022,2576437262,'Aquarius'],
  [2576437262,2576614096,'Pisces'],
  [2576614096,2576795223,'Aries'],
  [2576795223,2576983075,'Taurus'],
  [2576983075,2577178418,'Gemini'],
  [2577178418,2577381538,'Cancer'],
  [2577381538,2577592647,'Leo'],
  [2577592647,2577810518,'Virgo'],
  [2577810518,2578030236,'Libra'],
  [2578030236,2578243697,'Scorpio'],
  [2578243697,2578444094,'Sagittarius'],
  [2578444094,2578630228,'Capricorn'],
  [2578630228,2578806194,'Aquarius'],
  [2578806194,2578978500,'Pisces'],
  [2578978500,2579153731,'Aries'],
  [2579153731,2579337007,'Taurus'],
  [2579337007,2579530941,'Gemini'],
  [2579530941,2579735407,'Cancer'],
  [2579735407,2579948301,'Leo'],
  [2579948301,2580166659,'Virgo'],
  [2580166659,2580386490,'Libra'],
  [2580386490,2580602190,'Scorpio'],
  [2580602190,2580807679,'Sagittarius'],
  [2580807679,2580999491,'Capricorn'],
  [2580999491,2581178795,'Aquarius'],
  [2581178795,2581350518,'Pisces'],
  [2581350518,2581521404,'Aries'],
  [2581521404,2581698369,'Taurus'],
  [2581698369,2581886882,'Gemini'],
  [2581886882,2582089031,'Cancer'],
  [2582089031,2582302376,'Leo'],
  [2582302376,2582521462,'Virgo'],
  [2582521462,2582740829,'Libra'],
  [2582740829,2582956276,'Scorpio'],
  [2582956276,2583164285,'Sagittarius'],
  [2583164285,2583361792,'Capricorn'],
  [2583361792,2583547603,'Aquarius'],
  [2583547603,2583723640,'Pisces'],
  [2583723640,2583894867,'Aries'],
  [2583894867,2584068133,'Taurus'],
  [2584068133,2584250560,'Gemini'],
  [2584250560,2584447224,'Cancer'],
  [2584447224,2584658110,'Leo'],
  [2584658110,2584877193,'Virgo'],
  [2584877193,2585096327,'Libra'],
  [2585096327,2585310154,'Scorpio'],
  [2585310154,2585516924,'Sagittarius'],
  [2585516924,2585716170,'Capricorn'],
  [2585716170,2585907224,'Aquarius'],
  [2585907224,2586089904,'Pisces'],
  [2586089904,2586266156,'Aries'],
  [2586266156,2586440793,'Taurus'],
  [2586440793,2586620561,'Gemini'],
  [2586620561,2586812048,'Cancer'],
  [2586812048,2587018358,'Leo'],
  [2587018358,2587235788,'Virgo'],
  [2587235788,2587455088,'Libra'],
  [2587455088,2587668073,'Scorpio'],
  [2587668073,2587872124,'Sagittarius'],
  [2587872124,2588068686,'Capricorn'],
  [2588068686,2588259770,'Aquarius'],
  [2588259770,2588446206,'Pisces'],
  [2588446206,2588628393,'Aries'],
  [2588628393,2588808277,'Taurus'],
  [2588808277,2588990286,'Gemini'],
  [2588990286,2589180286,'Cancer'],
  [2589180286,2589382870,'Leo'],
  [2589382870,2589597530,'Virgo'],
  [2589597530,2589816826,'Libra'],
  [2589816826,2590030772,'Scorpio'],
  [2590030772,2590233893,'Sagittarius'],
  [2590233893,2590426976,'Capricorn'],
  [2590426976,2590613872,'Aquarius'],
  [2590613872,2590798191,'Pisces'],
  [2590798191,2590981953,'Aries'],
  [2590981953,2591166307,'Taurus'],
  [2591166307,2591353139,'Gemini'],
  [2591353139,2591545768,'Cancer'],
  [2591545768,2591747834,'Leo'],
  [2591747834,2591960457,'Virgo'],
  [2591960457,2592179280,'Libra'],
  [2592179280,2592395272,'Scorpio'],
  [2592395272,2592600530,'Sagittarius'],
  [2592600530,2592793098,'Capricorn'],
  [2592793098,2592976251,'Aquarius'],
  [2592976251,2593155259,'Pisces'],
  [2593155259,2593334937,'Aries'],
  [2593334937,2593518570,'Taurus'],
  [2593518570,2593708018,'Gemini'],
  [2593708018,2593904462,'Cancer'],
  [2593904462,2594108903,'Leo'],
  [2594108903,2594321540,'Virgo'],
  [2594321540,2594539868,'Libra'],
  [2594539868,2594757575,'Scorpio'],
  [2594757575,2594966762,'Sagittarius'],
  [2594966762,2595162669,'Capricorn'],
  [2595162669,2595346011,'Aquarius'],
  [2595346011,2595521492,'Pisces'],
  [2595521492,2595695364,'Aries'],
  [2595695364,2595873581,'Taurus'],
  [2595873581,2596060469,'Gemini'],
  [2596060469,2596257798,'Cancer'],
  [2596257798,2596464744,'Leo'],
  [2596464744,2596678960,'Virgo'],
  [2596678960,2596897340,'Libra'],
  [2596897340,2597115628,'Scorpio'],
  [2597115628,2597328094,'Sagittarius'],
  [2597328094,2597529226,'Capricorn'],
  [2597529226,2597716850,'Aquarius'],
  [2597716850,2597893283,'Pisces'],
  [2597893283,2598064207,'Aries'],
  [2598064207,2598236748,'Taurus'],
  [2598236748,2598417677,'Gemini'],
  [2598417677,2598611408,'Cancer'],
  [2598611408,2598818034,'Leo'],
  [2598818034,2599033492,'Virgo'],
  [2599033492,2599252395,'Libra'],
  [2599252395,2599470356,'Scorpio'],
  [2599470356,2599683821,'Sagittarius'],
  [2599683821,2599888913,'Capricorn'],
  [2599888913,2600082341,'Aquarius'],
  [2600082341,2600263630,'Pisces'],
  [2600263630,2600436220,'Aries'],
  [2600436220,2600606601,'Taurus'],
  [2600606601,2600782432,'Gemini'],
  [2600782432,2600970390,'Cancer'],
  [2600970390,2601173284,'Leo'],
  [2601173284,2601387928,'Virgo'],
  [2601387928,2601607127,'Libra'],
  [2601607127,2601824541,'Scorpio'],
  [2601824541,2602036968,'Sagittarius'],
  [2602036968,2602242759,'Capricorn'],
  [2602242759,2602439969,'Aquarius'],
  [2602439969,2602626999,'Pisces'],
  [2602626999,2602804683,'Aries'],
  [2602804683,2602977352,'Taurus'],
  [2602977352,2603151855,'Gemini'],
  [2603151855,2603335540,'Cancer'],
  [2603335540,2603533475,'Leo'],
  [2603533475,2603745127,'Virgo'],
  [2603745127,2603963741,'Libra'],
  [2603963741,2604180910,'Scorpio'],
  [2604180910,2604391811,'Sagittarius'],
  [2604391811,2604595581,'Capricorn'],
  [2604595581,2604792553,'Aquarius'],
  [2604792553,2604982500,'Pisces'],
  [2604982500,2605165357,'Aries'],
  [2605165357,2605343080,'Taurus'],
  [2605343080,2605520329,'Gemini'],
  [2605520329,2605703413,'Cancer'],
  [2605703413,2605898046,'Leo'],
  [2605898046,2606106114,'Virgo'],
  [2606106114,2606323228,'Libra'],
  [2606323228,2606540626,'Scorpio'],
  [2606540626,2606751098,'Sagittarius'],
  [2606751098,2606952504,'Capricorn'],
  [2606952504,2607146294,'Aquarius'],
  [2607146294,2607334631,'Pisces'],
  [2607334631,2607519041,'Aries'],
  [2607519041,2607700966,'Taurus'],
  [2607700966,2607882941,'Gemini'],
  [2607882941,2608068960,'Cancer'],
  [2608068960,2608263523,'Leo'],
  [2608263523,2608469386,'Virgo'],
  [2608469386,2608684778,'Libra'],
  [2608684778,2608902693,'Scorpio'],
  [2608902693,2609114578,'Sagittarius'],
  [2609114578,2609315680,'Capricorn'],
  [2609315680,2609506485,'Aquarius'],
  [2609506485,2609690472,'Pisces'],
  [2609690472,2609871683,'Aries'],
  [2609871683,2610053471,'Taurus'],
  [2610053471,2610238357,'Gemini'],
  [2610238357,2610428448,'Cancer'],
  [2610428448,2610625763,'Leo'],
  [2610625763,2610831852,'Virgo'],
  [2610831852,2611046223,'Libra'],
  [2611046223,2611264554,'Scorpio'],
  [2611264554,2611479165,'Sagittarius'],
  [2611479165,2611683045,'Capricorn'],
  [2611683045,2611873985,'Aquarius'],
  [2611873985,2612054705,'Pisces'],
  [2612054705,2612230618,'Aries'],
  [2612230618,2612407636,'Taurus'],
  [2612407636,2612590573,'Gemini'],
  [2612590573,2612782081,'Cancer'],
  [2612782081,2612982486,'Leo'],
  [2612982486,2613190747,'Virgo'],
  [2613190747,2613405371,'Libra'],
  [2613405371,2613623763,'Scorpio'],
  [2613623763,2613840791,'Sagittarius'],
  [2613840791,2614049394,'Capricorn'],
  [2614049394,2614244491,'Aquarius'],
  [2614244491,2614426107,'Pisces'],
  [2614426107,2614598973,'Aries'],
  [2614598973,2614770224,'Taurus'],
  [2614770224,2614947137,'Gemini'],
  [2614947137,2615135054,'Cancer'],
  [2615135054,2615335399,'Leo'],
  [2615335399,2615545571,'Virgo'],
  [2615545571,2615761472,'Libra'],
  [2615761472,2615979802,'Scorpio'],
  [2615979802,2616197510,'Sagittarius'],
  [2616197510,2616409839,'Capricorn'],
  [2616409839,2616611038,'Aquarius'],
  [2616611038,2616798017,'Pisces'],
  [2616798017,2616972836,'Aries'],
  [2616972836,2617141842,'Taurus'],
  [2617141842,2617313165,'Gemini'],
  [2617313165,2617494437,'Cancer'],
  [2617494437,2617690127,'Leo'],
  [2617690127,2617899149,'Virgo'],
  [2617899149,2618115891,'Libra'],
  [2618115891,2618334452,'Scorpio'],
  [2618334452,2618551364,'Sagittarius'],
  [2618551364,2618764174,'Capricorn'],
  [2618764174,2618969273,'Aquarius'],
  [2618969273,2619162808,'Pisces'],
  [2619162808,2619343819,'Aries'],
  [2619343819,2619515966,'Taurus'],
  [2619515966,2619686252,'Gemini'],
  [2619686252,2619862707,'Cancer'],
  [2619862707,2620051973,'Leo'],
  [2620051973,2620256261,'Virgo'],
  [2620256261,2620471588,'Libra'],
  [2620471588,2620690359,'Scorpio'],
  [2620690359,2620906507,'Sagittarius'],
  [2620906507,2621117428,'Capricorn'],
  [2621117428,2621321924,'Aquarius'],
  [2621321924,2621518352,'Pisces'],
  [2621518352,2621705339,'Aries'],
  [2621705339,2621883898,'Taurus'],
  [2621883898,2622058282,'Gemini'],
  [2622058282,2622234924,'Cancer'],
  [2622234924,2622420513,'Leo'],
  [2622420513,2622619465,'Virgo'],
  [2622619465,2622831145,'Libra'],
  [2622831145,2623049237,'Scorpio'],
  [2623049237,2623265543,'Sagittarius'],
  [2623265543,2623474955,'Capricorn'],
  [2623474955,2623676365,'Aquarius'],
  [2623676365,2623870589,'Pisces'],
  [2623870589,2624058644,'Aries'],
  [2624058644,2624241708,'Taurus'],
  [2624241708,2624421962,'Gemini'],
  [2624421962,2624603060,'Cancer'],
  [2624603060,2624789701,'Leo'],
  [2624789701,2624986227,'Virgo'],
  [2624986227,2625194334,'Libra'],
  [2625194334,2625410799,'Scorpio'],
  [2625410799,2625627884,'Sagittarius'],
  [2625627884,2625837884,'Capricorn'],
  [2625837884,2626037412,'Aquarius'],
  [2626037412,2626227594,'Pisces'],
  [2626227594,2626411864,'Aries'],
  [2626411864,2626593912,'Taurus'],
  [2626593912,2626776705,'Gemini'],
  [2626776705,2626962463,'Cancer'],
  [2626962463,2627153200,'Leo'],
  [2627153200,2627351122,'Virgo'],
  [2627351122,2627557954,'Libra'],
  [2627557954,2627772901,'Scorpio'],
  [2627772901,2627990728,'Sagittarius'],
  [2627990728,2628203169,'Capricorn'],
  [2628203169,2628403965,'Aquarius'],
  [2628403965,2628592293,'Pisces'],
  [2628592293,2628772046,'Aries'],
  [2628772046,2628949129,'Taurus'],
  [2628949129,2629129050,'Gemini'],
  [2629129050,2629315372,'Cancer'],
  [2629315372,2629509240,'Leo'],
  [2629509240,2629710366,'Virgo'],
  [2629710366,2629918452,'Libra'],
  [2629918452,2630132999,'Scorpio'],
  [2630132999,2630351206,'Sagittarius'],
  [2630351206,2630566497,'Capricorn'],
  [2630566497,2630771170,'Aquarius'],
  [2630771170,2630961506,'Pisces'],
  [2630961506,2631139797,'Aries'],
  [2631139797,2631312387,'Taurus'],
  [2631312387,2631486683,'Gemini'],
  [2631486683,2631668789,'Cancer'],
  [2631668789,2631861624,'Leo'],
  [2631861624,2632064423,'Virgo'],
  [2632064423,2632274595,'Libra'],
  [2632274595,2632489894,'Scorpio'],
  [2632489894,2632708182,'Sagittarius'],
  [2632708182,2632925220,'Capricorn'],
  [2632925220,2633134203,'Aquarius'],
  [2633134203,2633329441,'Pisces'],
  [2633329441,2633510472,'Aries'],
  [2633510472,2633682251,'Taurus'],
  [2633682251,2633852433,'Gemini'],
  [2633852433,2634028725,'Cancer'],
  [2634028725,2634216628,'Leo'],
  [2634216628,2634417409,'Virgo'],
  [2634417409,2634628161,'Libra'],
  [2634628161,2634844451,'Scorpio'],
  [2634844451,2635062738,'Sagittarius'],
  [2635062738,2635279845,'Capricorn'],
  [2635279845,2635491180,'Aquarius'],
  [2635491180,2635691434,'Pisces'],
  [2635691434,2635877989,'Aries'],
  [2635877989,2636053205,'Taurus'],
  [2636053205,2636223333,'Gemini'],
  [2636223333,2636396065,'Cancer'],
  [2636396065,2636578367,'Leo'],
  [2636578367,2636774186,'Virgo'],
  [2636774186,2636982701,'Libra'],
  [2636982701,2637199004,'Scorpio'],
  [2637199004,2637417315,'Sagittarius'],
  [2637417315,2637633456,'Capricorn'],
  [2637633456,2637844292,'Aquarius'],
  [2637844292,2638046701,'Pisces'],
  [2638046701,2638238268,'Aries'],
  [2638238268,2638419265,'Taurus'],
  [2638419265,2638593415,'Gemini'],
  [2638593415,2638766802,'Cancer'],
  [2638766802,2638946171,'Leo'],
  [2638946171,2639137003,'Virgo'],
  [2639137003,2639341277,'Libra'],
  [2639341277,2639555949,'Scorpio'],
  [2639555949,2639774222,'Sagittarius'],
  [2639774222,2639989571,'Capricorn'],
  [2639989571,2640198303,'Aquarius'],
  [2640198303,2640399147,'Pisces'],
  [2640399147,2640591951,'Aries'],
  [2640591951,2640777305,'Taurus'],
  [2640777305,2640957096,'Gemini'],
  [2640957096,2641134850,'Cancer'],
  [2641134850,2641315427,'Leo'],
  [2641315427,2641504025,'Virgo'],
  [2641504025,2641704376,'Libra'],
  [2641704376,2641916300,'Scorpio'],
  [2641916300,2642134273,'Sagittarius'],
  [2642134273,2642349953,'Capricorn'],
  [2642349953,2642557282,'Aquarius'],
  [2642557282,2642754875,'Pisces'],
  [2642754875,2642944716,'Aries'],
  [2642944716,2643129788,'Taurus'],
  [2643129788,2643312676,'Gemini'],
  [2643312676,2643495450,'Cancer'],
  [2643495450,2643680368,'Leo'],
  [2643680368,2643870526,'Virgo'],
  [2643870526,2644069429,'Libra'],
  [2644069429,2644278929,'Scorpio'],
  [2644278929,2644496270,'Sagittarius'],
  [2644496270,2644713454,'Capricorn'],
  [2644713454,2644921843,'Aquarius'],
  [2644921843,2645117794,'Pisces'],
  [2645117794,2645303491,'Aries'],
  [2645303491,2645484101,'Taurus'],
  [2645484101,2645664778,'Gemini'],
  [2645664778,2645848875,'Cancer'],
  [2645848875,2646037680,'Leo'],
  [2646037680,2646231723,'Virgo'],
  [2646231723,2646432283,'Libra'],
  [2646432283,2646641103,'Scorpio'],
  [2646641103,2646857744,'Sagittarius'],
  [2646857744,2647076649,'Capricorn'],
  [2647076649,2647288500,'Aquarius'],
  [2647288500,2647486563,'Pisces'],
  [2647486563,2647670931,'Aries'],
  [2647670931,2647847015,'Taurus'],
  [2647847015,2648021954,'Gemini'],
  [2648021954,2648201848,'Cancer'],
  [2648201848,2648389936,'Leo'],
  [2648389936,2648586350,'Virgo'],
  [2648586350,2648789948,'Libra'],
  [2648789948,2649000170,'Scorpio'],
  [2649000170,2649216643,'Sagittarius'],
  [2649216643,2649436355,'Capricorn'],
  [2649436355,2649651952,'Aquarius'],
  [2649651952,2649855219,'Pisces'],
  [2649855219,2650042966,'Aries'],
  [2650042966,2650218603,'Taurus'],
  [2650218603,2650389279,'Gemini'],
  [2650389279,2650562726,'Cancer'],
  [2650562726,2650745037,'Leo'],
  [2650745037,2650938898,'Virgo'],
  [2650938898,2651143335,'Libra'],
  [2651143335,2651355506,'Scorpio'],
  [2651355506,2651572707,'Sagittarius'],
  [2651572707,2651792243,'Capricorn'],
  [2651792243,2652009429,'Aquarius'],
  [2652009429,2652217596,'Pisces'],
  [2652217596,2652411722,'Aries'],
  [2652411722,2652591978,'Taurus'],
  [2652591978,2652763429,'Gemini'],
  [2652763429,2652933420,'Cancer'],
  [2652933420,2653109324,'Leo'],
  [2653109324,2653296709,'Virgo'],
  [2653296709,2653497531,'Libra'],
  [2653497531,2653709479,'Scorpio'],
  [2653709479,2653927548,'Sagittarius'],
  [2653927548,2654146804,'Capricorn'],
  [2654146804,2654363183,'Aquarius'],
  [2654363183,2654572730,'Pisces'],
  [2654572730,2654771776,'Aries'],
  [2654771776,2654958773,'Taurus'],
  [2654958773,2655135719,'Gemini'],
  [2655135719,2655307652,'Cancer'],
  [2655307652,2655481177,'Leo'],
  [2655481177,2655662904,'Virgo'],
  [2655662904,2655857635,'Libra'],
  [2655857635,2656066077,'Scorpio'],
  [2656066077,2656283652,'Sagittarius'],
  [2656283652,2656502956,'Capricorn'],
  [2656502956,2656717946,'Aquarius'],
  [2656717946,2656925616,'Pisces'],
  [2656925616,2657124992,'Aries'],
  [2657124992,2657315903,'Taurus'],
  [2657315903,2657499067,'Gemini'],
  [2657499067,2657676722,'Cancer'],
  [2657676722,2657852979,'Leo'],
  [2657852979,2658033412,'Virgo'],
  [2658033412,2658223744,'Libra'],
  [2658223744,2658427461,'Scorpio'],
  [2658427461,2658642758,'Sagittarius'],
  [2658642758,2658862060,'Capricorn'],
  [2658862060,2659076680,'Aquarius'],
  [2659076680,2659282038,'Pisces'],
  [2659282038,2659478377,'Aries'],
  [2659478377,2659668118,'Taurus'],
  [2659668118,2659853537,'Gemini'],
  [2659853537,2660036177,'Cancer'],
  [2660036177,2660217707,'Leo'],
  [2660217707,2660401170,'Virgo'],
  [2660401170,2660591109,'Libra'],
  [2660591109,2660791906,'Scorpio'],
  [2660791906,2661004485,'Sagittarius'],
  [2661004485,2661223426,'Capricorn'],
  [2661223426,2661439015,'Aquarius'],
  [2661439015,2661643989,'Pisces'],
  [2661643989,2661837470,'Aries'],
  [2661837470,2662023188,'Taurus'],
  [2662023188,2662205873,'Gemini'],
  [2662205873,2662388898,'Cancer'],
  [2662388898,2662573816,'Leo'],
  [2662573816,2662761638,'Virgo'],
  [2662761638,2662954453,'Libra'],
  [2662954453,2663155434,'Scorpio'],
  [2663155434,2663366538,'Sagittarius'],
  [2663366538,2663584974,'Capricorn'],
  [2663584974,2663802280,'Aquarius'],
  [2663802280,2664009358,'Pisces'],
  [2664009358,2664202776,'Aries'],
  [2664202776,2664385488,'Taurus'],
  [2664385488,2664563446,'Gemini'],
  [2664563446,2664742369,'Cancer'],
  [2664742369,2664925930,'Leo'],
  [2664925930,2665115528,'Virgo'],
  [2665115528,2665311590,'Libra'],
  [2665311590,2665514920,'Scorpio'],
  [2665514920,2665726406,'Sagittarius'],
  [2665726406,2665944595,'Capricorn'],
  [2665944595,2666163417,'Aquarius'],
  [2666163417,2666374052,'Pisces'],
  [2666374052,2666570671,'Aries'],
  [2666570671,2666753877,'Taurus'],
  [2666753877,2666928986,'Gemini'],
  [2666928986,2667102779,'Cancer'],
  [2667102779,2667281219,'Leo'],
  [2667281219,2667468071,'Virgo'],
  [2667468071,2667664544,'Libra'],
  [2667664544,2667870003,'Scorpio'],
  [2667870003,2668083025,'Sagittarius'],
  [2668083025,2668301430,'Capricorn'],
  [2668301430,2668520855,'Aquarius'],
  [2668520855,2668734531,'Pisces'],
  [2668734531,2668936091,'Aries'],
  [2668936091,2669123473,'Taurus'],
  [2669123473,2669299761,'Gemini'],
  [2669299761,2669471066,'Cancer'],
  [2669471066,2669644276,'Leo'],
  [2669644276,2669825434,'Virgo'],
  [2669825434,2670018302,'Libra'],
  [2670018302,2670223255,'Scorpio'],
  [2670223255,2670437402,'Sagittarius'],
  [2670437402,2670656333,'Capricorn'],
  [2670656333,2670875451,'Aquarius'],
  [2670875451,2671090035,'Pisces'],
  [2671090035,2671295443,'Aries'],
  [2671295443,2671488601,'Taurus'],
  [2671488601,2671669859,'Gemini'],
  [2671669859,2671843064,'Cancer'],
  [2671843064,2672014312,'Leo'],
  [2672014312,2672190475,'Virgo'],
  [2672190475,2672377611,'Libra'],
  [2672377611,2672578794,'Scorpio'],
  [2672578794,2672792103,'Sagittarius'],
  [2672792103,2673011363,'Capricorn'],
  [2673011363,2673229901,'Aquarius'],
  [2673229901,2673443293,'Pisces'],
  [2673443293,2673649228,'Aries'],
  [2673649228,2673846180,'Taurus'],
  [2673846180,2674033432,'Gemini'],
  [2674033432,2674212130,'Cancer'],
  [2674212130,2674385975,'Leo'],
  [2674385975,2674560876,'Virgo'],
  [2674560876,2674743623,'Libra'],
  [2674743623,2674939664,'Scorpio'],
  [2674939664,2675149861,'Sagittarius'],
  [2675149861,2675368601,'Capricorn'],
  [2675368601,2675586992,'Aquarius'],
  [2675586992,2675798741,'Pisces'],
  [2675798741,2676002301,'Aries'],
  [2676002301,2676198658,'Taurus'],
  [2676198658,2676388746,'Gemini'],
  [2676388746,2676572951,'Cancer'],
  [2676572951,2676752419,'Leo'],
  [2676752419,2676930521,'Virgo'],
  [2676930521,2677112833,'Libra'],
  [2677112833,2677305444,'Scorpio'],
  [2677305444,2677511770,'Sagittarius'],
  [2677511770,2677728891,'Capricorn'],
  [2677728891,2677947725,'Aquarius'],
  [2677947725,2678159298,'Pisces'],
  [2678159298,2678360416,'Aries'],
  [2678360416,2678553093,'Taurus'],
  [2678553093,2678740863,'Gemini'],
  [2678740863,2678926136,'Cancer'],
  [2678926136,2679109878,'Leo'],
  [2679109878,2679293219,'Virgo'],
  [2679293219,2679479075,'Libra'],
  [2679479075,2679672016,'Scorpio'],
  [2679672016,2679876104,'Sagittarius'],
  [2679876104,2680091208,'Capricorn'],
  [2680091208,2680310549,'Aquarius'],
  [2680310549,2680524043,'Pisces'],
  [2680524043,2680725481,'Aries'],
  [2680725481,2680915402,'Taurus'],
  [2680915402,2681098364,'Gemini'],
  [2681098364,2681279388,'Cancer'],
  [2681279388,2681461934,'Leo'],
  [2681461934,2681647696,'Virgo'],
  [2681647696,2681837839,'Libra'],
  [2681837839,2682034193,'Scorpio'],
  [2682034193,2682239053,'Sagittarius'],
  [2682239053,2682453100,'Capricorn'],
  [2682453100,2682672495,'Aquarius'],
  [2682672495,2682888801,'Pisces'],
  [2682888801,2683093849,'Aries'],
  [2683093849,2683285032,'Taurus'],
  [2683285032,2683465490,'Gemini'],
  [2683465490,2683641086,'Cancer'],
  [2683641086,2683817785,'Leo'],
  [2683817785,2684000134,'Virgo'],
  [2684000134,2684190620,'Libra'],
  [2684190620,2684389882,'Scorpio'],
  [2684389882,2684597456,'Sagittarius'],
  [2684597456,2684812205,'Capricorn'],
  [2684812205,2685031395,'Aquarius'],
  [2685031395,2685249492,'Pisces'],
  [2685249492,2685459232,'Aries'],
  [2685459232,2685655520,'Taurus'],
  [2685655520,2685838368,'Gemini'],
  [2685838368,2686012182,'Cancer'],
  [2686012182,2686183527,'Leo'],
  [2686183527,2686359208,'Virgo'],
  [2686359208,2686544704,'Libra'],
  [2686544704,2686742579,'Scorpio'],
  [2686742579,2686951616,'Sagittarius'],
  [2686951616,2687167966,'Capricorn'],
  [2687167966,2687387287,'Aquarius'],
  [2687387287,2687605454,'Pisces'],
  [2687605454,2687817897,'Aries'],
  [2687817897,2688019863,'Taurus'],
  [2688019863,2688208769,'Gemini'],
  [2688208769,2688385974,'Cancer'],
  [2688385974,2688556531,'Leo'],
  [2688556531,2688727566,'Virgo'],
  [2688727566,2688906471,'Libra'],
  [2688906471,2689098794,'Scorpio'],
  [2689098794,2689305557,'Sagittarius'],
  [2689305557,2689522282,'Capricorn'],
  [2689522282,2689742022,'Aquarius'],
  [2689742022,2689959425,'Pisces'],
  [2689959425,2690171577,'Aries'],
  [2690171577,2690376145,'Taurus'],
  [2690376145,2690570694,'Gemini'],
  [2690570694,2690754206,'Cancer'],
  [2690754206,2690928842,'Leo'],
  [2690928842,2691100126,'Virgo'],
  [2691100126,2691275452,'Libra'],
  [2691275452,2691461985,'Scorpio'],
  [2691461985,2691663701,'Sagittarius'],
  [2691663701,2691878301,'Capricorn'],
  [2691878301,2692097956,'Aquarius'],
  [2692097956,2692314824,'Pisces'],
  [2692314824,2692525213,'Aries'],
  [2692525213,2692728604,'Taurus'],
  [2692728604,2692924811,'Gemini'],
  [2692924811,2693113112,'Cancer'],
  [2693113112,2693293671,'Leo'],
  [2693293671,2693469340,'Virgo'],
  [2693469340,2693645764,'Libra'],
  [2693645764,2693829822,'Scorpio'],
  [2693829822,2694027019,'Sagittarius'],
  [2694027019,2694237977,'Capricorn'],
  [2694237977,2694456556,'Aquarius'],
  [2694456556,2694673485,'Pisces'],
  [2694673485,2694882720,'Aries'],
  [2694882720,2695083399,'Taurus'],
  [2695083399,2695277238,'Gemini'],
  [2695277238,2695465767,'Cancer'],
  [2695465767,2695649758,'Leo'],
  [2695649758,2695830525,'Virgo'],
  [2695830525,2696011253,'Libra'],
  [2696011253,2696196902,'Scorpio'],
  [2696196902,2696392568,'Sagittarius'],
  [2696392568,2696600561,'Capricorn'],
  [2696600561,2696817510,'Aquarius'],
  [2696817510,2697034959,'Pisces'],
  [2697034959,2697244795,'Aries'],
  [2697244795,2697444019,'Taurus'],
  [2697444019,2697634344,'Gemini'],
  [2697634344,2697819256,'Cancer'],
  [2697819256,2698001878,'Leo'],
  [2698001878,2698184499,'Virgo'],
  [2698184499,2698369237,'Libra'],
  [2698369237,2698558747,'Scorpio'],
  [2698558747,2698756081,'Sagittarius'],
  [2698756081,2698963281,'Capricorn'],
  [2698963281,2699178966,'Aquarius'],
  [2699178966,2699397051,'Pisces'],
  [2699397051,2699609154,'Aries'],
  [2699609154,2699809711,'Taurus'],
  [2699809711,2699998553,'Gemini'],
  [2699998553,2700179380,'Cancer'],
  [2700179380,2700357281,'Leo'],
  [2700357281,2700536991,'Virgo'],
  [2700536991,2700721999,'Libra'],
  [2700721999,2700914311,'Scorpio'],
  [2700914311,2701114740,'Sagittarius'],
  [2701114740,2701323299,'Capricorn'],
  [2701323299,2701538733,'Aquarius'],
  [2701538733,2701757215,'Pisces'],
  [2701757215,2701972097,'Aries'],
  [2701972097,2702176533,'Taurus'],
  [2702176533,2702367528,'Gemini'],
  [2702367528,2702547104,'Cancer'],
  [2702547104,2702720667,'Leo'],
  [2702720667,2702894838,'Virgo'],
  [2702894838,2703075629,'Libra'],
  [2703075629,2703266811,'Scorpio'],
  [2703266811,2703468844,'Sagittarius'],
  [2703468844,2703679492,'Capricorn'],
  [2703679492,2703895673,'Aquarius'],
  [2703895673,2704114191,'Pisces'],
  [2704114191,2704330791,'Aries'],
  [2704330791,2704539662,'Taurus'],
  [2704539662,2704735844,'Gemini'],
  [2704735844,2704918439,'Cancer'],
  [2704918439,2705091286,'Leo'],
  [2705091286,2705261268,'Virgo'],
  [2705261268,2705436094,'Libra'],
  [2705436094,2705622162,'Scorpio'],
  [2705622162,2705822054,'Sagittarius'],
  [2705822054,2706033288,'Capricorn'],
  [2706033288,2706250480,'Aquarius'],
  [2706250480,2706468897,'Pisces'],
  [2706468897,2706685387,'Aries'],
  [2706685387,2706896568,'Taurus'],
  [2706896568,2707098058,'Gemini'],
  [2707098058,2707286733,'Cancer'],
  [2707286733,2707463502,'Leo'],
  [2707463502,2707633635,'Virgo'],
  [2707633635,2707804839,'Libra'],
  [2707804839,2707984996,'Scorpio'],
  [2707984996,2708179493,'Sagittarius'],
  [2708179493,2708388213,'Capricorn'],
  [2708388213,2708605402,'Aquarius'],
  [2708605402,2708823875,'Pisces'],
  [2708823875,2709039211,'Aries'],
  [2709039211,2709249519,'Taurus'],
  [2709249519,2709452902,'Gemini'],
  [2709452902,2709646795,'Cancer'],
  [2709646795,2709829999,'Leo'],
  [2709829999,2710004891,'Virgo'],
  [2710004891,2710177309,'Libra'],
  [2710177309,2710354735,'Scorpio'],
  [2710354735,2710543930,'Sagittarius'],
  [2710543930,2710747811,'Capricorn'],
  [2710747811,2710963007,'Aquarius'],
  [2710963007,2711181525,'Pisces'],
  [2711181525,2711396248,'Aries'],
  [2711396248,2711604256,'Taurus'],
  [2711604256,2711805404,'Gemini'],
  [2711805404,2711999783,'Cancer'],
  [2711999783,2712187109,'Leo'],
  [2712187109,2712368091,'Virgo'],
  [2712368091,2712545768,'Libra'],
  [2712545768,2712725358,'Scorpio'],
  [2712725358,2712912842,'Sagittarius'],
  [2712912842,2713112589,'Capricorn'],
  [2713112589,2713324442,'Aquarius'],
  [2713324442,2713542430,'Pisces'],
  [2713542430,2713757898,'Aries'],
  [2713757898,2713965043,'Taurus'],
  [2713965043,2714162898,'Gemini'],
  [2714162898,2714353431,'Cancer'],
  [2714353431,2714539199,'Leo'],
  [2714539199,2714722368,'Virgo'],
  [2714722368,2714905000,'Libra'],
  [2714905000,2715089704,'Scorpio'],
  [2715089704,2715279849,'Sagittarius'],
  [2715279849,2715478823,'Capricorn'],
  [2715478823,2715688121,'Aquarius'],
  [2715688121,2715904969,'Pisces'],
  [2715904969,2716121968,'Aries'],
  [2716121968,2716331009,'Taurus'],
  [2716331009,2716528215,'Gemini'],
  [2716528215,2716714914,'Cancer'],
  [2716714914,2716895498,'Leo'],
  [2716895498,2717075000,'Virgo'],
  [2717075000,2717257485,'Libra'],
  [2717257485,2717445385,'Scorpio'],
  [2717445385,2717639775,'Sagittarius'],
  [2717639775,2717841294,'Capricorn'],
  [2717841294,2718050480,'Aquarius'],
  [2718050480,2718266415,'Pisces'],
  [2718266415,2718484607,'Aries'],
  [2718484607,2718697242,'Taurus'],
  [2718697242,2718897605,'Gemini'],
  [2718897605,2719084258,'Cancer'],
  [2719084258,2719261092,'Leo'],
  [2719261092,2719434734,'Virgo'],
  [2719434734,2719611929,'Libra'],
  [2719611929,2719797546,'Scorpio'],
  [2719797546,2719993209,'Sagittarius'],
  [2719993209,2720197638,'Capricorn'],
  [2720197638,2720408719,'Aquarius'],
  [2720408719,2720624779,'Pisces'],
  [2720624779,2720843331,'Aries'],
  [2720843331,2721058970,'Taurus'],
  [2721058970,2721264455,'Gemini'],
  [2721264455,2721455328,'Cancer'],
  [2721455328,2721632973,'Leo'],
  [2721632973,2721803516,'Virgo'],
  [2721803516,2721974887,'Libra'],
  [2721974887,2722154368,'Scorpio'],
  [2722154368,2722346311,'Sagittarius'],
  [2722346311,2722550472,'Capricorn'],
  [2722550472,2722763105,'Aquarius'],
  [2722763105,2722980099,'Pisces'],
  [2722980099,2723198543,'Aries'],
  [2723198543,2723415127,'Taurus'],
  [2723415127,2723624506,'Gemini'],
  [2723624506,2723821259,'Cancer'],
  [2723821259,2724003856,'Leo'],
  [2724003856,2724176134,'Virgo'],
  [2724176134,2724345345,'Libra'],
  [2724345345,2724519535,'Scorpio'],
  [2724519535,2724705291,'Sagittarius'],
  [2724705291,2724905246,'Capricorn'],
  [2724905246,2725116839,'Aquarius'],
  [2725116839,2725334360,'Pisces'],
  [2725334360,2725552689,'Aries'],
  [2725552689,2725768507,'Taurus'],
  [2725768507,2725978632,'Gemini'],
  [2725978632,2726179237,'Cancer'],
  [2726179237,2726367756,'Leo'],
  [2726367756,2726545364,'Virgo'],
  [2726545364,2726717095,'Libra'],
  [2726717095,2726890038,'Scorpio'],
  [2726890038,2727071288,'Sagittarius'],
  [2727071288,2727265705,'Capricorn'],
  [2727265705,2727473599,'Aquarius'],
  [2727473599,2727690176,'Pisces'],
  [2727690176,2727908440,'Aries'],
  [2727908440,2728123131,'Taurus'],
  [2728123131,2728331506,'Gemini'],
  [2728331506,2728532018,'Cancer'],
  [2728532018,2728723625,'Leo'],
  [2728723625,2728906640,'Virgo'],
  [2728906640,2729083718,'Libra'],
  [2729083718,2729259668,'Scorpio'],
  [2729259668,2729440383,'Sagittarius'],
  [2729440383,2729631219,'Capricorn'],
  [2729631219,2729834838,'Aquarius'],
  [2729834838,2730049096,'Pisces'],
  [2730049096,2730267187,'Aries'],
  [2730267187,2730481574,'Taurus'],
  [2730481574,2730687915,'Gemini'],
  [2730687915,2730885547,'Cancer'],
  [2730885547,2731075822,'Leo'],
  [2731075822,2731260659,'Virgo'],
  [2731260659,2731442207,'Libra'],
  [2731442207,2731623152,'Scorpio'],
  [2731623152,2731806997,'Sagittarius'],
  [2731806997,2731997793,'Capricorn'],
  [2731997793,2732198889,'Aquarius'],
  [2732198889,2732410645,'Pisces'],
  [2732410645,2732628384,'Aries'],
  [2732628384,2732843744,'Taurus'],
  [2732843744,2733049810,'Gemini'],
  [2733049810,2733244725,'Cancer'],
  [2733244725,2733431044,'Leo'],
  [2733431044,2733613114,'Virgo'],
  [2733613114,2733794900,'Libra'],
  [2733794900,2733979053,'Scorpio'],
  [2733979053,2734167184,'Sagittarius'],
  [2734167184,2734360888,'Capricorn'],
  [2734360888,2734562256,'Aquarius'],
  [2734562256,2734772649,'Pisces'],
  [2734772649,2734989969,'Aries'],
  [2734989969,2735207162,'Taurus'],
  [2735207162,2735415495,'Gemini'],
  [2735415495,2735610446,'Cancer'],
  [2735610446,2735793733,'Leo'],
  [2735793733,2735970977,'Virgo'],
  [2735970977,2736148536,'Libra'],
  [2736148536,2736331212,'Scorpio'],
  [2736331212,2736521084,'Sagittarius'],
  [2736521084,2736718081,'Capricorn'],
  [2736718081,2736921838,'Aquarius'],
  [2736921838,2737132606,'Pisces'],
  [2737132606,2737349666,'Aries'],
  [2737349666,2737568476,'Taurus'],
  [2737568476,2737780686,'Gemini'],
  [2737780686,2737979234,'Cancer'],
  [2737979234,2738163223,'Leo'],
  [2738163223,2738337585,'Virgo'],
  [2738337585,2738509784,'Libra'],
  [2738509784,2738686952,'Scorpio'],
  [2738686952,2738873724,'Sagittarius'],
  [2738873724,2739070988,'Capricorn'],
  [2739070988,2739276915,'Aquarius'],
  [2739276915,2739489297,'Pisces'],
  [2739489297,2739706523,'Aries'],
  [2739706523,2739925816,'Taurus'],
  [2739925816,2740141163,'Gemini'],
  [2740141163,2740345162,'Cancer'],
  [2740345162,2740534022,'Leo'],
  [2740534022,2740710108,'Virgo'],
  [2740710108,2740880060,'Libra'],
  [2740880060,2741051790,'Scorpio'],
  [2741051790,2741232216,'Sagittarius'],
  [2741232216,2741425167,'Capricorn'],
  [2741425167,2741630197,'Aquarius'],
  [2741630197,2741843719,'Pisces'],
  [2741843719,2742061583,'Aries'],
  [2742061583,2742280393,'Taurus'],
  [2742280393,2742496247,'Gemini'],
  [2742496247,2742703959,'Cancer'],
  [2742703959,2742899097,'Leo'],
  [2742899097,2743081101,'Virgo'],
  [2743081101,2743253972,'Libra'],
  [2743253972,2743424443,'Scorpio'],
  [2743424443,2743599871,'Sagittarius'],
  [2743599871,2743786364,'Capricorn'],
  [2743786364,2743986688,'Aquarius'],
  [2743986688,2744198853,'Pisces'],
  [2744198853,2744417145,'Aries'],
  [2744417145,2744635533,'Taurus'],
  [2744635533,2744849820,'Gemini'],
  [2744849820,2745057201,'Cancer'],
  [2745057201,2745255485,'Leo'],
  [2745255485,2745443634,'Virgo'],
  [2745443634,2745622954,'Libra'],
  [2745622954,2745797364,'Scorpio'],
  [2745797364,2745972624,'Sagittarius'],
  [2745972624,2746155043,'Capricorn'],
  [2746155043,2746349685,'Aquarius'],
  [2746349685,2746557866,'Pisces'],
  [2746557866,2746775274,'Aries'],
  [2746775274,2746993856,'Taurus'],
  [2746993856,2747206804,'Gemini'],
  [2747206804,2747411349,'Cancer'],
  [2747411349,2747607829,'Leo'],
  [2747607829,2747797559,'Virgo'],
  [2747797559,2747981881,'Libra'],
  [2747981881,2748162474,'Scorpio'],
  [2748162474,2748342176,'Sagittarius'],
  [2748342176,2748525375,'Capricorn'],
  [2748525375,2748717194,'Aquarius'],
  [2748717194,2748921264,'Pisces'],
  [2748921264,2749136445,'Aries'],
  [2749136445,2749355418,'Taurus'],
  [2749355418,2749568840,'Gemini'],
  [2749568840,2749771529,'Cancer'],
  [2749771529,2749964127,'Leo'],
  [2749964127,2750150405,'Virgo'],
  [2750150405,2750334194,'Libra'],
  [2750334194,2750517884,'Scorpio'],
  [2750517884,2750702690,'Sagittarius'],
  [2750702690,2750890180,'Capricorn'],
  [2750890180,2751083382,'Aquarius'],
  [2751083382,2751285912,'Pisces'],
  [2751285912,2751498983,'Aries'],
  [2751498983,2751718033,'Taurus'],
  [2751718033,2751933508,'Gemini'],
  [2751933508,2752137346,'Cancer'],
  [2752137346,2752328104,'Leo'],
  [2752328104,2752509949,'Virgo'],
  [2752509949,2752688911,'Libra'],
  [2752688911,2752869979,'Scorpio'],
  [2752869979,2753055725,'Sagittarius'],
  [2753055725,2753246752,'Capricorn'],
  [2753246752,2753443536,'Aquarius'],
  [2753443536,2753647562,'Pisces'],
  [2753647562,2753860101,'Aries'],
  [2753860101,2754078992,'Taurus'],
  [2754078992,2754296766,'Gemini'],
  [2754296766,2754504245,'Cancer'],
  [2754504245,2754697022,'Leo'],
  [2754697022,2754877493,'Virgo'],
  [2754877493,2755051981,'Libra'],
  [2755051981,2755227363,'Scorpio'],
  [2755227363,2755408871,'Sagittarius'],
  [2755408871,2755598961,'Capricorn'],
  [2755598961,2755797697,'Aquarius'],
  [2755797697,2756004265,'Pisces'],
  [2756004265,2756217913,'Aries'],
  [2756217913,2756436824,'Taurus'],
  [2756436824,2756655924,'Gemini'],
  [2756655924,2756867369,'Cancer'],
  [2756867369,2757065000,'Leo'],
  [2757065000,2757248362,'Virgo'],
  [2757248362,2757422172,'Libra'],
  [2757422172,2757593398,'Scorpio'],
  [2757593398,2757768906,'Sagittarius'],
  [2757768906,2757953832,'Capricorn'],
  [2757953832,2758150397,'Aquarius'],
  [2758150397,2758357685,'Pisces'],
  [2758357685,2758572743,'Aries'],
  [2758572743,2758792001,'Taurus'],
  [2758792001,2759011160,'Gemini'],
  [2759011160,2759224718,'Cancer'],
  [2759224718,2759427225,'Leo'],
  [2759427225,2759616191,'Virgo'],
  [2759616191,2759793624,'Libra'],
  [2759793624,2759964885,'Scorpio'],
  [2759964885,2760136755,'Sagittarius'],
  [2760136755,2760315856,'Capricorn'],
  [2760315856,2760507081,'Aquarius'],
  [2760507081,2760711782,'Pisces'],
  [2760711782,2760926850,'Aries'],
  [2760926850,2761146461,'Taurus'],
  [2761146461,2761364982,'Gemini'],
  [2761364982,2761578151,'Cancer'],
  [2761578151,2761782797,'Leo'],
  [2761782797,2761976792,'Virgo'],
  [2761976792,2762160119,'Libra'],
  [2762160119,2762335508,'Scorpio'],
  [2762335508,2762508045,'Sagittarius'],
  [2762508045,2762684152,'Capricorn'],
  [2762684152,2762870157,'Aquarius'],
  [2762870157,2763070097,'Pisces'],
  [2763070097,2763283002,'Aries'],
  [2763283002,2763502430,'Taurus'],
  [2763502430,2763720421,'Gemini'],
  [2763720421,2763931867,'Cancer'],
  [2763931867,2764135257,'Leo'],
  [2764135257,2764330692,'Virgo'],
  [2764330692,2764518520,'Libra'],
  [2764518520,2764699645,'Scorpio'],
  [2764699645,2764876559,'Sagittarius'],
  [2764876559,2765053876,'Capricorn'],
  [2765053876,2765237632,'Aquarius'],
  [2765237632,2765433346,'Pisces'],
  [2765433346,2765642790,'Aries'],
  [2765642790,2765861203,'Taurus'],
  [2765861203,2766079272,'Gemini'],
  [2766079272,2766289552,'Cancer'],
  [2766289552,2766490170,'Leo'],
  [2766490170,2766683145,'Virgo'],
  [2766683145,2766871103,'Libra'],
  [2766871103,2767055610,'Scorpio'],
  [2767055610,2767237661,'Sagittarius'],
  [2767237661,2767419341,'Capricorn'],
  [2767419341,2767604730,'Aquarius'],
  [2767604730,2767798982,'Pisces'],
  [2767798982,2768005544,'Aries'],
  [2768005544,2768222407,'Taurus'],
  [2768222407,2768441132,'Gemini'],
  [2768441132,2768652149,'Cancer'],
  [2768652149,2768851322,'Leo'],
  [2768851322,2769040649,'Virgo'],
  [2769040649,2769224746,'Libra'],
  [2769224746,2769407639,'Scorpio'],
  [2769407639,2769591474,'Sagittarius'],
  [2769591474,2769777281,'Capricorn'],
  [2769777281,2769966717,'Aquarius'],
  [2769966717,2770162797,'Pisces'],
  [2770162797,2770368615,'Aries'],
  [2770368615,2770584176,'Taurus'],
  [2770584176,2770803613,'Gemini'],
  [2770803613,2771017236,'Cancer'],
  [2771017236,2771218159,'Leo'],
  [2771218159,2771406227,'Virgo'],
  [2771406227,2771586119,'Libra'],
  [2771586119,2771763794,'Scorpio'],
  [2771763794,2771944101,'Sagittarius'],
  [2771944101,2772129800,'Capricorn'],
  [2772129800,2772322031,'Aquarius'],
  [2772322031,2772521488,'Pisces'],
  [2772521488,2772728953,'Aries'],
  [2772728953,2772944262,'Taurus'],
  [2772944262,2773163924,'Gemini'],
  [2773163924,2773380441,'Cancer'],
  [2773380441,2773585877,'Leo'],
  [2773585877,2773776960,'Virgo'],
  [2773776960,2773956247,'Libra'],
  [2773956247,2774129639,'Scorpio'],
  [2774129639,2774303761,'Sagittarius'],
  [2774303761,2774484241,'Capricorn'],
  [2774484241,2774674519,'Aquarius'],
  [2774674519,2774875325,'Pisces'],
  [2774875325,2775085165,'Aries'],
  [2775085165,2775301487,'Taurus'],
  [2775301487,2775520974,'Gemini'],
  [2775520974,2775738756,'Cancer'],
  [2775738756,2775948645,'Leo'],
  [2775948645,2776145730,'Virgo'],
  [2776145730,2776329318,'Libra'],
  [2776329318,2776503101,'Scorpio'],
  [2776503101,2776673434,'Sagittarius'],
  [2776673434,2776847472,'Capricorn'],
  [2776847472,2777031523,'Aquarius'],
  [2777031523,2777229065,'Pisces'],
  [2777229065,2777439047,'Aries'],
  [2777439047,2777656599,'Taurus'],
  [2777656599,2777876105,'Gemini'],
  [2777876105,2778093246,'Cancer'],
  [2778093246,2778304568,'Leo'],
  [2778304568,2778506591,'Virgo'],
  [2778506591,2778696904,'Libra'],
  [2778696904,2778875979,'Scorpio'],
  [2778875979,2779047836,'Sagittarius'],
  [2779047836,2779219087,'Capricorn'],
  [2779219087,2779397241,'Aquarius'],
  [2779397241,2779588544,'Pisces'],
  [2779588544,2779794934,'Aries'],
  [2779794934,2780012044,'Taurus'],
  [2780012044,2780231822,'Gemini'],
  [2780231822,2780447878,'Cancer'],
  [2780447878,2780657618,'Leo'],
  [2780657618,2780860265,'Virgo'],
  [2780860265,2781054819,'Libra'],
  [2781054819,2781240386,'Scorpio'],
  [2781240386,2781417980,'Sagittarius'],
  [2781417980,2781591771,'Capricorn'],
  [2781591771,2781768382,'Aquarius'],
  [2781768382,2781954940,'Pisces'],
  [2781954940,2782156098,'Aries'],
  [2782156098,2782370434,'Taurus'],
  [2782370434,2782590010,'Gemini'],
  [2782590010,2782805834,'Cancer'],
  [2782805834,2783013550,'Leo'],
  [2783013550,2783213443,'Virgo'],
  [2783213443,2783407121,'Libra'],
  [2783407121,2783595341,'Scorpio'],
  [2783595341,2783778328,'Sagittarius'],
  [2783778328,2783957658,'Capricorn'],
  [2783957658,2784137435,'Aquarius'],
  [2784137435,2784323561,'Pisces'],
  [2784323561,2784521411,'Aries'],
  [2784521411,2784732306,'Taurus'],
  [2784732306,2784950841,'Gemini'],
  [2784950841,2785167387,'Cancer'],
  [2785167387,2785374858,'Leo'],
  [2785374858,2785572126,'Virgo'],
  [2785572126,2785761935,'Libra'],
  [2785761935,2785947582,'Scorpio'],
  [2785947582,2786131248,'Sagittarius'],
  [2786131248,2786314350,'Capricorn'],
  [2786314350,2786498899,'Aquarius'],
  [2786498899,2786688262,'Pisces'],
  [2786688262,2786886387,'Aries'],
  [2786886387,2787095417,'Taurus'],
  [2787095417,2787312690,'Gemini'],
  [2787312690,2787530335,'Cancer'],
  [2787530335,2787739763,'Leo'],
  [2787739763,2787937126,'Virgo'],
  [2787937126,2788124066,'Libra'],
  [2788124066,2788305008,'Scorpio'],
  [2788305008,2788484609,'Sagittarius'],
  [2788484609,2788666489,'Capricorn'],
  [2788666489,2788853077,'Aquarius'],
  [2788853077,2789046098,'Pisces'],
  [2789046098,2789246990,'Aries'],
  [2789246990,2789456532,'Taurus'],
  [2789456532,2789673203,'Gemini'],
  [2789673203,2789891725,'Cancer'],
  [2789891725,2790104274,'Leo'],
  [2790104274,2790304796,'Virgo'],
  [2790304796,2790492349,'Libra'],
  [2790492349,2790670479,'Scorpio'],
  [2790670479,2790844927,'Sagittarius'],
  [2790844927,2791021665,'Capricorn'],
  [2791021665,2791205499,'Aquarius'],
  [2791205499,2791399038,'Pisces'],
  [2791399038,2791602365,'Aries'],
  [2791602365,2791813815,'Taurus'],
  [2791813815,2792030850,'Gemini'],
  [2792030850,2792249720,'Cancer'],
  [2792249720,2792464869,'Leo'],
  [2792464869,2792670063,'Virgo'],
  [2792670063,2792861762,'Libra'],
  [2792861762,2793041090,'Scorpio'],
  [2793041090,2793213053,'Sagittarius'],
  [2793213053,2793384590,'Capricorn'],
  [2793384590,2793562688,'Aquarius'],
  [2793562688,2793752475,'Pisces'],
  [2793752475,2793955219,'Aries'],
  [2793955219,2794167960,'Taurus'],
  [2794167960,2794385864,'Gemini'],
  [2794385864,2794604657,'Cancer'],
  [2794604657,2794820643,'Leo'],
  [2794820643,2795029454,'Virgo'],
  [2795029454,2795226758,'Libra'],
  [2795226758,2795410959,'Scorpio'],
  [2795410959,2795584764,'Sagittarius'],
  [2795584764,2795754390,'Capricorn'],
  [2795754390,2795927586,'Aquarius'],
  [2795927586,2796111538,'Pisces'],
  [2796111538,2796310185,'Aries'],
  [2796310185,2796521804,'Taurus'],
  [2796521804,2796740113,'Gemini'],
  [2796740113,2796958717,'Cancer'],
  [2796958717,2797173893,'Leo'],
  [2797173893,2797383382,'Virgo'],
  [2797383382,2797584460,'Libra'],
  [2797584460,2797774566,'Scorpio'],
  [2797774566,2797953732,'Sagittarius'],
  [2797953732,2798125905,'Capricorn'],
  [2798125905,2798297940,'Aquarius'],
  [2798297940,2798477557,'Pisces'],
  [2798477557,2798670796,'Aries'],
  [2798670796,2798878736,'Taurus'],
  [2798878736,2799096067,'Gemini'],
  [2799096067,2799314572,'Cancer'],
  [2799314572,2799528555,'Leo'],
  [2799528555,2799736186,'Virgo'],
  [2799736186,2799937049,'Libra'],
  [2799937049,2800130228,'Scorpio'],
  [2800130228,2800314971,'Sagittarius'],
  [2800314971,2800492726,'Capricorn'],
  [2800492726,2800667979,'Aquarius'],
  [2800667979,2800847227,'Pisces'],
  [2800847227,2801036919,'Aries'],
  [2801036919,2801240472,'Taurus'],
  [2801240472,2801455379,'Gemini'],
  [2801455379,2801673761,'Cancer'],
  [2801673761,2801887562,'Leo'],
  [2801887562,2802093140,'Virgo'],
  [2802093140,2802290857,'Libra'],
  [2802290857,2802482304,'Scorpio'],
  [2802482304,2802668653,'Sagittarius'],
  [2802668653,2802851020,'Capricorn'],
  [2802851020,2803031680,'Aquarius'],
  [2803031680,2803214569,'Pisces'],
  [2803214569,2803404562,'Aries'],
  [2803404562,2803605559,'Taurus'],
  [2803605559,2803817711,'Gemini'],
  [2803817711,2804035670,'Cancer'],
  [2804035670,2804250773,'Leo'],
  [2804250773,2804456523,'Virgo'],
  [2804456523,2804651636,'Libra'],
  [2804651636,2804838671,'Scorpio'],
  [2804838671,2805021444,'Sagittarius'],
  [2805021444,2805203382,'Capricorn'],
  [2805203382,2805387083,'Aquarius'],
  [2805387083,2805574662,'Pisces'],
  [2805574662,2805768246,'Aries'],
  [2805768246,2805969944,'Taurus'],
  [2805969944,2806180641,'Gemini'],
  [2806180641,2806397877,'Cancer'],
  [2806397877,2806614928,'Leo'],
  [2806614928,2806823694,'Virgo'],
  [2806823694,2807019738,'Libra'],
  [2807019738,2807204112,'Scorpio'],
  [2807204112,2807381616,'Sagittarius'],
  [2807381616,2807558265,'Capricorn'],
  [2807558265,2807739319,'Aquarius'],
  [2807739319,2807927972,'Pisces'],
  [2807927972,2808124991,'Aries'],
  [2808124991,2808329670,'Taurus'],
  [2808329670,2808541096,'Gemini'],
  [2808541096,2808757841,'Cancer'],
  [2808757841,2808976100,'Leo'],
  [2808976100,2809188956,'Virgo'],
  [2809188956,2809389642,'Libra'],
  [2809389642,2809575980,'Scorpio'],
  [2809575980,2809751368,'Sagittarius'],
  [2809751368,2809922614,'Capricorn'],
  [2809922614,2810097269,'Aquarius'],
  [2810097269,2810281414,'Pisces'],
  [2810281414,2810477597,'Aries'],
  [2810477597,2810684205,'Taurus'],
  [2810684205,2810897588,'Gemini'],
  [2810897588,2811114666,'Cancer'],
  [2811114666,2811332925,'Leo'],
  [2811332925,2811548211,'Virgo'],
  [2811548211,2811754325,'Libra'],
  [2811754325,2811946485,'Scorpio'],
  [2811946485,2812124956,'Sagittarius'],
  [2812124956,2812295143,'Capricorn'],
  [2812295143,2812464995,'Aquarius'],
  [2812464995,2812642479,'Pisces'],
  [2812642479,2812833147,'Aries'],
  [2812833147,2813037634,'Taurus'],
  [2813037634,2813251680,'Gemini'],
  [2813251680,2813469578,'Cancer'],
  [2813469578,2813687394,'Leo'],
  [2813687394,2813902473,'Virgo'],
  [2813902473,2814111164,'Libra'],
  [2814111164,2814309020,'Scorpio'],
  [2814309020,2814493842,'Sagittarius'],
  [2814493842,2814668086,'Capricorn'],
  [2814668086,2814838115,'Aquarius'],
  [2814838115,2815011831,'Pisces'],
  [2815011831,2815196371,'Aries'],
  [2815196371,2815395434,'Taurus'],
  [2815395434,2815607123,'Gemini'],
  [2815607123,2815825056,'Cancer'],
  [2815825056,2816042711,'Leo'],
  [2816042711,2816256341,'Virgo'],
  [2816256341,2816463964,'Libra'],
  [2816463964,2816663572,'Scorpio'],
  [2816663572,2816853400,'Sagittarius'],
  [2816853400,2817033835,'Capricorn'],
  [2817033835,2817208491,'Aquarius'],
  [2817208491,2817383401,'Pisces'],
  [2817383401,2817565279,'Aries'],
  [2817565279,2817759345,'Taurus'],
  [2817759345,2817966761,'Gemini'],
  [2817966761,2818183184,'Cancer'],
  [2818183184,2818400925,'Leo'],
  [2818400925,2818613697,'Virgo'],
  [2818613697,2818818826,'Libra'],
  [2818818826,2819016150,'Scorpio'],
  [2819016150,2819206330,'Sagittarius'],
  [2819206330,2819390440,'Capricorn'],
  [2819390440,2819570539,'Aquarius'],
  [2819570539,2819750096,'Pisces'],
  [2819750096,2819933727,'Aries'],
  [2819933727,2820126112,'Taurus'],
  [2820126112,2820330058,'Gemini'],
  [2820330058,2820544143,'Cancer'],
  [2820544143,2820761940,'Leo'],
  [2820761940,2820975300,'Virgo'],
  [2820975300,2821179166,'Libra'],
  [2821179166,2821373118,'Scorpio'],
  [2821373118,2821559780,'Sagittarius'],
  [2821559780,2821742643,'Capricorn'],
  [2821742643,2821924787,'Aquarius'],
  [2821924787,2822108643,'Pisces'],
  [2822108643,2822296438,'Aries'],
  [2822296438,2822490675,'Taurus'],
  [2822490675,2822693743,'Gemini'],
  [2822693743,2822906082,'Cancer'],
  [2822906082,2823123837,'Leo'],
  [2823123837,2823339043,'Virgo'],
  [2823339043,2823544196,'Libra'],
  [2823544196,2823736778,'Scorpio'],
  [2823736778,2823919514,'Sagittarius'],
  [2823919514,2824097815,'Capricorn'],
  [2824097815,2824277160,'Aquarius'],
  [2824277160,2824461394,'Pisces'],
  [2824461394,2824652161,'Aries'],
  [2824652161,2824849731,'Taurus'],
  [2824849731,2825054395,'Gemini'],
  [2825054395,2825266469,'Cancer'],
  [2825266469,2825484178,'Leo'],
  [2825484178,2825701552,'Virgo'],
  [2825701552,2825910201,'Libra'],
  [2825910201,2826104841,'Scorpio'],
  [2826104841,2826286430,'Sagittarius'],
  [2826286430,2826460624,'Capricorn'],
  [2826460624,2826634640,'Aquarius'],
  [2826634640,2826814745,'Pisces'],
  [2826814745,2827004391,'Aries'],
  [2827004391,2827203619,'Taurus'],
  [2827203619,2827410613,'Gemini'],
  [2827410613,2827623758,'Cancer'],
  [2827623758,2827841561,'Leo'],
  [2827841561,2828060286,'Virgo'],
  [2828060286,2828272861,'Libra'],
  [2828272861,2828472335,'Scorpio'],
  [2828472335,2828656823,'Sagittarius'],
  [2828656823,2828830420,'Capricorn'],
  [2828830420,2829000491,'Aquarius'],
  [2829000491,2829174816,'Pisces'],
  [2829174816,2829359372,'Aries'],
  [2829359372,2829556350,'Taurus'],
  [2829556350,2829763913,'Gemini'],
  [2829763913,2829978363,'Cancer'],
  [2829978363,2830196474,'Leo'],
  [2830196474,2830415252,'Virgo'],
  [2830415252,2830629946,'Libra'],
  [2830629946,2830834406,'Scorpio'],
  [2830834406,2831024700,'Sagittarius'],
  [2831024700,2831202107,'Capricorn'],
  [2831202107,2831372390,'Aquarius'],
  [2831372390,2831543206,'Pisces'],
  [2831543206,2831721897,'Aries'],
  [2831721897,2831913362,'Taurus'],
  [2831913362,2832118156,'Gemini'],
  [2832118156,2832332535,'Cancer'],
  [2832332535,2832551009,'Leo'],
  [2832551009,2832769089,'Virgo'],
  [2832769089,2832983224,'Libra'],
  [2832983224,2833189701,'Scorpio'],
  [2833189701,2833385202,'Sagittarius'],
  [2833385202,2833568952,'Capricorn'],
  [2833568952,2833743909,'Aquarius'],
  [2833743909,2833915856,'Pisces'],
  [2833915856,2834091694,'Aries'],
  [2834091694,2834277677,'Taurus'],
  [2834277677,2834477283,'Gemini'],
  [2834477283,2834689222,'Cancer'],
  [2834689222,2834907565,'Leo'],
  [2834907565,2835125238,'Virgo'],
  [2835125238,2835337487,'Libra'],
  [2835337487,2835542214,'Scorpio'],
  [2835542214,2835738705,'Sagittarius'],
  [2835738705,2835926964,'Capricorn'],
  [2835926964,2836108202,'Aquarius'],
  [2836108202,2836285390,'Pisces'],
  [2836285390,2836463184,'Aries'],
  [2836463184,2836647152,'Taurus'],
  [2836647152,2836842222,'Gemini'],
  [2836842222,2837050196,'Cancer'],
  [2837050196,2837267347,'Leo'],
  [2837267347,2837485416,'Virgo'],
  [2837485416,2837696805,'Libra'],
  [2837696805,2837898525,'Scorpio'],
  [2837898525,2838091745,'Sagittarius'],
  [2838091745,2838279207,'Capricorn'],
  [2838279207,2838463359,'Aquarius'],
  [2838463359,2838645992,'Pisces'],
  [2838645992,2838829028,'Aries'],
  [2838829028,2839015497,'Taurus'],
  [2839015497,2839209486,'Gemini'],
  [2839209486,2839414367,'Cancer'],
  [2839414367,2839629558,'Leo'],
  [2839629558,2839848367,'Virgo'],
  [2839848367,2840061173,'Libra'],
  [2840061173,2840262067,'Scorpio'],
  [2840262067,2840451589,'Sagittarius'],
  [2840451589,2840634346,'Capricorn'],
  [2840634346,2840815568,'Aquarius'],
  [2840815568,2840998887,'Pisces'],
  [2840998887,2841185787,'Aries'],
  [2841185787,2841376833,'Taurus'],
  [2841376833,2841573442,'Gemini'],
  [2841573442,2841778047,'Cancer'],
  [2841778047,2841991775,'Leo'],
  [2841991775,2842210943,'Virgo'],
  [2842210943,2842426620,'Libra'],
  [2842426620,2842630227,'Scorpio'],
  [2842630227,2842819501,'Sagittarius'],
  [2842819501,2842998526,'Capricorn'],
  [2842998526,2843174108,'Aquarius'],
  [2843174108,2843352588,'Pisces'],
  [2843352588,2843537852,'Aries'],
  [2843537852,2843730801,'Taurus'],
  [2843730801,2843930811,'Gemini'],
  [2843930811,2844137643,'Cancer'],
  [2844137643,2844351498,'Leo'],
  [2844351498,2844570568,'Virgo'],
  [2844570568,2844788593,'Libra'],
  [2844788593,2844996855,'Scorpio'],
  [2844996855,2845190123,'Sagittarius'],
  [2845190123,2845369872,'Capricorn'],
  [2845369872,2845542287,'Aquarius'],
  [2845542287,2845714878,'Pisces'],
  [2845714878,2845894087,'Aries'],
  [2845894087,2846083601,'Taurus'],
  [2846083601,2846283755,'Gemini'],
  [2846283755,2846492649,'Cancer'],
  [2846492649,2846707886,'Leo'],
  [2846707886,2846926942,'Virgo'],
  [2846926942,2847145591,'Libra'],
  [2847145591,2847357365,'Scorpio'],
  [2847357365,2847556354,'Sagittarius'],
  [2847556354,2847741092,'Capricorn'],
  [2847741092,2847915286,'Aquarius'],
  [2847915286,2848085595,'Pisces'],
  [2848085595,2848259270,'Aries'],
  [2848259270,2848442402,'Taurus'],
  [2848442402,2848638276,'Gemini'],
  [2848638276,2848846265,'Cancer'],
  [2848846265,2849062419,'Leo'],
  [2849062419,2849281769,'Virgo'],
  [2849281769,2849499766,'Libra'],
  [2849499766,2849712122,'Scorpio'],
  [2849712122,2849914822,'Sagittarius'],
  [2849914822,2850105540,'Capricorn'],
  [2850105540,2850285257,'Aquarius'],
  [2850285257,2850458181,'Pisces'],
  [2850458181,2850630485,'Aries'],
  [2850630485,2850808850,'Taurus'],
  [2850808850,2850998852,'Gemini'],
  [2850998852,2851202799,'Cancer'],
  [2851202799,2851417897,'Leo'],
  [2851417897,2851637407,'Virgo'],
  [2851637407,2851854600,'Libra'],
  [2851854600,2852065356,'Scorpio'],
  [2852065356,2852267958,'Sagittarius'],
  [2852267958,2852461765,'Capricorn'],
  [2852461765,2852647025,'Aquarius'],
  [2852647025,2852825493,'Pisces'],
  [2852825493,2853000892,'Aries'],
  [2853000892,2853178678,'Taurus'],
  [2853178678,2853364919,'Gemini'],
  [2853364919,2853564174,'Cancer'],
  [2853564174,2853776418,'Leo'],
  [2853776418,2853995476,'Virgo'],
  [2853995476,2854212483,'Libra'],
  [2854212483,2854421501,'Scorpio'],
  [2854421501,2854621461,'Sagittarius'],
  [2854621461,2854814056,'Capricorn'],
  [2854814056,2855001205,'Aquarius'],
  [2855001205,2855184262,'Pisces'],
  [2855184262,2855364788,'Aries'],
  [2855364788,2855545815,'Taurus'],
  [2855545815,2855732104,'Gemini'],
  [2855732104,2855928713,'Cancer'],
  [2855928713,2856137936,'Leo'],
  [2856137936,2856355974,'Virgo'],
  [2856355974,2856573604,'Libra'],
  [2856573604,2856782438,'Scorpio'],
  [2856782438,2856980011,'Sagittarius'],
  [2856980011,2857168977,'Capricorn'],
  [2857168977,2857353561,'Aquarius'],
  [2857353561,2857536968,'Pisces'],
  [2857536968,2857720788,'Aries'],
  [2857720788,2857906206,'Taurus'],
  [2857906206,2858095602,'Gemini'],
  [2858095602,2858292672,'Cancer'],
  [2858292672,2858500376,'Leo'],
  [2858500376,2858717362,'Virgo'],
  [2858717362,2858936098,'Libra'],
  [2858936098,2859146852,'Scorpio'],
  [2859146852,2859344558,'Sagittarius'],
  [2859344558,2859530831,'Capricorn'],
  [2859530831,2859710939,'Aquarius'],
  [2859710939,2859890378,'Pisces'],
  [2859890378,2860072880,'Aries'],
  [2860072880,2860260127,'Taurus'],
  [2860260127,2860452968,'Gemini'],
  [2860452968,2860652728,'Cancer'],
  [2860652728,2860861029,'Leo'],
  [2860861029,2861077542,'Virgo'],
  [2861077542,2861297228,'Libra'],
  [2861297228,2861511181,'Scorpio'],
  [2861511181,2861712164,'Sagittarius'],
  [2861712164,2861899189,'Capricorn'],
  [2861899189,2862076642,'Aquarius'],
  [2862076642,2862250986,'Pisces'],
  [2862250986,2862428253,'Aries'],
  [2862428253,2862612594,'Taurus'],
  [2862612594,2862805820,'Gemini'],
  [2862805820,2863007973,'Cancer'],
  [2863007973,2863218246,'Leo'],
  [2863218246,2863435154,'Virgo'],
  [2863435154,2863655152,'Libra'],
  [2863655152,2863871737,'Scorpio'],
  [2863871737,2864077674,'Sagittarius'],
  [2864077674,2864269287,'Capricorn'],
  [2864269287,2864448361,'Aquarius'],
  [2864448361,2864620425,'Pisces'],
  [2864620425,2864792331,'Aries'],
  [2864792331,2864970527,'Taurus'],
  [2864970527,2865159591,'Gemini'],
  [2865159591,2865360946,'Cancer'],
  [2865360946,2865572577,'Leo'],
  [2865572577,2865790471,'Virgo'],
  [2865790471,2866010276,'Libra'],
  [2866010276,2866227431,'Scorpio'],
  [2866227431,2866436957,'Sagittarius'],
  [2866436957,2866634651,'Capricorn'],
  [2866634651,2866819424,'Aquarius'],
  [2866819424,2866994111,'Pisces'],
  [2866994111,2867164452,'Aries'],
  [2867164452,2867337521,'Taurus'],
  [2867337521,2867520132,'Gemini'],
  [2867520132,2867716721,'Cancer'],
  [2867716721,2867926918,'Leo'],
  [2867926918,2868145329,'Virgo'],
  [2868145329,2868365013,'Libra'],
  [2868365013,2868581006,'Scorpio'],
  [2868581006,2868790609,'Sagittarius'],
  [2868790609,2868991788,'Capricorn'],
  [2868991788,2869182889,'Aquarius'],
  [2869182889,2869363946,'Pisces'],
  [2869363946,2869537878,'Aries'],
  [2869537878,2869710389,'Taurus'],
  [2869710389,2869888656,'Gemini'],
  [2869888656,2870079263,'Cancer'],
  [2870079263,2870285036,'Leo'],
  [2870285036,2870502177,'Virgo'],
  [2870502177,2870721964,'Libra'],
  [2870721964,2870936856,'Scorpio'],
  [2870936856,2871144100,'Sagittarius'],
  [2871144100,2871344103,'Capricorn'],
  [2871344103,2871537465,'Aquarius'],
  [2871537465,2871724069,'Pisces'],
  [2871724069,2871904366,'Aries'],
  [2871904366,2872081179,'Taurus'],
  [2872081179,2872259986,'Gemini'],
  [2872259986,2872447424,'Cancer'],
  [2872447424,2872648465,'Leo'],
  [2872648465,2872862561,'Virgo'],
  [2872862561,2873082110,'Libra'],
  [2873082110,2873297277,'Scorpio'],
  [2873297277,2873502830,'Sagittarius'],
  [2873502830,2873699344,'Capricorn'],
  [2873699344,2873889829,'Aquarius'],
  [2873889829,2874076660,'Pisces'],
  [2874076660,2874260806,'Aries'],
  [2874260806,2874443206,'Taurus'],
  [2874443206,2874626520,'Gemini'],
  [2874626520,2874815340,'Cancer'],
  [2874815340,2875014476,'Leo'],
  [2875014476,2875225644,'Virgo'],
  [2875225644,2875444291,'Libra'],
  [2875444291,2875660870,'Scorpio'],
  [2875660870,2875867397,'Sagittarius'],
  [2875867397,2876062154,'Capricorn'],
  [2876062154,2876248374,'Aquarius'],
  [2876248374,2876430701,'Pisces'],
  [2876430701,2876612819,'Aries'],
  [2876612819,2876796880,'Taurus'],
  [2876796880,2876984373,'Gemini'],
  [2876984373,2877177261,'Cancer'],
  [2877177261,2877378078,'Leo'],
  [2877378078,2877588388,'Virgo'],
  [2877588388,2877806058,'Libra'],
  [2877806058,2878024075,'Scorpio'],
  [2878024075,2878233792,'Sagittarius'],
  [2878233792,2878430497,'Capricorn'],
  [2878430497,2878615336,'Aquarius'],
  [2878615336,2878793128,'Pisces'],
  [2878793128,2878969626,'Aries'],
  [2878969626,2879149770,'Taurus'],
  [2879149770,2879336825,'Gemini'],
  [2879336825,2879532246,'Cancer'],
  [2879532246,2879736149,'Leo'],
  [2879736149,2879947832,'Virgo'],
  [2879947832,2880165281,'Libra'],
  [2880165281,2880383971,'Scorpio'],
  [2880383971,2880597065,'Sagittarius'],
  [2880597065,2880798410,'Capricorn'],
  [2880798410,2880986147,'Aquarius'],
  [2880986147,2881163182,'Pisces'],
  [2881163182,2881335368,'Aries'],
  [2881335368,2881509455,'Taurus'],
  [2881509455,2881691424,'Gemini'],
  [2881691424,2881884880,'Cancer'],
  [2881884880,2882089863,'Leo'],
  [2882089863,2882303397,'Virgo'],
  [2882303397,2882521474,'Libra'],
  [2882521474,2882740108,'Scorpio'],
  [2882740108,2882954898,'Sagittarius'],
  [2882954898,2883160776,'Capricorn'],
  [2883160776,2883354043,'Aquarius'],
  [2883354043,2883534712,'Pisces'],
  [2883534712,2883706861,'Aries'],
  [2883706861,2883877233,'Taurus'],
  [2883877233,2884053314,'Gemini'],
  [2884053314,2884241319,'Cancer'],
  [2884241319,2884443629,'Leo'],
  [2884443629,2884657273,'Virgo'],
  [2884657273,2884876031,'Libra'],
  [2884876031,2885094347,'Scorpio'],
  [2885094347,2885308786,'Sagittarius'],
  [2885308786,2885516588,'Capricorn'],
  [2885516588,2885714689,'Aquarius'],
  [2885714689,2885901206,'Pisces'],
  [2885901206,2886077484,'Aries'],
  [2886077484,2886248557,'Taurus'],
  [2886248557,2886421714,'Gemini'],
  [2886421714,2886604435,'Cancer'],
  [2886604435,2886801689,'Leo'],
  [2886801689,2887012819,'Virgo'],
  [2887012819,2887231327,'Libra'],
  [2887231327,2887449419,'Scorpio'],
  [2887449419,2887662529,'Sagittarius'],
  [2887662529,2887869240,'Capricorn'],
  [2887869240,2888068713,'Aquarius'],
  [2888068713,2888259629,'Pisces'],
  [2888259629,2888441598,'Aries'],
  [2888441598,2888617088,'Taurus'],
  [2888617088,2888791612,'Gemini'],
  [2888791612,2888972224,'Cancer'],
  [2888972224,2889165111,'Leo'],
  [2889165111,2889372286,'Virgo'],
  [2889372286,2889589247,'Libra'],
  [2889589247,2889807305,'Scorpio'],
  [2889807305,2890019578,'Sagittarius'],
  [2890019578,2890223950,'Capricorn'],
  [2890223950,2890421216,'Aquarius'],
  [2890421216,2890612339,'Pisces'],
  [2890612339,2890797694,'Aries'],
  [2890797694,2890978328,'Taurus'],
  [2890978328,2891157327,'Gemini'],
  [2891157327,2891339783,'Cancer'],
  [2891339783,2891531297,'Leo'],
  [2891531297,2891735304,'Virgo'],
  [2891735304,2891950046,'Libra'],
  [2891950046,2892168156,'Scorpio'],
  [2892168156,2892381041,'Sagittarius'],
  [2892381041,2892584248,'Capricorn'],
  [2892584248,2892778244,'Aquarius'],
  [2892778244,2892965831,'Pisces'],
  [2892965831,2893149827,'Aries'],
  [2893149827,2893332398,'Taurus'],
  [2893332398,2893515641,'Gemini'],
  [2893515641,2893702319,'Cancer'],
  [2893702319,2893895846,'Leo'],
  [2893895846,2894099104,'Virgo'],
  [2894099104,2894312133,'Libra'],
  [2894312133,2894530216,'Scorpio'],
  [2894530216,2894745105,'Sagittarius'],
  [2894745105,2894949865,'Capricorn'],
  [2894949865,2895142689,'Aquarius'],
  [2895142689,2895326298,'Pisces'],
  [2895326298,2895505443,'Aries'],
  [2895505443,2895684897,'Taurus'],
  [2895684897,2895868346,'Gemini'],
  [2895868346,2896058056,'Cancer'],
  [2896058056,2896255172,'Leo'],
  [2896255172,2896460235,'Virgo'],
  [2896460235,2896672985,'Libra'],
  [2896672985,2896890902,'Scorpio'],
  [2896890902,2897108051,'Sagittarius'],
  [2897108051,2897316791,'Capricorn'],
  [2897316791,2897512299,'Aquarius'],
  [2897512299,2897695111,'Pisces'],
  [2897695111,2897869996,'Aries'],
  [2897869996,2898043576,'Taurus'],
  [2898043576,2898222236,'Gemini'],
  [2898222236,2898410364,'Cancer'],
  [2898410364,2898609107,'Leo'],
  [2898609107,2898816771,'Virgo'],
  [2898816771,2899030752,'Libra'],
  [2899030752,2899248592,'Scorpio'],
  [2899248592,2899466842,'Sagittarius'],
  [2899466842,2899679690,'Capricorn'],
  [2899679690,2899880825,'Aquarius'],
  [2899880825,2900067517,'Pisces'],
  [2900067517,2900242413,'Aries'],
  [2900242413,2900412064,'Taurus'],
  [2900412064,2900584400,'Gemini'],
  [2900584400,2900766514,'Cancer'],
  [2900766514,2900962190,'Leo'],
  [2900962190,2901170158,'Virgo'],
  [2901170158,2901385603,'Libra'],
  [2901385603,2901603803,'Scorpio'],
  [2901603803,2901821718,'Sagittarius'],
  [2901821718,2902036170,'Capricorn'],
  [2902036170,2902242304,'Aquarius'],
  [2902242304,2902435619,'Pisces'],
  [2902435619,2902615493,'Aries'],
  [2902615493,2902786328,'Taurus'],
  [2902786328,2902955657,'Gemini'],
  [2902955657,2903131701,'Cancer'],
  [2903131701,2903320939,'Leo'],
  [2903320939,2903525119,'Virgo'],
  [2903525119,2903740057,'Libra'],
  [2903740057,2903958747,'Scorpio'],
  [2903958747,2904175983,'Sagittarius'],
  [2904175983,2904389283,'Capricorn'],
  [2904389283,2904596472,'Aquarius'],
  [2904596472,2904794470,'Pisces'],
  [2904794470,2904981095,'Aries'],
  [2904981095,2905157676,'Taurus'],
  [2905157676,2905329424,'Gemini'],
  [2905329424,2905503684,'Cancer'],
  [2905503684,2905687724,'Leo'],
  [2905687724,2905886045,'Virgo'],
  [2905886045,2906097600,'Libra'],
  [2906097600,2906315821,'Scorpio'],
  [2906315821,2906532974,'Sagittarius'],
  [2906532974,2906744585,'Capricorn'],
  [2906744585,2906949388,'Aquarius'],
  [2906949388,2907147017,'Pisces'],
  [2907147017,2907336949,'Aries'],
  [2907336949,2907519494,'Taurus'],
  [2907519494,2907697148,'Gemini'],
  [2907697148,2907874697,'Cancer'],
  [2907874697,2908058088,'Leo'],
  [2908058088,2908252495,'Virgo'],
  [2908252495,2908459715,'Libra'],
  [2908459715,2908676068,'Scorpio'],
  [2908676068,2908893588,'Sagittarius'],
  [2908893588,2909105014,'Capricorn'],
  [2909105014,2909307357,'Aquarius'],
  [2909307357,2909501325,'Pisces'],
  [2909501325,2909689113,'Aries'],
  [2909689113,2909872975,'Taurus'],
  [2909872975,2910055077,'Gemini'],
  [2910055077,2910237954,'Cancer'],
  [2910237954,2910424857,'Leo'],
  [2910424857,2910619406,'Virgo'],
  [2910619406,2910824169,'Libra'],
  [2910824169,2911038322,'Scorpio'],
  [2911038322,2911256126,'Sagittarius'],
  [2911256126,2911469181,'Capricorn'],
  [2911469181,2911671607,'Aquarius'],
  [2911671607,2911862732,'Pisces'],
  [2911862732,2912045918,'Aries'],
  [2912045918,2912226013,'Taurus'],
  [2912226013,2912407363,'Gemini'],
  [2912407363,2912592842,'Cancer'],
  [2912592842,2912783926,'Leo'],
  [2912783926,2912981574,'Virgo'],
  [2912981574,2913186850,'Libra'],
  [2913186850,2913399922,'Scorpio'],
  [2913399922,2913617768,'Sagittarius'],
  [2913617768,2913833264,'Capricorn'],
  [2913833264,2914038593,'Aquarius'],
  [2914038593,2914230293,'Pisces'],
  [2914230293,2914410692,'Aries'],
  [2914410692,2914585742,'Taurus'],
  [2914585742,2914762136,'Gemini'],
  [2914762136,2914945119,'Cancer'],
  [2914945119,2915137056,'Leo'],
  [2915137056,2915337516,'Virgo'],
  [2915337516,2915545066,'Libra'],
  [2915545066,2915758628,'Scorpio'],
  [2915758628,2915976464,'Sagittarius'],
  [2915976464,2916193866,'Capricorn'],
  [2916193866,2916403334,'Aquarius'],
  [2916403334,2916598987,'Pisces'],
  [2916598987,2916780594,'Aries'],
  [2916780594,2916953286,'Taurus'],
  [2916953286,2917124636,'Gemini'],
  [2917124636,2917301984,'Cancer'],
  [2917301984,2917490232,'Leo'],
  [2917490232,2917690208,'Virgo'],
  [2917690208,2917899308,'Libra'],
  [2917899308,2918114145,'Scorpio'],
  [2918114145,2918332112,'Sagittarius'],
  [2918332112,2918550087,'Capricorn'],
  [2918550087,2918762622,'Aquarius'],
  [2918762622,2918963469,'Pisces'],
  [2918963469,2919149811,'Aries'],
  [2919149811,2919324436,'Taurus'],
  [2919324436,2919494082,'Gemini'],
  [2919494082,2919666685,'Cancer'],
  [2919666685,2919849114,'Leo'],
  [2919849114,2920044881,'Virgo'],
  [2920044881,2920252778,'Libra'],
  [2920252778,2920468232,'Scorpio'],
  [2920468232,2920686443,'Sagittarius'],
  [2920686443,2920903869,'Capricorn'],
  [2920903869,2921116927,'Aquarius'],
  [2921116927,2921321178,'Pisces'],
  [2921321178,2921513136,'Aries'],
  [2921513136,2921693039,'Taurus'],
  [2921693039,2921865346,'Gemini'],
  [2921865346,2922036959,'Cancer'],
  [2922036959,2922215134,'Leo'],
  [2922215134,2922405401,'Virgo'],
  [2922405401,2922609338,'Libra'],
  [2922609338,2922823616,'Scorpio'],
  [2922823616,2923041906,'Sagittarius'],
  [2923041906,2923258564,'Capricorn'],
  [2923258564,2923470067,'Aquarius'],
  [2923470067,2923674134,'Pisces'],
  [2923674134,2923869044,'Aries'],
  [2923869044,2924054392,'Taurus'],
  [2924054392,2924232244,'Gemini'],
  [2924232244,2924407116,'Cancer'],
  [2924407116,2924584956,'Leo'],
  [2924584956,2924771641,'Virgo'],
  [2924771641,2924970961,'Libra'],
  [2924970961,2925182366,'Scorpio'],
  [2925182366,2925400223,'Sagittarius'],
  [2925400223,2925616781,'Capricorn'],
  [2925616781,2925826571,'Aquarius'],
  [2925826571,2926027852,'Pisces'],
  [2926027852,2926221322,'Aries'],
  [2926221322,2926408456,'Taurus'],
  [2926408456,2926590996,'Gemini'],
  [2926590996,2926771290,'Cancer'],
  [2926771290,2926952720,'Leo'],
  [2926952720,2927139628,'Virgo'],
  [2927139628,2927336258,'Libra'],
  [2927336258,2927544517,'Scorpio'],
  [2927544517,2927761345,'Sagittarius'],
  [2927761345,2927978760,'Capricorn'],
  [2927978760,2928188623,'Aquarius'],
  [2928188623,2928387486,'Pisces'],
  [2928387486,2928576946,'Aries'],
  [2928576946,2928761015,'Taurus'],
  [2928761015,2928943580,'Gemini'],
  [2928943580,2929127220,'Cancer'],
  [2929127220,2929313445,'Leo'],
  [2929313445,2929503907,'Virgo'],
  [2929503907,2929701186,'Libra'],
  [2929701186,2929907820,'Scorpio'],
  [2929907820,2930123428,'Sagittarius'],
  [2930123428,2930342106,'Capricorn'],
  [2930342106,2930554442,'Aquarius'],
  [2930554442,2930753952,'Pisces'],
  [2930753952,2930940776,'Aries'],
  [2930940776,2931119909,'Taurus'],
  [2931119909,2931297708,'Gemini'],
  [2931297708,2931479265,'Cancer'],
  [2931479265,2931667017,'Leo'],
  [2931667017,2931861151,'Virgo'],
  [2931861151,2932061545,'Libra'],
  [2932061545,2932269004,'Scorpio'],
  [2932269004,2932484000,'Sagittarius'],
  [2932484000,2932703438,'Capricorn'],
  [2932703438,2932919289,'Aquarius'],
  [2932919289,2933122946,'Pisces'],
  [2933122946,2933311400,'Aries'],
  [2933311400,2933488317,'Taurus'],
  [2933488317,2933660817,'Gemini'],
  [2933660817,2933836242,'Cancer'],
  [2933836242,2934019893,'Leo'],
  [2934019893,2934213596,'Virgo'],
  [2934213596,2934416253,'Libra'],
  [2934416253,2934626012,'Scorpio'],
  [2934626012,2934841598,'Sagittarius'],
  [2934841598,2935061039,'Capricorn'],
  [2935061039,2935279106,'Aquarius'],
  [2935279106,2935487941,'Pisces'],
  [2935487941,2935681969,'Aries'],
  [2935681969,2935861756,'Taurus'],
  [2935861756,2936033011,'Gemini'],
  [2936033011,2936203433,'Cancer'],
  [2936203433,2936380293,'Leo'],
  [2936380293,2936568508,'Virgo'],
  [2936568508,2936769189,'Libra'],
  [2936769189,2936979910,'Scorpio'],
  [2936979910,2937196737,'Sagittarius'],
  [2937196737,2937416064,'Capricorn'],
  [2937416064,2937634064,'Aquarius'],
  [2937634064,2937845590,'Pisces'],
  [2937845590,2938045475,'Aries'],
  [2938045475,2938231725,'Taurus'],
  [2938231725,2938407026,'Gemini'],
  [2938407026,2938577400,'Cancer'],
  [2938577400,2938750069,'Leo'],
  [2938750069,2938931698,'Virgo'],
  [2938931698,2939126561,'Libra'],
  [2939126561,2939334707,'Scorpio'],
  [2939334707,2939551690,'Sagittarius'],
  [2939551690,2939771194,'Capricorn'],
  [2939771194,2939988040,'Aquarius'],
  [2939988040,2940198739,'Pisces'],
  [2940198739,2940400741,'Aries'],
  [2940400741,2940592458,'Taurus'],
  [2940592458,2940774358,'Gemini'],
  [2940774358,2940949523,'Cancer'],
  [2940949523,2941123204,'Leo'],
  [2941123204,2941301727,'Virgo'],
  [2941301727,2941490983,'Libra'],
  [2941490983,2941694139,'Scorpio'],
  [2941694139,2941909081,'Sagittarius'],
  [2941909081,2942128587,'Capricorn'],
  [2942128587,2942344778,'Aquarius'],
  [2942344778,2942553226,'Pisces'],
  [2942553226,2942753241,'Aries'],
  [2942753241,2942945747,'Taurus'],
  [2942945747,2943131870,'Gemini'],
  [2943131870,2943312994,'Cancer'],
  [2943312994,2943491588,'Leo'],
  [2943491588,2943671831,'Virgo'],
  [2943671831,2943859111,'Libra'],
  [2943859111,2944058159,'Scorpio'],
  [2944058159,2944269859,'Sagittarius'],
  [2944269859,2944488723,'Capricorn'],
  [2944488723,2944705313,'Aquarius'],
  [2944705313,2944912641,'Pisces'],
  [2944912641,2945109536,'Aries'],
  [2945109536,2945298830,'Taurus'],
  [2945298830,2945484080,'Gemini'],
  [2945484080,2945667714,'Cancer'],
  [2945667714,2945851065,'Leo'],
  [2945851065,2946035793,'Virgo'],
  [2946035793,2946225091,'Libra'],
  [2946225091,2946423134,'Scorpio'],
  [2946423134,2946632445,'Sagittarius'],
  [2946632445,2946850295,'Capricorn'],
  [2946850295,2947068025,'Aquarius'],
  [2947068025,2947276473,'Pisces'],
  [2947276473,2947472181,'Aries'],
  [2947472181,2947657839,'Taurus'],
  [2947657839,2947838804,'Gemini'],
  [2947838804,2948019923,'Cancer'],
  [2948019923,2948203982,'Leo'],
  [2948203982,2948392028,'Virgo'],
  [2948392028,2948585027,'Libra'],
  [2948585027,2948784983,'Scorpio'],
  [2948784983,2948993971,'Sagittarius'],
  [2948993971,2949211111,'Capricorn'],
  [2949211111,2949430065,'Aquarius'],
  [2949430065,2949641405,'Pisces'],
  [2949641405,2949839089,'Aries'],
  [2949839089,2950023832,'Taurus'],
  [2950023832,2950200977,'Gemini'],
  [2950200977,2950377002,'Cancer'],
  [2950377002,2950557149,'Leo'],
  [2950557149,2950744290,'Virgo'],
  [2950744290,2950939213,'Libra'],
  [2950939213,2951141904,'Scorpio'],
  [2951141904,2951352334,'Sagittarius'],
  [2951352334,2951569502,'Capricorn'],
  [2951569502,2951789153,'Aquarius'],
  [2951789153,2952003601,'Pisces'],
  [2952003601,2952205648,'Aries'],
  [2952205648,2952393258,'Taurus'],
  [2952393258,2952569995,'Gemini'],
  [2952569995,2952742275,'Cancer'],
  [2952742275,2952916837,'Leo'],
  [2952916837,2953099068,'Virgo'],
  [2953099068,2953291872,'Libra'],
  [2953291872,2953495346,'Scorpio'],
  [2953495346,2953707475,'Sagittarius'],
  [2953707475,2953925310,'Capricorn'],
  [2953925310,2954144970,'Aquarius'],
  [2954144970,2954361026,'Pisces'],
  [2954361026,2954567458,'Aries'],
  [2954567458,2954760517,'Taurus'],
  [2954760517,2954940978,'Gemini'],
  [2954940978,2955113487,'Cancer'],
  [2955113487,2955284606,'Leo'],
  [2955284606,2955461130,'Virgo'],
  [2955461130,2955648552,'Libra'],
  [2955648552,2955849287,'Scorpio'],
  [2955849287,2956061462,'Sagittarius'],
  [2956061462,2956279983,'Capricorn'],
  [2956279983,2956499305,'Aquarius'],
  [2956499305,2956714906,'Pisces'],
  [2956714906,2956923151,'Aries'],
  [2956923151,2957121098,'Taurus'],
  [2957121098,2957307642,'Gemini'],
  [2957307642,2957484613,'Cancer'],
  [2957484613,2957656674,'Leo'],
  [2957656674,2957830302,'Virgo'],
  [2957830302,2958012334,'Libra'],
  [2958012334,2958207869,'Scorpio'],
  [2958207869,2958417443,'Sagittarius'],
  [2958417443,2958635774,'Capricorn'],
  [2958635774,2958854916,'Aquarius'],
  [2958854916,2959069034,'Pisces'],
  [2959069034,2959275881,'Aries'],
  [2959275881,2959474996,'Taurus'],
  [2959474996,2959666062,'Gemini'],
  [2959666062,2959849190,'Cancer'],
  [2959849190,2960026224,'Leo'],
  [2960026224,2960201548,'Virgo'],
  [2960201548,2960381480,'Libra'],
  [2960381480,2960572420,'Scorpio'],
  [2960572420,2960777745,'Sagittarius'],
  [2960777745,2960994446,'Capricorn'],
  [2960994446,2961213728,'Aquarius'],
  [2961213728,2961427110,'Pisces'],
  [2961427110,2961631371,'Aries'],
  [2961631371,2961827743,'Taurus'],
  [2961827743,2962018501,'Gemini'],
  [2962018501,2962204898,'Cancer'],
  [2962204898,2962387485,'Leo'],
  [2962387485,2962567931,'Virgo'],
  [2962567931,2962750230,'Libra'],
  [2962750230,2962939998,'Scorpio'],
  [2962939998,2963141963,'Sagittarius'],
  [2963141963,2963356131,'Capricorn'],
  [2963356131,2963575504,'Aquarius'],
  [2963575504,2963789927,'Pisces'],
  [2963789927,2963993377,'Aries'],
  [2963993377,2964186355,'Taurus'],
  [2964186355,2964372877,'Gemini'],
  [2964372877,2964556933,'Cancer'],
  [2964556933,2964740794,'Leo'],
  [2964740794,2964925488,'Virgo'],
  [2964925488,2965112548,'Libra'],
  [2965112548,2965305031,'Scorpio'],
  [2965305031,2965506648,'Sagittarius'],
  [2965506648,2965718949,'Capricorn'],
  [2965718949,2965937995,'Aquarius'],
  [2965937995,2966154656,'Pisces'],
  [2966154656,2966360471,'Aries'],
  [2966360471,2966553113,'Taurus'],
  [2966553113,2966735940,'Gemini'],
  [2966735940,2966914531,'Cancer'],
  [2966914531,2967093978,'Leo'],
  [2967093978,2967277616,'Virgo'],
  [2967277616,2967467112,'Libra'],
  [2967467112,2967663435,'Scorpio'],
  [2967663435,2967867569,'Sagittarius'],
  [2967867569,2968079985,'Capricorn'],
  [2968079985,2968298569,'Aquarius'],
  [2968298569,2968517065,'Pisces'],
  [2968517065,2968727163,'Aries'],
  [2968727163,2968923610,'Taurus'],
  [2968923610,2969106991,'Gemini'],
  [2969106991,2969282160,'Cancer'],
  [2969282160,2969455549,'Leo'],
  [2969455549,2969633232,'Virgo'],
  [2969633232,2969819605,'Libra'],
  [2969819605,2970016504,'Scorpio'],
  [2970016504,2970223181,'Sagittarius'],
  [2970223181,2970437348,'Capricorn'],
  [2970437348,2970656004,'Aquarius'],
  [2970656004,2970874963,'Pisces'],
  [2970874963,2971088415,'Aries'],
  [2971088415,2971290571,'Taurus'],
  [2971290571,2971478948,'Gemini'],
  [2971478948,2971655694,'Cancer'],
  [2971655694,2971826411,'Leo'],
  [2971826411,2971998212,'Virgo'],
  [2971998212,2972177988,'Libra'],
  [2972177988,2972370510,'Scorpio'],
  [2972370510,2972576388,'Sagittarius'],
  [2972576388,2972791794,'Capricorn'],
  [2972791794,2973011105,'Aquarius'],
  [2973011105,2973229617,'Pisces'],
  [2973229617,2973443737,'Aries'],
  [2973443737,2973649750,'Taurus'],
  [2973649750,2973844361,'Gemini'],
  [2973844361,2974026782,'Cancer'],
  [2974026782,2974199995,'Leo'],
  [2974199995,2974370149,'Virgo'],
  [2974370149,2974544828,'Libra'],
  [2974544828,2974731025,'Scorpio'],
  [2974731025,2974932358,'Sagittarius'],
  [2974932358,2975146439,'Capricorn'],
  [2975146439,2975366046,'Aquarius'],
  [2975366046,2975584107,'Pisces'],
  [2975584107,2975796941,'Aries'],
  [2975796941,2976003089,'Taurus'],
  [2976003089,2976201066,'Gemini'],
  [2976201066,2976389383,'Cancer'],
  [2976389383,2976568384,'Leo'],
  [2976568384,2976741707,'Virgo'],
  [2976741707,2976915773,'Libra'],
  [2976915773,2977097955,'Scorpio'],
  [2977097955,2977293965,'Sagittarius'],
  [2977293965,2977504378,'Capricorn'],
  [2977504378,2977723037,'Aquarius'],
  [2977723037,2977940977,'Pisces'],
  [2977940977,2978152446,'Aries'],
  [2978152446,2978356312,'Taurus'],
  [2978356312,2978553343,'Gemini'],
  [2978553343,2978743842,'Cancer'],
  [2978743842,2978927775,'Leo'],
  [2978927775,2979106531,'Virgo'],
  [2979106531,2979284106,'Libra'],
  [2979284106,2979466483,'Scorpio'],
  [2979466483,2979659603,'Sagittarius'],
  [2979659603,2979866221,'Capricorn'],
  [2979866221,2980082895,'Aquarius'],
  [2980082895,2980300935,'Pisces'],
  [2980300935,2980512310,'Aries'],
  [2980512310,2980714161,'Taurus'],
  [2980714161,2980907896,'Gemini'],
  [2980907896,2981096098,'Cancer'],
  [2981096098,2981280671,'Leo'],
  [2981280671,2981463034,'Virgo'],
  [2981463034,2981645346,'Libra'],
  [2981645346,2981831196,'Scorpio'],
  [2981831196,2982024968,'Sagittarius'],
  [2982024968,2982229765,'Capricorn'],
  [2982229765,2982444516,'Aquarius'],
  [2982444516,2982662703,'Pisces'],
  [2982662703,2982875549,'Aries'],
  [2982875549,2983077628,'Taurus'],
  [2983077628,2983268964,'Gemini'],
  [2983268964,2983452979,'Cancer'],
  [2983452979,2983633888,'Leo'],
  [2983633888,2983815246,'Virgo'],
  [2983815246,2983999690,'Libra'],
  [2983999690,2984189338,'Scorpio'],
  [2984189338,2984386165,'Sagittarius'],
  [2984386165,2984591712,'Capricorn'],
  [2984591712,2984805630,'Aquarius'],
  [2984805630,2985023893,'Pisces'],
  [2985023893,2985239077,'Aries'],
  [2985239077,2985444036,'Taurus'],
  [2985444036,2985636119,'Gemini'],
  [2985636119,2985817628,'Cancer'],
  [2985817628,2985993712,'Leo'],
  [2985993712,2986170210,'Virgo'],
  [2986170210,2986352099,'Libra'],
  [2986352099,2986542431,'Scorpio'],
  [2986542431,2986741964,'Sagittarius'],
  [2986741964,2986949800,'Capricorn'],
  [2986949800,2987164257,'Aquarius'],
  [2987164257,2987382517,'Pisces'],
  [2987382517,2987599595,'Aries'],
  [2987599595,2987808787,'Taurus'],
  [2987808787,2988005038,'Gemini'],
  [2988005038,2988187972,'Cancer'],
  [2988187972,2988361773,'Leo'],
  [2988361773,2988533172,'Virgo'],
  [2988533172,2988709322,'Libra'],
  [2988709322,2988895840,'Scorpio'],
  [2988895840,2989094817,'Sagittarius'],
  [2989094817,2989304238,'Capricorn'],
  [2989304238,2989519989,'Aquarius'],
  [2989519989,2989738298,'Pisces'],
  [2989738298,2989955828,'Aries'],
  [2989955828,2990168142,'Taurus'],
  [2990168142,2990369939,'Gemini'],
  [2990369939,2990558113,'Cancer'],
  [2990558113,2990734189,'Leo'],
  [2990734189,2990903927,'Virgo'],
  [2990903927,2991075146,'Libra'],
  [2991075146,2991255504,'Scorpio'],
  [2991255504,2991449919,'Sagittarius'],
  [2991449919,2991657981,'Capricorn'],
  [2991657981,2991874384,'Aquarius'],
  [2991874384,2992092926,'Pisces'],
  [2992092926,2992309694,'Aries'],
  [2992309694,2992522252,'Taurus'],
  [2992522252,2992727437,'Gemini'],
  [2992727437,2992921682,'Cancer'],
  [2992921682,2993103757,'Leo'],
  [2993103757,2993276756,'Virgo'],
  [2993276756,2993447290,'Libra'],
  [2993447290,2993623325,'Scorpio'],
  [2993623325,2993811766,'Sagittarius'],
  [2993811766,2994015296,'Capricorn'],
  [2994015296,2994230260,'Aquarius'],
  [2994230260,2994448957,'Pisces'],
  [2994448957,2994664983,'Aries'],
  [2994664983,2994875652,'Taurus'],
  [2994875652,2995080054,'Gemini'],
  [2995080054,2995276850,'Cancer'],
  [2995276850,2995464594,'Leo'],
  [2995464594,2995643876,'Virgo'],
  [2995643876,2995818572,'Libra'],
  [2995818572,2995995015,'Scorpio'],
  [2995995015,2996180081,'Sagittarius'],
  [2996180081,2996378540,'Capricorn'],
  [2996378540,2996589996,'Aquarius'],
  [2996589996,2996808080,'Pisces'],
  [2996808080,2997024334,'Aries'],
  [2997024334,2997233542,'Taurus'],
  [2997233542,2997434796,'Gemini'],
  [2997434796,2997629162,'Cancer'],
  [2997629162,2997817686,'Leo'],
  [2997817686,2998001298,'Virgo'],
  [2998001298,2998181871,'Libra'],
  [2998181871,2998362933,'Scorpio'],
  [2998362933,2998549281,'Sagittarius'],
  [2998549281,2998745487,'Capricorn'],
  [2998745487,2998953446,'Aquarius'],
  [2998953446,2999169974,'Pisces'],
  [2999169974,2999387196,'Aries'],
  [2999387196,2999597239,'Taurus'],
  [2999597239,2999796732,'Gemini'],
  [2999796732,2999986910,'Cancer'],
  [2999986910,3000171248,'Leo'],
  [3000171248,3000353393,'Virgo'],
  [3000353393,3000536251,'Libra'],
  [3000536251,3000722023,'Scorpio'],
  [3000722023,3000912744,'Sagittarius'],
  [3000912744,3001110633,'Capricorn'],
  [3001110633,3001317427,'Aquarius'],
  [3001317427,3001532406,'Pisces'],
  [3001532406,3001750469,'Aries'],
  [3001750469,3001963353,'Taurus'],
  [3001963353,3002164615,'Gemini'],
  [3002164615,3002353216,'Cancer'],
  [3002353216,3002532888,'Leo'],
  [3002532888,3002709517,'Virgo'],
  [3002709517,3002888788,'Libra'],
  [3002888788,3003074594,'Scorpio'],
  [3003074594,3003268350,'Sagittarius'],
  [3003268350,3003469709,'Capricorn'],
  [3003469709,3003678047,'Aquarius'],
  [3003678047,3003892671,'Pisces'],
  [3003892671,3004111007,'Aries'],
  [3004111007,3004326894,'Taurus'],
  [3004326894,3004532633,'Gemini'],
  [3004532633,3004723997,'Cancer'],
  [3004723997,3004902707,'Leo'],
  [3004902707,3005074860,'Virgo'],
  [3005074860,3005247995,'Libra'],
  [3005247995,3005428709,'Scorpio'],
  [3005428709,3005620619,'Sagittarius'],
  [3005620619,3005823325,'Capricorn'],
  [3005823325,3006033896,'Aquarius'],
  [3006033896,3006249476,'Pisces'],
  [3006249476,3006467804,'Aries'],
  [3006467804,3006685187,'Taurus'],
  [3006685187,3006895319,'Gemini'],
  [3006895319,3007092225,'Cancer'],
  [3007092225,3007274570,'Leo'],
  [3007274570,3007446653,'Virgo'],
  [3007446653,3007615996,'Libra'],
  [3007615996,3007790620,'Scorpio'],
  [3007790620,3007976763,'Sagittarius'],
  [3007976763,3008176531,'Capricorn'],
  [3008176531,3008387225,'Aquarius'],
  [3008387225,3008603843,'Pisces'],
  [3008603843,3008822256,'Aries'],
  [3008822256,3009039441,'Taurus'],
  [3009039441,3009251444,'Gemini'],
  [3009251444,3009453207,'Cancer'],
  [3009453207,3009641536,'Leo'],
  [3009641536,3009817917,'Virgo'],
  [3009817917,3009988115,'Libra'],
  [3009988115,3010159812,'Scorpio'],
  [3010159812,3010340381,'Sagittarius'],
  [3010340381,3010534545,'Capricorn'],
  [3010534545,3010742179,'Aquarius'],
  [3010742179,3010958412,'Pisces'],
  [3010958412,3011176924,'Aries'],
  [3011176924,3011393185,'Taurus'],
  [3011393185,3011604290,'Gemini'],
  [3011604290,3011807490,'Cancer'],
  [3011807490,3012000344,'Leo'],
  [3012000344,3012182629,'Virgo'],
  [3012182629,3012357514,'Libra'],
  [3012357514,3012530802,'Scorpio'],
  [3012530802,3012709257,'Sagittarius'],
  [3012709257,3012898690,'Capricorn'],
  [3012898690,3013101661,'Aquarius'],
  [3013101661,3013315658,'Pisces'],
  [3013315658,3013533943,'Aries'],
  [3013533943,3013749642,'Taurus'],
  [3013749642,3013958772,'Gemini'],
  [3013958772,3014160010,'Cancer'],
  [3014160010,3014353274,'Leo'],
  [3014353274,3014539156,'Virgo'],
  [3014539156,3014719433,'Libra'],
  [3014719433,3014897463,'Scorpio'],
  [3014897463,3015077937,'Sagittarius'],
  [3015077937,3015265953,'Capricorn'],
  [3015265953,3015465326,'Aquarius'],
  [3015465326,3015676283,'Pisces'],
  [3015676283,3015893872,'Aries'],
  [3015893872,3016109948,'Taurus'],
  [3016109948,3016318100,'Gemini'],
  [3016318100,3016516398,'Cancer'],
  [3016516398,3016706488,'Leo'],
  [3016706488,3016891369,'Virgo'],
  [3016891369,3017073890,'Libra'],
  [3017073890,3017256425,'Scorpio'],
  [3017256425,3017441325,'Sagittarius'],
  [3017441325,3017631471,'Capricorn'],
  [3017631471,3017830035,'Aquarius'],
  [3017830035,3018038787,'Pisces'],
  [3018038787,3018255451,'Aries'],
  [3018255451,3018472740,'Taurus'],
  [3018472740,3018682123,'Gemini'],
  [3018682123,3018879315,'Cancer'],
  [3018879315,3019065759,'Leo'],
  [3019065759,3019246284,'Virgo'],
  [3019246284,3019426194,'Libra'],
  [3019426194,3019609345,'Scorpio'],
  [3019609345,3019797551,'Sagittarius'],
  [3019797551,3019991457,'Capricorn'],
  [3019991457,3020191976,'Aquarius'],
  [3020191976,3020400423,'Pisces'],
  [3020400423,3020616401,'Aries'],
  [3020616401,3020835035,'Taurus'],
  [3020835035,3021047589,'Gemini'],
  [3021047589,3021247035,'Cancer'],
  [3021247035,3021432640,'Leo'],
  [3021432640,3021609213,'Virgo'],
  [3021609213,3021783772,'Libra'],
  [3021783772,3021962707,'Scorpio'],
  [3021962707,3022149811,'Sagittarius'],
  [3022149811,3022345640,'Capricorn'],
  [3022345640,3022548992,'Aquarius'],
  [3022548992,3022758936,'Pisces'],
  [3022758936,3022974890,'Aries'],
  [3022974890,3023194178,'Taurus'],
  [3023194178,3023410055,'Gemini'],
  [3023410055,3023614403,'Cancer'],
  [3023614403,3023803429,'Leo'],
  [3023803429,3023979889,'Virgo'],
  [3023979889,3024150679,'Libra'],
  [3024150679,3024323638,'Scorpio'],
  [3024323638,3024505196,'Sagittarius'],
  [3024505196,3024698390,'Capricorn'],
  [3024698390,3024902344,'Aquarius'],
  [3024902344,3025114083,'Pisces'],
  [3025114083,3025330775,'Aries'],
  [3025330775,3025549895,'Taurus'],
  [3025549895,3025767152,'Gemini'],
  [3025767152,3025976050,'Cancer'],
  [3025976050,3026171230,'Leo'],
  [3026171230,3026352318,'Virgo'],
  [3026352318,3026524097,'Libra'],
  [3026524097,3026693947,'Scorpio'],
  [3026693947,3026869451,'Sagittarius'],
  [3026869451,3027056387,'Capricorn'],
  [3027056387,3027256760,'Aquarius'],
  [3027256760,3027468201,'Pisces'],
  [3027468201,3027685719,'Aries'],
  [3027685719,3027904552,'Taurus'],
  [3027904552,3028120919,'Gemini'],
  [3028120919,3028330974,'Cancer'],
  [3028330974,3028530852,'Leo'],
  [3028530852,3028718623,'Virgo'],
  [3028718623,3028896016,'Libra'],
  [3028896016,3029068048,'Scorpio'],
  [3029068048,3029241427,'Sagittarius'],
  [3029241427,3029422870,'Capricorn'],
  [3029422870,3029617199,'Aquarius'],
  [3029617199,3029825121,'Pisces'],
  [3029825121,3030042173,'Aries'],
  [3030042173,3030261124,'Taurus'],
  [3030261124,3030476079,'Gemini'],
  [3030476079,3030684038,'Cancer'],
  [3030684038,3030883918,'Leo'],
  [3030883918,3031075402,'Virgo'],
  [3031075402,3031259083,'Libra'],
  [3031259083,3031437139,'Scorpio'],
  [3031437139,3031613625,'Sagittarius'],
  [3031613625,3031794031,'Capricorn'],
  [3031794031,3031984011,'Aquarius'],
  [3031984011,3032187110,'Pisces'],
  [3032187110,3032401836,'Aries'],
  [3032401836,3032620941,'Taurus'],
  [3032620941,3032835732,'Gemini'],
  [3032835732,3033041353,'Cancer'],
  [3033041353,3033237821,'Leo'],
  [3033237821,3033427583,'Virgo'],
  [3033427583,3033613122,'Libra'],
  [3033613122,3033796156,'Scorpio'],
  [3033796156,3033978280,'Sagittarius'],
  [3033978280,3034162203,'Capricorn'],
  [3034162203,3034352120,'Aquarius'],
  [3034352120,3034552348,'Pisces'],
  [3034552348,3034764229,'Aries'],
  [3034764229,3034983006,'Taurus'],
  [3034983006,3035199125,'Gemini'],
  [3035199125,3035404765,'Cancer'],
  [3035404765,3035598442,'Leo'],
  [3035598442,3035783762,'Virgo'],
  [3035783762,3035965804,'Libra'],
  [3035965804,3036148492,'Scorpio'],
  [3036148492,3036333697,'Sagittarius'],
  [3036333697,3036522192,'Capricorn'],
  [3036522192,3036715459,'Aquarius'],
  [3036715459,3036916251,'Pisces'],
  [3036916251,3037126726,'Aries'],
  [3037126726,3037344894,'Taurus'],
  [3037344894,3037562892,'Gemini'],
  [3037562892,3037771214,'Cancer'],
  [3037771214,3037965469,'Leo'],
  [3037965469,3038148078,'Virgo'],
  [3038148078,3038325127,'Libra'],
  [3038325127,3038502906,'Scorpio'],
  [3038502906,3038685758,'Sagittarius'],
  [3038685758,3038875369,'Capricorn'],
  [3038875369,3039071820,'Aquarius'],
  [3039071820,3039275311,'Pisces'],
  [3039275311,3039486491,'Aries'],
  [3039486491,3039704399,'Taurus'],
  [3039704399,3039923756,'Gemini'],
  [3039923756,3040135836,'Cancer'],
  [3040135836,3040333989,'Leo'],
  [3040333989,3040517937,'Virgo'],
  [3040517937,3040692736,'Libra'],
  [3040692736,3040865428,'Scorpio'],
  [3040865428,3041042512,'Sagittarius'],
  [3041042512,3041228325,'Capricorn'],
  [3041228325,3041424317,'Aquarius'],
  [3041424317,3041629659,'Pisces'],
  [3041629659,3041842575,'Aries'],
  [3041842575,3042060866,'Taurus'],
  [3042060866,3042280612,'Gemini'],
  [3042280612,3042495391,'Cancer'],
  [3042495391,3042698557,'Leo'],
  [3042698557,3042887324,'Virgo'],
  [3042887324,3043064243,'Libra'],
  [3043064243,3043235308,'Scorpio'],
  [3043235308,3043407548,'Sagittarius'],
  [3043407548,3043587314,'Capricorn'],
  [3043587314,3043778796,'Aquarius'],
  [3043778796,3043982771,'Pisces'],
  [3043982771,3044196500,'Aries'],
  [3044196500,3044415439,'Taurus'],
  [3044415439,3044634883,'Gemini'],
  [3044634883,3044850127,'Cancer'],
  [3044850127,3045056550,'Leo'],
  [3045056550,3045250903,'Virgo'],
  [3045250903,3045433222,'Libra'],
  [3045433222,3045607070,'Scorpio'],
  [3045607070,3045778327,'Sagittarius'],
  [3045778327,3045953740,'Capricorn'],
  [3045953740,3046139450,'Aquarius'],
  [3046139450,3046339004,'Pisces'],
  [3046339004,3046551222,'Aries'],
  [3046551222,3046770310,'Taurus'],
  [3046770310,3046989331,'Gemini'],
  [3046989331,3047203329,'Cancer'],
  [3047203329,3047409722,'Leo'],
  [3047409722,3047607095,'Virgo'],
  [3047607095,3047794932,'Libra'],
  [3047794932,3047974399,'Scorpio'],
  [3047974399,3048148924,'Sagittarius'],
  [3048148924,3048323985,'Capricorn'],
  [3048323985,3048506045,'Aquarius'],
  [3048506045,3048700626,'Pisces'],
  [3048700626,3048909322,'Aries'],
  [3048909322,3049127466,'Taurus'],
  [3049127466,3049346353,'Gemini'],
  [3049346353,3049558977,'Cancer'],
  [3049558977,3049763032,'Leo'],
  [3049763032,3049959355,'Virgo'],
  [3049959355,3050149255,'Libra'],
  [3050149255,3050333580,'Scorpio'],
  [3050333580,3050513563,'Sagittarius'],
  [3050513563,3050692187,'Capricorn'],
  [3050692187,3050874498,'Aquarius'],
  [3050874498,3051066305,'Pisces'],
  [3051066305,3051271332,'Aries'],
  [3051271332,3051487580,'Taurus'],
  [3051487580,3051706664,'Gemini'],
  [3051706664,3051919250,'Cancer'],
  [3051919250,3052121230,'Leo'],
  [3052121230,3052314099,'Virgo'],
  [3052314099,3052501510,'Libra'],
  [3052501510,3052686354,'Scorpio'],
  [3052686354,3052869995,'Sagittarius'],
  [3052869995,3053053523,'Capricorn'],
  [3053053523,3053239462,'Aquarius'],
  [3053239462,3053432011,'Pisces'],
  [3053432011,3053635238,'Aries'],
  [3053635238,3053849550,'Taurus'],
  [3053849550,3054068882,'Gemini'],
  [3054068882,3054283212,'Cancer'],
  [3054283212,3054485661,'Leo'],
  [3054485661,3054676150,'Virgo'],
  [3054676150,3054859120,'Libra'],
  [3054859120,3055039832,'Scorpio'],
  [3055039832,3055222058,'Sagittarius'],
  [3055222058,3055407610,'Capricorn'],
  [3055407610,3055597518,'Aquarius'],
  [3055597518,3055793426,'Pisces'],
  [3055793426,3055997615,'Aries'],
  [3055997615,3056211062,'Taurus'],
  [3056211062,3056430373,'Gemini'],
  [3056430373,3056647258,'Cancer'],
  [3056647258,3056853185,'Leo'],
  [3056853185,3057045055,'Virgo'],
  [3057045055,3057225834,'Libra'],
  [3057225834,3057401469,'Scorpio'],
  [3057401469,3057578061,'Sagittarius'],
  [3057578061,3057760198,'Capricorn'],
  [3057760198,3057950285,'Aquarius'],
  [3057950285,3058148929,'Pisces'],
  [3058148929,3058355793,'Aries'],
  [3058355793,3058570007,'Taurus'],
  [3058570007,3058789114,'Gemini'],
  [3058789114,3059007629,'Cancer'],
  [3059007629,3059218079,'Leo'],
  [3059218079,3059415053,'Virgo'],
  [3059415053,3059598393,'Libra'],
  [3059598393,3059772504,'Scorpio'],
  [3059772504,3059943958,'Sagittarius'],
  [3059943958,3060119518,'Capricorn'],
  [3060119518,3060304595,'Aquarius'],
  [3060304595,3060501777,'Pisces'],
  [3060501777,3060710073,'Aries'],
  [3060710073,3060925918,'Taurus'],
  [3060925918,3061145139,'Gemini'],
  [3061145139,3061363570,'Cancer'],
  [3061363570,3061576526,'Leo'],
  [3061576526,3061779156,'Virgo'],
  [3061779156,3061968768,'Libra'],
  [3061968768,3062146611,'Scorpio'],
  [3062146611,3062317564,'Sagittarius'],
  [3062317564,3062488588,'Capricorn'],
  [3062488588,3062666995,'Aquarius'],
  [3062666995,3062858445,'Pisces'],
  [3062858445,3063064339,'Aries'],
  [3063064339,3063280598,'Taurus'],
  [3063280598,3063500310,'Gemini'],
  [3063500310,3063717869,'Cancer'],
  [3063717869,3063930203,'Leo'],
  [3063930203,3064135126,'Virgo'],
  [3064135126,3064330399,'Libra'],
  [3064330399,3064514930,'Scorpio'],
  [3064514930,3064690494,'Sagittarius'],
  [3064690494,3064862181,'Capricorn'],
  [3064862181,3065037161,'Aquarius'],
  [3065037161,3065222692,'Pisces'],
  [3065222692,3065423246,'Aries'],
  [3065423246,3065637206,'Taurus'],
  [3065637206,3065856928,'Gemini'],
  [3065856928,3066074070,'Cancer'],
  [3066074070,3066284463,'Leo'],
  [3066284463,3066487687,'Virgo'],
  [3066487687,3066684060,'Libra'],
  [3066684060,3066873199,'Scorpio'],
  [3066873199,3067055020,'Sagittarius'],
  [3067055020,3067231706,'Capricorn'],
  [3067231706,3067408357,'Aquarius'],
  [3067408357,3067591725,'Pisces'],
  [3067591725,3067787711,'Aries'],
  [3067787711,3067997755,'Taurus'],
  [3067997755,3068216304,'Gemini'],
  [3068216304,3068433745,'Cancer'],
  [3068433745,3068643234,'Leo'],
  [3068643234,3068843609,'Virgo'],
  [3068843609,3069036975,'Libra'],
  [3069036975,3069225488,'Scorpio'],
  [3069225488,3069410188,'Sagittarius'],
  [3069410188,3069592015,'Capricorn'],
  [3069592015,3069773481,'Aquarius'],
  [3069773481,3069959091,'Pisces'],
  [3069959091,3070153998,'Aries'],
  [3070153998,3070361123,'Taurus'],
  [3070361123,3070577863,'Gemini'],
  [3070577863,3070795898,'Cancer'],
  [3070795898,3071006450,'Leo'],
  [3071006450,3071205850,'Virgo'],
  [3071205850,3071395750,'Libra'],
  [3071395750,3071580050,'Scorpio'],
  [3071580050,3071762355,'Sagittarius'],
  [3071762355,3071945129,'Capricorn'],
  [3071945129,3072130262,'Aquarius'],
  [3072130262,3072320006,'Pisces'],
  [3072320006,3072517171,'Aries'],
  [3072517171,3072723948,'Taurus'],
  [3072723948,3072939451,'Gemini'],
  [3072939451,3073157988,'Cancer'],
  [3073157988,3073371029,'Leo'],
  [3073371029,3073572428,'Virgo'],
  [3073572428,3073761577,'Libra'],
  [3073761577,3073942118,'Scorpio'],
  [3073942118,3074119325,'Sagittarius'],
  [3074119325,3074298213,'Capricorn'],
  [3074298213,3074482531,'Aquarius'],
  [3074482531,3074674441,'Pisces'],
  [3074674441,3074874737,'Aries'],
  [3074874737,3075083298,'Taurus'],
  [3075083298,3075298822,'Gemini'],
  [3075298822,3075517614,'Cancer'],
  [3075517614,3075733223,'Leo'],
  [3075733223,3075938734,'Virgo'],
  [3075938734,3076130779,'Libra'],
  [3076130779,3076310972,'Scorpio'],
  [3076310972,3076484449,'Sagittarius'],
  [3076484449,3076657766,'Capricorn'],
  [3076657766,3076837144,'Aquarius'],
  [3076837144,3077026883,'Pisces'],
  [3077026883,3077228053,'Aries'],
  [3077228053,3077438605,'Taurus'],
  [3077438605,3077655119,'Gemini'],
  [3077655119,3077873980,'Cancer'],
  [3077873980,3078090926,'Leo'],
  [3078090926,3078300481,'Virgo'],
  [3078300481,3078497800,'Libra'],
  [3078497800,3078681661,'Scorpio'],
  [3078681661,3078855341,'Sagittarius'],
  [3078855341,3079025270,'Capricorn'],
  [3079025270,3079199009,'Aquarius'],
  [3079199009,3079383266,'Pisces'],
  [3079383266,3079581476,'Aries'],
  [3079581476,3079791982,'Taurus'],
  [3079791982,3080009398,'Gemini'],
  [3080009398,3080228297,'Cancer'],
  [3080228297,3080445006,'Leo'],
  [3080445006,3080656329,'Virgo'],
  [3080656329,3080858378,'Libra'],
  [3080858378,3081048171,'Scorpio'],
  [3081048171,3081226173,'Sagittarius'],
  [3081226173,3081397009,'Capricorn'],
  [3081397009,3081567965,'Aquarius'],
  [3081567965,3081746877,'Pisces'],
  [3081746877,3081939641,'Aries'],
  [3081939641,3082147102,'Taurus'],
  [3082147102,3082364076,'Gemini'],
  [3082364076,3082583004,'Cancer'],
  [3082583004,3082798709,'Leo'],
  [3082798709,3083009043,'Virgo'],
  [3083009043,3083212467,'Libra'],
  [3083212467,3083406837,'Scorpio'],
  [3083406837,3083590919,'Sagittarius'],
  [3083590919,3083766612,'Capricorn'],
  [3083766612,3083939271,'Aquarius'],
  [3083939271,3084116164,'Pisces'],
  [3084116164,3084304219,'Aries'],
  [3084304219,3084506942,'Taurus'],
  [3084506942,3084721608,'Gemini'],
  [3084721608,3084940326,'Cancer'],
  [3084940326,3085155487,'Leo'],
  [3085155487,3085363742,'Virgo'],
  [3085363742,3085564962,'Libra'],
  [3085564962,3085759503,'Scorpio'],
  [3085759503,3085947198,'Sagittarius'],
  [3085947198,3086128575,'Capricorn'],
  [3086128575,3086306387,'Aquarius'],
  [3086306387,3086485691,'Pisces'],
  [3086485691,3086672523,'Aries'],
  [3086672523,3086871533,'Taurus'],
  [3086871533,3087082913,'Gemini'],
  [3087082913,3087300881,'Cancer'],
  [3087300881,3087516659,'Leo'],
  [3087516659,3087724174,'Virgo'],
  [3087724174,3087922357,'Libra'],
  [3087922357,3088113203,'Scorpio'],
  [3088113203,3088299254,'Sagittarius'],
  [3088299254,3088482554,'Capricorn'],
  [3088482554,3088665046,'Aquarius'],
  [3088665046,3088849351,'Pisces'],
  [3088849351,3089038969,'Aries'],
  [3089038969,3089237462,'Taurus'],
  [3089237462,3089446451,'Gemini'],
  [3089446451,3089663215,'Cancer'],
  [3089663215,3089880375,'Leo'],
  [3089880375,3090089775,'Virgo'],
  [3090089775,3090287466,'Libra'],
  [3090287466,3090474681,'Scorpio'],
  [3090474681,3090655659,'Sagittarius'],
  [3090655659,3090835271,'Capricorn'],
  [3090835271,3091017514,'Aquarius'],
  [3091017514,3091204919,'Pisces'],
  [3091204919,3091398791,'Aries'],
  [3091398791,3091599936,'Taurus'],
  [3091599936,3091808895,'Gemini'],
  [3091808895,3092024697,'Cancer'],
  [3092024697,3092242926,'Leo'],
  [3092242926,3092455919,'Virgo'],
  [3092455919,3092656946,'Libra'],
  [3092656946,3092844352,'Scorpio'],
  [3092844352,3093021710,'Sagittarius'],
  [3093021710,3093195426,'Capricorn'],
  [3093195426,3093372227,'Aquarius'],
  [3093372227,3093557194,'Pisces'],
  [3093557194,3093752292,'Aries'],
  [3093752292,3093956443,'Taurus'],
  [3093956443,3094167410,'Gemini'],
  [3094167410,3094383303,'Cancer'],
  [3094383303,3094601698,'Leo'],
  [3094601698,3094817576,'Virgo'],
  [3094817576,3095023918,'Libra'],
  [3095023918,3095215970,'Scorpio'],
  [3095215970,3095394526,'Sagittarius'],
  [3095394526,3095565306,'Capricorn'],
  [3095565306,3095736179,'Aquarius'],
  [3095736179,3095914692,'Pisces'],
  [3095914692,3096105720,'Aries'],
  [3096105720,3096309448,'Taurus'],
  [3096309448,3096522049,'Gemini'],
  [3096522049,3096738972,'Cancer'],
  [3096738972,3096957113,'Leo'],
  [3096957113,3097173583,'Virgo'],
  [3097173583,3097383627,'Libra'],
  [3097383627,3097581835,'Scorpio'],
  [3097581835,3097765955,'Sagittarius'],
  [3097765955,3097939064,'Capricorn'],
  [3097939064,3098108133,'Aquarius'],
  [3098108133,3098281364,'Pisces'],
  [3098281364,3098465849,'Aries'],
  [3098465849,3098664877,'Taurus'],
  [3098664877,3098876168,'Gemini'],
  [3098876168,3099093673,'Cancer'],
  [3099093673,3099311773,'Leo'],
  [3099311773,3099527214,'Virgo'],
  [3099527214,3099737431,'Libra'],
  [3099737431,3099939053,'Scorpio'],
  [3099939053,3100129221,'Sagittarius'],
  [3100129221,3100308277,'Capricorn'],
  [3100308277,3100480627,'Aquarius'],
  [3100480627,3100653228,'Pisces'],
  [3100653228,3100833441,'Aries'],
  [3100833441,3101026681,'Taurus'],
  [3101026681,3101233800,'Gemini'],
  [3101233800,3101450125,'Cancer'],
  [3101450125,3101668295,'Leo'],
  [3101668295,3101882732,'Virgo'],
  [3101882732,3102090873,'Libra'],
  [3102090873,3102291608,'Scorpio'],
  [3102291608,3102484087,'Sagittarius'],
  [3102484087,3102668326,'Capricorn'],
  [3102668326,3102846432,'Aquarius'],
  [3102846432,3103022820,'Pisces'],
  [3103022820,3103203285,'Aries'],
  [3103203285,3103393370,'Taurus'],
  [3103393370,3103596119,'Gemini'],
  [3103596119,3103809800,'Cancer'],
  [3103809800,3104027756,'Leo'],
  [3104027756,3104242226,'Virgo'],
  [3104242226,3104448608,'Libra'],
  [3104448608,3104646187,'Scorpio'],
  [3104646187,3104836450,'Sagittarius'],
  [3104836450,3105021465,'Capricorn'],
  [3105021465,3105203419,'Aquarius'],
  [3105203419,3105384874,'Pisces'],
  [3105384874,3105569103,'Aries'],
  [3105569103,3105759931,'Taurus'],
  [3105759931,3105960631,'Gemini'],
  [3105960631,3106171795,'Cancer'],
  [3106171795,3106389232,'Leo'],
  [3106389232,3106604867,'Virgo'],
  [3106604867,3106811543,'Libra'],
  [3106811543,3107006888,'Scorpio'],
  [3107006888,3107193112,'Sagittarius'],
  [3107193112,3107374595,'Capricorn'],
  [3107374595,3107555663,'Aquarius'],
  [3107555663,3107739420,'Pisces'],
  [3107739420,3107927686,'Aries'],
  [3107927686,3108121816,'Taurus'],
  [3108121816,3108323410,'Gemini'],
  [3108323410,3108533564,'Cancer'],
  [3108533564,3108750504,'Leo'],
  [3108750504,3108967862,'Virgo'],
  [3108967862,3109177125,'Libra'],
  [3109177125,3109373214,'Scorpio'],
  [3109373214,3109557079,'Sagittarius'],
  [3109557079,3109733961,'Capricorn'],
  [3109733961,3109910354,'Aquarius'],
  [3109910354,3110091650,'Pisces'],
  [3110091650,3110280673,'Aries'],
  [3110280673,3110477645,'Taurus'],
  [3110477645,3110681785,'Gemini'],
  [3110681785,3110892705,'Cancer'],
  [3110892705,3111109516,'Leo'],
  [3111109516,3111328246,'Virgo'],
  [3111328246,3111541197,'Libra'],
  [3111541197,3111741150,'Scorpio'],
  [3111741150,3111926395,'Sagittarius'],
  [3111926395,3112101171,'Capricorn'],
  [3112101171,3112272736,'Aquarius'],
  [3112272736,3112448485,'Pisces'],
  [3112448485,3112633739,'Aries'],
  [3112633739,3112830121,'Taurus'],
  [3112830121,3113035932,'Gemini'],
  [3113035932,3113248475,'Cancer'],
  [3113248475,3113465653,'Leo'],
  [3113465653,3113684799,'Virgo'],
  [3113684799,3113900483,'Libra'],
  [3113900483,3114105554,'Scorpio'],
  [3114105554,3114295750,'Sagittarius'],
  [3114295750,3114472742,'Capricorn'],
  [3114472742,3114642791,'Aquarius'],
  [3114642791,3114813802,'Pisces'],
  [3114813802,3114993001,'Aries'],
  [3114993001,3115184760,'Taurus'],
  [3115184760,3115389065,'Gemini'],
  [3115389065,3115602341,'Cancer'],
  [3115602341,3115820141,'Leo'],
  [3115820141,3116038928,'Virgo'],
  [3116038928,3116254987,'Libra'],
  [3116254987,3116463336,'Scorpio'],
  [3116463336,3116659395,'Sagittarius'],
  [3116659395,3116842195,'Capricorn'],
  [3116842195,3117015423,'Aquarius'],
  [3117015423,3117185739,'Pisces'],
  [3117185739,3117360592,'Aries'],
  [3117360592,3117546285,'Taurus'],
  [3117546285,3117745802,'Gemini'],
  [3117745802,3117957352,'Cancer'],
  [3117957352,3118175337,'Leo'],
  [3118175337,3118393740,'Virgo'],
  [3118393740,3118608357,'Libra'],
  [3118608357,3118816298,'Scorpio'],
  [3118816298,3119015199,'Sagittarius'],
  [3119015199,3119203807,'Capricorn'],
  [3119203807,3119383323,'Aquarius'],
  [3119383323,3119557699,'Pisces'],
  [3119557699,3119732751,'Aries'],
  [3119732751,3119914805,'Taurus'],
  [3119914805,3120108902,'Gemini'],
  [3120108902,3120316417,'Cancer'],
  [3120316417,3120533313,'Leo'],
  [3120533313,3120751823,'Virgo'],
  [3120751823,3120965183,'Libra'],
  [3120965183,3121170389,'Scorpio'],
  [3121170389,3121367459,'Sagittarius'],
  [3121367459,3121557513,'Capricorn'],
  [3121557513,3121741885,'Aquarius'],
  [3121741885,3121922403,'Pisces'],
  [3121922403,3122102024,'Aries'],
  [3122102024,3122285082,'Taurus'],
  [3122285082,3122476545,'Gemini'],
  [3122476545,3122679989,'Cancer'],
  [3122679989,3122894549,'Leo'],
  [3122894549,3123113375,'Virgo'],
  [3123113375,3123327264,'Libra'],
  [3123327264,3123530707,'Scorpio'],
  [3123530707,3123723901,'Sagittarius'],
  [3123723901,3123910404,'Capricorn'],
  [3123910404,3124094131,'Aquarius'],
  [3124094131,3124277716,'Pisces'],
  [3124277716,3124462548,'Aries'],
  [3124462548,3124650106,'Taurus'],
  [3124650106,3124843128,'Gemini'],
  [3124843128,3125045065,'Cancer'],
  [3125045065,3125257389,'Leo'],
  [3125257389,3125476177,'Virgo'],
  [3125476177,3125692222,'Libra'],
  [3125692222,3125897055,'Scorpio'],
  [3125897055,3126088556,'Sagittarius'],
  [3126088556,3126270556,'Capricorn'],
  [3126270556,3126449202,'Aquarius'],
  [3126449202,3126629874,'Pisces'],
  [3126629874,3126815507,'Aries'],
  [3126815507,3127006704,'Taurus'],
  [3127006704,3127203556,'Gemini'],
  [3127203556,3127407178,'Cancer'],
  [3127407178,3127618932,'Leo'],
  [3127618932,3127837343,'Virgo'],
  [3127837343,3128055627,'Libra'],
  [3128055627,3128264418,'Scorpio'],
  [3128264418,3128458419,'Sagittarius'],
  [3128458419,3128639368,'Capricorn'],
  [3128639368,3128813546,'Aquarius'],
  [3128813546,3128988196,'Pisces'],
  [3128988196,3129169067,'Aries'],
  [3129169067,3129358920,'Taurus'],
  [3129358920,3129557648,'Gemini'],
  [3129557648,3129764012,'Cancer'],
  [3129764012,3129977051,'Leo'],
  [3129977051,3130195353,'Virgo'],
  [3130195353,3130414626,'Libra'],
  [3130414626,3130627315,'Scorpio'],
  [3130627315,3130826626,'Sagittarius'],
  [3130826626,3131011178,'Capricorn'],
  [3131011178,3131185275,'Aquarius'],
  [3131185275,3131356015,'Pisces'],
  [3131356015,3131530644,'Aries'],
  [3131530644,3131714711,'Taurus'],
  [3131714711,3131910648,'Gemini'],
  [3131910648,3132117471,'Cancer'],
  [3132117471,3132332040,'Leo'],
  [3132332040,3132550792,'Virgo'],
  [3132550792,3132769829,'Libra'],
  [3132769829,3132984073,'Scorpio'],
  [3132984073,3133188021,'Sagittarius'],
  [3133188021,3133378578,'Capricorn'],
  [3133378578,3133557122,'Aquarius'],
  [3133557122,3133728749,'Pisces'],
  [3133728749,3133900279,'Aries'],
  [3133900279,3134078509,'Taurus'],
  [3134078509,3134268586,'Gemini'],
  [3134268586,3134472186,'Cancer'],
  [3134472186,3134686482,'Leo'],
  [3134686482,3134905697,'Virgo'],
  [3134905697,3135124123,'Libra'],
  [3135124123,3135337496,'Scorpio'],
  [3135337496,3135542757,'Sagittarius'],
  [3135542757,3135737800,'Capricorn'],
  [3135737800,3135922388,'Aquarius'],
  [3135922388,3136098890,'Pisces'],
  [3136098890,3136272043,'Aries'],
  [3136272043,3136448033,'Taurus'],
  [3136448033,3136633132,'Gemini'],
  [3136633132,3136831666,'Cancer'],
  [3136831666,3137043333,'Leo'],
  [3137043333,3137262246,'Virgo'],
  [3137262246,3137480356,'Libra'],
  [3137480356,3137692040,'Scorpio'],
  [3137692040,3137895480,'Sagittarius'],
  [3137895480,3138090959,'Capricorn'],
  [3138090959,3138279188,'Aquarius'],
  [3138279188,3138461217,'Pisces'],
  [3138461217,3138639242,'Aries'],
  [3138639242,3138817313,'Taurus'],
  [3138817313,3139000989,'Gemini'],
  [3139000989,3139195705,'Cancer'],
  [3139195705,3139403797,'Leo'],
  [3139403797,3139621460,'Virgo'],
  [3139621460,3139839768,'Libra'],
  [3139839768,3140050677,'Scorpio'],
  [3140050677,3140251507,'Sagittarius'],
  [3140251507,3140444072,'Capricorn'],
  [3140444072,3140631429,'Aquarius'],
  [3140631429,3140815783,'Pisces'],
  [3140815783,3140998402,'Aries'],
  [3140998402,3141180995,'Taurus'],
  [3141180995,3141366956,'Gemini'],
  [3141366956,3141560955,'Cancer'],
  [3141560955,3141766575,'Leo'],
  [3141766575,3141982642,'Virgo'],
  [3141982642,3142201525,'Libra'],
  [3142201525,3142413461,'Scorpio'],
  [3142413461,3142613394,'Sagittarius'],
  [3142613394,3142802691,'Capricorn'],
  [3142802691,3142986025,'Aquarius'],
  [3142986025,3143167979,'Pisces'],
  [3143167979,3143351333,'Aries'],
  [3143351333,3143537308,'Taurus'],
  [3143537308,3143727175,'Gemini'],
  [3143727175,3143923393,'Cancer'],
  [3143923393,3144128823,'Leo'],
  [3144128823,3144343846,'Virgo'],
  [3144343846,3144563322,'Libra'],
  [3144563322,3144777793,'Scorpio'],
  [3144777793,3144979780,'Sagittarius'],
  [3144979780,3145168416,'Capricorn'],
  [3145168416,3145348128,'Aquarius'],
  [3145348128,3145525058,'Pisces'],
  [3145525058,3145704471,'Aries'],
  [3145704471,3145889513,'Taurus'],
  [3145889513,3146081421,'Gemini'],
  [3146081421,3146280714,'Cancer'],
  [3146280714,3146487971,'Leo'],
  [3146487971,3146703073,'Virgo'],
  [3146703073,3146922830,'Libra'],
  [3146922830,3147139955,'Scorpio'],
  [3147139955,3147346305,'Sagittarius'],
  [3147346305,3147538151,'Capricorn'],
  [3147538151,3147717780,'Aquarius'],
  [3147717780,3147891067,'Pisces'],
  [3147891067,3148064722,'Aries'],
  [3148064722,3148244490,'Taurus'],
  [3148244490,3148433947,'Gemini'],
  [3148433947,3148634004,'Cancer'],
  [3148634004,3148843348,'Leo'],
  [3148843348,3149059536,'Virgo'],
  [3149059536,3149279279,'Libra'],
  [3149279279,3149497597,'Scorpio'],
  [3149497597,3149708127,'Sagittarius'],
  [3149708127,3149905786,'Capricorn'],
  [3149905786,3150089804,'Aquarius'],
  [3150089804,3150263862,'Pisces'],
  [3150263862,3150434243,'Aries'],
  [3150434243,3150607983,'Taurus'],
  [3150607983,3150791317,'Gemini'],
  [3150791317,3150987865,'Cancer'],
  [3150987865,3151196999,'Leo'],
  [3151196999,3151414247,'Virgo'],
  [3151414247,3151634049,'Libra'],
  [3151634049,3151851786,'Scorpio'],
  [3151851786,3152063665,'Sagittarius'],
  [3152063665,3152266100,'Capricorn'],
  [3152266100,3152456753,'Aquarius'],
  [3152456753,3152636198,'Pisces'],
  [3152636198,3152808362,'Aries'],
  [3152808362,3152979622,'Taurus'],
  [3152979622,3153157287,'Gemini'],
  [3153157287,3153347629,'Cancer'],
  [3153347629,3153553005,'Leo'],
  [3153553005,3153769637,'Virgo'],
  [3153769637,3153989657,'Libra'],
  [3153989657,3154206318,'Scorpio'],
  [3154206318,3154416585,'Sagittarius'],
  [3154416585,3154619572,'Capricorn'],
  [3154619572,3154814446,'Aquarius'],
  [3154814446,3155000475,'Pisces'],
  [3155000475,3155178590,'Aries'],
  [3155178590,3155352632,'Taurus'],
  [3155352632,3155528929,'Gemini'],
  [3155528929,3155714564,'Cancer'],
  [3155714564,3155914573,'Leo'],
  [3155914573,3156128239,'Virgo'],
  [3156128239,3156348001,'Libra'],
  [3156348001,3156564476,'Scorpio'],
  [3156564476,3156772699,'Sagittarius'],
  [3156772699,3156972782,'Capricorn'],
  [3156972782,3157166603,'Aquarius'],
  [3157166603,3157355244,'Pisces'],
  [3157355244,3157538930,'Aries'],
  [3157538930,3157718845,'Taurus'],
  [3157718845,3157898639,'Gemini'],
  [3157898639,3158084034,'Cancer'],
  [3158084034,3158280686,'Leo'],
  [3158280686,3158490655,'Virgo'],
  [3158490655,3158709194,'Libra'],
  [3158709194,3158926490,'Scorpio'],
  [3158926490,3159134671,'Sagittarius'],
  [3159134671,3159332161,'Capricorn'],
  [3159332161,3159521868,'Aquarius'],
  [3159521868,3159707533,'Pisces'],
  [3159707533,3159891607,'Aries'],
  [3159891607,3160075323,'Taurus'],
  [3160075323,3160260210,'Gemini'],
  [3160260210,3160449263,'Cancer'],
  [3160449263,3160646464,'Leo'],
  [3160646464,3160854501,'Virgo'],
  [3160854501,3161071482,'Libra'],
  [3161071482,3161289788,'Scorpio'],
  [3161289788,3161500254,'Sagittarius'],
  [3161500254,3161698297,'Capricorn'],
  [3161698297,3161885353,'Aquarius'],
  [3161885353,3162066095,'Pisces'],
  [3162066095,3162245521,'Aries'],
  [3162245521,3162427399,'Taurus'],
  [3162427399,3162614030,'Gemini'],
  [3162614030,3162806882,'Cancer'],
  [3162806882,3163007255,'Leo'],
  [3163007255,3163216087,'Virgo'],
  [3163216087,3163432339,'Libra'],
  [3163432339,3163651177,'Scorpio'],
  [3163651177,3163864764,'Sagittarius'],
  [3163864764,3164066508,'Capricorn'],
  [3164066508,3164254918,'Aquarius'],
  [3164254918,3164433345,'Pisces'],
  [3164433345,3164607584,'Aries'],
  [3164607584,3164783753,'Taurus'],
  [3164783753,3164966830,'Gemini'],
  [3164966830,3165159615,'Cancer'],
  [3165159615,3165362342,'Leo'],
  [3165362342,3165573370,'Virgo'],
  [3165573370,3165790145,'Libra'],
  [3165790145,3166009032,'Scorpio'],
  [3166009032,3166224732,'Sagittarius'],
  [3166224732,3166431110,'Capricorn'],
  [3166431110,3166624283,'Aquarius'],
  [3166624283,3166804833,'Pisces'],
  [3166804833,3166977345,'Aries'],
  [3166977345,3167148574,'Taurus'],
  [3167148574,3167325574,'Gemini'],
  [3167325574,3167513855,'Cancer'],
  [3167513855,3167715322,'Leo'],
  [3167715322,3167927449,'Virgo'],
  [3167927449,3168145255,'Libra'],
  [3168145255,3168364040,'Scorpio'],
  [3168364040,3168580040,'Sagittarius'],
  [3168580040,3168789320,'Capricorn'],
  [3168789320,3168987863,'Aquarius'],
  [3168987863,3169173784,'Pisces'],
  [3169173784,3169349064,'Aries'],
  [3169349064,3169519298,'Taurus'],
  [3169519298,3169691961,'Gemini'],
  [3169691961,3169874391,'Cancer'],
  [3169874391,3170071228,'Leo'],
  [3170071228,3170281675,'Virgo'],
  [3170281675,3170499742,'Libra'],
  [3170499742,3170718467,'Scorpio'],
  [3170718467,3170933518,'Sagittarius'],
  [3170933518,3171142769,'Capricorn'],
  [3171142769,3171344144,'Aquarius'],
  [3171344144,3171535445,'Pisces'],
  [3171535445,3171716296,'Aries'],
  [3171716296,3171889823,'Taurus'],
  [3171889823,3172062259,'Gemini'],
  [3172062259,3172241129,'Cancer'],
  [3172241129,3172432822,'Leo'],
  [3172432822,3172639316,'Virgo'],
  [3172639316,3172856070,'Libra'],
  [3172856070,3173074716,'Scorpio'],
  [3173074716,3173288794,'Sagittarius'],
  [3173288794,3173496089,'Capricorn'],
  [3173496089,3173696544,'Aquarius'],
  [3173696544,3173889868,'Pisces'],
  [3173889868,3174075509,'Aries'],
  [3174075509,3174254468,'Taurus'],
  [3174254468,3174430571,'Gemini'],
  [3174430571,3174609889,'Cancer'],
  [3174609889,3174798856,'Leo'],
  [3174798856,3175001353,'Virgo'],
  [3175001353,3175215580,'Libra'],
  [3175215580,3175433966,'Scorpio'],
  [3175433966,3175648058,'Sagittarius'],
  [3175648058,3175853673,'Capricorn'],
  [3175853673,3176051074,'Aquarius'],
  [3176051074,3176242164,'Pisces'],
  [3176242164,3176428462,'Aries'],
  [3176428462,3176611133,'Taurus'],
  [3176611133,3176792203,'Gemini'],
  [3176792203,3176975311,'Cancer'],
  [3176975311,3177165187,'Leo'],
  [3177165187,3177365814,'Virgo'],
  [3177365814,3177577611,'Libra'],
  [3177577611,3177795503,'Scorpio'],
  [3177795503,3178010857,'Sagittarius'],
  [3178010857,3178216926,'Capricorn'],
  [3178216926,3178412203,'Aquarius'],
  [3178412203,3178599189,'Pisces'],
  [3178599189,3178781733,'Aries'],
  [3178781733,3178963324,'Taurus'],
  [3178963324,3179146639,'Gemini'],
  [3179146639,3179333899,'Cancer'],
  [3179333899,3179527321,'Leo'],
  [3179527321,3179729018,'Virgo'],
  [3179729018,3179939799,'Libra'],
  [3179939799,3180157120,'Scorpio'],
  [3180157120,3180374315,'Sagittarius'],
  [3180374315,3180583379,'Capricorn'],
  [3180583379,3180779850,'Aquarius'],
  [3180779850,3180964635,'Pisces'],
  [3180964635,3181142301,'Aries'],
  [3181142301,3181318679,'Taurus'],
  [3181318679,3181499034,'Gemini'],
  [3181499034,3181686831,'Cancer'],
  [3181686831,3181883255,'Leo'],
  [3181883255,3182087831,'Virgo'],
  [3182087831,3182299509,'Libra'],
  [3182299509,3182516541,'Scorpio'],
  [3182516541,3182734968,'Sagittarius'],
  [3182734968,3182948040,'Capricorn'],
  [3182948040,3183149175,'Aquarius'],
  [3183149175,3183336140,'Pisces'],
  [3183336140,3183512017,'Aries'],
  [3183512017,3183683282,'Taurus'],
  [3183683282,3183857353,'Gemini'],
  [3183857353,3184040504,'Cancer'],
  [3184040504,3184235784,'Leo'],
  [3184235784,3184442038,'Virgo'],
  [3184442038,3184655598,'Libra'],
  [3184655598,3184873006,'Scorpio'],
  [3184873006,3185091481,'Sagittarius'],
  [3185091481,3185306995,'Capricorn'],
  [3185306995,3185513612,'Aquarius'],
  [3185513612,3185706558,'Pisces'],
  [3185706558,3185885747,'Aries'],
  [3185885747,3186056163,'Taurus'],
  [3186056163,3186225563,'Gemini'],
  [3186225563,3186402037,'Cancer'],
  [3186402037,3186591608,'Leo'],
  [3186591608,3186795495,'Virgo'],
  [3186795495,3187009585,'Libra'],
  [3187009585,3187227786,'Scorpio'],
  [3187227786,3187445785,'Sagittarius'],
  [3187445785,3187661027,'Capricorn'],
  [3187661027,3187870232,'Aquarius'],
  [3187870232,3188069064,'Pisces'],
  [3188069064,3188254943,'Aries'],
  [3188254943,3188429765,'Taurus'],
  [3188429765,3188599593,'Gemini'],
  [3188599593,3188772380,'Cancer'],
  [3188772380,3188955662,'Leo'],
  [3188955662,3189153765,'Virgo'],
  [3189153765,3189365195,'Libra'],
  [3189365195,3189583362,'Scorpio'],
  [3189583362,3189801231,'Sagittarius'],
  [3189801231,3190014935,'Capricorn'],
  [3190014935,3190222853,'Aquarius'],
  [3190222853,3190423296,'Pisces'],
  [3190423296,3190614330,'Aries'],
  [3190614330,3190795771,'Taurus'],
  [3190795771,3190970743,'Gemini'],
  [3190970743,3191145154,'Cancer'],
  [3191145154,3191325944,'Leo'],
  [3191325944,3191518834,'Virgo'],
  [3191518834,3191725527,'Libra'],
  [3191725527,3191941877,'Scorpio'],
  [3191941877,3192159888,'Sagittarius'],
  [3192159888,3192372886,'Capricorn'],
  [3192372886,3192578219,'Aquarius'],
  [3192578219,3192775974,'Pisces'],
  [3192775974,3192966914,'Aries'],
  [3192966914,3193151902,'Taurus'],
  [3193151902,3193332621,'Gemini'],
  [3193332621,3193512264,'Cancer'],
  [3193512264,3193695402,'Leo'],
  [3193695402,3193886900,'Virgo'],
  [3193886900,3194089933,'Libra'],
  [3194089933,3194303502,'Scorpio'],
  [3194303502,3194521398,'Sagittarius'],
  [3194521398,3194735270,'Capricorn'],
  [3194735270,3194939710,'Aquarius'],
  [3194939710,3195134097,'Pisces'],
  [3195134097,3195321025,'Aries'],
  [3195321025,3195504040,'Taurus'],
  [3195504040,3195686288,'Gemini'],
  [3195686288,3195870218,'Cancer'],
  [3195870218,3196057981,'Leo'],
  [3196057981,3196251941,'Virgo'],
  [3196251941,3196454419,'Libra'],
  [3196454419,3196666065,'Scorpio'],
  [3196666065,3196883541,'Sagittarius'],
  [3196883541,3197099280,'Capricorn'],
  [3197099280,3197305552,'Aquarius'],
  [3197305552,3197499193,'Pisces'],
  [3197499193,3197682405,'Aries'],
  [3197682405,3197860474,'Taurus'],
  [3197860474,3198039116,'Gemini'],
  [3198039116,3198222619,'Cancer'],
  [3198222619,3198413004,'Leo'],
  [3198413004,3198610516,'Virgo'],
  [3198610516,3198815057,'Libra'],
  [3198815057,3199026652,'Scorpio'],
  [3199026652,3199243807,'Sagittarius'],
  [3199243807,3199461327,'Capricorn'],
  [3199461327,3199671217,'Aquarius'],
  [3199671217,3199867618,'Pisces'],
  [3199867618,3200050504,'Aries'],
  [3200050504,3200224958,'Taurus'],
  [3200224958,3200398188,'Gemini'],
  [3200398188,3200576908,'Cancer'],
  [3200576908,3200765300,'Leo'],
  [3200765300,3200963921,'Virgo'],
  [3200963921,3201170795,'Libra'],
  [3201170795,3201383731,'Scorpio'],
  [3201383731,3201600983,'Sagittarius'],
  [3201600983,3201819370,'Capricorn'],
  [3201819370,3202032662,'Aquarius'],
  [3202032662,3202233945,'Pisces'],
  [3202233945,3202420403,'Aries'],
  [3202420403,3202595167,'Taurus'],
  [3202595167,3202765215,'Gemini'],
  [3202765215,3202938454,'Cancer'],
  [3202938454,3203121412,'Leo'],
  [3203121412,3203317057,'Virgo'],
  [3203317057,3203523945,'Libra'],
  [3203523945,3203738101,'Scorpio'],
  [3203738101,3203955797,'Sagittarius'],
  [3203955797,3204174044,'Capricorn'],
  [3204174044,3204388749,'Aquarius'],
  [3204388749,3204594279,'Pisces'],
  [3204594279,3204786364,'Aries'],
  [3204786364,3204965402,'Taurus'],
  [3204965402,3205136514,'Gemini'],
  [3205136514,3205307171,'Cancer'],
  [3205307171,3205484886,'Leo'],
  [3205484886,3205675019,'Virgo'],
  [3205675019,3205878669,'Libra'],
  [3205878669,3206092343,'Scorpio'],
  [3206092343,3206310379,'Sagittarius'],
  [3206310379,3206528054,'Capricorn'],
  [3206528054,3206741938,'Aquarius'],
  [3206741938,3206948674,'Pisces'],
  [3206948674,3207145062,'Aries'],
  [3207145062,3207329986,'Taurus'],
  [3207329986,3207505931,'Gemini'],
  [3207505931,3207678387,'Cancer'],
  [3207678387,3207854167,'Leo'],
  [3207854167,3208039582,'Virgo'],
  [3208039582,3208238285,'Libra'],
  [3208238285,3208449296,'Scorpio'],
  [3208449296,3208666997,'Sagittarius'],
  [3208666997,3208884387,'Capricorn'],
  [3208884387,3209096598,'Aquarius'],
  [3209096598,3209301411,'Pisces'],
  [3209301411,3209498083,'Aries'],
  [3209498083,3209686616,'Taurus'],
  [3209686616,3209868204,'Gemini'],
  [3209868204,3210045789,'Cancer'],
  [3210045789,3210223943,'Leo'],
  [3210223943,3210408078,'Virgo'],
  [3210408078,3210602930,'Libra'],
  [3210602930,3210810267,'Scorpio'],
  [3210810267,3211026705,'Sagittarius'],
  [3211026705,3211244456,'Capricorn'],
  [3211244456,3211456032,'Aquarius'],
  [3211456032,3211658126,'Pisces'],
  [3211658126,3211851523,'Aries'],
  [3211851523,3212038827,'Taurus'],
  [3212038827,3212222637,'Gemini'],
  [3212222637,3212405058,'Cancer'],
  [3212405058,3212588215,'Leo'],
  [3212588215,3212775035,'Virgo'],
  [3212775035,3212969262,'Libra'],
  [3212969262,3213173967,'Scorpio'],
  [3213173967,3213388652,'Sagittarius'],
  [3213388652,3213607143,'Capricorn'],
  [3213607143,3213820196,'Aquarius'],
  [3213820196,3214021690,'Pisces'],
  [3214021690,3214211647,'Aries'],
  [3214211647,3214394339,'Taurus'],
  [3214394339,3214575038,'Gemini'],
  [3214575038,3214757736,'Cancer'],
  [3214757736,3214944338,'Leo'],
  [3214944338,3215135524,'Virgo'],
  [3215135524,3215332416,'Libra'],
  [3215332416,3215537060,'Scorpio'],
  [3215537060,3215750512,'Sagittarius'],
  [3215750512,3215969490,'Capricorn'],
  [3215969490,3216185500,'Aquarius'],
  [3216185500,3216389850,'Pisces'],
  [3216389850,3216579749,'Aries'],
  [3216579749,3216758866,'Taurus'],
  [3216758866,3216933966,'Gemini'],
  [3216933966,3217111688,'Cancer'],
  [3217111688,3217296385,'Leo'],
  [3217296385,3217489222,'Virgo'],
  [3217489222,3217689400,'Libra'],
  [3217689400,3217896289,'Scorpio'],
  [3217896289,3218109944,'Sagittarius'],
  [3218109944,3218328905,'Capricorn'],
  [3218328905,3218547391,'Aquarius'],
  [3218547391,3218756638,'Pisces'],
  [3218756638,3218950824,'Aries'],
  [3218950824,3219130901,'Taurus'],
  [3219130901,3219302949,'Gemini'],
  [3219302949,3219474715,'Cancer'],
  [3219474715,3219653076,'Leo'],
  [3219653076,3219842110,'Virgo'],
  [3219842110,3220042178,'Libra'],
  [3220042178,3220251078,'Scorpio'],
  [3220251078,3220466163,'Sagittarius'],
  [3220466163,3220685099,'Capricorn'],
  [3220685099,3220904168,'Aquarius'],
  [3220904168,3221117051,'Pisces'],
  [3221117051,3221317350,'Aries'],
  [3221317350,3221502921,'Taurus'],
  [3221502921,3221677176,'Gemini'],
  [3221677176,3221846887,'Cancer'],
  [3221846887,3222019618,'Leo'],
  [3222019618,3222201823,'Virgo'],
  [3222201823,3222397040,'Libra'],
  [3222397040,3222604673,'Scorpio'],
  [3222604673,3222820651,'Sagittarius'],
  [3222820651,3223039949,'Capricorn'],
  [3223039949,3223258250,'Aquarius'],
  [3223258250,3223471475,'Pisces'],
  [3223471475,3223675460,'Aries'],
  [3223675460,3223867402,'Taurus'],
  [3223867402,3224047844,'Gemini'],
  [3224047844,3224220846,'Cancer'],
  [3224220846,3224392650,'Leo'],
  [3224392650,3224570087,'Virgo'],
  [3224570087,3224758949,'Libra'],
  [3224758949,3224961864,'Scorpio'],
  [3224961864,3225176396,'Sagittarius'],
  [3225176396,3225395899,'Capricorn'],
  [3225395899,3225613492,'Aquarius'],
  [3225613492,3225824888,'Pisces'],
  [3225824888,3226028277,'Aries'],
  [3226028277,3226222969,'Taurus'],
  [3226222969,3226409112,'Gemini'],
  [3226409112,3226588289,'Cancer'],
  [3226588289,3226763998,'Leo'],
  [3226763998,3226941488,'Virgo'],
  [3226941488,3227126751,'Libra'],
  [3227126751,3227324591,'Scorpio'],
  [3227324591,3227535665,'Sagittarius'],
  [3227535665,3227754467,'Capricorn'],
  [3227754467,3227972082,'Aquarius'],
  [3227972082,3228181932,'Pisces'],
  [3228181932,3228382425,'Aries'],
  [3228382425,3228575229,'Taurus'],
  [3228575229,3228762578,'Gemini'],
  [3228762578,3228946112,'Cancer'],
  [3228946112,3229127321,'Leo'],
  [3229127321,3229308790,'Virgo'],
  [3229308790,3229494796,'Libra'],
  [3229494796,3229690273,'Scorpio'],
  [3229690273,3229898061,'Sagittarius'],
  [3229898061,3230115404,'Capricorn'],
  [3230115404,3230333629,'Aquarius'],
  [3230333629,3230543731,'Pisces'],
  [3230543731,3230742214,'Aries'],
  [3230742214,3230931277,'Taurus'],
  [3230931277,3231115396,'Gemini'],
  [3231115396,3231298388,'Cancer'],
  [3231298388,3231482292,'Leo'],
  [3231482292,3231668165,'Virgo'],
  [3231668165,3231857787,'Libra'],
  [3231857787,3232054339,'Scorpio'],
  [3232054339,3232260870,'Sagittarius'],
  [3232260870,3232476904,'Capricorn'],
  [3232476904,3232695910,'Aquarius'],
  [3232695910,3232908104,'Pisces'],
  [3232908104,3233107346,'Aries'],
  [3233107346,3233294327,'Taurus'],
  [3233294327,3233474150,'Gemini'],
  [3233474150,3233652728,'Cancer'],
  [3233652728,3233834433,'Leo'],
  [3233834433,3234021333,'Virgo'],
  [3234021333,3234214113,'Libra'],
  [3234214113,3234413610,'Scorpio'],
  [3234413610,3234621169,'Sagittarius'],
  [3234621169,3234836816,'Capricorn'],
  [3234836816,3235056374,'Aquarius'],
  [3235056374,3235271410,'Pisces'],
  [3235271410,3235474131,'Aries'],
  [3235474131,3235662558,'Taurus'],
  [3235662558,3235840539,'Gemini'],
  [3235840539,3236014546,'Cancer'],
  [3236014546,3236190935,'Leo'],
  [3236190935,3236374274,'Virgo'],
  [3236374274,3236566648,'Libra'],
  [3236566648,3236768112,'Scorpio'],
  [3236768112,3236977724,'Sagittarius'],
  [3236977724,3237194001,'Capricorn'],
  [3237194001,3237413714,'Aquarius'],
  [3237413714,3237630767,'Pisces'],
  [3237630767,3237837932,'Aries'],
  [3237837932,3238031010,'Taurus'],
  [3238031010,3238211226,'Gemini'],
  [3238211226,3238383841,'Cancer'],
  [3238383841,3238555651,'Leo'],
  [3238555651,3238733146,'Virgo'],
  [3238733146,3238921059,'Libra'],
  [3238921059,3239121129,'Scorpio'],
  [3239121129,3239331720,'Sagittarius'],
  [3239331720,3239549015,'Capricorn'],
  [3239549015,3239768641,'Aquarius'],
  [3239768641,3239985936,'Pisces'],
  [3239985936,3240195927,'Aries'],
  [3240195927,3240394415,'Taurus'],
  [3240394415,3240580177,'Gemini'],
  [3240580177,3240755831,'Cancer'],
  [3240755831,3240926857,'Leo'],
  [3240926857,3241100061,'Virgo'],
  [3241100061,3241282067,'Libra'],
  [3241282067,3241477402,'Scorpio'],
  [3241477402,3241686242,'Sagittarius'],
  [3241686242,3241903842,'Capricorn'],
  [3241903842,3242123422,'Aquarius'],
  [3242123422,3242339626,'Pisces'],
  [3242339626,3242549358,'Aries'],
  [3242549358,3242750615,'Taurus'],
  [3242750615,3242942002,'Gemini'],
  [3242942002,3243123716,'Cancer'],
  [3243123716,3243298509,'Leo'],
  [3243298509,3243471685,'Virgo'],
  [3243471685,3243650029,'Libra'],
  [3243650029,3243839952,'Scorpio'],
  [3243839952,3244044573,'Sagittarius'],
  [3244044573,3244260816,'Capricorn'],
  [3244260816,3244480451,'Aquarius'],
  [3244480451,3244695671,'Pisces'],
  [3244695671,3244903124,'Aries'],
  [3244903124,3245102993,'Taurus'],
  [3245102993,3245296139,'Gemini'],
  [3245296139,3245482848,'Cancer'],
  [3245482848,3245663688,'Leo'],
  [3245663688,3245841173,'Virgo'],
  [3245841173,3246020327,'Libra'],
  [3246020327,3246207519,'Scorpio'],
  [3246207519,3246407824,'Sagittarius'],
  [3246407824,3246621230,'Capricorn'],
  [3246621230,3246840670,'Aquarius'],
  [3246840670,3247056219,'Pisces'],
  [3247056219,3247262091,'Aries'],
  [3247262091,3247458525,'Taurus'],
  [3247458525,3247648675,'Gemini'],
  [3247648675,3247835311,'Cancer'],
  [3247835311,3248019666,'Leo'],
  [3248019666,3248202535,'Virgo'],
  [3248202535,3248386180,'Libra'],
  [3248386180,3248574895,'Scorpio'],
  [3248574895,3248773528,'Sagittarius'],
  [3248773528,3248984227,'Capricorn'],
  [3248984227,3249202922,'Aquarius'],
  [3249202922,3249420033,'Pisces'],
  [3249420033,3249627040,'Aries'],
  [3249627040,3249821828,'Taurus'],
  [3249821828,3250007700,'Gemini'],
  [3250007700,3250189649,'Cancer'],
  [3250189649,3250371674,'Leo'],
  [3250371674,3250555946,'Virgo'],
  [3250555946,3250743672,'Libra'],
  [3250743672,3250936519,'Scorpio'],
  [3250936519,3251136977,'Sagittarius'],
  [3251136977,3251346934,'Capricorn'],
  [3251346934,3251564729,'Aquarius'],
  [3251564729,3251783443,'Pisces'],
  [3251783443,3251993967,'Aries'],
  [3251993967,3252191057,'Taurus'],
  [3252191057,3252375766,'Gemini'],
  [3252375766,3252553140,'Cancer'],
  [3252553140,3252729205,'Leo'],
  [3252729205,3252909057,'Virgo'],
  [3252909057,3253095933,'Libra'],
  [3253095933,3253291176,'Scorpio'],
  [3253291176,3253494848,'Sagittarius'],
  [3253494848,3253706351,'Capricorn'],
  [3253706351,3253923948,'Aquarius'],
  [3253923948,3254143299,'Pisces'],
  [3254143299,3254357401,'Aries'],
  [3254357401,3254559664,'Taurus'],
  [3254559664,3254747894,'Gemini'],
  [3254747894,3254924949,'Cancer'],
  [3254924949,3255096753,'Leo'],
  [3255096753,3255270141,'Virgo'],
  [3255270141,3255451221,'Libra'],
  [3255451221,3255643833,'Scorpio'],
  [3255643833,3255848304,'Sagittarius'],
  [3255848304,3256061770,'Capricorn'],
  [3256061770,3256280129,'Aquarius'],
  [3256280129,3256499302,'Pisces'],
  [3256499302,3256714890,'Aries'],
  [3256714890,3256921823,'Taurus'],
  [3256921823,3257116205,'Gemini'],
  [3257116205,3257297734,'Cancer'],
  [3257297734,3257470187,'Leo'],
  [3257470187,3257640120,'Virgo'],
  [3257640120,3257815026,'Libra'],
  [3257815026,3258001438,'Scorpio'],
  [3258001438,3258202428,'Sagittarius'],
  [3258202428,3258415634,'Capricorn'],
  [3258415634,3258634753,'Aquarius'],
  [3258634753,3258853656,'Pisces'],
  [3258853656,3259068587,'Aries'],
  [3259068587,3259276985,'Taurus'],
  [3259276985,3259476093,'Gemini'],
  [3259476093,3259663958,'Cancer'],
  [3259663958,3259841410,'Leo'],
  [3259841410,3260012894,'Virgo'],
  [3260012894,3260185391,'Libra'],
  [3260185391,3260366479,'Scorpio'],
  [3260366479,3260561798,'Sagittarius'],
  [3260561798,3260771747,'Capricorn'],
  [3260771747,3260990315,'Aquarius'],
  [3260990315,3261209116,'Pisces'],
  [3261209116,3261422745,'Aries'],
  [3261422745,3261629631,'Taurus'],
  [3261629631,3261829409,'Gemini'],
  [3261829409,3262021210,'Cancer'],
  [3262021210,3262204507,'Leo'],
  [3262204507,3262381092,'Virgo'],
  [3262381092,3262555826,'Libra'],
  [3262555826,3262735505,'Scorpio'],
  [3262735505,3262926636,'Sagittarius'],
  [3262926636,3263132203,'Capricorn'],
  [3263132203,3263348680,'Aquarius'],
  [3263348680,3263567353,'Pisces'],
  [3263567353,3263780427,'Aries'],
  [3263780427,3263985110,'Taurus'],
  [3263985110,3264182296,'Gemini'],
  [3264182296,3264373480,'Cancer'],
  [3264373480,3264559392,'Leo'],
  [3264559392,3264740876,'Virgo'],
  [3264740876,3264920448,'Libra'],
  [3264920448,3265102717,'Scorpio'],
  [3265102717,3265293209,'Sagittarius'],
  [3265293209,3265495859,'Capricorn'],
  [3265495859,3265709798,'Aquarius'],
  [3265709798,3265928174,'Pisces'],
  [3265928174,3266141993,'Aries'],
  [3266141993,3266346007,'Taurus'],
  [3266346007,3266540285,'Gemini'],
  [3266540285,3266727752,'Cancer'],
  [3266727752,3266911559,'Leo'],
  [3266911559,3267094074,'Virgo'],
  [3267094074,3267277331,'Libra'],
  [3267277331,3267463864,'Scorpio'],
  [3267463864,3267656910,'Sagittarius'],
  [3267656910,3267859408,'Capricorn'],
  [3267859408,3268071771,'Aquarius'],
  [3268071771,3268289764,'Pisces'],
  [3268289764,3268505320,'Aries'],
  [3268505320,3268711145,'Taurus'],
  [3268711145,3268904906,'Gemini'],
  [3268904906,3269089005,'Cancer'],
  [3269089005,3269268104,'Leo'],
  [3269268104,3269447046,'Virgo'],
  [3269447046,3269629699,'Libra'],
  [3269629699,3269818584,'Scorpio'],
  [3269818584,3270015048,'Sagittarius'],
  [3270015048,3270219671,'Capricorn'],
  [3270219671,3270432113,'Aquarius'],
  [3270432113,3270649847,'Pisces'],
  [3270649847,3270867168,'Aries'],
  [3270867168,3271076657,'Taurus'],
  [3271076657,3271273333,'Gemini'],
  [3271273333,3271457305,'Cancer'],
  [3271457305,3271632893,'Leo'],
  [3271632893,3271806421,'Virgo'],
  [3271806421,3271984231,'Libra'],
  [3271984231,3272171022,'Scorpio'],
  [3272171022,3272368535,'Sagittarius'],
  [3272368535,3272575529,'Capricorn'],
  [3272575529,3272789343,'Aquarius'],
  [3272789343,3273007128,'Pisces'],
  [3273007128,3273225253,'Aries'],
  [3273225253,3273438245,'Taurus'],
  [3273438245,3273640141,'Gemini'],
  [3273640141,3273828092,'Cancer'],
  [3273828092,3274004207,'Leo'],
  [3274004207,3274174494,'Virgo'],
  [3274174494,3274346594,'Libra'],
  [3274346594,3274527649,'Scorpio'],
  [3274527649,3274721939,'Sagittarius'],
  [3274721939,3274928898,'Capricorn'],
  [3274928898,3275144000,'Aquarius'],
  [3275144000,3275362197,'Pisces'],
  [3275362197,3275579986,'Aries'],
  [3275579986,3275794232,'Taurus'],
  [3275794232,3276000554,'Gemini'],
  [3276000554,3276194712,'Cancer'],
  [3276194712,3276375768,'Leo'],
  [3276375768,3276547522,'Virgo'],
  [3276547522,3276717100,'Libra'],
  [3276717100,3276892636,'Scorpio'],
  [3276892636,3277080878,'Sagittarius'],
  [3277080878,3277284125,'Capricorn'],
  [3277284125,3277498600,'Aquarius'],
  [3277498600,3277717207,'Pisces'],
  [3277717207,3277934344,'Aries'],
  [3277934344,3278147396,'Taurus'],
  [3278147396,3278354500,'Gemini'],
  [3278354500,3278552933,'Cancer'],
  [3278552933,3278740441,'Leo'],
  [3278740441,3278917874,'Virgo'],
  [3278917874,3279090009,'Libra'],
  [3279090009,3279264057,'Scorpio'],
  [3279264057,3279447469,'Sagittarius'],
  [3279447469,3279645140,'Capricorn'],
  [3279645140,3279856345,'Aquarius'],
  [3279856345,3280074496,'Pisces'],
  [3280074496,3280291571,'Aries'],
  [3280291571,3280502948,'Taurus'],
  [3280502948,3280707574,'Gemini'],
  [3280707574,3280905400,'Cancer'],
  [3280905400,3281095949,'Leo'],
  [3281095949,3281279211,'Virgo'],
  [3281279211,3281457287,'Libra'],
  [3281457287,3281634792,'Scorpio'],
  [3281634792,3281817782,'Sagittarius'],
  [3281817782,3282011726,'Capricorn'],
  [3282011726,3282218698,'Aquarius'],
  [3282218698,3282435058,'Pisces'],
  [3282435058,3282652640,'Aries'],
  [3282652640,3282863980,'Taurus'],
  [3282863980,3283066167,'Gemini'],
  [3283066167,3283260127,'Cancer'],
  [3283260127,3283448160,'Leo'],
  [3283448160,3283632417,'Virgo'],
  [3283632417,3283814845,'Libra'],
  [3283814845,3283997831,'Scorpio'],
  [3283997831,3284184625,'Sagittarius'],
  [3284184625,3284378962,'Capricorn'],
  [3284378962,3284583556,'Aquarius'],
  [3284583556,3284797700,'Pisces'],
  [3284797700,3285015688,'Aries'],
  [3285015688,3285229006,'Taurus'],
  [3285229006,3285431631,'Gemini'],
  [3285431631,3285622840,'Cancer'],
  [3285622840,3285805967,'Leo'],
  [3285805967,3285985865,'Virgo'],
  [3285985865,3286166961,'Libra'],
  [3286166961,3286352270,'Scorpio'],
  [3286352270,3286543369,'Sagittarius'],
  [3286543369,3286741160,'Capricorn'],
  [3286741160,3286946536,'Aquarius'],
  [3286946536,3287159614,'Pisces'],
  [3287159614,3287377583,'Aries'],
  [3287377583,3287593583,'Taurus'],
  [3287593583,3287799713,'Gemini'],
  [3287799713,3287992112,'Cancer'],
  [3287992112,3288172714,'Leo'],
  [3288172714,3288347316,'Virgo'],
  [3288347316,3288522758,'Libra'],
  [3288522758,3288704714,'Scorpio'],
  [3288704714,3288896082,'Sagittarius'],
  [3288896082,3289096628,'Capricorn'],
  [3289096628,3289304566,'Aquarius'],
  [3289304566,3289518344,'Pisces'],
  [3289518344,3289736211,'Aries'],
  [3289736211,3289953984,'Taurus'],
  [3289953984,3290164541,'Gemini'],
  [3290164541,3290361651,'Cancer'],
  [3290361651,3290544292,'Leo'],
  [3290544292,3290717053,'Virgo'],
  [3290717053,3290887446,'Libra'],
  [3290887446,3291063174,'Scorpio'],
  [3291063174,3291249887,'Sagittarius'],
  [3291249887,3291449146,'Capricorn'],
  [3291449146,3291658394,'Aquarius'],
  [3291658394,3291873611,'Pisces'],
  [3291873611,3292091685,'Aries'],
  [3292091685,3292309756,'Taurus'],
  [3292309756,3292523061,'Gemini'],
  [3292523061,3292725515,'Cancer'],
  [3292725515,3292913606,'Leo'],
  [3292913606,3293089225,'Virgo'],
  [3293089225,3293258688,'Libra'],
  [3293258688,3293430007,'Scorpio'],
  [3293430007,3293610566,'Sagittarius'],
  [3293610566,3293804744,'Capricorn'],
  [3293804744,3294011975,'Aquarius'],
  [3294011975,3294227531,'Pisces'],
  [3294227531,3294445955,'Aries'],
  [3294445955,3294663431,'Taurus'],
  [3294663431,3294876789,'Gemini'],
  [3294876789,3295082062,'Cancer'],
  [3295082062,3295275620,'Leo'],
  [3295275620,3295456990,'Virgo'],
  [3295456990,3295629979,'Libra'],
  [3295629979,3295801239,'Scorpio'],
  [3295801239,3295978161,'Sagittarius'],
  [3295978161,3296166779,'Capricorn'],
  [3296166779,3296369391,'Aquarius'],
  [3296369391,3296583125,'Pisces'],
  [3296583125,3296801484,'Aries'],
  [3296801484,3297018368,'Taurus'],
  [3297018368,3297230115,'Gemini'],
  [3297230115,3297434629,'Cancer'],
  [3297434629,3297630330,'Leo'],
  [3297630330,3297816656,'Virgo'],
  [3297816656,3297995310,'Libra'],
  [3297995310,3298170499,'Scorpio'],
  [3298170499,3298348017,'Sagittarius'],
  [3298348017,3298533788,'Capricorn'],
  [3298533788,3298731890,'Aquarius'],
  [3298731890,3298942293,'Pisces'],
  [3298942293,3299159812,'Aries'],
  [3299159812,3299376678,'Taurus'],
  [3299376678,3299587059,'Gemini'],
  [3299587059,3299788858,'Cancer'],
  [3299788858,3299982620,'Leo'],
  [3299982620,3300169872,'Virgo'],
  [3300169872,3300352481,'Libra'],
  [3300352481,3300532877,'Scorpio'],
  [3300532877,3300714382,'Sagittarius'],
  [3300714382,3300901144,'Capricorn'],
  [3300901144,3301097214,'Aquarius'],
  [3301097214,3301304582,'Pisces'],
  [3301304582,3301520713,'Aries'],
  [3301520713,3301738212,'Taurus'],
  [3301738212,3301948926,'Gemini'],
  [3301948926,3302148814,'Cancer'],
  [3302148814,3302338855,'Leo'],
  [3302338855,3302522819,'Virgo'],
  [3302522819,3302704776,'Libra'],
  [3302704776,3302887750,'Scorpio'],
  [3302887750,3303073636,'Sagittarius'],
  [3303073636,3303264082,'Capricorn'],
  [3303264082,3303461302,'Aquarius'],
  [3303461302,3303667479,'Pisces'],
  [3303667479,3303882362,'Aries'],
  [3303882362,3304100756,'Taurus'],
  [3304100756,3304313776,'Gemini'],
  [3304313776,3304514603,'Cancer'],
  [3304514603,3304702559,'Leo'],
  [3304702559,3304882065,'Virgo'],
  [3304882065,3305059385,'Libra'],
  [3305059385,3305239958,'Scorpio'],
  [3305239958,3305426802,'Sagittarius'],
  [3305426802,3305620493,'Capricorn'],
  [3305620493,3305820774,'Aquarius'],
  [3305820774,3306028014,'Pisces'],
  [3306028014,3306242467,'Aries'],
  [3306242467,3306461429,'Taurus'],
  [3306461429,3306677560,'Gemini'],
  [3306677560,3306882348,'Cancer'],
  [3306882348,3307072130,'Leo'],
  [3307072130,3307249869,'Virgo'],
  [3307249869,3307422407,'Libra'],
  [3307422407,3307597206,'Scorpio'],
  [3307597206,3307779972,'Sagittarius'],
  [3307779972,3307972968,'Capricorn'],
  [3307972968,3308175215,'Aquarius'],
  [3308175215,3308384647,'Pisces'],
  [3308384647,3308599762,'Aries'],
  [3308599762,3308818733,'Taurus'],
  [3308818733,3309036820,'Gemini'],
  [3309036820,3309246429,'Cancer'],
  [3309246429,3309441618,'Leo'],
  [3309441618,3309622324,'Virgo'],
  [3309622324,3309793915,'Libra'],
  [3309793915,3309964117,'Scorpio'],
  [3309964117,3310140445,'Sagittarius'],
  [3310140445,3310328108,'Capricorn'],
  [3310328108,3310528324,'Aquarius'],
  [3310528324,3310738585,'Pisces'],
  [3310738585,3310954884,'Aries'],
  [3310954884,3311173741,'Taurus'],
  [3311173741,3311391671,'Gemini'],
  [3311391671,3311603731,'Cancer'],
  [3311603731,3311804562,'Leo'],
  [3311804562,3311991688,'Virgo'],
  [3311991688,3312167453,'Libra'],
  [3312167453,3312337850,'Scorpio'],
  [3312337850,3312510252,'Sagittarius'],
  [3312510252,3312691508,'Capricorn'],
  [3312691508,3312885966,'Aquarius'],
  [3312885966,3313093633,'Pisces'],
  [3313093633,3313310085,'Aries'],
  [3313310085,3313529142,'Taurus'],
  [3313529142,3313745862,'Gemini'],
  [3313745862,3313956886,'Cancer'],
  [3313956886,3314159572,'Leo'],
  [3314159572,3314352064,'Virgo'],
  [3314352064,3314534561,'Libra'],
  [3314534561,3314710045,'Scorpio'],
  [3314710045,3314883779,'Sagittarius'],
  [3314883779,3315062127,'Capricorn'],
  [3315062127,3315250988,'Aquarius'],
  [3315250988,3315453568,'Pisces'],
  [3315453568,3315667944,'Aries'],
  [3315667944,3315887124,'Taurus'],
  [3315887124,3316103298,'Gemini'],
  [3316103298,3316311948,'Cancer'],
  [3316311948,3316512250,'Leo'],
  [3316512250,3316705094,'Virgo'],
  [3316705094,3316891638,'Libra'],
  [3316891638,3317073275,'Scorpio'],
  [3317073275,3317252373,'Sagittarius'],
  [3317252373,3317432888,'Capricorn'],
  [3317432888,3317620002,'Aquarius'],
  [3317620002,3317818432,'Pisces'],
  [3317818432,3318029412,'Aries'],
  [3318029412,3318247992,'Taurus'],
  [3318247992,3318464867,'Gemini'],
  [3318464867,3318672644,'Cancer'],
  [3318672644,3318869695,'Leo'],
  [3318869695,3319058774,'Virgo'],
  [3319058774,3319243734,'Libra'],
  [3319243734,3319427408,'Scorpio'],
  [3319427408,3319611282,'Sagittarius'],
  [3319611282,3319796712,'Capricorn'],
  [3319796712,3319986359,'Aquarius'],
  [3319986359,3320184086,'Pisces'],
  [3320184086,3320392660,'Aries'],
  [3320392660,3320610117,'Taurus'],
  [3320610117,3320828342,'Gemini'],
  [3320828342,3321037775,'Cancer'],
  [3321037775,3321234096,'Leo'],
  [3321234096,3321419552,'Virgo'],
  [3321419552,3321599687,'Libra'],
  [3321599687,3321779934,'Scorpio'],
  [3321779934,3321963686,'Sagittarius'],
  [3321963686,3322152114,'Capricorn'],
  [3322152114,3322345692,'Aquarius'],
  [3322345692,3322545799,'Pisces'],
  [3322545799,3322754352,'Aries'],
  [3322754352,3322971060,'Taurus'],
  [3322971060,3323190431,'Gemini'],
  [3323190431,3323403097,'Cancer'],
  [3323403097,3323602126,'Leo'],
  [3323602126,3323787370,'Virgo'],
  [3323787370,3323963982,'Libra'],
  [3323963982,3324138807,'Scorpio'],
  [3324138807,3324317737,'Sagittarius'],
  [3324317737,3324504214,'Capricorn'],
  [3324504214,3324699091,'Aquarius'],
  [3324699091,3324901925,'Pisces'],
  [3324901925,3325112250,'Aries'],
  [3325112250,3325329158,'Taurus'],
  [3325329158,3325549039,'Gemini'],
  [3325549039,3325764640,'Cancer'],
  [3325764640,3325968354,'Leo'],
  [3325968354,3326157258,'Virgo'],
  [3326157258,3326334362,'Libra'],
  [3326334362,3326506066,'Scorpio'],
  [3326506066,3326679415,'Sagittarius'],
  [3326679415,3326860271,'Capricorn'],
  [3326860271,3327051989,'Aquarius'],
  [3327051989,3327254861,'Pisces'],
  [3327254861,3327466751,'Aries'],
  [3327466751,3327684519,'Taurus'],
  [3327684519,3327904378,'Gemini'],
  [3327904378,3328121160,'Cancer'],
  [3328121160,3328328867,'Leo'],
  [3328328867,3328523350,'Virgo'],
  [3328523350,3328704871,'Libra'],
  [3328704871,3328877778,'Scorpio'],
  [3328877778,3329048548,'Sagittarius'],
  [3329048548,3329224032,'Capricorn'],
  [3329224032,3329409961,'Aquarius'],
  [3329409961,3329609237,'Pisces'],
  [3329609237,3329820520,'Aries'],
  [3329820520,3330038875,'Taurus'],
  [3330038875,3330258534,'Gemini'],
  [3330258534,3330474681,'Cancer'],
  [3330474681,3330683576,'Leo'],
  [3330683576,3330882312,'Virgo'],
  [3330882312,3331069753,'Libra'],
  [3331069753,3331247579,'Scorpio'],
  [3331247579,3331420170,'Sagittarius'],
  [3331420170,3331593690,'Capricorn'],
  [3331593690,3331774786,'Aquarius'],
  [3331774786,3331968739,'Pisces'],
  [3331968739,3332176821,'Aries'],
  [3332176821,3332394556,'Taurus'],
  [3332394556,3332614081,'Gemini'],
  [3332614081,3332828937,'Cancer'],
  [3332828937,3333036259,'Leo'],
  [3333036259,3333235516,'Virgo'],
  [3333235516,3333426708,'Libra'],
  [3333426708,3333610261,'Scorpio'],
  [3333610261,3333787976,'Sagittarius'],
  [3333787976,3333963824,'Capricorn'],
  [3333963824,3334143637,'Aquarius'],
  [3334143637,3334333595,'Pisces'],
  [3334333595,3334537457,'Aries'],
  [3334537457,3334753178,'Taurus'],
  [3334753178,3334972628,'Gemini'],
  [3334972628,3335186934,'Cancer'],
  [3335186934,3335391969,'Leo'],
  [3335391969,3335588484,'Virgo'],
  [3335588484,3335778924,'Libra'],
  [3335778924,3335965049,'Scorpio'],
  [3335965049,3336147769,'Sagittarius'],
  [3336147769,3336328622,'Capricorn'],
  [3336328622,3336511129,'Aquarius'],
  [3336511129,3336700494,'Pisces'],
  [3336700494,3336901458,'Aries'],
  [3336901458,3337114656,'Taurus'],
  [3337114656,3337333913,'Gemini'],
  [3337333913,3337549155,'Cancer'],
  [3337549155,3337753612,'Leo'],
  [3337753612,3337947104,'Virgo'],
  [3337947104,3338133528,'Libra'],
  [3338133528,3338317189,'Scorpio'],
  [3338317189,3338500755,'Sagittarius'],
  [3338500755,3338685393,'Capricorn'],
  [3338685393,3338872424,'Aquarius'],
  [3338872424,3339064600,'Pisces'],
  [3339064600,3339265536,'Aries'],
  [3339265536,3339477100,'Taurus'],
  [3339477100,3339695933,'Gemini'],
  [3339695933,3339913162,'Cancer'],
  [3339913162,3340119915,'Leo'],
  [3340119915,3340313268,'Virgo'],
  [3340313268,3340496348,'Libra'],
  [3340496348,3340674856,'Scorpio'],
  [3340674856,3340854107,'Sagittarius'],
  [3340854107,3341037544,'Capricorn'],
  [3341037544,3341226755,'Aquarius'],
  [3341226755,3341422592,'Pisces'],
  [3341422592,3341626058,'Aries'],
  [3341626058,3341837862,'Taurus'],
  [3341837862,3342056257,'Gemini'],
  [3342056257,3342275153,'Cancer'],
  [3342275153,3342486023,'Leo'],
  [3342486023,3342683189,'Virgo'],
  [3342683189,3342867009,'Libra'],
  [3342867009,3343042367,'Scorpio'],
  [3343042367,3343215781,'Sagittarius'],
  [3343215781,3343393348,'Capricorn'],
  [3343393348,3343579394,'Aquarius'],
  [3343579394,3343775706,'Pisces'],
  [3343775706,3343981671,'Aries'],
  [3343981671,3344195256,'Taurus'],
  [3344195256,3344413719,'Gemini'],
  [3344413719,3344632952,'Cancer'],
  [3344632952,3344847016,'Leo'],
  [3344847016,3345049894,'Virgo'],
  [3345049894,3345238908,'Libra'],
  [3345238908,3345416128,'Scorpio'],
  [3345416128,3345587099,'Sagittarius'],
  [3345587099,3345758852,'Capricorn'],
  [3345758852,3345938214,'Aquarius'],
  [3345938214,3346130006,'Pisces'],
  [3346130006,3346335091,'Aries'],
  [3346335091,3346549965,'Taurus'],
  [3346549965,3346769130,'Gemini'],
  [3346769130,3346987790,'Cancer'],
  [3346987790,3347202238,'Leo'],
  [3347202238,3347408797,'Virgo'],
  [3347408797,3347604194,'Libra'],
  [3347604194,3347787515,'Scorpio'],
  [3347787515,3347961448,'Sagittarius'],
  [3347961448,3348131846,'Capricorn'],
  [3348131846,3348306133,'Aquarius'],
  [3348306133,3348491384,'Pisces'],
  [3348491384,3348691633,'Aries'],
  [3348691633,3348905065,'Taurus'],
  [3348905065,3349124628,'Gemini'],
  [3349124628,3349342880,'Cancer'],
  [3349342880,3349555782,'Leo'],
  [3349555782,3349761986,'Virgo'],
  [3349761986,3349960397,'Libra'],
  [3349960397,3350149715,'Scorpio'],
  [3350149715,3350329955,'Sagittarius'],
  [3350329955,3350504147,'Capricorn'],
  [3350504147,3350678275,'Aquarius'],
  [3350678275,3350859646,'Pisces'],
  [3350859646,3351054370,'Aries'],
  [3351054370,3351263812,'Taurus'],
  [3351263812,3351482350,'Gemini'],
  [3351482350,3351700679,'Cancer'],
  [3351700679,3351912315,'Leo'],
  [3351912315,3352115912,'Virgo'],
  [3352115912,3352312674,'Libra'],
  [3352312674,3352503499,'Scorpio'],
  [3352503499,3352688480,'Sagittarius'],
  [3352688480,3352868478,'Capricorn'],
  [3352868478,3353046773,'Aquarius'],
  [3353046773,3353228949,'Pisces'],
  [3353228949,3353421086,'Aries'],
  [3353421086,3353626630,'Taurus'],
  [3353626630,3353842956,'Gemini'],
  [3353842956,3354061474,'Cancer'],
  [3354061474,3354273411,'Leo'],
  [3354273411,3354475260,'Virgo'],
  [3354475260,3354668483,'Libra'],
  [3354668483,3354856207,'Scorpio'],
  [3354856207,3355040850,'Sagittarius'],
  [3355040850,3355223862,'Capricorn'],
  [3355223862,3355406934,'Aquarius'],
  [3355406934,3355593113,'Pisces'],
  [3355593113,3355786551,'Aries'],
  [3355786551,3355990647,'Taurus'],
  [3355990647,3356205004,'Gemini'],
  [3356205004,3356423560,'Cancer'],
  [3356423560,3356637257,'Leo'],
  [3356637257,3356839964,'Virgo'],
  [3356839964,3357031310,'Libra'],
  [3357031310,3357214826,'Scorpio'],
  [3357214826,3357395090,'Sagittarius'],
  [3357395090,3357575994,'Capricorn'],
  [3357575994,3357760287,'Aquarius'],
  [3357760287,3357949961,'Pisces'],
  [3357949961,3358146771,'Aries'],
  [3358146771,3358352158,'Taurus'],
  [3358352158,3358565949,'Gemini'],
  [3358565949,3358784452,'Cancer'],
  [3358784452,3359000404,'Leo'],
  [3359000404,3359206390,'Virgo'],
  [3359206390,3359399279,'Libra'],
  [3359399279,3359581055,'Scorpio'],
  [3359581055,3359756776,'Sagittarius'],
  [3359756776,3359932380,'Capricorn'],
  [3359932380,3360113118,'Aquarius'],
  [3360113118,3360302447,'Pisces'],
  [3360302447,3360501456,'Aries'],
  [3360501456,3360709260,'Taurus'],
  [3360709260,3360923932,'Gemini'],
  [3360923932,3361142466,'Cancer'],
  [3361142466,3361359983,'Leo'],
  [3361359983,3361570009,'Virgo'],
  [3361570009,3361767411,'Libra'],
  [3361767411,3361951426,'Scorpio'],
  [3361951426,3362125768,'Sagittarius'],
  [3362125768,3362296850,'Capricorn'],
  [3362296850,3362471789,'Aquarius'],
  [3362471789,3362656581,'Pisces'],
  [3362656581,3362854103,'Aries'],
  [3362854103,3363062970,'Taurus'],
  [3363062970,3363278964,'Gemini'],
  [3363278964,3363497709,'Cancer'],
  [3363497709,3363715488,'Leo'],
  [3363715488,3363928104,'Virgo'],
  [3363928104,3364130667,'Libra'],
  [3364130667,3364320068,'Scorpio'],
  [3364320068,3364497338,'Sagittarius'],
  [3364497338,3364667632,'Capricorn'],
  [3364667632,3364838400,'Aquarius'],
  [3364838400,3365017318,'Pisces'],
  [3365017318,3365209898,'Aries'],
  [3365209898,3365416720,'Taurus'],
  [3365416720,3365632964,'Gemini'],
  [3365632964,3365851974,'Cancer'],
  [3365851974,3366069087,'Leo'],
  [3366069087,3366281682,'Virgo'],
  [3366281682,3366487025,'Libra'],
  [3366487025,3366681956,'Scorpio'],
  [3366681956,3366865119,'Sagittarius'],
  [3366865119,3367039039,'Capricorn'],
  [3367039039,3367209805,'Aquarius'],
  [3367209805,3367385163,'Pisces'],
  [3367385163,3367572229,'Aries'],
  [3367572229,3367774400,'Taurus'],
  [3367774400,3367988773,'Gemini'],
  [3367988773,3368207703,'Cancer'],
  [3368207703,3368424174,'Leo'],
  [3368424174,3368635024,'Virgo'],
  [3368635024,3368839429,'Libra'],
  [3368839429,3369036422,'Scorpio'],
  [3369036422,3369224715,'Sagittarius'],
  [3369224715,3369404639,'Capricorn'],
  [3369404639,3369579659,'Aquarius'],
  [3369579659,3369755858,'Pisces'],
  [3369755858,3369940147,'Aries'],
  [3369940147,3370137651,'Taurus'],
  [3370137651,3370348480,'Gemini'],
  [3370348480,3370566529,'Cancer'],
  [3370566529,3370783126,'Leo'],
  [3370783126,3370992671,'Virgo'],
  [3370992671,3371194141,'Libra'],
  [3371194141,3371388725,'Scorpio'],
  [3371388725,3371577552,'Sagittarius'],
  [3371577552,3371761440,'Capricorn'],
  [3371761440,3371942067,'Aquarius'],
  [3371942067,3372122858,'Pisces'],
  [3372122858,3372308669,'Aries'],
  [3372308669,3372504273,'Taurus'],
  [3372504273,3372711799,'Gemini'],
  [3372711799,3372928204,'Cancer'],
  [3372928204,3373145605,'Leo'],
  [3373145605,3373355982,'Virgo'],
  [3373355982,3373555863,'Libra'],
  [3373555863,3373746458,'Scorpio'],
  [3373746458,3373931174,'Sagittarius'],
  [3373931174,3374113520,'Capricorn'],
  [3374113520,3374296275,'Aquarius'],
  [3374296275,3374481659,'Pisces'],
  [3374481659,3374671869,'Aries'],
  [3374671869,3374869300,'Taurus'],
  [3374869300,3375075785,'Gemini'],
  [3375075785,3375290620,'Cancer'],
  [3375290620,3375508743,'Leo'],
  [3375508743,3375721945,'Virgo'],
  [3375721945,3375923735,'Libra'],
  [3375923735,3376112943,'Scorpio'],
  [3376112943,3376293091,'Sagittarius'],
  [3376293091,3376469879,'Capricorn'],
  [3376469879,3376648929,'Aquarius'],
  [3376648929,3376834246,'Pisces'],
  [3376834246,3377027495,'Aries'],
  [3377027495,3377228518,'Taurus'],
  [3377228518,3377436657,'Gemini'],
  [3377436657,3377651102,'Cancer'],
  [3377651102,3377869337,'Leo'],
  [3377869337,3378085478,'Virgo'],
  [3378085478,3378291952,'Libra'],
  [3378291952,3378484283,'Scorpio'],
  [3378484283,3378663744,'Sagittarius'],
  [3378663744,3378836099,'Capricorn'],
  [3378836099,3379008827,'Aquarius'],
  [3379008827,3379188745,'Pisces'],
  [3379188745,3379379904,'Aries'],
  [3379379904,3379582245,'Taurus'],
  [3379582245,3379792762,'Gemini'],
  [3379792762,3380008240,'Cancer'],
  [3380008240,3380226302,'Leo'],
  [3380226302,3380443657,'Virgo'],
  [3380443657,3380654497,'Libra'],
  [3380654497,3380852768,'Scorpio'],
  [3380852768,3381036454,'Sagittarius'],
  [3381036454,3381209192,'Capricorn'],
  [3381209192,3381378286,'Aquarius'],
  [3381378286,3381551930,'Pisces'],
  [3381551930,3381736871,'Aries'],
  [3381736871,3381935837,'Taurus'],
  [3381935837,3382146330,'Gemini'],
  [3382146330,3382362957,'Cancer'],
  [3382362957,3382581129,'Leo'],
  [3382581129,3382797970,'Virgo'],
  [3382797970,3383010200,'Libra'],
  [3383010200,3383213165,'Scorpio'],
  [3383213165,3383403236,'Sagittarius'],
  [3383403236,3383580992,'Capricorn'],
  [3383580992,3383751620,'Aquarius'],
  [3383751620,3383922749,'Pisces'],
  [3383922749,3384102098,'Aries'],
  [3384102098,3384295027,'Taurus'],
  [3384295027,3384501957,'Gemini'],
  [3384501957,3384718023,'Cancer'],
  [3384718023,3384936421,'Leo'],
  [3384936421,3385152337,'Virgo'],
  [3385152337,3385363211,'Libra'],
  [3385363211,3385566862,'Scorpio'],
  [3385566862,3385760980,'Sagittarius'],
  [3385760980,3385944804,'Capricorn'],
  [3385944804,3386120784,'Aquarius'],
  [3386120784,3386294332,'Pisces'],
  [3386294332,3386472226,'Aries'],
  [3386472226,3386660621,'Taurus'],
  [3386660621,3386862595,'Gemini'],
  [3386862595,3387076030,'Cancer'],
  [3387076030,3387294167,'Leo'],
  [3387294167,3387509785,'Virgo'],
  [3387509785,3387718751,'Libra'],
  [3387718751,3387919925,'Scorpio'],
  [3387919925,3388113486,'Sagittarius'],
  [3388113486,3388300074,'Capricorn'],
  [3388300074,3388481223,'Aquarius'],
  [3388481223,3388659944,'Pisces'],
  [3388659944,3388840670,'Aries'],
  [3388840670,3389028412,'Taurus'],
  [3389028412,3389227117,'Gemini'],
  [3389227117,3389437362,'Cancer'],
  [3389437362,3389654606,'Leo'],
  [3389654606,3389870808,'Virgo'],
  [3389870808,3390079281,'Libra'],
  [3390079281,3390277748,'Scorpio'],
  [3390277748,3390467717,'Sagittarius'],
  [3390467717,3390652305,'Capricorn'],
  [3390652305,3390834624,'Aquarius'],
  [3390834624,3391017255,'Pisces'],
  [3391017255,3391202529,'Aries'],
  [3391202529,3391393046,'Taurus'],
  [3391393046,3391591632,'Gemini'],
  [3391591632,3391799972,'Cancer'],
  [3391799972,3392016178,'Leo'],
  [3392016178,3392233550,'Virgo'],
  [3392233550,3392443660,'Libra'],
  [3392443660,3392641701,'Scorpio'],
  [3392641701,3392828477,'Sagittarius'],
  [3392828477,3393008558,'Capricorn'],
  [3393008558,3393187456,'Aquarius'],
  [3393187456,3393369594,'Pisces'],
  [3393369594,3393557358,'Aries'],
  [3393557358,3393751488,'Taurus'],
  [3393751488,3393952433,'Gemini'],
  [3393952433,3394160953,'Cancer'],
  [3394160953,3394376599,'Leo'],
  [3394376599,3394595113,'Virgo'],
  [3394595113,3394808363,'Libra'],
  [3394808363,3395009106,'Scorpio'],
  [3395009106,3395195791,'Sagittarius'],
  [3395195791,3395372578,'Capricorn'],
  [3395372578,3395546337,'Aquarius'],
  [3395546337,3395723811,'Pisces'],
  [3395723811,3395909546,'Aries'],
  [3395909546,3396104763,'Taurus'],
  [3396104763,3396308237,'Gemini'],
  [3396308237,3396518443,'Cancer'],
  [3396518443,3396734321,'Leo'],
  [3396734321,3396953399,'Virgo'],
  [3396953399,3397169618,'Libra'],
  [3397169618,3397375114,'Scorpio'],
  [3397375114,3397565534,'Sagittarius'],
  [3397565534,3397742864,'Capricorn'],
  [3397742864,3397913602,'Aquarius'],
  [3397913602,3398085616,'Pisces'],
  [3398085616,3398265755,'Aries'],
  [3398265755,3398457736,'Taurus'],
  [3398457736,3398661127,'Gemini'],
  [3398661127,3398872808,'Cancer'],
  [3398872808,3399089500,'Leo'],
  [3399089500,3399308521,'Virgo'],
  [3399308521,3399525907,'Libra'],
  [3399525907,3399735507,'Scorpio'],
  [3399735507,3399931796,'Sagittarius'],
  [3399931796,3400113850,'Capricorn'],
  [3400113850,3400286029,'Aquarius'],
  [3400286029,3400455609,'Pisces'],
  [3400455609,3400630312,'Aries'],
  [3400630312,3400816237,'Taurus'],
  [3400816237,3401015752,'Gemini'],
  [3401015752,3401226675,'Cancer'],
  [3401226675,3401443972,'Leo'],
  [3401443972,3401662777,'Virgo'],
  [3401662777,3401879352,'Libra'],
  [3401879352,3402089922,'Scorpio'],
  [3402089922,3402290527,'Sagittarius'],
  [3402290527,3402478954,'Capricorn'],
  [3402478954,3402656699,'Aquarius'],
  [3402656699,3402828723,'Pisces'],
  [3402828723,3403001790,'Aries'],
  [3403001790,3403182710,'Taurus'],
  [3403182710,3403376392,'Gemini'],
  [3403376392,3403583646,'Cancer'],
  [3403583646,3403800219,'Leo'],
  [3403800219,3404019055,'Virgo'],
  [3404019055,3404234313,'Libra'],
  [3404234313,3404442863,'Scorpio'],
  [3404442863,3404643377,'Sagittarius'],
  [3404643377,3404835312,'Capricorn'],
  [3404835312,3405019169,'Aquarius'],
  [3405019169,3405197199,'Pisces'],
  [3405197199,3405373556,'Aries'],
  [3405373556,3405553733,'Taurus'],
  [3405553733,3405743304,'Gemini'],
  [3405743304,3405945783,'Cancer'],
  [3405945783,3406159898,'Leo'],
  [3406159898,3406378787,'Virgo'],
  [3406378787,3406593910,'Libra'],
  [3406593910,3406800199,'Scorpio'],
  [3406800199,3406997301,'Sagittarius'],
  [3406997301,3407187429,'Capricorn'],
  [3407187429,3407373059,'Aquarius'],
  [3407373059,3407556063,'Pisces'],
  [3407556063,3407738186,'Aries'],
  [3407738186,3407922091,'Taurus'],
  [3407922091,3408111771,'Gemini'],
  [3408111771,3408311408,'Cancer'],
  [3408311408,3408522558,'Leo'],
  [3408522558,3408741013,'Virgo'],
  [3408741013,3408957539,'Libra'],
  [3408957539,3409164010,'Scorpio'],
  [3409164010,3409358380,'Sagittarius'],
  [3409358380,3409543942,'Capricorn'],
  [3409543942,3409725846,'Aquarius'],
  [3409725846,3409908327,'Pisces'],
  [3409908327,3410093540,'Aries'],
  [3410093540,3410282224,'Taurus'],
  [3410282224,3410475523,'Gemini'],
  [3410475523,3410675871,'Cancer'],
  [3410675871,3410885534,'Leo'],
  [3410885534,3411103177,'Virgo'],
  [3411103177,3411321576,'Libra'],
  [3411321576,3411531036,'Scorpio'],
  [3411531036,3411726347,'Sagittarius'],
  [3411726347,3411909345,'Capricorn'],
  [3411909345,3412086094,'Aquarius'],
  [3412086094,3412263261,'Pisces'],
  [3412263261,3412445686,'Aries'],
  [3412445686,3412635288,'Taurus'],
  [3412635288,3412831886,'Gemini'],
  [3412831886,3413035206,'Cancer'],
  [3413035206,3413245716,'Leo'],
  [3413245716,3413462936,'Virgo'],
  [3413462936,3413682430,'Libra'],
  [3413682430,3413895735,'Scorpio'],
  [3413895735,3414095468,'Sagittarius'],
  [3414095468,3414280421,'Capricorn'],
  [3414280421,3414455302,'Aquarius'],
  [3414455302,3414627362,'Pisces'],
  [3414627362,3414803571,'Aries'],
  [3414803571,3414988721,'Taurus'],
  [3414988721,3415184389,'Gemini'],
  [3415184389,3415389496,'Cancer'],
  [3415389496,3415601952,'Leo'],
  [3415601952,3415819625,'Virgo'],
  [3415819625,3416039192,'Libra'],
  [3416039192,3416254777,'Scorpio'],
  [3416254777,3416459561,'Sagittarius'],
  [3416459561,3416649939,'Capricorn'],
  [3416649939,3416827771,'Aquarius'],
  [3416827771,3416998886,'Pisces'],
  [3416998886,3417170505,'Aries'],
  [3417170505,3417349302,'Taurus'],
  [3417349302,3417539779,'Gemini'],
  [3417539779,3417742915,'Cancer'],
  [3417742915,3417956022,'Leo'],
  [3417956022,3418174492,'Virgo'],
  [3418174492,3418393706,'Libra'],
  [3418393706,3418609217,'Scorpio'],
  [3418609217,3418816577,'Sagittarius'],
  [3418816577,3419012346,'Capricorn'],
  [3419012346,3419196065,'Aquarius'],
  [3419196065,3419370863,'Pisces'],
  [3419370863,3419542401,'Aries'],
  [3419542401,3419717377,'Taurus'],
  [3419717377,3419902027,'Gemini'],
  [3419902027,3420100217,'Cancer'],
  [3420100217,3420311295,'Leo'],
  [3420311295,3420529828,'Virgo'],
  [3420529828,3420748788,'Libra'],
  [3420748788,3420962920,'Scorpio'],
  [3420962920,3421169532,'Sagittarius'],
  [3421169532,3421367378,'Capricorn'],
  [3421367378,3421556083,'Aquarius'],
  [3421556083,3421736700,'Pisces'],
  [3421736700,3421912284,'Aries'],
  [3421912284,3422087859,'Taurus'],
  [3422087859,3422269569,'Gemini'],
  [3422269569,3422462963,'Cancer'],
  [3422462963,3422670217,'Leo'],
  [3422670217,3422887519,'Virgo'],
  [3422887519,3423106460,'Libra'],
  [3423106460,3423319506,'Scorpio'],
  [3423319506,3423523692,'Sagittarius'],
  [3423523692,3423719758,'Capricorn'],
  [3423719758,3423909442,'Aquarius'],
  [3423909442,3424094077,'Pisces'],
  [3424094077,3424274964,'Aries'],
  [3424274964,3424454608,'Taurus'],
  [3424454608,3424637402,'Gemini'],
  [3424637402,3424828762,'Cancer'],
  [3424828762,3425032629,'Leo'],
  [3425032629,3425247892,'Virgo'],
  [3425247892,3425466965,'Libra'],
  [3425466965,3425680295,'Scorpio'],
  [3425680295,3425882860,'Sagittarius'],
  [3425882860,3426075578,'Capricorn'],
  [3426075578,3426262243,'Aquarius'],
  [3426262243,3426446374,'Pisces'],
  [3426446374,3426629923,'Aries'],
  [3426629923,3426814009,'Taurus'],
  [3426814009,3427000617,'Gemini'],
  [3427000617,3427193330,'Cancer'],
  [3427193330,3427396013,'Leo'],
  [3427396013,3427609559,'Virgo'],
  [3427609559,3427828763,'Libra'],
  [3427828763,3428043866,'Scorpio'],
  [3428043866,3428247310,'Sagittarius'],
  [3428247310,3428438231,'Capricorn'],
  [3428438231,3428620828,'Aquarius'],
  [3428620828,3428800653,'Pisces'],
  [3428800653,3428982036,'Aries'],
  [3428982036,3429167209,'Taurus'],
  [3429167209,3429357166,'Gemini'],
  [3429357166,3429553174,'Cancer'],
  [3429553174,3429757191,'Leo'],
  [3429757191,3429970271,'Virgo'],
  [3429970271,3430189502,'Libra'],
  [3430189502,3430406963,'Scorpio'],
  [3430406963,3430613872,'Sagittarius'],
  [3430613872,3430806525,'Capricorn'],
  [3430806525,3430987529,'Aquarius'],
  [3430987529,3431162837,'Pisces'],
  [3431162837,3431338759,'Aries'],
  [3431338759,3431520145,'Taurus'],
  [3431520145,3431709589,'Gemini'],
  [3431709589,3431907750,'Cancer'],
  [3431907750,3432114277,'Leo'],
  [3432114277,3432328315,'Virgo'],
  [3432328315,3432547535,'Libra'],
  [3432547535,3432766526,'Scorpio'],
  [3432766526,3432977702,'Sagittarius'],
  [3432977702,3433175369,'Capricorn'],
  [3433175369,3433359161,'Aquarius'],
  [3433359161,3433533440,'Pisces'],
  [3433533440,3433704772,'Aries'],
  [3433704772,3433879903,'Taurus'],
  [3433879903,3434064249,'Gemini'],
  [3434064249,3434260541,'Cancer'],
  [3434260541,3434468098,'Leo'],
  [3434468098,3434683640,'Virgo'],
  [3434683640,3434903068,'Libra'],
  [3434903068,3435122040,'Scorpio'],
  [3435122040,3435335596,'Sagittarius'],
  [3435335596,3435538728,'Capricorn'],
  [3435538728,3435728728,'Aquarius'],
  [3435728728,3435906901,'Pisces'],
  [3435906901,3436078073,'Aries'],
  [3436078073,3436249034,'Taurus'],
  [3436249034,3436426940,'Gemini'],
  [3436426940,3436617472,'Cancer'],
  [3436617472,3436822395,'Leo'],
  [3436822395,3437038145,'Virgo'],
  [3437038145,3437258015,'Libra'],
  [3437258015,3437476144,'Scorpio'],
  [3437476144,3437689061,'Sagittarius'],
  [3437689061,3437894419,'Capricorn'],
  [3437894419,3438090054,'Aquarius'],
  [3438090054,3438275006,'Pisces'],
  [3438275006,3438451001,'Aries'],
  [3438451001,3438622870,'Taurus'],
  [3438622870,3438797524,'Gemini'],
  [3438797524,3438982170,'Cancer'],
  [3438982170,3439181611,'Leo'],
  [3439181611,3439394876,'Virgo'],
  [3439394876,3439614690,'Libra'],
  [3439614690,3439832414,'Scorpio'],
  [3439832414,3440043344,'Sagittarius'],
  [3440043344,3440246874,'Capricorn'],
  [3440246874,3440443519,'Aquarius'],
  [3440443519,3440633145,'Pisces'],
  [3440633145,3440815647,'Aries'],
  [3440815647,3440992849,'Taurus'],
  [3440992849,3441169451,'Gemini'],
  [3441169451,3441352048,'Cancer'],
  [3441352048,3441546809,'Leo'],
  [3441546809,3441755890,'Virgo'],
  [3441755890,3441974372,'Libra'],
  [3441974372,3442192469,'Scorpio'],
  [3442192469,3442402598,'Sagittarius'],
  [3442402598,3442603196,'Capricorn'],
  [3442603196,3442796554,'Aquarius'],
  [3442796554,3442985262,'Pisces'],
  [3442985262,3443170569,'Aries'],
  [3443170569,3443353147,'Taurus'],
  [3443353147,3443534978,'Gemini'],
  [3443534978,3443720206,'Cancer'],
  [3443720206,3443914056,'Leo'],
  [3443914056,3444120056,'Virgo'],
  [3444120056,3444336422,'Libra'],
  [3444336422,3444555066,'Scorpio'],
  [3444555066,3444766549,'Sagittarius'],
  [3444766549,3444966470,'Capricorn'],
  [3444966470,3445156363,'Aquarius'],
  [3445156363,3445340482,'Pisces'],
  [3445340482,3445522826,'Aries'],
  [3445522826,3445705948,'Taurus'],
  [3445705948,3445891441,'Gemini'],
  [3445891441,3446081149,'Cancer'],
  [3446081149,3446277707,'Leo'],
  [3446277707,3446483569,'Virgo'],
  [3446483569,3446698504,'Libra'],
  [3446698504,3446917353,'Scorpio'],
  [3446917353,3447131434,'Sagittarius'],
  [3447131434,3447333904,'Capricorn'],
  [3447333904,3447523627,'Aquarius'],
  [3447523627,3447704208,'Pisces'],
  [3447704208,3447881141,'Aries'],
  [3447881141,3448059663,'Taurus'],
  [3448059663,3448243627,'Gemini'],
  [3448243627,3448435171,'Cancer'],
  [3448435171,3448635023,'Leo'],
  [3448635023,3448843055,'Virgo'],
  [3448843055,3449058143,'Libra'],
  [3449058143,3449276932,'Scorpio'],
  [3449276932,3449493232,'Sagittarius'],
  [3449493232,3449699998,'Capricorn'],
  [3449699998,3449893349,'Aquarius'],
  [3449893349,3450074426,'Pisces'],
  [3450074426,3450248134,'Aries'],
  [3450248134,3450421008,'Taurus'],
  [3450421008,3450599405,'Gemini'],
  [3450599405,3450787950,'Cancer'],
  [3450787950,3450988140,'Leo'],
  [3450988140,3451198161,'Virgo'],
  [3451198161,3451414477,'Libra'],
  [3451414477,3451633272,'Scorpio'],
  [3451633272,3451850372,'Sagittarius'],
  [3451850372,3452060664,'Capricorn'],
  [3452060664,3452259381,'Aquarius'],
  [3452259381,3452444867,'Pisces'],
  [3452444867,3452619749,'Aries'],
  [3452619749,3452789992,'Taurus'],
  [3452789992,3452963003,'Gemini'],
  [3452963003,3453145707,'Cancer'],
  [3453145707,3453342219,'Leo'],
  [3453342219,3453551664,'Virgo'],
  [3453551664,3453768832,'Libra'],
  [3453768832,3453987786,'Scorpio'],
  [3453987786,3454204395,'Sagittarius'],
  [3454204395,3454415690,'Capricorn'],
  [3454415690,3454618375,'Aquarius'],
  [3454618375,3454809638,'Pisces'],
  [3454809638,3454989397,'Aries'],
  [3454989397,3455161468,'Taurus'],
  [3455161468,3455332601,'Gemini'],
  [3455332601,3455510517,'Cancer'],
  [3455510517,3455701537,'Leo'],
  [3455701537,3455907459,'Virgo'],
  [3455907459,3456123825,'Libra'],
  [3456123825,3456342845,'Scorpio'],
  [3456342845,3456558573,'Sagittarius'],
  [3456558573,3456768564,'Capricorn'],
  [3456768564,3456971749,'Aquarius'],
  [3456971749,3457166618,'Pisces'],
  [3457166618,3457351994,'Aries'],
  [3457351994,3457529149,'Taurus'],
  [3457529149,3457702703,'Gemini'],
  [3457702703,3457879512,'Cancer'],
  [3457879512,3458066547,'Leo'],
  [3458066547,3458267911,'Virgo'],
  [3458267911,3458481722,'Libra'],
  [3458481722,3458700385,'Scorpio'],
  [3458700385,3458915769,'Sagittarius'],
  [3458915769,3459123926,'Capricorn'],
  [3459123926,3459324715,'Aquarius'],
  [3459324715,3459518968,'Pisces'],
  [3459518968,3459706932,'Aries'],
  [3459706932,3459889060,'Taurus'],
  [3459889060,3460067648,'Gemini'],
  [3460067648,3460247306,'Cancer'],
  [3460247306,3460433898,'Leo'],
  [3460433898,3460632246,'Virgo'],
  [3460632246,3460843003,'Libra'],
  [3460843003,3461060794,'Scorpio'],
  [3461060794,3461276798,'Sagittarius'],
  [3461276798,3461484540,'Capricorn'],
  [3461484540,3461682690,'Aquarius'],
  [3461682690,3461873301,'Pisces'],
  [3461873301,3462059116,'Aries'],
  [3462059116,3462242309,'Taurus'],
  [3462242309,3462424799,'Gemini'],
  [3462424799,3462609113,'Cancer'],
  [3462609113,3462798681,'Leo'],
  [3462798681,3462997063,'Virgo'],
  [3462997063,3463205933,'Libra'],
  [3463205933,3463422650,'Scorpio'],
  [3463422650,3463639934,'Sagittarius'],
  [3463639934,3463849614,'Capricorn'],
  [3463849614,3464047618,'Aquarius'],
  [3464047618,3464235061,'Pisces'],
  [3464235061,3464416056,'Aries'],
  [3464416056,3464595387,'Taurus'],
  [3464595387,3464777083,'Gemini'],
  [3464777083,3464963868,'Cancer'],
  [3464963868,3465157322,'Leo'],
  [3465157322,3465358395,'Virgo'],
  [3465358395,3465567538,'Libra'],
  [3465567538,3465783553,'Scorpio'],
  [3465783553,3466001921,'Sagittarius'],
  [3466001921,3466215113,'Capricorn'],
  [3466215113,3466416522,'Aquarius'],
  [3466416522,3466604443,'Pisces'],
  [3466604443,3466782195,'Aries'],
  [3466782195,3466955896,'Taurus'],
  [3466955896,3467132157,'Gemini'],
  [3467132157,3467316226,'Cancer'],
  [3467316226,3467510517,'Leo'],
  [3467510517,3467714350,'Virgo'],
  [3467714350,3467925486,'Libra'],
  [3467925486,3468141708,'Scorpio'],
  [3468141708,3468360326,'Sagittarius'],
  [3468360326,3468576410,'Capricorn'],
  [3468576410,3468783171,'Aquarius'],
  [3468783171,3468975889,'Pisces'],
  [3468975889,3469155076,'Aries'],
  [3469155076,3469326065,'Taurus'],
  [3469326065,3469496524,'Gemini'],
  [3469496524,3469674098,'Cancer'],
  [3469674098,3469864101,'Leo'],
  [3469864101,3470067270,'Virgo'],
  [3470067270,3470279921,'Libra'],
  [3470279921,3470497155,'Scorpio'],
  [3470497155,3470715515,'Sagittarius'],
  [3470715515,3470932176,'Capricorn'],
  [3470932176,3471142707,'Aquarius'],
  [3471142707,3471341799,'Pisces'],
  [3471341799,3471526862,'Aries'],
  [3471526862,3471700465,'Taurus'],
  [3471700465,3471869293,'Gemini'],
  [3471869293,3472041593,'Cancer'],
  [3472041593,3472224845,'Leo'],
  [3472224845,3472422976,'Virgo'],
  [3472422976,3472634077,'Libra'],
  [3472634077,3472851850,'Scorpio'],
  [3472851850,3473070169,'Sagittarius'],
  [3473070169,3473285695,'Capricorn'],
  [3473285695,3473496253,'Aquarius'],
  [3473496253,3473698781,'Pisces'],
  [3473698781,3473890196,'Aries'],
  [3473890196,3474070220,'Taurus'],
  [3474070220,3474242780,'Gemini'],
  [3474242780,3474414743,'Cancer'],
  [3474414743,3474593740,'Leo'],
  [3474593740,3474785755,'Virgo'],
  [3474785755,3474992213,'Libra'],
  [3474992213,3475208556,'Scorpio'],
  [3475208556,3475426994,'Sagittarius'],
  [3475426994,3475641567,'Capricorn'],
  [3475641567,3475849861,'Aquarius'],
  [3475849861,3476051136,'Pisces'],
  [3476051136,3476244631,'Aries'],
  [3476244631,3476429997,'Taurus'],
  [3476429997,3476608811,'Gemini'],
  [3476608811,3476785178,'Cancer'],
  [3476785178,3476964918,'Leo'],
  [3476964918,3477153890,'Virgo'],
  [3477153890,3477355639,'Libra'],
  [3477355639,3477568860,'Scorpio'],
  [3477568860,3477786946,'Sagittarius'],
  [3477786946,3478001790,'Capricorn'],
  [3478001790,3478208521,'Aquarius'],
  [3478208521,3478406441,'Pisces'],
  [3478406441,3478597142,'Aries'],
  [3478597142,3478782702,'Taurus'],
  [3478782702,3478965169,'Gemini'],
  [3478965169,3479146910,'Cancer'],
  [3479146910,3479331046,'Leo'],
  [3479331046,3479521358,'Virgo'],
  [3479521358,3479721250,'Libra'],
  [3479721250,3479931655,'Scorpio'],
  [3479931655,3480148846,'Sagittarius'],
  [3480148846,3480364936,'Capricorn'],
  [3480364936,3480572463,'Aquarius'],
  [3480572463,3480768568,'Pisces'],
  [3480768568,3480955149,'Aries'],
  [3480955149,3481136557,'Taurus'],
  [3481136557,3481317307,'Gemini'],
  [3481317307,3481500774,'Cancer'],
  [3481500774,3481688932,'Leo'],
  [3481688932,3481883016,'Virgo'],
  [3481883016,3482084338,'Libra'],
  [3482084338,3482293885,'Scorpio'],
  [3482293885,3482510261,'Sagittarius'],
  [3482510261,3482727784,'Capricorn'],
  [3482727784,3482938169,'Aquarius'],
  [3482938169,3483135745,'Pisces'],
  [3483135745,3483320625,'Aries'],
  [3483320625,3483497604,'Taurus'],
  [3483497604,3483673244,'Gemini'],
  [3483673244,3483853396,'Cancer'],
  [3483853396,3484041511,'Leo'],
  [3484041511,3484238143,'Virgo'],
  [3484238143,3484442250,'Libra'],
  [3484442250,3484652918,'Scorpio'],
  [3484652918,3484869139,'Sagittarius'],
  [3484869139,3485087574,'Capricorn'],
  [3485087574,3485301317,'Aquarius'],
  [3485301317,3485503066,'Pisces'],
  [3485503066,3485690132,'Aries'],
  [3485690132,3485865846,'Taurus'],
  [3485865846,3486037160,'Gemini'],
  [3486037160,3486211680,'Cancer'],
  [3486211680,3486395365,'Leo'],
  [3486395365,3486590607,'Virgo'],
  [3486590607,3486795966,'Libra'],
  [3486795966,3487008326,'Scorpio'],
  [3487008326,3487225074,'Sagittarius'],
  [3487225074,3487443667,'Capricorn'],
  [3487443667,3487659464,'Aquarius'],
  [3487659464,3487865828,'Pisces'],
  [3487865828,3488058001,'Aries'],
  [3488058001,3488236638,'Taurus'],
  [3488236638,3488407351,'Gemini'],
  [3488407351,3488577920,'Cancer'],
  [3488577920,3488755847,'Leo'],
  [3488755847,3488946127,'Virgo'],
  [3488946127,3489149356,'Libra'],
  [3489149356,3489362073,'Scorpio'],
  [3489362073,3489579479,'Sagittarius'],
  [3489579479,3489797773,'Capricorn'],
  [3489797773,3490013530,'Aquarius'],
  [3490013530,3490222312,'Pisces'],
  [3490222312,3490419631,'Aries'],
  [3490419631,3490603954,'Taurus'],
  [3490603954,3490778313,'Gemini'],
  [3490778313,3490949031,'Cancer'],
  [3490949031,3491123533,'Leo'],
  [3491123533,3491308318,'Virgo'],
  [3491308318,3491506729,'Libra'],
  [3491506729,3491717342,'Scorpio'],
  [3491717342,3491934720,'Sagittarius'],
  [3491934720,3492152753,'Capricorn'],
  [3492152753,3492367157,'Aquarius'],
  [3492367157,3492575129,'Pisces'],
  [3492575129,3492774420,'Aries'],
  [3492774420,3492963709,'Taurus'],
  [3492963709,3493143962,'Gemini'],
  [3493143962,3493318919,'Cancer'],
  [3493318919,3493494271,'Leo'],
  [3493494271,3493676266,'Virgo'],
  [3493676266,3493869892,'Libra'],
  [3493869892,3494076612,'Scorpio'],
  [3494076612,3494292733,'Sagittarius'],
  [3494292733,3494510841,'Capricorn'],
  [3494510841,3494724220,'Aquarius'],
  [3494724220,3494929637,'Pisces'],
  [3494929637,3495126860,'Aries'],
  [3495126860,3495316930,'Taurus'],
  [3495316930,3495501265,'Gemini'],
  [3495501265,3495681857,'Cancer'],
  [3495681857,3495861743,'Leo'],
  [3495861743,3496045140,'Virgo'],
  [3496045140,3496236741,'Libra'],
  [3496236741,3496439888,'Scorpio'],
  [3496439888,3496653826,'Sagittarius'],
  [3496653826,3496872211,'Capricorn'],
  [3496872211,3497086200,'Aquarius'],
  [3497086200,3497290111,'Pisces'],
  [3497290111,3497483675,'Aries'],
  [3497483675,3497670142,'Taurus'],
  [3497670142,3497853460,'Gemini'],
  [3497853460,3498036583,'Cancer'],
  [3498036583,3498221262,'Leo'],
  [3498221262,3498409044,'Virgo'],
  [3498409044,3498602384,'Libra'],
  [3498602384,3498804357,'Scorpio'],
  [3498804357,3499016347,'Sagittarius'],
  [3499016347,3499234808,'Capricorn'],
  [3499234808,3499451011,'Aquarius'],
  [3499451011,3499656451,'Pisces'],
  [3499656451,3499848522,'Aries'],
  [3499848522,3500030634,'Taurus'],
  [3500030634,3500208862,'Gemini'],
  [3500208862,3500388864,'Cancer'],
  [3500388864,3500574026,'Leo'],
  [3500574026,3500765198,'Virgo'],
  [3500765198,3500962292,'Libra'],
  [3500962292,3501166021,'Scorpio'],
  [3501166021,3501377574,'Sagittarius'],
  [3501377574,3501595789,'Capricorn'],
  [3501595789,3501814370,'Aquarius'],
  [3501814370,3502023977,'Pisces'],
  [3502023977,3502218783,'Aries'],
  [3502218783,3502400017,'Taurus'],
  [3502400017,3502573832,'Gemini'],
  [3502573832,3502747699,'Cancer'],
  [3502747699,3502927819,'Leo'],
  [3502927819,3503117343,'Virgo'],
  [3503117343,3503316140,'Libra'],
  [3503316140,3503522603,'Scorpio'],
  [3503522603,3503735495,'Sagittarius'],
  [3503735495,3503953616,'Capricorn'],
  [3503953616,3504173221,'Aquarius'],
  [3504173221,3504386934,'Pisces'],
  [3504386934,3504587453,'Aries'],
  [3504587453,3504772711,'Taurus'],
  [3504772711,3504946735,'Gemini'],
  [3504946735,3505116767,'Cancer'],
  [3505116767,3505290422,'Leo'],
  [3505290422,3505473683,'Virgo'],
  [3505473683,3505669208,'Libra'],
  [3505669208,3505875901,'Scorpio'],
  [3505875901,3506090358,'Sagittarius'],
  [3506090358,3506308977,'Capricorn'],
  [3506308977,3506528240,'Aquarius'],
  [3506528240,3506743393,'Pisces'],
  [3506743393,3506948728,'Aries'],
  [3506948728,3507140517,'Taurus'],
  [3507140517,3507319633,'Gemini'],
  [3507319633,3507491087,'Cancer'],
  [3507491087,3507661880,'Leo'],
  [3507661880,3507839086,'Virgo'],
  [3507839086,3508028144,'Libra'],
  [3508028144,3508230969,'Scorpio'],
  [3508230969,3508444870,'Sagittarius'],
  [3508444870,3508664026,'Capricorn'],
  [3508664026,3508882703,'Aquarius'],
  [3508882703,3509096714,'Pisces'],
  [3509096714,3509302987,'Aries'],
  [3509302987,3509499213,'Taurus'],
  [3509499213,3509684821,'Gemini'],
  [3509684821,3509861911,'Cancer'],
  [3509861911,3510035089,'Leo'],
  [3510035089,3510210504,'Virgo'],
  [3510210504,3510394497,'Libra'],
  [3510394497,3510591681,'Scorpio'],
  [3510591681,3510802315,'Sagittarius'],
  [3510802315,3511020971,'Capricorn'],
  [3511020971,3511239507,'Aquarius'],
  [3511239507,3511451870,'Pisces'],
  [3511451870,3511655919,'Aries'],
  [3511655919,3511851929,'Taurus'],
  [3511851929,3512040762,'Gemini'],
  [3512040762,3512223529,'Cancer'],
  [3512223529,3512402238,'Leo'],
  [3512402238,3512580559,'Virgo'],
  [3512580559,3512763725,'Libra'],
  [3512763725,3512957166,'Scorpio'],
  [3512957166,3513163783,'Sagittarius'],
  [3513163783,3513380719,'Capricorn'],
  [3513380719,3513599474,'Aquarius'],
  [3513599474,3513811423,'Pisces'],
  [3513811423,3514013019,'Aries'],
  [3514013019,3514205733,'Taurus'],
  [3514205733,3514392896,'Gemini'],
  [3514392896,3514577233,'Cancer'],
  [3514577233,3514760288,'Leo'],
  [3514760288,3514943501,'Virgo'],
  [3514943501,3515129657,'Libra'],
  [3515129657,3515322995,'Scorpio'],
  [3515322995,3515527277,'Sagittarius'],
  [3515527277,3515742270,'Capricorn'],
  [3515742270,3515961322,'Aquarius'],
  [3515961322,3516174551,'Pisces'],
  [3516174551,3516375824,'Aries'],
  [3516375824,3516565648,'Taurus'],
  [3516565648,3516748618,'Gemini'],
  [3516748618,3516929823,'Cancer'],
  [3516929823,3517112694,'Leo'],
  [3517112694,3517298717,'Virgo'],
  [3517298717,3517488815,'Libra'],
  [3517488815,3517684855,'Scorpio'],
  [3517684855,3517889435,'Sagittarius'],
  [3517889435,3518103418,'Capricorn'],
  [3518103418,3518322679,'Aquarius'],
  [3518322679,3518538243,'Pisces'],
  [3518538243,3518741942,'Aries'],
  [3518741942,3518931832,'Taurus'],
  [3518931832,3519111823,'Gemini'],
  [3519111823,3519288179,'Cancer'],
  [3519288179,3519466644,'Leo'],
  [3519466644,3519650878,'Virgo'],
  [3519650878,3519842300,'Libra'],
  [3519842300,3520041213,'Scorpio'],
  [3520041213,3520247888,'Sagittarius'],
  [3520247888,3520462229,'Capricorn'],
  [3520462229,3520681579,'Aquarius'],
  [3520681579,3520899247,'Pisces'],
  [3520899247,3521107029,'Aries'],
  [3521107029,3521300445,'Taurus'],
  [3521300445,3521481109,'Gemini'],
  [3521481109,3521654665,'Cancer'],
  [3521654665,3521827901,'Leo'],
  [3521827901,3522006785,'Virgo'],
  [3522006785,3522195161,'Libra'],
  [3522195161,3522394178,'Scorpio'],
  [3522394178,3522602669,'Sagittarius'],
  [3522602669,3522818231,'Capricorn'],
  [3522818231,3523037651,'Aquarius'],
  [3523037651,3523256099,'Pisces'],
  [3523256099,3523467332,'Aries'],
  [3523467332,3523666111,'Taurus'],
  [3523666111,3523851293,'Gemini'],
  [3523851293,3524026258,'Cancer'],
  [3524026258,3524197093,'Leo'],
  [3524197093,3524370692,'Virgo'],
  [3524370692,3524553228,'Libra'],
  [3524553228,3524748483,'Scorpio'],
  [3524748483,3524956317,'Sagittarius'],
  [3524956317,3525172750,'Capricorn'],
  [3525172750,3525392334,'Aquarius'],
  [3525392334,3525610190,'Pisces'],
  [3525610190,3525822280,'Aries'],
  [3525822280,3526025058,'Taurus'],
  [3526025058,3526216298,'Gemini'],
  [3526216298,3526396575,'Cancer'],
  [3526396575,3526569607,'Leo'],
  [3526569607,3526741429,'Virgo'],
  [3526741429,3526919024,'Libra'],
  [3526919024,3527108533,'Scorpio'],
  [3527108533,3527312629,'Sagittarius'],
  [3527312629,3527528250,'Capricorn'],
  [3527528250,3527747998,'Aquarius'],
  [3527747998,3527964899,'Pisces'],
  [3527964899,3528175363,'Aries'],
  [3528175363,3528378306,'Taurus'],
  [3528378306,3528573135,'Gemini'],
  [3528573135,3528759456,'Cancer'],
  [3528759456,3528938254,'Leo'],
  [3528938254,3529113038,'Virgo'],
  [3529113038,3529289699,'Libra'],
  [3529289699,3529475041,'Scorpio'],
  [3529475041,3529674188,'Sagittarius'],
  [3529674188,3529886976,'Capricorn'],
  [3529886976,3530106448,'Aquarius'],
  [3530106448,3530323204,'Pisces'],
  [3530323204,3530531731,'Aries'],
  [3530531731,3530731768,'Taurus'],
  [3530731768,3530925316,'Gemini'],
  [3530925316,3531113852,'Cancer'],
  [3531113852,3531297859,'Leo'],
  [3531297859,3531478359,'Virgo'],
  [3531478359,3531658578,'Libra'],
  [3531658578,3531843906,'Scorpio'],
  [3531843906,3532040007,'Sagittarius'],
  [3532040007,3532249357,'Capricorn'],
  [3532249357,3532467747,'Aquarius'],
  [3532467747,3532685427,'Pisces'],
  [3532685427,3532894022,'Aries'],
  [3532894022,3533091534,'Taurus'],
  [3533091534,3533280915,'Gemini'],
  [3533280915,3533466267,'Cancer'],
  [3533466267,3533650377,'Leo'],
  [3533650377,3533834467,'Virgo'],
  [3533834467,3534019729,'Libra'],
  [3534019729,3534208803,'Scorpio'],
  [3534208803,3534405608,'Sagittarius'],
  [3534405608,3534613171,'Capricorn'],
  [3534613171,3534830122,'Aquarius'],
  [3534830122,3535048988,'Pisces'],
  [3535048988,3535260135,'Aries'],
  [3535260135,3535458443,'Taurus'],
  [3535458443,3535645264,'Gemini'],
  [3535645264,3535825555,'Cancer'],
  [3535825555,3536004654,'Leo'],
  [3536004654,3536186494,'Virgo'],
  [3536186494,3536373244,'Libra'],
  [3536373244,3536566112,'Scorpio'],
  [3536566112,3536766261,'Sagittarius'],
  [3536766261,3536974778,'Capricorn'],
  [3536974778,3537191034,'Aquarius'],
  [3537191034,3537410468,'Pisces'],
  [3537410468,3537625011,'Aries'],
  [3537625011,3537827521,'Taurus'],
  [3537827521,3538016178,'Gemini'],
  [3538016178,3538194392,'Cancer'],
  [3538194392,3538368157,'Leo'],
  [3538368157,3538543759,'Virgo'],
  [3538543759,3538726285,'Libra'],
  [3538726285,3538918606,'Scorpio'],
  [3538918606,3539121024,'Sagittarius'],
  [3539121024,3539331934,'Capricorn'],
  [3539331934,3539548841,'Aquarius'],
  [3539548841,3539768223,'Pisces'],
  [3539768223,3539984808,'Aries'],
  [3539984808,3540192276,'Taurus'],
  [3540192276,3540386397,'Gemini'],
  [3540386397,3540567487,'Cancer'],
  [3540567487,3540740000,'Leo'],
  [3540740000,3540910652,'Virgo'],
  [3540910652,3541086569,'Libra'],
  [3541086569,3541273548,'Scorpio'],
  [3541273548,3541474012,'Sagittarius'],
  [3541474012,3541685829,'Capricorn'],
  [3541685829,3541903917,'Aquarius'],
  [3541903917,3542123215,'Pisces'],
  [3542123215,3542339800,'Aries'],
  [3542339800,3542549890,'Taurus'],
  [3542549890,3542749578,'Gemini'],
  [3542749578,3542936763,'Cancer'],
  [3542936763,3543112955,'Leo'],
  [3543112955,3543283320,'Virgo'],
  [3543283320,3543455144,'Libra'],
  [3543455144,3543635922,'Scorpio'],
  [3543635922,3543830948,'Sagittarius'],
  [3543830948,3544040360,'Capricorn'],
  [3544040360,3544258511,'Aquarius'],
  [3544258511,3544477874,'Pisces'],
  [3544477874,3544693425,'Aries'],
  [3544693425,3544902993,'Taurus'],
  [3544902993,3545104950,'Gemini'],
  [3545104950,3545297400,'Cancer'],
  [3545297400,3545479678,'Leo'],
  [3545479678,3545654209,'Virgo'],
  [3545654209,3545826656,'Libra'],
  [3545826656,3546004376,'Scorpio'],
  [3546004376,3546194150,'Sagittarius'],
  [3546194150,3546398973,'Capricorn'],
  [3546398973,3546615245,'Aquarius'],
  [3546615245,3546834470,'Pisces'],
  [3546834470,3547049254,'Aries'],
  [3547049254,3547256796,'Taurus'],
  [3547256796,3547457256,'Gemini'],
  [3547457256,3547650922,'Cancer'],
  [3547650922,3547837505,'Leo'],
  [3547837505,3548017616,'Virgo'],
  [3548017616,3548194388,'Libra'],
  [3548194388,3548373407,'Scorpio'],
  [3548373407,3548561096,'Sagittarius'],
  [3548561096,3548761971,'Capricorn'],
  [3548761971,3548975260,'Aquarius'],
  [3548975260,3549193890,'Pisces'],
  [3549193890,3549408854,'Aries'],
  [3549408854,3549615107,'Taurus'],
  [3549615107,3549812606,'Gemini'],
  [3549812606,3550003551,'Cancer'],
  [3550003551,3550189901,'Leo'],
  [3550189901,3550372957,'Virgo'],
  [3550372957,3550554465,'Libra'],
  [3550554465,3550737638,'Scorpio'],
  [3550737638,3550926957,'Sagittarius'],
  [3550926957,3551126560,'Capricorn'],
  [3551126560,3551337456,'Aquarius'],
  [3551337456,3551555209,'Pisces'],
  [3551555209,3551771267,'Aries'],
  [3551771267,3551978324,'Taurus'],
  [3551978324,3552174299,'Gemini'],
  [3552174299,3552361500,'Cancer'],
  [3552361500,3552543875,'Leo'],
  [3552543875,3552725104,'Virgo'],
  [3552725104,3552908004,'Libra'],
  [3552908004,3553094842,'Scorpio'],
  [3553094842,3553287808,'Sagittarius'],
  [3553287808,3553488990,'Capricorn'],
  [3553488990,3553699267,'Aquarius'],
  [3553699267,3553916317,'Pisces'],
  [3553916317,3554133775,'Aries'],
  [3554133775,3554343688,'Taurus'],
  [3554343688,3554541260,'Gemini'],
  [3554541260,3554726976,'Cancer'],
  [3554726976,3554905080,'Leo'],
  [3554905080,3555081241,'Virgo'],
  [3555081241,3555260775,'Libra'],
  [3555260775,3555447443,'Scorpio'],
  [3555447443,3555642875,'Sagittarius'],
  [3555642875,3555846878,'Capricorn'],
  [3555846878,3556058333,'Aquarius'],
  [3556058333,3556275235,'Pisces'],
  [3556275235,3556493586,'Aries'],
  [3556493586,3556706961,'Taurus'],
  [3556706961,3556908981,'Gemini'],
  [3556908981,3557097190,'Cancer'],
  [3557097190,3557274163,'Leo'],
  [3557274163,3557445906,'Virgo'],
  [3557445906,3557619599,'Libra'],
  [3557619599,3557801610,'Scorpio'],
  [3557801610,3557995504,'Sagittarius'],
  [3557995504,3558200785,'Capricorn'],
  [3558200785,3558414018,'Aquarius'],
  [3558414018,3558631413,'Pisces'],
  [3558631413,3558849770,'Aries'],
  [3558849770,3559065149,'Taurus'],
  [3559065149,3559272082,'Gemini'],
  [3559272082,3559465988,'Cancer'],
  [3559465988,3559646422,'Leo'],
  [3559646422,3559817768,'Virgo'],
  [3559817768,3559987375,'Libra'],
  [3559987375,3560163238,'Scorpio'],
  [3560163238,3560351666,'Sagittarius'],
  [3560351666,3560554487,'Capricorn'],
  [3560554487,3560768050,'Aquarius'],
  [3560768050,3560986167,'Pisces'],
  [3560986167,3561204087,'Aries'],
  [3561204087,3561419090,'Taurus'],
  [3561419090,3561628238,'Gemini'],
  [3561628238,3561827582,'Cancer'],
  [3561827582,3562014458,'Leo'],
  [3562014458,3562190241,'Virgo'],
  [3562190241,3562360518,'Libra'],
  [3562360518,3562533082,'Scorpio'],
  [3562533082,3562715633,'Sagittarius'],
  [3562715633,3562912932,'Capricorn'],
  [3562912932,3563123883,'Aquarius'],
  [3563123883,3563341923,'Pisces'],
  [3563341923,3563559704,'Aries'],
  [3563559704,3563773166,'Taurus'],
  [3563773166,3563980901,'Gemini'],
  [3563980901,3564181584,'Cancer'],
  [3564181584,3564373348,'Leo'],
  [3564373348,3564555640,'Virgo'],
  [3564555640,3564731122,'Libra'],
  [3564731122,3564905491,'Scorpio'],
  [3564905491,3565085797,'Sagittarius'],
  [3565085797,3565278100,'Capricorn'],
  [3565278100,3565484439,'Aquarius'],
  [3565484439,3565700730,'Pisces'],
  [3565700730,3565918737,'Aries'],
  [3565918737,3566131561,'Taurus'],
  [3566131561,3566336665,'Gemini'],
  [3566336665,3566534436,'Cancer'],
  [3566534436,3566725791,'Leo'],
  [3566725791,3566911421,'Virgo'],
  [3566911421,3567092658,'Libra'],
  [3567092658,3567272455,'Scorpio'],
  [3567272455,3567455380,'Sagittarius'],
  [3567455380,3567646499,'Capricorn'],
  [3567646499,3567849241,'Aquarius'],
  [3567849241,3568062753,'Pisces'],
  [3568062753,3568280768,'Aries'],
  [3568280768,3568494738,'Taurus'],
  [3568494738,3568699159,'Gemini'],
  [3568699159,3568893503,'Cancer'],
  [3568893503,3569080459,'Leo'],
  [3569080459,3569263582,'Virgo'],
  [3569263582,3569445963,'Libra'],
  [3569445963,3569629998,'Scorpio'],
  [3569629998,3569817820,'Sagittarius'],
  [3569817820,3570011774,'Capricorn'],
  [3570011774,3570214179,'Aquarius'],
  [3570214179,3570425752,'Pisces'],
  [3570425752,3570643325,'Aries'],
  [3570643325,3570859439,'Taurus'],
  [3570859439,3571066225,'Gemini'],
  [3571066225,3571260256,'Cancer'],
  [3571260256,3571443521,'Leo'],
  [3571443521,3571621238,'Virgo'],
  [3571621238,3571799250,'Libra'],
  [3571799250,3571982157,'Scorpio'],
  [3571982157,3572172302,'Sagittarius'],
  [3572172302,3572369991,'Capricorn'],
  [3572369991,3572574830,'Aquarius'],
  [3572574830,3572786538,'Pisces'],
  [3572786538,3573003700,'Aries'],
  [3573003700,3573221571,'Taurus'],
  [3573221571,3573432399,'Gemini'],
  [3573432399,3573629959,'Cancer'],
  [3573629959,3573813574,'Leo'],
  [3573813574,3573987916,'Virgo'],
  [3573987916,3574160193,'Libra'],
  [3574160193,3574337499,'Scorpio'],
  [3574337499,3574524702,'Sagittarius'],
  [3574524702,3574722927,'Capricorn'],
  [3574722927,3574930098,'Aquarius'],
  [3574930098,3575143411,'Pisces'],
  [3575143411,3575360733,'Aries'],
  [3575360733,3575579232,'Taurus'],
  [3575579232,3575793335,'Gemini'],
  [3575793335,3575996191,'Cancer'],
  [3575996191,3576184232,'Leo'],
  [3576184232,3576359749,'Virgo'],
  [3576359749,3576529382,'Libra'],
  [3576529382,3576701188,'Scorpio'],
  [3576701188,3576882293,'Sagittarius'],
  [3576882293,3577076551,'Capricorn'],
  [3577076551,3577283040,'Aquarius'],
  [3577283040,3577497453,'Pisces'],
  [3577497453,3577715365,'Aries'],
  [3577715365,3577933619,'Taurus'],
  [3577933619,3578148679,'Gemini'],
  [3578148679,3578355419,'Cancer'],
  [3578355419,3578549288,'Leo'],
  [3578549288,3578729820,'Virgo'],
  [3578729820,3578901454,'Libra'],
  [3578901454,3579071483,'Scorpio'],
  [3579071483,3579247658,'Sagittarius'],
  [3579247658,3579435999,'Capricorn'],
  [3579435999,3579638409,'Aquarius'],
  [3579638409,3579851722,'Pisces'],
  [3579851722,3580069895,'Aries'],
  [3580069895,3580287699,'Taurus'],
  [3580287699,3580501730,'Gemini'],
  [3580501730,3580709026,'Cancer'],
  [3580709026,3580906551,'Leo'],
  [3580906551,3581092830,'Virgo'],
  [3581092830,3581269766,'Libra'],
  [3581269766,3581442460,'Scorpio'],
  [3581442460,3581617635,'Sagittarius'],
  [3581617635,3581801797,'Capricorn'],
  [3581801797,3581999090,'Aquarius'],
  [3581999090,3582209124,'Pisces'],
  [3582209124,3582426560,'Aries'],
  [3582426560,3582644174,'Taurus'],
  [3582644174,3582856759,'Gemini'],
  [3582856759,3583061959,'Cancer'],
  [3583061959,3583259069,'Leo'],
  [3583259069,3583448119,'Virgo'],
  [3583448119,3583630225,'Libra'],
  [3583630225,3583808181,'Scorpio'],
  [3583808181,3583986400,'Sagittarius'],
  [3583986400,3584170161,'Capricorn'],
  [3584170161,3584364185,'Aquarius'],
  [3584364185,3584570487,'Pisces'],
  [3584570487,3584786227,'Aries'],
  [3584786227,3585004029,'Taurus'],
  [3585004029,3585216274,'Gemini'],
  [3585216274,3585419154,'Cancer'],
  [3585419154,3585613001,'Leo'],
  [3585613001,3585800291,'Virgo'],
  [3585800291,3585983794,'Libra'],
  [3585983794,3586165917,'Scorpio'],
  [3586165917,3586348989,'Sagittarius'],
  [3586348989,3586535842,'Capricorn'],
  [3586535842,3586729906,'Aquarius'],
  [3586729906,3586934015,'Pisces'],
  [3586934015,3587147901,'Aries'],
  [3587147901,3587366088,'Taurus'],
  [3587366088,3587579759,'Gemini'],
  [3587579759,3587782430,'Cancer'],
  [3587782430,3587973363,'Leo'],
  [3587973363,3588156314,'Virgo'],
  [3588156314,3588336516,'Libra'],
  [3588336516,3588518335,'Scorpio'],
  [3588518335,3588704221,'Sagittarius'],
  [3588704221,3588895144,'Capricorn'],
  [3588895144,3589092023,'Aquarius'],
  [3589092023,3589296455,'Pisces'],
  [3589296455,3589509312,'Aries'],
  [3589509312,3589727760,'Taurus'],
  [3589727760,3589944031,'Gemini'],
  [3589944031,3590149511,'Cancer'],
  [3590149511,3590340720,'Leo'],
  [3590340720,3590520609,'Virgo'],
  [3590520609,3590695658,'Libra'],
  [3590695658,3590872651,'Scorpio'],
  [3590872651,3591056405,'Sagittarius'],
  [3591056405,3591248573,'Capricorn'],
  [3591248573,3591448455,'Aquarius'],
  [3591448455,3591655125,'Pisces'],
  [3591655125,3591868337,'Aries'],
  [3591868337,3592086769,'Taurus'],
  [3592086769,3592305218,'Gemini'],
  [3592305218,3592515261,'Cancer'],
  [3592515261,3592710684,'Leo'],
  [3592710684,3592891740,'Virgo'],
  [3592891740,3593064122,'Libra'],
  [3593064122,3593235588,'Scorpio'],
  [3593235588,3593413294,'Sagittarius'],
  [3593413294,3593601688,'Capricorn'],
  [3593601688,3593801297,'Aquarius'],
  [3593801297,3594009809,'Pisces'],
  [3594009809,3594224411,'Aries'],
  [3594224411,3594442841,'Taurus'],
  [3594442841,3594661765,'Gemini'],
  [3594661765,3594875180,'Cancer'],
  [3594875180,3595076506,'Leo'],
  [3595076506,3595263039,'Virgo'],
  [3595263039,3595437783,'Libra'],
  [3595437783,3595607463,'Scorpio'],
  [3595607463,3595779828,'Sagittarius'],
  [3595779828,3595961583,'Capricorn'],
  [3595961583,3596156391,'Aquarius'],
  [3596156391,3596363590,'Pisces'],
  [3596363590,3596579048,'Aries'],
  [3596579048,3596797832,'Taurus'],
  [3596797832,3597015926,'Gemini'],
  [3597015926,3597229490,'Cancer'],
  [3597229490,3597434289,'Leo'],
  [3597434289,3597627149,'Virgo'],
  [3597627149,3597808229,'Libra'],
  [3597808229,3597981464,'Scorpio'],
  [3597981464,3598153170,'Sagittarius'],
  [3598153170,3598330314,'Capricorn'],
  [3598330314,3598518766,'Aquarius'],
  [3598518766,3598721171,'Pisces'],
  [3598721171,3598935160,'Aries'],
  [3598935160,3599154231,'Taurus'],
  [3599154231,3599371649,'Gemini'],
  [3599371649,3599583209,'Cancer'],
  [3599583209,3599787052,'Leo'],
  [3599787052,3599982370,'Virgo'],
  [3599982370,3600169157,'Libra'],
  [3600169157,3600348875,'Scorpio'],
  [3600348875,3600524936,'Sagittarius'],
  [3600524936,3600702497,'Capricorn'],
  [3600702497,3600887475,'Aquarius'],
  [3600887475,3601084693,'Pisces'],
  [3601084693,3601295063,'Aries'],
  [3601295063,3601513480,'Taurus'],
  [3601513480,3601731151,'Gemini'],
  [3601731151,3601941265,'Cancer'],
  [3601941265,3602141937,'Leo'],
  [3602141937,3602334785,'Virgo'],
  [3602334785,3602522228,'Libra'],
  [3602522228,3602706125,'Scorpio'],
  [3602706125,3602887969,'Sagittarius'],
  [3602887969,3603070051,'Capricorn'],
  [3603070051,3603256245,'Aquarius'],
  [3603256245,3603451285,'Pisces'],
  [3603451285,3603658263,'Aries'],
  [3603658263,3603875107,'Taurus'],
  [3603875107,3604093607,'Gemini'],
  [3604093607,3604304418,'Cancer'],
  [3604304418,3604503328,'Leo'],
  [3604503328,3604692190,'Virgo'],
  [3604692190,3604875690,'Libra'],
  [3604875690,3605058187,'Scorpio'],
  [3605058187,3605242188,'Sagittarius'],
  [3605242188,3605428706,'Capricorn'],
  [3605428706,3605618970,'Aquarius'],
  [3605618970,3605815590,'Pisces'],
  [3605815590,3606021543,'Aries'],
  [3606021543,3606236996,'Taurus'],
  [3606236996,3606456260,'Gemini'],
  [3606456260,3606669577,'Cancer'],
  [3606669577,3606869923,'Leo'],
  [3606869923,3607057186,'Virgo'],
  [3607057186,3607236357,'Libra'],
  [3607236357,3607413795,'Scorpio'],
  [3607413795,3607594571,'Sagittarius'],
  [3607594571,3607781244,'Capricorn'],
  [3607781244,3607974366,'Aquarius'],
  [3607974366,3608174181,'Pisces'],
  [3608174181,3608381582,'Aries'],
  [3608381582,3608596804,'Taurus'],
  [3608596804,3608816464,'Gemini'],
  [3608816464,3609032614,'Cancer'],
  [3609032614,3609236941,'Leo'],
  [3609236941,3609426483,'Virgo'],
  [3609426483,3609604557,'Libra'],
  [3609604557,3609777722,'Scorpio'],
  [3609777722,3609952789,'Sagittarius'],
  [3609952789,3610134928,'Capricorn'],
  [3610134928,3610326624,'Aquarius'],
  [3610326624,3610527880,'Pisces'],
  [3610527880,3610737405,'Aries'],
  [3610737405,3610953517,'Taurus'],
  [3610953517,3611173291,'Gemini'],
  [3611173291,3611391102,'Cancer'],
  [3611391102,3611599719,'Leo'],
  [3611599719,3611794324,'Virgo'],
  [3611794324,3611975486,'Libra'],
  [3611975486,3612148197,'Scorpio'],
  [3612148197,3612319307,'Sagittarius'],
  [3612319307,3612495550,'Capricorn'],
  [3612495550,3612682041,'Aquarius'],
  [3612682041,3612880949,'Pisces'],
  [3612880949,3613090905,'Aries'],
  [3613090905,3613308046,'Taurus'],
  [3613308046,3613527860,'Gemini'],
  [3613527860,3613745655,'Cancer'],
  [3613745655,3613956504,'Leo'],
  [3613956504,3614156120,'Virgo'],
  [3614156120,3614342998,'Libra'],
  [3614342998,3614519468,'Scorpio'],
  [3614519468,3614690773,'Sagittarius'],
  [3614690773,3614863552,'Capricorn'],
  [3614863552,3615044396,'Aquarius'],
  [3615044396,3615238126,'Pisces'],
  [3615238126,3615445591,'Aries'],
  [3615445591,3615662642,'Taurus'],
  [3615662642,3615882486,'Gemini'],
  [3615882486,3616099286,'Cancer'],
  [3616099286,3616309525,'Leo'],
  [3616309525,3616511182,'Virgo'],
  [3616511182,3616703056,'Libra'],
  [3616703056,3616885461,'Scorpio'],
  [3616885461,3617060997,'Sagittarius'],
  [3617060997,3617234582,'Capricorn'],
  [3617234582,3617412610,'Aquarius'],
  [3617412610,3617601363,'Pisces'],
  [3617601363,3617804406,'Aries'],
  [3617804406,3618019616,'Taurus'],
  [3618019616,3618239332,'Gemini'],
  [3618239332,3618455349,'Cancer'],
  [3618455349,3618663482,'Leo'],
  [3618663482,3618863507,'Virgo'],
  [3618863507,3619056490,'Libra'],
  [3619056490,3619243182,'Scorpio'],
  [3619243182,3619424408,'Sagittarius'],
  [3619424408,3619602462,'Capricorn'],
  [3619602462,3619781861,'Aquarius'],
  [3619781861,3619968573,'Pisces'],
  [3619968573,3620167718,'Aries'],
  [3620167718,3620379985,'Taurus'],
  [3620379985,3620599196,'Gemini'],
  [3620599196,3620815504,'Cancer'],
  [3620815504,3621022335,'Leo'],
  [3621022335,3621219217,'Virgo'],
  [3621219217,3621409207,'Libra'],
  [3621409207,3621595449,'Scorpio'],
  [3621595449,3621779623,'Sagittarius'],
  [3621779623,3621962639,'Capricorn'],
  [3621962639,3622146459,'Aquarius'],
  [3622146459,3622334975,'Pisces'],
  [3622334975,3622532888,'Aries'],
  [3622532888,3622742692,'Taurus'],
  [3622742692,3622961023,'Gemini'],
  [3622961023,3623178661,'Cancer'],
  [3623178661,3623386632,'Leo'],
  [3623386632,3623582133,'Virgo'],
  [3623582133,3623768188,'Libra'],
  [3623768188,3623949945,'Scorpio'],
  [3623949945,3624131713,'Sagittarius'],
  [3624131713,3624315836,'Capricorn'],
  [3624315836,3624503428,'Aquarius'],
  [3624503428,3624695945,'Pisces'],
  [3624695945,3624895789,'Aries'],
  [3624895789,3625105051,'Taurus'],
  [3625105051,3625322522,'Gemini'],
  [3625322522,3625541584,'Cancer'],
  [3625541584,3625752916,'Leo'],
  [3625752916,3625950756,'Virgo'],
  [3625950756,3626135867,'Libra'],
  [3626135867,3626313335,'Scorpio'],
  [3626313335,3626489349,'Sagittarius'],
  [3626489349,3626669093,'Capricorn'],
  [3626669093,3626855736,'Aquarius'],
  [3626855736,3627050512,'Pisces'],
  [3627050512,3627253520,'Aries'],
  [3627253520,3627464377,'Taurus'],
  [3627464377,3627681674,'Gemini'],
  [3627681674,3627901267,'Cancer'],
  [3627901267,3628116035,'Leo'],
  [3628116035,3628319053,'Virgo'],
  [3628319053,3628507852,'Libra'],
  [3628507852,3628685246,'Scorpio'],
  [3628685246,3628857192,'Sagittarius'],
  [3628857192,3629030524,'Capricorn'],
  [3629030524,3629211301,'Aquarius'],
  [3629211301,3629403339,'Pisces'],
  [3629403339,3629607098,'Aries'],
  [3629607098,3629819971,'Taurus'],
  [3629819971,3630038061,'Gemini'],
  [3630038061,3630257354,'Cancer'],
  [3630257354,3630473384,'Leo'],
  [3630473384,3630680998,'Virgo'],
  [3630680998,3630876163,'Libra'],
  [3630876163,3631058426,'Scorpio'],
  [3631058426,3631231392,'Sagittarius'],
  [3631231392,3631401446,'Capricorn'],
  [3631401446,3631575976,'Aquarius'],
  [3631575976,3631761568,'Pisces'],
  [3631761568,3631961604,'Aries'],
  [3631961604,3632174165,'Taurus'],
  [3632174165,3632393119,'Gemini'],
  [3632393119,3632612131,'Cancer'],
  [3632612131,3632827217,'Leo'],
  [3632827217,3633035896,'Virgo'],
  [3633035896,3633235652,'Libra'],
  [3633235652,3633424561,'Scorpio'],
  [3633424561,3633603113,'Sagittarius'],
  [3633603113,3633775267,'Capricorn'],
  [3633775267,3633947682,'Aquarius'],
  [3633947682,3634127910,'Pisces'],
  [3634127910,3634321960,'Aries'],
  [3634321960,3634530942,'Taurus'],
  [3634530942,3634749309,'Gemini'],
  [3634749309,3634968376,'Cancer'],
  [3634968376,3635182125,'Leo'],
  [3635182125,3635388855,'Virgo'],
  [3635388855,3635588632,'Libra'],
  [3635588632,3635781075,'Scorpio'],
  [3635781075,3635965632,'Sagittarius'],
  [3635965632,3636143480,'Capricorn'],
  [3636143480,3636318812,'Aquarius'],
  [3636318812,3636498116,'Pisces'],
  [3636498116,3636688092,'Aries'],
  [3636688092,3636892444,'Taurus'],
  [3636892444,3637108464,'Gemini'],
  [3637108464,3637327495,'Cancer'],
  [3637327495,3637540987,'Leo'],
  [3637540987,3637745562,'Virgo'],
  [3637745562,3637942268,'Libra'],
  [3637942268,3638133221,'Scorpio'],
  [3638133221,3638319625,'Sagittarius'],
  [3638319625,3638502169,'Capricorn'],
  [3638502169,3638682724,'Aquarius'],
  [3638682724,3638865297,'Pisces'],
  [3638865297,3639055247,'Aries'],
  [3639055247,3639256922,'Taurus'],
  [3639256922,3639470260,'Gemini'],
  [3639470260,3639688892,'Cancer'],
  [3639688892,3639903438,'Leo'],
  [3639903438,3640107867,'Virgo'],
  [3640107867,3640301924,'Libra'],
  [3640301924,3640488801,'Scorpio'],
  [3640488801,3640672157,'Sagittarius'],
  [3640672157,3640854687,'Capricorn'],
  [3640854687,3641038327,'Aquarius'],
  [3641038327,3641225227,'Pisces'],
  [3641225227,3641418274,'Aries'],
  [3641418274,3641620388,'Taurus'],
  [3641620388,3641832368,'Gemini'],
  [3641832368,3642050488,'Cancer'],
  [3642050488,3642266786,'Leo'],
  [3642266786,3642473520,'Virgo'],
  [3642473520,3642667807,'Libra'],
  [3642667807,3642851844,'Scorpio'],
  [3642851844,3643030395,'Sagittarius'],
  [3643030395,3643208556,'Capricorn'],
  [3643208556,3643390473,'Aquarius'],
  [3643390473,3643578866,'Pisces'],
  [3643578866,3643775124,'Aries'],
  [3643775124,3643979714,'Taurus'],
  [3643979714,3644192191,'Gemini'],
  [3644192191,3644410084,'Cancer'],
  [3644410084,3644627897,'Leo'],
  [3644627897,3644838297,'Virgo'],
  [3644838297,3645036039,'Libra'],
  [3645036039,3645220819,'Scorpio'],
  [3645220819,3645396621,'Sagittarius'],
  [3645396621,3645569609,'Capricorn'],
  [3645569609,3645746212,'Aquarius'],
  [3645746212,3645931533,'Pisces'],
  [3645931533,3646127936,'Aries'],
  [3646127936,3646334568,'Taurus'],
  [3646334568,3646548601,'Gemini'],
  [3646548601,3646766737,'Cancer'],
  [3646766737,3646985140,'Leo'],
  [3646985140,3647198598,'Virgo'],
  [3647198598,3647401413,'Libra'],
  [3647401413,3647590591,'Scorpio'],
  [3647590591,3647767744,'Sagittarius'],
  [3647767744,3647938360,'Capricorn'],
  [3647938360,3648109797,'Aquarius'],
  [3648109797,3648289300,'Pisces'],
  [3648289300,3648481795,'Aries'],
  [3648481795,3648687637,'Taurus'],
  [3648687637,3648902653,'Gemini'],
  [3648902653,3649121304,'Cancer'],
  [3649121304,3649339415,'Leo'],
  [3649339415,3649553758,'Virgo'],
  [3649553758,3649760405,'Libra'],
  [3649760405,3649955446,'Scorpio'],
  [3649955446,3650137717,'Sagittarius'],
  [3650137717,3650310406,'Capricorn'],
  [3650310406,3650480123,'Aquarius'],
  [3650480123,3650654804,'Pisces'],
  [3650654804,3650841467,'Aries'],
  [3650841467,3651043226,'Taurus'],
  [3651043226,3651257100,'Gemini'],
  [3651257100,3651475969,'Cancer'],
  [3651475969,3651693546,'Leo'],
  [3651693546,3651906732,'Virgo'],
  [3651906732,3652113829,'Libra'],
  [3652113829,3652312563,'Scorpio'],
  [3652312563,3652500828,'Sagittarius'],
  [3652500828,3652679123,'Capricorn'],
  [3652679123,3652851713,'Aquarius'],
  [3652851713,3653025507,'Pisces'],
  [3653025507,3653207983,'Aries'],
  [3653207983,3653404471,'Taurus'],
  [3653404471,3653614900,'Gemini'],
  [3653614900,3653833002,'Cancer'],
  [3653833002,3654050446,'Leo'],
  [3654050446,3654262125,'Virgo'],
  [3654262125,3654466869,'Libra'],
  [3654466869,3654664846,'Scorpio'],
  [3654664846,3654855758,'Sagittarius'],
  [3654855758,3655039481,'Capricorn'],
  [3655039481,3655217822,'Aquarius'],
  [3655217822,3655395181,'Pisces'],
  [3655395181,3655577610,'Aries'],
  [3655577610,3655770805,'Taurus'],
  [3655770805,3655977188,'Gemini'],
  [3655977188,3656193365,'Cancer'],
  [3656193365,3656411140,'Leo'],
  [3656411140,3656622799,'Virgo'],
  [3656622799,3656825286,'Libra'],
  [3656825286,3657019566,'Scorpio'],
  [3657019566,3657207960,'Sagittarius'],
  [3657207960,3657392511,'Capricorn'],
  [3657392511,3657574990,'Aquarius'],
  [3657574990,3657757712,'Pisces'],
  [3657757712,3657944012,'Aries'],
  [3657944012,3658137807,'Taurus'],
  [3658137807,3658341989,'Gemini'],
  [3658341989,3658555947,'Cancer'],
  [3658555947,3658774002,'Leo'],
  [3658774002,3658987602,'Virgo'],
  [3658987602,3659190640,'Libra'],
  [3659190640,3659382333,'Scorpio'],
  [3659382333,3659565906,'Sagittarius'],
  [3659565906,3659746061,'Capricorn'],
  [3659746061,3659927110,'Aquarius'],
  [3659927110,3660112081,'Pisces'],
  [3660112081,3660302714,'Aries'],
  [3660302714,3660500094,'Taurus'],
  [3660500094,3660705171,'Gemini'],
  [3660705171,3660918040,'Cancer'],
  [3660918040,3661135943,'Leo'],
  [3661135943,3661352187,'Virgo'],
  [3661352187,3661558912,'Libra'],
  [3661558912,3661752073,'Scorpio'],
  [3661752073,3661933295,'Sagittarius'],
  [3661933295,3662108119,'Capricorn'],
  [3662108119,3662283308,'Aquarius'],
  [3662283308,3662464685,'Pisces'],
  [3662464685,3662655465,'Aries'],
  [3662655465,3662855674,'Taurus'],
  [3662855674,3663063487,'Gemini'],
  [3663063487,3663277111,'Cancer'],
  [3663277111,3663494746,'Leo'],
  [3663494746,3663712556,'Virgo'],
  [3663712556,3663923794,'Libra'],
  [3663923794,3664122098,'Scorpio'],
  [3664122098,3664305860,'Sagittarius'],
  [3664305860,3664479131,'Capricorn'],
  [3664479131,3664649247,'Aquarius'],
  [3664649247,3664824081,'Pisces'],
  [3664824081,3665009754,'Aries'],
  [3665009754,3665208366,'Taurus'],
  [3665208366,3665417483,'Gemini'],
  [3665417483,3665632697,'Cancer'],
  [3665632697,3665850519,'Leo'],
  [3665850519,3666068303,'Virgo'],
  [3666068303,3666281950,'Libra'],
  [3666281950,3666485684,'Scorpio'],
  [3666485684,3666675464,'Sagittarius'],
  [3666675464,3666852294,'Capricorn'],
  [3666852294,3667021997,'Aquarius'],
  [3667021997,3667192594,'Pisces'],
  [3667192594,3667371862,'Aries'],
  [3667371862,3667564850,'Taurus'],
  [3667564850,3667771499,'Gemini'],
  [3667771499,3667986971,'Cancer'],
  [3667986971,3668205267,'Leo'],
  [3668205267,3668422355,'Virgo'],
  [3668422355,3668635541,'Libra'],
  [3668635541,3668841496,'Scorpio'],
  [3668841496,3669036611,'Sagittarius'],
  [3669036611,3669219673,'Capricorn'],
  [3669219673,3669393689,'Aquarius'],
  [3669393689,3669564980,'Pisces'],
  [3669564980,3669741058,'Aries'],
  [3669741058,3669928423,'Taurus'],
  [3669928423,3670129989,'Gemini'],
  [3670129989,3670343224,'Cancer'],
  [3670343224,3670561442,'Leo'],
  [3670561442,3670778121,'Virgo'],
  [3670778121,3670989573,'Libra'],
  [3670989573,3671194099,'Scorpio'],
  [3671194099,3671390463,'Sagittarius'],
  [3671390463,3671577984,'Capricorn'],
  [3671577984,3671757848,'Aquarius'],
  [3671757848,3671933765,'Pisces'],
  [3671933765,3672111307,'Aries'],
  [3672111307,3672296468,'Taurus'],
  [3672296468,3672493647,'Gemini'],
  [3672493647,3672703251,'Cancer'],
  [3672703251,3672920405,'Leo'],
  [3672920405,3673137262,'Virgo'],
  [3673137262,3673347700,'Libra'],
  [3673347700,3673549476,'Scorpio'],
  [3673549476,3673743206,'Sagittarius'],
  [3673743206,3673930580,'Capricorn'],
  [3673930580,3674113549,'Aquarius'],
  [3674113549,3674294471,'Pisces'],
  [3674294471,3674476465,'Aries'],
  [3674476465,3674663426,'Taurus'],
  [3674663426,3674859245,'Gemini'],
  [3674859245,3675066003,'Cancer'],
  [3675066003,3675281595,'Leo'],
  [3675281595,3675499077,'Virgo'],
  [3675499077,3675710281,'Libra'],
  [3675710281,3675910708,'Scorpio'],
  [3675910708,3676100879,'Sagittarius'],
  [3676100879,3676284439,'Capricorn'],
  [3676284439,3676465710,'Aquarius'],
  [3676465710,3676648158,'Pisces'],
  [3676648158,3676834013,'Aries'],
  [3676834013,3677024846,'Taurus'],
  [3677024846,3677222427,'Gemini'],
  [3677222427,3677428528,'Cancer'],
  [3677428528,3677642968,'Leo'],
  [3677642968,3677861180,'Virgo'],
  [3677861180,3678074792,'Libra'],
  [3678074792,3678276717,'Scorpio'],
  [3678276717,3678465518,'Sagittarius'],
  [3678465518,3678645042,'Capricorn'],
  [3678645042,3678821494,'Aquarius'],
  [3678821494,3679000733,'Pisces'],
  [3679000733,3679186511,'Aries'],
  [3679186511,3679379913,'Taurus'],
  [3679379913,3679580510,'Gemini'],
  [3679580510,3679788044,'Cancer'],
  [3679788044,3680002357,'Leo'],
  [3680002357,3680221041,'Virgo'],
  [3680221041,3680437499,'Libra'],
  [3680437499,3680643436,'Scorpio'],
  [3680643436,3680834566,'Sagittarius'],
  [3680834566,3681013059,'Capricorn'],
  [3681013059,3681185368,'Aquarius'],
  [3681185368,3681359042,'Pisces'],
  [3681359042,3681540313,'Aries'],
  [3681540313,3681732205,'Taurus'],
  [3681732205,3681934115,'Gemini'],
  [3681934115,3682143672,'Cancer'],
  [3682143672,3682358831,'Leo'],
  [3682358831,3682577629,'Virgo'],
  [3682577629,3682795785,'Libra'],
  [3682795785,3683006159,'Scorpio'],
  [3683006159,3683202596,'Sagittarius'],
  [3683202596,3683384367,'Capricorn'],
  [3683384367,3683556337,'Aquarius'],
  [3683556337,3683726114,'Pisces'],
  [3683726114,3683901410,'Aries'],
  [3683901410,3684087895,'Taurus'],
  [3684087895,3684287265,'Gemini'],
  [3684287265,3684497152,'Cancer'],
  [3684497152,3684713337,'Leo'],
  [3684713337,3684932130,'Virgo'],
  [3684932130,3685150150,'Libra'],
  [3685150150,3685362694,'Scorpio'],
  [3685362694,3685564377,'Sagittarius'],
  [3685564377,3685752356,'Capricorn'],
  [3685752356,3685928610,'Aquarius'],
  [3685928610,3686098995,'Pisces'],
  [3686098995,3686270949,'Aries'],
  [3686270949,3686451497,'Taurus'],
  [3686451497,3686645194,'Gemini'],
  [3686645194,3686852211,'Cancer'],
  [3686852211,3687068246,'Leo'],
  [3687068246,3687287169,'Virgo'],
  [3687287169,3687504084,'Libra'],
  [3687504084,3687715618,'Scorpio'],
  [3687715618,3687918978,'Sagittarius'],
  [3687918978,3688112060,'Capricorn'],
  [3688112060,3688294875,'Aquarius'],
  [3688294875,3688470391,'Pisces'],
  [3688470391,3688643944,'Aries'],
  [3688643944,3688821956,'Taurus'],
  [3688821956,3689010331,'Gemini'],
  [3689010331,3689212286,'Cancer'],
  [3689212286,3689426071,'Leo'],
  [3689426071,3689644988,'Virgo'],
  [3689644988,3689861376,'Libra'],
  [3689861376,3690070611,'Scorpio'],
  [3690070611,3690271581,'Sagittarius'],
  [3690271581,3690464924,'Capricorn'],
  [3690464924,3690651696,'Aquarius'],
  [3690651696,3690833362,'Pisces'],
  [3690833362,3691012415,'Aries'],
  [3691012415,3691192817,'Taurus'],
  [3691192817,3691379629,'Gemini'],
  [3691379629,3691577473,'Cancer'],
  [3691577473,3691787747,'Leo'],
  [3691787747,3692005954,'Virgo'],
  [3692005954,3692223082,'Libra'],
  [3692223082,3692431543,'Scorpio'],
  [3692431543,3692629269,'Sagittarius'],
  [3692629269,3692818717,'Capricorn'],
  [3692818717,3693003740,'Aquarius'],
  [3693003740,3693187377,'Pisces'],
  [3693187377,3693371317,'Aries'],
  [3693371317,3693556889,'Taurus'],
  [3693556889,3693746488,'Gemini'],
  [3693746488,3693943728,'Cancer'],
  [3693943728,3694151485,'Leo'],
  [3694151485,3694368381,'Virgo'],
  [3694368381,3694586875,'Libra'],
  [3694586875,3694797249,'Scorpio'],
  [3694797249,3694994480,'Sagittarius'],
  [3694994480,3695180302,'Capricorn'],
  [3695180302,3695360242,'Aquarius'],
  [3695360242,3695540075,'Pisces'],
  [3695540075,3695723623,'Aries'],
  [3695723623,3695912205,'Taurus'],
  [3695912205,3696105992,'Gemini'],
  [3696105992,3696305902,'Cancer'],
  [3696305902,3696513722,'Leo'],
  [3696513722,3696729675,'Virgo'],
  [3696729675,3696949120,'Libra'],
  [3696949120,3697162908,'Scorpio'],
  [3697162908,3697363352,'Sagittarius'],
  [3697363352,3697549423,'Capricorn'],
  [3697549423,3697725990,'Aquarius'],
  [3697725990,3697900156,'Pisces'],
  [3697900156,3698078331,'Aries'],
  [3698078331,3698264403,'Taurus'],
  [3698264403,3698459241,'Gemini'],
  [3698459241,3698662006,'Cancer'],
  [3698662006,3698871861,'Leo'],
  [3698871861,3699088042,'Virgo'],
  [3699088042,3699307683,'Libra'],
  [3699307683,3699524146,'Scorpio'],
  [3699524146,3699729532,'Sagittarius'],
  [3699729532,3699919955,'Capricorn'],
  [3699919955,3700097738,'Aquarius'],
  [3700097738,3700269222,'Pisces'],
  [3700269222,3700441768,'Aries'],
  [3700441768,3700621675,'Taurus'],
  [3700621675,3700812631,'Gemini'],
  [3700812631,3701014966,'Cancer'],
  [3701014966,3701226379,'Leo'],
  [3701226379,3701443603,'Virgo'],
  [3701443603,3701663111,'Libra'],
  [3701663111,3701880227,'Scorpio'],
  [3701880227,3702089145,'Sagittarius'],
  [3702089145,3702285288,'Capricorn'],
  [3702285288,3702468204,'Aquarius'],
  [3702468204,3702641807,'Pisces'],
  [3702641807,3702812506,'Aries'],
  [3702812506,3702987280,'Taurus'],
  [3702987280,3703172090,'Gemini'],
  [3703172090,3703370154,'Cancer'],
  [3703370154,3703580471,'Leo'],
  [3703580471,3703798264,'Virgo'],
  [3703798264,3704017698,'Libra'],
  [3704017698,3704233914,'Scorpio'],
  [3704233914,3704443250,'Sagittarius'],
  [3704443250,3704642899,'Capricorn'],
  [3704642899,3704831590,'Aquarius'],
  [3704831590,3705010661,'Pisces'],
  [3705010661,3705184120,'Aries'],
  [3705184120,3705357836,'Taurus'],
  [3705357836,3705538307,'Gemini'],
  [3705538307,3705730949,'Cancer'],
  [3705730949,3705937587,'Leo'],
  [3705937587,3706154447,'Virgo'],
  [3706154447,3706373859,'Libra'],
  [3706373859,3706588947,'Scorpio'],
  [3706588947,3706796390,'Sagittarius'],
  [3706796390,3706995660,'Capricorn'],
  [3706995660,3707187104,'Aquarius'],
  [3707187104,3707371407,'Pisces'],
  [3707371407,3707550235,'Aries'],
  [3707550235,3707727056,'Taurus'],
  [3707727056,3707907154,'Gemini'],
  [3707907154,3708096434,'Cancer'],
  [3708096434,3708298944,'Leo'],
  [3708298944,3708513533,'Virgo'],
  [3708513533,3708732805,'Libra'],
  [3708732805,3708947652,'Scorpio'],
  [3708947652,3709153105,'Sagittarius'],
  [3709153105,3709349430,'Capricorn'],
  [3709349430,3709539292,'Aquarius'],
  [3709539292,3709725070,'Pisces'],
  [3709725070,3709908126,'Aries'],
  [3709908126,3710089852,'Taurus'],
  [3710089852,3710273142,'Gemini'],
  [3710273142,3710462597,'Cancer'],
  [3710462597,3710662818,'Leo'],
  [3710662818,3710875017,'Virgo'],
  [3710875017,3711093963,'Libra'],
  [3711093963,3711309850,'Scorpio'],
  [3711309850,3711515176,'Sagittarius'],
  [3711515176,3711708949,'Capricorn'],
  [3711708949,3711894866,'Aquarius'],
  [3711894866,3712077629,'Pisces'],
  [3712077629,3712260552,'Aries'],
  [3712260552,3712445176,'Taurus'],
  [3712445176,3712632618,'Gemini'],
  [3712632618,3712825093,'Cancer'],
  [3712825093,3713025831,'Leo'],
  [3713025831,3713236833,'Virgo'],
  [3713236833,3713455386,'Libra'],
  [3713455386,3713673120,'Scorpio'],
  [3713673120,3713880864,'Sagittarius'],
  [3713880864,3714074961,'Capricorn'],
  [3714074961,3714258119,'Aquarius'],
  [3714258119,3714436088,'Pisces'],
  [3714436088,3714614529,'Aries'],
  [3714614529,3714797284,'Taurus'],
  [3714797284,3714986120,'Gemini'],
  [3714986120,3715181781,'Cancer'],
  [3715181781,3715385062,'Leo'],
  [3715385062,3715596625,'Virgo'],
  [3715596625,3715814960,'Libra'],
  [3715814960,3716034250,'Scorpio'],
  [3716034250,3716245911,'Sagittarius'],
  [3716245911,3716443862,'Capricorn'],
  [3716443862,3716628124,'Aquarius'],
  [3716628124,3716803507,'Pisces'],
  [3716803507,3716976603,'Aries'],
  [3716976603,3717153612,'Taurus'],
  [3717153612,3717338959,'Gemini'],
  [3717338959,3717534549,'Cancer'],
  [3717534549,3717739934,'Leo'],
  [3717739934,3717953231,'Virgo'],
  [3717953231,3718171798,'Libra'],
  [3718171798,3718391487,'Scorpio'],
  [3718391487,3718606183,'Sagittarius'],
  [3718606183,3718809662,'Capricorn'],
  [3718809662,3718999116,'Aquarius'],
  [3718999116,3719176619,'Pisces'],
  [3719176619,3719347695,'Aries'],
  [3719347695,3719519287,'Taurus'],
  [3719519287,3719698124,'Gemini'],
  [3719698124,3719889057,'Cancer'],
  [3719889057,3720093247,'Leo'],
  [3720093247,3720307610,'Virgo'],
  [3720307610,3720526851,'Libra'],
  [3720526851,3720746029,'Scorpio'],
  [3720746029,3720961097,'Sagittarius'],
  [3720961097,3721168172,'Capricorn'],
  [3721168172,3721363968,'Aquarius'],
  [3721363968,3721547662,'Pisces'],
  [3721547662,3721721931,'Aries'],
  [3721721931,3721892436,'Taurus'],
  [3721892436,3722066390,'Gemini'],
  [3722066390,3722250810,'Cancer'],
  [3722250810,3722450005,'Leo'],
  [3722450005,3722662733,'Virgo'],
  [3722662733,3722882295,'Libra'],
  [3722882295,3723101060,'Scorpio'],
  [3723101060,3723314543,'Sagittarius'],
  [3723314543,3723521175,'Capricorn'],
  [3723521175,3723719965,'Aquarius'],
  [3723719965,3723909780,'Pisces'],
  [3723909780,3724090621,'Aries'],
  [3724090621,3724265226,'Taurus'],
  [3724265226,3724439241,'Gemini'],
  [3724439241,3724619835,'Cancer'],
  [3724619835,3724813356,'Leo'],
  [3724813356,3725021830,'Virgo'],
  [3725021830,3725240233,'Libra'],
  [3725240233,3725459120,'Scorpio'],
  [3725459120,3725671360,'Sagittarius'],
  [3725671360,3725875244,'Capricorn'],
  [3725875244,3726072143,'Aquarius'],
  [3726072143,3726263328,'Pisces'],
  [3726263328,3726449030,'Aries'],
  [3726449030,3726629801,'Taurus'],
  [3726629801,3726808407,'Gemini'],
  [3726808407,3726990111,'Cancer'],
  [3726990111,3727181096,'Leo'],
  [3727181096,3727385429,'Virgo'],
  [3727385429,3727601316,'Libra'],
  [3727601316,3727820369,'Scorpio'],
  [3727820369,3728033131,'Sagittarius'],
  [3728033131,3728235404,'Capricorn'],
  [3728235404,3728428598,'Aquarius'],
  [3728428598,3728616251,'Pisces'],
  [3728616251,3728801185,'Aries'],
  [3728801185,3728984839,'Taurus'],
  [3728984839,3729168473,'Gemini'],
  [3729168473,3729354645,'Cancer'],
  [3729354645,3729547346,'Leo'],
  [3729547346,3729750330,'Virgo'],
  [3729750330,3729963980,'Libra'],
  [3729963980,3730182813,'Scorpio'],
  [3730182813,3730397504,'Sagittarius'],
  [3730397504,3730601116,'Capricorn'],
  [3730601116,3730792804,'Aquarius'],
  [3730792804,3730976204,'Pisces'],
  [3730976204,3731156245,'Aries'],
  [3731156245,3731337080,'Taurus'],
  [3731337080,3731521440,'Gemini'],
  [3731521440,3731711077,'Cancer'],
  [3731711077,3731907516,'Leo'],
  [3731907516,3732112212,'Virgo'],
  [3732112212,3732325365,'Libra'],
  [3732325365,3732543820,'Scorpio'],
  [3732543820,3732760546,'Sagittarius'],
  [3732760546,3732967773,'Capricorn'],
  [3732967773,3733161739,'Aquarius'],
  [3733161739,3733344060,'Pisces'],
  [3733344060,3733519759,'Aries'],
  [3733519759,3733694899,'Taurus'],
  [3733694899,3733874910,'Gemini'],
  [3733874910,3734063448,'Cancer'],
  [3734063448,3734261784,'Leo'],
  [3734261784,3734469098,'Virgo'],
  [3734469098,3734683426,'Libra'],
  [3734683426,3734901813,'Scorpio'],
  [3734901813,3735119611,'Sagittarius'],
  [3735119611,3735330584,'Capricorn'],
  [3735330584,3735529424,'Aquarius'],
  [3735529424,3735714849,'Pisces'],
  [3735714849,3735890057,'Aries'],
  [3735890057,3736061172,'Taurus'],
  [3736061172,3736235278,'Gemini'],
  [3736235278,3736418633,'Cancer'],
  [3736418633,3736614696,'Leo'],
  [3736614696,3736822663,'Virgo'],
  [3736822663,3737038390,'Libra'],
  [3737038390,3737257110,'Scorpio'],
  [3737257110,3737474839,'Sagittarius'],
  [3737474839,3737687675,'Capricorn'],
  [3737687675,3737891178,'Aquarius'],
  [3737891178,3738082196,'Pisces'],
  [3738082196,3738261136,'Aries'],
  [3738261136,3738432433,'Taurus'],
  [3738432433,3738603121,'Gemini'],
  [3738603121,3738780844,'Cancer'],
  [3738780844,3738971601,'Leo'],
  [3738971601,3739176902,'Virgo'],
  [3739176902,3739392549,'Libra'],
  [3739392549,3739611604,'Scorpio'],
  [3739611604,3739828696,'Sagittarius'],
  [3739828696,3740041023,'Capricorn'],
  [3740041023,3740246386,'Aquarius'],
  [3740246386,3740442180,'Pisces'],
  [3740442180,3740626931,'Aries'],
  [3740626931,3740802417,'Taurus'],
  [3740802417,3740973994,'Gemini'],
  [3740973994,3741149047,'Cancer'],
  [3741149047,3741334807,'Leo'],
  [3741334807,3741535377,'Virgo'],
  [3741535377,3741748775,'Libra'],
  [3741748775,3741967603,'Scorpio'],
  [3741967603,3742184233,'Sagittarius'],
  [3742184233,3742394892,'Capricorn'],
  [3742394892,3742598854,'Aquarius'],
  [3742598854,3742795750,'Pisces'],
  [3742795750,3742984695,'Aries'],
  [3742984695,3743165782,'Taurus'],
  [3743165782,3743341836,'Gemini'],
  [3743341836,3743518418,'Cancer'],
  [3743518418,3743702270,'Leo'],
  [3743702270,3743898788,'Virgo'],
  [3743898788,3744108723,'Libra'],
  [3744108723,3744326485,'Scorpio'],
  [3744326485,3744543273,'Sagittarius'],
  [3744543273,3744752946,'Capricorn'],
  [3744752946,3744954210,'Aquarius'],
  [3744954210,3745148443,'Pisces'],
  [3745148443,3745337137,'Aries'],
  [3745337137,3745521255,'Taurus'],
  [3745521255,3745702297,'Gemini'],
  [3745702297,3745883393,'Cancer'],
  [3745883393,3746069204,'Leo'],
  [3746069204,3746264518,'Virgo'],
  [3746264518,3746471665,'Libra'],
  [3746471665,3746687861,'Scorpio'],
  [3746687861,3746905355,'Sagittarius'],
  [3746905355,3747115982,'Capricorn'],
  [3747115982,3747316046,'Aquarius'],
  [3747316046,3747506670,'Pisces'],
  [3747506670,3747691273,'Aries'],
  [3747691273,3747873392,'Taurus'],
  [3747873392,3748055840,'Gemini'],
  [3748055840,3748240906,'Cancer'],
  [3748240906,3748430892,'Leo'],
  [3748430892,3748628255,'Virgo'],
  [3748628255,3748834800,'Libra'],
  [3748834800,3749049724,'Scorpio'],
  [3749049724,3749267942,'Sagittarius'],
  [3749267942,3749481331,'Capricorn'],
  [3749481331,3749683438,'Aquarius'],
  [3749683438,3749873030,'Pisces'],
  [3749873030,3750053447,'Aries'],
  [3750053447,3750230175,'Taurus'],
  [3750230175,3750408749,'Gemini'],
  [3750408749,3750593314,'Cancer'],
  [3750593314,3750785895,'Leo'],
  [3750785895,3750986651,'Virgo'],
  [3750986651,3751194933,'Libra'],
  [3751194933,3751409670,'Scorpio'],
  [3751409670,3751628114,'Sagittarius'],
  [3751628114,3751844435,'Capricorn'],
  [3751844435,3752051252,'Aquarius'],
  [3752051252,3752244132,'Pisces'],
  [3752244132,3752424128,'Aries'],
  [3752424128,3752596669,'Taurus'],
  [3752596669,3752769030,'Gemini'],
  [3752769030,3752948100,'Cancer'],
  [3752948100,3753138326,'Leo'],
  [3753138326,3753340148,'Virgo'],
  [3753340148,3753550704,'Libra'],
  [3753550704,3753766491,'Scorpio'],
  [3753766491,3753984804,'Sagittarius'],
  [3753984804,3754202367,'Capricorn'],
  [3754202367,3754413639,'Aquarius'],
  [3754413639,3754612665,'Pisces'],
  [3754612665,3754797159,'Aries'],
  [3754797159,3754970318,'Taurus'],
  [3754970318,3755139167,'Gemini'],
  [3755139167,3755311925,'Cancer'],
  [3755311925,3755495709,'Leo'],
  [3755495709,3755693855,'Virgo'],
  [3755693855,3755904206,'Libra'],
  [3755904206,3756121115,'Scorpio'],
  [3756121115,3756339523,'Sagittarius'],
  [3756339523,3756556488,'Capricorn'],
  [3756556488,3756769099,'Aquarius'],
  [3756769099,3756972969,'Pisces'],
  [3756972969,3757164226,'Aries'],
  [3757164226,3757342847,'Taurus'],
  [3757342847,3757513575,'Gemini'],
  [3757513575,3757683977,'Cancer'],
  [3757683977,3757862055,'Leo'],
  [3757862055,3758053772,'Virgo'],
  [3758053772,3758260130,'Libra'],
  [3758260130,3758476297,'Scorpio'],
  [3758476297,3758694970,'Sagittarius'],
  [3758694970,3758910986,'Capricorn'],
  [3758910986,3759122024,'Aquarius'],
  [3759122024,3759326332,'Pisces'],
  [3759326332,3759521648,'Aries'],
  [3759521648,3759706716,'Taurus'],
  [3759706716,3759883375,'Gemini'],
  [3759883375,3760056744,'Cancer'],
  [3760056744,3760233697,'Leo'],
  [3760233697,3760420808,'Virgo'],
  [3760420808,3760621749,'Libra'],
  [3760621749,3760834810,'Scorpio'],
  [3760834810,3761053122,'Sagittarius'],
  [3761053122,3761269013,'Capricorn'],
  [3761269013,3761478176,'Aquarius'],
  [3761478176,3761679679,'Pisces'],
  [3761679679,3761873906,'Aries'],
  [3761873906,3762061414,'Taurus'],
  [3762061414,3762243383,'Gemini'],
  [3762243383,3762422467,'Cancer'],
  [3762422467,3762602937,'Leo'],
  [3762602937,3762789887,'Virgo'],
  [3762789887,3762987574,'Libra'],
  [3762987574,3763197024,'Scorpio'],
  [3763197024,3763414071,'Sagittarius'],
  [3763414071,3763630655,'Capricorn'],
  [3763630655,3763839728,'Aquarius'],
  [3763839728,3764038715,'Pisces'],
  [3764038715,3764229019,'Aries'],
  [3764229019,3764413799,'Taurus'],
  [3764413799,3764596250,'Gemini'],
  [3764596250,3764779002,'Cancer'],
  [3764779002,3764964333,'Leo'],
  [3764964333,3765154698,'Virgo'],
  [3765154698,3765352788,'Libra'],
  [3765352788,3765560373,'Scorpio'],
  [3765560373,3765776009,'Sagittarius'],
  [3765776009,3765993547,'Capricorn'],
  [3765993547,3766204609,'Aquarius'],
  [3766204609,3766403828,'Pisces'],
  [3766403828,3766591358,'Aries'],
  [3766591358,3766771470,'Taurus'],
  [3766771470,3766949799,'Gemini'],
  [3766949799,3767131166,'Cancer'],
  [3767131166,3767318408,'Leo'],
  [3767318408,3767512404,'Virgo'],
  [3767512404,3767713303,'Libra'],
  [3767713303,3767921463,'Scorpio'],
  [3767921463,3768136466,'Sagittarius'],
  [3768136466,3768354722,'Capricorn'],
  [3768354722,3768568779,'Aquarius'],
  [3768568779,3768771189,'Pisces'],
  [3768771189,3768959455,'Aries'],
  [3768959455,3769136935,'Taurus'],
  [3769136935,3769310283,'Gemini'],
  [3769310283,3769486530,'Cancer'],
  [3769486530,3769670885,'Leo'],
  [3769670885,3769865241,'Virgo'],
  [3769865241,3770068470,'Libra'],
  [3770068470,3770278553,'Scorpio'],
  [3770278553,3770493971,'Sagittarius'],
  [3770493971,3770712494,'Capricorn'],
  [3770712494,3770928930,'Aquarius'],
  [3770928930,3771135860,'Pisces'],
  [3771135860,3771328297,'Aries'],
  [3771328297,3771507167,'Taurus'],
  [3771507167,3771678347,'Gemini'],
  [3771678347,3771849655,'Cancer'],
  [3771849655,3772028327,'Leo'],
  [3772028327,3772218817,'Virgo'],
  [3772218817,3772421290,'Libra'],
  [3772421290,3772632582,'Scorpio'],
  [3772632582,3772848928,'Sagittarius'],
  [3772848928,3773067399,'Capricorn'],
  [3773067399,3773284487,'Aquarius'],
  [3773284487,3773494724,'Pisces'],
  [3773494724,3773692589,'Aries'],
  [3773692589,3773876395,'Taurus'],
  [3773876395,3774049722,'Gemini'],
  [3774049722,3774219515,'Cancer'],
  [3774219515,3774393541,'Leo'],
  [3774393541,3774578248,'Virgo'],
  [3774578248,3774776530,'Libra'],
  [3774776530,3774986578,'Scorpio'],
  [3774986578,3775203346,'Sagittarius'],
  [3775203346,3775421721,'Capricorn'],
  [3775421721,3775637951,'Aquarius'],
  [3775637951,3775848562,'Pisces'],
  [3775848562,3776049834,'Aries'],
  [3776049834,3776239358,'Taurus'],
  [3776239358,3776418165,'Gemini'],
  [3776418165,3776590862,'Cancer'],
  [3776590862,3776764078,'Leo'],
  [3776764078,3776944641,'Virgo'],
  [3776944641,3777137568,'Libra'],
  [3777137568,3777343890,'Scorpio'],
  [3777343890,3777559673,'Sagittarius'],
  [3777559673,3777778056,'Capricorn'],
  [3777778056,3777993176,'Aquarius'],
  [3777993176,3778201789,'Pisces'],
  [3778201789,3778402487,'Aries'],
  [3778402487,3778594697,'Taurus'],
  [3778594697,3778778885,'Gemini'],
  [3778778885,3778957278,'Cancer'],
  [3778957278,3779133992,'Leo'],
  [3779133992,3779314415,'Virgo'],
  [3779314415,3779503945,'Libra'],
  [3779503945,3779705960,'Scorpio'],
  [3779705960,3779919344,'Sagittarius'],
  [3779919344,3780137697,'Capricorn'],
  [3780137697,3780352782,'Aquarius'],
  [3780352782,3780559395,'Pisces'],
  [3780559395,3780756794,'Aries'],
  [3780756794,3780946942,'Taurus'],
  [3780946942,3781132339,'Gemini'],
  [3781132339,3781315103,'Cancer'],
  [3781315103,3781497236,'Leo'],
  [3781497236,3781681426,'Virgo'],
  [3781681426,3781871406,'Libra'],
  [3781871406,3782071029,'Scorpio'],
  [3782071029,3782281760,'Sagittarius'],
  [3782281760,3782499760,'Capricorn'],
  [3782499760,3782716284,'Aquarius'],
  [3782716284,3782923228,'Pisces'],
  [3782923228,3783118110,'Aries'],
  [3783118110,3783303805,'Taurus'],
  [3783303805,3783485373,'Gemini'],
  [3783485373,3783667298,'Cancer'],
  [3783667298,3783852146,'Leo'],
  [3783852146,3784040882,'Virgo'],
  [3784040882,3784234468,'Libra'],
  [3784234468,3784434953,'Scorpio'],
  [3784434953,3784644408,'Sagittarius'],
  [3784644408,3784861760,'Capricorn'],
  [3784861760,3785080286,'Aquarius'],
  [3785080286,3785290385,'Pisces'],
  [3785290385,3785486400,'Aries'],
  [3785486400,3785669669,'Taurus'],
  [3785669669,3785846100,'Gemini'],
  [3785846100,3786022567,'Cancer'],
  [3786022567,3786204355,'Leo'],
  [3786204355,3786393749,'Virgo'],
  [3786393749,3786590517,'Libra'],
  [3786590517,3786793995,'Scorpio'],
  [3786793995,3787004369,'Sagittarius'],
  [3787004369,3787221356,'Capricorn'],
  [3787221356,3787441072,'Aquarius'],
  [3787441072,3787655259,'Pisces'],
  [3787655259,3787856056,'Aries'],
  [3787856056,3788041598,'Taurus'],
  [3788041598,3788216327,'Gemini'],
  [3788216327,3788387644,'Cancer'],
  [3788387644,3788562920,'Leo'],
  [3788562920,3788747419,'Virgo'],
  [3788747419,3788942902,'Libra'],
  [3788942902,3789148056,'Scorpio'],
  [3789148056,3789360446,'Sagittarius'],
  [3789360446,3789577923,'Capricorn'],
  [3789577923,3789797645,'Aquarius'],
  [3789797645,3790014129,'Pisces'],
  [3790014129,3790220301,'Aries'],
  [3790220301,3790411826,'Taurus'],
  [3790411826,3790590051,'Gemini'],
  [3790590051,3790760778,'Cancer'],
  [3790760778,3790931495,'Leo'],
  [3790931495,3791109254,'Virgo'],
  [3791109254,3791298900,'Libra'],
  [3791298900,3791501545,'Scorpio'],
  [3791501545,3791714427,'Sagittarius'],
  [3791714427,3791932796,'Capricorn'],
  [3791932796,3792152142,'Aquarius'],
  [3792152142,3792368304,'Pisces'],
  [3792368304,3792576865,'Aries'],
  [3792576865,3792774009,'Taurus'],
  [3792774009,3792958752,'Gemini'],
  [3792958752,3793133926,'Cancer'],
  [3793133926,3793305179,'Leo'],
  [3793305179,3793479332,'Virgo'],
  [3793479332,3793662818,'Libra'],
  [3793662818,3793859810,'Scorpio'],
  [3793859810,3794070059,'Sagittarius'],
  [3794070059,3794288367,'Capricorn'],
  [3794288367,3794507598,'Aquarius'],
  [3794507598,3794722300,'Pisces'],
  [3794722300,3794929654,'Aries'],
  [3794929654,3795128378,'Taurus'],
  [3795128378,3795318029,'Gemini'],
  [3795318029,3795499505,'Cancer'],
  [3795499505,3795675624,'Leo'],
  [3795675624,3795851166,'Virgo'],
  [3795851166,3796032122,'Libra'],
  [3796032122,3796224146,'Scorpio'],
  [3796224146,3796429965,'Sagittarius'],
  [3796429965,3796646566,'Capricorn'],
  [3796646566,3796865821,'Aquarius'],
  [3796865821,3797079699,'Pisces'],
  [3797079699,3797284568,'Aries'],
  [3797284568,3797480946,'Taurus'],
  [3797480946,3797670804,'Gemini'],
  [3797670804,3797855827,'Cancer'],
  [3797855827,3798037394,'Leo'],
  [3798037394,3798217663,'Virgo'],
  [3798217663,3798400498,'Libra'],
  [3798400498,3798591005,'Scorpio'],
  [3798591005,3798793394,'Sagittarius'],
  [3798793394,3799007503,'Capricorn'],
  [3799007503,3799226643,'Aquarius'],
  [3799226643,3799441085,'Pisces'],
  [3799441085,3799644789,'Aries'],
  [3799644789,3799837920,'Taurus'],
  [3799837920,3800024280,'Gemini'],
  [3800024280,3800207920,'Cancer'],
  [3800207920,3800391369,'Leo'],
  [3800391369,3800575848,'Virgo'],
  [3800575848,3800762859,'Libra'],
  [3800762859,3800955371,'Scorpio'],
  [3800955371,3801157051,'Sagittarius'],
  [3801157051,3801369389,'Capricorn'],
  [3801369389,3801588278,'Aquarius'],
  [3801588278,3801804419,'Pisces'],
  [3801804419,3802009467,'Aries'],
  [3802009467,3802201458,'Taurus'],
  [3802201458,3802384127,'Gemini'],
  [3802384127,3802563257,'Cancer'],
  [3802563257,3802743778,'Leo'],
  [3802743778,3802928451,'Virgo'],
  [3802928451,3803118306,'Libra'],
  [3803118306,3803314188,'Scorpio'],
  [3803314188,3803517644,'Sagittarius'],
  [3803517644,3803729811,'Capricorn'],
  [3803729811,3803948507,'Aquarius'],
  [3803948507,3804166551,'Pisces'],
  [3804166551,3804375003,'Aries'],
  [3804375003,3804569231,'Taurus'],
  [3804569231,3804751095,'Gemini'],
  [3804751095,3804926378,'Cancer'],
  [3804926378,3805101614,'Leo'],
  [3805101614,3805282050,'Virgo'],
  [3805282050,3805470609,'Libra'],
  [3805470609,3805668050,'Scorpio'],
  [3805668050,3805873921,'Sagittarius'],
  [3805873921,3806087296,'Capricorn'],
  [3806087296,3806306047,'Aquarius'],
  [3806306047,3806525169,'Pisces'],
  [3806525169,3806737274,'Aries'],
  [3806737274,3806936320,'Taurus'],
  [3806936320,3807121358,'Gemini'],
  [3807121358,3807296394,'Cancer'],
  [3807296394,3807467886,'Leo'],
  [3807467886,3807642582,'Virgo'],
  [3807642582,3807825988,'Libra'],
  [3807825988,3808021053,'Scorpio'],
  [3808021053,3808227460,'Sagittarius'],
  [3808227460,3808442225,'Capricorn'],
  [3808442225,3808661325,'Aquarius'],
  [3808661325,3808880332,'Pisces'],
  [3808880332,3809094220,'Aries'],
  [3809094220,3809297999,'Taurus'],
  [3809297999,3809488876,'Gemini'],
  [3809488876,3809667989,'Cancer'],
  [3809667989,3809839943,'Leo'],
  [3809839943,3810011275,'Virgo'],
  [3810011275,3810188908,'Libra'],
  [3810188908,3810378462,'Scorpio'],
  [3810378462,3810582039,'Sagittarius'],
  [3810582039,3810796734,'Capricorn'],
  [3810796734,3811016240,'Aquarius'],
  [3811016240,3811234516,'Pisces'],
  [3811234516,3811447631,'Aries'],
  [3811447631,3811653088,'Taurus'],
  [3811653088,3811848911,'Gemini'],
  [3811848911,3812034364,'Cancer'],
  [3812034364,3812211144,'Leo'],
  [3812211144,3812383759,'Virgo'],
  [3812383759,3812558725,'Libra'],
  [3812558725,3812742983,'Scorpio'],
  [3812742983,3812941426,'Sagittarius'],
  [3812941426,3813153650,'Capricorn'],
  [3813153650,3813373022,'Aquarius'],
  [3813373022,3813590934,'Pisces'],
  [3813590934,3813802156,'Aries'],
  [3813802156,3814005692,'Taurus'],
  [3814005692,3814202159,'Gemini'],
  [3814202159,3814391800,'Cancer'],
  [3814391800,3814574739,'Leo'],
  [3814574739,3814752619,'Virgo'],
  [3814752619,3814929704,'Libra'],
  [3814929704,3815112250,'Scorpio'],
  [3815112250,3815306398,'Sagittarius'],
  [3815306398,3815514705,'Capricorn'],
  [3815514705,3815732845,'Aquarius'],
  [3815732845,3815951184,'Pisces'],
  [3815951184,3816161685,'Aries'],
  [3816161685,3816362331,'Taurus'],
  [3816362331,3816555417,'Gemini'],
  [3816555417,3816743890,'Cancer'],
  [3816743890,3816929340,'Leo'],
  [3816929340,3817112411,'Virgo'],
  [3817112411,3817294712,'Libra'],
  [3817294712,3817480006,'Scorpio'],
  [3817480006,3817673431,'Sagittarius'],
  [3817673431,3817878844,'Capricorn'],
  [3817878844,3818095015,'Aquarius'],
  [3818095015,3818314063,'Pisces'],
  [3818314063,3818526114,'Aries'],
  [3818526114,3818726228,'Taurus'],
  [3818726228,3818915852,'Gemini'],
  [3818915852,3819099543,'Cancer'],
  [3819099543,3819281692,'Leo'],
  [3819281692,3819464998,'Virgo'],
  [3819464998,3819650834,'Libra'],
  [3819650834,3819840682,'Scorpio'],
  [3819840682,3820036995,'Sagittarius'],
  [3820036995,3820242415,'Capricorn'],
  [3820242415,3820457209,'Aquarius'],
  [3820457209,3820676553,'Pisces'],
  [3820676553,3820891495,'Aries'],
  [3820891495,3821094576,'Taurus'],
  [3821094576,3821284350,'Gemini'],
  [3821284350,3821464563,'Cancer'],
  [3821464563,3821641008,'Leo'],
  [3821641008,3821819160,'Virgo'],
  [3821819160,3822002925,'Libra'],
  [3822002925,3822194341,'Scorpio'],
  [3822194341,3822394023,'Sagittarius'],
  [3822394023,3822601848,'Capricorn'],
  [3822601848,3822816905,'Aquarius'],
  [3822816905,3823036126,'Pisces'],
  [3823036126,3823253341,'Aries'],
  [3823253341,3823461155,'Taurus'],
  [3823461155,3823655233,'Gemini'],
  [3823655233,3823836532,'Cancer'],
  [3823836532,3824009989,'Leo'],
  [3824009989,3824182229,'Virgo'],
  [3824182229,3824359738,'Libra'],
  [3824359738,3824547354,'Scorpio'],
  [3824547354,3824746875,'Sagittarius'],
  [3824746875,3824956681,'Capricorn'],
  [3824956681,3825173171,'Aquarius'],
  [3825173171,3825392398,'Pisces'],
  [3825392398,3825610171,'Aries'],
  [3825610171,3825821440,'Taurus'],
  [3825821440,3826021329,'Gemini'],
  [3826021329,3826207870,'Cancer'],
  [3826207870,3826383332,'Leo'],
  [3826383332,3826553428,'Virgo'],
  [3826553428,3826725488,'Libra'],
  [3826725488,3826906638,'Scorpio'],
  [3826906638,3827101584,'Sagittarius'],
  [3827101584,3827310197,'Capricorn'],
  [3827310197,3827527471,'Aquarius'],
  [3827527471,3827746988,'Pisces'],
  [3827746988,3827964113,'Aries'],
  [3827964113,3828175913,'Taurus'],
  [3828175913,3828379443,'Gemini'],
  [3828379443,3828572003,'Cancer'],
  [3828572003,3828753119,'Leo'],
  [3828753119,3828925973,'Virgo'],
  [3828925973,3829096869,'Libra'],
  [3829096869,3829273454,'Scorpio'],
  [3829273454,3829462493,'Sagittarius'],
  [3829462493,3829666789,'Capricorn'],
  [3829666789,3829882724,'Aquarius'],
  [3829882724,3830102296,'Pisces'],
  [3830102296,3830318667,'Aries'],
  [3830318667,3830528921,'Taurus'],
  [3830528921,3830732293,'Gemini'],
  [3830732293,3830927820,'Cancer'],
  [3830927820,3831114441,'Leo'],
  [3831114441,3831292889,'Virgo'],
  [3831292889,3831467059,'Libra'],
  [3831467059,3831643372,'Scorpio'],
  [3831643372,3831828875,'Sagittarius'],
  [3831828875,3832028410,'Capricorn'],
  [3832028410,3832241202,'Aquarius'],
  [3832241202,3832460097,'Pisces'],
  [3832460097,3832676291,'Aries'],
  [3832676291,3832884956,'Taurus'],
  [3832884956,3833085760,'Gemini'],
  [3833085760,3833279968,'Cancer'],
  [3833279968,3833468313,'Leo'],
  [3833468313,3833651253,'Virgo'],
  [3833651253,3833830596,'Libra'],
  [3833830596,3834010400,'Scorpio'],
  [3834010400,3834196274,'Sagittarius'],
  [3834196274,3834393302,'Capricorn'],
  [3834393302,3834602926,'Aquarius'],
  [3834602926,3834820527,'Pisces'],
  [3834820527,3835037243,'Aries'],
  [3835037243,3835245870,'Taurus'],
  [3835245870,3835444491,'Gemini'],
  [3835444491,3835635110,'Cancer'],
  [3835635110,3835820753,'Leo'],
  [3835820753,3836003862,'Virgo'],
  [3836003862,3836186382,'Libra'],
  [3836186382,3836370647,'Scorpio'],
  [3836370647,3836559880,'Sagittarius'],
  [3836559880,3836757597,'Capricorn'],
  [3836757597,3836965718,'Aquarius'],
  [3836965718,3837182057,'Pisces'],
  [3837182057,3837399672,'Aries'],
  [3837399672,3837610251,'Taurus'],
  [3837610251,3837809232,'Gemini'],
  [3837809232,3837997336,'Cancer'],
  [3837997336,3838178510,'Leo'],
  [3838178510,3838357539,'Virgo'],
  [3838357539,3838538572,'Libra'],
  [3838538572,3838724552,'Scorpio'],
  [3838724552,3838917294,'Sagittarius'],
  [3838917294,3839117864,'Capricorn'],
  [3839117864,3839326672,'Aquarius'],
  [3839326672,3839542450,'Pisces'],
  [3839542450,3839760790,'Aries'],
  [3839760790,3839974439,'Taurus'],
  [3839974439,3840176810,'Gemini'],
  [3840176810,3840365880,'Cancer'],
  [3840365880,3840544527,'Leo'],
  [3840544527,3840718505,'Virgo'],
  [3840718505,3840894264,'Libra'],
  [3840894264,3841077201,'Scorpio'],
  [3841077201,3841270217,'Sagittarius'],
  [3841270217,3841473179,'Capricorn'],
  [3841473179,3841684003,'Aquarius'],
  [3841684003,3841900176,'Pisces'],
  [3841900176,3842118688,'Aries'],
  [3842118688,3842334742,'Taurus'],
  [3842334742,3842541966,'Gemini'],
  [3842541966,3842735729,'Cancer'],
  [3842735729,3842916151,'Leo'],
  [3842916151,3843088005,'Virgo'],
  [3843088005,3843258575,'Libra'],
  [3843258575,3843435421,'Scorpio'],
  [3843435421,3843624168,'Sagittarius'],
  [3843624168,3843826199,'Capricorn'],
  [3843826199,3844038300,'Aquarius'],
  [3844038300,3844255461,'Pisces'],
  [3844255461,3844473767,'Aries'],
  [3844473767,3844690222,'Taurus'],
  [3844690222,3844900759,'Gemini'],
  [3844900759,3845100453,'Cancer'],
  [3845100453,3845286607,'Leo'],
  [3845286607,3845461239,'Virgo'],
  [3845461239,3845630544,'Libra'],
  [3845630544,3845802584,'Scorpio'],
  [3845802584,3845984992,'Sagittarius'],
  [3845984992,3846182161,'Capricorn'],
  [3846182161,3846392664,'Aquarius'],
  [3846392664,3846610272,'Pisces'],
  [3846610272,3846828521,'Aries'],
  [3846828521,3847043826,'Taurus'],
  [3847043826,3847254213,'Gemini'],
  [3847254213,3847457022,'Cancer'],
  [3847457022,3847649254,'Leo'],
  [3847649254,3847830231,'Virgo'],
  [3847830231,3848003368,'Libra'],
  [3848003368,3848175295,'Scorpio'],
  [3848175295,3848353737,'Sagittarius'],
  [3848353737,3848545040,'Capricorn'],
  [3848545040,3848751027,'Aquarius'],
  [3848751027,3848967241,'Pisces'],
  [3848967241,3849185640,'Aries'],
  [3849185640,3849400007,'Taurus'],
  [3849400007,3849608048,'Gemini'],
  [3849608048,3849809378,'Cancer'],
  [3849809378,3850003425,'Leo'],
  [3850003425,3850189613,'Virgo'],
  [3850189613,3850369066,'Libra'],
  [3850369066,3850545593,'Scorpio'],
  [3850545593,3850725018,'Sagittarius'],
  [3850725018,3850913461,'Capricorn'],
  [3850913461,3851114806,'Aquarius'],
  [3851114806,3851327917,'Pisces'],
  [3851327917,3851546072,'Aries'],
  [3851546072,3851760894,'Taurus'],
  [3851760894,3851967458,'Gemini'],
  [3851967458,3852165274,'Cancer'],
  [3852165274,3852356130,'Leo'],
  [3852356130,3852542096,'Virgo'],
  [3852542096,3852725017,'Libra'],
  [3852725017,3852907040,'Scorpio'],
  [3852907040,3853091193,'Sagittarius'],
  [3853091193,3853281316,'Capricorn'],
  [3853281316,3853480958,'Aquarius'],
  [3853480958,3853691215,'Pisces'],
  [3853691215,3853908476,'Aries'],
  [3853908476,3854124817,'Taurus'],
  [3854124817,3854332596,'Gemini'],
  [3854332596,3854528837,'Cancer'],
  [3854528837,3854715397,'Leo'],
  [3854715397,3854896635,'Virgo'],
  [3854896635,3855077143,'Libra'],
  [3855077143,3855260431,'Scorpio'],
  [3855260431,3855448593,'Sagittarius'],
  [3855448593,3855642837,'Capricorn'],
  [3855642837,3855844297,'Aquarius'],
  [3855844297,3856053834,'Pisces'],
  [3856053834,3856270190,'Aries'],
  [3856270190,3856488023,'Taurus'],
  [3856488023,3856699145,'Gemini'],
  [3856699145,3856897547,'Cancer'],
  [3856897547,3857082868,'Leo'],
  [3857082868,3857259631,'Virgo'],
  [3857259631,3857434444,'Libra'],
  [3857434444,3857613513,'Scorpio'],
  [3857613513,3857800844,'Sagittarius'],
  [3857800844,3857997356,'Capricorn'],
  [3857997356,3858201822,'Aquarius'],
  [3858201822,3858412802,'Pisces'],
  [3858412802,3858629049,'Aries'],
  [3858629049,3858847609,'Taurus'],
  [3858847609,3859062148,'Gemini'],
  [3859062148,3859265317,'Cancer'],
  [3859265317,3859453698,'Leo'],
  [3859453698,3859629898,'Virgo'],
  [3859629898,3859800618,'Libra'],
  [3859800618,3859973679,'Scorpio'],
  [3859973679,3860155675,'Sagittarius'],
  [3860155675,3860349830,'Capricorn'],
  [3860349830,3860555060,'Aquarius'],
  [3860555060,3860767796,'Pisces'],
  [3860767796,3860984754,'Aries'],
  [3860984754,3861203340,'Taurus'],
  [3861203340,3861419557,'Gemini'],
  [3861419557,3861627243,'Cancer'],
  [3861627243,3861821235,'Leo'],
  [3861821235,3862001250,'Virgo'],
  [3862001250,3862172256,'Libra'],
  [3862172256,3862341928,'Scorpio'],
  [3862341928,3862518116,'Sagittarius'],
  [3862518116,3862706586,'Capricorn'],
  [3862706586,3862908757,'Aquarius'],
  [3862908757,3863121333,'Pisces'],
  [3863121333,3863338959,'Aries'],
  [3863338959,3863557323,'Taurus'],
  [3863557323,3863773195,'Gemini'],
  [3863773195,3863982687,'Cancer'],
  [3863982687,3864181444,'Leo'],
  [3864181444,3864367372,'Virgo'],
  [3864367372,3864542763,'Libra'],
  [3864542763,3864713535,'Scorpio'],
  [3864713535,3864887107,'Sagittarius'],
  [3864887107,3865070328,'Capricorn'],
  [3865070328,3865267212,'Aquarius'],
  [3865267212,3865476948,'Pisces'],
  [3865476948,3865694179,'Aries'],
  [3865694179,3865912384,'Taurus'],
  [3865912384,3866126994,'Gemini'],
  [3866126994,3866335301,'Cancer'],
  [3866335301,3866535255,'Leo'],
  [3866535255,3866725484,'Virgo'],
  [3866725484,3866906638,'Libra'],
  [3866906638,3867082116,'Scorpio'],
  [3867082116,3867257406,'Sagittarius'],
  [3867257406,3867438720,'Capricorn'],
  [3867438720,3867631221,'Aquarius'],
  [3867631221,3867836791,'Pisces'],
  [3867836791,3868052257,'Aries'],
  [3868052257,3868270403,'Taurus'],
  [3868270403,3868484270,'Gemini'],
  [3868484270,3868690249,'Cancer'],
  [3868690249,3868887864,'Leo'],
  [3868887864,3869078126,'Virgo'],
  [3869078126,3869262548,'Libra'],
  [3869262548,3869443226,'Scorpio'],
  [3869443226,3869623213,'Sagittarius'],
  [3869623213,3869806586,'Capricorn'],
  [3869806586,3869997825,'Aquarius'],
  [3869997825,3870200193,'Pisces'],
  [3870200193,3870413269,'Aries'],
  [3870413269,3870631345,'Taurus'],
  [3870631345,3870845865,'Gemini'],
  [3870845865,3871050767,'Cancer'],
  [3871050767,3871245123,'Leo'],
  [3871245123,3871431773,'Virgo'],
  [3871431773,3871614681,'Libra'],
  [3871614681,3871797154,'Scorpio'],
  [3871797154,3871981374,'Sagittarius'],
  [3871981374,3872169058,'Capricorn'],
  [3872169058,3872362416,'Aquarius'],
  [3872362416,3872564118,'Pisces'],
  [3872564118,3872775437,'Aries'],
  [3872775437,3872993330,'Taurus'],
  [3872993330,3873209773,'Gemini'],
  [3873209773,3873416292,'Cancer'],
  [3873416292,3873609593,'Leo'],
  [3873609593,3873792384,'Virgo'],
  [3873792384,3873970470,'Libra'],
  [3873970470,3874149695,'Scorpio'],
  [3874149695,3874333945,'Sagittarius'],
  [3874333945,3874524551,'Capricorn'],
  [3874524551,3874721477,'Aquarius'],
  [3874721477,3874925075,'Pisces'],
  [3874925075,3875136197,'Aries'],
  [3875136197,3875353830,'Taurus'],
  [3875353830,3875572332,'Gemini'],
  [3875572332,3875782744,'Cancer'],
  [3875782744,3875978826,'Leo'],
  [3875978826,3876161061,'Virgo'],
  [3876161061,3876335179,'Libra'],
  [3876335179,3876508654,'Scorpio'],
  [3876508654,3876688005,'Sagittarius'],
  [3876688005,3876876822,'Capricorn'],
  [3876876822,3877075191,'Aquarius'],
  [3877075191,3877281361,'Pisces'],
  [3877281361,3877493837,'Aries'],
  [3877493837,3877711430,'Taurus'],
  [3877711430,3877930825,'Gemini'],
  [3877930825,3878145055,'Cancer'],
  [3878145055,3878346659,'Leo'],
  [3878346659,3878532951,'Virgo'],
  [3878532951,3878707489,'Libra'],
  [3878707489,3878877444,'Scorpio'],
  [3878877444,3879050636,'Sagittarius'],
  [3879050636,3879233359,'Capricorn'],
  [3879233359,3879428456,'Aquarius'],
  [3879428456,3879634761,'Pisces'],
  [3879634761,3879848739,'Aries'],
  [3879848739,3880066818,'Taurus'],
  [3880066818,3880285811,'Gemini'],
  [3880285811,3880501297,'Cancer'],
  [3880501297,3880707532,'Leo'],
  [3880707532,3880900334,'Virgo'],
  [3880900334,3881080105,'Libra'],
  [3881080105,3881251716,'Scorpio'],
  [3881251716,3881422285,'Sagittarius'],
  [3881422285,3881599097,'Capricorn'],
  [3881599097,3881787737,'Aquarius'],
  [3881787737,3881990118,'Pisces'],
  [3881990118,3882203518,'Aries'],
  [3882203518,3882422177,'Taurus'],
  [3882422177,3882640566,'Gemini'],
  [3882640566,3882854724,'Cancer'],
  [3882854724,3883061601,'Leo'],
  [3883061601,3883258682,'Virgo'],
  [3883258682,3883445070,'Libra'],
  [3883445070,3883622654,'Scorpio'],
  [3883622654,3883796001,'Sagittarius'],
  [3883796001,3883971294,'Capricorn'],
  [3883971294,3884154908,'Aquarius'],
  [3884154908,3884351500,'Pisces'],
  [3884351500,3884561487,'Aries'],
  [3884561487,3884779695,'Taurus'],
  [3884779695,3884998101,'Gemini'],
  [3884998101,3885210592,'Cancer'],
  [3885210592,3885414897,'Leo'],
  [3885414897,3885611242,'Virgo'],
  [3885611242,3885800524,'Libra'],
  [3885800524,3885983869,'Scorpio'],
  [3885983869,3886163194,'Sagittarius'],
  [3886163194,3886341944,'Capricorn'],
  [3886341944,3886525106,'Aquarius'],
  [3886525106,3886718011,'Pisces'],
  [3886718011,3886923796,'Aries'],
  [3886923796,3887140168,'Taurus'],
  [3887140168,3887358998,'Gemini'],
  [3887358998,3887571404,'Cancer'],
  [3887571404,3887773299,'Leo'],
  [3887773299,3887965910,'Virgo'],
  [3887965910,3888152766,'Libra'],
  [3888152766,3888337018,'Scorpio'],
  [3888337018,3888520496,'Sagittarius'],
  [3888520496,3888704471,'Capricorn'],
  [3888704471,3888891200,'Aquarius'],
  [3888891200,3889084465,'Pisces'],
  [3889084465,3889288040,'Aries'],
  [3889288040,3889502332,'Taurus'],
  [3889502332,3889721476,'Gemini'],
  [3889721476,3889935589,'Cancer'],
  [3889935589,3890137714,'Leo'],
  [3890137714,3890327660,'Virgo'],
  [3890327660,3890509978,'Libra'],
  [3890509978,3890690247,'Scorpio'],
  [3890690247,3890872571,'Sagittarius'],
  [3890872571,3891058785,'Capricorn'],
  [3891058785,3891249504,'Aquarius'],
  [3891249504,3891445925,'Pisces'],
  [3891445925,3891650245,'Aries'],
  [3891650245,3891863640,'Taurus'],
  [3891863640,3892082863,'Gemini'],
  [3892082863,3892299429,'Cancer'],
  [3892299429,3892504580,'Leo'],
  [3892504580,3892695360,'Virgo'],
  [3892695360,3892875201,'Libra'],
  [3892875201,3893050549,'Scorpio'],
  [3893050549,3893227731,'Sagittarius'],
  [3893227731,3893411068,'Capricorn'],
  [3893411068,3893602261,'Aquarius'],
  [3893602261,3893801321,'Pisces'],
  [3893801321,3894008010,'Aries'],
  [3894008010,3894222071,'Taurus'],
  [3894222071,3894441339,'Gemini'],
  [3894441339,3894659758,'Cancer'],
  [3894659758,3894869068,'Leo'],
  [3894869068,3895063995,'Virgo'],
  [3895063995,3895245405,'Libra'],
  [3895245405,3895418734,'Scorpio'],
  [3895418734,3895590969,'Sagittarius'],
  [3895590969,3895768501,'Capricorn'],
  [3895768501,3895955661,'Aquarius'],
  [3895955661,3896153902,'Pisces'],
  [3896153902,3896362040,'Aries'],
  [3896362040,3896577461,'Taurus'],
  [3896577461,3896796926,'Gemini'],
  [3896796926,3897015843,'Cancer'],
  [3897015843,3897228128,'Leo'],
  [3897228128,3897428297,'Virgo'],
  [3897428297,3897614696,'Libra'],
  [3897614696,3897790321,'Scorpio'],
  [3897790321,3897961108,'Sagittarius'],
  [3897961108,3898133946,'Capricorn'],
  [3898133946,3898315154,'Aquarius'],
  [3898315154,3898508895,'Pisces'],
  [3898508895,3898715576,'Aries'],
  [3898715576,3898931558,'Taurus'],
  [3898931558,3899151301,'Gemini'],
  [3899151301,3899369632,'Cancer'],
  [3899369632,3899582311,'Leo'],
  [3899582311,3899785796,'Virgo'],
  [3899785796,3899977868,'Libra'],
  [3899977868,3900159010,'Scorpio'],
  [3900159010,3900332719,'Sagittarius'],
  [3900332719,3900504722,'Capricorn'],
  [3900504722,3900681741,'Aquarius'],
  [3900681741,3900869904,'Pisces'],
  [3900869904,3901072391,'Aries'],
  [3901072391,3901287002,'Taurus'],
  [3901287002,3901506768,'Gemini'],
  [3901506768,3901724331,'Cancer'],
  [3901724331,3901935402,'Leo'],
  [3901935402,3902138594,'Virgo'],
  [3902138594,3902333513,'Libra'],
  [3902333513,3902520117,'Scorpio'],
  [3902520117,3902699512,'Sagittarius'],
  [3902699512,3902874923,'Capricorn'],
  [3902874923,3903051759,'Aquarius'],
  [3903051759,3903236475,'Pisces'],
  [3903236475,3903434294,'Aries'],
  [3903434294,3903645814,'Taurus'],
  [3903645814,3903864970,'Gemini'],
  [3903864970,3904082406,'Cancer'],
  [3904082406,3904291818,'Leo'],
  [3904291818,3904492247,'Virgo'],
  [3904492247,3904685637,'Libra'],
  [3904685637,3904873874,'Scorpio'],
  [3904873874,3905057885,'Sagittarius'],
  [3905057885,3905238742,'Capricorn'],
  [3905238742,3905419289,'Aquarius'],
  [3905419289,3905604464,'Pisces'],
  [3905604464,3905799765,'Aries'],
  [3905799765,3906008053,'Taurus'],
  [3906008053,3906225934,'Gemini'],
  [3906225934,3906444086,'Cancer'],
  [3906444086,3906653647,'Leo'],
  [3906653647,3906851854,'Virgo'],
  [3906851854,3907041348,'Libra'],
  [3907041348,3907226424,'Scorpio'],
  [3907226424,3907410256,'Sagittarius'],
  [3907410256,3907594291,'Capricorn'],
  [3907594291,3907779592,'Aquarius'],
  [3907779592,3907968494,'Pisces'],
  [3907968494,3908164730,'Aries'],
  [3908164730,3908371506,'Taurus'],
  [3908371506,3908587988,'Gemini'],
  [3908587988,3908807133,'Cancer'],
  [3908807133,3909019114,'Leo'],
  [3909019114,3909218203,'Virgo'],
  [3909218203,3909405395,'Libra'],
  [3909405395,3909585691,'Scorpio'],
  [3909585691,3909764658,'Sagittarius'],
  [3909764658,3909946387,'Capricorn'],
  [3909946387,3910132995,'Aquarius'],
  [3910132995,3910325524,'Pisces'],
  [3910325524,3910525076,'Aries'],
  [3910525076,3910732902,'Taurus'],
  [3910732902,3910948751,'Gemini'],
  [3910948751,3911168370,'Cancer'],
  [3911168370,3911383606,'Leo'],
  [3911383606,3911586896,'Virgo'],
  [3911586896,3911776073,'Libra'],
  [3911776073,3911954517,'Scorpio'],
  [3911954517,3912128330,'Sagittarius'],
  [3912128330,3912303873,'Capricorn'],
  [3912303873,3912486200,'Aquarius'],
  [3912486200,3912678090,'Pisces'],
  [3912678090,3912879875,'Aries'],
  [3912879875,3913090141,'Taurus'],
  [3913090141,3913306668,'Gemini'],
  [3913306668,3913526134,'Cancer'],
  [3913526134,3913743242,'Leo'],
  [3913743242,3913951474,'Virgo'],
  [3913951474,3914146333,'Libra'],
  [3914146333,3914327985,'Scorpio'],
  [3914327985,3914500825,'Sagittarius'],
  [3914500825,3914671507,'Capricorn'],
  [3914671507,3914847103,'Aquarius'],
  [3914847103,3915033426,'Pisces'],
  [3915033426,3915233086,'Aries'],
  [3915233086,3915444268,'Taurus'],
  [3915444268,3915662075,'Gemini'],
  [3915662075,3915881411,'Cancer'],
  [3915881411,3916098245,'Leo'],
  [3916098245,3916308821,'Virgo'],
  [3916308821,3916509292,'Libra'],
  [3916509292,3916697455,'Scorpio'],
  [3916697455,3916874535,'Sagittarius'],
  [3916874535,3917045355,'Capricorn'],
  [3917045355,3917216989,'Aquarius'],
  [3917216989,3917396927,'Pisces'],
  [3917396927,3917590781,'Aries'],
  [3917590781,3917799282,'Taurus'],
  [3917799282,3918017170,'Gemini'],
  [3918017170,3918236688,'Cancer'],
  [3918236688,3918452357,'Leo'],
  [3918452357,3918661938,'Virgo'],
  [3918661938,3918864176,'Libra'],
  [3918864176,3919057504,'Scorpio'],
  [3919057504,3919241096,'Sagittarius'],
  [3919241096,3919416770,'Capricorn'],
  [3919416770,3919589631,'Aquarius'],
  [3919589631,3919766817,'Pisces'],
  [3919766817,3919955332,'Aries'],
  [3919955332,3920158881,'Taurus'],
  [3920158881,3920374633,'Gemini'],
  [3920374633,3920594112,'Cancer'],
  [3920594112,3920809206,'Leo'],
  [3920809206,3921016615,'Virgo'],
  [3921016615,3921216733,'Libra'],
  [3921216733,3921410479,'Scorpio'],
  [3921410479,3921597930,'Sagittarius'],
  [3921597930,3921779369,'Capricorn'],
  [3921779369,3921957180,'Aquarius'],
  [3921957180,3922136379,'Pisces'],
  [3922136379,3922323304,'Aries'],
  [3922323304,3922522969,'Taurus'],
  [3922522969,3922735487,'Gemini'],
  [3922735487,3922954267,'Cancer'],
  [3922954267,3923169831,'Leo'],
  [3923169831,3923376323,'Virgo'],
  [3923376323,3923573460,'Libra'],
  [3923573460,3923763851,'Scorpio'],
  [3923763851,3923950056,'Sagittarius'],
  [3923950056,3924133617,'Capricorn'],
  [3924133617,3924315957,'Aquarius'],
  [3924315957,3924499703,'Pisces'],
  [3924499703,3924688945,'Aries'],
  [3924688945,3924887898,'Taurus'],
  [3924887898,3925098148,'Gemini'],
  [3925098148,3925315895,'Cancer'],
  [3925315895,3925532633,'Leo'],
  [3925532633,3925740443,'Virgo'],
  [3925740443,3925936669,'Libra'],
  [3925936669,3926123538,'Scorpio'],
  [3926123538,3926305299,'Sagittarius'],
  [3926305299,3926486003,'Capricorn'],
  [3926486003,3926668674,'Aquarius'],
  [3926668674,3926855524,'Pisces'],
  [3926855524,3927048529,'Aries'],
  [3927048529,3927249602,'Taurus'],
  [3927249602,3927459681,'Gemini'],
  [3927459681,3927676746,'Cancer'],
  [3927676746,3927894709,'Leo'],
  [3927894709,3928105541,'Virgo'],
  [3928105541,3928304015,'Libra'],
  [3928304015,3928490218,'Scorpio'],
  [3928490218,3928668214,'Sagittarius'],
  [3928668214,3928843693,'Capricorn'],
  [3928843693,3929022167,'Aquarius'],
  [3929022167,3929207763,'Pisces'],
  [3929207763,3929402492,'Aries'],
  [3929402492,3929606305,'Taurus'],
  [3929606305,3929817907,'Gemini'],
  [3929817907,3930035044,'Cancer'],
  [3930035044,3930253694,'Leo'],
  [3930253694,3930467675,'Virgo'],
  [3930467675,3930670692,'Libra'],
  [3930670692,3930860019,'Scorpio'],
  [3930860019,3931037776,'Sagittarius'],
  [3931037776,3931209571,'Capricorn'],
  [3931209571,3931382418,'Aquarius'],
  [3931382418,3931562877,'Pisces'],
  [3931562877,3931755162,'Aries'],
  [3931755162,3931959538,'Taurus'],
  [3931959538,3932172765,'Gemini'],
  [3932172765,3932390580,'Cancer'],
  [3932390580,3932609242,'Leo'],
  [3932609242,3932824817,'Virgo'],
  [3932824817,3933032258,'Libra'],
  [3933032258,3933227191,'Scorpio'],
  [3933227191,3933408857,'Sagittarius'],
  [3933408857,3933581038,'Capricorn'],
  [3933581038,3933750612,'Aquarius'],
  [3933750612,3933925427,'Pisces'],
  [3933925427,3934112134,'Aries'],
  [3934112134,3934313442,'Taurus'],
  [3934313442,3934526455,'Gemini'],
  [3934526455,3934744874,'Cancer'],
  [3934744874,3934963228,'Leo'],
  [3934963228,3935178353,'Virgo'],
  [3935178353,3935387548,'Libra'],
  [3935387548,3935587343,'Scorpio'],
  [3935587343,3935775171,'Sagittarius'],
  [3935775171,3935951965,'Capricorn'],
  [3935951965,3936122744,'Aquarius'],
  [3936122744,3936294976,'Pisces'],
  [3936294976,3936476401,'Aries'],
  [3936476401,3936672301,'Taurus'],
  [3936672301,3936882363,'Gemini'],
  [3936882363,3937100364,'Cancer'],
  [3937100364,3937318548,'Leo'],
  [3937318548,3937532285,'Virgo'],
  [3937532285,3937740065,'Libra'],
  [3937740065,3937940876,'Scorpio'],
  [3937940876,3938133106,'Sagittarius'],
  [3938133106,3938316061,'Capricorn'],
  [3938316061,3938492003,'Aquarius'],
  [3938492003,3938666321,'Pisces'],
  [3938666321,3938846009,'Aries'],
  [3938846009,3939037385,'Taurus'],
  [3939037385,3939242959,'Gemini'],
  [3939242959,3939459008,'Cancer'],
  [3939459008,3939677234,'Leo'],
  [3939677234,3939890377,'Virgo'],
  [3939890377,3940095707,'Libra'],
  [3940095707,3940293701,'Scorpio'],
  [3940293701,3940485400,'Sagittarius'],
  [3940485400,3940671423,'Capricorn'],
  [3940671423,3940852874,'Aquarius'],
  [3940852874,3941032540,'Pisces'],
  [3941032540,3941214996,'Aries'],
  [3941214996,3941405480,'Taurus'],
  [3941405480,3941607687,'Gemini'],
  [3941607687,3941820950,'Cancer'],
  [3941820950,3942039041,'Leo'],
  [3942039041,3942253277,'Virgo'],
  [3942253277,3942458025,'Libra'],
  [3942458025,3942652749,'Scorpio'],
  [3942652749,3942840121,'Sagittarius'],
  [3942840121,3943023584,'Capricorn'],
  [3943023584,3943206071,'Aquarius'],
  [3943206071,3943389899,'Pisces'],
  [3943389899,3943577285,'Aries'],
  [3943577285,3943770751,'Taurus'],
  [3943770751,3943972753,'Gemini'],
  [3943972753,3944184077,'Cancer'],
  [3944184077,3944401609,'Leo'],
  [3944401609,3944617953,'Virgo'],
  [3944617953,3944825203,'Libra'],
  [3944825203,3945019817,'Scorpio'],
  [3945019817,3945203604,'Sagittarius'],
  [3945203604,3945381594,'Capricorn'],
  [3945381594,3945559534,'Aquarius'],
  [3945559534,3945742075,'Pisces'],
  [3945742075,3945931762,'Aries'],
  [3945931762,3946129099,'Taurus'],
  [3946129099,3946333714,'Gemini'],
  [3946333714,3946545209,'Cancer'],
  [3946545209,3946762173,'Leo'],
  [3946762173,3946980129,'Virgo'],
  [3946980129,3947191564,'Libra'],
  [3947191564,3947390104,'Scorpio'],
  [3947390104,3947574621,'Sagittarius'],
  [3947574621,3947749371,'Capricorn'],
  [3947749371,3947921417,'Aquarius'],
  [3947921417,3948097994,'Pisces'],
  [3948097994,3948284368,'Aries'],
  [3948284368,3948482089,'Taurus'],
  [3948482089,3948689153,'Gemini'],
  [3948689153,3948902421,'Cancer'],
  [3948902421,3949119490,'Leo'],
  [3949119490,3949337773,'Virgo'],
  [3949337773,3949552295,'Libra'],
  [3949552295,3949756397,'Scorpio'],
  [3949756397,3949945959,'Sagittarius'],
  [3949945959,3950122482,'Capricorn'],
  [3950122482,3950292198,'Aquarius'],
  [3950292198,3950463214,'Pisces'],
  [3950463214,3950643065,'Aries'],
  [3950643065,3950836263,'Taurus'],
  [3950836263,3951042315,'Gemini'],
  [3951042315,3951256717,'Cancer'],
  [3951256717,3951474495,'Leo'],
  [3951474495,3951692360,'Virgo'],
  [3951692360,3951907342,'Libra'],
  [3951907342,3952114951,'Scorpio'],
  [3952114951,3952310530,'Sagittarius'],
  [3952310530,3952492747,'Capricorn'],
  [3952492747,3952665245,'Aquarius'],
  [3952665245,3952835069,'Pisces'],
  [3952835069,3953010177,'Aries'],
  [3953010177,3953197146,'Taurus'],
  [3953197146,3953398545,'Gemini'],
  [3953398545,3953611470,'Cancer'],
  [3953611470,3953829540,'Leo'],
  [3953829540,3954047062,'Virgo'],
  [3954047062,3954260741,'Libra'],
  [3954260741,3954468185,'Scorpio'],
  [3954468185,3954666732,'Sagittarius'],
  [3954666732,3954854589,'Capricorn'],
  [3954854589,3955032910,'Aquarius'],
  [3955032910,3955206236,'Pisces'],
  [3955206236,3955381149,'Aries'],
  [3955381149,3955564376,'Taurus'],
  [3955564376,3955760541,'Gemini'],
  [3955760541,3955969750,'Cancer'],
  [3955969750,3956186848,'Leo'],
  [3956186848,3956404353,'Virgo'],
  [3956404353,3956616784,'Libra'],
  [3956616784,3956821851,'Scorpio'],
  [3956821851,3957019116,'Sagittarius'],
  [3957019116,3957208763,'Capricorn'],
  [3957208763,3957391755,'Aquarius'],
  [3957391755,3957570543,'Pisces'],
  [3957570543,3957749227,'Aries'],
  [3957749227,3957932923,'Taurus'],
  [3957932923,3958126382,'Gemini'],
  [3958126382,3958331886,'Cancer'],
  [3958331886,3958547032,'Leo'],
  [3958547032,3958764730,'Virgo'],
  [3958764730,3958977225,'Libra'],
  [3958977225,3959180352,'Scorpio'],
  [3959180352,3959374198,'Sagittarius'],
  [3959374198,3959561258,'Capricorn'],
  [3959561258,3959744525,'Aquarius'],
  [3959744525,3959926653,'Pisces'],
  [3959926653,3960110042,'Aries'],
  [3960110042,3960297329,'Taurus'],
  [3960297329,3960491585,'Gemini'],
  [3960491585,3960695412,'Cancer'],
  [3960695412,3960908736,'Leo'],
  [3960908736,3961126674,'Virgo'],
  [3961126674,3961340790,'Libra'],
  [3961340790,3961544301,'Scorpio'],
  [3961544301,3961735809,'Sagittarius'],
  [3961735809,3961918630,'Capricorn'],
  [3961918630,3962098023,'Aquarius'],
  [3962098023,3962278801,'Pisces'],
  [3962278801,3962464027,'Aries'],
  [3962464027,3962654978,'Taurus'],
  [3962654978,3962852290,'Gemini'],
  [3962852290,3963056971,'Cancer'],
  [3963056971,3963269591,'Leo'],
  [3963269591,3963487694,'Virgo'],
  [3963487694,3963704249,'Libra'],
  [3963704249,3963910796,'Scorpio'],
  [3963910796,3964103213,'Sagittarius'],
  [3964103213,3964283677,'Capricorn'],
  [3964283677,3964458322,'Aquarius'],
  [3964458322,3964634094,'Pisces'],
  [3964634094,3964816423,'Aries'],
  [3964816423,3965007713,'Taurus'],
  [3965007713,3965207515,'Gemini'],
  [3965207515,3965414469,'Cancer'],
  [3965414469,3965627743,'Leo'],
  [3965627743,3965845931,'Virgo'],
  [3965845931,3966064401,'Libra'],
  [3966064401,3966275245,'Scorpio'],
  [3966275245,3966471984,'Sagittarius'],
  [3966471984,3966654117,'Capricorn'],
  [3966654117,3966826789,'Aquarius'],
  [3966826789,3966997645,'Pisces'],
  [3966997645,3967174114,'Aries'],
  [3967174114,3967361238,'Taurus'],
  [3967361238,3967560096,'Gemini'],
  [3967560096,3967768426,'Cancer'],
  [3967768426,3967983037,'Leo'],
  [3967983037,3968201375,'Virgo'],
  [3968201375,3968420288,'Libra'],
  [3968420288,3968634168,'Scorpio'],
  [3968634168,3968836467,'Sagittarius'],
  [3968836467,3969024023,'Capricorn'],
  [3969024023,3969199346,'Aquarius'],
  [3969199346,3969368968,'Pisces'],
  [3969368968,3969540712,'Aries'],
  [3969540712,3969721553,'Taurus'],
  [3969721553,3969915499,'Gemini'],
  [3969915499,3970122105,'Cancer'],
  [3970122105,3970337253,'Leo'],
  [3970337253,3970555914,'Virgo'],
  [3970555914,3970774102,'Libra'],
  [3970774102,3970988089,'Scorpio'],
  [3970988089,3971193600,'Sagittarius'],
  [3971193600,3971387197,'Capricorn'],
  [3971387197,3971568744,'Aquarius'],
  [3971568744,3971742065,'Pisces'],
  [3971742065,3971913525,'Aries'],
  [3971913525,3972090197,'Taurus'],
  [3972090197,3972278059,'Gemini'],
  [3972278059,3972479827,'Cancer'],
  [3972479827,3972693270,'Leo'],
  [3972693270,3972912068,'Virgo'],
  [3972912068,3973129604,'Libra'],
  [3973129604,3973341663,'Scorpio'],
  [3973341663,3973546188,'Sagittarius'],
  [3973546188,3973742119,'Capricorn'],
  [3973742119,3973929258,'Aquarius'],
  [3973929258,3974109057,'Pisces'],
  [3974109057,3974285027,'Aries'],
  [3974285027,3974462374,'Taurus'],
  [3974462374,3974646977,'Gemini'],
  [3974646977,3974843612,'Cancer'],
  [3974843612,3975053316,'Leo'],
  [3975053316,3975271333,'Virgo'],
  [3975271333,3975489127,'Libra'],
  [3975489127,3975699800,'Scorpio'],
  [3975699800,3975901145,'Sagittarius'],
  [3975901145,3976094495,'Capricorn'],
  [3976094495,3976282189,'Aquarius'],
  [3976282189,3976466173,'Pisces'],
  [3976466173,3976648085,'Aries'],
  [3976648085,3976830216,'Taurus'],
  [3976830216,3977016263,'Gemini'],
  [3977016263,3977210786,'Cancer'],
  [3977210786,3977416969,'Leo'],
  [3977416969,3977633237,'Virgo'],
  [3977633237,3977851876,'Libra'],
  [3977851876,3978063433,'Scorpio'],
  [3978063433,3978263137,'Sagittarius'],
  [3978263137,3978452401,'Capricorn'],
  [3978452401,3978635875,'Aquarius'],
  [3978635875,3978818184,'Pisces'],
  [3978818184,3979002167,'Aries'],
  [3979002167,3979188914,'Taurus'],
  [3979188914,3979379361,'Gemini'],
  [3979379361,3979575723,'Cancer'],
  [3979575723,3979780898,'Leo'],
  [3979780898,3979995557,'Virgo'],
  [3979995557,3980214813,'Libra'],
  [3980214813,3980429095,'Scorpio'],
  [3980429095,3980630662,'Sagittarius'],
  [3980630662,3980818609,'Capricorn'],
  [3980818609,3980997696,'Aquarius'],
  [3980997696,3981174558,'Pisces'],
  [3981174558,3981354781,'Aries'],
  [3981354781,3981541315,'Taurus'],
  [3981541315,3981734616,'Gemini'],
  [3981734616,3981934451,'Cancer'],
  [3981934451,3982141341,'Leo'],
  [3982141341,3982355741,'Virgo'],
  [3982355741,3982575098,'Libra'],
  [3982575098,3982792095,'Scorpio'],
  [3982792095,3982998034,'Sagittarius'],
  [3982998034,3983188930,'Capricorn'],
  [3983188930,3983367464,'Aquarius'],
  [3983367464,3983540216,'Pisces'],
  [3983540216,3983714412,'Aries'],
  [3983714412,3983895737,'Taurus'],
  [3983895737,3984086973,'Gemini'],
  [3984086973,3984287993,'Cancer'],
  [3984287993,3984497159,'Leo'],
  [3984497159,3984712649,'Virgo'],
  [3984712649,3984931963,'Libra'],
  [3984931963,3985150155,'Scorpio'],
  [3985150155,3985360168,'Sagittarius'],
  [3985360168,3985556536,'Capricorn'],
  [3985556536,3985738972,'Aquarius'],
  [3985738972,3985912086,'Pisces'],
  [3985912086,3986082803,'Aries'],
  [3986082803,3986258145,'Taurus'],
  [3986258145,3986443572,'Gemini'],
  [3986443572,3986641519,'Cancer'],
  [3986641519,3986850739,'Leo'],
  [3986850739,3987067332,'Virgo'],
  [3987067332,3987286779,'Libra'],
  [3987286779,3987504603,'Scorpio'],
  [3987504603,3987716127,'Sagittarius'],
  [3987716127,3987917043,'Capricorn'],
  [3987917043,3988105422,'Aquarius'],
  [3988105422,3988283087,'Pisces'],
  [3988283087,3988454969,'Aries'],
  [3988454969,3988627592,'Taurus'],
  [3988627592,3988807574,'Gemini'],
  [3988807574,3988999960,'Cancer'],
  [3988999960,3989206086,'Leo'],
  [3989206086,3989422300,'Virgo'],
  [3989422300,3989641892,'Libra'],
  [3989641892,3989858763,'Scorpio'],
  [3989858763,3990069174,'Sagittarius'],
  [3990069174,3990271190,'Capricorn'],
  [3990271190,3990463798,'Aquarius'],
  [3990463798,3990647302,'Pisces'],
  [3990647302,3990824008,'Aries'],
  [3990824008,3990998381,'Taurus'],
  [3990998381,3991176419,'Gemini'],
  [3991176419,3991364260,'Cancer'],
  [3991364260,3991565824,'Leo'],
  [3991565824,3991779826,'Virgo'],
  [3991779826,3991999223,'Libra'],
  [3991999223,3992215575,'Scorpio'],
  [3992215575,3992423984,'Sagittarius'],
  [3992423984,3992623877,'Capricorn'],
  [3992623877,3992816585,'Aquarius'],
  [3992816585,3993003378,'Pisces'],
  [3993003378,3993185337,'Aries'],
  [3993185337,3993364455,'Taurus'],
  [3993364455,3993544617,'Gemini'],
  [3993544617,3993731258,'Cancer'],
  [3993731258,3993929438,'Leo'],
  [3993929438,3994140497,'Virgo'],
  [3994140497,3994359225,'Libra'],
  [3994359225,3994576013,'Scorpio'],
  [3994576013,3994783550,'Sagittarius'],
  [3994783550,3994980574,'Capricorn'],
  [3994980574,3995170013,'Aquarius'],
  [3995170013,3995355494,'Pisces'],
  [3995355494,3995539350,'Aries'],
  [3995539350,3995722747,'Taurus'],
  [3995722747,3995907278,'Gemini'],
  [3995907278,3996096202,'Cancer'],
  [3996096202,3996293827,'Leo'],
  [3996293827,3996502850,'Virgo'],
  [3996502850,3996720689,'Libra'],
  [3996720689,3996938722,'Scorpio'],
  [3996938722,3997147630,'Sagittarius'],
  [3997147630,3997343785,'Capricorn'],
  [3997343785,3997529757,'Aquarius'],
  [3997529757,3997710810,'Pisces'],
  [3997710810,3997891733,'Aries'],
  [3997891733,3998075359,'Taurus'],
  [3998075359,3998262915,'Gemini'],
  [3998262915,3998455567,'Cancer'],
  [3998455567,3998655351,'Leo'],
  [3998655351,3998864276,'Virgo'],
  [3998864276,3999081490,'Libra'],
  [3999081490,3999300836,'Scorpio'],
  [3999300836,3999512989,'Sagittarius'],
  [3999512989,3999711663,'Capricorn'],
  [3999711663,3999897163,'Aquarius'],
  [3999897163,4000074487,'Pisces'],
  [4000074487,4000249979,'Aries'],
  [4000249979,4000429068,'Taurus'],
  [4000429068,4000615113,'Gemini'],
  [4000615113,4000809406,'Cancer'],
  [4000809406,4001012038,'Leo'],
  [4001012038,4001222635,'Virgo'],
  [4001222635,4001439914,'Libra'],
  [4001439914,4001659849,'Scorpio'],
  [4001659849,4001875264,'Sagittarius'],
  [4001875264,4002078976,'Capricorn'],
  [4002078976,4002268263,'Aquarius'],
  [4002268263,4002445873,'Pisces'],
  [4002445873,4002617782,'Aries'],
  [4002617782,4002790826,'Taurus'],
  [4002790826,4002971049,'Gemini'],
  [4002971049,4003162314,'Cancer'],
  [4003162314,4003365300,'Leo'],
  [4003365300,4003577700,'Virgo'],
  [4003577700,4003795796,'Libra'],
  [4003795796,4004015531,'Scorpio'],
  [4004015531,4004232188,'Sagittarius'],
  [4004232188,4004440383,'Capricorn'],
  [4004440383,4004635986,'Aquarius'],
  [4004635986,4004818581,'Pisces'],
  [4004818581,4004991784,'Aries'],
  [4004991784,4005161861,'Taurus'],
  [4005161861,4005336044,'Gemini'],
  [4005336044,4005520865,'Cancer'],
  [4005520865,4005719929,'Leo'],
  [4005719929,4005931800,'Virgo'],
  [4005931800,4006150676,'Libra'],
  [4006150676,4006370134,'Scorpio'],
  [4006370134,4006585832,'Sagittarius'],
  [4006585832,4006795042,'Capricorn'],
  [4006795042,4006995247,'Aquarius'],
  [4006995247,4007184623,'Pisces'],
  [4007184623,4007363665,'Aries'],
  [4007363665,4007536118,'Taurus'],
  [4007536118,4007708372,'Gemini'],
  [4007708372,4007887850,'Cancer'],
  [4007887850,4008080761,'Leo'],
  [4008080761,4008288804,'Virgo'],
  [4008288804,4008506977,'Libra'],
  [4008506977,4008726507,'Scorpio'],
  [4008726507,4008940844,'Sagittarius'],
  [4008940844,4009147957,'Capricorn'],
  [4009147957,4009348025,'Aquarius'],
  [4009348025,4009540945,'Pisces'],
  [4009540945,4009726242,'Aries'],
  [4009726242,4009904794,'Taurus'],
  [4009904794,4010080341,'Gemini'],
  [4010080341,4010259101,'Cancer'],
  [4010259101,4010447884,'Leo'],
  [4010447884,4010650998,'Virgo'],
  [4010650998,4010866535,'Libra'],
  [4010866535,4011086020,'Scorpio'],
  [4011086020,4011300245,'Sagittarius'],
  [4011300245,4011505205,'Capricorn'],
  [4011505205,4011701942,'Aquarius'],
  [4011701942,4011892991,'Pisces'],
  [4011892991,4012079914,'Aries'],
  [4012079914,4012263296,'Taurus'],
  [4012263296,4012444488,'Gemini'],
  [4012444488,4012627004,'Cancer'],
  [4012627004,4012816082,'Leo'],
  [4012816082,4013016489,'Virgo'],
  [4013016489,4013229010,'Libra'],
  [4013229010,4013447870,'Scorpio'],
  [4013447870,4013663331,'Sagittarius'],
  [4013663331,4013868511,'Capricorn'],
  [4013868511,4014062751,'Aquarius'],
  [4014062751,4014249460,'Pisces'],
  [4014249460,4014432744,'Aries'],
  [4014432744,4014615543,'Taurus'],
  [4014615543,4014799626,'Gemini'],
  [4014799626,4014986717,'Cancer'],
  [4014986717,4015179386,'Leo'],
  [4015179386,4015380617,'Virgo'],
  [4015380617,4015591757,'Libra'],
  [4015591757,4015809763,'Scorpio'],
  [4015809763,4016026860,'Sagittarius'],
  [4016026860,4016234752,'Capricorn'],
  [4016234752,4016429867,'Aquarius'],
  [4016429867,4016614154,'Pisces'],
  [4016614154,4016792524,'Aries'],
  [4016792524,4016970324,'Taurus'],
  [4016970324,4017151871,'Gemini'],
  [4017151871,4017339913,'Cancer'],
  [4017339913,4017535772,'Leo'],
  [4017535772,4017739855,'Virgo'],
  [4017739855,4017951802,'Libra'],
  [4017951802,4018169442,'Scorpio'],
  [4018169442,4018387627,'Sagittarius'],
  [4018387627,4018599100,'Capricorn'],
  [4018599100,4018798213,'Aquarius'],
  [4018798213,4018984111,'Pisces'],
  [4018984111,4019160429,'Aries'],
  [4019160429,4019333228,'Taurus'],
  [4019333228,4019509014,'Gemini'],
  [4019509014,4019693156,'Cancer'],
  [4019693156,4019888440,'Leo'],
  [4019888440,4020094355,'Virgo'],
  [4020094355,4020308076,'Libra'],
  [4020308076,4020526083,'Scorpio'],
  [4020526083,4020744488,'Sagittarius'],
  [4020744488,4020958400,'Capricorn'],
  [4020958400,4021162382,'Aquarius'],
  [4021162382,4021353184,'Pisces'],
  [4021353184,4021531789,'Aries'],
  [4021531789,4021703109,'Taurus'],
  [4021703109,4021874220,'Gemini'],
  [4021874220,4022052425,'Cancer'],
  [4022052425,4022243163,'Leo'],
  [4022243163,4022447618,'Virgo'],
  [4022447618,4022662086,'Libra'],
  [4022662086,4022880728,'Scorpio'],
  [4022880728,4023098791,'Sagittarius'],
  [4023098791,4023312995,'Capricorn'],
  [4023312995,4023519962,'Aquarius'],
  [4023519962,4023716183,'Pisces'],
  [4023716183,4023900196,'Aries'],
  [4023900196,4024074403,'Taurus'],
  [4024074403,4024244744,'Gemini'],
  [4024244744,4024418874,'Cancer'],
  [4024418874,4024603999,'Leo'],
  [4024603999,4024804017,'Virgo'],
  [4024804017,4025016872,'Libra'],
  [4025016872,4025235612,'Scorpio'],
  [4025235612,4025453289,'Sagittarius'],
  [4025453289,4025666240,'Capricorn'],
  [4025666240,4025872979,'Aquarius'],
  [4025872979,4026071895,'Pisces'],
  [4026071895,4026261202,'Aries'],
  [4026261202,4026440977,'Taurus'],
  [4026440977,4026614731,'Gemini'],
  [4026614731,4026788833,'Cancer'],
  [4026788833,4026970627,'Leo'],
  [4026970627,4027165809,'Virgo'],
  [4027165809,4027375108,'Libra'],
  [4027375108,4027592834,'Scorpio'],
  [4027592834,4027810428,'Sagittarius'],
  [4027810428,4028022137,'Capricorn'],
  [4028022137,4028226543,'Aquarius'],
  [4028226543,4028424148,'Pisces'],
  [4028424148,4028615139,'Aries'],
  [4028615139,4028799491,'Taurus'],
  [4028799491,4028978648,'Gemini'],
  [4028978648,4029156537,'Cancer'],
  [4029156537,4029338943,'Leo'],
  [4029338943,4029531612,'Virgo'],
  [4029531612,4029737318,'Libra'],
  [4029737318,4029953110,'Scorpio'],
  [4029953110,4030170937,'Sagittarius'],
  [4030170937,4030382800,'Capricorn'],
  [4030382800,4030585325,'Aquarius'],
  [4030585325,4030779442,'Pisces'],
  [4030779442,4030967641,'Aries'],
  [4030967641,4031152106,'Taurus'],
  [4031152106,4031334603,'Gemini'],
  [4031334603,4031517353,'Cancer'],
  [4031517353,4031703616,'Leo'],
  [4031703616,4031897307,'Virgo'],
  [4031897307,4032101369,'Libra'],
  [4032101369,4032315248,'Scorpio'],
  [4032315248,4032533332,'Sagittarius'],
  [4032533332,4032747102,'Capricorn'],
  [4032747102,4032950382,'Aquarius'],
  [4032950382,4033142306,'Pisces'],
  [4033142306,4033326000,'Aries'],
  [4033326000,4033506054,'Taurus'],
  [4033506054,4033686733,'Gemini'],
  [4033686733,4033871162,'Cancer'],
  [4033871162,4034061318,'Leo'],
  [4034061318,4034258499,'Virgo'],
  [4034258499,4034463671,'Libra'],
  [4034463671,4034676756,'Scorpio'],
  [4034676756,4034894821,'Sagittarius'],
  [4034894821,4035111212,'Capricorn'],
  [4035111212,4035318209,'Aquarius'],
  [4035318209,4035511802,'Pisces'],
  [4035511802,4035693453,'Aries'],
  [4035693453,4035868425,'Taurus'],
  [4035868425,4036043295,'Gemini'],
  [4036043295,4036223937,'Cancer'],
  [4036223937,4036413903,'Leo'],
  [4036413903,4036613648,'Virgo'],
  [4036613648,4036821490,'Libra'],
  [4036821490,4037035407,'Scorpio'],
  [4037035407,4037253302,'Sagittarius'],
  [4037253302,4037471313,'Capricorn'],
  [4037471313,4037682906,'Aquarius'],
  [4037682906,4037881819,'Pisces'],
  [4037881819,4038066254,'Aries'],
  [4038066254,4038239886,'Taurus'],
  [4038239886,4038409783,'Gemini'],
  [4038409783,4038583817,'Cancer'],
  [4038583817,4038768444,'Leo'],
  [4038768444,4038966323,'Virgo'],
  [4038966323,4039175327,'Libra'],
  [4039175327,4039390821,'Scorpio'],
  [4039390821,4039608900,'Sagittarius'],
  [4039608900,4039826847,'Capricorn'],
  [4039826847,4040040878,'Aquarius'],
  [4040040878,4040245445,'Pisces'],
  [4040245445,4040436277,'Aries'],
  [4040436277,4040613843,'Taurus'],
  [4040613843,4040783568,'Gemini'],
  [4040783568,4040953409,'Cancer'],
  [4040953409,4041131427,'Leo'],
  [4041131427,4041323278,'Virgo'],
  [4041323278,4041529457,'Libra'],
  [4041529457,4041745098,'Scorpio'],
  [4041745098,4041963681,'Sagittarius'],
  [4041963681,4042180866,'Capricorn'],
  [4042180866,4042394251,'Aquarius'],
  [4042394251,4042600945,'Pisces'],
  [4042600945,4042797333,'Aries'],
  [4042797333,4042981632,'Taurus'],
  [4042981632,4043156225,'Gemini'],
  [4043156225,4043327183,'Cancer'],
  [4043327183,4043502162,'Leo'],
  [4043502162,4043688148,'Virgo'],
  [4043688148,4043888713,'Libra'],
  [4043888713,4044101687,'Scorpio'],
  [4044101687,4044320134,'Sagittarius'],
  [4044320134,4044537016,'Capricorn'],
  [4044537016,4044748577,'Aquarius'],
  [4044748577,4044953475,'Pisces'],
  [4044953475,4045150737,'Aries'],
  [4045150737,4045339474,'Taurus'],
  [4045339474,4045520332,'Gemini'],
  [4045520332,4045696571,'Cancer'],
  [4045696571,4045873644,'Leo'],
  [4045873644,4046057750,'Virgo'],
  [4046057750,4046253748,'Libra'],
  [4046253748,4046462567,'Scorpio'],
  [4046462567,4046679597,'Sagittarius'],
  [4046679597,4046896770,'Capricorn'],
  [4046896770,4047107592,'Aquarius'],
  [4047107592,4047309715,'Pisces'],
  [4047309715,4047503849,'Aries'],
  [4047503849,4047691754,'Taurus'],
  [4047691754,4047875304,'Gemini'],
  [4047875304,4048056666,'Cancer'],
  [4048056666,4048238760,'Leo'],
  [4048238760,4048425371,'Virgo'],
  [4048425371,4048620434,'Libra'],
  [4048620434,4048826296,'Scorpio'],
  [4048826296,4049041326,'Sagittarius'],
  [4049041326,4049258963,'Capricorn'],
  [4049258963,4049470919,'Aquarius'],
  [4049470919,4049672212,'Pisces'],
  [4049672212,4049862930,'Aries'],
  [4049862930,4050046571,'Taurus'],
  [4050046571,4050227588,'Gemini'],
  [4050227588,4050409721,'Cancer'],
  [4050409721,4050595421,'Leo'],
  [4050595421,4050786235,'Virgo'],
  [4050786235,4050983660,'Libra'],
  [4050983660,4051189239,'Scorpio'],
  [4051189239,4051402970,'Sagittarius'],
  [4051402970,4051620945,'Capricorn'],
  [4051620945,4051835312,'Aquarius'],
  [4051835312,4052038684,'Pisces'],
  [4052038684,4052228773,'Aries'],
  [4052228773,4052408774,'Taurus'],
  [4052408774,4052584766,'Gemini'],
  [4052584766,4052762943,'Cancer'],
  [4052762943,4052947669,'Leo'],
  [4052947669,4053140529,'Virgo'],
  [4053140529,4053341042,'Libra'],
  [4053341042,4053548446,'Scorpio'],
  [4053548446,4053762238,'Sagittarius'],
  [4053762238,4053980368,'Capricorn'],
  [4053980368,4054197111,'Aquarius'],
  [4054197111,4054404514,'Pisces'],
  [4054404514,4054597569,'Aries'],
  [4054597569,4054777404,'Taurus'],
  [4054777404,4054949923,'Gemini'],
  [4054949923,4055122701,'Cancer'],
  [4055122701,4055302459,'Leo'],
  [4055302459,4055492997,'Virgo'],
  [4055492997,4055694220,'Libra'],
  [4055694220,4055903556,'Scorpio'],
  [4055903556,4056118398,'Sagittarius'],
  [4056118398,4056336603,'Capricorn'],
  [4056336603,4056554495,'Aquarius'],
  [4056554495,4056765685,'Pisces'],
  [4056765685,4056963915,'Aries'],
  [4056963915,4057147528,'Taurus'],
  [4057147528,4057320558,'Gemini'],
  [4057320558,4057490308,'Cancer'],
  [4057490308,4057664623,'Leo'],
  [4057664623,4057849667,'Virgo'],
  [4057849667,4058047788,'Libra'],
  [4058047788,4058256941,'Scorpio'],
  [4058256941,4058472700,'Sagittarius'],
  [4058472700,4058691021,'Capricorn'],
  [4058691021,4058908601,'Aquarius'],
  [4058908601,4059121250,'Pisces'],
  [4059121250,4059323898,'Aries'],
  [4059323898,4059513346,'Taurus'],
  [4059513346,4059690890,'Gemini'],
  [4059690890,4059861940,'Cancer'],
  [4059861940,4060033822,'Leo'],
  [4060033822,4060213681,'Virgo'],
  [4060213681,4060406355,'Libra'],
  [4060406355,4060612363,'Scorpio'],
  [4060612363,4060827650,'Sagittarius'],
  [4060827650,4061046097,'Capricorn'],
  [4061046097,4061262726,'Aquarius'],
  [4061262726,4061474200,'Pisces'],
  [4061474200,4061677836,'Aries'],
  [4061677836,4061871522,'Taurus'],
  [4061871522,4062055060,'Gemini'],
  [4062055060,4062231194,'Cancer'],
  [4062231194,4062405131,'Leo'],
  [4062405131,4062583222,'Virgo'],
  [4062583222,4062771315,'Libra'],
  [4062771315,4062972614,'Scorpio'],
  [4062972614,4063185579,'Sagittarius'],
  [4063185579,4063403898,'Capricorn'],
  [4063403898,4063620117,'Aquarius'],
  [4063620117,4063829512,'Pisces'],
  [4063829512,4064030706,'Aries'],
  [4064030706,4064224172,'Taurus'],
  [4064224172,4064410961,'Gemini'],
  [4064410961,4064592666,'Cancer'],
  [4064592666,4064771905,'Leo'],
  [4064771905,4064952617,'Virgo'],
  [4064952617,4065139658,'Libra'],
  [4065139658,4065337386,'Scorpio'],
  [4065337386,4065547135,'Sagittarius'],
  [4065547135,4065764766,'Capricorn'],
  [4065764766,4065981743,'Aquarius'],
  [4065981743,4066190534,'Pisces'],
  [4066190534,4066388695,'Aries'],
  [4066388695,4066578293,'Taurus'],
  [4066578293,4066763087,'Gemini'],
  [4066763087,4066946321,'Cancer'],
  [4066946321,4067130034,'Leo'],
  [4067130034,4067315737,'Virgo'],
  [4067315737,4067505654,'Libra'],
  [4067505654,4067703039,'Scorpio'],
  [4067703039,4067910561,'Sagittarius'],
  [4067910561,4068127062,'Capricorn'],
  [4068127062,4068345503,'Aquarius'],
  [4068345503,4068556336,'Pisces'],
  [4068556336,4068754173,'Aries'],
  [4068754173,4068940270,'Taurus'],
  [4068940270,4069119965,'Gemini'],
  [4069119965,4069299211,'Cancer'],
  [4069299211,4069482246,'Leo'],
  [4069482246,4069670721,'Virgo'],
  [4069670721,4069864745,'Libra'],
  [4069864745,4070064856,'Scorpio'],
  [4070064856,4070272552,'Sagittarius'],
  [4070272552,4070488220,'Capricorn'],
  [4070488220,4070707744,'Aquarius'],
  [4070707744,4070922226,'Pisces'],
  [4070922226,4071123570,'Aries'],
  [4071123570,4071310139,'Taurus'],
  [4071310139,4071486534,'Gemini'],
  [4071486534,4071659993,'Cancer'],
  [4071659993,4071837340,'Leo'],
  [4071837340,4072022932,'Virgo'],
  [4072022932,4072217774,'Libra'],
  [4072217774,4072420717,'Scorpio'],
  [4072420717,4072630534,'Sagittarius'],
  [4072630534,4072846468,'Capricorn'],
  [4072846468,4073066177,'Aquarius'],
  [4073066177,4073283458,'Pisces'],
  [4073283458,4073490135,'Aries'],
  [4073490135,4073681567,'Taurus'],
  [4073681567,4073859584,'Gemini'],
  [4073859584,4074030536,'Cancer'],
  [4074030536,4074202105,'Leo'],
  [4074202105,4074381048,'Virgo'],
  [4074381048,4074571409,'Libra'],
  [4074571409,4074773538,'Scorpio'],
  [4074773538,4074984875,'Sagittarius'],
  [4074984875,4075201957,'Capricorn'],
  [4075201957,4075421489,'Aquarius'],
  [4075421489,4075639249,'Pisces'],
  [4075639249,4075849474,'Aries'],
  [4075849474,4076047060,'Taurus'],
  [4076047060,4076230900,'Gemini'],
  [4076230900,4076404637,'Cancer'],
  [4076404637,4076574773,'Leo'],
  [4076574773,4076748548,'Virgo'],
  [4076748548,4076932231,'Libra'],
  [4076932231,4077129336,'Scorpio'],
  [4077129336,4077339074,'Sagittarius'],
  [4077339074,4077556686,'Capricorn'],
  [4077556686,4077776251,'Aquarius'],
  [4077776251,4077992952,'Pisces'],
  [4077992952,4078203178,'Aries'],
  [4078203178,4078404015,'Taurus'],
  [4078404015,4078593885,'Gemini'],
  [4078593885,4078773795,'Cancer'],
  [4078773795,4078947543,'Leo'],
  [4078947543,4079120912,'Virgo'],
  [4079120912,4079300417,'Libra'],
  [4079300417,4079491675,'Scorpio'],
  [4079491675,4079697013,'Sagittarius'],
  [4079697013,4079913253,'Capricorn'],
  [4079913253,4080132861,'Aquarius'],
  [4080132861,4080348587,'Pisces'],
  [4080348587,4080556687,'Aries'],
  [4080556687,4080756510,'Taurus'],
  [4080756510,4080948536,'Gemini'],
  [4080948536,4081133574,'Cancer'],
  [4081133574,4081313189,'Leo'],
  [4081313189,4081490501,'Virgo'],
  [4081490501,4081670403,'Libra'],
  [4081670403,4081858634,'Scorpio'],
  [4081858634,4082059582,'Sagittarius'],
  [4082059582,4082272994,'Capricorn'],
  [4082272994,4082492241,'Aquarius'],
  [4082492241,4082707994,'Pisces'],
  [4082707994,4082914395,'Aries'],
  [4082914395,4083111103,'Taurus'],
  [4083111103,4083300854,'Gemini'],
  [4083300854,4083486511,'Cancer'],
  [4083486511,4083669861,'Leo'],
  [4083669861,4083852227,'Virgo'],
  [4083852227,4084035958,'Libra'],
  [4084035958,4084225096,'Scorpio'],
  [4084225096,4084424141,'Sagittarius'],
  [4084424141,4084634981,'Capricorn'],
  [4084634981,4084853507,'Aquarius'],
  [4084853507,4085070311,'Pisces'],
  [4085070311,4085277070,'Aries'],
  [4085277070,4085471724,'Taurus'],
  [4085471724,4085657587,'Gemini'],
  [4085657587,4085839684,'Cancer'],
  [4085839684,4086021987,'Leo'],
  [4086021987,4086206493,'Virgo'],
  [4086206493,4086394182,'Libra'],
  [4086394182,4086586701,'Scorpio'],
  [4086586701,4086786832,'Sagittarius'],
  [4086786832,4086996747,'Capricorn'],
  [4086996747,4087214622,'Aquarius'],
  [4087214622,4087432917,'Pisces'],
  [4087432917,4087642214,'Aries'],
  [4087642214,4087837800,'Taurus'],
  [4087837800,4088021609,'Gemini'],
  [4088021609,4088199300,'Cancer'],
  [4088199300,4088376904,'Leo'],
  [4088376904,4088558794,'Virgo'],
  [4088558794,4088747061,'Libra'],
  [4088747061,4088942355,'Scorpio'],
  [4088942355,4089145157,'Sagittarius'],
  [4089145157,4089355991,'Capricorn'],
  [4089355991,4089573693,'Aquarius'],
  [4089573693,4089793094,'Pisces'],
  [4089793094,4090005853,'Aries'],
  [4090005853,4090205349,'Taurus'],
  [4090205349,4090390843,'Gemini'],
  [4090390843,4090566770,'Cancer'],
  [4090566770,4090739711,'Leo'],
  [4090739711,4090916037,'Virgo'],
  [4090916037,4091100410,'Libra'],
  [4091100410,4091294964,'Scorpio'],
  [4091294964,4091499429,'Sagittarius'],
  [4091499429,4091712008,'Capricorn'],
  [4091712008,4091930123,'Aquarius'],
  [4091930123,4092149755,'Pisces'],
  [4092149755,4092364915,'Aries'],
  [4092364915,4092569340,'Taurus'],
  [4092569340,4092759911,'Gemini'],
  [4092759911,4092938382,'Cancer'],
  [4092938382,4093110076,'Leo'],
  [4093110076,4093281785,'Virgo'],
  [4093281785,4093460129,'Libra'],
  [4093460129,4093649990,'Scorpio'],
  [4093649990,4093852866,'Sagittarius'],
  [4093852866,4094066203,'Capricorn'],
  [4094066203,4094285004,'Aquarius'],
  [4094285004,4094504217,'Pisces'],
  [4094504217,4094719487,'Aries'],
  [4094719487,4094926848,'Taurus'],
  [4094926848,4095123111,'Gemini'],
  [4095123111,4095307511,'Cancer'],
  [4095307511,4095482617,'Leo'],
  [4095482617,4095653803,'Virgo'],
  [4095653803,4095827953,'Libra'],
  [4095827953,4096011860,'Scorpio'],
  [4096011860,4096209936,'Sagittarius'],
  [4096209936,4096421509,'Capricorn'],
  [4096421509,4096640508,'Aquarius'],
  [4096640508,4096859362,'Pisces'],
  [4096859362,4097073107,'Aries'],
  [4097073107,4097279806,'Taurus'],
  [4097279806,4097478557,'Gemini'],
  [4097478557,4097668549,'Cancer'],
  [4097668549,4097849954,'Leo'],
  [4097849954,4098025304,'Virgo'],
  [4098025304,4098199829,'Libra'],
  [4098199829,4098380361,'Scorpio'],
  [4098380361,4098573196,'Sagittarius'],
  [4098573196,4098780743,'Capricorn'],
  [4098780743,4098998615,'Aquarius'],
  [4098998615,4099217604,'Pisces'],
  [4099217604,4099430174,'Aries'],
  [4099430174,4099634141,'Taurus'],
  [4099634141,4099830842,'Gemini'],
  [4099830842,4100021886,'Cancer'],
  [4100021886,4100207832,'Leo'],
  [4100207832,4100389192,'Virgo'],
  [4100389192,4100568342,'Libra'],
  [4100568342,4100750154,'Scorpio'],
  [4100750154,4100940697,'Sagittarius'],
  [4100940697,4101144339,'Capricorn'],
  [4101144339,4101359853,'Aquarius'],
  [4101359853,4101579134,'Pisces'],
  [4101579134,4101792356,'Aries'],
  [4101792356,4101994788,'Taurus'],
  [4101994788,4102187730,'Gemini'],
  [4102187730,4102375026,'Cancer'],
  [4102375026,4102559901,'Leo'],
  [4102559901,4102743920,'Virgo'],
  [4102743920,4102928056,'Libra'],
  [4102928056,4103114447,'Scorpio'],
  [4103114447,4103306881,'Sagittarius'],
  [4103306881,4103509315,'Capricorn'],
  [4103509315,4103722673,'Aquarius'],
  [4103722673,4103941858,'Pisces'],
  [4103941858,4104157277,'Aries'],
  [4104157277,4104361359,'Taurus'],
  [4104361359,4104552967,'Gemini'],
  [4104552967,4104735924,'Cancer'],
  [4104735924,4104915541,'Leo'],
  [4104915541,4105096243,'Virgo'],
  [4105096243,4105280738,'Libra'],
  [4105280738,4105470516,'Scorpio'],
  [4105470516,4105666865,'Sagittarius'],
  [4105666865,4105871245,'Capricorn'],
  [4105871245,4106084196,'Aquarius'],
  [4106084196,4106302982,'Pisces'],
  [4106302982,4106520583,'Aries'],
  [4106520583,4106728748,'Taurus'],
  [4106728748,4106923207,'Gemini'],
  [4106923207,4107105478,'Cancer'],
  [4107105478,4107280755,'Leo'],
  [4107280755,4107455307,'Virgo'],
  [4107455307,4107634719,'Libra'],
  [4107634719,4107822747,'Scorpio'],
  [4107822747,4108020730,'Sagittarius'],
  [4108020730,4108227877,'Capricorn'],
  [4108227877,4108442233,'Aquarius'],
  [4108442233,4108660940,'Pisces'],
  [4108660940,4108879458,'Aries'],
  [4108879458,4109091492,'Taurus'],
  [4109091492,4109291425,'Gemini'],
  [4109291425,4109477620,'Cancer'],
  [4109477620,4109653067,'Leo'],
  [4109653067,4109823808,'Virgo'],
  [4109823808,4109996958,'Libra'],
  [4109996958,4110178989,'Scorpio'],
  [4110178989,4110373837,'Sagittarius'],
  [4110373837,4110581205,'Capricorn'],
  [4110581205,4110797032,'Aquarius'],
  [4110797032,4111016210,'Pisces'],
  [4111016210,4111234474,'Aries'],
  [4111234474,4111447996,'Taurus'],
  [4111447996,4111652541,'Gemini'],
  [4111652541,4111844869,'Cancer'],
  [4111844869,4112024960,'Leo'],
  [4112024960,4112196745,'Virgo'],
  [4112196745,4112366958,'Libra'],
  [4112366958,4112543256,'Scorpio'],
  [4112543256,4112732106,'Sagittarius'],
  [4112732106,4112935943,'Capricorn'],
  [4112935943,4113151248,'Aquarius'],
  [4113151248,4113370814,'Pisces'],
  [4113370814,4113588494,'Aries'],
  [4113588494,4113801156,'Taurus'],
  [4113801156,4114006942,'Gemini'],
  [4114006942,4114203687,'Cancer'],
  [4114203687,4114389861,'Leo'],
  [4114389861,4114566620,'Virgo'],
  [4114566620,4114738643,'Libra'],
  [4114738643,4114912977,'Scorpio'],
  [4114912977,4115097002,'Sagittarius'],
  [4115097002,4115295632,'Capricorn'],
  [4115295632,4115508001,'Aquarius'],
  [4115508001,4115727056,'Pisces'],
  [4115727056,4115944426,'Aries'],
  [4115944426,4116155506,'Taurus'],
  [4116155506,4116359498,'Gemini'],
  [4116359498,4116556557,'Cancer'],
  [4116556557,4116746247,'Leo'],
  [4116746247,4116928499,'Virgo'],
  [4116928499,4117105490,'Libra'],
  [4117105490,4117282180,'Scorpio'],
  [4117282180,4117465099,'Sagittarius'],
  [4117465099,4117660009,'Capricorn'],
  [4117660009,4117868611,'Aquarius'],
  [4117868611,4118086132,'Pisces'],
  [4118086132,4118303611,'Aries'],
  [4118303611,4118514049,'Taurus'],
  [4118514049,4118715594,'Gemini'],
  [4118715594,4118909729,'Cancer'],
  [4118909729,4119098385,'Leo'],
  [4119098385,4119282798,'Virgo'],
  [4119282798,4119464319,'Libra'],
  [4119464319,4119645670,'Scorpio'],
  [4119645670,4119831177,'Sagittarius'],
  [4119831177,4120025612,'Capricorn'],
  [4120025612,4120231731,'Aquarius'],
  [4120231731,4120447418,'Pisces'],
  [4120447418,4120665273,'Aries'],
  [4120665273,4120876792,'Taurus'],
  [4120876792,4121077662,'Gemini'],
  [4121077662,4121268677,'Cancer'],
  [4121268677,4121453262,'Leo'],
  [4121453262,4121635116,'Virgo'],
  [4121635116,4121817198,'Libra'],
  [4121817198,4122001867,'Scorpio'],
  [4122001867,4122191425,'Sagittarius'],
  [4122191425,4122388306,'Capricorn'],
  [4122388306,4122594341,'Aquarius'],
  [4122594341,4122808873,'Pisces'],
  [4122808873,4123027085,'Aries'],
  [4123027085,4123241046,'Taurus'],
  [4123241046,4123444125,'Gemini'],
  [4123444125,4123634702,'Cancer'],
  [4123634702,4123815765,'Leo'],
  [4123815765,4123992570,'Virgo'],
  [4123992570,4124170596,'Libra'],
  [4124170596,4124354169,'Scorpio'],
  [4124354169,4124545704,'Sagittarius'],
  [4124545704,4124745739,'Capricorn'],
  [4124745739,4124953699,'Aquarius'],
  [4124953699,4125168306,'Pisces'],
  [4125168306,4125386629,'Aries'],
  [4125386629,4125603033,'Taurus'],
  [4125603033,4125810446,'Gemini'],
  [4125810446,4126004401,'Cancer'],
  [4126004401,4126185550,'Leo'],
  [4126185550,4126358826,'Virgo'],
  [4126358826,4126531171,'Libra'],
  [4126531171,4126709424,'Scorpio'],
  [4126709424,4126898366,'Sagittarius'],
  [4126898366,4127099068,'Capricorn'],
  [4127099068,4127309092,'Aquarius'],
  [4127309092,4127524803,'Pisces'],
  [4127524803,4127743063,'Aries'],
  [4127743063,4127960461,'Taurus'],
  [4127960461,4128171827,'Gemini'],
  [4128171827,4128371551,'Cancer'],
  [4128371551,4128557196,'Leo'],
  [4128557196,4128731405,'Virgo'],
  [4128731405,4128900721,'Libra'],
  [4128900721,4129073166,'Scorpio'],
  [4129073166,4129256000,'Sagittarius'],
  [4129256000,4129453057,'Capricorn'],
  [4129453057,4129662721,'Aquarius'],
  [4129662721,4129879438,'Pisces'],
  [4129879438,4130097797,'Aries'],
  [4130097797,4130314564,'Taurus'],
  [4130314564,4130527024,'Gemini'],
  [4130527024,4130731218,'Cancer'],
  [4130731218,4130923367,'Leo'],
  [4130923367,4131103022,'Virgo'],
  [4131103022,4131274387,'Libra'],
  [4131274387,4131444766,'Scorpio'],
  [4131444766,4131622234,'Sagittarius'],
  [4131622234,4131813122,'Capricorn'],
  [4131813122,4132018889,'Aquarius'],
  [4132018889,4132234852,'Pisces'],
  [4132234852,4132453463,'Aries'],
  [4132453463,4132669269,'Taurus'],
  [4132669269,4132880053,'Gemini'],
  [4132880053,4133084453,'Cancer'],
  [4133084453,4133280421,'Leo'],
  [4133280421,4133466436,'Virgo'],
  [4133466436,4133643817,'Libra'],
  [4133643817,4133817350,'Scorpio'],
  [4133817350,4133993917,'Sagittarius'],
  [4133993917,4134180378,'Capricorn'],
  [4134180378,4134380811,'Aquarius'],
  [4134380811,4134593703,'Pisces'],
  [4134593703,4134812030,'Aries'],
  [4134812030,4135027813,'Taurus'],
  [4135027813,4135236716,'Gemini'],
  [4135236716,4135438102,'Cancer'],
  [4135438102,4135632626,'Leo'],
  [4135632626,4135820802,'Virgo'],
  [4135820802,4136003467,'Libra'],
  [4136003467,4136182930,'Scorpio'],
  [4136182930,4136363340,'Sagittarius'],
  [4136363340,4136549921,'Capricorn'],
  [4136549921,4136747197,'Aquarius'],
  [4136747197,4136956427,'Pisces'],
  [4136956427,4137173509,'Aries'],
  [4137173509,4137390220,'Taurus'],
  [4137390220,4137599323,'Gemini'],
  [4137599323,4137798255,'Cancer'],
  [4137798255,4137988540,'Leo'],
  [4137988540,4138173401,'Virgo'],
  [4138173401,4138356018,'Libra'],
  [4138356018,4138538956,'Scorpio'],
  [4138538956,4138724436,'Sagittarius'],
  [4138724436,4138914862,'Capricorn'],
  [4138914862,4139112889,'Aquarius'],
  [4139112889,4139320328,'Pisces'],
  [4139320328,4139535905,'Aries'],
  [4139535905,4139753683,'Taurus'],
  [4139753683,4139965250,'Gemini'],
  [4139965250,4140164962,'Cancer'],
  [4140164962,4140352696,'Leo'],
  [4140352696,4140532586,'Virgo'],
  [4140532586,4140710340,'Libra'],
  [4140710340,4140891056,'Scorpio'],
  [4140891056,4141077928,'Sagittarius'],
  [4141077928,4141272006,'Capricorn'],
  [4141272006,4141473227,'Aquarius'],
  [4141473227,4141681574,'Pisces'],
  [4141681574,4141896535,'Aries'],
  [4141896535,4142114903,'Taurus'],
  [4142114903,4142329669,'Gemini'],
  [4142329669,4142533251,'Cancer'],
  [4142533251,4142722510,'Leo'],
  [4142722510,4142900231,'Virgo'],
  [4142900231,4143072905,'Libra'],
  [4143072905,4143247821,'Scorpio'],
  [4143247821,4143430803,'Sagittarius'],
  [4143430803,4143624438,'Capricorn'],
  [4143624438,4143827773,'Aquarius'],
  [4143827773,4144038278,'Pisces'],
  [4144038278,4144253863,'Aries'],
  [4144253863,4144472363,'Taurus'],
  [4144472363,4144689255,'Gemini'],
  [4144689255,4144897514,'Cancer'],
  [4144897514,4145091661,'Leo'],
  [4145091661,4145271690,'Virgo'],
  [4145271690,4145442917,'Libra'],
  [4145442917,4145613131,'Scorpio'],
  [4145613131,4145790002,'Sagittarius'],
  [4145790002,4145978820,'Capricorn'],
  [4145978820,4146180507,'Aquarius'],
  [4146180507,4146391878,'Pisces'],
  [4146391878,4146608503,'Aries'],
  [4146608503,4146827001,'Taurus'],
  [4146827001,4147044202,'Gemini'],
  [4147044202,4147255288,'Cancer'],
  [4147255288,4147454798,'Leo'],
  [4147454798,4147640311,'Virgo'],
  [4147640311,4147814583,'Libra'],
  [4147814583,4147984190,'Scorpio'],
  [4147984190,4148156982,'Sagittarius'],
  [4148156982,4148339903,'Capricorn'],
  [4148339903,4148536655,'Aquarius'],
  [4148536655,4148746002,'Pisces'],
  [4148746002,4148962761,'Aries'],
  [4148962761,4149181271,'Taurus'],
  [4149181271,4149397582,'Gemini'],
  [4149397582,4149608541,'Cancer'],
  [4149608541,4149810739,'Leo'],
  [4149810739,4150001593,'Virgo'],
  [4150001593,4150181578,'Libra'],
  [4150181578,4150354821,'Scorpio'],
  [4150354821,4150527759,'Sagittarius'],
  [4150527759,4150707300,'Capricorn'],
  [4150707300,4150898830,'Aquarius'],
  [4150898830,4151103949,'Pisces'],
  [4151103949,4151319164,'Aries'],
  [4151319164,4151537584,'Taurus'],
  [4151537584,4151753015,'Gemini'],
  [4151753015,4151962003,'Cancer'],
  [4151962003,4152163118,'Leo'],
  [4152163118,4152355828,'Virgo'],
  [4152355828,4152540544,'Libra'],
  [4152540544,4152719371,'Scorpio'],
  [4152719371,4152896280,'Sagittarius'],
  [4152896280,4153076524,'Capricorn'],
  [4153076524,4153265421,'Aquarius'],
  [4153265421,4153466452,'Pisces'],
  [4153466452,4153678927,'Aries'],
  [4153678927,4153896974,'Taurus'],
  [4153896974,4154112478,'Gemini'],
  [4154112478,4154319859,'Cancer'],
  [4154319859,4154517873,'Leo'],
  [4154517873,4154708208,'Virgo'],
  [4154708208,4154893412,'Libra'],
  [4154893412,4155075864,'Scorpio'],
  [4155075864,4155257834,'Sagittarius'],
  [4155257834,4155442043,'Capricorn'],
  [4155442043,4155631986,'Aquarius'],
  [4155631986,4155831207,'Pisces'],
  [4155831207,4156041163,'Aries'],
  [4156041163,4156258556,'Taurus'],
  [4156258556,4156475277,'Gemini'],
  [4156475277,4156683192,'Cancer'],
  [4156683192,4156879164,'Leo'],
  [4156879164,4157065423,'Virgo'],
  [4157065423,4157246804,'Libra'],
  [4157246804,4157428007,'Scorpio'],
  [4157428007,4157612089,'Sagittarius'],
  [4157612089,4157800428,'Capricorn'],
  [4157800428,4157993967,'Aquarius'],
  [4157993967,4158194362,'Pisces'],
  [4158194362,4158403356,'Aries'],
  [4158403356,4158620065,'Taurus'],
  [4158620065,4158838463,'Gemini'],
  [4158838463,4159049347,'Cancer'],
  [4159049347,4159246623,'Leo'],
  [4159246623,4159430870,'Virgo'],
  [4159430870,4159607555,'Libra'],
  [4159607555,4159783553,'Scorpio'],
  [4159783553,4159964506,'Sagittarius'],
  [4159964506,4160153190,'Capricorn'],
  [4160153190,4160349605,'Aquarius'],
  [4160349605,4160552897,'Pisces'],
  [4160552897,4160762914,'Aries'],
  [4160762914,4160979346,'Taurus'],
  [4160979346,4161198776,'Gemini'],
  [4161198776,4161413449,'Cancer'],
  [4161413449,4161615365,'Leo'],
  [4161615365,4161801993,'Virgo'],
  [4161801993,4161977258,'Libra'],
  [4161977258,4162148460,'Scorpio'],
  [4162148460,4162323190,'Sagittarius'],
  [4162323190,4162507074,'Capricorn'],
  [4162507074,4162702118,'Aquarius'],
  [4162702118,4162906941,'Pisces'],
  [4162906941,4163118908,'Aries'],
  [4163118908,4163335837,'Taurus'],
  [4163335837,4163555220,'Gemini'],
  [4163555220,4163772003,'Cancer'],
  [4163772003,4163979115,'Leo'],
  [4163979115,4164171717,'Virgo'],
  [4164171717,4164350616,'Libra'],
  [4164350616,4164521454,'Scorpio'],
  [4164521454,4164691858,'Sagittarius'],
  [4164691858,4164869147,'Capricorn'],
  [4164869147,4165058375,'Aquarius'],
  [4165058375,4165260641,'Pisces'],
  [4165260641,4165473068,'Aries'],
  [4165473068,4165690900,'Taurus'],
  [4165690900,4165909866,'Gemini'],
  [4165909866,4166126151,'Cancer'],
  [4166126151,4166335425,'Leo'],
  [4166335425,4166533584,'Virgo'],
  [4166533584,4166719176,'Libra'],
  [4166719176,4166894772,'Scorpio'],
  [4166894772,4167066028,'Sagittarius'],
  [4167066028,4167239900,'Capricorn'],
  [4167239900,4167422953,'Aquarius'],
  [4167422953,4167619418,'Pisces'],
  [4167619418,4167829098,'Aries'],
  [4167829098,4168046917,'Taurus'],
  [4168046917,4168265858,'Gemini'],
  [4168265858,4168480584,'Cancer'],
  [4168480584,4168688293,'Leo'],
  [4168688293,4168887637,'Virgo'],
  [4168887637,4169078028,'Libra'],
  [4169078028,4169260194,'Scorpio'],
  [4169260194,4169436818,'Sagittarius'],
  [4169436818,4169612565,'Capricorn'],
  [4169612565,4169793335,'Aquarius'],
  [4169793335,4169984769,'Pisces'],
  [4169984769,4170189783,'Aries'],
  [4170189783,4170405790,'Taurus'],
  [4170405790,4170624935,'Gemini'],
  [4170624935,4170839040,'Cancer'],
  [4170839040,4171044137,'Leo'],
  [4171044137,4171240593,'Virgo'],
  [4171240593,4171430519,'Libra'],
  [4171430519,4171615849,'Scorpio'],
  [4171615849,4171798055,'Sagittarius'],
  [4171798055,4171979064,'Capricorn'],
  [4171979064,4172162310,'Aquarius'],
  [4172162310,4172352581,'Pisces'],
  [4172352581,4172554162,'Aries'],
  [4172554162,4172767483,'Taurus'],
  [4172767483,4172986547,'Gemini'],
  [4172986547,4173201608,'Cancer'],
  [4173201608,4173405925,'Leo'],
  [4173405925,4173599096,'Virgo'],
  [4173599096,4173784937,'Libra'],
  [4173784937,4173967976,'Scorpio'],
  [4173967976,4174151309,'Sagittarius'],
  [4174151309,4174336327,'Capricorn'],
  [4174336327,4174524104,'Aquarius'],
  [4174524104,4174716954,'Pisces'],
  [4174716954,4174918234,'Aries'],
  [4174918234,4175129820,'Taurus'],
  [4175129820,4175348513,'Gemini'],
  [4175348513,4175565475,'Cancer'],
  [4175565475,4175771750,'Leo'],
  [4175771750,4175964397,'Virgo'],
  [4175964397,4176146747,'Libra'],
  [4176146747,4176324848,'Scorpio'],
  [4176324848,4176504291,'Sagittarius'],
  [4176504291,4176688476,'Capricorn'],
  [4176688476,4176878542,'Aquarius'],
  [4176878542,4177074843,'Pisces'],
  [4177074843,4177278335,'Aries'],
  [4177278335,4177490075,'Taurus'],
  [4177490075,4177708524,'Gemini'],
  [4177708524,4177927247,'Cancer'],
  [4177927247,4178137193,'Leo'],
  [4178137193,4178332809,'Virgo'],
  [4178332809,4178515179,'Libra'],
  [4178515179,4178689949,'Scorpio'],
  [4178689949,4178863993,'Sagittarius'],
  [4178863993,4179043136,'Capricorn'],
  [4179043136,4179230821,'Aquarius'],
  [4179230821,4179427922,'Pisces'],
  [4179427922,4179633701,'Aries'],
  [4179633701,4179846919,'Taurus'],
  [4179846919,4180065556,'Gemini'],
  [4180065556,4180285093,'Cancer'],
  [4180285093,4180498386,'Leo'],
  [4180498386,4180698980,'Virgo'],
  [4180698980,4180885215,'Libra'],
  [4180885215,4181060675,'Scorpio'],
  [4181060675,4181231770,'Sagittarius'],
  [4181231770,4181405419,'Capricorn'],
  [4181405419,4181587449,'Aquarius'],
  [4181587449,4181781229,'Pisces'],
  [4181781229,4181986792,'Aries'],
  [4181986792,4182201223,'Taurus'],
  [4182201223,4182420370,'Gemini'],
  [4182420370,4182639733,'Cancer'],
  [4182639733,4182854313,'Leo'],
  [4182854313,4183059104,'Virgo'],
  [4183059104,4183251095,'Libra'],
  [4183251095,4183431137,'Scorpio'],
  [4183431137,4183603592,'Sagittarius'],
  [4183603592,4183774804,'Capricorn'],
  [4183774804,4183951588,'Aquarius'],
  [4183951588,4184139688,'Pisces'],
  [4184139688,4184341734,'Aries'],
  [4184341734,4184555518,'Taurus'],
  [4184555518,4184774989,'Gemini'],
  [4184774989,4184993778,'Cancer'],
  [4184993778,4185207449,'Leo'],
  [4185207449,4185413321,'Virgo'],
  [4185413321,4185609558,'Libra'],
  [4185609558,4185795595,'Scorpio'],
  [4185795595,4185973106,'Sagittarius'],
  [4185973106,4186146295,'Capricorn'],
  [4186146295,4186321272,'Aquarius'],
  [4186321272,4186504714,'Pisces'],
  [4186504714,4186701686,'Aries'],
  [4186701686,4186912572,'Taurus'],
  [4186912572,4187131564,'Gemini'],
  [4187131564,4187350050,'Cancer'],
  [4187350050,4187562056,'Leo'],
  [4187562056,4187765958,'Virgo'],
  [4187765958,4187962361,'Libra'],
  [4187962361,4188151903,'Scorpio'],
  [4188151903,4188335082,'Sagittarius'],
  [4188335082,4188513499,'Capricorn'],
  [4188513499,4188690994,'Aquarius'],
  [4188690994,4188873362,'Pisces'],
  [4188873362,4189066589,'Aries'],
  [4189066589,4189273666,'Taurus'],
  [4189273666,4189491158,'Gemini'],
  [4189491158,4189709892,'Cancer'],
  [4189709892,4189921321,'Leo'],
  [4189921321,4190122622,'Virgo'],
  [4190122622,4190315771,'Libra'],
  [4190315771,4190503943,'Scorpio'],
  [4190503943,4190689171,'Sagittarius'],
  [4190689171,4190872337,'Capricorn'],
  [4190872337,4191054864,'Aquarius'],
  [4191054864,4191240122,'Pisces'],
  [4191240122,4191432998,'Aries'],
  [4191432998,4191637513,'Taurus'],
  [4191637513,4191853050,'Gemini'],
  [4191853050,4192072284,'Cancer'],
  [4192072284,4192285168,'Leo'],
  [4192285168,4192486082,'Virgo'],
  [4192486082,4192676048,'Libra'],
  [4192676048,4192859668,'Scorpio'],
  [4192859668,4193041621,'Sagittarius'],
  [4193041621,4193224835,'Capricorn'],
  [4193224835,4193410640,'Aquarius'],
  [4193410640,4193600295,'Pisces'],
  [4193600295,4193796093,'Aries'],
  [4193796093,4194000780,'Taurus'],
  [4194000780,4194215041,'Gemini'],
  [4194215041,4194434476,'Cancer'],
  [4194434476,4194650108,'Leo'],
  [4194650108,4194853988,'Virgo'],
  [4194853988,4195044256,'Libra'],
  [4195044256,4195224619,'Scorpio'],
  [4195224619,4195401040,'Sagittarius'],
  [4195401040,4195579138,'Capricorn'],
  [4195579138,4195762804,'Aquarius'],
  [4195762804,4195953925,'Pisces'],
  [4195953925,4196153054,'Aries'],
  [4196153054,4196360198,'Taurus'],
  [4196360198,4196574763,'Gemini'],
  [4196574763,4196794000,'Cancer'],
  [4196794000,4197011770,'Leo'],
  [4197011770,4197220388,'Virgo'],
  [4197220388,4197415147,'Libra'],
  [4197415147,4197596859,'Scorpio'],
  [4197596859,4197770497,'Sagittarius'],
  [4197770497,4197942720,'Capricorn'],
  [4197942720,4198120003,'Aquarius'],
  [4198120003,4198307151,'Pisces'],
  [4198307151,4198506021,'Aries'],
  [4198506021,4198715194,'Taurus'],
  [4198715194,4198931280,'Gemini'],
  [4198931280,4199150461,'Cancer'],
  [4199150461,4199368554,'Leo'],
  [4199368554,4199580465,'Virgo'],
  [4199580465,4199781197,'Libra'],
  [4199781197,4199968585,'Scorpio'],
  [4199968585,4200144698,'Sagittarius'],
  [4200144698,4200315061,'Capricorn'],
  [4200315061,4200486883,'Aquarius'],
  [4200486883,4200667293,'Pisces'],
  [4200667293,4200861233,'Aries'],
  [4200861233,4201069025,'Taurus'],
  [4201069025,4201285966,'Gemini'],
  [4201285966,4201505520,'Cancer'],
  [4201505520,4201722776,'Leo'],
  [4201722776,4201934780,'Virgo'],
  [4201934780,4202138847,'Libra'],
  [4202138847,4202332416,'Scorpio'],
  [4202332416,4202514764,'Sagittarius'],
  [4202514764,4202688552,'Capricorn'],
  [4202688552,4202859667,'Aquarius'],
  [4202859667,4203035614,'Pisces'],
  [4203035614,4203223386,'Aries'],
  [4203223386,4203426436,'Taurus'],
  [4203426436,4203641823,'Gemini'],
  [4203641823,4203861541,'Cancer'],
  [4203861541,4204078132,'Leo'],
  [4204078132,4204288298,'Virgo'],
  [4204288298,4204491548,'Libra'],
  [4204491548,4204687487,'Scorpio'],
  [4204687487,4204875260,'Sagittarius'],
  [4204875260,4205055137,'Capricorn'],
  [4205055137,4205230263,'Aquarius'],
  [4205230263,4205406581,'Pisces'],
  [4205406581,4205591125,'Aries'],
  [4205591125,4205789282,'Taurus'],
  [4205789282,4206001182,'Gemini'],
  [4206001182,4206220126,'Cancer'],
  [4206220126,4206436792,'Leo'],
  [4206436792,4206645565,'Virgo'],
  [4206645565,4206845973,'Libra'],
  [4206845973,4207039793,'Scorpio'],
  [4207039793,4207228372,'Sagittarius'],
  [4207228372,4207412271,'Capricorn'],
  [4207412271,4207592759,'Aquarius'],
  [4207592759,4207773203,'Pisces'],
  [4207773203,4207958842,'Aries'],
  [4207958842,4208154944,'Taurus'],
  [4208154944,4208363666,'Gemini'],
  [4208363666,4208581116,'Cancer'],
  [4208581116,4208798415,'Leo'],
  [4208798415,4209007623,'Virgo'],
  [4209007623,4209206258,'Libra'],
  [4209206258,4209396380,'Scorpio'],
  [4209396380,4209581486,'Sagittarius'],
  [4209581486,4209764455,'Capricorn'],
  [4209764455,4209947290,'Aquarius'],
  [4209947290,4210132008,'Pisces'],
  [4210132008,4210321422,'Aries'],
  [4210321422,4210518874,'Taurus'],
  [4210518874,4210726519,'Gemini'],
  [4210726519,4210942688,'Cancer'],
  [4210942688,4211160767,'Leo'],
  [4211160767,4211372206,'Virgo'],
  [4211372206,4211571874,'Libra'],
  [4211571874,4211760140,'Scorpio'],
  [4211760140,4211940947,'Sagittarius'],
  [4211940947,4212119281,'Capricorn'],
  [4212119281,4212299566,'Aquarius'],
  [4212299566,4212484979,'Pisces'],
  [4212484979,4212677435,'Aries'],
  [4212677435,4212877933,'Taurus'],
  [4212877933,4213086746,'Gemini'],
  [4213086746,4213302588,'Cancer'],
  [4213302588,4213521214,'Leo'],
  [4213521214,4213735557,'Virgo'],
  [4213735557,4213938917,'Libra'],
  [4213938917,4214128905,'Scorpio'],
  [4214128905,4214308022,'Sagittarius'],
  [4214308022,4214481779,'Capricorn'],
  [4214481779,4214656599,'Aquarius'],
  [4214656599,4214838147,'Pisces'],
  [4214838147,4215029886,'Aries'],
  [4215029886,4215232209,'Taurus'],
  [4215232209,4215443077,'Gemini'],
  [4215443077,4215659588,'Cancer'],
  [4215659588,4215878372,'Leo'],
  [4215878372,4216094730,'Virgo'],
  [4216094730,4216302627,'Libra'],
  [4216302627,4216497478,'Scorpio'],
  [4216497478,4216679036,'Sagittarius'],
  [4216679036,4216851528,'Capricorn'],
  [4216851528,4217021854,'Aquarius'],
  [4217021854,4217197499,'Pisces'],
  [4217197499,4217384505,'Aries'],
  [4217384505,4217585120,'Taurus'],
  [4217585120,4217796772,'Gemini'],
  [4217796772,4218014255,'Cancer'],
  [4218014255,4218232971,'Leo'],
  [4218232971,4218449562,'Virgo'],
  [4218449562,4218660257,'Libra'],
  [4218660257,4218860574,'Scorpio'],
  [4218860574,4219047824,'Sagittarius'],
  [4219047824,4219223522,'Capricorn'],
  [4219223522,4219393286,'Aquarius'],
  [4219393286,4219564865,'Pisces'],
  [4219564865,4219745960,'Aries'],
  [4219745960,4219941568,'Taurus'],
  [4219941568,4220151128,'Gemini'],
  [4220151128,4220368722,'Cancer'],
  [4220368722,4220587397,'Leo'],
  [4220587397,4220802953,'Virgo'],
  [4220802953,4221013350,'Libra'],
  [4221013350,4221216324,'Scorpio'],
  [4221216324,4221409166,'Sagittarius'],
  [4221409166,4221591002,'Capricorn'],
  [4221591002,4221764756,'Aquarius'],
  [4221764756,4221936678,'Pisces'],
  [4221936678,4222114413,'Aries'],
  [4222114413,4222304593,'Taurus'],
  [4222304593,4222509638,'Gemini'],
  [4222509638,4222725551,'Cancer'],
  [4222725551,4222944195,'Leo'],
  [4222944195,4223158884,'Virgo'],
  [4223158884,4223367085,'Libra'],
  [4223367085,4223568560,'Scorpio'],
  [4223568560,4223762957,'Sagittarius'],
  [4223762957,4223949660,'Capricorn'],
  [4223949660,4224129509,'Aquarius'],
  [4224129509,4224306044,'Pisces'],
  [4224306044,4224485019,'Aries'],
  [4224485019,4224672724,'Taurus'],
  [4224672724,4224873382,'Gemini'],
  [4224873382,4225086159,'Cancer'],
  [4225086159,4225304386,'Leo'],
  [4225304386,4225519471,'Virgo'],
  [4225519471,4225726300,'Libra'],
  [4225726300,4225924405,'Scorpio'],
  [4225924405,4226115647,'Sagittarius'],
  [4226115647,4226302032,'Capricorn'],
  [4226302032,4226485202,'Aquarius'],
  [4226485202,4226667144,'Pisces'],
  [4226667144,4226850899,'Aries'],
  [4226850899,4227040458,'Taurus'],
  [4227040458,4227239584,'Gemini'],
  [4227239584,4227449533,'Cancer'],
  [4227449533,4227666757,'Leo'],
  [4227666757,4227883309,'Virgo'],
  [4227883309,4228091445,'Libra'],
  [4228091445,4228288124,'Scorpio'],
  [4228288124,4228475138,'Sagittarius'],
  [4228475138,4228656725,'Capricorn'],
  [4228656725,4228837350,'Aquarius'],
  [4228837350,4229020473,'Pisces'],
  [4229020473,4229208272,'Aries'],
  [4229208272,4229402117,'Taurus'],
  [4229402117,4229603231,'Gemini'],
  [4229603231,4229812481,'Cancer'],
  [4229812481,4230028660,'Leo'],
  [4230028660,4230246600,'Virgo'],
  [4230246600,4230458229,'Libra'],
  [4230458229,4230657391,'Scorpio'],
  [4230657391,4230843419,'Sagittarius'],
  [4230843419,4231020544,'Capricorn'],
  [4231020544,4231195245,'Aquarius'],
  [4231195245,4231373819,'Pisces'],
  [4231373819,4231560551,'Aries'],
  [4231560551,4231756667,'Taurus'],
  [4231756667,4231960988,'Gemini'],
  [4231960988,4232171842,'Cancer'],
  [4232171842,4232387827,'Leo'],
  [4232387827,4232606236,'Virgo'],
  [4232606236,4232821219,'Libra'],
  [4232821219,4233025510,'Scorpio'],
  [4233025510,4233215179,'Sagittarius'],
  [4233215179,4233392180,'Capricorn'],
  [4233392180,4233562893,'Aquarius'],
  [4233562893,4233735203,'Pisces'],
  [4233735203,4233916098,'Aries'],
  [4233916098,4234109386,'Taurus'],
  [4234109386,4234314314,'Gemini'],
  [4234314314,4234527063,'Cancer'],
  [4234527063,4234743864,'Leo'],
  [4234743864,4234962082,'Virgo'],
  [4234962082,4235178321,'Libra'],
  [4235178321,4235386991,'Scorpio'],
  [4235386991,4235582700,'Sagittarius'],
  [4235582700,4235764265,'Capricorn'],
  [4235764265,4235935932,'Aquarius'],
  [4235935932,4236105208,'Pisces'],
  [4236105208,4236280207,'Aries'],
  [4236280207,4236467303,'Taurus'],
  [4236467303,4236668580,'Gemini'],
  [4236668580,4236880898,'Cancer'],
  [4236880898,4237098454,'Leo'],
  [4237098454,4237316491,'Virgo'],
  [4237316491,4237532012,'Libra'],
  [4237532012,4237741822,'Scorpio'],
  [4237741822,4237941903,'Sagittarius'],
  [4237941903,4238129644,'Capricorn'],
  [4238129644,4238306434,'Aquarius'],
  [4238306434,4238477654,'Pisces'],
  [4238477654,4238650676,'Aries'],
  [4238650676,4238832693,'Taurus'],
  [4238832693,4239028326,'Gemini'],
  [4239028326,4239237278,'Cancer'],
  [4239237278,4239454229,'Leo'],
  [4239454229,4239672257,'Virgo'],
  [4239672257,4239886562,'Libra'],
  [4239886562,4240094710,'Scorpio'],
  [4240094710,4240295083,'Sagittarius'],
  [4240295083,4240486389,'Capricorn'],
  [4240486389,4240668857,'Aquarius'],
  [4240668857,4240845323,'Pisces'],
  [4240845323,4241020935,'Aries'],
  [4241020935,4241201859,'Taurus'],
  [4241201859,4241393481,'Gemini'],
  [4241393481,4241598098,'Cancer'],
  [4241598098,4241812948,'Leo'],
  [4241812948,4242030921,'Virgo'],
  [4242030921,4242244817,'Libra'],
  [4242244817,4242450800,'Scorpio'],
  [4242450800,4242648379,'Sagittarius'],
  [4242648379,4242838712,'Capricorn'],
  [4242838712,4243023434,'Aquarius'],
  [4243023434,4243204625,'Pisces'],
  [4243204625,4243385168,'Aries'],
  [4243385168,4243568895,'Taurus'],
  [4243568895,4243760064,'Gemini'],
  [4243760064,4243961904,'Cancer'],
  [4243961904,4244174294,'Leo'],
  [4244174294,4244392050,'Virgo'],
  [4244392050,4244606840,'Libra'],
  [4244606840,4244812293,'Scorpio'],
  [4244812293,4245006970,'Sagittarius'],
  [4245006970,4245193429,'Capricorn'],
  [4245193429,4245375747,'Aquarius'],
  [4245375747,4245557619,'Pisces'],
  [4245557619,4245741638,'Aries'],
  [4245741638,4245929609,'Taurus'],
  [4245929609,4246123408,'Gemini'],
  [4246123408,4246325225,'Cancer'],
  [4246325225,4246536168,'Leo'],
  [4246536168,4246753636,'Virgo'],
  [4246753636,4246970282,'Libra'],
  [4246970282,4247177712,'Scorpio'],
  [4247177712,4247372004,'Sagittarius'],
  [4247372004,4247555164,'Capricorn'],
  [4247555164,4247732728,'Aquarius'],
  [4247732728,4247910777,'Pisces'],
  [4247910777,4248093837,'Aries'],
  [4248093837,4248283886,'Taurus'],
  [4248283886,4248480977,'Gemini'],
  [4248480977,4248684950,'Cancer'],
  [4248684950,4248896099,'Leo'],
  [4248896099,4249113406,'Virgo'],
  [4249113406,4249331878,'Libra'],
  [4249331878,4249543082,'Scorpio'],
  [4249543082,4249740458,'Sagittarius'],
  [4249740458,4249923695,'Capricorn'],
  [4249923695,4250097965,'Aquarius'],
  [4250097965,4250270658,'Pisces'],
  [4250270658,4250448651,'Aries'],
  [4250448651,4250636228,'Taurus'],
  [4250636228,4250834028,'Gemini'],
  [4250834028,4251040224,'Cancer'],
  [4251040224,4251252813,'Leo'],
  [4251252813,4251470279,'Virgo'],
  [4251470279,4251689569,'Libra'],
  [4251689569,4251904255,'Scorpio'],
  [4251904255,4252106930,'Sagittarius'],
  [4252106930,4252294358,'Capricorn'],
  [4252294358,4252469507,'Aquarius'],
  [4252469507,4252639314,'Pisces'],
  [4252639314,4252811696,'Aries'],
  [4252811696,4252993317,'Taurus'],
  [4252993317,4253187500,'Gemini'],
  [4253187500,4253393318,'Cancer'],
  [4253393318,4253607120,'Leo'],
  [4253607120,4253825101,'Virgo'],
  [4253825101,4254044092,'Libra'],
  [4254044092,4254259915,'Scorpio'],
  [4254259915,4254466907,'Sagittarius'],
  [4254466907,4254660596,'Capricorn'],
  [4254660596,4254840977,'Aquarius'],
  [4254840977,4255012713,'Pisces'],
  [4255012713,4255182949,'Aries'],
  [4255182949,4255359132,'Taurus'],
  [4255359132,4255547059,'Gemini'],
  [4255547059,4255748796,'Cancer'],
  [4255748796,4255961716,'Leo'],
  [4255961716,4256180121,'Virgo'],
  [4256180121,4256398549,'Libra'],
  [4256398549,4256613112,'Scorpio'],
  [4256613112,4256820672,'Sagittarius'],
  [4256820672,4257018467,'Capricorn'],
  [4257018467,4257205330,'Aquarius'],
  [4257205330,4257383056,'Pisces'],
  [4257383056,4257556270,'Aries'],
  [4257556270,4257731242,'Taurus'],
  [4257731242,4257914398,'Gemini'],
  [4257914398,4258110401,'Cancer'],
  [4258110401,4258319764,'Leo'],
  [4258319764,4258537567,'Virgo'],
  [4258537567,4258755989,'Libra'],
  [4258755989,4258968930,'Scorpio'],
  [4258968930,4259173908,'Sagittarius'],
  [4259173908,4259370883,'Capricorn'],
  [4259370883,4259560579,'Aquarius'],
  [4259560579,4259744102,'Pisces'],
  [4259744102,4259923462,'Aries'],
  [4259923462,4260102145,'Taurus'],
  [4260102145,4260285057,'Gemini'],
  [4260285057,4260477423,'Cancer'],
  [4260477423,4260682452,'Leo'],
  [4260682452,4260898251,'Virgo'],
  [4260898251,4261117097,'Libra'],
  [4261117097,4261330070,'Scorpio'],
  [4261330070,4261532677,'Sagittarius'],
  [4261532677,4261725776,'Capricorn'],
  [4261725776,4261912815,'Aquarius'],
  [4261912815,4262097103,'Pisces'],
  [4262097103,4262280687,'Aries'],
  [4262280687,4262464876,'Taurus'],
  [4262464876,4262651696,'Gemini'],
  [4262651696,4262844622,'Cancer'],
  [4262844622,4263047392,'Leo'],
  [4263047392,4263260875,'Virgo'],
  [4263260875,4263479924,'Libra'],
  [4263479924,4263694813,'Scorpio'],
  [4263694813,4263897965,'Sagittarius'],
  [4263897965,4264088509,'Capricorn'],
  [4264088509,4264270800,'Aquarius'],
  [4264270800,4264450675,'Pisces'],
  [4264450675,4264632698,'Aries'],
  [4264632698,4264818997,'Taurus'],
  [4264818997,4265010014,'Gemini'],
  [4265010014,4265206456,'Cancer'],
  [4265206456,4265410197,'Leo'],
  [4265410197,4265622690,'Virgo'],
  [4265622690,4265841542,'Libra'],
  [4265841542,4266058877,'Scorpio'],
  [4266058877,4266265494,'Sagittarius'],
  [4266265494,4266457436,'Capricorn'],
  [4266457436,4266637568,'Aquarius'],
  [4266637568,4266812422,'Pisces'],
  [4266812422,4266988795,'Aries'],
  [4266988795,4267171549,'Taurus'],
  [4267171549,4267362599,'Gemini'],
  [4267362599,4267561668,'Cancer'],
  [4267561668,4267768058,'Leo'],
  [4267768058,4267981404,'Virgo'],
  [4267981404,4268200106,'Libra'],
  [4268200106,4268418920,'Scorpio'],
  [4268418920,4268629706,'Sagittarius'],
  [4268629706,4268826370,'Capricorn'],
  [4268826370,4269008862,'Aquarius'],
  [4269008862,4269182313,'Pisces'],
  [4269182313,4269353911,'Aries'],
  [4269353911,4269530472,'Taurus'],
  [4269530472,4269716741,'Gemini'],
  [4269716741,4269914340,'Cancer'],
  [4269914340,4270121981,'Leo'],
  [4270121981,4270336862,'Virgo'],
  [4270336862,4270555824,'Libra'],
  [4270555824,4270774742,'Scorpio'],
  [4270774742,4270987913,'Sagittarius'],
  [4270987913,4271189675,'Capricorn'],
  [4271189675,4271377680,'Aquarius'],
  [4271377680,4271554329,'Pisces'],
  [4271554329,4271725353,'Aries'],
  [4271725353,4271897704,'Taurus'],
  [4271897704,4272077892,'Gemini'],
  [4272077892,4272270373,'Cancer'],
  [4272270373,4272475917,'Leo'],
  [4272475917,4272691146,'Virgo'],
  [4272691146,4272910519,'Libra'],
  [4272910519,4273128787,'Scorpio'],
  [4273128787,4273341740,'Sagittarius'],
  [4273341740,4273545964,'Capricorn'],
  [4273545964,4273739208,'Aquarius'],
  [4273739208,4273921666,'Pisces'],
  [4273921666,4274096451,'Aries'],
  [4274096451,4274268952,'Taurus'],
  [4274268952,4274445668,'Gemini'],
  [4274445668,4274632724,'Cancer'],
  [4274632724,4274833691,'Leo'],
  [4274833691,4275047099,'Virgo'],
  [4275047099,4275266439,'Libra'],
  [4275266439,4275484141,'Scorpio'],
  [4275484141,4275695392,'Sagittarius'],
  [4275695392,4275898611,'Capricorn'],
  [4275898611,4276093664,'Aquarius'],
  [4276093664,4276280839,'Pisces'],
  [4276280839,4276461270,'Aries'],
  [4276461270,4276637788,'Taurus'],
  [4276637788,4276815235,'Gemini'],
  [4276815235,4276999651,'Cancer'],
  [4276999651,4277196288,'Leo'],
  [4277196288,4277406436,'Virgo'],
  [4277406436,4277624961,'Libra'],
  [4277624961,4277842695,'Scorpio'],
  [4277842695,4278052633,'Sagittarius'],
  [4278052633,4278253113,'Capricorn'],
  [4278253113,4278446035,'Aquarius'],
  [4278446035,4278633799,'Pisces'],
  [4278633799,4278817901,'Aries'],
  [4278817901,4278999498,'Taurus'],
  [4278999498,4279180946,'Gemini'],
  [4279180946,4279366526,'Cancer'],
  [4279366526,4279561382,'Leo'],
  [4279561382,4279768653,'Virgo'],
  [4279768653,4279985831,'Libra'],
  [4279985831,4280204235,'Scorpio'],
  [4280204235,4280414625,'Sagittarius'],
  [4280414625,4280613362,'Capricorn'],
  [4280613362,4280802637,'Aquarius'],
  [4280802637,4280986939,'Pisces'],
  [4280986939,4281170032,'Aries'],
  [4281170032,4281353865,'Taurus'],
  [4281353865,4281539494,'Gemini'],
  [4281539494,4281728796,'Cancer'],
  [4281728796,4281925034,'Leo'],
  [4281925034,4282131335,'Virgo'],
  [4282131335,4282347336,'Libra'],
  [4282347336,4282566628,'Scorpio'],
  [4282566628,4282779416,'Sagittarius'],
  [4282779416,4282979337,'Capricorn'],
  [4282979337,4283166831,'Aquarius'],
  [4283166831,4283346803,'Pisces'],
  [4283346803,4283525081,'Aries'],
  [4283525081,4283706139,'Taurus'],
  [4283706139,4283892339,'Gemini'],
  [4283892339,4284084680,'Cancer'],
  [4284084680,4284284069,'Leo'],
  [4284284069,4284491649,'Virgo'],
  [4284491649,4284707329,'Libra'],
  [4284707329,4284927149,'Scorpio'],
  [4284927149,4285143027,'Sagittarius'],
  [4285143027,4285347088,'Capricorn'],
  [4285347088,4285536781,'Aquarius'],
  [4285536781,4285715353,'Pisces'],
  [4285715353,4285888963,'Aries'],
  [4285888963,4286064079,'Taurus'],
  [4286064079,4286245841,'Gemini'],
  [4286245841,4286437092,'Cancer'],
  [4286437092,4286638274,'Leo'],
  [4286638274,4286848134,'Virgo'],
  [4286848134,4287064594,'Libra'],
  [4287064594,4287284398,'Scorpio'],
  [4287284398,4287502113,'Sagittarius'],
  [4287502113,4287710988,'Capricorn'],
  [4287710988,4287906330,'Aquarius'],
  [4287906330,4288088277,'Pisces'],
  [4288088277,4288261247,'Aries'],
  [4288261247,4288431853,'Taurus'],
  [4288431853,4288607077,'Gemini'],
  [4288607077,4288792695,'Cancer'],
  [4288792695,4288991486,'Leo'],
  [4288991486,4289202016,'Virgo'],
  [4289202016,4289419681,'Libra'],
  [4289419681,4289639388,'Scorpio'],
  [4289639388,4289856845,'Sagittarius'],
  [4289856845,4290068031,'Capricorn'],
  [4290068031,4290269000,'Aquarius'],
  [4290269000,4290457582,'Pisces'],
  [4290457582,4290635029,'Aries'],
  [4290635029,4290806036,'Taurus'],
  [4290806036,4290977470,'Gemini'],
  [4290977470,4291156710,'Cancer'],
  [4291156710,4291349521,'Leo'],
  [4291349521,4291557135,'Virgo'],
  [4291557135,4291774772,'Libra'],
  [4291774772,4291994658,'Scorpio'],
  [4291994658,4292210913,'Sagittarius'],
  [4292210913,4292420990,'Capricorn'],
  [4292420990,4292623662,'Aquarius'],
  [4292623662,4292817526,'Pisces'],
  [4292817526,4293001794,'Aries'],
  [4293001794,4293178040,'Taurus'],
  [4293178040,4293351004,'Gemini'],
  [4293351004,4293527604,'Cancer'],
  [4293527604,4293714943,'Leo'],
  [4293714943,4293917281,'Virgo'],
  [4293917281,4294132527,'Libra'],
  [4294132527,4294352372,'Scorpio'],
  [4294352372,4294568124,'Sagittarius'],
  [4294568124,4294775938,'Capricorn'],
  [4294775938,4294976214,'Aquarius'],
  [4294976214,4295170246,'Pisces'],
  [4295170246,4295358383,'Aries'],
  [4295358383,4295540727,'Taurus'],
  [4295540727,4295719137,'Gemini'],
  [4295719137,4295898179,'Cancer'],
  [4295898179,4296084116,'Leo'],
  [4296084116,4296282410,'Virgo'],
  [4296282410,4296494041,'Libra'],
  [4296494041,4296712992,'Scorpio'],
  [4296712992,4296929381,'Sagittarius'],
  [4296929381,4297136507,'Capricorn'],
  [4297136507,4297333758,'Aquarius'],
  [4297333758,4297524039,'Pisces'],
  [4297524039,4297710393,'Aries'],
  [4297710393,4297894545,'Taurus'],
  [4297894545,4298077599,'Gemini'],
  [4298077599,4298261639,'Cancer'],
  [4298261639,4298450417,'Leo'],
  [4298450417,4298648287,'Virgo'],
  [4298648287,4298857509,'Libra'],
  [4298857509,4299075071,'Scorpio'],
  [4299075071,4299292588,'Sagittarius'],
  [4299292588,4299501441,'Capricorn'],
  [4299501441,4299698266,'Aquarius'],
  [4299698266,4299885173,'Pisces'],
  [4299885173,4300066710,'Aries'],
  [4300066710,4300247271,'Taurus'],
  [4300247271,4300429987,'Gemini'],
  [4300429987,4300616890,'Cancer'],
  [4300616890,4300809686,'Leo'],
  [4300809686,4301010165,'Virgo'],
  [4301010165,4301219491,'Libra'],
  [4301219491,4301436176,'Scorpio'],
  [4301436176,4301654561,'Sagittarius'],
  [4301654561,4301866516,'Capricorn'],
  [4301866516,4302066215,'Aquarius'],
  [4302066215,4302253216,'Pisces'],
  [4302253216,4302431416,'Aries'],
  [4302431416,4302606579,'Taurus'],
  [4302606579,4302784392,'Gemini'],
  [4302784392,4302969186,'Cancer'],
  [4302969186,4303163179,'Leo'],
  [4303163179,4303366432,'Virgo'],
  [4303366432,4303577624,'Libra'],
  [4303577624,4303794493,'Scorpio'],
  [4303794493,4304013187,'Sagittarius'],
  [4304013187,4304227825,'Capricorn'],
  [4304227825,4304432137,'Aquarius'],
  [4304432137,4304622968,'Pisces'],
  [4304622968,4304801868,'Aries'],
  [4304801868,4304974046,'Taurus'],
  [4304974046,4305146380,'Gemini'],
  [4305146380,4305325570,'Cancer'],
  [4305325570,4305516312,'Leo'],
  [4305516312,4305719520,'Virgo'],
  [4305719520,4305932253,'Libra'],
  [4305932253,4306149984,'Scorpio'],
  [4306149984,4306368580,'Sagittarius'],
  [4306368580,4306584186,'Capricorn'],
  [4306584186,4306792249,'Aquarius'],
  [4306792249,4306988584,'Pisces'],
  [4306988584,4307171991,'Aries'],
  [4307171991,4307345504,'Taurus'],
  [4307345504,4307515447,'Gemini'],
  [4307515447,4307689479,'Cancer'],
  [4307689479,4307874514,'Leo'],
  [4307874514,4308074068,'Virgo'],
  [4308074068,4308286095,'Libra'],
  [4308286095,4308504367,'Scorpio'],
  [4308504367,4308722770,'Sagittarius'],
  [4308722770,4308937675,'Capricorn'],
  [4308937675,4309146693,'Aquarius'],
  [4309146693,4309347000,'Pisces'],
  [4309347000,4309536198,'Aries'],
  [4309536198,4309714650,'Taurus'],
  [4309714650,4309886581,'Gemini'],
  [4309886581,4310058955,'Cancer'],
  [4310058955,4310239429,'Leo'],
  [4310239429,4310433748,'Virgo'],
  [4310433748,4310642509,'Libra'],
  [4310642509,4310860076,'Scorpio'],
  [4310860076,4311078373,'Sagittarius'],
  [4311078373,4311292063,'Capricorn'],
  [4311292063,4311499446,'Aquarius'],
  [4311499446,4311699980,'Pisces'],
  [4311699980,4311892591,'Aries'],
  [4311892591,4312076578,'Taurus'],
  [4312076578,4312253655,'Gemini'],
  [4312253655,4312428622,'Cancer'],
  [4312428622,4312608181,'Leo'],
  [4312608181,4312798746,'Virgo'],
  [4312798746,4313003334,'Libra'],
  [4313003334,4313218824,'Scorpio'],
  [4313218824,4313437062,'Sagittarius'],
  [4313437062,4313650359,'Capricorn'],
  [4313650359,4313855588,'Aquarius'],
  [4313855588,4314053271,'Pisces'],
  [4314053271,4314244778,'Aries'],
  [4314244778,4314430954,'Taurus'],
  [4314430954,4314612806,'Gemini'],
  [4314612806,4314792837,'Cancer'],
  [4314792837,4314975396,'Leo'],
  [4314975396,4315165681,'Virgo'],
  [4315165681,4315367527,'Libra'],
  [4315367527,4315580502,'Scorpio'],
  [4315580502,4315798544,'Sagittarius'],
  [4315798544,4316012933,'Capricorn'],
  [4316012933,4316217843,'Aquarius'],
  [4316217843,4316412632,'Pisces'],
  [4316412632,4316599974,'Aries'],
  [4316599974,4316783327,'Taurus'],
  [4316783327,4316965615,'Gemini'],
  [4316965615,4317149175,'Cancer'],
  [4317149175,4317336309,'Leo'],
  [4317336309,4317529634,'Virgo'],
  [4317529634,4317731643,'Libra'],
  [4317731643,4317943056,'Scorpio'],
  [4317943056,4318160673,'Sagittarius'],
  [4318160673,4318377135,'Capricorn'],
  [4318377135,4318584600,'Aquarius'],
  [4318584600,4318779527,'Pisces'],
  [4318779527,4318963619,'Aries'],
  [4318963619,4319141704,'Taurus'],
  [4319141704,4319319378,'Gemini'],
  [4319319378,4319501326,'Cancer'],
  [4319501326,4319690349,'Leo'],
  [4319690349,4319887293,'Virgo'],
  [4319887293,4320091918,'Libra'],
  [4320091918,4320303664,'Scorpio'],
  [4320303664,4320520872,'Sagittarius'],
  [4320520872,4320739009,'Capricorn'],
  [4320739009,4320950721,'Aquarius'],
  [4320950721,4321149729,'Pisces'],
  [4321149729,4321334787,'Aries'],
  [4321334787,4321509843,'Taurus'],
  [4321509843,4321681710,'Gemini'],
  [4321681710,4321857599,'Cancer'],
  [4321857599,4322043061,'Leo'],
  [4322043061,4322240133,'Virgo'],
  [4322240133,4322447089,'Libra'],
  [4322447089,4322660616,'Scorpio'],
  [4322660616,4322877960,'Sagittarius'],
  [4322877960,4323096439,'Capricorn'],
  [4323096439,4323311323,'Aquarius'],
  [4323311323,4323516135,'Pisces'],
  [4323516135,4323706577,'Aries'],
  [4323706577,4323883704,'Taurus'],
  [4323883704,4324053395,'Gemini'],
  [4324053395,4324223686,'Cancer'],
  [4324223686,4324402374,'Leo'],
  [4324402374,4324594549,'Virgo'],
  [4324594549,4324800225,'Libra'],
  [4324800225,4325014832,'Scorpio'],
  [4325014832,4325232906,'Sagittarius'],
  [4325232906,4325450897,'Capricorn'],
  [4325450897,4325666126,'Aquarius'],
  [4325666126,4325874505,'Pisces'],
  [4325874505,4326071321,'Aries'],
  [4326071321,4326254667,'Taurus'],
  [4326254667,4326427605,'Gemini'],
  [4326427605,4326596972,'Cancer'],
  [4326596972,4326770896,'Leo'],
  [4326770896,4326956473,'Virgo'],
  [4326956473,4327156957,'Libra'],
  [4327156957,4327369744,'Scorpio'],
  [4327369744,4327588094,'Sagittarius'],
  [4327588094,4327805788,'Capricorn'],
  [4327805788,4328019552,'Aquarius'],
  [4328019552,4328227451,'Pisces'],
  [4328227451,4328427083,'Aries'],
  [4328427083,4328616329,'Taurus'],
  [4328616329,4328795674,'Gemini'],
  [4328795674,4328969193,'Cancer'],
  [4328969193,4329143414,'Leo'],
  [4329143414,4329325367,'Virgo'],
  [4329325367,4329520251,'Libra'],
  [4329520251,4329728737,'Scorpio'],
  [4329728737,4329945806,'Sagittarius'],
  [4329945806,4330163589,'Capricorn'],
  [4330163589,4330376247,'Aquarius'],
  [4330376247,4330581571,'Pisces'],
  [4330581571,4330779381,'Aries'],
  [4330779381,4330969916,'Taurus'],
  [4330969916,4331153864,'Gemini'],
  [4331153864,4331333275,'Cancer'],
  [4331333275,4331511977,'Leo'],
  [4331511977,4331695059,'Virgo'],
  [4331695059,4331887494,'Libra'],
  [4331887494,4332091988,'Scorpio'],
  [4332091988,4332306611,'Sagittarius'],
  [4332306611,4332524463,'Capricorn'],
  [4332524463,4332737520,'Aquarius'],
  [4332737520,4332941238,'Pisces'],
  [4332941238,4333135504,'Aries'],
  [4333135504,4333322808,'Taurus'],
  [4333322808,4333506234,'Gemini'],
  [4333506234,4333688511,'Cancer'],
  [4333688511,4333872025,'Leo'],
  [4333872025,4334059282,'Virgo'],
  [4334059282,4334253175,'Libra'],
  [4334253175,4334456277,'Scorpio'],
  [4334456277,4334668829,'Sagittarius'],
  [4334668829,4334886550,'Capricorn'],
  [4334886550,4335101329,'Aquarius'],
  [4335101329,4335306018,'Pisces'],
  [4335306018,4335498515,'Aries'],
  [4335498515,4335681659,'Taurus'],
  [4335681659,4335860679,'Gemini'],
  [4335860679,4336040712,'Cancer'],
  [4336040712,4336225297,'Leo'],
  [4336225297,4336416000,'Virgo'],
  [4336416000,4336613294,'Libra'],
  [4336613294,4336817755,'Scorpio'],
  [4336817755,4337029762,'Sagittarius'],
  [4337029762,4337247312,'Capricorn'],
  [4337247312,4337464188,'Aquarius'],
  [4337464188,4337672135,'Pisces'],
  [4337672135,4337866275,'Aries'],
  [4337866275,4338047832,'Taurus'],
  [4338047832,4338222486,'Gemini'],
  [4338222486,4338397291,'Cancer'],
  [4338397291,4338578224,'Leo'],
  [4338578224,4338768422,'Virgo'],
  [4338768422,4338967790,'Libra'],
  [4338967790,4339174645,'Scorpio'],
  [4339174645,4339387594,'Sagittarius'],
  [4339387594,4339605159,'Capricorn'],
  [4339605159,4339823417,'Aquarius'],
  [4339823417,4340035211,'Pisces'],
  [4340035211,4340233833,'Aries'],
  [4340233833,4340417764,'Taurus'],
  [4340417764,4340591320,'Gemini'],
  [4340591320,4340761898,'Cancer'],
  [4340761898,4340937148,'Leo'],
  [4340937148,4341122735,'Virgo'],
  [4341122735,4341320448,'Libra'],
  [4341320448,4341528233,'Scorpio'],
  [4341528233,4341742526,'Sagittarius'],
  [4341742526,4341960366,'Capricorn'],
  [4341960366,4342178790,'Aquarius'],
  [4342178790,4342392883,'Pisces'],
  [4342392883,4342596427,'Aries'],
  [4342596427,4342785726,'Taurus'],
  [4342785726,4342962445,'Gemini'],
  [4342962445,4343132627,'Cancer'],
  [4343132627,4343304025,'Leo'],
  [4343304025,4343483845,'Virgo'],
  [4343483845,4343676557,'Libra'],
  [4343676557,4343882156,'Scorpio'],
  [4343882156,4344096656,'Sagittarius'],
  [4344096656,4344314850,'Capricorn'],
  [4344314850,4344532634,'Aquarius'],
  [4344532634,4344746486,'Pisces'],
  [4344746486,4344952432,'Aries'],
  [4344952432,4345146996,'Taurus'],
  [4345146996,4345329625,'Gemini'],
  [4345329625,4345503742,'Cancer'],
  [4345503742,4345675526,'Leo'],
  [4345675526,4345852038,'Virgo'],
  [4345852038,4346039325,'Libra'],
  [4346039325,4346240246,'Scorpio'],
  [4346240246,4346452823,'Sagittarius'],
  [4346452823,4346671006,'Capricorn'],
  [4346671006,4346888263,'Aquarius'],
  [4346888263,4347100323,'Pisces'],
  [4347100323,4347305027,'Aries'],
  [4347305027,4347501245,'Taurus'],
  [4347501245,4347688719,'Gemini'],
  [4347688719,4347868860,'Cancer'],
  [4347868860,4348045164,'Leo'],
  [4348045164,4348222786,'Virgo'],
  [4348222786,4348407475,'Libra'],
  [4348407475,4348603835,'Scorpio'],
  [4348603835,4348812893,'Sagittarius'],
  [4348812893,4349030243,'Capricorn'],
  [4349030243,4349247763,'Aquarius'],
  [4349247763,4349458623,'Pisces'],
  [4349458623,4349660312,'Aries'],
  [4349660312,4349853838,'Taurus'],
  [4349853838,4350041445,'Gemini'],
  [4350041445,4350225226,'Cancer'],
  [4350225226,4350407075,'Leo'],
  [4350407075,4350589406,'Virgo'],
  [4350589406,4350775764,'Libra'],
  [4350775764,4350970397,'Scorpio'],
  [4350970397,4351176290,'Sagittarius'],
  [4351176290,4351392059,'Capricorn'],
  [4351392059,4351610482,'Aquarius'],
  [4351610482,4351822334,'Pisces'],
  [4351822334,4352022552,'Aries'],
  [4352022552,4352212098,'Taurus'],
  [4352212098,4352395417,'Gemini'],
  [4352395417,4352577272,'Cancer'],
  [4352577272,4352760866,'Leo'],
  [4352760866,4352947584,'Virgo'],
  [4352947584,4353138305,'Libra'],
  [4353138305,4353334887,'Scorpio'],
  [4353334887,4353539944,'Sagittarius'],
  [4353539944,4353754265,'Capricorn'],
  [4353754265,4353973453,'Aquarius'],
  [4353973453,4354188227,'Pisces'],
  [4354188227,4354390534,'Aries'],
  [4354390534,4354578919,'Taurus'],
  [4354578919,4354757862,'Gemini'],
  [4354757862,4354934106,'Cancer'],
  [4354934106,4355113639,'Leo'],
  [4355113639,4355299849,'Virgo'],
  [4355299849,4355493282,'Libra'],
  [4355493282,4355693369,'Scorpio'],
  [4355693369,4355900238,'Sagittarius'],
  [4355900238,4356114355,'Capricorn'],
  [4356114355,4356333689,'Aquarius'],
  [4356333689,4356551371,'Pisces'],
  [4356551371,4356758440,'Aries'],
  [4356758440,4356950191,'Taurus'],
  [4356950191,4357128838,'Gemini'],
  [4357128838,4357300991,'Cancer'],
  [4357300991,4357474223,'Leo'],
  [4357474223,4357654721,'Virgo'],
  [4357654721,4357845610,'Libra'],
  [4357845610,4358046663,'Scorpio'],
  [4358046663,4358255862,'Sagittarius'],
  [4358255862,4358471172,'Capricorn'],
  [4358471172,4358690422,'Aquarius'],
  [4358690422,4358909224,'Pisces'],
  [4358909224,4359120560,'Aries'],
  [4359120560,4359318323,'Taurus'],
  [4359318323,4359501520,'Gemini'],
  [4359501520,4359674533,'Cancer'],
  [4359674533,4359844473,'Leo'],
  [4359844473,4360018726,'Virgo'],
  [4360018726,4360203150,'Libra'],
  [4360203150,4360400432,'Scorpio'],
  [4360400432,4360609334,'Sagittarius'],
  [4360609334,4360825794,'Capricorn'],
  [4360825794,4361045253,'Aquarius'],
  [4361045253,4361263503,'Pisces'],
  [4361263503,4361476053,'Aries'],
  [4361476053,4361678385,'Taurus'],
  [4361678385,4361868040,'Gemini'],
  [4361868040,4362046400,'Cancer'],
  [4362046400,4362218267,'Leo'],
  [4362218267,4362390237,'Virgo'],
  [4362390237,4362569101,'Libra'],
  [4362569101,4362760183,'Scorpio'],
  [4362760183,4362965231,'Sagittarius'],
  [4362965231,4363180955,'Capricorn'],
  [4363180955,4363400650,'Aquarius'],
  [4363400650,4363618002,'Pisces'],
  [4363618002,4363829098,'Aries'],
  [4363829098,4364031953,'Taurus'],
  [4364031953,4364225526,'Gemini'],
  [4364225526,4364409993,'Cancer'],
  [4364409993,4364587435,'Leo'],
  [4364587435,4364762042,'Virgo'],
  [4364762042,4364939599,'Libra'],
  [4364939599,4365126221,'Scorpio'],
  [4365126221,4365326216,'Sagittarius'],
  [4365326216,4365539098,'Capricorn'],
  [4365539098,4365758411,'Aquarius'],
  [4365758411,4365975474,'Pisces'],
  [4365975474,4366184681,'Aries'],
  [4366184681,4366385021,'Taurus'],
  [4366385021,4366577921,'Gemini'],
  [4366577921,4366765010,'Cancer'],
  [4366765010,4366947590,'Leo'],
  [4366947590,4367127444,'Virgo'],
  [4367127444,4367307941,'Libra'],
  [4367307941,4367494070,'Scorpio'],
  [4367494070,4367690900,'Sagittarius'],
  [4367690900,4367900495,'Capricorn'],
  [4367900495,4368118722,'Aquarius'],
  [4368118722,4368336283,'Pisces'],
  [4368336283,4368545054,'Aries'],
  [4368545054,4368742803,'Taurus'],
  [4368742803,4368932172,'Gemini'],
  [4368932172,4369117170,'Cancer'],
  [4369117170,4369300756,'Leo'],
  [4369300756,4369484413,'Virgo'],
  [4369484413,4369669438,'Libra'],
  [4369669438,4369858454,'Scorpio'],
  [4369858454,4370055357,'Sagittarius'],
  [4370055357,4370263110,'Capricorn'],
  [4370263110,4370480136,'Aquarius'],
  [4370480136,4370698667,'Pisces'],
  [4370698667,4370909056,'Aries'],
  [4370909056,4371106551,'Taurus'],
  [4371106551,4371292974,'Gemini'],
  [4371292974,4371473579,'Cancer'],
  [4371473579,4371653658,'Leo'],
  [4371653658,4371836645,'Virgo'],
  [4371836645,4372024006,'Libra'],
  [4372024006,4372216612,'Scorpio'],
  [4372216612,4372416031,'Sagittarius'],
  [4372416031,4372624124,'Capricorn'],
  [4372624124,4372840537,'Aquarius'],
  [4372840537,4373059957,'Pisces'],
  [4373059957,4373273309,'Aries'],
  [4373273309,4373473594,'Taurus'],
  [4373473594,4373660231,'Gemini'],
  [4373660231,4373837848,'Cancer'],
  [4373837848,4374012894,'Leo'],
  [4374012894,4374191140,'Virgo'],
  [4374191140,4374376305,'Libra'],
  [4374376305,4374569853,'Scorpio'],
  [4374569853,4374771829,'Sagittarius'],
  [4374771829,4374981763,'Capricorn'],
  [4374981763,4375198460,'Aquarius'],
  [4375198460,4375418248,'Pisces'],
  [4375418248,4375634261,'Aries'],
  [4375634261,4375839179,'Taurus'],
  [4375839179,4376029741,'Gemini'],
  [4376029741,4376208262,'Cancer'],
  [4376208262,4376380550,'Leo'],
  [4376380550,4376553416,'Virgo'],
  [4376553416,4376732943,'Libra'],
  [4376732943,4376923126,'Scorpio'],
  [4376923126,4377124932,'Sagittarius'],
  [4377124932,4377336401,'Capricorn'],
  [4377336401,4377553998,'Aquarius'],
  [4377553998,4377773652,'Pisces'],
  [4377773652,4377990534,'Aries'],
  [4377990534,4378199244,'Taurus'],
  [4378199244,4378395602,'Gemini'],
  [4378395602,4378579067,'Cancer'],
  [4378579067,4378753085,'Leo'],
  [4378753085,4378923695,'Virgo'],
  [4378923695,4379097891,'Libra'],
  [4379097891,4379282049,'Scorpio'],
  [4379282049,4379479911,'Sagittarius'],
  [4379479911,4379690586,'Capricorn'],
  [4379690586,4379908826,'Aquarius'],
  [4379908826,4380128277,'Pisces'],
  [4380128277,4380344204,'Aries'],
  [4380344204,4380553568,'Taurus'],
  [4380553568,4380753924,'Gemini'],
  [4380753924,4380943670,'Cancer'],
  [4380943670,4381123387,'Leo'],
  [4381123387,4381296605,'Virgo'],
  [4381296605,4381469336,'Libra'],
  [4381469336,4381648695,'Scorpio'],
  [4381648695,4381840827,'Sagittarius'],
  [4381840827,4382047806,'Capricorn'],
  [4382047806,4382265290,'Aquarius'],
  [4382265290,4382484800,'Pisces'],
  [4382484800,4382699433,'Aries'],
  [4382699433,4382906674,'Taurus'],
  [4382906674,4383106639,'Gemini'],
  [4383106639,4383299529,'Cancer'],
  [4383299529,4383485166,'Leo'],
  [4383485166,4383664377,'Virgo'],
  [4383664377,4383840512,'Libra'],
  [4383840512,4384019403,'Scorpio'],
  [4384019403,4384207724,'Sagittarius'],
  [4384207724,4384410045,'Capricorn'],
  [4384410045,4384625035,'Aquarius'],
  [4384625035,4384844578,'Pisces'],
  [4384844578,4385059175,'Aries'],
  [4385059175,4385264299,'Taurus'],
  [4385264299,4385460842,'Gemini'],
  [4385460842,4385651628,'Cancer'],
  [4385651628,4385838613,'Leo'],
  [4385838613,4386022481,'Virgo'],
  [4386022481,4386204268,'Libra'],
  [4386204268,4386387045,'Scorpio'],
  [4386387045,4386575837,'Sagittarius'],
  [4386575837,4386775607,'Capricorn'],
  [4386775607,4386987692,'Aquarius'],
  [4386987692,4387206744,'Pisces'],
  [4387206744,4387422797,'Aries'],
  [4387422797,4387628343,'Taurus'],
  [4387628343,4387822440,'Gemini'],
  [4387822440,4388008708,'Cancer'],
  [4388008708,4388191679,'Leo'],
  [4388191679,4388374576,'Virgo'],
  [4388374576,4388559058,'Libra'],
  [4388559058,4388746470,'Scorpio'],
  [4388746470,4388939070,'Sagittarius'],
  [4388939070,4389139873,'Capricorn'],
  [4389139873,4389350650,'Aquarius'],
  [4389350650,4389568867,'Pisces'],
  [4389568867,4389786753,'Aries'],
  [4389786753,4389995445,'Taurus'],
  [4389995445,4390190845,'Gemini'],
  [4390190845,4390374880,'Cancer'],
  [4390374880,4390552743,'Leo'],
  [4390552743,4390730083,'Virgo'],
  [4390730083,4390911370,'Libra'],
  [4390911370,4391099299,'Scorpio'],
  [4391099299,4391295054,'Sagittarius'],
  [4391295054,4391498961,'Capricorn'],
  [4391498961,4391710767,'Aquarius'],
  [4391710767,4391928605,'Pisces'],
  [4391928605,4392147516,'Aries'],
  [4392147516,4392360058,'Taurus'],
  [4392360058,4392560107,'Gemini'],
  [4392560107,4392746464,'Cancer'],
  [4392746464,4392922709,'Leo'],
  [4392922709,4393094980,'Virgo'],
  [4393094980,4393269910,'Libra'],
  [4393269910,4393453067,'Scorpio'],
  [4393453067,4393647537,'Sagittarius'],
  [4393647537,4393853071,'Capricorn'],
  [4393853071,4394066848,'Aquarius'],
  [4394066848,4394285189,'Pisces'],
  [4394285189,4394504142,'Aries'],
  [4394504142,4394718900,'Taurus'],
  [4394718900,4394924029,'Gemini'],
  [4394924029,4395116022,'Cancer'],
  [4395116022,4395295468,'Leo'],
  [4395295468,4395466951,'Virgo'],
  [4395466951,4395637392,'Libra'],
  [4395637392,4395814182,'Scorpio'],
  [4395814182,4396003222,'Sagittarius'],
  [4396003222,4396206470,'Capricorn'],
  [4396206470,4396420704,'Aquarius'],
  [4396420704,4396639805,'Pisces'],
  [4396639805,4396858417,'Aries'],
  [4396858417,4397073077,'Taurus'],
  [4397073077,4397280718,'Gemini'],
  [4397280718,4397478102,'Cancer'],
  [4397478102,4397663556,'Leo'],
  [4397663556,4397838860,'Virgo'],
  [4397838860,4398009395,'Libra'],
  [4398009395,4398182583,'Scorpio'],
  [4398182583,4398365853,'Sagittarius'],
  [4398365853,4398563943,'Capricorn'],
  [4398563943,4398775839,'Aquarius'],
  [4398775839,4398994821,'Pisces'],
  [4398994821,4399213182,'Aries'],
  [4399213182,4399426526,'Taurus'],
  [4399426526,4399633408,'Gemini'],
  [4399633408,4399832760,'Cancer'],
  [4399832760,4400023137,'Leo'],
  [4400023137,4400204291,'Virgo'],
  [4400204291,4400379002,'Libra'],
  [4400379002,4400553064,'Scorpio'],
  [4400553064,4400733676,'Sagittarius'],
  [4400733676,4400927006,'Capricorn'],
  [4400927006,4401134838,'Aquarius'],
  [4401134838,4401352305,'Pisces'],
  [4401352305,4401570566,'Aries'],
  [4401570566,4401782936,'Taurus'],
  [4401782936,4401987505,'Gemini'],
  [4401987505,4402185027,'Cancer'],
  [4402185027,4402376221,'Leo'],
  [4402376221,4402561275,'Virgo'],
  [4402561275,4402741285,'Libra'],
  [4402741285,4402919607,'Scorpio'],
  [4402919607,4403101635,'Sagittarius'],
  [4403101635,4403293160,'Capricorn'],
  [4403293160,4403497555,'Aquarius'],
  [4403497555,4403712717,'Pisces'],
  [4403712717,4403930918,'Aries'],
  [4403930918,4404143634,'Taurus'],
  [4404143634,4404346786,'Gemini'],
  [4404346786,4404541061,'Cancer'],
  [4404541061,4404729143,'Leo'],
  [4404729143,4404913509,'Virgo'],
  [4404913509,4405096033,'Libra'],
  [4405096033,4405278800,'Scorpio'],
  [4405278800,4405464861,'Sagittarius'],
  [4405464861,4405658014,'Capricorn'],
  [4405658014,4405861333,'Aquarius'],
  [4405861333,4406074636,'Pisces'],
  [4406074636,4406292723,'Aries'],
  [4406292723,4406507147,'Taurus'],
  [4406507147,4406711355,'Gemini'],
  [4406711355,4406904050,'Cancer'],
  [4406904050,4407088121,'Leo'],
  [4407088121,4407268093,'Virgo'],
  [4407268093,4407448284,'Libra'],
  [4407448284,4407631984,'Scorpio'],
  [4407631984,4407821399,'Sagittarius'],
  [4407821399,4408018009,'Capricorn'],
  [4408018009,4408222805,'Aquarius'],
  [4408222805,4408435630,'Pisces'],
  [4408435630,4408653551,'Aries'],
  [4408653551,4408870141,'Taurus'],
  [4408870141,4409077844,'Gemini'],
  [4409077844,4409272480,'Cancer'],
  [4409272480,4409455126,'Leo'],
  [4409455126,4409630642,'Virgo'],
  [4409630642,4409805357,'Libra'],
  [4409805357,4409985146,'Scorpio'],
  [4409985146,4410173902,'Sagittarius'],
  [4410173902,4410372631,'Capricorn'],
  [4410372631,4410579982,'Aquarius'],
  [4410579982,4410793801,'Pisces'],
  [4410793801,4411011631,'Aries'],
  [4411011631,4411229536,'Taurus'],
  [4411229536,4411441339,'Gemini'],
  [4411441339,4411641036,'Cancer'],
  [4411641036,4411826629,'Leo'],
  [4411826629,4412001268,'Virgo'],
  [4412001268,4412171567,'Libra'],
  [4412171567,4412345207,'Scorpio'],
  [4412345207,4412528791,'Sagittarius'],
  [4412528791,4412725501,'Capricorn'],
  [4412725501,4412933774,'Aquarius'],
  [4412933774,4413149073,'Pisces'],
  [4413149073,4413367127,'Aries'],
  [4413367127,4413584911,'Taurus'],
  [4413584911,4413798835,'Gemini'],
  [4413798835,4414003781,'Cancer'],
  [4414003781,4414195562,'Leo'],
  [4414195562,4414374212,'Virgo'],
  [4414374212,4414544605,'Libra'],
  [4414544605,4414714423,'Scorpio'],
  [4414714423,4414891770,'Sagittarius'],
  [4414891770,4415082677,'Capricorn'],
  [4415082677,4415288148,'Aquarius'],
  [4415288148,4415503524,'Pisces'],
  [4415503524,4415722044,'Aries'],
  [4415722044,4415939047,'Taurus'],
  [4415939047,4416152202,'Gemini'],
  [4416152202,4416359022,'Cancer'],
  [4416359022,4416556124,'Leo'],
  [4416556124,4416741445,'Virgo'],
  [4416741445,4416916809,'Libra'],
  [4416916809,4417087937,'Scorpio'],
  [4417087937,4417262477,'Sagittarius'],
  [4417262477,4417447715,'Capricorn'],
  [4417447715,4417647671,'Aquarius'],
  [4417647671,4417860412,'Pisces'],
  [4417860412,4418078838,'Aries'],
  [4418078838,4418295574,'Taurus'],
  [4418295574,4418506843,'Gemini'],
  [4418506843,4418711645,'Cancer'],
  [4418711645,4418909328,'Leo'],
  [4418909328,4419098924,'Virgo'],
  [4419098924,4419280628,'Libra'],
  [4419280628,4419457275,'Scorpio'],
  [4419457275,4419634197,'Sagittarius'],
  [4419634197,4419817773,'Capricorn'],
  [4419817773,4420013221,'Aquarius'],
  [4420013221,4420221761,'Pisces'],
  [4420221761,4420438798,'Aries'],
  [4420438798,4420656008,'Taurus'],
  [4420656008,4420866699,'Gemini'],
  [4420866699,4421068651,'Cancer'],
  [4421068651,4421262824,'Leo'],
  [4421262824,4421451082,'Virgo'],
  [4421451082,4421635161,'Libra'],
  [4421635161,4421816973,'Scorpio'],
  [4421816973,4421999255,'Sagittarius'],
  [4421999255,4422185766,'Capricorn'],
  [4422185766,4422380551,'Aquarius'],
  [4422380551,4422586139,'Pisces'],
  [4422586139,4422801081,'Aries'],
  [4422801081,4423018889,'Taurus'],
  [4423018889,4423231127,'Gemini'],
  [4423231127,4423432623,'Cancer'],
  [4423432623,4423623375,'Leo'],
  [4423623375,4423806880,'Virgo'],
  [4423806880,4423987663,'Libra'],
  [4423987663,4424169602,'Scorpio'],
  [4424169602,4424355284,'Sagittarius'],
  [4424355284,4424546269,'Capricorn'],
  [4424546269,4424743886,'Aquarius'],
  [4424743886,4424949485,'Pisces'],
  [4424949485,4425163103,'Aries'],
  [4425163103,4425381170,'Taurus'],
  [4425381170,4425596115,'Gemini'],
  [4425596115,4425800359,'Cancer'],
  [4425800359,4425991108,'Leo'],
  [4425991108,4426171155,'Virgo'],
  [4426171155,4426346506,'Libra'],
  [4426346506,4426523620,'Scorpio'],
  [4426523620,4426707388,'Sagittarius'],
  [4426707388,4426899891,'Capricorn'],
  [4426899891,4427100662,'Aquarius'],
  [4427100662,4427308457,'Pisces'],
  [4427308457,4427522344,'Aries'],
  [4427522344,4427740437,'Taurus'],
  [4427740437,4427957641,'Gemini'],
  [4427957641,4428166279,'Cancer'],
  [4428166279,4428360813,'Leo'],
  [4428360813,4428541527,'Virgo'],
  [4428541527,4428713865,'Libra'],
  [4428713865,4428885452,'Scorpio'],
  [4428885452,4429063498,'Sagittarius'],
  [4429063498,4429252636,'Capricorn'],
  [4429252636,4429453385,'Aquarius'],
  [4429453385,4429662991,'Pisces'],
  [4429662991,4429878145,'Aries'],
  [4429878145,4430096348,'Taurus'],
  [4430096348,4430314375,'Gemini'],
  [4430314375,4430526514,'Cancer'],
  [4430526514,4430726467,'Leo'],
  [4430726467,4430911735,'Virgo'],
  [4430911735,4431085519,'Libra'],
  [4431085519,4431254819,'Scorpio'],
  [4431254819,4431427653,'Sagittarius'],
  [4431427653,4431610809,'Capricorn'],
  [4431610809,4431807521,'Aquarius'],
  [4431807521,4432016211,'Pisces'],
  [4432016211,4432232114,'Aries'],
  [4432232114,4432450557,'Taurus'],
  [4432450557,4432668149,'Gemini'],
  [4432668149,4432881208,'Cancer'],
  [4432881208,4433085036,'Leo'],
  [4433085036,4433276104,'Virgo'],
  [4433276104,4433454957,'Libra'],
  [4433454957,4433626455,'Scorpio'],
  [4433626455,4433797777,'Sagittarius'],
  [4433797777,4433976274,'Capricorn'],
  [4433976274,4434167341,'Aquarius'],
  [4434167341,4434372177,'Pisces'],
  [4434372177,4434587043,'Aries'],
  [4434587043,4434805556,'Taurus'],
  [4434805556,4435022357,'Gemini'],
  [4435022357,4435234078,'Cancer'],
  [4435234078,4435438238,'Leo'],
  [4435438238,4435632781,'Virgo'],
  [4435632781,4435817264,'Libra'],
  [4435817264,4435994078,'Scorpio'],
  [4435994078,4436168186,'Sagittarius'],
  [4436168186,4436345847,'Capricorn'],
  [4436345847,4436532986,'Aquarius'],
  [4436532986,4436733108,'Pisces'],
  [4436733108,4436945165,'Aries'],
  [4436945165,4437163217,'Taurus'],
  [4437163217,4437379744,'Gemini'],
  [4437379744,4437589686,'Cancer'],
  [4437589686,4437791356,'Leo'],
  [4437791356,4437985105,'Virgo'],
  [4437985105,4438172025,'Libra'],
  [4438172025,4438353809,'Scorpio'],
  [4438353809,4438533144,'Sagittarius'],
  [4438533144,4438713905,'Capricorn'],
  [4438713905,4438900756,'Aquarius'],
  [4438900756,4439097884,'Pisces'],
  [4439097884,4439306748,'Aries'],
  [4439306748,4439523758,'Taurus'],
  [4439523758,4439740887,'Gemini'],
  [4439740887,4439950503,'Cancer'],
  [4439950503,4440149572,'Leo'],
  [4440149572,4440339624,'Virgo'],
  [4440339624,4440524256,'Libra'],
  [4440524256,4440706934,'Scorpio'],
  [4440706934,4440890117,'Sagittarius'],
  [4440890117,4441075612,'Capricorn'],
  [4441075612,4441265553,'Aquarius'],
  [4441265553,4441462823,'Pisces'],
  [4441462823,4441669816,'Aries'],
  [4441669816,4441885617,'Taurus'],
  [4441885617,4442103895,'Gemini'],
  [4442103895,4442315465,'Cancer'],
  [4442315465,4442514496,'Leo'],
  [4442514496,4442701500,'Virgo'],
  [4442701500,4442881378,'Libra'],
  [4442881378,4443060106,'Scorpio'],
  [4443060106,4443242306,'Sagittarius'],
  [4443242306,4443430134,'Capricorn'],
  [4443430134,4443623911,'Aquarius'],
  [4443623911,4443823934,'Pisces'],
  [4443823934,4444031318,'Aries'],
  [4444031318,4444246402,'Taurus'],
  [4444246402,4444465576,'Gemini'],
  [4444465576,4444680509,'Cancer'],
  [4444680509,4444882979,'Leo'],
  [4444882979,4445070657,'Virgo'],
  [4445070657,4445247588,'Libra'],
  [4445247588,4445420887,'Scorpio'],
  [4445420887,4445597605,'Sagittarius'],
  [4445597605,4445782516,'Capricorn'],
  [4445782516,4445976920,'Aquarius'],
  [4445976920,4446179603,'Pisces'],
  [4446179603,4446389076,'Aries'],
  [4446389076,4446604475,'Taurus'],
  [4446604475,4446823787,'Gemini'],
  [4446823787,4447041316,'Cancer'],
  [4447041316,4447248944,'Leo'],
  [4447248944,4447441492,'Virgo'],
  [4447441492,4447620204,'Libra'],
  [4447620204,4447791238,'Scorpio'],
  [4447791238,4447962422,'Sagittarius'],
  [4447962422,4448140827,'Capricorn'],
  [4448140827,4448330762,'Aquarius'],
  [4448330762,4448532565,'Pisces'],
  [4448532565,4448743505,'Aries'],
  [4448743505,4448960046,'Taurus'],
  [4448960046,4449179138,'Gemini'],
  [4449179138,4449396989,'Cancer'],
  [4449396989,4449607988,'Leo'],
  [4449607988,4449806679,'Virgo'],
  [4449806679,4449991392,'Libra'],
  [4449991392,4450165473,'Scorpio'],
  [4450165473,4450335475,'Sagittarius'],
  [4450335475,4450508845,'Capricorn'],
  [4450508845,4450692066,'Aquarius'],
  [4450692066,4450888722,'Pisces'],
  [4450888722,4451097984,'Aries'],
  [4451097984,4451315096,'Taurus'],
  [4451315096,4451534257,'Gemini'],
  [4451534257,4451750910,'Cancer'],
  [4451750910,4451961591,'Leo'],
  [4451961591,4452163284,'Virgo'],
  [4452163284,4452354091,'Libra'],
  [4452354091,4452534703,'Scorpio'],
  [4452534703,4452708786,'Sagittarius'],
  [4452708786,4452882131,'Capricorn'],
  [4452882131,4453061296,'Aquarius'],
  [4453061296,4453251953,'Pisces'],
  [4453251953,4453456565,'Aries'],
  [4453456565,4453672224,'Taurus'],
  [4453672224,4453891576,'Gemini'],
  [4453891576,4454107344,'Cancer'],
  [4454107344,4454315654,'Leo'],
  [4454315654,4454515785,'Virgo'],
  [4454515785,4454708257,'Libra'],
  [4454708257,4454893911,'Scorpio'],
  [4454893911,4455074242,'Sagittarius'],
  [4455074242,4455252145,'Capricorn'],
  [4455252145,4455432235,'Aquarius'],
  [4455432235,4455620075,'Pisces'],
  [4455620075,4455820163,'Aries'],
  [4455820163,4456032757,'Taurus'],
  [4456032757,4456251788,'Gemini'],
  [4456251788,4456467910,'Cancer'],
  [4456467910,4456674727,'Leo'],
  [4456674727,4456871478,'Virgo'],
  [4456871478,4457060952,'Libra'],
  [4457060952,4457246416,'Scorpio'],
  [4457246416,4457430049,'Sagittarius'],
  [4457430049,4457613169,'Capricorn'],
  [4457613169,4457797658,'Aquarius'],
  [4457797658,4457987001,'Pisces'],
  [4457987001,4458185493,'Aries'],
  [4458185493,4458395449,'Taurus'],
  [4458395449,4458613634,'Gemini'],
  [4458613634,4458831050,'Cancer'],
  [4458831050,4459038780,'Leo'],
  [4459038780,4459233883,'Virgo'],
  [4459233883,4459419354,'Libra'],
  [4459419354,4459600546,'Scorpio'],
  [4459600546,4459782103,'Sagittarius'],
  [4459782103,4459966560,'Capricorn'],
  [4459966560,4460154819,'Aquarius'],
  [4460154819,4460347907,'Pisces'],
  [4460347907,4460548022,'Aries'],
  [4460548022,4460757348,'Taurus'],
  [4460757348,4460974810,'Gemini'],
  [4460974810,4461193663,'Cancer'],
  [4461193663,4461404327,'Leo'],
  [4461404327,4461601106,'Virgo'],
  [4461601106,4461785177,'Libra'],
  [4461785177,4461962143,'Scorpio'],
  [4461962143,4462138500,'Sagittarius'],
  [4462138500,4462319306,'Capricorn'],
  [4462319306,4462507124,'Aquarius'],
  [4462507124,4462702502,'Pisces'],
  [4462702502,4462905419,'Aries'],
  [4462905419,4463116045,'Taurus'],
  [4463116045,4463333470,'Gemini'],
  [4463333470,4463553210,'Cancer'],
  [4463553210,4463767214,'Leo'],
  [4463767214,4463968297,'Virgo'],
  [4463968297,4464154865,'Libra'],
  [4464154865,4464330934,'Scorpio'],
  [4464330934,4464503149,'Sagittarius'],
  [4464503149,4464678228,'Capricorn'],
  [4464678228,4464861313,'Aquarius'],
  [4464861313,4465054931,'Pisces'],
  [4465054931,4465258908,'Aries'],
  [4465258908,4465471276,'Taurus'],
  [4465471276,4465689327,'Gemini'],
  [4465689327,4465909204,'Cancer'],
  [4465909204,4466125158,'Leo'],
  [4466125158,4466330852,'Virgo'],
  [4466330852,4466522716,'Libra'],
  [4466522716,4466702061,'Scorpio'],
  [4466702061,4466873986,'Sagittarius'],
  [4466873986,4467045229,'Capricorn'],
  [4467045229,4467222477,'Aquarius'],
  [4467222477,4467410877,'Pisces'],
  [4467410877,4467612420,'Aries'],
  [4467612420,4467825020,'Taurus'],
  [4467825020,4468043755,'Gemini'],
  [4468043755,4468263338,'Cancer'],
  [4468263338,4468479145,'Leo'],
  [4468479145,4468687140,'Virgo'],
  [4468687140,4468884155,'Libra'],
  [4468884155,4469069383,'Scorpio'],
  [4469069383,4469245240,'Sagittarius'],
  [4469245240,4469416831,'Capricorn'],
  [4469416831,4469590745,'Aquarius'],
  [4469590745,4469773625,'Pisces'],
  [4469773625,4469970145,'Aries'],
  [4469970145,4470180401,'Taurus'],
  [4470180401,4470399004,'Gemini'],
  [4470399004,4470618321,'Cancer'],
  [4470618321,4470832745,'Leo'],
  [4470832745,4471039831,'Virgo'],
  [4471039831,4471238701,'Libra'],
  [4471238701,4471428864,'Scorpio'],
  [4471428864,4471610740,'Sagittarius'],
  [4471610740,4471786733,'Capricorn'],
  [4471786733,4471961647,'Aquarius'],
  [4471961647,4472141895,'Pisces'],
  [4472141895,4472333658,'Aries'],
  [4472333658,4472539833,'Taurus'],
  [4472539833,4472756956,'Gemini'],
  [4472756956,4472976263,'Cancer'],
  [4472976263,4473189696,'Leo'],
  [4473189696,4473394268,'Virgo'],
  [4473394268,4473591016,'Libra'],
  [4473591016,4473781809,'Scorpio'],
  [4473781809,4473967661,'Sagittarius'],
  [4473967661,4474149292,'Capricorn'],
  [4474149292,4474328829,'Aquarius'],
  [4474328829,4474510692,'Pisces'],
  [4474510692,4474700666,'Aries'],
  [4474700666,4474903281,'Taurus'],
  [4474903281,4475117999,'Gemini'],
  [4475117999,4475337370,'Cancer'],
  [4475337370,4475551407,'Leo'],
  [4475551407,4475754643,'Virgo'],
  [4475754643,4475947894,'Libra'],
  [4475947894,4476135054,'Scorpio'],
  [4476135054,4476319694,'Sagittarius'],
  [4476319694,4476503663,'Capricorn'],
  [4476503663,4476687899,'Aquarius'],
  [4476687899,4476874247,'Pisces'],
  [4476874247,4477066248,'Aries'],
  [4477066248,4477267909,'Taurus'],
  [4477267909,4477480602,'Gemini'],
  [4477480602,4477699769,'Cancer'],
  [4477699769,4477915858,'Leo'],
  [4477915858,4478120758,'Virgo'],
  [4478120758,4478312848,'Libra'],
  [4478312848,4478495895,'Scorpio'],
  [4478495895,4478675421,'Sagittarius'],
  [4478675421,4478856066,'Capricorn'],
  [4478856066,4479040542,'Aquarius'],
  [4479040542,4479230151,'Pisces'],
  [4479230151,4479426033,'Aries'],
  [4479426033,4479629714,'Taurus'],
  [4479629714,4479842072,'Gemini'],
  [4479842072,4480060790,'Cancer'],
  [4480060790,4480278943,'Leo'],
  [4480278943,4480487927,'Virgo'],
  [4480487927,4480683018,'Libra'],
  [4480683018,4480865587,'Scorpio'],
  [4480865587,4481040931,'Sagittarius'],
  [4481040931,4481215442,'Capricorn'],
  [4481215442,4481394731,'Aquarius'],
  [4481394731,4481582468,'Pisces'],
  [4481582468,4481779937,'Aries'],
  [4481779937,4481986452,'Taurus'],
  [4481986452,4482200291,'Gemini'],
  [4482200291,4482418870,'Cancer'],
  [4482418870,4482637753,'Leo'],
  [4482637753,4482850531,'Virgo'],
  [4482850531,4483051304,'Libra'],
  [4483051304,4483238183,'Scorpio'],
  [4483238183,4483414057,'Sagittarius'],
  [4483414057,4483584914,'Capricorn'],
  [4483584914,4483757827,'Aquarius'],
  [4483757827,4483939273,'Pisces'],
  [4483939273,4484133321,'Aries'],
  [4484133321,4484339968,'Taurus'],
  [4484339968,4484555391,'Gemini'],
  [4484555391,4484774492,'Cancer'],
  [4484774492,4484992909,'Leo'],
  [4484992909,4485206821,'Virgo'],
  [4485206821,4485412097,'Libra'],
  [4485412097,4485605451,'Scorpio'],
  [4485605451,4485786585,'Sagittarius'],
  [4485786585,4485959052,'Capricorn'],
  [4485959052,4486129310,'Aquarius'],
  [4486129310,4486304932,'Pisces'],
  [4486304932,4486492598,'Aries'],
  [4486492598,4486695293,'Taurus'],
  [4486695293,4486910056,'Gemini'],
  [4486910056,4487129668,'Cancer'],
  [4487129668,4487347508,'Leo'],
  [4487347508,4487560182,'Virgo'],
  [4487560182,4487766107,'Libra'],
  [4487766107,4487963551,'Scorpio'],
  [4487963551,4488151021,'Sagittarius'],
  [4488151021,4488329145,'Capricorn'],
  [4488329145,4488501940,'Aquarius'],
  [4488501940,4488676087,'Pisces'],
  [4488676087,4488859014,'Aries'],
  [4488859014,4489056188,'Taurus'],
  [4489056188,4489267616,'Gemini'],
  [4489267616,4489486645,'Cancer'],
  [4489486645,4489704376,'Leo'],
  [4489704376,4489915495,'Virgo'],
  [4489915495,4490119156,'Libra'],
  [4490119156,4490316083,'Scorpio'],
  [4490316083,4490506392,'Sagittarius'],
  [4490506392,4490689942,'Capricorn'],
  [4490689942,4490868223,'Aquarius'],
  [4490868223,4491045486,'Pisces'],
  [4491045486,4491227966,'Aries'],
  [4491227966,4491421697,'Taurus'],
  [4491421697,4491629187,'Gemini'],
  [4491629187,4491846436,'Cancer'],
  [4491846436,4492064393,'Leo'],
  [4492064393,4492275256,'Virgo'],
  [4492275256,4492476644,'Libra'],
  [4492476644,4492670235,'Scorpio'],
  [4492670235,4492858558,'Sagittarius'],
  [4492858558,4493043280,'Capricorn'],
  [4493043280,4493225617,'Aquarius'],
  [4493225617,4493407735,'Pisces'],
  [4493407735,4493593447,'Aries'],
  [4493593447,4493787400,'Taurus'],
  [4493787400,4493992747,'Gemini'],
  [4493992747,4494208070,'Cancer'],
  [4494208070,4494426317,'Leo'],
  [4494426317,4494638594,'Virgo'],
  [4494638594,4494839921,'Libra'],
  [4494839921,4495030808,'Scorpio'],
  [4495030808,4495214861,'Sagittarius'],
  [4495214861,4495396150,'Capricorn'],
  [4495396150,4495577920,'Aquarius'],
  [4495577920,4495762562,'Pisces'],
  [4495762562,4495952196,'Aries'],
  [4495952196,4496149041,'Taurus'],
  [4496149041,4496354878,'Gemini'],
  [4496354878,4496569268,'Cancer'],
  [4496569268,4496787718,'Leo'],
  [4496787718,4497002404,'Virgo'],
  [4497002404,4497206389,'Libra'],
  [4497206389,4497397619,'Scorpio'],
  [4497397619,4497578816,'Sagittarius'],
  [4497578816,4497755175,'Capricorn'],
  [4497755175,4497932293,'Aquarius'],
  [4497932293,4498114793,'Pisces'],
  [4498114793,4498305484,'Aries'],
  [4498305484,4498505155,'Taurus'],
  [4498505155,4498713167,'Gemini'],
  [4498713167,4498927984,'Cancer'],
  [4498927984,4499146530,'Leo'],
  [4499146530,4499363333,'Virgo'],
  [4499363333,4499571534,'Libra'],
  [4499571534,4499766545,'Scorpio'],
  [4499766545,4499948628,'Sagittarius'],
  [4499948628,4500122275,'Capricorn'],
  [4500122275,4500294155,'Aquarius'],
  [4500294155,4500471134,'Pisces'],
  [4500471134,4500658454,'Aries'],
  [4500658454,4500857959,'Taurus'],
  [4500857959,4501067670,'Gemini'],
  [4501067670,4501283704,'Cancer'],
  [4501283704,4501502337,'Leo'],
  [4501502337,4501719909,'Virgo'],
  [4501719909,4501931574,'Libra'],
  [4501931574,4502132073,'Scorpio'],
  [4502132073,4502318873,'Sagittarius'],
  [4502318873,4502494096,'Capricorn'],
  [4502494096,4502663740,'Aquarius'],
  [4502663740,4502835552,'Pisces'],
  [4502835552,4503016914,'Aries'],
  [4503016914,4503212339,'Taurus'],
  [4503212339,4503421087,'Gemini'],
  [4503421087,4503637843,'Cancer'],
  [4503637843,4503856646,'Leo'],
  [4503856646,4504073651,'Virgo'],
  [4504073651,4504286133,'Libra'],
  [4504286133,4504490581,'Scorpio'],
  [4504490581,4504683493,'Sagittarius'],
  [4504683493,4504864161,'Capricorn'],
  [4504864161,4505036228,'Aquarius'],
  [4505036228,4505206585,'Pisces'],
  [4505206585,4505383216,'Aries'],
  [4505383216,4505572782,'Taurus'],
  [4505572782,4505777454,'Gemini'],
  [4505777454,4505993089,'Cancer'],
  [4505993089,4506211984,'Leo'],
  [4506211984,4506428122,'Virgo'],
  [4506428122,4506639014,'Libra'],
  [4506639014,4506843506,'Scorpio'],
  [4506843506,4507039857,'Sagittarius'],
  [4507039857,4507226529,'Capricorn'],
  [4507226529,4507404484,'Aquarius'],
  [4507404484,4507578146,'Pisces'],
  [4507578146,4507754263,'Aries'],
  [4507754263,4507939861,'Taurus'],
  [4507939861,4508139438,'Gemini'],
  [4508139438,4508351901,'Cancer'],
  [4508351901,4508570306,'Leo'],
  [4508570306,4508786369,'Virgo'],
  [4508786369,4508995494,'Libra'],
  [4508995494,4509197087,'Scorpio'],
  [4509197087,4509391961,'Sagittarius'],
  [4509391961,4509580618,'Capricorn'],
  [4509580618,4509763668,'Aquarius'],
  [4509763668,4509943178,'Pisces'],
  [4509943178,4510123231,'Aries'],
  [4510123231,4510309181,'Taurus'],
  [4510309181,4510505822,'Gemini'],
  [4510505822,4510714667,'Cancer'],
  [4510714667,4510931708,'Leo'],
  [4510931708,4511148626,'Virgo'],
  [4511148626,4511358009,'Libra'],
  [4511358009,4511557266,'Scorpio'],
  [4511557266,4511747951,'Sagittarius'],
  [4511747951,4511933234,'Capricorn'],
  [4511933234,4512116135,'Aquarius'],
  [4512116135,4512299071,'Pisces'],
  [4512299071,4512484255,'Aries'],
  [4512484255,4512674219,'Taurus'],
  [4512674219,4512871776,'Gemini'],
  [4512871776,4513078854,'Cancer'],
  [4513078854,4513294266,'Leo'],
  [4513294266,4513512166,'Virgo'],
  [4513512166,4513724136,'Libra'],
  [4513724136,4513924408,'Scorpio'],
  [4513924408,4514112693,'Sagittarius'],
  [4514112693,4514292943,'Capricorn'],
  [4514292943,4514470747,'Aquarius'],
  [4514470747,4514651218,'Pisces'],
  [4514651218,4514837698,'Aries'],
  [4514837698,4515031434,'Taurus'],
  [4515031434,4515232424,'Gemini'],
  [4515232424,4515440545,'Cancer'],
  [4515440545,4515655235,'Leo'],
  [4515655235,4515873509,'Virgo'],
  [4515873509,4516088702,'Libra'],
  [4516088702,4516293223,'Scorpio'],
  [4516293223,4516483512,'Sagittarius'],
  [4516483512,4516661859,'Capricorn'],
  [4516661859,4516834509,'Aquarius'],
  [4516834509,4517008807,'Pisces'],
  [4517008807,4517190918,'Aries'],
  [4517190918,4517383900,'Taurus'],
  [4517383900,4517587026,'Gemini'],
  [4517587026,4517797522,'Cancer'],
  [4517797522,4518012916,'Leo'],
  [4518012916,4518231085,'Virgo'],
  [4518231085,4518448085,'Libra'],
  [4518448085,4518657352,'Scorpio'],
  [4518657352,4518853092,'Sagittarius'],
  [4518853092,4519034455,'Capricorn'],
  [4519034455,4519206143,'Aquarius'],
  [4519206143,4519375842,'Pisces'],
  [4519375842,4519551514,'Aries'],
  [4519551514,4519739069,'Taurus'],
  [4519739069,4519940035,'Gemini'],
  [4519940035,4520151276,'Cancer'],
  [4520151276,4520367856,'Leo'],
  [4520367856,4520586007,'Virgo'],
  [4520586007,4520802902,'Libra'],
  [4520802902,4521014469,'Scorpio'],
  [4521014469,4521215497,'Sagittarius'],
  [4521215497,4521402889,'Capricorn'],
  [4521402889,4521578447,'Aquarius'],
  [4521578447,4521748274,'Pisces'],
  [4521748274,4521920264,'Aries'],
  [4521920264,4522101801,'Taurus'],
  [4522101801,4522297280,'Gemini'],
  [4522297280,4522505954,'Cancer'],
  [4522505954,4522722525,'Leo'],
  [4522722525,4522940822,'Virgo'],
  [4522940822,4523156739,'Libra'],
  [4523156739,4523367584,'Scorpio'],
  [4523367584,4523570492,'Sagittarius'],
  [4523570492,4523762834,'Capricorn'],
  [4523762834,4523944408,'Aquarius'],
  [4523944408,4524118645,'Pisces'],
  [4524118645,4524291674,'Aries'],
  [4524291674,4524470487,'Taurus'],
  [4524470487,4524660861,'Gemini'],
  [4524660861,4524864934,'Cancer'],
  [4524864934,4525079568,'Leo'],
  [4525079568,4525297784,'Virgo'],
  [4525297784,4525513063,'Libra'],
  [4525513063,4525721877,'Scorpio'],
  [4525721877,4525923018,'Sagittarius'],
  [4525923018,4526116184,'Capricorn'],
  [4526116184,4526301744,'Aquarius'],
  [4526301744,4526481495,'Pisces'],
  [4526481495,4526659062,'Aries'],
  [4526659062,4526839466,'Taurus'],
  [4526839466,4527027970,'Gemini'],
  [4527027970,4527228217,'Cancer'],
  [4527228217,4527439909,'Leo'],
  [4527439909,4527657586,'Virgo'],
  [4527657586,4527873186,'Libra'],
  [4527873186,4528080830,'Scorpio'],
  [4528080830,4528278953,'Sagittarius'],
  [4528278953,4528469148,'Capricorn'],
  [4528469148,4528654119,'Aquarius'],
  [4528654119,4528836498,'Pisces'],
  [4528836498,4529018701,'Aries'],
  [4529018701,4529203355,'Taurus'],
  [4529203355,4529393635,'Gemini'],
  [4529393635,4529592759,'Cancer'],
  [4529592759,4529802175,'Leo'],
  [4529802175,4530019062,'Virgo'],
  [4530019062,4530235882,'Libra'],
  [4530235882,4530444496,'Scorpio'],
  [4530444496,4530641192,'Sagittarius'],
  [4530641192,4530827622,'Capricorn'],
  [4530827622,4531008456,'Aquarius'],
  [4531008456,4531188686,'Pisces'],
  [4531188686,4531371950,'Aries'],
  [4531371950,4531560091,'Taurus'],
  [4531560091,4531753985,'Gemini'],
  [4531753985,4531954766,'Cancer'],
  [4531954766,4532163699,'Leo'],
  [4532163699,4532379989,'Virgo'],
  [4532379989,4532598297,'Libra'],
  [4532598297,4532809907,'Scorpio'],
  [4532809907,4533008366,'Sagittarius'],
  [4533008366,4533193464,'Capricorn'],
  [4533193464,4533370136,'Aquarius'],
  [4533370136,4533545226,'Pisces'],
  [4533545226,4533724819,'Aries'],
  [4533724819,4533912426,'Taurus'],
  [4533912426,4534108521,'Gemini'],
  [4534108521,4534312039,'Cancer'],
  [4534312039,4534522243,'Leo'],
  [4534522243,4534738501,'Virgo'],
  [4534738501,4534957743,'Libra'],
  [4534957743,4535172853,'Scorpio'],
  [4535172853,4535375888,'Sagittarius'],
  [4535375888,4535563692,'Capricorn'],
  [4535563692,4535739534,'Aquarius'],
  [4535739534,4535910458,'Pisces'],
  [4535910458,4536084189,'Aries'],
  [4536084189,4536266835,'Taurus'],
  [4536266835,4536460988,'Gemini'],
  [4536460988,4536665488,'Cancer'],
  [4536665488,4536877438,'Leo'],
  [4536877438,4537094302,'Virgo'],
  [4537094302,4537313594,'Libra'],
  [4537313594,4537530632,'Scorpio'],
  [4537530632,4537738545,'Sagittarius'],
  [4537738545,4537932170,'Capricorn'],
  [4537932170,4538111792,'Aquarius'],
  [4538111792,4538282763,'Pisces'],
  [4538282763,4538452719,'Aries'],
  [4538452719,4538629201,'Taurus'],
  [4538629201,4538817589,'Gemini'],
  [4538817589,4539019226,'Cancer'],
  [4539019226,4539231280,'Leo'],
  [4539231280,4539448912,'Virgo'],
  [4539448912,4539667854,'Libra'],
  [4539667854,4539884442,'Scorpio'],
  [4539884442,4540094380,'Sagittarius'],
  [4540094380,4540293346,'Capricorn'],
  [4540293346,4540479540,'Aquarius'],
  [4540479540,4540655341,'Pisces'],
  [4540655341,4540826423,'Aries'],
  [4540826423,4540999862,'Taurus'],
  [4540999862,4541182352,'Gemini'],
  [4541182352,4541378212,'Cancer'],
  [4541378212,4541587325,'Leo'],
  [4541587325,4541804762,'Virgo'],
  [4541804762,4542023645,'Libra'],
  [4542023645,4542238720,'Scorpio'],
  [4542238720,4542447090,'Sagittarius'],
  [4542447090,4542647162,'Capricorn'],
  [4542647162,4542838097,'Aquarius'],
  [4542838097,4543020505,'Pisces'],
  [4543020505,4543197121,'Aries'],
  [4543197121,4543372685,'Taurus'],
  [4543372685,4543553104,'Gemini'],
  [4543553104,4543743982,'Cancer'],
  [4543743982,4543948297,'Leo'],
  [4543948297,4544163755,'Virgo'],
  [4544163755,4544382817,'Libra'],
  [4544382817,4544597333,'Scorpio'],
  [4544597333,4544803085,'Sagittarius'],
  [4544803085,4545000133,'Capricorn'],
  [4545000133,4545190450,'Aquarius'],
  [4545190450,4545376000,'Pisces'],
  [4545376000,4545558367,'Aries'],
  [4545558367,4545739509,'Taurus'],
  [4545739509,4545922714,'Gemini'],
  [4545922714,4546112570,'Cancer'],
  [4546112570,4546313349,'Leo'],
  [4546313349,4546525879,'Virgo'],
  [4546525879,4546744769,'Libra'],
  [4546744769,4546960412,'Scorpio'],
  [4546960412,4547165582,'Sagittarius'],
  [4547165582,4547359319,'Capricorn'],
  [4547359319,4547545265,'Aquarius'],
  [4547545265,4547728150,'Pisces'],
  [4547728150,4547911428,'Aries'],
  [4547911428,4548096675,'Taurus'],
  [4548096675,4548284761,'Gemini'],
  [4548284761,4548477566,'Cancer'],
  [4548477566,4548678197,'Leo'],
  [4548678197,4548888830,'Virgo'],
  [4548888830,4549107090,'Libra'],
  [4549107090,4549324694,'Scorpio'],
  [4549324694,4549532240,'Sagittarius'],
  [4549532240,4549725864,'Capricorn'],
  [4549725864,4549908409,'Aquarius'],
  [4549908409,4550086048,'Pisces'],
  [4550086048,4550264854,'Aries'],
  [4550264854,4550448736,'Taurus'],
  [4550448736,4550638935,'Gemini'],
  [4550638935,4550835402,'Cancer'],
  [4550835402,4551038598,'Leo'],
  [4551038598,4551249528,'Virgo'],
  [4551249528,4551467315,'Libra'],
  [4551467315,4551686401,'Scorpio'],
  [4551686401,4551897796,'Sagittarius'],
  [4551897796,4552095024,'Capricorn'],
  [4552095024,4552278260,'Aquarius'],
  [4552278260,4552452926,'Pisces'],
  [4552452926,4552626198,'Aries'],
  [4552626198,4552804424,'Taurus'],
  [4552804424,4552991485,'Gemini'],
  [4552991485,4553188290,'Cancer'],
  [4553188290,4553393787,'Leo'],
  [4553393787,4553606453,'Virgo'],
  [4553606453,4553824457,'Libra'],
  [4553824457,4554043961,'Scorpio'],
  [4554043961,4554258291,'Sagittarius'],
  [4554258291,4554460642,'Capricorn'],
  [4554460642,4554648454,'Aquarius'],
  [4554648454,4554824695,'Pisces'],
  [4554824695,4554995691,'Aries'],
  [4554995691,4555168586,'Taurus'],
  [4555168586,4555349548,'Gemini'],
  [4555349548,4555542268,'Cancer'],
  [4555542268,4555746971,'Leo'],
  [4555746971,4555960765,'Virgo'],
  [4555960765,4556179438,'Libra'],
  [4556179438,4556398624,'Scorpio'],
  [4556398624,4556613601,'Sagittarius'],
  [4556613601,4556819489,'Capricorn'],
  [4556819489,4557012987,'Aquarius'],
  [4557012987,4557194415,'Pisces'],
  [4557194415,4557367731,'Aries'],
  [4557367731,4557539089,'Taurus'],
  [4557539089,4557715267,'Gemini'],
  [4557715267,4557902141,'Cancer'],
  [4557902141,4558102740,'Leo'],
  [4558102740,4558315413,'Virgo'],
  [4558315413,4558534389,'Libra'],
  [4558534389,4558753139,'Scorpio'],
  [4558753139,4558966939,'Sagittarius'],
  [4558966939,4559173074,'Capricorn'],
  [4559173074,4559369900,'Aquarius'],
  [4559369900,4559556932,'Pisces'],
  [4559556932,4559735650,'Aries'],
  [4559735650,4559909840,'Taurus'],
  [4559909840,4560085173,'Gemini'],
  [4560085173,4560268053,'Cancer'],
  [4560268053,4560463667,'Leo'],
  [4560463667,4560673096,'Virgo'],
  [4560673096,4560891355,'Libra'],
  [4560891355,4561109957,'Scorpio'],
  [4561109957,4561322314,'Sagittarius'],
  [4561322314,4561526238,'Capricorn'],
  [4561526238,4561722380,'Aquarius'],
  [4561722380,4561911852,'Pisces'],
  [4561911852,4562095547,'Aries'],
  [4562095547,4562274977,'Taurus'],
  [4562274977,4562453427,'Gemini'],
  [4562453427,4562636090,'Cancer'],
  [4562636090,4562828667,'Leo'],
  [4562828667,4563034502,'Virgo'],
  [4563034502,4563251099,'Libra'],
  [4563251099,4563469926,'Scorpio'],
  [4563469926,4563682033,'Sagittarius'],
  [4563682033,4563883725,'Capricorn'],
  [4563883725,4564076571,'Aquarius'],
  [4564076571,4564264029,'Pisces'],
  [4564264029,4564448762,'Aries'],
  [4564448762,4564632092,'Taurus'],
  [4564632092,4564815285,'Gemini'],
  [4564815285,4565001127,'Cancer'],
  [4565001127,4565193994,'Leo'],
  [4565193994,4565397854,'Virgo'],
  [4565397854,4565612673,'Libra'],
  [4565612673,4565831894,'Scorpio'],
  [4565831894,4566045520,'Sagittarius'],
  [4566045520,4566247213,'Capricorn'],
  [4566247213,4566437364,'Aquarius'],
  [4566437364,4566620500,'Pisces'],
  [4566620500,4566801670,'Aries'],
  [4566801670,4566984305,'Taurus'],
  [4566984305,4567169978,'Gemini'],
  [4567169978,4567359768,'Cancer'],
  [4567359768,4567555601,'Leo'],
  [4567555601,4567760029,'Virgo'],
  [4567760029,4567973943,'Libra'],
  [4567973943,4568193408,'Scorpio'],
  [4568193408,4568409648,'Sagittarius'],
  [4568409648,4568614345,'Capricorn'],
  [4568614345,4568805126,'Aquarius'],
  [4568805126,4568985503,'Pisces'],
  [4568985503,4569161541,'Aries'],
  [4569161541,4569339086,'Taurus'],
  [4569339086,4569522222,'Gemini'],
  [4569522222,4569712897,'Cancer'],
  [4569712897,4569911644,'Leo'],
  [4569911644,4570118471,'Virgo'],
  [4570118471,4570332891,'Libra'],
  [4570332891,4570552331,'Scorpio'],
  [4570552331,4570770658,'Sagittarius'],
  [4570770658,4570979968,'Capricorn'],
  [4570979968,4571175259,'Aquarius'],
  [4571175259,4571357227,'Pisces'],
  [4571357227,4571530879,'Aries'],
  [4571530879,4571702908,'Taurus'],
  [4571702908,4571879779,'Gemini'],
  [4571879779,4572066299,'Cancer'],
  [4572066299,4572264435,'Leo'],
  [4572264435,4572473030,'Virgo'],
  [4572473030,4572688928,'Libra'],
  [4572688928,4572908392,'Scorpio'],
  [4572908392,4573127086,'Sagittarius'],
  [4573127086,4573339653,'Capricorn'],
  [4573339653,4573540915,'Aquarius'],
  [4573540915,4573728674,'Pisces'],
  [4573728674,4573905042,'Aries'],
  [4573905042,4574075484,'Taurus'],
  [4574075484,4574247074,'Gemini'],
  [4574247074,4574426849,'Cancer'],
  [4574426849,4574619865,'Leo'],
  [4574619865,4574826842,'Virgo'],
  [4574826842,4575043487,'Libra'],
  [4575043487,4575263317,'Scorpio'],
  [4575263317,4575481152,'Sagittarius'],
  [4575481152,4575693748,'Capricorn'],
  [4575693748,4575898353,'Aquarius'],
  [4575898353,4576092461,'Pisces'],
  [4576092461,4576275371,'Aries'],
  [4576275371,4576449579,'Taurus'],
  [4576449579,4576620698,'Gemini'],
  [4576620698,4576796052,'Cancer'],
  [4576796052,4576982717,'Leo'],
  [4576982717,4577184631,'Virgo'],
  [4577184631,4577399509,'Libra'],
  [4577399509,4577619502,'Scorpio'],
  [4577619502,4577836691,'Sagittarius'],
  [4577836691,4578047318,'Capricorn'],
  [4578047318,4578250882,'Aquarius'],
  [4578250882,4578447270,'Pisces'],
  [4578447270,4578635803,'Aries'],
  [4578635803,4578816541,'Taurus'],
  [4578816541,4578992153,'Gemini'],
  [4578992153,4579168206,'Cancer'],
  [4579168206,4579351694,'Leo'],
  [4579351694,4579548445,'Virgo'],
  [4579548445,4579759435,'Libra'],
  [4579759435,4579978496,'Scorpio'],
  [4579978496,4580195891,'Sagittarius'],
  [4580195891,4580405224,'Capricorn'],
  [4580405224,4580605760,'Aquarius'],
  [4580605760,4580799607,'Pisces'],
  [4580799607,4580988575,'Aries'],
  [4580988575,4581173311,'Taurus'],
  [4581173311,4581354654,'Gemini'],
  [4581354654,4581535383,'Cancer'],
  [4581535383,4581720433,'Leo'],
  [4581720433,4581915278,'Virgo'],
  [4581915278,4582122826,'Libra'],
  [4582122826,4582340024,'Scorpio'],
  [4582340024,4582558050,'Sagittarius'],
  [4582558050,4582768172,'Capricorn'],
  [4582768172,4582967228,'Aquarius'],
  [4582967228,4583157275,'Pisces'],
  [4583157275,4583342230,'Aries'],
  [4583342230,4583525350,'Taurus'],
  [4583525350,4583708636,'Gemini'],
  [4583708636,4583893727,'Cancer'],
  [4583893727,4584083019,'Leo'],
  [4584083019,4584279733,'Virgo'],
  [4584279733,4584486391,'Libra'],
  [4584486391,4584702043,'Scorpio'],
  [4584702043,4584920552,'Sagittarius'],
  [4584920552,4585133094,'Capricorn'],
  [4585133094,4585333796,'Aquarius'],
  [4585333796,4585522559,'Pisces'],
  [4585522559,4585703334,'Aries'],
  [4585703334,4585881347,'Taurus'],
  [4585881347,4586061250,'Gemini'],
  [4586061250,4586246311,'Cancer'],
  [4586246311,4586438403,'Leo'],
  [4586438403,4586638439,'Virgo'],
  [4586638439,4586846692,'Libra'],
  [4586846692,4587062096,'Scorpio'],
  [4587062096,4587280776,'Sagittarius'],
  [4587280776,4587495915,'Capricorn'],
  [4587495915,4587700597,'Aquarius'],
  [4587700597,4587891874,'Pisces'],
  [4587891874,4588071785,'Aries'],
  [4588071785,4588245636,'Taurus'],
  [4588245636,4588419856,'Gemini'],
  [4588419856,4588600311,'Cancer'],
  [4588600311,4588790848,'Leo'],
  [4588790848,4588992274,'Virgo'],
  [4588992274,4589202686,'Libra'],
  [4589202686,4589419002,'Scorpio'],
  [4589419002,4589637690,'Sagittarius'],
  [4589637690,4589854251,'Capricorn'],
  [4589854251,4590063022,'Aquarius'],
  [4590063022,4590259379,'Pisces'],
  [4590259379,4590442539,'Aries'],
  [4590442539,4590616085,'Taurus'],
  [4590616085,4590786502,'Gemini'],
  [4590786502,4590961195,'Cancer'],
  [4590961195,4591146529,'Leo'],
  [4591146529,4591345518,'Virgo'],
  [4591345518,4591556281,'Libra'],
  [4591556281,4591773600,'Scorpio'],
  [4591773600,4591992311,'Sagittarius'],
  [4591992311,4592208737,'Capricorn'],
  [4592208737,4592419491,'Aquarius'],
  [4592419491,4592620642,'Pisces'],
  [4592620642,4592809487,'Aries'],
  [4592809487,4592986871,'Taurus'],
  [4592986871,4593157654,'Gemini'],
  [4593157654,4593329149,'Cancer'],
  [4593329149,4593509045,'Leo'],
  [4593509045,4593702884,'Virgo'],
  [4593702884,4593911068,'Libra'],
  [4593911068,4594128210,'Scorpio'],
  [4594128210,4594346961,'Sagittarius'],
  [4594346961,4594562415,'Capricorn'],
  [4594562415,4594772435,'Aquarius'],
  [4594772435,4594975324,'Pisces'],
  [4594975324,4595168894,'Aries'],
  [4595168894,4595352113,'Taurus'],
  [4595352113,4595527207,'Gemini'],
  [4595527207,4595699789,'Cancer'],
  [4595699789,4595877216,'Leo'],
  [4595877216,4596066282,'Virgo'],
  [4596066282,4596270054,'Libra'],
  [4596270054,4596485267,'Scorpio'],
  [4596485267,4596703885,'Sagittarius'],
  [4596703885,4596918672,'Capricorn'],
  [4596918672,4597126654,'Aquarius'],
  [4597126654,4597327737,'Pisces'],
  [4597327737,4597522047,'Aries'],
  [4597522047,4597709224,'Taurus'],
  [4597709224,4597889873,'Gemini'],
  [4597889873,4598067064,'Cancer'],
  [4598067064,4598246217,'Leo'],
  [4598246217,4598433564,'Virgo'],
  [4598433564,4598633577,'Libra'],
  [4598633577,4598845829,'Scorpio'],
  [4598845829,4599063922,'Sagittarius'],
  [4599063922,4599279137,'Capricorn'],
  [4599279137,4599486035,'Aquarius'],
  [4599486035,4599684035,'Pisces'],
  [4599684035,4599875120,'Aries'],
  [4599875120,4600061448,'Taurus'],
  [4600061448,4600244671,'Gemini'],
  [4600244671,4600426677,'Cancer'],
  [4600426677,4600610415,'Leo'],
  [4600610415,4600799873,'Virgo'],
  [4600799873,4600998871,'Libra'],
  [4600998871,4601208727,'Scorpio'],
  [4601208727,4601425928,'Sagittarius'],
  [4601425928,4601642563,'Capricorn'],
  [4601642563,4601850860,'Aquarius'],
  [4601850860,4602047728,'Pisces'],
  [4602047728,4602234905,'Aries'],
  [4602234905,4602416524,'Taurus'],
  [4602416524,4602596958,'Gemini'],
  [4602596958,4602779671,'Cancer'],
  [4602779671,4602967002,'Leo'],
  [4602967002,4603160550,'Virgo'],
  [4603160550,4603361649,'Libra'],
  [4603361649,4603571076,'Scorpio'],
  [4603571076,4603787441,'Sagittarius'],
  [4603787441,4604005521,'Capricorn'],
  [4604005521,4604217351,'Aquarius'],
  [4604217351,4604416854,'Pisces'],
  [4604416854,4604603295,'Aries'],
  [4604603295,4604780671,'Taurus'],
  [4604780671,4604955239,'Gemini'],
  [4604955239,4605133254,'Cancer'],
  [4605133254,4605319225,'Leo'],
  [4605319225,4605514782,'Virgo'],
  [4605514782,4605718993,'Libra'],
  [4605718993,4605930073,'Scorpio'],
  [4605930073,4606146330,'Sagittarius'],
  [4606146330,4606364944,'Capricorn'],
  [4606364944,4606580235,'Aquarius'],
  [4606580235,4606785086,'Pisces'],
  [4606785086,4606975453,'Aries'],
  [4606975453,4607152945,'Taurus'],
  [4607152945,4607323624,'Gemini'],
  [4607323624,4607495290,'Cancer'],
  [4607495290,4607675160,'Leo'],
  [4607675160,4607867564,'Virgo'],
  [4607867564,4608072189,'Libra'],
  [4608072189,4608285149,'Scorpio'],
  [4608285149,4608502246,'Sagittarius'],
  [4608502246,4608720624,'Capricorn'],
  [4608720624,4608937139,'Aquarius'],
  [4608937139,4609146542,'Pisces'],
  [4609146542,4609343361,'Aries'],
  [4609343361,4609525894,'Taurus'],
  [4609525894,4609697873,'Gemini'],
  [4609697873,4609866627,'Cancer'],
  [4609866627,4610040440,'Leo'],
  [4610040440,4610226216,'Virgo'],
  [4610226216,4610426705,'Libra'],
  [4610426705,4610638997,'Scorpio'],
  [4610638997,4610856870,'Sagittarius'],
  [4610856870,4611075069,'Capricorn'],
  [4611075069,4611290689,'Aquarius'],
  [4611290689,4611501031,'Pisces'],
  [4611501031,4611702301,'Aries'],
  [4611702301,4611891471,'Taurus'],
  [4611891471,4612069207,'Gemini'],
  [4612069207,4612240460,'Cancer'],
  [4612240460,4612412605,'Leo'],
  [4612412605,4612593205,'Virgo'],
  [4612593205,4612787539,'Libra'],
  [4612787539,4612995878,'Scorpio'],
  [4612995878,4613212908,'Sagittarius'],
  [4613212908,4613431191,'Capricorn'],
  [4613431191,4613645618,'Aquarius'],
  [4613645618,4613854001,'Pisces'],
  [4613854001,4614055094,'Aries'],
  [4614055094,4614247602,'Taurus'],
  [4614247602,4614431281,'Gemini'],
  [4614431281,4614608416,'Cancer'],
  [4614608416,4614783879,'Leo'],
  [4614783879,4614963913,'Virgo'],
  [4614963913,4615154278,'Libra'],
  [4615154278,4615357822,'Scorpio'],
  [4615357822,4615572225,'Sagittarius'],
  [4615572225,4615790363,'Capricorn'],
  [4615790363,4616004650,'Aquarius'],
  [4616004650,4616211005,'Pisces'],
  [4616211005,4616408965,'Aries'],
  [4616408965,4616599795,'Taurus'],
  [4616599795,4616785124,'Gemini'],
  [4616785124,4616966870,'Cancer'],
  [4616966870,4617147700,'Leo'],
  [4617147700,4617331273,'Virgo'],
  [4617331273,4617521811,'Libra'],
  [4617521811,4617722711,'Scorpio'],
  [4617722711,4617934281,'Sagittarius'],
  [4617934281,4618151841,'Capricorn'],
  [4618151841,4618367177,'Aquarius'],
  [4618367177,4618573520,'Pisces'],
  [4618573520,4618768915,'Aries'],
  [4618768915,4618955641,'Taurus'],
  [4618955641,4619137811,'Gemini'],
  [4619137811,4619319370,'Cancer'],
  [4619319370,4619503181,'Leo'],
  [4619503181,4619691125,'Virgo'],
  [4619691125,4619884867,'Libra'],
  [4619884867,4620086295,'Scorpio'],
  [4620086295,4620296503,'Sagittarius'],
  [4620296503,4620513411,'Capricorn'],
  [4620513411,4620730372,'Aquarius'],
  [4620730372,4620939048,'Pisces'],
  [4620939048,4621134788,'Aries'],
  [4621134788,4621318786,'Taurus'],
  [4621318786,4621496239,'Gemini'],
  [4621496239,4621673403,'Cancer'],
  [4621673403,4621855346,'Leo'],
  [4621855346,4622044649,'Virgo'],
  [4622044649,4622241538,'Libra'],
  [4622241538,4622445462,'Scorpio'],
  [4622445462,4622656227,'Sagittarius'],
  [4622656227,4622872871,'Capricorn'],
  [4622872871,4623091173,'Aquarius'],
  [4623091173,4623303383,'Pisces'],
  [4623303383,4623502604,'Aries'],
  [4623502604,4623687487,'Taurus'],
  [4623687487,4623862423,'Gemini'],
  [4623862423,4624034624,'Cancer'],
  [4624034624,4624211281,'Leo'],
  [4624211281,4624397386,'Virgo'],
  [4624397386,4624594251,'Libra'],
  [4624594251,4624800112,'Scorpio'],
  [4624800112,4625012469,'Sagittarius'],
  [4625012469,4625229406,'Capricorn'],
  [4625229406,4625448184,'Aquarius'],
  [4625448184,4625663196,'Pisces'],
  [4625663196,4625867329,'Aries'],
  [4625867329,4626056652,'Taurus'],
  [4626056652,4626233188,'Gemini'],
  [4626233188,4626403379,'Cancer'],
  [4626403379,4626575131,'Leo'],
  [4626575131,4626755457,'Virgo'],
  [4626755457,4626948301,'Libra'],
  [4626948301,4627153208,'Scorpio'],
  [4627153208,4627366504,'Sagittarius'],
  [4627366504,4627584038,'Capricorn'],
  [4627584038,4627802528,'Aquarius'],
  [4627802528,4628018188,'Pisces'],
  [4628018188,4628225811,'Aries'],
  [4628225811,4628420817,'Taurus'],
  [4628420817,4628602571,'Gemini'],
  [4628602571,4628775191,'Cancer'],
  [4628775191,4628945617,'Leo'],
  [4628945617,4629121347,'Virgo'],
  [4629121347,4629308398,'Libra'],
  [4629308398,4629509135,'Scorpio'],
  [4629509135,4629721204,'Sagittarius'],
  [4629721204,4629939017,'Capricorn'],
  [4629939017,4630157069,'Aquarius'],
  [4630157069,4630371484,'Pisces'],
  [4630371484,4630579213,'Aries'],
  [4630579213,4630777526,'Taurus'],
  [4630777526,4630965086,'Gemini'],
  [4630965086,4631143451,'Cancer'],
  [4631143451,4631317104,'Leo'],
  [4631317104,4631492255,'Virgo'],
  [4631492255,4631675285,'Libra'],
  [4631675285,4631870810,'Scorpio'],
  [4631870810,4632079410,'Sagittarius'],
  [4632079410,4632296485,'Capricorn'],
  [4632296485,4632514533,'Aquarius'],
  [4632514533,4632727510,'Pisces'],
  [4632727510,4632932729,'Aries'],
  [4632932729,4633129923,'Taurus'],
  [4633129923,4633319728,'Gemini'],
  [4633319728,4633503305,'Cancer'],
  [4633503305,4633682794,'Leo'],
  [4633682794,4633861734,'Virgo'],
  [4633861734,4634044908,'Libra'],
  [4634044908,4634237300,'Scorpio'],
  [4634237300,4634441951,'Sagittarius'],
  [4634441951,4634657144,'Capricorn'],
  [4634657144,4634875628,'Aquarius'],
  [4634875628,4635088736,'Pisces'],
  [4635088736,4635291757,'Aries'],
  [4635291757,4635485142,'Taurus'],
  [4635485142,4635672128,'Gemini'],
  [4635672128,4635856119,'Cancer'],
  [4635856119,4636039459,'Leo'],
  [4636039459,4636223700,'Virgo'],
  [4636223700,4636410812,'Libra'],
  [4636410812,4636603958,'Scorpio'],
  [4636603958,4636806603,'Sagittarius'],
  [4636806603,4637019684,'Capricorn'],
  [4637019684,4637238506,'Aquarius'],
  [4637238506,4637453681,'Pisces'],
  [4637453681,4637657421,'Aries'],
  [4637657421,4637848366,'Taurus'],
  [4637848366,4638030578,'Gemini'],
  [4638030578,4638209966,'Cancer'],
  [4638209966,4638391457,'Leo'],
  [4638391457,4638577564,'Virgo'],
  [4638577564,4638768794,'Libra'],
  [4638768794,4638965524,'Scorpio'],
  [4638965524,4639169253,'Sagittarius'],
  [4639169253,4639381431,'Capricorn'],
  [4639381431,4639600151,'Aquarius'],
  [4639600151,4639817988,'Pisces'],
  [4639817988,4640025538,'Aries'],
  [4640025538,4640218189,'Taurus'],
  [4640218189,4640398374,'Gemini'],
  [4640398374,4640572642,'Cancer'],
  [4640572642,4640748146,'Leo'],
  [4640748146,4640930257,'Virgo'],
  [4640930257,4641121187,'Libra'],
  [4641121187,4641320467,'Scorpio'],
  [4641320467,4641526956,'Sagittarius'],
  [4641526956,4641740084,'Capricorn'],
  [4641740084,4641958634,'Aquarius'],
  [4641958634,4642177974,'Pisces'],
  [4642177974,4642390000,'Aries'],
  [4642390000,4642587929,'Taurus'],
  [4642587929,4642771004,'Gemini'],
  [4642771004,4642944177,'Cancer'],
  [4642944177,4643114876,'Leo'],
  [4643114876,4643290360,'Virgo'],
  [4643290360,4643475830,'Libra'],
  [4643475830,4643673082,'Scorpio'],
  [4643673082,4643880643,'Sagittarius'],
  [4643880643,4644095421,'Capricorn'],
  [4644095421,4644314285,'Aquarius'],
  [4644314285,4644533563,'Pisces'],
  [4644533563,4644747840,'Aries'],
  [4644747840,4644951133,'Taurus'],
  [4644951133,4645140385,'Gemini'],
  [4645140385,4645317521,'Cancer'],
  [4645317521,4645488233,'Leo'],
  [4645488233,4645659685,'Virgo'],
  [4645659685,4645838696,'Libra'],
  [4645838696,4646030054,'Scorpio'],
  [4646030054,4646234810,'Sagittarius'],
  [4646234810,4646449703,'Capricorn'],
  [4646449703,4646669093,'Aquarius'],
  [4646669093,4646887702,'Pisces'],
  [4646887702,4647101391,'Aries'],
  [4647101391,4647306732,'Taurus'],
  [4647306732,4647501243,'Gemini'],
  [4647501243,4647684758,'Cancer'],
  [4647684758,4647860103,'Leo'],
  [4647860103,4648032520,'Virgo'],
  [4648032520,4648208474,'Libra'],
  [4648208474,4648394208,'Scorpio'],
  [4648394208,4648593698,'Sagittarius'],
  [4648593698,4648806120,'Capricorn'],
  [4648806120,4649025343,'Aquarius'],
  [4649025343,4649243567,'Pisces'],
  [4649243567,4649455504,'Aries'],
  [4649455504,4649659311,'Taurus'],
  [4649659311,4649854927,'Gemini'],
  [4649854927,4650042804,'Cancer'],
  [4650042804,4650224069,'Leo'],
  [4650224069,4650401271,'Virgo'],
  [4650401271,4650578833,'Libra'],
  [4650578833,4650762505,'Scorpio'],
  [4650762505,4650957652,'Sagittarius'],
  [4650957652,4651166299,'Capricorn'],
  [4651166299,4651384273,'Aquarius'],
  [4651384273,4651602616,'Pisces'],
  [4651602616,4651813580,'Aries'],
  [4651813580,4652014684,'Taurus'],
  [4652014684,4652207643,'Gemini'],
  [4652207643,4652395241,'Cancer'],
  [4652395241,4652579479,'Leo'],
  [4652579479,4652761655,'Virgo'],
  [4652761655,4652943713,'Libra'],
  [4652943713,4653129318,'Scorpio'],
  [4653129318,4653323282,'Sagittarius'],
  [4653323282,4653529108,'Capricorn'],
  [4653529108,4653745346,'Aquarius'],
  [4653745346,4653964146,'Pisces'],
  [4653964146,4654175873,'Aries'],
  [4654175873,4654375771,'Taurus'],
  [4654375771,4654565340,'Gemini'],
  [4654565340,4654749155,'Cancer'],
  [4654749155,4654931561,'Leo'],
  [4654931561,4655115096,'Virgo'],
  [4655115096,4655300908,'Libra'],
  [4655300908,4655490412,'Scorpio'],
  [4655490412,4655686317,'Sagittarius'],
  [4655686317,4655891640,'Capricorn'],
  [4655891640,4656106659,'Aquarius'],
  [4656106659,4656325952,'Pisces'],
  [4656325952,4656539954,'Aries'],
  [4656539954,4656741456,'Taurus'],
  [4656741456,4656929935,'Gemini'],
  [4656929935,4657109961,'Cancer'],
  [4657109961,4657287585,'Leo'],
  [4657287585,4657467780,'Virgo'],
  [4657467780,4657653332,'Libra'],
  [4657653332,4657845285,'Scorpio'],
  [4657845285,4658044279,'Sagittarius'],
  [4658044279,4658251217,'Capricorn'],
  [4658251217,4658466159,'Aquarius'],
  [4658466159,4658685724,'Pisces'],
  [4658685724,4658902297,'Aries'],
  [4658902297,4659107752,'Taurus'],
  [4659107752,4659298793,'Gemini'],
  [4659298793,4659478145,'Cancer'],
  [4659478145,4659651858,'Leo'],
  [4659651858,4659826515,'Virgo'],
  [4659826515,4660007455,'Libra'],
  [4660007455,4660197732,'Scorpio'],
  [4660197732,4660397966,'Sagittarius'],
  [4660397966,4660607030,'Capricorn'],
  [4660607030,4660822926,'Aquarius'],
  [4660822926,4661042514,'Pisces'],
  [4661042514,4661260479,'Aries'],
  [4661260479,4661470103,'Taurus'],
  [4661470103,4661666468,'Gemini'],
  [4661666468,4661849393,'Cancer'],
  [4661849393,4662023085,'Leo'],
  [4662023085,4662194011,'Virgo'],
  [4662194011,4662369024,'Libra'],
  [4662369024,4662553846,'Scorpio'],
  [4662553846,4662751429,'Sagittarius'],
  [4662751429,4662960803,'Capricorn'],
  [4662960803,4663177796,'Aquarius'],
  [4663177796,4663397387,'Pisces'],
  [4663397387,4663615023,'Aries'],
  [4663615023,4663826475,'Taurus'],
  [4663826475,4664027827,'Gemini'],
  [4664027827,4664216993,'Cancer'],
  [4664216993,4664395203,'Leo'],
  [4664395203,4664566941,'Virgo'],
  [4664566941,4664738765,'Libra'],
  [4664738765,4664917787,'Scorpio'],
  [4664917787,4665109719,'Sagittarius'],
  [4665109719,4665316166,'Capricorn'],
  [4665316166,4665532995,'Aquarius'],
  [4665532995,4665752747,'Pisces'],
  [4665752747,4665969248,'Aries'],
  [4665969248,4666179494,'Taurus'],
  [4666179494,4666382180,'Gemini'],
  [4666382180,4666576157,'Cancer'],
  [4666576157,4666760876,'Leo'],
  [4666760876,4666937837,'Virgo'],
  [4666937837,4667111410,'Libra'],
  [4667111410,4667288145,'Scorpio'],
  [4667288145,4667474992,'Sagittarius'],
  [4667474992,4667676436,'Capricorn'],
  [4667676436,4667890966,'Aquarius'],
  [4667890966,4668110699,'Pisces'],
  [4668110699,4668326740,'Aries'],
  [4668326740,4668534737,'Taurus'],
  [4668534737,4668734902,'Gemini'],
  [4668734902,4668928781,'Cancer'],
  [4668928781,4669117086,'Leo'],
  [4669117086,4669300004,'Virgo'],
  [4669300004,4669479065,'Libra'],
  [4669479065,4669658397,'Scorpio'],
  [4669658397,4669844043,'Sagittarius'],
  [4669844043,4670041632,'Capricorn'],
  [4670041632,4670252683,'Aquarius'],
  [4670252683,4670471647,'Pisces'],
  [4670471647,4670688482,'Aries'],
  [4670688482,4670895903,'Taurus'],
  [4670895903,4671093010,'Gemini'],
  [4671093010,4671282914,'Cancer'],
  [4671282914,4671469098,'Leo'],
  [4671469098,4671653548,'Virgo'],
  [4671653548,4671837190,'Libra'],
  [4671837190,4672021657,'Scorpio'],
  [4672021657,4672210362,'Sagittarius'],
  [4672210362,4672407703,'Capricorn'],
  [4672407703,4672616412,'Aquarius'],
  [4672616412,4672834038,'Pisces'],
  [4672834038,4673052212,'Aries'],
  [4673052212,4673261716,'Taurus'],
  [4673261716,4673458670,'Gemini'],
  [4673458670,4673645210,'Cancer'],
  [4673645210,4673826248,'Leo'],
  [4673826248,4674006548,'Virgo'],
  [4674006548,4674189350,'Libra'],
  [4674189350,4674376483,'Scorpio'],
  [4674376483,4674569343,'Sagittarius'],
  [4674569343,4674769589,'Capricorn'],
  [4674769589,4674978592,'Aquarius'],
  [4674978592,4675195327,'Pisces'],
  [4675195327,4675414386,'Aries'],
  [4675414386,4675627344,'Taurus'],
  [4675627344,4675827781,'Gemini'],
  [4675827781,4676014953,'Cancer'],
  [4676014953,4676192839,'Leo'],
  [4676192839,4676367424,'Virgo'],
  [4676367424,4676544593,'Libra'],
  [4676544593,4676728818,'Scorpio'],
  [4676728818,4676922404,'Sagittarius'],
  [4676922404,4677125446,'Capricorn'],
  [4677125446,4677336598,'Aquarius'],
  [4677336598,4677553644,'Pisces'],
  [4677553644,4677772865,'Aries'],
  [4677772865,4677988442,'Taurus'],
  [4677988442,4678193907,'Gemini'],
  [4678193907,4678385713,'Cancer'],
  [4678385713,4678565106,'Leo'],
  [4678565106,4678737150,'Virgo'],
  [4678737150,4678908706,'Libra'],
  [4678908706,4679086626,'Scorpio'],
  [4679086626,4679276008,'Sagittarius'],
  [4679276008,4679478327,'Capricorn'],
  [4679478327,4679690921,'Aquarius'],
  [4679690921,4679909018,'Pisces'],
  [4679909018,4680128113,'Aries'],
  [4680128113,4680344297,'Taurus'],
  [4680344297,4680553252,'Gemini'],
  [4680553252,4680750855,'Cancer'],
  [4680750855,4680935576,'Leo'],
  [4680935576,4681109907,'Virgo'],
  [4681109907,4681279765,'Libra'],
  [4681279765,4681452689,'Scorpio'],
  [4681452689,4681635874,'Sagittarius'],
  [4681635874,4681833646,'Capricorn'],
  [4681833646,4682044854,'Aquarius'],
  [4682044854,4682263379,'Pisces'],
  [4682263379,4682482403,'Aries'],
  [4682482403,4682697712,'Taurus'],
  [4682697712,4682907048,'Gemini'],
  [4682907048,4683108081,'Cancer'],
  [4683108081,4683298589,'Leo'],
  [4683298589,4683478480,'Virgo'],
  [4683478480,4683651247,'Libra'],
  [4683651247,4683823367,'Scorpio'],
  [4683823367,4684002432,'Sagittarius'],
  [4684002432,4684194738,'Capricorn'],
  [4684194738,4684401988,'Aquarius'],
  [4684401988,4684619307,'Pisces'],
  [4684619307,4684838237,'Aries'],
  [4684838237,4685052501,'Taurus'],
  [4685052501,4685260010,'Gemini'],
  [4685260010,4685460587,'Cancer'],
  [4685460587,4685653716,'Leo'],
  [4685653716,4685838780,'Virgo'],
  [4685838780,4686016969,'Libra'],
  [4686016969,4686192415,'Scorpio'],
  [4686192415,4686371441,'Sagittarius'],
  [4686371441,4686560580,'Capricorn'],
  [4686560580,4686763599,'Aquarius'],
  [4686763599,4686978356,'Pisces'],
  [4686978356,4687196961,'Aries'],
  [4687196961,4687411045,'Taurus'],
  [4687411045,4687616735,'Gemini'],
  [4687616735,4687814421,'Cancer'],
  [4687814421,4688005839,'Leo'],
  [4688005839,4688192203,'Virgo'],
  [4688192203,4688374519,'Libra'],
  [4688374519,4688554941,'Scorpio'],
  [4688554941,4688737435,'Sagittarius'],
  [4688737435,4688927050,'Capricorn'],
  [4688927050,4689127870,'Aquarius'],
  [4689127870,4689340061,'Pisces'],
  [4689340061,4689558087,'Aries'],
  [4689558087,4689773165,'Taurus'],
  [4689773165,4689978910,'Gemini'],
  [4689978910,4690174235,'Cancer'],
  [4690174235,4690361717,'Leo'],
  [4690361717,4690544925,'Virgo'],
  [4690544925,4690726922,'Libra'],
  [4690726922,4690910126,'Scorpio'],
  [4690910126,4691096857,'Sagittarius'],
  [4691096857,4691289730,'Capricorn'],
  [4691289730,4691491245,'Aquarius'],
  [4691491245,4691702211,'Pisces'],
  [4691702211,4691919627,'Aries'],
  [4691919627,4692136378,'Taurus'],
  [4692136378,4692344616,'Gemini'],
  [4692344616,4692540494,'Cancer'],
  [4692540494,4692725366,'Leo'],
  [4692725366,4692903784,'Virgo'],
  [4692903784,4693081203,'Libra'],
  [4693081203,4693262367,'Scorpio'],
  [4693262367,4693450375,'Sagittarius'],
  [4693450375,4693646480,'Capricorn'],
  [4693646480,4693850655,'Aquarius'],
  [4693850655,4694062236,'Pisces'],
  [4694062236,4694279326,'Aries'],
  [4694279326,4694497412,'Taurus'],
  [4694497412,4694709455,'Gemini'],
  [4694709455,4694909307,'Cancer'],
  [4694909307,4695095474,'Leo'],
  [4695095474,4695271434,'Virgo'],
  [4695271434,4695443598,'Libra'],
  [4695443598,4695619013,'Scorpio'],
  [4695619013,4695803393,'Sagittarius'],
  [4695803393,4695999296,'Capricorn'],
  [4695999296,4696205530,'Aquarius'],
  [4696205530,4696418860,'Pisces'],
  [4696418860,4696636179,'Aries'],
  [4696636179,4696854521,'Taurus'],
  [4696854521,4697069356,'Gemini'],
  [4697069356,4697274616,'Cancer'],
  [4697274616,4697466051,'Leo'],
  [4697466051,4697644278,'Virgo'],
  [4697644278,4697814642,'Libra'],
  [4697814642,4697984894,'Scorpio'],
  [4697984894,4698162854,'Sagittarius'],
  [4698162854,4698353988,'Capricorn'],
  [4698353988,4698558859,'Aquarius'],
  [4698558859,4698773150,'Pisces'],
  [4698773150,4698991165,'Aries'],
  [4698991165,4699209006,'Taurus'],
  [4699209006,4699424032,'Gemini'],
  [4699424032,4699632567,'Cancer'],
  [4699632567,4699830140,'Leo'],
  [4699830140,4700014556,'Virgo'],
  [4700014556,4700188306,'Libra'],
  [4700188306,4700357859,'Scorpio'],
  [4700357859,4700531318,'Sagittarius'],
  [4700531318,4700716071,'Capricorn'],
  [4700716071,4700915849,'Aquarius'],
  [4700915849,4701128330,'Pisces'],
  [4701128330,4701346622,'Aries'],
  [4701346622,4701564159,'Taurus'],
  [4701564159,4701777631,'Gemini'],
  [4701777631,4701985469,'Cancer'],
  [4701985469,4702185617,'Leo'],
  [4702185617,4702375850,'Virgo'],
  [4702375850,4702556126,'Libra'],
  [4702556126,4702730058,'Scorpio'],
  [4702730058,4702904054,'Sagittarius'],
  [4702904054,4703085356,'Capricorn'],
  [4703085356,4703279579,'Aquarius'],
  [4703279579,4703487729,'Pisces'],
  [4703487729,4703704772,'Aries'],
  [4703704772,4703922520,'Taurus'],
  [4703922520,4704134941,'Gemini'],
  [4704134941,4704340040,'Cancer'],
  [4704340040,4704537987,'Leo'],
  [4704537987,4704729134,'Virgo'],
  [4704729134,4704913903,'Libra'],
  [4704913903,4705093927,'Scorpio'],
  [4705093927,4705272785,'Sagittarius'],
  [4705272785,4705455589,'Capricorn'],
  [4705455589,4705647545,'Aquarius'],
  [4705647545,4705851652,'Pisces'],
  [4705851652,4706066157,'Aries'],
  [4706066157,4706284108,'Taurus'],
  [4706284108,4706497249,'Gemini'],
  [4706497249,4706700935,'Cancer'],
  [4706700935,4706895147,'Leo'],
  [4706895147,4707082485,'Virgo'],
  [4707082485,4707266070,'Libra'],
  [4707266070,4707448588,'Scorpio'],
  [4707448588,4707632343,'Sagittarius'],
  [4707632343,4707819754,'Capricorn'],
  [4707819754,4708013641,'Aquarius'],
  [4708013641,4708216572,'Pisces'],
  [4708216572,4708428931,'Aries'],
  [4708428931,4708646704,'Taurus'],
  [4708646704,4708861898,'Gemini'],
  [4708861898,4709067143,'Cancer'],
  [4709067143,4709259998,'Leo'],
  [4709259998,4709443079,'Virgo'],
  [4709443079,4709621617,'Libra'],
  [4709621617,4709800980,'Scorpio'],
  [4709800980,4709985075,'Sagittarius'],
  [4709985075,4710175734,'Capricorn'],
  [4710175734,4710373336,'Aquarius'],
  [4710373336,4710578068,'Pisces'],
  [4710578068,4710790060,'Aries'],
  [4710790060,4711007540,'Taurus'],
  [4711007540,4711224831,'Gemini'],
  [4711224831,4711433831,'Cancer'],
  [4711433831,4711629141,'Leo'],
  [4711629141,4711811287,'Virgo'],
  [4711811287,4711985605,'Libra'],
  [4711985605,4712159259,'Scorpio'],
  [4712159259,4712338737,'Sagittarius'],
  [4712338737,4712527915,'Capricorn'],
  [4712527915,4712727120,'Aquarius'],
  [4712727120,4712934364,'Pisces'],
  [4712934364,4713147600,'Aries'],
  [4713147600,4713365119,'Taurus'],
  [4713365119,4713583525,'Gemini'],
  [4713583525,4713796297,'Cancer'],
  [4713796297,4713996587,'Leo'],
  [4713996587,4714181996,'Virgo'],
  [4714181996,4714356065,'Libra'],
  [4714356065,4714525962,'Scorpio'],
  [4714525962,4714699601,'Sagittarius'],
  [4714699601,4714883357,'Capricorn'],
  [4714883357,4715079903,'Aquarius'],
  [4715079903,4715287492,'Pisces'],
  [4715287492,4715502059,'Aries'],
  [4715502059,4715720002,'Taurus'],
  [4715720002,4715938397,'Gemini'],
  [4715938397,4716152978,'Cancer'],
  [4716152978,4716357897,'Leo'],
  [4716357897,4716548977,'Virgo'],
  [4716548977,4716726997,'Libra'],
  [4716726997,4716897442,'Scorpio'],
  [4716897442,4717067986,'Sagittarius'],
  [4717067986,4717246166,'Capricorn'],
  [4717246166,4717437171,'Aquarius'],
  [4717437171,4717641726,'Pisces'],
  [4717641726,4717855989,'Aries'],
  [4717855989,4718074288,'Taurus'],
  [4718074288,4718292132,'Gemini'],
  [4718292132,4718506164,'Cancer'],
  [4718506164,4718712795,'Leo'],
  [4718712795,4718908575,'Virgo'],
  [4718908575,4719092488,'Libra'],
  [4719092488,4719267414,'Scorpio'],
  [4719267414,4719439242,'Sagittarius'],
  [4719439242,4719615014,'Capricorn'],
  [4719615014,4719801025,'Aquarius'],
  [4719801025,4720000621,'Pisces'],
  [4720000621,4720212347,'Aries'],
  [4720212347,4720430325,'Taurus'],
  [4720430325,4720647785,'Gemini'],
  [4720647785,4720860188,'Cancer'],
  [4720860188,4721065291,'Leo'],
  [4721065291,4721261989,'Virgo'],
  [4721261989,4721449993,'Libra'],
  [4721449993,4721630605,'Scorpio'],
  [4721630605,4721807196,'Sagittarius'],
  [4721807196,4721984799,'Capricorn'],
  [4721984799,4722169057,'Aquarius'],
  [4722169057,4722364575,'Pisces'],
  [4722364575,4722572640,'Aries'],
  [4722572640,4722789375,'Taurus'],
  [4722789375,4723006996,'Gemini'],
  [4723006996,4723218501,'Cancer'],
  [4723218501,4723420900,'Leo'],
  [4723420900,4723614811,'Virgo'],
  [4723614811,4723802388,'Libra'],
  [4723802388,4723985901,'Scorpio'],
  [4723985901,4724167524,'Sagittarius'],
  [4724167524,4724349819,'Capricorn'],
  [4724349819,4724536202,'Aquarius'],
  [4724536202,4724730614,'Pisces'],
  [4724730614,4724935862,'Aries'],
  [4724935862,4725150869,'Taurus'],
  [4725150869,4725369090,'Gemini'],
  [4725369090,4725581596,'Cancer'],
  [4725581596,4725782887,'Leo'],
  [4725782887,4725973233,'Virgo'],
  [4725973233,4726156680,'Libra'],
  [4726156680,4726338038,'Scorpio'],
  [4726338038,4726520899,'Sagittarius'],
  [4726520899,4726707114,'Capricorn'],
  [4726707114,4726897708,'Aquarius'],
  [4726897708,4727094266,'Pisces'],
  [4727094266,4727299013,'Aries'],
  [4727299013,4727512700,'Taurus'],
  [4727512700,4727731471,'Gemini'],
  [4727731471,4727946648,'Cancer'],
  [4727946648,4728150052,'Leo'],
  [4728150052,4728339532,'Virgo'],
  [4728339532,4728518993,'Libra'],
  [4728518993,4728695036,'Scorpio'],
  [4728695036,4728873890,'Sagittarius'],
  [4728873890,4729059397,'Capricorn'],
  [4729059397,4729252428,'Aquarius'],
  [4729252428,4729452341,'Pisces'],
  [4729452341,4729658940,'Aries'],
  [4729658940,4729872530,'Taurus'],
  [4729872530,4730091402,'Gemini'],
  [4730091402,4730309263,'Cancer'],
  [4730309263,4730517269,'Leo'],
  [4730517269,4730710160,'Virgo'],
  [4730710160,4730889527,'Libra'],
  [4730889527,4731061752,'Scorpio'],
  [4731061752,4731234551,'Sagittarius'],
  [4731234551,4731414459,'Capricorn'],
  [4731414459,4731604911,'Aquarius'],
  [4731604911,4731805687,'Pisces'],
  [4731805687,4732014551,'Aries'],
  [4732014551,4732229332,'Taurus'],
  [4732229332,4732448089,'Gemini'],
  [4732448089,4732666930,'Cancer'],
  [4732666930,4732879050,'Leo'],
  [4732879050,4733077961,'Virgo'],
  [4733077961,4733262038,'Libra'],
  [4733262038,4733435345,'Scorpio'],
  [4733435345,4733605058,'Sagittarius'],
  [4733605058,4733778827,'Capricorn'],
  [4733778827,4733962785,'Aquarius'],
  [4733962785,4734159699,'Pisces'],
  [4734159699,4734368213,'Aries'],
  [4734368213,4734584172,'Taurus'],
  [4734584172,4734803137,'Gemini'],
  [4734803137,4735021277,'Cancer'],
  [4735021277,4735234356,'Leo'],
  [4735234356,4735437715,'Virgo'],
  [4735437715,4735628418,'Libra'],
  [4735628418,4735807436,'Scorpio'],
  [4735807436,4735979467,'Sagittarius'],
  [4735979467,4736151216,'Capricorn'],
  [4736151216,4736329632,'Aquarius'],
  [4736329632,4736520149,'Pisces'],
  [4736520149,4736724585,'Aries'],
  [4736724585,4736939762,'Taurus'],
  [4736939762,4737159078,'Gemini'],
  [4737159078,4737376319,'Cancer'],
  [4737376319,4737587641,'Leo'],
  [4737587641,4737791049,'Virgo'],
  [4737791049,4737985405,'Libra'],
  [4737985405,4738170697,'Scorpio'],
  [4738170697,4738348814,'Sagittarius'],
  [4738348814,4738523794,'Capricorn'],
  [4738523794,4738701304,'Aquarius'],
  [4738701304,4738887414,'Pisces'],
  [4738887414,4739086553,'Aries'],
  [4739086553,4739298636,'Taurus'],
  [4739298636,4739517618,'Gemini'],
  [4739517618,4739734815,'Cancer'],
  [4739734815,4739944284,'Leo'],
  [4739944284,4740144750,'Virgo'],
  [4740144750,4740337703,'Libra'],
  [4740337703,4740525032,'Scorpio'],
  [4740525032,4740708212,'Sagittarius'],
  [4740708212,4740888890,'Capricorn'],
  [4740888890,4741070011,'Aquarius'],
  [4741070011,4741256155,'Pisces'],
  [4741256155,4741452291,'Aries'],
  [4741452291,4741660911,'Taurus'],
  [4741660911,4741878668,'Gemini'],
  [4741878668,4742096612,'Cancer'],
  [4742096612,4742306091,'Leo'],
  [4742306091,4742504134,'Virgo'],
  [4742504134,4742693157,'Libra'],
  [4742693157,4742877521,'Scorpio'],
  [4742877521,4743060787,'Sagittarius'],
  [4743060787,4743244808,'Capricorn'],
  [4743244808,4743430638,'Aquarius'],
  [4743430638,4743620241,'Pisces'],
  [4743620241,4743817005,'Aries'],
  [4743817005,4744023997,'Taurus'],
  [4744023997,4744240439,'Gemini'],
  [4744240439,4744459360,'Cancer'],
  [4744459360,4744670915,'Leo'],
  [4744670915,4744869372,'Virgo'],
  [4744869372,4745055853,'Libra'],
  [4745055853,4745235643,'Scorpio'],
  [4745235643,4745414588,'Sagittarius'],
  [4745414588,4745596841,'Capricorn'],
  [4745596841,4745784213,'Aquarius'],
  [4745784213,4745977260,'Pisces'],
  [4745977260,4746176910,'Aries'],
  [4746176910,4746384694,'Taurus'],
  [4746384694,4746600643,'Gemini'],
  [4746600643,4746820283,'Cancer'],
  [4746820283,4747034847,'Leo'],
  [4747034847,4747236647,'Virgo'],
  [4747236647,4747424167,'Libra'],
  [4747424167,4747601648,'Scorpio'],
  [4747601648,4747775720,'Sagittarius'],
  [4747775720,4747952666,'Capricorn'],
  [4747952666,4748136787,'Aquarius'],
  [4748136787,4748329832,'Pisces'],
  [4748329832,4748531675,'Aries'],
  [4748531675,4748741485,'Taurus'],
  [4748741485,4748957983,'Gemini'],
  [4748957983,4749177892,'Cancer'],
  [4749177892,4749394761,'Leo'],
  [4749394761,4749601120,'Virgo'],
  [4749601120,4749793043,'Libra'],
  [4749793043,4749972287,'Scorpio'],
  [4749972287,4750144491,'Sagittarius'],
  [4750144491,4750316560,'Capricorn'],
  [4750316560,4750494834,'Aquarius'],
  [4750494834,4750683686,'Pisces'],
  [4750683686,4750884470,'Aries'],
  [4750884470,4751095414,'Taurus'],
  [4751095414,4751312910,'Gemini'],
  [4751312910,4751532784,'Cancer'],
  [4751532784,4751750201,'Leo'],
  [4751750201,4751959778,'Virgo'],
  [4751959778,4752157196,'Libra'],
  [4752157196,4752341644,'Scorpio'],
  [4752341644,4752516327,'Sagittarius'],
  [4752516327,4752687082,'Capricorn'],
  [4752687082,4752860749,'Aquarius'],
  [4752860749,4753043701,'Pisces'],
  [4753043701,4753240021,'Aries'],
  [4753240021,4753449493,'Taurus'],
  [4753449493,4753667353,'Gemini'],
  [4753667353,4753887144,'Cancer'],
  [4753887144,4754103646,'Leo'],
  [4754103646,4754313471,'Virgo'],
  [4754313471,4754514205,'Libra'],
  [4754514205,4754704428,'Scorpio'],
  [4754704428,4754884806,'Sagittarius'],
  [4754884806,4755058677,'Capricorn'],
  [4755058677,4755231677,'Aquarius'],
  [4755231677,4755410580,'Pisces'],
  [4755410580,4755601483,'Aries'],
  [4755601483,4755806996,'Taurus'],
  [4755806996,4756023674,'Gemini'],
  [4756023674,4756243416,'Cancer'],
  [4756243416,4756458816,'Leo'],
  [4756458816,4756666614,'Virgo'],
  [4756666614,4756866672,'Libra'],
  [4756866672,4757059456,'Scorpio'],
  [4757059456,4757245200,'Sagittarius'],
  [4757245200,4757424862,'Capricorn'],
  [4757424862,4757601491,'Aquarius'],
  [4757601491,4757780453,'Pisces'],
  [4757780453,4757968133,'Aries'],
  [4757968133,4758169284,'Taurus'],
  [4758169284,4758383325,'Gemini'],
  [4758383325,4758602852,'Cancer'],
  [4758602852,4758818219,'Leo'],
  [4758818219,4759024127,'Virgo'],
  [4759024127,4759220952,'Libra'],
  [4759220952,4759411576,'Scorpio'],
  [4759411576,4759598343,'Sagittarius'],
  [4759598343,4759782256,'Capricorn'],
  [4759782256,4759964293,'Aquarius'],
  [4759964293,4760147170,'Pisces'],
  [4760147170,4760335591,'Aries'],
  [4760335591,4760534531,'Taurus'],
  [4760534531,4760745803,'Gemini'],
  [4760745803,4760964706,'Cancer'],
  [4760964706,4761181385,'Leo'],
  [4761181385,4761387763,'Virgo'],
  [4761387763,4761582341,'Libra'],
  [4761582341,4761768655,'Scorpio'],
  [4761768655,4761951487,'Sagittarius'],
  [4761951487,4762134331,'Capricorn'],
  [4762134331,4762318877,'Aquarius'],
  [4762318877,4762506246,'Pisces'],
  [4762506246,4762698473,'Aries'],
  [4762698473,4762898569,'Taurus'],
  [4762898569,4763108649,'Gemini'],
  [4763108649,4763326684,'Cancer'],
  [4763326684,4763545081,'Leo'],
  [4763545081,4763754592,'Virgo'],
  [4763754592,4763950595,'Libra'],
  [4763950595,4764134854,'Scorpio'],
  [4764134854,4764312710,'Sagittarius'],
  [4764312710,4764490009,'Capricorn'],
  [4764490009,4764671277,'Aquarius'],
  [4764671277,4764859075,'Pisces'],
  [4764859075,4765054434,'Aries'],
  [4765054434,4765257706,'Taurus'],
  [4765257706,4765468886,'Gemini'],
  [4765468886,4765686494,'Cancer'],
  [4765686494,4765905773,'Leo'],
  [4765905773,4766119108,'Virgo'],
  [4766119108,4766319961,'Libra'],
  [4766319961,4766506850,'Scorpio'],
  [4766506850,4766683339,'Sagittarius'],
  [4766683339,4766855628,'Capricorn'],
  [4766855628,4767030379,'Aquarius'],
  [4767030379,4767213146,'Pisces'],
  [4767213146,4767407033,'Aries'],
  [4767407033,4767611934,'Taurus'],
  [4767611934,4767825217,'Gemini'],
  [4767825217,4768043355,'Cancer'],
  [4768043355,4768262470,'Leo'],
  [4768262470,4768477768,'Virgo'],
  [4768477768,4768683751,'Libra'],
  [4768683751,4768876698,'Scorpio'],
  [4768876698,4769056951,'Sagittarius'],
  [4769056951,4769228872,'Capricorn'],
  [4769228872,4769399233,'Aquarius'],
  [4769399233,4769575394,'Pisces'],
  [4769575394,4769763420,'Aries'],
  [4769763420,4769965687,'Taurus'],
  [4769965687,4770179389,'Gemini'],
  [4770179389,4770398420,'Cancer'],
  [4770398420,4770617137,'Leo'],
  [4770617137,4770831937,'Virgo'],
  [4770831937,4771039981,'Libra'],
  [4771039981,4771238276,'Scorpio'],
  [4771238276,4771425027,'Sagittarius'],
  [4771425027,4771601509,'Capricorn'],
  [4771601509,4771772586,'Aquarius'],
  [4771772586,4771945426,'Pisces'],
  [4771945426,4772127543,'Aries'],
  [4772127543,4772324201,'Taurus'],
  [4772324201,4772535172,'Gemini'],
  [4772535172,4772754059,'Cancer'],
  [4772754059,4772972677,'Leo'],
  [4772972677,4773186042,'Virgo'],
  [4773186042,4773392747,'Libra'],
  [4773392747,4773592279,'Scorpio'],
  [4773592279,4773783611,'Sagittarius'],
  [4773783611,4773966253,'Capricorn'],
  [4773966253,4774142233,'Aquarius'],
  [4774142233,4774316708,'Pisces'],
  [4774316708,4774496673,'Aries'],
  [4774496673,4774688627,'Taurus'],
  [4774688627,4774895203,'Gemini'],
  [4774895203,4775112300,'Cancer'],
  [4775112300,4775330934,'Leo'],
  [4775330934,4775543596,'Virgo'],
  [4775543596,4775747925,'Libra'],
  [4775747925,4775944982,'Scorpio'],
  [4775944982,4776136156,'Sagittarius'],
  [4776136156,4776321976,'Capricorn'],
  [4776321976,4776503196,'Aquarius'],
  [4776503196,4776682449,'Pisces'],
  [4776682449,4776864599,'Aries'],
  [4776864599,4777055386,'Taurus'],
  [4777055386,4777258718,'Gemini'],
  [4777258718,4777473321,'Cancer'],
  [4777473321,4777691818,'Leo'],
  [4777691818,4777905165,'Virgo'],
  [4777905165,4778108559,'Libra'],
  [4778108559,4778302495,'Scorpio'],
  [4778302495,4778490013,'Sagittarius'],
  [4778490013,4778674089,'Capricorn'],
  [4778674089,4778856815,'Aquarius'],
  [4778856815,4779040064,'Pisces'],
  [4779040064,4779226467,'Aries'],
  [4779226467,4779419527,'Taurus'],
  [4779419527,4779622383,'Gemini'],
  [4779622383,4779835296,'Cancer'],
  [4779835296,4780053531,'Leo'],
  [4780053531,4780268654,'Virgo'],
  [4780268654,4780473628,'Libra'],
  [4780473628,4780666686,'Scorpio'],
  [4780666686,4780850588,'Sagittarius'],
  [4780850588,4781029991,'Capricorn'],
  [4781029991,4781209464,'Aquarius'],
  [4781209464,4781392546,'Pisces'],
  [4781392546,4781581595,'Aries'],
  [4781581595,4781778079,'Taurus'],
  [4781778079,4781982863,'Gemini'],
  [4781982863,4782195707,'Cancer'],
  [4782195707,4782413759,'Leo'],
  [4782413759,4782630811,'Virgo'],
  [4782630811,4782839351,'Libra'],
  [4782839351,4783034922,'Scorpio'],
  [4783034922,4783218227,'Sagittarius'],
  [4783218227,4783393821,'Capricorn'],
  [4783393821,4783567901,'Aquarius'],
  [4783567901,4783746477,'Pisces'],
  [4783746477,4783933890,'Aries'],
  [4783933890,4784131731,'Taurus'],
  [4784131731,4784338902,'Gemini'],
  [4784338902,4784552996,'Cancer'],
  [4784552996,4784771127,'Leo'],
  [4784771127,4784989249,'Virgo'],
  [4784989249,4785201495,'Libra'],
  [4785201495,4785402071,'Scorpio'],
  [4785402071,4785588782,'Sagittarius'],
  [4785588782,4785764281,'Capricorn'],
  [4785764281,4785934712,'Aquarius'],
  [4785934712,4786107548,'Pisces'],
  [4786107548,4786289587,'Aries'],
  [4786289587,4786484719,'Taurus'],
  [4786484719,4786692182,'Gemini'],
  [4786692182,4786907573,'Cancer'],
  [4786907573,4787126064,'Leo'],
  [4787126064,4787344078,'Virgo'],
  [4787344078,4787558080,'Libra'],
  [4787558080,4787763409,'Scorpio'],
  [4787763409,4787956093,'Sagittarius'],
  [4787956093,4788135837,'Capricorn'],
  [4788135837,4788306933,'Aquarius'],
  [4788306933,4788476650,'Pisces'],
  [4788476650,4788653010,'Aries'],
  [4788653010,4788842425,'Taurus'],
  [4788842425,4789046706,'Gemini'],
  [4789046706,4789261755,'Cancer'],
  [4789261755,4789480595,'Leo'],
  [4789480595,4789697936,'Virgo'],
  [4789697936,4789911167,'Libra'],
  [4789911167,4790118071,'Scorpio'],
  [4790118071,4790315632,'Sagittarius'],
  [4790315632,4790501762,'Capricorn'],
  [4790501762,4790677856,'Aquarius'],
  [4790677856,4790849196,'Pisces'],
  [4790849196,4791023259,'Aries'],
  [4791023259,4791207490,'Taurus'],
  [4791207490,4791406411,'Gemini'],
  [4791406411,4791618629,'Cancer'],
  [4791618629,4791837137,'Leo'],
  [4791837137,4792054178,'Virgo'],
  [4792054178,4792265638,'Libra'],
  [4792265638,4792470580,'Scorpio'],
  [4792470580,4792668585,'Sagittarius'],
  [4792668585,4792858735,'Capricorn'],
  [4792858735,4793040965,'Aquarius'],
  [4793040965,4793217791,'Pisces'],
  [4793217791,4793394401,'Aries'],
  [4793394401,4793577280,'Taurus'],
  [4793577280,4793771960,'Gemini'],
  [4793771960,4793980015,'Cancer'],
  [4793980015,4794196992,'Leo'],
  [4794196992,4794414411,'Virgo'],
  [4794414411,4794625336,'Libra'],
  [4794625336,4794827528,'Scorpio'],
  [4794827528,4795022062,'Sagittarius'],
  [4795022062,4795210807,'Capricorn'],
  [4795210807,4795395315,'Aquarius'],
  [4795395315,4795577262,'Pisces'],
  [4795577262,4795759300,'Aries'],
  [4795759300,4795945287,'Taurus'],
  [4795945287,4796139478,'Gemini'],
  [4796139478,4796344618,'Cancer'],
  [4796344618,4796559391,'Leo'],
  [4796559391,4796777326,'Virgo'],
  [4796777326,4796989879,'Libra'],
  [4796989879,4797191772,'Scorpio'],
  [4797191772,4797382961,'Sagittarius'],
  [4797382961,4797566861,'Capricorn'],
  [4797566861,4797747882,'Aquarius'],
  [4797747882,4797929819,'Pisces'],
  [4797929819,4798115274,'Aries'],
  [4798115274,4798305920,'Taurus'],
  [4798305920,4798503183,'Gemini'],
  [4798503183,4798708437,'Cancer'],
  [4798708437,4798921766,'Leo'],
  [4798921766,4799139782,'Virgo'],
  [4799139782,4799355106,'Libra'],
  [4799355106,4799560085,'Scorpio'],
  [4799560085,4799751619,'Sagittarius'],
  [4799751619,4799932170,'Capricorn'],
  [4799932170,4800107556,'Aquarius'],
  [4800107556,4800284271,'Pisces'],
  [4800284271,4800467447,'Aries'],
  [4800467447,4800659491,'Taurus'],
  [4800659491,4800860079,'Gemini'],
  [4800860079,4801067782,'Cancer'],
  [4801067782,4801281422,'Leo'],
  [4801281422,4801499223,'Virgo'],
  [4801499223,4801716593,'Libra'],
  [4801716593,4801926180,'Scorpio'],
  [4801926180,4802122091,'Sagittarius'],
  [4802122091,4802303892,'Capricorn'],
  [4802303892,4802476536,'Aquarius'],
  [4802476536,4802647586,'Pisces'],
  [4802647586,4802824550,'Aries'],
  [4802824550,4803012634,'Taurus'],
  [4803012634,4803212855,'Gemini'],
  [4803212855,4803422415,'Cancer'],
  [4803422415,4803637510,'Leo'],
  [4803637510,4803855357,'Virgo'],
  [4803855357,4804073144,'Libra'],
  [4804073144,4804285892,'Scorpio'],
  [4804285892,4804487430,'Sagittarius'],
  [4804487430,4804674493,'Capricorn'],
  [4804674493,4804849367,'Aquarius'],
  [4804849367,4805018669,'Pisces'],
  [4805018669,4805190532,'Aries'],
  [4805190532,4805372245,'Taurus'],
  [4805372245,4805567770,'Gemini'],
  [4805567770,4805775943,'Cancer'],
  [4805775943,4805991749,'Leo'],
  [4805991749,4806209959,'Virgo'],
  [4806209959,4806427119,'Libra'],
  [4806427119,4806640162,'Scorpio'],
  [4806640162,4806844972,'Sagittarius'],
  [4806844972,4807037821,'Capricorn'],
  [4807037821,4807218373,'Aquarius'],
  [4807218373,4807390745,'Pisces'],
  [4807390745,4807561888,'Aries'],
  [4807561888,4807739353,'Taurus'],
  [4807739353,4807929065,'Gemini'],
  [4807929065,4808132843,'Cancer'],
  [4808132843,4808347210,'Leo'],
  [4808347210,4808565518,'Virgo'],
  [4808565518,4808782032,'Libra'],
  [4808782032,4808993479,'Scorpio'],
  [4808993479,4809197813,'Sagittarius'],
  [4809197813,4809393237,'Capricorn'],
  [4809393237,4809579046,'Aquarius'],
  [4809579046,4809757058,'Pisces'],
  [4809757058,4809931786,'Aries'],
  [4809931786,4810109330,'Taurus'],
  [4810109330,4810295728,'Gemini'],
  [4810295728,4810494832,'Cancer'],
  [4810494832,4810706046,'Leo'],
  [4810706046,4810923707,'Virgo'],
  [4810923707,4811140174,'Libra'],
  [4811140174,4811350124,'Scorpio'],
  [4811350124,4811551767,'Sagittarius'],
  [4811551767,4811745549,'Capricorn'],
  [4811745549,4811932706,'Aquarius'],
  [4811932706,4812114961,'Pisces'],
  [4812114961,4812294884,'Aries'],
  [4812294884,4812476122,'Taurus'],
  [4812476122,4812663094,'Gemini'],
  [4812663094,4812859849,'Cancer'],
  [4812859849,4813067994,'Leo'],
  [4813067994,4813284424,'Virgo'],
  [4813284424,4813501536,'Libra'],
  [4813501536,4813711604,'Scorpio'],
  [4813711604,4813911120,'Sagittarius'],
  [4813911120,4814101200,'Capricorn'],
  [4814101200,4814285392,'Aquarius'],
  [4814285392,4814467462,'Pisces'],
  [4814467462,4814650294,'Aries'],
  [4814650294,4814835930,'Taurus'],
  [4814835930,4815026323,'Gemini'],
  [4815026323,4815223884,'Cancer'],
  [4815223884,4815430664,'Leo'],
  [4815430664,4815645937,'Virgo'],
  [4815645937,4815864049,'Libra'],
  [4815864049,4816076226,'Scorpio'],
  [4816076226,4816276253,'Sagittarius'],
  [4816276253,4816463905,'Capricorn'],
  [4816463905,4816643623,'Aquarius'],
  [4816643623,4816821421,'Pisces'],
  [4816821421,4817002418,'Aries'],
  [4817002418,4817189457,'Taurus'],
  [4817189457,4817383187,'Gemini'],
  [4817383187,4817583585,'Cancer'],
  [4817583585,4817791166,'Leo'],
  [4817791166,4818006000,'Virgo'],
  [4818006000,4818224905,'Libra'],
  [4818224905,4818440238,'Scorpio'],
  [4818440238,4818643811,'Sagittarius'],
  [4818643811,4818832622,'Capricorn'],
  [4818832622,4819010034,'Aquarius'],
  [4819010034,4819182909,'Pisces'],
  [4819182909,4819358490,'Aries'],
  [4819358490,4819542128,'Taurus'],
  [4819542128,4819735760,'Gemini'],
  [4819735760,4819938322,'Cancer'],
  [4819938322,4820147929,'Leo'],
  [4820147929,4820363283,'Virgo'],
  [4820363283,4820582415,'Libra'],
  [4820582415,4820800129,'Scorpio'],
  [4820800129,4821008592,'Sagittarius'],
  [4821008592,4821202262,'Capricorn'],
  [4821202262,4821381763,'Aquarius'],
  [4821381763,4821552898,'Pisces'],
  [4821552898,4821723500,'Aries'],
  [4821723500,4821900919,'Taurus'],
  [4821900919,4822089918,'Gemini'],
  [4822089918,4822291149,'Cancer'],
  [4822291149,4822501850,'Leo'],
  [4822501850,4822718264,'Virgo'],
  [4822718264,4822937280,'Libra'],
  [4822937280,4823155329,'Scorpio'],
  [4823155329,4823366968,'Sagittarius'],
  [4823366968,4823566557,'Capricorn'],
  [4823566557,4823751995,'Aquarius'],
  [4823751995,4823926342,'Pisces'],
  [4823926342,4824096124,'Aries'],
  [4824096124,4824268933,'Taurus'],
  [4824268933,4824451474,'Gemini'],
  [4824451474,4824647501,'Cancer'],
  [4824647501,4824856262,'Leo'],
  [4824856262,4825073041,'Virgo'],
  [4825073041,4825292097,'Libra'],
  [4825292097,4825509005,'Scorpio'],
  [4825509005,4825720316,'Sagittarius'],
  [4825720316,4825922812,'Capricorn'],
  [4825922812,4826114272,'Aquarius'],
  [4826114272,4826295182,'Pisces'],
  [4826295182,4826469219,'Aries'],
  [4826469219,4826642271,'Taurus'],
  [4826642271,4826820983,'Gemini'],
  [4826820983,4827011066,'Cancer'],
  [4827011066,4827215041,'Leo'],
  [4827215041,4827430192,'Virgo'],
  [4827430192,4827649387,'Libra'],
  [4827649387,4827865437,'Scorpio'],
  [4827865437,4828074359,'Sagittarius'],
  [4828074359,4828275190,'Capricorn'],
  [4828275190,4828468238,'Aquarius'],
  [4828468238,4828654247,'Pisces'],
  [4828654247,4828834737,'Aries'],
  [4828834737,4829012653,'Taurus'],
  [4829012653,4829192558,'Gemini'],
  [4829192558,4829379914,'Cancer'],
  [4829379914,4829579228,'Leo'],
  [4829579228,4829791076,'Virgo'],
  [4829791076,4830009869,'Libra'],
  [4830009869,4830226392,'Scorpio'],
  [4830226392,4830433916,'Sagittarius'],
  [4830433916,4830631254,'Capricorn'],
  [4830631254,4830821023,'Aquarius'],
  [4830821023,4831006595,'Pisces'],
  [4831006595,4831190371,'Aries'],
  [4831190371,4831373766,'Taurus'],
  [4831373766,4831558482,'Gemini'],
  [4831558482,4831747666,'Cancer'],
  [4831747666,4831945445,'Leo'],
  [4831945445,4832154432,'Virgo'],
  [4832154432,4832372136,'Libra'],
  [4832372136,4832590042,'Scorpio'],
  [4832590042,4832798826,'Sagittarius'],
  [4832798826,4832994756,'Capricorn'],
  [4832994756,4833180416,'Aquarius'],
  [4833180416,4833361289,'Pisces'],
  [4833361289,4833542467,'Aries'],
  [4833542467,4833726897,'Taurus'],
  [4833726897,4833915475,'Gemini'],
  [4833915475,4834108777,'Cancer'],
  [4834108777,4834308539,'Leo'],
  [4834308539,4834516959,'Virgo'],
  [4834516959,4834733676,'Libra'],
  [4834733676,4834952825,'Scorpio'],
  [4834952825,4835164825,'Sagittarius'],
  [4835164825,4835363030,'Capricorn'],
  [4835363030,4835547770,'Aquarius'],
  [4835547770,4835724497,'Pisces'],
  [4835724497,4835900078,'Aries'],
  [4835900078,4836080148,'Taurus'],
  [4836080148,4836267664,'Gemini'],
  [4836267664,4836463055,'Cancer'],
  [4836463055,4836665836,'Leo'],
  [4836665836,4836875862,'Virgo'],
  [4836875862,4837092526,'Libra'],
  [4837092526,4837312187,'Scorpio'],
  [4837312187,4837527302,'Sagittarius'],
  [4837527302,4837730176,'Capricorn'],
  [4837730176,4837918191,'Aquarius'],
  [4837918191,4838094774,'Pisces'],
  [4838094774,4838266606,'Aries'],
  [4838266606,4838440772,'Taurus'],
  [4838440772,4838622871,'Gemini'],
  [4838622871,4838815727,'Cancer'],
  [4838815727,4839019153,'Leo'],
  [4839019153,4839230991,'Virgo'],
  [4839230991,4839448465,'Libra'],
  [4839448465,4839668064,'Scorpio'],
  [4839668064,4839884533,'Sagittarius'],
  [4839884533,4840091616,'Capricorn'],
  [4840091616,4840285190,'Aquarius'],
  [4840285190,4840465855,'Pisces'],
  [4840465855,4840638346,'Aries'],
  [4840638346,4840809374,'Taurus'],
  [4840809374,4840985769,'Gemini'],
  [4840985769,4841172933,'Cancer'],
  [4841172933,4841373215,'Leo'],
  [4841373215,4841584865,'Virgo'],
  [4841584865,4841803064,'Libra'],
  [4841803064,4842022450,'Scorpio'],
  [4842022450,4842238377,'Sagittarius'],
  [4842238377,4842446920,'Capricorn'],
  [4842446920,4842644971,'Aquarius'],
  [4842644971,4842831515,'Pisces'],
  [4842831515,4843008599,'Aries'],
  [4843008599,4843180957,'Taurus'],
  [4843180957,4843354904,'Gemini'],
  [4843354904,4843536964,'Cancer'],
  [4843536964,4843732028,'Leo'],
  [4843732028,4843940835,'Virgo'],
  [4843940835,4844158658,'Libra'],
  [4844158658,4844377922,'Scorpio'],
  [4844377922,4844592546,'Sagittarius'],
  [4844592546,4844799705,'Capricorn'],
  [4844799705,4844998634,'Aquarius'],
  [4844998634,4845189191,'Pisces'],
  [4845189191,4845371961,'Aries'],
  [4845371961,4845549103,'Taurus'],
  [4845549103,4845724886,'Gemini'],
  [4845724886,4845905221,'Cancer'],
  [4845905221,4846096103,'Leo'],
  [4846096103,4846300848,'Virgo'],
  [4846300848,4846516931,'Libra'],
  [4846516931,4846736169,'Scorpio'],
  [4846736169,4846950106,'Sagittarius'],
  [4846950106,4847154944,'Capricorn'],
  [4847154944,4847351399,'Aquarius'],
  [4847351399,4847541680,'Pisces'],
  [4847541680,4847727399,'Aries'],
  [4847727399,4847909573,'Taurus'],
  [4847909573,4848090027,'Gemini'],
  [4848090027,4848272545,'Cancer'],
  [4848272545,4848462412,'Leo'],
  [4848462412,4848664158,'Virgo'],
  [4848664158,4848877922,'Libra'],
  [4848877922,4849097109,'Scorpio'],
  [4849097109,4849311782,'Sagittarius'],
  [4849311782,4849515698,'Capricorn'],
  [4849515698,4849709015,'Aquarius'],
  [4849709015,4849895593,'Pisces'],
  [4849895593,4850079476,'Aries'],
  [4850079476,4850263078,'Taurus'],
  [4850263078,4850447513,'Gemini'],
  [4850447513,4850634298,'Cancer'],
  [4850634298,4850826477,'Leo'],
  [4850826477,4851027816,'Virgo'],
  [4851027816,4851239953,'Libra'],
  [4851239953,4851458958,'Scorpio'],
  [4851458958,4851675590,'Sagittarius'],
  [4851675590,4851881315,'Capricorn'],
  [4851881315,4852073881,'Aquarius'],
  [4852073881,4852256811,'Pisces'],
  [4852256811,4852435788,'Aries'],
  [4852435788,4852615805,'Taurus'],
  [4852615805,4852799861,'Gemini'],
  [4852799861,4852989278,'Cancer'],
  [4852989278,4853185021,'Leo'],
  [4853185021,4853388472,'Virgo'],
  [4853388472,4853600589,'Libra'],
  [4853600589,4853819342,'Scorpio'],
  [4853819342,4854037978,'Sagittarius'],
  [4854037978,4854247690,'Capricorn'],
  [4854247690,4854443354,'Aquarius'],
  [4854443354,4854626133,'Pisces'],
  [4854626133,4854801360,'Aries'],
  [4854801360,4854975544,'Taurus'],
  [4854975544,4855154386,'Gemini'],
  [4855154386,4855341595,'Cancer'],
  [4855341595,4855538501,'Leo'],
  [4855538501,4855744542,'Virgo'],
  [4855744542,4855958160,'Libra'],
  [4855958160,4856176917,'Scorpio'],
  [4856176917,4856396343,'Sagittarius'],
  [4856396343,4856609803,'Capricorn'],
  [4856609803,4856811136,'Aquarius'],
  [4856811136,4856998350,'Pisces'],
  [4856998350,4857174371,'Aries'],
  [4857174371,4857345199,'Taurus'],
  [4857345199,4857517844,'Gemini'],
  [4857517844,4857698723,'Cancer'],
  [4857698723,4857891979,'Leo'],
  [4857891979,4858097900,'Virgo'],
  [4858097900,4858312994,'Libra'],
  [4858312994,4858532280,'Scorpio'],
  [4858532280,4858751255,'Sagittarius'],
  [4858751255,4858965832,'Capricorn'],
  [4858965832,4859171716,'Aquarius'],
  [4859171716,4859365574,'Pisces'],
  [4859365574,4859547133,'Aries'],
  [4859547133,4859719865,'Taurus'],
  [4859719865,4859890041,'Gemini'],
  [4859890041,4860065096,'Cancer'],
  [4860065096,4860251766,'Leo'],
  [4860251766,4860453437,'Virgo'],
  [4860453437,4860667697,'Libra'],
  [4860667697,4860887490,'Scorpio'],
  [4860887490,4861105877,'Sagittarius'],
  [4861105877,4861319091,'Capricorn'],
  [4861319091,4861525491,'Aquarius'],
  [4861525491,4861723500,'Pisces'],
  [4861723500,4861911709,'Aries'],
  [4861911709,4862090559,'Taurus'],
  [4862090559,4862263686,'Gemini'],
  [4862263686,4862437475,'Cancer'],
  [4862437475,4862619332,'Leo'],
  [4862619332,4862815138,'Virgo'],
  [4862815138,4863025678,'Libra'],
  [4863025678,4863244770,'Scorpio'],
  [4863244770,4863463142,'Sagittarius'],
  [4863463142,4863674792,'Capricorn'],
  [4863674792,4863878671,'Aquarius'],
  [4863878671,4864075815,'Pisces'],
  [4864075815,4864266722,'Aries'],
  [4864266722,4864451238,'Taurus'],
  [4864451238,4864630372,'Gemini'],
  [4864630372,4864807823,'Cancer'],
  [4864807823,4864989581,'Leo'],
  [4864989581,4865181927,'Virgo'],
  [4865181927,4865388153,'Libra'],
  [4865388153,4865605102,'Scorpio'],
  [4865605102,4865823722,'Sagittarius'],
  [4865823722,4866035383,'Capricorn'],
  [4866035383,4866237087,'Aquarius'],
  [4866237087,4866430601,'Pisces'],
  [4866430601,4866618941,'Aries'],
  [4866618941,4866804134,'Taurus'],
  [4866804134,4866987252,'Gemini'],
  [4866987252,4867169929,'Cancer'],
  [4867169929,4867355499,'Leo'],
  [4867355499,4867548531,'Virgo'],
  [4867548531,4867752669,'Libra'],
  [4867752669,4867967348,'Scorpio'],
  [4867967348,4868186005,'Sagittarius'],
  [4868186005,4868399322,'Capricorn'],
  [4868399322,4868601488,'Aquarius'],
  [4868601488,4868792627,'Pisces'],
  [4868792627,4868976519,'Aries'],
  [4868976519,4869157608,'Taurus'],
  [4869157608,4869339366,'Gemini'],
  [4869339366,4869524106,'Cancer'],
  [4869524106,4869713676,'Leo'],
  [4869713676,4869910074,'Virgo'],
  [4869910074,4870115148,'Libra'],
  [4870115148,4870328904,'Scorpio'],
  [4870328904,4870547393,'Sagittarius'],
  [4870547393,4870762954,'Capricorn'],
  [4870762954,4870968203,'Aquarius'],
  [4870968203,4871160456,'Pisces'],
  [4871160456,4871342106,'Aries'],
  [4871342106,4871518339,'Taurus'],
  [4871518339,4871694901,'Gemini'],
  [4871694901,4871876622,'Cancer'],
  [4871876622,4872066531,'Leo'],
  [4872066531,4872265572,'Virgo'],
  [4872265572,4872473117,'Libra'],
  [4872473117,4872687582,'Scorpio'],
  [4872687582,4872905985,'Sagittarius'],
  [4872905985,4873123146,'Capricorn'],
  [4873123146,4873332405,'Aquarius'],
  [4873332405,4873528904,'Pisces'],
  [4873528904,4873712339,'Aries'],
  [4873712339,4873886706,'Taurus'],
  [4873886706,4874058425,'Gemini'],
  [4874058425,4874234387,'Cancer'],
  [4874234387,4874420191,'Leo'],
  [4874420191,4874618315,'Virgo'],
  [4874618315,4874827270,'Libra'],
  [4874827270,4875043102,'Scorpio'],
  [4875043102,4875261668,'Sagittarius'],
  [4875261668,4875479163,'Capricorn'],
  [4875479163,4875691149,'Aquarius'],
  [4875691149,4875892752,'Pisces'],
  [4875892752,4876081234,'Aries'],
  [4876081234,4876258022,'Taurus'],
  [4876258022,4876428451,'Gemini'],
  [4876428451,4876599931,'Cancer'],
  [4876599931,4876779911,'Leo'],
  [4876779911,4876973507,'Virgo'],
  [4876973507,4877180908,'Libra'],
  [4877180908,4877397227,'Scorpio'],
  [4877397227,4877616068,'Sagittarius'],
  [4877616068,4877832950,'Capricorn'],
  [4877832950,4878045157,'Aquarius'],
  [4878045157,4878249790,'Pisces'],
  [4878249790,4878443764,'Aries'],
  [4878443764,4878626053,'Taurus'],
  [4878626053,4878799522,'Gemini'],
  [4878799522,4878970435,'Cancer'],
  [4878970435,4879146530,'Leo'],
  [4879146530,4879334696,'Virgo'],
  [4879334696,4879537874,'Libra'],
  [4879537874,4879752717,'Scorpio'],
  [4879752717,4879971562,'Sagittarius'],
  [4879971562,4880187749,'Capricorn'],
  [4880187749,4880398349,'Aquarius'],
  [4880398349,4880602465,'Pisces'],
  [4880602465,4880798936,'Aries'],
  [4880798936,4880986441,'Taurus'],
  [4880986441,4881165547,'Gemini'],
  [4881165547,4881340063,'Cancer'],
  [4881340063,4881516342,'Leo'],
  [4881516342,4881701367,'Virgo'],
  [4881701367,4881899984,'Libra'],
  [4881899984,4882111689,'Scorpio'],
  [4882111689,4882329883,'Sagittarius'],
  [4882329883,4882546052,'Capricorn'],
  [4882546052,4882755158,'Aquarius'],
  [4882755158,4882956499,'Pisces'],
  [4882956499,4883151148,'Aries'],
  [4883151148,4883339885,'Taurus'],
  [4883339885,4883523307,'Gemini'],
  [4883523307,4883703226,'Cancer'],
  [4883703226,4883883472,'Leo'],
  [4883883472,4884069309,'Virgo'],
  [4884069309,4884265632,'Libra'],
  [4884265632,4884474156,'Scorpio'],
  [4884474156,4884691045,'Sagittarius'],
  [4884691045,4884908014,'Capricorn'],
  [4884908014,4885117511,'Aquarius'],
  [4885117511,4885316830,'Pisces'],
  [4885316830,4885507527,'Aries'],
  [4885507527,4885692792,'Taurus'],
  [4885692792,4885875614,'Gemini'],
  [4885875614,4886058376,'Cancer'],
  [4886058376,4886243324,'Leo'],
  [4886243324,4886433094,'Virgo'],
  [4886433094,4886630586,'Libra'],
  [4886630586,4886837722,'Scorpio'],
  [4886837722,4887053227,'Sagittarius'],
  [4887053227,4887271219,'Capricorn'],
  [4887271219,4887483330,'Aquarius'],
  [4887483330,4887683830,'Pisces'],
  [4887683830,4887872398,'Aries'],
  [4887872398,4888052833,'Taurus'],
  [4888052833,4888230548,'Gemini'],
  [4888230548,4888410603,'Cancer'],
  [4888410603,4888596491,'Leo'],
  [4888596491,4888789765,'Virgo'],
  [4888789765,4888990638,'Libra'],
  [4888990638,4889198933,'Scorpio'],
  [4889198933,4889413871,'Sagittarius'],
  [4889413871,4889632341,'Capricorn'],
  [4889632341,4889847777,'Aquarius'],
  [4889847777,4890052706,'Pisces'],
  [4890052706,4890243519,'Aries'],
  [4890243519,4890422256,'Taurus'],
  [4890422256,4890594884,'Gemini'],
  [4890594884,4890768654,'Cancer'],
  [4890768654,4890949910,'Leo'],
  [4890949910,4891142148,'Virgo'],
  [4891142148,4891345017,'Libra'],
  [4891345017,4891555700,'Scorpio'],
  [4891555700,4891771381,'Sagittarius'],
  [4891771381,4891989745,'Capricorn'],
  [4891989745,4892207032,'Aquarius'],
  [4892207032,4892416940,'Pisces'],
  [4892416940,4892613602,'Aries'],
  [4892613602,4892795747,'Taurus'],
  [4892795747,4892967644,'Gemini'],
  [4892967644,4893136814,'Cancer'],
  [4893136814,4893311379,'Leo'],
  [4893311379,4893497749,'Virgo'],
  [4893497749,4893698069,'Libra'],
  [4893698069,4893909366,'Scorpio'],
  [4893909366,4894126279,'Sagittarius'],
  [4894126279,4894344606,'Capricorn'],
  [4894344606,4894561642,'Aquarius'],
  [4894561642,4894773794,'Pisces'],
  [4894773794,4894976013,'Aries'],
  [4894976013,4895164744,'Taurus'],
  [4895164744,4895341096,'Gemini'],
  [4895341096,4895510798,'Cancer'],
  [4895510798,4895681789,'Leo'],
  [4895681789,4895861858,'Virgo'],
  [4895861858,4896056101,'Libra'],
  [4896056101,4896264308,'Scorpio'],
  [4896264308,4896481063,'Sagittarius'],
  [4896481063,4896699615,'Capricorn'],
  [4896699615,4896915608,'Aquarius'],
  [4896915608,4897126722,'Pisces'],
  [4897126722,4897330518,'Aries'],
  [4897330518,4897524277,'Taurus'],
  [4897524277,4897707165,'Gemini'],
  [4897707165,4897881989,'Cancer'],
  [4897881989,4898054657,'Leo'],
  [4898054657,4898232327,'Virgo'],
  [4898232327,4898421275,'Libra'],
  [4898421275,4898624282,'Scorpio'],
  [4898624282,4898838584,'Sagittarius'],
  [4898838584,4899057001,'Capricorn'],
  [4899057001,4899272546,'Aquarius'],
  [4899272546,4899481586,'Pisces'],
  [4899481586,4899683151,'Aries'],
  [4899683151,4899877115,'Taurus'],
  [4899877115,4900063693,'Gemini'],
  [4900063693,4900244284,'Cancer'],
  [4900244284,4900422155,'Leo'],
  [4900422155,4900602188,'Virgo'],
  [4900602188,4900789760,'Libra'],
  [4900789760,4900988873,'Scorpio'],
  [4900988873,4901199734,'Sagittarius'],
  [4901199734,4901417262,'Capricorn'],
  [4901417262,4901633297,'Aquarius'],
  [4901633297,4901841565,'Pisces'],
  [4901841565,4902040197,'Aries'],
  [4902040197,4902230705,'Taurus'],
  [4902230705,4902415866,'Gemini'],
  [4902415866,4902598411,'Cancer'],
  [4902598411,4902780785,'Leo'],
  [4902780785,4902965515,'Virgo'],
  [4902965515,4903155583,'Libra'],
  [4903155583,4903354084,'Scorpio'],
  [4903354084,4903562637,'Sagittarius'],
  [4903562637,4903778967,'Capricorn'],
  [4903778967,4903996073,'Aquarius'],
  [4903996073,4904205728,'Pisces'],
  [4904205728,4904403566,'Aries'],
  [4904403566,4904590612,'Taurus'],
  [4904590612,4904771323,'Gemini'],
  [4904771323,4904950905,'Cancer'],
  [4904950905,4905133452,'Leo'],
  [4905133452,4905321208,'Virgo'],
  [4905321208,4905515057,'Libra'],
  [4905515057,4905715742,'Scorpio'],
  [4905715742,4905924179,'Sagittarius'],
  [4905924179,4906139762,'Capricorn'],
  [4906139762,4906357932,'Aquarius'],
  [4906357932,4906570532,'Pisces'],
  [4906570532,4906770686,'Aries'],
  [4906770686,4906957196,'Taurus'],
  [4906957196,4907134310,'Gemini'],
  [4907134310,4907308777,'Cancer'],
  [4907308777,4907487073,'Leo'],
  [4907487073,4907673424,'Virgo'],
  [4907673424,4907868857,'Libra'],
  [4907868857,4908072223,'Scorpio'],
  [4908072223,4908282232,'Sagittarius'],
  [4908282232,4908497922,'Capricorn'],
  [4908497922,4908716656,'Aquarius'],
  [4908716656,4908932193,'Pisces'],
  [4908932193,4909136802,'Aries'],
  [4909136802,4909326518,'Taurus'],
  [4909326518,4909503628,'Gemini'],
  [4909503628,4909674716,'Cancer'],
  [4909674716,4909847563,'Leo'],
  [4909847563,4910028747,'Virgo'],
  [4910028747,4910221586,'Libra'],
  [4910221586,4910425350,'Scorpio'],
  [4910425350,4910636953,'Sagittarius'],
  [4910636953,4910853398,'Capricorn'],
  [4910853398,4911072126,'Aquarius'],
  [4911072126,4911289021,'Pisces'],
  [4911289021,4911497773,'Aries'],
  [4911497773,4911692998,'Taurus'],
  [4911692998,4911874171,'Gemini'],
  [4911874171,4912046009,'Cancer'],
  [4912046009,4912215951,'Leo'],
  [4912215951,4912391665,'Virgo'],
  [4912391665,4912578907,'Libra'],
  [4912578907,4912779466,'Scorpio'],
  [4912779466,4912990752,'Sagittarius'],
  [4912990752,4913207857,'Capricorn'],
  [4913207857,4913426354,'Aquarius'],
  [4913426354,4913642677,'Pisces'],
  [4913642677,4913852829,'Aries'],
  [4913852829,4914052588,'Taurus'],
  [4914052588,4914239838,'Gemini'],
  [4914239838,4914416521,'Cancer'],
  [4914416521,4914588070,'Leo'],
  [4914588070,4914761517,'Virgo'],
  [4914761517,4914943613,'Libra'],
  [4914943613,4915138767,'Scorpio'],
  [4915138767,4915347027,'Sagittarius'],
  [4915347027,4915563727,'Capricorn'],
  [4915563727,4915782173,'Aquarius'],
  [4915782173,4915997142,'Pisces'],
  [4915997142,4916205657,'Aries'],
  [4916205657,4916406028,'Taurus'],
  [4916406028,4916597324,'Gemini'],
  [4916597324,4916780077,'Cancer'],
  [4916780077,4916957008,'Leo'],
  [4916957008,4917132845,'Virgo'],
  [4917132845,4917313418,'Libra'],
  [4917313418,4917504181,'Scorpio'],
  [4917504181,4917708000,'Sagittarius'],
  [4917708000,4917922762,'Capricorn'],
  [4917922762,4918141353,'Aquarius'],
  [4918141353,4918355863,'Pisces'],
  [4918355863,4918561922,'Aries'],
  [4918561922,4918759255,'Taurus'],
  [4918759255,4918949637,'Gemini'],
  [4918949637,4919135074,'Cancer'],
  [4919135074,4919317359,'Leo'],
  [4919317359,4919498629,'Virgo'],
  [4919498629,4919682119,'Libra'],
  [4919682119,4919872163,'Scorpio'],
  [4919872163,4920072783,'Sagittarius'],
  [4920072783,4920284843,'Capricorn'],
  [4920284843,4920503363,'Aquarius'],
  [4920503363,4920719104,'Pisces'],
  [4920719104,4920924724,'Aries'],
  [4920924724,4921118838,'Taurus'],
  [4921118838,4921304789,'Gemini'],
  [4921304789,4921487340,'Cancer'],
  [4921487340,4921670240,'Leo'],
  [4921670240,4921855398,'Virgo'],
  [4921855398,4922043731,'Libra'],
  [4922043731,4922236826,'Scorpio'],
  [4922236826,4922437447,'Sagittarius'],
  [4922437447,4922647744,'Capricorn'],
  [4922647744,4922865764,'Aquarius'],
  [4922865764,4923083672,'Pisces'],
  [4923083672,4923291941,'Aries'],
  [4923291941,4923486153,'Taurus'],
  [4923486153,4923668741,'Gemini'],
  [4923668741,4923845872,'Cancer'],
  [4923845872,4924023960,'Leo'],
  [4924023960,4924207389,'Virgo'],
  [4924207389,4924397638,'Libra'],
  [4924397638,4924594421,'Scorpio'],
  [4924594421,4924797742,'Sagittarius'],
  [4924797742,4925008425,'Capricorn'],
  [4925008425,4925225985,'Aquarius'],
  [4925225985,4925445478,'Pisces'],
  [4925445478,4925657957,'Aries'],
  [4925657957,4925856269,'Taurus'],
  [4925856269,4926039928,'Gemini'],
  [4926039928,4926214207,'Cancer'],
  [4926214207,4926386552,'Leo'],
  [4926386552,4926563805,'Virgo'],
  [4926563805,4926750314,'Libra'],
  [4926750314,4926947064,'Scorpio'],
  [4926947064,4927152667,'Sagittarius'],
  [4927152667,4927365240,'Capricorn'],
  [4927365240,4927583054,'Aquarius'],
  [4927583054,4927802851,'Pisces'],
  [4927802851,4928018298,'Aries'],
  [4928018298,4928222173,'Taurus'],
  [4928222173,4928411105,'Gemini'],
  [4928411105,4928587598,'Cancer'],
  [4928587598,4928758027,'Leo'],
  [4928758027,4928929860,'Virgo'],
  [4928929860,4929109685,'Libra'],
  [4929109685,4929301547,'Scorpio'],
  [4929301547,4929505788,'Sagittarius'],
  [4929505788,4929719400,'Capricorn'],
  [4929719400,4929938017,'Aquarius'],
  [4929938017,4930157430,'Pisces'],
  [4930157430,4930373201,'Aries'],
  [4930373201,4930580430,'Taurus'],
  [4930580430,4930775374,'Gemini'],
  [4930775374,4930957807,'Cancer'],
  [4930957807,4931131416,'Leo'],
  [4931131416,4931302352,'Virgo'],
  [4931302352,4931477529,'Libra'],
  [4931477529,4931663067,'Scorpio'],
  [4931663067,4931862384,'Sagittarius'],
  [4931862384,4932074278,'Capricorn'],
  [4932074278,4932293138,'Aquarius'],
  [4932293138,4932512249,'Pisces'],
  [4932512249,4932726666,'Aries'],
  [4932726666,4932933584,'Taurus'],
  [4932933584,4933131353,'Gemini'],
  [4933131353,4933319404,'Cancer'],
  [4933319404,4933499016,'Leo'],
  [4933499016,4933673694,'Virgo'],
  [4933673694,4933848842,'Libra'],
  [4933848842,4934030742,'Scorpio'],
  [4934030742,4934224793,'Sagittarius'],
  [4934224793,4934432773,'Capricorn'],
  [4934432773,4934650489,'Aquarius'],
  [4934650489,4934869551,'Pisces'],
  [4934869551,4935082744,'Aries'],
  [4935082744,4935287262,'Taurus'],
  [4935287262,4935483660,'Gemini'],
  [4935483660,4935673362,'Cancer'],
  [4935673362,4935857579,'Leo'],
  [4935857579,4936037778,'Virgo'],
  [4936037778,4936216800,'Libra'],
  [4936216800,4936399309,'Scorpio'],
  [4936399309,4936590798,'Sagittarius'],
  [4936590798,4936795050,'Capricorn'],
  [4936795050,4937010628,'Aquarius'],
  [4937010628,4937229740,'Pisces'],
  [4937229740,4937443005,'Aries'],
  [4937443005,4937645679,'Taurus'],
  [4937645679,4937838742,'Gemini'],
  [4937838742,4938025814,'Cancer'],
  [4938025814,4938210153,'Leo'],
  [4938210153,4938393569,'Virgo'],
  [4938393569,4938577252,'Libra'],
  [4938577252,4938763422,'Scorpio'],
  [4938763422,4938955896,'Sagittarius'],
  [4938955896,4939158605,'Capricorn'],
  [4939158605,4939372270,'Aquarius'],
  [4939372270,4939591404,'Pisces'],
  [4939591404,4939806192,'Aries'],
  [4939806192,4940009358,'Taurus'],
  [4940009358,4940200316,'Gemini'],
  [4940200316,4940383315,'Cancer'],
  [4940383315,4940563746,'Leo'],
  [4940563746,4940745648,'Virgo'],
  [4940745648,4940931001,'Libra'],
  [4940931001,4941120762,'Scorpio'],
  [4941120762,4941316403,'Sagittarius'],
  [4941316403,4941520162,'Capricorn'],
  [4941520162,4941733167,'Aquarius'],
  [4941733167,4941952265,'Pisces'],
  [4941952265,4942169255,'Aries'],
  [4942169255,4942375447,'Taurus'],
  [4942375447,4942567556,'Gemini'],
  [4942567556,4942748528,'Cancer'],
  [4942748528,4942924387,'Leo'],
  [4942924387,4943101247,'Virgo'],
  [4943101247,4943283549,'Libra'],
  [4943283549,4943473474,'Scorpio'],
  [4943473474,4943671567,'Sagittarius'],
  [4943671567,4943877742,'Capricorn'],
  [4943877742,4944091525,'Aquarius'],
  [4944091525,4944310609,'Pisces'],
  [4944310609,4944529215,'Aries'],
  [4944529215,4944739491,'Taurus'],
  [4944739491,4944936012,'Gemini'],
  [4944936012,4945118987,'Cancer'],
  [4945118987,4945293193,'Leo'],
  [4945293193,4945465271,'Virgo'],
  [4945465271,4945641699,'Libra'],
  [4945641699,4945827340,'Scorpio'],
  [4945827340,4946024357,'Sagittarius'],
  [4946024357,4946231921,'Capricorn'],
  [4946231921,4946447147,'Aquarius'],
  [4946447147,4946666385,'Pisces'],
  [4946666385,4946885209,'Aries'],
  [4946885209,4947098180,'Taurus'],
  [4947098180,4947300084,'Gemini'],
  [4947300084,4947488624,'Cancer'],
  [4947488624,4947665787,'Leo'],
  [4947665787,4947836855,'Virgo'],
  [4947836855,4948008678,'Libra'],
  [4948008678,4948188095,'Scorpio'],
  [4948188095,4948380144,'Sagittarius'],
  [4948380144,4948585911,'Capricorn'],
  [4948585911,4948801690,'Aquarius'],
  [4948801690,4949021292,'Pisces'],
  [4949021292,4949239316,'Aries'],
  [4949239316,4949452128,'Taurus'],
  [4949452128,4949656896,'Gemini'],
  [4949656896,4949851288,'Cancer'],
  [4949851288,4950034759,'Leo'],
  [4950034759,4950209704,'Virgo'],
  [4950209704,4950381407,'Libra'],
  [4950381407,4950556861,'Scorpio'],
  [4950556861,4950742983,'Sagittarius'],
  [4950742983,4950943909,'Capricorn'],
  [4950943909,4951157929,'Aquarius'],
  [4951157929,4951377667,'Pisces'],
  [4951377667,4951595075,'Aries'],
  [4951595075,4951805914,'Taurus'],
  [4951805914,4952009465,'Gemini'],
  [4952009465,4952205816,'Cancer'],
  [4952205816,4952394610,'Leo'],
  [4952394610,4952575973,'Virgo'],
  [4952575973,4952752257,'Libra'],
  [4952752257,4952928611,'Scorpio'],
  [4952928611,4953111805,'Sagittarius'],
  [4953111805,4953307798,'Capricorn'],
  [4953307798,4953518076,'Aquarius'],
  [4953518076,4953736977,'Pisces'],
  [4953736977,4953954688,'Aries'],
  [4953954688,4954164281,'Taurus'],
  [4954164281,4954364720,'Gemini'],
  [4954364720,4954558294,'Cancer'],
  [4954558294,4954747229,'Leo'],
  [4954747229,4954932405,'Virgo'],
  [4954932405,4955114440,'Libra'],
  [4955114440,4955295637,'Scorpio'],
  [4955295637,4955480595,'Sagittarius'],
  [4955480595,4955674836,'Capricorn'],
  [4955674836,4955881746,'Aquarius'],
  [4955881746,4956098858,'Pisces'],
  [4956098858,4956317396,'Aries'],
  [4956317396,4956528039,'Taurus'],
  [4956528039,4956727128,'Gemini'],
  [4956727128,4956916775,'Cancer'],
  [4956916775,4957101310,'Leo'],
  [4957101310,4957284392,'Virgo'],
  [4957284392,4957468063,'Libra'],
  [4957468063,4957653624,'Scorpio'],
  [4957653624,4957843063,'Sagittarius'],
  [4957843063,4958039459,'Capricorn'],
  [4958039459,4958245623,'Aquarius'],
  [4958245623,4958461176,'Pisces'],
  [4958461176,4958680272,'Aries'],
  [4958680272,4958893704,'Taurus'],
  [4958893704,4959094946,'Gemini'],
  [4959094946,4959283643,'Cancer'],
  [4959283643,4959463950,'Leo'],
  [4959463950,4959641430,'Virgo'],
  [4959641430,4959820979,'Libra'],
  [4959820979,4960005901,'Scorpio'],
  [4960005901,4960197938,'Sagittarius'],
  [4960197938,4960397861,'Capricorn'],
  [4960397861,4960605939,'Aquarius'],
  [4960605939,4960821346,'Pisces'],
  [4960821346,4961040507,'Aries'],
  [4961040507,4961256617,'Taurus'],
  [4961256617,4961462368,'Gemini'],
  [4961462368,4961654348,'Cancer'],
  [4961654348,4961834407,'Leo'],
  [4961834407,4962007881,'Virgo'],
  [4962007881,4962181318,'Libra'],
  [4962181318,4962360769,'Scorpio'],
  [4962360769,4962550371,'Sagittarius'],
  [4962550371,4962751240,'Capricorn'],
  [4962751240,4962961571,'Aquarius'],
  [4962961571,4963178130,'Pisces'],
  [4963178130,4963397256,'Aries'],
  [4963397256,4963614506,'Taurus'],
  [4963614506,4963824322,'Gemini'],
  [4963824322,4964021924,'Cancer'],
  [4964021924,4964206145,'Leo'],
  [4964206145,4964380165,'Virgo'],
  [4964380165,4964550232,'Libra'],
  [4964550232,4964723736,'Scorpio'],
  [4964723736,4964907362,'Sagittarius'],
  [4964907362,4965104840,'Capricorn'],
  [4965104840,4965314978,'Aquarius'],
  [4965314978,4965532554,'Pisces'],
  [4965532554,4965751821,'Aries'],
  [4965751821,4965968699,'Taurus'],
  [4965968699,4966179980,'Gemini'],
  [4966179980,4966382105,'Cancer'],
  [4966382105,4966572363,'Leo'],
  [4966572363,4966751078,'Virgo'],
  [4966751078,4966922461,'Libra'],
  [4966922461,4967093453,'Scorpio'],
  [4967093453,4967271767,'Sagittarius'],
  [4967271767,4967463552,'Capricorn'],
  [4967463552,4967670291,'Aquarius'],
  [4967670291,4967887241,'Pisces'],
  [4967887241,4968106596,'Aries'],
  [4968106596,4968322573,'Taurus'],
  [4968322573,4968532764,'Gemini'],
  [4968532764,4968735909,'Cancer'],
  [4968735909,4968930315,'Leo'],
  [4968930315,4969114882,'Virgo'],
  [4969114882,4969291185,'Libra'],
  [4969291185,4969464156,'Scorpio'],
  [4969464156,4969640832,'Sagittarius'],
  [4969640832,4969828208,'Capricorn'],
  [4969828208,4970030222,'Aquarius'],
  [4970030222,4970244652,'Pisces'],
  [4970244652,4970463639,'Aries'],
  [4970463639,4970679149,'Taurus'],
  [4970679149,4970887468,'Gemini'],
  [4970887468,4971088498,'Cancer'],
  [4971088498,4971282864,'Leo'],
  [4971282864,4971470582,'Virgo'],
  [4971470582,4971652096,'Libra'],
  [4971652096,4971829940,'Scorpio'],
  [4971829940,4972009051,'Sagittarius'],
  [4972009051,4972195527,'Capricorn'],
  [4972195527,4972394211,'Aquarius'],
  [4972394211,4972605482,'Pisces'],
  [4972605482,4972823540,'Aries'],
  [4972823540,4973039452,'Taurus'],
  [4973039452,4973247071,'Gemini'],
  [4973247071,4973445385,'Cancer'],
  [4973445385,4973636441,'Leo'],
  [4973636441,4973822675,'Virgo'],
  [4973822675,4974005915,'Libra'],
  [4974005915,4974187981,'Scorpio'],
  [4974187981,4974371624,'Sagittarius'],
  [4974371624,4974560680,'Capricorn'],
  [4974560680,4974759002,'Aquarius'],
  [4974759002,4974968183,'Pisces'],
  [4974968183,4975185111,'Aries'],
  [4975185111,4975402110,'Taurus'],
  [4975402110,4975611201,'Gemini'],
  [4975611201,4975808876,'Cancer'],
  [4975808876,4975996583,'Leo'],
  [4975996583,4976178331,'Virgo'],
  [4976178331,4976358482,'Libra'],
  [4976358482,4976540596,'Scorpio'],
  [4976540596,4976727205,'Sagittarius'],
  [4976727205,4976920123,'Capricorn'],
  [4976920123,4977120787,'Aquarius'],
  [4977120787,4977329932,'Pisces'],
  [4977329932,4977546101,'Aries'],
  [4977546101,4977764189,'Taurus'],
  [4977764189,4977976464,'Gemini'],
  [4977976464,4978176829,'Cancer'],
  [4978176829,4978364267,'Leo'],
  [4978364267,4978542377,'Virgo'],
  [4978542377,4978717102,'Libra'],
  [4978717102,4978894581,'Scorpio'],
  [4978894581,4979079510,'Sagittarius'],
  [4979079510,4979273988,'Capricorn'],
  [4979273988,4979477534,'Aquarius'],
  [4979477534,4979688410,'Pisces'],
  [4979688410,4979904624,'Aries'],
  [4979904624,4980123127,'Taurus'],
  [4980123127,4980338451,'Gemini'],
  [4980338451,4980543824,'Cancer'],
  [4980543824,4980735195,'Leo'],
  [4980735195,4980913751,'Virgo'],
  [4980913751,4981085059,'Libra'],
  [4981085059,4981256638,'Scorpio'],
  [4981256638,4981435722,'Sagittarius'],
  [4981435722,4981627019,'Capricorn'],
  [4981627019,4981830784,'Aquarius'],
  [4981830784,4982043404,'Pisces'],
  [4982043404,4982260456,'Aries'],
  [4982260456,4982478722,'Taurus'],
  [4982478722,4982695076,'Gemini'],
  [4982695076,4982904670,'Cancer'],
  [4982904670,4983102270,'Leo'],
  [4983102270,4983285889,'Virgo'],
  [4983285889,4983458697,'Libra'],
  [4983458697,4983627649,'Scorpio'],
  [4983627649,4983800978,'Sagittarius'],
  [4983800978,4983985863,'Capricorn'],
  [4983985863,4984185554,'Aquarius'],
  [4984185554,4984397471,'Pisces'],
  [4984397471,4984615266,'Aries'],
  [4984615266,4984833330,'Taurus'],
  [4984833330,4985048689,'Gemini'],
  [4985048689,4985259009,'Cancer'],
  [4985259009,4985460849,'Leo'],
  [4985460849,4985651062,'Virgo'],
  [4985651062,4985829762,'Libra'],
  [4985829762,4986001418,'Scorpio'],
  [4986001418,4986173290,'Sagittarius'],
  [4986173290,4986353155,'Capricorn'],
  [4986353155,4986546741,'Aquarius'],
  [4986546741,4986754694,'Pisces'],
  [4986754694,4986971671,'Aries'],
  [4986971671,4987189884,'Taurus'],
  [4987189884,4987404029,'Gemini'],
  [4987404029,4987612184,'Cancer'],
  [4987612184,4987813517,'Leo'],
  [4987813517,4988006838,'Virgo'],
  [4988006838,4988191525,'Libra'],
  [4988191525,4988369339,'Scorpio'],
  [4988369339,4988544882,'Sagittarius'],
  [4988544882,4988724470,'Capricorn'],
  [4988724470,4988914187,'Aquarius'],
  [4988914187,4989117258,'Pisces'],
  [4989117258,4989331529,'Aries'],
  [4989331529,4989549717,'Taurus'],
  [4989549717,4989763940,'Gemini'],
  [4989763940,4989970101,'Cancer'],
  [4989970101,4990167988,'Leo'],
  [4990167988,4990359067,'Virgo'],
  [4990359067,4990544935,'Libra'],
  [4990544935,4990727267,'Scorpio'],
  [4990727267,4990908474,'Sagittarius'],
  [4990908474,4991092094,'Capricorn'],
  [4991092094,4991282393,'Aquarius'],
  [4991282393,4991482935,'Pisces'],
  [4991482935,4991694250,'Aries'],
  [4991694250,4991911832,'Taurus'],
  [4991911832,4992127424,'Gemini'],
  [4992127424,4992334030,'Cancer'],
  [4992334030,4992529535,'Leo'],
  [4992529535,4992716175,'Virgo'],
  [4992716175,4992898124,'Libra'],
  [4992898124,4993079471,'Scorpio'],
  [4993079471,4993263232,'Sagittarius'],
  [4993263232,4993451343,'Capricorn'],
  [4993451343,4993645330,'Aquarius'],
  [4993645330,4993846846,'Pisces'],
  [4993846846,4994056914,'Aries'],
  [4994056914,4994273718,'Taurus'],
  [4994273718,4994491022,'Gemini'],
  [4994491022,4994700511,'Cancer'],
  [4994700511,4994897076,'Leo'],
  [4994897076,4995081394,'Virgo'],
  [4995081394,4995258444,'Libra'],
  [4995258444,4995434640,'Scorpio'],
  [4995434640,4995615516,'Sagittarius'],
  [4995615516,4995804222,'Capricorn'],
  [4995804222,4996001202,'Aquarius'],
  [4996001202,4996205546,'Pisces'],
  [4996205546,4996416520,'Aries'],
  [4996416520,4996633070,'Taurus'],
  [4996633070,4996851519,'Gemini'],
  [4996851519,4997064661,'Cancer'],
  [4997064661,4997265370,'Leo'],
  [4997265370,4997451460,'Virgo'],
  [4997451460,4997626650,'Libra'],
  [4997626650,4997798010,'Scorpio'],
  [4997798010,4997973064,'Sagittarius'],
  [4997973064,4998157553,'Capricorn'],
  [4998157553,4998353578,'Aquarius'],
  [4998353578,4998559503,'Pisces'],
  [4998559503,4998772225,'Aries'],
  [4998772225,4998989244,'Taurus'],
  [4998989244,4999207978,'Gemini'],
  [4999207978,4999423546,'Cancer'],
  [4999423546,4999629151,'Leo'],
  [4999629151,4999820262,'Virgo'],
  [4999820262,4999997962,'Libra'],
  [4999997962,5000168174,'Scorpio'],
  [5000168174,5000338803,'Sagittarius'],
  [5000338803,5000517312,'Capricorn'],
  [5000517312,5000708485,'Aquarius'],
  [5000708485,5000912570,'Pisces'],
  [5000912570,5001125842,'Aries'],
  [5001125842,5001343534,'Taurus'],
  [5001343534,5001562013,'Gemini'],
  [5001562013,5001777840,'Cancer'],
  [5001777840,5001986326,'Leo'],
  [5001986326,5002182841,'Virgo'],
  [5002182841,5002366085,'Libra'],
  [5002366085,5002539506,'Scorpio'],
  [5002539506,5002709760,'Sagittarius'],
  [5002709760,5002884417,'Capricorn'],
  [5002884417,5003069907,'Aquarius'],
  [5003069907,5003269259,'Pisces'],
  [5003269259,5003480610,'Aries'],
  [5003480610,5003698322,'Taurus'],
  [5003698322,5003916498,'Gemini'],
  [5003916498,5004131096,'Cancer'],
  [5004131096,5004339217,'Leo'],
  [5004339217,5004538271,'Virgo'],
  [5004538271,5004726767,'Libra'],
  [5004726767,5004905925,'Scorpio'],
  [5004905925,5005079945,'Sagittarius'],
  [5005079945,5005254906,'Capricorn'],
  [5005254906,5005437198,'Aquarius'],
  [5005437198,5005631623,'Pisces'],
  [5005631623,5005839164,'Aries'],
  [5005839164,5006055677,'Taurus'],
  [5006055677,5006273791,'Gemini'],
  [5006273791,5006487228,'Cancer'],
  [5006487228,5006692971,'Leo'],
  [5006692971,5006890545,'Virgo'],
  [5006890545,5007080553,'Libra'],
  [5007080553,5007264224,'Scorpio'],
  [5007264224,5007443794,'Sagittarius'],
  [5007443794,5007622808,'Capricorn'],
  [5007622808,5007805916,'Aquarius'],
  [5007805916,5007997903,'Pisces'],
  [5007997903,5008201764,'Aries'],
  [5008201764,5008416151,'Taurus'],
  [5008416151,5008634413,'Gemini'],
  [5008634413,5008848070,'Cancer'],
  [5008848070,5009051999,'Leo'],
  [5009051999,5009246053,'Virgo'],
  [5009246053,5009433147,'Libra'],
  [5009433147,5009616750,'Scorpio'],
  [5009616750,5009799555,'Sagittarius'],
  [5009799555,5009983482,'Capricorn'],
  [5009983482,5010170569,'Aquarius'],
  [5010170569,5010363699,'Pisces'],
  [5010363699,5010565986,'Aries'],
  [5010565986,5010778374,'Taurus'],
  [5010778374,5010996729,'Gemini'],
  [5010996729,5011212251,'Cancer'],
  [5011212251,5011417022,'Leo'],
  [5011417022,5011609003,'Virgo'],
  [5011609003,5011791685,'Libra'],
  [5011791685,5011970837,'Scorpio'],
  [5011970837,5012151639,'Sagittarius'],
  [5012151639,5012337077,'Capricorn'],
  [5012337077,5012527979,'Aquarius'],
  [5012527979,5012724625,'Pisces'],
  [5012724625,5012928148,'Aries'],
  [5012928148,5013139804,'Taurus'],
  [5013139804,5013358003,'Gemini'],
  [5013358003,5013575952,'Cancer'],
  [5013575952,5013784402,'Leo'],
  [5013784402,5013978194,'Virgo'],
  [5013978194,5014159109,'Libra'],
  [5014159109,5014333440,'Scorpio'],
  [5014333440,5014508470,'Sagittarius'],
  [5014508470,5014689944,'Capricorn'],
  [5014689944,5014880428,'Aquarius'],
  [5014880428,5015079481,'Pisces'],
  [5015079481,5015285708,'Aries'],
  [5015285708,5015498343,'Taurus'],
  [5015498343,5015716365,'Gemini'],
  [5015716365,5015935680,'Cancer'],
  [5015935680,5016148462,'Leo'],
  [5016148462,5016347541,'Virgo'],
  [5016347541,5016531497,'Libra'],
  [5016531497,5016704935,'Scorpio'],
  [5016704935,5016875351,'Sagittarius'],
  [5016875351,5017050296,'Capricorn'],
  [5017050296,5017235301,'Aquarius'],
  [5017235301,5017432256,'Pisces'],
  [5017432256,5017639512,'Aries'],
  [5017639512,5017853809,'Taurus'],
  [5017853809,5018072127,'Gemini'],
  [5018072127,5018291243,'Cancer'],
  [5018291243,5018506083,'Leo'],
  [5018506083,5018710494,'Virgo'],
  [5018710494,5018900832,'Libra'],
  [5018900832,5019078552,'Scorpio'],
  [5019078552,5019249278,'Sagittarius'],
  [5019249278,5019420356,'Capricorn'],
  [5019420356,5019598853,'Aquarius'],
  [5019598853,5019789715,'Pisces'],
  [5019789715,5019993994,'Aries'],
  [5019993994,5020208397,'Taurus'],
  [5020208397,5020427323,'Gemini'],
  [5020427323,5020645707,'Cancer'],
  [5020645707,5020859654,'Leo'],
  [5020859654,5021065765,'Virgo'],
  [5021065765,5021261309,'Libra'],
  [5021261309,5021445736,'Scorpio'],
  [5021445736,5021621628,'Sagittarius'],
  [5021621628,5021794170,'Capricorn'],
  [5021794170,5021969862,'Aquarius'],
  [5021969862,5022155011,'Pisces'],
  [5022155011,5022353712,'Aries'],
  [5022353712,5022565409,'Taurus'],
  [5022565409,5022784228,'Gemini'],
  [5022784228,5023002391,'Cancer'],
  [5023002391,5023214483,'Leo'],
  [5023214483,5023418557,'Virgo'],
  [5023418557,5023614585,'Libra'],
  [5023614585,5023803083,'Scorpio'],
  [5023803083,5023985136,'Sagittarius'],
  [5023985136,5024163083,'Capricorn'],
  [5024163083,5024341044,'Aquarius'],
  [5024341044,5024524522,'Pisces'],
  [5024524522,5024718874,'Aries'],
  [5024718874,5024926518,'Taurus'],
  [5024926518,5025143942,'Gemini'],
  [5025143942,5025362454,'Cancer'],
  [5025362454,5025573885,'Leo'],
  [5025573885,5025775193,'Virgo'],
  [5025775193,5025967960,'Libra'],
  [5025967960,5026155294,'Scorpio'],
  [5026155294,5026339656,'Sagittarius'],
  [5026339656,5026522508,'Capricorn'],
  [5026522508,5026705447,'Aquarius'],
  [5026705447,5026891535,'Pisces'],
  [5026891535,5027085197,'Aries'],
  [5027085197,5027290110,'Taurus'],
  [5027290110,5027505624,'Gemini'],
  [5027505624,5027724632,'Cancer'],
  [5027724632,5027937283,'Leo'],
  [5027937283,5028137907,'Virgo'],
  [5028137907,5028327399,'Libra'],
  [5028327399,5028510439,'Scorpio'],
  [5028510439,5028691974,'Sagittarius'],
  [5028691974,5028875203,'Capricorn'],
  [5028875203,5029061446,'Aquarius'],
  [5029061446,5029251630,'Pisces'],
  [5029251630,5029447784,'Aries'],
  [5029447784,5029652659,'Taurus'],
  [5029652659,5029867028,'Gemini'],
  [5029867028,5030086396,'Cancer'],
  [5030086396,5030301496,'Leo'],
  [5030301496,5030504353,'Virgo'],
  [5030504353,5030693488,'Libra'],
  [5030693488,5030873140,'Scorpio'],
  [5030873140,5031049656,'Sagittarius'],
  [5031049656,5031228656,'Capricorn'],
  [5031228656,5031413530,'Aquarius'],
  [5031413530,5031605438,'Pisces'],
  [5031605438,5031804606,'Aries'],
  [5031804606,5032011460,'Taurus'],
  [5032011460,5032226054,'Gemini'],
  [5032226054,5032445603,'Cancer'],
  [5032445603,5032663041,'Leo'],
  [5032663041,5032870003,'Virgo'],
  [5032870003,5033062357,'Libra'],
  [5033062357,5033242211,'Scorpio'],
  [5033242211,5033415514,'Sagittarius'],
  [5033415514,5033589103,'Capricorn'],
  [5033589103,5033768758,'Aquarius'],
  [5033768758,5033957971,'Pisces'],
  [5033957971,5034157572,'Aries'],
  [5034157572,5034366342,'Taurus'],
  [5034366342,5034582099,'Gemini'],
  [5034582099,5034801761,'Cancer'],
  [5034801761,5035020259,'Leo'],
  [5035020259,5035230957,'Virgo'],
  [5035230957,5035428609,'Libra'],
  [5035428609,5035612561,'Scorpio'],
  [5035612561,5035786728,'Sagittarius'],
  [5035786728,5035957472,'Capricorn'],
  [5035957472,5036131659,'Aquarius'],
  [5036131659,5036315168,'Pisces'],
  [5036315168,5036511345,'Aries'],
  [5036511345,5036719729,'Taurus'],
  [5036719729,5036936398,'Gemini'],
  [5036936398,5037156209,'Cancer'],
  [5037156209,5037374328,'Leo'],
  [5037374328,5037586355,'Virgo'],
  [5037586355,5037788381,'Libra'],
  [5037788381,5037978306,'Scorpio'],
  [5037978306,5038157279,'Sagittarius'],
  [5038157279,5038329569,'Capricorn'],
  [5038329569,5038501446,'Aquarius'],
  [5038501446,5038679790,'Pisces'],
  [5038679790,5038870363,'Aries'],
  [5038870363,5039075337,'Taurus'],
  [5039075337,5039291372,'Gemini'],
  [5039291372,5039511283,'Cancer'],
  [5039511283,5039728440,'Leo'],
  [5039728440,5039939211,'Virgo'],
  [5039939211,5040142101,'Libra'],
  [5040142101,5040336194,'Scorpio'],
  [5040336194,5040521248,'Sagittarius'],
  [5040521248,5040698798,'Capricorn'],
  [5040698798,5040872887,'Aquarius'],
  [5040872887,5041049629,'Pisces'],
  [5041049629,5041235717,'Aries'],
  [5041235717,5041435852,'Taurus'],
  [5041435852,5041649319,'Gemini'],
  [5041649319,5041868951,'Cancer'],
  [5041868951,5042085698,'Leo'],
  [5042085698,5042294438,'Virgo'],
  [5042294438,5042494868,'Libra'],
  [5042494868,5042688607,'Scorpio'],
  [5042688607,5042876774,'Sagittarius'],
  [5042876774,5043059870,'Capricorn'],
  [5043059870,5043239326,'Aquarius'],
  [5043239326,5043418864,'Pisces'],
  [5043418864,5043604166,'Aries'],
  [5043604166,5043800849,'Taurus'],
  [5043800849,5044010939,'Gemini'],
  [5044010939,5044229626,'Cancer'],
  [5044229626,5044447034,'Leo'],
  [5044447034,5044655288,'Virgo'],
  [5044655288,5044852873,'Libra'],
  [5044852873,5045042788,'Scorpio'],
  [5045042788,5045228796,'Sagittarius'],
  [5045228796,5045413209,'Capricorn'],
  [5045413209,5045597002,'Aquarius'],
  [5045597002,5045781555,'Pisces'],
  [5045781555,5045969982,'Aries'],
  [5045969982,5046166618,'Taurus'],
  [5046166618,5046374530,'Gemini'],
  [5046374530,5046591848,'Cancer'],
  [5046591848,5046810472,'Leo'],
  [5046810472,5047020787,'Virgo'],
  [5047020787,5047218333,'Libra'],
  [5047218333,5047405052,'Scorpio'],
  [5047405052,5047586031,'Sagittarius'],
  [5047586031,5047766291,'Capricorn'],
  [5047766291,5047949157,'Aquarius'],
  [5047949157,5048136288,'Pisces'],
  [5048136288,5048328856,'Aries'],
  [5048328856,5048528475,'Taurus'],
  [5048528475,5048736764,'Gemini'],
  [5048736764,5048953164,'Cancer'],
  [5048953164,5049172559,'Leo'],
  [5049172559,5049386319,'Virgo'],
  [5049386319,5049587513,'Libra'],
  [5049587513,5049775093,'Scorpio'],
  [5049775093,5049953086,'Sagittarius'],
  [5049953086,5050127631,'Capricorn'],
  [5050127631,5050304705,'Aquarius'],
  [5050304705,5050488740,'Pisces'],
  [5050488740,5050681941,'Aries'],
  [5050681941,5050884419,'Taurus'],
  [5050884419,5051094990,'Gemini'],
  [5051094990,5051311709,'Cancer'],
  [5051311709,5051531084,'Leo'],
  [5051531084,5051747304,'Virgo'],
  [5051747304,5051953671,'Libra'],
  [5051953671,5052146303,'Scorpio'],
  [5052146303,5052326258,'Sagittarius'],
  [5052326258,5052498527,'Capricorn'],
  [5052498527,5052669937,'Aquarius'],
  [5052669937,5052847343,'Pisces'],
  [5052847343,5053035942,'Aries'],
  [5053035942,5053237469,'Taurus'],
  [5053237469,5053449538,'Gemini'],
  [5053449538,5053667445,'Cancer'],
  [5053667445,5053886594,'Leo'],
  [5053886594,5054103052,'Virgo'],
  [5054103052,5054312633,'Libra'],
  [5054312633,5054511252,'Scorpio'],
  [5054511252,5054697143,'Sagittarius'],
  [5054697143,5054872389,'Capricorn'],
  [5054872389,5055042555,'Aquarius'],
  [5055042555,5055215024,'Pisces'],
  [5055215024,5055397097,'Aries'],
  [5055397097,5055593560,'Taurus'],
  [5055593560,5055803917,'Gemini'],
  [5055803917,5056022292,'Cancer'],
  [5056022292,5056241480,'Leo'],
  [5056241480,5056456836,'Virgo'],
  [5056456836,5056666205,'Libra'],
  [5056666205,5056867725,'Scorpio'],
  [5056867725,5057059417,'Sagittarius'],
  [5057059417,5057240811,'Capricorn'],
  [5057240811,5057414690,'Aquarius'],
  [5057414690,5057587012,'Pisces'],
  [5057587012,5057765252,'Aries'],
  [5057765252,5057956071,'Taurus'],
  [5057956071,5058162013,'Gemini'],
  [5058162013,5058378913,'Cancer'],
  [5058378913,5058598123,'Leo'],
  [5058598123,5058812585,'Virgo'],
  [5058812585,5059019853,'Libra'],
  [5059019853,5059220150,'Scorpio'],
  [5059220150,5059413617,'Sagittarius'],
  [5059413617,5059599838,'Capricorn'],
  [5059599838,5059779470,'Aquarius'],
  [5059779470,5059955856,'Pisces'],
  [5059955856,5060134835,'Aries'],
  [5060134835,5060322980,'Taurus'],
  [5060322980,5060524691,'Gemini'],
  [5060524691,5060738733,'Cancer'],
  [5060738733,5060957540,'Leo'],
  [5060957540,5061172129,'Virgo'],
  [5061172129,5061377885,'Libra'],
  [5061377885,5061575118,'Scorpio'],
  [5061575118,5061766072,'Sagittarius'],
  [5061766072,5061952521,'Capricorn'],
  [5061952521,5062135553,'Aquarius'],
  [5062135553,5062316865,'Pisces'],
  [5062316865,5062499838,'Aries'],
  [5062499838,5062689219,'Taurus'],
  [5062689219,5062889281,'Gemini'],
  [5062889281,5063100825,'Cancer'],
  [5063100825,5063318889,'Leo'],
  [5063318889,5063534599,'Virgo'],
  [5063534599,5063740937,'Libra'],
  [5063740937,5063936347,'Scorpio'],
  [5063936347,5064123425,'Sagittarius'],
  [5064123425,5064306069,'Capricorn'],
  [5064306069,5064487680,'Aquarius'],
  [5064487680,5064670796,'Pisces'],
  [5064670796,5064857617,'Aries'],
  [5064857617,5065050527,'Taurus'],
  [5065050527,5065251895,'Gemini'],
  [5065251895,5065462640,'Cancer'],
  [5065462640,5065680066,'Leo'],
  [5065680066,5065897297,'Virgo'],
  [5065897297,5066106351,'Libra'],
  [5066106351,5066302975,'Scorpio'],
  [5066302975,5066488188,'Sagittarius'],
  [5066488188,5066666402,'Capricorn'],
  [5066666402,5066843109,'Aquarius'],
  [5066843109,5067023271,'Pisces'],
  [5067023271,5067210348,'Aries'],
  [5067210348,5067405920,'Taurus'],
  [5067405920,5067610021,'Gemini'],
  [5067610021,5067821776,'Cancer'],
  [5067821776,5068039063,'Leo'],
  [5068039063,5068257399,'Virgo'],
  [5068257399,5068470001,'Libra'],
  [5068470001,5068670764,'Scorpio'],
  [5068670764,5068857912,'Sagittarius'],
  [5068857912,5069034491,'Capricorn'],
  [5069034491,5069206553,'Aquarius'],
  [5069206553,5069381032,'Pisces'],
  [5069381032,5069563913,'Aries'],
  [5069563913,5069758431,'Taurus'],
  [5069758431,5069964031,'Gemini'],
  [5069964031,5070177501,'Cancer'],
  [5070177501,5070395225,'Leo'],
  [5070395225,5070613790,'Virgo'],
  [5070613790,5070828791,'Libra'],
  [5070828791,5071034570,'Scorpio'],
  [5071034570,5071226991,'Sagittarius'],
  [5071226991,5071406300,'Capricorn'],
  [5071406300,5071577277,'Aquarius'],
  [5071577277,5071747290,'Pisces'],
  [5071747290,5071924110,'Aries'],
  [5071924110,5072113651,'Taurus'],
  [5072113651,5072317324,'Gemini'],
  [5072317324,5072531336,'Cancer'],
  [5072531336,5072749709,'Leo'],
  [5072749709,5072967891,'Virgo'],
  [5072967891,5073182984,'Libra'],
  [5073182984,5073391640,'Scorpio'],
  [5073391640,5073589772,'Sagittarius'],
  [5073589772,5073775129,'Capricorn'],
  [5073775129,5073949710,'Aquarius'],
  [5073949710,5074119506,'Pisces'],
  [5074119506,5074292419,'Aries'],
  [5074292419,5074476007,'Taurus'],
  [5074476007,5074674587,'Gemini'],
  [5074674587,5074886475,'Cancer'],
  [5074886475,5075104873,'Leo'],
  [5075104873,5075322748,'Virgo'],
  [5075322748,5075536393,'Libra'],
  [5075536393,5075744315,'Scorpio'],
  [5075744315,5075944772,'Sagittarius'],
  [5075944772,5076135637,'Capricorn'],
  [5076135637,5076316580,'Aquarius'],
  [5076316580,5076490814,'Pisces'],
  [5076490814,5076664538,'Aries'],
  [5076664538,5076845068,'Taurus'],
  [5076845068,5077038380,'Gemini'],
  [5077038380,5077245934,'Cancer'],
  [5077245934,5077462899,'Leo'],
  [5077462899,5077680874,'Virgo'],
  [5077680874,5077893509,'Libra'],
  [5077893509,5078098784,'Scorpio'],
  [5078098784,5078297049,'Sagittarius'],
  [5078297049,5078488726,'Capricorn'],
  [5078488726,5078674037,'Aquarius'],
  [5078674037,5078854316,'Pisces'],
  [5078854316,5079032982,'Aries'],
  [5079032982,5079215210,'Taurus'],
  [5079215210,5079406456,'Gemini'],
  [5079406456,5079610026,'Cancer'],
  [5079610026,5079824348,'Leo'],
  [5079824348,5080042433,'Virgo'],
  [5080042433,5080255826,'Libra'],
  [5080255826,5080459788,'Scorpio'],
  [5080459788,5080654354,'Sagittarius'],
  [5080654354,5080842135,'Capricorn'],
];

export default signs;
